/* eslint-disable */
  import angular from "angular";
  import { Configs } from "@salaxy/core";
  /**
   * Bootstrap templates compiled to JavaScript
   * @ignore
   */
  export const SalaxyNg1BootstrapTemplatesModule = angular.module("salaxy.ng1.templates.bootstrap", [])
    .run(["$templateCache", function ($templateCache) {
      const useCache = !((Configs.current as any)?.noCache);
      if (useCache) {
        
 $templateCache.put("salaxy-components/account/AccountAvatarEdit.html",`<div class="salaxy-component salaxy-account-contact-edit" ng-if="$ctrl.isAuthenticated">
  <div ng-if="$ctrl.session.currentAccount.entityType == 'company'" ng-controller="CompanyAccountController as $accountCtrl">
    <ng-include src="'AvatarEditor.html'"></ng-include>
  </div>
  <div ng-if="$ctrl.session.currentAccount.entityType != 'company'" ng-controller="PersonAccountController as $accountCtrl">
    <ng-include src="'AvatarEditor.html'"></ng-include>
  </div>
  <script type="text/ng-template" id="AvatarEditor.html">
    <form name="avatarForm" class="form-horizontal" ng-if="$accountCtrl.current">
      <div class="form-group">
        <div class="col-12 col-sm-4">
          <label for="avatarPreview" class="control-label" style="text-align:left" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarLabel"></label>
        </div>
        <div class="col-12 col-sm-8">
          <div class="worker-avatar-col">
            <salaxy-avatar style="font-size: 130px" avatar="$accountCtrl.current.avatar"></salaxy-avatar>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="col-12 col-sm-4">
          <label for="avatarPictureType" class="control-label" style="text-align:left" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarTypeLabel"></label>
        </div>
        <div class="col-12 col-sm-8">
          <select class="form-select" id="avatarPictureType" ng-model="$accountCtrl.current.avatar.pictureType" ng-change="$accountCtrl.typeForAvatarChanged()">
            <option value="" disabled sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionChoose"></option>
            <option value="icon" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionIcon"></option>
            <option value="uploaded" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionUploaded"></option>
            <option value="gravatar" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionGravatar"></option>
          </select>
        </div>
      </div>
      <div ng-if="$accountCtrl.current.avatar.pictureType == 'gravatar'" class="row">
        <div class="input-info col-sm-8 offset-sm-4">
          <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
          <p class="small input-info-text with-icon " sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.gravatarInfo.html"></p>
        </div>
      </div>
      <div ng-if="$accountCtrl.current.avatar.pictureType == 'icon'">
        <salaxy-input name="avatarInitials" label="SALAXY.NG1.AccountAvatarEditPersonComponent.initialsLabel" ng-model="$accountCtrl.current.avatar.initials" max-length="2"></salaxy-input>
        <salaxy-input-enum ng-model="$accountCtrl.current.avatar.color" name="avatarColor" label="SALAXY.NG1.AccountAvatarEditPersonComponent.colorLabel" options="{
          '#009FD8': '#009FD8',
          '#91D214': '#91D214',
          '#D10074': '#D10074',
          '#3C3C3C': '#3C3C3C',
          '#61703B': '#61703B',
          '#7F2C2A': '#7F2C2A',
          '#FF911E': '#FF911E',
          '#289548': '#289548',
          'blue': 'blue',
          'lime': 'lime',
          'pink': 'pink',
          'gray': 'gray',
          'darkgreen': 'darkgreen',
          'brown': 'brown',
          'yellow': 'yellow',
          'orange': 'orange',
          'green': 'green',
          'black': 'black'         
          }">
        </salaxy-input-enum>
      </div>
      <div class="form-group">
        <div ng-if="$accountCtrl.current.avatar.pictureType == 'uploaded'">
          <div class="col-12 col-sm-4">
            <label for="avatarImageUpload" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImageLabel"></label>
          </div>
          <div class="col-12 col-sm-8">
            <div name="avatarImageUpload" ng-model="avatarImage" ngf-drop="$accountCtrl.uploadAvatarImage($file)" ngf-select="$accountCtrl.uploadAvatarImage($file)" class="salaxy-drop-box" ngf-drag-over-class="'salaxy-drag-over'" ngf-multiple="false" ngf-min-size="5KB" ngf-max-size="10MB"
              ngf-pattern="'image/*'" ngf-model-invalid="invalidFile" ng-class="invalidFile.$error != null ? 'error' : ''">
              <span sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImage.html"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end">
        <button ng-click="$accountCtrl.saveCurrent()" ng-disabled="avatarForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
      </div>
    </form>
  </script>
</div>`);

 $templateCache.put("salaxy-components/account/AccountContactEdit.html",`<div class="salaxy-component salaxy-account-contact-edit" ng-if="$ctrl.isAuthenticated">
  <div ng-if="$ctrl.session.currentAccount.entityType == 'company'" ng-controller="CompanyAccountController as $accountCtrl">
    <ng-include src="'ContactEditor.html'"></ng-include>
  </div>
  <div ng-if="$ctrl.session.currentAccount.entityType != 'company'" ng-controller="PersonAccountController as $accountCtrl">
    <ng-include src="'ContactEditor.html'"></ng-include>
  </div>
  <script type="text/ng-template" id="ContactEditor.html">
    <form name="contactForm" class="form-horizontal" ng-if="$accountCtrl.current">
      <div class="row">
        <div class="col-12">
          <salaxy-input name="email" label="SALAXY.MODEL.PersonAccount.contact.email.title" sxy-email ng-model="$accountCtrl.current.contact.email" ng-change="$accountCtrl.emailForAvatarChanged()">
          </salaxy-input>
          <salaxy-input name="telephone" label="SALAXY.MODEL.PersonAccount.contact.telephone.title" sxy-mobile-phone ng-model="$accountCtrl.current.contact.telephone"></salaxy-input>
          <salaxy-input name="street" label="SALAXY.MODEL.PersonAccount.contact.street.title" ng-model="$accountCtrl.current.contact.street" ng-required="('household' | sxyIsInRole) || ('company' | sxyIsInRole)"></salaxy-input>
          <salaxy-input name="postalCode" label="SALAXY.MODEL.PersonAccount.contact.postalCode.title" sxy-postal-code-fi ng-model="$accountCtrl.current.contact.postalCode" ng-required="('household' | sxyIsInRole) || ('company' | sxyIsInRole)"></salaxy-input>
          <salaxy-input name="city" label="SALAXY.MODEL.PersonAccount.contact.city.title" ng-model="$accountCtrl.current.contact.city" ng-required="('household' | sxyIsInRole) || ('company' | sxyIsInRole)"></salaxy-input>
          <salaxy-input-enum type="select" label="SALAXY.MODEL.PersonAccount.contact.countryCode.title" ng-model="$accountCtrl.current.contact.countryCode"
          name="country" read-only="true" enum="Country"></salaxy-input-enum>
        </div>
      </div>
      <div class="text-end">
        <button ng-click="$accountCtrl.saveCurrent()" ng-disabled="contactForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
      </div>
    </form>
  </script>
</div>`);

 $templateCache.put("salaxy-components/account/AccountInfo.html",`﻿<div class="container-fixed salaxy-component salaxy-account-info" ng-controller="CompanyAccountController as $companyCtrl">
  <div class="d-flex flex-column flex-md-row">
    <div>
      <salaxy-avatar avatar="$ctrl.company.avatar" class="avatar-xl mb-4 me-4"></salaxy-avatar>
      <button type="button" style="margin-bottom: 5px;" class="btn btn-sm btn-default mb-2" ng-click="$companyCtrl.openEditDialog('avatar')" sxy-text="SALAXY.NG1.AccountInfoComponent.changeAvatar"></button>
    </div>   
    <p class="lead" ng-controller="CompanyOnboardingController as $onBoarding">
      {{'SALAXY.NG1.AccountInfoComponent.lead.infoText' | sxyTranslate}} <a ng-click="$onBoarding.openSigningWizardDialog()">{{'SALAXY.NG1.AccountInfoComponent.lead.buttonText' | sxyTranslate}}</a> {{'SALAXY.NG1.AccountInfoComponent.lead.infoTextAlt' | sxyTranslate}}
    </p>
  </div>
  <div class="table-responsive">
    <table class="table">
      <tr>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.palkkausAccount" ps=":"></th>
        <td>{{ $ctrl.company.id | sxyIban }}</td>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.email" ps=":"></th>
        <td>{{ $ctrl.company.contact.email }}</td>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.companyName" ps=":"></th>
        <td>{{ $ctrl.company.avatar.displayName }}</td>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.phone" ps=":"></th>
        <td>{{ $ctrl.company.contact.telephone }}</td>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.officialId" ps=":"></th>
        <td>{{ $ctrl.company.identity.officialId }}</td>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.address" ps=":"></th>
        <td>
          {{ $ctrl.company.contact.street }}<br /> {{ $ctrl.company.contact.postalCode }} {{ $ctrl.company.contact.city }}
        </td>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.companyType" ps=":"></th>
        <td>{{ 'CompanyType.' + $ctrl.company.companyType | sxyEnum }}</td>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.ibanNumber" ps=":"></th>
        <td>{{ $ctrl.company.identity.ibanNumber | sxyIban }}</td>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.authorizationType" ps=":"></th>
        <td>
          {{ 'AuthorizationType.' + $ctrl.company.identity.contract.authorizationType | sxyEnum }}
          <span ng-if="$ctrl.company.identity.contract.authorizationType == 'companyContract' || $ctrl.company.identity.contract.authorizationType == 'employerAuthorization'">
            (<a class="" ng-href="{{$ctrl.authorizationPdfUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.seePreview"></a>)
          </span>
        </td>
        <th><button type="button" class="btn btn-sm btn-default mb-1" ng-click="$companyCtrl.openEditDialog('contactInfo')" sxy-text="SALAXY.NG1.AccountInfoComponent.editContactInfo"></button></th>
        <td></td>
      </tr>
      <tr>
        <th sxy-text="Asiakkaan tunnistaminen tehty" ps=":"></th>
        <td>
          <span ng-if="$ctrl.kycState == 'ignored'"></span>
          <span ng-if="$ctrl.kycState == 'valid'" class="text-success">KYC OK {{ $ctrl.kycUpdatedAt | sxyDate }}</span>
          <span ng-if="$ctrl.kycState == 'missing'" class="text-danger">Päivitä KYC</span>
          <span ng-if="$ctrl.kycState == 'expired'" class="text-warning">KYC vanhenee {{ $ctrl.kycExpiresAt | sxyDate }}</span>
        </td>
        <th>
          <a ng-href="{{('test' | sxyIsInRole) ? 'https://rc-iam.palkkaus.fi/wizard/index.html' : 'https://iam.palkkaus.fi/wizard/index.html'}}" target="_blank" class="btn btn-sm btn-default" role="button">Päivitä asiakkaan tunnistaminen</a>
        </th>
        <td></td>
      </tr>
    </table>
  </div>
</div>`);

 $templateCache.put("salaxy-components/account/AssurePartner.html",`<div class="salaxy-assure-partner salaxy-component" ng-controller="SessionController as $sessionCtrl">
  <div ng-if="$sessionCtrl.session.settings.partner.accountId">
    <ng-transclude ng-transclude-slot="header">
      <!-- Further information of the partner etc. -->
    </ng-transclude>
    <ng-transclude ng-transclude-slot="main">
      <!-- Content to assure -->
    </ng-transclude>
  </div>
  <div ng-if="!$sessionCtrl.session.settings.partner.accountId">
    <div class="row">
      <div class="col-12">
        <div class="content settings">
          <salaxy-accountant></salaxy-accountant>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/account/AuthCard.html",`<div class="salaxy-component salaxy-product-card p-3 d-flex flex-column" ng-click="$ctrl.showPartnerSiteDialog($ctrl.authId)">
  <div class="d-flex row flex-grow-1">
    <div class="col-4">
      <i class="salaxy-avatar avatar-lg"><img ng-src="{{$ctrl.getPartnerSite($ctrl.authId).img}}" /></i>
    </div>
    <div class="col-8 ps-4">
      <div class="salaxy-product-title text-break">{{ $ctrl.getPartnerSite($ctrl.authId).title }}</div>
      <div class="salaxy-product-descr text-break">{{ $ctrl.getPartnerSite($ctrl.authId).status }}</div>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <salaxy-input-boolean type="switch" ng-if="$ctrl.isInRole('auth') && !$ctrl.hideSwitch" id="salaxyService" name="salaxyService" ng-model="$ctrl.getPartnerSite($ctrl.authId).enabled" label-type="no-label" label-true="Aktivoitu" label-false="Aktivoi"></salaxy-input-boolean>
  </div>
</div>`);

 $templateCache.put("salaxy-components/account/AuthorizedAccounts.html",`<div class="card card-default" ng-controller="AccountAuthorizationController as $ctrl">
  <div class="card-header">
    <h2 sxy-text="SALAXY.NG1.AuthoringAccountComponent.authorizeIntro"></h2>
    <p><small sxy-text="SALAXY.NG1.AuthoringAccountComponent.authorizeDescription"></small></p>
  </div>
  <div class="card-body">
    <div class="salaxy-component salaxy-authorized-accounts">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th colspan="2" sxy-text="SALAXY.NG1.AuthoringAccountComponent.palkkausAccount"></th>
              <th ng-if="('admin' | sxyIsInRole)">Partnerin antama ID</th>
              <th class="right" sxy-text="SALAXY.NG1.AuthoringAccountComponent.date"></th>
              <th class="right">
                <ng-transclude ng-transclude-slot="header">
                  <button class="btn btn-sm btn-default" ng-click="$ctrl.showAuthorizedAccountAddDialog()" sxy-text="SALAXY.UI_Terms.createNew"></button>
                </ng-transclude>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="avatar in $ctrl.list">
              <td>
                <salaxy-avatar class="avatar-sm" avatar="avatar"></salaxy-avatar>
              </td>
              <td>
                <strong>{{avatar.displayName}}</strong><br/>
                <small>{{avatar.id | sxyIban}}</small>
              </td>
              <td  ng-if="('admin' | sxyIsInRole)">{{avatar.partnerKey}}</td>
              <td class="right">{{avatar.createdAt | date}}</td>
              <td class="right">
                <button ng-click="$ctrl.delete(avatar.id)" class="btn btn-danger btn-sm" sxy-text="SALAXY.UI_Terms.delete"></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/account/AuthorizingAccounts.html",`<div class="salaxy-component salaxy-authorizing-accounts">
  <div class="table-responsive" ng-controller="CustomerOnboardingController as wizard">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-text="SALAXY.NG1.AuthoringAccountComponent.palkkausAccount"></th>
          <th sxy-text="SALAXY.NG1.AuthoringAccountComponent.status"></th>
          <th class="right" sxy-text="SALAXY.NG1.AuthoringAccountComponent.date"></th>
          <th class="right" colspan="3">
            <ng-transclude ng-transclude-slot="header">
              <button class="btn btn-sm btn-default" ng-click="wizard.launch()" sxy-text="SALAXY.UI_Terms.createNew"></button>
            </ng-transclude>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="account in $ctrl.authorizingAccounts">
          <td>
            <salaxy-avatar class="avatar-sm" avatar="account.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{account.avatar.displayName}}</strong><br/>
            <small>{{account.id | sxyIban }}</small>
          </td>
          <td>
            <small class="text-success" ng-if="account.identity.contract.isSigned" sxy-text="SALAXY.NG1.AuthoringAccountComponent.signeratureOk"></small>
            <small class="text-danger" ng-if="!account.identity.contract.isSigned" sxy-text="SALAXY.NG1.AuthoringAccountComponent.signeratureNo"></small>
          </td>
          <td class="right">{{account.createdAt | date }}</td>
          <td>
            <button ng-if="!account.identity.contract.isSigned && account.entityType == 'company'" ng-click="wizard.launch(account.id)" class="btn btn-default btn-block" sxy-text="SALAXY.NG1.AuthoringAccountComponent.invite"></button>
          </td>
          <td>
            <a ng-href="{{$ctrl.getLoginAsUrl(account.id)}}" target="_blank" class="btn btn-primary btn-block" sxy-text="SALAXY.NG1.AuthoringAccountComponent.signIn"></a>
          </td>
          <td>
            <button salaxy-if-role="test" ng-click="$ctrl.deleteAccount(account.id)" class="btn btn-danger btn-block" sxy-text="SALAXY.UI_Terms.delete"></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>`);

 $templateCache.put("salaxy-components/account/Certificates.html",`<div class="card card-default">
  <div class="card-header">
    <h2 sxy-text="SALAXY.NG1.CertificatesComponent.title"></h2>    
  </div>
  <div class="card-body">
    <div class="salaxy-component salaxy-certificates">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th sxy-text="SALAXY.NG1.CertificatesComponent.name"></th>
              <th sxy-text="SALAXY.NG1.CertificatesComponent.id"></th>
              <th class="right" sxy-text="SALAXY.NG1.AuthoringAccountComponent.date"></th>
              <th class="right">
                <ng-transclude ng-transclude-slot="header">
                  <button class="btn btn-default btn-sm" ng-click="$ctrl.showCertificateAddDialog()" sxy-text="SALAXY.UI_Terms.createNew"></button>
                </ng-transclude>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="certificate in $ctrl.list">
              <td>{{certificate.title || '-'}}</td>
              <td>{{certificate.thumbprint}}</td>
              <td class="right">{{certificate.createdAt | date}}</td>
              <td class="right">
                <button ng-click="$ctrl.delete(certificate.thumbprint)" class="btn btn-danger btn-sm" sxy-text="SALAXY.UI_Terms.delete"></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/account/Credentials.html",`<div class="card card-secondary">

  <div class="card-header">
    <h2 sxy-text="SALAXY.NG1.CredentialsComponent.title"></h2>
    <p>
      <!--<small sxy-text="SALAXY.NG1.CredentialsComponent.intro"></small>--></p>
  </div>
  <div class="card-body">
    <div class="salaxy-component salaxy-credentials">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th sxy-text="SALAXY.NG1.CredentialsComponent.userId"></th>
              <th sxy-text="SALAXY.NG1.CredentialsComponent.authenticationMethod"></th>
              <th class="right" sxy-text="SALAXY.NG1.AuthoringAccountComponent.date"></th>
              <th class="right">
                <ng-transclude ng-transclude-slot="header"></ng-transclude>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="credential in $ctrl.list">
              <td>{{credential.email}}</td>
              <td>{{ 'AuthenticationMethod.' + credential.authenticationMethod | sxyEnum}}</td>
              <td class="right">{{credential.createdAt | date}}</td>
              <td class="right">

                <button ng-if="$ctrl.showEdit" ng-click="$ctrl.setCurrent(credential)" class="btn btn-primary btn-sm" sxy-text="SALAXY.UI_Terms.select"></button>
                <button ng-if="$ctrl.showEdit && !('admin' | sxyIsInRole)" ng-disabled="$ctrl.list.length &lt;= 1" ng-click="$ctrl.delete(credential.id)" class="btn btn-danger btn-sm" sxy-text="SALAXY.UI_Terms.delete"></button>
                <button ng-if="$ctrl.showEdit && ('admin' | sxyIsInRole)" ng-click="$ctrl.delete(credential.id)" class="btn btn-danger btn-sm" sxy-text="SALAXY.UI_Terms.delete"></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <form name="credentialsForm" class="form-horizontal" ng-if="$ctrl.current && $ctrl.showEdit">
        <div class="row">
          <div class="col-12">
            <salaxy-input name="firstName" label="SALAXY.NG1.CredentialsComponent.firstName" ng-model="$ctrl.current.avatar.firstName"></salaxy-input>
            <salaxy-input name="lastName" label="SALAXY.NG1.CredentialsComponent.lastName" ng-model="$ctrl.current.avatar.lastName"></salaxy-input>
            <salaxy-input name="email" label="SALAXY.NG1.CredentialsComponent.email" ng-model="$ctrl.current.email" ng-change="$ctrl.emailForAvatarChanged()"></salaxy-input>
            <!-- <salaxy-input name="telephone" label="SALAXY.NG1.CredentialsComponent.telephone" ng-model="$ctrl.current.telephone"></salaxy-input>-->
            <div class="form-group">
              <div class="col-12 col-sm-4">
                <strong sxy-text="SALAXY.NG1.CredentialsComponent.authenticationMethod"></strong>
              </div>
              <div class="col-12 col-sm-8">
                {{ 'AuthenticationMethod.' + $ctrl.current.authenticationMethod | sxyEnum}}
              </div>
            </div>

          </div>
        </div>

        <div class="form-group">

          <div class="col-12 col-sm-4">
            <label for="avatarPictureType" class="control-label" style="text-align:left" sxy-text="SALAXY.NG1.CredentialsComponent.avatar.label"></label>
          </div>
          <div class="col-12 col-sm-6">
            <select class="form-select" style="margin-bottom:15px;" id="avatarPictureType" ng-model="$ctrl.current.avatar.pictureType" ng-change="$ctrl.typeForAvatarChanged()">
              <option value="" disabled sxy-text="SALAXY.NG1.CredentialsComponent.avatar.optionChoose"></option>
              <option value="icon" sxy-text="SALAXY.NG1.CredentialsComponent.avatar.optionIcon"></option>
              <option value="uploaded" sxy-text="SALAXY.NG1.CredentialsComponent.avatar.optionUploaded"></option>
              <option value="gravatar" sxy-text="SALAXY.NG1.CredentialsComponent.avatar.optionGravatar"></option>
            </select>
            <div ng-if="$ctrl.current.avatar.pictureType == 'gravatar'" class="input-info">
              <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
              <p class="small input-info-text with-icon " sxy-html="SALAXY.NG1.CredentialsComponent.avatar.gravatarInfo.html"></p>
            </div>
            <div ng-if="$ctrl.current.avatar.pictureType == 'icon'">
              <salaxy-input name="avatarInitials" label="SALAXY.NG1.CredentialsComponent.avatar.labelInitials" ng-model="$ctrl.current.avatar.initials" max-length="2"></salaxy-input>
              <salaxy-input-enum name="avatarColor" label="SALAXY.NG1.CredentialsComponent.avatar.labelColor" ng-model="$ctrl.current.avatar.color" options="$ctrl.colorOptions">
              </salaxy-input-enum>
            </div>
            <div ng-if="$ctrl.current.avatar.pictureType == 'uploaded'" class="form-group">
              <div class="col-12 col-sm-4">
                <label for="avatarImageUpload" sxy-text="SALAXY.NG1.CredentialsComponent.avatar.labelUploadImage"></label>
              </div>
              <div class="col-12 col-sm-8">
                <div name="avatarImageUpload" ng-model="avatarImage" ngf-drop="$ctrl.uploadAvatarImage($file)" ngf-select="$ctrl.uploadAvatarImage($file)" class="salaxy-drop-box" ngf-drag-over-class="'salaxy-drag-over'" ngf-multiple="false" ngf-min-size="5KB" ngf-max-size="10MB"
                  ngf-pattern="'image/*'" ngf-model-invalid="invalidFile" ng-class="invalidFile.$error != null ? 'error' : ''">
                  <span sxy-html="SALAXY.NG1.CredentialsComponent.avatar.uploadImage.html"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-2 col-12 text-center">
            <salaxy-avatar avatar="$ctrl.current.avatar" style="font-size:70px;"></salaxy-avatar>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-end">
            <button ng-click="$ctrl.saveCurrent()" ng-disabled="credentialsForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/account/LanguageSelector.html",`<div class="salaxy-component salaxy-language-selector" ng-controller="CompanyAccountController as $accountCtrl">
  <div class="card language-selection card-secondary">
    <div class="card-header">
      <h2>{{'SALAXY.NG1.LanguageSelectionComponent.panelTitle' | sxyTranslate}}</h2>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-6">
          <fieldset>
            <legend sxy-text="SALAXY.NG1.LanguageSelectionComponent.changeLanguage"></legend>
            <p sxy-text="SALAXY.NG1.LanguageSelectionComponent.changeLanguageInfo"></p>
            <div class="btn-group">
              <button type="button" class="btn" ng-class="$ctrl.getLanguage() == 'fi' ? 'btn-primary disabled' : 'btn-default'" ng-click="$ctrl.setLanguage('fi')" sxy-text="SALAXY.ENUM.Language.fi.label"></button>
              <button type="button" class="btn" ng-class="$ctrl.getLanguage() == 'en' ? 'btn-primary disabled' : 'btn-default'" ng-click="$ctrl.setLanguage('en')" sxy-text="SALAXY.ENUM.Language.en.label"></button>
              <button type="button" class="btn" ng-class="$ctrl.getLanguage() == 'sv' ? 'btn-primary disabled' : 'btn-default'" ng-click="$ctrl.setLanguage('sv')" sxy-text="SALAXY.ENUM.Language.sv.label"></button>
            </div>
          </fieldset>
        </div>
        <div class="col-sm-6">
          <fieldset>
            <legend sxy-text="SALAXY.NG1.LanguageSelectionComponent.changeCompanyDefaultLanguage"></legend>
            <p sxy-text="SALAXY.NG1.LanguageSelectionComponent.changeCompanyDefaultLanguageInfo"></p>
            <div class="btn-group">
              <button type="button" class="btn" ng-class="$accountCtrl.getAccountLanguage() == 'fi' ? 'btn-primary active disabled' : 'btn-default'" ng-click="$accountCtrl.current.language = 'fi'" sxy-text="SALAXY.ENUM.Language.fi.label"></button>
              <button type="button" class="btn" ng-class="$accountCtrl.getAccountLanguage() == 'en' ? 'btn-primary active disabled' : 'btn-default'" ng-click="$accountCtrl.current.language = 'en'" sxy-text="SALAXY.ENUM.Language.en.label"></button>
              <button type="button" class="btn" ng-class="$accountCtrl.getAccountLanguage() == 'sv' ? 'btn-primary active disabled' : 'btn-default'" ng-click="$accountCtrl.current.language = 'sv'" sxy-text="SALAXY.ENUM.Language.sv.label"></button>
            </div>
            <div>&nbsp;</div>
            <div class="alert alert-warning" sxy-html="SALAXY.NG1.LanguageSelectionComponent.warning.html"></div>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col text-end">
          <button class="btn btn-primary" ng-click="$accountCtrl.saveCurrent()" sxy-text="SALAXY.UI_Terms.save"></button>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/account/LoginButton.html",`<div class="salaxy-login-button salaxy-component d-flex" sxy-if-role="!worker">
  <button ng-hide="$ctrl.isAuthenticated" ng-click="$ctrl.signIn()" class="btn salaxy-login-button-login" ng-class="$ctrl.btnClass || 'btn-default'">
    <span class="bi bi-lock-fill me-2"></span>
    <span class="salaxy-login-button-text">{{ $ctrl.isSessionChecking ?  ('SALAXY.NG1.LoginButtonComponent.searching' | sxyTranslate) : ($ctrl.loginText || 'SALAXY.UI_Terms.login' | sxyTranslate) }}</span>
  </button>
  <div ng-show="$ctrl.isAuthenticated" class="btn-group dropdown salaxy-login-button-logout">
    <button type="button" id="loginBtn" class="btn dropdown-toggle" ng-class="$ctrl.btnClass || 'btn-default'" data-bs-toggle="dropdown" aria-expanded="false">
      <salaxy-avatar class="me-2" avatar="$ctrl.avatar"></salaxy-avatar>
      <span class="salaxy-login-button-text">{{ $ctrl.isAuthenticated ? $ctrl.avatar.displayName : ('SALAXY.NG1.LoginButtonComponent.authenticating' | sxyTranslate) }}</span>
    </button>
    <ul class="dropdown-menu" aria-labelledby="loginBtn" ng-controller="NaviController as $navi">
      <li>
        <a href="#" class="dropdown-item" ng-click="$ctrl.signOut()" sxy-text="SALAXY.UI_Terms.logout"></a>
      </li>
      <li role="separator" class="divider"></li>
      <li>
        <a href="#/settings/service-settings" class="dropdown-item" sxy-text="SALAXY.NG1.LoginButtonComponent.accountSettings" ng-click="$navi.toggleNavi()"></a>
      </li>
      <li>
        <a href="#/settings/authorizations" class="dropdown-item" sxy-text="SALAXY.NG1.LoginButtonComponent.authAndCerti" ng-click="$navi.toggleNavi()"></a>
      </li>
      <li ng-if="$ctrl.ownedPaymentChannel">
        <a href="#/payment-channel" class="dropdown-item" sxy-text="SALAXY.NG1.LoginButtonComponent.paymentChannel" ng-click="$navi.toggleNavi()"></a>
      </li>
    </ul>
  </div>
</div>
<div class="salaxy-login-button" sxy-if-role="worker" ng-controller="NaviController as $navi">
  <div ng-show="$ctrl.isAuthenticated" class="dropdown salaxy-login-button-logout">
    <button type="button" class="btn dropdown-toggle btn-transparent" data-bs-toggle="dropdown">
      <salaxy-avatar avatar="$ctrl.avatar" class="me-2"></salaxy-avatar>
      <span class="salaxy-login-button-text">{{ $ctrl.isAuthenticated ? $ctrl.avatar.displayName : ('SALAXY.NG1.LoginButtonComponent.authenticating' | sxyTranslate) }}
      </span>
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="account-menu">
      <li>
        <a href="#" ng-click="$ctrl.signOut()" class="dropdown-item" sxy-text="SALAXY.UI_Terms.logout"></a>
      </li>
      <li role="separator" class="dropdown-divider"></li>
      <li>
        <a href="#/account/account-info" sxy-text="SALAXY.NG1.LoginButtonComponent.accountSettings" ng-click="$navi.toggleNavi()" class="dropdown-item"></a>
      </li>
      <li>
        <a href="#/settings/authorizations" sxy-text="SALAXY.NG1.LoginButtonComponent.authAndCerti" ng-click="$navi.toggleNavi()" class="dropdown-item"></a>
      </li>
    </ul>
  </div>
</div>`);

 $templateCache.put("salaxy-components/account/Signing.html",`<div class="salaxy-component salaxy-signing">
  <div salaxy-if-role="init">
    <salaxy-spinner heading="SALAXY.UI_Terms.loading"></salaxy-spinner>
    <p>&nbsp;</p>
  </div>
  <div ng-if="$ctrl.isSigningRequired || $ctrl.showAlways">
    <form name="signingForm" class="form-horizontal">
      <h2 sxy-text="SALAXY.NG1.SigningComponent.heading"></h2>
      <div class="row">
        <div class="col-md-6">
          <fieldset>
            <legend sxy-text="SALAXY.NG1.SigningComponent.signerInformation"></legend>
            <salaxy-input name="sign_personName" label="SALAXY.NG1.SigningComponent.name" ng-model="$ctrl.model.signature.personName" ng-required="true"></salaxy-input>
            <salaxy-input name="sign_email" label="SALAXY.NG1.SigningComponent.email" sxy-email ng-model="$ctrl.model.signature.email" ng-required="true"></salaxy-input>
            <salaxy-input name="sign_telephone" label="SALAXY.NG1.SigningComponent.tel" sxy-mobile-phone ng-model="$ctrl.model.signature.telephone" ng-required="true">
            </salaxy-input>
            <salaxy-input name="sign_personalId" label="SALAXY.NG1.SigningComponent.ssNumber" sxy-personal-id-fi ng-model="$ctrl.model.signature.personalId" ng-required="true">
            </salaxy-input>
            <div class="text-right text-danger" style="margin-top: -14px; font-weight: bold;" sxy-if-role="test"> TEST ONLY: Ota hetu täältä ==></div>
            <salaxy-input-boolean type="checkbox" name="isProcura" required ng-model="$ctrl.model.signature.isProcura" label="SALAXY.NG1.SigningComponent.isProcuraLabel"
              label-true="SALAXY.NG1.SigningComponent.isProcuraLabelTrue"></salaxy-input-boolean>
          </fieldset>
        </div>
        <div class="col-md-6">
          <legend sxy-text="SALAXY.NG1.SigningComponent.attorney.info"></legend>
          <p>
            <span sxy-text="SALAXY.NG1.SigningComponent.attorney.infoText"></span>

            <a ng-href="{{ $ctrl.getPdfPreviewAddress() }}" target="_blank">{{'SALAXY.NG1.SigningComponent.attorney.linkText' | sxyTranslate}}</a>.
            {{'SALAXY.NG1.SigningComponent.attorney.linkTextInfo' | sxyTranslate}}
          </p>
          <p sxy-text="SALAXY.NG1.SigningComponent.attorney.signingConfirmationInfo"></p>
          <div sxy-if-role="test" class="alert alert-danger">
            <p>
              Allekirjoitus ohjaa nyt testiympäristöön, jossa
              <strong>HETU tarkistetaan</strong>.
              Katso testiympäristön
              <a href="https://gist.github.com/ykarikos/e43e567eb7b9e05432d4bd9d0b51ef35" target="_blank">HETU:t täältä</a>
              (valitse validi hetu).
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <fieldset>
            <legend sxy-text="SALAXY.NG1.SigningComponent.salaryPaymentContactInformation"></legend>
            <p sxy-text="SALAXY.NG1.SigningComponent.salaryPaymentContanctInformationToAuthoritiesInfo"></p>
            <salaxy-input-boolean type="checkbox" name="isContactPersonSigner" ng-model="$ctrl.isContactPersonSigner" label="SALAXY.NG1.SigningComponent.contactPersonLabel"
              label-true="SALAXY.NG1.SigningComponent.contactPersonLabelTrue"></salaxy-input-boolean>
            <div ng-if="!$ctrl.isContactPersonSigner">
              <salaxy-input name="contact_email" label="SALAXY.NG1.SigningComponent.email" sxy-email ng-model="$ctrl.model.company.contact.email" ng-required="true">
              </salaxy-input>
              <salaxy-input name="contact_telephone" label="SALAXY.NG1.SigningComponent.tel" sxy-mobile-phone ng-model="$ctrl.model.company.contact.telephone" ng-required="true">
              </salaxy-input>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6">
          <fieldset>
            <legend sxy-text="SALAXY.NG1.SigningComponent.postalAddress"></legend>
            <salaxy-input label="SALAXY.NG1.SigningComponent.streetAddress" name="Katuosoite" ng-model="$ctrl.model.company.contact.street" ng-required="true"></salaxy-input>
            <salaxy-input label="SALAXY.NG1.SigningComponent.postalNumber" name="Postinumero" sxy-postal-code-fi ng-model="$ctrl.model.company.contact.postalCode"
              ng-required="true"></salaxy-input>
            <salaxy-input label="SALAXY.NG1.SigningComponent.postOffice" name="Postitoimipaikka" ng-model="$ctrl.model.company.contact.city" ng-required="true"></salaxy-input>
          </fieldset>
        </div>
      </div>
      <p sxy-html="SALAXY.NG1.SigningComponent.authoritativeQuestions.bySigningAcceptTermsOfUse.html"></p>
      <div class="mb-2">
        <div>
          <button class="btn btn-primary" ng-disabled="!signingForm.$valid || $ctrl.isSigninStarted" ng-click="signingForm.$valid ? $ctrl.startDigitalSignature() : null"
            sxy-text="SALAXY.NG1.SigningComponent.signBtn"></button> &nbsp; &nbsp;
          <span ng-if="!signingForm.$valid" class="text-danger" sxy-text="SALAXY.NG1.SigningComponent.authoritativeQuestions.error"></span>
        </div>
      </div>
      <p sxy-text="SALAXY.NG1.SigningComponent.authoritativeQuestions.usePersonalMobileBanking"></p>
      <hr />
      <div>
        <div class="d-flex justify-content-between">
          <h3 sxy-text="SALAXY.NG1.SigningComponent.authoritativeQuestions.previewAttorney"></h3>
          <div>
            <small><a ng-href="{{ $ctrl.getPdfPreviewAddress() }}" target="_blank" sxy-text="SALAXY.NG1.SigningComponent.authoritativeQuestions.downloadPDF"></a>&nbsp;&nbsp;</small>
            <button ng-click="$ctrl.save()" ng-disabled="!signingForm.$valid" class="btn btn-primary"
              sxy-text="SALAXY.NG1.SigningComponent.authoritativeQuestions.updateForPreview"></button>
          </div>
        </div>
        <iframe id="preview-power-of-attorney-pdf" ng-src="{{ $ctrl.getPdfPreviewAddress() }}" class="w-100"></iframe>
      </div>
    </form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/account/UserInfo.html",`﻿<div class="salaxy-component salaxy-user-info">
  <div class="d-flex flex-column flex-md-row">
    <salaxy-avatar class="avatar-xl mb-1 me-4" avatar="$ctrl.session.currentCredential.avatar"></salaxy-avatar>
    <p class="lead" sxy-html="SALAXY.NG1.UserInfoComponent.description.html"></p>
  </div>
   
  <div class="table-responsive">
    <table class="table">
      <tr>
        <th colspan="2">
          <h3 sxy-text="SALAXY.NG1.UserInfoComponent.userNameTitle"></h3>
        </th>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.UserInfoComponent.authType" ps=":"></th>
        <td>{{ 'AuthenticationMethod.' + $ctrl.session.currentCredential.authenticationMethod | sxyEnum }}</td>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.UserInfoComponent.userName" ps=":"></th>
        <td>{{ $ctrl.session.currentCredential.id }}</td>
      </tr>
      <tr ng-if="$ctrl.session.currentCredential.authenticationMethod != 'salaxy' && $ctrl.session.currentCredential.authenticationMethod != 'x509'">
        <th sxy-text="SALAXY.NG1.UserInfoComponent.email" ps=":"></th>
        <td>{{ $ctrl.session.currentCredential.email }}</td>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.UserInfoComponent.name" ps=":"></th>
        <td>{{ $ctrl.session.currentCredential.avatar.displayName }}</td>
      </tr>
    </table>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/2022/CalcEmployment.html",`<div class="salaxy-component salaxy-calc-employment">
  <div ng-if="!$ctrl.current.worker.employmentId" class="alert alert-danger">
    <strong>Error: Not supported</strong>
    <p>Tämä komponentti ei tue uuden Työntekijän valintaa (implement EmploymentSelect)</p>
  </div>
  <div ng-if="$ctrl.current.worker.employmentId">
    <salaxy-form-group class="select-worker" name="worker" label="SALAXY.NG1_Pages.Calc.History.workerLabel">
      <!--
        TODO: Need to create Employment relation selection component!
        <button class="btn btn-default float-end" ng-click="$ctrl.current.worker=null;todo()">Vaihda...</button>
      -->
      <div class="salaxy-worker-item">
        <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="$ctrl.current.worker.avatar"></salaxy-avatar>
        <b>{{ $ctrl.current.worker.avatar.displayName }} ({{$ctrl.current.worker.paymentData.socialSecurityNumberValid}}) </b> <br />
        <small>
          <div>IBAN: {{ $ctrl.current.worker.paymentData.ibanNumber | sxyIban }}</div>
        </small>
      </div>
    </salaxy-form-group>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/2022/CalcRowsEditor.html",`<div class="salaxy-component salaxy-calc-rows-editor salaxy-calc-rows-2022-editor" ng-switch="$ctrl.type">
  <div ng-switch-when="salary-defaults" class="salaxy-calc-rows-editor-worktime-import">
    <!-- TODO: Will be replaced by new row type editors -->
    <table class="table table-sm align-middle">
      <thead>
        <tr>
          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editor.action"></th>
          <th colspan="2">{{ $ctrl.title | sxyTranslate }}</th>
          <th class="right" sxy-text="SALAXY.NG1.DateRange.labelStartAndEndDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.filteredList track by $index">
          <td style="width: 25%;">
            <salaxy-input-enum type="select" label-type="plain" ng-model="row.source"
              filter="{{$ctrl.rowSources}}" hidden-options="''"
              name="{{ 'source' + $index }}" enum="CalculationRowSource"></salaxy-input-enum>
          </td>
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td style="width: 40%;">
            <div>{{row.message || ( "CalculationRowType." + row.rowType | sxyEnum) }}</div>
            <div ng-if="row.count && row.count != 1"><small class="text-muted">{{row.count | sxyCount : row.unit }} * {{ row.price | currency }}</small></div>
            <small class="" ng-if="$ctrl.getValidation(row).type == 'default'">
              {{ $ctrl.getValidation(row).msg | sxyTranslate }}
            </small>
            <span ng-if="$ctrl.getValidation(row).type == 'error'">
              <span class="label label-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.note"></span>
              <small class="alert-danger">{{ $ctrl.getValidation(row).msg | sxyTranslate }}
                <a href="" ng-click="$ctrl.showEdit(row, 'auto')" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
              </small>
            </span>
          </td>
          <td class="right">
            <div>{{ row.period | sxyDateRange }}&nbsp;&nbsp;</div>
          </td>
          <td style="width: 32px;">
            <div class="float-end">{{ $ctrl.getRowTotal(row) | currency }}</div>
          </td>
          <td class="right">
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}">
              <i class="bi bi-info-circle-fill" ng-class="$ctrl.current == row ? 'bi-arrow-right-circle-fill' : 'bi-info-circle'"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-transclude ng-transclude-slot="footer">
      <footer>
        <p><b>{{'SALAXY.NG1.CalcRowsComponent.editor.addNewRow' | sxyTranslate}}:</b></p>
        <table>
          <tbody>
            <tr>
              <td style="width: 40%;">
                <salaxy-input-enum type="select" label-type="plain" ng-model="$ctrl.newRow.source"
                  filter="{{$ctrl.rowSources}}" hidden-options="''"
                  name="newRowSource" enum="CalculationRowSource"></salaxy-input-enum>
              </td>
              <td style="width: 40%;">
                <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder"
                  on-row-changed="$ctrl.commitNewRow(true)" row-types="$ctrl.rowTypes" categories="$ctrl.categories"></salaxy-calc-row-type>
              </td>
              <td>
                <button type="button" class="btn btn-default w-100" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-circle-fill text-primary me-2"></i> <span
                    sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
              </td>
            </tr>
          </tbody>
        </table>
      </footer>
    </ng-transclude>
  </div>
  <div ng-switch-when="salary-defaults-temp2" class="salaxy-calc-rows-editor-worktime-import">
    <!-- TODO: Will be replaced by new row type editors -->
    <table class="table table-condensed">
      <thead>
        <tr>
          <th colspan="2">{{ $ctrl.title | sxyTranslate }}</th>
          <th class="right" sxy-text="SALAXY.NG1.DateRange.labelStartAndEndDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.filteredList track by $index">
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td style="width: 40%;">
            <div>{{row.message || ( "CalculationRowType." + row.rowType | sxyEnum) }}</div>
            <div ng-if="row.count && row.count != 1"><small class="text-muted">{{row.count | sxyCount : row.unit }} * {{ row.price | currency }}</small></div>
            <small class="" ng-if="$ctrl.getValidation(row).type == 'default'">
              {{ $ctrl.getValidation(row).msg | sxyTranslate }}
            </small>
            <span ng-if="$ctrl.getValidation(row).type == 'error'">
              <span class="label label-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.note"></span>
              <small class="alert-danger">{{ $ctrl.getValidation(row).msg | sxyTranslate }}
                <a href="" ng-click="$ctrl.showEdit(row, 'auto')" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
              </small>
            </span>
          </td>
          <td class="right">
            <div>{{ row.period | sxyDateRange }}&nbsp;&nbsp;</div>
          </td>
          <td style="width: 32px;">
            <div class="float-end">{{ $ctrl.getRowTotal(row) | currency }}</div>
          </td>
          <td class="right">
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}">
              <i class="bi bi-info-circle-fill" ng-class="$ctrl.current == row ? 'bi-arrow-right-circle-fill' : 'bi-info-circle'"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-transclude ng-transclude-slot="footer">
      <footer>
        <table>
          <tbody>
            <tr>
              <td><b>{{'SALAXY.NG1.CalcRowsComponent.editor.addNewRow' | sxyTranslate}}:</b></td>
              <td>
                <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder"
                  on-row-changed="$ctrl.commitNewRow(true)" row-types="$ctrl.rowTypes" categories="$ctrl.categories" clear-on-select="true"></salaxy-calc-row-type>
              </td>
              <td>
                <button type="button" class="btn btn-default" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-circle-fill text-primary me-2"></i> <span
                    sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
              </td>
            </tr>
          </tbody>
        </table>
      </footer>
    </ng-transclude>
  </div>
  <div ng-switch-when="worktime-import" class="salaxy-calc-rows-editor-worktime-import">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th sxy-text="SALAXY.NG1.ImportStagingCalcRowsEditorComponent.validation"></th>
          <th colspan="2">
            <div sxy-text="SALAXY.NG1.ImportStagingCalcRowsEditorComponent.employmentId"></div>
            <div sxy-text="SALAXY.NG1.ImportStagingCalcRowsEditorComponent.personalId"></div>
          </th>
          <th colspan="2">{{ $ctrl.title | sxyTranslate }}</th>
          <th>
            <div sxy-text="SALAXY.NG1.ImportStagingCalcRowsEditorComponent.rowType"></div>
            <div sxy-text="SALAXY.NG1.ImportStagingCalcRowsEditorComponent.kind"></div>
          </th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.filteredList track by $index">
          <td ng-if="row.validation.isValid">
            <div class="text-success"><b>{{"SALAXY.UI_Terms.ok" | sxyTranslate}}</b></div>
          </td>
          <td ng-if="row.validation.isValid == null">
            <div class="text-muted" sxy-text="SALAXY.NG1.ImportStagingCalcRowsEditorComponent.noValidation"></div>
          </td>
          <td ng-if="row.validation.isValid === false">
            <div class="text-danger"><salaxy-validation-summary api-validation="row.validation" layout="minimal"></salaxy-validation-summary></div>
          </td>
          <td style="width: 32px;">
            <salaxy-avatar class="salaxy-calc-row-type-avatar"
              avatar="row.$avatar"></salaxy-avatar>
          </td>
          <td ng-if="row.$avatar">
            <div>{{ row.$avatar.sortableName }}</div>
            <div>{{ row.personalId || "-" }} ({{ row.employmentType || "-" }})</div>
          </td>
          <td ng-if="!row.$avatar">
            <div>{{ row.employmentId || "-" }}</div>
            <div>{{ row.personalId || "-" }} ({{ row.employmentType || "-" }})</div>
          </td>
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td>
            <div>{{row.message || ( "CalculationRowType." + row.rowType | sxyEnum) }}</div>
            <div ng-if="row.count && row.count != 1"><small class="text-muted">{{row.count | sxyCount : row.unit }} * {{ row.price | currency }}</small></div>
            <small class="" ng-if="$ctrl.getValidation(row).type == 'default'">
              {{ $ctrl.getValidation(row).msg | sxyTranslate }}
            </small>
            <span ng-if="$ctrl.getValidation(row).type == 'error'">
              <span class="label label-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.note"></span>
              <small class="alert-danger">{{ $ctrl.getValidation(row).msg | sxyTranslate }}
                <a href="" ng-click="$ctrl.showEdit(row, 'auto')" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
              </small>
            </span>
          </td>
          <td>
            <div>{{ ("CalculationRowType." + row.rowType | sxyEnum ) || "-" }}</div>
            <div>{{ row.data.kind || "-" }}</div>
          </td>
          <td>
            <div class="float-end">{{ $ctrl.getRowTotal(row) | currency }}</div>
          </td>
          <td class="right">
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}">
              <i class="bi bi-info-circle-fill" ng-class="$ctrl.current == row ? 'bi-arrow-right-circle-fill' : 'bi-info-circle'"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-switch-when="worktime-import-employment" class="salaxy-calc-rows-editor-worktime-import">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th sxy-text="SALAXY.NG1.ImportStagingCalcRowsEditorComponent.validation"></th>
          <th class="right">
            <div sxy-text="SALAXY.NG1.ImportStagingCalcRowsEditorComponent.period"></div>
            <div sxy-text="SALAXY.NG1.ImportStagingCalcRowsEditorComponent.status"></div>
          </th>
          <th colspan="2">{{ $ctrl.title | sxyTranslate }}</th>
          <th>
            <div sxy-text="SALAXY.NG1.ImportStagingCalcRowsEditorComponent.rowType"></div>
            <div sxy-text="SALAXY.NG1.ImportStagingCalcRowsEditorComponent.kind"></div>
          </th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.filteredList track by $index">
          <td ng-if="row.validation.isValid">
            <div class="text-success">
              <b>OK</b>
              <a ng-href="{{ '#/payroll/details/' + row.data.payrollId }}" ng-if="row.data.payrollId">{{'SALAXY.NG1.ImportStagingCalcRowsEditorComponent.payroll' | sxyTranslate}}</a>
            </div>
            <div ng-if="row.data.originalPayrollId" style="padding-left: 22px;">
              <a ng-href="{{ '#/payroll/details/' + row.data.originalPayrollId }}" ng-if="row.data.originalPayrollId">{{'SALAXY.NG1.ImportStagingCalcRowsEditorComponent.originalPayroll' | sxyTranslate}}</a>
            </div>
          </td>
          <td ng-if="row.validation.isValid == null">
            <div class="text-muted" sxy-text="SALAXY.NG1.ImportStagingCalcRowsEditorComponent.noValidation"></div>
          </td>
          <td ng-if="row.validation.isValid === false">
            <div class="text-danger"><salaxy-validation-summary api-validation="row.validation" layout="minimal"></salaxy-validation-summary></div>
          </td>
          <td class="right" ng-switch="row.status">
            <div>{{ row.period | sxyDateRange }}</div>
            <div ng-switch-when="preview" class="text-warning"><b>{{"SALAXY.NG1.ImportStagingCalcRowsEditorComponent.rowStatuses.preview" | sxyTranslate}}</b></div>
            <div ng-switch-when="new" class="text-primary"><b>{{"SALAXY.NG1.ImportStagingCalcRowsEditorComponent.rowStatuses.new" | sxyTranslate}}</b></div>
            <div ng-switch-when="deleted" class="text-danger"><s>{{"SALAXY.NG1.ImportStagingCalcRowsEditorComponent.rowStatuses.deleted" | sxyTranslate}}</s></div>
            <div ng-switch-when="error" class="text-danger"><b>{{"SALAXY.NG1.ImportStagingCalcRowsEditorComponent.rowStatuses.error" | sxyTranslate}}</b></div>
            <div ng-switch-when="committed" class="text-success"><b>{{"SALAXY.NG1.ImportStagingCalcRowsEditorComponent.rowStatuses.committed" | sxyTranslate}}</b></div>
            <div ng-switch-when="ignored" class="text-muted"><s>{{"SALAXY.NG1.ImportStagingCalcRowsEditorComponent.rowStatuses.ignored" | sxyTranslate}}</s></div>
            <div ng-switch-when="edited" class="text-primary">{{"SALAXY.NG1.ImportStagingCalcRowsEditorComponent.rowStatuses.edited" | sxyTranslate}}</div>
            <div ng-switch-default>{{ row.status }}</div>
          </td>
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td>
            <div>{{row.message || ( "CalculationRowType." + row.rowType | sxyEnum) }}</div>
            <div ng-if="row.count && row.count != 1"><small class="text-muted">{{row.count | sxyCount : row.unit }} * {{ row.price | currency }}</small></div>
            <small class="" ng-if="$ctrl.getValidation(row).type == 'default'">
              {{ $ctrl.getValidation(row).msg | sxyTranslate }}
            </small>
            <span ng-if="$ctrl.getValidation(row).type == 'error'">
              <span class="label label-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.note"></span>
              <small class="alert-danger">{{ $ctrl.getValidation(row).msg | sxyTranslate }}
                <a href="" ng-click="$ctrl.showEdit(row, 'auto')" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
              </small>
            </span>
          </td>
          <td>
            <div>{{ (row.rowType || 'unknown') == "unknown" ? "-" : ("CalculationRowType." + row.rowType | sxyEnum) }}</div>
            <div>{{ row.data.kind || "-" }}</div>
          </td>
          <td>
            <div class="float-end">{{ $ctrl.getRowTotal(row) ? ($ctrl.getRowTotal(row) | currency) : "-" }}</div>
          </td>
          <td class="right">
            <input type="checkbox" ng-model="row.data.isSelected" ng-if="$ctrl.showRowSelection" style="margin-right: 8px;margin-top: 10px;" />
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}">
              <i class="bi bi-info-circle-fill" ng-class="$ctrl.current == row ? 'bi-arrow-right-circle-fill' : 'bi-info-circle'"></i></button>
            <salaxy-json-formatter key="'js'" json="row" open="2" type="dialog" btn-class="btn btn-default" ></salaxy-json-formatter>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-switch-default class="row">
    <div class="col-sm-6">
      <table class="table table-sm">
        <thead>
          <tr>
            <th colspan="2" class="uppercase">{{ $ctrl.title || ('SALAXY.NG1.CalcRowsComponent.editor.calcRow' | sxyTranslate) }}</th>
            <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.filteredList track by $index">
            <td width="42px">
              <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
                avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
            </td>
            <td width="100%">
              <div class="float-end">{{ $ctrl.getRowTotal(row) | currency }}</div>
              <div>{{row.message || ( "CalculationRowType." + row.rowType | sxyEnum) }}</div>
              <div ng-if="row.count && row.count != 1"><small class="text-muted">{{row.count | sxyCount : row.unit }} * {{ row.price | currency }}</small></div>
              <small class="" ng-if="$ctrl.getValidation(row).type == 'default'">
                {{ $ctrl.getValidation(row).msg | sxyTranslate }}
              </small>
              <span ng-if="$ctrl.getValidation(row).type == 'error'">
                <span class="label label-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.note"></span>
                <small class="alert-danger">{{ $ctrl.getValidation(row).msg | sxyTranslate }}
                  <a href="" ng-click="$ctrl.showEdit(row, 'auto')" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
                </small>
              </span>
            </td>
            <td class="right">
              <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
                title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}">
                <i class="bi bi-info-circle-fill" ng-class="$ctrl.current == row ? 'bi-arrow-right-circle-fill' : 'bi-info-circle'"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-transclude ng-transclude-slot="footer">
        <footer>
          <p><b>{{'SALAXY.NG1.CalcRowsComponent.editor.addNewRow' | sxyTranslate}}:</b></p>
          <table>
            <tbody>
              <tr>
                <td style="width: 100%;">
                  <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder"
                    on-row-changed="$ctrl.commitNewRow(true)" row-types="$ctrl.rowTypes" categories="$ctrl.categories"></salaxy-calc-row-type>
                </td>
                <td>
                  <button type="button" class="btn btn-default" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-circle-fill text-primary me-2"></i> <span
                      sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
                </td>
              </tr>
            </tbody>
          </table>
        </footer>
      </ng-transclude>
    </div>
    <div class="col-sm-6 d-none d-sm-block salaxy-calc-rows-editor-details-container">
      <ng-include ng-if="$ctrl.current" src="'salaxy-components/calc/rows/CalcRows2019EditDialog.html'"></ng-include>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/2022/CalcUsecase.html",`<div class="salaxy-component salaxy-calc-usecase" ng-controller="NaviController as $naviCtrl">

  <salaxy-spinner ng-if="$ctrl.isLoading"></salaxy-spinner>
  <div class="btn-toolbar calc-toolbar" ng-if="$ctrl.current">
    <div class="btn-group dropdown" ng-if="$ctrl.current.worker.employmentId">
      <button id="workerBtn" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        <salaxy-avatar avatar="$ctrl.current.worker.avatar" style="font-size: 2em; margin: -5px 5px -5px -10px; width: 1em; height: 1em;"></salaxy-avatar>  
        {{ $ctrl.current.worker.avatar.displayName }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="workerBtn">
        
        <li role="menuitem"><a href="" ng-click="$ctrl.isWorkerInfoOpen = true" data-bs-toggle="collapse" data-bs-target="#workerInfo" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.showAdditionalInfo"></a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.showWorkerEditDialog()" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.editWorker"></a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.showRefreshAutoTaxcardDialog()" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.checkAutomaticTaxCard"></a></li>
      </ul>
    </div>
   
    <div class="ms-auto d-flex calc-actions flex-wrap" ng-if="$ctrl.current.worker.employmentId && !$ctrl.usecases">
      <salaxy-calc-sharing-receipt-action ng-if="$ctrl.showAction('reject')" button-class="btn btn-danger" model="$ctrl" type="'reject'"></salaxy-calc-sharing-receipt-action>
      <salaxy-calc-sharing-receipt-action ng-if="$ctrl.showAction('approve')"  button-class="btn btn-success" model="$ctrl" type="'approve'"></salaxy-calc-sharing-receipt-action>
      <button ng-if="$ctrl.showAction('save')" ng-disabled="$ctrl.isActionDisabled('save')" type="button" class="btn btn-primary" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.save"></button>
      <salaxy-pay-button ng-if="$ctrl.showAction('pay')" model="$ctrl.current" mode="pay-button" style="display: inline-block" ng-ref="$payButton" disabled="!$payButton.isChannelDefined"></salaxy-pay-button>
      <salaxy-pay-button ng-if="$ctrl.showAction('pay')" model="$ctrl.current" mode="channel-select" style="display: inline-block"></salaxy-pay-button>
    
      <div class="btn-group dropdown">
        <button id="actionsBtn" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
          <i class="bi bi-three-dots"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end" role="menu" aria-labelledby="actionsBtn">
          <li role="menuitem" ng-if="$ctrl.showAction('recalculate')">
            <a href="" ng-click="$ctrl.recalculate()" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.recalculate"></a>
          </li>
          <li role="menuitem"><a href="" ng-click="$ctrl.showReportDialog('salarySlip')" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.reports" ps="..."></a></li>
          <li role="menuitem"><a href="" ng-click="$ctrl.showUsecaseInfo()" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.usecase"></a></li>
          
          <li role="menuitem" ng-if="$ctrl.showAction('cancel')">
            <a href="" ng-click="$ctrl.cancel()" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.cancelPayment"></a>
          </li>
          <li role="menuitem" ng-if="$ctrl.showAction('copyAsNew')">
            <a href="" ng-click="$ctrl.showCopyAsNew($ctrl.current)" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.copy"></a>
          </li>
          <li role="menuitem" ng-if="$ctrl.showAction('showPaymentDialog')">
            <a href="" ng-click="$ctrl.showPaymentDialog()" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.showPaymentInfo"></a>
          </li>

          <li role="menuitem" ng-if="$ctrl.showAction('delete')">
            <a href="" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isActionDisabled('delete')" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.deleteCalc"></a>
          </li>
          <li role="menuitem" style="margin: 5px 20px;">
            <salaxy-json-formatter key="'JSON Data'" json="$ctrl.current" open="2" type="dialog"></salaxy-json-formatter>
          </li>
        </ul>
      </div>
    </div>
  </div>
  
  <div class="worker-info-wrapper collapse" id="workerInfo">
    <button class="btn btn-transparent close-btn btn-sm" data-bs-toggle="collapse" data-bs-target="#workerInfo"><i class="bi bi-x-lg"></i></button>
    <salaxy-calc-worker-info model="$ctrl.current"></salaxy-calc-worker-info>
  </div>
  <div ng-if="$ctrl.usecases">
    <h2 sxy-text="SALAXY.NG1.CalcUsecase.selectCalculationType" class="mt-3"></h2>
    <div class="row g-4">
      <div class="col-sm-6 col-md-4" ng-repeat="usecase in $ctrl.usecases">
        <div class="card">
          <div class="text-center  card-pic-fixed clickable" style="height: 150px;position: relative;" ng-click="$ctrl.setUsecase(usecase.uri)">
            <img ng-if="usecase.data.icon[0] == 'h'" ng-src="{{usecase.data.icon}}">
            <div ng-if="usecase.data.icon[0] != 'h'" class="bg-primary card-pic-icon">
              <i class="fa" ng-class="(usecase.data.icon || 'fa') == 'fa' ? 'bi-currency-euro' : usecase.data.icon" aria-hidden="true"></i>
            </div>
            <span class="badge float-end bg-info" ng-if="usecase.status=='default'" sxy-text="SALAXY.NG1.CalcUsecase.default"></span>
            <salaxy-avatar avatar="usecase.ownerInfo.avatar" style="font-size: 2em; position: absolute; right: 10px; bottom: 10px"></salaxy-avatar>
          </div>
          <div class="card-body p-3">
            <h3 class="truncate">{{ usecase.shortText }}</h3>
            <p style="height: 80px;overflow: hidden">{{ usecase.data.description }}</p>
            <button type="button" class="btn btn-primary mb-2" ng-click="$ctrl.setUsecase(usecase.uri)" sxy-text="SALAXY.UI_Terms.select"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div ng-if="$ctrl.current && !$ctrl.usecases">
    
    <div ng-if="!$ctrl.usecase.defaultView" style="margin-top: 6px">
      <salaxy-calc model="$ctrl"></salaxy-calc>
    </div>
    <div ng-if="$ctrl.usecase.defaultView">
      <div ng-if="!$ctrl.current.worker.employmentId">
        <div class="row">
          <div class="col-12 col-sm-7">
            <div class="intro-text">
              <h1 sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.selectWorker"></h1>
              <p sxy-html="SALAXY.NG1.CalcDetailsWorkerComponent.myWorkers.description.html"></p>
            </div>
          </div>
          <div class="col-12 col-sm-5">
            <button type="button" class="btn add-new-worker btn-primary float-end-sm" style="margin-bottom:5px;" ng-click="$ctrl.showNewWorkerDialog()" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.newWorker.cta"></button>
          </div>
          <div class="col-12">
            <div class="table-responsive">
              <salaxy-employment-list mode="select" on-list-select="$ctrl.updateFromEmployment(item.id, true)"></salaxy-employment-list>
            </div>
          </div>
        </div>
      </div>
      <div>
        
        <ng-include src="$ctrl.usecase.defaultView"></ng-include>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/Calc.html",`<div class="salaxy-component salaxy-calc">
  <div class="salaxy-calc-overview" ng-if="!$ctrl.current">
    <salaxy-spinner ng-if="$ctrl.isLoading"></salaxy-spinner>
  </div>

  <!--salaxy-varma-banner calc="$ctrl.current" ng-if="('auth' | sxyIsInRole) && ('company' | sxyIsInRole) && $ctrl.current.workflow.status == 'draft'"></salaxy-varma-banner-->
  <div class="row" sxy-if-role="worker">
    <div class="col-12 mb-2" ng-if="$ctrl.current.workflow.status == 'draft' || $ctrl.current.id == null">
      <p class="lead text-center" sxy-text="SALAXY.NG1.CalcComponent.introWorker"></p>
    </div>
  </div>
  <div ng-if="!$ctrl.isReadOnly && $ctrl.current" class="btn-toolbar calc-toolbar w-100">
    <div class="btn-group" role="group" ng-if="!$ctrl.isReadOnly">
      <div ng-if="'company' | sxyIsInRole" ng-controller="CompanyAccountController as $company" style="padding: 8px;">
        <salaxy-workflow-badge ng-if="$company.current" mode="horizontal" model="$company.current" api-ctrl="$company" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
      </div>
    </div>
  </div>
  <div class="salaxy-calc-overview" ng-if="$ctrl.current">
    <div sxy-if-role="worker" class="visible-xxs">
      <div class="mb-2" ng-if="$ctrl.current.workflow.status == 'draft' || $ctrl.current.workflow.status == 'workerRequested' || $ctrl.current.workflow.status == 'workerRequestAccepted' || $ctrl.current.workflow.status == 'workerRequestDeclined' || $ctrl.current.workflow.status == 'paymentWorkerCopy'">
        <salaxy-calc-sharing-info model="$ctrl"></salaxy-calc-sharing-info>
      </div>
    </div>
    <div class="calc-container" style="display:block;">
      <div class="salaxy-calc-step-container step1" ng-class="{ 'active': $ctrl.calcSections.get('worker').isActive }">
        <div class="card overview-worker salaxy-calc-overview-card">
          <div class="card-header" ng-click="$ctrl.calcSections.toggleActive('worker')">
            <i class="bi bi-x-lg float-end close"></i> <span class="overview-title" sxy-text="SALAXY.NG1.CalcComponent.panelWorker.heading"></span>
          </div>
          <div class="card-body">
            <div class="content-overview" ng-click="$ctrl.calcSections.toggleActive('worker')">
              <div ng-if="!$ctrl.calcSections.get('worker').isSelectionDone">
                <a href="">
                  <h3 class="text-center" sxy-html="SALAXY.NG1.CalcComponent.panelWorker.overview.html"></h3>
                </a>
              </div>
              <div class="salaxy-calc-overview-worker h-100" ng-if="$ctrl.calcSections.get('worker').isSelectionDone">
                <salaxy-avatar ng-if="$ctrl.current.worker.avatar.displayName" avatar="$ctrl.current.worker.avatar"></salaxy-avatar>
                <strong>{{$ctrl.current.worker.avatar.displayName || ("SALAXY.NG1.CalcComponent.panelWorker.noSelection" | sxyTranslate) }}</strong><br />
                <div ng-if="!$ctrl.isReadOnly" ng-controller="EmploymentCrudController as $employment"
                  ng-init="$employment.queryResult={};$employment.getOData({ '$filter': 'id eq \\'' +  $ctrl.current.worker.employmentId + '\\''}, $employment.queryResult)">
                  <salaxy-workflow-badge mode="horizontal" ng-if="$employment.queryResult.items.length > 0" model="$employment.queryResult.items[0]" api-ctrl="$employment"
                    wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
                </div>
                <div class="salaxy-calc-worker-info-texts" ng-if="$ctrl.current.worker.avatar.displayName">
                  <div class="text-danger" ng-if="$ctrl.taxUi.status == 'missing'">
                    {{ $ctrl.taxUi.shortText }}

                  </div>
                  <div ng-if="$ctrl.taxUi.status == 'ok'">{{ $ctrl.taxUi.shortText }}</div>
                  <div>{{ $ctrl.current.worker.paymentData.ibanNumber ? ('SALAXY.NG1.WorkerInfo.ibanOk'|sxyTranslate) : ('SALAXY.NG1.WorkerInfo.noIbanNumber' | sxyTranslate) }}
                  </div>
                  <div class="truncate">{{ $ctrl.current.info.occupationCode | sxyOccupation : "code-label" }}</div>
                  <div class="truncate">{{ $ctrl.getPensionText(true) }}</div>
                </div>
              </div>
            </div>
            <div class="content-details">
              <div ng-if="!$ctrl.isReadOnly" ng-controller="EmploymentCrudController as $employment" class="text-end" style="padding: 8px;"
                ng-init="$employment.queryResult={};$employment.getOData({ '$filter': 'id eq \\'' +  $ctrl.current.worker.employmentId + '\\''}, $employment.queryResult)">
                <salaxy-workflow-badge mode="horizontal" ng-if="$employment.queryResult.items.length > 0" model="$employment.queryResult.items[0]" api-ctrl="$employment"
                  wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
              </div>
              <ng-include src="'salaxy-components/calc/details/worker.html'"></ng-include>
            </div>
          </div>
        </div>
      </div>
      <div ng-if="$ctrl.isHousehold" class="salaxy-calc-step-container step2" ng-class="{ 'active': $ctrl.calcSections.get('household-usecase').isActive }">
        <div class="card card-warning salaxy-calc-overview-card">
          <div class="card-header" ng-click="$ctrl.calcSections.toggleActive('household-usecase')">
            <i class="bi bi-x-lg float-end close"></i><span class="overview-title" sxy-text="SALAXY.NG1.CalcComponent.panelHouseHold.heading"></span>
          </div>
          <div class="card-body">
            <div class="content-overview" ng-click="$ctrl.calcSections.toggleActive('household-usecase')">
              <div ng-show="!$ctrl.calcSections.get('household-usecase').isSelectionDone">
                <a href="">
                  <h3 class="text-center" sxy-html="SALAXY.NG1.CalcComponent.panelHouseHold.overview.html"></h3>
                </a>
              </div>
              <div ng-show="$ctrl.calcSections.get('household-usecase').isSelectionDone">
                <div>{{ $ctrl.getUsecaseText() | sxyTranslate}}</div>
              </div>
            </div>
            <div class="content-details">
              <salaxy-calc-household-usecase ng-if="$ctrl.currentCalc" calc="$ctrl.currentCalc"></salaxy-calc-household-usecase>
            </div>
          </div>
        </div>
      </div>
      <div ng-if="!$ctrl.isHousehold" class="salaxy-calc-step-container step2" ng-class="{ 'active': $ctrl.calcSections.get('worktime').isActive }">
        <div class="card overview-worktime salaxy-calc-overview-card">
          <div class="card-header " ng-click="$ctrl.calcSections.toggleActive('worktime');$ctrl.worktimeCtrl.loadEmployment()">
            <i class="bi bi-x-lg float-end close"></i><span class="overview-title" sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.heading"></span>
          </div>
          <div class="card-body">
            <div class="content-overview" ng-click="$ctrl.calcSections.toggleActive('worktime');$ctrl.worktimeCtrl.loadEmployment()">
              <div ng-show="!$ctrl.calcSections.get('worktime').isSelectionDone">
                <a href="">
                  <h3 class="text-center" sxy-html="SALAXY.NG1.CalcComponent.panelWorkTime.overview.html"></h3>
                </a>
              </div>
              <div ng-show="$ctrl.calcSections.get('worktime').isSelectionDone">
                <div><strong>{{ $ctrl.getDatesRangeText() | sxyTranslate }}</strong></div>
                <table>
                  <tbody>
                    <tr>
                      <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.salaryDate"></td>
                      <td class="right" ng-if="!$ctrl.currentCalc.workflow.requestedSalaryDate" sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.now"></td>
                      <td class="right" ng-if="$ctrl.currentCalc.workflow.requestedSalaryDate">{{ $ctrl.currentCalc.workflow.salaryDate | sxyDate }}</td>
                    </tr>
                  </tbody>
                </table>
                <table>
                  <tbody>
                    <tr>
                      <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.leavesDays"></td>
                      <td class="right">{{ $ctrl.calculatePeriodDays('leavesDays') | sxyCount : 'day' }}</td>
                    </tr>
                    <tr>
                      <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.absencesDays"></td>
                      <td class="right">{{ $ctrl.calculatePeriodDays('absencesDays') | sxyCount : 'day' }}</td>
                    </tr>
                    <tr>
                      <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.paidAbsencesDays"></td>
                      <td class="right">{{ $ctrl.calculatePeriodDays('paidAbsencesDays') | sxyCount : 'day' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="content-details">
              <salaxy-calc-worktime ng-ref="$ctrl.worktimeCtrl" ng-if="$ctrl.currentCalc" calc="$ctrl.currentCalc"></salaxy-calc-worktime>
            </div>
          </div>
        </div>
      </div>
      <div class="salaxy-calc-step-container step3" ng-class="{ 'active': $ctrl.calcSections.get('salary').isActive }">
        <div class="card overview-salary salaxy-calc-overview-card">
          <div class="card-header" ng-click="$ctrl.calcSections.toggleActive('salary')">
            <i class="bi bi-x-lg float-end close"></i><span class="overview-title" sxy-text="SALAXY.NG1.CalcComponent.panelSalary.heading"></span>
          </div>
          <div class="card-body">
            <div class="content-overview" ng-click="$ctrl.calcSections.toggleActive('salary')">
              <table>
                <tbody>
                  <tr>
                    <td>
                      {{ $ctrl.calcLogic.hasCompensation ? ('SALAXY.NG1.CalcDetailsExpensesComponent.foreclosurePayment.infoCompensation' | sxyTranslate) :
                      ('SALAXY.NG1.CalcDetailsExpensesComponent.foreclosurePayment.infoSalary' | sxyTranslate) }}
                    </td>
                    <td class="right">{{$ctrl.currentCalc.result.totals.totalBaseSalary || 0 | currency : "" : 2}} €</td>
                  </tr>
                  <tr>
                    <td sxy-text="SALAXY.NG1.CalcDetailsExpensesComponent.titleAdditions"></td>
                    <td class="right">{{ ($ctrl.currentCalc.result.totals.totalGrossSalary - $ctrl.currentCalc.result.totals.totalBaseSalary) || 0 | currency : "" : 2}} €</td>
                  </tr>
                  <tr class="total">
                    <td sxy-text="SALAXY.NG1.GeneralCalcDetailLabels.total"></td>
                    <td class="right">{{$ctrl.currentCalc.result.totals.totalGrossSalary || 0 | currency : "" : 2}} €</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="content-details">
              <ng-include src="'salaxy-components/calc/details/salary.html'"></ng-include>
            </div>
          </div>
        </div>
      </div>
      <div class="salaxy-calc-step-container step4" ng-class="{ 'active': $ctrl.calcSections.get('expenses').isActive }">
        <div class="card overview-expenses salaxy-calc-overview-card">
          <div class="card-header" ng-click="$ctrl.calcSections.toggleActive('expenses')">
            <i class="bi bi-x-lg float-end close"></i> <span class="overview-title" sxy-text="SALAXY.NG1.CalcComponent.panelExpenses.heading"></span>
          </div>
          <div class="card-body">
            <div class="content-overview" ng-click="$ctrl.calcSections.toggleActive('expenses')">
              <table>
                <tbody>
                  <tr>
                    <td sxy-text="SALAXY.NG1.CalcDetailsExpensesComponent.compensations.title"></td>
                    <td class="right">{{ $ctrl.currentCalc.result.totals.totalExpenses || 0 | currency : '' : 2}}€</td>
                  </tr>
                  <tr>
                    <td sxy-text="SALAXY.NG1.CalcDetailsExpensesComponent.benefits.title"></td>
                    <td class="right">{{ $ctrl.currentCalc.result.workerCalc.benefits || 0 | currency : '' : 2}}€</td>
                  </tr>
                  <tr>
                    <td sxy-text="SALAXY.NG1.CalcDetailsExpensesComponent.deductions"></td>
                    <td class="right">{{ $ctrl.calcLogic.expensesTotal || 0 | currency : '' : 2}}€</td>
                  </tr>
                  <tr ng-if="$ctrl.isHousehold">
                    <td ng-if="$ctrl.calcLogic.childCareSubsidy">Yks. hoid. tuki</td>
                    <td ng-if="$ctrl.calcLogic.childCareSubsidy" class="right">{{ $ctrl.calcLogic.childCareSubsidy || 0 | currency : '' : 2}}€</td>
                    <td colspan="2" class="text-end" ng-if="!$ctrl.calcLogic.childCareSubsidy">
                      <small>{{ $ctrl.isHouseholdDeductible ? ("SALAXY.NG1.CalcComponent.panelExpenses.householdExpense" | sxyTranslate) :
                        ("SALAXY.NG1.CalcComponent.panelExpenses.noHouseholdExpenses" | sxyTranslate) }}</small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="content-details">
              <ng-include src="'salaxy-components/calc/details/expenses.html'"></ng-include>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <salaxy-calc-new-intro model="$ctrl"></salaxy-calc-new-intro>
  <salaxy-calc-results model="$ctrl"></salaxy-calc-results>
</div>`);

 $templateCache.put("salaxy-components/calc/CalcChart.html",`<!-- <div class="d-none">{{$ctrl.refresh($ctrl.chart)}}</div> -->
<div ng-if="$ctrl.calc" ng-init="$ctrl.init()" class="salaxy-component salaxy-calc-chart chart-container w-100 d-flex justify-content-center" ng-class="'salaxy-calc-chart-' + $ctrl.role + 'salaxy-calc-chart-' + $ctrl.chartType">
  <canvas class="chart" ng-class="$ctrl.chartType ==='bar' ? 'chart-bar' : 'chart-pie'"></canvas>
</div>`);

 $templateCache.put("salaxy-components/calc/CalcCostAccounting.html",`<div class="salaxy-component salaxy-calc-cost-accounting">

  <div ng-if="$ctrl.isLegacy">

    <fieldset>
      <legend sxy-text="SALAXY.NG1.CalcCostAccountingComponent.title"></legend>
      <table class="table">
        <thead>
          <tr>
            <th>{{('SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}</th>
            <th class="right">{{"SALAXY.NG1.CalcCostAccountingComponent.percent" | sxyTranslate}}</th>
            <th class="right">
              <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.isReadOnly" ng-click="$ctrl.costCenter.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="item in $ctrl.costCenter">
            <td>
              <salaxy-input-typeahead ng-if="$ctrl.getOptions('costCenter').length" ng-model="item.id" label-format="text-value" get-options="$ctrl.getOptions('costCenter')" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.isReadOnly"></salaxy-input-typeahead>
              <salaxy-input ng-if="!$ctrl.getOptions('costCenter').length" ng-model="item.id" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.isReadOnly">
              </salaxy-input>
            </td>
            <td>
              <salaxy-input-number ng-model="item.percent" name="{{ 'percent' + $index }}" label-type="plain" read-only="$ctrl.isReadOnly" unit="percent"></salaxy-input-number>
            </td>
            <td class="text-end">
              <button ng-if="!$ctrl.isReadOnly" type="button" class="btn btn-danger" ng-click="$ctrl.costCenter.splice($index, 1)">
                <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="total">
            <td>{{"SALAXY.UI_Terms.total" | sxyTranslate}}</td>
            <td class="right">{{ $ctrl.getLegacySum() | sxyCount : 'percent' }}</td>
            <td class="right"></td>
          </tr>
        </tfoot>
      </table>
    </fieldset>
  </div>

  <div ng-if="!$ctrl.isLegacy && ( $ctrl.calc.accounting.dimensions.length > 0 || $ctrl.definitions.length > 0 )">
    <salaxy-cost-accounting ng-init="$ctrl.calc.accounting = ($ctrl.calc.accounting  || $ctrl.isReadOnly) ? $ctrl.calc.accounting : { dimensions: []}" current="$ctrl.calc.accounting.dimensions" scope="calculation" dimensions="$ctrl.dimensions" read-only="$ctrl.isReadOnly"></salaxy-cost-accounting>
  </div>
  <div ng-if="!$ctrl.isLegacy && !( $ctrl.calc.accounting.dimensions.length > 0 || $ctrl.definitions.length > 0 )">
    <salaxy-input name="costCenter" ng-model="$ctrl.calc.info.costCenter" label="SALAXY.NG1.CalcDetailsWorkerComponent.costCenter" read-only="$ctrl.isReadOnly" input-mode="{{$ctrl.inputMode}}"></salaxy-input>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/CalcDashboard.html",`<div class="salaxy-component salaxy-calc-dashboard">
  <div class="row">
    <div class="col-12 mb-4" ng-if="!$ctrl.hideButton">
      <salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation"></salaxy-action-button>
    </div>
    <div class="col-12 col-sm-6 mb-4 mb-sm-0">
      <salaxy-calc-list category="paid" mode="panel" limit-to="5" read-only="$ctrl.readOnly"></salaxy-calc-list>
    </div>
    <div class="col-12 col-sm-6">
      <salaxy-calc-list category="draft" mode="panel" limit-to="5" read-only="$ctrl.readOnly"></salaxy-calc-list>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/CalcEditor.html",`<div>
  <salaxy-validation-summary api-validation="$ctrl.validation"></salaxy-validation-summary>
</div>
<div style="margin-top:30px; margin-bottom:30px;">
  
  <h2 class="mb-2" sxy-text="SALAXY.NG1.CalcEditorComponent.title"></h2>
  <!-- spinning icon or similar?-->
  <button class="btn btn-primary btn-labeled-right" ng-click="$ctrl.saveEdited()"><span sxy-text="SALAXY.UI_Terms.save"></span><i class="bi bi-floppy"></i></button>
  <!-- spinning icon or similar?-->
  <button class="btn btn-default btn-labeled-right" ng-click="$ctrl.refresh()"><span sxy-text="SALAXY.UI_Terms.refresh"></span><i class="bi bi-arrow-repeat" ng-class="{'bi-spin' : $ctrl.loaders['default'] }"></i></button>

  <div class="float-end">Alkuperäinen: {{$ctrl.base.updatedAt | date: 'd.M.yyyy HH:mm:ss'}} <button class="btn btn-xs btn-default" ng-click="$ctrl.changeBase()">Vaihda...</button></div>
</div>
<div ng-if="$ctrl.current" class="salaxy-component salaxy-calc-editor">
  <div class="row">
    <div class="col-12 col-xl-6 " style="margin-top:20px;">
      <div class="row mb-2">
        <div class="col-md-6 col-12 calc-editor-worker-details mb-2">
          <legend>
            <span sxy-text="SALAXY.NG1.CalcEditorComponent.workerTitle"></span>
            <button ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end" ng-click="$ctrl.refresh('worker')" title="Päivitä työntekijän tiedot"><i class="" ng-class="$ctrl.loaders['worker']  ? 'bi bi-arrow-repeat bi-spin' : 'bi bi-download'"></i></button>
            <a class="btn btn-xs btn-default float-end btn-details" href="#/employments/details/{{$ctrl.current.worker.employmentId}}" ng-click="$ctrl.isRightSidebarOpen = true" title="Tiedot / Muokkaa" style="margin-right:2px;"><i class="bi bi-info-circle-fill"></i></a>

          </legend>
          <div class="row">
            <div class="col-3">
              <div class="avatar-container">
                <salaxy-avatar class="avatar-sm" avatar="$ctrl.current.worker.avatar"></salaxy-avatar>
              </div>
            </div>
            <div class="col-9">
              <strong>{{$ctrl.current.worker.avatar.displayName}}</strong>
              <br>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="socialSecurityNumber" ng-model="$ctrl.current.worker.paymentData.socialSecurityNumber"></salaxy-input>
              <div>&nbsp;</div>
              <br>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="firstName" ng-model="$ctrl.current.worker.avatar.firstName"></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="lastName" ng-model="$ctrl.current.worker.avatar.lastName"></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="ibanNumber" ng-model="$ctrl.current.worker.paymentData.ibanNumber" sxy-iban></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="email" ng-model="$ctrl.current.worker.contact.email" sxy-email></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="telephone" ng-model="$ctrl.current.worker.contact.telephone" sxy-mobile-phone></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="street" ng-model="$ctrl.current.worker.contact.street"></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="postalCode" ng-model="$ctrl.current.worker.contact.postalCode" sxy-postal-code-fi></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="city" ng-model="$ctrl.current.worker.contact.city"></salaxy-input>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12 calc-editor-employer-details mb-2">
          <legend>
            <span sxy-text="SALAXY.NG1.CalcEditorComponent.employerTitle"></span>
            <button ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end" ng-click="$ctrl.refresh('employer')" title="Päivitä omat tiedot"><i class=""  ng-class="$ctrl.loaders['employer']  ? 'bi bi-arrow-repeat bi-spin' : 'bi bi-download'"></i></button></legend>
          <div class="row">
            <div class="col-3">
              <div class="avatar-container">
                <salaxy-avatar class="avatar-sm" avatar="$ctrl.current.employer.avatar"></salaxy-avatar>
              </div>
            </div>
            <div class="col-9">
              <strong>{{$ctrl.current.employer.avatar.displayName}}</strong>
              <br>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerOfficialId" ng-model="$ctrl.current.employer.officialId"></salaxy-input>
              <div>&nbsp;</div>
              <br>
            </div>
          </div>
          <div class="row">
            <div class="col-12">       
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerEmail" ng-model="$ctrl.current.employer.contact.email" sxy-email></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerTelephone" ng-model="$ctrl.current.employer.contact.telephone"></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerStreet" ng-model="$ctrl.current.employer.contact.street"></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerPostalCode" ng-model="$ctrl.current.employer.contact.postalCode"></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerCiy" ng-model="$ctrl.current.employer.contact.city"></salaxy-input>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 col-12 mb-2">
          <form class="form-horizontal" >
            <fieldset>
              <legend>
                <span sxy-text="Työsuhteen tiedot"></span>

                <button ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end" ng-click="$ctrl.refresh('employment')" title="Päivitä työsuhdetiedot"><i ng-class="$ctrl.loaders['employment']  ? 'bi bi-arrow-repeat bi-spin' : 'bi bi-download'"></i></button>
                <a class="btn btn-xs btn-default float-end btn-details" href="#/employments/details/{{$ctrl.current.worker.employmentId}}#employment" ng-click="$ctrl.isRightSidebarOpen = true" title="Tiedot / Muokkaa" style="margin-right:2px;"><i class="bi bi-info-circle-fill"></i></a>
              </legend>
              <salaxy-input-enum input-mode="openClose"  enum="PensionCalculation" name="PensionCalculation" label="Sovellettava eläketurva" ng-model="$ctrl.current.result.responsibilities.pensionCalculation"></salaxy-input-enum>
              <salaxy-input-enum input-mode="openClose"  enum="PensionRule" name="PensionRule" label="Eläkemaksun laskentasääntö" ng-model="$ctrl.current.result.responsibilities.pensionRule"></salaxy-input-enum>
              <salaxy-input-enum input-mode="openClose"  enum="EmploymentRelationType" name="EmploymentRelationType" label="Työsuhde" ng-model="$ctrl.current.result.responsibilities.employmentType"></salaxy-input-enum>
              <salaxy-datepicker-popup input-mode="openClose" name="employmentPeriodStart" ng-model="$ctrl.current.worktime.employmentPeriod.start"
                label="Työsuhteen alkupäivä"></salaxy-datepicker-popup>
              <salaxy-datepicker-popup input-mode="openClose" name="employmentPeriodEnd" ng-model="$ctrl.current.worktime.employmentPeriod.end"
                label="Työsuhteen loppupäivä"></salaxy-datepicker-popup>
              <salaxy-input-enum input-mode="openClose" ng-if="$ctrl.current.result.responsibilities.pensionCalculation == 'publicSector'"  type="select" name="employmentRegCodes" disable-cache="true"
                options="$ctrl.getEmploymentRegCodeOptions()" label="SALAXY.NG1.WorkerWizardComponent.employment.employmentRegCode" ng-model="$ctrl.current.result.responsibilities.employmentRegCode"></salaxy-input-enum>
              <salaxy-input-enum input-mode="openClose" enum="TaxcardKind" name="TaxcardKind" label="Työsuhteessa käytettävä verokortti" ng-model="$ctrl.current.result.responsibilities.employmentTaxcard"></salaxy-input-enum>
              <salaxy-input-enum input-mode="openClose" enum="EmploymentRelationSalaryPaymentMethod" name="SalaryPaymentMethod" label="Palkanmaksutapa" ng-model="$ctrl.current.result.responsibilities.salaryPaymentMethod"></salaxy-input-enum>
              <salaxy-input-enum input-mode="openClose" enum="IncomeEarnerType" name="irIncomeEarnerTypes" label="Tulonsaajan tyyppi" ng-model="$ctrl.current.result.responsibilities.irIncomeEarnerTypes" type="multi-select"></salaxy-input-enum>
              <salaxy-input-occupation-type name="occupationCode" ng-model="$ctrl.current.info.occupationCode" label="Ammattiluokka vakuutukseen" read-only="false">
              </salaxy-input-occupation-type>
              <salaxy-input tooltip-html="&lt;a target=&#39;_blank&#39; href=&#39;https://www.keva.fi/tyonantajalle/elakemaksut/ammattinimikkeiden-haku/&#39;&gt;Info&lt;/a&gt;" ng-if="$ctrl.current.result.responsibilities.pensionCalculation == 'publicSector'"  input-mode="openClose" name="occupationCode2" ng-model="$ctrl.current.info.occupationCode2" label="Keva:n ammattiluokka" read-only="false">
              </salaxy-input>

            </fieldset>
          </form>
        </div>
      
        <div class="col-md-6 col-12 mb-2">
          <form class="form-horizontal" ng-readonly="true">
            <fieldset>
              <legend>
                <span sxy-text="Verokortin tiedot"></span>
                <button ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end" ng-click="$ctrl.refresh('taxcard')" title="Päivitä verokortti"><i  ng-class="$ctrl.loaders['taxcard']  ? 'bi bi-arrow-repeat bi-spin' : 'bi bi-download'"></i></button>
                <a ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end btn-details" href="#/employments/details/{{$ctrl.current.worker.employmentId}}#taxcards" ng-click="$ctrl.isRightSidebarOpen = true" title="Tiedot / Muokkaa" style="margin-right:2px;"><i class="bi bi-info-circle-fill"></i></a>
              </legend>

              <salaxy-input-enum enum="TaxcardKind" name="TaxcardKind" label="Verokortti" ng-model="$ctrl.current.worker.tax.snapshot.kind"></salaxy-input-enum>
              <salaxy-input name="forYear" label="Vuodelle" ng-model="$ctrl.current.worker.tax.snapshot.forYear"></salaxy-input>
           
              <salaxy-form-group name="validity" class="salaxy-read-only" label="Voimassa">
                <div class="form-control-plaintext">
                  {{$ctrl.current.worker.tax.snapshot.validity.start | date}} - {{$ctrl.current.worker.tax.snapshot.validity.end | date}}
                </div>
              </salaxy-form-group>
              <salaxy-input label="veroprosentti" name="Veroprosentti" unit="percent" ng-model="$ctrl.current.worker.tax.snapshot.taxPercent" require="true"></salaxy-input>
              <salaxy-input-number label="Tuloraja" name="tuloraja" unit="euro" ng-model="$ctrl.current.worker.tax.snapshot.incomeLimit" maxlength="10"></salaxy-input-number>
              <salaxy-input label="Lisäveroprosentti" name="lisaveroprosentti" unit="percent" ng-model="$ctrl.current.worker.tax.snapshot.taxPercent2"></salaxy-input>
              <!--for admin, should be nullable-->
              <salaxy-input-number input-mode="openClose" name="fixedTaxAmount" ng-model="$ctrl.current.worker.tax.fixedTaxAmount" label="Kiinteä ennakonpidätyksen määrä" read-only="'!admin' | sxyIsInRole"></salaxy-input-number>
            </fieldset>
          </form>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 col-12 mb-2">
          <form class="form-horizontal">
            <fieldset>
              <legend>
                <span sxy-text="Vero, eläke- ja vakuutustiedot"></span>
                <button ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end" ng-click="$ctrl.refresh('insurances')" title="Päivitä vakuutustiedot"><i  ng-class="$ctrl.loaders['insurances']  ? 'bi bi-arrow-repeat bi-spin' : 'bi bi-download'"></i></button>

                <a ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end btn-details" href="#/settings/pro-settings" title="Katso / Muokkaa" ng-click="$ctrl.isRightSidebarOpen = true" style="margin-right:2px;"><i class="bi bi-info-circle-fill"></i></a>

              </legend>

              <salaxy-input-boolean input-mode="openClose" label="Hoidan ennakonpidätyksen maksun itse" name="taxAndSocialSecuritySelfPayment" ng-model="$ctrl.current.result.responsibilities.taxAndSocialSecuritySelfPayment"></salaxy-input-boolean>
              
              <salaxy-input-enum input-mode="openClose" label="Työeläkeyhtiö" enum="PensionCompany" name="PensionCompany" ng-model="$ctrl.current.result.responsibilities.pensionCompany"></salaxy-input-enum>
              <salaxy-input input-mode="openClose" label="Sopimusnumero" name="PensionContractNumber" ng-model="$ctrl.current.result.responsibilities.pensionContractNumber" sxy-pension-contract-number></salaxy-input>
              <salaxy-input ng-if="$ctrl.current.result.responsibilities.pensionCalculation == 'publicSector'" input-mode="openClose" label="SALAXY.MODEL.PensionContract.subOrgCode.title" name="SubOrgCode" ng-model="$ctrl.current.result.responsibilities.subOrgCode"></salaxy-input>
              <salaxy-input-number input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.pensionPercent" unit="percent" name="PensionPercent" label="SALAXY.MODEL.PensionContract.pensionPercent.title"></salaxy-input-number>
              <salaxy-input-number input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.pensionDiscountPercent" unit="percent" name="PensionDiscount" label="SALAXY.MODEL.PensionContract.pensionDiscountPercent.title"></salaxy-input-number>
              <salaxy-input-boolean input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.pensionSelfPayment" name="pensionSelfPayment" label="Hoitaa TyEl-maksut itse"></salaxy-input-boolean>

              <salaxy-input-enum input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.insuranceCompany" label="Vakuutusyhtiö" enum="InsuranceCompany" name="InsuranceCompany"></salaxy-input-enum>
              <salaxy-input input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.insuranceContractNumber" name="insuranceContractNumber" label="SALAXY.MODEL.InsuranceContract.contractNumber.title"></salaxy-input>
              <salaxy-input-number input-mode="openClose" label-cols="col-sm-6" ng-model="$ctrl.current.result.responsibilities.insurancePercent" label="Tapaturm.vak.maksun arvio-%" unit="percent" name="insurancePercent"></salaxy-input-number>
              <salaxy-input-number input-mode="openClose" label-cols="col-sm-6" ng-model="$ctrl.current.result.responsibilities.groupLifeInsurancePercent" label="SALAXY.MODEL.InsuranceContract.groupLifeInsurancePercent.title" unit="percent" name="groupLifeInsurancePercent"></salaxy-input-number>
              
              <salaxy-input-boolean input-mode="openClose" read-only="true" label-cols="col-sm-6" ng-model="$ctrl.current.result.responsibilities.unemploymentSelfPayment" name="unemploymentSelfPayment" label="Hoitaa työt.vak.maksut itse"></salaxy-input-boolean>
              <salaxy-input-enum input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.unemploymentPayrollLimitStatus" label="Työt.vak.maksun palkkasummaraja" enum="UnemploymentPayrollLimitStatus" name="unemploymentPayrollLimitStatus">
              </salaxy-input-enum>

            </fieldset>
          </form>
        </div>
        <div class="col-md-6 col-12 calc-editor-payment-details mb-2">
          <!-- todo fix readOnly-->
          <form class="form-horizontal">
            <legend sxy-text="Palkanmaksu"></legend>
            <salaxy-input-boolean input-mode="openClose"  label="Hoitaa nettopalkan maksun itse" name="WorkerSelfPayment" ng-model="$ctrl.current.result.responsibilities.workerSelfPayment"></salaxy-input-boolean>
            <salaxy-input-enum  input-mode="openClose"  ng-model="$ctrl.current.workflow.salaryDateKind" name="salaryDateKind" enum="SalaryDateKind"  label="SALAXY.MODEL.CalcWorkflow.salaryDateKind.title"></salaxy-input-enum>
            <salaxy-datepicker-popup input-mode="openClose" name="salaryDate" ng-model="$ctrl.current.workflow.salaryDate" label="SALAXY.NG1.CalcEditorComponent.paymentInfo.salaryDateLabel"></salaxy-datepicker-popup>
            <salaxy-datepicker-popup input-mode="openClose" name="salaryPaidAt" ng-model="$ctrl.current.workflow.paidAt" label="SALAXY.NG1.CalcEditorComponent.paymentInfo.paymentDateLabel"></salaxy-datepicker-popup>  
            <salaxy-date-range input-mode="openClose" ng-model="$ctrl.dateRange" class="condensed" name="dateRange" on-change="$ctrl.dateRangeChange()" label="SALAXY.CORE.CalcWorktime.salaryPeriod" label-days-count="SALAXY.MODEL.CalcWorktime.workDays.title"></salaxy-date-range>            
            <salaxy-input-enum  input-mode="openClose"  ng-model="$ctrl.current.pricingModel" name="pricingModel" enum="PricingModel"  label="SALAXY.MODEL.ServiceModelPricing.pricingModel.title"></salaxy-input-enum>
            <salaxy-input-number input-mode="openClose" name="fixedFee" ng-model="$ctrl.current.fixedFee" label="SALAXY.MODEL.ServiceModelPricing.fixedFee.title"></salaxy-input-number>
            <salaxy-input-number input-mode="openClose" read-only="true" label="Maksu Palkkaus.fi-palvelulle" name="palkkausFee" ng-model="$ctrl.current.result.employerCalc.palkkaus" sxy-currency></salaxy-input-number>
            <salaxy-input-enum ng-if="'admin' | sxyIsInRole"  input-mode="openClose"  ng-model="$ctrl.current.info.paymentChannel" name="paymentChannel" enum="PaymentChannel"  label="SALAXY.NG1.CalcEditorComponent.paymentInfo.paymentChannel"></salaxy-input-enum>
          </form>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 col-12 mb-2">
          <form class="form-horizontal" ng-readonly="true">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.CalcEditorComponent.messages.title"></legend>

              <salaxy-input input-mode="openClose" read-only="false" name="workDescription" ng-model="$ctrl.current.info.workDescription" label="SALAXY.NG1.CalcEditorComponent.messages.workDescriptionLabel"></salaxy-input>
              <salaxy-textarea input-mode="openClose" read-only="false" name="salarySlipMessage" ng-model="$ctrl.current.info.salarySlipMessage" label="SALAXY.NG1.CalcEditorComponent.messages.salarySlipMessageLabel"></salaxy-textarea>
            </fieldset>
          </form>
        </div>
        <div class="col-md-6 col-12" sxy-if-role="company">
          <div class="form-horizontal">
            <salaxy-calc-cost-accounting read-only="false" input-mode="openClose" calc="$ctrl.current"></salaxy-calc-cost-accounting>
          </div>
        </div>
        <div class="col-6" sxy-if-role="person">
          <legend sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.title"></legend>
          <div class="row form-horizontal">
            <div class="col-6">
              <salaxy-input-boolean type="checkbox" name="isHouseholdDeductible" ng-model="$ctrl.current.usecase.data.isHouseholdDeductible" label-type="no-label" />
            </div>
            <div class="col-6">
              <div ng-if="!$ctrl.current.usecase.data.isHouseholdDeductible" class="text-danger" style="padding-top:7px;" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.noDeduction"></div>
              <div ng-if="$ctrl.current.usecase.data.isHouseholdDeductible">
                <select class="form-select" ng-model="$ctrl.current.usecase.data.taxDeductionCategories">
                  <option hidden value="" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionCategory.select"></option>
                  <option value="none" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionCategory.none"></option>
                  <option value="householdwork" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionCategory.householdwork"></option>
                  <option value="carework" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionCategory.carework"></option>
                  <option value="homeImprovement" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionCategory.homeImprovement"></option>
                  <option value="oilHeatingReplacementWork" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionCategory.oilHeatingReplacementWork"></option>
                </select>
              </div>
              <div ng-if="$ctrl.current.usecase.data.isHouseholdDeductible">
                <select class="form-select" ng-model="$ctrl.current.usecase.data.taxDeductionProperty">
                  <option hidden value="" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionProperty.select"></option>
                  <option value="none" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionProperty.none"></option>
                  <option value="ownProperty" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionProperty.ownProperty"></option>
                  <option value="relativesProperty" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionProperty.relativesProperty"></option>
                </select>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="row calc-editor-calc-rows">
        <div class="col-12">
          <fieldset>

            <legend sxy-text="SALAXY.NG1.CalcEditorComponent.calcRowsTitle"></legend>
            <salaxy-calc-rows-2019-editor parent="$ctrl.current" mode="edit" show-gross-totals="false">
            </salaxy-calc-rows-2019-editor>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="col-12 col-xl-6">
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'edited', text: 'SALAXY.NG1.CalcEditorComponent.editedHeading' },
          { value: 'default', text: 'SALAXY.NG1.CalcEditorComponent.originalHeading' },
          { value: 'paymentreport', text: 'SALAXY.NG1.CalcEditorComponent.diffHeading' },
          { value: 'accounting', text: 'SALAXY.NG1.CalcEditorComponent.diffAccountingHeading' },
          { value: 'cfa', text: 'SALAXY.NG1.CalcEditorComponent.diffCfa', hidden: !('admin' | sxyIsInRole) },
          { value: 'documentflow', text: 'Laskut ja ilmoitukset' }
        ]"
        tabs-id="calcEditor">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-calcEditor">
        <div class="tab-pane" id="edited-tab">
          <salaxy-calc-reports calcs="[$ctrl.current]" report-type="'salarySlip'"></salaxy-calc-reports>
        </div>
        <div class="tab-pane" id="default-tab">
          <salaxy-calc-reports calcs="[$ctrl.base]" report-type="'salarySlip'"></salaxy-calc-reports>
        </div>
        <div class="tab-pane" id="paymentreport-tab">
          <div class="payroll-report payroll-report-partial-container">
            <salaxy-calc-report calc="$ctrl.diffCalc" report-type="'paymentReport'" template-name="'paymentTablesV2'" apply-site-styles="true">
          </div>
        </div>
        <div class="tab-pane" id="accounting-tab">
          <salaxy-accounting-report-tools any-expanded="$reportRows.anyExpanded" on-expand-change="$reportRows.expand(close)" on-target-change="$ctrl.loadAccountingDiffData(targetId)" reader="$ctrl.accountingDiffDataReader"></salaxy-accounting-report-tools>
          <salaxy-accounting-report-rows ng-ref="$reportRows" data="$ctrl.accountingDiffData"></salaxy-accounting-report-rows>
        </div>
        <div class="tab-pane" id="cfa-tab" ng-if="'admin' | sxyIsInRole">
          <fieldset>
            <legend>
              <span sxy-text="Asiakasmaksut"></span>
            </legend>
          </fieldset>
          <table class="table">
            <tr>
              <th>Erä</th>
              <th class="text-right">Nykyinen summa</th>
              <th class="text-right">Laskettu summa</th>
              <th class="text-right">Laskettu ero</th>
              <th class="text-right">Tallennettava summa</th>
              <th class="text-right">Tallennettava ero</th>
            </tr>
            <tr>
              <td>Nettopalkka</td>
              <td class="text-right">{{ $ctrl.base.cfa ? ($ctrl.base.cfa.net  | currency) : " - "}}</td>
              <td class="text-right">{{ ($ctrl.current.result.workerCalc.totalWorkerPayment - $ctrl.current.result.employerCalc.deductionWorkerSelfPayment) | currency}}</td>
              <td class="text-right">{{ (($ctrl.current.result.workerCalc.totalWorkerPayment - $ctrl.current.result.employerCalc.deductionWorkerSelfPayment) - ($ctrl.base.cfa ? $ctrl.base.cfa.net  : 0)) | currency }}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ($ctrl.current.cfa.net  | currency) : " - "}}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ( ($ctrl.current.cfa.net - $ctrl.base.cfa.net) | currency) : " - "}}</td>
            </tr>
            <tr>
              <td>Eläke</td>
              <td class="text-right">{{ $ctrl.base.cfa ? ($ctrl.base.cfa.pension  | currency) : " - "}}</td>
              <td class="text-right">{{ ($ctrl.current.result.totals.pension - $ctrl.current.result.employerCalc.deductionPensionSelfPayment) | currency}}</td>
              <td class="text-right">{{ (($ctrl.current.result.totals.pension - $ctrl.current.result.employerCalc.deductionPensionSelfPayment) - ($ctrl.base.cfa ? $ctrl.base.cfa.pension  : 0)) | currency }}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ($ctrl.current.cfa.pension  | currency) : " - "}}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ( ($ctrl.current.cfa.pension - $ctrl.base.cfa.pension) | currency) : " - "}}</td>
            </tr>
            <tr>
              <td>Vero</td>
              <td class="text-right">{{ $ctrl.base.cfa ? ($ctrl.base.cfa.tax  | currency) : " - "}}</td>
              <td class="text-right">{{ ($ctrl.current.result.workerCalc.tax + $ctrl.current.result.employerCalc.socialSecurity + $ctrl.current.result.workerCalc.taxAtSource +  $ctrl.current.result.workerCalc.socialSecurity - $ctrl.current.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment) | currency}}</td>
              <td class="text-right">{{ (($ctrl.current.result.workerCalc.tax + $ctrl.current.result.employerCalc.socialSecurity + $ctrl.current.result.workerCalc.taxAtSource +  $ctrl.current.result.workerCalc.socialSecurity - $ctrl.current.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment) - ($ctrl.base.cfa ? $ctrl.base.cfa.tax  : 0)) | currency }}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ($ctrl.current.cfa.tax  | currency) : " - "}}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ( ($ctrl.current.cfa.tax - $ctrl.base.cfa.tax) | currency) : " - "}}</td>
            </tr>
            <tr>
              <td>Palvelumaksu</td>
              <td class="text-right">{{ $ctrl.base.cfa ? ($ctrl.base.cfa.service  | currency) : " - "}}</td>
              <td class="text-right">{{ ($ctrl.current.result.employerCalc.service) | currency}}</td>
              <td class="text-right">{{ (($ctrl.current.result.employerCalc.service) - ($ctrl.base.cfa ? $ctrl.base.cfa.service  : 0)) | currency }}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ($ctrl.current.cfa.service  | currency) : " - "}}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ( ($ctrl.current.cfa.service - $ctrl.base.cfa.service) | currency) : " - "}}</td>
            </tr>
            <tr>
              <td>Palkkio</td>
              <td class="text-right">{{ $ctrl.base.cfa ? ($ctrl.base.cfa.fee  | currency) : " - "}}</td>
              <td class="text-right">{{ ($ctrl.current.result.employerCalc.palkkaus) | currency}}</td>
              <td class="text-right">{{ (($ctrl.current.result.employerCalc.palkkaus) - ($ctrl.base.cfa ? $ctrl.base.cfa.fee  : 0)) | currency }}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ($ctrl.current.cfa.fee  | currency) : " - "}}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ( ($ctrl.current.cfa.fee - $ctrl.base.cfa.fee) | currency) : " - "}}</td>
            </tr>
            <tr class="total">
              <td>Yhteensä</td>
              <td class="text-right">{{ $ctrl.base.cfa ? ($ctrl.base.cfa.total  | currency) : " - "}}</td>
              <td class="text-right">{{ (
                $ctrl.current.result.workerCalc.totalWorkerPayment - $ctrl.current.result.employerCalc.deductionWorkerSelfPayment +
                $ctrl.current.result.totals.pension - $ctrl.current.result.employerCalc.deductionPensionSelfPayment +
                $ctrl.current.result.workerCalc.tax + $ctrl.current.result.employerCalc.socialSecurity + $ctrl.current.result.workerCalc.taxAtSource +  $ctrl.current.result.workerCalc.socialSecurity - $ctrl.current.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment +
                $ctrl.current.result.employerCalc.service +
                $ctrl.current.result.employerCalc.palkkaus
                ) | currency}}</td>
              <td class="text-right">{{ ((
                $ctrl.current.result.workerCalc.totalWorkerPayment - $ctrl.current.result.employerCalc.deductionWorkerSelfPayment +
                $ctrl.current.result.totals.pension - $ctrl.current.result.employerCalc.deductionPensionSelfPayment +
                $ctrl.current.result.workerCalc.tax + $ctrl.current.result.employerCalc.socialSecurity + $ctrl.current.result.workerCalc.taxAtSource +  $ctrl.current.result.workerCalc.socialSecurity - $ctrl.current.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment +
                $ctrl.current.result.employerCalc.service +
                $ctrl.current.result.employerCalc.palkkaus
                ) - ($ctrl.base.cfa ? $ctrl.base.cfa.total  : 0)) | currency }}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ($ctrl.current.cfa.total  | currency) : " - "}}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ( ($ctrl.current.cfa.total - $ctrl.base.cfa.total) | currency) : " - "}}</td>
            </tr>
          </table>
        </div>
        <div class="tab-pane" id="documentflow-tab">
          <div ng-if="$ctrl.documentFlow.children">
            <table class="table table-striped">
              <tr ng-repeat="doc in $ctrl.documentFlow.children">
                <td>
                  <salaxy-avatar ng-if="doc.item.type != 'payerSummary' && doc.item.type != 'payrollDetails'" class="salaxy-calc-row-type-avatar" avatar="doc.item.otherPartyInfo.avatar"></salaxy-avatar>
                  <salaxy-avatar ng-if="doc.item.type == 'payerSummary' || doc.item.type == 'payrollDetails'" class="salaxy-calc-row-type-avatar" avatar="doc.item.ownerInfo.avatar"></salaxy-avatar>
                </td>
                <td class="middle">
                  <strong ng-if="doc.item.type == 'invoice'">{{doc.item.shortText}}</strong>
                  <strong ng-if="doc.item.type == 'earningsPayment'">{{'Palkkatietoilmoitus' |sxyTranslate}}</strong>
                  <strong ng-if="doc.item.type == 'payrollDetails'">{{'Palkkalista' |sxyTranslate}}</strong>
                  <strong ng-if="doc.item.type == 'payerSummary'">{{'Erillisilmoitus' |sxyTranslate}}</strong>
                  <strong ng-if="doc.item.type == 'taxcard'">{{'Verokortti' |sxyTranslate}}</strong>
                </td>
                <td>
                  <a ng-if="doc.item.type == 'earningsPayment'" class="btn btn-default btn-sm" ng-href="#/irepr/details/{{doc.item.id}}">Näytä</a>
                  <a ng-if="doc.item.type == 'invoice'" class="btn btn-default btn-sm" ng-href="#/invoices/details/{{doc.item.id}}">
                    {{ 'SALAXY.UI_Terms.show' | sxyTranslate}}</a>
                  <a ng-if="doc.item.type == 'payerSummary'" class="btn btn-default btn-sm" ng-href="#/irpsr/details/{{doc.item.id}}">Näytä</a>
                  <a ng-if="doc.item.type == 'payrollDetails'" class="btn btn-default btn-sm" ng-href="#/payroll/details/{{doc.item.id}}">Näytä</a>
                  <a ng-if="doc.item.type == 'taxcard'" class="btn btn-default btn-sm" ng-href="#/taxcards/details/{{doc.item.id}}">Näytä</a>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div ng-if="'admin' | sxyIsInRole" class="right-sidebar"  ng-class="{'is-open' : $ctrl.isRightSidebarOpen}">
      <button class="btn btn-transparent custom-close" ng-click="$ctrl.isRightSidebarOpen = false">
        <i class="bi bi-x-lg"></i>
      </button>
      <div ng-view></div>
    </div>
  </div>
 
</div>`);

 $templateCache.put("salaxy-components/calc/CalcLeaves.html",`<div class="row">
  <div class="col-12">
    <p class="lead" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.details.lead"></p>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <table class="table table-sm">
      <thead>
        <th></th>
        <th class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.holidaySalariesAndCompensations"></th>
        <th ng-if="$ctrl.logic.worktime.holidaySpec.bonusMethod != 'none'" class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.bonuses"></th>
      </thead>
      <tbody>
        <tr>
          <td sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.accrualRemaining"></td>
          <td class="right">{{$ctrl.worktime.holidayPayAccrualRemaining}}</td>
          <td ng-if="$ctrl.logic.worktime.holidaySpec.bonusMethod != 'none'" class="right">{{$ctrl.worktime.holidayBonusAccrualRemaining}}</td>
        </tr>
        <tr> 
          <td sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.paidInThisSalary"></td>
          <td class="right">{{$ctrl.getAccrualRemaningsToBePaid('holidayPay')}}</td>
          <td ng-if="$ctrl.logic.worktime.holidaySpec.bonusMethod != 'none'" class="right">{{$ctrl.getAccrualRemaningsToBePaid('holidayBonus')}}</td>
        </tr>
        <tr>
          <td sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.newAccrualRemaining"></td>
          <td class="right">{{$ctrl.worktime.holidayPayAccrualRemaining - $ctrl.getAccrualRemaningsToBePaid('holidayPay')}}</td>
          <td ng-if="$ctrl.logic.worktime.holidaySpec.bonusMethod != 'none'" class="right">{{$ctrl.worktime.holidayBonusAccrualRemaining - $ctrl.getAccrualRemaningsToBePaid('holidayBonus')}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-sm-6">
    <h4 sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.paidInThisSalary"></h4>
    <table class="table table-sm" ng-if="$ctrl.annualLeavestoBePaid.length">
      <thead>
        <tr>
          <th width="60%" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.holidayPeriod"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.days"></th>
          <th ng-if="$ctrl.logic.worktime.holidaySpec.bonusMethod != 'none'" class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.bonusDays"></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.annualLeavestoBePaid">
          <td width="60%">
            {{row.period | sxyDateRange}}
          </td>
          <td class="right">
            <salaxy-input-number name="daysCount" ng-model="row.period.daysCount" label-type="plain"></salaxy-input-number>
          </td>
          <td ng-if="$ctrl.logic.worktime.holidaySpec.bonusMethod != 'none'" class="right">
            <salaxy-input-number name="bonusDaysCount" ng-model="row.bonusDaysCount" label-type="plain"></salaxy-input-number>
          </td>
          <td>
            <button type="button" class="btn btn-default" ng-click="$ctrl.showEditDialog(row)">
              <span><i class="bi bi-calendar3"></i></span>
            </button>
          </td>
          <td>
            <button type="button" class="delete btn btn-danger" ng-click="$ctrl.moveItem(row, 'annualLeavesWaitingForPayment')">
              <span></span><i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-sm-6">
    <h4 sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.plannedHolidays"></h4>
    <table class="table table-sm" ng-if="$ctrl.annualLeavesWaitingForPayment.length">
      <thead>
        <tr>
          <th width="40%" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.startDate"></th>
          <th width="40%" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.endDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.days"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.annualLeavesWaitingForPayment" ng-style="$ctrl.getDisabledStyle(row)">
          <td width="40%">
            <span>{{row.period.start | sxyDate}}</span>
          </td>
          <td width="40%">
            <span>{{row.period.end | sxyDate}}</span>
          </td>
          <td class="right">
            <span>{{row.period.daysCount}}</span>
          </td>
          <td>
            <button type="button" class="btn btn-primary" ng-click="$ctrl.moveItem(row,'annualLeavestoBePaid')" ng-disabled="$ctrl.isSelectedToBePaid(row)" sxy-text="SALAXY.UI_Terms.select">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-sm-6">
    <h4 sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.absencesToUse"></h4>
    <table class="table table-sm" ng-if="$ctrl.absencesToUse.length">
      <thead>
        <tr>
          <th width="60%" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.absenceTime"></th>
          <th sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.cause"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.days"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.absencesToUse">
          <td width="60%">
            {{row.period | sxyDateRange}}
          </td>
          <td>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</td>
          <td class="right">{{row.period.daysCount}}</td>
          <td>
            <button type="button" class="delete btn btn-danger" ng-click="$ctrl.moveAbsenceItem(row, 'absencesToReject')">
              <span></span><i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-6">
    <h4 sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.absencesToReject"></h4>
    <table class="table table-sm" ng-if="$ctrl.absencesToReject.length">
      <thead>
        <tr>
          <th width="40%" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.startDate"></th>
          <th width="40%" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.endDate"></th>
          <th sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.cause"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.days"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.absencesToReject" ng-style="$ctrl.getAbsenceDisabledStyle(row)">
          <td width="40%">
            <span>{{row.period.start | sxyDate}}</span>
          </td>
          <td width="40%">
            <span>{{row.period.end | sxyDate}}</span>
          </td>
          <td>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</td>
          <td class="right">
            <span>{{row.period.daysCount}}</span>
          </td>
          <td>
            <button type="button" class="btn btn-primary" ng-click="$ctrl.moveAbsenceItem(row,'absencesToUse')" ng-disabled="$ctrl.isAbsenceSelectedToUse(row)" sxy-text="SALAXY.UI_Terms.select">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/CalcList.html",`<div class="salaxy-component salaxy-calc-list">
  <div ng-if="($ctrl.mode || 'default') == 'default'">
    <salaxy-odata-table ng-if="$ctrl.category=='draft'" url="/v03/api/calculations/category/editable" crud-controller="CalculationCrudController as $crud" options="{$top:$ctrl.limitTo}" template-url="salaxy-components/odata/lists/CalculationsDrafts.html" read-only="$ctrl.readOnly">
    </salaxy-odata-table>
    <salaxy-odata-table ng-if="$ctrl.category=='paid'" url="/v03/api/calculations/category/readonly" crud-controller="CalculationCrudController as $crud" options="{$top:$ctrl.limitTo}" template-url="salaxy-components/odata/lists/CalculationsPaid.html" read-only="$ctrl.readOnly">
    </salaxy-odata-table>
    <div ng-if="$ctrl.category=='paidIr'">
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'paymentsucceeded', text: 'SALAXY.ENUM.CalculationStatus.paymentSucceeded.label' },
          { value: 'paymentstarted', text: 'SALAXY.ENUM.CalculationStatus.paymentStarted.label' }
        ]"
        tabs-id="calcList">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-calcList">
        <div class="tab-pane" id="paymentsucceeded-tab">
          <div ng-if="$ctrl.currentTab == 'paymentsucceeded'">
            <salaxy-odata-table url="/v03/api/calculations/category/readonly" crud-controller="CalculationCrudController as $crud" options="{$top:$ctrl.limitTo, $filter: 'status eq \\'paymentSucceeded\\'' }" template-url="salaxy-components/odata/lists/CalculationsPaidIr.html" read-only="$ctrl.readOnly"></salaxy-odata-table>
          </div>
        </div>
        <div class="tab-pane" id="paymentstarted-tab">
          <div ng-if="$ctrl.currentTab == 'paymentstarted'">
            <salaxy-odata-table url="/v03/api/calculations/category/readonly" crud-controller="CalculationCrudController as $crud" options="{$top:$ctrl.limitTo, $filter: 'status eq \\'paymentStarted\\'' }" template-url="salaxy-components/odata/lists/CalculationsPaidIr.html" read-only="$ctrl.readOnly"></salaxy-odata-table>
          </div>
        </div>
      </div>
    </div>    
    <salaxy-odata-table ng-if="$ctrl.category=='shared'" url="/v03/api/calculations/category/shared" crud-controller="CalculationCrudController as $crud" options="{$top: $ctrl.limitTo, $orderby:'createdAt desc'}" template-url="salaxy-components/odata/lists/CalculationsShared.html"
      read-only="$ctrl.readOnly">
    </salaxy-odata-table>
    <salaxy-odata-table ng-if="$ctrl.category=='sent'" url="/v03/api/calculations/category/sent" crud-controller="CalculationCrudController as $crud" options="{$top: $ctrl.limitTo}" template-url="salaxy-components/odata/lists/CalculationsSent.html" read-only="$ctrl.readOnly">
    </salaxy-odata-table>
    <salaxy-odata-table ng-if="$ctrl.category=='received'" url="/v03/api/calculations/category/received" crud-controller="CalculationCrudController as $crud" options="{$top: $ctrl.limitTo}" template-url="salaxy-components/odata/lists/CalculationsReceived.html"
      read-only="$ctrl.readOnly">
    </salaxy-odata-table>
    <salaxy-odata-table ng-if="$ctrl.category=='all'" crud-controller="CalculationCrudController as $crud" options="{$top: $ctrl.limitTo}" template-url="salaxy-components/odata/lists/CalculationsAll.html" read-only="$ctrl.readOnly">
    </salaxy-odata-table>
    <salaxy-odata-table ng-if="$ctrl.category=='error'" url="/v03/api/calculations/category/error" crud-controller="CalculationCrudController as $crud" options="{$top: $ctrl.limitTo}" template-url="salaxy-components/odata/lists/CalculationsAll.html" read-only="$ctrl.readOnly">
    </salaxy-odata-table>

    <salaxy-odata-table ng-if="$ctrl.category=='allEmployer'" url="/v03/api/calculations/category/all" crud-controller="CalculationCrudController as $crud" options="{ $top: $ctrl.limitTo, $filter: 'status eq \\'paymentWorkerCopy\\' or status eq \\'draft\\' or status eq \\'workerRequested\\' or status eq \\'workerRequestAccepted\\' or status eq \\'workerRequestDeclined\\' ' }"
      template-url="salaxy-components/odata/lists/CalculationsEmployerAll.html">
    </salaxy-odata-table>
  </div>
  <salaxy-odata-table ng-if="$ctrl.mode == 'panel'" url="{{ $ctrl.category == 'paid' ? '/v03/api/calculations/category/readonly' : $ctrl.category == 'sent' ? '/v03/api/calculations/category/sent' : $ctrl.category == 'received' ? '/v03/api/calculations/category/received' : $ctrl.category == 'shared' ? '/v03/api/calculations/category/shared' : '/v03/api/calculations/category/editable'}}"
    crud-controller="CalculationCrudController as $crud" options="{$top: $ctrl.limitTo, $filter: $ctrl.filter, $orderby: $ctrl.category == 'shared' ? 'createdAt desc' : null}" data="{ category: $ctrl.category }" template-url="salaxy-components/odata/lists/CalculationsPanel.html"
    read-only="$ctrl.readOnly">
  </salaxy-odata-table>
  <salaxy-odata-table ng-if="$ctrl.mode == 'select'" url="{{ $ctrl.category == 'paid' ? '/v03/api/calculations/category/readonly' : $ctrl.category == 'shared' ? '/v03/api/calculations/category/shared' : '/v03/api/calculations/category/editable'}}" template-url="salaxy-components/odata/lists/Calculations-select.html" options="$ctrl.options"
    selected-items="$ctrl.selectedItems" on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });" crud-controller="CalculationCrudController as $crud"></salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/calc/CalcNewIntro.html",`<div class="calc-start-instructions" ng-if="!$ctrl.calcSections.get('result').isSelectionDone">
  <h1 style="font-size: 2em" class="mt-2 text-center mb-5" sxy-text="SALAXY.NG1.CalcNewIntroComponent.title"></h1>
  <div class="row mb-4">
    <div class="col-6 col-sm-3 text-center" style="min-height: 200px; cursor: pointer;" ng-click="$ctrl.calcSections.toggle('worker');">
      <div class="bi-stack-icons bi-7x">
        <i class="bi bi-circle-fill text-info"></i>
        <span class="bi-text-on-top">1</span>
      </div>
      <strong class="uppercase" sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepOne.title"></strong>
      <p sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepOne.description"></p>
    </div>
    <div class="col-6 col-sm-3 text-center" style="min-height: 200px; cursor: pointer;" ng-click="$ctrl.calcSections.toggle('worktime');">
      <div class="bi-stack-icons bi-7x">
        <i class="bi bi-circle-fill text-warning"></i>
        <span class="bi-text-on-top">2</span>
      </div>
      <strong class="uppercase" sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepTwo.title"></strong>
      <p sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepTwo.description"></p>
    </div>
    <div class="col-6 col-sm-3 text-center" style="min-height: 200px; cursor: pointer;" ng-click="$ctrl.calcSections.toggle('salary');">
      <div class="bi-stack-icons bi-7x">
        <i class="bi bi-circle-fill text-success"></i>
        <span class="bi-text-on-top">3</span>
      </div>
      <strong class="uppercase" sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepThree.title"></strong>
      <p sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepThree.description"></p>
    </div>
    <div class="col-6 col-sm-3 text-center" style="min-height: 200px; cursor: pointer;" ng-click="$ctrl.calcSections.toggle('expenses');">
      <div class="bi-stack-icons bi-7x">
        <i class="bi bi-circle-fill text-danger"></i>
        <span class="bi-text-on-top">4</span>
      </div>
      <strong class="uppercase" sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepFour.title"></strong>
      <p sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepFour.description"></p>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/CalcRepair.html",`<div class="salaxy-component salaxy-calc-repair" ng-if="$ctrl.current && $ctrl.current.workflow.status == 'repair'">
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-6 ">
      <div ng-if="$ctrl.current">
        <div class="btn-toolbar calc-toolbar">
          <div class="btn-group" role="group">
            <!--button class="btn btn-default" ng-click="$ctrl.recalculateRepair()" sxy-text="SALAXY.UI_Terms.recalculate"></button-->
            <button class="btn btn-success" ng-click="$ctrl.saveRepair()" sxy-text="SALAXY.UI_Terms.save"></button>
            <button class="btn btn-danger"ng-click="$ctrl.deleteCalc('/calc/repairs')"  sxy-text="SALAXY.UI_Terms.delete"></button>
          </div>
          <div class="btn-group" role="group">
            <button class="btn btn-primary" type="button" ng-click="$ctrl.commitRepair()" ng-disabled="$ctrl.hasChanges"  sxy-text="Korvaa alkuperäinen laskelma"></button>
          </div>
        </div>
        <div class="panel panel-primary" style="padding: 10px">
          <div class="panel-body">
            <salaxy-validation-summary api-validation="$ctrl.validation"></salaxy-validation-summary>
            <div class="row">
              <div class="row calc-editor-calc-rows">
                <div class="col-12">
                  <fieldset>
                    <legend sxy-text="SALAXY.NG1.CalcEditorComponent.calcRowsTitle"></legend>
                    <salaxy-calc-rows-2019-editor parent="$ctrl.current" mode="edit" show-gross-totals="false">
                    </salaxy-calc-rows-2019-editor>
                  </fieldset>
                </div>
              </div>
              <div class="row spacer-bottom salaxy-calc-editor">
                <div class="col-md-6 col-12 calc-editor-worker-details spacer-bottom">
                  <legend>
                    <span sxy-text="SALAXY.NG1.CalcEditorComponent.workerTitle"></span>
                  </legend>
                  <div class="row">
                    <div class="col-3">
                      <div class="avatar-container">
                        <salaxy-avatar avatar="$ctrl.current.worker.avatar"></salaxy-avatar>
                      </div>
                    </div>
                    <div class="col-9">
                      <strong>{{$ctrl.current.worker.avatar.displayName}}</strong>
                      <br>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="socialSecurityNumber"
                        ng-model="$ctrl.current.worker.paymentData.socialSecurityNumber"></salaxy-input>
                      <div>&nbsp;</div>
                      <br>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="firstName" ng-model="$ctrl.current.worker.avatar.firstName"></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="lastName" ng-model="$ctrl.current.worker.avatar.lastName"></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="ibanNumber" ng-model="$ctrl.current.worker.paymentData.ibanNumber"
                        sxy-iban></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="email" ng-model="$ctrl.current.worker.contact.email" sxy-email></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="telephone" ng-model="$ctrl.current.worker.contact.telephone"
                        sxy-mobile-phone></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="street" ng-model="$ctrl.current.worker.contact.street"></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="postalCode" ng-model="$ctrl.current.worker.contact.postalCode"
                        sxy-postal-code-fi></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="city" ng-model="$ctrl.current.worker.contact.city"></salaxy-input>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12 calc-editor-employer-details spacer-bottom">
                  <legend>
                    <span sxy-text="SALAXY.NG1.CalcEditorComponent.employerTitle"></span>
                  </legend>
                  <div class="row">
                    <div class="col-3 ">
                      <div class="avatar-container ">
                        <salaxy-avatar avatar="$ctrl.current.employer.avatar"></salaxy-avatar>
                      </div>
                    </div>
                    <div class="col-9">
                      <strong>{{$ctrl.current.employer.avatar.displayName}}</strong>
                      <br>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerOfficialId"
                        ng-model="$ctrl.current.employer.officialId"></salaxy-input>
                      <div>&nbsp;</div>
                      <br>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerEmail" ng-model="$ctrl.current.employer.contact.email"
                        sxy-email></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerTelephone"
                        ng-model="$ctrl.current.employer.contact.telephone"></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerStreet"
                        ng-model="$ctrl.current.employer.contact.street"></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerPostalCode"
                        ng-model="$ctrl.current.employer.contact.postalCode"></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerCiy" ng-model="$ctrl.current.employer.contact.city"></salaxy-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row spacer-bottom">
                <div class="col-md-6 col-12 spacer-bottom">
                  <form class="form-horizontal">
                    <fieldset>
                      <legend>
                        <span sxy-text="Työsuhteen tiedot"></span>
                      </legend>
                      <salaxy-input-enum input-mode="openClose" enum="PensionCalculation" name="PensionCalculation" label="Sovellettava eläketurva"
                        ng-model="$ctrl.current.result.responsibilities.pensionCalculation"></salaxy-input-enum>
                      <salaxy-input-enum input-mode="openClose" enum="PensionRule" name="PensionRule" label="Eläkemaksun laskentasääntö"
                        ng-model="$ctrl.current.result.responsibilities.pensionRule"></salaxy-input-enum>
                      <salaxy-input-enum input-mode="openClose" enum="EmploymentRelationType" name="EmploymentRelationType" label="Työsuhde"
                        ng-model="$ctrl.current.result.responsibilities.employmentType"></salaxy-input-enum>
                      <salaxy-datepicker-popup input-mode="openClose" name="employmentPeriodStart" ng-model="$ctrl.current.worktime.employmentPeriod.start"
                        label="Työsuhteen alkupäivä"></salaxy-datepicker-popup>
                      <salaxy-datepicker-popup input-mode="openClose" name="employmentPeriodEnd" ng-model="$ctrl.current.worktime.employmentPeriod.end"
                        label="Työsuhteen loppupäivä"></salaxy-datepicker-popup>
                      <salaxy-input-enum input-mode="openClose" ng-if="$ctrl.current.result.responsibilities.pensionCalculation == 'publicSector'" type="select"
                        name="employmentRegCodes" disable-cache="true" options="$ctrl.getEmploymentRegCodeOptions()"
                        label="SALAXY.NG1.WorkerWizardComponent.employment.employmentRegCode"
                        ng-model="$ctrl.current.result.responsibilities.employmentRegCode"></salaxy-input-enum>
                      <salaxy-input-enum input-mode="openClose" enum="TaxcardKind" name="TaxcardKind" label="Työsuhteessa käytettävä verokortti"
                        ng-model="$ctrl.current.result.responsibilities.employmentTaxcard"></salaxy-input-enum>
                      <salaxy-input-enum input-mode="openClose" enum="EmploymentRelationSalaryPaymentMethod" name="SalaryPaymentMethod" label="Palkanmaksutapa"
                        ng-model="$ctrl.current.result.responsibilities.salaryPaymentMethod"></salaxy-input-enum>
                      <salaxy-input-enum input-mode="openClose" enum="IncomeEarnerType" name="irIncomeEarnerTypes" label="Tulonsaajan tyyppi" ng-model="$ctrl.current.result.responsibilities.irIncomeEarnerTypes" type="multi-select"></salaxy-input-enum>
                      <salaxy-input-occupation-type input-mode="openClose" name="occupationCode" ng-model="$ctrl.current.info.occupationCode" label="Ammattiluokka vakuutukseen"
                        read-only="false">
                      </salaxy-input-occupation-type>
                      <salaxy-input
                        tooltip-html="&lt;a target=&#39;_blank&#39; href=&#39;https://www.keva.fi/tyonantajalle/elakemaksut/ammattinimikkeiden-haku/&#39;&gt;Info&lt;/a&gt;"
                        ng-if="$ctrl.current.result.responsibilities.pensionCalculation == 'publicSector'" input-mode="openClose" name="occupationCode2"
                        ng-model="$ctrl.current.info.occupationCode2" label="Keva:n ammattiluokka" read-only="false">
                      </salaxy-input>
                    </fieldset>
                  </form>
                </div>
                <div class="col-md-6 col-12 spacer-bottom">
                  <div class="col-12">
                    <form class="form-horizontal">
                      <legend sxy-text="Palkanmaksu"></legend>
                      <salaxy-input-enum  input-mode="openClose"  ng-model="$ctrl.current.workflow.salaryDateKind" name="salaryDateKind" enum="SalaryDateKind"  label="SALAXY.MODEL.CalcWorkflow.salaryDateKind.title"></salaxy-input-enum>
                      <salaxy-datepicker-popup input-mode="openClose" name="salaryDate" ng-model="$ctrl.current.workflow.salaryDate"
                        label="SALAXY.NG1.CalcEditorComponent.paymentInfo.salaryDateLabel"></salaxy-datepicker-popup>
                      <salaxy-datepicker-popup read-only="!('admin' | sxyIsInRole)" input-mode="openClose" name="salaryPaidAt" ng-model="$ctrl.current.workflow.paidAt"
                        label="SALAXY.NG1.CalcEditorComponent.paymentInfo.paymentDateLabel"></salaxy-datepicker-popup>
                      <salaxy-date-range input-mode="openClose" ng-model="$ctrl.dateRange" class="condensed" name="dateRange" on-change="$ctrl.dateRangeChange()"
                        label="SALAXY.CORE.CalcWorktime.salaryPeriod" label-days-count="SALAXY.MODEL.CalcWorktime.workDays.title"></salaxy-date-range>
                      <salaxy-input-enum  read-only="true" ng-model="$ctrl.current.info.paymentChannel" name="paymentChannel" enum="PaymentChannel"  label="SALAXY.NG1.CalcEditorComponent.paymentInfo.paymentChannel"></salaxy-input-enum>

                    </form>
                  </div>
                  <div class="col-12">
                    <form class="form-horizontal" ng-readonly="true">
                      <fieldset>
                        <legend>
                          <span sxy-text="Verokortin tiedot"></span>
                          <button class="btn btn-xs btn-default pull-right" ng-click="$ctrl.selectTaxcard()" sxy-text="SALAXY.UI_Terms.change"></button>
                        </legend>

                        <salaxy-input-enum enum="TaxcardKind" name="TaxcardKind" label="Verokortti" ng-model="$ctrl.current.worker.tax.snapshot.kind"></salaxy-input-enum>
                        <salaxy-input name="forYear" label="Vuodelle" ng-model="$ctrl.current.worker.tax.snapshot.forYear"></salaxy-input>

                        <salaxy-form-group name="validity" class="salaxy-read-only" label="Voimassa">
                          <div class="salaxy-read-only-value">
                            {{$ctrl.current.worker.tax.snapshot.validity.start | date}} - {{$ctrl.current.worker.tax.snapshot.validity.end | date}}
                          </div>
                        </salaxy-form-group>
                        <salaxy-input label="veroprosentti" name="Veroprosentti" unit="percent" ng-model="$ctrl.current.worker.tax.snapshot.taxPercent"
                          require="true"></salaxy-input>
                        <salaxy-input-number label="Tuloraja" name="tuloraja" unit="euro" ng-model="$ctrl.current.worker.tax.snapshot.incomeLimit"
                          maxlength="10"></salaxy-input-number>
                        <salaxy-input label="Lisäveroprosentti" name="lisaveroprosentti" unit="percent" ng-model="$ctrl.current.worker.tax.snapshot.taxPercent2"></salaxy-input>
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
              <div class="row spacer-bottom">
                <div class="col-md-6 col-12 spacer-bottom">
                  <form class="form-horizontal">
                    <fieldset>
                      <legend>
                        <span sxy-text="Vero, eläke- ja vakuutustiedot"></span>
                      </legend>
                      <salaxy-input-enum input-mode="openClose" label="Työeläkeyhtiö" enum="PensionCompany" name="PensionCompany"
                        ng-model="$ctrl.current.result.responsibilities.pensionCompany"></salaxy-input-enum>
                      <salaxy-input input-mode="openClose" label="Sopimusnumero" name="PensionContractNumber" ng-model="$ctrl.current.result.responsibilities.pensionContractNumber"
                        sxy-pension-contract-number></salaxy-input>
                      <salaxy-input ng-if="$ctrl.current.result.responsibilities.pensionCalculation == 'publicSector'" input-mode="openClose"
                        label="SALAXY.MODEL.PensionContract.subOrgCode.title" name="SubOrgCode" ng-model="$ctrl.current.result.responsibilities.subOrgCode"></salaxy-input>
                      <salaxy-input-number input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.pensionPercent" unit="percent" name="PensionPercent"
                        label="SALAXY.MODEL.PensionContract.pensionPercent.title"></salaxy-input-number>
                      <salaxy-input-number input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.pensionDiscountPercent" unit="percent" name="PensionDiscount"
                        label="SALAXY.MODEL.PensionContract.pensionDiscountPercent.title"></salaxy-input-number>
                      <salaxy-input-boolean input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.pensionSelfPayment" name="pensionSelfPayment"
                        label="Hoitaa TyEl-maksut itse"></salaxy-input-boolean>

                      <salaxy-input-enum input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.insuranceCompany" label="Vakuutusyhtiö" enum="InsuranceCompany"
                        name="InsuranceCompany"></salaxy-input-enum>
                      <salaxy-input input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.insuranceContractNumber" name="insuranceContractNumber"
                        label="SALAXY.MODEL.InsuranceContract.contractNumber.title"></salaxy-input>
                      <salaxy-input-number input-mode="openClose" label-cols="col-sm-6" ng-model="$ctrl.current.result.responsibilities.insurancePercent"
                        label="Tapaturm.vak.maksun arvio-%" unit="percent" name="insurancePercent"></salaxy-input-number>
                      <salaxy-input-number input-mode="openClose" label-cols="col-sm-6" ng-model="$ctrl.current.result.responsibilities.groupLifeInsurancePercent"
                        label="SALAXY.MODEL.InsuranceContract.groupLifeInsurancePercent.title" unit="percent" name="groupLifeInsurancePercent"></salaxy-input-number>

                      <salaxy-input-enum input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.unemploymentPayrollLimitStatus"
                        label="Työt.vak.maksun palkkasummaraja" enum="UnemploymentPayrollLimitStatus" name="unemploymentPayrollLimitStatus">
                      </salaxy-input-enum>

                    </fieldset>
                  </form>
                </div>
                <div class="col-md-6 col-12 spacer-bottom">
                  <div class="col-12">
                    <form class="form-horizontal" ng-readonly="true">
                      <fieldset>
                        <legend sxy-text="SALAXY.NG1.CalcEditorComponent.messages.title"></legend>
                        <salaxy-input input-mode="openClose" read-only="false" name="workDescription" ng-model="$ctrl.current.info.workDescription"
                          label="SALAXY.NG1.CalcEditorComponent.messages.workDescriptionLabel"></salaxy-input>
                        <salaxy-textarea input-mode="openClose" read-only="false" name="salarySlipMessage" ng-model="$ctrl.current.info.salarySlipMessage"
                          label="SALAXY.NG1.CalcEditorComponent.messages.salarySlipMessageLabel"></salaxy-textarea>
                      </fieldset>
                    </form>
                  </div>
                  <div class="col-12">
                    <div class="form-horizontal">
                      <salaxy-calc-cost-accounting read-only="false" input-mode="openClose" calc="$ctrl.current"></salaxy-calc-cost-accounting>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-6 ">
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'edited', text: 'SALAXY.NG1.CalcEditorComponent.editedHeading' },
          { value: 'default', text: 'SALAXY.NG1.CalcEditorComponent.originalHeading' },
          { value: 'paymentreport', text: 'SALAXY.NG1.CalcEditorComponent.diffHeading' },
          { value: 'accounting', text: 'SALAXY.NG1.CalcEditorComponent.diffAccountingHeading' },
          { value: 'cfa', text: 'SALAXY.NG1.CalcEditorComponent.diffCfa', hidden: !('admin' | sxyIsInRole) },
          { value: 'documentflow', text: 'Laskelma, palkkalistat, laskut ja ilmoitukset' },
          { value: 'editedfields', text: 'Muokatut kentät' },
        ]"
        tabs-id="calcRepair">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-calcRepair">
        <div class="tab-pane" id="edited-tab">
          <salaxy-calc-reports calcs="[$ctrl.current]" report-type="$ctrl.shared.reportType" on-report-type-change="$ctrl.shared.reportType=reportType"></salaxy-calc-reports>
        </div>
        <div class="tab-pane" id="default-tab">
          <salaxy-calc-reports ng-if="$ctrl.base" calcs="[$ctrl.base]" report-type="$ctrl.shared.reportType"
            on-report-type-change="$ctrl.shared.reportType=reportType"></salaxy-calc-reports>
        </div>
        <div class="tab-pane" id="paymentreport-tab">
          <div class="payroll-report payroll-report-partial-container">
            <salaxy-calc-report ng-if="$ctrl.base" calc="$ctrl.diffCalc" report-type="'paymentReport'" template-name="'paymentTablesV2'" apply-site-styles="true">
          </div>
        </div>
        <div class="tab-pane" id="accounting-tab">
          <salaxy-accounting-report-tools any-expanded="$reportRows.anyExpanded" on-expand-change="$reportRows.expand(close)" on-target-change="$ctrl.onTargetChange(targetId)"
            reader="$ctrl.accountingDiffDataReader"></salaxy-accounting-report-tools>
          <salaxy-accounting-report-rows ng-ref="$reportRows" data="$ctrl.accountingDiffData"></salaxy-accounting-report-rows>
        </div>
        <div class="tab-pane" id="cfa-tab" ng-if="'admin' | sxyIsInRole">
          <div>
            <table class="table table-striped">
              <tr>
                <th>Erä</th>
                <th class="text-right">Alkuperäinen summa</th>
                <th class="text-right">Korjattu summa</th>
                <th class="text-right">Ero</th>
              </tr>
              <tr>
                <td>Nettopalkka</td>
                <td class="text-right">{{ $ctrl.baseCfa.net | currency}}</td>
                <td class="text-right">{{ $ctrl.currentCfa.net | currency}}</td>
                <td class="text-right">{{ ($ctrl.currentCfa.net - $ctrl.baseCfa.net) | currency}}</td>
              </tr>
              <tr>
                <td>Eläke</td>
                <td class="text-right">{{ $ctrl.baseCfa.pension | currency}}</td>
                <td class="text-right">{{ $ctrl.currentCfa.pension | currency}}</td>
                <td class="text-right">{{ ($ctrl.currentCfa.pension - $ctrl.baseCfa.pension) | currency}}</td>
              </tr>
              <tr>
                <td>Vero</td>
                <td class="text-right">{{ $ctrl.baseCfa.tax | currency}}</td>
                <td class="text-right">{{ $ctrl.currentCfa.tax | currency}}</td>
                <td class="text-right">{{ ($ctrl.currentCfa.tax - $ctrl.baseCfa.tax) | currency}}</td>
              </tr>
              <tr>
                <td>Palvelumaksu</td>
                <td class="text-right">{{ $ctrl.baseCfa.service | currency}}</td>
                <td class="text-right">{{ $ctrl.currentCfa.service | currency}}</td>
                <td class="text-right">{{ ($ctrl.currentCfa.service - $ctrl.baseCfa.service) | currency}}</td>
              </tr>
              <tr>
                <td>Palkkio</td>
                <td class="text-right">{{ $ctrl.baseCfa.fee | currency}}</td>
                <td class="text-right">{{ $ctrl.currentCfa.fee | currency}}</td>
                <td class="text-right">{{ ($ctrl.currentCfa.fee - $ctrl.baseCfa.fee) | currency}}</td>
              </tr>
              <tr class="total">
                <td>Yhteensä</td>
                <td class="text-right">{{ $ctrl.baseCfa.total | currency}}</td>
                <td class="text-right">{{ $ctrl.currentCfa.total | currency}}</td>
                <td class="text-right">{{ ($ctrl.currentCfa.total - $ctrl.baseCfa.total) | currency}}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="tab-pane" id="documentflow-tab">
          <div>
            <table class="table table-striped">
              <tr ng-if="$ctrl.documentFlow.item">
                <td>
                  <salaxy-avatar class="salaxy-calc-row-type-avatar"
                    avatar="$ctrl.documentFlow.item.otherPartyInfo.avatar"></salaxy-avatar>
                </td>
                <td class="middle">
                  <strong >{{'Palkkalaskelma' |sxyTranslate}}</strong>
                </td>
                <td>
                  <a class="btn btn-default btn-sm" ng-href="#/calc/details/{{$ctrl.documentFlow.item.id}}">Näytä</a>
                </td>
              </tr>
              <tr ng-repeat="doc in $ctrl.documentFlow.children" ng-if="$ctrl.documentFlow.children">
                <td>
                  <salaxy-avatar ng-if="doc.item.type != 'payerSummary' && doc.item.type != 'payrollDetails'" class="salaxy-calc-row-type-avatar"
                    avatar="doc.item.otherPartyInfo.avatar"></salaxy-avatar>
                  <salaxy-avatar ng-if="doc.item.type == 'payerSummary' || doc.item.type == 'payrollDetails'" class="salaxy-calc-row-type-avatar"
                    avatar="doc.item.ownerInfo.avatar"></salaxy-avatar>
                </td>
                <td class="middle">
                  <strong ng-if="doc.item.type == 'invoice'">{{doc.item.shortText}}</strong>
                  <strong ng-if="doc.item.type == 'earningsPayment'">{{'Palkkatietoilmoitus' |sxyTranslate}}</strong>
                  <strong ng-if="doc.item.type == 'payrollDetails'">{{'Palkkalista' |sxyTranslate}}</strong>
                  <strong ng-if="doc.item.type == 'payerSummary'">{{'Erillisilmoitus' |sxyTranslate}}</strong>
                  <strong ng-if="doc.item.type == 'taxcard'">{{'Verokortti' |sxyTranslate}}</strong>
                </td>
                <td>
                  <a ng-if="doc.item.type == 'earningsPayment'" class="btn btn-default btn-sm" ng-href="#/irepr/details/{{doc.item.id}}">Näytä</a>
                  <a ng-if="doc.item.type == 'invoice'" class="btn btn-default btn-sm" ng-href="#/invoices/details/{{doc.item.id}}">
                    {{ 'SALAXY.UI_Terms.show' | sxyTranslate}}</a>
                  <a ng-if="doc.item.type == 'payerSummary'" class="btn btn-default btn-sm" ng-href="#/irpsr/details/{{doc.item.id}}">Näytä</a>
                  <a ng-if="doc.item.type == 'payrollDetails'" class="btn btn-default btn-sm" ng-href="#/payroll/details/{{doc.item.id}}">Näytä</a>
                  <a ng-if="doc.item.type == 'taxcard'" class="btn btn-default btn-sm" ng-href="#/taxcards/details/{{doc.item.id}}">Näytä</a>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="tab-pane" id="editedfields-tab">
          <salaxy-json-diff json="$ctrl.base" compare-to="$ctrl.current" exclude-paths="$ctrl.excludeDiffPaths" item-type="'Calculation'"></salaxy-json-diff>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/CalcRepairInfo.html",`<span ng-if="$ctrl.current.workflow.repairedAt" class="salaxy-component salaxy-calc-repair-info">
  <a class="btn-link"  ng-click="$ctrl.showRepaired()">
     <span>{{'Laskelman aiemmat versiot' | sxyTranslate}}</span>
  </a>
</span>`);

 $templateCache.put("salaxy-components/calc/CalcReport.html",`<div ng-if="$ctrl.reportType != 'totalsReport'" class="salaxy-component salaxy-calc-report">
  <div ng-class="{'report-table-html': $ctrl.applySiteStyles}">
    <div ng-bind-html="$ctrl.html" class="report-binder table-responsive"></div>
  </div>
  <p ng-if="('person' | sxyIsInRole) && $ctrl.calc.workflow.status !== 'paymentWorkerCopy'">{{'SALAXY.NG1.CalcReportComponent.palkkausFeeInfo' | sxyTranslate}}</p>
</div>
<div ng-if="$ctrl.reportType == 'totalsReport'" class="salaxy-component">
  <sxy-table ng-ref="$ctrl.$sxyTable" options="$ctrl.tableConfig.options" include="$ctrl.tableConfig.include" data="$ctrl.tableConfig.data"></sxy-table>
</div>`);

 $templateCache.put("salaxy-components/calc/CalcReports.html",`<div class="salaxy-component salaxy-calc-reports">
  <div class="btn-toolbar w-100 mb-3" role="toolbar" aria-label="Report options">
    <div class="btn-group btn-group-sm dropdown">
      <button id="single-button" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
        <span ng-if="!($ctrl.reportType == 'irRows' || $ctrl.reportType == 'irFull' || $ctrl.reportType == 'rowsReport')">
          <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportType" ps=":"></span>
          {{ "ReportType." + $ctrl.reportType | sxyEnum }} 
        </span>
        <span ng-if="$ctrl.reportType == 'irRows'" >
          <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportType" ps=":"></span> {{"SALAXY.NG1.CalcReportsComponent.irRows" | sxyTranslate}}
        </span>
        <span ng-if="$ctrl.reportType == 'irFull'" >
          <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportType" ps=":"></span> {{"SALAXY.NG1.CalcReportsComponent.irFull" | sxyTranslate}}
        </span>
        <span ng-if="$ctrl.reportType == 'rowsReport'" >
          <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportType" ps=":"></span> {{"SALAXY.NG1.CalcReportsComponent.rowsReport" | sxyTranslate}}
        </span>
      </button>
      <ul class="dropdown-menu"  role="menu" aria-labelledby="single-button">
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'salarySlip'" class="dropdown-item">{{ "ReportType.salarySlip" | sxyEnum }}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'employerReport'" class="dropdown-item">{{ "ReportType.employerReport" | sxyEnum }}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'paymentReport'" class="dropdown-item" class="dropdown-item">{{ "ReportType.paymentReport" | sxyEnum }}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'paymentSummaryReport'" class="dropdown-item">{{ "ReportType.paymentSummaryReport" | sxyEnum }}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'accountingReport'" class="dropdown-item">{{ "ReportType.accountingReport" | sxyEnum }}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'totalsReport'" class="dropdown-item">{{ "ReportType.totalsReport" | sxyEnum }}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'rowsReport'" class="dropdown-item">{{"SALAXY.NG1.CalcReportsComponent.rowsReport" | sxyTranslate}}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'irRows'" class="dropdown-item">{{"SALAXY.NG1.CalcReportsComponent.irRows" | sxyTranslate}}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'irFull'" class="dropdown-item">{{"SALAXY.NG1.CalcReportsComponent.irFull" | sxyTranslate}}</a></li>
        <li role="menuitem" ng-if="'test' | sxyIsInRole"><a href="" ng-click="$ctrl.reportType = 'costCenterReport'" class="dropdown-item">{{"SALAXY.NG1.CalcReportsComponent.costCenterReport" | sxyTranslate}}</a></li>
      </ul>
    </div>
    <!-- 
      TODO: When implementing, use <salaxy-input-enum type="ui-dropdown">
      Needs some fixes to the component (e.g. btn-group-sm support)
    -->
    <div class="btn-group ms-1 btn-group-sm dropdown">
      <button id="single-button2" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
        <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguage" ps=":"></span> {{$ctrl.languageText | sxyTranslate}}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button2">
        <li ng-if="$ctrl.reportType == 'salarySlip' || $ctrl.reportType == 'employerReport' || $ctrl.reportType == 'paymentReport'" role="menuitem">
          <a href="" ng-click="$ctrl.setReportLang('default')" class="dropdown-item"  sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguageWorker"></a>
        </li>
        <li ng-if="!($ctrl.reportType == 'salarySlip' || $ctrl.reportType == 'employerReport' || $ctrl.reportType == 'paymentReport')" role="menuitem">
          <a href="" ng-click="$ctrl.setReportLang('default')" class="dropdown-item"  sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguageCompany"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setReportLang('fi')" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.fi.label"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setReportLang('en')" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.en.label"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setReportLang('sv')" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.sv.label"></a>
        </li>
      </ul>
    </div>
    <salaxy-toggle-buttons ng-show="$ctrl.reportType !== 'eSalarySpecification' && $ctrl.reportType !== 'totalsReport' && $ctrl.reportType !== 'irRows' && $ctrl.reportType !== 'rowsReport'" ng-model="$ctrl.view" options="[
      { value: 'partial', label: 'SALAXY.NG1.CalcReportsComponent.reportViewPartial' },
      { value: 'page1', label: 'SALAXY.NG1.CalcReportsComponent.reportViewPage1', disabled: ($ctrl.reportType == 'accountingReport') },
      { value: 'full', label: 'SALAXY.NG1.CalcReportsComponent.reportViewFull' }
    ]" type="inline"></salaxy-toggle-buttons>
    <button ng-show="$ctrl.reportType !== 'eSalarySpecification' && $ctrl.reportType !== 'totalsReport' && $ctrl.reportType !== 'irRows' && $ctrl.reportType !== 'rowsReport'" class="btn btn-default btn-sm" ng-click="$ctrl.reload()"><i class="bi bi-arrow-repeat" aria-hidden="true"></i></button>

    <div ng-show="$ctrl.reportType !== 'eSalarySpecification' && $ctrl.reportType !== 'totalsReport' && $ctrl.reportType !== 'irRows' && $ctrl.reportType !== 'rowsReport' && $ctrl.reportType !== 'accountingReport'" class="btn-group btn-group-sm ms-auto" role="group" aria-label="Pdf">
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.showDownloadDialog(true)">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.print"></span>
        <i class="bi bi-printer" aria-hidden="true"></i>
      </button>
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.showDownloadDialog(false)">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.downloadPdf"></span>
        <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
      </button>
    </div>
    <div ng-show="$ctrl.reportType == 'totalsReport' || $ctrl.reportType == 'irRows' || $ctrl.reportType == 'rowsReport'" class="btn-group btn-group-sm ms-auto" role="group" aria-label="Excel">
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.downloadExcel()">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.downloadExcel"></span>
        <i class="bi bi-file-earmark-excel" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <!-- Results view -->
  <div ng-switch="$ctrl.reportType || 'none'">
    <div ng-switch-when="accountingReport">
      <div class="payroll-report" ng-class="{'payroll-accounting-report-partial-container': $ctrl.view == 'partial'}">
        <salaxy-accounting-report-query ng-if="$ctrl.getEmployerLang() && $ctrl.getEmployerLang() !== 'default'" lang="$ctrl.getEmployerLang()" calcs="$ctrl.calcs"
          view="$ctrl.view">
          </salaxy-accouting-report-query>
      </div>
    </div>
    <div ng-switch-when="paymentSummaryReport">
      <!-- TODO: Below development of new summary report, cleaned/moved later -->
      <div class="payroll-report" ng-class="{'payroll-report-partial-container': $ctrl.view == 'partial'}">
        <salaxy-calc-report ng-if="$ctrl.getEmployerLang() && $ctrl.getEmployerLang() !== 'default'" lang="$ctrl.getEmployerLang()" calc="$ctrl.calcs"
          apply-site-styles="$ctrl.view == 'partial'" report-type="$ctrl.reportType" preview="$ctrl.preview" template-name="$ctrl.reports[$ctrl.reportType][$ctrl.view]">
        </salaxy-calc-report>
      </div>
    </div>
    <div ng-switch-when="totalsReport">
      <!-- TODO: Set preview false or get rid of it -->
      <salaxy-calc-report class="report" ng-ref="$ctrl.$calcReports" ng-if="$ctrl.getEmployerLang() && $ctrl.getEmployerLang() !== 'default'" lang="$ctrl.getEmployerLang()" calc="$ctrl.calcs"
        apply-site-styles="$ctrl.view == 'partial'" report-type="$ctrl.reportType" preview="$ctrl.preview" template-name="$ctrl.reports[$ctrl.reportType][$ctrl.view]">
      </salaxy-calc-report>
    </div>
    <div ng-switch-when="rowsReport">
      <sxy-table ng-ref="$ctrl.$sxyTable" options="$ctrl.reportTableConfig.options" include="$ctrl.reportTableConfig.include"
        data="$ctrl.reportTableConfig.data" class="report"></sxy-table>
    </div>
    <div ng-switch-when="irRows">
      <salaxy-calcs-ir-rows ng-ref="$ctrl.$calcsIrRows" calcs="$ctrl.calcs" lang="$ctrl.getEmployerLang()" class="report"></salaxy-calcs-ir-rows>
    </div>
    <div ng-switch-when="irFull">
      <div ng-repeat="calc in $ctrl.calcs">
        <salaxy-ir-earnings-payment ng-if="calc.workflow.status == 'paymentSucceeded'" calculation="calc"></salaxy-ir-earnings-payment>
        <salaxy-ir-earnings-payment ng-if="calc.workflow.status != 'paymentSucceeded' && $ctrl.loadEpr(calc)" calculation-for="calc" model="$ctrl.loadEpr(calc)" ></salaxy-ir-earnings-payment>
      </div>
    </div>
    <div ng-switch-when="costCenterReport" ng-if="'test' | sxyIsInRole">
      <sxy-table class="report" ng-if="$ctrl.reportTableConfig.data" ng-ref="$ctrl.$sxyTable" options="$ctrl.reportTableConfig.options" include="$ctrl.reportTableConfig.include" data="$ctrl.reportTableConfig.data"></sxy-table>
    </div>
    <div ng-switch-when="none">
      <!-- Report type not selected -->
    </div>
    <div ng-switch-default="">
      <div ng-repeat="calc in $ctrl.calcs" class="payroll-report" ng-class="{'payroll-report-partial-container': $ctrl.view == 'partial'}">
        <salaxy-calc-worker-info model="calc" ng-if="$ctrl.view == 'partial'"></salaxy-calc-worker-info>
        <salaxy-calc-report ng-if="$ctrl.getWorkerLang(calc) && $ctrl.getWorkerLang(calc) !== 'default'" lang="$ctrl.getWorkerLang(calc)" calc="calc"
          apply-site-styles="$ctrl.view == 'partial'" report-type="$ctrl.reportType" preview="$ctrl.preview" template-name="$ctrl.reports[$ctrl.reportType][$ctrl.view]">
        </salaxy-calc-report>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/CalcResults.html",`<div class="result-area" ng-if="$ctrl.currentCalc && $ctrl.calcSections.get('result').isSelectionDone">
  <div class="card border-primary" style="padding: 10px">
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-md-4 order-1 order-md-2 calc-results-actions">
          <h2 class="text-center uppercase text-uppercase fw-normal"> {{ $ctrl.calcLogic.hasCompensation ? ("SALAXY.NG1.CalcResultsComponent.calculation" | sxyTranslate) : ("SALAXY.NG1.CalcResultsComponent.calculationSalary" | sxyTranslate) }}</h2>
          <div salaxy-if-role="anon">
            <button type="button" ng-click="$ctrl.register()" class="btn btn-info btn-block" sxy-text="SALAXY.UI_Terms.register"></button>
            <button type="button" ng-click="$ctrl.signIn()" class="btn btn-success btn-block" sxy-text="SALAXY.UI_Terms.login"></button>
          </div>
          
          <salaxy-validation-summary ng-if="$ctrl.currentCalc.workflow.status != 'sharedWaiting'" api-validation="$ctrl.validation"></salaxy-validation-summary>
            
          <p ng-if="$ctrl.currentCalc.workflow.status == 'payrollDraft'" class="text-center">
            <strong class="text-success" sxy-text="SALAXY.NG1.CalcResultsComponent.payrollDraft"></strong><br>
            <span sxy-text="SALAXY.NG1.CalcResultsComponent.payrollDraftInfo"></span>
          </p>
          <p ng-if="$ctrl.currentCalc.workflow.status == 'sharedWaiting'" class="text-center">
            <strong class="text-warning" sxy-text="SALAXY.NG1.CalcResultsComponent.sharedWaiting"></strong>
            <br> <span sxy-text="SALAXY.NG1.CalcResultsComponent.sharedWaitingInfo"></span>
          </p>
          <p ng-if="$ctrl.currentCalc.workflow.status == 'sharedApproved'" class="text-center">
            <strong class="text-success" sxy-text="SALAXY.NG1.CalcResultsComponent.sharedApproved"></strong>
            <br>
            <span ng-if="$ctrl.validation.isValid" sxy-text="SALAXY.NG1.CalcResultsComponent.draftInfo"></span>
          </p>
          <p ng-if="$ctrl.currentCalc.workflow.status == 'sharedRejected'" class="text-center">
            <strong class="text-danger" sxy-text="SALAXY.NG1.CalcResultsComponent.sharedRejected"></strong>
          </p>
          <p ng-if="$ctrl.currentCalc.workflow.status == 'paymentStarted'" class="text-center">
            <strong class="text-success" sxy-text="SALAXY.NG1.CalcResultsComponent.paymentStarted"></strong>
            <br>{{ $ctrl.currentCalc.workflow.paidAt | date }}
            <span ng-if="$ctrl.currentCalc.info.paymentChannel != 'undefined'">, <span sxy-text="SALAXY.NG1.CalcResultsComponent.paymentChannelTextPartial"></span> {{ "PaymentChannel." + $ctrl.currentCalc.info.paymentChannel | sxyEnum }}</span>.
            <span ng-if="$ctrl.currentCalc.workflow.salaryDateKind == 'inPast'">
              {{"SALAXY.ENUM.SalaryDateKind." + ($ctrl.currentCalc.workflow.salaryDateKind) + ".label" | sxyTranslate  }}.
            </span>
          </p>
          <p ng-if="$ctrl.currentCalc.workflow.status == 'paymentSucceeded' || $ctrl.currentCalc.workflow.status == 'paymentCanceled' || $ctrl.currentCalc.workflow.status == 'paymentRefunded' || $ctrl.currentCalc.workflow.status == 'paymentError'" class="text-center">
            <strong ng-if="$ctrl.currentCalc.workflow.status == 'paymentSucceeded'" class="text-success" sxy-text="SALAXY.NG1.CalcResultsComponent.isPaidDate"></strong>
            <strong ng-if="$ctrl.currentCalc.workflow.status == 'paymentError'" class="text-danger" sxy-text="SALAXY.NG1.CalcResultsComponent.paymentError"></strong>
            <strong ng-if="$ctrl.currentCalc.workflow.status == 'paymentRefunded'" class="" sxy-text="SALAXY.NG1.CalcResultsComponent.paymentRefunded"></strong>
            <strong  ng-if="$ctrl.currentCalc.workflow.status == 'paymentCanceled'" class="" sxy-text="SALAXY.NG1.CalcResultsComponent.paymentCanceled"></strong>
           
            <br>{{ $ctrl.currentCalc.workflow.paidAt | date }}
            <span ng-if="$ctrl.currentCalc.info.paymentChannel != 'undefined'">, <span sxy-text="SALAXY.NG1.CalcResultsComponent.paymentChannelTextPartial"></span> {{ "PaymentChannel." + $ctrl.currentCalc.info.paymentChannel | sxyEnum }}</span>.
            <span ng-if="$ctrl.currentCalc.workflow.salaryDateKind == 'inPast'">
              {{"SALAXY.ENUM.SalaryDateKind." + ($ctrl.currentCalc.workflow.salaryDateKind) + ".label" | sxyTranslate  }}.
            </span>
            <salaxy-calc-repair-info model="$ctrl" ng-if="(('repairs' | sxyIsInRole) || ('admin' | sxyIsInRole)) && $ctrl.currentCalc.workflow.status == 'paymentSucceeded'"></salaxy-calc-repair-info>
          </p>
          <p ng-if="$ctrl.currentCalc.workflow.status == 'draft'" class="text-center">
            <span ng-if="$ctrl.isReadOnly" sxy-text="SALAXY.NG1.CalcResultsComponent.draft"></span>
            <br>
            <span ng-if="$ctrl.validation.isValid  && ('!worker' | sxyIsInRole) && !$ctrl.isReadOnly" sxy-text="SALAXY.NG1.CalcResultsComponent.draftInfo"></span>
          </p>
          <div ng-if="('auth' | sxyIsInRole) && ('!worker' | sxyIsInRole)">
            <div ng-if="$ctrl.showAction('sendToPro')">
              <p  class="text-center">
                <strong class="text-success" sxy-text="SALAXY.NG1.CalcResultsComponent.waitingApproval"></strong>
                <br>
                <span sxy-text="SALAXY.NG1.CalcResultsComponent.waitingApprovalInfo"></span>
              </p>
              <div class="form-horizontal mb-1">
                <salaxy-textarea  name="workflowMessage" ng-model="$ctrl.workflowMessage" label="SALAXY.NG1.CalcResultsComponent.messageToAccountant" label-type="basic"></salaxy-textarea>
              </div>
              <div class="text-center">
                <button type="button" class="btn btn-primary" ng-click="$ctrl.sendToPro($ctrl.workflowMessage)" sxy-text="SALAXY.NG1.CalcResultsComponent.sendToProBtn" ps="»"></button>
              </div>
            </div>
            <div ng-if="$ctrl.showAction('showPaymentDialog')" class="text-center mb-1">
              <a href="" ng-click="$ctrl.showPaymentDialog()" sxy-text="SALAXY.NG1.CalcResultsComponent.showPaymentDialog"></a>.
            </div>
            <div ng-if="$ctrl.showAction('continuePsdPayment') && ('salaxyPay' | sxyIsInRole)" ng-controller="NewPaymentController as $newPaymentCtrl" class="text-center mb-1">
              <button type="button" ng-click="$newPaymentCtrl.openSalaxyPay($ctrl.currentCalc, 2)" class="btn btn-primary btn-block" sxy-text="SALAXY.NG1.CalcResultsComponent.continuePsdPayment"></button>
              
            </div>
            <div ng-if="!$ctrl.validation.isValid">
              <salaxy-pay-button ng-if="$ctrl.showAction('allowForcePay')" label="SALAXY.UI_Terms.payAllShort" model="$ctrl.currentCalc" mode="button-and-channel" button-class="uppercase" ng-ref="$payButton" disabled="!$payButton.isChannelDefined" on-payment-channel-change="$ctrl.recalculate()"></salaxy-pay-button>
            </div>
            <div ng-if="$ctrl.validation.isValid">
              <div ng-if="$ctrl.showAction('pay')" class="mb-1">
                <salaxy-pay-button model="$ctrl.currentCalc" mode="button-and-channel" salaxy-if-role="employer" button-class="uppercase" ng-ref="$payButton" disabled="!$payButton.isChannelDefined" on-payment-channel-change="$ctrl.recalculate()"></salaxy-pay-button>
                <salaxy-salary-date-kind-button ng-if="$ctrl.showAction('setSalaryDateKind') && ('test,setSalaryDateKind' | sxyIsInRole) && ('employer' | sxyIsInRole)" button-class="btn-block" model="$ctrl.currentCalc" disabled="$ctrl.currentCalc.isReadOnly || $ctrl.isReadOnlyForced" on-salary-date-kind-change="$ctrl.recalculate()"></salaxy-salary-date-kind-button>
              </div>
            </div> 
            <div ng-if="$ctrl.showAction('save')" class="mb-1">
              <button type="button" ng-click="$ctrl.save()" class="btn btn-success btn-block" ng-disabled="$ctrl.isActionDisabled('save')" sxy-text="SALAXY.UI_Terms.save"></button>
            </div>
            <div ng-if="$ctrl.showAction('reject')" class="mb-1">
              <salaxy-calc-sharing-receipt-action button-class="btn btn-danger btn-block" model="$ctrl" type="'reject'"></salaxy-calc-sharing-receipt-action>
            </div>
            <div ng-if="$ctrl.showAction('approve')" class="mb-1">
              <salaxy-calc-sharing-receipt-action button-class="btn btn-success btn-block" model="$ctrl" type="'approve'"></salaxy-calc-sharing-receipt-action>
            </div>
            <button ng-if="$ctrl.showAction('delete')" type="button" ng-click="$ctrl.deleteCalc()" ng-disabled="$ctrl.isActionDisabled('delete')" class="btn btn-danger btn-block" sxy-text="SALAXY.UI_Terms.delete"></button>
            <button ng-if="$ctrl.showAction('cancel')" class="btn btn-default btn-sm btn-block" ng-click="$ctrl.cancel()" sxy-text="SALAXY.NG1.CalcResultsComponent.cancelPaymentOrChangeChannelBtn"></button>
            
            <button ng-if="$ctrl.showAction('copyAsNew')" type="button" ng-click="$ctrl.copyAsNew()" class="btn btn-primary btn-block" sxy-text="SALAXY.UI_Terms.copyAsNew" ps=" »"></button>
          </div>
          <div sxy-if-role="worker" class="row hidden-xxs">
            <div ng-if="$ctrl.showAction('save')" class="col-12">
              <button type="button" ng-click="$ctrl.save()" class="btn btn-success btn-block" ng-disabled="$ctrl.isActionDisabled('save')" sxy-text="SALAXY.UI_Terms.save"></button>
            </div>
            <div ng-if="$ctrl.currentCalc.workflow.status == 'draft' || $ctrl.currentCalc.workflow.status == 'workerRequested' || $ctrl.currentCalc.workflow.status == 'workerRequestAccepted' || $ctrl.currentCalc.workflow.status == 'workerRequestDeclined' || $ctrl.currentCalc.workflow.status == 'paymentWorkerCopy'" class="col-12">
              <salaxy-calc-sharing-info model="$ctrl"></salaxy-calc-sharing-info>
            </div>
            <div ng-if="$ctrl.showAction('delete')" class="col-12">
              <button ng-if="$ctrl.showAction('delete')" type="button" ng-click="$ctrl.deleteCalc()" ng-disabled="$ctrl.isActionDisabled('delete')" class="btn btn-danger btn-block" sxy-text="SALAXY.UI_Terms.delete"></button>
            </div>
          </div>
         
          <div class="text-center btn-group-chart">
            <a ng-click="$ctrl.chartType = 'bar'" class="btn-chart me-2" ng-class="{'active' : $ctrl.chartType == 'bar'}"><i class="bi bi-bar-chart-line-fill"></i></a>
            <a ng-click="$ctrl.chartType = 'pie'" class="btn-chart" ng-class="{'active' : $ctrl.chartType == 'pie'}"><i class="bi bi-pie-chart-fill"></i></a>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4 order-2 order-md-1">
          <h3 class="text-center fw-normal" sxy-text="SALAXY.NG1_Other.Roles.employer"></h3>
          <salaxy-calc-chart role="employer" scale-y-axis="true" chart-type="$ctrl.chartType" calc="$ctrl.currentCalc"></salaxy-calc-chart>
          <p class="text-center" ng-if="$ctrl.isHouseholdDeductible">
            <span sxy-text="SALAXY.NG1.CalcResultsComponent.nowPaying" ps=":"></span> {{ $ctrl.currentCalc.result.employerCalc.totalPayment | currency: "":2 }} €
            <br />
            <span sxy-text="SALAXY.NG1.CalcResultsComponent.finalCost" ps=":"></span> {{ $ctrl.currentCalc.result.employerCalc.finalCost | currency: "":2 }} €
          </p>
          <p class="text-center" ng-if="!$ctrl.isHouseholdDeductible">
            <span sxy-text="SALAXY.NG1.CalcDetailsSalaryComponent.paymentTotal.title" ps=":"></span> {{ $ctrl.currentCalc.result.employerCalc.finalCost | currency: "":2 }} €
          </p>
        </div>
        <div class="col-12 col-sm-6 col-md-4 order-3">
          <h3 class="text-center fw-normal" sxy-text="SALAXY.NG1_Other.Roles.worker"></h3>
          <salaxy-calc-chart role="worker" scale-y-axis="true" chart-type="$ctrl.chartType" calc="$ctrl.currentCalc"></salaxy-calc-chart>
          <p class="text-center">
            <span sxy-text="SALAXY.NG1.CalcResultsComponent.workerGetsPaid" ps=":"></span> {{ $ctrl.currentCalc.result.workerCalc.totalWorkerPayment | currency: "":2 }} €
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-4 d-flex justify-content-center">
        <a class="action-link" ng-click="$ctrl.showReportDialog('employerReport')" sxy-text="SALAXY.NG1.CalcResultsComponent.employerReport"></a>
      </div>
      <div class="col-12 col-sm-4 d-flex justify-content-center">
        <a class="action-link" ng-click="$ctrl.showReportDialog('paymentReport')" sxy-text="SALAXY.NG1.CalcResultsComponent.societyReport"></a>
      </div>
      <div class="col-12 col-sm-4 d-flex justify-content-center">
        <a class="action-link" ng-click="$ctrl.showReportDialog('salarySlip')" sxy-text="SALAXY.NG1.CalcResultsComponent.workerReport"></a>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/CalcRowType.html",`<div class="salaxy-component salaxy-calc-row-type">
  <div ng-if="$ctrl.type == 'read-only'" class="salaxy-calc-row-type-read-only">
    {{ $ctrl.getRowLabel() | sxyTranslate }}
  </div>
  <div ng-if="$ctrl.type == 'typehead'" class="salaxy-calc-row-type-typehead" style="position: relative">
    <salaxy-input-typeahead
      label-type="no-label"
      ng-model="$ctrl.internalValue"
      name="{{ $ctrl.name }}"
      disable-cache="true"
      clear-on-select="$ctrl.clearOnSelect"
      value-as-object="true"
      placeholder="{{ $ctrl.placeholder || 'SALAXY.UI_Terms.select' | sxyTranslate }}"
      get-options="$ctrl.search">
    </salaxy-input-typeahead>
  </div>
  <div ng-if="$ctrl.type == 'list'" class="salaxy-calc-row-type-list">
    <div class="list-group">
      <div ng-repeat="item in $ctrl.getCachedSearch($ctrl.searchText, true)">
        <a ng-if="item.ui.iconText" class="list-group-item clickable d-flex" ng-click="$ctrl.internalValue = item" ng-class="{ 'active': $ctrl.internalValue == item }">
          <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="{ color: item.ui.color, initials: item.ui.iconText, entityType: 'company' }"></salaxy-avatar>
          <div>
            <b class="salaxy-highlight" ng-bind-html="item.text | uibTypeaheadHighlight:$ctrl.searchText"></b><br />
            <small class="salaxy-highlight">
              <div ng-bind-html="item.title | uibTypeaheadHighlight:$ctrl.searchText"></div>
            </small>
          </div>
        </a>
        <a ng-if="!item.ui.iconText" class="list-group-item clickable salaxy-highlight" ng-click="$ctrl.internalValue = item" ng-class="{ 'active': $ctrl.internalValue == item }" title="{{ enum.title }}" style="display: list-item; list-style-type: disc; list-style-position: inside; padding: 2px 2px 2px 60px">
          <span ng-bind-html="item.text | uibTypeaheadHighlight:query"></span>
        </a>
      </div>
    </div>
  </div>
  <div ng-if="$ctrl.type == 'table'" class="salaxy-calc-row-type-table">
    <table class="table table-sm">
      <thead>
        <tr class="active">
          <td>
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="{ color: 'rgb(79, 205, 196)', initials: 'type', entityType: 'company' }"></salaxy-avatar>
          </td>
          <td>
            <div><b sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowType" ps=" (type)"></b></div>
            <div sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowDescription"></div>
          </td>
          <td><b sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowTypeEn"></b></td>
        </tr>
        <tr class="active">
          <td></td>
          <td sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowKind" ps=" (kind)"></td>
          <td sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowKindEn"></td>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat-start="item in $ctrl.getCachedSearch($ctrl.searchText, true)" ng-if="item.ui.iconText">
          <th rowspan="2">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="{ color: item.ui.color, initials: item.ui.iconText, entityType: 'company' }"></salaxy-avatar>
          </th>
          <th>
            <div>
              <b class="salaxy-highlight" ng-bind-html="item.text | uibTypeaheadHighlight:$ctrl.searchText"></b>
              <button type="button" class="btn btn-xs btn-default" ng-click="$ctrl.showInfoScreen(item)" style="margin-left: 5px">edit</button>
            </div>
          </th>
          <th>
            <div class="salaxy-highlight" ng-bind-html="item.value | uibTypeaheadHighlight:$ctrl.searchText"></div>
          </th>
        </tr>
        <tr ng-if="item.ui.iconText" class="no-border">
          <td colspan="2" style="padding-top: 0;">
            <div style="padding-top: 0;" class="salaxy-highlight" ng-bind-html="item.title | uibTypeaheadHighlight:$ctrl.searchText"></div>
          </td>
        </tr>
        <tr ng-if="!item.ui.iconText">
          <td></td>
          <td>
            <div class="salaxy-highlight" ng-bind-html="item.text | uibTypeaheadHighlight:$ctrl.searchText"></div>
          </td>
          <td>
            <div class="salaxy-highlight" ng-bind-html="item.value.split('.')[1] | uibTypeaheadHighlight:$ctrl.searchText"></div>
          </td>
        </tr>
        <tr ng-repeat-end="item in $ctrl.getList()" ng-if="!item.ui.iconText" class="no-border">
          <td></td>
          <td colspan="2" style="padding-top: 0;">
            <div class="salaxy-highlight" ng-bind-html="item.title | uibTypeaheadHighlight:$ctrl.searchText"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/CalcRowTypeItem.html",`<a class="clickable d-flex" ng-if="match.model.ui.iconText">
  <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" 
    avatar="{ color: match.model.ui.color, initials: match.model.ui.iconText, entityType: 'company' }"></salaxy-avatar>
  <div>
    <b class="salaxy-highlight" ng-bind-html="match.model.text | uibTypeaheadHighlight:query"></b><br />
    <small class="salaxy-highlight"><div ng-bind-html="match.model.title | uibTypeaheadHighlight:query"></div></small>
  </div>
</a>
<a class="clickable" ng-if="!match.model.ui.iconText"
style="display: list-item; list-style-type: disc; list-style-position: inside; padding: 2px 2px 2px 60px">
  <b class="salaxy-highlight" ng-bind-html="match.model.text | uibTypeaheadHighlight:query"></b> 
  <small class="salaxy-highlight"><span ng-bind-html="match.model.title || '' | uibTypeaheadHighlight:query"></span></small>
</a>`);

 $templateCache.put("salaxy-components/calc/CalcSharingReceiptAction.html",`<span ng-switch="$ctrl.type">
  <button ng-switch-when="approve" class="btn {{$ctrl.buttonClass || 'btn-success btn-block btn-sm' }}" type="button" id="approve" ng-disabled="$ctrl.disabled"
    ng-click="$ctrl.approve()" title="{{'SALAXY.NG1.CalcSharingReceiptActionComponent.approveBtnTitle' | sxyTranslate}}">
    <span ng-if="!$ctrl.iconOnly">{{'SALAXY.NG1.CalcSharingReceiptActionComponent.approveBtn' | sxyTranslate}}&nbsp;</span>
<span ng-show="!$ctrl.isLoading"><i class="bi bi-hand-thumbs-up"></i></span>
<span ng-show="$ctrl.isLoading"><i class="bi bi-arrow-repeat bi-spin"></i></span>
</button>
<button ng-switch-when="reject" class="btn {{$ctrl.buttonClass || 'btn-danger btn-block btn-sm' }}" type="button" id="reject" ng-disabled="$ctrl.disabled" ng-click="$ctrl.reject()" title="{{'SALAXY.NG1.CalcSharingReceiptActionComponent.rejectBtnTitle' | sxyTranslate}}">
    <span ng-if="!$ctrl.iconOnly"> {{'SALAXY.NG1.CalcSharingReceiptActionComponent.rejectBtn' | sxyTranslate}}&nbsp;</span>
    <span ng-show="!$ctrl.isLoading"><i class="bi bi-hand-thumbs-down"></i></span>
    <span ng-show="$ctrl.isLoading"><i class="bi bi-arrow-repeat bi-spin"></i></span>
  </button>
<span ng-switch-default class="alert alert-danger" sxy-text="SALAXY.NG1.CalcSharingReceiptActionComponent.alertUnknown"></span>
</span>`);

 $templateCache.put("salaxy-components/calc/CalcWorkerInfo.html",`<div class="salaxy-component salaxy-calc-worker-info">
  <div class="row">
    <div class="col-2 col-md-2 worker-info-avatar-container d-flex align-items-center justify-content-center">
      <salaxy-avatar avatar="$ctrl.current.worker.avatar"></salaxy-avatar>
    </div>
    <div class="col-10 col-md-10 worker-info-col">
      <h2>{{ $ctrl.current.worker.avatar.displayName || ("SALAXY.NG1.WorkerInfo.noSelection" | sxyTranslate) }}</h2>
      <div class="row">
        <div class="col-12 col-md-6">
          <div ng-class="{'text-danger': $ctrl.taxUi.status != 'ok'}">{{ $ctrl.taxUi.text || "&nbsp;" }}</div>
          <div ng-if="!$ctrl.current.worker.paymentData.ibanNumber" class="text-danger" sxy-text="SALAXY.NG1.WorkerInfo.noIbanNumber"></div>
          <div ng-if="$ctrl.current.worker.paymentData.ibanNumber">{{ $ctrl.current.worker.paymentData.ibanNumber | sxyIban }}</div>
          <div>{{ $ctrl.getPensionText() || "&nbsp;" }}</div>
        </div>
        <div class="col-12 col-md-6 ">
          <div ng-if="!$ctrl.current.worker.paymentData.socialSecurityNumberValid" class="text-danger">
            <span sxy-text="SALAXY.NG1.PaymentDialogComponent.noSSNumber"></span>
            <br />
          </div>
          <div ng-if="$ctrl.current.worker.paymentData.socialSecurityNumberValid">{{ $ctrl.current.worker.paymentData.socialSecurityNumberValid }}<br /></div>
          <span ng-if="$ctrl.current.worker.paymentData.telephone">
            {{ $ctrl.current.worker.paymentData.telephone ||  ('SALAXY.NG1.PaymentDialogComponent.noTel' | sxyTranslate) }}
          </span>
          <br />
          <a href="{{ 'mailto:' + $ctrl.current.worker.paymentData.email }}" ng-if="$ctrl.current.worker.paymentData.email">{{ $ctrl.current.worker.paymentData.email }}</a>
          <div ng-if="$ctrl.current && !$ctrl.current.worker.paymentData.email">
            <span sxy-text="SALAXY.NG1.PaymentDialogComponent.noEmail"></span> &nbsp;
            <span class="text-warning" sxy-text="SALAXY.NG1.PaymentDialogComponent.noEmailInfo"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/CalcWorktime.html",`<style type="text/css">
  .form-condensed .form-group {
    margin-bottom: 1px
  }

  .form-condensed .form-horizontal .control-label {
    padding-top: 0px;
  }
</style>
<div class="salaxy-component salaxy-calc-worktime" ng-if="$ctrl.currentCalc">
  <form ng-submit="$ctrl.submitWorktime()" name="detailsWork2" class="form-horizontal">
    <div class="salaxy-calc-dialog-body">
      <div class="salaxy-calc-dialog-container">
        <div class="row">
          <div class="col-md-6" >
            <h1 sxy-text="SALAXY.NG1.CalcWorktimeComponent.salaryDateTitle"></h1>
            <p sxy-html="SALAXY.NG1.CalcWorktimeComponent.salaryDateDescription.html"></p>
            <div class="form-horizontal">
              <salaxy-form-group ng-if="$ctrl.currentCalc.workflow.salaryDateKind == 'inPast'" name="salaryDateKind" class="salaxy-component salaxy-read-only" label-cols="col-sm-6" label="SALAXY.MODEL.CalcWorkflow.salaryDateKind.title">
                <div class="form-control-plaintext">{{"SALAXY.ENUM.SalaryDateKind." + ($ctrl.currentCalc.workflow.salaryDateKind) + ".label" | sxyTranslate  }}</div>
              </salaxy-form-group>
              <salaxy-datepicker-popup name="requestedSalaryDate" ng-model="$ctrl.requestedSalaryDate" label="SALAXY.NG1.CalcWorktimeComponent.salaryDateLabel" label-cols="col-sm-6" date-disabled="disable-function" disable-function="$ctrl.isDisabledSalaryDate" update-disabled-dates="($ctrl.currentCalc.workflow.salaryDateKind || '-') + '|' + ($ctrl.currentCalc.info.paymentChannel || '-')" placeholder="SALAXY.NG1.CalcWorktimeComponent.salaryDatePlaceholder"></salaxy-datepicker-popup>
            </div>
            <h1 sxy-text="SALAXY.NG1.CalcWorktimeComponent.worktime.title"></h1>
            <p ng-if="!$ctrl.dateRange.start || !$ctrl.dateRange.start" sxy-text="SALAXY.NG1.CalcWorktimeComponent.worktime.description"></p>
            <div class="form-horizontal">
              <salaxy-input-enum ng-model="$ctrl.periodShortcut" require="!!$ctrl.isWorkerHolidaysActive" name="periodShortcut" ng-if="!$ctrl.periodShortcut" label="SALAXY.CORE.CalcWorktime.salaryPeriod" label-cols="col-sm-6" type="radio" options="$ctrl.periodShortcuts"></salaxy-input-enum>
              <salaxy-input-enum ng-model="$ctrl.periodShortcut" require="!!$ctrl.isWorkerHolidaysActive" name="periodShortcut" ng-if="$ctrl.periodShortcut" label="SALAXY.CORE.CalcWorktime.salaryPeriod" label-cols="col-sm-6" type="select" options="$ctrl.periodShortcuts"></salaxy-input-enum>
              <salaxy-date-range ng-model="$ctrl.dateRange" require="!!$ctrl.isWorkerHolidaysActive" class="condensed" name="dateRange" ng-if="$ctrl.periodShortcut == 'other'" on-change="$ctrl.dateRangeChange()" label="SALAXY.CORE.CalcWorktime.salaryPeriod" label-days-count="SALAXY.MODEL.CalcWorktime.workDays.title"
                label-cols="col-sm-6" read-only="$ctrl.isReadOnly"></salaxy-date-range>
              <div ng-if="$ctrl.periodShortcut && $ctrl.periodShortcut != 'other'">
                <salaxy-form-group name="periodStartDate" label="SALAXY.MODEL.DateRange.start.title" label-cols="col-sm-6">
                  <input type="text" class="form-control" autocomplete="off" id="periodStartDate" name="periodStartDate" placeholder="{{'SALAXY.UI_Terms.dateFormats.dm' | sxyTranslate}}" ng-model="$ctrl.periodStartDate" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }"
                  />
                  <div ng-if="$ctrl.periodStartDateError" class="form-control-plaintext text-danger">{{ $ctrl.periodStartDateError |sxyTranslate}}</div>
                </salaxy-form-group>
                <salaxy-form-group name="formattedRange" label="SALAXY.CORE.CalcWorktime.startAndEndDates" label-cols="col-sm-6" class="salaxy-read-only">
                  <div class="form-control-plaintext">{{ $ctrl.dateRange | sxyDateRange }}</div>
                </salaxy-form-group>
                <salaxy-input-number name="labelDaysCount" ng-model="$ctrl.dateRange.daysCount" ng-change="$ctrl.dateRangeChange()" require="!!$ctrl.isWorkerHolidaysActive" label="SALAXY.MODEL.DateRange.daysCount.title" label-cols="col-sm-6">
                </salaxy-input-number>
              </div>
            </div>
          </div>
          <div class="col-md-6" ng-if="!(('worker' | sxyIsInRole) || ('disableHolidays' | sxyIsInRole))">
            <h1 sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.title"></h1>
            <div ng-switch="$ctrl.getHolidaysStatus()">
              <div ng-switch-when="noWorker" sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.descriptionNoWorker"></div>
              <div ng-switch-when="noPeriod" sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.descriptionNoPeriod"></div>
              <div ng-switch-when="loading">
                <salaxy-spinner full-screen="false" heading="SALAXY.UI_Terms.loading" text="SALAXY.NG1.CalcWorktimeComponent.absences.loadingText"></salaxy-spinner>
              </div>
              <div ng-switch-when="ok">
                <button class="btn btn-default float-end salaxy-button-pro" ng-click="$ctrl.showPeriodDetails()" type="button" title="{{'SALAXY.NG1.CalcWorktimeComponent.absences.proTabTitle' | sxyTranslate}}">Pro</button>
                <salaxy-tab-buttons
                  current-tab="$ctrl.currentTab"
                  options="[
                    { value: 'default', text: 'SALAXY.NG1.CalcWorktimeComponent.absences.calculationTabHeading', isDefault: true },
                    { value: 'absences', text: 'SALAXY.NG1.AbsencePeriodsComponent.headerAbsence' },
                    { value: 'leaves', text: 'SALAXY.NG1.CalcWorktimeComponent.absences.leavesTabHeading', hidden: !$ctrl.isHolidayAccrual }  
                  ]"
                  tabs-id="calcWorktime">
                </salaxy-tab-buttons>
                <div class="tab-content" id="tab-content-calcWorktime">
                  <div class="tab-pane" id="default-tab">
                    <fieldset ng-if="$ctrl.accruesHolidays">
                      <table class="table table-striped table-sm">
                        <thead>
                          <tr>
                            <th sxy-text="SALAXY.NG1.CalcWorktimeComponent.holidays.headerHolidays"></th>
                            <th class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.holidays.headerDays"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr ng-repeat="month in $ctrl.worktime.accruals">
                            <td>
                              <strong>{{ $ctrl.getAccrualMonthText('header', month) | sxyTranslate}}</strong><br>
                              <small>
                                <div>
                                  <a href="" ng-click="$ctrl.changeTab('absences')">
                                    <span sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.link"></span> {{ month.absencesDays | sxyCount : 'day' }}
                                  </a>
                                </div>
                              </small>
                            </td>
                            <td class="right">
                              <strong>{{ month.daysAccrued | sxyCount : 'day' }}</strong><br>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <small>
                        <p>{{ $ctrl.getAccrualMonthText("description") | sxyTranslate }}</p>
                      </small>
                    </fieldset>
                    <legend sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.calculationLegend"></legend>
                      <div>
                        <fieldset>
                          <table class="table table-striped table-sm" ng-if="$ctrl.getLogicForLists().getAbcencesForPeriod().length">
                            <thead>
                              <tr>
                                <th sxy-text="SALAXY.NG1.AbsencePeriodsComponent.headerAbsence"></th>
                                <th class="right" sxy-text="SALAXY.NG1.AbsencePeriodsComponent.headerDays"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr ng-repeat="row in $ctrl.getLogicForLists().getAbcencesForPeriod()">
                                <td>
                                  <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
                                  <strong>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</strong><br />
                                  <div class="float-start" style="padding: 0px;">
                                    {{ row.isPaid ? ('SALAXY.NG1.AbsencePeriodsComponent.isPaid' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notPaid' |sxyTranslate) }}
                                    <span ng-if="row.isPaid != row.isHolidayAccrual"> {{ row.isHolidayAccrual ? ('SALAXY.NG1.AbsencePeriodsComponent.isAccrual' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notAccrual' | sxyTranslate) }}</span>
                                  </div>
                                  <div class="truncate" style="max-width: 250px; padding: 0px;">
                                    &nbsp;{{ row.notes }}
                                  </div>
                                </td>
                                <td class="right">
                                  <strong>{{ row.period.daysCount | sxyCount : "day" }}</strong><br /> {{ row.period | sxyDateRange }}
                                </td>
                              </tr>
                              <tr class="total">
                                <td>
                                  <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" style="margin-bottom: 20px" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
                                  <strong>
                                    <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalUnpaid"></span><br />
                                    <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalPaid"></span><br />
                                    <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalNoHolidayAccrual"></span><br />
                                  <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalAll"></span><br />
                                  </strong>
                                </td>
                                <td class="right">
                                  <strong>
                                    {{ $ctrl.getLogicForLists().getAbcensePeriodsTotalDays("absencesUnpaid") | sxyCount : "day" }}<br />
                                    {{ $ctrl.getLogicForLists().getAbcensePeriodsTotalDays("absencesPaid") | sxyCount : "day" }}<br />
                                    {{ $ctrl.getLogicForLists().getAbcensePeriodsTotalDays("absencesNoHolidayAccrual") | sxyCount : "day" }}<br />
                                    {{ $ctrl.getLogicForLists().getAbcensePeriodsTotalDays("all") | sxyCount : "day" }}<br />
                                  </strong>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <p ng-if="!$ctrl.getLogicForLists().getAbcencesForPeriod().length" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.noAbsences"></p>
                        </fieldset>
                      </div>
                      <div ng-if="$ctrl.worktime.holidaySpec.code == 'noHolidays'">
                        <strong sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.calculationDescriptionNoHolidays"></strong>
                      </div>
                      <div ng-if="$ctrl.worktime.holidaySpec.code == 'holidayCompensation'">
  
                        <div style="margin-bottom: 8px; margin-right: 10px;">
                          <div class="float-end">{{ $ctrl.worktime.holidaySpec.compensation | sxyCount : 'percent' }}</div>
                          <strong sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.calculationDescriptionHolidayCompensation"></strong>
                        </div>
                        <div style="margin-bottom: 8px; margin-right: 10px;" ng-if="$ctrl.worktime.holidaySpec.bonus > 0">
  
                          <div class="float-end">{{ $ctrl.worktime.holidaySpec.bonus | sxyCount : 'percent' }}</div>
                          <strong sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.calculationDescriptionHolidayBonus" pre="+ "></strong>
                        </div>
                        <div ng-if="!$ctrl.worktime.holidaySpec.bonus" sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.calculationDescriptionNoHolidayBonus"></div>
                      </div>
                      <div ng-if="$ctrl.isHolidayAccrual">
                      <button ng-if="!$ctrl.currentCalc.isReadOnly" type="button" class="btn btn-default" ng-click="$ctrl.openCalcLeavesDialog()">{{"SALAXY.UI_Terms.edit" | sxyTranslate}}...</button> 
                      <fieldset >
                        <table class="table table-striped table-sm" ng-if="$ctrl.getLogicForLists().getAnnualLeavesForPeriod().length">
                          <thead>
                            <tr>
                              <th sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.period"></th>
                              <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.daysCount"></th>
                            </tr>
                          </thead>
                          <tr ng-repeat="row in $ctrl.getLogicForLists().getAnnualLeavesForPeriod()">
                            <td>
                              <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
                              <strong>{{ row.period | sxyDateRange }}</strong>
                              <br />
                              <small>
                                <div class="truncate" style="max-width: 250px;">{{ $ctrl.getLogicForLists().getAnnualLeaveDescription(row) }}</div>
                              </small>
                            </td>
                            <td class="right">
                              <strong>{{ row.period.daysCount | sxyCount : "day"  }}</strong>
                            </td>
                          </tr>
                          <tr class="total">
                            <td>
                              <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
                              <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.total"></strong>
                              <br />
                              <small>
                                <div class="truncate" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.totalMore"></div>
                              </small>
                            </td>
                            <td class="right">
                              <strong>{{ $ctrl.getLogicForLists().getAnnualLeavesTotalDays() | sxyCount : "day" }}</strong>
                            </td>
                          </tr>
                        </table>
                        <p ng-if="!$ctrl.getLogicForLists().getAnnualLeavesForPeriod().length" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.noAnnualLeaves"></p>
                      </fieldset>  
                    </div>
                  </div>
                  <div class="tab-pane" id="absences-tab">
                    <div sxy-if-role="auth" ng-controller="WorkerAbsencesCrudController as $absencesCtrl" ng-init="$absencesCtrl.employmentId=$ctrl.currentCalc.worker.employmentId">
                      <salaxy-absence-periods parent="$absencesCtrl.current" condensed="true" on-commit="$ctrl.absencesChanged($absencesCtrl)" ng-if="$absencesCtrl.current" ></salaxy-absence-periods>
                    </div>
                    <div sxy-if-role="!auth">
                      <p sxy-html="SALAXY.NG1.CalcWorktimeComponent.anonDemoText.html"></p>
                      <salaxy-absence-periods parent="$ctrl.demoData.absences" condensed="true" on-commit="$ctrl.reloadHolidays()"></salaxy-absence-periods>
                    </div>
                    <p>&nbsp;</p>
                    <small>
                      <p sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.absencesAttention"></p>
                    </small>
                  </div>
                  <div class="tab-pane" id="leaves-tab">
                    <div ng-if="$ctrl.isHolidayAccrual">
                      <div ng-controller="HolidayYearCrudController as $holidaysCtrl" ng-init="$holidaysCtrl.employmentId=$ctrl.currentCalc.worker.employmentId;$holidaysCtrl.forDate=$ctrl.currentCalc.info.workStartDate">
                        <salaxy-holiday-year-holidays parent="$holidaysCtrl.current" condensed="true" on-commit="$ctrl.holidaysChanged($holidaysCtrl)" ng-if="$holidaysCtrl.current" ></salaxy-holiday-year-holidays>
                      </div>
                      <p>&nbsp;</p>
                      <small>
                        <p sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.absencesAttention"></p>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button ng-show="!$ctrl.currentCalc.isReadOnly" class="btn btn-warning btn-lg salaxy-calc-btn-recalculate" type="submit">{{ $ctrl.hasHolidaysOrAbsences() ?
      ('SALAXY.NG1.CalcWorktimeComponent.absences.calculateButtonText' | sxyTranslate) : ('SALAXY.UI_Terms.updateCalculation' |sxyTranslate) }}</button>
  </form>
</div>`);

 $templateCache.put("salaxy-components/calc/CostAccounting.html",`<div class="salaxy-component salaxy-cost-accounting">
  <div ng-if="$ctrl.current.length > 0 || $ctrl.definitions.length > 0">
    <fieldset>
      <legend sxy-text="SALAXY.NG1.CalcCostAccountingComponent.title"></legend>
      <div ng-repeat="dimension in $ctrl.definitions">
        <div ng-if="!dimension.allowCostSharing">
          <div class="form-horizontal">
            <div class="row">
              <div class="col-md-11">
                <salaxy-input-typeahead class="text-muted" ng-if="$ctrl.isInherited(dimension.id) && $ctrl.hasOptions(dimension.id, $ctrl.getInheritedSingleValue(dimension.id).value)" label="{{(dimension.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" ng-model="$ctrl.getInheritedSingleValue(dimension.id).value"
                  label-format="text-value" get-options="$ctrl.getOptions(dimension.id)" name="single" read-only="true" placeholder="{{ 'SALAXY.UI_Terms.notChosen' | sxyTranslate }}">
                </salaxy-input-typeahead>
                <salaxy-input class="text-muted" ng-if="$ctrl.isInherited(dimension.id) && !$ctrl.hasOptions(dimension.id, $ctrl.getInheritedSingleValue(dimension.id).value)" label="{{(dimension.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" ng-model="$ctrl.getInheritedSingleValue(dimension.id).value" name="single"
                  read-only="true">
                </salaxy-input>

                <salaxy-input-typeahead ng-if="!$ctrl.isInherited(dimension.id) && $ctrl.hasOptions(dimension.id, $ctrl.getSingleValue(dimension.id).value)" label="{{(dimension.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" ng-model="$ctrl.getSingleValue(dimension.id).value"
                  label-format="text-value" options="$ctrl.getOptions(dimension.id)" name="single" read-only="$ctrl.readOnly" input-mode="{{$ctrl.inputMode}}" ng-change="$ctrl.setSingleValue(dimension.id, $ctrl.getSingleValue(dimension.id).value)" placeholder="{{ 'SALAXY.UI_Terms.notChosen' | sxyTranslate }}"></salaxy-input-typeahead>

                <salaxy-input ng-if="!$ctrl.isInherited(dimension.id) && !$ctrl.hasOptions(dimension.id, $ctrl.getSingleValue(dimension.id).value)" label="{{(dimension.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" ng-model="$ctrl.getSingleValue(dimension.id).value" name="single"
                read-only="$ctrl.readOnly" input-mode="{{$ctrl.inputMode}}" ng-change="$ctrl.setSingleValue(dimension.id, $ctrl.getSingleValue(dimension.id).value)">
                </salaxy-input>
              </div>
              <div class="col-md-1">
                <div ng-if="!$ctrl.readOnly && $ctrl.isInherited(dimension.id)" class="btn float-end" ng-click="$ctrl.setSingleValue(dimension.id, $ctrl.getInheritedSingleValue(dimension.id).value)">
                  <i class="bi bi-pencil-fill clickable"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ng-if="dimension.allowCostSharing">
          <div class="form-horizontal">
            <div class="row">
              <div class="col-md-11">    
                <table ng-if="$ctrl.isInherited(dimension.id)" class="table">
                  <thead>
                    <tr>
                      <th class="text-muted">{{(dimension.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}</th>
                      <th class="right text-muted">{{"SALAXY.NG1.CalcCostAccountingComponent.percent" | sxyTranslate}}</th>
                      <th class="right">
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr ng-repeat="item in $ctrl.getInheritedValues(dimension.id)">
                      <td>
                        <salaxy-input-typeahead class="text-muted" ng-if="$ctrl.hasOptions(item.id, item.value)" ng-model="item.value" label-format="text-value" get-options="$ctrl.getOptions(dimension.id)" name="{{ 'id' + $index }}" label-type="plain" read-only="true" placeholder="{{ 'SALAXY.UI_Terms.notChosen' | sxyTranslate }}"></salaxy-input-typeahead>
                        <salaxy-input class="text-muted" ng-if="!$ctrl.hasOptions(item.id, item.value)" ng-model="item.value" name="{{ 'id' + $index }}" label-type="plain" read-only="true"></salaxy-input>
                      </td>
                      <td class="right">
                        <salaxy-input-number class="text-muted" ng-model="item.percent" name="{{ 'percent' + $index }}" label-type="plain" read-only="true" unit="percent"></salaxy-input-number>
                      </td>
                      <td class="text-right">
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="total">
                      <td class="text-muted">{{"SALAXY.UI_Terms.total" | sxyTranslate}}</td>
                      <td class="right text-muted">{{ $ctrl.getInheritedSum(dimension.id) | sxyCount : 'percent' }}</td>
                      <td class="right"></td>
                    </tr>
                  </tfoot>
                </table>
                <table ng-if="!$ctrl.isInherited(dimension.id)" class="table">
                  <thead>
                    <tr>
                      <th>{{(dimension.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}</th>
                      <th class="right">{{"SALAXY.NG1.CalcCostAccountingComponent.percent" | sxyTranslate}}</th>
                      <th class="right">
                        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.readOnly" ng-click="$ctrl.current.push({'id': dimension.id})" sxy-text="SALAXY.UI_Terms.addRow"></button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr ng-repeat="item in $ctrl.getValues(dimension.id)">
                      <td>
                        <salaxy-input-typeahead ng-if="$ctrl.hasOptions(item.id, item.value)" ng-model="item.value" label-format="text-value" options="$ctrl.getOptions(dimension.id)" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.readOnly" placeholder="{{ 'SALAXY.UI_Terms.notChosen' | sxyTranslate }}"></salaxy-input-typeahead>
                        <salaxy-input ng-if="!$ctrl.hasOptions(item.id, item.value)" ng-model="item.value" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.readOnly"></salaxy-input>
                      </td>
                      <td class="right">
                        <salaxy-input-number ng-model="item.percent" name="{{ 'percent' + $index }}" label-type="plain" read-only="$ctrl.readOnly" unit="percent"></salaxy-input-number>
                      </td>
                      <td class="text-right">
                        <button ng-if="!$ctrl.readOnly" type="button" class="btn btn-danger" ng-click="$ctrl.deleteValue(item)">
                          <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="total">
                      <td>{{"SALAXY.UI_Terms.total" | sxyTranslate}}</td>
                      <td class="right">{{ $ctrl.getSum(dimension.id) | sxyCount : 'percent' }}</td>
                      <td class="right"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div class="col-md-1">
                <div class="btn btn-padding-right" ng-if="!$ctrl.readOnly && $ctrl.isInherited(dimension.id)">
                  <i ng-click="$ctrl.setValues($ctrl.getInheritedValues(dimension.id))" class="bi bi-pencil-fill clickable"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ng-if="$ctrl.hasObsoleteValues">
        <table class="table">
          <thead>
            <tr>
              <th sxy-text="SALAXY.MODEL.CostAccountingDimensionDefinition.id.title"></th>
              <th sxy-text="SALAXY.MODEL.CostAccountingDimensionOption.value.title"></th>
              <th class="right">{{"SALAXY.NG1.CalcCostAccountingComponent.percent" | sxyTranslate}}</th>
              <th class="right"></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="item in $ctrl.obsoleteValues">
              <td>
                <salaxy-input ng-model="item.id" name="{{ 'nameObsolete' + $index }}" label-type="plain" read-only="true"></salaxy-input>
              </td>
              <td>
                <salaxy-input ng-model="item.value" name="{{ 'idObsolete' + $index }}" label-type="plain" read-only="true"></salaxy-input-enum>
              </td>
              <td>
                <salaxy-input-number ng-if="item.percent" ng-model="item.percent" name="{{ 'percentObsolete' + $index }}" label-type="plain" read-only="true" unit="percent"></salaxy-input-number>
              </td>
              <td class="text-end">
                <button ng-if="!$ctrl.readOnly" type="button" class="btn btn-danger" ng-click="$ctrl.deleteValue(item)">
                    <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
                  </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </fieldset>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/details/expenses.html",`<form ng-submit="$ctrl.recalculate()" name="detailsExpenses">
  <div class="salaxy-calc-dialog-body">
    <div class="salaxy-calc-dialog-container">
      <h1 sxy-text="SALAXY.NG1.CalcDetailsDialogComponent.allExpenses.title"></h1>
      <div class="form-horizontal" ng-if="$ctrl.isHousehold">
        <salaxy-input-boolean type="checkbox" name="isHouseholdDeductible" ng-model="$ctrl.isHouseholdDeductible" label="SALAXY.NG1.CalcDetailsDialogComponent.deductions.householdDetuction" label-true="{{'SALAXY.NG1.CalcDetailsDialogComponent.deductions.label' | sxyTranslate}}"></salaxy-input-boolean>
        <salaxy-input-enum label="SALAXY.NG1.CalcDetailsDialogComponent.workType" hidden-options="none" name="taxDeductionCategory" ng-if="$ctrl.isHouseholdDeductible" ng-model="$ctrl.taxDeductionCategory" enum="TaxDeductionWorkCategories" type="select" required></salaxy-input-enum>
      </div>
      <salaxy-calc-rows-2019-editor categories="['expenses']" row-type-select-help="expenses" parent="$ctrl.currentCalc" mode="{{$ctrl.isReadOnly ? 'read-only' : 'edit'}}" title="{{'SALAXY.NG1.CalcDetailsDialogComponent.expenses.title' | sxyTranslate}}"></salaxy-calc-rows-2019-editor>
      <salaxy-calc-rows-2019-editor categories="['benefits']" row-type-select-help="benefits" parent="$ctrl.currentCalc" mode="{{$ctrl.isReadOnly ? 'read-only' : 'edit'}}" title="{{ 'SALAXY.NG1.CalcDetailsDialogComponent.benefits.title2' | sxyTranslate}}"></salaxy-calc-rows-2019-editor>
      <salaxy-calc-rows-2019-editor categories="[ 'deductions']" row-type-select-help="deductions" parent="$ctrl.currentCalc" mode="{{$ctrl.isReadOnly ? 'read-only' : 'edit'}}" title="{{ 'SALAXY.NG1.CalcDetailsDialogComponent.deductions.title' |
        sxyTranslate}}"></salaxy-calc-rows-2019-editor>
      <p>&nbsp;</p>
    </div>
  </div>
  <button ng-if="!$ctrl.isReadOnly && $ctrl.currentCalc.workflow.status !='paymentStarted'" class="btn btn-danger btn-lg salaxy-calc-btn-recalculate" type="submit" sxy-text="SALAXY.UI_Terms.recalculate"></button>
</form>`);

 $templateCache.put("salaxy-components/calc/details/salary.html",`<form ng-submit="$ctrl.recalculate()" name="detailsSalary">
  <div class="salaxy-calc-dialog-body">
    <div class="salaxy-calc-dialog-container">
      <h1 sxy-text="SALAXY.NG1.CalcDetailsDialogComponent.allSalaries.title"></h1>
      <salaxy-calc-rows-2019-editor row-type-select-help="salaries" categories="['salary', 'salaryCalc', 'holidays', 'salaryAdditions']" parent="$ctrl.currentCalc" mode="{{$ctrl.isReadOnly ? 'read-only' : 'edit'}}" title="{{'SALAXY.NG1.CalcDetailsDialogComponent.salaries.title2' | sxyTranslate}}"></salaxy-calc-rows-2019-editor>
      <p>&nbsp;</p>

    </div>
  </div>

  <button ng-if="!$ctrl.isReadOnly && $ctrl.currentCalc.workflow.status != 'paymentStarted'" class="btn btn-success btn-lg salaxy-calc-btn-recalculate" type="submit" sxy-text="SALAXY.UI_Terms.recalculate"></button>
</form>`);

 $templateCache.put("salaxy-components/calc/details/worker.html",`<form ng-submit="$ctrl.recalculate()" name="detailsWork">
  <div class="salaxy-calc-dialog-body">
    <div class="salaxy-calc-dialog-container">
      <div ng-if="!$ctrl.calcSections.get('worker').isSelectionDone">

        <div sxy-if-role="auth">
          <div class="row">
            <div class="col-12 col-sm-7">
              <div class="intro-text">
                <h1 sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.selectWorker"></h1>
                <p sxy-html="SALAXY.NG1.CalcDetailsWorkerComponent.myWorkers.description.html"></p>
              </div>
            </div>
            <div class="col-12 col-sm-5">
              <button type="button" class="btn add-new-worker btn-primary float-sm-end mb-1" ng-click="$ctrl.showNewWorkerDialog()" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.newWorker.cta"></button>
            </div>
            <div class="col-12">
              <div class="table-responsive">
                <salaxy-employment-list mode="select" on-list-select="$ctrl.updateFromEmployment(item.id, true)"></salaxy-employment-list>
              </div>
            </div>
          </div>
        </div>
        <div salaxy-if-role="anon">
          <h1 sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.selectWorker" ps=" (demo)"></h1>
          <p sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.notLoggedIn"></p>
          <p>Selecting an employment relation is not supported in the anonymous calculator. Implement if necessary.</p>
        </div>
      </div>
      <div ng-if="$ctrl.calcSections.get('worker').isSelectionDone">
        <salaxy-calc-worker-info model="$ctrl.currentCalc"></salaxy-calc-worker-info>
        <div class="row">
          <div class="col-md-6 col-12 form-horizontal">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.job"></legend>
              <salaxy-input-occupation-type name="occupationCode" ng-model="$ctrl.currentCalc.info.occupationCode" label="SALAXY.MODEL.CalcInfo.occupationCode.title" read-only="$ctrl.isReadOnly"></salaxy-input-occupation-type>
              <salaxy-input name="workDescription" ng-model="$ctrl.currentCalc.info.workDescription" label="SALAXY.MODEL.CalcInfo.workDescription.title" read-only="$ctrl.isReadOnly"></salaxy-input>
              <salaxy-input-collective-bargain-agreement read-only="$ctrl.isReadOnly" name="collectiveBargainAgreement" ng-model="$ctrl.currentCalc.info.cbaCode" label="SALAXY.NG1.WorkerWizardComponent.employment.info.cbaCode"></salaxy-input-collective-bargain-agreement>
              <salaxy-textarea sxy-if-role="!worker" name="salarySlipMessage" ng-model="$ctrl.currentCalc.info.salarySlipMessage" label="SALAXY.MODEL.CalcInfo.salarySlipMessage.title" read-only="$ctrl.isReadOnly"></salaxy-textarea>
            </fieldset>
          </div>
          <div class="col-md-6 col-12 form-horizontal">
              <salaxy-calc-cost-accounting salaxy-if-role="company" calc="$ctrl.current" read-only="$ctrl.isReadOnly"></salaxy-calc-cost-accounting>
          </div>
        </div>
        <div class="row" sxy-if-role="worker">
          <div class="col">
            <a href="#/taxcards" class="btn add-new-worker btn-info" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.addSharedTaxCard"></a>
            <a href="#/account" class="btn btn-default" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.editAccount"></a>
          </div>
        </div>
        <div class="row" sxy-if-role="!worker">
          <div class="col">
            <span sxy-if-role="auth">
              <span ng-if="$ctrl.currentCalc.worker.tax.snapshot.kind == 'auto'">
                <span class="text-info" ng-if="$ctrl.currentCalc.worker.tax.snapshot.lastChecked != '2000-01-01T00:00:00Z'"><small>{{'SALAXY.NG1.CalcDetailsWorkerComponent.taxCardChecked' | sxyTranslate}} {{$ctrl.currentCalc.worker.tax.snapshot.lastChecked | date: "dd.MM.yyyy HH:mm"}}</small></span>
                <br/>
                <button type="button" ng-disabled="$ctrl.loaders['showRefreshAutoTaxcardDialog']" ng-click="$ctrl.showRefreshAutoTaxcardDialog()" class="btn btn-info" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.checkAutomaticTaxcard"></button>
              </span>
              <button type="button" ng-click="$ctrl.showWorkerEditDialog()" class="btn add-new-worker btn-default" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.workerEdit"></button>
            </span>
            <button ng-if="!$ctrl.isReadOnly &&  $ctrl.currentCalc.workflow.status != 'paymentStarted'" ng-click="$ctrl.resetWorker()" type="button" class="btn add-new-worker btn-default" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.resetWorker"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button ng-if="!$ctrl.isReadOnly" ng-disabled="!$ctrl.calcSections.get('worker').isSelectionDone" class="btn btn-info btn-lg salaxy-calc-btn-recalculate" type="submit" sxy-text="SALAXY.UI_Terms.recalculate"></button>
</form>`);

 $templateCache.put("salaxy-components/calc/details/worktime-pro.html",`<div class="modal-header bg-primary d-flex">
  <h1 class="d-flex align-items-center m-0">
    <span class="badge bg-secondary text-dark me-2">Pro</span>
    <span sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.proTabTitle"></span>
  </h1>
  <button type="button" class="btn-close btn-close ms-auto" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="form-horizontal form-condensed">
    <p class="lead" sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.lead.text"></p>
    <div class="row">
      <div class="col-sm-6">
        <fieldset>
          <legend sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.basicInfo"></legend>
          <salaxy-date-range read-only="true" ng-model="$ctrl.data.worktime.workDays" name="workDays" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.workDays"></salaxy-date-range>
        </fieldset>
        <fieldset>
          <salaxy-input-number ng-model="$ctrl.data.worktime.absencesDailySalary" name="absencesDailySalary" label="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.absencesDailySalary" label-cols="col-sm-6"></salaxy-input-number>
          <table class="table table-striped table-sm" ng-if="$ctrl.data.logic.getAbcencesForPeriod().length">
            <thead>
              <tr>
                <th sxy-text="SALAXY.NG1.AbsencePeriodsComponent.headerAbsence"></th>
                <th class="right" sxy-text="SALAXY.NG1.AbsencePeriodsComponent.headerDays"></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="row in $ctrl.data.logic.getAbcencesForPeriod()">
                <td>
                  <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
                  <strong>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</strong><br />
                  <div class="float-start" style="padding: 0px;">
                    {{ row.isPaid ? ('SALAXY.NG1.AbsencePeriodsComponent.isPaid' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notPaid' |sxyTranslate) }}
                    <span ng-if="row.isPaid != row.isHolidayAccrual"> {{ row.isHolidayAccrual ? ('SALAXY.NG1.AbsencePeriodsComponent.isAccrual' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notAccrual' | sxyTranslate) }}</span>
                  </div>
                  <div class="truncate" style="max-width: 250px; padding: 0px;">
                    &nbsp;{{ row.notes }}
                  </div>
                </td>
                <td class="right">
                  <strong>{{ row.period.daysCount | sxyCount : "day" }}</strong><br /> {{ row.period | sxyDateRange }}
                </td>
              </tr>
              <tr class="total">
                <td>
                  <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" style="margin-bottom: 20px" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
                  <strong>
                    <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalUnpaid"></span><br />
                                <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalNoHolidayAccrual"></span><br />
                                  <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalAll"></span><br />
                  </strong>
                </td>
                <td class="right">
                  <strong>
                    {{ $ctrl.data.logic.getAbcensePeriodsTotalDays("absencesUnpaid") | sxyCount : "day" }}<br />
                    {{ $ctrl.data.logic.getAbcensePeriodsTotalDays("absencesNoHolidayAccrual") | sxyCount : "day" }}<br />
                    {{ $ctrl.data.logic.getAbcensePeriodsTotalDays("all") | sxyCount : "day" }}<br />
                  </strong>
                </td>
              </tr>
            </tbody>
          </table>
          <p ng-if="!$ctrl.data.logic.getAbcencesForPeriod().length" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.noAbsences"></p>
        </fieldset>
          <fieldset  ng-if="$ctrl.data.worktime.holidaySpec.code == 'permanent14Days' || $ctrl.data.worktime.holidaySpec.code == 'permanent35Hours' || $ctrl.data.worktime.holidaySpec.code == 'temporaryTimeOff' || $ctrl.data.worktime.holidaySpec.code == 'other' || $ctrl.data.worktime.holidaySpec.code == 'script'">
          <table class="table table-striped table-sm" ng-if="$ctrl.data.logic.getAnnualLeavesForPeriod().length">
            <thead>
              <tr>
                <th sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.period"></th>
                <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.daysCount"></th>
                <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.bonusDaysCount"></th>
              </tr>
            </thead>
            <tr ng-repeat="row in $ctrl.data.logic.getAnnualLeavesForPeriod()">
              <td>
                <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
                <strong>{{ row.period | sxyDateRange }}</strong>
                <br />
                <small>
                  <div class="truncate" style="max-width: 250px;">{{ $ctrl.data.logic.getAnnualLeaveDescription(row) }}</div>
                </small>
              </td>
              <td class="right">
                <strong>{{ row.period.daysCount | sxyCount : "day"  }}</strong>
              </td>
              <td class="right">
                <strong>{{ row.bonusDaysCount | sxyCount : "day"  }}</strong>
              </td>
            </tr>
            <tr class="total">
              <td>
                <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
                <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.total"></strong>
                <br />
                <small>
                  <div class="truncate" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.totalMore"></div>
                </small>
              </td>
              <td class="right">
                <strong>{{ $ctrl.data.logic.getAnnualLeavesTotalDays() | sxyCount : "day" }}</strong>
              </td>
              <td class="right">
                <strong>{{ $ctrl.data.logic.getAnnualLeavesBonusTotalDays() | sxyCount : "day" }}</strong>
              </td>
            </tr>
          </table>
          <p ng-if="!$ctrl.data.logic.getAnnualLeavesForPeriod().length" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.noAnnualLeaves"></p>
        </fieldset>      
      </div>
      <div class="col-sm-6">
          <fieldset ng-if="$ctrl.data.worktime.accrualSpec.code == 'permanent14Days' || $ctrl.data.worktime.accrualSpec.code == 'permanent35Hours' || $ctrl.data.worktime.accrualSpec.code == 'temporaryTimeOff' || $ctrl.data.worktime.accrualSpec.code == 'other' || $ctrl.data.worktime.accrualSpec.code == 'script'">
          <legend sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.holidays"></legend>
          <table class="table table-sm">
            <thead>
              <th sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.headerMonth"></th>
              <th sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.headerHolidays" class="right"></th>
              <th sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.headerAway" class="right"></th>
              <th sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.headerDate" class="right"></th>
              <th sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.headerHours" class="right"></th>
            </thead>
            <tbody>
              <tr ng-repeat="month in $ctrl.data.worktime.accruals">
                <td>{{ month.month | sxyDate }}</td>
                <td class="right">{{ month.daysAccrued | sxyCount : "days" }}</td>
                <td class="right">{{ month.absencesDays | sxyCount : "days" }}</td>
                <td class="right">{{ month.workDays | sxyCount : "days" }}</td>
                <td class="right">{{ month.workHours | sxyCount : "hours" }}</td>
              </tr>
            </tbody>
          </table>
        </fieldset>
        <fieldset ng-if="$ctrl.data.worktime.holidaySpec.code != 'undefined'">
          <legend sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.holidayYearSettings"></legend>
          <salaxy-form-group name="employmentPeriod" class="salaxy-read-only" label-cols="col-sm-6" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.employmentPeriod">
            <div class="form-control-plaintext">
              {{$ctrl.data.worktime.holidaySpec.employmentPeriod | sxyDateRange }}
            </div>
          </salaxy-form-group>
          <salaxy-input-enum disabled="true" ng-model="$ctrl.data.worktime.holidaySpec.wageBasis" name="wageBasis" enum="WageBasis" hidden-options="other" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.wageBasis" label-cols="col-sm-6"></salaxy-input-enum>
          <salaxy-input-enum disabled="true" name="holidayPayCalculation" ng-model="$ctrl.data.worktime.holidaySpec.holidayPayCalculation" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayCalculation.title" options="$ctrl.data.logic.getholidayPayCalculationOptions()" disable-cache="true" label-cols="col-sm-6"></salaxy-input-enum>
          <salaxy-input-number ng-model="$ctrl.data.worktime.leavesDailySalary" name="leavesDailySalary" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.leavesDailySalary" label-cols="col-sm-6"></salaxy-input-number>

          <salaxy-input-number ng-model="$ctrl.data.worktime.holidaySpec.compensation" name="compensation" ng-if="$ctrl.data.worktime.holidaySpec.code == 'holidayCompensation'" label-cols="col-sm-6" unit="percent" required label="SALAXY.MODEL.HolidaySpecificationForYear.compensation.label" ></salaxy-input-number>     
            <salaxy-input-number  ng-model="$ctrl.data.worktime.holidaySpec.compensation" name="compensation" ng-if="($ctrl.data.worktime.holidaySpec.code == 'temporaryTimeOff' || $ctrl.data.worktime.holidaySpec.code == 'other' || $ctrl.data.worktime.holidaySpec.code == 'script') && $ctrl.data.worktime.holidaySpec.holidayPayCalculation == 'holidayCompensation'" label-cols="col-sm-6" unit="percent" required label="SALAXY.MODEL.HolidaySpecificationForYear.compensation.title" ></salaxy-input-number>
        
          <!-- accruals or compensation -->
            <salaxy-input-enum ng-if="($ctrl.data.worktime.holidaySpec.code == 'permanent14Days' || $ctrl.data.worktime.holidaySpec.code == 'permanent35Hours' || $ctrl.data.worktime.holidaySpec.code == 'temporaryTimeOff' || $ctrl.data.worktime.holidaySpec.code == 'other' || $ctrl.data.worktime.holidaySpec.code == 'script')" ng-model="$ctrl.data.worktime.holidaySpec.bonusMethod" name="bonusMethod" filter="none,payForHolidaySalary,paySelectedDays" enum="HolidayBonusPaymentMethod" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.bonusMethod" label-cols="col-sm-6"></salaxy-input-enum>
          <salaxy-input-enum ng-if="($ctrl.data.worktime.holidaySpec.code == 'holidayCompensation')" ng-model="$ctrl.data.worktime.holidaySpec.bonusMethod" name="bonusMethod" filter="none,payForHolidaySalary" enum="HolidayBonusPaymentMethod" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.bonusMethod" label-cols="col-sm-6"></salaxy-input-enum>
            <salaxy-input-number ng-if="($ctrl.data.worktime.holidaySpec.code == 'holidayCompensation' || $ctrl.data.worktime.holidaySpec.code == 'permanent14Days' || $ctrl.data.worktime.holidaySpec.code == 'permanent35Hours' || $ctrl.data.worktime.holidaySpec.code == 'temporaryTimeOff' || $ctrl.data.worktime.holidaySpec.code == 'other' || $ctrl.data.worktime.holidaySpec.code == 'script')" ng-model="$ctrl.data.worktime.holidaySpec.bonus" name="bonus" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.bonus" label-cols="col-sm-6" unit="percent"></salaxy-input-number>
        </fieldset>
          <fieldset ng-if="$ctrl.data.worktime.holidaySpec.code == 'permanent14Days' || $ctrl.data.worktime.holidaySpec.code == 'permanent35Hours' || $ctrl.data.worktime.holidaySpec.code == 'temporaryTimeOff' || $ctrl.data.worktime.holidaySpec.code == 'other' || $ctrl.data.worktime.holidaySpec.code == 'script'">
          <legend sxy-text="SALAXY.NG1.CalcWorktimeComponent.availableHolidays.legend"></legend>
          <salaxy-input-number ng-model="$ctrl.data.worktime.holidayPayAccrualRemaining" name="holidayPayAccrualRemaining" disabled="true" label="SALAXY.NG1.CalcWorktimeComponent.availableHolidays.holidayPayAccrualRemaining" label-cols="col-sm-7"></salaxy-input-number>
          <salaxy-input-number ng-if="$ctrl.data.worktime.holidaySpec.bonusMethod != 'none'" ng-model="$ctrl.data.worktime.holidayBonusAccrualRemaining" name="holidayBonusAccrualRemaining" disabled="true" label="SALAXY.NG1.CalcWorktimeComponent.availableHolidays.holidayBonusAccrualRemaining" label-cols="col-sm-7"></salaxy-input-number>
        </fieldset>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer"></div>`);

 $templateCache.put("salaxy-components/calc/PayButton.html",`<div class="salaxy-pay-button salaxy-component" ng-if="!('salaxyPay' | sxyIsInRole)">
  <button ng-if="($ctrl.mode || 'pay-button') != 'channel-select'" ng-disabled="$ctrl.disabled" type="button" ng-click="$ctrl.goToInvoices()" class="btn btn-primary btn-labeled-right btn-pay" ng-class="$ctrl.buttonClass + ($ctrl.mode == 'button-and-channel' ? ' btn-block' : '')">
    {{ $ctrl.getPaymentButtonText() }} <i class="bi bi-currency-euro"></i>
  </button>
  <div>
    <div ng-if="$ctrl.mode == 'button-and-channel'" class="payment-channel-selection-label mt-4" sxy-text="SALAXY.NG1.PayButtonComponent.paymentChannelLabel" ps=":"></div>
    <div ng-if="($ctrl.mode || 'pay-button') != 'pay-button'" class="dropdown" ng-class="$ctrl.buttonClass + ($ctrl.mode == 'button-and-channel' ? ' btn-block' : '')">
      <button id="btnChannel" type="button" class="btn btn-default btn-block dropdown-toggle justify-content-start" data-bs-toggle="dropdown">
        <salaxy-avatar class="py-1" avatar="$ctrl.currentChannel"></salaxy-avatar>
        <span class="button-text">
          {{ $ctrl.currentChannel.displayName }}
        </span>
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="btnChannel">
        <li role="menuitem" ng-class="{ 'disabled': channel.id == 'zeroPayment' }" ng-repeat="channel in $ctrl.allChannels">
          <a href="" ng-click="$ctrl.setPaymentChannel(channel.id)" class="dropdown-item text-uppercase d-flex p-2" title="{{ channel.description }}">
            <salaxy-avatar style="font-size: 1.8em; margin: -2px 6px -2px 0px;" avatar="channel"></salaxy-avatar>
            <span class="button-text">{{ channel.displayName }}</span>
          </a>
        </li>
        <li>
          <a href="#/settings/payment-channel-settings" class="dropdown-item text-uppercase" sxy-text="SALAXY.NG1.PayButtonComponent.moreOptionsLink" ps="..."></a>
        </li>
      </ul>
    </div>
  </div>
</div>
<div ng-if="('salaxyPay' | sxyIsInRole)" ng-controller="NewPaymentController as $newCtrl">
  <button ng-disabled="$newCtrl.disabled" type="button" ng-click="$newCtrl.openSalaxyPay($ctrl.model)" class="btn btn-primary btn-labeled-right btn-pay btn-block">
    {{ $newCtrl.getPaymentButtonText($ctrl.label) }} <i class="bi bi-currency-euro"></i>
  </button>
</div>`);

 $templateCache.put("salaxy-components/calc/payroll/PayrollCalcs.html",`<div class="salaxy-component salaxy-calc-group-edit">
  <div class="payroll-calculations-container">

    <div class="dropdown toolbar-top" ng-if="$ctrl.hasCalculations">
      <ng-include src="'salaxy-components/calc/payroll/PayrollCalcs_toolbar.html'"></ng-include>
    </div>
    

    <div ng-if="!$ctrl.hasCalculations">
      <div class="salaxy-placeholder-empty placeholder-md placeholder-default text-center">
        <h4 sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.placeholder.title"></h4>
        <div ng-if="$ctrl.mode != 'service'" class="btn-group dropdown">
          <button type="button" class="btn btn-labeled-left btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i class="bi bi-plus-lg"></i>
            <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCalculation"></span>
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="addcalculation">
            <li role="menuitem">
              <a ng-click="$ctrl.createNewCalc()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addWorker"></a>
            </li>
            <li role="menuitem">
              <a ng-click="$ctrl.addExistingCalc('draft')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addDraft"></a>
            </li>
            <li role="menuitem">
              <a ng-click="$ctrl.addExistingCalc('paid')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCopy"></a>
            </li>
            <li role="menuitem">
              <a ng-click="$ctrl.mergePayroll(true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addPayroll"></a>
            </li>
          </ul>
        </div>
        <button ng-if="$ctrl.mode == 'service'" type="button" class="btn btn-labeled-right btn-primary" ng-click="$ctrl.createNewCalc()">
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCalculation"></span><i class="bi bi-plus-lg"></i>
        </button>
      </div>
    </div>
    <div ng-repeat="calc in $ctrl.calcs | filter: {worker:{avatar:{displayName:$ctrl.searchByName}}}">
      
      <div class="payroll-single-calculation" ng-class="{'error-container': !$ctrl.getValidation(calc).isValid }">
        <div class="float-end icon-container btn-group">
          <button class="btn btn-transparent btn-xs toggle-details" ng-click="$ctrl.getUi(calc).isCollapsed = !$ctrl.getUi(calc).isCollapsed">
            <i class="bi" ng-class="{'bi-chevron-up' : !$ctrl.getUi(calc).isCollapsed,  'bi-chevron-down' : $ctrl.getUi(calc).isCollapsed}"
               title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.toggle' | sxyTranslate}}">
            </i>
          </button>
          <div class="btn-group btn-group-sm">
            <button class="btn btn-transparent btn-xs options dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" ng-if="!$ctrl.isReadOnly">
              <i class="bi bi-three-dots" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.options' | sxyTranslate}}"></i>
            </button>
            <ul class="dropdown-menu" role="menu" ng-if="!$ctrl.isReadOnly">
              <ng-include src="'salaxy-components/calc/payroll/PayrollCalcs_edit_dropdown.html'"></ng-include>
            </ul>
          </div>
        </div>
        <div class="payroll-worker-summary clickable" ng-if="$ctrl.getUi(calc).isCollapsed" ng-click="$ctrl.getUi(calc).isCollapsed = !$ctrl.getUi(calc).isCollapsed">
          <div class="avatar-container">
            <salaxy-avatar avatar="calc.worker.avatar"></salaxy-avatar>
            <span class="worker-name">{{calc.worker.avatar.displayName}}</span>
            <span class="calculation-summary">{{calc.result.totals.totalGrossSalary | currency }}</span>
            <span ng-if="!$ctrl.getValidation(calc).isValid" class="error-summary text-danger d-none d-sm-inline" sxy-text="{{'SALAXY.VALIDATION.' + $ctrl.getValidation(calc).errors[0].code + '.label'}}"></span>
            <span ng-if="!$ctrl.isReadOnly">
              <span ng-controller="EmploymentCrudController as $employment">
                <salaxy-workflow-badge ng-if="$ctrl.employments[calc.worker.employmentId]" mode="horizontal" model="$ctrl.employments[calc.worker.employmentId]" api-ctrl="$employment" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
              </span>
            </span>
          </div>
        </div>
        <div class="payroll-worker-details" ng-if="!$ctrl.getUi(calc).isCollapsed">
          <div class="row payroll-worker-info">
            <div class="col-2 col-sm-2">
              <div class="avatar-container">
                <salaxy-avatar avatar="calc.worker.avatar"></salaxy-avatar>
              </div>
            </div>
            <div class="col-9">
              <h3 class="worker-name clickable" ng-click="$ctrl.getUi(calc).isCollapsed = !$ctrl.getUi(calc).isCollapsed">{{calc.worker.avatar.displayName}}</h3>
              <div class="row">
                <div class="col-12 col-sm-5 worker-info-col">
                  {{calc.worker.paymentData.email}}<br> {{calc.worker.paymentData.telephone}}
                  <br>
                  <span ng-if="calc.worker.paymentData.ibanNumber">{{calc.worker.paymentData.ibanNumber | sxyIban}}</span>
                  <span ng-if="!calc.worker.paymentData.ibanNumber"><span class="text-danger"
                      sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.noIban"></span></span>
                  <br>
                  <button class="btn btn-secondary btn-xs btn-edit-worker" ng-click="$ctrl.showEditWorkerDialog(calc)" ng-class="{'btn-danger':!calc.worker.paymentData.ibanNumber}" ng-if="!$ctrl.isReadOnly" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.editWorker"></button>
                </div>
                <div class="col-12 col-sm-7 worker-info-col">
                  <span>
                    <span ng-class="{'text-danger': $ctrl.getTaxUi(calc).status != 'ok'}">{{ $ctrl.getTaxUi(calc).text }}</span>
                    <button ng-if="!$ctrl.isReadOnly && $ctrl.getTaxUi(calc).status != 'ok'" class="btn btn-xs btn-default" ng-click="$ctrl.commitCalc(calc, false, true)"><i class="bi bi-arrow-repeat"></i></button>
                    <button ng-if="!$ctrl.isReadOnly && $ctrl.getTaxUi(calc).status == 'missing'" class="btn btn-xs btn-default" ng-click="$ctrl.showAddNewTaxcard(calc)"><i class="bi bi-plus-lg"></i></button>
                  </span>
                  <span ng-if="calc.worker.tax.snapshot.kind == 'auto'">
                    <br />
                    <span class="text-info" ng-if="calc.worker.tax.snapshot.lastChecked != '2000-01-01T00:00:00Z'"><small>{{'SALAXY.NG1.PayrollComponent.payrollCalcs.taxCard.taxCardChecked' | sxyTranslate}} {{calc.worker.tax.snapshot.lastChecked | date: "dd.MM.yyyy HH:mm"}}</small></span>
                  <br/>
                  <button ng-if="!$ctrl.isReadOnly" class="btn btn-xs btn-info" ng-disabled="$ctrl.loaders['showRefreshAutoTaxcardDialog']" ng-click="$ctrl.showRefreshAutoTaxcardDialog(calc)" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.taxCard.refreshAutoTaxCard"></button>
                  </span>
                  <br> <strong sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.salaryPeriod"></strong>
                  <span>{{ calc.info | sxyDateRange }} ({{ calc.framework.numberOfDays }} <span
                      sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.salaryPeriodDaysCount"></span>)</span>
                  <button class="btn btn-transparent btn-xs" ng-click="$ctrl.showDateRangeForCalculation(calc)" ng-if="!$ctrl.isReadOnly"><i class="bi bi-pencil-fill"></i></button>
                  <div ng-if="$ctrl.isDateDifferent(calc)">
                    <del class="small">{{ $ctrl.current.input.period | sxyDateRange }} ({{ $ctrl.current.input.period.daysCount }} <span
                        sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.salaryPeriodDaysCount"></span>)</del>
                  </div>
                  <table ng-if="!('disableHolidays' | sxyIsInRole)" class="text-small">
                    <tbody>
                      <tr>
                        <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.leavesDays"></td>
                        <td class="right">{{ $ctrl.calculatePeriodDays(calc,'leavesDays') | sxyCount : 'day' }}</td>
                      </tr>
                      <tr>
                        <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.absencesDays"></td>
                        <td class="right">{{ $ctrl.calculatePeriodDays(calc,'absencesDays') | sxyCount : 'day' }}</td>
                      </tr>
                      <tr>
                        <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.paidAbsencesDays"></td>
                        <td class="right">{{ $ctrl.calculatePeriodDays(calc,'paidAbsencesDays') | sxyCount : 'day' }}</td>
                      </tr>
                      <tr ng-if="$ctrl.showAccruals(calc)">
                        <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.accruedDays"></td>
                        <td class="right">{{ $ctrl.calculatePeriodDays(calc,'accruedDays') | sxyCount : 'day' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div ng-if="!$ctrl.isReadOnly">
                <span ng-controller="EmploymentCrudController as $employment">
                  <salaxy-workflow-badge ng-if="$ctrl.employments[calc.worker.employmentId]" mode="horizontal" model="$ctrl.employments[calc.worker.employmentId]" api-ctrl="$employment" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
                </span>
              </div>
            </div>
          </div>
          <div ng-if="!$ctrl.getValidation(calc).isValid" class="text-danger d-flex align-items-baseline">
            <ul class="small">
              <li ng-if="!$ctrl.getValidation(calc)" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.validation.noValidationFound"></li>
              <li ng-repeat="error in $ctrl.getValidation(calc).errors">
                <strong>{{ 'ApiValidationErrorType.' + error.type | sxyEnum }}:</strong>
                <span sxy-text="{{'SALAXY.VALIDATION.' + error.code + '.label'}}"></span>
              </li>
            </ul>
            <button ng-if="$ctrl.getValidation(calc)" ng-controller="ValidationSummaryController as $validation" class="btn btn-xs btn-danger ms-auto" ng-click="$validation.apiValidation=$ctrl.getValidation(calc);$validation.showDetails()" sxy-text="SALAXY.UI_Terms.readMore" ps="..."></button>
          </div>
          <div class="row worker-calculations-row">
            <div class="col-12 table-responsive">
              <salaxy-calc-rows-2019-editor parent="calc" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calcRowEditor.title' | sxyTranslate}}" mode="{{$ctrl.isReadOnly ? 'read-only' : 'read-edit'}}" show-edit-buttons="true" on-commit="$ctrl.commitCalc(calc)" on-reset="$ctrl.resetCalc(calc)"
                on-start-edit="$ctrl.getUi(calc).isInEdit = true" is-in-edit="$ctrl.getUi(calc).isInEdit" show-gross-totals="true">
              </salaxy-calc-rows-2019-editor>

            </div>
            <div class="col-12 payroll-calculation-footer">
              <div class="btn-group btn-group-sm dropup" ng-if="!$ctrl.isReadOnly">
                <button type="button" class="btn btn-secondary dropdown-toggle"  data-bs-toggle="dropdown" aria-expanded="false">
                  <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.edit"></span>
                </button>
                <ul class="dropdown-menu">
                  <ng-include src="'salaxy-components/calc/payroll/PayrollCalcs_edit_dropdown.html'"></ng-include>
                </ul>
              </div>
              <div ng-if="$ctrl.mode != 'service'" class="btn-group btn-group-sm float-start float-sm-end dropup">
                <button id="reports" type="button" class="btn btn-transparent dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.viewReports"></span>
                </button>
                <ul class="dropdown-menu dropdown-menu-end"  role="menu" aria-labelledby="reports">
                  <li role="menuitem">
                    <a href="" ng-click="$ctrl.showReport('employerReport', calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.employerReport"></a>
                  </li>
                  <li role="menuitem">
                    <a href="" ng-click="$ctrl.showReport('paymentReport', calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.paymentReport"></a>
                  </li>
                  <li role="menuitem">
                    <a href="" ng-click="$ctrl.showReport('salarySlip', calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.salarySlip"></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ng-if="$ctrl.hasCalculations">
      <div class="payroll-totals col-padding">
        <div class="totals-container">
          <span class="total-label"><span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.payrollTotals.finalCost"></span><br>
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.payrollTotals.grossSalary"></span><br>
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.payrollTotals.totalPayment"></span>
          </span>
          <span class="amount">
            {{ $ctrl.calcsResult.employerCalc.finalCost | currency }}<br>
            {{ $ctrl.info.totalGrossSalary | currency}}<br>
            {{ $ctrl.info.totalPayment | currency}}
          </span>
        </div>
      </div>
    </div>
    <div class="dropup toolbar-bottom" ng-if="$ctrl.hasCalculations">
      <ng-include src="'salaxy-components/calc/payroll/PayrollCalcs_toolbar.html'"></ng-include>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/payroll/PayrollCalcs_edit_dropdown.html",`<li class="dropdown-header" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.editCalculation"></li>
<li role="menuitem" ng-class="{ 'disabled': $ctrl.getUi(calc).isInEdit }">
  <a href="" ng-click="$ctrl.setRowsEditable(calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.editRows"></a>
</li>
<li ng-if="$ctrl.mode != 'service'" role="menuitem">
  <a href="" ng-click="$ctrl.showEditCalcDialog(calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.openCalculator"></a>
</li>
<li ng-if="$ctrl.mode != 'service'" role="menuitem">
  <a href="" ng-click="$ctrl.showEditCalcDialog(calc, 'ir')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.openIrRows"></a>
</li>
<li role="menuitem">
  <a href="" ng-click="$ctrl.commitCalc(calc, false, true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.save"></a>
</li>
<li role="menuitem" ng-class="{ 'disabled': !$ctrl.hasCalcChanges(calc) && !$ctrl.getUi(calc).isInEdit }">
  <a href="" ng-click="$ctrl.resetCalc(calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.cancel"></a>
</li>
<li role="separator" class="divider"></li>
<li class="dropdown-header" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.rowsEmployment"></li>
<li role="menuitem">
  <a href="" ng-click="$ctrl.importEmploymentData(calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.import"></a>
</li>
<li role="separator" class="divider"></li>
<li role="menuitem">
  <a href="" ng-click="$ctrl.deleteCalc(calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.delete"></a>
</li>
<li role="menuitem" ng-if="$ctrl.mode != 'service'">
  <a href="" ng-click="$ctrl.deleteCalc(calc, true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.unlink"></a>
</li>`);

 $templateCache.put("salaxy-components/calc/payroll/PayrollCalcs_toolbar.html",`<div class="btn-toolbar" role="toolbar" aria-label="Payroll actions">
  

  <div class="btn-group dropdown" ng-if="!$ctrl.isReadOnly && $ctrl.mode != 'service'">
    <button type="button" class="btn btn-sm btn-labeled-left btn-primary dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="bi bi-plus-lg h-100"></i>
      <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCalculation"></span>
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="addcalculation">
      <li role="menuitem">
        <a ng-click="$ctrl.createNewCalc()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addWorker"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addExistingCalc('draft')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addDraft"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addExistingCalc('paid')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCopy"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.mergePayroll(true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addPayroll"></a>
      </li>
    </ul>
  </div>
  <input type="text" class="form-control input-sm payroll-search-input mx-1"  id="searchText" name="searchText" placeholder="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.searchByName' | sxyTranslate}}" ng-model="$ctrl.searchByName" />
 
  <button ng-if="!$ctrl.isReadOnly && $ctrl.mode == 'service'" type="button" class="btn btn-sm btn-labeled-right btn-primary" ng-click="$ctrl.createNewCalc()">
    <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCalculation"></span>
    <i class="bi bi-plus-lg"></i>
  </button>
  <div class="btn-group btn-group-sm toggle-all-buttons ms-auto">
    <button ng-if="!$ctrl.isReadOnly && !('disableHolidays' | sxyIsInRole)" class="btn btn-secondary toggle-all text-end" ng-click="$ctrl.recalculateWorktimes()">
      <span class="d-none d-sm-inline" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.saveWorktime"></span>
      <i class="bi bi-arrow-repeat" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.saveWorktime' | sxyTranslate}}"></i>
    </button>
    <button class="btn btn-secondary  toggle-all text-end" ng-click="$ctrl.setUiForAll('isCollapsed', false)">
      <span class="d-none d-sm-inline" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.open"></span>
      <i class="bi bi-chevron-down" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.open' | sxyTranslate}}"></i>
    </button>
    <button class="btn btn-secondary  toggle-all text-end" ng-if="!$ctrl.isReadOnly" ng-click="$ctrl.setRowsEditable('all')">
      <span class="d-none d-sm-inline" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.edit"></span>
      <i class="bi bi-pencil-fill" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.edit' | sxyTranslate}}"></i>
    </button>
    <button class="btn btn-secondary toggle-all text-end" ng-click="$ctrl.commitAllCalcs()" ng-if="$ctrl.changedCalcCount && !$ctrl.isReadOnly">
      <span class="d-none d-sm-inline" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.save"></span> ({{ $ctrl.changedCalcCountCache }}) 
      <i class="bi bi-floppy text-success" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.save' | sxyTranslate}}"></i>
    </button>
    <button class="btn btn-secondary toggle-all text-end" ng-click="$ctrl.resetAllCalcs()" ng-if="$ctrl.changedCalcCountCache && !$ctrl.isReadOnly">
      <span class="d-none d-sm-inline" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.cancel"></span> ({{ $ctrl.changedCalcCountCache }}) <i
        class="bi bi-x-lg text-danger" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.cancel' | sxyTranslate}}"></i>
    </button>
    <button class="btn btn-secondary  toggle-all text-end" ng-click="$ctrl.setUiForAll('isCollapsed', true);$ctrl.setUiForAll('isInEdit', false)" ng-if="!$ctrl.changedCalcCountCache">
      <span class="d-none d-sm-inline" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.close"></span>
      <i class="bi bi-chevron-up" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.close' | sxyTranslate}}"></i>
    </button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/payroll/PayrollEdit.html",`<div class="salaxy-component salaxy-payroll" ng-controller="NaviController as $naviCtrl">
  <salaxy-spinner ng-if="$ctrl.isLoading"></salaxy-spinner>
  <div sxy-if-role="auth">
    <div class="dropdown">
      <ng-include ng-if="$ctrl.isNew()" src="'salaxy-components/calc/payroll/PayrollNew.html'"></ng-include>
    </div>
    <div ng-if="!$ctrl.isNew() && $ctrl.current">
      <ng-include src="'salaxy-components/calc/payroll/PayrollEdit_toolbar.html'"></ng-include>
      <div class="row payroll-info-row">
        <div class="col-3 col-sm-2">
          <salaxy-avatar-placeholder class="payroll-avatar">
            <i class="salaxy-avatar bi bi-square-fill text-muted d-flex" ng-class="{'draft-invalid' : $ctrl.current.info.status == 'draft' && !$ctrl.current.info.isReadyForPayment, 'text-success' : $ctrl.current.info.status == 'paymentSucceeded', 'text-warning' : ($ctrl.current.info.status == 'paymentStarted' || $ctrl.current.info.status == 'waitingApproval') , 'text-danger' : $ctrl.current.info.status == 'paymentCancelled'}">
              <div class="avatar-text-wrapper">
                <strong>{{ $ctrl.calcs.length }}</strong>
                <small>{{ $ctrl.current.info.salaryDate | date : "d.M." }}</small>
              </div>
            </i>
          </salaxy-avatar-placeholder>
        </div>
        <div class="col-9 col-sm-10 payroll-info-col">
          <h3 class="payroll-title">{{ $ctrl.current.input.title }}</h3>
          <div class="row">
            <div class="col-12 col-sm-6">
              <div>
                <span>{{ 'PayrollStatus.' + $ctrl.current.info.status | sxyEnum }}</span>
                <span ng-if="$ctrl.current.info.status == 'draft'" ng-class="$ctrl.current.info.isReadyForPayment ? 'text-success' : 'text-danger'">
                  {{ $ctrl.current.info.isReadyForPayment ? (('SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.readyForPayment' | sxyTranslate)) :
                  (('SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.notReadyForPayment' | sxyTranslate)) }}
                </span>
              </div>
              <div>
                <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryPeriod" ps=":"></span> {{ $ctrl.current.input.period | sxyDateRange }} ({{$ctrl.current.input.period.daysCount}} <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryPeriodDaysCount"></span>)
              </div>
              <div>
                <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDate" ps=":"></span> {{ $ctrl.current.info.salaryDate | date }}
                <span class="badge bg-info" ng-if="$ctrl.current.info.status != 'paymentSucceeded' && !$ctrl.current.input.salaryDate && $ctrl.current.info.salaryDate">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateEstimate' | sxyTranslate}}</span>
                <span ng-if="$ctrl.current.info.status != 'paymentSucceeded' &&  $ctrl.current.info.salaryDate && $ctrl.current.input.salaryDate && $ctrl.current.input.salaryDate != $ctrl.current.info.salaryDate"><s>{{ $ctrl.current.input.salaryDate | date }}</s> <span class="badge bg-warning">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateNote' | sxyTranslate}}</span></span>
              </div>
              <div>
                <span ng-if="$ctrl.current.input.template" sxy-html="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.template.html" params="{template: ($ctrl.current.input.template)}"></span>
              </div>
              <div>
                <small>ID: <code>{{ $ctrl.currentId }}</code></small>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.calcCount" ps=":"></span> {{$ctrl.calcs.length}} </span><br />
              <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.finalCost" ps=":"></span> {{ $ctrl.calcsResult.employerCalc.finalCost | currency }}
              </span><br />
              <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.grossSalary" ps=":"></span> {{ $ctrl.info.totalGrossSalary | currency}}</span><br>
              <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.totalPayment" ps=":"></span> {{ $ctrl.info.totalPayment | currency}}</span>
            </div>
          </div>
        </div>
      </div>
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'properties', text: 'SALAXY.NG1.PayrollComponent.payrollEdit.tabs.editProperties' },
          { value: 'calculations', text: 'SALAXY.NG1.PayrollComponent.payrollEdit.tabs.calculations' },
          { value: 'reports', text: 'SALAXY.NG1.PayrollComponent.payrollEdit.tabs.reports', disabled: !$ctrl.hasCalculations },
          { value: 'additionalinformation', text: 'SALAXY.NG1.PayrollComponent.payrollCalcs.additionalInformation', disabled: !$ctrl.hasCalculations },
          { value: 'msg', text: 'Viestit / hyväksyntä', hidden: !('partnerMessaging' | sxyIsInRole) }
        ]"
        tabs-id="payrollEdit">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-payrollEdit">
        <div class="tab-pane" id="properties-tab">
          <div ng-if="$ctrl.currentTab == 'properties'" class="row payroll-edit-properties-container">
            <form class="form-horizontal" ng-disabled="$ctrl.isDisabled" ng-readonly="$ctrl.isReadOnly">
              <div class="col-12 payroll-edit-properties-col">
                <salaxy-input name="title" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.title" ng-model="$ctrl.current.input.title"></salaxy-input>
                <div class="form-group" ng-if="$ctrl.current.info.status == 'paymentSucceeded'">
                  <label for="status" class="col-sm-4 text-start" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.status"></label>
                  <div class="col-sm-8">{{ 'PayrollStatus.' + $ctrl.current.info.status | sxyEnum | sxyTranslate }}</div>
                </div>
                 <div  ng-if="(!$ctrl.isReadOnly || $ctrl.showAction('pay')) && ('test,setSalaryDateKind' | sxyIsInRole)"  ng-switch="$ctrl.current.input.paymentChannel">
                  <div ng-switch-when="palkkausManual|talenomManual|palkkausInvoices|palkkausCfaTest|kitsas|briox|askelma|passeliMerit|ecom|hausvise" ng-switch-when-separator="|">
                    <salaxy-form-group name="salaryDateKind" label="SALAXY.MODEL.PayrollInput.salaryDateKind.title">       
                      <salaxy-salary-date-kind-button button-class="btn-block" model="$ctrl.current" on-salary-date-kind-change="$ctrl.save()"></salaxy-salary-date-kind-button>
                    </salaxy-form-group>
                  </div>
                </div>
                <salaxy-form-group ng-if="($ctrl.isReadOnly && !$ctrl.showAction('pay')) && $ctrl.current.input.salaryDateKind == 'inPast'" name="salaryDateKind" class="salaxy-component salaxy-read-only" label="SALAXY.MODEL.CalcWorkflow.salaryDateKind.title">
                  <div class="form-control-plaintext">{{"SALAXY.ENUM.SalaryDateKind." + ($ctrl.current.input.salaryDateKind) + ".label" | sxyTranslate  }}</div>
                </salaxy-form-group>
                <salaxy-datepicker-popup read-only="false" ng-if="!$ctrl.isReadOnly || $ctrl.showAction('pay')" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryDate" name="salaryDate" ng-model="$ctrl.current.input.salaryDate" date-disabled="disable-function" disable-function="$ctrl.isDisabledSalaryDate" update-disabled-dates="($ctrl.current.input.salaryDateKind || '-') + '|' + ($ctrl.current.input.paymentChannel || '-')"></salaxy-datepicker-popup>       
                <div class="row py-2" ng-if="$ctrl.isReadOnly && !$ctrl.showAction('pay')">
                  <div class="col-sm-4"><strong sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryDate" ps=":"></strong> </div>
                  <div class="col-sm-8">
                    {{ $ctrl.current.info.salaryDate | date }}
                    <span class="badge bg-info" ng-if="$ctrl.current.info.status != 'paymentSucceeded' && !$ctrl.current.input.salaryDate && $ctrl.current.info.salaryDate">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateEstimate' | sxyTranslate}}</span>
                    <span ng-if="$ctrl.current.info.status != 'paymentSucceeded' &&  $ctrl.current.info.salaryDate && $ctrl.current.input.salaryDate && $ctrl.current.input.salaryDate != $ctrl.current.info.salaryDate"><s>{{ $ctrl.current.input.salaryDate | date }}</s> <span class="badge bg-warning">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateNote' | sxyTranslate}}</span></span>    
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-4"><strong sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryPeriod" ps=":"></strong> </div>
                  <div class="col-sm-8">
                    {{ $ctrl.current.input.period | sxyDateRange }} ({{$ctrl.current.input.period.daysCount}} <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryPeriodDaysCount"></span>)
                    <button class="btn btn-transparent btn-xs" ng-click="$ctrl.showDateRange()" ng-if="!$ctrl.isReadOnly || $ctrl.showAction('pay')"><i class="bi bi-pencil-fill "></i></button>
                  </div>
                </div>
                <salaxy-form-group name="paymentChannel" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.paymentChannel">
                  <salaxy-pay-button ng-if="!$ctrl.isReadOnly || $ctrl.showAction('pay')" model="$ctrl.current" mode="channel-select" ng-ref="$ctrl.$payButton" disabled="!$ctrl.$payButton.isChannelDefined" on-payment-channel-change="$ctrl.save()" button-class="btn-block"></salaxy-pay-button>
                  <div ng-if="$ctrl.isReadOnly && !$ctrl.showAction('pay')">{{ "PaymentChannel." + $ctrl.current.input.paymentChannel | sxyEnum }}</div>
                </salaxy-form-group>
              </div>
            </form>
          </div>
        </div>
        <div class="tab-pane" id="calculations-tab">
          <ng-include ng-if="$ctrl.currentTab == 'calculations'" src="'salaxy-components/calc/payroll/PayrollCalcs.html'"></ng-include>
        </div>
        <div class="tab-pane" id="reports-tab">
          <salaxy-calc-reports calcs="$ctrl.calcs" ng-if="$ctrl.currentTab == 'reports' && $ctrl.hasCalculations" report-type="'salarySlip'"></salaxy-calc-reports>
        </div>
        <div class="tab-pane" id="additionalinformation-tab">
          <div class="dropdown toolbar-top" ng-if="$ctrl.currentTab == 'additionalinformation' && $ctrl.hasCalculations">
            <ng-include src="'salaxy-components/calc/payroll/PayrollCalcs_toolbar.html'"></ng-include>
            <div ng-repeat="calc in $ctrl.calcs">
              <div class="payroll-single-calculation " ng-class="{'error-container': !$ctrl.getValidation(calc).isValid }">
                <div class="float-end icon-container btn-group">
                  <button class="btn btn-transparent btn-xs toggle-details" ng-click="$ctrl.getUi(calc).isCollapsed = !$ctrl.getUi(calc).isCollapsed"><i class="bi"
                      ng-class="{'bi-chevron-up' : !$ctrl.getUi(calc).isCollapsed,  'bi-chevron-down' : $ctrl.getUi(calc).isCollapsed}"
                      title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.toggle' | sxyTranslate}}"></i></button>
                </div>
                <div class="payroll-worker-summary px-2-g clickable" ng-if="$ctrl.getUi(calc).isCollapsed" ng-click="$ctrl.getUi(calc).isCollapsed = !$ctrl.getUi(calc).isCollapsed">
                  <div class="avatar-container">
                    <salaxy-avatar avatar="calc.worker.avatar"></salaxy-avatar>
                    <span class="worker-name">{{calc.worker.avatar.displayName}}</span>
                    <span class="calculation-summary">{{calc.result.totals.total | currency }}</span>
                  </div>
                </div>
                <div class="payroll-worker-details" ng-if="!$ctrl.getUi(calc).isCollapsed">
                  <div class="row payroll-worker-info">
                    <div class="col-2 col-sm-2">
                      <div class="avatar-container">
                        <salaxy-avatar avatar="calc.worker.avatar"></salaxy-avatar>
                      </div>
                    </div>
                    <div class="col-10">
                      <h3 class="worker-name clickable" ng-click="$ctrl.getUi(calc).isCollapsed = !$ctrl.getUi(calc).isCollapsed">{{calc.worker.avatar.displayName}}</h3>
                      <div class="row">
                        <div class="col-12 col-sm-5 worker-info-col">
                          {{calc.worker.paymentData.email}}<br> {{calc.worker.paymentData.telephone}}
                        </div>
                        <div class="col-12 col-sm-7 worker-info-col">
                          <!-- additional info -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row worker-calculations-row">
                    <div class="col-sm-6">
                      <salaxy-calc-cost-accounting salaxy-if-role="company" calc="calc" read-only="$ctrl.isReadOnly"></salaxy-calc-cost-accounting>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane" id="msg-tab" ng-if="'partnerMessaging' | sxyIsInRole">
          <div ng-if="!$ctrl.current.info.messageThreadId" ng-controller="MessageThreadCrudController as $msg" ng-init="$msg.model='new'" class="form-horizontal" style="max-width: 600px;">
            <fieldset sxy-if-role="!pro">
              <p ng-if="!$ctrl.current.info.messageThreadId">Tähän palkkalistaan ei liity viestiketjua / työnkulkua.</p>
              <!--
              <legend>Lähetä tilitoimistolle</legend>
              <p>Luo tästä uusi viestiketju, jolla voit lähettää palkkalistan tilitoimiston käsittelyyn.</p>
              <salaxy-input-enum name="action" label="Pyydetään toimintaa" type="radio" ng-model="$msg.current.input.todoAction" options="$ctrl.messageActions"
                ng-change="$msg.current.title = $ctrl.getTitle($msg.current.input.todoAction)"></salaxy-input-enum>
              <salaxy-input name="title" label="SALAXY.NG1.MessageThreadComponent.title" require="true" disabled="!$msg.current.input.todoAction" ng-model="$msg.current.title"></salaxy-input>
              <salaxy-form-group name="msgSubmit" label-type="empty-label">
                <button type="button" class="btn btn-primary" ng-click="$ctrl.sendPayroll($msg)">Lähetä</button>
              </salaxy-form-group>
              -->
            </fieldset>
            <fieldset sxy-if-role="pro">
              <legend>Lähetä yritykselle</legend>
              <p>Luo tästä uusi viestiketju, jolla voit lähettää palkkalistan yritykselle hyväksyttäväksi / maksettavaksi.</p>
              <salaxy-input-enum name="action" label="Pyydetään toimintaa" type="radio" ng-model="$msg.current.input.todoAction" options="$ctrl.messageActions" ng-change="$msg.current.title = $ctrl.getTitle($msg.current.input.todoAction)"></salaxy-input-enum>
              <salaxy-input name="title" label="SALAXY.NG1.MessageThreadComponent.title" require="true" disabled="!$msg.current.input.todoAction" ng-model="$msg.current.title"></salaxy-input>
              <salaxy-form-group name="msgSubmit" label-type="empty-label">
                <button type="button" class="btn btn-primary" ng-click="$ctrl.sendPayroll($msg)">Lähetä</button>
              </salaxy-form-group>
            </fieldset>
          </div>
          <div ng-if="$ctrl.current.info.messageThreadId">
            <button type="button" class="btn btn-danger float-end" ng-click="$ctrl.deleteMessage($ctrl.$msg)"><i class="bi bi-trash-fill" aria-hidden="true"></i></button>
            <salaxy-message-thread model="$ctrl.current.info.messageThreadId" ng-ref="$ctrl.$msg" role="{{('pro' | sxyIsInRole) ? 'otherParty' : 'owner' }}" other-party="'partner'" mark-as-read="5"></salaxy-message-thread>
          </div>
        </div>
      </div>
      <div class="dropup">
        <ng-include src="'salaxy-components/calc/payroll/PayrollEdit_toolbar.html'"></ng-include>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/payroll/PayrollEdit_toolbar.html",`<div>
  <div ng-if="$ctrl.isReadOnly" class="btn-toolbar w-100">
    <button ng-if="$ctrl.showAction('pay')" type="button" class="btn" ng-class="{ 'btn-primary': $ctrl.hasChanges, 'btn-default': !$ctrl.hasChanges }" ng-disabled="!$ctrl.hasChanges" ng-click="$ctrl.save()">
      {{ $ctrl.hasChanges ? ('SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.save' | sxyTranslate) : ('SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.saved' | sxyTranslate) }}
    </button>
    <button class="btn btn-secondary" ng-if="$ctrl.showAction('copy')" ng-click="$ctrl.showCopyAsNew($ctrl.current)" ng-style="{ visibility: $ctrl.isDisabled ? 'hidden' : 'visible' }" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.copyAsNew"></button>
    <div class="ms-sm-auto" >
      <salaxy-pay-button ng-if="$ctrl.showAction('pay')"
        model="$ctrl.current" mode="pay-button" label="SALAXY.NG1.PayrollComponent.payrollPayButton" ng-ref="$payButton" disabled="!$ctrl.current.info.isReadyForPayment || !$ctrl.calcs.length || !$payButton.isChannelDefined"
        on-payment-channel-change="$ctrl.save()"></salaxy-pay-button>
        <button ng-if="$ctrl.showAction('cancel') && ($ctrl.current.info.status == 'paymentStarted' && ($ctrl.current.input.paymentChannel == 'palkkausManual' || $ctrl.current.input.paymentChannel == 'talenomManual' || $ctrl.current.input.paymentChannel == 'palkkausInvoices' || $ctrl.current.input.paymentChannel == 'kitsas' || $ctrl.current.input.paymentChannel == 'palkkausPersonal' || $ctrl.current.input.paymentChannel == 'palkkausCfaPaytrail' || $ctrl.current.input.paymentChannel == 'palkkausEcfaPaytrail' || $ctrl.current.input.paymentChannel == 'palkkausCfaReference'|| $ctrl.current.input.paymentChannel == 'palkkausEcfaReference' || $ctrl.current.input.paymentChannel == 'palkkausCfaFinvoice' || $ctrl.current.input.paymentChannel == 'palkkausEcfaFinvoice' ||  $ctrl.current.input.paymentChannel == 'palkkausCfaTest'))" class="btn btn-secondary  btn-labeled-right" ng-click="$ctrl.cancel()"><span sxy-text="SALAXY.NG1.CalcResultsComponent.cancelPaymentOrChangeChannelBtn"></span><i class="bi bi-x-circle"></i></button>
        <button ng-if="$ctrl.current.info.status != 'waitingApproval' && $ctrl.current.info.status != 'draft'" class="btn btn-secondary  btn-labeled-right" ng-click="$ctrl.showPaymentDialog()"><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.showPaymentInfo"></span><i class="bi bi-info-circle"></i></button>
    </div>
    <button type="button" ng-if="('partnerMessaging' | sxyIsInRole) && (!('pro' | sxyIsInRole) && $ctrl.current.info.messageThreadId )"  class="btn btn-default float-end" ng-click="$ctrl.activeTab = 'msg'">Kommentoi</button>
  </div>
  <div ng-if="!$ctrl.isReadOnly" class="btn-toolbar calc-toolbar w-100">
    <button type="button" class="btn" ng-class="{ 'btn-primary': $ctrl.hasChanges, 'btn-default': !$ctrl.hasChanges }" ng-disabled="!$ctrl.hasChanges" ng-click="$ctrl.save()">
      {{ $ctrl.hasChanges ? ('SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.save' | sxyTranslate) : ('SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.saved' | sxyTranslate) }}
    </button>
    <div class="btn-group dropdown"  ng-disabled="$ctrl.isDisabled">
      <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.options"></span>
      </button>
      <ul class="dropdown-menu"  role="menu" aria-labelledby="actions">
        <li role="menuitem">
          <a ng-click="$ctrl.importEmploymentDataAll()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.importEmploymentCalc"></a>
        </li>
        <li role="menuitem">
          <a ng-click="$ctrl.showCopyAsNew($ctrl.current)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.copyAsNew"></a>
        </li>
        <li ng-class="{ disabled: !$ctrl.hasChanges }" role="menuitem">
          <a ng-click="$ctrl.reset()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.cancel"></a>
        </li>
        <li role="menuitem">
          <a class="text-danger dropdown-item" ng-click="$ctrl.delete()" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.delete"></a>
        </li>
        <li role="menuitem" ng-if="( $ctrl.current.owner == 'FI90PRYL0001975846') && ('pro, test' | sxyIsInRole)">
          <a ng-href="#/payroll/import/{{$ctrl.current.id}}" class="dropdown-item">Import (BETA)</a>
        </li>
      </ul>
    </div>
    <div sxy-if-role="pro" class="btn-group">
      <div class="btn-group dropdown ms-1">
        <!-- HACK: Rewrite workflow buttons as components. Or make PRO calculator a component. -->
        <button class="btn btn-default dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" style="font-weight: bold;">
          {{ "PayrollStatus." + $ctrl.current.info.status | sxyEnum }}
        </button>
        <ul class="dropdown-menu" >
          <li ng-class="{ disabled: $ctrl.current.info.status=='draft' }">
            <a href="" ng-click="$ctrl.current.info.status = 'draft';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.draft" | sxyEnum }}</a>
          </li>
          <li ng-class="{ disabled: $ctrl.current.info.status=='template' }">
            <a href="" ng-click="$ctrl.current.info.status = 'template';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.template" | sxyEnum }}</a>
          </li>
          <li ng-class="{ disabled: $ctrl.current.info.status=='handled' }">
            <a href="" ng-click="$ctrl.current.info.status = 'handled';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.handled" | sxyEnum }}</a>
          </li>
          <li ng-class="{ disabled: $ctrl.current.info.status=='waitingApproval' }">
            <a href="" ng-click="$ctrl.current.info.status = 'waitingApproval';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.waitingApproval" | sxyEnum }}</a>
          </li>
        </ul>
      </div>
      <salaxy-workflow-buttons api-ctrl="$ctrl"></salaxy-workflow-buttons>
    </div>
    <div class="btn-group ms-sm-auto">
      <salaxy-pay-button ng-if="$ctrl.current.info.status != 'template'" model="$ctrl.current" mode="pay-button"  label="SALAXY.NG1.PayrollComponent.payrollPayButton" ng-ref="$payButton" disabled="!$ctrl.current.info.isReadyForPayment || !$ctrl.calcs.length || !$payButton.isChannelDefined"
        on-payment-channel-change="$ctrl.save()"></salaxy-pay-button>
    </div>
  </div>
</div>
<div>
  <div ng-if="'company' | sxyIsInRole" ng-controller="CompanyAccountController as $company" style="padding: 8px">
    <salaxy-workflow-badge ng-if="$company.current" model="$company.current" mode="horizontal" api-ctrl="$company" wf-types="'EmployerMessageRecord'" ></salaxy-workflow-badge>
  </div>
</div>
<div class="row" ng-if="$ctrl.showWorkflowMessage" style="margin-top: 4px;margin-bottom: -50px">
  <div class="offset-sm-6 col-sm-6">
    <salaxy-textarea name="workflowMessage" ng-model="$ctrl.workflowMessage" placeholder="{{'SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.workFlowMessage'}}" rows="2" label-type="plain"></salaxy-textarea>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/payroll/PayrollList.html",`<div class="salaxy-component salaxy-payroll-list">
  <div class="row w-100" ng-if="!$ctrl.hideButton">
    <div class="col-12 action-button-container mb-3">
      <salaxy-action-button action="'newPayroll'" button-class="btn-primary" style="margin-bottom:30px;"></salaxy-action-button>
    </div>
  </div>
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'default', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.latest' },
      { value: 'templates', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.repeated' },
      { value: 'paid', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.paid' },
      { value: 'paidcalcs', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.paidSalaries' },
      { value: 'draftcalcs', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.draftCalcs' }
    ]"
    tabs-id="payrollList">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-payrollList">
    <div class="tab-pane" id="default-tab">
      <salaxy-odata-table crud-controller="PayrollCrudController as $crud" options="{ $filter: 'status ne \\'paymentSucceeded\\' and status ne \\'paymentStarted\\' and status ne \\'template\\' and status ne \\'handled\\' and status ne \\'paymentCanceled\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="templates-tab">
      <salaxy-odata-table crud-controller="PayrollCrudController as $crud" options="{ $filter: 'status eq \\'template\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="paid-tab">
      <salaxy-odata-table crud-controller="PayrollCrudController as $crud" options="{ $filter: 'status eq \\'paymentSucceeded\\' or status eq \\'paymentStarted\\' or status eq \\'handled\\' or status eq \\'paymentCanceled\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="paidcalcs-tab">
      <salaxy-odata-table url="/v03/api/calculations/category/readonly" crud-controller="CalculationCrudController as $crud" options="{ $filter: 'status eq \\'paymentSucceeded\\' and data/payrollId ne null' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="draftcalcs-tab">
      <salaxy-odata-table crud-controller="CalculationCrudController as $crud" options="{ $filter: 'status eq \\'payrollDraft\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/payroll/PayrollNew.html",`<div>
  <div class="h2" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.heading"></div>
  <div class="form-horizontal" ng-controller="NaviController as $naviCtrl">
    <form name="newPayrollForm">
      <salaxy-input name="title" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.title" require="true" ng-model="$ctrl.current.input.title"></salaxy-input>
      <div  ng-if="('test,setSalaryDateKind' | sxyIsInRole)" ng-switch="$ctrl.current.input.paymentChannel">
        <div ng-switch-when="palkkausManual|talenomManual|palkkausInvoices|palkkausCfaTest|kitsas|briox|askelma|passeliMerit|ecom|hausvise" ng-switch-when-separator="|">
          <salaxy-form-group name="salaryDateKind" label="SALAXY.MODEL.PayrollInput.salaryDateKind.title">       
            <salaxy-salary-date-kind-button button-class="btn-block" model="$ctrl.current" disabled="$ctrl.isReadOnly"></salaxy-salary-date-kind-button>
          </salaxy-form-group>
        </div>
      </div>
      <salaxy-datepicker-popup label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryDate" name="salaryDate" ng-model="$ctrl.current.input.salaryDate" update-disabled-dates="($ctrl.current.input.salaryDateKind || '-') + '|' + ($ctrl.current.input.paymentChannel || '-')" date-disabled="disable-function" disable-function="$ctrl.isDisabledSalaryDate"></salaxy-datepicker-popup>
      <salaxy-date-range label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryPeriod" name="period" ng-model="$ctrl.current.input.period" mode="calc"></salaxy-date-range>
      <salaxy-form-group name="paymentChannel" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.paymentChannel">
        <salaxy-pay-button model="$ctrl.current" mode="channel-select" ng-ref="$ctrl.$payButton" disabled="!$ctrl.$payButton.isChannelDefined" button-class="btn-block"></salaxy-pay-button>
      </salaxy-form-group>
      <div ng-if="$ctrl.current.calcs.length">
        <salaxy-form-group label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.copyingCalcs" name="calcCount">
          {{ $ctrl.current.calcs.length }} kpl
        </salaxy-form-group>
        <salaxy-input-boolean type="select" placeholder="SALAXY.UI_Terms.choose" name="noUpdateFromEmployment" ng-model="$ctrl.current.input.noUpdateFromEmployment" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.updateCalcs" label-false="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.updateCalcsFalse"
          label-true="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.updateCalcsTrue"></salaxy-input-boolean>
      </div>
      <salaxy-form-group label-type="empty-label" name="submit" class="no-colon">
        <button type="submit" class="btn btn-primary" ng-disabled="!newPayrollForm.$valid" ng-click="$ctrl.save()" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.createPayrollButton"></button>
      </salaxy-form-group>
    </form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/payroll/PayrollSelectList.html",`<div class="salaxy-component salaxy-payroll-select-list">
  <salaxy-odata-table ng-if="$ctrl.category=='paid'"  ng-if="$ctrl.mode == 'select'" template-url="salaxy-components/odata/lists/Payrolls-select.html"  options="{ $filter: 'status eq \\'paymentSucceeded\\' or status eq \\'paymentStarted\\'' }"
    selected-items="$ctrl.selectedItems" on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });" crud-controller="PayrollCrudController as $crud"></salaxy-odata-table>
  <salaxy-odata-table ng-if="$ctrl.category=='draft'"  ng-if="$ctrl.mode == 'select'" template-url="salaxy-components/odata/lists/Payrolls-select.html"  options="{ $filter: 'status eq \\'draft\\'' }"
    selected-items="$ctrl.selectedItems" on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });" crud-controller="PayrollCrudController as $crud"></salaxy-odata-table>
  </div>`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollAssistant.html",`
<div class="salaxy-component salaxy-payroll-assistant salaxy-message-thread" ng-if="$ctrl.current">
  <div class="messages-container" >
    <div id="openairesponse" style="overflow-y: scroll;overflow-x: hidden; max-height: 300px;">
      <div class="text-end">
        <salaxy-avatar avatar="$ctrl.openAiAvatar" class="float-end"></salaxy-avatar>
        <div class="message-bubble right text"> 
          <div>
            Hei! Olen palkanlaskennan tekoäly. Voin halutessasi muokata tätä palkkalistaa, vastata palkanlaskentaa koskeviin kysymyksiisi tai luoda erilaisia raportteja. Voit myös liittää Excel aineistoja, joita voin käyttää, jos haluat. Miten voin auttaa sinua tänään?
          </div>     
        </div>
      </div>
      <div  ng-repeat="item in $ctrl.messages | filter: {hidden: false}" ng-switch="item.type">
        <div ng-switch-when="file">
          <salaxy-avatar avatar="$ctrl.myAvatar" class="float-start"></salaxy-avatar>
          <div class="message-bubble left text"> 
            <span><i class="fa fa-file-excel-o"></i> {{item.file}}</span>    
          </div>
        </div>
        <div ng-switch-when="html"  class="text-end">
          <salaxy-avatar avatar="$ctrl.openAiAvatar" class="float-end"></salaxy-avatar>
          <div class="message-bubble right text"> 
            <span class="clickable"  ng-click="$ctrl.showReport(item)"><i class="fa fa-file-o"></i> {{item.file}}</span>    
          </div>
        </div>
        <div ng-switch-default ng-class="item.role == 'assistant' ? 'text-end' : ''">
          <salaxy-avatar ng-if="item.role != 'assistant'" avatar="$ctrl.myAvatar" class="float-start"></salaxy-avatar>
          <salaxy-avatar ng-if="item.role == 'assistant'" avatar="$ctrl.openAiAvatar" class="float-end"></salaxy-avatar>
          <div ng-if="item.role != 'assistant'" class="message-bubble left text"> 
            <div>
              {{item.content}}
            </div>     
          </div>
          <div ng-if="item.role == 'assistant'" class="message-bubble right text"> 
            <div>
              {{item.content}}
            </div>     
          </div>
        </div>
      </div>
      <div ng-if="$ctrl.loading" class="text-end">
        <salaxy-avatar avatar="$ctrl.openAiAvatar" class="float-end"></salaxy-avatar>
        <div class="message-bubble right text"> 
          <span ><span style="font-size: large;"><i class="fa fa-refresh fa-spin fa-fw"></i></span> Valmistellaan vastausta...</span>  
        </div>
      </div>
    </div>
      <div class="row  message-actions">
        <div class="col-8 col-sm-8">
          <textarea name="content" ng-model="$ctrl.content" placeholder="Kirjoita viesti palkanlaskennan tekoälylle" ></textarea>
        </div>
        <div class="col-4 col-sm-4 d-flex flex-column">
          <button type="button" class="btn btn-primary btn-labeled-left text-start mb-1" ng-click="$ctrl.chatForPayroll()">
            <i class="bi bi-pencil-fill"></i>
            <span>Muokkaa</span>
          </button>
          <button type="button" class="btn btn-default btn-labeled-left text-start mb-1" ng-click="$ctrl.chatForAdvise()">
            <i class="bi bi-question-circle-fill"></i>
            <span>Kysy</span>
          </button>
          <button type="button" class="btn btn-default btn-labeled-left text-start mb-1" ng-click="$ctrl.chatForReport()">
            <i class="bi bi-table"></i>
            <span>Raportti</span>
          </button>
          <button type="button" class="btn btn-default btn-labeled-left text-start mb-1" ngf-select="$ctrl.readFile($file)" ngf-multiple="false"  ngf-max-size="10MB">
            <i class="bi bi-paperclip"></i>
            <span>Liitä Excel</span>
          </button>
      </div>
  </div>
  <div>&nbsp;</div>`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetails.html",`<div class="salaxy-component salaxy-payroll-details" ng-if="$ctrl.current">
  <ng-include ng-show="!$ctrl.isNew()" src="'salaxy-components/calc/payrollV4/PayrollDetails_info.html'"></ng-include>
  <ng-include ng-show="!$ctrl.isNew()" src="'salaxy-components/calc/payrollV4/PayrollDetails_toolbar.html'"></ng-include>
  <salaxy-tab-buttons
    current-tab="$ctrl.payrollDetailsCurrentTab"
    default-tab="$ctrl.defaultTab"
    ng-show="!$ctrl.isNew()"
    options="[
      { value: 'calculations', text: 'SALAXY.NG1.PayrollComponent.headerViews.calculations' },
      { value: 'rows', text: 'SALAXY.NG1.PayrollComponent.headerViews.rows' },
      { value: 'reports', text: 'SALAXY.NG1.PayrollComponent.headerViews.reports' },
      { value: 'messages', text: 'SALAXY.NG1.PayrollComponent.headerViews.messages', hidden: !('partnerMessaging' | sxyIsInRole) },
      { value: 'ports', text: 'SALAXY.NG1.PayrollComponent.headerViews.ports', hidden: !$ctrl.$import.isSupported },
      { value: 'records', text: 'Tarkistusraportti', hidden: !('aidemo' | sxyIsInRole) },
      { value: 'debug', text: 'Debug', hidden: !('test' | sxyIsInRole) || ('aidemo' | sxyIsInRole) },
    ]"
    tabs-id="payrollDetails"
    class="d-block mt-3">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-payrollDetails" ng-show="!$ctrl.isNew()">
    <div class="tab-pane" id="calculations-tab">
      <ng-include ng-if="$ctrl.payrollDetailsCurrentTab == 'calculations'" src="'salaxy-components/calc/payrollV4/PayrollDetails_calcs.html'"></ng-include>
    </div>
    <div class="tab-pane" id="rows-tab">
      <div ng-if="$ctrl.payrollDetailsCurrentTab == 'rows'" class="row">
        <div class="col" ng-class="$ctrl.hasAssistantKey ? 'col-8' : 'col-12'">
          <ng-include  ng-if="$ctrl.calcs && $ctrl.payrollDetailsCurrentTab == 'rows'" src="'salaxy-components/calc/payrollV4/PayrollDetails_calcs_paged.html'"></ng-include>
        </div>
        <div ng-show="$ctrl.hasAssistantKey" class="col" ng-class="$ctrl.hasAssistantKey ? 'col-4' : 'col-12'">
          <salaxy-payroll-assistant current="$ctrl.current" page="$ctrl.page"></salaxy-payroll-assistant>
        </div>
      </div>
    </div>
    <div class="tab-pane" id="reports-tab">
      <div class="tab-content-wrapper" ng-if="$ctrl.payrollDetailsCurrentTab == 'reports'">
        <div ng-show="false" ng-init="$ctrl.clearReports()"></div>
        <ng-include src="'salaxy-components/calc/payrollV4/PayrollDetails_reports.html'"></ng-include>
      </div>
    </div>
    <div class="tab-pane" id="messages-tab" ng-if="'partnerMessaging' | sxyIsInRole">
      <ng-include ng-if="$ctrl.payrollDetailsCurrentTab == 'messages'" src="'salaxy-components/calc/payrollV4/PayrollDetails_messages.html'"></ng-include>
    </div>
    <div class="tab-pane" id="ports-tab" ng-show="$ctrl.$import.isSupported">
      <ng-include ng-show="$ctrl.payrollDetailsCurrentTab == 'ports'" src="'salaxy-components/calc/payrollV4/PayrollDetails_ports.html'"></ng-include>
    </div>
    <div class="tab-pane" id="records-tab" ng-if="'aidemo' | sxyIsInRole">
      <salaxy-records ng-if="$ctrl.current && $ctrl.payrollDetailsCurrentTab == 'records'" read-only="false" api-ctrl="$ctrl" entity-type="'payrollDetails'"></salaxy-records>
    </div>
    <div class="tab-pane" id="debug-tab" ng-if="('test' | sxyIsInRole) && !('aidemo' | sxyIsInRole)">
      <ng-include ng-if="$ctrl.payrollDetailsCurrentTab == 'debug'" src="'salaxy-components/calc/payrollV4/PayrollDetails_debug.html'"></ng-include>
    </div>
  </div>
  <ng-include src="'salaxy-components/calc/payrollV4/PayrollDetails_calc.html'"></ng-include>
  <ng-include src="'salaxy-components/calc/payrollV4/PayrollDetails_header.html'"></ng-include>
</div>`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetailsList.html",`<div class="salaxy-component salaxy-payroll-details-list">
  <div class="row w-100" ng-if="!$ctrl.hideButton">
    <div class="col-12 action-button-container mb-3">
      <salaxy-action-button action="'newPayroll'" button-class="btn-primary" style="margin-bottom:30px;"></salaxy-action-button>
    </div>
  </div>
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'default', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.latest' },
      { value: 'templates', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.repeated' },
      { value: 'paid', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.paid' },
      { value: 'paidcalcs', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.paidSalaries' },
      { value: 'draftcalcs', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.draftCalcs' }
    ]"
    tabs-id="payrollDetailsList">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-payrollDetailsList">
    <div class="tab-pane" id="default-tab">
      <salaxy-odata-table crud-controller="Payroll4CrudController as $crud" options="{ $filter: 'status ne \\'paymentSucceeded\\' and status ne \\'paymentStarted\\' and status ne \\'template\\' and status ne \\'handled\\' and status ne \\'paymentCanceled\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="templates-tab">
      <salaxy-odata-table crud-controller="Payroll4CrudController as $crud" options="{ $filter: 'status eq \\'template\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="paid-tab">
      <salaxy-odata-table crud-controller="Payroll4CrudController as $crud" options="{ $filter: 'status eq \\'paymentSucceeded\\' or status eq \\'paymentStarted\\' or status eq \\'handled\\' or status eq \\'paymentCanceled\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="paidcalcs-tab">
      <salaxy-odata-table url="/v03/api/calculations/category/readonly" crud-controller="CalculationCrudController as $crud" options="{ $filter: 'status eq \\'paymentSucceeded\\' and data/payrollId ne null' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="draftcalcs-tab">
      <salaxy-odata-table crud-controller="CalculationCrudController as $crud" options="{ $filter: 'status eq \\'payrollDraft\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetailsSelectList.html",`<div class="salaxy-component salaxy-payroll-details-select-list">
  <salaxy-odata-table ng-if="$ctrl.category=='paid'"  ng-if="$ctrl.mode == 'select'" template-url="salaxy-components/odata/lists/Payrolls-select.html"  options="{ $filter: 'status eq \\'paymentSucceeded\\' or status eq \\'paymentStarted\\'' }"
    selected-items="$ctrl.selectedItems" on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });" crud-controller="Payroll4CrudController as $crud"></salaxy-odata-table>
  <salaxy-odata-table ng-if="$ctrl.category=='draft'"  ng-if="$ctrl.mode == 'select'" template-url="salaxy-components/odata/lists/Payrolls-select.html"  options="{ $filter: 'status eq \\'draft\\'' }"
    selected-items="$ctrl.selectedItems" on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });" crud-controller="Payroll4CrudController as $crud"></salaxy-odata-table>
  </div>`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetails_calc.html",`<div class="salaxy-navi-page-container salaxy-payroll-details-calc salaxy-payroll-details-dialog " ng-style="{'max-width': '100%','width': $ctrl.userSettings.ng1Binder('payroll.calcDialogSize').val || '75%'}" ng-class="{ 'offcanvas-show': $ctrl.shouldShowCanvas('calc',$ctrl.calcId) }">
  <div class="modal-header bg-primary">
    <h3 class="modal-title">{{ $ctrl.calc ? ( $ctrl.calc.worker.avatar.displayName + ", " + ($ctrl.calc.result.totals.totalGrossSalary | currency) ) : ('SALAXY.UI_Terms.loading' | sxyTranslate) }}
      <span ng-if="$ctrl.calc && ('pro' | sxyIsInRole)" ng-controller="CalculationCrudController as $calcCrud" ng-init="$calcCrud.model = $ctrl.calc">
        <salaxy-workflow-buttons api-ctrl="$calcCrud" on-change="$ctrl.refreshAfterWorkflow()" show-workflow-assign="false"></salaxy-workflow-buttons>
      </span>
    </h3>
    <span class="ms-auto">
      <button type="button" class="btn btn-transparent"  ng-click="$ctrl.userSettings.ng1Binder('payroll.calcDialogSize').val = ($ctrl.userSettings.ng1Binder('payroll.calcDialogSize').val == '100%' ? '75%' : '100%')"><i ng-class="$ctrl.userSettings.ng1Binder('payroll.calcDialogSize').val == '100%' ? 'bi bi-arrows-angle-contract' : 'bi bi-arrows-angle-expand'"></i></button>
      <button type="button" class="btn btn-primary" aria-label="Close" ng-click="$ctrl.setCalc()"><span class="bi bi-x-lg"></span></button>
    </span>
  </div>
  <div class="modal-body">
    <salaxy-tab-buttons
      current-tab="$ctrl.calcTab"
      options="[
        { value: 'calcrows', text: 'SALAXY.NG1.PayrollComponent.calcViews.rows' },
        { value: 'calccalculator', text: 'SALAXY.NG1.PayrollComponent.calcViews.calculator' },
        { value: 'calccostaccounting', text: 'SALAXY.NG1.PayrollComponent.calcViews.costAccounting' },
        { value: 'calcemployment', text: 'SALAXY.NG1.PayrollComponent.calcViews.employment' },
        { value: 'calcreports', text: 'SALAXY.NG1.PayrollComponent.calcViews.reports' },
        { value: 'calcdebug', text: 'Debug', hidden: !('test' | sxyIsInRole) }
      ]"
      tabs-id="payrollDetailsCalc">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-payrollDetailsCalc">
      <div class="tab-pane" id="calcrows-tab">
        <salaxy-calc-worker-info ng-if="$ctrl.calc" model="$ctrl.calc"></salaxy-calc-worker-info>
        <div ng-if="$ctrl.calc" class="my-2" ng-controller="EmploymentCrudController as $employment" ng-init="$employment.queryResult={};$employment.getOData({ '$filter': 'id eq \\'' +  $ctrl.calc.worker.employmentId + '\\''}, $employment.queryResult)">
          <salaxy-workflow-badge mode="horizontal" ng-if="$employment.queryResult.items.length > 0" model="$employment.queryResult.items[0]" api-ctrl="$employment" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
        </div>
        <salaxy-calc-rows-2019-editor ng-if="$ctrl.calc" parent="$ctrl.calc" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calcRowEditor.title' | sxyTranslate}}"
          mode="{{($ctrl.calc.isReadOnly || $ctrl.isReadOnly ) ? 'read-only' : 'read-edit'}}" 
          is-in-edit="!$ctrl.isReadOnly && !$ctrl.calc.isReadOnly"
          show-edit-buttons="false" 
          show-gross-totals="true"></salaxy-calc-rows-2019-editor>
        <salaxy-spinner ng-if="!$ctrl.calc"></salaxy-spinner>
      </div>
      <div class="tab-pane" id="calccalculator-tab">
        <salaxy-calc ng-if="$ctrl.calc" model="$ctrl.calc"></salaxy-calc>
        <salaxy-spinner ng-if="!$ctrl.calc"></salaxy-spinner>
      </div>
      <div class="tab-pane" id="calccostaccounting-tab">
        <div ng-class="$ctrl.userSettings.ng1Binder('payroll.calcDialogSize').val == '100%' ? 'container' : ''">
          <salaxy-calc-cost-accounting ng-if="$ctrl.calc" calc="$ctrl.calc" read-only="$ctrl.isReadOnly || $ctrl.calc.isReadOnly"></salaxy-calc-cost-accounting>
          <salaxy-spinner ng-if="!$ctrl.calc"></salaxy-spinner>
      </div>
      </div>
      <div class="tab-pane" id="calcemployment-tab">
        <salaxy-employment-details ng-if="$ctrl.calc" ng-ref="$ctrl.$employment" model="$ctrl.calc.worker.employmentId" is-modal="true"></salaxy-employment-details>
        <salaxy-spinner ng-if="!$ctrl.calc"></salaxy-spinner>
      </div>
      <div class="tab-pane" id="calcreports-tab">
        <salaxy-calc-reports ng-if="$ctrl.calc" calcs="[$ctrl.calc]" report-type="'salarySlip'"></salaxy-calc-reports>
        <salaxy-spinner ng-if="!$ctrl.calc"></salaxy-spinner>
      </div>
      <div class="tab-pane" id="calcdebug-tab">
        <div class="row" ng-if="$ctrl.calc">
          <div class="col-sm-6">
            <salaxy-json-formatter ng-if="$ctrl.calc" key="'Calculation'" open="0" json="$ctrl.calc"></salaxy-json-formatter>
            <salaxy-json-formatter ng-if="$ctrl.calcListItem" key="'List item'" open="0" json="$ctrl.calcListItem"></salaxy-json-formatter>
          </div>
          <div class="col-sm-6">
            <fieldset ng-init="$ctrl.initRowsImportParams()">
              <legend>Vie rivit (Muoto: Työajan tuonti)</legend>
              <salaxy-input name="debugTitle" ng-model="$ctrl.rowsImportParams.title" label="Otsikko"></salaxy-input>
              <salaxy-input name="debugPersonalId" ng-model="$ctrl.rowsImportParams.personalId" label="Henkilötunnus"></salaxy-input>
              <salaxy-input name="debugEmploymentType" ng-model="$ctrl.rowsImportParams.employmentType" label="Työsuhteen tyyppi"></salaxy-input>
              <salaxy-input name="debugPayrollId" ng-model="$ctrl.rowsImportParams.payrollId" label="Palkkalistan ID"></salaxy-input>
              <salaxy-date-range name="debugPeriod" ng-model="$ctrl.rowsImportParams.period" label="Palkkakausi"></salaxy-date-range>
              <button type="button" class="btn btn-default" ng-click="$ctrl.copyRowsImportData()">Vie rivit</button>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-end">
    <div class="me-1">
      <button type="button" class="btn btn-default" ng-click="$ctrl.setCalc()" sxy-text="SALAXY.UI_Terms.close"></button>
      <div ng-if="$ctrl.calcTab=='calcrows' || $ctrl.calcTab=='calccalculator' || $ctrl.calcTab=='calccostaccounting'" class="btn-group dropup">
        <button type="button" ng-disabled="$ctrl.loaders[$ctrl.calc.id]" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.options"></span>
        </button>
        <ul class="dropdown-menu dropdown-menu-end" role="menu" aria-labelledby="actions">
          <li role="menuitem" ng-if="!$ctrl.isReadOnlyForced && !$ctrl.calc.isReadOnly">
            <a href="" ng-click="$ctrl.deleteCalc()" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.deletePayrollCalc" class="dropdown-item"></a>
          </li>
          <li role="menuitem" ng-if="!$ctrl.isReadOnlyForced && (!$ctrl.isReadOnly || !$ctrl.calc.isReadOnly)">
            <a href="" ng-click="$ctrl.deleteCalc(true)" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.unlink" class="dropdown-item"></a>
          </li>
          <li role="menuitem">
            <a href="" ng-click="$ctrl.copyCalc()" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.copyAsNew" class="dropdown-item"></a>
          </li>
          <li role="menuitem" ng-if="$ctrl.isReadOnly && !$ctrl.calc.isReadOnly && !$ctrl.isCfa">
            <a href="" ng-click="$ctrl.payCalc()" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.pay" class="dropdown-item"></a>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <button ng-if="$ctrl.page.total > 1 && $ctrl.payrollDetailsCurrentTab !=='calculations'" type="button" class="btn btn-default" ng-click="$ctrl.goToPage(true)"><span><i class="bi bi-rewind-fill"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.previousPage"></span></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.goToCalc(true)"><span><i class="bi bi-caret-left-fill"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.previousCalc"></span></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.goToCalc(false)"><span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.nextCalc"></span> <span><i class="bi bi-caret-right-fill"></i></span></button>
    </div>

    <button ng-if="$ctrl.page.total > 1 && $ctrl.payrollDetailsCurrentTab !=='calculations'" type="button" class="btn btn-default" ng-click="$ctrl.goToPage(false)"><span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.nextPage"></span> <span><i class="bi bi-fast-forward-fill"></i></span></button>
    <button ng-if="$ctrl.calcTab=='calcrows' || $ctrl.calcTab=='calccalculator' || $ctrl.calcTab=='calccostaccounting'"  type="button" class="btn btn-primary" ng-click="$ctrl.saveCalc($ctrl.calc)" ng-disabled="$ctrl.isReadOnly || $ctrl.calc.isReadOnly || $ctrl.loaders[$ctrl.calc.id]">
      <span ng-if="$ctrl.loaders[$ctrl.calc.id]"><i class="bi bi-arrow-repeat bi-spin"></i></span>
      <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.save"></span>
      <span ng-if="$ctrl.hasCalcChange"> <span class="badge">1<span></span>
    </button>

    <button ng-if="$ctrl.calcTab=='calcemployment'" type="button" class="btn btn-default" ng-click="$ctrl.addSalaryDefaultsToCalc($ctrl.calc)" ng-disabled="$ctrl.isReadOnly || $ctrl.calc.isReadOnly || $ctrl.loaders[$ctrl.calc.id + '-add-salary-defaults']"><span ng-if="$ctrl.loaders[$ctrl.calc.id + '-add-salary-defaults']"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.workerEdit.addSalaryDefaults"></span></button>
    <button ng-if="$ctrl.calcTab=='calcemployment'" type="button" class="btn btn-danger" ng-click="$ctrl.saveEmployment($ctrl.$employment.current, true)" ng-disabled="$ctrl.isReadOnly || $ctrl.calc.isReadOnly || $ctrl.loaders[$ctrl.calc.id + '-employment-true']"><span ng-if="$ctrl.loaders[$ctrl.calc.id + '-employment-true']"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.workerEdit.updateWorkerInfoAndSalaryRows"></span></button>
    <button ng-if="$ctrl.calcTab=='calcemployment'" type="button" class="btn btn-primary" ng-click="$ctrl.saveEmployment($ctrl.$employment.current)" ng-disabled="$ctrl.isReadOnly || $ctrl.calc.isReadOnly || $ctrl.loaders[$ctrl.calc.id + '-employment-false']"><span ng-if="$ctrl.loaders[$ctrl.calc.id + '-employment-false']"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.workerEdit.updateWorkerInfo"></span><span ng-if="$ctrl.hasEmploymentChange"> <span class="badge">1<span></span></button>
    
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetails_calcs.html",`<div class="table-responsive">
  <table class="table table-striped">
    <thead>
      <tr>
        <th colspan="4" ng-click="$ctrl.orderBy('otherPartyInfo.avatar.sortableName')" class="clickable">
          <span><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span> <i ng-if="$ctrl.orderField == 'otherPartyInfo.avatar.sortableName'" class="fa" ng-class="$ctrl.orderReverse  ? 'bi-sort-down' : 'bi-sort-up'"></i></span>
        </th>
        <th class="right clickable" ng-click="$ctrl.orderBy('grossSalary')">
          <span><span sxy-text="SALAXY.NG1.CalcListComponent.salary"></span> <i ng-if="$ctrl.orderField == 'grossSalary'" class="fa" ng-class="$ctrl.orderReverse  ? 'bi-sort-down' : 'bi-sort-up'"></i></span>
        </th>
        <th class="right clickable" ng-click="$ctrl.orderBy('data.workerPayment')">
          <span><span sxy-text="SALAXY.NG1.CalcListComponent.net"></span> <i ng-if="$ctrl.orderField == 'data.workerPayment'" class="fa" ng-class="$ctrl.orderReverse  ? 'bi-sort-down' : 'bi-sort-up'"></i></span>
        </th>
        <th class="clickable" ng-click="$ctrl.orderBy('status')">
          <span><span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span> <i ng-if="$ctrl.orderField == 'status'" class="fa" ng-class="$ctrl.orderReverse  ? 'bi-sort-down' : 'bi-sort-up'"></i></span>
        </th>
        <th>
          <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.records.label"></span>
        </th>
        <th sxy-if-role="pro">
          <div class="d-flex align-items-end">
            <span sxy-text="SALAXY.NG1.CalcListComponent.checked" class="me-2"></span>
            <salaxy-input-enum class="column-filter" ng-model="calculationChecked" ng-change="calculationChecked != null && $ctrl.setColumnFilter('PartnerMessageClosed', calculationChecked)" placeholder="SALAXY.MODEL.PayrollListItem.messages.tableHeading" name="calculationCheckedStatus" options="{ '': 'SALAXY.UI_Terms.showAll', true: 'SALAXY.MODEL.PayrollListItem.messages.tableHeading', false: 'SALAXY.MODEL.PayrollListItem.messages.tableHeadingNotChecked' }" label-type="plain"></salaxy-input-enum>
          </div>
        </th>
        <th sxy-if-role="pro">
          <div class="d-flex align-items-end">
            <span sxy-text="SALAXY.NG1.CalcListComponent.issues" class="me-2"></span>
            <salaxy-input-enum class="column-filter" ng-model="calculationIssue" ng-change="calculationIssue != null && $ctrl.setColumnFilter('PartnerMessageIssue', calculationIssue)" placeholder="SALAXY.MODEL.PayrollListItem.messages.tableHeadingIssues" name="calculationIssuesStatus" options="{ '': 'SALAXY.UI_Terms.showAll', true: 'SALAXY.MODEL.PayrollListItem.messages.tableHeadingIssues', false: 'SALAXY.MODEL.PayrollListItem.messages.tableHeadingNoIssues' }" label-type="plain"></salaxy-input-enum>
          </div>
        </th>
        <th class="right clickable" ng-click="$ctrl.orderBy('data.workStartDate')" >
          <span><span sxy-text="SALAXY.NG1.CalcListComponent.salaryPeriod"></span> <i ng-if="$ctrl.orderField == 'data.workStartDate'" class="fa" ng-class="$ctrl.orderReverse  ? 'bi-sort-down' : 'bi-sort-up'"></i></span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.calcs" class="clickable" ng-class="{ 'active-payroll-item': $ctrl.calcId == row.id }"  ng-click="$ctrl.toggleCalc(row.id)">
        <td class="td-avatar middle">
          <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="td-name middle">
          <div>
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
          </div>
          <div>{{ row.otherPartyInfo.officialId }}</div>
        </td>
        <td colspan="2" class="middle">
          <span ng-if="$ctrl.getCalcValidity(row)" class="error-summary text-danger" sxy-text="{{'SALAXY.VALIDATION.' + $ctrl.getCalcValidity(row).errors[0].code + '.label'}}"></span>
          <span ng-if="$ctrl.getCalcValidity(row) && $ctrl.getCalcValidity(row).errors[0].code == 'Payroll.Calc.TaxCardType'">
            <button class="btn btn-xs btn-default" ng-click="$ctrl.showAddNewTaxcard($event, row)">{{ 'SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.addTaxcard' | sxyTranslate}} <i class="bi bi-plus-lg"></i></button>
          </span>
        </td>
        <td class="right middle">{{ row.grossSalary | currency }}</td>
        <td class="right middle">{{ row.data.workerPayment | currency }}</td>
        <td class="middle"><span ng-class="$ctrl.rowStatusWarning(row) ? 'badge bg-danger': ''">{{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}<span></td>
        <td>
          <salaxy-workflow-badge mode="horizontal" ng-if="$ctrl.employments[row.data.employmentId].messages.length > 0" model="$ctrl.employments[row.data.employmentId]" api-ctrl="$employment" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
        </td>
        <td sxy-if-role="pro">
          <div ng-repeat="message in row.messages" ng-bind-html="message | sxyWorkflowMessage: 'PartnerMessageClosed'"></div>
        </td>
        <td sxy-if-role="pro">
          <div ng-repeat="message in row.messages" ng-bind-html="message | sxyWorkflowMessage: 'PartnerMessageIssue'"></div>
        </td>
        <td class="right middle">
          <span>{{ { start: row.data.workStartDate, end: row.data.workEndDate, } | sxyDateRange }}</span>
          <div ng-if="$ctrl.isDateDifferent(row)">
            <del class="small">{{ $ctrl.current.input.period | sxyDateRange }}</del>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetails_calcs_paged.html",`<div class="text-end">
  <span class="float-start" ng-if="$ctrl.page.total > 1">{{$ctrl.page.calcRange}}/{{$ctrl.page.totalCalcCount}}</span>
  <button type="button" ng-if="!('disableHolidays' | sxyIsInRole)" class="btn btn-secondary" ng-click="$ctrl.saveWorktimes()" ng-disabled="$ctrl.isReadOnly || !$ctrl.current.id  || $ctrl.current.input.calculations.length == 0 || $ctrl.loaders['worktime' + $ctrl.current.id]"><span ng-if="$ctrl.loaders['worktime' + $ctrl.current.id]"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.saveWorktime"></span></button>
  <div class="btn-group">
   <salaxy-input-enum  style="display: inline-block" name="pageSize" ng-model="$ctrl.pageSizeOption" label-type="plain" options="$ctrl.pageSizeOptions" ng-change="$ctrl.setPageItems()"></salaxy-input-enum>
   <button ng-if="$ctrl.page.total > 1" type="button" class="btn btn-default" ng-click="$ctrl.goToPage(true)"><span><i class="bi bi-caret-left-fill"></i></span> <span sxy-text="SALAXY.UI_Terms.previous"></span></button>
   <button ng-if="$ctrl.page.total > 1" type="button" class="btn btn-default" ng-click="$ctrl.goToPage(false)"><span sxy-text="SALAXY.UI_Terms.next"></span> <span><i class="bi bi-caret-right-fill"></i></span></button>
  </div>
  <button type="button" class="btn btn-primary" ng-click="$ctrl.savePageCalcs()" ng-disabled="$ctrl.isReadOnly || $ctrl.numOfChangedPageCalcs == 0 || $ctrl.loaders['pageCalcs' + $ctrl.page.current]"><span ng-if="$ctrl.loaders['pageCalcs' + $ctrl.page.current]"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.save"></span><span ng-if="$ctrl.numOfChangedPageCalcs > 0"> <span class="badge">{{$ctrl.numOfChangedPageCalcs}}<span></span></span></button>
</div>
<div class="table-responsive">
  <table class="table table-striped">
    <thead>
      <tr>
        <th colspan="4" sxy-text="SALAXY.NG1_Other.Roles.worker"></th>
        <th class="right" sxy-text="SALAXY.NG1.CalcListComponent.salary"></th>
        <th class="right" sxy-text="SALAXY.NG1.CalcListComponent.net"></th>
        <th class="" sxy-text="SALAXY.NG1.CalcListComponent.status.title"></th>
        <th sxy-text="SALAXY.NG1.WorkerDetailsComponent.records.label"></th>
        <th sxy-if-role="pro" sxy-text="SALAXY.NG1.CalcListComponent.checked"></th>
        <th sxy-if-role="pro" sxy-text="SALAXY.NG1.CalcListComponent.issues"></th>
        <th ng-if="!('disableHolidays' | sxyIsInRole)" class="right" sxy-text="SALAXY.NG1.CalcListComponent.worktime"></th>
        <th class="right" sxy-text="SALAXY.NG1.CalcListComponent.salaryPeriod"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat-start="row in $ctrl.page.items" class="clickable" ng-class="{ 'active-payroll-item': $ctrl.calcId == row.id }" ng-click="$ctrl.toggleCalc(row.id)">
        <td class="td-avatar middle">
          <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="td-name middle">
          <div>
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
          </div>
          <div>{{ row.otherPartyInfo.officialId }}</div>
        </td>
        <td colspan="2" class="middle">
          <span ng-if="$ctrl.getCalcValidity(row)" class="error-summary text-danger" sxy-text="{{'SALAXY.VALIDATION.' + $ctrl.getCalcValidity(row).errors[0].code + '.label'}}"></span>
          <span ng-if="$ctrl.getCalcValidity(row) && $ctrl.getCalcValidity(row).errors[0].code == 'Payroll.Calc.TaxCardType'">
            <button class="btn btn-xs btn-default" ng-click="$ctrl.showAddNewTaxcard($event, row)">{{ 'SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.addTaxcard' | sxyTranslate}} <i class="bi bi-plus-lg"></i></button>
          </span>
        </td>
        <td class="right middle">{{ row.grossSalary | currency }}</td>
        <td class="right middle">{{ row.data.workerPayment | currency }}</td>
        <td class="middle"><span ng-class="$ctrl.rowStatusWarning(row) ? 'badge bg-danger': ''">{{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}<span></td>
        <td class="middle">
          <div ng-if="$ctrl.getPageCalc(row)" ng-controller="EmploymentCrudController as $employment" ng-init="$employment.queryResult={};$employment.getOData({ '$filter': 'id eq \\'' +  $ctrl.getPageCalc(row).worker.employmentId + '\\''}, $employment.queryResult)">
            <salaxy-workflow-badge mode="horizontal" ng-if="$employment.queryResult.items.length > 0" model="$employment.queryResult.items[0]" api-ctrl="$employment" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
          </div>
        </td>
        <td class="middle" sxy-if-role="pro">
          <div ng-repeat="message in row.messages" ng-bind-html="message | sxyWorkflowMessage: 'PartnerMessageClosed'"></div>
        </td>
        <td class="middle" sxy-if-role="pro">
          <div ng-repeat="message in row.messages" ng-bind-html="message | sxyWorkflowMessage: 'PartnerMessageIssue'"></div>
        </td>
        <td ng-if="!('disableHolidays' | sxyIsInRole)" class="right">
          <table class="text-small" ng-if="$ctrl.getPageCalc(row)">
            <tbody>
              <tr>
                <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.leavesDays"></td>
                <td class="right">{{ $ctrl.calculatePeriodDays($ctrl.getPageCalc(row),'leavesDays') | sxyCount : 'day' }}</td>
              </tr>
              <tr>
                <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.absencesDays"></td>
                <td class="right">{{ $ctrl.calculatePeriodDays($ctrl.getPageCalc(row),'absencesDays') | sxyCount : 'day' }}</td>
              </tr>
              <tr>
                <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.paidAbsencesDays"></td>
                <td class="right">{{ $ctrl.calculatePeriodDays($ctrl.getPageCalc(row),'paidAbsencesDays') | sxyCount : 'day' }}</td>
              </tr>
              <tr ng-if="$ctrl.showAccruals($ctrl.getPageCalc(row))">
                <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.accruedDays"></td>
                <td class="right">{{ $ctrl.calculatePeriodDays($ctrl.getPageCalc(row),'accruedDays') | sxyCount : 'day' }}</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td class="right middle">
          <span>{{ { start: row.data.workStartDate, end: row.data.workEndDate, } | sxyDateRange }}</span>
          <div ng-if="$ctrl.isDateDifferent(row)">
            <del class="small">{{ $ctrl.current.input.period | sxyDateRange }}</del>
          </div>
        </td>
      </tr>
      <tr ng-repeat-end>
        <td colspan="12">
          <salaxy-spinner ng-if="!$ctrl.getPageCalc(row)"></salaxy-spinner>
          <salaxy-calc-rows-2019-editor ng-if="$ctrl.getPageCalc(row)" parent="$ctrl.getPageCalc(row)" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calcRowEditor.title' | sxyTranslate}}" mode="{{($ctrl.getPageCalc(row).isReadOnly || $ctrl.isReadOnly ) ? 'read-only' : 'read-edit'}}" show-edit-buttons="false" is-in-edit="!($ctrl.isAiDemoWaitingApproval) && !$ctrl.isReadOnly && !$ctrl.getPageCalc(row).isReadOnly" show-gross-totals="true" dimension-count="2">
          </salaxy-calc-rows-2019-editor>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="text-right">
  <span class="float-start" ng-if="$ctrl.page.total > 1">{{$ctrl.page.calcRange}}/{{$ctrl.page.totalCalcCount}}</span>
  <button type="button" class="btn btn-default" ng-click="$ctrl.goToPage(true)"><span><i class="bi bi-rewind-fill me-2"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.previousPage"></span></button>
  <button type="button" class="btn btn-default" ng-click="$ctrl.goToPage(false)"><span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.nextPage"></span> <span><i class="ms-2 bi bi-fast-forward-fill"></i></span></button>
  <button type="button" class="btn btn-primary" ng-click="$ctrl.savePageCalcs()" ng-disabled="$ctrl.isReadOnly || $ctrl.numOfChangedPageCalcs == 0 || $ctrl.loaders['pageCalcs' + $ctrl.page.current]"><span ng-if="$ctrl.loaders['pageCalcs' + $ctrl.page.current]"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.save"></span><span ng-if="$ctrl.numOfChangedPageCalcs > 0"> <span class="badge">{{$ctrl.numOfChangedPageCalcs}}<span></span></span></button>
</div>`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetails_debug.html",`<salaxy-json-formatter ng-if="$ctrl.current" key="'PAYROLL'" json="$ctrl.current"></salaxy-json-formatter>`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetails_header.html",`<div class="salaxy-navi-page-container salaxy-payroll-details-header salaxy-payroll-details-dialog" ng-style="{'max-width': '100%','width': $ctrl.userSettings.ng1Binder('payroll.headerDialogSize').val || '75%'}" ng-class="{ 'offcanvas-show': $ctrl.shouldShowCanvas('header',$ctrl.showHeader || $ctrl.isNew())}">
  <div class="modal-header bg-primary">
   
    <h3 ng-if="$ctrl.isNew()"  class="modal-title">{{$ctrl.current.input.title || ('SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.heading' | sxyTranslate)}}</h3>
    <h3 ng-if="!$ctrl.isNew()"  class="modal-title">{{$ctrl.current.input.title}}</h3>
    <span class="ms-auto">
      <button type="button" class="btn btn-transparent"  ng-click="$ctrl.userSettings.ng1Binder('payroll.headerDialogSize').val = ($ctrl.userSettings.ng1Binder('payroll.headerDialogSize').val == '100%' ? '75%' : '100%')"><i ng-class="$ctrl.userSettings.ng1Binder('payroll.headerDialogSize').val == '100%' ? 'bi bi-arrows-angle-contract' : 'bi bi-arrows-angle-expand'" class="text-white"></i></button>
      <button type="button" class="btn btn-transparent" aria-label="Close" ng-click="$ctrl.closeHeader()"><span class="bi bi-x-lg text-white"></span></button>
    </span>
  </div>
  <div class="modal-body">
    <div ng-class="$ctrl.userSettings.ng1Binder('payroll.headerDialogSize').val == '100%' ? 'container' : ''">
      <ng-form name="$ctrl.payrollDetailsForm" class="form-horizontal" ng-readonly="$ctrl.isReadOnly">
        <div class="col-12 payroll-edit-properties-col">
          <salaxy-input name="title" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.title" required ng-model="$ctrl.current.input.title"></salaxy-input>
          <salaxy-form-group name="paymentChannel" ng-if="!('salaxyPay' | sxyIsInRole)" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.paymentChannel">
            <salaxy-pay-button ng-if="!$ctrl.isReadOnly || $ctrl.showAction('pay')" model="$ctrl.current" mode="channel-select" button-class="btn-block"></salaxy-pay-button>
            <div ng-if="$ctrl.isReadOnly && !$ctrl.showAction('pay')">{{ "PaymentChannel." + $ctrl.current.input.paymentChannel | sxyEnum }}</div>
          </salaxy-form-group>
          <div ng-if="(!$ctrl.isReadOnly || $ctrl.showAction('pay')) && ('test,setSalaryDateKind' | sxyIsInRole) && !('salaxyPay' | sxyIsInRole)"  ng-switch="$ctrl.current.input.paymentChannel">
            <div ng-switch-when="palkkausManual|talenomManual|palkkausInvoices|palkkausCfaTest|kitsas|briox|askelma|passeliMerit|ecom|hausvise" ng-switch-when-separator="|">
              <salaxy-form-group name="salaryDateKind" label="SALAXY.MODEL.PayrollInput.salaryDateKind.title">       
                <salaxy-salary-date-kind-button button-class="btn-block" model="$ctrl.current" ></salaxy-salary-date-kind-button>
              </salaxy-form-group>
            </div>
          </div>
          <salaxy-form-group ng-if="($ctrl.isReadOnly && !$ctrl.showAction('pay')) && $ctrl.current.input.salaryDateKind == 'inPast'" name="salaryDateKind" class="salaxy-component salaxy-read-only" label="SALAXY.MODEL.CalcWorkflow.salaryDateKind.title">
            <div class="form-control-plaintext">{{"SALAXY.ENUM.SalaryDateKind." + ($ctrl.current.input.salaryDateKind) + ".label" | sxyTranslate  }}</div>
          </salaxy-form-group>

          <salaxy-datepicker-popup read-only="false" ng-if="!$ctrl.isReadOnly || $ctrl.showAction('pay')" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryDate" name="salaryDate" ng-model="$ctrl.current.input.salaryDate" update-disabled-dates="($ctrl.current.input.salaryDateKind || '-') + '|' + ($ctrl.current.input.paymentChannel || '-')" date-disabled="disable-function" disable-function="$ctrl.isDisabledSalaryDate"></salaxy-datepicker-popup>
          <div class="row py-2" ng-if="$ctrl.isReadOnly && !$ctrl.showAction('pay')">
            <div class="col-sm-4"><strong sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryDate" ps=":"></strong> </div>
            <div class="col-sm-8">
              {{ $ctrl.current.info.salaryDate | date }}
              <span class="badge bg-info" ng-if="$ctrl.current.info.status != 'paymentSucceeded' && !$ctrl.current.input.salaryDate && $ctrl.current.info.salaryDate">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateEstimate' | sxyTranslate}}</span>
              <span ng-if="$ctrl.current.info.status != 'paymentSucceeded' &&  $ctrl.current.info.salaryDate && $ctrl.current.input.salaryDate && $ctrl.current.input.salaryDate != $ctrl.current.info.salaryDate"><s>{{ $ctrl.current.input.salaryDate | date }}</s> <span class="badge bg-warning">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateNote' | sxyTranslate}}</span></span>    
            </div>
          </div>
          <salaxy-date-range read-only="$ctrl.isReadOnly && !$ctrl.showAction('pay')" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryPeriod" name="period" ng-model="$ctrl.current.input.period" mode="calc"></salaxy-date-range>

          <salaxy-input name="sourceId" label="Source ID (import)" ng-model="$ctrl.current.input.sourceId"></salaxy-input>
          
          <salaxy-form-group ng-if="$ctrl.isNew() && $ctrl.current.input.calculations.length" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.copyingCalcs" name="calcCount">
            {{ $ctrl.current.input.calculations.length }} {{ 'SALAXY.UI_Terms.units.pce' | sxyTranslate}}
          </salaxy-form-group>
          <salaxy-input-boolean ng-if="$ctrl.isNew() && $ctrl.current.input.calculations.length" type="select" required placeholder="SALAXY.UI_Terms.choose" name="updateCalcsInCopy" ng-model="$ctrl.updateCalcsInCopy" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.updateCalcs" label-false="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.updateCalcsFalse"
            label-true="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.updateCalcsTrue"></salaxy-input-boolean>
        </div>
      </ng-form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" ng-click="$ctrl.closeHeader()" sxy-text="SALAXY.UI_Terms.close"></button>

    <button type="button" ng-if="!$ctrl.isNew()" class="btn btn-primary ms-2" ng-click="$ctrl.save()" ng-disabled="($ctrl.isReadOnly && !$ctrl.showAction('pay')) || (!$ctrl.payrollDetailsForm.$valid || !$ctrl.current.input.paymentChannel || $ctrl.current.input.paymentChannel == 'undefined' )  || $ctrl.loaders[$ctrl.current.id || 'new']"><span
      ng-if="$ctrl.loaders[$ctrl.current.id || 'new']"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.save"></span></button>
    <button type="button" ng-if="$ctrl.isNew()" class="btn btn-primary ms-2" ng-click="$ctrl.save({ 'applyEmploymentDefaultRows' : !$ctrl.updateCalcsInCopy})" ng-disabled="(!$ctrl.payrollDetailsForm.$valid || !$ctrl.current.input.paymentChannel || $ctrl.current.input.paymentChannel == 'undefined') || $ctrl.loaders[$ctrl.current.id || 'new']"><span
        ng-if="$ctrl.loaders[$ctrl.current.id || 'new']"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.createPayrollButton"></span></button>
  </div>
</div>
`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetails_import_debug.html",`<div ng-controller="ImportStagingController as $import">
  <div>
    <div class="row">
      <div class="col-12">
        <div class="btn-group" style="padding: 5px;">
          <button 
            class="btn btn-primary" 
            ng-click="$import.uploadTestJson($import.debugJson)"
            ng-disabled="!$import.debugJson">
            Send JSON
          </button>
          <button 
            class="btn btn-info" 
            ng-click="$import.formatDebugJson($import.debugJson)"
            ng-disabled="!$import.debugJson"
            style="margin-left: 5px;">
            Format JSON
          </button>
          <button 
            class="btn btn-info" 
            ng-click="$import.debugJsonAddBlank()"
            style="margin-left: 5px;">
            Add Blank WorktimeImport
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6 col-md-6">
          <sxy-code-editor ng-model="$import.debugJson" lang="json" height="600px"></sxy-code-editor>
      </div>
      <div class="col-6 col-md-6">
        <div ng-if="$import.uploadResults">
          <salaxy-json-formatter json="$import.uploadResults" key="'result'" open="10"></salaxy-json-formatter>
        </div>
        <div ng-if="!$import.uploadResults">
          <p class="text-center text-muted">
            Results will appear here after sending JSON
          </p>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetails_info.html",`<div class="row w-100 payroll-info-row">
  <div class="col-auto">
    <salaxy-avatar-placeholder class="payroll-avatar">
      <i class="salaxy-avatar bi bi-square-fill text-muted d-flex" ng-class="{'draft-invalid' : $ctrl.current.info.status == 'draft' && !$ctrl.current.info.isReadyForPayment, 'text-success' : $ctrl.current.info.status == 'paymentSucceeded', 'text-warning' : ($ctrl.current.info.status == 'paymentStarted' || $ctrl.current.info.status == 'waitingApproval') , 'text-danger' : $ctrl.current.info.status == 'paymentCancelled'}">
        <div class="avatar-text-wrapper">
          <strong>{{ $ctrl.current.info.calcCount }}</strong>
          <small>{{ $ctrl.current.info.salaryDate | date : "d.M." }}</small>
        </div>
      </i>
    </salaxy-avatar-placeholder>
  </div>
  <div class="col-auto payroll-info-col">
    <h3 class="payroll-title">{{ $ctrl.current.input.title }}</h3>
    <div class="row">
      <div class="col-12 col-sm-6">
        <div>
          <span>{{ 'PayrollStatus.' + $ctrl.current.info.status | sxyEnum }}</span>
          <span ng-if="$ctrl.current.info.status == 'draft'" ng-class="$ctrl.current.info.isReadyForPayment ? 'text-success' : 'text-danger'">
            {{ $ctrl.current.info.isReadyForPayment ? (('SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.readyForPayment' | sxyTranslate)) :
            (('SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.notReadyForPayment' | sxyTranslate)) }}
          </span>
        </div>
        <div>
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryPeriod" ps=":"></span> {{ $ctrl.current.input.period | sxyDateRange }} ({{$ctrl.current.input.period.daysCount}} <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryPeriodDaysCount"></span>)
        </div>
        <div>
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDate" ps=":"></span> 
          {{ $ctrl.current.info.salaryDate | date }}
          <span class="badge bg-info" ng-if="$ctrl.current.info.status != 'paymentSucceeded' && !$ctrl.current.input.salaryDate && $ctrl.current.info.salaryDate">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateEstimate' | sxyTranslate}}</span>
          <span ng-if="$ctrl.current.info.status != 'paymentSucceeded' &&  $ctrl.current.info.salaryDate && $ctrl.current.input.salaryDate && $ctrl.current.input.salaryDate != $ctrl.current.info.salaryDate"><s>{{ $ctrl.current.input.salaryDate | date }}</s> <span class="badge bg-warning">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateNote' | sxyTranslate}}</span></span>
        </div>
        <div>
          <span ng-if="$ctrl.current.input.template" sxy-html="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.template.html" params="{template: ($ctrl.current.input.template)}"></span>
        </div>
        <div>
          <small>ID: <code>{{ $ctrl.currentId }}</code></small>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.calcCount" ps=":"></span><span ng-style="$ctrl.getExceptionStyle($ctrl.info.calcCount.exception)"> {{ $ctrl.info.calcCount.original }}</span><span ng-if="$ctrl.info.calcCount.exception"> {{ $ctrl.info.calcCount.actual }}</span></span><br />
        <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.grossSalary" ps=":"></span><span ng-style="$ctrl.getExceptionStyle($ctrl.info.totalGrossSalary.exception)"> {{ $ctrl.info.totalGrossSalary.original | currency }}</span><span ng-if="$ctrl.info.totalGrossSalary.exception"> {{ $ctrl.info.totalGrossSalary.actual | currency }}</span></span><br />
        <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.totalPayment" ps=":"></span><span ng-style="$ctrl.getExceptionStyle($ctrl.info.totalPayment.exception)"> {{ $ctrl.info.totalPayment.original | currency }}</span><span ng-if="$ctrl.info.totalPayment.exception"> {{ $ctrl.info.totalPayment.actual | currency }}</span></span><br />
        <button type="button" class="btn btn-xs btn-default" ng-click="$ctrl.showHeader = !$ctrl.showHeader" ><span sxy-text="{{$ctrl.isReadOnly ? 'SALAXY.UI_Terms.show' : 'SALAXY.UI_Terms.edit'}}"></span> <i ng-class="$ctrl.isReadOnly ? 'bi bi-info-circle' : 'bi bi-pencil-fill'"></i></button>
      </div>
    </div>
    <div ng-if="'company' | sxyIsInRole" ng-controller="CompanyAccountController as $company" style="padding: 8px">
      <salaxy-workflow-badge ng-if="$company.current" model="$company.current" mode="horizontal" api-ctrl="$company" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
    </div>
    <div ng-if="$ctrl.showWorkflowMessage" style="margin-bottom: 4px;">
      <!-- Only shown in Accountor / Finago -->
      <salaxy-textarea name="workflowMessage" ng-model="$ctrl.workflowMessage" placeholder="{{'SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.workFlowMessage'}}" rows="2" label-type="plain"></salaxy-textarea>
    </div>
  </div>
  <div class="col ms-auto d-none d-sm-block" ng-if="$ctrl.$import.isSupported && $ctrl.$import.worktimeApi.list" style="max-width: 400px;">
    <button type="button" class="btn btn-primary btn-sm pull-right" ng-click="$ctrl.selectTab('ports')" sxy-text="SALAXY.NG1.ImportStagingComponent.payrollView.btnMoreInfo"></button>
    <h3 sxy-text="SALAXY.NG1.ImportStagingComponent.payrollView.title" style="margin-top: 0"></h3>
    <table style="width: 100%; ">
      <colgroup>
        <col style="width: 40%;">
        <col style="width: 10%;">
        <col style="width: 40%;">
        <col style="width: 10%;">
      </colgroup>
      <tbody>
        <tr>
          <td><div class="text-muted" sxy-text="SALAXY.NG1.ImportStagingComponent.status.preview"></div></td>
          <td class="right"><div class="text-muted">{{ $ctrl.$import.getTotals("all").rows.preview }}</div></td>
          <td style="padding-left: 6px;"><div class="" sxy-text="SALAXY.NG1.ImportStagingComponent.list.calcCount"></div></td>
          <td class="right">{{ $ctrl.$import.getTotals("all").rows.count }}</td>
        </tr>
        <tr>
          <td><div class="text-primary"><b sxy-text="SALAXY.NG1.ImportStagingComponent.status.new"></b></div></td>
          <td ng-if="$ctrl.$import.getTotals('all').rows.new" class="right"><div class="bg-primary badge">&nbsp;&nbsp;{{ $ctrl.$import.getTotals("all").rows.new }}&nbsp;</div></td>
          <td ng-if="!$ctrl.$import.getTotals('all').rows.new" class="right"><div class="text-primary">0</div></td>
          <td style="padding-left: 6px;"><div class=""><b sxy-text="SALAXY.NG1.ImportStagingComponent.status.committed"></b></div></td>
          <td class="right"><b>{{ $ctrl.$import.getTotals("all").rows.committed }}</b></td>
        </tr>
        <tr>
          <td><div class=""><s sxy-text="SALAXY.NG1.ImportStagingComponent.status.deleted"></s></div></td>
          <td class="right"><s>{{ $ctrl.$import.getTotals("all").rows.deleted }}</s></td>
          <td style="padding-left: 6px;"><div class="text-muted" sxy-text="SALAXY.NG1.ImportStagingComponent.status.ignored"></div></td>
          <td class="right"><div class="text-muted">{{ $ctrl.$import.getTotals("all").rows.ignored }}</div></td>
        </tr>
        <tr>
          <td><div class="text-danger" sxy-text="SALAXY.NG1.ImportStagingComponent.status.error"></div></td>
          <td ng-if="$ctrl.$import.getTotals('all').rows.error" class="right"><div class="bg-danger badge">&nbsp;&nbsp;{{ $ctrl.$import.getTotals("all").rows.error }}&nbsp;</div></td>
          <td ng-if="!$ctrl.$import.getTotals('all').rows.error" class="right"><div class="text-danger">0</div></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetails_messages.html",`<div ng-if="!$ctrl.current.info.messageThreadId" ng-controller="MessageThreadCrudController as $msg" ng-init="$msg.model='new'" class="form-horizontal" style="max-width: 600px;">
  <fieldset sxy-if-role="!pro">
    <p ng-if="!$ctrl.current.info.messageThreadId">Tähän palkkalistaan ei liity viestiketjua / työnkulkua.</p>
  </fieldset>
  <fieldset sxy-if-role="pro">
    <legend>Lähetä yritykselle</legend>
    <p>Luo tästä uusi viestiketju, jolla voit lähettää palkkalistan yritykselle hyväksyttäväksi / maksettavaksi.</p>
    <salaxy-input-enum name="action" label="Pyydetään toimintaa" type="radio" ng-model="$msg.current.input.todoAction" options="$ctrl.messageActions"
      ng-change="$msg.current.title = $ctrl.getMessageTitle($msg.current.input.todoAction)"></salaxy-input-enum>
    <salaxy-input name="title" label="SALAXY.NG1.MessageThreadComponent.title" require="true" disabled="!$msg.current.input.todoAction"
      ng-model="$msg.current.title"></salaxy-input>
    <salaxy-form-group name="msgSubmit" label-type="empty-label">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.sendPayrollMessage($msg)">Lähetä</button>
    </salaxy-form-group>
  </fieldset>
</div>
<div class="container" ng-if="$ctrl.current.info.messageThreadId">
  <div ng-if="$ctrl.isAiDemoEditable">
    <div class="row">
      <div class="col-sm-12 col-lg-12">
        <p class="lead">{{"SALAXY.NG1.PayrollDetailsMessages.payrollStatus" | sxyTranslate}}: {{ 'PayrollStatus.' + $ctrl.current.info.status | sxyEnum }}</p>
        <p sxy-text="SALAXY.NG1.PayrollDetailsMessages.payrollStatusDescription"></p>
        <p>
          <b sxy-text="SALAXY.NG1.PayrollDetailsMessages.payrollStatusDescription1"></b>
        </p>
        <ul>
          <li sxy-text="SALAXY.NG1.PayrollDetailsMessages.payrollStatusDescription1Description"></li>
        </ul>
        <p>
          <b sxy-text="SALAXY.NG1.PayrollDetailsMessages.payrollStatusDescription2"></b>
        </p>
        <ul>
          <li sxy-text="SALAXY.NG1.PayrollDetailsMessages.payrollStatusDescription2Description"></li>
        </ul>
        <p>
          <b sxy-text="SALAXY.NG1.PayrollDetailsMessages.note"></b>
          <span sxy-text="SALAXY.NG1.PayrollDetailsMessages.payrollStatusDescription3"></span>
        </p>
        <div class="btn-group dropdown">
          <!-- HACK: Rewrite workflow buttons as components. Or make PRO calculator a component. -->
          <button class="btn btn-default dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="font-weight: bold;">
            <span sxy-text="SALAXY.NG1.PayrollDetailsMessages.setPayrollStatus"></span>
          </button>
          <ul class="dropdown-menu">
            <li ng-class="{ disabled: $ctrl.current.info.status=='paymentAllowed' }">
              <a href="" class="dropdown-item" ng-click="$ctrl.current.info.status = 'paymentAllowed';$ctrl.save()">{{ "PayrollStatus.paymentAllowed" | sxyEnum }}</a>
            </li>
            <li ng-class="{ disabled: $ctrl.current.info.status=='waitingPartnerApproval' }">
              <a href="" class="dropdown-item" ng-click="$ctrl.current.info.status = 'waitingPartnerApproval';$ctrl.save()">{{ "PayrollStatus.waitingPartnerApproval" | sxyEnum }}</a>
            </li>
            <li ng-class="{ disabled: $ctrl.current.info.status=='waitingApproval' }">
              <a href="" class="dropdown-item" ng-click="$ctrl.current.info.status = 'waitingApproval';$ctrl.save()">{{ "PayrollStatus.waitingApproval" | sxyEnum }}</a>
            </li>
            <li ng-class="{ disabled: $ctrl.current.info.status=='draft' }">
              <a href="" class="dropdown-item" ng-click="$ctrl.current.info.status = 'draft';$ctrl.save()">{{ "PayrollStatus.draft" | sxyEnum }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <p>&nbsp;</p>
  <button type="button" class="btn btn-danger float-end" ng-click="$ctrl.deleteMessage($ctrl.$msg)"><i class="bi bi-trash-fill" aria-hidden="true"></i></button>
  <salaxy-message-thread model="$ctrl.current.info.messageThreadId" ng-ref="$ctrl.$msg" role="{{('pro' | sxyIsInRole) ? 'otherParty' : 'owner' }}" other-party="'partner'"
    mark-as-read="5"></salaxy-message-thread>
</div>`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetails_ports.html",`<div> 
  <salaxy-import-staging ng-ref="$ctrl.$import" payroll="$ctrl.current" payroll-calcs="$ctrl.calcs"></salaxy-import-staging>
</div>`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetails_reports.html",`<div class="container" ng-if="$ctrl.calcs.length" ng-init="$ctrl.refreshReports()">
  <salaxy-calc-reports ng-if="$ctrl.reportCalcs.length" calcs="$ctrl.reportCalcs"  report-type="'salarySlip'"></salaxy-calc-reports>
</div>
`);

 $templateCache.put("salaxy-components/calc/payrollV4/PayrollDetails_toolbar.html",`<div ng-if="$ctrl.isReadOnly" class="btn-toolbar">
  <button class="btn btn-secondary" ng-if="$ctrl.showAction('copy')" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.copyAsNew"></button>
  <div class="ms-auto">
    <salaxy-pay-button ng-ref="$ctrl.$payButton" ng-if="$ctrl.showAction('pay')" model="$ctrl.current" mode="pay-button" button-class="float-sm-end"
      label="SALAXY.NG1.PayrollComponent.payrollPayButton" 
      disabled="!$ctrl.current.info.isReadyForPayment || !$ctrl.current.input.calculations.length || !$ctrl.$payButton.isChannelDefined" ></salaxy-pay-button>
    <button ng-if="$ctrl.showAction('cancel') && ($ctrl.current.info.status == 'paymentStarted' && ($ctrl.current.input.paymentChannel == 'palkkausManual' || $ctrl.current.input.paymentChannel == 'talenomManual' || $ctrl.current.input.paymentChannel == 'palkkausInvoices' || $ctrl.current.input.paymentChannel == 'kitsas' || $ctrl.current.input.paymentChannel == 'palkkausPersonal' || $ctrl.current.input.paymentChannel == 'palkkausCfaPaytrail' || $ctrl.current.input.paymentChannel == 'palkkausEcfaPaytrail' || $ctrl.current.input.paymentChannel == 'palkkausCfaReference' || $ctrl.current.input.paymentChannel == 'palkkausEcfaReference' || $ctrl.current.input.paymentChannel == 'palkkausCfaFinvoice' || $ctrl.current.input.paymentChannel == 'palkkausEcfaFinvoice' ||  $ctrl.current.input.paymentChannel == 'palkkausCfaTest'))"
      class="btn btn-secondary  btn-labeled-right" ng-click="$ctrl.cancelInvoices()"><span sxy-text="SALAXY.NG1.CalcResultsComponent.cancelPaymentOrChangeChannelBtn"></span><i
        class="bi bi-x-circle"></i></button>
    <button ng-if="$ctrl.current.info.status != 'waitingApproval' && $ctrl.current.info.status != 'draft'" class="btn btn-secondary btn-labeled-right"
      ng-click="$ctrl.showPaymentDialog()"><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.showPaymentInfo"></span><i class="bi bi-info-circle"></i></button>
  </div>
  <button class="btn btn-default float-end" ng-if="('partnerMessaging' | sxyIsInRole) && (!('pro' | sxyIsInRole) && $ctrl.current.info.messageThreadId )" ng-click="$ctrl.selectTab('messages')" sxy-text="SALAXY.NG1.PayrollComponent.payrollCommentButton"></button>
</div>
<div ng-if="!$ctrl.isReadOnly" class="btn-toolbar calc-toolbar">
  <div ng-if="!$ctrl.isAiDemoWaitingApproval" class="btn-group dropdown">
    <button type="button" class="btn btn-labeled-left btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="bi bi-plus-lg"></i>
      <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCalculation"></span>
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="addcalculation">
      <li role="menuitem">
        <a ng-click="$ctrl.addEmployments()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addWorker"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addCalcs('draft')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addDraft"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addCalcs('shared')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addShared"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addCalcs('draft', true, true, true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.mergeDraft"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addCalcs('shared', true, true, true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.mergeShared"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addCalcs('paid')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCopy"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.mergePayroll(true, true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addPayroll"></a>
      </li>
    </ul>
  </div>
  <div ng-if="!$ctrl.isAiDemoWaitingApproval" class="btn-group dropdown ms-1" >
    <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.options"></span>
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="actions">
      <li role="menuitem">
        <a ng-click="$ctrl.importEmploymentDataAll()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.importEmploymentCalc"></a>
      </li>
      <li role="menuitem" salaxy-if-role="test">
        <a ng-click="$ctrl.addSalaryDefaultsToAllCalcs()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.addSalaryDefaults"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.showCopyAsNew($ctrl.current)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.copyAsNew"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.delete()" class="text-danger dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.delete"></a>
      </li>
    </ul>
  </div>
  <div sxy-if-role="pro" class="btn-group">
    <div class="btn-group align-items-center ms-1 dropdown">
      <!-- HACK: Rewrite workflow buttons as components. Or make PRO calculator a component. -->
      <button class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" type="button" aria-haspopup="true" aria-expanded="false" style="font-weight: bold;">
        {{ "PayrollStatus." + $ctrl.current.info.status | sxyEnum }}
      </button>
      <ul class="dropdown-menu" role="menu">
        <li ng-class="{ disabled: $ctrl.current.info.status=='draft' }">
          <a href="" ng-click="$ctrl.current.info.status = 'draft';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.draft" | sxyEnum }}</a>
        </li>
        <li ng-class="{ disabled: $ctrl.current.info.status=='template' }">
          <a href="" ng-click="$ctrl.current.info.status = 'template';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.template" | sxyEnum }}</a>
        </li>
        <li ng-class="{ disabled: $ctrl.current.info.status=='handled' }">
          <a href="" ng-click="$ctrl.current.info.status = 'handled';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.handled" | sxyEnum }}</a>
        </li>
        <li ng-class="{ disabled: $ctrl.current.info.status=='waitingApproval' }">
          <a href="" ng-click="$ctrl.current.info.status = 'waitingApproval';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.waitingApproval" | sxyEnum }}</a>
        </li>
        <li ng-class="{ disabled: $ctrl.current.info.status=='waitingPartnerApproval' }">
          <a href="" ng-click="$ctrl.current.info.status = 'waitingPartnerApproval';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.waitingPartnerApproval" | sxyEnum }}</a>
        </li>
        <li ng-class="{ disabled: $ctrl.current.info.status=='paymentAllowed' }">
          <a href="" ng-click="$ctrl.current.info.status = 'paymentAllowed';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.paymentAllowed" | sxyEnum }}</a>
        </li>
      </ul>
    </div>
    <salaxy-workflow-buttons api-ctrl="$ctrl"></salaxy-workflow-buttons>
  </div>
  <div class="btn-group ms-auto">
    <button class="btn btn-primary float-end" ng-if="$ctrl.isAiDemoWaitingApproval" ng-click="$ctrl.showAiDemoApproval()" sxy-text="Hyväksy"></button>
    <salaxy-pay-button ng-ref="$ctrl.$payButton" ng-if="!$ctrl.isAiDemoWaitingApproval && $ctrl.current.info.status != 'template'" model="$ctrl.current" mode="pay-button" button-class="float-sm-end"
      label="SALAXY.NG1.PayrollComponent.payrollPayButton" 
      disabled="!$ctrl.current.info.isReadyForPayment || !$ctrl.current.input.calculations.length || !$ctrl.$payButton.isChannelDefined" ></salaxy-pay-button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/rows/CalcIrRows.html",`<div class="salaxy-calc-ir-rows salaxy-component">
  <table class="table">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.headerIrCode"></th>
        <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.headerRowDescription"></th>
        <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.headerCalc" class="right"></th>
        <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.headerSum" class="right"></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.irRows">
        <td>
          <div class="d-flex">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="{ color: '#2b507c', initials: row.irData.code, entityType: 'company' }"></salaxy-avatar>
            <div class="flex-column">
              <b>{{ $ctrl.getIncomeType(row).label }}</b><br />
              <small>
                <div class="truncate" style="max-width: 250px;">
                  {{$ctrl.getIncomeType(row).description}}
                </div>
              </small>
            </div>
          </div>
        </td>
        <td>{{ row.message }}</td>
        <td class="right">
          <span ng-if="row.unit != 'one'">
            {{ row.count | sxyCount : row.unit }} *
          </span> {{ row.price | currency }} =
        </td>
        <td class="right">{{ row.total | currency }}
        </td>
        <td class="salaxy-calc-rows-editor-btns" ng-if="row.type=='manual'">
          <button type="button" class="edit btn btn-info" ng-click="$ctrl.setCurrentIrRow(row)"><i class="bi bi-pencil-square"></i></button>
          <button type="button" class="delete btn btn-danger" ng-click="$ctrl.deleteIrRow(row)"><i class="bi bi-trash-fill"></i></button>
        </td>
        <td class="salaxy-calc-rows-editor-btns" ng-if="row.type!='manual'">
          <button type="button" class="edit btn btn-info" ng-click="$ctrl.setCurrentIrRow(row)"><i class="bi bi-info-circle"></i></button>
        </td>
      </tr>
    </tbody>
    <tfoot ng-if="!$ctrl.isReadOnly">
      <tr>
        <th colspan="6" class="text-end">
          <button type="button" class="btn btn-default" ng-click="$ctrl.recalculate()" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.updateCalc"></button>
          <button type="button" class="btn btn-info" ng-click="$ctrl.addIrRow()" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.addNewRow"></button>
        </th>
      </tr>
    </tfoot>
  </table>
  <h4 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.chosenRowInfo"></h4>
  <div ng-if="!$ctrl.currentRow" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.chooseRowOrAddNew"></div>
  <salaxy-tab-buttons
    ng-if="$ctrl.currentRow"
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'irbasic', text: 'SALAXY.NG1.CalcRowsComponent.irRows.basicInfo' },
      { value: 'irincometype', text: 'SALAXY.NG1.CalcRowsComponent.irRows.irFlagsInfo' },
      { value: 'irsidecosts', text: 'SALAXY.NG1.CalcRowsComponent.irRows.taxAndSideCosts' },
      { value: 'irjson', text: 'JSON' }
    ]"
    tabs-id="calcIrRows">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-calcIrRows">
    <div class="tab-pane" id="irbasic-tab">
      <div class="form-horizontal">
        <div class="row">
          <div class="col col-md-12 col-lg-6">
            <h2 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.textAndType"></h2>
            <salaxy-input-income-type name="code" ng-model="$ctrl.currentRow.irData.code" hidden-codes="[1]" label="SALAXY.NG1.CalcRowsComponent.irRows.typeLabel" disabled="$ctrl.isIrRowReadOnly" ng-change="$ctrl.updateCurrentRowType()">
            </salaxy-input-income-type>
            <salaxy-input name="message" ng-model="$ctrl.currentRow.message" label="SALAXY.NG1.CalcRowsComponent.irRows.messageLabel" disabled="$ctrl.isIrRowReadOnly"></salaxy-input>
            <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.groupingLabel" disabled="$ctrl.isIrRowReadOnly"
              options="$ctrl.groupingOptions"
              name="calcGrouping" ng-model="$ctrl.currentRow.calcData.grouping" type="select"></salaxy-input-enum>
            <salaxy-form-group label="SALAXY.NG1.CalcRowsComponent.irRows.creditTransferLabel" name="paymentDefault">
              <div ng-if="$ctrl.currentRowType.paymentDefault == 1" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.payment"></div>
              <div ng-if="$ctrl.currentRowType.paymentDefault == -1" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.deduction"></div>
              <div ng-if="$ctrl.currentRowType.paymentDefault == 0" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.noPayment"></div>
            </salaxy-form-group>
          </div>
          <div class="col col-md-12 col-lg-6">
            <h2 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.calc"></h2>
            <salaxy-input-number name="count" ng-model="$ctrl.currentRow.count" disabled="$ctrl.isIrRowReadOnly" label="SALAXY.NG1.CalcRowsComponent.irRows.countLabel"></salaxy-input-number>
            <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.unitLabel" enum="Unit" name="Unit" disabled="$ctrl.isIrRowReadOnly" ng-model="$ctrl.currentRow.unit" type="select"></salaxy-input-enum>
            <salaxy-input-number name="price" ng-model="$ctrl.currentRow.price" disabled="$ctrl.isIrRowReadOnly" label="SALAXY.NG1.CalcRowsComponent.irRows.priceLabel"></salaxy-input-number>
            <salaxy-form-group name="total" label="SALAXY.NG1.CalcRowsComponent.irRows.totalLabel">
              <p>{{ $ctrl.currentRow.count * $ctrl.currentRow.price | currency }}</p>
            </salaxy-form-group>
          </div>
          <div class="col col-md-12 col-lg-6" ng-if="$ctrl.currentRow.irData.code == 304">
            <h2 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitInfo"></h2>
            <p sxy-html="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitInfoHtml"></p>
            <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitTypeLabel" disabled="$ctrl.isIrRowReadOnly" enum="CarBenefitCode" name="carBenefitCode"
              ng-model="$ctrl.currentRow.irData.carBenefit.carBenefitCode" disabled="$ctrl.isIrRowReadOnly" type="select"></salaxy-input-enum>
            <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitAgeGroupLabel" enum="AgeGroupCode" name="ageGroupCode" disabled="$ctrl.isIrRowReadOnly" ng-model="$ctrl.currentRow.irData.carBenefit.ageGroupCode" type="select">
            </salaxy-input-enum>
            <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitEmissionsValueLabel" name="emissionsValue" disabled="$ctrl.isIrRowReadOnly" minimum="0" maximum="100" ng-model="$ctrl.currentRow.irData.carBenefit.emissionsValue">
            </salaxy-input-number>
            <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitKilometersLabel" name="kilometers" disabled="$ctrl.isIrRowReadOnly" ng-model="$ctrl.currentRow.irData.carBenefit.kilometers">
            </salaxy-input-number>
          </div>
          <div class="col col-md-12 col-lg-6" ng-if="$ctrl.currentRow.irData.code == 331">
            <h2 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.dailyAllowanceAdditionalSelections"></h2>
            <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.dailyAllowanceTypeLabel" disabled="$ctrl.isIrRowReadOnly" enum="AllowanceCode" name="dailyAllowance" type="multi-select"
              ng-model="$ctrl.currentRow.irData.dailyAllowance"></salaxy-input-enum>
          </div>
          <div class="col col-md-12 col-lg-6" ng-if="$ctrl.currentRow.irData.code == 334">

            <h2 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.mealBenefitAdditionalSelections"></h2>
            <p sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.mealBenefitTaxInfo"></p>

            <salaxy-input-boolean type="checkbox" name="mealBenefitIsTaxValue" ng-model="$ctrl.currentRow.irData.mealBenefitIsTaxValue" label-type="plain"
              label-true="SALAXY.NG1.CalcRowsComponent.irRows.mealBenefitIsTaxValueLabel" disabled="$ctrl.isIrRowReadOnly"></salaxy-input-boolean>

          </div>
        </div>
        <div class="text-end" ng-if="!$ctrl.isIrRowReadOnly">
          <button type="button" class="btn btn-default" ng-click="$ctrl.recalculate()" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.updateCalc"></button>
          <button type="button" class="btn btn-info" ng-click="$ctrl.addIrRow()" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.addNewRow"></button>
        </div>
      </div>
    </div>
    <div class="tab-pane" id="irincometype-tab">
      <div class="form-horizontal">
        <h2>{{ $ctrl.currentRowType.label }} ({{ $ctrl.currentRowType.code }})</h2>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.irFlagsLabel" enum="IrFlags" name="flags" type="multi-select" disabled="$ctrl.isIrRowReadOnly" ng-model="$ctrl.currentRow.irData.flags">
        </salaxy-input-enum>
        <salaxy-form-group label="SALAXY.NG1.CalcRowsComponent.irRows.negativeSupportedLabel" name="isNegativeSupported">
          <div ng-if="$ctrl.currentRowType.isNegativeSupported" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.allowed"></div>
          <div ng-if="!$ctrl.currentRowType.isNegativeSupported" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.notAllowed"></div>
        </salaxy-form-group>
        <div style="white-space: pre-wrap">{{ $ctrl.currentRowType.description }}</div>

        <h2 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriod"></h2>
        <p sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriodInfo"></p>
        <salaxy-datepicker-popup name="startDate" disabled="$ctrl.isIrRowReadOnly" label="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriodStartDateLabel" ng-model="$ctrl.currentRow.earningPeriod.start"></salaxy-datepicker-popup>
        <salaxy-datepicker-popup name="endDate" disabled="$ctrl.isIrRowReadOnly" label="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriodEndDateLabel" ng-model="$ctrl.currentRow.earningPeriod.end"></salaxy-datepicker-popup>
      </div>
    </div>
    <div class="tab-pane" id="irsidecosts-tab">
      <div class="form-horizontal">
        <h2>{{ $ctrl.currentRowType.label }}</h2>
        <div style="white-space: pre-wrap">{{ $ctrl.currentRowType.taxAndSidecostsDescr }}</div>
        <table class="table">
          <tbody>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.tax"></th>
              <td>
                <div ng-if="$ctrl.currentRowType.taxDefault == 1" class="text-success" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.withheld"></div>
                <div ng-if="$ctrl.currentRowType.taxDefault == -1" class="text-warning" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.deductionAlt"></div>
                <div ng-if="$ctrl.currentRowType.taxDefault == 0" class="text-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.notwithheld"></div>
              </td>
              <td></td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.socialSecurityPayment"></th><th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.socialSecurityPayment">
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.toBePaid"></th>
              <th>
                <!-- TODO: Lisää tähän srakkeeseen tieto poikkeuksen jälkeen-->
              </th>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.occupationPension"></th>
              <td>
                <span ng-class="$ctrl.currentRowType.pensionInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.currentRowType.pensionInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.insurancePayment"></th>
              <td>
                <span ng-class="$ctrl.currentRowType.accidentInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.currentRowType.accidentInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td></td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.unemploymentInsurancePayment"></th>
              <td>
                <span ng-class="$ctrl.currentRowType.unemploymentInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.currentRowType.unemploymentInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td></td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.healtInsurancePayment"></th>
              <td>
                <span ng-class="$ctrl.currentRowType.healthInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.currentRowType.healthInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div ng-if="!$ctrl.currentRowType.insuranceInformationAllowed">
          <p sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.insuranceInformationAllowed"></p>
        </div>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.IrInsuranceExceptions" enum="IrInsuranceExceptions" name="dailyAllowance" disabled="$ctrl.isIrRowReadOnly"
          ng-if="$ctrl.currentRowType.insuranceInformationAllowed" ng-model="$ctrl.currentRow.irData.insuranceExceptions" type="multi-select"></salaxy-input-enum>
      </div>
    </div>
    <div class="tab-pane" id="irjson-tab">
      <salaxy-json-formatter json="$ctrl.currentRow" open="2"></salaxy-json-formatter>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/rows/CalcRowCostAccounting.html",`<div class="salaxy-component salaxy-calc-cost-accounting">
  <div ng-if="$ctrl.isLegacy">
    <fieldset>
      <legend sxy-text="SALAXY.NG1.CalcCostAccountingComponent.title"></legend>
      <table class="table">
        <thead>
          <tr>
            <th>{{('SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}</th>
            <th class="right">{{"SALAXY.NG1.CalcCostAccountingComponent.percent" | sxyTranslate}}</th>
            <th class="right">
              <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.isReadOnly" ng-click="$ctrl.costCenter.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="item in $ctrl.costCenter">
            <td>
              <salaxy-input-typeahead ng-if="$ctrl.getOptions('costCenter').length" ng-model="item.id" label-format="text-value"
                options="$ctrl.getOptions('costCenter')" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.isReadOnly"></salaxy-input-typeahead>
              <salaxy-input ng-if="!$ctrl.getOptions('costCenter').length" ng-model="item.id" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.isReadOnly">
              </salaxy-input>
            </td>
            <td>
              <salaxy-input-number ng-model="item.percent" name="{{ 'percent' + $index }}" label-type="plain" read-only="$ctrl.isReadOnly" unit="percent"></salaxy-input-number>
            </td>
            <td class="text-end" >
              <button ng-if="!$ctrl.isReadOnly" type="button" class="btn btn-danger" ng-click="$ctrl.costCenter.splice($index, 1)">
                <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="total">
            <td>{{"SALAXY.UI_Terms.total" | sxyTranslate}}</td>
            <td class="right">{{ $ctrl.getLegacySum() | sxyCount : 'percent' }}</td>
            <td class="right"></td>
          </tr>
        </tfoot>
      </table>
    </fieldset>
  </div>
  <div ng-if="!$ctrl.isLegacy && ($ctrl.row.accounting.dimensions.length > 0 || $ctrl.definitions.length > 0)">
    <salaxy-cost-accounting ng-init="$ctrl.row.accounting = ($ctrl.row.accounting || $ctrl.isReadOnly)  ? $ctrl.row.accounting : { dimensions: []}" current="$ctrl.row.accounting.dimensions" inherited="$ctrl.calc.accounting.dimensions" scope="row" dimensions="$ctrl.dimensions" read-only="$ctrl.isReadOnly" ></salaxy-cost-accounting>
  </div>
 
</div>`);

 $templateCache.put("salaxy-components/calc/rows/CalcRowDimensionInput.html",`<div class="d-flex">
  <salaxy-input-typeahead 
    class="text-muted flex-grow-1" 
    style="flex-grow: 1;"
    ng-if="$ctrl.isInherited() && $ctrl.hasOptions() && !$ctrl.isCostSharingEnabled()" 
    label-type="plain"
    ng-model="$ctrl.getInheritedSingleValue().value"
    label-format="text-value" 
    options="$ctrl.getOptions()" 
    name="single" 
    read-only="true"
    placeholder="{{ 'SALAXY.UI_Terms.notChosen' | sxyTranslate }}">
  </salaxy-input-typeahead>
  <salaxy-input 
    class="text-muted flex-grow-1"
    style="flex-grow: 1;"
    ng-if="$ctrl.isInherited() && !$ctrl.hasOptions() && !$ctrl.isCostSharingEnabled()"
    label-type="plain"
    ng-model="$ctrl.getInheritedSingleValue().value"
    name="single"
    read-only="true">
  </salaxy-input>
  <salaxy-input-typeahead 
    class="flex-grow-1"
    ng-if="!$ctrl.isInherited() && $ctrl.hasOptions() && !$ctrl.isCostSharingEnabled()"
    label-type="plain"
    ng-model="$ctrl.getSingleValue().value"
    ng-change="$ctrl.setSingleValue($ctrl.getSingleValue().value)"
    label-format="text-value"
    options="$ctrl.getOptions()"
    name="single"
    read-only="$ctrl.readOnly"
    placeholder="{{ 'SALAXY.UI_Terms.notChosen' | sxyTranslate }}">
  </salaxy-input-typeahead>
  <salaxy-input
    class="flex-grow-1"
    ng-if="!$ctrl.isInherited() && !$ctrl.hasOptions() && !$ctrl.isCostSharingEnabled()"
    style="flex-grow: 1;"
    label-type="plain"
    ng-model="$ctrl.getSingleValue().value" 
    ng-change="$ctrl.setSingleValue($ctrl.getSingleValue().value)"
    name="single"
    read-only="$ctrl.readOnly">
  </salaxy-input>
  <i ng-if="!$ctrl.readOnly && $ctrl.isInherited() && !$ctrl.isCostSharingEnabled()" ng-click="$ctrl.setSingleValue($ctrl.getInheritedSingleValue().value)" class="btn bi bi-pencil-fill clickable"></i>
  <table ng-if="$ctrl.isCostSharingEnabled()" class="text-small">
    <tbody>
      <tr ng-repeat="costCenter in $ctrl.getCostSharingValues()" ng-class="$ctrl.isInherited() ? 'text-muted' : ''" class="" style="line-height: 0.9em;">
        <td>{{costCenter.text}}</td>
        <td>{{costCenter.value | sxyCount: 'percent'}}</td>
      </tr>    
    </tbody>
  </table>
</div>
`);

 $templateCache.put("salaxy-components/calc/rows/CalcRowDocumentation.html",`<div ng-if="!$ctrl.showLoader()">
  <fieldset>
    <legend>
      <span>{{$ctrl.example.description}}</span>
    </legend>
    <salaxy-input-typeahead ng-if="$ctrl.row.config.kind.name" name="kind" label-type="horizontal" label="Kind for row" ng-change="$ctrl.generateExampleLocally()" ng-model="$ctrl.selectedKind" enum="{{$ctrl.row.config.kind.name}}" ></salaxy-input-typeahead>
  </fieldset>
  <div ng-if="$ctrl.exampleSamples.length > 0">
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="$ctrl.tabOptions"
      tabs-id="calcRowDocumentation">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-calcRowDocumentation">
      <div ng-repeat="sample in $ctrl.exampleSamples track by $index" class="tab-pane" id="tab{{ $index + 1 }}-tab">
        <p>{{sample.description}}</p>
        <sxy-code-editor ng-model="sample.code" editor="sample"></sxy-code-editor>
      </div>
    </div>
  </div>
</div>
<div ng-if="$ctrl.showLoader()">
  <salaxy-spinner></salaxy-spinner>
</div>`);

 $templateCache.put("salaxy-components/calc/rows/CalcRowFormula.html",`<div>
  <div ng-if="!$ctrl.editingScript">
    <div class="row">
      <div class="col-md-6">
        <salaxy-input-enum ng-model="$ctrl.selectedScriptName" options="$ctrl.scriptNames" name="scriptName" label="Laskukaavat" label-type="plain"></salaxy-input-enum>
      </div>
      <div class="col-md-6">
        <button class="btn btn-primary" ng-click="$ctrl.addScript()" ng-disabled="$ctrl.selectedScriptAdded">Lisää laskukaava</button>
      </div>
    </div>
    <table style="margin-top: 10px;">
      <thead>
        <tr>
          <th width="20%">Nimi</th>
          <th width="20%">Kuvaus</th>
          <th width="50%">Kaava</th>
          <th width="10%"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="prop in $ctrl.row.config.scripts">
          <td width="20%">{{ prop.name }}</td>
          <td width="20%">{{ $ctrl.getDescription(prop.name) }}</td>
          <td width="50%">
            <textarea class="form-control" style="width: 100%; height: 48px;" ng-model="prop.script" readonly></textarea>
          </td>
          <td width="10%">
            <button type="button" class="edit btn btn-info btn-sm" ng-click="$ctrl.editScript(prop)"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}"><i class="bi bi-pencil-fill"></i></button>
            <button type="button" class="delete btn btn-danger btn-sm" ng-click="$ctrl.removeScript(prop)"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}"><i class="bi bi-trash-fill"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-if="$ctrl.editingScript">
    <div class="row" ng-if="!$ctrl.selectedCalc">
      <div class="col d-flex justify-content-start gap-2">
        <button ng-click="$ctrl.addExistingCalc()"  class="btn btn-default" sxy-text="Lisää laskelma..."></button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive" ng-if="$ctrl.selectedCalc">    
          <table class="table">
            <tbody>
              <tr>
                <td class="td-avatar hidden-xxs middle">
                  <salaxy-avatar avatar="$ctrl.selectedCalc.worker.avatar"></salaxy-avatar>
                </td>
                <td class="td-name hidden-xxs middle">
                  <strong>{{$ctrl.selectedCalc.worker.avatar.displayName}}</strong><br />
                </td>
                <td class="hidden-xxs middle">
                  {{ $ctrl.selectedCalc.workflow.status ? ("SALAXY.ENUM.CalculationStatus." + $ctrl.selectedCalc.workflow.status + ".label" | sxyTranslate) : "#ERR" }}<br /> {{ $ctrl.selectedCalc.workflow.salaryDate | date }}
                </td>
                <td class="right hidden-xxs middle">
                  {{ $ctrl.selectedCalc.result.totals.totalGrossSalary | currency }}
                </td>
                <td>
                  <a class="btn btn-secondary btn-sm"  target="_blank" ng-href="#/calc/details/{{$ctrl.selectedCalc.id}}">
                    Avaa laskelma
                </td>
                <td class="right middle">
                  <button class="btn btn-sm btn-danger" type="button" ng-click="$ctrl.selectedCalc = undefined;$ctrl.selectedEmployment = undefined;">
                    <i class="bi bi-x-circle"></i>
                  </button>
                </td>
                
              </tr>
            </tbody>    
          </table>
        </div>
      </div>
      <div ng-if="$ctrl.selectedCalc">
        <salaxy-calc-rows-2019-editor parent="$ctrl.selectedCalc" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calcRowEditor.title' | sxyTranslate}}" mode="edit" show-edit-buttons="true"></salaxy-calc-rows-2019-editor>
      </div>
      <hr>
      <div ng-if="$ctrl.selectedEmployment">
        <div class="float-end">
          <salaxy-json-formatter key="'Debug'" sxy-if-role="test" json="$ctrl.selectedEmployment.work.salaryDefaults" open="1" type="dialog"></salaxy-json-formatter>
        </div>
        <p>Oletuspalkkarivit kopioidaan uudelle laskelmalle sellaisenaan. Päivämäärärajaukset huomioidaan vain tuntien sisääntuonnissa.</p>  
        <salaxy-calc-rows-editor rows="$ctrl.selectedEmployment.work.salaryDefaults" row-sources="thisproperty will be removed, just a marker until refactoring"
          title="{{ 'SALAXY.NG1.WorkerDetailsComponent.defaultCalcRows' | sxyTranslate }}" type="salary-defaults-temp2" mode="edit"></salaxy-calc-rows-editor>
        <hr>
        <p>Hintoja käytetään tällä hetkellä tuntien sisään tuonnissa. Myöhemmissä versioissa oletushintoja käytetään myös laskurissa.</p>
        <salaxy-row-types-settings ng-ref="$ctrl.$prices" mode="prices" model="$ctrl.selectedEmployment"></salaxy-row-types-settings>
      </div>
    </div>
    <sxy-code-editor ng-model="$ctrl.editingScript.script" editor="formula"></sxy-code-editor>
    <div class="row">
      <div class="col-md-6">
        <button class="btn btn-primary" ng-disabled="!$ctrl.isScriptEvaluatable()" ng-click="$ctrl.evaluateEditingScript()">Testaa kaava</button>
      </div>      
      <div class="col-md-6">
        <button class="btn btn-default" ng-click="$ctrl.editScript(undefined)">Sulje kaavan muokkaus</button>
      </div>
    </div>
    <div class="row" ng-if="$ctrl.evalResult">
      <div class="col-md-12">
        <span>Kaavan tulos:</span><pre>{{$ctrl.evalResult}}</pre>
      </div>
    </div>
    
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/rows/CalcRows2019EditDialog-irIncomeType.html",`<salaxy-tab-buttons
  current-tab="$ctrl.currentTab"
  options="[
    { value: 'basic', text: 'Perustiedot' },
    { value: 'incometype', text: 'SALAXY.NG1.CalcRowsComponent.irRows.irFlagsInfo' },
    { value: 'sidecosts', text: 'SALAXY.NG1.CalcRowsComponent.irRows.taxAndSideCosts' }
  ]"
  tabs-id="irIncomeType">
</salaxy-tab-buttons>
<div class="tab-content" id="tab-content-irIncomeType">
  <div class="tab-pane" id="basic-tab">
    <div class="col">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.textAndIncomeType"></legend>
        <salaxy-input-income-type name="code" ng-model="$ctrl.current.data.irData.code"  hidden-codes="[1]" label="SALAXY.NG1.CalcRowsComponent.irRows.incomeTypeLabel" ng-change="$ctrl.updateUsecase($ctrl.current)">
        </salaxy-input-income-type>
        <salaxy-input name="message" ng-model="$ctrl.current.message" label="SALAXY.NG1.CalcRowsComponent.irRows.messageLabel" placeholder="{{$ctrl.getMessagePlaceholderText($ctrl.current)}}"></salaxy-input>

        <salaxy-form-group label="SALAXY.NG1.CalcRowsComponent.irRows.paymentToCreditTransferLabel" name="paymentDefault">
          <!--TODO -->
          <div ng-if="$ctrl.getIrCodeData().paymentDefault == 1" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.payment"></div>
          <div ng-if="$ctrl.getIrCodeData().paymentDefault == -1" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.deduction"></div>
          <div ng-if="$ctrl.getIrCodeData().paymentDefault == 0" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.noPayment"></div>
        </salaxy-form-group>
      </fieldset>
    </div>
    <div class="col">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.calc"></legend>
        <salaxy-input-number name="count" ng-model="$ctrl.current.count" label="SALAXY.NG1.CalcRowsComponent.irRows.countLabel"></salaxy-input-number>
        <salaxy-input-enum name="unit" label="SALAXY.NG1.CalcRowsComponent.irRows.unitLabel" enum="Unit" ng-model="$ctrl.current.data.unit" type="select"></salaxy-input-enum>
        <salaxy-input-number name="price" ng-model="$ctrl.current.price" label="SALAXY.NG1.CalcRowsComponent.irRows.priceLabel"></salaxy-input-number>
        <salaxy-form-group name="total" label="SALAXY.NG1.CalcRowsComponent.irRows.totalLabel">
          <p>{{ $ctrl.current.count * $ctrl.current.price | currency }}</p>
        </salaxy-form-group>
      </fieldset>
    </div>
    <div class="col" ng-if="$ctrl.current.data.irData.code == 304">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitInfo"></legend>
        <p sxy-html="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitInfoHtml"></p>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitTypeLabel" enum="CarBenefitCode" name="carBenefitCode" ng-model="$ctrl.current.data.irData.carBenefit.carBenefitCode"
          type="select"></salaxy-input-enum>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitAgeGroupLabel" enum="AgeGroupCode" name="ageGroupCode" ng-model="$ctrl.current.data.irData.carBenefit.ageGroupCode" type="select">
        </salaxy-input-enum>
        <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitEmissionsValueLabel" name="emissionsValue" minimum="0" maximum="100" ng-model="$ctrl.current.data.irData.carBenefit.emissionsValue"></salaxy-input-number>
        <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitKilometersLabel" name="kilometers" ng-model="$ctrl.current.data.irData.carBenefit.kilometers"></salaxy-input-number>     
      </fieldset>
    </div>
    <div class="col" ng-if="$ctrl.current.data.irData.code == 331">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.dailyAllowanceAdditionalSelections"></legend>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.dailyAllowanceTypeLabel" enum="AllowanceCode" name="dailyAllowance" type="multi-select"
          ng-model="$ctrl.current.data.irData.dailyAllowance" require="true"></salaxy-input-enum>
      </fieldset>
    </div>

    <div class="col" ng-if="$ctrl.current.data.irData.code == 334">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.mealBenefitAdditionalSelections"></legend>
        <p sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.mealBenefitTaxInfo"></p>
        <salaxy-input-boolean type="checkbox" name="mealBenefitIsTaxValue" ng-model="$ctrl.current.data.irData.mealBenefitIsTaxValue" label-type="plain"
          label-true="SALAXY.NG1.CalcRowsComponent.irRows.mealBenefitIsTaxValueLabel"></salaxy-input-boolean>
      </fieldset>
    </div>
  </div>
  <div class="tab-pane" id="incometype-tab">
    <div class="col">
      <fieldset>
        <legend>{{ $ctrl.getMessagePlaceholderText($ctrl.current) }} ({{ $ctrl.current.data.irData.code }})</legend>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.irFlagsLabel" enum="IrFlags" name="flags" type="multi-select" ng-model="$ctrl.current.data.irData.flags"></salaxy-input-enum>
        <salaxy-form-group label="SALAXY.NG1.CalcRowsComponent.irRows.negativeSupportedLabel" name="isNegativeSupported">
          <div ng-if="$ctrl.getIrCodeData().isNegativeSupported" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.allowed"></div>
          <div ng-if="!$ctrl.getIrCodeData().isNegativeSupported" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.notAllowed"></div>
        </salaxy-form-group>
        <div style="white-space: pre-wrap">{{ $ctrl.getIrCodeData().description }}</div>
      </fieldset>
    </div>
    <div class="col">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriod"></legend>
        <p sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriodInfo"></p>
        <salaxy-datepicker-popup name="startDate" label="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriodStartDateLabel" ng-model="$ctrl.current.data.earningPeriod.start"></salaxy-datepicker-popup>
        <salaxy-datepicker-popup name="endDate" label="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriodEndDateLabel" ng-model="$ctrl.current.data.earningPeriod.end"></salaxy-datepicker-popup>
      </fieldset>
    </div>
  </div>
  <div class="tab-pane" id="sidecosts-tab">
    <div class="col">
      <fieldset>
        <legend>{{ $ctrl.getMessagePlaceholderText($ctrl.current) }}</legend>
        <div style="white-space: pre-wrap">{{ $ctrl.getIrCodeData().taxAndSidecostsDescr }}</div>
        <table class="table">
          <tbody>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.tax"></th>
              <td>
                <div ng-if="$ctrl.getIrCodeData().taxDefault == 1" class="text-success" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.withheld"></div>
                <div ng-if="$ctrl.getIrCodeData().taxDefault == -1" class="text-warning" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.deductionAlt"></div>
                <div ng-if="$ctrl.getIrCodeData().taxDefault == 0" class="text-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.notwithheld"></div>
              </td>
              <td></td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.socialSecurityPayment"></th>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.toBePaid"></th>
              <th>
                <!-- TODO: Lisää tähän srakkeeseen tieto poikkeuksen jälkeen-->
              </th>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.occupationPension"></th>
              <td>
                <span ng-class="$ctrl.getIrCodeData().pensionInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.getIrCodeData().pensionInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.insurancePayment"></th>
              <td>
                <span ng-class="$ctrl.getIrCodeData().accidentInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.getIrCodeData().accidentInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td></td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.unemploymentInsurancePayment"></th>
              <td>
                <span ng-class="$ctrl.getIrCodeData().unemploymentInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.getIrCodeData().unemploymentInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td></td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.healtInsurancePayment"></th>
              <td>
                <span ng-class="$ctrl.getIrCodeData().healthInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.getIrCodeData().healthInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div ng-if="!$ctrl.getIrCodeData().insuranceInformationAllowed">
          <p sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.insuranceInformationAllowed"></p>
        </div>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.IrInsuranceExceptions" enum="IrInsuranceExceptions" name="dailyAllowance" disabled="$ctrl.isIrRowReadOnly"
          ng-if="$ctrl.getIrCodeData().insuranceInformationAllowed" ng-model="$ctrl.current.data.irData.insuranceExceptions" type="multi-select">
        </salaxy-input-enum>
      </fieldset>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/rows/CalcRows2019EditDialog.html",`<div class="salaxy-calc-details-dialog" ng-style="{ 'position': $ctrl.isDialog ? 'absolute' : 'initial' }">

  <div class="card card-detail" ng-style="{'border-color':$ctrl.getConfig().color}">

    <form class="form-horizontal" ng-readonly="!$ctrl.isEditable">
      <div class="card-header d-flex" ng-style="{'background-color':$ctrl.getConfig().color, 'border-color':$ctrl.getConfig().color}">
        <div class="avatar-container">
          <salaxy-avatar avatar="{ color: $ctrl.getConfig().color, initials: $ctrl.getConfig().iconText, entityType: 'company' }">
          </salaxy-avatar>
        </div>
        <div class="flex-grow">
          <h1 class="truncate">
            {{ $ctrl.getConfig().label }}
            <span class="smaller" ng-if="$ctrl.current.message"> - {{$ctrl.current.message}}</span>
          </h1>
          <p class="calc-text">{{$ctrl.current.count}} <span ng-if="$ctrl.current.count">&times;</span> {{$ctrl.current.price}}
            <span class="result-text">{{ $ctrl.getRowTotal($ctrl.current) | currency }}</span>
          </p>
        </div>
        <div class="d-flex justify-content-between flex-column ms-auto">
          <button type="button" class="btn-close align-self-end" ng-click="$ctrl.closeEditDialog('cancel', $close)" aria-label="Close"></button>
          <a ng-show="$ctrl.getConfig().moreInfo || $ctrl.getConfig().incomeTypes.length > 0" class="btn-link btn-showmore" ng-click="showInfo = !showInfo">{{!showInfo ?
            ('SALAXY.NG1.CalcRowsComponent.editDialog.showInfo' | sxyTranslate) : ('SALAXY.NG1.CalcRowsComponent.editDialog.hideInfo' | sxyTranslate)}}
            <i class="bi bi-info-circle-fill ms-1"></i>
          </a>
        </div>
      </div>
      <div class="card-body">
        <p>{{ $ctrl.getConfig().descr }}
          <!-- TODO: We should have full HTML formatting here instead of just white-space: pre-wrap -->
          <span class="collapse" ng-class="{show: showInfo}" style="white-space: pre-wrap;"><br>{{ $ctrl.getConfig().moreInfo }}</span>
        </p>
        <div ng-if="showInfo && $ctrl.getConfig().incomeTypes.length > 0" class="mb-3">
          <p>{{'SALAXY.NG1.CalcRowsComponent.editDialog.incomeTypesInfo' | sxyTranslate}}:</p>
          <div class="accordion accordion-flush salaxy-accordion" id="incomeTypes">
            <div ng-repeat="type in $ctrl.getConfig().incomeTypes track by $index" class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#type{{$index}}">
                  {{$ctrl.getIrCodeDataWithCode(type).code}} {{$ctrl.getIrCodeDataWithCode(type).label}}
                </button>
              </h2>
              <div id="type{{$index}}" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#incomeTypes">
                <div class="accordion-body">
                  <p>{{$ctrl.getIrCodeDataWithCode(type).description}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <!-- TODO: The row specific UI's need to be refactored to a better structure soon. -->
          <div ng-switch="$ctrl.current.rowType">
            <div ng-switch-when="salary|paidSickLeaveSalary|trainingSalary|monthlySalary|paidSickLeaveMonthlySalary|trainingMonthlySalary|compensation"
              ng-switch-when-separator="|">
              <!-- Row types that have count hidden, but should be shown in edit -->
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'amount') }}"></salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'price') }}"  ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="irIncomeType">
              <ng-include src="'salaxy-components/calc/rows/CalcRows2019EditDialog-irIncomeType.html'"></ng-include>
            </div>
            <div ng-switch-when="unionPayment">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.unionPaymentLabel" label-type="horizontal" enum="UnionPaymentKind" hidden-options="other,undefined"
                require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="UnionPaymentKind" ng-model="$ctrl.current.data.kind" type="select">
              </salaxy-input-enum>
              <div class="alert alert-warning" ng-if="$ctrl.current.data.kind == 'raksaNormal' ||  $ctrl.current.data.kind == 'raksaUnemploymentOnly'">
                <p sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.raksaInfo"></p>
              </div>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'percentage' || $ctrl.current.data.kind == 'raksaNormal' ||
                $ctrl.current.data.kind == 'raksaUnemploymentOnly'" required="true" ng-model="$ctrl.current.count" name="count" label-type="horizontal" unit="percent"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.percentOfSalary"
                disabled="$ctrl.current.data.kind == 'raksaNormal' ||  $ctrl.current.data.kind == 'raksaUnemploymentOnly'" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind !='percentageAndLimits'" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.current.data.kind != 'fixed'"
                label="{{$ctrl.current.data.kind == 'fixed' ? ('SALAXY.NG1.CalcRowsComponent.editDialog.unionPaymentCount' | sxyTranslate) : ('SALAXY.NG1.CalcRowsComponent.editDialog.underTaxSalary' | sxyTranslate)}}"
                ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'percentageAndLimits'" required="true" ng-model="$ctrl.current.data.paymentPercentage" name="paymentPercentage"
                label-type="horizontal" unit="percent" label="SALAXY.NG1.CalcRowsComponent.editDialog.percentOfSalary" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind =='percentageAndLimits'" ng-model="$ctrl.current.data.minimumPayment" name="minimumPayment"
                label-type="horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.unionPayment.minimumPayment" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind =='percentageAndLimits'" ng-model="$ctrl.current.data.maximumPayment" name="maximumPayment"
                label-type="horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.unionPayment.maximumPayment" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>

              <div class="row">
                <div class="input-info offset-4 col-8">
                  <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
                  <p class="small input-info-text with-icon" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.fillUnionPaymentInformation"></p>
                </div>
              </div>
              <salaxy-input ng-model="$ctrl.current.data.recipientFullName" name="unionFullName" label-type="horizontal" require="false"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.unionLabel"></salaxy-input>
              <salaxy-input ng-model="$ctrl.current.data.iban" name="unionIban" label-type="horizontal" require="false"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.unionIbanLabel" sxy-iban>
              </salaxy-input>
              <salaxy-input ng-model="$ctrl.current.data.referenceNumber" name="unionReferenceNumber" label-type="horizontal" require="false"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.unionReferenceNumberLabel" sxy-bank-reference-fi></salaxy-input>
            </div>
            <div ng-switch-when="foreclosure">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureKindLabel" label-type="horizontal" enum="ForeclosureKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="ForeclosureKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <salaxy-input-number ng-model="$ctrl.current.count" name="count" label-type="horizontal" unit="{{$ctrl.getConfig().amount.unit}}"
                disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'" label="{{$ctrl.getConfig().amount.label}}"
                ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-number ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.current.data.kind == 'periodic' || $ctrl.current.data.kind == 'nonPeriodic'" label="{{$ctrl.getConfig().price.label}}"
                ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'periodic'" ng-model="$ctrl.current.data.periodLength" name="periodLength" label-type="horizontal"
                disabled="true" label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosurePeriodLengthLabel" ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'periodic'" ng-model="$ctrl.current.data.protectedPortionBase" name="protectedPortionBase"
                label-type="horizontal" require="true" label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureprotectedPortionBaseLabel"
                ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'periodic'" ng-model="$ctrl.current.data.protectedPortionDependant" name="protectedPortionDependant"
                label-type="horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureprotectedPortionDependantLabel" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'periodic'" sxy-integer ng-model="$ctrl.current.data.dependantsCount" name="dependantsCount"
                label-type="horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosuredependantsCountLabel" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'periodic'" ng-model="$ctrl.current.data.incomeFromOtherSources" name="incomeFromOtherSources"
                label-type="horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureincomeFromOtherSourcesLabel" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'periodic'" ng-model="$ctrl.current.data.additionalAmountLeftToDebtor" name="additionalAmountLeftToDebtor"
                label-type="horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureadditionalAmountLeftToDebtorLabel" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <div class="row">
                <div class="input-info offset-4 col-8">
                  <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
                  <p class="small input-info-text with-icon" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureReferenceNumberInfo"></p>
                </div>
              </div>
              <salaxy-input ng-model="$ctrl.current.data.referenceNumber" name="referenceNumber" label-type="horizontal" require="false"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureReferenceNumberLabel" sxy-bank-reference-fi></salaxy-input>
            </div>
            <div ng-switch-when="totalWorkerPayment">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.totalWorkerPaymentKindLabel" label-type="horizontal" enum="TotalWorkerPaymentKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="TotalWorkerPaymentKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <salaxy-input-number ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.totalWorkerSumLabel" ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.totalWorkerCalculationRowTypeLabel" label-type="horizontal" enum="CalculationRowType" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="CalculationRowType" ng-model="$ctrl.current.data.rowType" filter="salary,monthlySalary" type="select">
              </salaxy-input-enum>
              <salaxy-input ng-model="$ctrl.current.data.message" name="message" label-type="horizontal" require="false"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.totalWorkerCalculationMessage"></salaxy-input>
            </div>
            <div ng-switch-when="carBenefit">
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.carBenefitCode" label-type="horizontal" enum="CarBenefitCode" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="CarBenefitCode" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.ageGroupCode" label-type="horizontal" enum="AgeGroupCode" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" hidden-options="undefined,u" name="AgeGroupCode" ng-model="$ctrl.current.data.ageGroup" type="select">
              </salaxy-input-enum>
              <salaxy-input-boolean type="checkbox" name="isKilometersBased" label="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.kilometersBased"
                label-true="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.kilometersBasedTrue" label-type="horizontal" ng-model="$ctrl.current.data.isKilometersBased">
              </salaxy-input-boolean>
              <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.kilometers" ng-model="$ctrl.current.data.kilometers" name="kilometers"
                label-type="horizontal" require="true" ng-if="$ctrl.current.data.isKilometersBased"></salaxy-input-number>
              <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.deduction" ng-model="$ctrl.current.data.deduction" name="deduction"
                label-type="horizontal"></salaxy-input-number>
              <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.emissionsValue" ng-model="$ctrl.current.data.emissionsValue" name="emissionsValue"
                label-type="horizontal" minimum="0" maximum="100"></salaxy-input-number>
            </div>
            <div ng-switch-when="subsidisedCommute">
              <p sxy-html="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.info.html"></p>
              <div ng-init="$subsidisedCommute = $ctrl.getUsecaseLogic($ctrl.current)">
                <salaxy-input-number ng-change="$subsidisedCommute.updateUsecase()" label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price"
                  label-type="horizontal" require="true" disabled="$ctrl.isDisabled($ctrl.current, 'price')"
                  ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
                <salaxy-input-enum ng-change="$subsidisedCommute.updateUsecase()" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.subsidisedCommuteKind"
                  label-type="horizontal" enum="SubsidisedCommuteKind" require="true" name="SubsidisedCommuteKind" ng-model="$ctrl.current.data.kind" type="select">
                </salaxy-input-enum>
                <salaxy-input-number ng-change="$subsidisedCommute.updateUsecase()" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.deduction"
                  ng-model="$ctrl.current.data.deduction" name="deduction" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-change="$subsidisedCommute.updateUsecase()" ng-if="$ctrl.isEditable && !$subsidisedCommute.isBefore2021"
                  placeholder="{{$subsidisedCommute.calculatedTaxable | number : 2}}" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.taxable"
                  ng-model="$ctrl.current.data.taxable" name="taxable" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-if="$ctrl.isEditable && !$subsidisedCommute.isBefore2021" placeholder="{{$subsidisedCommute.calculatedTaxfree | number : 2}}"
                  disabled="true" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.taxfree" ng-model="subsidisedCommuteForDisplayOnly" name="taxfree"
                  label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-if="!$ctrl.isEditable && !$subsidisedCommute.isBefore2021" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.taxable"
                  ng-model="$subsidisedCommute.calculatedTaxable" name="taxable" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-if="!$ctrl.isEditable && !$subsidisedCommute.isBefore2021" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.taxfree"
                  ng-model="$subsidisedCommute.calculatedTaxfree" name="taxfree" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-change="$subsidisedCommute.updateUsecase()" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.periodDivider"
                  ng-model="$ctrl.current.data.periodDivider" name="periodDivider" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
              </div>
            </div>
            <div ng-switch-when="bicycleBenefit">
              <div ng-init="$bicycleBenefit = $ctrl.getUsecaseLogic($ctrl.current)">
                <salaxy-input-number ng-change="$bicycleBenefit.updateUsecase()" label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price"
                  label-type="horizontal" require="true" disabled="$ctrl.isDisabled($ctrl.current, 'price')"
                  ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
                <salaxy-input-enum ng-change="$bicycleBenefit.updateUsecase()" label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.bicycleBenefitKind"
                  label-type="horizontal" enum="BicycleBenefitKind" require="true" name="BicycleBenefitKind" ng-model="$ctrl.current.data.kind" type="select">
                </salaxy-input-enum>
                <salaxy-input-number ng-change="$bicycleBenefit.updateUsecase()" label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.deduction"
                  ng-model="$ctrl.current.data.deduction" name="deduction" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-change="$bicycleBenefit.updateUsecase()" ng-if="$ctrl.isEditable" placeholder="{{$bicycleBenefit.calculatedTaxable | number : 2}}"
                  label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.taxable" ng-model="$ctrl.current.data.taxable" name="taxable" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-if="$ctrl.isEditable" placeholder="{{$bicycleBenefit.calculatedTaxfree | number : 2}}" disabled="true"
                  label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.taxfree" ng-model="bicycleBenefitForDisplayOnly" name="taxfree" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-if="!$ctrl.isEditable" label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.taxable" ng-model="$bicycleBenefit.calculatedTaxable"
                  name="taxable" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-if="!$ctrl.isEditable" label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.taxfree" ng-model="$bicycleBenefit.calculatedTaxfree"
                  name="taxfree" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-change="$bicycleBenefit.updateUsecase()" label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.periodDivider"
                  ng-model="$ctrl.current.data.periodDivider" name="periodDivider" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
              </div>
            </div>
            <div ng-switch-when="nonProfitOrg">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.nonProfitOrg.profitOrgKind" label-type="horizontal" enum="NonProfitOrgKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="NonProfitOrgKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="dailyAllowance">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.dailyAllowance.allowanceKind" hidden-options="mealAllowance" label-type="horizontal"
                enum="DailyAllowanceKind" require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="DailyAllowanceKind" ng-model="$ctrl.current.data.kind" type="select">
              </salaxy-input-enum>
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.dailyAllowance.internationalDailyAllowanceCount" label-type="horizontal"
                ng-if="$ctrl.current.data.kind === 'internationalDailyAllowance'" options="$ctrl.dailyAllowanceRegions" ng-change="$ctrl.updateUsecase($ctrl.current)"
                name="country" ng-model="$ctrl.current.data.country" type="select">
              </salaxy-input-enum>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="mealBenefit">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.mealBenefitKind" label-type="horizontal" enum="MealBenefitKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="MealBenefitKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <p ng-if="$ctrl.current.data.kind" sxy-text="{{'SALAXY.ENUM.MealBenefitKind.' + $ctrl.current.data.kind + '.descriptionWithYearlyNumbers'}}"
                params="$ctrl.yearlySideCosts"></p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <div ng-switch="$ctrl.current.data.kind">
                <div ng-switch-when="mealAllowance">
                  <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.mealPrice" ng-model="$ctrl.current.price" name="price" label-type="horizontal"
                    ng-change="$ctrl.updateUsecase($ctrl.current)" require="true" disabled="$ctrl.isDisabled($ctrl.current)"></salaxy-input-number>
                </div>
                <div ng-switch-when="taxableAmount|collectedReimbursement|undefined" ng-switch-when-separator="|">
                  <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.mealTaxablePrice" ng-model="$ctrl.current.price" name="price"
                    label-type="horizontal" ng-change="$ctrl.updateUsecase($ctrl.current)" require="true" disabled="$ctrl.isDisabled($ctrl.current)"></salaxy-input-number>
                </div>
                <div ng-switch-when="mealTicket">
                  <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.mealTicketPrice" ng-model="$ctrl.current.price" name="price"
                    label-type="horizontal" ng-change="$ctrl.updateUsecase($ctrl.current)" require="true" disabled="$ctrl.isDisabled($ctrl.current)"></salaxy-input-number>
                </div>
                <div ng-switch-when="cateringContract|institute|restaurantWorker|teacher" ng-switch-when-separator="|">
                  <salaxy-input-number disabled="true" label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.mealTaxablePrice" ng-model="$ctrl.current.price" name="price"
                    label-type="horizontal"></salaxy-input-number>
                </div>
              </div>
              <div ng-if="$ctrl.current.data.kind != 'mealAllowance'">
                <salaxy-form-group ng-if="$ctrl.current.data.kind != 'collectedReimbursement'" label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.mealPriceAmount"
                  name="taxablePrice" label-type="horizontal">
                  <label class="control-label">{{ $ctrl.current.data.taxablePrice * ($ctrl.current.count || 1.0) | currency }}</label>
                </salaxy-form-group>
                <salaxy-input-boolean ng-if="$ctrl.current.data.kind != 'collectedReimbursement'" label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.workerDeduction"
                  label-true="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.taxValueTrue" label-false="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.taxValueFalse"
                  name="isTaxValue" type="radio" ng-model="$ctrl.current.data.isTaxValue" label-type="horizontal" ng-change="$ctrl.updateUsecase($ctrl.current)" require="true"
                  disabled="$ctrl.isDisabled($ctrl.current)"></salaxy-input-boolean>
                <salaxy-input-boolean ng-if="$ctrl.current.data.kind != 'collectedReimbursement' && $ctrl.current.data.isTaxValue"
                  label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.isTaxValueDeductionDone"
                  label-true="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.isTaxValueDeductionDoneTrue"
                  label-false="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.isTaxValueDeductionDoneFalse" name="isTaxValueDeductionDone" type="radio"
                  ng-model="$ctrl.current.data.isTaxValueDeductionDone" label-type="horizontal" ng-change="$ctrl.updateUsecase($ctrl.current)" require="true"
                  disabled="$ctrl.isDisabled($ctrl.current)"></salaxy-input-boolean>
                <salaxy-form-group ng-if="$ctrl.current.data.isTaxValue" label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.deduction" name="deductionWhenTaxValue"
                  label-type="horizontal">
                  <label class="control-label">{{ $ctrl.current.data.taxablePrice * ($ctrl.current.count || 1.0) | currency }}</label>
                </salaxy-form-group>
                <salaxy-input-number ng-if="$ctrl.current.data.kind != 'collectedReimbursement' && !$ctrl.current.data.isTaxValue"
                  label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.deduction" ng-model="$ctrl.current.data.deduction" name="deduction" label-type="horizontal"
                  ng-change="$ctrl.updateUsecase($ctrl.current)" disabled="$ctrl.isDisabled($ctrl.current)"></salaxy-input-number>
              </div>
            </div>
            <div ng-switch-when="board">
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="remuneration">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.remuneration.remunerationKind" label-type="horizontal" enum="RemunerationKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="RemunerationKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <p>{{ "RemunerationKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number ng-if="$ctrl.getConfig().amount.units.length > 1" on-unit-change="$ctrl.current.unit=unit" label="{{$ctrl.getConfig().amount.label}}"
                ng-model="$ctrl.current.count" name="count" label-type="horizontal" unit="{{$ctrl.ensureUnit($ctrl.current)}}" units="$ctrl.getConfig().amount.units"
                disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number ng-if="!($ctrl.getConfig().amount.units.length > 1)" label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count"
                label-type="horizontal" unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')"
                ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="otherCompensation">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.otherCompensation.compensationKind" label-type="horizontal" enum="OtherCompensationKind"
                require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="OtherCompensationKind" ng-model="$ctrl.current.data.kind" type="select">
              </salaxy-input-enum>
              <p>{{ "OtherCompensationKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="workingTimeCompensation">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.workingTimeCompensation.compensationKind" label-type="horizontal" enum="WorkingTimeCompensationKind"
                require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="WorkingTimeCompensation" ng-model="$ctrl.current.data.kind" type="select">
              </salaxy-input-enum>
              <p>{{ "WorkingTimeCompensationKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="employmentTermination">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.employmentTermination.employmentTerminationKind" label-type="horizontal"
                enum="EmploymentTerminationKind" require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="EmploymentTermination" ng-model="$ctrl.current.data.kind"
                type="select"></salaxy-input-enum>
              <p>{{ "EmploymentTerminationKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="paidSickLeave">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.paidSickLeave.paidSickLeaveKind" label-type="horizontal" enum="PaidSickLeaveKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="PaidSickLeaveKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <p>{{ "PaidSickLeaveKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="training">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.training.trainingKind" label-type="horizontal" enum="TrainingKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="TrainingKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <p>{{ "TrainingKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="hourlySalaryWithWorkingTimeCompensation">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.WorkingTimeCompensationKind" label-type="horizontal" enum="WorkingTimeCompensationKind"
                require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="HourlySalaryWithWorkingTimeCompensation" ng-model="$ctrl.current.data.kind" type="select">
              </salaxy-input-enum>
              <p>{{ "WorkingTimeCompensationKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-change="$ctrl.updateUsecase($ctrl.current)"
                ng-if="$ctrl.getConfig().amount.input != 'hidden'"></salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-change="$ctrl.updateUsecase($ctrl.current)" ng-if="$ctrl.getConfig().price.input != 'hidden'">
              </salaxy-input-number>
              <style>
                div.input-group-addon {
                  display: none;
                }

                div.input-group {
                  width: 100%
                }
              </style>
              <div>
                <salaxy-input label="SALAXY.NG1.CalcRowsComponent.editDialog.additionalRows.description" label-type="horizontal" disabled="$ctrl.isDisabled($ctrl.current)"
                  ng-model="$ctrl.current.message" name="message" placeholder="{{$ctrl.getMessagePlaceholderText($ctrl.current)}}"></salaxy-input>
              </div>
              <hr>
              <div ng-repeat="cr in $ctrl.current.data.compensationRows">
                <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.hourlySalaryWithWorkingTimeCompensationRowCountLabel" ng-model="cr.count" name="crCount" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="{{$ctrl.current.count || 1}}" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-change="$ctrl.updateUsecase($ctrl.current)"
                ng-if="$ctrl.getConfig().amount.input != 'hidden'"></salaxy-input-number>
                <salaxy-form-group name="compensationRow" label-type="form-horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.hourlySalaryWithWorkingTimeCompensationRowLabel" required="true">
                  <div class="input-group">
                    <salaxy-input-number ng-if="$ctrl.current.data.pricing == 'percent'" ng-model="cr.percent" class="flex-grow-1" name="percent" label-type="plain" require="true" unit="percent"
                      ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
                    <salaxy-input-number ng-if="$ctrl.current.data.pricing != 'percent'" ng-model="cr.price" name="price" label-type="plain" require="true"
                      ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
                    <div class="btn-group">
                      <button id="compUnit" type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        {{ $ctrl.current.data.pricing == 'percent' ? "%" : "€" }}
                      </button>
                      <ul class="dropdown-menu" aria-labelledby="compUnit">
                        <li><a class="dropdown-item" href="" ng-click="$ctrl.current.data.pricing = 'percent'; $ctrl.updateUsecase($ctrl.current)">%</a></li>
                        <li><a class="dropdown-item" href="" ng-click="$ctrl.current.data.pricing = 'fixed'; $ctrl.updateUsecase($ctrl.current)">€</a></li>
                      </ul>
                    </div>
                  </div>
                </salaxy-form-group>
                <salaxy-input label="SALAXY.NG1.CalcRowsComponent.editDialog.hourlySalaryWithWorkingTimeCompensationRowMessageLabel" label-type="horizontal" disabled="$ctrl.isDisabled($ctrl.current)"
                  ng-model="cr.message" name="crMessage" placeholder="{{ 'WorkingTimeCompensationKind.' + $ctrl.current.data.kind | sxyEnum }}"></salaxy-input>
              </div>
            </div>
            <div ng-switch-when="milageOwnCar">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.milageOwnCar.vehicleType" label-type="horizontal" options="$ctrl.getVehicleTypeSelection()"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="vehicleType" ng-model="$ctrl.current.data.vehicleType" type="select"></salaxy-input-enum>
              <salaxy-input-enum ng-if="$ctrl.current.data.additionsAllowed" label="SALAXY.NG1.CalcRowsComponent.editDialog.milageOwnCar.additions" label-type="horizontal"
                options="$ctrl.getVehicleAdditions()" ng-change="$ctrl.updateUsecase($ctrl.current)" name="additions" ng-model="$ctrl.current.data.additions"
                type="select"></salaxy-input-enum>
              <salaxy-input-number ng-if="$ctrl.current.data.passengersAllowed" label="SALAXY.NG1.CalcRowsComponent.editDialog.milageOwnCar.passangerCount" unit="count"
                label-type="horizontal" ng-model="$ctrl.current.data.passengerCount" name="passengerCount" ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal"
                disabled="$ctrl.current.data.vehicleType != 'custom'" ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
            </div>
            <div ng-switch-when="taxAtSource">
              <salaxy-input-number label="Palkkasumma ennen vähennystä" ng-model="$ctrl.current.data.totalTaxable" name="totalTaxable" label-type="horizontal"
                disabled="true"></salaxy-input-number>
              <salaxy-input-enum label="Vähennyksen tyyppi" filter="{{ $ctrl.current.data.allowedKinds }}" label-type="horizontal" enum="TaxAtSourceKind"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="taxAtSourceKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <div ng-if="$ctrl.current.data.kind == 'monthlyDeduction' || $ctrl.current.data.kind == 'dailyDeduction'" class="input-info offset-4 col-8">
                <p>{{ $ctrl.current.data.deductionCount | sxyCount }} * {{ $ctrl.current.data.deductionPrice | currency }} = {{ $ctrl.current.data.deduction | currency }}</p>
              </div>
              <div ng-if="$ctrl.current.data.kind == 'fixedValues'">
                <salaxy-input-number label="Kiinteä vähennys" ng-model="$ctrl.current.data.deduction" name="deduction" unit="eur" label-type="horizontal"
                  ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
                <salaxy-input-number label="Kiinteä lähdevero" ng-model="$ctrl.current.data.taxValue" name="taxValue" unit="eur" label-type="horizontal"
                  ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              </div>
              <div ng-if="$ctrl.current.data.kind != 'fixedValues'">
                <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal"
                  ng-change="$ctrl.updateUsecase($ctrl.current)" disabled="true"></salaxy-input-number>
                <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                  unit="{{$ctrl.getConfig().amount.unit}}" disabled="true"></salaxy-input-number>
                <salaxy-input-number label="Lähdevero" ng-model="$ctrl.current.data.taxValue" name="taxValue" label-type="horizontal" unit="eur"
                  disabled="true"></salaxy-input-number>
              </div>
            </div>
            <div ng-switch-when="taxWithholding">
              <salaxy-input-enum label="SALAXY.ENUM.TaxWithholdingKind.label" label-type="horizontal" enum="TaxWithholdingKind" ng-change="$ctrl.updateUsecase($ctrl.current)"
                name="taxWithholdingKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <div ng-switch="$ctrl.current.data.kind">
                <salaxy-input-number ng-switch-when="percentage" label="SALAXY.ENUM.TaxWithholdingKind.percentage.label" ng-model="$ctrl.current.data.taxValue" name="percentage"
                  label-type="horizontal" ng-change="$ctrl.updateUsecase($ctrl.current)" require="true" unit="percent"></salaxy-input-number>
                <salaxy-input-number ng-switch-when="fixedValue" label="SALAXY.ENUM.TaxWithholdingKind.fixedValue.label" ng-model="$ctrl.current.data.taxValue" name="fixedvalue"
                  label-type="horizontal" ng-change="$ctrl.updateUsecase($ctrl.current)" require="true" unit="eur"></salaxy-input-number>
              </div>
            </div>
            <div ng-switch-when="absencePeriod" ng-init="$absencesLogic = $ctrl.getUsecaseLogic($ctrl.current)">
              <salaxy-input-enum name="causeCode" ng-model="$ctrl.current.data.kind" enum="AbsenceCauseCode" label="SALAXY.MODEL.WorkerAbsencePeriod.absencesId.title"
                type="select" ng-change="$absencesLogic.updateIsPaid($ctrl.current, true)" require="true"></salaxy-input-enum>
              <salaxy-datepicker-popup name="start" ng-model="$ctrl.current.period.start" ng-change="$absencesLogic.updatePeriodDays($ctrl.current)"
                label="SALAXY.MODEL.DateRange.start.title"></salaxy-datepicker-popup>
              <salaxy-datepicker-popup name="end" ng-model="$ctrl.current.period.end" ng-change="$absencesLogic.updatePeriodDays($ctrl.current)"
                label="SALAXY.MODEL.DateRange.end.title"></salaxy-datepicker-popup>
              <salaxy-form-group name="daysCount" label="SALAXY.MODEL.DateRange.daysCount.title" ng-if="$ctrl.current.period.days == null">
                <div class="input-group">
                  <input class="form-control" type="text" autocomplete="off" id="daysCount" name="daysCount" ng-model="$ctrl.current.period.daysCount" disabled>
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-default" ng-click="$absencesLogic.setDaysSelection($ctrl.current)"
                      sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.editDatesButtonText"></button>
                  </span>
                </div>
              </salaxy-form-group>
              <salaxy-datepicker ng-model="$ctrl.current.period" name="days" is-multiple="true" ng-if="$ctrl.current.period.days.length > 0" label="SALAXY.MODEL.WorkerAbsencePeriod.period.title"></salaxy-datepicker>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'annualLeave'" label="SALAXY.MODEL.WorkerAbsencePeriod.bonusDaysCount.title" ng-model="$ctrl.current.data.bonusDaysCount" name="bonusDaysCount" label-type="horizontal"></salaxy-input-number>
              <salaxy-input-boolean ng-init="$ctrl.current.data.applyPricing = ($ctrl.current.data.applyPricing || false)" type="radio" name="applyPricing" label="SALAXY.MODEL.AbsencePeriodUsecase.applyPricing.title"
                label-true="SALAXY.MODEL.AbsencePeriodUsecase.applyPricing.labelTrue"
                label-false="SALAXY.MODEL.AbsencePeriodUsecase.applyPricing.labelFalse"
                ng-model="$ctrl.current.data.applyPricing">
              </salaxy-input-boolean>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
               placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'price') }}"  ng-if="!$ctrl.current.data.applyPricing"></salaxy-input-number>
              <salaxy-input-boolean type="checkbox" name="isPaid" label="SALAXY.MODEL.WorkerAbsencePeriod.isPaid.title"
                label-true="SALAXY.NG1.AbsencePeriodsEditDialog.label.isPaidLabelTrue" disabled="!$absencesLogic.canSelectIsPaid($ctrl.current)" ng-model="$ctrl.current.data.isPaid"
                ng-change="$ctrl.logic.updateIsHolidayAccrual($ctrl.current)"></salaxy-input-boolean>

              <salaxy-input-boolean type="checkbox" name="isHolidayAccrual" label="SALAXY.MODEL.WorkerAbsencePeriod.isHolidayAccrual.title"
                label-true="SALAXY.NG1.AbsencePeriodsEditDialog.label.isAccrualLabelTrue" ng-model="$ctrl.current.data.isHolidayAccrual"></salaxy-input-boolean>
            </div>
            <div ng-switch-when="expenses" ng-init="$expenseLogic = $ctrl.getUsecaseLogic($ctrl.current)">
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal"
                require="true"></salaxy-input-number>
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercent.label" label-type="horizontal" enum="ExpensesVatRate"
                hidden-options="undefined" require="true" ng-change="$expenseLogic.updateUsecase($ctrl.current)" name="ExpensesVatRate" ng-model="$ctrl.current.data.vatRate"
                type="select"></salaxy-input-enum>

              <div ng-switch="$ctrl.current.data.vatRate">
                <span ng-switch-when="tax255" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p255.description"></span>
                <span ng-switch-when="tax24" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p24.description"></span>
                <span ng-switch-when="tax14" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p14.description"></span>
                <span ng-switch-when="tax135" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p135.description"></span>
                <span ng-switch-when="tax10" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p10.description"></span>
                <span ng-switch-when="tax0" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p0.description"></span>
              </div>
              <div ng-if="$ctrl.current.data.vatRate == 'multiple'">
                <p class="mb-0" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.taxableAmountInPercent" ps=":"></p>
                <div class="row">
                  <salaxy-input-number class="col-sm-3" label="25,5%" label-type="basic" name="inpt5" ng-model="$ctrl.current.accounting.vatEntries[4].gross" ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="24%" label-type="basic" name="inpt1" ng-model="$ctrl.current.accounting.vatEntries[0].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="14%" label-type="basic" name="inpt2" ng-model="$ctrl.current.accounting.vatEntries[1].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="13,5%" label-type="basic" name="inpt6" ng-model="$ctrl.current.accounting.vatEntries[5].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="10%" label-type="basic" name="inpt3" ng-model="$ctrl.current.accounting.vatEntries[2].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="0%" label-type="basic" name="inpt4" ng-model="$ctrl.current.accounting.vatEntries[3].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                </div>
              </div>
              <salaxy-input-number ng-if="$ctrl.current.data.vatRate == 'other'" label="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercent.label" label-type="horizontal" name="vatRate" ng-model="$ctrl.current.accounting.vatPercent" unit="percent" ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
              <div ng-if="$expenseLogic.hasGrossVatEntries">
                <div class="row">
                  <div class="col-12">
                    <table class="table table-sm table-striped" style="font-size: 0.8em">
                      <thead>
                        <tr>
                          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.vatRate"></th>
                          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.exemptFromTaxation" class="right"></th>
                          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.tax" class="right"></th>
                          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.taxable" class="right"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr ng-repeat="item in $ctrl.current.accounting.vatEntries">
                          <td ng-if="!!item.gross">{{ "VatRate." + item.vatRate | sxyEnum }}</td>
                          <td ng-if="!!item.gross" class="right">{{ item.net | currency }}</td>
                          <td ng-if="!!item.gross" class="right">{{ item.tax | currency }}</td>
                          <td ng-if="!!item.gross" class="right">{{ item.gross | currency }}</td>
                        </tr>
                        <tr ng-if="$ctrl.current.data.total" class="total">
                          <th sxy-text="SALAXY.UI_Terms.total"></th>
                          <td class="right">{{ $ctrl.current.data.total.net | currency}}</td>
                          <td class="right">{{ $ctrl.current.data.total.tax | currency}}</td>
                          <td class="right">{{ $ctrl.current.data.total.gross | currency}}</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
                <salaxy-datepicker-popup name="startDate" label="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.date"
                  ng-model="$ctrl.current.data.date"></salaxy-datepicker-popup>
              </div>
              <salaxy-form-group name="receiptImage" label="SALAXY.NG1.CalcRowsComponent.editDialog.receiptUrlAddress">
                <div class="input-group">
                  <input class="form-control" type="text" autocomplete="off" id="file" name="file" ng-model="$ctrl.current.data.fileUrl">
                  <span class="input-group-btn">
                    <a class="btn btn-default" ng-disabled="!$ctrl.showImagePreview()" ng-href="{{$ctrl.current.data.fileUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.open"></a>
                  </span>
                </div>
              </salaxy-form-group>
              <div class="text-center" style="margin-bottom: 10px;" ng-if="$ctrl.showImagePreview()">
                <img style="max-width: 560px; max-height: 200px;" ng-src="{{$ctrl.current.data.fileUrl}}">
              </div>
            </div>
            <div ng-switch-when="prepaidExpenses" ng-init="$expenseLogic = $ctrl.getUsecaseLogic($ctrl.current)">
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal"
                require="true"></salaxy-input-number>
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercent.label" label-type="horizontal" enum="ExpensesVatRate"
                hidden-options="undefined" require="true" ng-change="$expenseLogic.updateUsecase($ctrl.current)" name="ExpensesVatRate" ng-model="$ctrl.current.data.vatRate"
                type="select"></salaxy-input-enum>

              <div ng-switch="$ctrl.current.data.vatRate">
                <span ng-switch-when="tax255" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p255.description"></span>
                <span ng-switch-when="tax24" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p24.description"></span>
                <span ng-switch-when="tax14" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p14.description"></span>
                <span ng-switch-when="tax135" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p135.description"></span>
                <span ng-switch-when="tax10" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p10.description"></span>
                <span ng-switch-when="tax0" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p0.description"></span>
              </div>
              <div ng-if="$ctrl.current.data.vatRate == 'multiple'">
                <p class="mb-0" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.taxableAmountInPercent" ps=":"></p>
                <div class="row">
                  <salaxy-input-number class="col-sm-3" label="25,5%" label-type="basic" name="inpt5" ng-model="$ctrl.current.accounting.vatEntries[4].gross" ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="24%" label-type="basic" name="inpt1" ng-model="$ctrl.current.accounting.vatEntries[0].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="14%" label-type="basic" name="inpt2" ng-model="$ctrl.current.accounting.vatEntries[1].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="13,5%" label-type="basic" name="inpt6" ng-model="$ctrl.current.accounting.vatEntries[5].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="10%" label-type="basic" name="inpt3" ng-model="$ctrl.current.accounting.vatEntries[2].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="0%" label-type="basic" name="inpt4" ng-model="$ctrl.current.accounting.vatEntries[3].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                </div>
              </div>
              <salaxy-input-number ng-if="$ctrl.current.data.vatRate == 'other'" label="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercent.label" label-type="horizontal" name="vatRate" ng-model="$ctrl.current.accounting.vatPercent" unit="percent" ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
              <div ng-if="$expenseLogic.hasGrossVatEntries">
                <div class="row">
                  <div class="col-12">
                    <table class="table table-sm table-striped" style="font-size: 0.8em">
                      <thead>
                        <tr>
                          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.vatRate"></th>
                          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.exemptFromTaxation" class="right"></th>
                          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.tax" class="right"></th>
                          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.taxable" class="right"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr ng-repeat="item in $ctrl.current.accounting.vatEntries">
                          <td ng-if="!!item.gross">{{ "VatRate." + item.vatRate | sxyEnum }}</td>
                          <td ng-if="!!item.gross" class="right">{{ item.net | currency }}</td>
                          <td ng-if="!!item.gross" class="right">{{ item.tax | currency }}</td>
                          <td ng-if="!!item.gross" class="right">{{ item.gross | currency }}</td>
                        </tr>
                        <tr ng-if="$ctrl.current.data.total" class="total">
                          <th sxy-text="SALAXY.UI_Terms.total"></th>
                          <td class="right">{{ $ctrl.current.data.total.net | currency}}</td>
                          <td class="right">{{ $ctrl.current.data.total.tax | currency}}</td>
                          <td class="right">{{ $ctrl.current.data.total.gross | currency}}</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
                <salaxy-datepicker-popup name="startDate" label="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.date"
                  ng-model="$ctrl.current.data.date"></salaxy-datepicker-popup>
              </div>
            </div>
            <div ng-switch-when="holidayBonus|holidaySalary|holidayCompensation" ng-switch-when-separator="|" ng-init="$holidaysLogic = $ctrl.getUsecaseLogic($ctrl.current)">
              <salaxy-input-number ng-if="$ctrl.getConfig().amount.units.length > 1" label="SALAXY.UI_Terms.amount" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.ensureUnit($ctrl.current)}}" units="$ctrl.getConfig().amount.units" on-unit-change="$ctrl.current.unit=unit" 
                disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number  ng-if="!($ctrl.getConfig().amount.units.length > 1)" label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'price') }}" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
              <salaxy-input-number  ng-if="$ctrl.getConfig().amount.units.length > 1" label="SALAXY.UI_Terms.price" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
              <salaxy-datepicker-popup name="start" ng-model="$ctrl.current.period.start" ng-change="$holidaysLogic.updatePeriodDays($ctrl.current)"
                label="SALAXY.MODEL.DateRange.start.title"></salaxy-datepicker-popup>
              <salaxy-datepicker-popup name="end" ng-model="$ctrl.current.period.end" ng-change="$holidaysLogic.updatePeriodDays($ctrl.current)"
                label="SALAXY.MODEL.DateRange.end.title"></salaxy-datepicker-popup>
              <salaxy-form-group name="daysCount" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelHolidaysCount" ng-if="!$ctrl.current.period.days || $ctrl.current.period.days.length == 0">
                <div class="input-group">
                  <input class="form-control" type="text" autocomplete="off" id="daysCount" name="daysCount" ng-model="$ctrl.current.period.daysCount" disabled>
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-default" ng-click="$holidaysLogic.setDaysSelection($ctrl.current)" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.editDatesButtonText"></button>
                  </span>
                </div>
              </salaxy-form-group>
              <salaxy-datepicker ng-model="$ctrl.current.period" name="days" is-multiple="true" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelHolidaysCount" min-date="$ctrl.current.period.start" max-date="$ctrl.current.period.end" ng-if="$ctrl.current.period.days.length > 0"></salaxy-date-range>
            </div>
            <div ng-switch-when="timeRatePay">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.timeRatePay.timeRatePayKind" label-type="horizontal"
                enum="TimeRatePayKind" require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="timeRatePayKind" ng-model="$ctrl.current.data.kind"
                type="select"></salaxy-input-enum>
              <p>{{ "TimeRatePayKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number ng-if="!($ctrl.getConfig().amount.units.length > 1)" label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'amount') }}" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.getConfig().amount.units.length > 1" label="SALAXY.UI_Terms.amount" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.ensureUnit($ctrl.current)}}" units="$ctrl.getConfig().amount.units" on-unit-change="$ctrl.current.unit=unit" 
                 disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number  ng-if="!($ctrl.getConfig().amount.units.length > 1)" label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'price') }}" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
              <salaxy-input-number  ng-if="$ctrl.getConfig().amount.units.length > 1" label="SALAXY.UI_Terms.price" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                  disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="payStats">
              <salaxy-input-enum label="SALAXY.MODEL.PayStatsTypeDefinition.kind.title" label-type="horizontal"
                enum="PayStatsKind" require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="payStatsKind" ng-model="$ctrl.current.data.kind"
                type="select"></salaxy-input-enum>
              <p>{{ "PayStatsKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input ng-model="$ctrl.current.data.id" name="payStatsId" label-type="horizontal" require="true"
                label="SALAXY.MODEL.PayStatsTypeDefinition.id.title"></salaxy-input>
              <salaxy-input-enum label="SALAXY.MODEL.PayStatsTypeDefinition.periodLength.title" label-type="horizontal"
                enum="PayStatsPeriodLength" require="true"  name="payStatsPeriodLength" ng-model="$ctrl.current.data.periodLength"
                type="select" filter="quarter,month,year"></salaxy-input-enum>
              <salaxy-input-enum label="SALAXY.MODEL.PayStatsTypeDefinition.periodDateKind.title" label-type="horizontal"
                enum="PeriodDateKind" require="true"  name="payStatsPeriodDateKind" ng-model="$ctrl.current.data.periodDateKind"
                type="select"></salaxy-input-enum>
              <salaxy-input ng-model="$ctrl.current.data.salary" name="payStatsSalary" label-type="horizontal"
              label="SALAXY.REPORTS.payStatsReport.salary"></salaxy-input>
              <salaxy-input ng-model="$ctrl.current.data.workingTime" name="payStatsWorkingTime" label-type="horizontal"
              label="SALAXY.REPORTS.payStatsReport.workingTime"></salaxy-input>
              <salaxy-form-group label="SALAXY.UI_Terms.updated" name="payStatsUpdatedAt"
                label-type="horizontal">
                <label class="control-label">{{ $ctrl.current.data.updatedAt | date: "dd.MM.yyyy HH:mm" }}</label>
              </salaxy-form-group>
              <salaxy-input-number ng-if="!($ctrl.getConfig().amount.units.length > 1)" label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'amount') }}" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-enum label="Arvon lähde" label-type="horizontal"
                name="payStatsSource" ng-model="$ctrl.current.data.source"
                type="select" options="{'':'','calc':'Laskettu','manual':'Päivitetty käsin'}"></salaxy-input-enum>
              <salaxy-input-number ng-if="$ctrl.getConfig().amount.units.length > 1" label="SALAXY.UI_Terms.amount" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.ensureUnit($ctrl.current)}}" units="$ctrl.getConfig().amount.units" on-unit-change="$ctrl.current.unit=unit" 
                 disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number  ng-if="!($ctrl.getConfig().amount.units.length > 1)" label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'price') }}" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
              <salaxy-input-number  ng-if="$ctrl.getConfig().amount.units.length > 1" label="SALAXY.UI_Terms.price" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                  disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-default>
              <salaxy-input-number ng-if="!($ctrl.getConfig().amount.units.length > 1)" label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'amount') }}" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.getConfig().amount.units.length > 1" label="SALAXY.UI_Terms.amount" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.ensureUnit($ctrl.current)}}" units="$ctrl.getConfig().amount.units" on-unit-change="$ctrl.current.unit=unit" 
                 disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number  ng-if="!($ctrl.getConfig().amount.units.length > 1)" label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'price') }}" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
              <salaxy-input-number  ng-if="$ctrl.getConfig().amount.units.length > 1" label="SALAXY.UI_Terms.price" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                  disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
          </div>
          <div ng-if="$ctrl.current.rowType != 'irIncomeType'">
            <hr>
            <salaxy-input ng-if="$ctrl.current.rowType != 'hourlySalaryWithWorkingTimeCompensation'" label="SALAXY.NG1.CalcRowsComponent.editDialog.additionalRows.description" label-type="horizontal" disabled="$ctrl.isDisabled($ctrl.current)"
              ng-model="$ctrl.current.message" name="message" placeholder="{{$ctrl.getMessagePlaceholderText($ctrl.current)}}"></salaxy-input>
            <salaxy-input label="SALAXY.NG1.CalcRowsComponent.editDialog.additionalRows.additionalRow" label-type="horizontal" disabled="$ctrl.isDisabled($ctrl.current)"
              ng-model="$ctrl.current.data.sxySalarySlipRowComment" name="sxySalarySlipRowComment"></salaxy-input>
          </div>
          <div ng-if="$ctrl.isStandAlone && $ctrl.current.rowType != 'absencePeriod'">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.DateRange.labelStartAndEndDate"></legend>
              <salaxy-datepicker-popup label="SALAXY.MODEL.DateRange.start.title" name="salaryDate" ng-model="$ctrl.current.period.start"></salaxy-datepicker-popup>
              <salaxy-datepicker-popup label="SALAXY.MODEL.DateRange.end.title" name="salaryDate" ng-model="$ctrl.current.period.end"></salaxy-datepicker-popup>
            </fieldset>
          </div>
          <div ng-if="$ctrl.current.rowType != 'taxAtSource'">
            <salaxy-calc-row-cost-accounting calc="$ctrl.parent" row="$ctrl.current" dimensions="$ctrl.dimensions"></salaxy-calc-row-cost-accounting>
          </div>
          <div>
            <fieldset>
              <legend>
                <div class="d-flex justify-content-between">
                  <a ng-show="$ctrl.showAccountingEditing()" class="btn-link text-right text-muted" ng-click="showAccountingEditing = !showAccountingEditing">
                    <small style="font-size: 0.7em;">{{!showAccountingEditing ?('SALAXY.NG1.CalcRowsComponent.editDialog.accounting.entry.rowAccounting' | sxyTranslate) : ('SALAXY.NG1.CalcRowsComponent.editDialog.accounting.entry.closeRowAccounting' | sxyTranslate)}}</small>
                  </a>
                </div>
              </legend>
              <div ng-if="showAccountingEditing">
                <salaxy-form-group name="debitAccountNumber" label="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.entry.debetAccountNumber">
                  <div class="input-group">
                    <input ng-readonly="!$ctrl.isEditable" class="form-control" type="text" placeholder="{{ 'SALAXY.NG1.CalcRowsComponent.editDialog.accounting.entry.accountNumberPlaceholder' | sxyTranslate }}" autocomplete="off" id="debitAccountNumber" name="debitAccountNumber" ng-model="$ctrl.current.accounting.entry.debitAccountNumber">
                   
                    <span class="input-group-btn" ng-if="$ctrl.isEditable">
                      <button type="button" class="btn btn-default" ng-click="$ctrl.openAccountingRulesetSelection(true)">...</button>
                    </span>
                  </div>
                </salaxy-form-group>
                <salaxy-form-group name="creditAccountNumber" label="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.entry.creditAccountNumber">
                  <div class="input-group">
                    <input  ng-readonly="!$ctrl.isEditable" class="form-control" type="text" placeholder="{{ 'SALAXY.NG1.CalcRowsComponent.editDialog.accounting.entry.accountNumberPlaceholder' | sxyTranslate }}" autocomplete="off" id="creditAccountNumber" name="creditAccountNumber" ng-model="$ctrl.current.accounting.entry.creditAccountNumber">               
                    <span class="input-group-btn" ng-if="$ctrl.isEditable">
                      <button  type="button" class="btn btn-default" ng-click="$ctrl.openAccountingRulesetSelection(false)">...</button>
                    </span>
                  </div>
                </salaxy-form-group>
                <div class="text-right d-flex mb-3" ng-if="$ctrl.isEditable">
                  <button type="button" class="btn btn-secondary btn-sm ms-auto me-1 mt-1" ng-click="$ctrl.showRowAccountingPreview()">{{'SALAXY.NG1.CalcRowsComponent.editDialog.accounting.entry.showAccountingPreview' | sxyTranslate}}</button>
                </div>
              </div>
             
            </fieldset>
          </div>
        </div>
        <div class="text-right d-flex" ng-if="$ctrl.isEditable && !$ctrl.definitionEditor.mode">
          <button type="button" class="btn btn-danger float-start" ng-click="$ctrl.closeEditDialog('delete-no-save', $close)"
            sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.buttons.delete"></button>
          <button type="button" ng-if="$ctrl.isDialog" class="btn btn-default ms-auto me-1" ng-click="$ctrl.closeEditDialog('cancel', $close)"
            sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.buttons.cancel"></button>
          <button type="submit" class="btn btn-primary" ng-click="$ctrl.closeEditDialog('ok-no-save', $close)"
            sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.buttons.save"></button>
        </div>
        <div ng-if="!$ctrl.isEditable" class="text-end">
          <button type="button" class="btn btn-default" ng-click="$ctrl.closeEditDialog('cancel', $close)"
            sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.buttons.close"></button>
        </div>
      </div>
    </form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/rows/CalcRows2019Editor.html",`<div class="salaxy-component salaxy-calc-rows-editor salaxy-calc-rows-2019-editor">

  <div ng-if="$ctrl.isInEdit">
    <table class="table table-sm">
      <thead>
        <tr>
          <th width="42px" class="hidden-xxs th-avatar"></th>
          <th width="40%" class="uppercase th-calc-row-type">{{ $ctrl.title }}</th>
          <th ng-if="$ctrl.showDimension()" ng-repeat="definition in $ctrl.getDimensionsToShow()">{{definition.label}}</th>
          <th class="right" ng-if="$ctrl.hasRows" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.amount"></th>
          <th class="right" ng-if="$ctrl.hasRows" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.price"></th>
          <th class="right th-row-total" ng-if="$ctrl.hasRows" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.total"></th>
          <th colspan="3" ng-if="!$ctrl.hasRows">&nbsp;</th>
          <th class="salaxy-calc-rows-editor-btns">
            <span ng-if="$ctrl.showEditButtons">
              <button class="btn btn-sm btn-transparent" ng-click="$ctrl.commit()" title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.okIcon' | sxyTranslate}}">
                <i class="bi bi-check-lg text-success"></i>
              </button>
              <button class="btn btn-sm btn-transparent" ng-click="$ctrl.reset()" title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.cancelIcon' | sxyTranslate}}">
                <i class="bi bi-x-lg"></i>
              </button>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat-start="row in $ctrl.filteredList track by $index" ng-class="$ctrl.getValidation(row).type ? 'row-before-validation' : ''">
          <td width="42px" class="hidden-xxs td-avatar" ng-class="{'td-no-avatar' : !row.rowType}">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar" avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td width="40%" class="td-calc-row-type" ng-class="{'td-add-new': !row.rowType}">
            <salaxy-calc-row-type ng-if="!row.rowType" name="rowType" model="row" row-types="$ctrl.rowTypes" categories="$ctrl.categories" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder" on-row-changed="$ctrl.rowTypeChanged(row)"></salaxy-calc-row-type>
            <input class="form-control" ng-if="row.rowType" name="message" type="text" ng-model="row.message" ng-disabled="$ctrl.isDisabled(row, 'message')" placeholder="{{$ctrl.getMessagePlaceholderText(row)}}" />
          </td>
          <td  ng-if="$ctrl.showDimension()" ng-repeat="definition in $ctrl.getDimensionsToShow()">
            <div class="truncate">
              <salaxy-calc-row-dimension-input row="row" definition="definition" inherited="$ctrl.parent.accounting.dimensions" read-only="$ctrl.mode == 'read-only'"></salaxy-calc-row-dimension-input>
            </div>
          </td>
          <td ng-if="row.rowType" class="right">
            <salaxy-input-number ng-if="$ctrl.getConfig(row).amount.units.length > 1" on-unit-change="row.unit=unit" name="{{ 'iptCount' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-model="row.count" label-type="plain" disabled="$ctrl.isDisabled(row, 'amount')" unit="{{$ctrl.ensureUnit(row)}}" units="$ctrl.getConfig(row).amount.units">
            </salaxy-input-number>
            <salaxy-input-number ng-if="!($ctrl.getConfig(row).amount.units.length > 1)" name="{{ 'iptCount' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-model="row.count" label-type="plain" placeholder="{{ $ctrl.getPlaceholderText(row, 'amount') }}" disabled="$ctrl.isDisabled(row, 'amount')" unit="{{$ctrl.getConfig(row).amount.unit}}">
            </salaxy-input-number>
          </td>
          <td ng-if="row.rowType" class="right">
            <salaxy-input-number ng-if="$ctrl.getConfig(row).amount.units.length > 1" name="{{ 'iptPrice' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-model="row.price" label-type="plain"  disabled="$ctrl.isDisabled(row, 'price')" require="true"></salaxy-input-number>
            <salaxy-input-number ng-if="!($ctrl.getConfig(row).amount.units.length > 1)" name="{{ 'iptPrice' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-change="row.rowType == 'hourlySalaryWithWorkingTimeCompensation' ? $ctrl.updateUsecase(row) : null" ng-model="row.price" label-type="plain" placeholder="{{ $ctrl.getPlaceholderText(row, 'price') }}" disabled="$ctrl.isDisabled(row, 'price')" require="true"></salaxy-input-number>
          </td>
          <td ng-if="row.rowType" class="right td-row-total">
            <div>{{ $ctrl.getRowTotal(row) | currency }}</div>
          </td>
          <td ng-if="row.rowType" class="salaxy-calc-rows-editor-btns">
            <button type="button" class="edit btn btn-info btn-sm" ng-disabled="!row.rowType" ng-click="$ctrl.showEditDialog(row)" title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.editIcon' | sxyTranslate}}"><i class="bi bi-pencil-fill"></i></button>
            <button type="button" class="delete btn btn-danger btn-sm" ng-if="row.rowIndex >= 0" ng-click="$ctrl.delete(row)" title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.deleteIcon' | sxyTranslate}}"><i class="bi bi-trash-fill"></i></button>
          </td>
          <td ng-if="!row.rowType" colspan="2" class="td-add-new-btn">
            <div>
              <button type="button" class="btn btn-default" ng-click="$ctrl.createNew()"><i class="bi bi-info-circle-fill text-primary me-2"></i><span
                  sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
            </div>
          </td>
          <td ng-if="!row.rowType" colspan="2" class="td-no-btns">&nbsp;</td>
        </tr>
        <tr ng-if="row.rowType == 'hourlySalaryWithWorkingTimeCompensation' && $ctrl.getValidation(row).type != 'error'" ng-repeat="compensationRow in row.data.compensationRows track by $index" class="no-border">
          <td width="42px" class="hidden-xxs td-avatar">
          </td>
          <td width="40%" class="td-calc-row-type">
            <input class="form-control" name="message" type="text" readonly="true" value="{{ compensationRow.message || ('WorkingTimeCompensationKind.' + row.data.kind | sxyEnum) }}, {{ row.data.pricing == 'percent' ? (compensationRow.percent | sxyCount:'percent') : (compensationRow.price | currency) + ' / h' }}" />
          </td>
          <td  ng-if="$ctrl.showDimension()" ng-repeat="definition in $ctrl.getDimensionsToShow()">
            <div style="min-width: 100px" class="truncate">
              <salaxy-calc-row-dimension-input row="row" definition="definition" inherited="$ctrl.parent.accounting.dimensions" read-only="true"></salaxy-calc-row-dimension-input>
            </div>
          </td>
          <td class="right">
            <salaxy-input-number name="{{ 'iptCount' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-if="compensationRow.count != null" ng-model="compensationRow.count" label-type="plain" readonly="true">
            </salaxy-input-number>
            <salaxy-input-number name="{{ 'iptCount' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-if="compensationRow.count == null" ng-model="row.count" label-type="plain" readonly="true"></salaxy-input-number>
            </salaxy-input-number>
          </td>
          <td class="right">
            <salaxy-input-number name="{{ 'iptPrice' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-model="compensationRow.price" label-type="plain" readonly="true"></salaxy-input-number>
          </td>
          <td class="right td-row-total">
            <div>{{ (compensationRow.price * (compensationRow.count || row.count || 1)) | currency }}</div>
          </td>
          <td></td>
        </tr>
        <tr ng-repeat-end class="row-validation no-border" ng-if="row.rowType != 'hourlySalaryWithWorkingTimeCompensation' || $ctrl.getValidation(row).type == 'error'">
          <td></td>
          <td colspan="5">
            <small class="" ng-if="$ctrl.getValidation(row).type == 'default'">
              {{ $ctrl.getValidation(row).msg | sxyTranslate }}
              <a href="" ng-click="$ctrl.showEditDialog(row)" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
            </small>
            <span ng-if="$ctrl.getValidation(row).type == 'error'">
              <span class="label label-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.note"></span>
            <small class="alert-danger">{{ $ctrl.getValidation(row).msg | sxyTranslate }}
                <a href="" ng-click="$ctrl.showEditDialog(row)" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
              </small>
            </span>
          </td>
        </tr>
        <tr class="new-row">
          <td width="42px" class="hidden-xxs td-avatar border-0" ng-class="{'td-no-avatar' : !row.rowType}">
          </td>
          <td width="40%" class="border-0">
            <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder" on-row-changed="$ctrl.commitNewRow()" row-types="$ctrl.rowTypes" categories="$ctrl.categories" clear-on-select="true"></salaxy-calc-row-type>
          </td>
          <td colspan="2" class="td-add-new-btn border-0">
            <button type="button" class="btn btn-default" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-circle-fill text-primary me-2"></i> <span
                sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
          </td>
          <td colspan="2" class="td-no-btns border-0">&nbsp;</td>
        </tr>
      </tbody>
      <tfoot ng-if="$ctrl.hasRows">
        <tr class="total">
          <th width="42px" class="hidden-xxs"></th>
          <td>
            <strong sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.finalCost"></strong>
          </td>
          <td colspan="3" class="right">
            <strong>{{ $ctrl.getFinalCost() | currency }}
              <!--{{ $ctrl.getTotal() | currency }}--></strong>
          </td>
          <td colspan="2"></td>
        </tr>
      </tfoot>
    </table>

  </div>
  <div ng-if="!$ctrl.isInEdit">
    <table class="table table-sm">
      <thead>
        <tr>
          <th width="42px" class="hidden-xxs"></th>
          <th width="40%" class="uppercase">{{ $ctrl.title || ('SALAXY.NG1.CalcRowsComponent.editor.calcRow' | sxyTranslate) }}</th>
          <th></th>
          <th class="right" ng-if="$ctrl.hasRows" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
          <th class="salaxy-calc-rows-editor-btns text-end">
            <span ng-if="$ctrl.showEditButtons && $ctrl.mode != 'read-only'">
              <button ng-if="$ctrl.showEditButtons && $ctrl.mode != 'read-only'" ng-hide="$ctrl.parent.isReadOnly" ng-disabled="!$ctrl.isEditable" ng-click="$ctrl.startEdit()" type="button" class="edit btn btn-info btn-sm" title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.editIcon' | sxyTranslate}}">
                <i class="bi bi-pencil-fill"></i>
              </button>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.filteredList track by $index">
          <td width="42px" class="hidden-xxs">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar" avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td width="50%">{{$ctrl.getMessagePlaceholderText(row)}}</td>
          <td ng-if="row.rowType" class="right">
            <small class="text-muted" ng-if="row.count && row.count != 1">{{row.count | sxyCount : row.unit }} * {{ row.price | currency }}</small>
          </td>
          <td ng-if="row.rowType" class="right">
            <div>{{ $ctrl.getRowTotal(row) | currency }}</div>
          </td>
          <td ng-if="row.rowType" class="salaxy-calc-rows-editor-btns text-end">
            <button type="button" class="edit btn btn-info btn-sm" ng-disabled="!row.rowType" ng-click="$ctrl.showEditDialog(row)" title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}"><i class="bi bi-pencil-fill"></i></button>
          </td>
        </tr>
      </tbody>
      <tfoot ng-if="$ctrl.hasRows && $ctrl.hideFinalCostRow">
        <tr class="total">
          <td width="42px" class="hidden-xxs"></td>
          <td>
            <strong sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></strong>
          </td>
          <td></td>
          <td class="right">
            <strong>
              <!--{{ $ctrl.getTotal() | currency }}--></strong>
          </td>
          <td></td>
        </tr>
        <tr ng-if="$ctrl.showGrossTotals">
          <th width="42px" class="hidden-xxs"></th>
          <td>
            <span sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.grossTotal"></span><br>
            <small class="text-muted" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.netSalary"></small>
          </td>
          <td>

          </td>
          <td class="right">
            {{ $ctrl.getGrossTotal() | currency }}<br>
            <small class="text-muted">{{ $ctrl.getNetSalary() | currency }}</small>
          </td>
          <td></td>
        </tr>
        <tr ng-if="$ctrl.showGrossTotals" class="total">
          <th width="42px" class="hidden-xxs"></th>
          <td>
            <strong sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.finalCost"></strong>
            <br>
            <small class="text-muted" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.totalPayment"></small>
          </td>
          <td>
          </td>
          <td class="right">
            <strong>{{ $ctrl.getFinalCost() | currency }}</strong><br>
            <small class="text-muted">{{ $ctrl.getTotalPayment() | currency }}</small>
          </td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/rows/CalcsIrRows.html",`<div class="salaxy-calc-ir-rows salaxy-component">
  <sxy-table ng-ref="$ctrl.$sxyTable" options="$ctrl.tableConfig.options" include="$ctrl.tableConfig.include" data="$ctrl.tableConfig.data"></sxy-table>
</div>`);

 $templateCache.put("salaxy-components/calc/rows/RowTypeEditDialog.html",`<div class="modal-header">
  <h2 class="modal-title">Palkkalaji: {{ $ctrl.current.config.label }}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { 'value': 'default', 'text': 'SALAXY.NG1.WorkerDetailsComponent.workerInfo' },
      { 'value': 'defaultseditor', 'text': 'Oletusarvot' },
      { 'value': 'kinds', 'text': 'Alalajit', disabled: !$ctrl.current.config.kind.values.length },
      { 'value': 'editor', 'text': 'Esikatselu, UI' },
      { 'value': 'json', 'text': 'Esikatselu, data' },
      { 'value': 'formulas', 'text': 'Laskukaavat', 'hidden': !(('bizConfigs' | sxyIsInRole) && $ctrl.definitionEditor.mode != 'builtIn') },
      { 'value': 'examples', 'text': 'Kehittäjälle', 'hidden': !(('!prod' | sxyIsInRole) && $ctrl.definitionEditor.mode == 'builtIn') }
    ]"
    tabs-id="rowTypeEditDialogTabs">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-rowTypeEditDialogTabs">
    <div class="tab-pane" id="default-tab">
      <sxy-form open-api="salaxy-secure/schemas/v02.json" type="CalcRowConfig" auto-gen="false" debugger="false"
        model="$ctrl.current.config" read-only="{{ $ctrl.definitionEditor.mode == 'builtIn' }}">
        <div>
          <salaxy-form-group name="id" class="salaxy-read-only" label="Koodi">
            <div class="salaxy-read-only-value">
              <button type="button" class="btn btn-default" ng-click="$ctrl.copyToClipboard($ctrl.current.config.type)" title="Kopioi ID leikepöydälle">
                <i class="bi bi-clipboard" aria-hidden="true"></i></button>
              <code>{{ $ctrl.current.config.type }}</code>
            </div>
            <p>Kopioi tämä koodi esim. tuntiraportointijärjestelmään, jotta tiedot lähetetään Palkkaukseen oikealla koodilla.</p>
          </salaxy-form-group>
          <fieldset>
            <legend>Rivityypin kuvaus</legend>
            <sxy-input label="Teksti" id="label" model="form.label"></sxy-input>
            <sxy-input label="Kuvaus" id="descr" model="form.descr"></sxy-input>
            <sxy-input label="Kategoria" id="category" model="form.category" options="CalculationRowCategory"></sxy-input>
            <sxy-input label="Suosikki" id="favorite" model="form.favorite" type="integer"></sxy-input>
            <sxy-input label="Väri" id="color" model="form.color"></sxy-input>
            <sxy-input label="Ikonin teksti" id="iconText" model="form.iconText" format="color"></sxy-input>
          </fieldset>
          <div class="row">
            <div class="col-sm-6">
              <fieldset>
                <legend>Hinta</legend>
                <sxy-input label="Teksti" id="price.label" model="form.price.label"></sxy-input>
                <!-- TODO: Fix options to be drop-down -->
                <sxy-input label="Kentän tyyppi" id="price.input" model="form.price.input" options="['number','hidden','readOnly']" format="select"></sxy-input>
                <sxy-input label="Oletus" id="price.default" model="form.price.default"></sxy-input>
              </fieldset>
            </div>
            <div class="col-sm-6">
              <fieldset>
                <legend>Määrä</legend>
                <sxy-input label="Teksti" id="amount.label" model="form.amount.label"></sxy-input>
                <sxy-input label="Kentän tyyppi" id="amount.input" model="form.amount.input" options="['number','hidden','readOnly']" format="select"></sxy-input>
                <sxy-input label="Oletus" id="amount.default" model="form.amount.default"></sxy-input>
              </fieldset>
            </div>
          </div>
        </div>
      </sxy-form>
    </div>
    <div class="tab-pane" id="defaultseditor-tab">
      <div>
        <ng-include src="'salaxy-components/calc/rows/CalcRows2019EditDialog.html'"></ng-include>
      </div>
    </div>
    <div class="tab-pane" id="kinds-tab">
      <table>
        <thead>
          <tr>
            <th>Nro</th>
            <th>Teksti</th>
            <th>Kuvaus</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat-start="kind in $ctrl.current.config.kind.values">
            <td>{{ kind.order }}</td>
            <td>{{ kind.label }}</td>
            <td>{{ kind.descr }}</td>
            <td rowspan="2">
              <button type="button" class="btn btn-default" ng-click="$ctrl.copyToClipboard($ctrl.current.config.type + '/' + kind.name)" title="Kopioi ID leikepöydälle">
                <i class="bi bi-clipboard" aria-hidden="true"></i></button>
            </td>
          </tr>
          <tr ng-repeat-end>
            <td></td>
            <td colspan="2">
              <code>{{ $ctrl.current.config.type }}/{{ kind.name }}</code>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="tab-pane" id="editor-tab">
      <div>
        <div class="alert alert-warning">
          <strong>Huom!</strong> Tuotteen palkkalajeja ei voi muokata. Tämä näkymä on vain esikatselua varten.
        </div>
        <ng-include src="'salaxy-components/calc/rows/CalcRows2019EditDialog.html'"></ng-include>
      </div>
    </div>
    <div class="tab-pane" id="json-tab">
      <div ng-if="true || $ctrl.currentTab == 'json'">
        <salaxy-json-formatter key="'Data'" json="$ctrl.current" open="2"></salaxy-json-formatter>
      </div>
    </div>
    <div class="tab-pane" id="formulas-tab" heading="Laskukaavat">
      <div ng-if="$ctrl.currentTab == 'formulas'">
        <salaxy-calc-row-formula row="$ctrl.current"></salaxy-calc-row-formula>
      </div>
    </div>
    <div class="tab-pane" id="examples-tab">
      <div ng-if="$ctrl.currentTab == 'examples'">
        <salaxy-calc-row-documentation row="$ctrl.current"></salaxy-calc-row-documentation>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" ng-if="$ctrl.definitionEditor.mode == 'custom'" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`);

 $templateCache.put("salaxy-components/calc/SalaryDateKindButton.html",`<div class="salaxy-date-kind-button salaxy-component" ng-if="!('salaxyPay' | sxyIsInRole)">
  <div class="dropdown" ng-class="$ctrl.buttonClass">
    <button id="btnSalaryDateKind" type="button" ng-disabled="$ctrl.disabled" class="btn btn-default btn-block dropdown-toggle justify-content-start" data-bs-toggle="dropdown">
      <salaxy-avatar class="py-1" avatar="$ctrl.currentSalaryDateKind.avatar" template-url="iconAvatar.html"></salaxy-avatar>
      <span class="button-text">
        {{ $ctrl.currentSalaryDateKind.text | sxyTranslate}}
      </span>
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="btnSalaryDateKind">
      <li role="menuitem" ng-class="{ 'disabled': $ctrl.disabled }" ng-repeat="salaryDateKind in $ctrl.salaryDateKinds">
        <a href="" ng-click="$ctrl.setSalaryDateKind(salaryDateKind.value)" class="dropdown-item d-flex align-items-center">
          <salaxy-avatar avatar="salaryDateKind.avatar" class="me-2" template-url="iconAvatar.html"></salaxy-avatar>
          <span class="button-text">
            {{ salaryDateKind.text | sxyTranslate }}
          </span>
        </a>
      </li>
    </ul>
  </div>
</div>
<div ng-if="('salaxyPay' | sxyIsInRole)" ng-controller="NewPaymentController as $newCtrl">
<!-- When using salaxy pay, we don't need to show the salary date kind button -->
</div>
<script type="text/ng-template" id="iconAvatar.html">
  <i class="salaxy-avatar bi" ng-class="$ctrl.avatar.icon" ng-style="{color: $ctrl.avatar.color }"></i>
</script>`);

 $templateCache.put("salaxy-components/calc/usecases/household-childCare.html",`<div>
  <div ng-if="$ctrl.usecaseData.id == 'childCare/mll'">
    <div class="card-header childcare">
      <span class="float-start">
        <div class="icon-wrapper salaxy-household-usecase-avatar">
          <div class="main-icon-wrapper" ng-if="$ctrl.usecaseData.icon">
            <img ng-src="{{$ctrl.usecaseData.icon}}">
          </div>
          <div ng-if="$ctrl.usecaseData.badge" class="badge-image-wrapper">
            <img ng-src="{{$ctrl.usecaseData.badge}}">
          </div>
        </div>
      </span>
      <h1>{{$ctrl.usecaseData.label}}</h1>
      <p class="calc-text">
        {{$ctrl.salaryRow.count || 0}} h x {{$ctrl.salaryRow.price || '9,5'}} € <span ng-if="$ctrl.usecaseData.isSunday" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.hoursPerPriceWithSunday"></span>
        <span class="result-text" ng-if="!$ctrl.usecaseData.isSunday">{{ ($ctrl.salaryRow.count || 0) * ($ctrl.salaryRow.price || 9.5) | currency }}</span>
        <span class="result-text" ng-if="$ctrl.usecaseData.isSunday">{{ ($ctrl.salaryRow.count || 0) * ($ctrl.salaryRow.price || 9.5) * 2 | currency }}</span>
      </p>
      <a class="btn-link btn-showmore" ng-click="showInfo = !showInfo"><span sxy-text="SALAXY.UI_Terms.showMore"></span><i class="bi bi-info-circle-fill"></i></a>
    </div>
    <div class="card-body">
      <p sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.mll.shortInfoText.html"></p>
      <span class="collapse" ng-class="{show: showInfo}">
        <p sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.mll.longInfoText.html"></p>
      </span>
      <div class="form-horizontal">
        <salaxy-input-number name="hours" label="SALAXY.NG1.HouseholdUsecaseComponent.base.hourCount" ng-model="$ctrl.salaryRow.count" label-cols="col-sm-6" required>
        </salaxy-input-number>
        <salaxy-input-boolean name="isSunday" label="SALAXY.NG1.HouseholdUsecaseComponent.base.isSunday" type="switch" ng-model="$ctrl.usecaseData.isSunday" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" label-cols="col-sm-6"></salaxy-input-boolean>
        <salaxy-input-boolean name="useCustomPrice" label="SALAXY.NG1.HouseholdUsecaseComponent.mll.useCustomPrice" type="switch" ng-model="$ctrl.usecaseData.useCustomPrice" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" label-cols="col-sm-6">
        </salaxy-input-boolean>
        <salaxy-input-number ng-if="$ctrl.usecaseData.useCustomPrice" name="price" label="SALAXY.NG1.HouseholdUsecaseComponent.base.eurPerH" ng-model="$ctrl.salaryRow.price" label-cols="col-sm-6"></salaxy-input-number>
      </div>
    </div>
  </div>
  <div ng-if="$ctrl.usecaseData.id != 'childCare/mll'">
    <div class="card-header childcare">
      <span class="float-start">
        <div class="icon-wrapper salaxy-household-usecase-avatar">
          <div class="main-icon-wrapper" ng-if="$ctrl.usecaseData.icon">
            <img ng-src="{{$ctrl.usecaseData.icon}}" type="image/svg+xml">
          </div>
          <div ng-if="$ctrl.usecaseData.badge" class="badge-image-wrapper">
            <img ng-src="{{$ctrl.usecaseData.badge}}">
          </div>
        </div>
      </span>

      <h1>{{$ctrl.usecaseData.label}}</h1>
      <p class="calc-text">
        <span ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">{{$ctrl.salaryRow.count || 0}} h x
          {{$ctrl.salaryRow.price || 0}} €</span>
        <span ng-if="$ctrl.salaryRow.rowType=='monthlySalary'">{{$ctrl.salaryRow.price || 0}} <span sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.eurPerMonth"></span></span>
        <span ng-if="$ctrl.usecaseData.isChildcareSubsidy">+ {{ $ctrl.usecaseData.subsidyAmount || 0 }} <span
            sxy-test="SALAXY.NG1.HouseholdUsecaseComponent.childCare.isChildCareSubsidy"></span></span>
        <span ng-if="$ctrl.isHouseholdDeductible" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.isHouseholdDeductible"></span>
        <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">{{ ($ctrl.salaryRow.count || 0) * ($ctrl.salaryRow.price || 0) }}
          €</span>
        <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='monthlySalary'">{{ $ctrl.salaryRow.price || 0}} €</span>
      </p>
      <a class="btn-link btn-showmore" ng-click="showInfo = !showInfo"><span sxy-text="SALAXY.UI_Terms.showMore"></span><i class="bi bi-info-circle-fill"></i></a>
    </div>
    <div class="card-body">
      <p sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.childCare.shortInfoText.html"></p>
      <span class="collapse" ng-class="{show: showInfo}">

        <p ng-if="$ctrl.usecaseData.isChildcareSubsidy" sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.childCare.longInfoTextIfchildCareSubsidy.html"></p>
        
        <p ng-if="!$ctrl.usecaseData.isChildcareSubsidy" sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.childCare.longInfoTextIfNotchildCareSubsidy.html"></p>

        
      </span>
      <div class="form-horizontal">
        <salaxy-input-number ng-show="$ctrl.usecaseData.isChildcareSubsidy" name="subsidyAmount" label="SALAXY.NG1.HouseholdUsecaseComponent.childCare.childCareSubsidy" ng-model="$ctrl.usecaseData.subsidyAmount" label-cols="col-sm-6">
        </salaxy-input-number>
        <salaxy-input-enum type="select" name="mainRowType" label="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryKind" ng-model="$ctrl.salaryRow.rowType" options="{'hourlySalary': ('SALAXY.ENUM.SalaryKind.hourlySalary.label' | sxyTranslate),'monthlySalary':('SALAXY.ENUM.SalaryKind.monthlySalary.label'| sxyTranslate)}"
          ng-change="$ctrl.changeRowType()" label-cols="col-sm-6" required></salaxy-input-enum>
        <salaxy-input-number name="price" label="{{$ctrl.usecaseData.isChildcareSubsidy ? $ctrl.priceLabel + ( 'SALAXY.NG1.HouseholdUsecaseComponent.childCare.inAdditionToBenefits'|sxyTranslate) : $ctrl.priceLabel}}" ng-model="$ctrl.salaryRow.price" label-cols="col-sm-6"></salaxy-input-number>
        <salaxy-input-number ng-if="$ctrl.salaryRow.rowType=='hourlySalary'" name="amount" label="SALAXY.NG1.HouseholdUsecaseComponent.base.hourCount" ng-model="$ctrl.salaryRow.count" required label-cols="col-sm-6"></salaxy-input-number>

        <salaxy-input-boolean ng-if="!$ctrl.usecaseData.isChildcareSubsidy" name="isHouseholdDeductible" label="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeduction" type="radio" ng-model="$ctrl.isHouseholdDeductible" label-true="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionTrue"
          label-false="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionFalse" label-cols="col-sm-6"></salaxy-input-boolean>
        <div class="form-group" ng-if="$ctrl.usecaseData.isChildcareSubsidy">
          <div class="col-sm-6"><strong sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.childCare.workerTotalPayment"></strong></div>
          <div class="col-sm-6 text-end" ng-if="$ctrl.salaryRow.rowType=='hourlySalary'">
            {{ ($ctrl.salaryRow.price || 0) * ($ctrl.salaryRow.count || 0) + ($ctrl.usecaseData.subsidyAmount || 0) }}</div>
          <div class="col-sm-6 text-end" ng-if="$ctrl.salaryRow.rowType=='monthlySalary'">
            {{ ($ctrl.salaryRow.price || 0) + ($ctrl.usecaseData.subsidyAmount || 0) }}</div>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/usecases/household-cleaning.html",`<div>
  <div class="card-header cleaning">
    <span class="float-start">
      <div class="icon-wrapper salaxy-household-usecase-avatar">
        <div class="main-icon-wrapper">
          <img ng-src="{{$ctrl.usecaseData.icon}}">
        </div>
      </div>
    </span>
    <h1>{{$ctrl.usecaseData.label}}</h1>
    <p class="calc-text">

      <span ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">{{$ctrl.salaryRow.count || 0}} h x {{$ctrl.salaryRow.price || 0}}
        €</span>
      <span ng-if="$ctrl.salaryRow.rowType=='salary' || $ctrl.salaryRow.rowType=='monthlySalary'">{{$ctrl.salaryRow.price || 0}} € <span
          ng-if="$ctrl.salaryRow.rowType=='monthlySalary'" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.pricePerMonth"></span></span>

      <span ng-if="$ctrl.isHouseholdDeductible" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.isHouseholdDeductible"></span>

      <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">{{ ($ctrl.salaryRow.count || 0) * ($ctrl.salaryRow.price || 0) }}
        €</span>
      <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='salary' || $ctrl.salaryRow.rowType=='monthlySalary'">{{ $ctrl.salaryRow.price || 0}} € </span>
    </p>
    <a class="btn-link btn-showmore" ng-click="showInfo = !showInfo"><span sxy-text="SALAXY.UI_Terms.showMore"></span><i class="bi bi-info-circle-fill"></i></a>
  </div>
  <div class="card-body">
    <p sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.cleaning.shortInfoText.html"></p>
    <span class="collapse" ng-class="{show: showInfo}" sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.cleaning.longInfoText.html"></span>
    <div class="form-horizontal">
      <salaxy-textarea ng-if="$ctrl.usecaseData.subType == 'other'" name="workTypeOtherMessage" label="SALAXY.NG1.HouseholdUsecaseComponent.base.workDescription" ng-model="$ctrl.usecaseData.workTypeOtherMessage" label-cols="col-sm-6"></salaxy-textarea>
      <salaxy-input-enum type="select" name="mainRowType" label="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryKind" ng-model="$ctrl.salaryRow.rowType" options="{'salary':('SALAXY.ENUM.SalaryKind.salary.label'| sxyTranslate),'hourlySalary':('SALAXY.ENUM.SalaryKind.hourlySalary.label' | sxyTranslate),'monthlySalary':('SALAXY.ENUM.SalaryKind.monthlySalary.label' | sxyTranslate)}"
        ng-change="$ctrl.changeRowType()" label-cols="col-sm-6" required></salaxy-input-enum>
      <salaxy-input-number name="price" label="{{$ctrl.priceLabel}}" ng-model="$ctrl.salaryRow.price" label-cols="col-sm-6" required></salaxy-input-number>
      <salaxy-input-number ng-if="$ctrl.salaryRow.rowType == 'hourlySalary'" name="hours" label="SALAXY.NG1.HouseholdUsecaseComponent.base.hourCount" ng-model="$ctrl.salaryRow.count" required label-cols="col-sm-6"></salaxy-input-number>

      <salaxy-input-boolean name="isContractLessThanYear" label="SALAXY.NG1.HouseholdUsecaseComponent.cleaning.contractLastedLessThanYear" type="switch" ng-model="$ctrl.usecaseData.isContractLessThanYear" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no"
        label-cols="col-sm-6">
      </salaxy-input-boolean>
      <salaxy-input-boolean name="isFullTime" label="SALAXY.NG1.HouseholdUsecaseComponent.cleaning.fullTime" type="switch" ng-model="$ctrl.usecaseData.isFullTime" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" label-cols="col-sm-6">
      </salaxy-input-boolean>

      <salaxy-input-boolean name="isHouseholdDeductible" label="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeduction" type="radio" ng-model="$ctrl.isHouseholdDeductible" label-true="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionTrue" label-false="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionFalse"
        label-cols="col-sm-6"></salaxy-input-boolean>
      <div ng-if="$ctrl.usecaseData.isFullTime" class="text-danger" sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.cleaning.footnote.html"></div>
    </div>
  </div>

</div>`);

 $templateCache.put("salaxy-components/calc/usecases/household-construction.html",`<div>
  <div class="card-header construction">
    <span class="float-start">
      <div class="icon-wrapper salaxy-household-usecase-avatar">
        <div class="main-icon-wrapper">
          <img ng-src="{{$ctrl.usecaseData.icon}}">
        </div>
      </div>
    </span>
    <h1>{{$ctrl.usecaseData.label}}</h1>
    <p class="calc-text">
      <span ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">{{$ctrl.salaryRow.count || 0}} h x {{$ctrl.salaryRow.price || 0}}
        €</span>
      <span ng-if="$ctrl.salaryRow.rowType=='salary' || $ctrl.salaryRow.rowType=='monthlySalary'">{{$ctrl.salaryRow.price || 0}} € <span
          ng-if="$ctrl.salaryRow.rowType=='monthlySalary'"></span></span>
      <span sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.construction.subtitlePlusExpenses"></span>
      <span ng-if="$ctrl.isHouseholdDeductible" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.isHouseholdDeductible"></span>
      <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">{{ ($ctrl.salaryRow.count || 0) * ($ctrl.salaryRow.price ||
        0) }}
        €</span>
      <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='salary' || $ctrl.salaryRow.rowType=='monthlySalary'">{{ $ctrl.salaryRow.price || 0}} €</span>
    </p>
    <a class="btn-link btn-showmore" ng-click="showInfo = !showInfo"><span sxy-text="SALAXY.UI_Terms.showMore"></span><i class="bi bi-info-circle-fill"></i></a>
  </div>
  <div class="card-body">
    <p sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.construction.shortInfoText.html"></p>
    <span class="collapse" ng-class="{show: showInfo}" sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.construction.longInfoText.html"></span>
    <div class="form-horizontal">
      <salaxy-input-enum type="select" name="mainRowType" label="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryKind" ng-model="$ctrl.salaryRow.rowType" options="{'salary':('SALAXY.ENUM.SalaryKind.salary.label'| sxyTranslate),'hourlySalary':('SALAXY.ENUM.CalculationRowType.hourlySalary.label' | sxyTranslate),'monthlySalary':('SALAXY.ENUM.CalculationRowType.monthlySalary.label' | sxyTranslate),'totalEmployerPayment':('SALAXY.ENUM.CalculationRowType.totalEmployerPayment.label' | sxyTranslate)}"
        ng-change="$ctrl.changeRowType()" label-cols="col-sm-6" required ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-enum>
      <salaxy-input-number name="price" label="{{$ctrl.priceLabel}}" ng-model="$ctrl.salaryRow.price" label-cols="col-sm-6" required ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-number>
      <salaxy-input-number ng-if="$ctrl.salaryRow.rowType == 'hourlySalary'" name="hours" label="SALAXY.NG1.HouseholdUsecaseComponent.base.hourCount" ng-model="$ctrl.salaryRow.count" required label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-number>
      <salaxy-input-boolean name="isHouseholdDeductible" label="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeduction" type="radio" ng-model="$ctrl.isHouseholdDeductible" label-true="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionTrue" label-false="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionFalse"
        label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-boolean>
      <div ng-if="$ctrl.salaryRow.rowType == 'totalEmployerPayment'" class="alert alert-info" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.totalEmployerPaymentAlert"></div>
      <div ng-if="$ctrl.salaryRow.rowType == 'salary'" class="alert alert-info" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryAlert"></div>
      <div ng-if="$ctrl.salaryRow.rowType != 'totalEmployerPayment'">
        <salaxy-input-boolean name="isTesIncludedInSalary" label="SALAXY.NG1.HouseholdUsecaseComponent.base.tesInclusions" type="radio" ng-model="$ctrl.usecaseData.isTesIncludedInSalary" label-cols="col-sm-6" label-false="SALAXY.NG1.HouseholdUsecaseComponent.base.noCalcAuto"
          label-true="SALAXY.NG1.HouseholdUsecaseComponent.base.yesAgreedTotalPayment" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-boolean>
        <salaxy-input-boolean name="isExpensesCustom" label="SALAXY.NG1.HouseholdUsecaseComponent.construction.expensesCustom" type="radio" ng-model="$ctrl.usecaseData.isExpensesCustom" label-cols="col-sm-6" label-false="SALAXY.NG1.HouseholdUsecaseComponent.base.noByTes"
          label-true="SALAXY.NG1.HouseholdUsecaseComponent.base.yesAgreedPerDay" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-boolean>
        <salaxy-input-number ng-if="!$ctrl.usecaseData.isExpensesCustom" name="dailyTravelExpensesKm" label="SALAXY.NG1.HouseholdUsecaseComponent.construction.dailyTravelExpensesKm" ng-model="$ctrl.usecaseData.dailyTravelExpensesKm" label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()">
        </salaxy-input-number>
        <div ng-if="$ctrl.usecaseData.isExpensesCustom">
          <salaxy-input-number name="dailyExpenses" label="SALAXY.NG1.HouseholdUsecaseComponent.construction.dailyExpenses" ng-model="$ctrl.usecaseData.dailyExpenses" label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-number>
          <salaxy-input-number name="dailyTravelExpenses" label="SALAXY.NG1.HouseholdUsecaseComponent.construction.dailyTravelExpenses" ng-model="$ctrl.usecaseData.dailyTravelExpenses" label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-number>
          <div ng-if="!$ctrl.isReadOnly" class="alert alert-info" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.construction.taxFreeMilageAlert"></div>
        </div>
      </div>
      <salaxy-textarea ng-if="$ctrl.usecaseData.id == 'construction/new' || $ctrl.usecaseData.id == 'construction/renovation'" name="workTypeOtherMessage" label="SALAXY.NG1.HouseholdUsecaseComponent.base.workDescription" ng-model="$ctrl.usecaseData.workTypeOtherMessage"
        label-cols="col-sm-6">
      </salaxy-textarea>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/calc/usecases/household-other.html",`<div>
  <div class="card-header cleaning">
    <span class="float-start">
      <div class="icon-wrapper salaxy-household-usecase-avatar">
        <div class="main-icon-wrapper">
          <img ng-src="{{$ctrl.usecaseData.icon}}">
        </div>
      </div>
    </span>
    <h1>{{$ctrl.usecaseData.label}}</h1>
    <p class="calc-text">
      <span ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">
        {{$ctrl.salaryRow.count || 0}} h x {{$ctrl.salaryRow.price || 0}} €</span>
      <span ng-if="!($ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown')">
        {{$ctrl.salaryRow.price || 0}} €
        <span ng-if="$ctrl.salaryRow.rowType=='monthlySalary'" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.pricePerMonth"></span>
      </span>
      <span ng-if="$ctrl.isHouseholdDeductible" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.isHouseholdDeductible"></span>
      <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">
        {{ ($ctrl.salaryRow.count || 0) * ($ctrl.salaryRow.price || 0) }} €
      </span>
      <span class="result-text" ng-if="!($ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown')">
        {{ $ctrl.salaryRow.price || 0}} €
      </span>
    </p>
    <a class="btn-link btn-showmore" ng-click="showInfo = !showInfo"><span sxy-text="SALAXY.UI_Terms.showMore"></span><i class="bi bi-info-circle-fill"></i></a>
  </div>
  <div class="card-body">
    <p sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.base.shortInfoText.html"></p>
    <span class="collapse" ng-class="{show: showInfo}" sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.base.longInfoText.html"></span>
    <div class="form-horizontal">

      <salaxy-input-enum type="select" name="mainRowType" label="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryKind" placeholder="SALAXY.UI_Terms.select" ng-model="$ctrl.salaryRow.rowType" options="{salary:('SALAXY.ENUM.SalaryKind.salary.label'| sxyTranslate),hourlySalary:('SALAXY.ENUM.CalculationRowType.hourlySalary.label' | sxyTranslate),monthlySalary:('SALAXY.ENUM.CalculationRowType.monthlySalary.label' | sxyTranslate),totalEmployerPayment:('SALAXY.ENUM.CalculationRowType.totalEmployerPayment.label' | sxyTranslate)}"
        ng-change="$ctrl.changeRowType()" label-cols="col-sm-6" hidden-options="unknown" enum="CalculationRowType" required ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-enum>


      <salaxy-input-number name="price" label="{{$ctrl.priceLabel}}" ng-model="$ctrl.salaryRow.price" label-cols="col-sm-6" required ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-number>
      <salaxy-input-number ng-if="$ctrl.salaryRow.rowType == 'hourlySalary'" name="hours" label="SALAXY.NG1.HouseholdUsecaseComponent.base.hourCount" ng-model="$ctrl.salaryRow.count" required label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-number>
      <salaxy-input-occupation-type name="occupationType" ng-model="$ctrl.usecaseData.occupation" label-cols="col-sm-6" label="SALAXY.NG1.WorkerWizardComponent.employment.work.occupationCode" require="$ctrl.usecaseData.id == 'construction/other'" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-occupation-type>

      <salaxy-input-boolean name="isHouseholdDeductible" label="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeduction" type="radio" ng-model="$ctrl.isHouseholdDeductible" label-true="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionTrue" label-false="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionFalse"
        label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-boolean>
      <div ng-if="$ctrl.salaryRow.rowType == 'totalEmployerPayment'" class="alert alert-info" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.totalEmployerPaymentAlert"></div>
      <div ng-if="$ctrl.salaryRow.rowType == 'salary'" class="alert alert-info" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryAlert"></div>
      <salaxy-input-enum label="SALAXY.NG1.HouseholdUsecaseComponent.base.taxDeductionCategories" hidden-options="none" label-cols="col-sm-6" name="taxDeductionCategories" ng-if="$ctrl.isHouseholdDeductible" ng-model="$ctrl.usecaseData.taxDeductionCategories"
        enum="TaxDeductionWorkCategories" type="select" required ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-enum>

      <salaxy-textarea name="message" label="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryMessage" ng-model="$ctrl.salaryRow.message" label-cols="col-sm-6">
      </salaxy-textarea>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/communications/ContactInfo.html",`<div class="salaxy-component salaxy-contact-info">
  <div class="row contact-info-row">
    <div class="salaxy-alert col-12">
      <div class="alert alert-primary">
        <div class="icon-container hidden-xxs">
          <span class="icon">
            <i class="bi bi-question-lg"></i>
          </span>
        </div>
        <div class="contact-info-text" ng-if="!$ctrl.showShortContent">
          <p ng-if="!$ctrl.hideContactInfo" sxy-html="SALAXY.NG1.ContactInfoComponent.contactInfo.html"></p>
          <p sxy-html="SALAXY.NG1.ContactInfoComponent.defaultContent.html"></p>
        </div>
        <div class="contact-info-text" ng-if="$ctrl.showShortContent">
          <p sxy-html="SALAXY.NG1.ContactInfoComponent.shortContent.html"></p>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/communications/messages/message-types/ExpenseReport.html",`<salaxy-calc-rows-editor dimensions="$ctrl.crudController.employingRelation.settings.costAccounting.dimensions" row-types="$ctrl.getRowTypes()" parent="$ctrl.getCalcRowMessage().contentData"></salaxy-calc-rows-editor>
<button type="button" ng-disabled="$ctrl.crudController.isNew()" class="btn btn-primary btn-labeled-left" style="width: 20%; text-align: left; margin-bottom: 4px" ngf-select="$ctrl.crudController.uploadFiles($files)" ngf-multiple="true" ngf-max-size="10MB" xxngf-pattern="$ctrl.crudController.supportedFilesPattern"><i class="bi bi-paperclip" style="width: 38px"></i>
  <span sxy-text="SALAXY.NG1.MessageThreadComponent.fileBtn"></span>
</button>
<div class="row" style="margin-top: 10px;" ng-repeat="item in $ctrl.list">
  <div ng-switch="item.type">
    <div ng-switch-when="blobFile" style="min-width: 600px">
      <div ng-if="item.showPreview">
        <div class="float-end">
          <button type="button" class="btn btn-default btn-xs" ng-click="item.showPreview=false" sxy-text="SALAXY.UI_Terms.close"></button>
          <a class="btn btn-default btn-xs" ng-href="{{$ctrl.crudController.getFileInfo(item).downloadUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.download"></a>
        </div>
        <div style="font-weight: bold;font-size: 1.5em;">{{ item.content }}</div>
        <img class="img-responsive img-thumbnail" ng-src="{{$ctrl.crudController.getFileInfo(item).previewUrl}}" />
      </div>
      <div ng-if="!item.showPreview">
        <div class="float-start" style="margin-right: 10px;max-height: 100px; overflow-y:hidden;" ng-if="$ctrl.crudController.getFileInfo(item).previewUrl">
          <img ng-src="{{$ctrl.crudController.getFileInfo(item).previewUrl}}" class="img-thumbnail" style="max-width: 200px;" />
        </div>
        <i ng-if="!$ctrl.crudController.getFileInfo(item).previewUrl" class="bi {{ $ctrl.crudController.getFileInfo(item).icon }} text-primary float-start" aria-hidden="true" style="font-size: 104px; font-weight: bold"></i>
        <div style="font-weight: bold; font-size: 1.5em;">{{ item.content }}</div>
        <div>
          <button type="button" class="btn btn-default btn-xs" ng-click="item.showPreview=true" ng-if="$ctrl.crudController.getFileInfo(item).previewUrl" sxy-text="SALAXY.UI_Terms.seePreviewAlt"></button>
          <a class="btn btn-default btn-xs" ng-href="{{$ctrl.crudController.getFileInfo(item).downloadUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.download"></a>
        </div>
      </div>
    </div>
  </div>
  
</div>`);

 $templateCache.put("salaxy-components/communications/messages/message-types/HourlyReport.html",`<div class="salaxy-component salaxy-hourly-report">
  <div class="list-group">
    <div class="list-group-item bg-primary">
      <h4 class="list-group-item-heading text-center">
        <div ng-if="$ctrl.reportType === 'hourlyReport'">Tuntiraportti</div>
        <div ng-if="$ctrl.reportType === 'timeReport'">Työaikaraportti</div>
        <i ng-click="$ctrl.changeWeek(false)" class="bi bi-arrow-left-circle-fill bi-2x float-start" aria-hidden="true"></i>
        <i ng-click="$ctrl.changeWeek(true)" class="bi bi-arrow-right-circle-fill bi-2x float-end" aria-hidden="true"></i>
        <div>Viikko {{$ctrl.currentWeekNumber}}</div>
        <div>{{$ctrl.firstDayOfCurrentWeekFormatted}} - {{$ctrl.lastDayOfCurrentWeekFormatted}}</div>
      </h4>
    </div>
    <div class="list-group-item" ng-repeat="day in $ctrl.currentWeek">
      <div class="text-center float-start text-uppercase week-icon" ng-class="$ctrl.getDateStyle(day.date)">
        {{ day.dayName }}<br> {{ day.displayDate }}
      </div>
      <div class="float-end" style="margin-top: 6px">
        <button ng-if="$ctrl.showExpandButton(day.date)" ng-click="$ctrl.setHourlyRecordsVisible(day.date)" type="button" class="btn btn-default">
          <i class="bi" ng-class="{'bi-chevron-up' : !day.isCollapsed,  'bi-chevron-down' : day.isCollapsed}"></i>
        </button>
        <button ng-click="$ctrl.showEditDialog($ctrl.getEditDialogItem(day.date), true)" type="button" class="btn btn-default"><i class="bi bi-plus-lg"></i></button>
      </div>
      <p class="list-group-item-text">{{$ctrl.countDailyHours(day.date) | sxyTotalTime : "minutes"}}</p>
      <div ng-if="!day.isCollapsed">
        <div ng-if="$ctrl.reportType == 'hourlyReport'" style="margin-bottom: 5px;" ng-repeat="message in $ctrl.list | filter: { contentData: {period: {start: day.date}} }">
          <div>
            <span style="padding-top: 2px;"><strong>{{$ctrl.getDimensionOptionText(message.contentData.project)}}</strong> ({{message.contentData.totalTime | sxyTotalTime : "minutes"}} h)</span><br>
            <span class="small text-overflow-80pc" style="padding-top: 2px;">{{message.contentData.projectText}}</span>
            <div class="float-end">
              <button ng-click="$ctrl.showEditDialog(message, false)" type="button" class="btn btn-default btn-xs"><i class="bi bi-pencil-fill"></i></button>
            </div>
          </div>
        </div>
        <div ng-if="$ctrl.reportType == 'timeReport'" style="margin-bottom: 5px;" ng-repeat="message in $ctrl.list | filter: { contentData: {period: {start: day.date}} }">
          <div>
            <span style="padding-top: 2px;"><strong>{{message.contentData.project}}</strong> ({{message.contentData.startTime | date:'HH:mm'}} - {{message.contentData.endTime | date:'HH:mm'}})</span><br>
            <span class="small text-overflow-80pc" style="padding-top: 2px;">{{message.contentData.projectText}}</span>
            <div class="float-end">
              <button ng-click="$ctrl.showEditDialog(message, false)" type="button" class="btn btn-default btn-xs"><i class="bi bi-pencil-fill"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list-group-item">
      <h4 class="list-group-item-heading">
        <div class="text-center float-start text-uppercase btn btn-default week-icon">
          <small>Viikko</small><br> {{$ctrl.currentWeekNumber}}
        </div>
        <div class="float-end" style="margin-top: 10px">Yhteensä</div>
        <p class="list-group-item-text" style="height: 40px; padding-left: 80px; padding-top: 10px;">{{$ctrl.weeklyHours | sxyTotalTime : "minutes"}}</p>
      </h4>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/communications/messages/message-types/Timer.html",`<div class="salaxy-component salaxy-timer">
  <div ng-if="$ctrl.timerMode == 'mini'">
    <div class="card card-panel panel-solid" ng-class="$ctrl.isTimerOnFromDayBefore ? 'panel-warning' : 'panel-primary'">
      <div class="card-header">
        <div class="float-start icon-container" style="padding-left: 0;">
          <i class="bi " ng-class="$ctrl.isTimerOn ? 'bi-exclamation-lg' : 'bi-clock'">
          </i>
        </div>
        <h3 class="card-title">Olet leimannut sisään kellokorttiin</h3>
        <div class="date">{{$ctrl.getTimerMessage().contentData.period.start | date : "d.M.yyyy"}}</div>
      </div>
      <div class="card-content card-body">
        <div class="text-center">
          <div class="otherparty-container">
            <salaxy-avatar avatar="$ctrl.parent.ownerInfo"></salaxy-avatar>
            <span>{{$ctrl.parent.ownerInfo.displayName}}</span>
          </div>
          <div class="clock-text card-main text-white">
            <i class="bi bi-clock" aria-hidden="true"></i> {{ $ctrl.getTimerMessage().contentData.totalTimeInSeconds | sxyTotalTime : "seconds"}}
          </div>
          <div class="card-details-title" ng-if="$ctrl.getTimerMessage().contentData.project">
            
            {{$ctrl.getDimensionOptionText($ctrl.getTimerMessage().contentData.project)}}
          </div>
          <span ng-if="$ctrl.getTimerMessage().contentData.projectText" class="card-details">
            {{$ctrl.getTimerMessage().contentData.projectText}}
          </span>
        </div>

      </div>
      <div class="card-footer">
        <button ng-click="$ctrl.crudController.showDetails($ctrl.parent)" class="btn btn-sm btn-white">Muokkaa</button>
      </div>
    </div>
  </div>

  <div ng-if="$ctrl.timerMode != 'mini' && $ctrl.timerMode != 'edit'">
    <div class="thumbnail thumbnail-timer">
      <form name="timerForm">

        <div class="text-center timer-container" ng-class="$ctrl.isTimerOnFromDayBefore ? 'bg-warning' : 'bg-primary'">
          <h3>Kellokortti</h3>
          <div class="clock-text">
            <i class="bi bi-clock" aria-hidden="true"></i> {{$ctrl.getTimerMessage().contentData.totalTimeInSeconds | sxyTotalTime : "seconds"}}
          </div>
          <div class="text-center form-inline">
            Aloitus:
            <span ng-if="!$ctrl.editStartTime" class="timer-time-input-read-only">{{ $ctrl.getTimerMessage().contentData.startTime}}</span>
            <salaxy-input-time ng-if="$ctrl.editStartTime" name="startTime" label="Työaika" type="time" ng-model="$ctrl.getTimerMessage().contentData.startTime"></salaxy-input-time>
            <button type="button" class="btn btn-sm btn-transparent" ng-click="$ctrl.editStartTime=!$ctrl.editStartTime"><i class="bi bi-pencil-fill"></i></button>
          </div>
          <div>Yhteensä tänään {{ $ctrl.getAndFormatTotal()}}</div>
          <div style="padding: 10px;">
            <div ng-if="$ctrl.crudController.employingRelation.settings.costAccounting.dimensions"  ng-controller="CostAccountingController as $cost" ng-init="$cost.dimensions=$ctrl.crudController.employingRelation.settings.costAccounting.dimensions">
              <salaxy-input-typeahead ng-if="$cost.getDefinition('lk1')"  label-type="plain" placeholder="{{($cost.getDefinition('lk1').label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" label-format="text-value" name="options_project" ng-model="$ctrl.getTimerMessage().contentData.project" options="$cost.getDefinition('lk1').options" required="true"></salaxy-input-typeahead>
            </div>
            <salaxy-input label-type="plain" placeholder="Kommentti"  name="comment" ng-model="$ctrl.getTimerMessage().contentData.projectText" class="timer-comment-input"></salaxy-input>
          </div>
          <div>
            <button ng-if="!$ctrl.isTimerOn" class="btn btn-lg btn-primary btn-timer-start" ng-click="$ctrl.startTimer()">
          <i class="bi bi-play-fill bi-2x"></i>
        </button>
            <button ng-if="$ctrl.isTimerOn" class="btn btn-lg btn-danger btn-timer-stop" ng-click="$ctrl.stopTimer()">
          <i class="bi bi-stop-fill bi-2x"></i>
        </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div ng-if="$ctrl.timerMode != 'mini' && $ctrl.list.length" class="list-group list-group-timer">
    <div class="list-group-item item-today">
      <div class="list-group-item-heading">
        TÄNÄÄN, {{ "today" | sxyDate }}
      </div>
    </div>
    <div class="list-group-item" ng-repeat="message in $ctrl.list">
      <div class="list-group-item-heading">
        <div class="float-end">
          {{ message.contentData.totalTime | sxyTotalTime : "minutes"}} h
          <button type="button" class="btn btn-xs btn-transparent" ng-click="$ctrl.showEditDialog(message, false)"><i class="bi bi-pencil-fill"></i></button>
        </div>
        {{ message.contentData.startTime}}-{{ message.contentData.endTime}}
        <br>
      </div>
     <!--  <div class="float-end">
        <button type="button" class="btn btn-xs btn-transparent" ng-click="$ctrl.showEditDialog(message, false)"><i class="bi bi-pencil-fill"></i></button>
      </div> -->
      <p class="list-group-item-text">{{ $ctrl.getDimensionOptionText(message.contentData.project) }}</p>
      <p class="list-group-item-text" ng-if="message.contentData.projectText">{{ message.contentData.projectText }}</p>
      <salaxy-validation-summary api-validation="message.validation" layout="minimal" class="text-danger"></salaxy-validation-summary>
    </div>
    <div class="list-group-item list-group-item-footer text-end">
      <button class="btn btn-sm btn-primary" ng-click="$ctrl.showEditDialog('new', true)">Lisää uusi merkintä <span class="bi bi-plus-lg"></span></button>
    </div>
    <div class="list-group-item list-group-item-footer">
      <div class="float-end">{{ $ctrl.getAndFormatTotal() }}</div>
      Yhteensä
    </div>
  </div>

</div>`);

 $templateCache.put("salaxy-components/communications/messages/MessageContent.html",`<div ng-switch="item.type">
  <div ng-switch-when="blobFile" style="min-width: 600px">
    <div ng-if="item.showPreview">
      <div class="float-end">
        <button type="button" class="btn btn-default btn-xs" ng-click="item.showPreview=false" sxy-text="SALAXY.UI_Terms.close"></button>
        <a class="btn btn-default btn-xs" ng-href="{{$ctrl.getFileInfo(item).downloadUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.download"></a>
      </div>
      <div style="font-weight: bold;font-size: 1.5em;">{{ item.content }}</div>
      <img class="img-fluid img-thumbnail" ng-src="{{$ctrl.getFileInfo(item).previewUrl}}" />
    </div>
    <div ng-if="!item.showPreview">
      <div class="float-start" style="margin-right: 10px;max-height: 100px; overflow-y:hidden;" ng-if="$ctrl.getFileInfo(item).previewUrl">
        <img ng-src="{{$ctrl.getFileInfo(item).previewUrl}}" class="img-thumbnail" style="max-width: 200px;" />
      </div>
      <i ng-if="!$ctrl.getFileInfo(item).previewUrl" class="bi {{ $ctrl.getFileInfo(item).icon }} text-primary float-start" aria-hidden="true" style="font-size: 104px; font-weight: bold"></i>
      <div style="font-weight: bold; font-size: 1.5em;">{{ item.content }}</div>
      <div>
        <button type="button" class="btn btn-default btn-xs" ng-click="item.showPreview=true" ng-if="$ctrl.getFileInfo(item).previewUrl" sxy-text="SALAXY.UI_Terms.seePreviewAlt"></button>
        <a class="btn btn-default btn-xs" ng-href="{{$ctrl.getFileInfo(item).downloadUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.download"></a>
      </div>
    </div>
  </div>
  <div ng-switch-when="calculation" ng-controller="CalculationCrudController as $calcCtrl" ng-init="$calcCtrl.model=(item.contentId || item.content)">
    <salaxy-spinner ng-if="$calcCtrl.isLoading"></salaxy-spinner>
    <div ng-if="$calcCtrl.current">
      <div>
        <table class="table table-borderless bg-transparent">
          <tbody>
            <tr>
              <td class="td-avatar middle">
                <salaxy-avatar avatar="$calcCtrl.current.worker.avatar"></salaxy-avatar>
              </td>
              <td class="td-name middle">
                <span ng-if="!$calcCtrl.current.worker.avatar.displayName" sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.notSelected"></span>
                <strong>{{$calcCtrl.current.worker.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + $calcCtrl.current.workflow.status + ".label" | sxyTranslate }} {{$calcCtrl.current.workflow.paidAt | date}}
              </td>
              <td class="right middle">
                <span sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.salary" ps=":"></span> {{ $calcCtrl.current.result.totals.totalGrossSalary | currency }}<br /> <span sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.payment" ps=":"></span>                {{ $calcCtrl.current.result.employerCalc.totalPayment | currency }}
              </td>
              <td class="middle">
                <a ng-href="{{$calcCtrl.getPdfUrl($calcCtrl.current)}}" target="_blank" class="btn btn-sm btn-primary btn-block" sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.report"></a>
              </td>
              <td class=" middle">
                <a ng-href="#/calc/details/{{ $calcCtrl.current.id }}" class="btn btn-sm btn-default btn-block">
                  {{ $calcCtrl.current.workflow.status == 'draft' ? ('SALAXY.NG1.MessageThreadComponent.messageContent.editPay' |sxyTranslate) : ('SALAXY.NG1.MessageThreadComponent.messageContent.showCalc' |sxyTranslate) }}
                </a>
                <a ng-if="$calcCtrl.current.data.payrollId" class="btn btn-sm btn-primary btn-block" ng-href="#/payroll/details/{{ $calcCtrl.current.data.payrollId }}">
                  <i class="bi bi-list-task d-sm-none d-inline-block"></i>
                  <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.payroll"></span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- TODO: change the preview to be based on index not on actual object -->
  <div ng-switch-when="payroll" ng-controller="PayrollCrudController as $payrollCtrl" ng-init="$payrollCtrl.model=(item.contentId || item.content)">
    <salaxy-spinner ng-if="$payrollCtrl.isLoading"></salaxy-spinner>
    <div ng-if="$payrollCtrl.current">
      <div>
        <table class="table table-borderless bg-transparent">
          <tbody>
            <tr>
              <td class="middle salaxy-component salaxy-payroll">
                <div class="payroll-info-row" style="margin-top:0px">
                  <salaxy-avatar-placeholder class="payroll-avatar">
                    <i class="salaxy-avatar bi bi-square-fill d-flex" style="color:#FDC338;">
                      <div class="avatar-text-wrapper">
                        <strong>{{ $payrollCtrl.calcs.length }}</strong>
                        <small>{{ $payrollCtrl.current.info.salaryDate | date : "d.M." }}</small>
                      </div>
                    </i>
                  </salaxy-avatar-placeholder>
                </div>
              </td>
              <td class="td-name middle">
                <strong>{{$payrollCtrl.current.input.title}}</strong><br /> {{ "SALAXY.ENUM.PayrollStatus." + $payrollCtrl.current.info.status + ".label" | sxyTranslate }}
              </td>
              <td class="right middle">
                <span sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.salary" ps=":"></span> {{ $payrollCtrl.info.totalGrossSalary | currency }}<br /> <span sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.payment" ps=":"></span>                {{ $payrollCtrl.info.totalPayment | currency }}
              </td>
              <td class="middle">
                <a ng-href="{{$payrollCtrl.getPdfUrl()}}" target="_blank" class="btn btn-sm btn-default btn-block" sxy-text="PDF"></a>
              </td>
              <td class=" middle">
                <a ng-href="#/payroll/details/{{ $payrollCtrl.current.id }}" class="btn btn-sm btn-primary btn-block">
                  {{ $payrollCtrl.current.info.status == 'draft' ? ('SALAXY.UI_Terms.edit' |sxyTranslate) : ('SALAXY.UI_Terms.show' |sxyTranslate) + " &raquo;"   }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div ng-switch-when="text">
    <div class="message-content" ng-if="!$ctrl.isInEdit">{{ item.content }}</div>
    <div ng-if="$ctrl.isInEdit">
      <textarea ng-model="item.content"></textarea>
    </div>
  </div>
  <div ng-switch-when="email">
    <div class="message-content">
      <span sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.toEmail" ps=":"></span> <a href="mailto:{{ item.content }}">{{ item.content }}</a>
    </div>
  </div>
  <div ng-switch-when="absence">
    <salaxy-absence-periods parent="item.contentData" condensed="true"></salaxy-absence-periods>
  </div>
  <div ng-switch-default class="alert alert-danger">
    {{ item.type }}: {{ item.content }}
  </div>
  <div class="edit-toolbar btn-toolbar" role="toolbar" ng-if="$ctrl.isInEdit">
    <div class="btn-group" role="group">
      <button class="btn btn-xs btn-danger" ng-click="$ctrl.deleteMessage(item)" sxy-text="SALAXY.UI_Terms.delete"></button>
      <button class="btn btn-xs btn-primary" ng-click="$ctrl.markItemAsRead(item, true)" ng-if="!$ctrl.getReadTime(item)" sxy-text="SALAXY.NG1.MessageThreadComponent.markAsReadBtn"></button>
      <button class="btn btn-xs btn-primary" ng-click="$ctrl.markItemAsRead(item, false)" ng-if="$ctrl.getReadTime(item)" sxy-text="SALAXY.NG1.MessageThreadComponent.markAsUnreadBtn"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/communications/messages/proto-usecase/calc.html",`<h1>calc here</h1>`);

 $templateCache.put("salaxy-components/communications/messages/proto-usecase/default.html",`<div ng-if="$ctrl.isNew()">
  <salaxy-input name="title" label="SALAXY.NG1.MessageThreadComponent.title" require="true" ng-model="$ctrl.current.title"></salaxy-input>
  <salaxy-form-group label="" name="submit" class="no-colon">
    <button type="submit" class="btn btn-primary" ng-disabled="!newMessageThread.$valid" ng-click="$ctrl.save()"
      sxy-text="SALAXY.NG1.MessageThreadComponent.ui.newMessageThreadBtn"></button>
  </salaxy-form-group>
</div>
<div ng-if="!$ctrl.isNew()"> 
  <p ng-if="$ctrl.current.messages.length == 0">&nbsp;</p>
  <div class="messages-container" ng-if="$ctrl.current.messages">
    <div ng-repeat="item in $ctrl.current.messages" ng-switch="item.fromParty">
      <div ng-switch-when="owner,undefined" ng-switch-when-separator=",">
        <salaxy-avatar avatar="$ctrl.current.ownerInfo" class="float-start"></salaxy-avatar>
        <div class="message-bubble left" ng-class="{ 'in-edit': $ctrl.isInEdit, 'unread': !$ctrl.getReadTime(item)  }">
          <ng-include src="'salaxy-components/communications/messages/MessageContent.html'"></ng-include>
          <span class="updated-at">{{ item.time | sxyTime }}, {{ $ctrl.getReadTime(item) ? (('SALAXY.NG1.MessageThreadComponent.read' |sxyTranslate) + ' ' + ($ctrl.getReadTime(item) |
            sxyTime)) : ('SALAXY.NG1.MessageThreadComponent.unread' |sxyTranslate) }}</span>
        </div>
      </div>
      <div ng-switch-when="otherParty" class="text-end">
        <salaxy-avatar avatar="$ctrl.current.otherPartyInfo" class="float-end"></salaxy-avatar>
        <div class="message-bubble right {{item.type}}" ng-class="{ 'in-edit': $ctrl.isInEdit, 'unread': !$ctrl.getReadTime(item) }">
          <ng-include src="'salaxy-components/communications/messages/MessageContent.html'"></ng-include>
          <span class="updated-at" ng-if="item.type != 'email'">{{ item.time | sxyTime }}, {{ $ctrl.getReadTime(item) ? (('SALAXY.NG1.MessageThreadComponent.read' |sxyTranslate) + ' ' +
            ($ctrl.getReadTime(item) | sxyTime)) : ('SALAXY.NG1.MessageThreadComponent.unread' |sxyTranslate)}}</span>
          <span class="updated-at" ng-if="item.type == 'email'">{{ item.time | sxyTime }}</span>
        </div>
      </div>
      <div ng-switch-default class="alert alert-danger">
        <ng-include src="'salaxy-components/communications/MessageThread_MessageContent.html'"></ng-include>
      </div>
    </div>
    <div class="padding">
      <div ng-if="$ctrl.isReadOnly" class="alert alert-info">
        <p>
          <strong>Viestiketju on suljettu</strong>
          <!-- TODO: Onko reopen mahdollinen myös työntekijälle? -->
        </p>
      </div>
      <div class="row" ng-if="!$ctrl.isReadOnly">
        <div class="col-8 col-sm-9" ng-switch="$ctrl.newMessage.type">
          <div ng-switch-when="absence">
            <salaxy-absence-periods parent="$ctrl.newMessage.contentData" condensed="true"></salaxy-absence-periods>
          </div>
          <div ng-switch-when="annualLeave">
            <salaxy-holiday-year-holidays parent="$ctrl.newMessage.contentData" condensed="true"></salaxy-holiday-year-holidays>
          </div>
          <textarea ng-switch-default placeholder="{{'SALAXY.NG1.MessageThreadComponent.writeOrPaste' |sxyTranslate}}" ng-model="$ctrl.newMessage.content"></textarea>
        </div>
        <div class="col-4 col-sm-3" ng-if="!$ctrl.isReadOnly">
          <button type="button" class="btn btn-primary btn-labeled-left test-start" style="width: 100%;  margin-bottom: 4px" ng-click="$ctrl.sendMessage()"
            ng-disabled="!$ctrl.newMessage.content">
            <i class="bi bi-send-fill"></i>
            <span sxy-text="SALAXY.UI_Terms.send"></span>
          </button>
          <button type="button" class="btn btn-primary btn-labeled-left text-start" style="width: 100%;  margin-bottom: 4px" ngf-select="$ctrl.uploadFiles($files)"
            ngf-multiple="true" ngf-max-size="10MB">
            <i class="bi bi-paperclip"></i>
            <span sxy-text="SALAXY.NG1.MessageThreadComponent.fileBtn"></span>
          </button>
          <div class="btn-group btn-block dropup">
            <button type="button" class="btn btn-secondary dropdown-toggle btn-labeled-left text-start mt-1 w-100" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="bi bi-chevron-up"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.MessageThreadComponent.moreFeaturesBtn"></span>
            </button>
            <ul class="dropdown-menu dropdown-menu-end" role="menu">
              <li role="menuitem">
                <a ng-click="$ctrl.delete(null, ('SALAXY.NG1.MessageThreadComponent.deleteThreadAlert' | sxyTranslate ))" class="dropdown-item" sxy-text="SALAXY.NG1.MessageThreadComponent.deleteThread"></a>
              </li>
              <li role="separator" class="divider"></li>
              <li role="menuitem">
                <a ng-click="$ctrl.setType('absence')" class="dropdown-item">Lisää poissaoloja</a>
              </li>
              <li role="menuitem">
                <a ng-click="$ctrl.setType('annualLeave')" class="dropdown-item">Lisää lomapyyntö</a>
              </li>
              <li role="menuitem">
                <a ng-click="$ctrl.setType('calcRow')" class="dropdown-item">Lisää palkkarivejä</a>
              </li>
              <li role="menuitem">
                <a ng-click="$ctrl.setType('text')" class="dropdown-item">Teksti tai tiedosto (oletus)</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div id="messageContainerBottom">&nbsp;</div>
  </div>
</div>
`);

 $templateCache.put("salaxy-components/communications/messages/proto-usecase/expenses.html",`<h1>Kulukorvaukset tänne</h1>`);

 $templateCache.put("salaxy-components/communications/messages/proto-usecase/timer.html",`<div>
  <h3>Kellokortti</h3>
    <div class="thumbnail" style="max-width:400px; height: 320px; margin: auto;" >
      <div style="width: 100%; height: 100%;" class="bg-primary text-center">
        <div style="font-size: 3.5em; padding-top: 20px;">
          <i class="bi bi-clock" aria-hidden="true"></i>
          {{ $ctrl.currentEntry.total | date : "HH:mm:ss" : "UTC" }}
        </div>
        <div class="d-flex justify-content-center">
          Aloitus: 
          <span ng-if="!$ctrl.editStartTime">{{ $ctrl.currentEntry.start | date : "HH:mm" }}</span>
          <input ng-if="$ctrl.editStartTime" class="form-control input-sm" style="display: inline;width: 100px;" type="time" id="appt" name="appt" ng-model="$ctrl.currentEntry.start" ng-model-options="{allowInvalid: true, debounce: 1000}" required>
          <button type="button" class="btn btn-xs btn-primary" ng-click="$ctrl.editStartTime=!$ctrl.editStartTime"><i class="bi bi-pencil-fill"></i></button>
        </div>
        <div>Yhteensä tänään 01:20</div>
        <div style="padding: 10px;">
          <salaxy-input-typeahead label="Valitse projekti" placeholder="Valitse projekti" label-type="plain" name="project" ng-model="$ctrl.currentEntry.project" options="$ctrl.projects"></salaxy-input-typeahead>
          <salaxy-input placeholder="Kommentti" label-type="plain" name="comment" ng-model="$ctrl.currentEntry.comment"></salaxy-input>
        </div>
        <div>
          <a ng-if="!$ctrl.currentEntry.isStarted" class="btn btn-lg btn-success" href="" ng-click="$ctrl.startTimer()">
            <i class="bi bi-play-fill bi-2x"></i>
          </a>
          <a ng-if="$ctrl.currentEntry.isStarted" class="btn btn-lg btn-danger" href="" ng-click="$ctrl.stopTimer()">
            <i class="bi bi-stop-fill bi-2x"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="list-group">
      <div class="list-group-item" style="margin-top: 10px;padding-bottom: 0px" ng-if="$ctrl.entries.length">
        <div class="list-group-item-heading">
          TÄNÄÄN, {{ "today" | sxyDate }}
        </div>
      </div>
      <a href="" class="list-group-item" ng-repeat="entry in $ctrl.entries">
        <h4 class="list-group-item-heading">
          <div class="float-end">{{ entry.total | date : "HH:mm" : "UTC" }}</div>
          {{ entry.start | date : "HH:mm" }}-{{ entry.end | date : "HH:mm" }}
        </h4>
        <div class="float-end">
          <button type="button" class="btn btn-xs btn-primary"><i class="bi bi-pencil-fill"></i></button>
          <button type="button" class="btn btn-xs btn-danger"><i class="bi bi-trash-fill"></i></button>
        </div>
        <p class="list-group-item-text">{{ $ctrl.getProjectText(entry.project) }}</p>
        <p class="list-group-item-text" ng-if="entry.comment">{{ entry.comment }}</p>
      </a>
      <div class="list-group-item" style="" ng-if="$ctrl.entries.length">
        <div class="list-group-item-footer">
          <div class="float-end">{{ $ctrl.getTotal() | date : "HH:mm" : "UTC" }}</div>
          Yhteensä
        </div>
      </div>
    </div>
    <pre>{{ $ctrl.current | json }}</pre>
</div>`);

 $templateCache.put("salaxy-components/communications/messages/proto-usecase/timesheet.html",`<div>
  <h3>Tuntiraportti</h3>
  <div class="list-group">
    <div class="list-group-item bg-primary">
      <h4 class="list-group-item-heading text-center">
        <div>Viikko 18</div>
        <i class="bi bi-arrow-left-circle-fill float-start" aria-hidden="true"></i>
        <i class="bi bi-arrow-right-circle-fill float-end" aria-hidden="true"></i>
        <div>2.-8.5.2022</div>
      </h4>
    </div>
    <div class="list-group-item" ng-repeat="day in $ctrl.calendarDemoData">
      <h4 class="list-group-item-heading">
        <div class="text-center float-start text-uppercase" ng-class="day.isHoliday ? 'btn btn-default' : 'bg-primary'" style="margin-left: -10px;margin-top:-5px;height: 55px; padding-top: 10px;width: 60px;">
          {{ day.day }}<br>
          {{ day.date }}
        </div>
        <div class="float-end" style="margin-top: 6px">
          <button type="button" class="btn btn-default"><i class="bi bi-pencil-fill"></i></button>
          <button type="button" class="btn btn-default"><i class="bi bi-plus-lg"></i></button>
        </div>
        <p class="list-group-item-text" style="height: 40px; padding-left: 80px; padding-top: 10px;">{{ day.hours }}</p>
      </h4>
    </div>
    <div class="list-group-item">
      <h4 class="list-group-item-heading">
        <div class="text-center float-start text-uppercase btn btn-default" style="margin-left: -10px;margin-top:-5px;height: 55px; padding-top: 10px;width: 60px;">
          <small>Viikko</small><br>
          18
        </div>
        <div class="float-end" style="margin-top: 10px">yhteensä</div>
        <p class="list-group-item-text" style="height: 40px; padding-left: 80px; padding-top: 10px;">15:00 h</p>
      </h4>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/communications/messages/proto-usecase/travel.html",`<h1>Travel here</h1>`);

 $templateCache.put("salaxy-components/communications/MessageThread.html",`<div class="salaxy-component salaxy-message-thread">
  <salaxy-spinner ng-if="$ctrl.isLoading"></salaxy-spinner>
  <div ng-if="$ctrl.status == 'loadError'" class="alert alert-danger" sxy-text="SALAXY.NG1.MessageThreadComponent.error"></div>
  <div>
    <!-- ng-transclude does not work in include -->
    <div ng-if="$ctrl.isNew()">
      <form name="newMessageThread" ng-readonly="$ctrl.isReadOnly" class="form-horizontal">
        <ng-transclude ng-transclude-slot="headerNew">
          <h1 sxy-text="SALAXY.NG1.MessageThreadComponent.newMessage.headerTitle"></h1>
          <p class="lead" sxy-html="SALAXY.NG1.MessageThreadComponent.newMessage.headerDescription.html"></p>
        </ng-transclude>
        <salaxy-input name="title" label="SALAXY.NG1.MessageThreadComponent.title" require="true" ng-model="$ctrl.current.title"></salaxy-input>
        <salaxy-input-enum name="otherParty" ng-model="$ctrl.otherParty" ng-if="$ctrl.otherPartyOptions" label="SALAXY.NG1.MessageThreadComponent.receiver" type="select" placeholder="SALAXY.UI_Terms.choose" required options="$ctrl.otherPartyOptions"></salaxy-input-enum>
        <salaxy-input-enum name="msgType" ng-model="$ctrl.msgType" label="SALAXY.NG1.MessageThreadComponent.subject" type="radio" ng-init="$ctrl.msgType = 'salary'" options="{ salary: ('SALAXY.NG1.MessageThreadComponent.subjectOptionSalary' | sxyTranslate), other:  ('SALAXY.NG1.MessageThreadComponent.subjectOptionOther' | sxyTranslate) }"></salaxy-input-enum>
        <salaxy-datepicker name="salaryDate" ng-model="$ctrl.current.ownerWorkflow.salaryDate" label="{{ $ctrl.msgType == 'salary' ? 'SALAXY.NG1.MessageThreadComponent.salaryDate' : 'SALAXY.NG1.MessageThreadComponent.replyDate'}}" date-disabled="next-weekday" require="$ctrl.msgType == 'salary'" show-buttons="false"></salaxy-datepicker>
        <salaxy-form-group label-type="empty-label" name="submit" class="no-colon">
          <button type="submit" class="btn btn-primary" ng-disabled="!newMessageThread.$valid" ng-click="$ctrl.save()" sxy-text="SALAXY.NG1.MessageThreadComponent.ui.newMessageThreadBtn"></button>
        </salaxy-form-group>
      </form>
    </div>
    <div ng-if="!$ctrl.isNew() && $ctrl.current">
      <ng-transclude ng-transclude-slot="header">
        <h2>
          {{ $ctrl.current.title }}<small>, <span sxy-text="SALAXY.NG1.MessageThreadComponent.salaryDate"></span> {{ $ctrl.current.ownerWorkflow.salaryDate | sxyDate }}</small>
        </h2>
      </ng-transclude>
      <p ng-if="$ctrl.current.messages.length == 0">&nbsp;</p>
      <div class="messages-container" ng-if="$ctrl.current.messages">
        <div ng-repeat="item in $ctrl.current.messages" ng-switch="item.fromParty">
          <div ng-switch-when="owner,undefined" ng-switch-when-separator=",">
            <salaxy-avatar avatar="$ctrl.current.ownerInfo" class="float-start"></salaxy-avatar>
            <div class="message-bubble left" ng-class="{ 'in-edit': $ctrl.isInEdit, 'unread': !$ctrl.getReadTime(item)  }">
              <ng-include src="'salaxy-components/communications/messages/MessageContent.html'"></ng-include>
              <span class="updated-at">{{ item.time | sxyTime }}, {{ $ctrl.getReadTime(item) ? (('SALAXY.NG1.MessageThreadComponent.read' |sxyTranslate) + ' ' + ($ctrl.getReadTime(item) | sxyTime)) : ('SALAXY.NG1.MessageThreadComponent.unread' |sxyTranslate) }}</span>
            </div>
          </div>
          <div ng-switch-when="otherParty" class="text-end">
            <salaxy-avatar avatar="$ctrl.current.otherPartyInfo" class="float-end"></salaxy-avatar>
            <div class="message-bubble right {{item.type}}" ng-class="{ 'in-edit': $ctrl.isInEdit, 'unread': !$ctrl.getReadTime(item) }">
              <ng-include src="'salaxy-components/communications/messages/MessageContent.html'"></ng-include>
              <span class="updated-at" ng-if="item.type != 'email'">{{ item.time | sxyTime }}, {{ $ctrl.getReadTime(item) ? (('SALAXY.NG1.MessageThreadComponent.read' |sxyTranslate) + ' ' + ($ctrl.getReadTime(item) | sxyTime)) : ('SALAXY.NG1.MessageThreadComponent.unread' |sxyTranslate)}}</span>
              <span class="updated-at" ng-if="item.type == 'email'">{{ item.time | sxyTime }}</span>
            </div>
          </div>
          <div ng-switch-default class="alert alert-danger">
            <ng-include src="'salaxy-components/communications/MessageThread_MessageContent.html'"></ng-include>
          </div>
        </div>
        <div class="padding message-actions">
          <div class="btn-toolbar mb-2" role="toolbar" ng-if="$ctrl.role == 'otherParty'">
            <salaxy-workflow-buttons api-ctrl="$ctrl"></salaxy-workflow-buttons>
            <div class="btn-group" role="group">
              <button class="btn btn-primary" ng-class="{ 'disabled': $ctrl.getReadTime()}" ng-click="$ctrl.markAllAsRead()" sxy-text="SALAXY.NG1.MessageThreadComponent.markAsReadBtn"></button>
            </div>
            <button ng-if="$ctrl.role == 'otherParty'" ng-click="$ctrl.sendNotification()" class="btn btn-default" sxy-text="SALAXY.NG1.MessageThreadComponent.sendtoEmailBtn"></button>
            <div class="btn-group" role="group">
              <button class="btn btn-default" ng-click="$ctrl.reload()" sxy-text="SALAXY.NG1.MessageThreadComponent.reloadBtn"></button>
              <button class="btn btn-default" ng-click="$ctrl.isInEdit=true" ng-class="{ 'disabled': $ctrl.isInEdit }" sxy-text="SALAXY.UI_Terms.edit"></button>
              <button class="btn" ng-click="$ctrl.save();$ctrl.isInEdit=false" ng-class="{ 'btn-primary': $ctrl.hasChanges, 'btn-default': !$ctrl.hasChanges }" sxy-text="SALAXY.UI_Terms.save"></button>
              <button class="btn btn-default" ng-class="{ 'disabled': !$ctrl.isInEdit }" ng-click="$ctrl.reset();$ctrl.isInEdit=false" sxy-text="SALAXY.UI_Terms.cancel"></button>
            </div>
            <div ng-if="$ctrl.current.status == 'active' || $ctrl.current.status == 'approved' || $ctrl.current.status == 'rejected'" class="btn-group btn-group-sm" role="group" aria-label="Approval toolbar">
              <button type="button" class="btn btn-success" ng-click="$ctrl.current.status = 'approved';$ctrl.save()"
                ng-disabled="$ctrl.current.status == 'approved'">Hyväksy</button>
              <button type="button" class="btn btn-danger" ng-click="$ctrl.current.status = 'rejected';$ctrl.save()"
                ng-disabled="$ctrl.current.status == 'rejected'">Hylkää</button>
              <button type="button" class="btn btn-danger" ng-click="$ctrl.current.status = 'active';$ctrl.save()"
                ng-disabled="$ctrl.current.status == 'active'">Poista hyväksyntä/hylkäys</button>
            </div>
          </div>
          <div ng-if="$ctrl.isReadOnly" class="alert alert-info">
            <p>
              <strong sxy-text="SALAXY.NG1.MessageThreadComponent.handledInfo"></strong>
              <br>
              <salaxy-workflow-reopen api-ctrl="$ctrl"></salaxy-workflow-reopen>
            </p>
          </div>
          <div class="row" ng-if="!$ctrl.isReadOnly">
            <div class="col-8 col-sm-9">
              <textarea placeholder="{{'SALAXY.NG1.MessageThreadComponent.writeOrPaste' |sxyTranslate}}" ng-model="$ctrl.newMessage.content"></textarea>
            </div>
            <div class="col-4 col-sm-3 d-flex flex-column" ng-if="!$ctrl.isReadOnly">
              <button type="button" class="btn btn-primary btn-labeled-left text-start mb-1" ng-click="$ctrl.sendMessage()" ng-disabled="!$ctrl.newMessage.content">
                <i class="bi bi-send-fill"></i>
                <span sxy-text="SALAXY.UI_Terms.send"></span>
              </button>
              <button type="button" class="btn btn-primary btn-labeled-left text-start mb-1" ng-disabled="$ctrl.newMessage.content.length > 0" ngf-select="$ctrl.uploadFiles($files)" ngf-multiple="true" ngf-max-size="10MB" xxngf-pattern="$ctrl.supportedFilesPattern">
                <i class="bi bi-paperclip"></i>
                <span sxy-text="SALAXY.NG1.MessageThreadComponent.fileBtn"></span>
              </button>
              <div class="btn-group btn-block dropup" ng-if="$ctrl.role == 'otherParty'">
                <button type="button" class="btn btn-secondary dropdown-toggle text-start w-100" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span sxy-text="SALAXY.NG1.MessageThreadComponent.moreFeaturesBtn"></span>
                </button>
                <ul class="dropdown-menu dropdown-menu-end" role="menu">
                  <li role="menuitem">
                    <a ng-click="$ctrl.delete(null, ('SALAXY.NG1.MessageThreadComponent.deleteThreadAlert' | sxyTranslate ))" class="dropdown-item" sxy-text="SALAXY.NG1.MessageThreadComponent.deleteThread"></a>
                  </li>
                  <li role="separator" class="divider"></li>
                  <li role="menuitem">
                    <a ng-click="$ctrl.addExistingCalc('draft')" class="dropdown-item" sxy-text="SALAXY.NG1.MessageThreadComponent.addDraft"></a>
                  </li>
                  <li role="menuitem">
                    <a ng-click="$ctrl.addExistingCalc('paid')" class="dropdown-item" sxy-text="SALAXY.NG1.MessageThreadComponent.addPaid"></a>
                  </li>
                  <li role="separator" class="divider"  salaxy-if-role="test"></li>
                  <li role="menuitem" salaxy-if-role="test">
                    <a ng-click="$ctrl.addExistingPayroll('draft')" class="dropdown-item" sxy-text="Palkkalistaluonnos"></a>
                  </li>
                  <li role="menuitem"  salaxy-if-role="test">
                    <a ng-click="$ctrl.addExistingPayroll('paid')" class="dropdown-item" sxy-text="Maksettu palkkalista"></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div id="messageContainerBottom">&nbsp;</div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/communications/MessageThreadList.html",`<div class="salaxy-component salaxy-message-thread-list">
  <div class="btn-toolbar" role="toolbar">
    <div class="btn-group btn-group-sm">
      <button type="button" class="btn btn-default"
        ng-click="$ctrl.$odata.options.$filter = 'status eq \\'active\\' or ( status eq \\'draft\\' and data/otherPartyUnreadCount gt 0 )';$ctrl.$odata.searchChanged()"
        ng-class="{ active: $ctrl.$odata.options.$filter == 'status eq \\'active\\' or ( status eq \\'draft\\' and data/otherPartyUnreadCount gt 0 )' }">Aktiiviset</button>
      <button type="button" class="btn btn-default"
        ng-click="$ctrl.$odata.options.$filter = '(status eq \\'approved\\' or status eq \\'rejected\\' or status eq \\'active\\' or status eq \\'draft\\')';$ctrl.$odata.searchChanged()"
        ng-class="{ active: $ctrl.$odata.options.$filter == '(status eq \\'approved\\' or status eq \\'rejected\\' or status eq \\'active\\' or status eq \\'draft\\')' }">Kaikki</button>
    </div>
    <div class="btn-group btn-group-sm ms-1" ng-if="!$ctrl.readOnly" ng-controller="SessionController as $sessionCtrl">
        <salaxy-action-button button-class="btn-sm btn-primary" action="'newMessage'" label="SALAXY.NG1.ActionButtonComponent.startNewMessage" disabled="!$sessionCtrl.session.settings.partner.accountId">
        </salaxy-action-button>
    </div>
  </div>

  <salaxy-odata-table crud-controller="MessageThreadCrudController as $crud" ng-ref="$ctrl.$odata"
    options="{ $top: $ctrl.limitTo, $filter: 'status eq \\'active\\' or ( status eq \\'draft\\' and data/otherPartyUnreadCount gt 0 )' }" template-url="salaxy-components/odata/lists/MessageThreads.html">
  </salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/communications/VarmaBanner.html",`<div class="salaxy-component salaxy-varma-banner">
  <div ng-if="$ctrl.varmaPensionBanners.isReady" ng-init="$ctrl.showVarmaPopup()">


  </div>
</div>`);

 $templateCache.put("salaxy-components/communications/Welcome.html",`<div class="salaxy-component salaxy-welcome">
  <div ng-controller="SessionController as $sessionCtrl">
    <div ng-if="$ctrl.hasSystemAlert" class="salaxy-welcome-system-alert alert-has-system-alert" ng-bind-html="$ctrl.systemAlertHtml"></div>
    <salaxy-alert ng-if="$ctrl.tutorials.showAnon" type="danger" icon="bi-box-arrow-in-right" class="alert-anon">
      <main sxy-html="SALAXY.NG1.WelcomeComponent.showAnon.main.html"></main>
    </salaxy-alert>
    <salaxy-alert ng-if="$ctrl.tutorials.showInsurance || $ctrl.tutorials.showPension" type="warning" class="alert-insurance-and-pension">
      <main>
        <div class="row">
          <div class="col-sm-8 col-lg-9">
            <p class="lead lead-with-text" sxy-html="SALAXY.NG1.WelcomeComponent.showSettings.lead.html"></p>
            <p sxy-html="SALAXY.NG1.WelcomeComponent.showSettings.main"></p>
          </div>
          <div class="col-sm-4 col-lg-3">
            <a href="#/settings/insurances" class="btn btn-warning float-end-sm btn-block btn-edit-settings" style="margin-bottom:10px;" sxy-text="SALAXY.NG1.WelcomeComponent.showSettings.settings.cta"></a>
          </div>
        </div>
      </main>
    </salaxy-alert>
    <salaxy-alert ng-if="$ctrl.tutorials.showSign" class="alert-sign" type="warning">
      <main>
        <div class="row">
          <div class="col-sm-8 col-lg-9">
            <p class="lead lead-with-text" sxy-text="SALAXY.NG1.WelcomeComponent.showSign.lead"></p>
            <p sxy-html="SALAXY.NG1.WelcomeComponent.showSign.main.html"></p>
          </div>
          <div class="col-sm-4 col-lg-3">
            <button sxy-if-role="person" ng-controller="WorkerOnboardingController as wizard" class="btn btn-warning btn-add-signature float-end btn-block" ng-click="wizard.launch()" sxy-text="SALAXY.NG1.WelcomeComponent.showSign.main.cta"></button>
            <button sxy-if-role="company" ng-controller="CompanyOnboardingController as wizard" class="btn btn-warning btn-add-signature float-end btn-block" ng-click="wizard.launch()" sxy-text="SALAXY.NG1.WelcomeComponent.showSign.main.cta"></button>
          </div>
        </div>
      </main>
    </salaxy-alert>
    <salaxy-invoice-alerts ng-if="'auth' | sxyIsInRole" payment-channels="['palkkausManual', 'holvi', 'talenomOnline']"></salaxy-invoice-alerts>    
    <salaxy-alert ng-if="$ctrl.tutorials.showTryPayroll" type="primary" class="alert-try-payroll">
      <main>
        <div class="row">
          <div class="col-sm-8 col-lg-9">
            <p class="lead" sxy-text="SALAXY.NG1.WelcomeComponent.showTryPayroll.main"></p>
          </div>
          <div class="col-sm-4 col-lg-3">
            <a class="btn btn-info btn-block" href="#/payroll" sxy-text="SALAXY.NG1.WelcomeComponent.showTryPayroll.cta"></a>
          </div>
        </div>
      </main>
    </salaxy-alert>
    <salaxy-alert ng-if="$ctrl.showAutoTaxcardInfobox()" type="warning" class="taxcard-info">
      <main>
        <div class="row">
          <div class="col-sm-8 col-lg-9">
            <p class="lead" sxy-html="SALAXY.NG1.WelcomeComponent.autoTaxcard.lead.html"></p>
          </div>
          <div class="col-sm-4 col-lg-3">
            <a ng-href="#/workers" class="btn btn-warning btn-add btn-add-taxcard btn-block" title="{{'SALAXY.NG1.WorkerListComponent.activeAutoTaxcard' | sxyTranslate}}" sxy-text="SALAXY.NG1.WorkerListComponent.autoTaxcard"></a>
          </div>
        </div>
      </main>
    </salaxy-alert>
    <salaxy-alert ng-if="$ctrl.tutorials.showAddCalculation" type="primary" class="alert-add-calculation">
      <main>
        <div class="row">
          <div class="col-sm-8 col-lg-9">
            <p class="lead" sxy-html="SALAXY.NG1.WelcomeComponent.showAddCalculation.main.html"></p>
            <salaxy-input-typeahead
              label-type="no-label"
              ng-model="$ctrl.employmentId"
              name="options_type"
              disable-cache="true"
              placeholder="{{'SALAXY.NG1.WelcomeComponent.showAddCalculation.selectWorkerPlaceholder' | sxyTranslate}}"
              get-options="$ctrl.filterWorkers"
              on-select-function="$ctrl.createNewCalculationFor"
              input-formatter="$ctrl.getWorkerName">
            </salaxy-input-typeahead>
          </div>
          <div class="col-sm-4 col-lg-3">
            <button class="btn btn-info btn-add btn-add-worker btn-block mb-2" ng-click="$ctrl.launchEmploymentWizard()" sxy-text="SALAXY.NG1.WelcomeComponent.showAddWorker.main.cta"></button>
            <a class="btn btn-default btn-block btn-try-payroll" href="#/payroll" sxy-text="SALAXY.NG1.WelcomeComponent.showAddWorker.tryPayroll.cta"></a>
          </div>
        </div>
      </main>
    </salaxy-alert>
  </div>
</div>`);

 $templateCache.put("salaxy-components/form-controls/Datepicker.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.datepickerValue }} </div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" class="salaxy-component salaxy-datepicker" ng-if="!$ctrl.getReadOnly()">
  <salaxy-form-group name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control datepicker-input" ng-model="$ctrl.datepickerValue" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-change="$ctrl.onChange()" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()"></div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError }}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
</ng-form>
<salaxy-form-group ng-if="$ctrl.isMultiple" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{ $ctrl.labelDaysCount || 'SALAXY.NG1.DateRange.labelDaysCount' }}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.datepickerValue.daysCount }}</div>
</salaxy-form-group>`);

 $templateCache.put("salaxy-components/form-controls/DatepickerPopup.html",`<style>
  input.datepicker-popup,
  input.datepicker-input {
    background-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" fill-opacity="0.54" viewBox="0 0 16 16"%3E%3Cpath d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z"/%3E%3Cpath d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/%3E%3C/svg%3E');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 16px;
    width: 3.5em !important;
    cursor: pointer;
    caret-color: transparent;
    color: transparent !important;
    user-select: none !important;
  }

  input.datepicker-input::selection {
    background: transparent;
    color: transparent;
  }
  .datepicker-text-input.validation-error {
    border-color: rgba(255, 0, 0, 0.25) !important;
    z-index: 1;
  }

  .datepicker-text-input.validation-error:active,
  .datepicker-text-input.validation-error:focus {
    box-shadow: 0 0 0 0.25rem rgba(255, 0, 0, 0.25) !important;
    z-index: 1;
  }
</style>
<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.datepickerValue }} </div>
</salaxy-form-group>
<ng-form ng-show="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-datepicker-popup">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' && !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">{{ $ctrl.datepickerValue }}
      <span class="float-end btn-padding-right">
        <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-show="!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen)" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="input-group">
      <input ng-focus="$ctrl.initDatepicker(true)" class="form-control datepicker-text-input" ng-class="$ctrl.validationError ? 'validation-error' : ''" type="text" autocomplete="off" ng-model-options="{ debounce: 1000 }" name="datepicker-popup-text-input" placeholder="{{ $ctrl.placeholder ? ($ctrl.placeholder | sxyTranslate) : ('SALAXY.NG1.DatepickerPopupComponent.placeholder' | sxyTranslate) }}" ng-model="$ctrl.datepickerValue" ng-change="$ctrl.changeManualDate()" ng-required="$ctrl.require"
        ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.disabled" salaxy-datepicker-input-validation>
      <input ng-focus="$ctrl.initDatepicker()" class="form-control datepicker-popup datepicker-input p-0 flex-grow-0" type="text" autocomplete="off" name="datepicker-popup" ng-model="$ctrl.datepickerValue" ng-required="$ctrl.require"
        ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.disabled" salaxy-datepicker-input-validation>
      <span class="input-group-btn">
        <button ng-if="$ctrl.getToolTipHtml()" type="button" class="btn btn-default" data-bs-toggle="popover" data-bs-container="body" aria-label="Info" data-bs-html="true" data-bs-title="'Info'" data-bs-content="$ctrl.getToolTipHtml()" data-bs-placement="'{{$ctrl.tooltipPlacement}}'" sxy-bs5-popover>
          <span class="bi bi-question-circle-fill"></span>
        </button>
        <button ng-if="$ctrl.inputMode == 'openClose'" class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </span>
    </div>
    <div ng-if="$ctrl.validationError" class="input-errors">
      <span class="salaxy-validation-error text-danger small" sxy-text="{{ $ctrl.validationError }}"></span>
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/DateRange.html",`<style>
  .datepicker-text-input.validation-error {
    border-color: rgba(255, 0, 0, 0.25) !important;
    z-index: 1;
  }

  .datepicker-text-input.validation-error:active,
  .datepicker-text-input.validation-error:focus {
    box-shadow: 0 0 0 0.25rem rgba(255, 0, 0, 0.25) !important;
    z-index: 1;
  }
</style>
<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.dateRangeValues.formattedRange || "-" }}</div>
</salaxy-form-group>
<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-date-range mode-{{ $ctrl.mode || 'range' }}">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' && !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">{{ $ctrl.dateRangeValues.formattedRange || "-" }}
      <span class="float-end btn-padding-right">
        <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>
  <div ng-show="!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen)">
    <salaxy-input-enum ng-if="$ctrl.mode == 'calc' && !$ctrl.periodShortcut" ng-model="$ctrl.periodShortcut" name="periodShortcut" label="SALAXY.NG1.DateRange.salaryPeriod" label-cols="{{$ctrl.labelCols}}" type="radio" options="$ctrl.periodShortcuts"></salaxy-input-enum>
    <salaxy-input-enum ng-if="$ctrl.mode == 'calc' && $ctrl.periodShortcut" ng-model="$ctrl.periodShortcut" name="periodShortcut" label="SALAXY.NG1.DateRange.salaryPeriod" label-cols="{{$ctrl.labelCols}}" type="select" options="$ctrl.periodShortcuts"></salaxy-input-enum>
    <salaxy-form-group ng-show="$ctrl.mode != 'calc' || $ctrl.periodShortcut == 'other'" ng-init="$ctrl.selectedDates = []" name="{{ $ctrl.name + '_datepicker' }}" label="{{$ctrl.label}}" require="$ctrl.require" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
      <div class="salaxy-read-only">
        <div class="form-control-plaintext">
          {{ $ctrl.dateRangeValues.formattedRange || "-" }}
          <span class="float-end btn-padding-right" ng-if="$ctrl.inputMode == 'openClose'">
            <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
          </span>
        </div>
      </div>
      <div class="d-flex gap-2 align-items-center">
        <label>
          {{ 'SALAXY.MODEL.DateRange.start.title' | sxyTranslate }}
          <input type="text" class="form-control datepicker-text-input" ng-model="$ctrl.datepickerValueStart" ng-model-options="{ debounce: 1000 }" ng-change="$ctrl.changeManualDate()" ng-class="$ctrl.validationError ? 'validation-error' : ''">
        </label>
        <span class="mt-4">-</span>
        <label>
          {{ 'SALAXY.MODEL.DateRange.end.title' | sxyTranslate }}
          <input type="text" class="form-control datepicker-text-input" ng-model="$ctrl.datepickerValueEnd" ng-model-options="{ debounce: 1000 }" ng-change="$ctrl.changeManualDate()" ng-class="$ctrl.validationError ? 'validation-error' : ''">
        </label>
      </div>
      <div ng-if="$ctrl.validationError" class="input-errors">
        <span class="salaxy-validation-error text-danger small" sxy-text="{{ $ctrl.validationError }}"></span>
      </div>
      <div class="form-control input-daterange" ng-model="$ctrl.dateRangeValues" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" on-change="$ctrl.dateRangeChange()" ng-disabled="$ctrl.getDisabled()"></div>
    </salaxy-form-group>
    <div ng-if="$ctrl.mode == 'calc' && $ctrl.periodShortcut && $ctrl.periodShortcut != 'other'">
      <salaxy-form-group name="{{$ctrl.name}}_periodStartDate" label="SALAXY.NG1.DateRange.startDate" label-cols="{{$ctrl.labelCols}}">
        <input type="text" class="form-control" autocomplete="off" id="{{$ctrl.name}}_periodStartDate" name="{{$ctrl.name}}_periodStartDate" placeholder="{{'SALAXY.UI_Terms.dateFormats.dm' | sxyTranslate}}" ng-model="$ctrl.periodStartDate" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }"
        />
        <div ng-if="$ctrl.periodStartDateError" class="form-control-plaintext text-danger">{{ $ctrl.periodStartDateError | sxyTranslate }}</div>
      </salaxy-form-group>
      <salaxy-form-group name="formattedRange" label="SALAXY.NG1.DateRange.labelStartAndEndDate" label-cols="{{$ctrl.labelCols}}" class="salaxy-read-only">
        <div class="form-control-plaintext">{{ $ctrl.dateRangeValues.formattedRange }}</div>
      </salaxy-form-group>
    </div>
  </div>
  <div>
    <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' && !$ctrl.isOpen" name="{{$ctrl.name}}" label="{{ $ctrl.labelDaysCount || 'SALAXY.NG1.DateRange.labelDaysCount' }}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" class="salaxy-read-only">
      <div class="form-control-plaintext">{{ $ctrl.dateRangeValues.daysCount }}
        <span class="float-end btn-padding-right">
          <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
        </span>
      </div>
    </salaxy-form-group>
    <salaxy-form-group ng-if="!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen)" name="{{$ctrl.name}}" require="$ctrl.require" label="{{ $ctrl.labelDaysCount || 'SALAXY.NG1.DateRange.labelDaysCount' }}" label-type="{{$ctrl.labelType}}"
      label-cols="{{$ctrl.labelCols}}">
      <div ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">
        <input type="text" class="form-control" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate}}" ng-model="$ctrl.dateRangeValues.daysCount" ng-model-options="{allowInvalid: true, debounce: 250}" ng-change="$ctrl.onDaysCountChange()"
          ng-pattern="$ctrl.pattern" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" ng-minlength="$ctrl.minlength" ng-maxlength="$ctrl.maxlength" maxlength="{{$ctrl.maxlength}}" />
        <div class="input-group-btn" ng-if="$ctrl.inputMode == 'openClose'">
          <button class="btn btn-transparent float-end" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
            <i class="bi bi-pencil-fill"></i>
          </button>
        </div>
      </div>
    </salaxy-form-group>
  </div>
</ng-form>
<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{ $ctrl.labelDaysCount || 'SALAXY.NG1.DateRange.labelDaysCount' }}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.dateRangeValues.daysCount }}</div>
</salaxy-form-group>`);

 $templateCache.put("salaxy-components/form-controls/FormGroup.html",`<div ng-if="$ctrl.getLabelType() == 'basic'" class="row">
  <label for="{{$ctrl.name}}" class="col-12 col-form-label"><span class="label-text">{{$ctrl.label | sxyTranslate}}</span><span class="salaxy-form-group-required-indicator"
    ng-show="!!$ctrl.require">*</span>
  </label>
  <div class="col-12">
    <ng-transclude></ng-transclude>
  </div>
</div>
<div ng-if="$ctrl.getLabelType() == 'empty-label'" class="row">
  <div class="{{ $ctrl.getLabelCols('label') }} col-form-label"></div>
  <div class="{{ $ctrl.getLabelCols('value') }}">
    <ng-transclude></ng-transclude>
  </div>
</div>
<div ng-if="$ctrl.getLabelType() == 'no-label'">
  <div class="{{ $ctrl.getLabelCols('no-label') }}">
    <ng-transclude></ng-transclude>
  </div>
</div>
<span ng-if="$ctrl.getLabelType() == 'plain'" class="salaxy-form-group-plain">
  <ng-transclude></ng-transclude>
</span>
<div ng-if="$ctrl.getLabelType() == 'horizontal'" class="row mb-1">
  <label for="{{$ctrl.name}}" class="{{ $ctrl.getLabelCols('label') }} col-form-label">
    <span class="label-text">{{$ctrl.label | sxyTranslate}}</span><span class="salaxy-form-group-required-indicator"
      ng-show="!!$ctrl.require">*</span>
  </label>
  <div class="{{ $ctrl.getLabelCols('value') }}">
    <ng-transclude class="w-100"></ng-transclude>
  </div>
</div>
<div ng-if="$ctrl.getLabelType() == 'inline'" class="row mb-1">
  <label for="{{$ctrl.name}}" class="{{ $ctrl.getLabelCols('label') }} col-form-label">
    <span class="label-text">{{$ctrl.label | sxyTranslate}}</span>
    <span class="salaxy-form-group-required-indicator" ng-show="!!$ctrl.require">*</span>
  </label>
  <ng-transclude class="inline-salaxy-input {{ $ctrl.getLabelCols('value') }}"></ng-transclude>
</div>`);

 $templateCache.put("salaxy-components/form-controls/Input.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.value }}

  </div>

</salaxy-form-group>

<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' &&  !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">{{ $ctrl.value || "\\u00A0" }}
      <span class="float-end btn-padding-right">
          <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>

  <salaxy-form-group ng-if="!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen)" name="{{$ctrl.name}}" label="{{$ctrl.label}}" require="$ctrl.require" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div ng-if="$ctrl.getToolTipHtml()" class="input-group">
      <input type="{{$ctrl.type || 'text'}}" class="form-control" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}" ng-model="$ctrl.value" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }"
        ng-change="$ctrl.onChange()" ng-pattern="$ctrl.pattern" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" ng-minlength="$ctrl.minlength" ng-maxlength="$ctrl.maxlength" maxlength="{{$ctrl.maxlength}}" />
      <div class="input-group-btn">
        <button type="button" class="btn btn-default" data-bs-container="body" aria-label="Info" data-bs-toggle="popover" data-bs-html="true" data-bs-title="'Info'" data-bs-content="$ctrl.getToolTipHtml()" data-bs-placement="'{{$ctrl.tooltipPlacement}}'" sxy-bs5-popover>
          <span class="bi bi-question-circle-fill"></span>
        </button>
        <button ng-if="$ctrl.inputMode == 'openClose'" class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
    <div ng-if="!$ctrl.getToolTipHtml()" ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">
      <input type="{{$ctrl.type || 'text'}}" class="form-control" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}" ng-model="$ctrl.value" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }"
        ng-change="$ctrl.onChange()" ng-pattern="$ctrl.pattern" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" ng-minlength="$ctrl.minlength" ng-maxlength="$ctrl.maxlength" maxlength="{{$ctrl.maxlength}}" />
      <div class="input-group-btn" ng-if="$ctrl.inputMode == 'openClose'">
        <button class="btn btn-transparent float-end" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>

    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>

</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputAccountingTarget.html",`<ng-form name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input-accounting-target">
  <salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">{{ $ctrl.value }}</div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" ng-init="refresher = [0]">
    <div ng-repeat="item in refresher">
      <salaxy-input-typeahead
        label-type="no-label"
        ng-model="$ctrl.value"
        name="{{ $ctrl.name }}"
        disable-cache="true"
        placeholder="{{ $ctrl.placeholder }}"
        get-options="$ctrl.queryAccountingTargets($viewValue)"
        input-formatter="$ctrl.queryAccountingTargetDisplayName($model, refresher)">
      </salaxy-input-typeahead>
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputBoolean.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">
    <span ng-if="$ctrl.value==true">{{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}} </span>
    <span ng-if="$ctrl.value==false && $ctrl.labelType != 'no-label'">{{$ctrl.labelFalse || 'SALAXY.UI_Terms.no' | sxyTranslate}} </span>
  </div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" ng-if="!$ctrl.getReadOnly()">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' &&  !$ctrl.isOpen && $ctrl.type != 'switch'" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">
      <span ng-if="$ctrl.value==true">{{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}} </span>
      <span ng-if="$ctrl.value==false">{{$ctrl.labelFalse || 'SALAXY.UI_Terms.no' | sxyTranslate}} </span>
      <span class="float-end btn-padding-right">
          <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="($ctrl.type == 'radio' || !$ctrl.type) && (!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen))" name="{{$ctrl.name}}" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" require="$ctrl.require" class="salaxy-component salaxy-input-boolean boolean-radio">
    <div ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">
      <div class="radio form-check d-flex" ng-class="$ctrl.horizontal ? 'form-check-inline' : null">
        <input class="form-check-input me-2 mt-0.5" type="radio" ng-disabled="$ctrl.getDisabled()" name="{{$ctrl.name}}Radio" id="{{$ctrl.name}}True" ng-change="$ctrl.onChange()" ng-model="$ctrl.value" value="true" sxy-enum-as-boolean>
        <label class="form-check-label" for="{{$ctrl.name}}True">{{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}}</label>
      </div>
      <div class="radio form-check d-flex" ng-class="$ctrl.horizontal ? 'form-check-inline' : null">
        <input class="form-check-input me-2 mt-0.5" type="radio" ng-disabled="$ctrl.getDisabled()" name="{{$ctrl.name}}Radio" id="{{$ctrl.name}}False" ng-change="$ctrl.onChange()" ng-model="$ctrl.value" value="false" sxy-enum-as-boolean>
        <label class="form-check-label" for="{{$ctrl.name}}False">{{$ctrl.labelFalse || 'SALAXY.UI_Terms.no' | sxyTranslate}}</label>
      </div>
      <div class="input-group-btn ms-auto" ng-if="$ctrl.inputMode == 'openClose'">
        <button class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br />
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type == 'checkbox' && (!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen))" name="{{$ctrl.name}}" label="{{$ctrl.label}}" require="$ctrl.require" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" class="salaxy-component salaxy-input-boolean boolean-checkbox">
    <div ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">
      <div class="checkbox">
        <div class="{{$ctrl.offsetCols}} form-check d-flex align-items-start" ng-class="{'col-woffset' : $ctrl.offsetCols}">
          <label class="form-check-label" ng-class="{ 'disabled': $ctrl.getDisabled() }">
            <input class="form-check-input me-2 mt-0.5" type="checkbox" ng-disabled="$ctrl.getDisabled()" ng-required="$ctrl.require" ng-model="$ctrl.value" ng-change="$ctrl.onChange()" name="{{$ctrl.name}}" id="{{$ctrl.name}}" title="true">
            {{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}}
          </label>
        </div>
      </div>
      <div class="input-group-btn ms-auto" ng-if="$ctrl.inputMode == 'openClose'">
        <button class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br />
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type == 'switch'" name="{{$ctrl.name}}" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" require="$ctrl.require" class="salaxy-component salaxy-input-boolean boolean-switch">
    <div class="form-check form-switch d-flex align-items-center" ng-class="{ 'disabled': $ctrl.getDisabled() }">
      <input class="form-check-input ms-1 me-2" type="checkbox" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-model="$ctrl.value" ng-change="$ctrl.onChange()" />
      <label class="form-check-label" for="{{$ctrl.name}}" ng-if="$ctrl.value">{{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}}</label>
      <label class="form-check-label" for="{{$ctrl.name}}" ng-if="!$ctrl.value || $ctrl.value == false">{{$ctrl.labelFalse || 'SALAXY.UI_Terms.no' | sxyTranslate}}</label>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br />
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type == 'switch-xl'" name="{{$ctrl.name}}" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" require="$ctrl.require" class="salaxy-component salaxy-input-boolean boolean-switch">
    <div class="form-check form-switch fs-3">
      <input class="form-check-input" type="checkbox" id="{{$ctrl.id}}" name="{{$ctrl.name}}" ng-model="$ctrl.value" ng-disabled="$ctrl.getDisabled()" ng-change="$ctrl.onChange()">
    </div>
    <span class="switch-text"></span>
      <span class="on" ng-if="$ctrl.labelTrue"> {{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}}</span>
      <span class="off" ng-if="$ctrl.labelFalse"> {{$ctrl.labelFalse || 'SALAXY.UI_Terms.no' | sxyTranslate}}</span>
    </span>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br />
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type=='select'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" class="salaxy-component salaxy-input-boolean boolean-select">
    <select ng-disabled="$ctrl.getDisabled()" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-change="$ctrl.onChange()" ng-model="$ctrl.value" class="form-select" sxy-enum-as-boolean>
      <option ng-if="$ctrl.value == null" value="{{$ctrl.value}}" selected disabled>{{ $ctrl.placeholder || 'SALAXY.UI_Terms.select' | sxyTranslate }}</option>
      <option value="true" title="{{$ctrl.labelTrue}}">{{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}}</option>
      <option value="false" title="{{$ctrl.labelFalse}}">{{$ctrl.labelFalse || 'SALAXY.UI_Terms.no' | sxyTranslate}}</option>
    </select>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br />
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputCollectiveBargainAgreement.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.getCbaLabel($ctrl.value) }}</div>
</salaxy-form-group>
<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input-collective-bargain-agreement">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' &&  !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">{{ $ctrl.getCbaLabel($ctrl.value) }}
      <span class="pull-right btn-padding-right">
          <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>
  <salaxy-form-group name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <salaxy-input-typeahead
      label-type="no-label"
      ng-model="$ctrl.value"
      ng-change="$ctrl.onChange()"
      name="{{ $ctrl.name }}"
      disable-cache="true"
      placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}"
      get-options="$ctrl.getCbaCodes"
      input-formatter="$ctrl.getCbaLabel"
      tooltip-html="{{$ctrl.getToolTipHtml()}}">
    </salaxy-input-typeahead>
    <div ng-show="{{$ctrl.name}}Form.{{$ctrl.name}}.$invalid && $ctrl.validationError && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted)">
      {{$ctrl.validationError | sxyTranslate}}
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputDuration.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.value | sxyDuration }} </div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input-duration" ng-if="!$ctrl.getReadOnly()">
  <salaxy-form-group ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <salaxy-input-number name="{{$ctrl.name}}Days" ng-model="$ctrl.innerValue.days" ng-change="$ctrl.onChange()" label-type="plain" unit="days"></salaxy-input-number>
    <salaxy-input-boolean type="select" name="{{$ctrl.name}}Negative" ng-model="$ctrl.innerValue.isNegative" ng-change="$ctrl.onChange()" label-true="SALAXY.NG1.InputDurationComponent.labelTrue" label-false="SALAXY.NG1.InputDurationComponent.labelFalse" label-type="plain"></salaxy-input-boolean>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputEnum.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly() && $ctrl.type != 'multi-select'" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.getEnumerationLabel($ctrl.value) }}</div>
</salaxy-form-group>
<salaxy-form-group ng-if="$ctrl.getReadOnly() && $ctrl.type == 'multi-select'" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div ng-repeat="x in $ctrl.value" class="form-control-plaintext">{{ $ctrl.getEnumerationLabel(x)}}</div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" ng-if="!$ctrl.getReadOnly()" class="salaxy-input-enum">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' && !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">
      <span ng-if="$ctrl.type != 'multi-select'">
        {{ $ctrl.getEnumerationLabel($ctrl.value) }}
      </span>
      <span ng-if="$ctrl.type == 'multi-select'" ng-repeat="option in $ctrl.value track by $index">
        {{ $ctrl.getEnumerationLabel(option) }}<span ng-if="!$last">, </span>
      </span>
      <span class="float-end btn-padding-right">
        <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="($ctrl.type || 'select')=='select' && (!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen))" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">
      <select ng-disabled="$ctrl.getDisabled()" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-change="$ctrl.setStoredValue($ctrl.name, $ctrl.value);$ctrl.onChange()" ng-model="$ctrl.value" class="form-select" ng-required="$ctrl.require" sxy-exclude-unknowns="$ctrl.require ? $ctrl.invalidEnums : ''">
        <option ng-if="$ctrl.showPlaceholder" value="{{$ctrl.value}}" disabled selected>{{ $ctrl.placeholder || 'SALAXY.UI_Terms.select' | sxyTranslate }}</option>
        <option ng-repeat="x in $ctrl.getEnumerations()" value="{{x.value}}" title="{{x.title}}">{{$ctrl.formatLabel(x)}}</option>
      </select>
      <div class="input-group-btn ms-auto" ng-if="$ctrl.inputMode == 'openClose'">
        <button class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type=='radio'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" class="enum-radio">
    <div class="radio form-check d-flex" ng-repeat="x in $ctrl.getEnumerations()">
      <input class="form-check-input me-2 mt-0.5" ng-disabled="$ctrl.getDisabled()" ng-required="$ctrl.require" type="radio" ng-model="$ctrl.value" ng-change="$ctrl.onChange()" name="{{$ctrl.label}}" id="{{x.value}}" value="{{x.value}}" title="{{x.title}}">
      <label class="form-check-label radio-label" for="{{x.value}}">{{$ctrl.formatLabel(x)}}</label>
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type == 'multi-select' && (!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen))" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <select ng-disabled="$ctrl.getDisabled()" id="{{$ctrl.name}}" name="{{$ctrl.name}}" multiple ng-change="$ctrl.onChange()" ng-model="$ctrl.value" class="form-select">
      <option ng-repeat="x in $ctrl.getEnumerations()" value="{{x.value}}" title="{{x.title}}">{{$ctrl.formatLabel(x)}}</option>
    </select>
    <div class="input-group-btn ms-auto" ng-if="$ctrl.inputMode == 'openClose'">
      <button class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
        <i class="bi bi-pencil-fill"></i>
      </button>
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type=='dropdown'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="dropdown" role="group">
      <button id="{{$ctrl.name}}" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ng-disabled="$ctrl.getDisabled()">
        {{ $ctrl.getEnumerationLabel($ctrl.value) || $ctrl.placeholder || 'SALAXY.UI_Terms.select' | sxyTranslate }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="{{$ctrl.name}}">
        <li><a href="" ng-click="$ctrl.value=x.value;$ctrl.setStoredValue($ctrl.name, $ctrl.value);$ctrl.onChange()" ng-repeat="x in $ctrl.getEnumerations()" class="dropdown-item">{{$ctrl.formatLabel(x)}}</a></li>
      </ul>
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputEnumTypeaheadMatch.html",`<a ng-if="match.model.ui.avatar" class="clickable salaxy-component salaxy-worker-item" style="padding: 10px 10px 5px 10px;">
  <salaxy-avatar style="font-size: 30px; vertical-align: middle; margin-right: 10px;" avatar="match.model.ui.avatar"></salaxy-avatar>
  <b class="salaxy-highlight" ng-bind-html="match.label | uibTypeaheadHighlight:query"></b><br />
</a>
<a ng-if="!match.model.ui.avatar" href
   tabindex="-1"
   ng-bind-html="match.label | uibTypeaheadHighlight:query"
   ng-attr-title="{{match.model.title}}">
</a>`);

 $templateCache.put("salaxy-components/form-controls/InputHolidayMultipliers.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="salaxy-read-only-value">
    <table ng-if="$ctrl.value" class="table table-condensed table-striped">
      <thead>
        <tr>
          <th class="right" sxy-terms="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.days"></th>
          <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.multiplier"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="(key, value) in $ctrl.value track by $index">
          <td class="right">{{key}}</td>
          <td class="right">{{value}}</td>
        </tr>
    </table>
  </div>
</salaxy-form-group>

<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input form-condensed">
  <salaxy-form-group name="{{$ctrl.name}}" label="{{$ctrl.label}}" require="$ctrl.require" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div>
      <table class="table table-condensed table-striped">
        <thead>
          <tr>
            <th class="right" sxy-terms="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.days"></th>
            <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.multiplier"></th>
            <th class="text-right">
              <button type="button" class="btn btn-primary btn-xs"  ng-click="$ctrl.createNew({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="(key, value) in $ctrl.value">
            <td ng-init="editableKey=key" class="right"><salaxy-input-number name="Key{{key}}" label-type="no-label" ng-model="editableKey" ng-change="$ctrl.onKeyChanged(key, editableKey)" sxy-integer></salaxy-input-number></td>
            <td class="right"><salaxy-input-number name="Value{{key}}" label-type="no-label" ng-model="$ctrl.value[key]" ng-change="$ctrl.onChange()"></salaxy-input-number></td>
            <td class="text-right">
              <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.delete(key)">
                <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputIncomeType.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.getRowLabel($ctrl.value) }}</div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" ng-if="!$ctrl.getReadOnly()">
  <salaxy-form-group name="{{$ctrl.name}}" ng-if="!$ctrl.type || $ctrl.type == 'typehead'" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <salaxy-input-typeahead
      ng-model="$ctrl.value"
      label-type="no-label"
      name="{{ $ctrl.name }}"
      get-options="$ctrl.getIncomeTypes"
      ng-change="$ctrl.onChange()"
      disable-cache="true"
      placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}"
      ng-disabled="$ctrl.getDisabled()"
      input-formatter="$ctrl.getRowLabel">
    </salaxy-input-typeahead>
    <div ng-show="{{$ctrl.name}}Form.{{$ctrl.name}}.$invalid && $ctrl.validationError && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted)">
      {{$ctrl.validationError | sxyTranslate}}
    </div>
  </salaxy-form-group>
  <salaxy-form-group name="{{$ctrl.name}}" ng-if="$ctrl.type == 'list'" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <input type="hidden" ng-model="$ctrl.value" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-required="$ctrl.require">
    <div class="list-group">
      <a ng-repeat="type in $ctrl.getIncomeTypes()" ng-click="$ctrl.selectionClicked(type.code)" class="list-group-item clickable" ng-class="{ 'active': $ctrl.value == type.code, 'clickable': !$ctrl.readonly && !$ctrl.disabled }">
        <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: type.code, entityType: 'company' }"></salaxy-avatar>
        <b class="salaxy-highlight" ng-bind-html="$ctrl.getRowLabel(type.code) | uibTypeaheadHighlight:$ctrl.searchText"></b><br />
        <small class="salaxy-highlight">
          <div ng-bind-html="type.description | uibTypeaheadHighlight:$ctrl.searchText" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></div>
        </small>
      </a>
    </div>
    <div ng-show="{{$ctrl.name}}Form.{{$ctrl.name}}.$invalid && $ctrl.validationError && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted)">
      {{$ctrl.validationError | sxyTranslate}}
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputIncomeTypeItem.html",`<a class="clickable">
    <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" 
    avatar="{ color: '#2b507c', initials: match.model.code, entityType: 'company' }"></salaxy-avatar>
    
    <b class="salaxy-highlight" ng-bind-html="(match.label + ' (' + match.model.code + ')') | uibTypeaheadHighlight:query"></b><br />
    <small class="salaxy-highlight"><div ng-bind-html="match.model.description | uibTypeaheadHighlight:query"></div></small>
</a>`);

 $templateCache.put("salaxy-components/form-controls/InputMarkdown.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-input-markdown salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <salaxy-markdown-viewer name="{{ $ctrl.name }}" ng-model="$ctrl.value"></salaxy-markdown-viewer>
</salaxy-form-group>
<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input-markdown">
  <salaxy-form-group name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <salaxy-markdown-editor
      ng-model="$ctrl.value"
      ng-change="$ctrl.onChange()"
      name="{{ $ctrl.name }}">
    </salaxy-markdown-editor>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputNumber.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext ">{{ $ctrl.viewValue + ($ctrl.getUnitIndicator() ? " " + $ctrl.getUnitIndicator() : "") }}</div>
</salaxy-form-group>
<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-read-only salaxy-input-number salaxy-input">
  <salaxy-form-group ng-if="(!$ctrl.type || $ctrl.type == 'default') && $ctrl.inputMode == 'openClose' &&  !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">{{ $ctrl.value }}
      <span class="float-end btn-padding-right">
          <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>

  <salaxy-form-group ng-if="(!$ctrl.type || $ctrl.type == 'default') && !$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen)" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div ng-if="$ctrl.getUnitIndicator()" class="input-group">
      <div ng-if="!$ctrl.units" class="input-group-text">{{ $ctrl.getUnitIndicator() }}</div>
      <div ng-if="$ctrl.units" class="input-group-btn dropdown">
        <button id="units" type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown">
          {{ $ctrl.getUnitIndicator() }}
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="units">
          <li ng-repeat="unit in $ctrl.units" role="menuitem">
            <a href="" ng-click="$ctrl.changeUnit(unit)" class="dropdown-item">{{$ctrl.getUnitIndicator(unit)}}</a>
          </li>
        </ul>
      </div>
      <input type="text" class="form-control text-end" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate}}" ng-model="$ctrl.viewValue" ng-model-options="{allowInvalid: true, updateOn: 'blur' }"
        ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" sxy-min="$ctrl.minimum" sxy-max="$ctrl.maximum" />
      <div ng-if="$ctrl.getToolTipHtml() || $ctrl.inputMode == 'openClose'" class="input-group-btn">
        <a ng-if="$ctrl.getToolTipHtml()" tabindex="0" type="button" class="btn btn-default" data-bs-toggle="popover" data-bs-container="body" aria-label="Info" data-bs-html="true" data-bs-title="'Info'" data-bs-content="$ctrl.getToolTipHtml()" data-bs-placement="'{{$ctrl.tooltipPlacement}}'" sxy-bs5-popover>
          <span class="bi bi-question-circle-fill"></span>
        </a>
        <button ng-if="$ctrl.inputMode == 'openClose'" class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
        
      </div>
    </div>
    <div ng-if="!$ctrl.getUnitIndicator() && !$ctrl.getToolTipHtml()" ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">

      <input type="text" class="form-control text-end" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate}}" ng-model="$ctrl.viewValue" ng-model-options="{allowInvalid: true, updateOn: 'blur'}"
        ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" sxy-min="$ctrl.minimum" sxy-max="$ctrl.maximum" />
      <div class="input-group-btn" ng-if="$ctrl.inputMode == 'openClose'">

        <button class="btn btn-transparent float-end" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
    <div ng-if="!$ctrl.getUnitIndicator() && $ctrl.getToolTipHtml()" class="input-group">

      <input type="text" class="form-control text-end" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate}}" ng-model="$ctrl.viewValue" ng-model-options="{allowInvalid: true, updateOn: 'blur'}"
        ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" sxy-min="$ctrl.minimum" sxy-max="$ctrl.maximum" sxy-multiple-of="$ctrl.multipleOf" />

      <div class="input-group-btn">
        <button type="button" class="btn btn-default" data-bs-container="body" aria-label="Info" data-bs-toggle="popover" data-bs-html="true" data-bs-title="'Info'" data-bs-content="$ctrl.getToolTipHtml()" data-bs-placement="'{{$ctrl.tooltipPlacement}}'" sxy-bs5-popover>
          <span class="bi bi-question-circle-fill"></span>
        </button>
        <button ng-if="$ctrl.inputMode == 'openClose'" class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i> 
        </button>
      </div>
    </div>
    <div ng-show="$ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted)" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type == 'slider'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
     <input type="range" class="form-control text-end" id="{{$ctrl.name}}" name="{{$ctrl.name}}" min="{{$ctrl.minimum}}" max="{{$ctrl.maximum}}" step="{{$ctrl.sliderStep}}" ng-model="$ctrl.value" ng-change="$ctrl.onChange()"/>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputOccupationType.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.getOccupationLabel($ctrl.value) }}</div>
</salaxy-form-group>
<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input-occupation-type">
  <salaxy-form-group name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <salaxy-input-typeahead
      label-type="no-label"
      ng-model="$ctrl.value"
      ng-change="$ctrl.onChange()"
      name="{{ $ctrl.name }}"
      disable-cache="true"
      placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}"
      get-options="$ctrl.getOccupations"
      input-formatter="$ctrl.getOccupationLabel">
    </salaxy-input-typeahead>
    <div ng-show="{{$ctrl.name}}Form.{{$ctrl.name}}.$invalid && $ctrl.validationError && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted)">
      {{$ctrl.validationError | sxyTranslate}}
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputPayStatsRowType.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="salaxy-read-only-value">
    <span class="badge bg-default" ng-if="!$ctrl.isExclusive">{{ $ctrl.text }}</span>
    <span class="badge bg-danger" ng-if="$ctrl.isExclusive"><s>{{ $ctrl.text }}</s></span>
  </div>
</salaxy-form-group>

<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input">
  <salaxy-form-group name="{{$ctrl.name}}" label="{{$ctrl.label}}" require="$ctrl.require" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="clickable" ng-click="$ctrl.edit()">
      <span class="badge bg-default" ng-if="!$ctrl.isExclusive">{{ $ctrl.text || ('SALAXY.UI_Terms.new' | sxyTranslate) }}</span> 
      <span class="badge bg-danger" ng-if="$ctrl.isExclusive"><s>{{ $ctrl.text || ('SALAXY.UI_Terms.new' | sxyTranslate)}}</s></span>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputProfileItem.html",`<a class="clickable salaxy-component salaxy-avatar-item">
  <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" 
  avatar="match.model"></salaxy-avatar>
  <b class="salaxy-highlight" ng-bind-html="match.label | uibTypeaheadHighlight:query"></b><br />
  <small class="salaxy-highlight"><div ng-bind-html="(match.model.description || '') | uibTypeaheadHighlight:query"></div></small>
</a>`);

 $templateCache.put("salaxy-components/form-controls/InputRrule.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.getRRuleText($ctrl.value) }} </div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input-duration" ng-if="!$ctrl.getReadOnly()">
  <salaxy-form-group ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" class="salaxy-read-only">
    <!-- TODO: Better UI -->
    <div class="form-control-plaintext">
      <a href="" ng-click="$ctrl.showRRule = !$ctrl.showRRule">{{ $ctrl.getRRuleText($ctrl.value) }}</a>
      <salaxy-input ng-if="$ctrl.showRRule" name="{{$ctrl.name}}Inner" ng-model="$ctrl.value" ng-change="$ctrl.onChange()" label-type="plain"></salaxy-input>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputTime.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.viewValue }}</div>
</salaxy-form-group>
<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input  salaxy-input-number salaxy-input-time">
  <salaxy-form-group ng-if="$ctrl.type == 'minutes'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <input type="time" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-model="$ctrl.viewValue" ng-model-options="{allowInvalid: true, debounce: 1000}" ng-required="$ctrl.require" class="form-control">
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type == 'time'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <input type="time" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-model="$ctrl.viewValue" ng-model-options="{allowInvalid: true, debounce: 1000}" ng-required="$ctrl.require" class="form-control">
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputTypeahead.html",`<style>
  .dropdown-menu > .input-typeahead-option.keyboard-selected {
    color: #fff;
    background-color: #009fd8;
  }
  .typeahead-result-list.no-results .dropdown-item:not(.search-item) {
    opacity: 0.6;
    pointer-events: none;
  }
  .typeahead-result-list .dropdown-item.search-item:active {
    background-color: #fff;
  }
  .form-control[readonly].input-select {
    background-color: #fff;
    cursor: pointer;
  }
  salaxy-input-typeahead.text-muted .form-control-plaintext {
    color: #55585c !important;
  }
</style>
<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{ $ctrl.name }}" class="salaxy-component salaxy-read-only" label="{{ $ctrl.label }}" label-type="{{ $ctrl.labelType }}" label-cols="{{ $ctrl.labelCols }}">
  <div class="form-control-plaintext">{{ $ctrl.getEnumerationLabel($ctrl.value) }}</div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" ng-if="!$ctrl.getReadOnly()" class="salaxy-input-typeahead">
  <salaxy-form-group name="{{ $ctrl.name }}" require="$ctrl.require" label="{{ $ctrl.label }}" label-type="{{ $ctrl.labelType }}" label-cols="{{ $ctrl.labelCols }}">
    <div class="typeahead-wrapper d-flex">
      <div class="position-relative w-100">
        <input
          type="text"
          readonly
          name="search_{{ $ctrl.name }}"
          class="form-control input-select"
          ng-model="$ctrl.displayText"
          ng-focus="$ctrl.openResultsList()"
          get-options="$ctrl.getOptions"
          ng-disabled="$ctrl.getDisabled()"
          ng-required="$ctrl.require"
          placeholder="{{ $ctrl.placeholder }}"
        >
        <ul class="typeahead-menu dropdown-menu typeahead-result-list d-none pt-1">
          <li class="dropdown-item p-2 search-item">
            <input
              type="text"
              class="form-control typeahead-input"
              ng-model="$ctrl.searchText"
              name="{{ $ctrl.name }}"
              placeholder="{{ $ctrl.placeholder }}"
              ng-change="$ctrl.onInputChange()"
              ng-model-options="{ allowInvalid: true, debounce: 250 }"
              autocomplete="off"
            />
          </li>
          <li ng-if="$ctrl.allowCustomValues && $ctrl.searchText" class="dropdown-item clickable px-2 input-typeahead-option d-flex align-items-center py-1" ng-click="$ctrl.selectItem({ value: $ctrl.searchText, text: $ctrl.searchText }, true)">
            <div class="typeahead-result">
              <div class="salaxy-highlight">{{ $ctrl.searchText }}</div>
            </div>
          </li>
          <li class="dropdown-item clickable px-2 input-typeahead-option d-flex align-items-center" ng-repeat="item in $ctrl.filteredItems" ng-click="$ctrl.selectItem(item)" ng-class="item.ui.isChild ? 'typeahead-child-result py-0' : 'py-1'">
            <salaxy-avatar ng-if="item.ui || item.ui.avatar" class="salaxy-calc-row-type-avatar" ng-class="item.ui.isChild ? 'invisible' : ''" avatar="item.ui"></salaxy-avatar>
            <div class="typeahead-result">
              <i ng-if="item.ui.isChild" class="bi bi-square-fill me-2"></i>
              <b ng-if="item.ui" class="salaxy-highlight display-block">{{ item.text }}</b>
              <div ng-if="!item.ui" class="salaxy-highlight">
                {{ item.text || item.value + ' (' + item.value + ')' }}
              </div>
              <small ng-if="item.title" class="salaxy-highlight">
                <span ng-if="!item.ui.isChild" ng-bind-html="item.title" class="text-truncate d-block"></span>
                <span ng-if="item.ui.isChild" ng-bind-html="item.title" class="text-truncate"></span>
              </small>
            </div>
          </li>
        </ul>
        <button type="button" class="clear btn-close" ng-if="$ctrl.value && !$ctrl.getDisabled()" ng-click="$ctrl.clearValue(true); $ctrl.openResultsList();"></button>
      </div>
      <div class="input-group-btn">
        <button ng-if="$ctrl.getToolTipHtml()" type="button" class="btn btn-default" data-bs-toggle="popover" data-bs-container="body" aria-label="Info" data-bs-html="true" data-bs-title="'Info'" data-bs-content="$ctrl.getToolTipHtml()" sxy-bs5-popover>
          <span class="bi bi-question-circle-fill"></span>
        </button>
      </div>
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/InputWorkerItem.html",`<a class="clickable salaxy-component salaxy-worker-item">
    <salaxy-avatar class="salaxy-calc-row-type-avatar pull-left" 
    avatar="match.model"></salaxy-avatar>
    <b class="salaxy-highlight" ng-bind-html="match.label + ' (' + match.model.displayId + ')' | uibTypeaheadHighlight:query"></b><br />
    <small class="salaxy-highlight"><div ng-bind-html="match.model.description | uibTypeaheadHighlight:query"></div></small>
</a>`);

 $templateCache.put("salaxy-components/form-controls/MarkdownEditor.html",`<div id="editor"></div>
`);

 $templateCache.put("salaxy-components/form-controls/MarkdownViewer.html",`<div id="viewer"></div>`);

 $templateCache.put("salaxy-components/form-controls/Textarea.html",`<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.value }}</div>
</salaxy-form-group>
<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-textarea">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' &&  !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="">
      <span class="form-control-plaintext" style="max-width:90%; display:inline-block;">{{ $ctrl.value }}</span>
      <span class="float-end btn-padding-right" style="padding-top:7px;">
        <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>

  </salaxy-form-group>
  <salaxy-form-group ng-if="!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen)" name="{{$ctrl.name}}" label="{{$ctrl.label}}" require="$ctrl.require" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div ng-if="$ctrl.getToolTipHtml()" class="input-group">
      <textarea class="form-control" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}" ng-model="$ctrl.value" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }" ng-change="$ctrl.onChange()"
        ng-pattern="$ctrl.pattern" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" ng-minlength="$ctrl.minlength" ng-maxlength="$ctrl.maxlength" maxlength="{{$ctrl.maxlength}}" rows="{{ $ctrl.rows || 3 }}"></textarea>
      <div class="input-group-btn">
        <button type="button" class="btn btn-default" data-bs-container="body" aria-label="Info" data-bs-toggle="popover" data-bs-html="true" data-bs-title="'Info'" data-bs-content="$ctrl.getToolTipHtml()" data-bs-placement="'{{$ctrl.tooltipPlacement}}'" sxy-bs5-popover>
          <span class="bi bi-question-circle-fill"></span>
        </button>
        <button ng-if="$ctrl.inputMode == 'openClose'" class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
    <div ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">
      <textarea ng-if="!$ctrl.getToolTipHtml()" class="form-control" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}" ng-model="$ctrl.value" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }"
        ng-change="$ctrl.onChange()" ng-pattern="$ctrl.pattern" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" ng-minlength="$ctrl.minlength" ng-maxlength="$ctrl.maxlength" maxlength="{{$ctrl.maxlength}}" rows="{{ $ctrl.rows || 3 }}"></textarea>
      <div class="input-group-btn" ng-if="$ctrl.inputMode == 'openClose'">
        <button class="btn btn-transparent float-end" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/form-controls/ToggleButtons.html",`<div class="salaxy-component salaxy-toggle-buttons btn-group" role="group" 
     ng-class="{
         'd-block': $ctrl.type === 'block',
         'row': $ctrl.type === 'row',
         'd-inline-block': $ctrl.type === 'inline'
     }">
  <div ng-repeat="item in $ctrl.options track by $index" index="$index" class="toggle-button-wrapper" ng-if="!item.hidden"
       ng-class="{
           'd-block': $ctrl.type === 'block',
           'col-2': $ctrl.type === 'row',
           'd-inline-block': $ctrl.type === 'inline'
       }">
    <input type="radio" class="btn-check" name="btn-toggle" id="btn-toggle-{{ item.value }}" autocomplete="off" ng-model="$ctrl.model.$viewValue" ng-value="item.value" ng-disabled="item.disabled">
    <label class="btn btn-sm btn-outline-primary toggle-button" for="btn-toggle-{{ item.value }}" ng-click="$ctrl.onClick(item.value)" 
           ng-class="{
               'btn-primary': $ctrl.model.$viewValue == item.value,
               'btn-default': $ctrl.model.$viewValue != item.value,
               'btn-block': $ctrl.type === 'block',
               'd-inline-block': $ctrl.type === 'inline',
               'flex-fill': $ctrl.type === 'row'
           }">
      <img ng-if="item.imgSrc" class="toggle-button-image me-2" ng-src="{{ item.imgSrc }}"/>
      <span class="toggle-button-label">{{ item.label | sxyTranslate }}</span>
    </label>
  </div>
</div>
`);

 $templateCache.put("salaxy-components/form-controls/ValidationSummary.html",`<div ng-if="!$ctrl.hasValidation" ng-bind-html="$ctrl.loadingHtml"></div>
<div ng-if="$ctrl.hasValidation" class="salaxy-component salaxy-validation-summary">
  <ng-transclude ng-if="$ctrl.isValid"></ng-transclude>
  <div ng-if="$ctrl.layout != 'minimal'">
    <div ng-if="!$ctrl.isValid && !$ctrl.hasWarningsOnly" class="alert alert-danger">
      <div ng-if="$ctrl.hasValidationOrGeneralErrors">
        <h4 sxy-text="SALAXY.NG1.ValidationSummaryComponent.checkForErrors" ps=":"></h4>
        <ul class="validation-error-list">
          <li ng-repeat="error in $ctrl.getErrors('!required') | limitTo:3" ng-class="error.type">{{ $ctrl.getLabel(error) }}</li>
        </ul>
      </div>
      <div ng-if="!$ctrl.hasAllRequiredFields">
        <h4 sxy-text="SALAXY.NG1.ValidationSummaryComponent.missingRequired" ps=":"></h4>
        <ul class="validation-error-list">
          <li ng-repeat="error in $ctrl.getErrors('required') | limitTo:3" class="warning">{{ $ctrl.getLabel(error) }}</li>
        </ul>
      </div>
      <button class="btn btn-xs btn-danger float-end" ng-click="$ctrl.showDetails()" sxy-text="SALAXY.UI_Terms.readMore" ps="..."></button>
    </div>
    <div ng-if="$ctrl.hasWarningsOnly" class="alert alert-warning">
      <h4>Varoituksia:</h4>
      <ul>
        <li ng-repeat="error in $ctrl.getErrors('warning') | limitTo:3">{{ $ctrl.getLabel(error) }}</li>
      </ul>
      <button class="btn btn-xs btn-warning float-end" ng-click="$ctrl.showDetails()" sxy-text="SALAXY.UI_Terms.readMore" ps="..."></button>
    </div>
  </div>
  <span ng-if="$ctrl.layout == 'minimal' && (!$ctrl.isValid || $ctrl.hasWarningsOnly)" class="validation-container">
    <span ng-if="$ctrl.hasValidationOrGeneralErrors"><span ng-repeat="error in $ctrl.getErrors('!required') | limitTo:3" class="validation-error-item" ng-class="error.type">{{ $ctrl.getLabel(error) }}</span></span>
  <span ng-if="!$ctrl.hasAllRequiredFields"><span ng-repeat="error in $ctrl.getErrors('required') | limitTo:3" class="validation-error-item" ng-class="error.type">{{ $ctrl.getLabel(error) }}</span></span>
  <span ng-if="!$ctrl.hasWarningsOnly"><span ng-repeat="error in $ctrl.getErrors('warning') | limitTo:3" class="validation-error-item" ng-class="error.type">{{ $ctrl.getLabel(error) }}</span></span>
  </span>
</div>`);

 $templateCache.put("salaxy-components/form-controls/ValidationSummaryDetails.html",`<style type="text/css">
  .panel-validation {
    border-color: var(--salaxy-brand-danger);
  }
  
  .panel-heading-validation {
    border-color: var(--salaxy-brand-danger);
    background-color: var(--salaxy-brand-danger);
  }
</style>
<div class="salaxy-component salaxy-calc-details-dialog card-validation">
  <div class="modal-header card-header-validation">
    <h2 sxy-text="SALAXY.NG1.ValidationSummaryDetailsComponent.moreInfoTitle"></h2>
    <button type="button" class="btn-close float-end" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div ng-repeat="error in $ctrl.data.controller().getErrors()" class="alert" ng-class="error.type=='warning' ? 'alert-warning' : 'alert-danger'" role="alert">
      <b>{{$ctrl.data.controller().getLabel(error)}}</b>
      <br/>{{$ctrl.data.controller().getDescription(error)}}
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary float-end" ng-click="$close('ok')">OK</button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/ActionButton.html",`<span class="d-flex" ng-switch="$ctrl.action">
  <a ng-switch-when="newCalc" href="#/calc/details/new" class="btn salaxy-action-button btn-new-calc btn-labeled-right" ng-class="$ctrl.buttonClass" ng-disabled="$ctrl.disabled"
    type="button" id="new-calc">
    {{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.newCalculation' | sxyTranslate}}<i class="bi bi-plus-lg"></i>
  </a>
  <span ng-switch-when="newRepair" ng-controller="CalculationCrudController as $calculationCtrl">
    <button ng-click="$calculationCtrl.launchCreateRepair($ctrl.onAfterAction)" class="btn salaxy-action-button btn-new-repair btn-labeled-right" ng-class="$ctrl.buttonClass"
      ng-disabled="$ctrl.disabled" type="button" id="new-repair">
      {{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.newRepair' | sxyTranslate}}<i class="bi bi-plus-lg"></i>
    </button>
  </span>
  <div ng-switch-when="newCalcForEmployment" class="btn-group btn-new-calc-for-employment dropdown" ng-class="$ctrl.buttonClass" id="new-calc-for-employment">
    <a class="btn btn-primary" href="#/calc/details/{{$ctrl.options.id}}/new-for-employment">{{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.newCalculation' | sxyTranslate}}</a>
    <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <span class="sr-only"sxy-text="SALAXY.NG1.ActionButtonComponent.addCalcTypes" ps="..."></span>
    </button>
    <ul class="dropdown-menu">
      <li><a href="#/calc/details/{{$ctrl.options.id}}/new-for-employment" class="dropdown-item" sxy-text="SALAXY.NG1.ActionButtonComponent.commonCalc"></a></li>
      <li><a href="#/calc/history/{{$ctrl.options.id}}/new-for-employment" class="dropdown-item" sxy-text="SALAXY.NG1.ActionButtonComponent.historicalCalc"></a></li>
    </ul>
  </div>
  <a ng-switch-when="newMessage" href="#/messages/details/new" class="btn salaxy-action-button btn-new-message btn-labeled-right" ng-class="$ctrl.buttonClass"
    ng-disabled="$ctrl.disabled" type="button" id="new-message">
    {{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.startNewMessage' | sxyTranslate}}<i class="bi bi-plus-lg"></i>
  </a>
  <a ng-switch-when="newPayroll" href="#/payroll/details/new" class="btn salaxy-action-button btn-new-payroll btn-labeled-right" ng-class="$ctrl.buttonClass"
    ng-disabled="$ctrl.disabled" type="button" id="new-payroll">
    {{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.newPayroll' | sxyTranslate}}<i class="bi bi-plus-lg"></i>
  </a>
  <span ng-switch-when="newWorker" ng-controller="EmploymentCrudController as $employmentCtrl">
    <button ng-click="$employmentCtrl.launchCreateEmploymentWizard()" class="btn salaxy-action-button btn-new-worker btn-labeled-right" ng-class="$ctrl.buttonClass"
      ng-disabled="$ctrl.disabled" type="button" id="new-worker">
      {{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.newWorker' | sxyTranslate}}<i class="bi bi-plus-lg"></i>
    </button>
  </span>
  <span ng-switch-when="newTaxcard">
    <a href="#/taxcards" class="btn salaxy-action-button btn-new-payroll btn-labeled-right" ng-class="$ctrl.buttonClass" ng-disabled="$ctrl.disabled" type="button"
      id="new-taxcard">
      {{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.sendTaxCard' | sxyTranslate}}<i class="bi bi-plus-lg"></i>
    </a>
  </span>
  <span ng-switch-default class="alert alert-danger" sxy-text="SALAXY.NG1.ActionButtonComponent.error"></span>
</span>`);

 $templateCache.put("salaxy-components/helpers/Alert.html",`<div class="salaxy-component salaxy-alert">
  <div ng-class="'alert alert-' + $ctrl.type">
    <div>
      <table style="width: 100%; border-collapse:separate;">
        <!-- TODO: Switch this to position:absolute & margins or flex-grid -->
        <tr>
          <td class="icon-container hidden-xxs" ng-if="$ctrl.getIcon()">
            <span class="icon"><i class="bi {{ $ctrl.getIcon() }}"></i></span>
          </td>
          <td>
            <div class="main ps-3">
              <ng-transclude ng-transclude-slot="main">
                <p>{{ $ctrl.text }}</p>
              </ng-transclude>
            </div>
          </td>
          <td ng-if="$ctrl.hasMoreInfo && !$ctrl.forceMoreInfo" class="text-end">
            <button class="btn btn-info btn-main" ng-click="$ctrl.showMoreInfo = !$ctrl.showMoreInfo" sxy-text="SALAXY.UI_Terms.learnMore"></button>
          </td>
        </tr>
      </table>
      <div class="collapse" ng-if="$ctrl.hasMoreInfo" ng-class="{ show: ($ctrl.showMoreInfo || $ctrl.forceMoreInfo) }">
        <ng-transclude ng-transclude-slot="aside"></ng-transclude>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/Avatar.html",`<i class="salaxy-avatar bi" ng-class="{'bi-person-fill': $ctrl.isPersonIcon, 'bi-square-fill': $ctrl.isCompanyIcon }" ng-style="{ color: $ctrl.color }">
  <img ng-src="{{ $ctrl.avatar.url }}" ng-show="$ctrl.isImage" />
  <strong ng-show="!$ctrl.isImage" ng-style="{'text-shadow': '1px 1px 0 ' + ($ctrl.color || 'black') + ', -1px -1px 0 ' + ($ctrl.color || 'black') + ', 1px -1px 0 ' + ($ctrl.color || 'black') + ', -1px 1px 0 ' + ($ctrl.color || 'black')}">
    {{ $ctrl.initials !== '-' ? $ctrl.initials : $ctrl.avatar.iconText }}
  </strong>
</i>`);

 $templateCache.put("salaxy-components/helpers/Calendar.html",`<div class="salaxy-component salaxy-calendar">
  <button ng-if="$ctrl.showExport" type="button" class="btn btn-default" ng-click="$ctrl.exportCalendarPdf()">
    <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.downloadPdf"></span>
    <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
  </button>
  <button ng-if="$ctrl.showExport" type="button" class="btn btn-default" ng-click="$ctrl.exportCalendarExcel()">
    <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.downloadExcel"></span>
    <i class="bi bi-file-earmark-excel" aria-hidden="true"></i>
  </button>
  <div ng-if="$ctrl.mode == 'align-weekdays'">
    <table class="calendar">
      <thead>
        <tr>
          <th class="calendar-title">
            {{ $ctrl.start | date : "yyyy" }}
            <span ng-if="($ctrl.start | date : 'yyyy') != ($ctrl.end | date : 'yyyy')">- {{ $ctrl.end | date : "yyyy" }}</span>
          </th>
          <th class="day day-of-week-{{ day.weekday }}" ng-repeat="day in $ctrl.weekdaysForMonth track by $index">{{ day.text }}</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="month in $ctrl.months">
          <td class="month-title">{{ month.title }}</td>
          <td class="beginning-spacer" ng-if="month.firstDayDayOfWeek > 1" colspan="{{ month.firstDayDayOfWeek - 1}}"></td>
          <td class="day day-of-week-{{ day.weekday }} day-type-{{ day.dayType }} clickable" ng-repeat="day in month.days" ng-click="$ctrl.dateClicked(day, $ctrl.series[0], $event)">
            <div ng-repeat="ev in day.periods[0]" ng-class="$ctrl.getCssClass(ev)" ng-click="$ctrl.eventClicked(ev, day, null, $event)" data-bs-toggle="tooltip" data-bs-title="'{{ ev.summary }}'" data-bs-container="body" ng-style="$ctrl.getEventStyle(ev, day.periods[0])" sxy-bs5-tooltip></div>
            <i ng-repeat="ev in day.singleDays[0]" ng-class="$ctrl.getCssClass(ev)" ng-style="$ctrl.getEventStyle(ev, day.singleDays[0])" ng-click="$ctrl.eventClicked(ev, day, null, $event)" data-bs-toggle="tooltip" data-bs-title="'{{ ev.summary }}'" data-bs-container="body" sxy-bs5-tooltip></i>
            <span class="day-number">{{ day.day }}</span><br />
          </td>
          <td class="day end-spacer" ng-if="(38 - month.firstDayDayOfWeek - month.daysInMonth) > 0" colspan="{{ 38 - month.firstDayDayOfWeek - month.daysInMonth  }}"></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-if="$ctrl.mode == 'align-left'">
    <table class="calendar">
      <thead>
        <tr>
          <th class="calendar-title">
            {{ $ctrl.start | date : "yyyy" }}
            <span ng-if="($ctrl.start | date : 'yyyy') != ($ctrl.end | date : 'yyyy')">- {{ $ctrl.end | date : "yyyy" }}</span>
          </th>
          <th class="day" ng-repeat="day in $ctrl.weekdaysForMonth track by $index">{{ day.text }}</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="month in $ctrl.months">
          <td class="month-title">{{ month.title }}</td>
          <td class="day day-of-week-{{ day.weekday }} day-type-{{ day.dayType }} clickable" ng-repeat="day in month.days" ng-click="$ctrl.dateClicked(day, $ctrl.series[0], $event)">
            <div ng-repeat="ev in day.periods[0]" ng-class="$ctrl.getCssClass(ev)"  ng-style="$ctrl.getEventStyle(ev, day.periods[0])" ng-click="$ctrl.eventClicked(ev, day, null, $event)" data-bs-toggle="tooltip" data-bs-title="'{{ ev.summary }}'" data-bs-container="body" sxy-bs5-tooltip></div>
            <i ng-repeat="ev in day.singleDays[0]" ng-class="$ctrl.getCssClass(ev)" ng-style="$ctrl.getEventStyle(ev, day.singleDays[0])" ng-click="$ctrl.eventClicked(ev, day, null, $event)" data-bs-toggle="tooltip" data-bs-title="'{{ ev.summary }}'" data-bs-container="body" sxy-bs5-tooltip></i>
            <span class="day-number">{{ day.weekdayText }}</span><br />
          </td>
          <td class="day end-spacer" ng-if="(31 - month.daysInMonth) > 0" colspan="{{ 31 - month.daysInMonth }}"></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-if="$ctrl.mode == 'horizontal'" class="calendar-horizontal">
    <table class="calendar" style="width: max-content;margin-bottom: 10px;">
      <thead>
        <tr>
          <th class="calendar-title" rowspan="2">
            {{ $ctrl.start | date : "yyyy" }}
            <span ng-if="($ctrl.start | date : 'yyyy') != ($ctrl.end | date : 'yyyy')">- {{ $ctrl.end | date : "yyyy" }}</span>
          </th>
          <th class="month-title" ng-repeat="month in $ctrl.months" colspan="{{ month.daysInMonth }}">{{ month.title }} {{ month.year }}</th>
        </tr>
        <tr>
          <th class="day day-of-week-{{ day.weekday }} day-type-{{ day.dayType }}" ng-click="$ctrl.dateClicked(day, null, $event)" ng-repeat="day in $ctrl.allDays">
            {{ day.weekdayText }}<br />
            {{ day.day }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="series in $ctrl.series" ng-init="seriesIndex = $index">
          <td class="series-title clickable" ng-class="{ 'has-avatar': series.avatar }" ng-click="$ctrl.seriesClicked(series, $event)">
            <salaxy-avatar avatar="series.avatar" ng-if="series.avatar"
              style="font-size: 30px;left: 2px;position: absolute;top: 2px;"></salaxy-avatar>
            <div><strong>{{ series.title }}</strong></div>
            <div>{{ series.description }}</div>
          </td>
          <td class="day day-of-week-{{ day.weekday }} day-type-{{ day.dayType }} clickable"
            ng-repeat="day in $ctrl.allDays" ng-click="$ctrl.dateClicked(day, series, $event)">
            <div ng-repeat="ev in day.periods[seriesIndex]" ng-class="$ctrl.getCssClass(ev)" ng-style="$ctrl.getEventStyle(ev, day.periods[seriesIndex])" ng-click="$ctrl.eventClicked(ev, day, series, $event)" data-bs-toggle="tooltip" title="{{ ev.summary }}" data-bs-container="body" sxy-bs5-tooltip></div>
            <i ng-repeat="ev in day.singleDays[seriesIndex]" ng-class="$ctrl.getCssClass(ev)" ng-style="$ctrl.getEventStyle(ev, day.singleDays[seriesIndex])" ng-click="$ctrl.eventClicked(ev, day, series, $event)" data-bs-toggle="tooltip" title="{{ ev.summary }}" data-bs-container="body" sxy-bs5-tooltip></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-if="$ctrl.mode == 'list'">
    <h3>TODO: List layout</h3>
    <p>Period: {{ { start: $ctrl.start, end: $ctrl.end } | sxyDateRange }}</p>
    <fieldset ng-repeat="month in $ctrl.monthlyList">
      <legend>{{ month.title }} / {{ month.year }}</legend>
      <table class="table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Weekday</th>
            <th>Events</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="day in month.days">
            <td>{{ day.day }}</td>
            <td>
              {{ day.weekdayText }}
              <span ng-if="day.dayType != 'normal'">{{ day.dayType }}</span>
            </td>
            <td>
              <ul ng-repeat="eventArr in day.events" ng-init="seriesIndex = $index">
                <li ng-repeat="period in eventArr"><strong>{{ $ctrl.series[$index].title || $ctrl.series[$index].key }}: {{ period | sxyDateRange }}</strong> {{ period.title }}: {{ period.description }}</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </fieldset>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/Chart.html",`
<div ng-if="$ctrl.config" ng-init="$ctrl.init()" class="salaxy-component salaxy-chart" ng-class="$ctrl.customClass" ng-style="{width: $ctrl.customWidth, height: $ctrl.customHeight}">
  <canvas class="chart" ng-class="$ctrl.chart.config.type ==='line' ? 'chart-line' : 'chart-pie'"></canvas>
</div>`);

 $templateCache.put("salaxy-components/helpers/DataMapper.html",`<div class="salaxy-component salaxy-data-mapper">
  <div ng-if="!$ctrl.model" class="alert alert-danger">Data mapper not found</div>
  <div ng-if="$ctrl.model" ng-switch="$ctrl.type || 'value-map'">
    <div ng-switch-when="value-map">
      <table class="table table-sm">
        <thead>
          <tr>
            <th ng-repeat="selector in $ctrl.model.map" style="padding: 0;">
              <salaxy-input readonly="true" label="header" label-type="plain" name="header" ng-model="selector.source"></salaxy-input>
            </th>
          </tr>
          <tr ng-if="$ctrl.model">
            <th ng-repeat="selector in $ctrl.model.map" style="padding: 0;">
              <salaxy-input-enum name="parserMapperSource" label-type="plain" options="$ctrl.model.target.allKeys" ng-model="selector.target" type="select"
                  ng-change="selector.resolve($ctrl.model.source.getSchema(), $ctrl.model.target.getSchema())"></salaxy-input-enum>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.model.source.value">
            <td ng-repeat="selector in $ctrl.model.map">{{row[selector.source]}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div ng-switch-when="debug">
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'info', text: 'Basic info' },
          { value: 'mapping', text: 'Mapping' },
          { value: 'source', text: 'Source data' },
          { value: 'target', text: 'Target data' },
          { value: 'json', text: 'JSON' }
        ]"
        tabs-id="dataMapper">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-dataMapper">
        <div class="tab-pane" id="info-tab">
          <fieldset class="form-horizontal" style="max-width: 800px;">
            <salaxy-input name="title" ng-model="$ctrl.model.title" label="Title"></salaxy-input>
            <salaxy-input name="uri" ng-model="$ctrl.model.uri" label="Uri"></salaxy-input>
            <salaxy-input-boolean name="isSourceAList" ng-model="$ctrl.model.isSourceAList" label="Source is a list"></salaxy-input-boolean>
            <button type="button" ng-click="$ctrl.model.doMap()" class="btn btn-default">Do map</button>
          </fieldset>
        </div>
        <div class="tab-pane" id="mapping-tab">
          <table class="table table-striped">
            <thead>
              <th>{{$ctrl.model.source.name || "Source unknown"}} ({{$ctrl.model.source.schema.format || "format unknown"}})</th>
              <th>Type / format</th>
              <th class="text-center">Mapping</th>
              <th>{{$ctrl.model.target.name || "Target unknown"}} ({{$ctrl.model.target.schema.format || "format unknown"}})</th>
              <th>Type / format</th>
            </thead>
            <tbody>
              <tr ng-repeat="selector in $ctrl.model.map">
                <td>
                  <salaxy-input-enum name="parserMapperSource" label-type="plain" options="$ctrl.model.source.allKeys" ng-model="selector.source" type="select"
                    ng-change="selector.resolve($ctrl.model.source.getSchema(), $ctrl.model.target.getSchema())"></salaxy-input-enum>
                </td>
                <td ng-if="selector.sourceProp">
                  <span>{{ selector.sourceProp.schema.type }} / {{ selector.sourceProp.schema.format || "-" }}</span>
                  <salaxy-json-formatter json="selector.sourceProp" key="'...'" type="dialog"></salaxy-json-formatter>
                </td>
                <td ng-if="!selector.sourceProp" class="text-danger">Not found!</td>
                <td class="text-center middle">
                  <i ng-if="selector.flatten.length" class="text-primary bi bi-diagram-3-fill" aria-hidden="true"></i>
                  <i ng-if="!selector.flatten.length && !selector.func" class="bi bi-arrow-left-circle-fill" aria-hidden="true"></i>
                  <i ng-if="!selector.flatten.length && selector.func" class="bi bi-gear-fill bi-spin text-primary" aria-hidden="true"></i>
                </td>
                <td ng-if="!selector.flatten.length">
                  <salaxy-input-enum name="parserMapperTarget" label-type="plain" options="$ctrl.model.target.allKeys" ng-model="selector.target" type="select"
                    ng-change="selector.resolve($ctrl.model.source.getSchema(), $ctrl.model.target.getSchema())"></salaxy-input-enum>
                </td>
                <td ng-if="!selector.flatten.length && selector.targetProp">
                  <span>{{ selector.targetProp.schema.type }} / {{ selector.targetProp.schema.format || "-" }}</span>
                  <salaxy-json-formatter json="selector.targetProp" key="'...'" type="dialog"></salaxy-json-formatter>
                </td>
                <td ng-if="!selector.flatten.length && !selector.targetProp" class="text-danger">Not found!</td>
                <td ng-if="selector.flatten.length" colspan="2">
                  <table>
                    <tr ng-repeat="flattenSelector in selector.flatten">
                      <td>
                        <salaxy-input-enum name="parserMapperTarget" label-type="plain" options="$ctrl.model.target.allKeys" ng-model="flattenSelector.target" type="select"
                          ng-change="flattenSelector.resolve(flattenSelector.sourceProp.schema.items, $ctrl.model.target.getSchema())"></salaxy-input-enum>
                      </td>
                      <td>
                        <span>{{ flattenSelector.targetProp.schema.type }} / {{ flattenSelector.targetProp.schema.format || "-" }}</span>
                        <salaxy-json-formatter json="flattenSelector.targetProp" key="'...'" type="dialog"></salaxy-json-formatter>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-pane" id="source-tab">
          <salaxy-data-mapper model="$ctrl.model" type="source-value"></salaxy-data-mapper>
        </div>
        <div class="tab-pane" id="target-tab">
          <salaxy-data-mapper model="$ctrl.model" type="target-value"></salaxy-data-mapper>
        </div>
        <div class="tab-pane" id="json-tab">
          <div class="row">
            <div class="col-sm-4">
              <h3>Source</h3>
              <salaxy-json-formatter json="$ctrl.model.source" open="3"></salaxy-json-formatter>
            </div>
            <div class="col-sm-4">
              <h3>Mapper</h3>
              <salaxy-json-formatter json="$ctrl.model.map" open="3"></salaxy-json-formatter>
            </div>
            <div class="col-sm-4">
              <h3>Target</h3>
              <salaxy-json-formatter json="$ctrl.model.target" open="3"></salaxy-json-formatter>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ng-switch-when="source-value">
      <table class="table table-sm">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.ODataImportComponent.step3.okey"></th>
            <th ng-repeat="header in $ctrl.model.source.keys">
              {{header}}
              (<span>{{ $ctrl.model.source.schema.properties[header].type || "-" }} / {{ $ctrl.model.source.schema.properties[header].format || "-" }}</span>
              <salaxy-json-formatter json="$ctrl.model.source.schema.properties[header]" key="'...'" type="dialog"></salaxy-json-formatter>)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.model.source.value">
            <td>
              <div ng-if="row.validation && row.validation.errors && row.validation.errors.length" ng-repeat="error in row.validation.errors">
                <button data-bs-toggle="popover" data-bs-content="{{ error.msg }}" data-bs-title="{{ error.code }}" type="button" class="btn btn-danger" sxy-bs5-popover>{{ error.type }}</button><br>
              </div>
              
              <div ng-if="row.validation && row.validation.isValid">
                <span class="text-success" sxy-text="SALAXY.NG1.ODataImportComponent.step3.okey"></span>
              </div>
            </td>
            <td ng-repeat="header in $ctrl.model.source.keys">{{row[header]}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div ng-switch-when="target-value">
      <table class="table table-sm">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.ODataImportComponent.step3.okey"></th>
            <th ng-repeat="header in $ctrl.model.target.keys">
              {{header}}
              (<span>{{ $ctrl.model.target.schema.properties[header].type || "-" }} / {{ $ctrl.model.target.schema.properties[header].format || "-" }}</span>
              <salaxy-json-formatter json="$ctrl.model.target.schema.properties[header]" key="'...'" type="dialog"></salaxy-json-formatter>)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.model.target.value">
            <td>
              <div ng-if="row.validation.errors.length" ng-repeat="error in row.validation.errors">
                <button data-bs-toggle="popover" data-bs-content="{{ error.msg }}" data-bs-title="{{ error.code }}" type="button" class="btn btn-danger" sxy-bs5-popover>{{ error.type }}</button><br>
              </div>
              <div ng-if="row.validation && row.validation.isValid">
                <span class="text-success" sxy-text="SALAXY.NG1.ODataImportComponent.step3.okey"></span>
              </div>
            </td>
            <td ng-repeat="header in $ctrl.model.target.keys">{{row[header]}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/import/CalcImportOptions.html",`<div class="salaxy-component salaxy-calc-import-options">
  <div class="row">
    <form class="form-horizontal col-sm-6" name="$ctrl.optionsForm">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcImport.options.title"></legend>
        <div class="row">
          <div class="col col-sm-6">
            <salaxy-input-enum options="{
            addRows: 'SALAXY.NG1.CalcImport.options.addRows',
            removeAllRows: 'SALAXY.NG1.CalcImport.options.removeAllRows',
            removeImportedRows: 'SALAXY.NG1.CalcImport.options.removeImportedRows'}" label-type="plain" name="customOptions" ng-model="$ctrl.customOptions" type="radio"
              ng-change="$ctrl.updateOptions()"></salaxy-input-enum>
            <salaxy-input-boolean type="checkbox" name="applyEmploymentDefaultRows" label-type="plain" label-true="SALAXY.NG1.CalcImport.options.applyEmploymentDefaultRows"
              ng-model="$ctrl.options.applyEmploymentDefaultRows"></salaxy-input-boolean>
          </div>
          <div class="col col-sm-6">
            <salaxy-input ng-if="true" require="$ctrl.options.rowMergeOption == 'removeImportedRows'" ng-model="$ctrl.options.sourceId" name="sourceId"
              label="SALAXY.NG1.CalcImport.options.sourceId"></salaxy-input>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/import/DataImport.html",`<div class="salaxy-component salaxy-data-import">
  <div class="salaxy-wizard">
    <div class="wizard-steps">
      <div class="wizard-step" ng-class="{'active': $ctrl.action == 'upload'}">
        <span class="salaxy-avatar">
          <div class="wizard-icons-wrapper">
            <i class="bi" ng-class="$ctrl.action == 'upload' ? 'bi-circle-fill' : 'bi-circle'"></i>
            <i class="bi bi-circle-fill"></i>
          </div>
          <strong class="number">1</strong>
        </span>
        <span class="step-text" sxy-text="SALAXY.NG1.DataImport.stepUpload.title"></span>
      </div>
      <div class="wizard-step" ng-class="{'active': $ctrl.action == 'validate'}">
        <span class="salaxy-avatar">
          <div class="wizard-icons-wrapper">
            <i class="bi" ng-class="$ctrl.action == 'validate' ? 'bi-circle-fill' : 'bi-circle'"></i>
            <i class="bi bi-circle-fill"></i>
          </div>
          <strong class="number">2</strong>
        </span>
        <span class="step-text" sxy-text="SALAXY.NG1.DataImport.stepValidate.title"></span>
      </div>
      <div class="wizard-step" ng-class="{'active': $ctrl.action == 'import'}">
        <span class="salaxy-avatar">
          <div class="wizard-icons-wrapper">
            <i class="bi" ng-class="$ctrl.action == 'import' ? 'bi-circle-fill' : 'bi-circle'"></i>
            <i class="bi bi-circle-fill"></i>
          </div>
          <strong class="number">3</strong>
        </span>
        <span class="step-text" sxy-text="SALAXY.NG1.DataImport.stepImport.title"></span>
      </div>
    </div>
    <div class="wizard-strikethrough"></div>
  </div>
  <ng-include ng-if="$ctrl.optionsTemplate" src="$ctrl.optionsTemplate"></ng-include>
  <div ng-switch="$ctrl.action">
    <div ng-switch-when="upload">
      <p sxy-text="SALAXY.NG1.DataImport.stepUpload.intro"></p>
      <p>
        <span class="badge bg-primary" ng-if="$ctrl.sourceData.length">{{'SALAXY.NG1.DataImport.badgeUploadedLabel' | sxyTranslate }} {{$ctrl.sourceData.length}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span>
      </p>
      <div class="modal-footer mb-3">
        <button id="info" ng-disabled="$ctrl.isImporting" type="button" class="btn btn-default" ng-click="$ctrl.help()">
          <span>{{'SALAXY.NG1.DataImport.stepUpload.buttonHelp' | sxyTranslate}} <i class="bi bi-info-circle"></i></span>
        </button>
        <button id="upload" ng-disabled="$ctrl.isImporting" type="button" class="btn btn-default" ngf-select="$ctrl.upload($files)" ngf-multiple="false" ngf-max-size="10MB">
          <span>{{'SALAXY.NG1.DataImport.stepUpload.buttonUpload' | sxyTranslate}} <i class="bi bi-file-earmark-excel"></i></span>
        </button>
        <button id="paste" ng-disabled="$ctrl.isImporting" type="button" class="btn btn-default" ng-click="$ctrl.paste()">
          <span>{{'SALAXY.NG1.DataImport.stepUpload.buttonPaste' | sxyTranslate}} <i class="bi bi-clipboard"></i></span>
        </button>
        <button id="reset" ng-disabled="$ctrl.isImporting" type="button" class="btn btn-default" ng-click="$ctrl.reset(true)">
          {{'SALAXY.NG1.DataImport.stepUpload.buttonReset' | sxyTranslate}}
        </button>
        <button class="btn btn-primary ms-auto" sxy-text="SALAXY.UI_Terms.next" ng-click="$ctrl.action='validate';$ctrl.validate()"></button>
      </div>
    </div>
    <div ng-switch-when="validate">
      <p sxy-text="SALAXY.NG1.DataImport.stepValidate.intro"></p>
      <p>
        <span ng-if="$ctrl.validationUndoneRows"><span class="badge bg-default">{{'SALAXY.NG1.DataImport.badgeUndoneLabel' | sxyTranslate }} {{$ctrl.validationUndoneRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
        <span ng-if="$ctrl.validationErrorRows"><span class="badge bg-danger">{{'SALAXY.NG1.DataImport.badgeErrorLabel' | sxyTranslate }} {{$ctrl.validationErrorRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
        <span ng-if="$ctrl.validationSuccessRows"><span class="badge bg-success">{{'SALAXY.NG1.DataImport.badgeSuccessLabel' | sxyTranslate }} {{$ctrl.validationSuccessRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
      </p>
      <div class="modal-footer mb-3">
        <button class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous" ng-click="$ctrl.action='upload'"></button>
        <button id="validate" ng-disabled="$ctrl.isImporting" type="button" class="btn btn-default" ng-click="$ctrl.validate()">
          {{'SALAXY.NG1.DataImport.stepValidate.buttonValidate' | sxyTranslate}}
        </button>
        <button  ng-repeat="validator in $ctrl.getExtraValidators()"  ng-disabled="$ctrl.isImporting || $ctrl.isValidating" type="button" class="btn btn-default"
          ng-click="validator.validate()">
          {{ validator.buttonLabel }}
        </button>
        <button  ng-repeat="enricher in $ctrl.getDataEnrichers()"  ng-disabled="$ctrl.isImporting" type="button" class="btn btn-default"
        ng-click="enricher.enrich()">
        {{ enricher.buttonLabel }}
       </button>
        <button class="btn btn-primary ms-auto" sxy-text="SALAXY.UI_Terms.next" ng-click="$ctrl.action='import'"></button>
      </div>
    </div>
    <div ng-switch-when="import">
      <p sxy-text="SALAXY.NG1.DataImport.stepImport.intro"></p>
      <p>
      <div class="progress" ng-if="$ctrl.importTotal">
        <div style="min-width: 10em;" ng-style="{'width': ($ctrl.importCurrent * 100 / $ctrl.importTotal) + '%' }" class="progress-bar" role="progressbar"
          aria-valuenow="{{$ctrl.importCurrent}}" aria-valuemin="0" aria-valuemax="{{$ctrl.importTotal}}">
          <span><span ng-if="$ctrl.importCurrent != $ctrl.importTotal"><span ng-if="$ctrl.isImporting"><i class="bi bi-arrow-repeat bi-spin"></i></span></span>
            {{$ctrl.importCurrent}}/{{$ctrl.importTotal}}</span>
        </div>
      </div>
      <span ng-if="$ctrl.importIgnoredRows"><span class="badge bg-default">{{'SALAXY.NG1.DataImport.badgeIgnoredLabel' | sxyTranslate }} {{$ctrl.importIgnoredRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
      <span ng-if="$ctrl.importSuccessRows"><span class="badge bg-success">{{'SALAXY.NG1.DataImport.badgeFinishedLabel' | sxyTranslate }} {{$ctrl.importSuccessRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
      <span ng-if="$ctrl.importWarningRows"><span class="badge bg-warning">{{'SALAXY.NG1.DataImport.badgeWarningLabel' | sxyTranslate }} {{$ctrl.importWarningRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
      <span ng-if="$ctrl.importErrorRows"><span class="badge bg-danger">{{'SALAXY.NG1.DataImport.badgeErrorLabel' | sxyTranslate }} {{$ctrl.importErrorRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
      </p>
      <div class="modal-footer mb-3">
        <button class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous" ng-click="$ctrl.action='validate';$ctrl.validate()"></button>
        <div class="ms-auto">
          <button id="cancel" ng-disabled="!$ctrl.isImporting" type="button" class="btn btn-danger" ng-click="$ctrl.cancel()">
            {{'SALAXY.NG1.DataImport.stepImport.buttonCancel' | sxyTranslate}}
          </button>
          <button id="import" ng-disabled="$ctrl.isImporting || $ctrl.hasInvalidOptions()" type="button" class="btn btn-primary" ng-click="$ctrl.import()">
            {{'SALAXY.NG1.DataImport.stepImport.buttonImport' | sxyTranslate}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div id="import-table"></div>
</div>`);

 $templateCache.put("salaxy-components/helpers/import/EInvoiceAddressSelect.html",`<div class="modal-eInvoiceAddress-select">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.CompanyImport.enrichEInvoiceAddressesSelectionMessage"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <table class="table table-striped">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.name"></th>
            <th sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.receiver"></th>
            <th sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.intermediator"></th>
            <th class="right">              
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.logic.addresses">
            <td>
              <span>{{row.receiverName}}</span><br>
              <small>{{row.receiverOfficialId}}</small>
            </td>
            <td>
              <span>{{row.receiver}}</span><br>
            </td>
            <td>
              <span>{{row.intermediatorName}}</span><br>
              <small>{{row.intermediator}}</small>
            </td>
            <td class="right middle">
              <button class="btn btn-sm btn-default" type="button"
                ng-click="$ctrl.logic.select($ctrl.current, row, $close)">{{ 'SALAXY.UI_Terms.select' | sxyTranslate }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer text-end">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/import/staging/ImportStaging.html",`<div class="salaxy-component salaxy-import-staging">
  <div class="pull-right"><small>{{ $ctrl.serverUrl }}</small></div>
  <div class="toolbar">
    <button type="button" class="btn btn-default" ng-click="$ctrl.reloadUi()"><i class="bi bi-arrow-repeat" aria-hidden="true"></i></button>
    <div style="display: inline-block; width: 240px; vertical-align: middle;" ng-if="$ctrl.worktimeApi.payrolls && !$ctrl.payroll">
      <salaxy-input-typeahead options="$ctrl.worktimeApi.payrolls" name="payrollId" label-type="plain"
        placeholder="{{ 'SALAXY.NG1.ImportStagingComponent.toolbar.selectPayroll' | sxyTranslate }}"
        ng-model="$ctrl.payrollId"></salaxy-input-typeahead>
    </div>
    <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.payrollId" ng-click="$ctrl.commitPayroll('payroll')" sxy-text="SALAXY.NG1.ImportStagingComponent.toolbar.commitPayroll"></button>
    <button type="button" class="btn btn-default" ng-click="$ctrl.recalculateAllWorktimes()" sxy-text="SALAXY.NG1.ImportStagingComponent.toolbar.recalculateAll"></button>
  </div>
  <ng-include src="'salaxy-components/helpers/import/staging/ImportStaging_list.html'"></ng-include>
  <!-- TODO: Move to a dialog -->
  <ng-include src="'salaxy-components/helpers/import/staging/ImportStaging_test_data.html'"></ng-include>
</div>
<ng-include ng-if="$ctrl.worktimeApi.current" src="'salaxy-components/helpers/import/staging/ImportStaging_details.html'"></ng-include>`);

 $templateCache.put("salaxy-components/helpers/import/staging/ImportStaging_details.html",`<div class="salaxy-payroll-details-calc salaxy-payroll-details-dialog"
  ng-style="{'max-width': 'calc(100vw - 260px)','width': $ctrl.userSettings.ng1Binder('worktimeImport.calcDialogSize').val || '60%'}"
  ng-class="{ 'offcanvas-show': $ctrl.showOffcanvas }">
  <div class="modal-header bg-primary d-flex justify-content-between">
    <div ng-if="$ctrl.worktimeApi.current" class="d-flex">
      <salaxy-avatar class="align-self-center ms-2 me-3" avatar="$ctrl.worktimeApi.current.preview.employments[0].personalInfo.avatar"></salaxy-avatar>
      <div class="d-flex flex-column">
        <h3 class="modal-title">{{ $ctrl.worktimeApi.current.preview.employments[0].personalInfo.avatar.displayName }}</h3>
        <div>{{ $ctrl.worktimeApi.current.preview.employments[0].identity.personalId }} ({{ "EmploymentRelationType." + $ctrl.worktimeApi.current.preview.employments[0].info.type |
          sxyEnum }})
        </div>
      </div>
    </div>
    <div>
      <button type="button" class="btn btn-primary" ng-click="$ctrl.userSettings.ng1Binder('worktimeImport.calcDialogSize').val = ($ctrl.userSettings.ng1Binder('worktimeImport.calcDialogSize').val == '100%' ? '60%' : '100%')">
        <i ng-class="$ctrl.userSettings.ng1Binder('worktimeImport.calcDialogSize').val == '100%' ? 'bi bi-arrows-angle-contract' : 'bi bi-arrows-angle-expand'"></i>
      </button>
      <button type="button" class="btn btn-primary" aria-label="Close" ng-click="$ctrl.showDetails()"><span class="bi bi-x-lg"></span></button>
    </div>
  </div>
  <div class="modal-body">
    <table style="width: 100%">
      <tr>
        <td width="20%" sxy-text="SALAXY.NG1.ImportStagingComponent.details.payroll"></td>
        <td width="50%">
          <div>{{ $ctrl.worktimeApi.detailsPayroll.text || $ctrl.worktimeApi.detailsPayrollId || ("SALAXY.NG1.ImportStagingComponent.details.noPayroll" | sxyTranslate) }}</div>
          <div ng-if="$ctrl.payrollId && $ctrl.payrollId != $ctrl.worktimeApi.detailsPayrollId">
            <span class="text-danger" sxy-text="SALAXY.NG1.ImportStagingComponent.details.notTheSameAsSelectedPayroll"></span>
            <a href="" ng-click="$ctrl.worktimeApi.detailsPayrollId = $ctrl.payrollId" sxy-text="SALAXY.UI_Terms.back"></a>
          </div>
        </td>
        <td width="30%" rowspan="2">
          <salaxy-input-typeahead options="$ctrl.worktimeApi.payrolls" name="payrollId" label-type="plain"
            placeholder="{{ 'SALAXY.NG1.ImportStagingComponent.toolbar.selectPayroll' | sxyTranslate }}" ng-model="$ctrl.worktimeApi.detailsPayrollId"></salaxy-input-typeahead>
          <div class="text-danger" ng-if="$ctrl.worktimeApi.rowsOutsidePayrollCount">
            <small>
              {{"SALAXY.NG1.ImportStagingComponent.details.rowsOutsidePayrollCountLeadText" | sxyTranslate}} {{ $ctrl.worktimeApi.rowsOutsidePayrollCount }} {{"SALAXY.NG1.ImportStagingComponent.details.rowsOutsidePayrollCountEndText" | sxyTranslate}}
              <a href="" ng-click="$ctrl.worktimeApi.detailsPayrollId = 'unknown'" sxy-text="SALAXY.UI_Terms.show"></a>
            </small>
          </div>
        </td>
      </tr>
      <tr>
        <td sxy-text="SALAXY.NG1.ImportStagingComponent.details.period"></td>
        <td>
          <div>{{ $ctrl.worktimeApi.detailsPayroll.ui | sxyDateRange }} / {{ $ctrl.worktimeApi.detailsPayroll.ui.date | sxyDate }}</div>
          <div>{{ $ctrl.worktimeApi.detailsPayroll.ui.calcCount }} {{"SALAXY.NG1.ImportStagingComponent.details.leftCalculations" | sxyTranslate}} / {{ $ctrl.worktimeApi.detailsPayroll.ui.rowCount }} {{"SALAXY.NG1.ImportStagingComponent.details.leftRows" | sxyTranslate}}</div>
        </td>
      </tr>
    </table>
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { 'value': 'rawrows', 'text': 'SALAXY.NG1.ImportStagingComponent.details.rawRows' },
        { 'value': 'processrows', 'text': 'SALAXY.NG1.ImportStagingComponent.details.editRows' },
        { 'value': 'manual', 'text': 'SALAXY.NG1.ImportStagingComponent.details.manualRows' },
        { 'value': 'reports', 'text': 'SALAXY.NG1.ImportStagingComponent.details.reports' },
        { 'value': 'preview', 'text': 'SALAXY.NG1.ImportStagingComponent.details.preview' },
        { 'value': 'salaryslips', 'text': 'SALAXY.NG1.ImportStagingComponent.details.salarySlips' },
        { 'value': 'debug', 'text': 'SALAXY.NG1.ImportStagingComponent.details.debug' }
      ]"
      tabs-id="importStagingDetails">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-importStagingDetails">
      <div class="tab-pane" id="rawrows-tab">
        <div ng-if="$ctrl.currentTab == 'rawrows'">
          <ng-include src="'salaxy-components/helpers/import/staging/ImportStaging_rawRows.html'"></ng-include>
        </div>
      </div>
      <div class="tab-pane" id="manual-tab">
        <div ng-if="$ctrl.currentTab == 'manual'">
          <salaxy-calc-rows-2019-editor ng-if="$ctrl.worktimeApi.current" rows="$ctrl.worktimeApi.editableRows" mode="edit"
          title="{{'SALAXY.NG1.ImportStagingComponent.details.manuallyEditableRows' | sxyTranslate}}"></salaxy-calc-rows-2019-editor>
          <button type="button" class="btn btn-primary" ng-click="$ctrl.saveManualRows()" sxy-text="SALAXY.UI_Terms.save"></button>
        </div>
      </div>
      <div class="tab-pane" id="preview-tab">
        <div ng-if="$ctrl.currentTab == 'preview'">
          <div ng-if="!$ctrl.worktimeApi.currentCalc">{{"SALAXY.NG1.ImportStagingComponent.details.noPreviewCalc" | sxyTranslate}}</div>
          <div ng-if="$ctrl.worktimeApi.currentCalc">
            <div class="alert alert-warning">
              {{"SALAXY.NG1.ImportStagingComponent.details.previewWarning" | sxyTranslate}}
              {{"SALAXY.NG1.ImportStagingComponent.details.previewWarning2" | sxyTranslate}}
            </div>
            <salaxy-tab-buttons
              current-tab="$ctrl.currentSubTab"
              options="[
                { 'value': 'rows', 'text': 'SALAXY.NG1.ImportStagingComponent.details.rows' },
                { 'value': 'calculator', 'text': 'SALAXY.NG1.ImportStagingComponent.details.calculator' }
              ]"
              tabs-id="importStagingDetailsPreview">
            </salaxy-tab-buttons>
            <div class="tab-content" id="tab-content-importStagingDetailsPreview">
              <div class="tab-pane" id="rows-tab">
                <div ng-if="$ctrl.currentSubTab == 'rows'">
                  <salaxy-calc-rows-2019-editor parent="$ctrl.worktimeApi.currentCalc" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calcRowEditor.title' | sxyTranslate}}"
                    mode="edit" show-edit-buttons="false" show-gross-totals="true"></salaxy-calc-rows-2019-editor>
                </div>
              </div>
              <div class="tab-pane" id="calculator-tab">
                <div ng-if="$ctrl.currentSubTab == 'calculator'">
                  <salaxy-calc ng-if="$ctrl.worktimeApi.currentCalc" model="$ctrl.worktimeApi.currentCalc"></salaxy-calc>
                </div>
              </div>
            </div>
            <div ng-switch="$ctrl.previewView">
              <div ng-switch-when="rows">
                <salaxy-calc-rows-2019-editor parent="$ctrl.worktimeApi.currentCalc" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calcRowEditor.title' | sxyTranslate}}"
                mode="edit" show-edit-buttons="false" show-gross-totals="true"></salaxy-calc-rows-2019-editor>
              </div>
              <div ng-switch-when="calculator">
                <salaxy-calc ng-if="$ctrl.worktimeApi.currentCalc" model="$ctrl.worktimeApi.currentCalc"></salaxy-calc>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane" id="salaryslips-tab">
        <div ng-if="$ctrl.currentTab == 'salaryslips'">
          <ng-include src="'salaxy-components/helpers/import/staging/ImportStaging_salarySlipsList.html'"></ng-include>
        </div>
      </div>
      <div class="tab-pane" id="processrows-tab">
        <div ng-if="$ctrl.currentTab == 'processrows'">
          <ng-include src="'salaxy-components/helpers/import/staging/ImportStaging_processRows.html'"></ng-include>
        </div>
      </div>
      <div class="tab-pane" id="reports-tab">
        <div ng-if="$ctrl.currentTab == 'reports'">
          <div ng-if="!$ctrl.worktimeApi.currentCalc" sxy-text="SALAXY.NG1.ImportStagingComponent.details.noPreviewCalc"></div>
          <salaxy-calc-reports ng-if="$ctrl.worktimeApi.currentCalc" calcs="[$ctrl.worktimeApi.currentCalc]" preview="true" view="page1"
          report-type="'salarySlip'"></salaxy-calc-reports>
        </div>
      </div>
      <div class="tab-pane" id="debug-tab">
        <div ng-if="$ctrl.currentTab == 'debug' && $ctrl.worktimeApi.currentJson">
          <div class="toolbar">
            <button type="button" class="btn btn-default" ng-click="$ctrl.worktimeApi.saveJson()" sxy-text="SALAXY.UI_Terms.save"></button>
            <button type="button" class="btn btn-default" ng-click="$ctrl.deleteWorktime()" sxy-text="SALAXY.UI_Terms.delete"></button>
          </div>
          <div ng-if="$ctrl.worktimeApi.error">
            <h2 sxy-text="SALAXY.UI_Terms.error"></h2>
            <salaxy-json-formatter json="$ctrl.worktimeApi.error"></salaxy-json-formatter>
            <textarea style="width: 100%; height: 400px;">{{ $ctrl.worktimeApi.error | json }}</textarea>
            <button type="button" class="btn btn-default" ng-click="$ctrl.worktimeApi.error = ''" sxy-text="SALAXY.UI_Terms.clear"></button>
          </div>
          <sxy-code-editor ng-model="$ctrl.worktimeApi.currentJson" lang="json" height="calc(100vh - 372px)"></sxy-code-editor>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" ng-click="$ctrl.showDetails()" sxy-text="SALAXY.UI_Terms.close"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/import/staging/ImportStaging_list.html",`<div>
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th>
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.list.title"></div>
          <div sxy-text="SALAXY.NG1.ApiCrudObjectComponent.id"></div>
        </th>
        <th class="right">
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.list.grossSalary"></div>
        </th>
        <th class="right">
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.list.netSalary"></div>
        </th>
        <th class="right">
          <div sxy-text="SALAXY.UI_Terms.created"></div>
          <div sxy-text="SALAXY.UI_Terms.updated"></div>
        </th>
        <th class="right">
          <small>
            <div class="text-muted" sxy-text="SALAXY.NG1.ImportStagingComponent.status.preview"></div>
            <div class="text-primary" sxy-text="SALAXY.NG1.ImportStagingComponent.status.new"><b></b></div>
            <div class=""><s sxy-text="SALAXY.NG1.ImportStagingComponent.status.deleted"></s></div>
            <div class="text-danger" sxy-text="SALAXY.NG1.ImportStagingComponent.status.error"></div>
          </small>
        </th>
        <th class="right">
          <small>
            <div class="" sxy-text="SALAXY.NG1.ImportStagingComponent.list.total"></div>
            <div class="" sxy-text="SALAXY.NG1.ImportStagingComponent.status.committed"><b></b></div>
            <div class="text-muted" sxy-text="SALAXY.NG1.ImportStagingComponent.status.ignored"></div>
          </small>
        </th>
        <th class="right">
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.list.calcCount"></div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="emp in $ctrl.worktimeApi.getFilteredList($ctrl.payrollId)" class="clickable" ng-click="$ctrl.showDetails(emp.id)">
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="emp.avatar"></salaxy-avatar>
        </td>
        <td>
          <div><b>{{ emp.sortableName }}</b></div>
          <div>{{ emp.personalId }} ({{ "EmploymentRelationType." + emp.employmentType | sxyEnum }})</div>
          <div ng-if="emp.payrolls.unknown" class="text-danger"><small>Palkkalistojen ulkopuolella {{ emp.payrolls.unknown.rows.count }} riviä.</small></div>
        </td>
        <td class="right">
          <div>{{ $ctrl.getTotals(emp).calcs.gross | currency }}</div>
          <div><s>{{ $ctrl.getTotals(emp).committed.gross | currency }}</s></div>
        </td>
        <td class="right">
          <div>{{ $ctrl.getTotals(emp).calcs.net | currency }}</div>
          <div><s>{{ $ctrl.getTotals(emp).committed.net | currency }}</s></div>
        </td>
        <td class="right">
          <div>{{ emp.createdAt | sxyTime }}</div>
          <div>{{ emp.updatedAt | sxyTime }}</div>
        </td>
        <td class="right">
          <small>
            <div class="text-muted">{{ $ctrl.getTotals(emp).rows.preview }}</div>
            <div ng-if="$ctrl.getTotals(emp).rows.new" class="bg-primary badge">&nbsp;&nbsp;<b>{{ $ctrl.getTotals(emp).rows.new }}</b>&nbsp;</div>
            <div ng-if="!$ctrl.getTotals(emp).rows.new" class="text-primary"><b>0</b></div>
            <div class=""><s>{{ $ctrl.getTotals(emp).rows.deleted || "&nbsp;" }}</s></div>
            <div ng-if="$ctrl.getTotals(emp).rows.error" class="bg-danger badge">&nbsp;&nbsp;<b>{{ $ctrl.getTotals(emp).rows.error }}</b>&nbsp;</div>
            <div ng-if="!$ctrl.getTotals(emp).rows.error" class="text-danger"><b>0</b></div>
          </small>
        </td>
        <td class="right">
          <small>
            <div class="">{{ $ctrl.getTotals(emp).rows.count }}</div>
            <div class=""><b>{{ $ctrl.getTotals(emp).rows.committed }}</b></div>
            <div class="text-muted">{{ $ctrl.getTotals(emp).rows.ignored }}</div>
          </small>
        </td>
        <td class="right">
          <div>{{ $ctrl.getTotals(emp).calcs.count }}</div>
        </td>
      </tr>
    </tbody>
  </table>
</div>`);

 $templateCache.put("salaxy-components/helpers/import/staging/ImportStaging_overview.html",`<div>
  <div ng-if="$ctrl.serverUrl">
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { 'value': 'default', 'text': 'Overview' },
        { 'value': 'tests', 'text': 'Tests' }
      ]"
      tabs-id="importStagingOverview">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-importStagingOverview">
      <div class="tab-pane" id="default-tab">
        <div ng-if="$ctrl.currentTab == 'default'">
          <div>Current staging server: <a ng-href="{{ $ctrl.serverUrl }}" target="_blank">{{ $ctrl.serverUrl }}</a></div>
        </div>
      </div>
      <div class="tab-pane" id="tests-tab">
        <div ng-if="$ctrl.currentTab == 'tests'">
          <fieldset>
            <legend>Upload test data</legend>
            <p class="lead">
              Upload a test file to the staging server.
              The file should be a JSON file with employment relations or rows: The same structure that an integration sends.
            </p>
            <div class="row">
              <div class="col-md-6">
                <form ng-submit="$ctrl.uploadTestFile($event)">
                  <input type="file" class="form-control" />
                  <button type="submit" class="btn btn-primary">Process uploaded file</button>
                <button type="submit" class="btn btn-default" ng-click="$ctrl.uploadTestFile('clipboard')">Process from clipboard</button>
                </form>
              </div>
              <div class="col-md-6">
                <p>Get demo files:</p>
                <ul>
                  <li>Rows: check the personal ID before processing</li>
                  <ul>
                    <li><a ng-href="{{ $ctrl.serverUrl + '/test-data/rows_2023-09-01_2023-12-22.json' }}" target="_blank">2023-09-01 - 2023-12-22</a></li>
                    <li><a ng-href="{{ $ctrl.serverUrl + '/test-data/rows_2023-11-01_2023-11-30.json' }}" target="_blank">2023-11-01 - 2023-11-30</a></li>
                  </ul>
                  <li><a ng-href="{{ $ctrl.serverUrl + '/test-data/employment-190372-942M.json' }}" target="_blank">Employment, Pauliina Palkkanen, 190372-942M</a>.</li>
                </ul>
              </div>
            </div>
            <salaxy-json-formatter json="$ctrl.uploadResults" key="'result'" open="0"></salaxy-json-formatter>
          </fieldset>
          <fieldset>
            <legend>Create a Payroll / Nepton Payment Period</legend>
            <div class="btn-toolbar">
              <div class="btn-goup">
                <p>TODO: Add possibility for setting the values and creating the Payroll</p>
                <button type="button" class="btn btn-default" ng-click="$ctrl.runTest('createUpdatePaymentPeriod')">Demo button (fixed ID)</button>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
  <div ng-if="!$ctrl.serverUrl" class="container">
    <div class="alert alert-info">
      Integrations has not been set up for this environment.
      Please specify the integration server in the settings (PRO settings => other)
      or contact customer services.
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/import/staging/ImportStaging_processRows.html",`<div class="btn-toolbar">
  <div class="btn-group">
    <button type="button" class="btn btn-default" ng-repeat="group in $ctrl.statusGroups" ng-click="$ctrl.statusGroup = group" ng-disabled="group.active">{{ group.text |
      sxyTranslate }}</button>
  </div>
  <div class="btn-group">
    <button id="single-button" type="button" class="btn dropdown-toggle" ng-class="$ctrl.$ctrlRows.getSelectedRows().length ? 'btn-primary' : 'btn-default'" data-bs-toggle="dropdown" aria-expanded="false">
      {{'SALAXY.UI_Terms.selected' | sxyTranslate}} ({{ $ctrl.$ctrlRows.getSelectedRows().length }})
    </button>
    <ul class="dropdown-menu" aria-labelledby="single-button">
      <li><a class="dropdown-item" href="" ng-click="$ctrl.$ctrlRows.toggleSelectedRow('all', true)">{{'SALAXY.UI_Terms.selectAll' | sxyTranslate}}</a></li>
      <li><a class="dropdown-item" href="" ng-click="$ctrl.$ctrlRows.toggleSelectedRow('all', false)">{{'SALAXY.UI_Terms.removeSelections' | sxyTranslate}}</a></li>
    </ul>
  </div>
</div>
<div class="btn-toolbar">
  <div class="btn-group">
    <div style="width: 240px; vertical-align: middle;float: left;">
      <salaxy-input-typeahead options="$ctrl.worktimeApi.payrolls" name="payrollId" label-type="plain"
        placeholder="{{ 'SALAXY.NG1.ImportStagingComponent.toolbar.selectPayroll' | sxyTranslate }}" ng-model="$ctrl.payrollMoveTarget"></salaxy-input-typeahead>
    </div>
    <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.$ctrlRows.getSelectedRows().length || !$ctrl.payrollMoveTarget"
      ng-click="$ctrl.moveToPayroll($ctrl.$ctrlRows.getSelectedRows(), $ctrl.payrollMoveTarget)" sxy-text="SALAXY.NG1.ImportStagingComponent.toolbar.moveToPayroll"></button>
    <button type="button" class="btn btn-default" ng-disabled="!$ctrl.payrollMoveTarget"
      ng-click="$ctrl.$ctrlRows.toggleSelectedRow('all', true);$ctrl.moveToPayroll($ctrl.$ctrlRows.getSelectedRows(), $ctrl.payrollMoveTarget)" sxy-text="SALAXY.NG1.ImportStagingComponent.toolbar.selectAndMove"></button>
  </div>
  <button type="button" class="btn btn-default" ng-disabled="!$ctrl.$ctrlRows.getSelectedRows().length" ng-click="$ctrl.deleteRows($ctrl.$ctrlRows.getSelectedRows())" sxy-text="SALAXY.NG1.ImportStagingComponent.toolbar.deleteFromData"></button>
  <div class="btn-group">
    <div style="vertical-align: middle;float: left;line-height: 26px; padding: 4px" sxy-text="SALAXY.NG1.ImportStagingComponent.toolbar.moveToStatus"></div>
    <button type="button" class="btn btn-default" ng-disabled="!$ctrl.$ctrlRows.getSelectedRows().length" ng-click="$ctrl.setStatus($ctrl.$ctrlRows.getSelectedRows(), 'ignored')"
      sxy-text="SALAXY.NG1.ImportStagingComponent.status.ignored"></button>
    <button type="button" class="btn btn-default" ng-disabled="!$ctrl.$ctrlRows.getSelectedRows().length" ng-click="$ctrl.setStatus($ctrl.$ctrlRows.getSelectedRows(), 'new')"
      sxy-text="SALAXY.NG1.ImportStagingComponent.statusGroup.todo"></button>
  </div>
</div>
<salaxy-calc-rows-editor ng-if="$ctrl.worktimeApi.current" type="worktime-import-employment" rows="$ctrl.worktimeApi.filteredRows" title="{{'SALAXY.NG1.ImportStagingComponent.toolbar.rowsInImport' | sxyTranslate}}" ng-ref="$ctrl.$ctrlRows"
  mode="read-only" statuses="$ctrl.statusGroup.statuses" show-row-selection="true"></salaxy-calc-rows-editor>`);

 $templateCache.put("salaxy-components/helpers/import/staging/ImportStaging_rawRows.html",`<div class="btn-toolbar">
  <div class="btn-group">
    <button type="button" class="btn btn-default" ng-repeat="group in $ctrl.statusGroups" ng-click="$ctrl.statusGroup = group"
      ng-disabled="group.active">{{ group.text | sxyTranslate }} <div class="badge">{{ group.count ? group.count : '' }}</div></button>
  </div>
  <button type="button" class="btn btn-default" ng-click="$ctrl.recalculateWorktime()" sxy-text="SALAXY.NG1.ImportStagingComponent.details.recalculate"></button>
  <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.worktimeApi.detailsPayrollId" ng-click="$ctrl.commitPayroll('employment')"
    sxy-text="SALAXY.NG1.ImportStagingComponent.details.commitPayroll"></button>
</div>
<salaxy-calc-rows-editor ng-if="$ctrl.worktimeApi.current" type="worktime-import-employment"
  rows="$ctrl.worktimeApi.filteredRows" title="Rivit importissa" ng-ref="$ctrl.$ctrlRows"
  mode="read-only" statuses="$ctrl.statusGroup.statuses"></salaxy-calc-rows-editor>`);

 $templateCache.put("salaxy-components/helpers/import/staging/ImportStaging_salarySlipsList.html",`<div ng-if="!$ctrl.currentEmploymentPdf">
  <div class="btn-toolbar">
    <div class="btn-group">
      <button type="button" class="btn btn-default" ng-click="$ctrl.salarySlipListType = 'all'" ng-disabled="$ctrl.salarySlipListType == 'all'" sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.type.all"></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.salarySlipListType = 'preview'" ng-disabled="$ctrl.salarySlipListType == 'preview'" sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.type.preview"></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.salarySlipListType = 'committed'" ng-disabled="$ctrl.salarySlipListType == 'committed'" sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.type.committed"></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.salarySlipListType = 'distinct'" ng-disabled="$ctrl.salarySlipListType == 'distinct'" sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.type.distinct"></button>
    </div>
  </div>
  <table class="table table-condenced">
    <thead>
      <tr>
        <th>
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.status"></div>
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.id"></div>
        </th>
        <th class="right" style="font-size: 0.75em;">
          <div sxy-text="SALAXY.ENUM.CalcGroup.baseSalary.label"></div>
          <div sxy-text="SALAXY.ENUM.CalcGroup.salaryAdditions.label"></div>
          <div sxy-text="SALAXY.ENUM.CalcGroup.benefits.label"></div>
          <div sxy-text="SALAXY.ENUM.CalcGroup.deductions.label"></div>
          <div sxy-text="SALAXY.ENUM.CalcGroup.expenses.label"></div> 
        </th>
        <th class="right">
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.grossSalary"></div>
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.netSalary"></div>
        </th>
        <th class="right">
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.salaryDate"></div>
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.period"></div>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="calc in $ctrl.currentEmploymentCalcs">
        <td>
          <div>
            {{ "CalculationStatus." + calc.status | sxyEnum }}
            <span ng-if="calc.status == 'payrollDraft'"><a ng-href="{{ '#/payroll/details/' + calc.data.payrollId }}" sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.payrollLink"></a></span>
            <!-- TODO: Add links when paid etc. -->
          </div>
          <div class="small truncate" style="max-width: 256px;"><code>{{ calc.id }}</code></div>
        </td>
        <td class="right" style="font-size: 0.75em;">
          <div>{{ calc.data.salary | currency }}</div>
          <div>{{ calc.data.allowances | currency }}</div>
          <div>{{ calc.data.benefits | currency }}</div>
          <div>{{ calc.data.deductions | currency }}</div>
          <div>{{ calc.data.expenses | currency }}</div>
        </td>
        <td class="right">
          <div>{{ calc.grossSalary | currency }}</div>
          <div>{{ calc.data.workerPayment | currency }}</div>
        </td>
        <td class="right">
          <div>{{ calc.salaryDate | sxyDate }}</div>
          <div>{{ calc.data | sxyDateRange }}</div>
        </td>
        <td class="right">
          <button class="btn btn-primary" ng-click="$ctrl.showReportDialog(calc.id)"><i class="bi bi-search"></i> <span sxy-text="SALAXY.UI_Terms.show"></span></button>
          <button class="btn btn-default" ng-click="$ctrl.showSalarySlipPdf(calc.id)"><i class="bi bi-file-earmark-pdf"></i> <span sxy-text="SALAXY.UI_Terms.downloadPdf"></span></button>
          <button class="btn btn-default" sxy-if-role="test" ng-click="$ctrl.showSalarySlipHtml(calc.id)">TEST: html</span></button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div ng-if="$ctrl.currentEmploymentPdf">
  <div class="btn-toolbar">
    <button class="btn btn-default pull-right" ng-click="$ctrl.showSalarySlipPdf(undefined)"><i class="bi bi-x-lg"></i> <span sxy-text="SALAXY.UI_Terms.close"></span></button>
  </div>
  <salaxy-spinner ng-if="$ctrl.currentEmploymentPdf == 'loading'"></salaxy-spinner>
  <iframe ng-if="$ctrl.currentEmploymentPdf != 'loading'" style="width:100%;height:200vh" ng-src="{{ $ctrl.currentEmploymentPdf }}"></iframe>
</div>`);

 $templateCache.put("salaxy-components/helpers/import/staging/ImportStaging_test_data.html",`<div sxy-if-role="test">
  <p>&nbsp;</p>
  <hr />
  <button type="button" class="btn btn-default" ng-click="$ctrl.showDebug = !$ctrl.showDebug">TEST ONLY: show/hide debug upload</button>
  <div style="max-width: 800px;">
    <fieldset ng-if="$ctrl.showDebug">
      <legend>Upload test data</legend>
      <p class="lead">
        Upload a test file to the staging server.
        The file should be a JSON file with employment relations or rows: The same structure that an integration sends.
      </p>
      <div class="row">
        <div class="col-md-6">
          <form ng-submit="$ctrl.uploadTestFile($event)">
            <input type="file" class="form-control" />
            <button type="submit" class="btn btn-primary">Process uploaded file</button>
            <button type="submit" class="btn btn-default" ng-click="$ctrl.uploadTestFile('clipboard')">Process from clipboard</button>
          </form>
        </div>
        <div class="col-md-6">
          <p>Get demo files:</p>
          <ul>
            <li>Rows: check the personal ID before processing</li>
            <ul>
              <li><a ng-href="{{ $ctrl.serverUrl + '/test-data/rows_2023-09-01_2023-12-22.json' }}" target="_blank">2023-09-01 - 2023-12-22</a></li>
              <li><a ng-href="{{ $ctrl.serverUrl + '/test-data/rows_2023-11-01_2023-11-30.json' }}" target="_blank">2023-11-01 - 2023-11-30</a></li>
            </ul>
            <li><a ng-href="{{ $ctrl.serverUrl + '/test-data/employment-190372-942M.json' }}" target="_blank">Employment, Pauliina Palkkanen, 190372-942M</a>.</li>
          </ul>
        </div>
      </div>
      <salaxy-json-formatter json="$ctrl.uploadResults" key="'result'" open="0"></salaxy-json-formatter>
    </fieldset>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/import/WorktimeImport.html",`<div class="salaxy-component salaxy-worktime-import">
  <h1 sxy-text="SALAXY.NG1_Sitemap.pro-service.worktime-imports.details"></h1>
  <div ng-if="$ctrl.current">
    <div class="btn-toolbar" role="toolbar">
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-default" ng-click="$ctrl.process('parse')">Parse</button>
        <button type="button" class="btn btn-default" ng-click="$ctrl.process('validate')">Validate</button>
        <button type="button" class="btn btn-default" ng-click="$ctrl.process('preview')">Preview</button>
        <button type="button" class="btn btn-default" ng-click="$ctrl.process('previewWithEmployments')">Preview (commit employments)</button>
        <button type="button" class="btn btn-default" ng-click="$ctrl.process('import')">Import</button>
      </div>
      <button type="button" class="btn btn-default" ng-click="$ctrl.save()">Save</button>
      <a href="#/worktime-imports" class="btn btn-default">Back to list</a>
    </div>
    <sxy-form ng-ref="$frm" open-api="http://localhost:82/schemas/v02.json" xx-open-api="salaxy-secure/schemas/v02.json" type="WorktimeImport" model="$ctrl.current">
      <div>
        <salaxy-tab-buttons
          current-tab="$ctrl.currentTab"
          options="[
            { value: 'default', text: 'Perustiedot' },
            { value: 'files', text: 'Tiedostot' },
            { value: 'employmentrelations', text: 'Employment relations' },
            { value: 'salaryrows', text: 'Salary rows' },
            { value: 'previewemployment', text: 'Preview: Employment' },
            { value: 'preview', text: 'Preview' },
            { value: 'debug', text: 'Debugger' }
          ]"
          tabs-id="worktimeImport">
        </salaxy-tab-buttons>
        <div class="tab-content" id="tab-content-worktimeImport">
          <div class="tab-pane" id="default-tab">
            <div class="row">
              <div class="col-sm-6">
                <fieldset>
                  <legend>Basic data</legend>
                  <sxy-input model="form.id"></sxy-input>
                  <sxy-input model="form.createdAt"></sxy-input>
                  <sxy-input model="form.updatedAt"></sxy-input>
                  <sxy-input model="form.header.status"></sxy-input>
                </fieldset>
              </div>
              <div class="col-sm-6">
                <fieldset>
                  <legend>Control data</legend>
                  <sxy-input model="form.header.payrollId" label="Palkkalistan ID"></sxy-input>
                  <sxy-input model="form.header.sourceId" label="ID (lähde)"></sxy-input>
                  <sxy-input model="form.header.salaryDate" format="date" label="Palkkapäivä"></sxy-input>
                  <sxy-input model="form.header.period" label="Palkkakausi"></sxy-input>
                </fieldset>
              </div>
            </div>
            <div class="tab-pane" id="files-tab"></div>
            <table class="table">
              <thead>
                <tr>
                  <th>
                    File<br />
                    File type (mime type)
                  </th>
                  <th>Data</th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="file in $ctrl.current.files">
                  <td style="width: 50%;">
                    <salaxy-input name="fileName" ng-model="file.name" label-type="plain"></salaxy-input>
                    <salaxy-input name="fileMimeType" ng-model="file.mimeType" label-type="plain"></salaxy-input>
                    <salaxy-input name="fileUsecaseUri" label="Usecase" ng-model="file.usecase.uri"></salaxy-input>
                  </td>
                  <td style="width: 50%;">
                    <salaxy-textarea name="fileData" ng-model="file.data" rows="5" label-type="plain"></salaxy-textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab-pane" id="employmentrelations-tab">
            <sxy-table ng-if="!$ctrl.isLoading" doc="http://localhost:82/schemas/v02.json" schema="WorktimeImportEmployment"
            data="$ctrl.current.employments" include="$ctrl.employmentsCols"></sxy-table>
          </div>
          <div class="tab-pane" id="salaryrows-tab">
            <salaxy-calc-rows-editor ng-if="!$ctrl.isLoading" rows="$ctrl.current.rows" title="Import rows" type="worktime-import"></salaxy-calc-rows-editor>
          </div>
          <div class="tab-pane" id="previewemployment-tab">
            TODO: Employment preview UI here
          </div>
          <div class="tab-pane" id="preview-tab">
            TODO: Calc preview (also absences & holidays?)
          </div>
          <div class="tab-pane" id="debug-tab">
            <salaxy-json-formatter json="$ctrl.current"></salaxy-json-formatter>
          </div>
        </div>
      </div>
    </sxy-form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/JsonDiff.html",`<div class="salaxy-component salaxy-json-diff-table">
  <div ng-if="$ctrl.isLoading" class="text-center p-3 text-muted">
    <p>Loading schema...</p>
  </div>
  <div ng-if="!$ctrl.isLoading && $ctrl.tableConfig.data.length === 0" class="text-center p-3 text-muted">
    <p>No differences found between the objects.</p>
  </div>
  <div ng-show="!$ctrl.isLoading && $ctrl.tableConfig.data.length > 0">
    <sxy-table ng-ref="$ctrl.$sxyTable" options="$ctrl.tableConfig.options" include="$ctrl.tableConfig.include" data="$ctrl.tableConfig.data"></sxy-table>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/JsonFormatter.html",`<button ng-class="$ctrl.btnClass ? $ctrl.btnClass : 'btn btn-default btn-xs'" ng-if="$ctrl.type == 'dialog'" ng-click="$ctrl.showDialog()">
  <span ng-if="$ctrl.hasKey"><span class="key-text">{{ $ctrl.key }}</span></span>
  <span ng-if="!$ctrl.hasKey && $ctrl.isArray()"><span class="bracket">[</span><span class="number">{{$ctrl.json.length}}</span><span class="bracket">]</span></span>
  <span ng-if="!$ctrl.hasKey && !$ctrl.isArray()"><span class="bracket">{</span><span class="number">{{$ctrl.getKeys().length}}</span><span class="bracket">}</span></span>
</button>
<div class="json-formatter-row" ng-if="$ctrl.type != 'dialog'">
  <a ng-click="$ctrl.toggleOpen()">
    <span class="toggler {{ $ctrl.isOpen ? 'open' : ''}}" ng-if="$ctrl.isObject()"></span>
    <span class="key {{$ctrl.changes.type}}" ng-if="$ctrl.hasKey"><span class="key-text">{{ $ctrl.key }}</span><span ng-if="$ctrl.changes"> ({{ $ctrl.changes.icon }})</span><span class="colon">:</span></span>
    <span class="value">
      <span ng-if="$ctrl.isObject()">
        <span ng-if="$ctrl.isArray()"><span class="bracket">[</span><span class="number">{{$ctrl.json.length}}</span><span class="bracket">]</span></span>
        <span ng-if="!$ctrl.isArray()"><span class="bracket">{</span><span class="number">{{$ctrl.getKeys().length}}</span><span class="bracket">}</span></span>
      </span>
      <span ng-if="!$ctrl.isObject()" ng-click="$ctrl.openLink($ctrl.isUrl)" class="{{ $ctrl.jsonType }}"
        ng-class="{ date: $ctrl.isDate, url: $ctrl.isUrl }">{{$ctrl.parseValue($ctrl.json)}}<del
        ng-if="$ctrl.changes">{{$ctrl.changes.oldValue}}</del></span>
    </span>
    <span ng-if="$ctrl.showThumbnail()" class="thumbnail-text">{{$ctrl.getThumbnail()}}</span>
  </a>
  <div class="children" ng-if="$ctrl.getKeys().length && $ctrl.isOpen">
    <salaxy-json-formatter ng-repeat="key in $ctrl.getKeys() track by $index" key="key" open="$ctrl.childrenOpen()"
      json="$ctrl.json[key]" compare="$ctrl.compare" compare-to="$ctrl.compareTo[key]"></salaxy-json-formatter>
    <salaxy-json-formatter ng-repeat="key in $ctrl.deletedKeys track by $index" key="key" open="$ctrl.childrenOpen()"
      json="$ctrl.json[key]" compare="$ctrl.compare" compare-to="$ctrl.compareTo[key]"></salaxy-json-formatter>
  </div>
  <div class="children empty object" ng-if="$ctrl.isEmptyObject()"></div>
  <div class="children empty array" ng-if="$ctrl.getKeys() && !$ctrl.getKeys().length && $ctrl.isOpen && $ctrl.isArray()"></div>
</div>`);

 $templateCache.put("salaxy-components/helpers/JsonFormatterDialog.html",`<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{ $ctrl.logic.title }}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <salaxy-json-formatter json="$ctrl.current" type="{{ $ctrl.logic.type }}" open="$ctrl.logic.open" compare="$ctrl.logic.compare" compare-to="$ctrl.logic.compareTo" key="$ctrl.logic.key"></salaxy-json-formatter>
    <div class="text-end">
      <button type="reset" class="btn btn-primary" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/NaviSitemap.html",`
<div class="salaxy-component salaxy-navi-sitemap" ng-if="$ctrl.mode != 'horizontal'">

  <ul class="list-group" ng-class="{'salaxy-navi-3-level': $ctrl.mode == '3-level'}">
    <li ng-repeat="section in $ctrl.filterHidden($ctrl.sitemap)" class="list-group-item">
      <a ng-href="{{section.url}}" ng-click="!$ctrl.hasChildren(section) ? $ctrl.toggleNavi() : return" ng-class="{ 'active' : $ctrl.isCurrent(section)}">
        <span ng-if="$ctrl.mode != 'default' && $ctrl.hasChildren(section)">
          <i aria-hidden="true" class="bi float-end" ng-class="$ctrl.isCurrent(section) ? 'bi-chevron-up' : 'bi-chevron-down' "></i>
        </span> {{section.title | sxyTranslate}} <span ng-if="$ctrl.isTest(section)" class="badge bg-primary float-end"><span class="small">test</span></span>
      </a>
      <ul ng-if="$ctrl.hasChildren(section) && ($ctrl.mode == 'default' || $ctrl.isCurrent(section))">
        <li ng-repeat="subNavi in $ctrl.filterHidden(section.children)">
          <a ng-href="{{ $ctrl.getUrl(subNavi) }}" ng-click="$ctrl.toggleNavi()" ng-class="{ 'active' : $ctrl.isCurrent(subNavi)}">{{subNavi.title | sxyTranslate}} <span ng-if="$ctrl.isTest(subNavi)" class="badge bg-primary"><span class="small">test</span></span></a>

          <ul ng-if="$ctrl.mode == '3-level' && $ctrl.isCurrent(subNavi) && $ctrl.hasChildren(subNavi)">
            <li ng-repeat="naviLevel3 in $ctrl.filterHidden(subNavi.children)">
              <a ng-href="{{ $ctrl.getUrl(naviLevel3) }}" ng-click="$ctrl.toggleNavi()" ng-class="{'active' : $ctrl.isCurrent(naviLevel3)}">{{naviLevel3.title | sxyTranslate}} <span ng-if="$ctrl.isTest(naviLevel3)" class="badge bg-primary"><span class="small">test</span></span></a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
  <div class="poweredby">
    <span class="poweredby-image"></span>
  </div>
</div>

<div class="salaxy-component salaxy-navi-sitemap" ng-if="$ctrl.mode == 'horizontal'">
  <header class="salaxy-navi-header-horizontal">
    <div class="container-fluid">
      <div class="d-md-none align-items-center d-flex">
        <span class="page-title-sm">
          <span class="uppercase"><strong>{{ $ctrl.currentPath[0].title | sxyTranslate }}</strong></span>
          <span class="small" ng-if="$ctrl.hasChildren($ctrl.currentPath[0])">/ {{$ctrl.current.title | sxyTranslate}}</span>
        </span>
        <button type="button" class="navbar-toggle btn btn-lg ms-auto" data-bs-toggle="collapse" data-bs-target="#navbar-content">
          <i class="bi bi-list" aria-hidden="true"></i>
        </button>
      </div>
      <nav class="navbar navbar-expand-md">
        <div class="collapse navbar-collapse" id="navbar-content">
          <ul class="navbar-nav">
            <li ng-repeat="section in $ctrl.filterHidden($ctrl.sitemap)" class="nav-item dropdown" ng-class="{ 'active' : $ctrl.isCurrentSection(section)}">
              <a ng-if="!$ctrl.hasChildren(section)" ng-href="{{section.url}}" class="nav-link">{{section.title | sxyTranslate}}</a>
              <a ng-if="$ctrl.hasChildren(section)" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">{{section.title | sxyTranslate}}</a>
              <ul ng-if="$ctrl.hasChildren(section)" class="dropdown-menu">
                <li ng-repeat="subNavi in $ctrl.filterHidden(section.children)">
                  <a ng-href="{{ $ctrl.getUrl(subNavi) }}" ng-click="$ctrl.toggleNavi()" class="dropdown-item" ng-class="{'active' : $ctrl.isCurrent(subNavi)}">
                    {{subNavi.title | sxyTranslate}} 
                    <span ng-if="$ctrl.isTest(subNavi)" class="badge bg-info"><span class="small">test</span></span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
  <div class="d-none d-sm-block breadcrumb-container mt-2 ps-5 mb-4">
    <span class="text-primary"><span class="text-uppercase"><strong>{{ $ctrl.currentPath[0].title | sxyTranslate }}</strong></span> <span class="small" ng-if="$ctrl.hasChildren($ctrl.currentPath[0])">/ {{$ctrl.current.title | sxyTranslate}}</span></span>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/NaviStarterLayout.html",`<salaxy-spinner ng-if="$ctrl.showFullPageLoader" full-screen="true" heading="SALAXY.UI_Terms.loading"></salaxy-spinner>
<div ng-if="!$ctrl.showFullPageLoader && (!$ctrl.layout || $ctrl.layout == 'default')" ng-cloak class="salaxy-component salaxy-navi-page-container" ng-class="{ 'salaxy-navi-sm-opened': $ctrl.isNaviOpen }">

  <ng-transclude ng-transclude-slot="nav">
    <nav class="salaxy-navi-sidebar d-print-none">
      <div class="salaxy-logo-container">
        <a href="/#/"></a>
      </div>
      <div class="d-block d-md-none mobile-login-container text-center">
        <salaxy-login-button></salaxy-login-button>
      </div>
      <salaxy-navi-sitemap mode="accordion"></salaxy-navi-sitemap>
    </nav>
  </ng-transclude>
  <header class="salaxy-navi-header-mobile d-block d-md-none" style="width: 100vw;">
    <button type="button" class="salaxy-navi-hamburger d-print-none btn btn-default float-end" ng-click="$ctrl.toggleNavi()">
      <span class="sr-only" sxy-text="SALAXY.UI_Terms.navigation"></span>
      <i class="bi bi-list m-0" aria-hidden="true"></i>
    </button>
    <h1>{{ $ctrl.title | sxyTranslate }}</h1>
  </header>
  <div class="salaxy-navi-main-container">
    <content>
      <ng-transclude ng-transclude-slot="header">
        <header class="salaxy-navi-header-default d-none d-md-block">
          <div ng-class="$ctrl.current.isFullWidth ? 'container-fluid' : 'container-md'" class="h-100">
            <div class="d-flex justify-content-between align-items-center h-100">
              <h1 class="page-title m-0">
                {{ $ctrl.title | sxyTranslate }}
              </h1>
              <div class="d-print-none">
                <salaxy-login-button class='float-end'></salaxy-login-button>
              </div>
            </div>
          </div>
        </header>
      </ng-transclude>
      <div id="salaxy-alert-container"></div>
      <ng-transclude ng-transclude-slot="main">
        <main class="pt-3">
          <div ng-class="$ctrl.current.isFullWidth ? 'container-fluid' : 'container-md'" ng-if="!$ctrl.getDisabled()" ng-view autoscroll="true"></div>
          <div class="container" ng-if="$ctrl.getDisabled()">
            <div class="alert alert-info" sxy-text="SALAXY.UI_Terms.pageDisabledAlert"></div>
          </div>
        </main>
      </ng-transclude>
    </content>
  </div>
</div>

<div ng-if="!$ctrl.showFullPageLoader && $ctrl.layout == 'iframe'" ng-cloak class="salaxy-component salaxy-navi-page-container iframe-container">
  <div class="salaxy-navi-main-container">
    <content>
      <ng-transclude ng-transclude-slot="header" ng-if="$ctrl.mode != 'horizontal'">

        <header class="salaxy-navi-header-default">
          <div class="container-fluid">
            <div class="d-flex align-items-center">
              <h1 class="page-title">
                {{ $ctrl.title | sxyTranslate }}
              </h1>
              <div class="ms-auto" ng-if="$ctrl.hasChildren($ctrl.currentPath[0])" style="margin-left:10px;">
                <div class="btn-group dropdown">
                  <button class="btn btn-default dropdown-toggle btn-submenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="d-none d-sm-inline-block">{{ ($ctrl.currentPath[0].subMenuTitle || 'SALAXY.UI_Terms.menu') | sxyTranslate }}</span>
                    <i class="bi bi-list d-inline-block d-sm-none" aria-hidden="true"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end" menu role="menu">
                    <li ng-repeat="subNavi in $ctrl.filterHidden($ctrl.currentPath[0].children)">
                      <a class="dropdown-item" ng-href="{{subNavi.url}}" class="dropdown-item">{{ subNavi.title | sxyTranslate }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </header>
      </ng-transclude>
      <ng-transclude ng-transclude-slot="nav" ng-if="$ctrl.mode == 'horizontal'">

        <salaxy-navi-sitemap mode="{{$ctrl.mode}}"></salaxy-navi-sitemap>
      </ng-transclude>


      <div id="salaxy-alert-container"></div>
      <ng-transclude ng-transclude-slot="main">
        <main salaxy-if-role="company">
          <div ng-class="$ctrl.current.isFullWidth ? 'container-fluid' : 'container-md'" ng-if="!$ctrl.getDisabled()" ng-view autoscroll="true"></div>
          <div class="container" ng-if="$ctrl.getDisabled()">
            <div class="alert alert-info" sxy-text="SALAXY.UI_Terms.pageDisabledAlert"></div>
          </div>
        </main>
        <main salaxy-if-role="!company">
          <div class="salaxy-navi-page-container salaxy-component salaxy-tpl-iframe-anon" style="padding-left: 0;">
            <div class="container" style="max-width: 600px; margin-top: 10vh;">
              <div class="alert alert-danger">
                <h2 sxy-text="SALAXY.UI_Terms.sessionExpired"></h2>
                <p class="lead text-muted" sxy-text="SALAXY.UI_Terms.sessionExpiredEmbedded"></p>
                <div sxy-if-role="person">
                  <p>&nbsp;</p>
                  <pre><small>ERROR: Authenticated as personal, not supported.</small></pre>
                </div>
                <div sxy-if-role="test">
                  
                  <small>Test only:</small> <salaxy-login-button></salaxy-login-button>
                </div>
              </div>
            </div>
          </div>
        </main>
      </ng-transclude>
    </content>
  </div>
</div>
<div ng-if="!$ctrl.showFullPageLoader && $ctrl.layout == 'pro-customer'" ng-cloak class="salaxy-component salaxy-navi-page-container iframe-container">
  <div class="salaxy-navi-main-container">
    <content>
      <ng-transclude ng-transclude-slot="header">
      </ng-transclude>
      <div id="salaxy-alert-container"></div>
      <ng-transclude ng-transclude-slot="main">
        <main class="pt-2">
          <div ng-class="$ctrl.current.isFullWidth ? 'container-fluid' : 'container-md'"  ng-if="!$ctrl.getDisabled()" ng-view autoscroll="true"></div>
          <div class="container-md" ng-if="$ctrl.getDisabled()">
            <div class="alert alert-info" sxy-text="SALAXY.UI_Terms.pageDisabledAlert"></div>
          </div>
        </main>
      </ng-transclude>
    </content>
  </div>
</div>
</div>
</main>
</ng-transclude>
</content>
</div>
</div>`);

 $templateCache.put("salaxy-components/helpers/Spinner.html",`<div ng-cloak ng-class="{'sxy-spinner-full-screen-container': $ctrl.fullScreen, 'salaxy-component': true, 'salaxy-spinner': true, }">
  <div class="sxy-spinner-container">
    <div class="sxy-spinner">
      <svg class="sxy-spinner-bg" viewBox="0 0 64 64"><circle cx="32" cy="32" r="26"></circle></svg>
      <svg class="sxy-spinner-spin" viewBox="0 0 64 64">
        <circle transform="translate(32,32)" r="26"></circle>
      </svg>
    </div>
    <h3 ng-if="$ctrl.heading" class="spinner-heading">{{$ctrl.getHeading()}}</h3>
    <p style="white-space: pre;" ng-if="$ctrl.text" class="spinner-text">{{$ctrl.text | sxyTranslate}}</p>
  </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/Tab.html",`<div class="tabpane" ng-class="{ active: $ctrl.selected}" ng-show="$ctrl.selected" ng-transclude="content"></div>
<div ng-transclude="heading"></div>
`);

 $templateCache.put("salaxy-components/helpers/TabButtons.html",`<div class="tabs-buttons" id="tabs-buttons-{{$ctrl.tabsId}}">
  <ul class="nav nav-tabs">
    <li class="nav-item" ng-repeat="tab in $ctrl.options" ng-if="!tab.hidden">
      <button
        class="nav-link"
        id="{{ tab.value }}-tab-button"
        ng-disabled="tab.disabled"
        type="button"
        ng-click="$ctrl.showTab(tab.value)"
        ng-class="{ active: $ctrl.currentTab === tab.value }">
        {{ $ctrl.getTabText(tab.text) }}
      </button>
    </li>
  </ul>
</div>`);

 $templateCache.put("salaxy-components/helpers/Tabs.html",`<div>
    <ul class="nav nav-tabs">
        <li ng-repeat="tab in $ctrl.tabs" ng-class="{ active: tab.selected, disabled: tab.disable}" class="nav-item">
            <a href class="nav-link" ng-click="$ctrl.select(tab, $event)" salaxy-append-node="tab.headingElement">{{tab.heading}}</a>
        </li>
    </ul>
    <div class="tab-content">
        <ng-transclude></ng-transclude>
    </div>
</div>`);

 $templateCache.put("salaxy-components/helpers/UiTranslator.html",`<div class="salaxy-component salaxy-ui-translator">
  <salaxy-spinner ng-if="$ctrl.isLoading" heading="SALAXY.UI_Terms.loading" text="SALAXY.UI_Terms.pleaseWait"></salaxy-spinner>
  <div ng-if="!$ctrl.isLoading && $ctrl.allKeyValues.length &lt; 1" class="alert alert-danger">
    No rows for filter: {{$ctrl.filter}}
  </div>
  <div ng-if="$ctrl.allKeyValues.length > 0">
    <div ng-if="$ctrl.mode == 'fieldset'">
      <fieldset class="form-horizontal" ng-repeat="row in $ctrl.allKeyValues | limitTo: 10">
        <legend>
          <button ng-if="$ctrl.canDeleteFromText(row.fullKey)" ng-click="$ctrl.removeFromTexts(row.fullKey)" class="btn btn-danger btn-xs float-end"><i class="bi bi-trash"></i></button>
          {{row.fullKey}}
        </legend>
        <salaxy-input ng-if="$ctrl.checkIfExistsInTexts(row.fullKey, 'fi')" name="fi" ng-change="$ctrl.updateTexts()" placeholder="{{row.fi}}" ng-model="$ctrl.getEditableText(row.fullKey).fi" label="Suomi"></salaxy-input>
        <salaxy-input ng-if="!$ctrl.checkIfExistsInTexts(row.fullKey, 'fi')" name="fi" ng-click="$ctrl.addToTexts(row.fullKey, 'fi')" ng-model="row.fi" read-only="true" label="Suomi"></salaxy-input>
        <salaxy-input ng-if="$ctrl.checkIfExistsInTexts(row.fullKey, 'en')" name="en" ng-change="$ctrl.updateTexts()" placeholder="{{row.en}}" ng-model="$ctrl.getEditableText(row.fullKey).en" label="English"></salaxy-input>
        <salaxy-input ng-if="!$ctrl.checkIfExistsInTexts(row.fullKey, 'en')" name="en" ng-click="$ctrl.addToTexts(row.fullKey, 'en')" ng-model="row.en" read-only="true" label="English"></salaxy-input>
        <salaxy-input ng-if="$ctrl.checkIfExistsInTexts(row.fullKey, 'sv')" name="sv" ng-change="$ctrl.updateTexts()" placeholder="{{row.sv}}" ng-model="$ctrl.getEditableText(row.fullKey).sv" label="Svenska"></salaxy-input>
        <salaxy-input ng-if="!$ctrl.checkIfExistsInTexts(row.fullKey, 'sv')" name="sv" ng-click="$ctrl.addToTexts(row.fullKey, 'sv')" ng-model="row.sv" read-only="true" label="Svenska"></salaxy-input>
      </fieldset>
      <div class="alert alert-warning" ng-if="$ctrl.allKeyValues.length > 10">ERR: More than 10 translation key values, showing max 10.</div>
    </div>
    <div ng-if="$ctrl.mode != 'fieldset'">
      <div class="btn-toolbar" role="toolbar" aria-label="Report options">
        <div class="btn-group btn-group-sm dropdown">
          <button id="single-button" type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
            Avaimet:
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.fullKey = !$ctrl.showCols.fullKey" class="dropdown-item">
                <i ng-if="$ctrl.showCols.fullKey" class="bi bi-x-lg" aria-hidden="true"></i>
                Koko avain
              </a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.shortKey = !$ctrl.showCols.shortKey" class="dropdown-item">
                <i ng-if="$ctrl.showCols.shortKey" class="bi bi-x-lg" aria-hidden="true"></i>
                Lyhyt avain
              </a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.fileName = !$ctrl.showCols.fileName" class="dropdown-item">
                <i ng-if="$ctrl.showCols.fileName" class="bi bi-x-lg" aria-hidden="true"></i>
                Käännöstiedosto / pääryhmä
              </a>
              </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.keyComponent = !$ctrl.showCols.keyComponent" class="dropdown-item">
                <i ng-if="$ctrl.showCols.keyComponent" class="bi bi-x-lg" aria-hidden="true"></i>
                Komponentti / tiedoston ryhmittely
              </a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.keyValue = !$ctrl.showCols.keyValue" class="dropdown-item">
                <i ng-if="$ctrl.showCols.keyValue" class="bi bi-x-lg" aria-hidden="true"></i>
                3. taso (1. avain)
              </a>
            </li>
          </ul>
        </div>
        <div class="btn-group btn-group-sm dropdown ms-1">
          <button id="single-button" type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
            Kieli:
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.fi = !$ctrl.showCols.fi" class="dropdown-item">
                <i ng-if="$ctrl.showCols.fi" class="bi bi-x-lg" aria-hidden="true"></i> 
                Suomi
              </a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.en = !$ctrl.showCols.en" class="dropdown-item">
                <i ng-if="$ctrl.showCols.en" class="bi bi-x-lg" aria-hidden="true"></i> 
                Englanti
              </a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.sv = !$ctrl.showCols.sv" class="dropdown-item">
                <i ng-if="$ctrl.showCols.sv" class="bi bi-x-lg" aria-hidden="true"></i> 
                Ruotsi
              </a>
            </li>
          </ul>
        </div>
        <div class="btn-group btn-group-sm ms-sm-auto" role="group" aria-label="Json">
          <button sxy-if-role="!anon" type="button" class="btn btn-secondary" ng-click="$ctrl.downloadTexts()">
            <span class="d-none d-md-inline-block">Lataa muutos JSON</span>
            <i class="bi bi-file-earmark" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th ng-if="$ctrl.showCols.fullKey">
              <salaxy-input label-type="basic" name="fullKey" label="Koko avain" ng-model="$ctrl.listFilter.fullKey"></salaxy-input>
            </th>
            <th ng-if="$ctrl.showCols.shortKey">
              <salaxy-input label-type="basic" name="shortKey" label="Lyhyt avain" ng-model="$ctrl.listFilter.shortKey"></salaxy-input>
            </th>
            <th ng-if="$ctrl.showCols.keyComponent">
              <salaxy-input label-type="basic" name="keyComponent" label="Komponenttiavain" ng-model="$ctrl.listFilter.keyComponent"></salaxy-input>
            </th>
            <th ng-if="$ctrl.showCols.fi">
              <salaxy-input label-type="basic" name="fi" label="Suomi" ng-model="$ctrl.listFilter.fi"></salaxy-input>
            </th>
            <th ng-if="$ctrl.showCols.en">
              <salaxy-input label-type="basic" name="en" label="Englanti" ng-model="$ctrl.listFilter.en"></salaxy-input>
            </th>
            <th ng-if="$ctrl.showCols.sv">
              <salaxy-input label-type="basic" name="sv" label="Ruotsi" ng-model="$ctrl.listFilter.sv"></salaxy-input>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.allKeyValues | filter: $ctrl.listFilter | limitTo: 100 ">
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.fullKey">{{row.fullKey}}</td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.shortKey">{{row.shortKey}}</td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.keyComponent">{{row.keyComponent}}</td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.keyValue">{{row.keyValue}}</td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.fi && $ctrl.checkIfExistsInTexts(row.fullKey, 'fi')">
              <salaxy-input name="fi" ng-change="$ctrl.updateTexts()" placeholder="{{row.fi}}" ng-model="$ctrl.getEditableText(row.fullKey).fi" label-type="plain"></salaxy-input>
            </td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.fi && !$ctrl.checkIfExistsInTexts(row.fullKey, 'fi')" ng-click="$ctrl.addToTexts(row.fullKey, 'fi')">{{row.fi}}
            </td>
  
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.en && $ctrl.checkIfExistsInTexts(row.fullKey, 'en')">
              <salaxy-input name="en" ng-change="$ctrl.updateTexts()" placeholder="{{row.en}}" ng-model="$ctrl.getEditableText(row.fullKey).en" label-type="plain"></salaxy-input>
            </td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.en && !$ctrl.checkIfExistsInTexts(row.fullKey, 'en')" ng-click="$ctrl.addToTexts(row.fullKey, 'en')">{{row.en}}
            </td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.sv && $ctrl.checkIfExistsInTexts(row.fullKey, 'sv')">
              <salaxy-input name="sv" ng-change="$ctrl.updateTexts()" placeholder="{{row.sv}}" ng-model="$ctrl.getEditableText(row.fullKey).sv" label-type="plain"></salaxy-input>
            </td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.sv && !$ctrl.checkIfExistsInTexts(row.fullKey, 'sv')" ng-click="$ctrl.addToTexts(row.fullKey, 'sv')">{{row.sv}}
            </td>
            <td ng-if="$ctrl.canDeleteFromText(row.fullKey)"><button ng-click="$ctrl.removeFromTexts(row.fullKey)" class="btn btn-danger"><i class="bi bi-trash"></i></button>
            </td>
            <td ng-if="!$ctrl.canDeleteFromText(row.fullKey)"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/invoices/CompanyInvoices.html",`<div class="salaxy-component salaxy-company-invoices">
  <salaxy-odata-table crud-controller="CompanyInvoicesController as $crud" options="$ctrl.getListOptions()" crud-bindings="{ channel: $ctrl.channel }"
    template-url="salaxy-components/odata/lists/InvoicesCompany.html">
  </salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/invoices/CreditTransfer.html",`<div class="salaxy-component salaxy-credit-transfer">
  <div class="salaxy-credit-transfer-official" ng-if="$ctrl.mode != 'barcode-copy'">
    <div class="sct-row sct-row1">
      <div class="sct-col sct-col1">
        <div class="sct-row sct-row1" sxy-html="SALAXY.NG1.CreditTransferComponent.receiverIban.html"></div>
        <div class="sct-row sct-row2" sxy-html="SALAXY.NG1.CreditTransferComponent.receiver.html"></div>
        <div class="sct-row sct-row3">
          <div class="sct-label-payer" sxy-html="SALAXY.NG1.CreditTransferComponent.payerInfo.html"></div>
          <div class="sct-label-credit-transfer" sxy-text="SALAXY.NG1.CreditTransferComponent.creditTransfer"></div>
          <div class="sct-label-signature" sxy-html="SALAXY.NG1.CreditTransferComponent.signature.html"></div>
        </div>
        <div class="sct-row sct-row4" sxy-html="SALAXY.NG1.CreditTransferComponent.fromAccount.html"></div>
      </div>
      <div class="sct-col sct-col2">
        <div class="sct-row sct-row1">
          <!-- Recipient account numbers (IBAN), max 4 lines -->
          <div class="sct-label-iban" sxy-text="SALAXY.NG1.CreditTransferComponent.iban"></div>
          <div class="sct-filled-content">
            {{ $ctrl.invoice.recipient.iban | sxyIban }}
          </div>
          <div class="sct-label-iban" sxy-text="BIC"></div>
          <div class="sct-filled-content">
            {{ $ctrl.getBicForIban($ctrl.invoice.recipient.iban) }}
          </div>
        </div>
        <div class="sct-row sct-row2">
          <div class="sct-filled-content sct-filled-content-main">
            <!-- Recipient, max 3 lines -->
            {{ $ctrl.invoice.recipient.fullName }}<br> {{ $ctrl.invoice.recipient.contact.street }} {{ $ctrl.invoice.recipient.contact.postalCode }} {{ $ctrl.invoice.recipient.contact.city }}
          </div>
        </div>
        <div class="sct-row sct-row3">
          <div class="sct-filled-content sct-filled-content-main">
            <!-- Payer’s name and address -->
            {{ $ctrl.invoice.payer.avatar.displayName }}<br> {{ $ctrl.invoice.payer.contact.street }}<br> {{ $ctrl.invoice.payer.contact.postalCode }} {{ $ctrl.invoice.payer.contact.city }}
          </div>
          <div class="sct-filled-content sct-signature">
            <!-- Signature -->
          </div>
          <div class="sct-guideline-signature"></div>
        </div>
        <div class="sct-row sct-row4">
          <div class="sct-filled-content sct-filled-content-main">
            <!-- From account no. -->
          </div>
        </div>
      </div>
      <div class="sct-col sct-col3">
        <div class="sct-row sct-row1" ng-if="$ctrl.getQrCode(row) !== 'loading' && $ctrl.getQrCode(row) !== 'error'">
          <div class="sct-qrcode" >
            <div ng-bind-html="$ctrl.getQrCode(row)"></div>
          </div>
          <div class="sct-filled-content-message">
            <ng-transclude ng-transclude-slot="message">
              <span>{{ $ctrl.invoice.header.message }}</span>
            </ng-transclude>
          </div>
        </div>
        <div class="sct-row sct-row1" ng-if="$ctrl.getQrCode(row) === 'error'">
          <div class="sct-filled-content sct-filled-content-main">
            <ng-transclude ng-transclude-slot="message">
              <span>{{ $ctrl.invoice.header.message }}</span>
            </ng-transclude>
          </div>
        </div>
        <div class="sct-row sct-row2">
          <div class="sct-col sct-col1" sxy-html="SALAXY.NG1.CreditTransferComponent.refNumber.html"></div>
          <div class="sct-col sct-col2">
            <div class="sct-filled-content sct-filled-content-main">
              <!-- Ref. nr -->
              {{ $ctrl.invoice.header.referenceNumber | sxyIban }}
            </div>
          </div>
        </div>
        <div class="sct-row sct-row3">
          <div class="sct-col sct-col1" sxy-html="SALAXY.NG1.CreditTransferComponent.dueDate.html"></div>
          <div class="sct-col sct-col2">
            <div class="sct-filled-content sct-filled-content-main">
              <!-- Due date -->
              {{ $ctrl.invoice.header.dueDate | sxyDate }}
            </div>
          </div>
          <div class="sct-col sct-col3">
            <div class="sct-label-euro" sxy-text="SALAXY.NG1.CreditTransferComponent.euro"></div>
            <div class="sct-filled-content sct-filled-content-main">
              <!-- Euro amount -->
              {{ $ctrl.invoice.header.total | currency }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sct-row sct-row2">
      <div id="barcode">
        <!-- Barcode can be shown only with FI IBAN -->
         <div ng-bind-html="$ctrl.getBarcode()"></div>
      </div>
      <!--
        NOTE: Terms of clearance is part of original specification: https://www.finanssiala.fi/wp-content/uploads/2021/03/Tilisiirto-opas.pdf.
        It is removed because it has no real value today and it makes reading barcode difficult.
      -->
      <!--
        <div id="terms-of-clearance">
          Maksu välitetään saajalle maksujenvälityksen ehtojen mukaisesti ja vain maksajan ilmoittaman tilinumeron perusteella.
          <br> Betalningen förmedlas till mottagaren engligt villkoren för betalningsförmedling och endast till det kontonummer som betalaren angivit.
        </div>
      -->
    </div>
  </div>
  <div class="barcodeform-container d-print-none" ng-if="$ctrl.mode != 'official'">
    <form name="barcodeForm" id="barcodeForm" class="form-horizontal">
      <p sxy-text="SALAXY.NG1.CreditTransferComponent.transferDescription" ng-if="$ctrl.mode != 'barcode-copy' && !$ctrl.isInternationalIban()"></p>
      <p ng-if="$ctrl.mode != 'barcode-copy' && $ctrl.isInternationalIban()">&nbsp;</p>    
      <div class="row" ng-if="!$ctrl.isInternationalIban()">
        <div class="col-sm-10">
          <salaxy-input name="{{ 'barcode' + $ctrl.getId() }}" label="SALAXY.NG1.CreditTransferComponent.barcodeLabel" readonly="true" label-cols="col-sm-4" ng-model="$ctrl.bcValue"></salaxy-input>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-default btn-block" ng-click="$ctrl.copyBarcode()" sxy-text="SALAXY.UI_Terms.copyToClipboard"></button>
        </div>
      </div>
    </form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/invoices/InvoiceAlerts.html",`<div class="row payment-started-alert">
  <div class="col-xs-12">
    <salaxy-alert type="warning" ng-repeat="paymentChannel in $ctrl.groupedPaymentChannelResult">
      <main>
        <div ng-bind-html="$ctrl.getpaymentChannelInfoHtml(paymentChannel)"></div>
      </main>
    </salaxy-alert>
  </div>
</div>`);

 $templateCache.put("salaxy-components/invoices/InvoiceEdit.html",`<div class="salaxy-component salaxy-invoice-edit">
  <salaxy-spinner ng-if="$ctrl.isLoading"></salaxy-spinner>
  <div class="alert alert-danger" ng-if="!$ctrl.isLoading && !$ctrl.current" sxy-text="SALAXY.NG1.InvoiceEditComponent.error"></div>
  <form name="statusForm" ng-if="$ctrl.current" ng-submit="$ctrl.requestStatusUpdate()">
    <div class="form-horizontal">
      <h2 sxy-text="SALAXY.NG1.InvoiceEditComponent.headingAlt"></h2>
      <p sxy-text="SALAXY.NG1.InvoiceEditComponent.headingInfoAlt"></p>
      <salaxy-input-enum label="SALAXY.NG1.InvoiceEditComponent.channel" read-only="true" name="paymentChannel" ng-model="$ctrl.current.header.channel" enum="PaymentChannel"></salaxy-input-enum>
      <salaxy-input-enum label="SALAXY.NG1.InvoiceEditComponent.invoiceStatus" read-only="!( ( ('test' | sxyIsInRole) || ('pro' | sxyIsInRole) ) && ($ctrl.current.header.channel == 'palkkausManual' || $ctrl.current.header.channel == 'talenomManual' || $ctrl.current.header.channel == 'palkkausInvoices' || $ctrl.current.header.channel == 'kitsas' || $ctrl.current.header.channel == 'palkkausWS' || $ctrl.current.header.channel == 'palkkausPSD'))" name="requestedStatus" ng-model="$ctrl.requestedStatus" enum="InvoiceStatus" required></salaxy-input-enum>
    </div>
    <div>
      <button type="submit" class="btn btn-primary float-end" ng-disabled="!statusForm.$valid || !( ( ('test' | sxyIsInRole) || ('pro' | sxyIsInRole) ) && ($ctrl.current.header.channel == 'palkkausManual' || $ctrl.current.header.channel == 'talenomManual' || $ctrl.current.header.channel == 'palkkausInvoices' || $ctrl.current.header.channel == 'kitsas' || $ctrl.current.header.channel == 'palkkausWS' || $ctrl.current.header.channel == 'palkkausPSD'))" sxy-text="SALAXY.NG1.InvoiceEditComponent.updateStatusBtn"></button>
      <button ng-if="'test' | sxyIsInRole" type="button" ng-click="$ctrl.delete()" class="btn btn-danger" sxy-text="SALAXY.NG1.InvoiceEditComponent.deleteInvoice" pre="(Test only): "></button>
      <button ng-if="'test' | sxyIsInRole" type="button" ng-click="$ctrl.deleteWithBusinessObjects()" class="btn btn-danger" sxy-text="SALAXY.NG1.InvoiceEditComponent.deleteInvoiceWithCals" pre="(Test only): "></button>
    </div>
  </form>
</div>`);

 $templateCache.put("salaxy-components/invoices/InvoiceList.html",`<div class="salaxy-component salaxy-invoice-list" ng-switch="$ctrl.mode">
  <salaxy-odata-table ng-switch-when="panel" crud-controller="InvoiceCrudController as $crud" options="$ctrl.getListOptions()"
    template-url="salaxy-components/odata/lists/InvoicesPanel.html">
  </salaxy-odata-table>

  <salaxy-odata-table ng-switch-when="sepa" crud-controller="InvoiceSepaController as $crud"
    template-url="salaxy-components/odata/lists/InvoicesSepa.html">
  </salaxy-odata-table>

  <salaxy-odata-table ng-switch-when="person" crud-controller="InvoiceCrudController as $crud" options="$ctrl.getListOptions()"
    template-url="salaxy-components/odata/lists/InvoicesPerson.html">
  </salaxy-odata-table>
  
  <div ng-switch-default>
    <salaxy-odata-table crud-controller="InvoiceCrudController as $crud" options="$ctrl.getListOptions()" template-url="salaxy-components/odata/lists/Invoices.html">
    </salaxy-odata-table>
  </div>

</div>`);

 $templateCache.put("salaxy-components/invoices/InvoicePaymentList.html",`<div class="salaxy-component salaxy-invoice-list">
  <salaxy-odata-table crud-controller="InvoicePaymentListController as $crud"
    template-url="salaxy-components/odata/lists/InvoicePaymentList.html">
  </salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/invoices/InvoicePreview.html",`<div ng-init="$ctrl.view = 'full'">
  <salaxy-spinner ng-if="!$ctrl.current && $ctrl.isLoading"></salaxy-spinner>
  <div class="alert alert-danger" ng-if="!$ctrl.isLoading && !$ctrl.current" sxy-text="SALAXY.NG1.InvoicePreviewComponent.error"></div>
  
  <div ng-if="$ctrl.current">
    <div class="mb-3">
      <div class="btn-group btn-group-sm" role="group">
        <salaxy-toggle-buttons
          ng-model="$ctrl.view"
          options="[
            { value: 'full', label: 'SALAXY.NG1.InvoicePreviewComponent.fullInvoice' },
            { value: 'partial', label: 'SALAXY.NG1.InvoicePreviewComponent.tableInvoice' }
          ]"
          type="inline"></salaxy-toggle-buttons>
      </div>
      <a ng-href="{{$ctrl.getContentUrl($ctrl.current.id, true)}}" target="_blank"class="btn btn-primary float-end">
        <i class="bi bi-file-earmark-pdf"></i> <span sxy-text="SALAXY.NG1.InvoicePreviewComponent.showFile"></span>
      </a>
    </div>
    <salaxy-invoice-report invoice="$ctrl.current" apply-site-styles="$ctrl.view == 'partial'"></salaxy-invoice-report>
  </div>
</div>`);

 $templateCache.put("salaxy-components/invoices/InvoiceReport.html",`<div class="salaxy-component salaxy-calc-report">
  <div class="row" ng-if="$ctrl.applySiteStyles">
    <div class="col-sm-6">
      <table>
        <tr>
          <td colspan="2"><small><strong sxy-text="SALAXY.NG1.InvoicePreviewComponent.recipient" ps=":"></strong></small></td>
        </tr>
        <tr>
          <td>
            <salaxy-avatar avatar="$ctrl.invoice.recipient.beneficiary.avatar" style="font-size: 64px;"></salaxy-avatar>
          </td>
          <td>
            <div><strong>{{ $ctrl.invoice.recipient.fullName }}</strong></div>
            <div>
              {{ $ctrl.invoice.recipient.contact.street }}<br /> {{ $ctrl.invoice.recipient.contact.postalCode }} {{ $ctrl.invoice.recipient.contact.city }}
            </div>
          </td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td colspan="2"><small><strong sxy-text="SALAXY.NG1.InvoicePreviewComponent.payer" ps=":"></strong></small></td>
        </tr>
        <tr>
          <td>
            <salaxy-avatar avatar="$ctrl.invoice.payer.avatar" style="font-size: 64px;"></salaxy-avatar>
          </td>
          <td>
            <div><strong>{{ $ctrl.invoice.payer.avatar.displayName }}</strong></div>
            <div>
              {{ $ctrl.invoice.payer.contact.street }}<br /> {{ $ctrl.invoice.payer.contact.postalCode }} {{ $ctrl.invoice.payer.contact.city }}
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="col-sm-6">
      <p style="font-size: 24px; font-weight: bold; text-transform: uppercase;">{{ "SALAXY.NG1.InvoiceReportComponent.invoice.title" | sxyTranslate }}</p>
      <p style="font-size: 16px; font-weight: bold; text-transform: uppercase;">{{ ("SALAXY.ENUM.InvoiceType." + $ctrl.invoice.header.type + ".label") | sxyTranslate }}</p>
      <div > </div>
      <table>
        <tr>
          <td sxy-text="SALAXY.NG1.InvoicePreviewComponent.date" ps=":"></td>
          <td>{{ $ctrl.invoice.header.date | sxyDate }}</td>
        </tr>
        <tr>
          <td sxy-text="SALAXY.NG1.InvoicePreviewComponent.dueDate" ps=":"></td>
          <td>{{ $ctrl.invoice.header.dueDate | sxyDate }}</td>
        </tr>
        <tr>
          <td sxy-text="SALAXY.NG1.InvoicePreviewComponent.referenceNumber" ps=":"></td>
          <td>{{ $ctrl.invoice.header.referenceNumber || "-" }}</td>
        </tr>
        <tr>
          <td sxy-text="SALAXY.NG1.InvoicePreviewComponent.iban" ps=":"></td>
          <td ng-if="!$ctrl.isPreviewInvoice()">{{ $ctrl.invoice.recipient.iban | sxyIban }}</td>
          <td ng-if="$ctrl.isPreviewInvoice()">{{ 'SALAXY.REPORTS.invoice.heading.preview' | sxyTranslate }}</td>
        </tr>
        <tr>
          <td sxy-text="SALAXY.NG1.InvoicePreviewComponent.status" ps=":"></td>
          <td>{{ "InvoiceStatus." + $ctrl.invoice.header.status | sxyEnum }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div ng-class="{'report-table-html': $ctrl.applySiteStyles}"></div>
    <div ng-bind-html="$ctrl.html" class="report-binder table-responsive"></div>
  </div>
</div>
`);

 $templateCache.put("salaxy-components/invoices/InvoicesCreate.html",`<div class="salaxy-component salaxy-invoices-create">
  <div ng-if="!$ctrl.currentType" class="alert alert-error">Error: {{ $ctrl.current ? "Invalid object" : "No object" }} bound in InvoicesCreateController</div>
  <div ng-if="$ctrl.currentType">
    <div ng-switch="$ctrl.uiStatus">
      <div ng-switch-when="invalid">
        <salaxy-validation-summary api-validation="$ctrl.current.result.validation">
          <div class="alert alert-danger" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusInvalid"></div>
        </salaxy-validation-summary>
      </div>
      <div ng-switch-when="loading">
        <salaxy-spinner heading="SALAXY.NG1.InvoicesCreateComponent.uiStatusLoading"></salaxy-spinner>
      </div>
      <div ng-switch-when="created" ng-switch="$ctrl.paymentStatus">
        <p class="lead" ng-switch-when="inProgress" sxy-html="SALAXY.NG1.InvoicesCreateComponent.uiStatusCreated.inProgress.html"></p>
        <div class="alert alert-success" ng-switch-when="paid" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusCreated.paid" ps="."></div>
        <div class="alert alert-danger" ng-switch-when="exceptions" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusCreated.exceptions"></div>
        <div class="alert alert-danger" ng-switch-when="canceled" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusCreated.canceled"></div>
        <ng-include src="'salaxy-components/invoices/InvoicesCreate_Table.html'"></ng-include>
      </div>
      <div ng-switch-when="supportedChannel">
        <div sxy-html="{{$ctrl.intro}}"></div>
        <ng-include src="'salaxy-components/invoices/InvoicesCreate_Table.html'"></ng-include>
      </div>
      <div ng-switch-when="undefined">
        <div class="alert alert-error" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusDefault"></div>
      </div>
      <div ng-switch-when="userCanceled">
        <div class="alert alert-error" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusUserCanceled"></div>
      </div>
      <div ng-switch-default>
        <div class="alert alert-error" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusDefault"></div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/invoices/InvoicesCreate_Table.html",`<table class="table">
  <thead>
    <tr>
      <th colspan="2" sxy-text="SALAXY.NG1.InvoicesCreateTableComponent.receiverInvoiceType"></th>
      <th sxy-text="SALAXY.NG1.InvoicesCreateTableComponent.comingToPay"></th>
      <th class="right" sxy-html="SALAXY.NG1.InvoicesCreateTableComponent.invoiceDate.html"></th>
      <th class="right" sxy-text="SALAXY.NG1.InvoicesCreateTableComponent.invoiceSum"></th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="row in $ctrl.invoices" ng-class="{ 'success': $ctrl.getDueDateType(row) == 'default' || $ctrl.getDueDateType(row) == 'paid'}">
      <td class="td-avatar middle">
        <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.invoice.otherPartyInfo.avatar"></salaxy-avatar>
      </td>
      <td class="middle">
        {{ row.invoice.otherPartyInfo.avatar.sortableName }}<br>
        <small class="hidden-xxs">{{("SALAXY.ENUM.InvoiceType." + row.invoice.entityType + ".label") | sxyTranslate}}</small>
      </td class="middle">
      <td class="middle">
        <div ng-switch="$ctrl.getDueDateType(row)">
          <span ng-switch-when="preview" class="disabled">{{$ctrl.getPreviewText(row)}}</span>
          <span ng-switch-when="zero" class="disabled" sxy-text="SALAXY.NG1.InvoicesCreateTableComponent.dueDateTypeZero" ps="."></span>
          <span ng-switch-when="estimation">{{$ctrl.getEstimationText(row)}}</span>
          <span ng-switch-when="forecast">{{ row.invoice.otherPartyInfo.avatar.sortableName }} {{'SALAXY.NG1.InvoicesCreateTableComponent.sendsInvoice' | sxyTranslate}}</span>
          <strong ng-switch-when="paid" sxy-text="SALAXY.NG1.InvoicesCreateTableComponent.dueDateTypePaid"></strong>
          <span ng-switch-when="inProgress" sxy-text="SALAXY.ENUM.InvoiceStatus.read.label"></span>
          <strong ng-switch-when="default" sxy-text="SALAXY.NG1.InvoicesCreateTableComponent.dueDateTypeDefault"></strong>
          <span ng-switch-when="unknown"></span>
          <span ng-switch-when="canceled">{{"SALAXY.ENUM.InvoiceStatus." + row.invoice.status + ".label" | sxyTranslate }}</span>
        </div>
        <div ng-if="row.invoice.businessObjects.length > 1">
          {{'SALAXY.NG1.InvoicesCreateTableComponent.totalSalaries' | sxyTranslate}} {{ row.invoice.businessObjects.length }}
        </div>
      </td>
      <td class="middle right">
        <div>{{ row.invoice.startAt | sxyDate }}</div>
        <div ng-switch="$ctrl.getDueDateType(row)">
          <span ng-switch-when="estimation">{{ "SALAXY.ENUM.CalendarMonth.month" + (row.invoice.endAt | date : 'M') + ".label" | sxyTranslate }}</span>
          <span ng-switch-when="zero">-</span>
          <span ng-switch-when="preview">{{ row.invoice.endAt | sxyDate }}</span>
          <span ng-switch-when="forecast">{{ row.invoice.endAt | sxyDate }}</span>
          <span ng-switch-when="paid">{{ row.invoice.endAt | sxyDate }}</span>
          <span ng-switch-when="default">{{ row.invoice.endAt | sxyDate }}</span>
          <span ng-switch-when="unknown">{{ row.invoice.endAt | sxyDate }}</span>
          <span ng-switch-when="canceled">{{ row.invoice.endAt | sxyDate }}</span>
        </div>
      </td>
      <td class="middle right">
        <strong ng-if="row.invoice.status != 'canceled'">{{ row.invoice.payment | currency }}</strong>
        <s ng-if="row.invoice.status == 'canceled'">{{ row.invoice.payment | currency }}</s>
      </td>
    </tr>
  </tbody>
</table>`);

 $templateCache.put("salaxy-components/invoices/InvoiceTools.html",`<div class="salaxy-component salaxy-invoice-tools">

  <div class="btn-toolbar" role="toolbar" aria-label="Invoice options">
    <div class="btn-group">
      <salaxy-input-enum type="dropdown" name="fileType" label-type="plain" ng-model="$ctrl.fileTypeId" options="$ctrl.fileTypeOptions" remember="invoice"></salaxy-input-enum>

    </div>
    <div class="btn-group">
      <button ng-disabled="$ctrl.reader.disabled()" id="reportExport" type="button" class="btn btn-default" ng-click="$ctrl.export()">
        {{ $ctrl.reader.exportLabel || ('SALAXY.NG1.AccountingReportToolsComponent.createExport' | sxyTranslate) }}
      </button>
    </div>

    <div ng-if="'test' | sxyIsInRole" class="btn-group">
      <salaxy-input-enum type="dropdown" name="channel" label-type="plain" ng-model="channel" enum="PaymentChannel" ></salaxy-input-enum>
      <button ng-disabled="!channel || channel=='undefined'" type="button" class="btn btn-default" ng-click="$ctrl.createSingleInvoice(channel,'verification')">Luo avauslasku</button>
      <button ng-disabled="!channel || channel=='undefined'" type="button" class="btn btn-default" ng-click="$ctrl.createSingleInvoice(channel, 'tax')">Luo verolasku kuluvalle kuulle</button>
    </div>

  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/account/AccountAvatarEdit.html",`
<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AccountInfoComponent.changeAvatar"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <form name="avatarForm" class="form-horizontal" ng-if="$ctrl.current" >
    <div class="row mb-2">
      <div class="col-12 col-sm-4">
        <label for="avatarPreview" class="col-form-label" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarLabel"></label>
      </div>
      <div class="col-12 col-sm-8">
        <div class="worker-avatar-col">
          <salaxy-avatar class="avatar-xxl" avatar="$ctrl.current.avatar"></salaxy-avatar>
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12 col-sm-4">
        <label for="avatarPictureType" class="col-form-label" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarTypeLabel"></label>
      </div>
      <div class="col-12 col-sm-8">
        <select class="form-select" id="avatarPictureType" ng-model="$ctrl.current.avatar.pictureType" ng-change="$ctrl.logic.typeForAvatarChanged($ctrl.current)">
          <option value="" disabled sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionChoose"></option>
          <option value="icon" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionIcon"></option>
          <option value="uploaded" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionUploaded"></option>
          <option hidden value="gravatar" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionGravatar"></option>
        </select>
      </div>
    </div>
    <div ng-if="$ctrl.current.avatar.pictureType == 'gravatar'" class="row">
      <div class="input-info col-sm-8 offset-sm-4">
        <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
        <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.gravatarInfo.html"></p>
      </div>
    </div>
    <div ng-if="$ctrl.current.avatar.pictureType == 'icon'">
      <salaxy-input name="avatarInitials" label="SALAXY.NG1.AccountAvatarEditPersonComponent.initialsLabel" ng-model="$ctrl.current.avatar.initials" max-length="2"></salaxy-input>
      <div class="row">
        <div class="col-12 col-sm-4">
          <label for="avatarPictureColor" class="col-form-label"  sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.colorLabel"></label>
        </div>
        <div class="col-12 col-sm-8">
          <input class="form-control" type="color" id="avatarPictureColor" ng-model="$ctrl.current.avatar.color" />
        </div>
      </div>
    </div>
    <div class="row" ng-if="$ctrl.current.avatar.pictureType == 'uploaded'">
      <div class="col-12 col-sm-4">
        <label for="avatarImageUpload" class="col-form-label" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImageLabel"></label>
      </div>
      <div class="col-12 col-sm-8">
        <div name="avatarImageUpload" ng-model="avatarImage" ngf-drop="$ctrl.logic.uploadAvatarImage($file, $ctrl.current)" ngf-select="$ctrl.logic.uploadAvatarImage($file, $ctrl.current)" class="salaxy-drop-box" ngf-drag-over-class="'salaxy-drag-over'" ngf-multiple="false" ngf-min-size="5KB" ngf-max-size="10MB"
          ngf-pattern="'image/*'" ngf-model-invalid="invalidFile" ng-class="invalidFile.$error != null ? 'error' : ''">
          <span sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImage.html"></span>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/account/AccountContactEdit.html",`
<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AccountInfoComponent.editContactInfo"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body" id="modal-body">
  <form name="contactForm" class="form-horizontal" ng-if="$ctrl.current">
    <div class="row">
      <div class="col-12">
        <salaxy-input name="email" label="SALAXY.MODEL.PersonAccount.contact.email.title" sxy-email ng-model="$ctrl.current.contact.email" ng-change="$ctrl.logic.emailForAvatarChanged($ctrl.current)">
        </salaxy-input>
        <salaxy-input name="telephone" label="SALAXY.MODEL.PersonAccount.contact.telephone.title" sxy-mobile-phone ng-model="$ctrl.current.contact.telephone"></salaxy-input>
        <salaxy-input name="street" label="SALAXY.MODEL.PersonAccount.contact.street.title" ng-model="$ctrl.current.contact.street" ng-required="('household' | sxyIsInRole) || ('company' | sxyIsInRole)"></salaxy-input>
        <salaxy-input name="postalCode" label="SALAXY.MODEL.PersonAccount.contact.postalCode.title" sxy-postal-code-fi ng-model="$ctrl.current.contact.postalCode" ng-required="('household' | sxyIsInRole) || ('company' | sxyIsInRole)"></salaxy-input>
        <salaxy-input name="city" label="SALAXY.MODEL.PersonAccount.contact.city.title" ng-model="$ctrl.current.contact.city" ng-required="('household' | sxyIsInRole) || ('company' | sxyIsInRole)"></salaxy-input>
        <salaxy-input-enum type="select" label="SALAXY.MODEL.PersonAccount.contact.countryCode.title" ng-model="$ctrl.current.contact.countryCode" name="country" read-only="true" enum="Country"></salaxy-input-enum>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/account/Authorization.html",`<div class="modal-header">
  <div>
    <h2 class="modal-title" id="salaxyProductDialogLabel">{{ $ctrl.currentPartnerSite.title | sxyTranslate }}</h2>
    <h4 class="subtitle">{{ $ctrl.currentPartnerSite.status | sxyTranslate}}</h4>
  </div>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body">
  <div class="form-horizontal">
    <div class="salaxy-product-info-headers">
      <div class="row">
        <div class="col-12 col-sm-4">
          <i class="salaxy-avatar" style="font-size: 140px;">
            <img ng-src="{{$ctrl.currentPartnerSite.img}}" />
          </i>
        </div>
        <div class="col-12 col-sm-8">
          <div class="salaxy-product-description">
            <p>{{ 'SALAXY.NG1.AuthInfoHeadersComponent.' + $ctrl.currentPartnerSite.id + '.description' | sxyTranslate }}</p>
            <a class="btn btn-primary" target="_blank" href="{{'SALAXY.NG1.AuthInfoHeadersComponent.' + $ctrl.currentPartnerSite.id + '.link' | sxyTranslate}}">
              {{ 'SALAXY.NG1.AuthInfoHeadersComponent.' + $ctrl.currentPartnerSite.id + '.cta' | sxyTranslate }} »</a>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div sxy-if-role="auth">
      <div ng-if="$ctrl.currentPartnerSite.id == 'holvi'" sxy-html="SALAXY.NG1.AuthorizationDialogsComponent.holvi.html"></div>
      <div ng-if="$ctrl.currentPartnerSite.id == 'isolta'" sxy-html="SALAXY.NG1.AuthorizationDialogsComponent.isolta.html"></div>
      <div ng-if="$ctrl.currentPartnerSite.id == 'accountor'" sxy-html="SALAXY.NG1.AuthorizationDialogsComponent.accountor.html"></div>
      <div ng-if="$ctrl.currentPartnerSite.id == 'finago'" sxy-html="SALAXY.NG1.AuthorizationDialogsComponent.finago.html"></div>
      <div ng-if="$ctrl.currentPartnerSite.id == 'briox'" sxy-html="SALAXY.NG1.AuthorizationDialogsComponent.briox.html"></div>
    </div>
    <div class="row">
      <div class="col-12 mb-2">
        <div class="d-flex justify-content-end">
          <salaxy-input-boolean class="authorization-switch" sxy-if-role="auth" ng-change="$ctrl.switchAuthorization()" name="{{$ctrl.currentPartnerSite.id}}" id="{{$ctrl.currentPartnerSite.id}}" type="switch" ng-model="$ctrl.currentPartnerSite.enabled" label-type="no-label" label-true="on" label-false="off"></salaxy-input-boolean>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer text-end">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/account/AuthorizedAccountAdd.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AuthoringAccountComponent.authorize"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body" id="modal-body">
  <form name="authorizedAccountAddDialogForm">
    <div class="form-horizontal">
      <legend sxy-text="SALAXY.NG1.AuthoringAccountComponent.authorizeTitle"></legend>
      <p sxy-text="SALAXY.NG1.AuthoringAccountComponent.authorizeDescription"></p>
      <salaxy-input name="accountId" label="SALAXY.NG1.AuthoringAccountComponent.palkkausAccount" ng-model="$ctrl.current.id" require="true"></salaxy-input>
      <salaxy-input name="scope" label="SALAXY.NG1.AuthoringAccountComponent.scope" placeholder="SALAXY.NG1.AuthoringAccountComponent.defaultScope" ng-model="$ctrl.current.scope"></salaxy-input>
      <salaxy-input  ng-if="('admin' | sxyIsInRole)" name="partnerKey" label="Partnerin antama ID"  ng-model="$ctrl.current.partnerKey"></salaxy-input>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary" ng-disabled="!authorizedAccountAddDialogForm.$valid" ng-click="$ctrl.saveCurrent($close)" sxy-text="SALAXY.NG1.AuthoringAccountComponent.authorize"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/account/CertificateAdd.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.CertificateAddComponent.title"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <div sxy-html="SALAXY.NG1.CertificateAddComponent.html"></div>
  <form name="certificateAddDialogForm">
    <div ng-if="!$ctrl.result.thumbprint" class="row">
      <div class="col-12">
        <salaxy-input name="title" label="SALAXY.NG1.CertificatesComponent.name" ng-model="$ctrl.current.title" require="true"></salaxy-input>
        <salaxy-input-enum name="certFormat" ng-model="$ctrl.certFormat" require="true" label="Sertifikaatin tyyppi"
        options="$ctrl.certFormats"></salaxy-input-enum>
        <div class="form-group row" ng-if="$ctrl.certFormat == 'pfx'">
          <label for="salasana" class="col-sm-4 col-form-label" style="text-align:left">
            <span sxy-text="SALAXY.NG1.CertificateAddComponent.password" ps="*"></span>
          </label>
          <div class="col-sm-8">
            <input type="password" class="form-control" id="password" name="password" placeholder="{{'SALAXY.NG1.CertificateAddComponent.password' | sxyTranslate}}" ng-model="$ctrl.current.password" ng-required="true" autocomplete="off" />
          </div>
        </div>
      </div>
    </div>
  </form>
  <div ng-if="$ctrl.result.thumbprint">
    <strong sxy-text="SALAXY.NG1.CertificateAddComponent.createdSertificate"></strong><br />
    <a ng-click="$ctrl.downloadCertFile()">{{ "SALAXY.NG1.CertificateAddComponent.downloadBase64" |sxyTranslate }} (.{{ $ctrl.certFormat == 'pem' ? 'zip' : $ctrl.certFormat }})</a><br />
    <b></b>{{ "SALAXY.NG1.CertificateAddComponent.base64" |sxyTranslate }} ({{ $ctrl.certFormat }})<br />
    <textarea readonly rows="15" id="certificate-bytes" style="width:100%;">{{$ctrl.result.text }}</textarea>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button ng-if="$ctrl.result.thumbprint" type="button" class="btn btn-info" onclick='document.getElementById("certificate-bytes").select(); document.execCommand("copy");'
    sxy-text="SALAXY.NG1.CertificateAddComponent.copyBase64"></button>
  <button ng-if="!$ctrl.result.thumbprint" type="button" class="btn btn-primary" ng-disabled="!certificateAddDialogForm.$valid" ng-click="$ctrl.createCert()"
    sxy-text="SALAXY.NG1.CertificateAddComponent.createSertificate"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/account/EInvoiceAddressList.html",`<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <table class="table table-striped">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.name"></th>
            <th sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.receiver"></th>
            <th sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.intermediator"></th>
            <th class="right">
              <form name="searchForm">
                <salaxy-form-group name="search" label-type="plain">
                  <div class="input-group">
                    <input class="form-control" type="text" autocomplete="off" id="searchAddress" name="searchAddress" ng-model="$ctrl.logic.officialId" sxy-company-id-fi>
                    <span class="input-group-btn">
                      <button type="submit" ng-disabled="!searchForm.$valid" class="btn btn-default" ng-click="$ctrl.logic.search()">
                        <span ng-show="$ctrl.logic.isLoading">
                          <i class="bi bi-arrow-repeat bi-spin"></i>
                        </span>
                        <span ng-show="!$ctrl.logic.isLoading">
                          <i class="bi bi-search"></i>
                        </span>
                      </button>
                    </span>
                  </div>
              </form>
              </salaxy-form-group>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.logic.addresses">
            <td>
              <span>{{row.receiverName}}</span><br>
              <small>{{row.receiverOfficialId}}</small>
            </td>
            <td>
              <span>{{row.receiver}}</span><br>
            </td>
            <td>
              <span>{{row.intermediatorName}}</span><br>
              <small>{{row.intermediator}}</small>
            </td>
            <td class="right middle">
              <button class="btn btn-sm" type="button" ng-class="$ctrl.logic.isSelected($ctrl.current, row) ? 'btn-success' : 'btn-default'" ng-click="$ctrl.logic.setCurrent($ctrl.current, row)">
                {{ $ctrl.logic.isSelected($ctrl.current, row) ? ('SALAXY.UI_Terms.chosen' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
              </button>
            </td>
          </tr>
          <tr ng-if="$ctrl.logic.addresses.length == 0">
            <td colspan="4" sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.receiverNotFound"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer text-end">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="button" class="btn btn-danger" ng-click="$close('reset')" sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.dontUseAnyAddress"></button>
    <button type="button" ng-disabled="!$ctrl.logic.isAnySelected($ctrl.current)" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.useSelectedAddress"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/account/Insurance.html",`<div class="localtapiola-modal-wrapper">
  <!-- Import LocalTapiola fonts -->
  <link rel="stylesheet" href="https://cdn.duetds.com/api/fonts/1.3.14/lib/localtapiola.css" integrity="sha384-5JYmtSD7nykpUvSmTW1CHMoBDkBZUpUmG0vuh+NUVtZag3F75Kr7+/JU3J7JV6Wq"
    crossorigin="anonymous" />
  <div class="localtapiola-modal">
    <div class="modal-header">
      <div class="logo-wrapper">
        <img src="https://cdn.salaxy.com/ng1/localtapiola-modal/localtapiola-white-logo.png" class="img-responsive logo-img" alt="LähiTapiola" />
      </div>
      <button class="btn-close ms-auto" ng-click="$close('cancel')" aria-label="Close">{{'SALAXY.UI_Terms.close' | sxyTranslate}}</button>
    </div>
    <div class="modal-body salaxy-wizard">
      <ng-include src="$ctrl.currentStep.view || 'salaxy-components/modals/localTapiola/Start.html'"></ng-include>
    </div>
    <div class="modal-footer" ng-if="$ctrl.currentStep.buttonsView">
      <div class="footer-content w-100">
        <ng-include src="$ctrl.currentStep.buttonsView || 'salaxy-components/modals/localTapiola/buttons-default.html'" class="d-flex justify-content-between"></ng-include>
      </div>
    </div>
  </div>
</div>
<style>
  .datepicker .datepicker-cell.focused {
    background-color: #0077b3;
    box-shadow: none;
    color: #fff;
  }
  
  .datepicker .today-button,
  .datepicker .today-button:hover,
  .datepicker .today-button:focus,
  .datepicker .clear-button,
  .datepicker .clear-button:hover,
  .datepicker .clear-button:focus {
    color: #009fd8 !important;
    border-color: transparent !important;
    background-color: transparent !important;
    font-family: "localtapiola-sans" !important;
    font-size: 14px !important;
    outline: none !important;
    font-weight: 600 !important;
  }
</style>`);

 $templateCache.put("salaxy-components/modals/account/PrimaryPartner.html",`<div class="modal-header">
  <div>
    <h2 class="modal-title" id="salaxyProductDialogLabel">{{ $ctrl.current.name }}</h2>
    <h4 class="subtitle">{{ $ctrl.current.description }}</h4>
  </div>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body">
  <div class="form-horizontal">
    <div class="salaxy-component salaxy-product-info-headers">
      <div class="row">
        <div class="col-12 col-sm-4">
          <i class="salaxy-avatar" style="font-size: 140px;">
            <img ng-src="{{ $ctrl.current.branding.logo }}" />
          </i>
        </div>
        <div class="col-12 col-sm-8">
          <div class="salaxy-product-description">
            <p>
              {{ $ctrl.current.branding.text }}
            </p>
            <a ng-if="$ctrl.current.branding.url" class="btn btn-primary" target="_blank" ng-href="{{$ctrl.current.branding.url}}">{{'SALAXY.NG1.PrimaryPartnerComponent.moreInfo' | sxyTranslate}} »</a>
          </div>
        </div>
      </div>
      <div class="row" ng-if="!$ctrl.current.isAuthorized">
        <div class="col-12 input-info">
          <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
          <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.PrimaryPartnerComponent.notAuthorized.html"></p>
        </div>
      </div>
      <div class="row" ng-if="!$ctrl.current.isAuthorized">
        <div class="col-12 input-info">
          <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
          <p class="small input-info-text with-icon" sxy-text="SALAXY.NG1.PrimaryPartnerComponent.notAuthorized.text"></p>
        </div>
      </div>

      <div class="row" ng-if="$ctrl.current.isAuthorized">
        <div class="col-12 input-info">
          <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
          <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.PrimaryPartnerComponent.authorized.html"></p>
        </div>
      </div>
      <div class="row" ng-if="$ctrl.current.isAuthorized">
        <div class="col-12 input-info">
          <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
          <p class="small input-info-text with-icon" sxy-text="SALAXY.NG1.PrimaryPartnerComponent.authorized.text"></p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer text-end">
  <button type="button" class="btn btn-danger" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button ng-if="!$ctrl.current.isAuthorized" type="button" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.NG1.PrimaryPartnerComponent.setPrimaryPartner"></button>
  <button ng-if="$ctrl.current.isAuthorized" type="button" class="btn btn-danger" ng-click="$close('ok')" sxy-text="SALAXY.NG1.PrimaryPartnerComponent.removePrimaryPartnerCredential"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/account/VismaModal.html",`<div id="salaxyDialog" class="salaxy-component salaxy-dialog modal-dialog visma-modal {{size ? 'modal-' + size : ''}}" aria-labelledby="salaxyDialogLabel" role="dialog">
  <link href="https://fonts.googleapis.com/css?family=Exo:400,700" rel="stylesheet">
  <div class="modal-content" role="document" uib-modal-transclude></div>
</div>`);

 $templateCache.put("salaxy-components/modals/accounting-target/accounting-targets.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <div sxy-orderby="shortText" sxy-text="SALAXY.NG1.AccountingTargetsComponent.exportDefinition"></div>
            <div sxy-text="SALAXY.NG1.AccountingTargetsComponent.targetChannel"></div>
          </th>
          <th sxy-orderby="owner" colspan="2">
            <div sxy-text="SALAXY.NG1.AccountingTargetsComponent.owner"></div>
            <div sxy-text="SALAXY.NG1.AccountingTargetsComponent.status"></div>
          </th>

          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div title="{{ row.shortText }} ({{ row.id }})">
              <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong>
            </div>
          </td>
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div>{{ row.ownerInfo.avatar.displayName }}</div>
            <div>{{ "AccountingTargetStatus." + row.status | sxyEnum }}</div>
          </td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/modals/batch/default.html",`﻿<div class="salaxy-batch-default">
  <button ng-if="!$ctrl.autoStart" type="button" class="btn btn-primary" ng-disabled="$ctrl.isProcessStarted" ng-click="$ctrl.startProcess()">Aloita prosessi</button>
</div>`);

 $templateCache.put("salaxy-components/modals/batch/dialog.html",`<div class="modal-header">
  <h2 class="modal-title">{{ $ctrl.dialogHeader }}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body" id="modal-body">
  <div class="salaxy-batch-content" ng-include="$ctrl.batchTemplateUrl"></div>
  <hr/>
  <sxy-table ng-if="$ctrl.isReady" data="$ctrl.list" options="$ctrl.tableOptions" include="$ctrl.columns" ng-ref="$ctrl.$table"></sxy-table>
</div>
<div class="modal-footer">
  <h2 class="float-start" style="margin: 0" ng-if="$ctrl.processCounter.isProcessing || $ctrl.processCounter.isDone">
    {{ $ctrl.processCounter.isDone ? ('SALAXY.NG1.BatchProcessComponent.dialog.done' | sxyTranslate) : ('SALAXY.NG1.BatchProcessComponent.dialog.processing' | sxyTranslate) }}: {{ $ctrl.processCounter.processedCount }} / {{ $ctrl.processCounter.totalCount }}
    <span class="bg-danger" ng-if="$ctrl.processCounter.errorsCount">{{'SALAXY.NG1.BatchProcessComponent.dialog.errors' | sxyTranslate}}: {{ $ctrl.processCounter.errorsCount }}</span>
    <span class="bg-warning" ng-if="$ctrl.processCounter.canceling" sxy-text="SALAXY.NG1.BatchProcessComponent.dialog.canceling"></span>
  </h2>
  <h2 class="float-start" style="margin: 0" ng-if="!($ctrl.processCounter.isProcessing || $ctrl.processCounter.isDone)">
    {{'SALAXY.NG1.BatchProcessComponent.dialog.count' | sxyTranslate}}: {{ $ctrl.processCounter.totalCount }} ({{ $ctrl.list.length }})
  </h2>
  <button type="button" class="btn btn-danger" ng-click="$ctrl.cancelProcess()" ng-if="$ctrl.processCounter.isProcessing" sxy-text="SALAXY.NG1.BatchProcessComponent.dialog.stopProcessing"></button>
  <button type="button" class="btn btn-default" ng-click="$ctrl.close()" ng-if="!$ctrl.processCounter.isProcessing">{{'SALAXY.UI_Terms.close' | sxyTranslate}}</button>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/Calc.html",`<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <salaxy-calc model="$ctrl.current"></salaxy-calc>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.delete"></button>
    <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/CalcAccountingReportQuery.html",`<div class="modal-version-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title | sxyTranslate}}</h2>

    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-accounting-report-query lang="$ctrl.logic.lang" calcs="$ctrl.logic.calcs" view="$ctrl.logic.view"></salaxy-accouting-report-query>
  </div>
  <div class="modal-footer text-end">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/CalcIr.html",`<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-calcs-ir-rows calcs="[$ctrl.current]" class="report"></salaxy-calcs-ir-rows>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.close"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/CalcLeaves.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.calculationLegend"></h2>
  <button type="button" class="btn-close" ng-click="$close(null)" aria-label="Close"></button>
</div>
<div class="modal-body">
  <salaxy-calc-leaves ng-ref="$calcLeaves" calc="$ctrl.current.calc" worktime="$ctrl.current.worktime"></salaxy-calc-leaves>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default float-end" ng-click="$close(null)" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary float-end" ng-click="$close({absencesPeriods: $calcLeaves.getAbsencesPeriods()})" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/CalcList.html",`<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title | sxyTranslate}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <salaxy-calc-list category="{{ $ctrl.logic.category || 'draft' }}" options="$ctrl.logic.options" mode="select" selected-items="$ctrl.current"></salaxy-calc-list>
    </div>
    <div class="text-end">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="{{ $ctrl.logic.cancelButtonText || 'SALAXY.UI_Terms.cancel'}}"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="{{ $ctrl.logic.okButtonText || 'SALAXY.UI_Terms.save'}}"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/CalcRepaired.html",`<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{'SALAXY.ENUM.CalculationStatus.paymentRepairCopy.label' | sxyTranslate}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
        <table class="table table-striped">
          <thead>
            <tr>
              <th colspan="2">
                <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
              </th>
              <th class="hidden-xxs">
                <span sxy-text="SALAXY.UI_Terms.updated"></span><br />
                <span><span sxy-text="SALAXY.NG1.CalculationsWithSalaryDateSelectComponent.salaryDate"></span></span>
              </th>
              <th class="right hidden-xxs" colspan="2">
              </th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="row in $ctrl.current">
              <td class="td-avatar visible-xxs middle">
                <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
              </td>
              <td class="td-name visible-xxs middle">
                <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ row.updatedAt | date }}
                <br /> {{ row.salaryDate | date }}
              </td>
              <td class="right visible-xxs bottom">
                <a ng-href="#/calc/details/{{row.id}}">
                  {{ row.grossSalary | currency }}
                </a>
              </td>
              <td class="td-avatar hidden-xxs middle">
                <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
              </td>
              <td class="td-name hidden-xxs middle">
                <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
              </td>
              <td class="hidden-xxs middle">
                {{ row.updatedAt | date }}<br /> {{ row.salaryDate | date }}
              </td>
              <td class="right hidden-xxs middle">
                {{ row.grossSalary | currency }}
              </td>
              <td class="right middle">
                  <a ng-href="#/calc/details/{{row.id}}" class="btn btn-sm btn-default btn-block">
                    <i class="bi bi-info-lg visible-xs me-1"></i><span class="hidden-xs" sxy-text="SALAXY.UI_Terms.show"></span>
                  </a>
              </td>
            </tr>
          </tbody>
        </table>
    </div>
    <div class="text-end">
      <button type="reset" class="btn btn-default" ng-click="$close()" sxy-text="SALAXY.UI_Terms.close"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/CalcReports.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.CalcReportsComponent.calcReports" ></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body ">
  <salaxy-calc-reports calcs="$ctrl.data.calcs" preview="$ctrl.data.preview" view="{{ $ctrl.data.view || 'page1' }}" report-type="$ctrl.data.reportType"></salaxy-calc-reports>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/CfaPaymentOverview.html",`<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{ $ctrl.logic.title }}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">

    <style type="text/css">
      .left.carousel-control {
        background-image: none;
      }
      
      .right.carousel-control {
        background-image: none;
      }
      
      .right.carousel-control>span.glyphicon.glyphicon-chevron-right {
        color: var(--salaxy-brand-primary)
      }
      
      .left.carousel-control>span.glyphicon.glyphicon-chevron-left {
        color: var(--salaxy-brand-primary)
      }
      
      .carousel-indicators .active {
        background-color: var(--salaxy-brand-primary);
      }
      
      .carousel-indicators li {
        border-color: var(--salaxy-brand-primary);
      }
    </style>
      
    <p class="lead" sxy-text="SALAXY.NG1.CfaPaymentOverviewComponent.lead" ng-if="$ctrl.logic.isReadyForPayment"></p>
    <div class="alert alert-danger" ng-if="!$ctrl.logic.isReadyForPayment()">
      <p class="lead" sxy-html="SALAXY.NG1.PaymentDialogComponent.alert.html"></p>
    </div>
    <p class="lead" ng-if="$ctrl.logic.isReadyForPayment() && $ctrl.logic.instructions">
      {{ $ctrl.logic.instructions }}
    </p>
    <div ng-if="$ctrl.logic.type == 'calc'">
      <salaxy-calc-worker-info model="$ctrl.current"></salaxy-calc-worker-info>
      <p >
        <strong sxy-text="SALAXY.NG1.CalcDetailsWorkComponent.workEndStartDate" ps=":"></strong> {{$ctrl.current.info.workStartDate | date : 'dd.MM.yyyy'}}{{ $ctrl.current.info.workStartDate ? ' - ': ''}} {{$ctrl.current.info.workEndDate
        | date: 'dd.MM.yyyy'}}, {{$ctrl.current.framework.numberOfDays > 0 ? $ctrl.current.framework.numberOfDays : '?' }} {{'SALAXY.NG1.CfaPaymentOverviewComponent.days' | sxyTranslate}}.
      </p>
      <hr />
      <div class="table-responsive"> 
        <salaxy-calc-report apply-site-styles="true" calc="$ctrl.current" report-type="'paymentReport'" template-name="'paymentTablesV2'"></salaxy-calc-report>
      </div>
      <p sxy-html="SALAXY.NG1.PaymentDialogComponent.afterPayment.html" params="{totalPayment: ($ctrl.current.result.employerCalc.totalPayment | currency)}"></p>
      <p ng-if="$ctrl.current.result.employerCalc.householdDeduction > 0" sxy-html="SALAXY.NG1.PaymentDialogComponent.household.html" params="{householdDeduction: ($ctrl.current.result.employerCalc.householdDeduction | currency) }">
      </p>
    </div>
    <div ng-if="$ctrl.logic.type != 'calc'">
      <strong>{{'SALAXY.NG1.CfaPaymentOverviewComponent.totalPayments' | sxyTranslate}}: {{$ctrl.current.info.totalPayment | currency}}</strong><br />
      <strong>{{'SALAXY.NG1.CfaPaymentOverviewComponent.calculations' | sxyTranslate}}: {{$ctrl.current.calcs.length}}</strong><br />
      <hr />
      <div id="payroll-calcs-carousel" class="carousel carousel-dark slide" data-bs-interval="false">
        <div class="carousel-controls d-flex align-items-center justify-content-between mb-3">
          <button class="carousel-control-prev" type="button" data-bs-target="#payroll-calcs-carousel" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#payroll-calcs-carousel" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
          </button>
        </div>
        <div class="carousel-inner">
          <div ng-repeat="calc in $ctrl.current.calcs track by $index" index="$index" class="carousel-item" ng-class="{'active': $index == 0}">
            <strong>{{$index + 1}}/{{$ctrl.current.calcs.length}} {{calc.worker.avatar.sortableName}}</strong>
            <salaxy-calc-report calc="calc" apply-site-styles="true" report-type="'paymentReport'" template-name="'paymentTablesV2'"></salaxy-calc-report>
          </div>
        </div>
      </div>
      <p sxy-html="SALAXY.NG1.PaymentDialogComponent.afterPayment.html" params="{totalPayment: ($ctrl.current.info.totalPayment | currency)}"></p>
    </div>
    <div ng-if="$ctrl.logic.channel == 'palkkausCfaPaytrail' || $ctrl.logic.channel == 'palkkausEcfaPaytrail'">
      <p sxy-text="SALAXY.NG1.CfaPaymentOverviewComponent.palkkausCfaPaytrailInfo"></p>
      <p sxy-text="SALAXY.NG1.CfaPaymentOverviewComponent.palkkausCfaPaytrailInfoAlt"></p>
    </div>
  </div>
  <div class="modal-footer text-end">
    <button ng-if="$ctrl.logic.channel != 'palkkausCfaPaytrail' && $ctrl.logic.channel != 'palkkausEcfaPaytrail'" type="submit" class="btn btn-primary float-end" ng-disabled="!$ctrl.logic.isReadyForPayment()" ng-click="$close('ok')">
      {{ $ctrl.logic.okButtonText}}
    </button>
    <button ng-if="$ctrl.logic.channel == 'palkkausCfaPaytrail' || $ctrl.logic.channel == 'palkkausEcfaPaytrail'" type="submit" class="btn btn-primary float-end" ng-disabled="!$ctrl.logic.isReadyForPayment()" ng-click="$ctrl.logic.paymentFunc($ctrl.current);$close('ok')">
      {{ $ctrl.logic.okButtonText}}
    </button>
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/EditorConfirm.html",`<div class="modal-editor-confirm">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="Oletko varma?"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <p sxy-text="Hyväksynnän jälkeen päivitämme tulosteet ja raportoimme muutokset tulorekisteriin."></p>
    <p>&nbsp;</p>
    <form name="snapshotForm" class="form-horizontal">
      <salaxy-input-enum label="Syykoodi" name="reasonCode" ng-model="$ctrl.current.reasonCode" options="{
        1: 'Asiakkaan korjauspyyntö',
        2: 'Virheellinen laskelma',
        3: 'Palkkaus ohjelmistovirhe',
        4: 'Uusi ilmoitus/peruminen tulorekisteriin',
        }"></salaxy-input-enum>
      <salaxy-input-enum label="Vakavuusaste" name="severityCode" type="radio" ng-model="$ctrl.current.severityCode" options="{ 1:'1', 2:'2', 3 :'3', 4 :'4', 5:'5' }">
      </salaxy-input-enum>
      <div class="row">
        <label for="" class="col-4 col-form-label">
          <span class="label-text">Kategoriat</span>
        </label>
        <div class="col-8">
          <table>
            <tr>
              <td colspan="2" class="text-end"><button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.current.categories.push('')">Uusi kategoria</button></td>
            </tr>
            <tr>
              <td colspan="2">&nbsp;</td>
            </tr>
            <tr ng-repeat="category in $ctrl.current.categories track by $index">
              <td>
                  <salaxy-form-group name="category{{$index}}" label-type="plain">
                      <div>
                          <salaxy-input-typeahead
                            label-type="no-label"
                            ng-model="$ctrl.current.categories[$index]"
                            name="worker"
                            disable-cache="true"
                            placeholder=""
                            options="$ctrl.logic.categories">
                          </salaxy-input-typeahead>
                      </div>
                  </salaxy-form-group>
              </td>
              <td>
                  <button type="button" class="btn btn-danger btn-sm" ng-click="$ctrl.current.categories.splice($index,1)" title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}"><i class="bi bi-trash-fill"></i></button>
              </td>
          </tr>
          </table>
        </div>
      </div>

      <salaxy-textarea label="Kuvaus" name="description" ng-model="$ctrl.current.description"></salaxy-textarea>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    <button type="submit" class="btn btn-primary" ng-disabled="!snapshotForm.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/EmailSharing.html",`<div class="modal-email-sharing">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.EmailSharingComponent.title"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <p sxy-html="SALAXY.NG1.EmailSharingComponent.body.html"></p>
    <form name="emailForm" class="form-horizontal">
      <salaxy-input label="SALAXY.NG1.EmailSharingComponent.emailTo" name="to" type="text" require="true" ng-model="$ctrl.current.to" sxy-email></salaxy-input>
      <salaxy-input label="SALAXY.NG1.EmailSharingComponent.emailCC" name="cc" type="text" ng-model="$ctrl.current.cc" sxy-email></salaxy-input>
      <salaxy-textarea label="SALAXY.NG1.EmailSharingComponent.message" name="message" ng-model="$ctrl.current.message"></salaxy-textarea>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    <button type="submit" class="btn btn-primary" ng-disabled="!emailForm.$valid" ng-click="$close('ok')" sxy-text="SALAXY.NG1.EmailSharingComponent.sendEmail"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/PalkkausPersonalPaymentOverview.html",`<div class="modal-header">
  <h2 class="modal-title">{{ $ctrl.editDialogParameters.logic.isInspectingPaidInvoices ? ('SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.titleInspect' | sxyTranslate) : ('SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.title' | sxyTranslate) }}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" ng-controller="InvoicesCreateController as $invCreate">
  <div class="d-block d-md-none d-print-none" ng-init="$invCreate.model=$ctrl.model">
    <h4><span sxy-text="SALAXY.NG1.WorkerWizardComponent.wizard.step"></span> {{$ctrl.currentStep.number}}/{{$ctrl.steps.length}}</h4>
  </div>
  <div class="salaxy-wizard d-print-none">
    <div class="wizard-steps">
      <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
        <span class="salaxy-avatar">
          <div class="wizard-icons-wrapper">
            <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
            <i class="bi bi-circle-fill"></i>
          </div>
          <strong class="number">{{ step.number }}</strong>
        </span>
        <span class="step-text">{{ step.title | sxyTranslate }}</span>
      </div>
    </div>
    <div class="wizard-strikethrough"></div>
  </div>
  <div class="worker-wizard-content">
    <ng-include src="$ctrl.currentStep.view"></ng-include>
  </div>
</div>
<div class="modal-footer d-print-none">
  <button ng-if="$ctrl.step < 2 && !$ctrl.editDialogParameters.logic.isInspectingPaidInvoices" ng-click="$close('cancel')" class="btn float-start btn-default" sxy-text="SALAXY.UI_Terms.close"></button>
  <button ng-if="$ctrl.editDialogParameters.logic.isInspectingPaidInvoices && $ctrl.step == 3" ng-click="$close('cancel')" class="btn btn-default" sxy-text="SALAXY.UI_Terms.close"></button>
  <button ng-if="$ctrl.step >= 2" ng-click="$ctrl.goPrevious()" ng-disabled="!$ctrl.canGoPrevious" class="btn float-start btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
  <button ng-if="$ctrl.step &lt; $ctrl.steps.length" ng-click="$ctrl.goNext()" ng-disabled="!$ctrl.canGoNext" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>
</div>
`);

 $templateCache.put("salaxy-components/modals/calc/PaymentOverview.html",`<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{ $ctrl.$invCreate.title }}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body overflow-auto">
    <salaxy-invoices-create model="$ctrl.current" ng-ref="$ctrl.$invCreate"></salaxy-invoices-create>
  </div>
  <div class="modal-footer text-start">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="submit" class="btn btn-primary float-end" ng-if="$ctrl.$invCreate.getOkBtn()" ng-click="$ctrl.$invCreate.createInvoices($close)">
      {{ $ctrl.$invCreate.getOkBtn() }}
    </button>
    <div ng-if="$ctrl.logic.channel == 'palkkausPersonal'">
      <div>
        <b>Debug</b><br>
        <salaxy-json-formatter json="$ctrl.$invCreate.invoices" open="1"></salaxy-json-formatter>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/personal-payment/Approval.html",`<div ng-controller="InvoicesCreateController as $invCreate" ng-init="$invCreate.model=$ctrl.model">
  <section>
    <h3 sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.title"></h3>
    <p class="lead" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.text"></p>      
  </section>
  <section>
    <h3 sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.buttonInfoText"></h3>
    <p class="lead" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.irInfo"></p>
  </section>
  <section ng-if="$ctrl.eprPaymentWarning && $invCreate.primaryCalcNetInvoicePreview && $invCreate.primaryCalcNetInvoicePreview.invoice.status !== 'paid'">
    <p class="lead">{{$ctrl.eprPaymentWarning}}</p>
  </section>
  <section ng-if="$ctrl.eprCancelWarning && $invCreate.primaryCalcNetInvoicePreview && $invCreate.primaryCalcNetInvoicePreview.invoice.status === 'paid'">
    <p class="lead">{{$ctrl.eprCancelWarning}}</p>
  </section>
 
  <button ng-click="$close('paid')" ng-if="$invCreate.primaryCalcNetInvoicePreview && ( $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'unread' || $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'read' ||  $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'waitingConfirmation' )"
  type="button" class="btn btn-success" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.acceptButton"></button>
  <button ng-click="$close('cancel')" ng-if="$invCreate.primaryCalcNetInvoicePreview && $invCreate.primaryCalcNetInvoicePreview.exists == false" type="button" class="btn btn-danger"  sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.notPaidInfo"></button>
  <button ng-click="$close('canceled')" ng-if="$invCreate.primaryCalcNetInvoicePreview &&  $invCreate.primaryCalcNetInvoicePreview.exists == true && ( $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'unread' || $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'read' ||  $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'waitingConfirmation' )"
    type="button" class="btn btn-danger"  sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.declineButton"></button>
  <button ng-click="$close('canceled')" ng-if="$invCreate.primaryCalcNetInvoicePreview && $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'paid'" type="button" class="btn btn-danger"  sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.cancelInfo"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/personal-payment/SideCosts.html",`<section>
  <h3 sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.title"></h3>
  <p class="lead" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.text"></p>   
  <ul>
    <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.listItem1"></li>
    <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.listItem2"></li>
    <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.listItem3"></li>
  </ul>
  <p class="lead" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.textAlt"></p>
</section>`);

 $templateCache.put("salaxy-components/modals/calc/personal-payment/Tax.html",`<div ng-controller="InvoicesCreateController as $invCreate" ng-init="$invCreate.model=$ctrl.model">
  <div class="d-print-none" ng-if="$invCreate.primaryCalcNetInvoicePreview.invoice.status == 'paid'">
    <p class="lead">
      <button type="button" class="btn btn-primary float-end" onclick="window.print()" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.printInvoices"></button> {{'SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.paid.paidInspectTax' |
      sxyTranslate}}
    </p>
    <div ng-if="$invCreate.primaryCalcTaxInvoicePreview" class="credit-transfer-container">
      <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcTaxInvoicePreview" mode="official">
        <message>
          <p sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.tax"></p>
          <p style="text-transform: none;" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.taxInfo.html"></p>
        </message>
      </salaxy-credit-transfer>
    </div>
  </div>
  <div class="d-print-none" ng-if="$invCreate.primaryCalcNetInvoicePreview && $invCreate.primaryCalcNetInvoicePreview.invoice.status != 'paid'">
    <section>
      <h3 sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step2.title"></h3>
      <button type="button" class="btn btn-primary float-end" onclick="window.print()" sxy-text="Tulosta"></button>
      <p class="lead" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step2.text.html"></p>
    </section>
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.receiver"></th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.iban"></th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.reference"></th>
          <th class="right" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.dueDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.sum"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th rowspan="2" style="font-size: 2em;"></th>
          <th>{{ $invCreate.primaryCalcTaxInvoicePreview.invoice.otherPartyInfo.avatar.displayName }}</th>
          <th>{{ $invCreate.primaryCalcTaxInvoicePreview.invoice.otherPartyInfo.ibanNumber }}</th>
          <th sxy-if-role="test">{{ $invCreate.primaryCalcTaxInvoicePreview.invoice.reference || "RF02 TEST 1234" }}</th>
          <th sxy-if-role="!test">{{ $invCreate.primaryCalcTaxInvoicePreview.invoice.reference || ('SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.checkReference' | sxyTranslate) }}</th>
          <th class="right">{{ $invCreate.primaryCalcTaxInvoicePreview.invoice.data.dueDate | sxyDate }}</th>
          <th class="right">{{ $invCreate.primaryCalcTaxInvoicePreview.invoice.payment | currency }}</th>
        </tr>
        <tr class="no-border">
          <td colspan="5">
            <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcTaxInvoicePreview" mode="barcode-copy">
          </td>
        </tr>
      </tbody>
    </table>
    <div ng-if="$invCreate.primaryCalcTaxInvoicePreview" class="credit-transfer-container">

      <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcTaxInvoicePreview" mode="official">
        <message>
          <p sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.tax"></p>
          <p style="text-transform: none;" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.taxInfo.html"></p>
        </message>
      </salaxy-credit-transfer>
    </div>
  </div>
  <div class="d-none d-print-block">
    <h1 ng-if="!$ctrl.editDialogParameters.logic.isInspectingPaidInvoices" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.heading"></h1>
    <div ng-if="$invCreate.primaryCalcTaxInvoicePreview" class="credit-transfer-container">
      <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcTaxInvoicePreview" mode="official">
        <message>
          <p>Ennakonpidätys</p>
          <p style="text-transform: none;" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.taxInfo.html"></p>
        </message>
      </salaxy-credit-transfer>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/personal-payment/TotalWorkerPayment.html",`<div ng-controller="InvoicesCreateController as $invCreate" ng-init="$invCreate.model=$ctrl.model">
  <div ng-if="!$invCreate.isValid">
    <p sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.invalidCalc"></p>
    <salaxy-validation-summary api-validation="$invCreate.current.result.validation"></salaxy-validation-summary>
  </div>
  <div ng-if="$invCreate.paymentStatus == 'canceled'">
    <p class="lead" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.canceled.lead"></p>
    <p sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.canceled.salaryAlreadyPaid"></p>
    <ul>
      <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.canceled.salaryAlreadyPaidInfo1"></li>
      <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.canceled.salaryAlreadyPaidInfo2"></li>
      <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.canceled.salaryAlreadyPaidInfo3"></li>
      <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.canceled.salaryAlreadyPaidInfo4"></li>
    </ul>
  </div>
  <div class="d-print-none" ng-if="$invCreate.primaryCalcNetInvoicePreview.invoice.status == 'paid'">
    <p class="lead">
      <button type="button" class="btn btn-primary float-end" onclick="window.print()" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.printInvoices"></button> {{'SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.paid.paidInspectNet' |
      sxyTranslate}}
    </p>
    <div ng-if="$invCreate.primaryCalcNetInvoicePreview" class="credit-transfer-container">
      <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcNetInvoicePreview" mode="official">
        <message>
          <p sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.salary"></p>
          <p style="text-transform: none;" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.salaryInfo.html"></p>
        </message>
      </salaxy-credit-transfer>
    </div>
  </div>
  <div class="d-print-none" ng-if="$invCreate.primaryCalcNetInvoicePreview && $invCreate.primaryCalcNetInvoicePreview.invoice.status != 'paid'">
    <section>
      <h3 sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step1.title"></h3>
      <button type="button" class="btn btn-primary float-end" onclick="window.print()" sxy-text="Tulosta"></button>
      <p class="lead" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step1.text.html"></p>
    </section>
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.receiver"></th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.iban"></th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.reference"></th>
          <th class="right" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.dueDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.sum"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th rowspan="2" style="font-size: 2em;"></th>
          <th>{{ $invCreate.primaryCalcNetInvoicePreview.invoice.otherPartyInfo.avatar.displayName }}</th>
          <th>{{ $invCreate.primaryCalcNetInvoicePreview.invoice.otherPartyInfo.ibanNumber }}</th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.salary"></th>
          <th class="right">{{ $invCreate.primaryCalcNetInvoicePreview.invoice.data.dueDate | sxyDate }}</th>
          <th class="right">{{ $invCreate.primaryCalcNetInvoicePreview.invoice.payment | currency }}</th>
        </tr>
        <tr class="no-border">
          <td colspan="5">
            <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcNetInvoicePreview" mode="barcode-copy">
          </td>
        </tr>
      </tbody>
    </table>
    <div ng-if="$invCreate.primaryCalcNetInvoicePreview" class="credit-transfer-container">
      <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcNetInvoicePreview" mode="official">
        <message>
          <p sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.salary"></p>
          <p style="text-transform: none;" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.salaryInfo.html"></p>
        </message>
      </salaxy-credit-transfer>
    </div>
  </div>
  <div class="d-none d-print-block">
    <h1 ng-if="!$ctrl.editDialogParameters.logic.isInspectingPaidInvoices" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.heading"></h1>
    <div ng-if="$invCreate.primaryCalcNetInvoicePreview" class="credit-transfer-container">
      <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcNetInvoicePreview" mode="official">
        <message>
          <p>Palkka</p>
          <p style="text-transform: none;" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.salaryInfo.html"></p>
        </message>
      </salaxy-credit-transfer>
    </div>
  </div>

</div>`);

 $templateCache.put("salaxy-components/modals/calc/PSDPaymentOverview.html",`<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{ $ctrl.$invCreate.title }}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-invoices-create model="$ctrl.current" ng-ref="$ctrl.$invCreate"></salaxy-invoices-create>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    
    <button type="submit" class="btn btn-secondary ms-auto" ng-disabled="!$ctrl.logic.isReadyForPayment()" ng-click="$close('create-invoices-pay-later')">
      Luo maksut ja maksa myöhemmin
    </button>
    <button type="submit" class="btn btn-primary" ng-disabled="!$ctrl.logic.isReadyForPayment()" ng-click="$close('create-invoices-pay-now')">
      Maksa nyt
    </button>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/row-type-select.html",`<div class="salaxy-component salaxy-calc-details-dialog">
  <div class="card card-list" ng-class="'card-' + ($ctrl.logic.rowTypeSelectHelp || 'primary')">
    <div class="card-header d-flex align-items-center p-3">
      <h1>{{ "SALAXY.NG1.CalcDetailsDialogComponent." + ($ctrl.logic.rowTypeSelectHelp || "all") + ".title" | sxyTranslate }}</h1>
      <button type="button" class="btn-close ms-auto" ng-click="$close('cancel')" aria-label="Close"></button>
    </div>
    <div class="card-body" ng-if="$ctrl.logic.rowTypeSelectHelp">
      <p>{{ "SALAXY.NG1.CalcDetailsDialogComponent." + ($ctrl.logic.rowTypeSelectHelp || "all") + ".intro" | sxyTranslate }}</p>
    </div>
    <salaxy-calc-row-type name="rowType" type="list" model="$ctrl.current"
      categories="$ctrl.logic.categories"
      row-types="$ctrl.logic.rowTypes"
      on-row-changed="$close('ok')" label-type="plain"></salaxy-calc-row-type>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/SalaryDateKind.html",`<div class="modal-body modal-salary-date-kind">
  <form class="mb-2 form-horizontal">
    <legend sxy-text="{{$ctrl.logic.text}}"></legend>
    <p sxy-html="{{$ctrl.logic.title}}"></p>
  </form>
  <div class="text-end">
    <button class="btn btn-sm btn-default" ng-click="$dismiss()" sxy-text="SALAXY.UI_Terms.close"></button>
    <button class="btn btn-sm btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.select"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/SalaryDateKindInputEnum.html",`<ng-form name="{{$ctrl.name}}Form" class="salaxy-input-enum">
  <salaxy-form-group ng-if="$ctrl.type=='radio'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="radio" ng-repeat="x in $ctrl.getEnumerations()">
      <label class="control-label radio-label" for="{{x.value}}">
        <input ng-disabled="$ctrl.getDisabled()" type="radio" ng-model="$ctrl.value" ng-change="$ctrl.onChange()" class="" name="{{$ctrl.label}}" id="{{x.value}}" value="{{x.value}}"
          title="{{x.title | sxyTranslate}}">
          <strong>{{$ctrl.formatLabel(x)}}</strong>
          <p ng-if="x.title" class="text-small">{{ x.title | sxyTranslate }}</p>
      </label>
    </div>
  </salaxy-form-group>
</ng-form>`);

 $templateCache.put("salaxy-components/modals/calc/SelectRuleset.html",`
<div class="modal-header">
  <h2 class="modal-title">{{$ctrl.logic.title | sxyTranslate}}</h2>

  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" style="max-height: calc(100vh - 300px); overflow-y: auto;">
  <table class="table table-sm table-hover">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.entry.rulesetSelection.account"></th>
        <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.entry.rulesetSelection.description"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="ruleset in $ctrl.logic.items" class="clickable"  ng-click="$close(ruleset)">
        <td>{{ruleset.account}}</td>
        <td>{{ruleset.text}}</td>
      </tr>
    </tbody>
  </table>
  <salaxy-spinner ng-if="!$ctrl.logic.items.length"></salaxy-spinner>
</div>
<div class="modal-footer text-end">
  <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/SelectVersion.html",`<div class="modal-version-list">
  <div class="modal-header">
    <h2 class="modal-title">{{"Valitse versio" | sxyTranslate}}</h2>

    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <style>
      .table-hover>tbody>tr:hover>td,
      .table-hover>tbody>tr:hover>th {
        background-color: var(--salaxy-brand-info);
        ;
        text-decoration: none;
      }
    </style>
    <table class="table table-sm table-hover">
      <thead>
        <tr>
          <th colspan="2" sxy-text="SALAXY.NG1.CalcComponent.versions.creator"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcComponent.versions.date"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.data.versions" class="clickable" ng-class="{ 'bg-success': $ctrl.data.versionId == row.versionId }" ng-click="$close(row)">
          <td class="align-middle td-avatar">
            <salaxy-avatar avatar="row.userAccount"></salaxy-avatar>
          </td>
          <td class="td-name">
            {{row.userAccount.displayName}}
          </td>
          <td class="right">
            <span>{{row.date | date: 'd.M.yyyy HH:mm:ss' }}</span><br />
          </td>
        </tr>
      </tbody>
    </table>
    <salaxy-spinner ng-if="!$ctrl.data.versions.length"></salaxy-spinner>
  </div>
  <div class="modal-footer text-end">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/TaxcardSelect.html",`<div class="modal-taxcard-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title | sxyTranslate}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <salaxy-taxcard-list mode="select" selected-items="$ctrl.current" options="$ctrl.logic.options" ng-ref="$taxcardList" on-list-select="$taxcardList.selectedItems.splice(0, $taxcardList.selectedItems.length);(value == true ? $taxcardList.selectedItems.push(item) : null);"></salaxy-taxcard-list>
    </div>
    <div class="text-right">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="{{ $ctrl.logic.cancelButtonText || 'SALAXY.UI_Terms.cancel'}}"></button>
      <button type="submit" ng-disabled="$taxcardList.selectedItems.length != 1" class="btn btn-primary" ng-click="$close('ok')" sxy-text="{{ $ctrl.logic.okButtonText || 'SALAXY.UI_Terms.save'}}"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/WorkerList.html",`<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title | sxyTranslate}}</h2>

    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <span ng-if="$ctrl.logic.infoHtml" sxy-html="{{$ctrl.logic.infoHtml}}"></span>
    <div class="list-content">
      <salaxy-employment-list mode="multiselect" selected-items="$ctrl.current"></salaxy-employment-list>
    </div>
    <div class="text-end">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')">{{$ctrl.logic.okButtonText ? ($ctrl.logic.okButtonText | sxyTranslate) : ('SALAXY.UI_Terms.save' | sxyTranslate)}}</button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/WorkerSelect.html",`<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title | sxyTranslate}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <span ng-if="$ctrl.logic.infoHtml" sxy-html="{{$ctrl.logic.infoHtml}}"></span>
    <div class="list-content">
      <salaxy-employment-list mode="select" selected-items="$ctrl.current" ng-ref="$employmentsList" on-list-select="$employmentsList.selectedItems.splice(0, $employmentsList.selectedItems.length);(value == true ? $employmentsList.selectedItems.push(item) : null);"></salaxy-employment-list>
    </div>
    <div class="text-end">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')">{{$ctrl.logic.okButtonText ? ($ctrl.logic.okButtonText | sxyTranslate) : ('SALAXY.UI_Terms.save' | sxyTranslate)}}</button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/calc/WSPaymentOverview.html",`<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{ $ctrl.$invCreate.title }}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-invoices-create model="$ctrl.current" ng-ref="$ctrl.$invCreate"></salaxy-invoices-create>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="submit" class="btn btn-primary ms-auto" ng-if="$ctrl.$invCreate.getOkBtn()" ng-click="$ctrl.$invCreate.createInvoices($close)">
      {{ $ctrl.$invCreate.getOkBtn() }}     
    </button>
    
</div>`);

 $templateCache.put("salaxy-components/modals/communications/VarmaPopup.html",`<div class="modal-ui-translation">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.current.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <p ng-bind-html="$ctrl.current.message"></p>
    <div class="row">
      <div class="col-12 mt-2">
        <button class="btn btn-default float-start" sxy-text="SALAXY.UI_Terms.close" ng-click="$close('cancel')"></button>
        <a class="btn btn-primary float-end" href="{{$ctrl.current.varmaShopLink}}" target="_blank" sxy-text="{{$ctrl.current.btnText}}"></a>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/date-range/DateRange.html",`<div class="modal-body modal-date-range">
  <form class="mb-2 form-horizontal">
    <salaxy-date-range ng-model="$ctrl.current" label="{{ $ctrl.logic.title }}" name="dateRange" label-type="basic"></salaxy-date-range>
  </form>
  <div class="text-end">
    <button class="btn btn-sm btn-default" ng-click="$dismiss()" sxy-text="{{ $ctrl.logic.cancelText }}"></button>
    <button class="btn btn-sm btn-primary" ng-click="$close('ok')" sxy-text="{{ $ctrl.logic.okText }}"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/export/Export.html",`<div class="modal-header">
  <h2 class="modal-title" id="salaxyODataExportTitle">{{ 'SALAXY.NG1.ODataExportComponent.heading' | sxyTranslate }}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body" id="modal-body">
  <div class="btn-toolbar" role="toolbar" aria-label="Export options">
    <div class="btn-group dropdown">
      <button id="exportMapper" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        {{ $ctrl.data.$parent.mapper.title }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="exportMapper">
        <li role="menuitem" ng-repeat="mapper in $ctrl.data.$parent.allMappers">
          <a href="" ng-click="$ctrl.data.$parent.setExportMapper(mapper)" class="dropdown-item">{{mapper.title}}</a></li>
      </ul>
    </div>
    <div class="btn-group dropdown ms-1">
      <button id="exportFileType" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        {{ $ctrl.data.$parent.currentExporter.label }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="exportFileType">
        <li role="menuitem" ng-repeat="exporter in $ctrl.data.$parent.exporters">
          <a href="" ng-click="$ctrl.data.$parent.currentExporter = exporter" class="dropdown-item">{{ exporter.label }}</a></li>
      </ul>
    </div>
    <salaxy-input-enum name="localeId" type="dropdown" enum="Culture" label-type="plain" label-format="title" ng-model="$ctrl.data.$parent.localeId"
      ng-if="$ctrl.data.$parent.currentExporter.hasLocales"></salaxy-input-enum>
    <salaxy-input-enum name="maxCount" type="dropdown" label-type="plain" label-format="title" ng-model="$ctrl.data.$parent.maxCount"
      options="$ctrl.data.$parent.maxCountOptions"></salaxy-input-enum>
    <div class="btn-group ms-auto" sxy-if-role="test">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.data.$parent.toggleDebug()">Debug <span class="badge">test</span></button>
    </div>
  </div>
  <div ng-if="$ctrl.data.$parent.isDebug">
    <salaxy-data-mapper model="$ctrl.data.$parent.mapper" type="debug"></salaxy-data-mapper>
  </div>
  <div class="table-responsive" style="padding-top: 5vh; text-align:center">
    <button id="exportNonQuick" type="button" class="btn btn-primary" ng-click="$ctrl.data.$parent.export()">
      <span ng-show="!$ctrl.data.$parent.isExporting">{{ 'SALAXY.NG1.ODataExportComponent.createMaterial' | sxyTranslate }} <i class="bi bi-download"></i></span>
      <span ng-show="$ctrl.data.$parent.isExporting">{{ 'SALAXY.NG1.ODataExportComponent.createMaterial' | sxyTranslate }} <i class="bi bi-arrow-repeat bi-spin"></i></span>
    </button>
    <div ng-show="$ctrl.data.$parent.isExporting"><small>&nbsp;{{$ctrl.data.$parent.exportMessage}}</small></div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/form-controls/PayStatsRowTypeEdit.html",`<div class="modal-header">
  <h2 class="modal-title" id="payStatsRowTypeHeader" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.type"></h2>
  <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
</div>
<div class="modal-body">
  <form name="payStatsRowType" class="form-horizontal" ng-readonly="$ctrl.logic.readOnly">
    <salaxy-input-enum label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.type" name="baseType" type="radio" options="{'incomeType': 'SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.incomeType', 'rowType' : 'SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.rowType', 'type': 'SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.wageType'}" ng-model="$ctrl.current.baseType" require="true"></salaxy-input-enum>
    <salaxy-input-income-type ng-if="$ctrl.current.baseType == 'incomeType'" label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.incomeType" name="code" ng-model="$ctrl.current.type" hidden-codes="[1]">
    </salaxy-input-income-type>
    <salaxy-form-group ng-if="$ctrl.current.baseType == 'rowType'" name="rowTypeLabel" label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.rowType">
      <salaxy-calc-row-type label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.rowType" name="rowType" model="$ctrl.logic.asUserDefinedRow($ctrl.current)" clear-on-select="false"></salaxy-calc-row-type>
    </salaxy-form-group>
    <salaxy-form-group ng-if="$ctrl.current.baseType == 'type'" name="type" label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.wageType">
      <salaxy-calc-row-type label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.wageType" name="type" model="$ctrl.logic.asUserDefinedRow($ctrl.current)" clear-on-select="false"></salaxy-calc-row-type>
    </salaxy-form-group>
    <salaxy-input-boolean label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.exclusive" name="isExclusive" ng-model="$ctrl.current.isExclusive"></salaxy-input-boolean>
    <salaxy-input-enum ng-if="$ctrl.current.baseType == 'incomeType' && $ctrl.current.type == '201'" label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.unit" enum="CalculationRowUnit" hidden-options="[]" filter="undefined,hours" name="unit" ng-model="$ctrl.current.unit"></salaxy-input-enum>
  </form>
</div>
<div class="modal-footer">
  <button type="reset" ng-if="!$ctrl.logic.readOnly" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="button" ng-if="$ctrl.logic.readOnly" class="btn btn-primary" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" ng-if="!$ctrl.logic.readOnly" class="btn btn-primary" ng-disabled="!payStatsRowType.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>
`);

 $templateCache.put("salaxy-components/modals/import/Import.html",`<div>
  <div class="modal-header">
    <h2 class="modal-title" id="salaxyODataExportTitle">{{'SALAXY.NG1.ODataImportComponent.heading' | sxyTranslate}} {{$ctrl.currentStep.number}}/{{$ctrl.steps.length}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body" id="modal-body">
    <div class="salaxy-wizard">
      <div class="wizard-steps">
        <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
          <span class="salaxy-avatar">
            <div class="wizard-icons-wrapper">
              <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
              <i class="bi bi-circle-fill"></i>
            </div>
            <strong class="number">{{ step.number }}</strong>
          </span>
          <span class="step-text">{{ step.title | sxyTranslate }}</span>
        </div>
      </div>
      <div class="wizard-strikethrough"></div>
    </div>
    <div class="wizard-content">
      <ng-include src="$ctrl.currentStep.view"></ng-include>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/import/ImportStep1.html",`<div ng-if="!$ctrl.data.$parent.api" class="alert alert-danger">
  ERROR: No API selected.
</div>
<div ng-if="$ctrl.data.$parent.api">
  <div ng-if="$ctrl.data.$parent.api" class="btn-toolbar" role="toolbar" aria-label="Data options">
    <div class="btn-group" role="group">
      <button type="button" class="btn btn-default" ng-click="$ctrl.data.$parent.pasteFromClipboard()">
        <span>{{'SALAXY.NG1.ODataImportComponent.step1.pasteFromDesktop' | sxyTranslate}} <i class="bi bi-clipboard"></i></span></button>
      <button type="button" class="btn btn-default" ngf-select="$ctrl.data.$parent.readFile($file)" ngf-multiple="false" ngf-max-size="10MB">
        <span>{{'SALAXY.NG1.ODataImportComponent.step1.downloadFile' | sxyTranslate}}... <i class="bi bi-file-earmark-text"></i></span>
      </button>
    </div>
  </div>
  <textarea ng-model="$ctrl.data.$parent.batch.rawData" style="width: 100%; height: 300px;" placeholder="{{'SALAXY.NG1.ODataImportComponent.step1.copyExcelFileFromClipboard' | sxyTranslate}}"></textarea>
</div>
<div class="modal-footer">
  <button ng-disabled="!$ctrl.data.$parent.batch.rawData" ng-click="$ctrl.data.$parent.readBatch();$ctrl.goNext()" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/import/ImportStep2.html",`<salaxy-validation-summary api-validation="$ctrl.data.$parent.lastResult"></salaxy-validation-summary>
<div class="btn-toolbar" role="toolbar" aria-label="Read options">
  <div class="btn-group dropdown">
    <button id="importMapper" type="button" class="btn dropdown-toggle" ng-class="$ctrl.data.$parent.mapper ? 'btn-primary' : 'btn-danger'" data-bs-toggle="dropdown">
      {{$ctrl.data.$parent.mapper ? $ctrl.data.$parent.mapper.title : ('SALAXY.NG1.ODataImportComponent.step2.chooseMaterial' | sxyTranslate) }}
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="importMapper">
      <li role="menuitem" ng-repeat="mapper in $ctrl.data.$parent.objectMappers">
        <a href="" ng-click="$ctrl.data.$parent.setMapper(mapper.value)" class="dropdown-item">{{mapper.text}}</a>
      </li>
    </ul>
  </div>
  <div class="btn-group dropdown ms-1">
    <button id="importFileType" type="button" class="btn dropdown-toggle" ng-class="$ctrl.data.$parent.currentFileParser ? 'btn-primary' : 'btn-danger'" data-bs-toggle="dropdown">
      {{ $ctrl.data.$parent.currentFileParser.label || ('SALAXY.NG1.ODataImportComponent.step2.chooseFiletype' | sxyTranslate) }}
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="importFileType">
      <li role="menuitem" ng-repeat="parser in $ctrl.data.$parent.fileParsers">
        <a href="" ng-click="$ctrl.data.$parent.currentFileParser = parser;$ctrl.data.$parent.readBatch()" class="dropdown-item">{{ parser.label }}</a>
      </li>
    </ul>
  </div>
  <salaxy-input-enum name="localeId" type="dropdown" enum="Culture" label-type="plain" label-format="title" ng-model="$ctrl.data.$parent.localeId"
    ng-change="$ctrl.data.$parent.readBatch()"
    ng-if="$ctrl.data.$parent.currentFileParser.hasLocales"></salaxy-input-enum>
  <div class="btn-group ms-auto" sxy-if-role="test">
    <button type="button" class="btn btn-primary" ng-click="$ctrl.data.$parent.toggleDebug()">Debug <span class="badge">test</span></button>
  </div>
</div>
<div ng-if="!$ctrl.data.$parent.batch.unmappedData.data.length" class="table-responsive" style="padding-top: 5vh; padding-bottom: 10vh; text-align:center">
  <span></span>
</div>
<div ng-if="$ctrl.data.$parent.batch.unmappedData.data.length" class="table-responsive" style="width: 100%; min-height: 300px; max-height: calc(100vh - 450px);">
  <salaxy-data-mapper ng-if="!$ctrl.data.$parent.isDebug" model="$ctrl.data.$parent.batch.parserMapper"></salaxy-data-mapper>
  <salaxy-data-mapper ng-if="$ctrl.data.$parent.isDebug" model="$ctrl.data.$parent.batch.parserMapper" type="debug"></salaxy-data-mapper>
</div>
<div class="modal-footer">
  <button ng-click="$ctrl.goPrevious()" class="btn float-start btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
  <button ng-click="$ctrl.data.$parent.mapBatch();$ctrl.goNext()" ng-disabled="!$ctrl.data.$parent.batch.unmappedData.data.length || !$ctrl.data.$parent.mapper" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/import/ImportStep3.html",`<div ng-init="$ctrl.data.$parent.validateBatch()">
  <div class="alert alert-danger" ng-if="$ctrl.data.$parent.batch.hasDataValidationErrors" sxy-text="SALAXY.NG1.ODataImportComponent.step3.error"></div>
  <div class="btn-toolbar" role="toolbar" aria-label="Validation options">
    <div class="btn-group" role="group">
      <button id="validate" type="button" class="btn btn-default" ng-click="$ctrl.data.$parent.validateBatch()">
        <span>{{ 'SALAXY.NG1.ODataImportComponent.step3.check' | sxyTranslate }}
          <i class="bi" ng-class="$ctrl.data.$parent.progress ? 'bi-arrow-repeat bi-spin' : 'bi-check-lg'"></i></span>
      </button>
      <div ng-show="$ctrl.data.$parent.progress"><small>&nbsp;{{$ctrl.data.$parent.progressMessage}}</small></div>
    </div>
    <div class="btn-group ms-1">
      <button class="btn btn-default" ng-click="$ctrl.showTarget = false" ng-class="{ active: !$ctrl.showTarget }">Lähdedata</button>
      <button class="btn btn-default" ng-click="$ctrl.showTarget = true" ng-class="{ active: $ctrl.showTarget }">Kohdedata</button>
    </div>
    <div class="btn-group ms-auto" sxy-if-role="test">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.data.$parent.toggleDebug()">Debug <span class="badge">test</span></button>
    </div>
  </div>
  <div ng-if="$ctrl.data.$parent.isDebug">
    <salaxy-data-mapper model="$ctrl.data.$parent.batch.mapper" type="debug"></salaxy-data-mapper>
  </div>
  <div ng-if="$ctrl.showTarget && $ctrl.data.$parent.batch.data.length" class="table-responsive" style="width: 100%; min-height: 300px; max-height: calc(100vh - 450px);">
    <salaxy-data-mapper model="$ctrl.data.$parent.batch.mapper" type="target-value"></salaxy-data-mapper>
  </div>
  <div ng-if="!$ctrl.showTarget && $ctrl.data.$parent.batch.data.length" class="table-responsive" style="width: 100%; min-height: 300px; max-height: calc(100vh - 450px);">
    <salaxy-data-mapper model="$ctrl.data.$parent.batch.mapper" type="source-value"></salaxy-data-mapper>
  </div>
  <div class="modal-footer">
    <button ng-click="$ctrl.goPrevious()" class="btn float-start btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
    <button ng-click="$ctrl.data.$parent.clearLastResult();$ctrl.goNext()" ng-disabled="!$ctrl.data.$parent.batch.isDataValid" class="btn btn-primary ms-auto" sxy-text="SALAXY.UI_Terms.next"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/import/ImportStep4.html",`<div class="alert alert-danger" ng-if="$ctrl.data.$parent.batch.hasDataValidationErrors" sxy-text="SALAXY.NG1.ODataImportComponent.step4.error"></div>
<div class="btn-toolbar" role="toolbar" aria-label="Import options">
  <div class="btn-group" role="group">
    <div ng-show="$ctrl.data.$parent.progress"><small>&nbsp;{{$ctrl.data.$parent.progressMessage}}</small></div>
  </div>
</div>
<div ng-if="$ctrl.data.$parent.batch.data.length" class="table-responsive" style="width: 100%; min-height: 300px; max-height: calc(100vh - 450px);">
  <table class="table table-sm">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.ODataImportComponent.step4.okey"></th>
        <th ng-repeat="header in $ctrl.data.$parent.mapper.target.keys">{{header}}</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.data.$parent.batch.data">
        <td>
          <div ng-if="row.validation && row.validation.errors && row.validation.errors.length" ng-repeat="error in row.validation.errors">
            <button type="button" class="btn btn-danger" data-bs-toggle="popover" data-bs-html="true" data-bs-content="{{ error.msg }}" data-bs-title="{{ error.code }}" sxy-bs5-popover>{{ error.code }}</button><br>
          </div>
          <div ng-if="row.validation && row.validation.isValid">
            <span class="text-success" sxy-text="SALAXY.NG1.ODataImportComponent.step4.okey"></span>
          </div>
        </td>
        <td ng-repeat="header in $ctrl.data.$parent.mapper.target.keys" ng-switch="header">
          <!-- HACK: use type information instead of field name to format (or use sxyGrid.) -->
          <span ng-switch-when="employment">
            <salaxy-avatar style="font-size: 18px;" avatar="row.employment.personalInfo.avatar"></salaxy-avatar>
            {{ row.employment.personalInfo.avatar.displayName }}
          </span>
          <span ng-switch-default>{{row[header]}}</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="modal-footer">
  <button id="import" type="button" class="btn btn-default ms-auto" ng-click="$ctrl.data.$parent.importBatch($close)">
    <span>{{ 'SALAXY.UI_Terms.save' | sxyTranslate }}
      <i class="bi" ng-class="$ctrl.data.$parent.progress ? 'bi-arrow-repeat bi-spin' : 'bi-upload'"></i>
    </span>
  </button>
  <button ng-click="$ctrl.data.$parent.clearLastResult();$ctrl.goPrevious()" class="btn float-start btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/invoices/company-invoice-dialog.html",`<div class="modal-invoice-group-dialog" ng-controller="InvoiceToolsController as $invoiceTools" ng-init="$invoiceTools.setFileTypes(['pdfFile'])">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.InvoiceDialog.paymentInformation"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <h2 class="visible-print-block" sxy-text="SALAXY.NG1.InvoiceDialog.paymentInformation"></h2>
    <div class="row">
      <div class="col-sm-6">
        <fieldset>
          <legend sxy-text="SALAXY.NG1.InvoiceDialog.paymentReceiver"></legend>
          <salaxy-avatar avatar="$ctrl.current.otherPartyInfo.avatar" class="pull-left" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.otherPartyInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.otherPartyInfo.officialId }}</div>
          <div ng-if="$ctrl.current.otherPartyInfo.ibanNumber">{{ $ctrl.current.otherPartyInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.otherPartyInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </fieldset>
        <fieldset>
          <legend sxy-text="SALAXY.NG1.InvoiceDialog.payer"></legend>
          <salaxy-avatar avatar="$ctrl.current.ownerInfo.avatar" class="pull-left" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.ownerInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.ownerInfo.officialId }}</div>
          <div ng-if="$ctrl.current.ownerInfo.ibanNumber">{{ $ctrl.current.ownerInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.ownerInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </fieldset>
      </div>
      <div class="col-sm-6 form-horizontal">
        <fieldset>
          <legend>
            {{"SALAXY.NG1.InvoiceDialog.invoiceStatus" | sxyTranslate}}: {{ "InvoiceStatus." + $ctrl.current.status | sxyEnum }}
          </legend>
            <button ng-if="$ctrl.logic.parent.showMarkAsPaidButton($ctrl.current)" class="btn btn-primary" ng-click="$ctrl.logic.parent.updateInvoiceStatus($ctrl.current,'paid')">
              <i class="bi bi-check-lg visible-xs me-1"></i><span class="hidden-xs" sxy-text="SALAXY.NG1.InvoicesCompany.setAsPaid"></span>
            </button> 
            <button class="btn btn-danger" ng-if="$ctrl.logic.parent.showMarkAsCanceledButton($ctrl.current)" ng-click="$ctrl.logic.parent.updateInvoiceStatus($ctrl.current,'canceled')">
              <i class="bi bi-x-lg visible-xs me-1"></i><span class="hidden-xs" sxy-text="SALAXY.NG1.InvoicesCompany.cancelPayment"></span>
            </button>
            <p ng-if="$ctrl.logic.parent.showIrCancelInfoText($ctrl.current)" class="text-center" sxy-text="SALAXY.NG1.InvoicesCompany.cancelInfoText"></p>
        </fieldset>
        <div class="pull-right" style="width: 160px" ng-if="$ctrl.current.status != 'paid' && $ctrl.current.status != 'canceled' && $ctrl.logic.parent.getQrCode($ctrl.current) !== 'loading' && $ctrl.logic.parent.getQrCode($ctrl.current) !== 'error'">
          <div height="160px" ng-bind-html="$ctrl.logic.parent.getQrCode($ctrl.current)" ></div>
        </div>
        <div ng-if="$ctrl.current.data.totalPaid && $ctrl.current.data.totalPaid != $ctrl.current.payment">
          
            <h4 style="text-decoration: line-through;">{{'SALAXY.NG1.InvoicesCompany.sum' | sxyTranslate}} {{ $ctrl.current.payment | currency }}</h4>
            <h4>{{'SALAXY.NG1.InvoicesCompany.alreadyPaid' | sxyTranslate}} {{ $ctrl.current.data.totalPaid | currency }}</h4>
            <h4 class="total" style="font-weight: bold;">{{'SALAXY.NG1.InvoicesCompany.payable' | sxyTranslate}} {{ ($ctrl.current.payment - $ctrl.current.data.totalPaid) | currency }}</h4>
          
        </div>
      </div>
    </div>
    <div ng-switch="$ctrl.current.status">
      <div class="alert alert-info" ng-switch-when="paid|paymentStarted|read" ng-switch-when-separator="|" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.paidPaymentStartedRead.html"></div>
      <div class="alert alert-info" ng-switch-when="canceled" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.canceled.html"></div>
      <div class="alert alert-danger" ng-switch-when="preview" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.preview.html"></div>
    </div>
    <div class="table-responsive" ng-if="$ctrl.current.status !== 'canceled'">
      <table class="table">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.receiver"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.receiverIban"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.reference"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.message"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.amount" class="right"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.dueDate" class="right"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.barcode" class="d-print-none"></th>
            <th class="d-print-none">PDF</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $ctrl.current.otherPartyInfo.avatar.displayName }}</td>
            <td>{{ $ctrl.current.otherPartyInfo.ibanNumber }}</td>
            <td>{{ $ctrl.current.entityType == 'net' ? '' : $ctrl.current.reference }}</td>
            <td>{{ ("SALAXY.ENUM.InvoiceType." + $ctrl.current.entityType + ".label") | sxyTranslate }}</td>
            <td class="right">{{ $ctrl.logic.parent.getInvoicePayment($ctrl.current) | currency }}</td>
            <td class="right">{{ $ctrl.current.data.dueDate | sxyDate }}</td>
            <td class="d-print-none">
              <a type="button" class="btn btn-default btn-block" ng-href="{{$ctrl.logic.parent.getPdfUrl($ctrl.current)}}"><i class="bi bi-file-earmark-pdf text-danger me-1" title="Lataa PDF"></i>pdf</a>
            </td>
          </tr>
          <tr>
            <td colspan="6" class="text-right" style="border-top: 0;padding: 0px;">
              <div ng-init="$ctrl.current.barcode = $ctrl.logic.parent.getBarcodeValue($ctrl.current)" ng-bind-html="$ctrl.logic.parent.getBarcode($ctrl.current)"></div>
            </td>
            <td class="d-print-none" style="border-top: 0;padding: 0px 8px;">
              <button type="button" class="btn btn-default btn-block" ng-click="$ctrl.logic.parent.copyBarcode($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyToClipboard"></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/invoices/company-invoices-date-filter-dialog.html",`
<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.InvoicesCompany.dateFilterDialogHeading"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
<form name="dateFilterForm" class="form-horizontal">
  <div class="row">
    <div class="col-sm-12">
      <salaxy-datepicker-popup label="SALAXY.NG1.InvoicesCompany.dateFilterDialogStart" name="startDate" ng-model="$ctrl.logic.startDate"></salaxy-datepicker-popup>
      <salaxy-datepicker-popup label="SALAXY.NG1.InvoicesCompany.dateFilterDialogEnd" name="endDate" ng-model="$ctrl.logic.endDate"></salaxy-datepicker-popup>
    </div>
  </div>
</form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="button" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.select"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/invoices/invoice-dialog.html",`<div class="modal-invoice-group-dialog" ng-controller="InvoiceToolsController as $invoiceTools">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.InvoiceDialog.paymentInformation"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <h2 class="d-none d-print-block" sxy-text="SALAXY.NG1.InvoiceDialog.paymentInformation"></h2>
    <div class="row">
      <div class="col-sm-6">
        <fieldset>
          <legend sxy-text="SALAXY.NG1.InvoiceDialog.paymentReceiver"></legend>
          <salaxy-avatar avatar="$ctrl.current.otherPartyInfo.avatar" class="float-start" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.otherPartyInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.otherPartyInfo.officialId }}</div>
          <div ng-if="$ctrl.current.otherPartyInfo.ibanNumber">{{ $ctrl.current.otherPartyInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.otherPartyInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </fieldset>
        <fieldset>
          <legend>Maksaja</legend>
          <salaxy-avatar avatar="$ctrl.current.ownerInfo.avatar" class="float-start" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.ownerInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.ownerInfo.officialId }}</div>
          <div ng-if="$ctrl.current.ownerInfo.ibanNumber">{{ $ctrl.current.ownerInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.ownerInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </fieldset>
      </div>
      <div class="col-sm-6 form-horizontal">
        <fieldset>
          <legend>{{"SALAXY.NG1.InvoiceDialog.invoiceStatus" | sxyTranslate}}: {{ "InvoiceStatus." + $ctrl.current.status | sxyEnum }}</legend>
          <salaxy-form-group name="paymentChannel" label="{{'SALAXY.NG1.InvoiceDialog.paymentChannel' | sxyTranslate}}">
            <div style="height:100%">
              <div style="display: inline-block;vertical-align: middle;">
                <salaxy-avatar style="font-size: 2.8em" avatar="$ctrl.logic.parent.getChannelAvatar($ctrl.current.data.channel)"></salaxy-avatar>
              </div>
              <div style="display: inline-block;vertical-align: middle;">{{ $ctrl.logic.parent.getChannelAvatar($ctrl.current.data.channel).displayName }}</div>
            </div>
          </salaxy-form-group>
          <div class="d-print-none" ng-init="$ctrl.logic.newStatus = $ctrl.current.status">
            <salaxy-input-enum label="{{'SALAXY.NG1.InvoiceDialog.changeStatus' | sxyTranslate}}" name="requestedStatus" options="{'unread': ('SALAXY.ENUM.InvoiceStatus.unread.label' | sxyTranslate),'read': ('SALAXY.ENUM.InvoiceStatus.read.label' | sxyTranslate),'waitingConfirmation': ('SALAXY.ENUM.InvoiceStatus.waitingConfirmation.label' | sxyTranslate),'paid': ('SALAXY.ENUM.InvoiceStatus.paid.label' | sxyTranslate),'canceled': ('SALAXY.ENUM.InvoiceStatus.canceled.label' | sxyTranslate)}" ng-model="$ctrl.logic.newStatus" enum="InvoiceStatus">
            </salaxy-input-enum>
            <salaxy-form-group name="statusButton" label-type="empty-label">
              <button type="button" class="btn btn-default float-end" ng-click="$ctrl.logic.parent.updateInvoiceGroupItemStatus($ctrl.current,$ctrl.logic.newStatus)" sxy-text="SALAXY.NG1.InvoiceDialog.change"></button>
            </salaxy-form-group>

            <salaxy-input-enum name="fileType" label="{{'SALAXY.NG1.InvoiceDialog.downloadInvoice' | sxyTranslate}}" ng-model="$invoiceTools.fileTypeId" options="$invoiceTools.fileTypeOptions" remember="invoice"></salaxy-input-enum>

            <salaxy-form-group name="exportButton" label-type="empty-label">
              <button type="button" class="btn btn-default float-end" ng-disabled="!$invoiceTools.fileTypeId" ng-click="$invoiceTools.export($ctrl.logic.parent.getGroupItemDataReader($ctrl.current,null),false)" sxy-text="SALAXY.NG1.InvoiceDialog.download"></button>
            </salaxy-form-group>
          </div>
        </fieldset>
      </div>
    </div>
    <div ng-switch="$ctrl.current.status">
      <div class="alert alert-info" ng-switch-when="paid|paymentStarted|read" ng-switch-when-separator="|" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.paidPaymentStartedRead.html"></div>
      <div class="alert alert-info" ng-switch-when="canceled" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.canceled.html"></div>
      <div class="alert alert-danger" ng-switch-when="forecast" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.forecast.html"></div>
      <div class="alert alert-danger" ng-switch-when="preview" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.preview.html"></div>
    </div>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.receiver"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.receiverIban"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.reference"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.message"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.amount" class="right"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.dueDate" class="right"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.barcode" class="d-print-none"></th>
            <th class="d-print-none">PDF</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $ctrl.current.otherPartyInfo.avatar.displayName }}</td>
            <td ng-if="$ctrl.logic.parent.hideBarCode($ctrl.current)">{{ 'SALAXY.REPORTS.invoice.heading.preview' | sxyTranslate }}</td>
            <td ng-if="!$ctrl.logic.parent.hideBarCode($ctrl.current)">{{ $ctrl.current.otherPartyInfo.ibanNumber }}</td>
            <td>{{ $ctrl.current.reference }}</td>
            <td>{{ ("SALAXY.ENUM.InvoiceType." + $ctrl.current.entityType + ".label") | sxyTranslate }}</td>
            <td class="right">{{ $ctrl.current.payment | currency }}</td>
            <td class="right">{{ $ctrl.current.data.dueDate | sxyDate }}</td>
            <td class="d-print-none">
              <a type="button" class="btn btn-default btn-block" ng-href="{{$ctrl.logic.parent.getPdfUrl($ctrl.current)}}"><i class="bi bi-file-earmark-pdf text-danger me-1" title="Lataa PDF"></i>pdf</a>
            </td>
          </tr>
          <tr ng-if="!$ctrl.logic.parent.hideBarCode($ctrl.current)">
            <td class="qrCode-column" colspan="1" style="border-top: 0; padding: 0px; width: 150px;">
              <div class="text-end" ng-if="$ctrl.logic.parent.getQrCode($ctrl.current) !== 'loading' && $ctrl.logic.parent.getQrCode($ctrl.current) !== 'error'">
                <div ng-bind-html="$ctrl.logic.parent.getQrCode($ctrl.current)" ></div>
              </div>
            </td>
            <td colspan="5" class="text-end" style="border-top: 0;padding: 0px;">
              <span style="font-family: 'Courier New', Courier, monospace; font-size: 1.15em;">{{$ctrl.logic.parent.getBarcodeValue($ctrl.current)}}</span>
            </td>
            <td class="d-print-none" style="border-top: 0;padding: 0px 8px;">
              <button type="button" class="btn btn-default btn-block" ng-click="$ctrl.logic.parent.copyBarcode($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyToClipboard"></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer d-print-none">
    <button type="button" class="btn btn-default float-start" onClick="window.print()" sxy-text="SALAXY.UI_Terms.print"></button>
    <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/invoices/invoice-group-dialog.html",`<div class="modal-invoice-group-dialog" ng-controller="InvoiceToolsController as $invoiceTools" ng-init="($ctrl.current.invoices[0].data.channel == 'palkkausInvoices' || $ctrl.current.invoices[0].data.channel == 'kitsas') ? $invoiceTools.setFileTypes(['pdfFile']) : null">
  <style>
    @media print {
      #launcher {
        display: none;
      }
      @page {
        margin-bottom: 20mm;
      }
    }
  </style>
  <div class="modal-header">
    <h2 class="modal-title">Maksuaineiston tiedot</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <h2 class="d-none d-print-block">Maksuaineiston tiedot</h2>
    <div class="row">
      <div class="col-sm-6">
        <fieldset>
          <legend>Maksaja</legend>
          <salaxy-avatar avatar="$ctrl.current.ownerInfo.avatar" class="float-start" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.ownerInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.ownerInfo.officialId }}</div>
          <div ng-if="$ctrl.current.ownerInfo.ibanNumber">{{ $ctrl.current.ownerInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.ownerInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.WorkerInfo.noIbanNumber"></div>
        </fieldset>
      </div>
      <div class="col-sm-6 form-horizontal">
        <fieldset>
          <legend>Aineiston tila: {{ "InvoiceStatus." + $ctrl.current.status | sxyEnum }}</legend>
          <salaxy-form-group name="paymentChannel" label="Maksukanava">
            <div style="height:100%">
              <div style="display: inline-block;vertical-align: middle;">
                <salaxy-avatar style="font-size: 2.8em" avatar="$ctrl.logic.parent.getChannelAvatar($ctrl.current.invoices[0].data.channel)"></salaxy-avatar>
              </div>
              <div style="display: inline-block;vertical-align: middle;">{{ $ctrl.logic.parent.getChannelAvatar($ctrl.current.invoices[0].data.channel).displayName }}</div>
            </div>
          </salaxy-form-group>
          <div class="d-print-none" ng-init="$ctrl.logic.newStatus = $ctrl.current.status">
            <salaxy-input-enum label="Vaihda tilaa" name="requestedStatus" hidden-options="undefined,forecast,preview,waitingPalkkaus" ng-model="$ctrl.logic.newStatus" enum="InvoiceStatus">
            </salaxy-input-enum>
            <salaxy-form-group name="statusButton" label-type="empty-label">
              <button type="button" class="btn btn-default float-end" ng-click="$ctrl.logic.parent.updateInvoiceGroupStatus($ctrl.current,$ctrl.logic.newStatus)">Vaihda</button>
            </salaxy-form-group>

            <salaxy-input-enum name="fileType" label="Lataa aineisto" ng-model="$invoiceTools.fileTypeId" options="$invoiceTools.fileTypeOptions" remember="invoice"></salaxy-input-enum>

            <salaxy-form-group name="exportButton" label-type="empty-label">
              <button type="button" class="btn btn-default float-end" ng-disabled="!$invoiceTools.fileTypeId" ng-click="$invoiceTools.export($ctrl.logic.parent.getGroupDataReader($ctrl.current,null),false)">Lataa</button>
            </salaxy-form-group>
          </div>
        </fieldset>
      </div>
    </div>
    <div ng-switch="$ctrl.current.status">
      <div class="alert alert-info" ng-switch-when="paid|paymentStarted" ng-switch-when-separator="|">
        <strong>HUOM</strong>: Aineisto on jo merkitty maksetuksi!<br /> Jos maksat tai lähetät aineiston / maksun uudelleen, varmistathan, ettei maksua makseta kahteen kertaan.
      </div>
      <div class="alert alert-info" ng-switch-when="read">
        <strong>HUOM</strong>: Aineisto on jo merkitty lähetetyksi.<br /> Jos maksat tai lähetät aineiston / maksun uudelleen, varmistathan, ettei maksua makseta kahteen kertaan.
      </div>
      <div class="alert alert-info" ng-switch-when="canceled">
        Aineisto maksut on merkitty perutuksi.<br />
      </div>
      <div class="alert alert-info" ng-switch-when="canceled">
        Aineiston edellisessä maksussa on tapahtunut virheitä.<br />
      </div>
      <div class="alert alert-danger" ng-switch-when="forecast">
        <strong>HUOM</strong>: Aineisto on <strong>Arvio</strong> (forecast).<br /> Tyypillisesti nämä ainestot ovat vain kassavirran suunnittelua varten. Niitä ei ole tarkoitus maksaa, vaan lopullinen lasku tulee laskuttajalta (esim. Työllisyysrahasto).
      </div>
      <div class="alert alert-danger" ng-switch-when="preview">
        <strong>HUOM</strong>: Aineisto on <strong>Esikatselu</strong>-tilassa.<br /> Aineistoon (esim. ennakonpidätys) voi olla vielä tulossa muutoksia. Jos maksat aineiston, varmistathan ettei aineistoon tule enää muutoksia (esim. lisää palkkoja samassa
        kuussa).
      </div>
    </div>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Saajan nimi</th>
            <th>Saajan IBAN</th>
            <th>Viite</th>
            <th>Viesti</th>
            <th class="right">Summa</th>
            <th class="right">Eräpäivä</th>
            <th class="d-print-none"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat-start="invoice in $ctrl.current.invoices">
            <td>{{ invoice.otherPartyInfo.avatar.displayName }}</td>
            <td>{{ invoice.otherPartyInfo.ibanNumber }}</td>
            <td>{{ invoice.reference }}</td>
            <td>{{ ("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate }}</td>
            <td class="right">{{ invoice.payment | currency }}</td>
            <td class="right">{{ invoice.data.dueDate | sxyDate }}</td>
            <td class="d-print-none"><a type="button" class="btn btn-default btn-block" ng-href="{{$ctrl.logic.parent.getPdfUrl(invoice)}}"><i class="bi bi-file-earmark-pdf text-danger me-1" title="Lataa PDF"></i>pdf</a></td>
          </tr>
          <tr ng-repeat-end>
            <td class="qrCode-column" colspan="1" style="border-top: 0;padding: 0px; width: 150px;">
              <div class="text-end"  ng-if="$ctrl.logic.parent.getQrCode(invoice) !== 'loading' && $ctrl.logic.parent.getQrCode(invoice) !== 'error'">
                <div ng-bind-html="$ctrl.logic.parent.getQrCode(invoice)" ></div>
              </div>
            </td>
            <td colspan="5" style="border-top: 0;padding: 0px;" class="text-end">
              <span style="font-family: 'Courier New', Courier, monospace; font-size: 1.15em;">{{$ctrl.logic.parent.getBarcodeValue(invoice)}}</span>
            </td>
            <td class="d-print-none" style="border-top: 0;padding: 0px 8px;">
              <button type="button" class="btn btn-default btn-block" ng-click="$ctrl.logic.parent.copyBarcode(invoice)">Kopioi</button>
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right">{{ $ctrl.logic.parent.sumInvoicePayments($ctrl.current.invoices) | currency }}</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer d-print-none">
    <button type="button" class="btn btn-default float-start" onClick="window.print()" sxy-text="SALAXY.UI_Terms.print"></button>
    <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')">OK</button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/invoices/invoice-payment-list-dialog.html",`<div class="modal-invoice-group-dialog" ng-controller="InvoiceToolsController as $invoiceTools">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.InvoiceDialog.paymentInformation"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <h2 class="visible-print-block" sxy-text="SALAXY.NG1.InvoiceDialog.paymentInformation"></h2>
    <div class="row">
      <div class="col-sm-6">
        <fieldset>
          <legend sxy-text="SALAXY.NG1.InvoiceDialog.paymentReceiver"></legend>
          <salaxy-avatar avatar="$ctrl.current.otherPartyInfo.avatar" class="pull-left" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.otherPartyInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.otherPartyInfo.officialId }}</div>
          <div ng-if="$ctrl.current.otherPartyInfo.ibanNumber">{{ $ctrl.current.otherPartyInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.otherPartyInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </fieldset>
        <fieldset>
          <legend>Maksaja</legend>
          <salaxy-avatar avatar="$ctrl.current.ownerInfo.avatar" class="pull-left" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.ownerInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.ownerInfo.officialId }}</div>
          <div ng-if="$ctrl.current.ownerInfo.ibanNumber">{{ $ctrl.current.ownerInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.ownerInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </fieldset>
      </div>
      <div class="col-sm-6 form-horizontal">
        <fieldset>
          <legend>{{"SALAXY.NG1.InvoiceDialog.invoiceStatus" | sxyTranslate}}: {{ "InvoiceStatus." + $ctrl.current.status | sxyEnum }}</legend>
          <salaxy-form-group name="paymentChannel" label="{{'SALAXY.NG1.InvoiceDialog.paymentChannel' | sxyTranslate}}">
            <div style="height:100%">
              <div style="display: inline-block;vertical-align: middle;">
                <salaxy-avatar style="font-size: 2.8em" avatar="$ctrl.logic.parent.getChannelAvatar($ctrl.current.data.channel)"></salaxy-avatar>
              </div>
              <div style="display: inline-block;vertical-align: middle;">{{ $ctrl.logic.parent.getChannelAvatar($ctrl.current.data.channel).displayName }}</div>
            </div>
          </salaxy-form-group>
          <div class="d-print-none" ng-init="$ctrl.logic.newStatus = $ctrl.current.status">
            <salaxy-input-enum name="fileType" label="{{'SALAXY.NG1.InvoiceDialog.downloadInvoice' | sxyTranslate}}" ng-model="$invoiceTools.fileTypeId" options="$invoiceTools.fileTypeOptions" remember="invoice"></salaxy-input-enum>
            <salaxy-form-group name="exportButton" label-type="empty-label">
              <button type="button" class="btn btn-default pull-right" ng-disabled="!$invoiceTools.fileTypeId" ng-click="$invoiceTools.export($ctrl.logic.parent.getGroupItemDataReader($ctrl.current,null, $invoiceTools.fileTypeId),false)" sxy-text="SALAXY.NG1.InvoiceDialog.download"></button>
            </salaxy-form-group>
          </div>
        </fieldset>
      </div>
    </div>
    <div ng-switch="$ctrl.current.status">
      <div class="alert alert-info" ng-switch-when="paid|paymentStarted|read" ng-switch-when-separator="|" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.paidPaymentStartedRead.html"></div>
      <div class="alert alert-info" ng-switch-when="canceled" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.canceled.html"></div>
      <div class="alert alert-danger" ng-switch-when="forecast" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.forecast.html"></div>
      <div class="alert alert-danger" ng-switch-when="preview" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.preview.html"></div>
    </div>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.receiver"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.receiverIban"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.reference"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.message"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.amount" class="right"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.dueDate" class="right"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.barcode" class="d-print-none"></th>
            <th class="d-print-none">PDF</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $ctrl.current.otherPartyInfo.avatar.displayName }}</td>
            <td ng-if="$ctrl.logic.parent.hideBarCode($ctrl.current)">{{ 'SALAXY.REPORTS.invoice.heading.preview' | sxyTranslate }}</td>
            <td ng-if="!$ctrl.logic.parent.hideBarCode($ctrl.current)">{{ $ctrl.current.otherPartyInfo.ibanNumber }}</td>
            <td>{{ ($ctrl.current.entityType !== 'net' && $ctrl.current.reference) ? $ctrl.current.reference : '' }}</td>
            <td>{{ ("SALAXY.ENUM.InvoiceType." + $ctrl.current.entityType + ".label") | sxyTranslate }}</td>
            <td class="right">{{ $ctrl.current.payment | currency }}</td>
            <td class="right">{{ $ctrl.current.data.dueDate | sxyDate }}</td>
            <td class="d-print-none">
              <a type="button" class="btn btn-default btn-block" ng-href="{{$ctrl.logic.parent.getPdfUrl($ctrl.current)}}"><i class="bi bi-file-earmark-pdf text-danger me-1" title="Lataa PDF"></i>pdf</a>
            </td>
          </tr>
          <tr ng-if="!$ctrl.logic.parent.hideBarCode($ctrl.current)">
            <td class="qrCode-column" colspan="1" style="border-top: 0; padding: 0px; width: 150px;">
              <div class="text-right"  ng-if="$ctrl.logic.parent.getQrCode($ctrl.current) !== 'loading' && $ctrl.logic.parent.getQrCode($ctrl.current) !== 'error'">
                <div ng-bind-html="$ctrl.logic.parent.getQrCode($ctrl.current)" ></div>
              </div>
            </td>
            <td colspan="5" style="border-top: 0;padding: 0px;" class="text-right">
              <span style="font-family: 'Courier New', Courier, monospace; font-size: 1.15em;">{{$ctrl.logic.parent.getBarcodeValue($ctrl.current)}}</span>
            </td>
            <td class="d-print-none" style="border-top: 0;padding: 0px 8px;">
              <button type="button" class="btn btn-default btn-block" ng-click="$ctrl.logic.parent.copyBarcode($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyToClipboard"></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    <button type="button" class="btn btn-default ms-auto" onClick="window.print()" sxy-text="SALAXY.UI_Terms.print"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/localTapiola/Beneficiary-info.html",`<form name="currentForm" class="form-horizontal" model="temp">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>

  <div class="text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}</h2>
    <p class="intro" ng-if="$ctrl.currentStep.intro != ''">{{ $ctrl.currentStep.intro }}</p>
  </div>

  <fieldset>
    <legend sxy-text="SALAXY.NG1.InsuranceComponent.beneficiaryInfo.wizard.label"></legend>
    <div class="row" ng-repeat="item in $ctrl.current.company.beneficiaries">

      <div class="col-sm-6">
        <salaxy-input ng-model="item.avatar.displayName" name="beneficiaryName{{$index}}" label="SALAXY.NG1.InsuranceComponent.common.name" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-3">
        <salaxy-input ng-model="item.officialId" name="beneficiaryPersonalId{{$index}}" label="SALAXY.NG1.InsuranceComponent.common.ssNumber" sxy-personal-id-fi label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-3">
        <salaxy-input ng-model="item.nationality" name="beneficiaryNationality{{$index}}" label="SALAXY.NG1.InsuranceComponent.common.nationality" label-type="basic"></salaxy-input>
      </div>
      <div class="col-12 text-end">
        <button class="btn btn-lt btn-danger btn-sm" ng-click="$ctrl.current.company.beneficiaries.splice($index,1)"><i class="bi bi-trash-fill"></i> <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.delete"></span></button>
      </div>
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button class="btn btn-lt btn-secondary btn-sm" ng-click="$ctrl.current.company.beneficiaries.push({ avatar: {}})"><i class="bi bi-plus-lg" style="margin-right:5px"></i> {{'SALAXY.NG1.InsuranceComponent.beneficiaryInfo.beneficiariesAdd' | sxyTranslate}}</button>
      </div>
    </div>
  </fieldset>


</form>`);

 $templateCache.put("salaxy-components/modals/localTapiola/buttons-default.html",`<div class="col-6 col-sm-4 text-start">
  <button ng-click="$ctrl.goPrevious()" class="btn btn-lt btn-sm btn-link navi-link"><i class="bi bi-chevron-left"></i> {{'SALAXY.UI_Terms.previous' | sxyTranslate}}</button>
</div>
<div class="col-sm-4 d-none d-sm-block text-center txt-index">
  <div>{{$ctrl.currentStep.number-1}}/{{$ctrl.steps.length-1}}</div>
</div>
<div class="col-6 col-sm-4 text-end">

  <button ng-click="$ctrl.goNext()" ng-disabled="!$ctrl.canGoNext" class="btn btn-lt btn-sm btn-link navi-link">{{'SALAXY.UI_Terms.next' | sxyTranslate}} <i class="bi bi-chevron-right"></i></button>
  <!--button ng-click="$ctrl.goNext()" ng-disabled="!$ctrl.canGoNext" class="btn-link navi-link">Seuraava <i class="bi bi-chevron-right"></i></button-->
</div>`);

 $templateCache.put("salaxy-components/modals/localTapiola/buttons-send.html",`<div class="col-6 col-sm-4 text-start">
  <button ng-click="$ctrl.goPrevious()" class="btn btn-lt btn-sm btn-link navi-link"><i class="bi bi-chevron-left"></i> {{'SALAXY.UI_Terms.previous' | sxyTranslate}}</button>
</div>
<div class="col-sm-4 d-none d-sm-block text-center txt-index">
  <div>{{$ctrl.currentStep.number-1}}/{{$ctrl.steps.length-1}}</div>

</div>
<div class="col-6 col-sm-4 text-end">

  <span>
    <button ng-click="$ctrl.send()" ng-disabled="!$ctrl.canGoNext" class="btn btn-lt btn-sm btn-primary" sxy-text="SALAXY.UI_Terms.send"></button>
  </span>
</div>`);

 $templateCache.put("salaxy-components/modals/localTapiola/ContactInfo-entrepreneur.html",`<form name="currentForm" class="form-horizontal" ng-model="temp">

  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>

  <div class="text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}
    </h2>

  </div>

  <fieldset>
    <legend sxy-text="SALAXY.NG1.InsuranceComponent.common.insuranceContactPerson"></legend>
    <div class="content row">
      <div class="col-sm-8">
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.avatar.displayName" name="contactName" label="SALAXY.NG1.InsuranceComponent.common.name" required label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.officialId" name="contactSSNumber" label="SALAXY.NG1.InsuranceComponent.common.ssNumber" required sxy-personal-id-fi label-type="basic"></salaxy-input>

      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.telephone" name="contactTelephone" label="SALAXY.NG1.InsuranceComponent.common.telephone" required sxy-mobile-phone label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.email" name="contactEmail" label="SALAXY.NG1.InsuranceComponent.common.email" required sxy-email label-type="basic"> </salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input-enum type="select" ng-model="$ctrl.current.company.contactPerson.authorizationType" options="{procuration: ('SALAXY.NG1.InsuranceComponent.enums.procurationEnum' | sxyTranslate), powerOfAttorney: ('SALAXY.NG1.InsuranceComponent.enums.powerOfAttorneyEnum' | sxyTranslate), apparentAuthority: ('SALAXY.NG1.InsuranceComponent.enums.apparentAuthorityEnum' | sxyTranslate), other: ('SALAXY.NG1.InsuranceComponent.enums.otherEnum' | sxyTranslate)}"
          name="DelegateType" enum="DelegateType" label="SALAXY.NG1.InsuranceComponent.enums.authorizationTypeLabel" required label-type="basic"></salaxy-input-enum>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <legend sxy-html="SALAXY.NG1.InsuranceComponent.principalBusinessAddress.label.html"></legend>
    <button class="btn btn-lt btn-xs btn-secondary" ng-click="$ctrl.current.company.hasPrincipalBusinessAddress = !$ctrl.current.company.hasPrincipalBusinessAddress"><i class="bi" style="margin-right:5px" ng-class="!$ctrl.current.company.hasPrincipalBusinessAddress ? 'bi bi-plus-lg' : 'bi-x-lg'"></i> <span ng-if="!$ctrl.current.company.hasPrincipalBusinessAddress" sxy-text="SALAXY.NG1.InsuranceComponent.common.addAddressBtn"></span><span ng-if="$ctrl.current.company.hasPrincipalBusinessAddress" sxy-text="SALAXY.UI_Terms.cancelAlt">Peru</span></button>

    <div class="content row" ng-if="$ctrl.current.company.hasPrincipalBusinessAddress">
      <div class="col-sm-12">
        <salaxy-input ng-model="$ctrl.current.company.principalBusinessAddress.street" name="streetAddress" label="SALAXY.NG1.InsuranceComponent.common.streetAddress" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="$ctrl.current.company.principalBusinessAddress.postalCode" name="postalCode" label="SALAXY.NG1.InsuranceComponent.common.postalCode" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="$ctrl.current.company.principalBusinessAddress.city" name="city" label="SALAXY.NG1.InsuranceComponent.common.city" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input-enum options="$ctrl.countryCodes" ng-model="$ctrl.current.company.principalBusinessAddress.countryCode" name="country" label="SALAXY.NG1.InsuranceComponent.common.country" label-type="basic" disable-cache="true"></salaxy-input>
      </div>
    </div>
  </fieldset>

</form>`);

 $templateCache.put("salaxy-components/modals/localTapiola/ContactInfo.html",`<form name="currentForm" class="form-horizontal" ng-model="temp">

  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>

  <div class="text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}
    </h2>
    <p class="intro">
      <span ng-if="$ctrl.action == 'moveInsurance'" sxy-text="SALAXY.NG1.InsuranceComponent.contactInfo.moveInsuranceInfo"></span>
    </p>
  </div>


  <div class="content row">
    <div class="col-12 col-sm-6">
      <fieldset>
        <legend>Yrityksen tiedot</legend>
        <salaxy-input ng-model="$ctrl.current.company.details.avatar.displayName" name="companyName" label="SALAXY.NG1.InsuranceComponent.common.companyName" readonly="true" label-type="basic"> </salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.details.officialId" name="vatNumber" label="SALAXY.NG1.InsuranceComponent.common.vatNumber" readonly="true" label-type="basic"></salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.address.street" name="streetAddress" label="SALAXY.NG1.InsuranceComponent.common.streetAddress" readonly="true" label-type="basic"></salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.address.postalCode" name="postalCode" label="SALAXY.NG1.InsuranceComponent.common.postalCode" readonly="true" label-type="basic"></salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.address.city" name="city" label="SALAXY.NG1.InsuranceComponent.common.city" readonly="true" label-type="basic"></salaxy-input>
      </fieldset>
      <fieldset>
        <legend sxy-html="SALAXY.NG1.InsuranceComponent.principalBusinessAddress.label.html"></legend>
        <button class="btn btn-lt btn-xs btn-secondary" ng-click="$ctrl.current.company.hasPrincipalBusinessAddress = !$ctrl.current.company.hasPrincipalBusinessAddress"><i class="bi" style="margin-right:5px" ng-class="!$ctrl.current.company.hasPrincipalBusinessAddress ? 'bi bi-plus-lg' : 'bi-x-lg'"></i> <span ng-if="!$ctrl.current.company.hasPrincipalBusinessAddress" sxy-text="SALAXY.NG1.InsuranceComponent.common.addAddressBtn"></span><span ng-if="$ctrl.current.company.hasPrincipalBusinessAddress"  sxy-text="SALAXY.UI_Terms.cancelAlt">Peru</span></button>

        <div ng-if="$ctrl.current.company.hasPrincipalBusinessAddress">
          <salaxy-input ng-model="$ctrl.current.company.principalBusinessAddress.street" name="streetAddress" label="SALAXY.NG1.InsuranceComponent.common.streetAddress" label-type="basic"></salaxy-input>
          <salaxy-input ng-model="$ctrl.current.company.principalBusinessAddress.postalCode" name="postalCode" label="SALAXY.NG1.InsuranceComponent.common.postalCode" label-type="basic"></salaxy-input>
          <salaxy-input ng-model="$ctrl.current.company.principalBusinessAddress.city" name="city" label="SALAXY.NG1.InsuranceComponent.common.city" label-type="basic"></salaxy-input>
          <salaxy-input-typeahead options="$ctrl.countryCodes" ng-model="$ctrl.current.company.principalBusinessAddress.countryCode" name="country" label="SALAXY.NG1.InsuranceComponent.common.country" label-type="basic"></salaxy-typeahead>
        </div>
      </fieldset>

    </div>
    <div class="col-12 col-sm-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.InsuranceComponent.common.insuranceContactPerson"></legend>
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.avatar.displayName" name="contactName" label="SALAXY.NG1.InsuranceComponent.common.name" required label-type="basic"></salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.officialId" name="contactSSNumber" label="SALAXY.NG1.InsuranceComponent.common.ssNumber" required sxy-personal-id-fi label-type="basic"></salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.telephone" name="contactTelephone" label="SALAXY.NG1.InsuranceComponent.common.telephone" required sxy-mobile-phone label-type="basic"></salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.email" name="contactEmail" label="SALAXY.NG1.InsuranceComponent.common.email" required sxy-email label-type="basic"> </salaxy-input>
        <salaxy-input-enum type="select" ng-model="$ctrl.current.company.contactPerson.authorizationType" options="{procuration: ('SALAXY.NG1.InsuranceComponent.enums.procurationEnum' | sxyTranslate), powerOfAttorney: ('SALAXY.NG1.InsuranceComponent.enums.powerOfAttorneyEnum' | sxyTranslate), apparentAuthority: ('SALAXY.NG1.InsuranceComponent.enums.apparentAuthorityEnum' | sxyTranslate), other: ('SALAXY.NG1.InsuranceComponent.enums.otherEnum' | sxyTranslate)}"
          name="DelegateType" enum="DelegateType" label="SALAXY.NG1.InsuranceComponent.common.procura" required label-type="basic"></salaxy-input-enum>
      </fieldset>
    </div>
  </div>


</form>`);

 $templateCache.put("salaxy-components/modals/localTapiola/Entrepreneur.html",`<form name="currentForm" class="form-horizontal" ng-model="temp">

  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>

  <div class="text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}
      </h23>
      <p class="intro" ng-if="$ctrl.currentStep.intro != ''">{{ $ctrl.currentStep.intro }}
      </p>
  </div>
  <fieldset>
    <legend sxy-text="SALAXY.NG1.InsuranceComponent.entrepreneur.companyInfo"></legend>
    <div class="row">
      <div class="col-sm-8">
        <salaxy-input ng-model="$ctrl.current.company.details.avatar.displayName" name="companyName" label="SALAXY.NG1.InsuranceComponent.common.companyName" readonly="true" label-type="basic"> </salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="$ctrl.current.company.details.officialId" name="vatNumber" label="SALAXY.NG1.InsuranceComponent.common.vatNumber" readonly="true" label-type="basic" sxy-company-id-fi></salaxy-input>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <legend sxy-text="SALAXY.NG1.InsuranceComponent.entrepreneur.entrepreneurInsuranceInfo"></legend>
    <div class="row" ng-repeat="item in $ctrl.current.items">
      <div class="col-sm-8">
        <salaxy-input ng-model="item.insuredName" name="entrepreneurName{{$index}}" label="SALAXY.NG1.InsuranceComponent.entrepreneur.entrepreneurName" required label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="item.insuredOfficialId" name="entrepreneurSSNumber{{$index}}" label="SALAXY.NG1.InsuranceComponent.common.ssNumber" required label-type="basic" sxy-personal-id-fi></salaxy-input>
      </div>
      <div class="col-sm-8">
        <salaxy-input-enum type="select" ng-model="item.orderType" options="{newEntrepreneurInsurance: ('SALAXY.NG1.InsuranceComponent.entrepreneur.newEntrepreneurInsuranceEnum' | sxyTranslate), moveEntrepreneurInsurance: ('SALAXY.NG1.InsuranceComponent.entrepreneur.moveEntrepreneurInsuranceEnum' | sxyTranslate)}"
          name="InsuranceOrder{{$index}}" enum="InsuranceOrder" label="SALAXY.NG1.InsuranceComponent.entrepreneur.insuranceLabel" required label-type="basic"></salaxy-input-enum>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-if="item.orderType == 'moveEntrepreneurInsurance'" ng-model="item.oldInsuranceCompany" label="SALAXY.NG1.InsuranceComponent.common.oldInsuranceCompany" name="insuranceCompany{{$index}}" label-type="basic" required></salaxy-input>
      </div>

      <div class="col-sm-8">
        <salaxy-datepicker-popup ng-if="item.orderType == 'newEntrepreneurInsurance'" ng-model="item.startDate" name="insuranceForEntrepreneurStartDate{{$index}}" placeholder="pp.kk.vvvv" label="SALAXY.NG1.InsuranceComponent.common.startDate"
          min-date="$ctrl.today" label-type="basic" tooltip-html="{{'SALAXY.NG1.InsuranceComponent.common.startDateToolTip' | sxyTranslate}}" require="true"></salaxy-datepicker-popup>
        <salaxy-input-enum ng-if="item.orderType == 'moveEntrepreneurInsurance'" label="SALAXY.NG1.InsuranceComponent.common.startDate" type="select" options="$ctrl.insuranceStartingPointDateOptions" placeholder="SALAXY.UI_Terms.select" ng-model="item.startDate"
          name="insuranceMoveForEntrepreneurStartDate{{$index}}" label-type="basic" required></salaxy-input-enum>
      </div>
      <div class="col-sm-4">
        <salaxy-input-enum label="SALAXY.NG1.InsuranceComponent.common.billingInterval" options="{1:'1', 2:'2', 3:'3', 4:'4'}" ng-model="item.billingInterval" name="billing{{$index}}" label-type="basic" required></salaxy-input-enum>
      </div>


      <div class="col-sm-8">
        <salaxy-input-occupation-type name="occupationType{{$index}}" ng-model="item.occupations[0].occupationCode" label="SALAXY.NG1.InsuranceComponent.common.occupationCode" label-type="basic" required></salaxy-input-occupation-type>
      </div>
      <div class="col-sm-4 ">
        <salaxy-input ng-model="item.occupations[0].estimatedIncome" name="YELincome{{$index}}" label="SALAXY.NG1.InsuranceComponent.entrepreneur.estimatedIncome" label-type="basic" required></salaxy-input>
      </div>
      <div class="col-12 text-end">
        <button class="btn-lt btn-sm btn-danger" ng-click="$ctrl.current.items.splice($index,1)"><i class="bi bi-trash-fill"></i> <span sxy-text="SALAXY.UI_Terms.delete"></span></button>
      </div>
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button class="btn btn-lt btn-secondary btn-sm" ng-click="$ctrl.current.items.push({ occupations: [{}]})"><i class="bi bi-plus-lg" style="margin-right:5px"></i> {{'SALAXY.NG1.InsuranceComponent.entrepreneur.addEntrepreneur' | sxyTranslate}}</button>
      </div>
    </div>
  </fieldset>

</form>`);

 $templateCache.put("salaxy-components/modals/localTapiola/InsuranceInfo-move.html",`<form name="currentForm" class="form-horizontal" ng-model="temp">

  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>

  <div class=" text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}
    </h2>
    <p class="intro" sxy-text="SALAXY.NG1.InsuranceComponent.insuranceMove.intro" ps="."></p>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <salaxy-input-enum label="SALAXY.NG1.InsuranceComponent.common.startDate" type="select" options="$ctrl.insuranceStartingPointDateOptions" placeholder="SALAXY.UI_Terms.select" ng-model="$ctrl.current.items[0].startDate" name="insuranceStartDate" label-type="basic"
        required></salaxy-input-enum>
    </div>
    <div class="col-sm-6">
      <salaxy-input-enum label="SALAXY.NG1.InsuranceComponent.common.billingInterval" options="{1:'1', 2:'2', 3:'3', 4:'4'}" ng-model="$ctrl.current.items[0].billingInterval" name="billing" label-type="basic" required></salaxy-input-enum>
    </div>
    <div class="col-sm-6">
      <salaxy-input ng-model="$ctrl.current.items[0].oldInsuranceCompany" label="SALAXY.NG1.InsuranceComponent.common.oldInsuranceCompany" name="insuranceCompany" label-type="basic" required></salaxy-input>
    </div>
    <div class="col-sm-6">
      <salaxy-input ng-model="$ctrl.current.items[0].industry" name="industry" label="SALAXY.NG1.InsuranceComponent.common.industry.label" label-type="basic" required tooltip-html="{{'SALAXY.NG1.InsuranceComponent.common.industry.html' | sxyTranslate}}" tooltip-placement="right"></salaxy-input>

    </div>
  </div>
  <div class="row" ng-repeat="item in $ctrl.current.items[0].occupations">
    <div class="col-sm-6">
      <salaxy-input-occupation-type name="occupationType" ng-model="item.occupationCode" label="SALAXY.NG1.InsuranceComponent.common.occupationCode" label-type="basic" required></salaxy-input-occupation-type>
    </div>
    <div class="col-sm-4 col-9">
      <salaxy-input ng-model="item.estimatedIncome" name="salary" label="SALAXY.NG1.InsuranceComponent.common.salaryLabel" sxy-currency label-type="basic" required></salaxy-input>
    </div>
    <div class="col-sm-2 col-3 text-end delete-row-col">
      <button class="btn btn-lt btn-danger btn-sm" ng-click="$ctrl.current.items[0].occupations.splice($index,1)"><i class="bi bi-trash-fill"></i> <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.delete"></span></button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <button class="btn btn-lt btn-secondary btn-sm" ng-click="$ctrl.current.items[0].occupations.push({})"><i class="bi bi-plus-lg" style="margin-right:5px"></i> {{'SALAXY.NG1.InsuranceComponent.common.addOccupation' | sxyTranslate}}</button>
    </div>
  </div>


</form>`);

 $templateCache.put("salaxy-components/modals/localTapiola/InsuranceInfo-new.html",`<form name="currentForm" class="form-horizontal" model="temp">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>
  <div class="text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}
    </h2>
    <p class="intro" ng-if="$ctrl.currentStep.intro != ''">{{ $ctrl.currentStep.intro }}</p>
  </div>
  <div class="row">
    <div class="col-md-5">
      <salaxy-datepicker-popup ng-model="$ctrl.current.items[0].startDate" placeholder="pp.kk.vvvv" name="insuranceStartDate" label="SALAXY.NG1.InsuranceComponent.common.startDate" min-date="$ctrl.today"
        label-type="basic" require="true" tooltip-html="{{'SALAXY.NG1.InsuranceComponent.common.startDateToolTip' | sxyTranslate}}"></salaxy-datepicker-popup>
    </div>
    <div class="col-md-4">
      <salaxy-input-enum label="SALAXY.NG1.InsuranceComponent.common.billingInterval" options="{1:'1', 2:'2', 3:'3', 4:'4'}" ng-model="$ctrl.current.items[0].billingInterval" name="billing" label-type="basic" required></salaxy-input-enum>
    </div>
    <div class="col-md-3">
      <salaxy-input ng-model="$ctrl.current.items[0].industry" name="industry" label="SALAXY.NG1.InsuranceComponent.common.industry.label" label-type="basic" required tooltip-html="{{'SALAXY.NG1.InsuranceComponent.common.industry.html' | sxyTranslate}}" tooltip-placement="top-right"></salaxy-input>
    </div>
  </div>
  <div class="row" ng-repeat="item in $ctrl.current.items[0].occupations">
    <div class="col-md-6">
      <salaxy-input-occupation-type name="occupationType" ng-model="item.occupationCode" label="SALAXY.NG1.InsuranceComponent.common.occupationCode" label-type="basic" required></salaxy-input-occupation-type>
    </div>
    <div class="col-md-4 col-9">
      <salaxy-input ng-model="item.estimatedIncome" name="salary" label="SALAXY.NG1.InsuranceComponent.common.salaryLabel" sxy-currency label-type="basic" required></salaxy-input>
    </div>
    <div class="col-md-2 col-3 text-end delete-row-col">
      <button class="btn-lt btn-danger btn-sm" ng-click="$ctrl.current.items[0].occupations.splice($index,1)"><i class="bi bi-trash-fill" ></i> <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.delete"></span></button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <button class="btn btn-lt btn-secondary btn-sm" ng-click="$ctrl.current.items[0].occupations.push({})"><i class="bi bi-plus-lg" style="margin-right:5px"></i> {{'SALAXY.NG1.InsuranceComponent.common.addOccupation' | sxyTranslate}}</button>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/localTapiola/Owner-info.html",`<form name="currentForm" class="form-horizontal" model="temp">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>

  <div class="text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}
    </h2>
    <p class="intro" sxy-text="SALAXY.NG1.InsuranceComponent.ownerInfo.intro" ps="."></p>
    <p sxy-text="SALAXY.NG1.InsuranceComponent.ownerInfo.introInfo" ps="."></p>
  </div>



  <fieldset>
    <legend sxy-text="SALAXY.NG1.InsuranceComponent.ownerInfo.ownerInfo"></legend>

    <div class="row" ng-repeat="item in $ctrl.current.company.owners">
      <div class="col-sm-8">
        <salaxy-input ng-model="item.avatar.displayName" name="ownerName{{$index}}" label="SALAXY.NG1.InsuranceComponent.ownerInfo.displayName" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="item.officialId" name="ownerPersonalId{{$index}}" label="SALAXY.NG1.InsuranceComponent.ownerInfo.officialId" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-8">
        <salaxy-input ng-model="item.address" name="ownerAddress{{$index}}" label="SALAXY.NG1.InsuranceComponent.ownerInfo.address" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="item.percentOfShares" name="ownerShare{{$index}}" label="SALAXY.NG1.InsuranceComponent.ownerInfo.percentOfShares" label-type="basic"></salaxy-input>
      </div>
      <div class="col-12 text-end">
        <button class="btn btn-lt btn-danger btn-sm" ng-click="$ctrl.current.company.owners.splice($index,1)"><i class="bi bi-trash-fill"></i> {{'SALAXY.UI_Terms.delete' | sxyTranslate}}</button>
      </div>
      <div class="col-12">
        <hr>
      </div>

    </div>

    <div class="row">
      <div class="col-12 ">
        <button class="btn btn-lt btn-secondary btn-sm" ng-click="$ctrl.current.company.owners.push({ avatar: {}})"><i class="bi bi-plus-lg" style="margin-right:5px"></i>{{'SALAXY.NG1.InsuranceComponent.ownerInfo.addOwner' | sxyTranslate}}</button>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <legend sxy-text="SALAXY.NG1.InsuranceComponent.ownerInfo.additionalOwnerInfo"></legend>
    <salaxy-input-boolean ng-model="$ctrl.current.company.complexOwnerStructure" label-type="no-label" name="additionalOwnerInfo" type="checkbox" label-true="SALAXY.NG1.InsuranceComponent.ownerInfo.additionalOwnerInfoLabel"></salaxy-input-boolean>
  </fieldset>

</form>`);

 $templateCache.put("salaxy-components/modals/localTapiola/Start.html",`<div class="row row-video">
  <div class="col-sm-6">
    <h1 class="text-center" sxy-text="SALAXY.NG1.InsuranceComponent.start.wizard.title2"></h1>
  </div>
  <div class="col-sm-6" class="text-center">
    <div class="video-wrapper">
      <div class="videoWrapper">
        <iframe src="https://www.youtube.com/embed/LDuzMEsPz4o" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12 mb-2">
    <h2 class="start-subtitle text-center" sxy-text="SALAXY.NG1.InsuranceComponent.start.heading"></h2>
    <p class="text-center" sxy-text="SALAXY.NG1.InsuranceComponent.start.infoText" ps="."></p>
  </div>
  <div class="col-12 col-sm-6 text-center mb-2">
    <button type="button" class="btn btn-lt btn-primary btn-sm" ng-click="$ctrl.setInsuranceAction('newInsurance'); $ctrl.goNext()" sxy-text="SALAXY.NG1.InsuranceComponent.start.newInsurance"></button>
  </div>
  <div class="col-12 col-sm-6 text-center mb-2">
    <button type="button" class="btn btn-lt btn-primary btn-sm" ng-click="$ctrl.setInsuranceAction('moveInsurance'); $ctrl.goNext()" sxy-text="SALAXY.NG1.InsuranceComponent.start.moveInsurance"></button>
  </div>
  <div class="col-12 text-center mb-2">
    <button type="button" class="btn btn-lt btn-primary btn-sm" ng-click="$ctrl.setInsuranceAction('newInsuranceForEntrepreneur'); $ctrl.goNext()" sxy-text="SALAXY.NG1.InsuranceComponent.start.newInsuranceForEntrepreneur"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/localTapiola/ThankYou.html",`<div class="text-center mb-2">
  <h1>
    {{ $ctrl.currentStep.title }}
  </h1>


  <p class="intro" sxy-text="SALAXY.NG1.InsuranceComponent.thankYou.intro" ps="."></p>

  <p ng-if="$ctrl.action == 'newInsurance' || $ctrl.action == 'moveInsurance'" sxy-html="SALAXY.NG1.InsuranceComponent.thankYou.notNewInsuranceForEntrepreneur.html"></p>
  <p ng-if="$ctrl.action == 'newInsuranceForEntrepreneur'" sxy-html="SALAXY.NG1.InsuranceComponent.thankYou.newInsuranceForEntrepreneur.html"></p>
</div>

<div class="row" ng-if="$ctrl.action == 'newInsurance' || $ctrl.action == 'moveInsurance'" style="margin-top:30px;">
  <div class="col-12 col-sm-6  mb-2 text-center">
    <button class="btn btn-lt btn-primary btn-sm" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  </div>
  <div class="col-sm-6 mb-2 text-center">
    <button class="btn btn-lt btn-primary btn-sm" ng-click="$ctrl.setInsuranceAction('newInsuranceForEntrepreneur');  $ctrl.goNext()" sxy-text="SALAXY.NG1.InsuranceComponent.thankYou.newInsuranceForEntrepreneur.text"></button>
  </div>
</div>

<div class="row" ng-if="$ctrl.action == 'newInsuranceForEntrepreneur'" style="margin-top:30px;">
  <div class="col-12 col-sm-6 mb-2 text-center">
    <button class="btn btn-lt btn-primary btn-sm" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  </div>
  <div class="col-sm-6 mb-2 text-center">
    <button class="btn btn-lt btn-primary btn-sm" ng-click="$ctrl.setInsuranceAction('newInsurance'); $ctrl.goNext()" sxy-text="SALAXY.NG1.InsuranceComponent.thankYou.notNewInsuranceForEntrepreneur.text"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/onboarding/company/company-legal.html",`﻿<form name="companyLegalForm" class="form-horizontal">
  <!-- Updating formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = companyLegalForm.$valid && (wizard.showCompanySelection || wizard.model.signature.isProcura)}}</span>
  <div class="row">
    <div class="col-md-6">
      <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.legalLegend"></legend>
      <div class="mb-4">
        <p>
          <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.pep" ps="*"></span>
          <i class="bi bi-info-circle-fill" type="button" data-bs-toggle="popover" data-bs-html="true" data-bs-title="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.pepTitle' | sxyTranslate" data-bs-content="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.pepPopOver' | sxyTranslate" data-bs-container="body"
            data-bs-placement="top" sxy-bs5-popover></i>
        </p>
        
        <salaxy-input-boolean type="radio" name="identityPep" label="" label-type="plain" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" ng-model="wizard.model.signature.isPep" required></salaxy-input-boolean>
      </div>
      <div ng-if="wizard.model.company.companyType != 'fiRy'" class="mb-4">
        <p>
          <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.owner" ps="*"></span>
          <i class="bi bi-info-circle-fill" type="button" data-bs-toggle="popover" data-bs-html="true" data-bs-title="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.ownerTitle' | sxyTranslate" data-bs-content="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.ownerPopOver' | sxyTranslate" data-bs-container="body"
            data-bs-placement="top" sxy-bs5-popover></i>
        </p>
        <salaxy-input-boolean type="radio" name="Ownership.IsRequiredTracking" label="" label-type="plain" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" ng-model="wizard.model.company.ownership.isRequiredTracking" required></salaxy-input-boolean>

      </div>
      <div ng-if="!wizard.showCompanySelection" class="mb-4">
        <p>
          <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.procura" ps="*"></span>
          <i class="bi bi-info-circle-fill" type="button" data-bs-toggle="popover" data-bs-html="true" data-bs-title="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.procuraTitle' | sxyTranslate" data-bs-content="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.procuraPopOver' | sxyTranslate" data-bs-container="body"
            data-bs-placement="top" sxy-bs5-popover></i>
           
        </p>
        <salaxy-input-boolean type="radio" name="procuraOptions" label="" label-type="plain" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" ng-model="wizard.model.signature.isProcura" required></salaxy-input-boolean>
        <br />
        <div ng-if="!wizard.model.signature.isProcura" class="alert alert-danger">
          <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.procuraText"></p>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div ng-if="!wizard.model.company.ownership.isRequiredTracking">
        <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.fiva"></legend>
        <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.fivaText"></p>
      </div>
      <div ng-if="wizard.model.company.ownership.isRequiredTracking">
        <fieldset class="form-horizontal">
          <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.shareHolderTitle"></legend>
          <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.shareHolderText" ps=":"></p>
          <salaxy-input type="text" name="shareholder1" label="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.shareHolder' | sxyTranslate}} 1" label-cols="col-sm-4 col-md-3 col-lg-4" ng-model="wizard.model.company.ownership.shareHolders[0].name" require="true"></salaxy-input>
          <salaxy-input type="text" name="shareholder2" label="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.shareHolder' | sxyTranslate}} 2" label-cols="col-sm-4 col-md-3 col-lg-4" ng-model="wizard.model.company.ownership.shareHolders[1].name">
          </salaxy-input>
          <salaxy-input type="text" name="shareholder3" label="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.shareHolder' | sxyTranslate}} 3" label-cols="col-sm-4 col-md-3 col-lg-4" ng-model="wizard.model.company.ownership.shareHolders[2].name">
          </salaxy-input>
          <salaxy-input type="text" name="shareholder4" label="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.shareHolder' | sxyTranslate}} 4" label-cols="col-sm-4 col-md-3 col-lg-4" ng-model="wizard.model.company.ownership.shareHolders[3].name">
          </salaxy-input>
        </fieldset>
      </div>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/company/company.html",`﻿<form name="companyForm" class="form-horizontal">
  <!-- Updating formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = companyForm.$valid && ( wizard.showCompanySelection || (wizard.model.company.resolvedId == (sessionCtrl.session.hasCurrentAccount ? sessionCtrl.session.currentAccount.id:null)))}}</span>
  <div class="">
    <br />
    <p>{{wizard.currentStep.intro | sxyTranslate}}</p>
    <br />
  </div>
  <div>
    <div class="alert alert-danger" ng-if="wizard.showCompanySelection && wizard.existingCompanyAlert">
      <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.existingCompanyAlert"></p>
      <p>
        <a ng-href="{{wizard.model.ui.successUrl}}" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.loginLink"></a>
      </p>
    </div>
  </div>
  <div ng-if="!wizard.showCompanySelection && ( wizard.model.company.resolvedId != (sessionCtrl.session.hasCurrentAccount ? sessionCtrl.session.currentAccount.id:null))">
    <div class="alert alert-danger">
      <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.existingBusinessIdAlert" params="{businessId: wizard.model.company.businessId}"></p>
      <p>
        <a ng-href="{{wizard.model.ui.successUrl}}" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.loginLink2"></a>
      </p>
      <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.existingBusinessIdAlert2"></p>
    </div>
  </div>
  <div class="row">

    <div ng-if="wizard.showCompanySelection" class="col-md-6">
      <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyInfo"></legend>
      <salaxy-input readonly="true" label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyBusinessId" name="businessId" ng-model="wizard.model.company.businessId" tooltip-html="Tarvitset käyttäjätilin luomiseen Y-tunnuksen. Jos käytät palveluamme yhdistyksen palkanmaksuun, yhdistyksellä on oltava Y-tunnus. Yhdistys voi hakea Y-tunnuksen tekemällä perustamisilmoituksen Verohallintoon (lomakkeella Y1)." ng-required="true"></salaxy-input>
      <salaxy-input salaxy-if-role="!test" readonly="true" label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyName" name="name" ng-model="wizard.model.company.name" ng-required="true"></salaxy-input>
      <salaxy-input salaxy-if-role="test" label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyName" name="name" ng-model="wizard.model.company.name" ng-required="true"></salaxy-input>
      <div class="row mb-2" salaxy-if-role="!test">
        <label for="Yritysmuoto" class="col-sm-4 control-label" style="text-align:left">
          <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyType" ps="*"></span>
        </label>
        <div class="col-sm-8">
          <input type="text" class="form-control" id="Yritysmuoto" name="Yritysmuoto" placeholder="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyType' | sxyTranslate | lowercase}}" readonly="true" autocomplete="off" value="{{ !wizard.model.company.companyType ? '' : ('SALAXY.ENUM.CompanyType.' + wizard.model.company.companyType +'.label' | sxyTranslate) }}"/>
        </div>
      </div>
      <salaxy-input-enum salaxy-if-role="test" label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyType" name="companyType" ng-model="wizard.model.company.companyType" enum="CompanyType" type="select" placeholder="SALAXY.UI_Terms.select" ng-required="true"></salaxy-input-enum>
    </div>

    <div ng-if="!wizard.showCompanySelection" class="col-md-6">
      <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyInfo"></legend>
      <div class="row mb-2">
        <label for="businessId" class="col-sm-4 col-md-3 col-lg-4 control-label" style="text-align: left">
         <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyBusinessId" ps="*"></span>
          <i class="bi bi-info-circle-fill" 
            type="button" 
            data-bs-toggle="popover" 
            data-bs-html="true" 
            data-bs-title="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyBusinessId' | sxyTranslate" 
            data-bs-content="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.businessIdPopOver' | sxyTranslate" 
            data-bs-container="body" 
            data-bs-placement="top" sxy-bs5-popover>
          </i>
        </label>
        <div class="col-sm-8 col-md-9 col-lg-8">
          <div class="input-group">
            <input ng-disabled="sessionCtrl.session.hasCurrentAccount" type="text" id="businessId" class="form-control" ng-model="wizard.model.company.businessId" sxy-company-id-fi ng-required="true">
            <div class="input-group-btn">
              <button 
                ng-disabled="sessionCtrl.session.hasCurrentAccount" 
                ng-click="wizard.searchYtj('businessId')" 
                class="btn btn-default form-control" 
                type="button" 
                data-bs-toggle="popover" 
                data-bs-html="true" 
                data-bs-title="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchTitle' | sxyTranslate" 
                data-bs-content="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjPopOver' | sxyTranslate" 
                data-bs-container="body" 
                data-bs-placement="top" 
                data-bs-trigger="hover"
                sxy-bs5-popover>
                <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchBtn"></span>
                <span class="d-none d-md-inline" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchBtn2"></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <label for="name" class="col-sm-4 col-md-3 col-lg-4 control-label" style="text-align: left" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyName" ps="*"></label>
        <div class="col-sm-8 col-md-9 col-lg-8">
          <div class="input-group">
            <input ng-disabled="sessionCtrl.session.hasCurrentAccount" type="text" class="form-control" id="name" ng-model="wizard.model.company.name" ng-required="true">
            <div class="input-group-btn">
              <button 
                ng-disabled="sessionCtrl.session.hasCurrentAccount" 
                class="btn btn-default form-control" 
                type="button" 
                ng-click="wizard.searchYtj('name')"
                data-bs-toggle="popover" 
                data-bs-html="true" 
                data-bs-title="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchTitle' | sxyTranslate}}"
                data-bs-content="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjPopOver' | sxyTranslate}}" 
                data-bs-container="body" 
                data-bs-placement="top"  
                data-bs-trigger="hover"
                sxy-bs5-popover>
                <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchBtn"></span>
                <span class="d-none d-md-inline" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchBtn2"></span>
              </button>
            </div>
          </div>

        </div>
      </div>
      <!-- HUOM! Tästä kentästä on mobiiliversio edempänä koodissa -->
      <salaxy-input-enum class="d-none d-sm-block" label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyType2" label-cols="col-sm-4 col-md-3 col-lg-4" enum="CompanyType" options="{'fiOy':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiOy' | sxyTranslate),'fiTm':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiTm' | sxyTranslate),'fiRy':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiRy' | sxyTranslate),'fiYy':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiYy' | sxyTranslate)}" name="companyType" ng-model="wizard.model.company.companyType" disabled="sessionCtrl.session.hasCurrentAccount" require="true"></salaxy-input-enum>
    </div>

    <!-- MOBIILIVERSIO YTJ haun tulokset/virheet -->
    <div ng-if="!wizard.showCompanySelection" class="d-sm-none col-12">
      <!--Näytetään y-tunnuksesta johtuvat virheet, jos niitä on -->
      <div ng-if="wizard.getValidationError('Company.BusinessId') && wizard.getValidationError('Company.BusinessId').type=='invalid'">
        <h3 sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchResultTitle" ps=":"></h3>
        <p>{{ wizard.getValidationError('Company.BusinessId').msg | sxyTranslate}}</p>
      </div>

      <div ng-if="wizard.model.company.ytjSearch != null">
        <h3>
          <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchResultTitle" ps=":"></span>
          <span ng-if="wizard.model.company.ytjSearch && wizard.model.company.ytjSearch.result.length != 0">
            ({{wizard.model.company.ytjSearch.result.length}} kpl)
          </span>
        </h3>
        <!--Näytetään ytj-hausta johtuvat virheet, jos niitä on -->
        <div ng-if="wizard.model.company.ytjSearch.userMessage != null">
          <p>{{ wizard.model.company.ytjSearch.userMessage }}</p>
        </div>
        <div ng-if="wizard.model.company.ytjSearch.isSuccess">
          <!--Näytetään että tiedot syötetty jos yrityksiä oli tasan yksi -->
          <div ng-if="wizard.model.company.ytjSearch.result.length == 1">
            <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchResultText"></p>
          </div>
          <!--Näytetään viestit jos yrityksiä on nolla-->
          <div ng-if="wizard.model.company.ytjSearch.result.length == 0 && wizard.model.validation.isOfficialIdValid">
            <p>{{wizard.model.company.ytjSearch.userMessage}}</p>
          </div>
          <div ng-if="wizard.model.company.ytjSearch.result.length != 0">
            <div class="accordion accordion-flush salaxy-accordion" id="companies">
              <div ng-repeat="company in wizard.model.company.ytjSearch.result track by $index" class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#company{{$index}}">
                    {{company.name}}
                  </button>
                </h2>
                <div id="company{{$index}}" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#companies">
                  <div class="accordion-body">
                    <p>{{company.businessId}}<br /> {{company.type}} <br />
                      <button class="btn btn-primary" ng-click="wizard.chooseBusinessId(company.businessId)" sxy-text="SALAXY.UI_Terms.select"></button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyContact"></legend>
      <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyStreet" name="Katuosoite" ng-model="wizard.model.company.contact.street" ng-required="true"></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyPostalCode" name="Postinumero" sxy-postal-code-fi ng-model="wizard.model.company.contact.postalCode" ng-required="true"></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyCity" name="Postitoimipaikka" ng-model="wizard.model.company.contact.city" ng-required="true"></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyEmail" name="Sahkoposti" ng-model="wizard.model.company.contact.email" ng-required="true" sxy-email></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyPhone" name="Puhelinnumero" ng-model="wizard.model.company.contact.telephone" ng-required="true" sxy-mobile-phone></salaxy-input>
      <!-- HUOM! Tästä kentästä on mobiiliversio ylempänä koodissa -->
      <div ng-if="!wizard.showCompanySelection" class="d-block d-sm-none">
        <salaxy-input-enum label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyType2" label-cols="col-sm-4 col-md-3 col-lg-4" enum="CompanyType" options="{'fiOy':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiOy' | sxyTranslate),'fiTm':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiTm' | sxyTranslate),'fiRy':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiRy' | sxyTranslate),'fiYy':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiYy' | sxyTranslate)}"
          name="companyTypeMobile" ng-model="wizard.model.company.companyType" disabled="sessionCtrl.session.hasCurrentAccount" require="true"></salaxy-input-enum>
      </div>
    </div>

    <!-- YTJ haun tulokset/virheet -->
    <div ng-if="!wizard.showCompanySelection" class="d-none d-sm-block col-12">
      <!-- Näytetään y-tunnuksesta johtuvat virheet, jos niitä on -->
      <div ng-if="wizard.getValidationError('Company.BusinessId') && wizard.getValidationError('Company.BusinessId').type=='invalid'">
        <h3 sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchResultTitle" ps=":"></h3>
        <p>{{ wizard.getValidationError('Company.BusinessId').msg | sxyTranslate}}</p>
      </div>

      <div ng-if="wizard.model.company.ytjSearch != null">
        <h3>
          <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchResultTitle" ps=":"></span>
          <span ng-if="wizard.model.company.ytjSearch && wizard.model.company.ytjSearch.result.length != 0">
            ({{wizard.model.company.ytjSearch.result.length}} kpl)
          </span>
        </h3>
        <!--Näytetään ytj-hausta johtuvat virheet, jos niitä on -->
        <div ng-if="wizard.model.company.ytjSearch.userMessage != null">
          <p>{{ wizard.model.company.ytjSearch.userMessage }}</p>
        </div>


        <!-- Haku onnistui -->
        <div ng-if="wizard.model.company.ytjSearch.isSuccess">
          <!--Näytetään viestit jos yrityksiä on nolla-->
          <div ng-if="wizard.model.company.ytjSearch.result.length == 0 && wizard.model.validation.isOfficialIdValid">
            <p>{{wizard.model.company.ytjSearch.userMessage}}</p>
          </div>
          <div ng-if="wizard.model.company.ytjSearch.result.length != 0" class="table-responsive" style="max-height: 300px; overflow-y: auto;">

            <table class="table table-hover table-bordered" style="overflow-wrap: break-word">
              <thead>
                <tr>
                  <th>
                    <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyName2"></span>
                    <br />
                    <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyBusinessId"></span>
                  </th>
                  <th class="d-none d-sm-table-cell" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyType"></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="company in wizard.model.company.ytjSearch.result">
                  <td>
                    {{company.name}}
                    <br /> {{company.businessId}}
                  </td>
                  <td class="d-none d-sm-table-cell">{{company.type}}</td>
                  <td>
                    <a class="btn btn-primary" ng-click="wizard.chooseBusinessId(company.businessId)" sxy-text="SALAXY.UI_Terms.select"></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/company/contract.html",`﻿<form name="contractForm">
  <span class="d-none">{{ wizard.formDataValidity = contractForm.$valid}}</span>
  
  <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.intro"></p>

  <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.info"></p>

  <div class="row" ng-controller="SignatureController as sign">
    <div class="col-md-6">
      <fieldset ng-if="!wizard.showCompanySelection">
        <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.yourPersonalId"></legend>
        <div>
          <salaxy-input name="personalId" label-type="plain" type="text" style="width:150px" placeholder="SALAXY.NG1.CompanyOnboardingComponent.stepContract.personalIdExample" ng-model="wizard.model.signature.personalId" require="true" sxy-personal-id-fi></salaxy-input>
        </div>
      </fieldset>

      <div class="mb-2">
        <input ng-init="wizard.model.signature.terms = false" name="terms" type="checkbox" require="true" ng-model="wizard.model.signature.terms"></input>
        <span sxy-html="SALAXY.NG1.CompanyOnboardingComponent.stepContract.termsText.html"></span>
        <a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.termsText2"></a> <span sxy-html="SALAXY.NG1.CompanyOnboardingComponent.stepContract.termsText3.html"></span>
      </div>

      <fieldset>
        <div ng-if="wizard.model.accountType == 'company'">
          <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.usePersonalBank"></p>
        </div>

        <p sxy-html="SALAXY.NG1.CompanyOnboardingComponent.stepContract.privacyPolicy.html"></p>
        
        <div sxy-if-role="test">
          <h3>TEST: Huomaa HETU:sta!</h3>
          <p class="text-warning">
            Allekirjoitus ohjaa nyt testiympäristöön, jossa
            <strong>HETU tarkistetaan</strong>.
            Katso testiympäristön
            <a href="https://gist.github.com/ykarikos/e43e567eb7b9e05432d4bd9d0b51ef35" target="_blank">HETU:t täältä</a>
            (valitse validi hetu).
          </p>
        </div>
      </fieldset>
    </div>

    <div class="col-md-6 d-none d-sm-block">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.pdfPreviewTitle"></legend>
        <small><a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.downloadHereLink"></a></small>

        <iframe ng-src="{{ wizard.getPdfPreviewAddress() }}" style="width: 100%; height: 300px"></iframe>
      </fieldset>
    </div>
    <div class="col-md-6 d-block d-sm-none">
      <a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.pdfPreviewLink"></a>
    </div>

  </div>

</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/company/contractButtons.html",`﻿<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>

<button ng-if="wizard.model.signature.personalId == null || wizard.model.signature.terms == false" ng-disabled="true" class="btn btn-primary" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.signBtn"></button>
<a ng-if="!(wizard.model.signature.personalId == null || wizard.model.signature.terms == false)" ng-href="{{wizard.vismaSignUrl}}" target="_top" class="btn btn-primary" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.signBtn"></a>`);

 $templateCache.put("salaxy-components/modals/onboarding/company/defaultWizardButtons.html",`﻿<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-click="wizard.goNext()" ng-disabled="!wizard.canGoNext" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>`);

 $templateCache.put("salaxy-components/modals/onboarding/company/firstPageButtons.html",`﻿<!--a ng-if="wizard.model.ui.cancelUrl" ng-href="{{wizard.model.ui.cancelUrl}}"  class="btn btn-default">Takaisin etusivulle</a-->
<button class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.backToFront"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-click="wizard.goNext()" ng-disabled="!wizard.canGoNext" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>`);

 $templateCache.put("salaxy-components/modals/onboarding/company/index.html",`<div ng-controller="SessionController as sessionCtrl" class="company-onboarding">
  <div ng-controller="CompanyOnboardingController as wizard">
    <div ng-controller="NaviController as $naviCtrl">
      <div ng-if="!$naviCtrl.showFullPageLoader">
        <div class="modal-header bg-primary">
          <h2 class="modal-title" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.modalTitle"></h2>
          <button type="button" class="btn-close btn-close-white" ng-click="$close('cancel')" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="d-block d-md-none">
            <h4><span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.step"></span> {{ wizard.currentStep.number }}/{{ wizard.steps.length }}</h4>
          </div>
          <div class="salaxy-wizard">
            <div class="wizard-steps">
              <div class="wizard-step" ng-repeat="step in wizard.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
                <span class="salaxy-avatar">
                  <div class="wizard-icons-wrapper">
                    <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
                    <i class="bi bi-circle-fill"></i>
                  </div>
                  <strong class="number">{{ step.number }}</strong>
                </span>
                <span class="step-text">{{ step.title | sxyTranslate }}</span>
              </div>
            </div>
            <div class="wizard-strikethrough"></div>
          </div>
          <ng-include src="wizard.currentStep.view"></ng-include>
        </div>
        <div class="modal-footer">
          <ng-include class="d-flex justify-content-between w-100" src="wizard.currentStep.buttonsView"></ng-include>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/onboarding/company/suomifi.html",`<form name="currentForm">
  <!-- Hidden ariable formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div class="">
    <br />
    <p>{{wizard.currentStep.intro | sxyTranslate}}</p>
    <br />
  </div>
  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepSuomiFi.infoText"></legend>
        <div class="form-horizontal">
          <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.stepSuomiFi.personalId" name="personalId" ng-model="wizard.model.signature.personalId" ng-required="true" sxy-personal-id-fi></salaxy-input>
        </div>
      </fieldset>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/company/suomifiButtons.html",`﻿<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-click="wizard.goToSuomifi()" ng-disabled="!wizard.canGoNext" class="btn btn-primary" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepSuomiFi.goToSuomiFiBtn"></button>`);

 $templateCache.put("salaxy-components/modals/onboarding/company/wizard_index.html",`﻿<form name="currentForm" class="form-horizontal">
  <!-- Hidden ariable formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div class="">
    <br />
    <p>{{wizard.currentStep.intro | sxyTranslate}}</p>
    <br />
  </div>
  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.step1.personInfo"></legend>
        <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.step1.personFirstName" name="Etunimi" ng-model="wizard.model.person.firstName" ng-required="true"></salaxy-input>
        <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.step1.personLastName" name="Sukunimi" ng-model="wizard.model.person.lastName" ng-required="true"></salaxy-input>
      </fieldset>
    </div>
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.step1.personContact"></legend>
        <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.step1.personEmail" name="Sahkoposti" ng-model="wizard.model.person.contact.email" ng-required="true" sxy-email></salaxy-input>
        <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.step1.personPhone" name="Puhelinnumero" ng-model="wizard.model.person.contact.telephone" ng-required="true" sxy-mobile-phone></salaxy-input>
      </fieldset>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/customer/buttons.html",`﻿<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-click="wizard.goNext()" ng-disabled="!wizard.canGoNext" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>`);

 $templateCache.put("salaxy-components/modals/onboarding/customer/commit-buttons.html",`<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-danger" sxy-text="SALAXY.UI_Terms.previous"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-click="wizard.commit()" ng-disabled="!wizard.canGoNext" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>`);

 $templateCache.put("salaxy-components/modals/onboarding/customer/company-legal.html",`<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div class="row">
    <div class="col-12 col-md-6">
      <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.legalTitle"></legend>
      <div class="mb-4">
        <p>
          <span sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.pep" ps="*"></span>
          <i class="bi bi-info-circle-fill"
            type="button" 
            data-bs-toggle="popover" 
            data-bs-html="true"
            data-bs-title="'SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.pepTitle' | sxyTranslate" 
            data-bs-content="'SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.pepPopOver' | sxyTranslate" 
            data-bs-container="body" 
            data-bs-placement="top" sxy-bs5-popover>
          </i>
        </p>
        <!-- TODO: test-->
        <salaxy-input-boolean type="radio" name="identityPep" label="" label-type="plain" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" ng-model="wizard.model.signature.isPep" require="true"></salaxy-input-boolean>
      </div>
    
      <div cng-hide="!(wizard.model.company.companyType == 'fiOy' || wizard.model.company.companyType == 'fiYy')" class="mb-4">
        <p>
          <span sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.owner" ps="*"></span>
          <i class="bi bi-info-circle-fill"
            type="button" 
            data-bs-toggle="popover" 
            data-bs-html="true"
            data-bs-title="'SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.ownerTitle' | sxyTranslate" 
            data-bs-content="'SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.ownerPopOver' | sxyTranslate" 
            data-bs-container="body" 
            data-bs-placement="top" sxy-bs5-popover>
          </i>
        </p>
        <div class="radio">
          <label class="radio-inline" for="IsRequiredTracking-true">
            <input type="radio" id="IsRequiredTracking-true" name="Ownership.IsRequiredTracking" ng-value="true" ng-model="wizard.model.company.ownership.isRequiredTracking" required> <span sxy-text="SALAXY.UI_Terms.yes"></span>
          </label>
          <label class="radio-inline" for="IsRequiredTracking-false">
            <input type="radio" id="IsRequiredTracking-false" name="Ownership.IsRequiredTracking" ng-value="false" ng-model="wizard.model.company.ownership.isRequiredTracking" required><span sxy-text="SALAXY.UI_Terms.no"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div ng-hide="wizard.model.company.ownership.isRequiredTracking">
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.fiva"></legend>
        <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.fivaText"></p>
      </div>
      <div ng-hide="!wizard.model.company.ownership.isRequiredTracking">
        <fieldset class="form-horizontal">
          <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.shareHolderTitle"></legend>
          <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.shareHolderText"></p>
          <div class="row mb-2">
            <label class="col-sm-4 col-md-3 col-lg-4 col-form-label" for="shareholder1" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.shareHolder" ps=" 1*"></label>
            <div class="col-sm-8 col-md-9 col-lg-8">
              <input class="form-control" id="shareholder1" name="shareholder1" type="text" ng-model="wizard.model.company.ownership.shareHolders[0].name" value="" ng-required="wizard.model.company.ownership.isRequiredTracking == true">
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-sm-4 col-md-3 col-lg-4 col-form-label" for="shareholder2" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.shareHolder" ps=" 2 "></label>
            <div class="col-sm-8 col-md-9 col-lg-8">
              <input class="form-control" id="shareholder2" name="shareholder2" type="text" ng-model="wizard.model.company.ownership.shareHolders[1].name" value="">
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-sm-4 col-md-3 col-lg-4 col-form-label" for="shareholder3" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.shareHolder" ps=" 3 "></label>
            <div class="col-sm-8 col-md-9 col-lg-8">
              <input class="form-control" id="shareholder3" name="shareholder3" type="text" ng-model="wizard.model.company.ownership.shareHolders[2].name" value="">
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-sm-4 col-md-3 col-lg-4 col-form-label" for="shareholder4" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.shareHolder" ps=" 4 "></label>
            <div class="col-sm-8 col-md-9 col-lg-8">
              <input class="form-control" id="shareholder4" name="shareholder4" type="text" ng-model="wizard.model.company.ownership.shareHolders[3].name" value="">
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
  
</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/customer/company.html",`<form name="currentForm">
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div>
    <div class="alert alert-danger" ng-if="wizard.existingCompanyAlert">
      <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.existingCompanyAlert"></p>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6">
      <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyInfo"></legend>
      <div class="form-horizontal">
        <salaxy-input salaxy-if-role="!test" readonly="true" label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyBusinessId" name="Ytunnus" ng-required="true" ng-model="wizard.model.company.businessId"></salaxy-input>
        <salaxy-input salaxy-if-role="test" label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyBusinessId" name="Ytunnus" ng-required="true" ng-model="wizard.model.company.businessId"></salaxy-input>
        <salaxy-input salaxy-if-role="!test" readonly="true" label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyName" name="Nimi" ng-required="true" ng-model="wizard.model.company.name"></salaxy-input>
        <salaxy-input salaxy-if-role="test" label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyName" name="Nimi" ng-required="true" ng-model="wizard.model.company.name"></salaxy-input>
        <div class="row" salaxy-if-role="!test">
          <label for="Yritysmuoto" class="col-12 col-sm-4 col-form-label">
            <span sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyType" ps="*"></span>
          </label>
          <div class="col-12 col-sm-8">
            <input type="text" class="form-control" id="Yritysmuoto" name="Yritysmuoto" placeholder="{{'SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyType' | sxyTranslate | lowercase}}" readonly="true" autocomplete="off" value="{{ !wizard.model.company.companyType ? '' : ('SALAXY.ENUM.CompanyType.' + wizard.model.company.companyType +'.label' | sxyTranslate) }}"
            />
          </div>
        </div>
      </div>
      <salaxy-input-enum sxy-if-role="test" label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyType" name="companyType" ng-model="wizard.model.company.companyType" enum="CompanyType" type="select" placeholder="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyType"
        required></salaxy-input-enum>
    </div>
    <div class="col-12 col-md-6">
      <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyContact"></legend>
      <div class="form-horizontal">
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyStreet" name="Katuosoite" ng-model="wizard.model.company.contact.street" ng-required="true"></salaxy-input>
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyPostalCode" name="Postinumero" sxy-postal-code-fi ng-model="wizard.model.company.contact.postalCode" ng-required="true"></salaxy-input>
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyCity" name="Postitoimipaikka" ng-model="wizard.model.company.contact.city" ng-required="true"></salaxy-input>
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyEmail" name="Sahkoposti" ng-model="wizard.model.company.contact.email" ng-required="true" sxy-email></salaxy-input>
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyPhone" name="Puhelinnumero" ng-model="wizard.model.company.contact.telephone" ng-required="true" sxy-mobile-phone></salaxy-input>
      </div>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/customer/finish-buttons.html",`<div class="btn-group" role="group">
  <button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-danger" sxy-text="SALAXY.UI_Terms.previous"></button>
</div>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<div class="btn-group">
  <button class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button class="btn btn-success" ng-click="$close('ok');wizard.launch()" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.newAccountBtn"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/onboarding/customer/finish.html",`﻿<form name="currentForm">
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div class="row">
    <div class="col-md-12" sxy-html="SALAXY.NG1.CustomerOnboardingComponent.stepInviteCompany.html" params="{sharingLink :wizard.sharingLink, mailToLink : wizard.mailtoLink}"></div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/customer/index.html",`<div ng-controller="SessionController as sessionCtrl">
  <div ng-controller="CustomerOnboardingController as wizard">
    <div ng-controller="NaviController as $naviCtrl">
      <div ng-if="!$naviCtrl.showFullPageLoader">
        <div class="modal-header bg-primary">
          <h2 class="modal-title" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.modalTitle"></h2>
          <button type="button" class="btn-close btn-close-white" ng-click="$close('cancel')" aria-label="Close"></button>
        </div>
        <div class="modal-body">       
          <div class="d-block d-md-none">
            <h4><span sxy-text="SALAXY.NG1.CustomerOnboardingComponent.step"></span> {{wizard.currentStep.number}}/{{wizard.steps.length}}</h4>
          </div>
          <div class="salaxy-wizard">
            <div class="wizard-steps">
              <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
                <span class="salaxy-avatar">
                  <div class="wizard-icons-wrapper">
                    <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
                    <i class="bi bi-circle-fill"></i>
                  </div>
                  <strong class="number">{{ step.number }}</strong>
                </span>
                <span class="step-text">{{ step.title | sxyTranslate }}</span>
              </div>
            </div>
            <div class="wizard-strikethrough"></div>
          </div>
          <ng-include src="wizard.currentStep.view"></ng-include>
        </div>
        <div class="modal-footer">
          <ng-include class="d-flex justify-content-between w-100" src="wizard.currentStep.buttonsView"></ng-include>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/onboarding/customer/insurance.html",`<form name="currentForm">

  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid}}</span>

  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionTitle"></legend>
        <div class="form-horizontal">
          <salaxy-input-boolean label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionText" type="radio" name="isPensionContractDone" ng-model="wizard.model.products.pension.isPensionContractDone" label-type="basic" label-true="SALAXY.UI_Terms.yes"
            label-false="SALAXY.UI_Terms.no" ng-change="wizard.checkPensionCompanySelection()"></salaxy-input-boolean>
        </div>
        <div ng-if="!wizard.model.products.pension.isPensionContractDone">
          <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.hasPension"></p>
        </div>
        <div ng-if="wizard.model.products.pension.isPensionContractDone" class="form-horizontal">
          <salaxy-input-enum label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionCompany" name="pensionCompany" enum="PensionCompany" filter="varma,elo,ilmarinen,veritas,apteekkien,verso,valio,kevaMunicipal,kevaAland,kevaChurch,kevaKela,kevaState" ng-model="wizard.model.products.pension.pensionCompany"
            ng-change="wizard.checkPensionCompanySelection(); wizard.model.products.pension.pensionContractNumber = null;" require="true"></salaxy-input-enum>

          <main salaxy-if-role="test" class="test-number">
            <div class="row" ng-if="wizard.model.products.pension.pensionCompany != 'null' && wizard.model.products.pension.pensionCompany != 'none'">
              <div class="col-sm-8 offset-sm-4 mb-2 text-end text-sm-start">
                <span><span sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.testOnly"></span> <button class="btn btn-secondary  btn-xs" ng-click="wizard.setPensionNumberForTest()" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.testGenerateNumberBtn"></button></span>
              </div>
            </div>
          </main>
          <div ng-if="wizard.model.products.pension.pensionCompany != 'other'">
            <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionContractNumber" require="true" type="text" name="pensionContractNumber" id="pensionContractNumber" ng-model="wizard.model.products.pension.pensionContractNumber" tooltip-html="{{'SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionContractNumberToolTip.html' | sxyTranslate}}"
              tooltip-placement="right" sxy-pension-contract-number="wizard.model.products.pension.pensionCompany"></salaxy-input>

            <div class="row" ng-show="currentForm.pensionContractNumber.$error.sxyTemporaryPensionContractNumber">
              <div class="col-12 input-info text-danger">
                <div class="input-info-icon"><i class="bi bi-exclamation-triangle-fill"></i></div>
                <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionContractNumberTemporaryToolTip.html"></p>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    <div class="col-sm-6 col-12" ng-if="wizard.model.products.pension.isPensionContractDone">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionHandling"></legend>
        <div class="input-wrapper">
          <div class="form-group">
            <div>
              <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionSelfHandleDescription"></p>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.insuranceTitle"></legend>
        <div class="form-horizontal">
          <salaxy-input-boolean type="radio" label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.insuranceText" label-type="basic" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" ng-model="wizard.model.products.insurance.isInsuranceContractDone"
            name="isInsuranceContractDone" ng-change="wizard.checkInsuranceCompanySelection()"></salaxy-input-boolean>
        </div>
        <div ng-if="wizard.model.products.insurance.isInsuranceContractDone" class="form-horizontal">
          <salaxy-input-enum enum="InsuranceCompany" filter="if,fennia,lähiTapiola,pohjantähti,pohjola,turva,aVakuutus,folksam,alandia,ålands" name="InsuranceCompany" label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.insuranceCompany" ng-model="wizard.model.products.insurance.insuranceCompany"
            require="true"></salaxy-input-enum>
          <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.insuranceContractNumber" require="true" name="insuranceContractNumber" ng-model="wizard.model.products.insurance.insuranceContractNumber"></salaxy-input>
        </div>
        <div ng-if="!wizard.model.products.insurance.isInsuranceContractDone && !wizard.model.products.insurance.isPartnerInsurance">
          <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.noInsuranceAlert"></p>
        </div>
      </fieldset>
    </div>
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.taxTitle"></legend>

        <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.taxText"></p>
        <div class="form-horizontal">
          <salaxy-input-enum ng-model="wizard.model.products.tax.irReporting" name="irReporting" label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.irReporting" options="{ default: ('SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.irReportingDefault' | sxyTranslate), noMonthlyReport: ('SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.irReportingNoMonthlyReport' | sxyTranslate), always: ('SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.irReportingAlways' | sxyTranslate)}"></salaxy-input-enum>
        </div>
      </fieldset>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.employmentTitle"></legend>
        <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.employmentText"></p>
      </fieldset>
    </div>
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.reportTitle"></legend>
        <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.reportText"></p>
        <div class="form-horizontal">
          <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.accountantEmail" name="Sahkopostiosoite" ng-model="wizard.model.products.accounting.accountantEmail" sxy-email></salaxy-input>
        </div>
      </fieldset>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/customer/invitation.html",`﻿

<div ng-controller="SessionController as sessionCtrl">
  <div ng-controller="NaviController as $naviCtrl">
    <div ng-if="!$naviCtrl.showFullPageLoader">
        <div class="modal-header bg-primary">
          <h2 class="modal-title" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.invitation.title"></h2>
          <button type="button" class="btn-close btn-close-white" ng-click="$close('cancel')" aria-label="Close"></button>
        </div>
        <div class="modal-body salaxy-wizard">
          <form name="currentForm">
            <div class="row">
              <div class="col-md-12" sxy-html="SALAXY.NG1.CustomerOnboardingComponent.invitation.html" params="{signingLink : $ctrl.signingLink}"></div>
              <div class="col-md-12 text-end">
                <button 
                  type="button" 
                  class="btn btn-primary" 
                  ng-click="$ctrl.copyLink($ctrl.signingLink)" 
                  data-bs-toggle="popover" 
                  data-bs-html="true" 
                  data-bs-title="Info"
                  data-bs-content="{{ !!$ctrl.linkCopied ? ('SALAXY.UI_Terms.copiedToClipboard' | sxyTranslate) : ('SALAXY.UI_Terms.copyToClipboard' | sxyTranslate)}}" 
                  data-bs-container="body" 
                  data-bs-placement="top" 
                  data-bs-trigger="hover"
                  sxy-bs5-popover>
                  <i class="bi bi-clipboard me-1"></i>
                  <span sxy-text="SALAXY.UI_Terms.copyToClipboard"></span>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer text-start">
          <button class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
        </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/onboarding/customer/user-buttons.html",`<button ng-click="$close('cancel')" class="btn btn-default" sxy-text="SALAXY.UI_Terms.backToFront"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-disabled="!wizard.canGoNext" ng-click="wizard.goToCompanySelection()" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>`);

 $templateCache.put("salaxy-components/modals/onboarding/customer/user.html",`﻿<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div class="row">
    <div class="col-12 col-md-6">
      <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.userInfo"></legend>
      <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.userFirstName" name="Etunimi" ng-model="wizard.model.person.firstName" ng-required="true"></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.userLastName" name="Sukunimi" ng-model="wizard.model.person.lastName" ng-required="true"></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.userEmail" name="Sahkoposti" ng-model="wizard.model.person.contact.email" ng-required="true" sxy-email></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.userPhone" name="Puhelinnumero" ng-model="wizard.model.person.contact.telephone" ng-required="true" sxy-mobile-phone></salaxy-input>
    </div>

    <div class="col-12 col-md-6">
      <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.signeratureTitle"></legend>
      <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.signeratureText"></p>
      <div class="form-horizontal">
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.userPersonalId" name="Henkilotunnus" sxy-personal-id-fi placeholder="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.personalIdExample" ng-model="wizard.model.signature.personalId"
          ng-required="true"></salaxy-input>
      </div>
      <div class="alert alert-danger" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.checkSignatureAlert"></div>

      <div class="form-horizontal">
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.businessId" name="Ytunnus" ng-model="wizard.model.company.businessId" sxy-company-id-fi ng-required="true"></salaxy-input>
      </div>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/generic/index.html",`<div ng-controller="SessionController as sessionCtrl">
  <div ng-controller="NaviController as $naviCtrl">
    <div ng-if="!$naviCtrl.showFullPageLoader">
      <div class="modal-header bg-primary">
        <img src="https://cdn.salaxy.com/img/palkkaus/logo/palkkaus-www-logo-white-border.png" class="img-responsive d-none d-sm-inline-block modal-logo" />
        <h2 class="modal-title" sxy-text="SALAXY.NG1.GenericOnboardingComponent.modalTitle"></h2>
        <button type="button" class="btn-close btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
      </div>
      <div class="modal-body salaxy-wizard">
        <div>
          <fieldset>
            <legend sxy-text="SALAXY.NG1.GenericOnboardingComponent.roleTitle" ps="*"></legend>
            <div class="form-horizontal">
              <div class="radio" ng-repeat="accountType in ['company', 'worker']">
                <label ng-if="accountType == 'company'">
                  <input type="radio" name="wizardType" ng-model="$ctrl.data.model.accountType" value="company" ng-disabled="sessionCtrl.session.hasCurrentAccount" /> 
                  <span sxy-text="SALAXY.NG1.GenericOnboardingComponent.roleCompany"></span>
                </label>
                <label ng-if="accountType == 'worker'">
                  <input type="radio" name="wizardType" ng-model="$ctrl.data.model.accountType" value="worker" ng-disabled="sessionCtrl.session.hasCurrentAccount" />
                  <span sxy-text="SALAXY.NG1.GenericOnboardingComponent.roleWorker"></span>
                </label>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="modal-footer">
        <button ng-click="$ctrl.data.launch($close)" ng-disabled="!$ctrl.data.model.accountType || $ctrl.data.model.accountType == 'none'" class="btn btn-primary" sxy-text="SALAXY.NG1.GenericOnboardingComponent.launchBtn"></button>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/onboarding/household/contract.html",`﻿<form name="contractForm">
  <span class="d-none">{{ wizard.formDataValidity = contractForm.$valid}}</span>

  <h3>Palvelusopimus ja valtuutus</h3>
  <p>
    Rakennusliitto tarjoaa Palkkamylly-palvelun jäsenilleen ja heidän työnantajilleen. Palvelun tuottaa Suomen Palkanlaskenta Oy (Palkkaus.fi).
  </p>
  <p>
    Jotta Palkkamylly voi hoitaa puolestasi palkanmaksuun liittyviä velvoitteita, sinun täytyy allekirjoittaa <a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank">oheinen valtakirja</a>. Se pitää allekirjoittaa vain kerran.
  </p>
  <p>
    Kirjoita henkilötunnuksesi ja valitse pankkisi. Siirryt pankkisi verkkopalveluun, jossa varsinainen tunnistautuminen tapahtuu. Sen jälkeen palaat Palkkamylly-palveluun ja olet valmis aloittamaan käytön.
  </p>


  <div class="row" ng-controller="SignatureController as sign">
    <div class="col-md-6">
      <fieldset>
        <legend>Allekirjoita henkilötunnuksellasi</legend>
        <div class="mb-3">
          <salaxy-input name="personalId" label-type="plain" type="text" style="width:150px" placeholder="PPKKVV-NNNX" ng-model="wizard.model.signature.personalId" require="true" sxy-personal-id-fi></salaxy-input>
        </div>
      </fieldset>
      <fieldset>
        <legend>Valitse verkkopankkisi</legend>
        <div ng-if="wizard.model.accountType == 'company'">
          <p>
            Et voi käyttää yrityksen tai yhdistyksen verkkopankkitunnuksia valtakirjan allekirjoittamiseen. Sinun täytyy käyttää henkilökohtaisia verkkopankkitunnuksiasi
          </p>
        </div>
        <div id="bankButtonRow">
          <div class="btn-group" id="mostUsedBanks">
            <salaxy-toggle-buttons 
              ng-model="wizard.model.signature.method" 
              options="$ctrl.visibleSignatureMethods" 
              type="inline">
            </salaxy-toggle-buttons>
          </div>
          <div class="btn-group group-dropdown dropdown">
            <a class="btn btn-default dropdown-toggle" id="other-banks-button" data-bs-toggle="dropdown" ng-class="(wizard.model.signature.method != null && sign.getMethod(wizard.model.signature.method).isPopular == false) ? 'bank-chosen': ''">
              <span ng-if="wizard.model.signature.method == null || sign.getMethod(wizard.model.signature.method).isPopular == true">Muut verkkopankit</span>
              <span ng-if="wizard.model.signature.method != null && sign.getMethod(wizard.model.signature.method).isPopular == false">
                <img ng-src="{{ sign.getMethod(wizard.model.signature.method).img }}" style="max-height: 20px; max-width: 85px"/> {{sign.getMethod(wizard.model.signature.method).title}}
              </span> &nbsp; 
            </a>
            <ul class="dropdown-menu" role="menu" aria-labelledby="other-banks-button">
              <li ng-repeat="signMethod in sign.getMethods('telia') | filter: {isPopular:false}" role="menuitem" ng-class="wizard.model.signature.method == signMethod.value ? 'active' : ''">
                <a ng-click="wizard.model.signature.method = signMethod.value" class="dropdown-item">
                  <img ng-src="{{signMethod.img}}" style="max-height: 20px; max-width: 85px" /> {{signMethod.title}}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </fieldset>
      <p class="mt-3">

        <strong>HUOM:</strong> Palkkamyllyn tarjoaa Rakennusliitto ry, joka toimii henkilötietojen käsittelijänä ja vastaa myös asiakaspalvelusta. Palvelun tuottajana ja teknisenä toteuttajana ja myös henkilötietojen käsittelijä toimii Suomen Palkanlaskenta
        Oy (Palkkaus.fi).

      </p>
      <p>
        Tunnistautumalla hyväksyt:<br>
        <a href="https://storage.googleapis.com/rakennusliitto-production-uploads/content_management/documents/Palkkamylly_Kayttoehdot_Oct2021.pdf?Expires=1795336880&GoogleAccessId=cloud-run-service-account%40rakennusliitto.iam.gserviceaccount.com&Signature=dTZrDk4AgZv29ldlizR%2Bfe9uv5NgXtAU%2BZBr%2FgbO7p%2FWpoyc4rtUnbUyoRwqLE2OSJ2ZUIRvPucZt7jUhGiAmXEpsG7vsieoBHX9C1P%2F79VoJdIvLG9sqe4wOIQG0t0KUhNxv4I3dpymLV1F16T%2FKLN94vSGRLv6pNHblNqc3iGpoIw11d3dG3%2BhVL%2Fnajwcfirh7m7V7PLIn4fHNY6Q6PbfhbVRpeLprM37sUKTlCBLwdEihZJ7bNcoRvWG4CWfZMk9hRaV66YYadNxEEnBd6EOQZZ5%2B0S2%2F%2FSOLWT5d9amM%2F8S0IW7wOcwr3crCs%2BcroZ6aYSFrZ1H6TCTdRUkNA%3D%3D"
          target="_blank">Palkkamyllyn käyttöehdot</a><br>
        <a href="https://storage.googleapis.com/rakennusliitto-production-uploads/content_management/documents/Palkkamylly_Sopimus_henkilotietojen_kasittelysta_Oct2021.pdf?Expires=1795336940&GoogleAccessId=cloud-run-service-account%40rakennusliitto.iam.gserviceaccount.com&Signature=gcO62AB17YCjv5mVTtSP%2FtgG2RxGUSnaGpfK0GencENWGoq8FF1F5MlXEfyZ5pM6eW9tEubAWd8WkxP7WpmX63mtcvdnCViiz52TQjYiK%2BSjJw6ZD6QB%2F%2FPQRVQGsoKilFVJZ4HVshOWcsvOVrcR1ci6dlsFOQPnFQXQhalCaJHiFzGJzxsRtPEaD1GMtqANqzdcmZbqR6ULEE73G2WxYVJ4%2FeK1bpd0qAKlBvs%2Fh9DlDd8RDx5M3BSJj7q43KHP5kT8mOq2bky4xNnq7q31jgnub%2BVO1a4X7RAKzbKabW4D6y%2BlDKzK%2FJgnmbPsS8TzYFuSkH81aiqu5MGR2zfn9A%3D%3D"
          target="_blank">Sopimuksen henkilötietojen käsittelystä</a><br>
        <a href="https://storage.googleapis.com/rakennusliitto-production-uploads/content_management/documents/Palkkamylly_Tietosuojaseloste_Oct2021.pdf?Expires=1793455095&GoogleAccessId=cloud-run-service-account%40rakennusliitto.iam.gserviceaccount.com&Signature=dVqt3NenZZwBOPmmKz15jrIlgUOv2J2QE39Ltl7sK9t6iUC6YSXpnRifRoJLdcCrJpgt8KBpw%2FDXLm9olu5wzBFhSXKa1b4LRclyVjpzs27e9%2BMJceizLURvLWeKyZsyuYc%2BU3U7V0vkN0S%2B4nqkcDqskXCtvccmcBg0BgPYaslcSwLu4NUztiR2vA5qUj%2FL6hBelLqjKyqA%2FwDHahcTp07de6WqkEDud46W9Fv1oEJDioiho9W3%2F2W5kpVe2JxA3VB6D9j7Fwt45LBsDZC5opFiwnzWuahr7zEyn9UVuf4nLOJ83PcfYIsRo0pZWAPIgScsH%2BcAOXFgbnr5OkTu2A%3D%3D"
          target="_blank">Tietosuojaselosteen</a>
      </p>
    </div>

    <div class="col-md-6 d-none d-sm-block">
      <fieldset>
        <legend>Valtakirjan esikatselu</legend>

        <small><a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank">Lataa tästä, jos et näe esikatselua</a></small>

        <iframe ng-src="{{ wizard.getPdfPreviewAddress() }}" style="width: 100%; height: 300px"></iframe>
      </fieldset>
    </div>


  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/household/contractButtons.html",`﻿<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default">Edellinen</button>
<div salaxy-loader class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
</div>

<button ng-if="wizard.model.signature.personalId == null || wizard.model.signature.method == null"  ng-disabled="true" class="btn btn-primary">Allekirjoita valtakirja<span class="d-none d-sm-inline" ng-if="wizard.model.accountType != 'worker'"> ja voit maksaa palkkaa</span></button>
<a ng-if="!(wizard.model.signature.personalId == null || wizard.model.signature.method == null)" ng-href="{{wizard.vismaSignUrl}}" target="_top"  class="btn btn-primary">Allekirjoita valtakirja<span class="d-none d-sm-inline" ng-if="wizard.model.accountType != 'worker'"> ja voit maksaa palkkaa</span></a>`);

 $templateCache.put("salaxy-components/modals/onboarding/household/firstPageButtons.html",`﻿<!--a ng-if="wizard.model.ui.cancelUrl" ng-href="{{wizard.model.ui.cancelUrl}}"  class="btn btn-default">Takaisin etusivulle</a-->

<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-click="wizard.goNext()" ng-disabled="!wizard.canGoNext" class="btn btn-primary">Seuraava</button>`);

 $templateCache.put("salaxy-components/modals/onboarding/household/household.html",`﻿<form name="householdForm" class="form-horizontal">
  <!-- Hidden variable formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = householdForm.$valid}}</span>
  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend> Yhteystiedot 
          <i class="bi bi-info-circle-fill"
            type="button" 
            data-bs-toggle="popover" 
            data-bs-title="'Miksi kysymme osoitetietojasi?'" 
            data-bs-content="'Lähetämme puolestasi tietoja ja erilaisia lomakkeita eri viranomaisille. Jotkut näistä viranomaisista vaativat joissain lomakkeissa osoitetiedot pakollisina tietoina.'"
            data-bs-container="body" 
            data-bs-placement="top" 
            sxy-bs5-popover>
          </i>
        </legend>
        <div class="form-horizontal">
          <salaxy-input label="Katuosoite" name="Katuosoite" ng-model="wizard.model.person.contact.street" require="true"></salaxy-input>
          <salaxy-input label="Postinumero" name="Postinumero" ng-model="wizard.model.person.contact.postalCode" require="true" sxy-postal-code-fi></salaxy-input>
          <salaxy-input label="Postitoimipaikka" name="Postitoimipaikka" ng-model="wizard.model.person.contact.city" require="true"></salaxy-input>
        </div>
      </fieldset>
    </div>
    <div class="col-md-6">
      <fieldset>
        <legend>Palkanmaksuun tarvittavat tiedot</legend>
        <p>
          Osoitetietojasi työnantajana tarvitaan tulorekisteri-ilmoitukseen, näin esim. työttömyysvakuutuslaskujen lähettäminen sinulle onnistuu.
        </p>
      </fieldset>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/household/householdButtons.html",`﻿
<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default">Edellinen</button>
<div salaxy-loader class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
</div>
<button ng-click="wizard.goNext()" ng-disabled="!wizard.canGoNext" class="btn btn-primary">Seuraava</button>`);

 $templateCache.put("salaxy-components/modals/onboarding/household/index.html",`<div ng-controller="SessionController as sessionCtrl">
  <div ng-controller="HouseholdOnboardingController as wizard">
    <div ng-controller="NaviController as $naviCtrl">

      <div ng-if="!$naviCtrl.showFullPageLoader">
        <div class="modal-header bg-primary">
          <h2 class="modal-title">Palkkamylly / Käyttöönotto</h2>
          <button type="button" class="btn-close btn-close-white" ng-click="$close('cancel')" aria-label="Close"></button>

          <!--
        TODO: Consider adding back with skinning. But perhaps not needed?
        <img src="https://cdn.salaxy.com/img/palkkaus/logo/palkkaus-www-logo-white-border.png" class="img-responsive d-none d-sm-inline modal-logo" />
      -->
        </div>
        <div class="modal-body">
          <div class="d-block d-md-none">
            <h4>Vaihe {{wizard.currentStep.number}}/{{wizard.steps.length}}</h4>
          </div>
          <div class="salaxy-wizard">
            <div class="wizard-steps">
              <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
                <span class="salaxy-avatar">
                  <div class="wizard-icons-wrapper">
                    <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
                    <i class="bi bi-circle-fill"></i>
                  </div>
                  <strong class="number">{{ step.number }}</strong>
                </span>
                <span class="step-text">{{ step.title | sxyTranslate }}</span>
              </div>
            </div>
            <div class="wizard-strikethrough"></div>
          </div>
          <ng-include src="wizard.currentStep.view"></ng-include>
        </div>
        <div class="modal-footer">
          <ng-include class="d-flex justify-content-between w-100" src="wizard.currentStep.buttonsView"></ng-include>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/onboarding/household/wizard_index.html",`﻿<form name="currentForm" class="form-horizontal">
  <!-- Hidden ariable formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div class="">
    <br/>
    <p>{{wizard.currentStep.intro | sxyTranslate}}</p>

    <br/>
  </div>
  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend>Henkilötiedot</legend>
        <salaxy-input label="Etunimi" name="Etunimi" ng-model="wizard.model.person.firstName" ng-required="true"></salaxy-input>
        <salaxy-input label="Sukunimi" name="Sukunimi" ng-model="wizard.model.person.lastName" ng-required="true"></salaxy-input>
      </fieldset>
    </div>
    <div class="col-md-6">
      <fieldset>
        <legend>Yhteystiedot</legend>
        <salaxy-input label="Sähköposti" name="Sahkoposti" ng-model="wizard.model.person.contact.email" ng-required="true" sxy-email read-only="!!wizard.model.person.contact.email"></salaxy-input>
        <salaxy-input label="Puhelinnumero" name="Puhelinnumero" ng-model="wizard.model.person.contact.telephone" ng-required="true" sxy-mobile-phone></salaxy-input>
      </fieldset>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/palkkamylly/federate-sign.html",`<div ng-controller="SessionController as sessionCtrl" class="worker-onboarding-wizard">
  <div ng-controller="WorkerOnboardingController as wizard">
    <div class="modal-header bg-primary">
      <h2 class="modal-title">Palkkamylly käyttöönotto</h2>
      <button type="button" class="btn-close btn-close-white" ng-click="$close('cancel')" aria-label="Close"></button>

    </div>
    <div class="modal-body salaxy-wizard">
      <form name="contractForm">
        <span class="d-none">{{ wizard.formDataValidity = contractForm.$valid && !wizard.model.signature.personalId && !wizard.model.signature.method}}</span>
        <div ng-controller="SignatureController as sign">
          <h3>Palvelusopimus ja valtuutus</h3>
          <p>
            Rakennusliitto tarjoaa Palkkamylly-palvelun jäsenilleen ja heidän työnantajilleen. Palvelun tuottaa Suomen Palkanlaskenta Oy (Palkkaus.fi).
          </p>
          <p>
            Jotta Palkkamylly voi hoitaa puolestasi palkanmaksuun liittyviä velvoitteita, sinun täytyy allekirjoittaa <a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank">oheinen valtakirja</a>. Se pitää allekirjoittaa vain kerran.
          </p>
          <p>Kirjoita henkilötunnuksesi, valitse pankkisi ja paina Tunnistaudu-nappia. Siirryt pankkisi verkkopalveluun, jossa varsinainen tunnistautuminen tapahtuu. Sen jälkeen palaat Palkkamylly-palveluun ja olet valmis aloittamaan käytön.</p>
          <div class="row form-horizontal" ng-init="ui.telephone = wizard.model.person.contact.telephone">
            <div class="" ng-init="wizard.model.signature.personalId = wizard.model.person.personalId" ng-class="{'col-sm-6': ui.telephone, 'col-sm-8': !ui.telephone}">
              <salaxy-input label="Tarkista henkilötunnuksesi" label-type="basic" name="personalId" placeholder="PPKKVV-NNNX" ng-model="wizard.model.signature.personalId" sxy-personal-id-fi ng-required="true"></salaxy-input>
            </div>
            <div ng-if="ui.telephone" class="col-sm-6">
              <salaxy-input label="Tarkista puhelinnumerosi" name="telephone" ng-model="wizard.model.person.contact.telephone" sxy-mobile-phone label-type="basic" ng-required="true"></salaxy-input>
            </div>
            <div ng-if="!ui.telephone" class="col-sm-4">
              <salaxy-input label="Puhelinnumero" name="telephone" ng-model="wizard.model.person.contact.telephone" sxy-mobile-phone label-type="basic" ng-required="true"></salaxy-input>
            </div>
          </div>

          <div class="row form-horizontal">
            <div class="col-sm-4">
              <salaxy-input label="Etunimi" name="firstName" ng-model="wizard.model.person.firstName" label-type="basic" readonly="true"></salaxy-input>
            </div>
            <div class="col-sm-4">
              <salaxy-input label="Sukunimi" name="lastName" ng-model="wizard.model.person.lastName" label-type="basic" readonly="true"></salaxy-input>
            </div>
            <div class="col-sm-4">
              <salaxy-input label="Sähköpostiosoite" name="email" ng-model="wizard.model.person.contact.email" label-type="basic" readonly="true"></salaxy-input>
            </div>
          </div>

          <div class="row mb-2" ng-if="wizard.isOtherIdentifier(wizard.model.signature.personalId)">
            <div class="col-12">
              <h5><strong>Osoite</strong></h5>
            </div>
            <salaxy-input ng-model="wizard.model.person.contact.street" placeholder="Katuosoite" name="street" class="col-sm-4" label-type="plain" ng-required="true"></salaxy-input>
            <salaxy-input ng-model="wizard.model.person.contact.postalCode" placeholder="Postinumero" name="postalCode" class="col-sm-4" label-type="plain" ng-required="true"></salaxy-input>
            <salaxy-input ng-model="wizard.model.person.contact.city" placeholder="Toimipaikka" name="city" class="col-sm-4" label-type="plain" ng-required="true"></salaxy-input>
          </div>

          <h4>
            Ja valitse verkkopankkisi
            <small>
              <i class="bi bi-info-circle-fill"
                type="button" 
                data-bs-toggle="popover" 
                data-bs-content="'Kun olet valinnut pankkisi ja painat \\'Tunnistaudu\\'- nappia, siirryt tekemään sähköisen allekirjoituksen verkkopankkitunnuksillasi. Tunnistautumisen jälkeen palaat Palkkaus.fi-palveluun.'"
                data-bs-container="body" 
                sxy-bs5-popover>
              </i>
            </small>
          </h4>
          <div id="bankButtonRow">
            <salaxy-toggle-buttons 
              ng-model="wizard.model.signature.method" 
              options="$ctrl.signatureMethods" 
              type="row">
            </salaxy-toggle-buttons>
          </div>
          <br/>
          <p class="mt-3">
            <strong>HUOM:</strong> Palkkamyllyn tarjoaa Rakennusliitto ry, joka toimii henkilötietojen käsittelijänä ja vastaa myös asiakaspalvelusta. Palvelun tuottajana ja teknisenä toteuttajana ja myös henkilötietojen käsittelijä toimii Suomen Palkanlaskenta
            Oy (Palkkaus.fi).
          </p>
          <p>Tunnistautumalla hyväksyt:<br>
            <a href="https://storage.googleapis.com/rakennusliitto-production-uploads/content_management/documents/Palkkamylly_Kayttoehdot_Oct2021.pdf?Expires=1795336880&GoogleAccessId=cloud-run-service-account%40rakennusliitto.iam.gserviceaccount.com&Signature=dTZrDk4AgZv29ldlizR%2Bfe9uv5NgXtAU%2BZBr%2FgbO7p%2FWpoyc4rtUnbUyoRwqLE2OSJ2ZUIRvPucZt7jUhGiAmXEpsG7vsieoBHX9C1P%2F79VoJdIvLG9sqe4wOIQG0t0KUhNxv4I3dpymLV1F16T%2FKLN94vSGRLv6pNHblNqc3iGpoIw11d3dG3%2BhVL%2Fnajwcfirh7m7V7PLIn4fHNY6Q6PbfhbVRpeLprM37sUKTlCBLwdEihZJ7bNcoRvWG4CWfZMk9hRaV66YYadNxEEnBd6EOQZZ5%2B0S2%2F%2FSOLWT5d9amM%2F8S0IW7wOcwr3crCs%2BcroZ6aYSFrZ1H6TCTdRUkNA%3D%3D"
              target="_blank">Palkkamyllyn käyttöehdot</a><br>
            <a href="https://storage.googleapis.com/rakennusliitto-production-uploads/content_management/documents/Palkkamylly_Sopimus_henkilotietojen_kasittelysta_Oct2021.pdf?Expires=1795336940&GoogleAccessId=cloud-run-service-account%40rakennusliitto.iam.gserviceaccount.com&Signature=gcO62AB17YCjv5mVTtSP%2FtgG2RxGUSnaGpfK0GencENWGoq8FF1F5MlXEfyZ5pM6eW9tEubAWd8WkxP7WpmX63mtcvdnCViiz52TQjYiK%2BSjJw6ZD6QB%2F%2FPQRVQGsoKilFVJZ4HVshOWcsvOVrcR1ci6dlsFOQPnFQXQhalCaJHiFzGJzxsRtPEaD1GMtqANqzdcmZbqR6ULEE73G2WxYVJ4%2FeK1bpd0qAKlBvs%2Fh9DlDd8RDx5M3BSJj7q43KHP5kT8mOq2bky4xNnq7q31jgnub%2BVO1a4X7RAKzbKabW4D6y%2BlDKzK%2FJgnmbPsS8TzYFuSkH81aiqu5MGR2zfn9A%3D%3D"
              target="_blank">Sopimuksen henkilötietojen käsittelystä</a><br>
            <a href="https://storage.googleapis.com/rakennusliitto-production-uploads/content_management/documents/Palkkamylly_Tietosuojaseloste_Oct2021.pdf?Expires=1793455095&GoogleAccessId=cloud-run-service-account%40rakennusliitto.iam.gserviceaccount.com&Signature=dVqt3NenZZwBOPmmKz15jrIlgUOv2J2QE39Ltl7sK9t6iUC6YSXpnRifRoJLdcCrJpgt8KBpw%2FDXLm9olu5wzBFhSXKa1b4LRclyVjpzs27e9%2BMJceizLURvLWeKyZsyuYc%2BU3U7V0vkN0S%2B4nqkcDqskXCtvccmcBg0BgPYaslcSwLu4NUztiR2vA5qUj%2FL6hBelLqjKyqA%2FwDHahcTp07de6WqkEDud46W9Fv1oEJDioiho9W3%2F2W5kpVe2JxA3VB6D9j7Fwt45LBsDZC5opFiwnzWuahr7zEyn9UVuf4nLOJ83PcfYIsRo0pZWAPIgScsH%2BcAOXFgbnr5OkTu2A%3D%3D"
              target="_blank">Tietosuojaselosteen</a>
          </p>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <div salaxy-loader class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
      <button ng-if="wizard.model.signature.personalId == null || wizard.model.signature.method == null" ng-disabled="true" class="btn btn-primary">Tunnistaudu</button>
      <a ng-if="!(wizard.model.signature.personalId == null || wizard.model.signature.method == null)" ng-href="{{wizard.vismaSignUrl}}" target="_top" class="btn btn-primary">Tunnistaudu</a>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/onboarding/worker/contract-worker.html",`﻿<form name="contractForm">
  <span class="d-none">{{ wizard.formDataValidity = contractForm.$valid && !wizard.model.signature.personalId && !wizard.model.signature.method}}</span>
  <div ng-controller="SignatureController as sign">

    <h3 sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.title"></h3>
    <p sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.signatureText"></p>
    <p sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.signatureText2"></p>
    <fieldset>
      <legend sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.personalId"></legend>
      <div class="row" style="max-width:150px;">
        <salaxy-input name="personalId" label-type="plain" type="text" style="width:150px" sxy-personal-id-fi ng-required="true" placeholder="SALAXY.NG1.WorkerOnboardingComponent.stepContract.personalIdExample" ng-model="wizard.model.signature.personalId" sxy-personal-id-fi>
      </div>
      <div class="mb-2">
        <input ng-init="wizard.model.signature.terms = false" name="terms" type="checkbox" require="true" ng-model="wizard.model.signature.terms"></input>
        <span style="margin-left: 5px;" sxy-html="SALAXY.NG1.WorkerOnboardingComponent.stepContract.termsText.html"></span> <a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank"><span sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.termsText2"></span></a>
        <span sxy-html="SALAXY.NG1.WorkerOnboardingComponent.stepContract.termsText3.html"></span>
      </div>
    </fieldset>
    <fieldset>
      <legend sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.chooseBank"></legend>
      <div id="bankButtonRow">
        <salaxy-toggle-buttons 
          ng-model="wizard.model.signature.method" 
          options="$ctrl.signatureMethods" 
          type="row">
        </salaxy-toggle-buttons>
      </div>
    </fieldset>
    <p sxy-html="SALAXY.NG1.WorkerOnboardingComponent.stepContract.privacyPolicy.html"></p>

    <p>
      <span sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.savePdfText"></span>
      <a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank">
        <span sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.savePdfLink"></span>
      </a>
      <span sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.savePdfText2"></span>
    </p>

  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/onboarding/worker/contractButtons.html",`﻿<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default">{{'SALAXY.UI_Terms.previous' | sxyTranslate}}</button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-if="wizard.model.signature.personalId == null || wizard.model.signature.method == null || wizard.model.signature.terms == false" ng-disabled="true" class="btn btn-primary">{{'SALAXY.NG1.WorkerOnboardingComponent.signBtn' | sxyTranslate}}</button>
<a ng-if="!(wizard.model.signature.personalId == null || wizard.model.signature.method == null || wizard.model.signature.terms == false)" ng-href="{{wizard.vismaSignUrl}}" target="_top" class="btn btn-primary">{{'SALAXY.NG1.WorkerOnboardingComponent.signBtn' | sxyTranslate}}</a>`);

 $templateCache.put("salaxy-components/modals/onboarding/worker/firstPageButtons.html",`﻿<button class="btn btn-default" ng-click="$close('cancel')">{{'SALAXY.UI_Terms.backToFront' | sxyTranslate}}</button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>

<button ng-click="wizard.goNext()" class="btn btn-primary" ng-disabled="!wizard.canGoNext">{{'SALAXY.UI_Terms.next' | sxyTranslate}}</button>`);

 $templateCache.put("salaxy-components/modals/onboarding/worker/index.html",`<div ng-controller="SessionController as sessionCtrl" class="worker-onboarding-wizard">
  <div ng-controller="WorkerOnboardingController as wizard">
    <div ng-controller="NaviController as $naviCtrl">
      <div ng-if="!$naviCtrl.showFullPageLoader">
        <div class="modal-header bg-primary">
          <img src="https://cdn.salaxy.com/img/palkkaus/logo/palkkaus-www-logo-white-border.png" class="img-responsive d-none b-sm-inline-block modal-logo" />
          <h2 class="modal-title" sxy-text="SALAXY.NG1.WorkerOnboardingComponent.title"></h2>
          <button type="button" class="btn-close btn-close-white" ng-click="$close('cancel')" aria-label="Close"></button>

          
        </div>
        <div class="modal-body">
          <div class="d-block d-md-none">
            <h4><span sxy-text="SALAXY.NG1.WorkerOnboardingComponent.step"></span> {{wizard.currentStep.number}}/{{wizard.steps.length}}</h4>
          </div>
          <div class="salaxy-wizard">
            <div class="wizard-steps">
              <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
                <span class="salaxy-avatar">
                  <div class="wizard-icons-wrapper">
                    <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
                    <i class="bi bi-circle-fill"></i>
                  </div>
                  <strong class="number">{{ step.number }}</strong>
                </span>
                <span class="step-text">{{ step.title | sxyTranslate }}</span>
              </div>
            </div>
            <div class="wizard-strikethrough"></div>
          </div>
          <ng-include src="wizard.currentStep.view"></ng-include>
        </div>
        <div class="modal-footer">
          <ng-include class="d-flex justify-content-between w-100" src="wizard.currentStep.buttonsView"></ng-include>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/onboarding/worker/user-info.html",`﻿<form name="currentForm">
  <!-- Hidden ariable formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>

  <br/>
  <p sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.registerText"></p>
  <br>
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="form-horizontal">
        <salaxy-input label="SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.firstName" name="Etunimi" ng-model="wizard.model.person.firstName" ng-required="true"></salaxy-input>
        <salaxy-input label="SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.lastName" name="Sukunimi" ng-model="wizard.model.person.lastName" ng-required="true"></salaxy-input>
        <salaxy-input label="SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.email" name="Sahkoposti" ng-model="wizard.model.person.contact.email" ng-required="true" sxy-email></salaxy-input>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="row language-selection mb-2" ng-controller="SessionController as $session">
        <div class="col-4 control-label"><strong class="" sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.language" ps=":"></strong></div>

        <div class="col-8">
          <div class="btn-group btn-group-sm float-end" role="group">
            <button class="btn btn-default" ng-class="{'active btn-primary' : $session.getLanguage() == 'fi'}" ng-click="$session.setLanguage('fi'); wizard.model.person.language = 'fi'">{{'SALAXY.ENUM.Language.fi.label' | sxyTranslate}}</button>
            <button class="btn btn-default " ng-class="{'active btn-primary' : $session.getLanguage() == 'en'}" ng-click="$session.setLanguage('en'); wizard.model.person.language = 'en'">{{'SALAXY.ENUM.Language.en.label' | sxyTranslate}}</button>
            <button class="btn btn-default" ng-class="{'active btn-primary' : $session.getLanguage() == 'sv'}" ng-click="$session.setLanguage('sv'); wizard.model.person.language = 'sv'">{{'SALAXY.ENUM.Language.sv.label' | sxyTranslate}}</button>
          </div>
        </div>

      </div>
      <div class="form-horizontal">
        <salaxy-input label="SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.phoneNumber" name="Puhelinnumero" ng-model="wizard.model.person.contact.telephone" ng-required="true" sxy-mobile-phone></salaxy-input>
      </div>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/payment/cfa/EInvoice.html",`<div class="modal-header">
  <h2 class="modal-title" id="salaxyEInvoiceLabel" sxy-text="SALAXY.NG1.NewPaymentComponent.einvoice.title"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body">
  <p sxy-text="SALAXY.NG1.NewPaymentComponent.einvoice.description"></p>
  <form name="address" class="form-horizontal">
    <salaxy-form-group name="eInvoiceReceiver" label="SALAXY.NG1.PaymentSettingsComponent.einvoice.invoiceAddress">
      <div class="input-group">
        <input required class="form-control" type="text" autocomplete="off" id="eInvoiceReceiver" name="eInvoiceReceiver" ng-disabled="true" ng-model="$ctrl.current.eInvoiceReceiver" >
        <span class="input-group-btn">
          <button type="button" class="btn btn-default" ng-click="$ctrl.logic.selectEInvoiceAddress($ctrl.current)" sxy-text="Valitse..."></button>
        </span>
      </div>
    </salaxy-form-group>
    <salaxy-input require="true" disabled="true" name="intermediator" ng-model="$ctrl.current.eInvoiceIntermediator" label="SALAXY.NG1.NewPaymentComponent.einvoice.intermediatorLabel"></salaxy-input>
  </form>
</div>
<div class="modal-footer text-start">
  <button type="submit" class="btn btn-primary float-end" ng-disabled="!address.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.send"></button>
  <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/payment/cfa/Transfer.html",`<div class="modal-header">
  <h2 class="modal-title" id="salaxyTransferLabel" sxy-text="SALAXY.NG1.NewPaymentComponent.selection.creditTransferTitle"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <div class="credit-transfer-container">
    <div class="text-end d-print-none">
      <button type="button" class="btn btn-default btn-sm" ng-click="$ctrl.logic.print('sxyFullPrint')" sxy-text="SALAXY.UI_Terms.print"></button>
      <button type="button" class="btn btn-default btn-sm" ng-click="$ctrl.logic.print('sxySecurePrint')" sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.securePrint"></button>
    </div>
    <salaxy-credit-transfer invoice="$ctrl.current">
      <message>
        <p sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.mainContent"></p>
      </message>
    </salaxy-credit-transfer>
    <div class="payment-per-worker-container table-responsive" ng-class="$ctrl.logic.printClass">
      <h4 sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.calcsBreakdown"></h4>
      <table>
        <thead>
          <tr>
            <th class="align-bottom" sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.worker"></th>
            <th class="right"><strong sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.totalGrossSalary"></strong></th>
            <th class="right"> <strong sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.payNow"></strong></th>
          </tr>
        </thead>
        <tbody>
          <tr class="payment-per-worker" ng-repeat="calc in $ctrl.logic.calculations">
            <td class="align-middle"> {{calc.worker.avatar.sortableName}}</td>
            <td class="right">{{calc.result.totals.totalGrossSalary | currency}}</td>
            <td class="right">
              {{calc.result.employerCalc.totalPayment| currency}}
            </td>
          </tr>
          <tr class="total">
            <td><strong sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.paymentPerWorkerTable.total"></strong><br><span sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.paymentPerWorkerTable.palkkausFee"></span></td>
            <td class="right">{{$ctrl.logic.totalResultCalculation.result.totals.totalGrossSalary | currency}}</td>
            <td class="right">
              {{$ctrl.logic.totalResultCalculation.result.employerCalc.totalPayment | currency}}<br>{{$ctrl.logic.totalResultCalculation.result.employerCalc.palkkaus | currency}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div sxy-if-role="!household" class="table-responsive">
      <h4 sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.paymentTable"></h4>
      <salaxy-calc-report apply-site-styles="true" calc="$ctrl.logic.totalResultCalculation" report-type="'paymentReport'" template-name="'paymentTablesV2'"></salaxy-calc-report>
    </div>
  </div>
</div>
<div class="modal-footer text-start d-print-none">
  <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/payment/PaymentCancel.html",`<div class="modal-header">
  <h2 class="modal-title" id="salaxyPaymentCancelDialogLabel" sxy-text="SALAXY.NG1.PaymentCancelDialogComponent.paymentCancelled"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <p sxy-text="SALAXY.NG1.PaymentCancelDialogComponent.paymentCancelledBank"></p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/payment/PaymentConfirm.html",`<div class="modal-header">
  <h2 class="modal-title" id="salaxyPaymentConfirmDialogLabel" sxy-text="SALAXY.NG1.PaymentConfirmDialogComponent.paymentConfirmed"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body">
  <p sxy-text="SALAXY.NG1.PaymentConfirmDialogComponent.paymentConfirmedInfo"></p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/payment/PaymentError.html",`<div class="modal-header">
  <h2 class="modal-title" id="salaxyPaymentErrorDialogLabel" sxy-text="Maksaminen keskeytetty"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body">
  <p sxy-text="Maksaminen keskeytyi virheen vuoksi. Yritä uudelleen tai käytä muuta maksua."></p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/payment/psd/BankSelection.html",`<div class="modal-header">
  <h2 class="modal-title" id="salaxyPaymentConfirmDialogLabel" sxy-text="Valitse pankki"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="d-flex flex-column align-items-start">
    <p sxy-text="Valitse pankki, josta haluat suorittaa PSD-maksun"></p>
    <div ng-click="$ctrl.logic.selectBank(bank.id)" ng-repeat="bank in $ctrl.logic.banks" class="btn btn-default mb-2" style="width: 400px; height: 50px;" ng-class="{'active': $ctrl.logic.selectedBank === bank.id}" aria-label="{{bank.name}}">
      <img ng-src="{{bank.logo}}" style="max-height: 20px; max-width: 85px" />
        {{bank.name}}
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.select"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/payroll/PayrollDetailsList.html",`<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <salaxy-payroll-details-select-list category="{{ $ctrl.logic.category || 'draft' }}" mode="select" selected-items="$ctrl.current"></salaxy-payroll-details-select-list>
    </div>
    <div class="text-end">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/payroll/PayrollList.html",`<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <salaxy-payroll-select-list category="{{ $ctrl.logic.category || 'draft' }}" mode="select" selected-items="$ctrl.current"></salaxy-payroll-select-list>
    </div>
    <div class="text-end">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/records/Record.html",`<div class="modal-header">
  <h2 class="modal-title">{{ $ctrl.logic.title }}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <form class="form-horizontal" name="record" ng-readonly="$ctrl.logic.readOnly">
    <fieldset>
      <div class="subtext">
        {{ 'SALAXY.NG1.WorkerDetailsComponent.records.createTypeInfo' | sxyTranslate }}
      </div>
      <salaxy-form-group ng-if="!$ctrl.logic.readOnly" name="recordType" label="SALAXY.NG1.WorkerDetailsComponent.records.recordType">
        <div class="input-group">
          <input ng-model="$ctrl.current.record.recordType" type="text" class="form-control">
          <div class="input-group-btn dropdown">
            <button type="button" class="btn btn-default dropdown-toggle h-100" data-bs-toggle="dropdown"></button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li ng-repeat="recordType in $ctrl.logic.recordTypes">
                <a href="" ng-click="$ctrl.current.record.recordType = recordType" class="dropdown-item">{{recordType}}</a>
              </li>
              <li ng-if="!$ctrl.logic.recordTypes">
                <a href="" class="dropdown-item disabled" style="font-style: italic;">
                  {{ 'SALAXY.NG1.WorkerDetailsComponent.records.noTypes' | sxyTranslate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </salaxy-form-group>
      <salaxy-input ng-if="$ctrl.logic.readOnly" ng-model="$ctrl.current.record.recordType" label="SALAXY.NG1.WorkerDetailsComponent.records.recordType" name="recordType"></salaxy-input>
      <salaxy-input ng-model="$ctrl.current.record.title" label="SALAXY.NG1.WorkerDetailsComponent.records.title" name="title"></salaxy-input>
      <salaxy-textarea ng-if="!('markdown' | sxyIsInRole)" ng-model="$ctrl.current.record.text" label="SALAXY.NG1.WorkerDetailsComponent.records.text" name="text"></salaxy-textarea>
      <salaxy-input-markdown ng-if="('markdown' | sxyIsInRole)" ng-model="$ctrl.current.record.text" label="SALAXY.NG1.WorkerDetailsComponent.records.text" name="text" label-type="plain"></salaxy-input-markdown>
      <salaxy-form-group name="attachments" label="SALAXY.NG1.WorkerDetailsComponent.records.attachments">
        <table>
          <tr ng-repeat="attachment in $ctrl.current.record.attachments">
            <td><i class="bi {{ $ctrl.logic.getAttachmentIcon(attachment) }} text-primary float-start me-1"></i> <a target="_blank"
                ng-href="{{$ctrl.logic.getAttachmentDownloadUrl(attachment)}}">{{attachment.fileName}}</a></td>
            <td class="text-end">
              <button type="button" class="btn btn-danger btn-xs" ng-if="!$ctrl.logic.readOnly" ng-click="$ctrl.current.record.attachments.splice($index, 1)"><i class="bi bi-trash"
                  title="{{'SALAXY.UI_Terms.removeAttachment' | sxyTranslate}}"></i></button>
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="text-end">
              <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.logic.readOnly" ngf-select="$ctrl.logic.uploadAttachments($files, $ctrl.current.record.attachments)"
                ngf-multiple="true" ngf-max-size="10MB"><i class="bi bi-paperclip" title="{{'SALAXY.UI_Terms.addAttachment' | sxyTranslate}}"></i></button>
            </td>
          </tr>
        </table>
      </salaxy-form-group>
      <salaxy-datepicker-popup ng-model="$ctrl.current.record.startDate" label="SALAXY.NG1.WorkerDetailsComponent.records.startDate" name="startDate"></salaxy-datepicker-popup>
    </fieldset>
    <fieldset>
      <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.records.badge"></legend>
      <div class="badge bg-danger">
        {{ 'SALAXY.NG1.WorkerDetailsComponent.records.badgeInfo' | sxyTranslate }}
      </div>
      <salaxy-input label="SALAXY.NG1.WorkFlowEventEditComponent.description" name="message" ng-model="$ctrl.current.wfEvent.message"></salaxy-input>
      <salaxy-input-enum type="select" enum="BootstrapStyle" label="SALAXY.NG1.WorkFlowEventEditComponent.ui" name="ui" require="$ctrl.current.wfEvent.message" ng-model="$ctrl.current.wfEvent.ui"></salaxy-input-enum>
    </fieldset>
  </form>
</div>
<div class="modal-footer">
  <button type="reset" ng-if="!$ctrl.logic.readOnly" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="button" ng-if="$ctrl.logic.readOnly" class="btn btn-primary" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" ng-if="!$ctrl.logic.readOnly" class="btn btn-primary" ng-disabled="!record.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/report/AccountingReport.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AccountingReportComponent.accountingReports"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body">
  <salaxy-accounting-report-tools any-expanded="$reportRows.anyExpanded" on-expand-change="$reportRows.expand(close)" on-target-change="$ctrl.data.loadCurrent(targetId)"  reader="$ctrl.data.reader"></salaxy-accounting-report-tools>
  <salaxy-accounting-report-rows ng-show="!$ctrl.data.isLoading" ng-ref="$reportRows" data="$ctrl.data.accountingData"></salaxy-accounting-report-rows>
  <salaxy-spinner ng-if="$ctrl.data.isLoading" full-screen="false" heading="SALAXY.UI_Terms.loading" text="SALAXY.NG1.AccountingReportComponent.loadingReport"></salaxy-spinner>
</div>`);

 $templateCache.put("salaxy-components/modals/report/SummaryReport.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.SummaryReportComponent.summaryReport"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body ">
  <salaxy-spinner ng-if="$ctrl.data.isLoading" full-screen="false" heading="SALAXY.UI_Terms.loading" text="SALAXY.NG1.SummaryReportComponent.loadingReport"></salaxy-spinner>
  <salaxy-summary-report ng-if="!$ctrl.data.isLoading" data="$ctrl.data.summaryReportData"></salaxy-summary-report>
</div>`);

 $templateCache.put("salaxy-components/modals/report/WorkerSummaryReport.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.SummaryReportComponent.summaryReport"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body">
  <salaxy-spinner ng-if="$ctrl.data.isLoading" full-screen="false" heading="SALAXY.UI_Terms.loading" text="SALAXY.NG1.SummaryReportComponent.loadingReport"></salaxy-spinner>
  <salaxy-worker-summary-report ng-if="!$ctrl.data.isLoading" data="$ctrl.data.workerSummaryReportData"></salaxy-worker-summary-report>
</div>`);

 $templateCache.put("salaxy-components/modals/settings/AccountantSelection.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AccountantSelectionComponent.heading"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>

<div class="modal-body">
  <div ng-if="!$ctrl.logic.selected" class="row">
    <div class="col-12">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.AccountantSelectionComponent.accountantType"></legend>
        <salaxy-input-enum ng-model="$ctrl.logic.type" type="radio" name="logicType" label="SALAXY.NG1.AccountantSelectionComponent.companyOrPerson" options="{ 
                          company: ('SALAXY.NG1.AccountantSelectionComponent.companyEnum' | sxyTranslate),
                          none: ('SALAXY.NG1.AccountantSelectionComponent.personEnum' | sxyTranslate)}">
        </salaxy-input-enum>
      </fieldset>
    </div>
  </div>
  <form name="personAccountantForm" class="form-horizontal">
    <div ng-if="$ctrl.logic.type == 'none'" class="row">
      <div class="col-12">
        <fieldset>
          <salaxy-input name="firstName" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.firstName" ng-model="$ctrl.current.info.avatar.firstName"></salaxy-input>
          <salaxy-input name="lastName" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.lastName"  ng-model="$ctrl.current.info.avatar.lastName"></salaxy-input>
          <salaxy-input name="email" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.email"  sxy-email ng-model="$ctrl.current.info.email"></salaxy-input>
          <salaxy-input name="telephone" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.telephone"  sxy-mobile-phone ng-model="$ctrl.current.info.telephone"></salaxy-input>
        </fieldset>
      </div>
    </div>
  </form>
  <div ng-if="!$ctrl.logic.selected && $ctrl.logic.type == 'company'" class="row">
    <div class="col-12">
      <legend sxy-text="SALAXY.NG1.AccountantSelectionComponent.searchAccountingFirm"></legend>
    </div>
  </div>
  <div ng-if="!$ctrl.logic.selected && $ctrl.logic.type == 'company'" class="table-responsive" style="max-height: calc(100vh - 200px)">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-text="SALAXY.NG1.AccountantSelectionComponent.name"></th>
          <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.officialId"></th>
          <th class="right">
            <form name="searchForm">
              <salaxy-form-group name="search" label-type="plain">
                <div class="input-group">
                  <input class="form-control" type="text" autocomplete="off" id="searchAccountant" name="searchAccountant" ng-model="$ctrl.logic.searchInput" require="true" ng-minlength="3">
                  <span class="input-group-btn">
                    <button type="submit" ng-disabled="!searchForm.$valid" class="btn btn-default"
                      ng-click="$ctrl.logic.search($ctrl.logic.searchInput)"><span ng-show="$ctrl.logic.isLoading"><i
                          class="bi bi-arrow-repeat bi-spin"></i></span><span ng-show="!$ctrl.logic.isLoading"><i class="bi bi-search"></i></span></button>
                  </span>
                </div>
            </form>
            </salaxy-form-group>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.logic.searchResult">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.avatar"></salaxy-avatar>
          </td>
          <td class="td-name  middle">
            <strong>{{row.avatar.displayName}}</strong><br />
          </td>
          <td class="td-name  middle">
            <strong>{{row.officialId}}</strong><br />
          </td>
          <td class="right middle">
            <button class="btn btn-sm btn-default" type="button" ng-click="$ctrl.logic.select($ctrl.current, row)">
              {{ 'SALAXY.UI_Terms.select' | sxyTranslate }}
            </button>
          </td>
        </tr>
        <tr ng-if="$ctrl.logic.searchResult.length == 0">
          <td colspan="4" sxy-text="SALAXY.NG1.AccountantSelectionComponent.noSearchResult"></td>
        </tr>
      </tbody>
    </table>
  </div>
  <form name="companyAccountantForm" class="form-horizontal">
    <div ng-if="$ctrl.logic.selected && $ctrl.logic.type == 'company'">
      <div class="container-fixed salaxy-component salaxy-accountant-info">
        <button ng-if="$ctrl.current.type != 'primaryPartner'" class="btn btn-default float-end" ng-click="$ctrl.logic.reset($ctrl.current)" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.search"></button>
        <div class="table">
          <table>
            <tr class="border-0">
              <td>
                <salaxy-avatar style="margin-right: 40px;" class="avatar-xl" avatar="$ctrl.current.info.avatar"></salaxy-avatar>
              </td>
              <td ng-if="$ctrl.current.type != 'primaryPartner'">
                <p class="lead" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.notPrimaryPartner.lead" ps="."></p>

                <div class="input-info">
                  <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
                  <p ng-if="$ctrl.current.info.avatar.id" class="input-info-text with-icon" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.notPrimaryPartner.partnerInfo" ps="."></p>
                  <p ng-if="!$ctrl.current.info.avatar.id" class="input-info-text with-icon" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.notPrimaryPartner.notPartnerInfo" ps="."></p>
                </div>
              </td>
              <td ng-if="$ctrl.current.type == 'primaryPartner'">
                <p class="lead" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.primaryPartner.lead" ps="."></p>

                <div class="input-info">
                  <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
                  <p ng-if="$ctrl.current.info.avatar.id" class="input-info-text with-icon" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.primaryPartner.partnerInfo" ps="."></p>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="table-responsive">
          <table class="table">
            <tr>
              <th sxy-text="Nimi" ps=":"></th>
              <td>{{ $ctrl.current.info.avatar.displayName}}</td>
            </tr>
            <tr>
              <th sxy-text="Y-tunnus" ps=":"></th>
              <td>{{ $ctrl.current.info.officialId}}</td>
            </tr>
            <tr ng-if="!$ctrl.current.info.avatar.id">
              <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.accountantPermissions" ps=":"></th>
              <td>
                <salaxy-input-enum disabled="true" ng-model="$ctrl.current.type" type="radio" name="partnerType" label="" label-type="plain" options="{ 
                unlinkedPrimaryPartner: ('SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.unlinkedPrimaryPartnerEnum' | sxyTranslate),
                unlinkedAccountingOnly: ('SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.unlinkedAccountingOnlyEnum' | sxyTranslate)}">
                </salaxy-input-enum>
              </td>
            </tr>
            <tr ng-if="$ctrl.current.info.avatar.id">
              <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.accountantPermissions" ps=":"></th>
              <td>
                <salaxy-input-enum  ng-if="$ctrl.current.type != 'primaryPartner'" ng-model="$ctrl.current.type" type="radio" name="partnerType" label="" label-type="plain" options="{ 
                pendingPrimaryPartner: ('SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.pendingPrimaryPartnerEnum' | sxyTranslate),
                unlinkedAccountingOnly: ('SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.unlinkedAccountingOnlyEnum' | sxyTranslate)}">
                </salaxy-input-enum>
                <salaxy-input-enum ng-if="$ctrl.current.type == 'primaryPartner'" read-only="true" ng-model="$ctrl.current.type" type="radio" name="partnerType" label="" label-type="plain" options="{ 
                  primaryPartner: ('SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.primaryPartnerEnum' | sxyTranslate)}">
                </salaxy-input-enum>
              </td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.email" ps=":"></th>
              <td>
                <salaxy-input name="email" label="" label-type="plain" sxy-email ng-model="$ctrl.current.info.email"></salaxy-input>
              </td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.telephone" ps=":"></th>
              <td>
                <salaxy-input name="telephone" label="" label-type="plain" sxy-mobile-phone ng-model="$ctrl.current.info.telephone"></salaxy-input>
              </td>
            </tr>
          </table>
        </div>

      </div>
    </div>
  </form>
</div>

<div class="modal-footer text-end">
  <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="button" ng-if="$ctrl.current.type != 'primaryPartner'" class="btn btn-danger" ng-click="$close('remove')" sxy-text="SALAXY.UI_Terms.delete"></button>
  <button type="button" ng-if="$ctrl.current.type == 'primaryPartner' && !$ctrl.logic.removalDisabled" class="btn btn-danger" ng-click="$close('removePrimaryPartner')" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.deletePrimaryPartner"></button>
  <button type="button" ng-disabled="(!$ctrl.logic.selected && $ctrl.logic.type == 'company') || personAccountantForm.$invalid || companyAccountantForm.$invalid" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>
`);

 $templateCache.put("salaxy-components/modals/settings/BrandSelection.html",`<form name="brandForm" class="form-horizontal">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.BrandSelectionComponent.title"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <salaxy-odata-table 
        url="/v03/api/settings/brands" 
        template-url="salaxy-components/odata/lists/BrandList.html" 
        options="{ $filter: 'data/skin ne null and data/skin ne \\'\\'' }"
        selected-items="selectedItems"
        on-list-select="($ctrl.current.brand = value == true ? item : null);( selectedItems = value == true? [item ]: []);">
    </salaxy-odata-table>
    </div>
  </div>
  <div class="modal-footer">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="button" class="btn btn-default" ng-click="$close('set-default')" sxy-text="SALAXY.NG1.BrandSelectionComponent.useDefaultStyle"></button>
      <button type="submit" class="btn btn-primary" ng-disabled="!$ctrl.current.brand" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/settings/EntryCodes.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.EntryCodesComponent.title"></h2>
  <button type="button" class="ms-auto btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body" ng-init="$ctrl.logic.currentItem = $ctrl.current">
  <form name="entryCodesForm" class="form-horizontal">
    <div class="row">
      <div class="col-12">
        <salaxy-input-typeahead label="SALAXY.NG1.EntryCodesComponent.entryCodeGroupLabel" name="EntryCodeGroup" ng-model="$ctrl.current.entryCodeGroup" options="$ctrl.logic.entryCodeGroups" on-select-function="$ctrl.logic.onEntryCodeGroupChange"></salaxy-input-typeahead>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <salaxy-input-typeahead label="SALAXY.NG1.EntryCodesComponent.incomeTypeLabel" name="IncomeType" disable-cache="true" ng-model="$ctrl.current.entryCode" options="$ctrl.logic.optionTypes"></salaxy-input-typeahead>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/settings/Flags.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.additionalSelectionsHead"></h2>
  <button type="button" class="ms-auto btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <div class="table-responsive" style="max-height: 40vh;">
    <table class="table table-sm">
      <thead>
        <tr>
          <th colspan="2" sxy-text="SALAXY.NG1.FlagsComponent.flag"></th>
          <th class="text-right">
            <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.logic.addFlag($ctrl.current)" sxy-text="SALAXY.UI_Terms.addRow"></button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in $ctrl.current.flags track by $index">
          <td><span class="badge" ng-class="$ctrl.logic.getFlagText(item).found ? 'bg-success' : 'bg-warning'">{{$ctrl.logic.getFlagText(item).text}}</span></td>
          <td>
            <salaxy-input ng-model="$ctrl.current.flags[$index]" name="{{ 'flag' + $index }}" label-type="plain"  ></salaxy-input>
          </td>
          <td class="text-right">
            <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.current.flags.splice($index,1)" title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}"><i class="bi bi-trash-fill"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/settings/FlagSelection.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.FlagsComponent.title"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <form name="FlagForm" class="form-horizontal">
    <div class="row">
      <div class="col-xs-12">
        <salaxy-input-enum require="true" label="SALAXY.NG1.FlagsComponent.prefix" name="Prefix" ng-model="$ctrl.current.prefix" options="$ctrl.logic.prefixOptions" type="radio"></salaxy-input-enum>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12" ng-switch="$ctrl.current.prefix">
        <salaxy-input-enum require="true" ng-switch-when="employmentType" label="SALAXY.NG1.EmploymentRelation.employmentRelation"  name="EmploymentType" ng-model="$ctrl.current.value" enum="EmploymentRelationType" type="select"></salaxy-input-enum>
        <salaxy-input-enum require="true" ng-switch-when="pensionCalculation" label="SALAXY.NG1.WorkerWizardComponent.employment.pension.title"  name="PensionCalculation" ng-model="$ctrl.current.value" options="$ctrl.logic.pensionCalculation" type="select"></salaxy-input-enum>
        <salaxy-calc-row-type ng-switch-when="rowType" label="SALAXY.NG1.CalcRowTypeComponent.rowType"  name="rowType" model="$ctrl.logic.asUserDefinedRow($ctrl.current)" ></salaxy-calc-row-type>
        <salaxy-calc-row-type ng-switch-when="type" label="SALAXY.NG1.CalcRowTypeComponent.wageType"  name="type" model="$ctrl.logic.asUserDefinedRow($ctrl.current)" ></salaxy-calc-row-type>
        <salaxy-input-enum require="true" ng-switch-when="dimension" label="SALAXY.MODEL.CostAccountingSettings.title"  name="Dimension" ng-model="$ctrl.current.value" options="$ctrl.logic.dimension" type="select"></salaxy-input-enum>
        <salaxy-input require="true" ng-switch-when="dimension" label="SALAXY.MODEL.CostAccountingDimensionOption.value.title"  name="dimensionValue" ng-model="$ctrl.current.dimensionValue"></salaxy-input>
        <salaxy-input-enum require="true" ng-switch-when="selfPayment" label="SelfPayment"  name="SelfPayment" ng-model="$ctrl.current.value" options="$ctrl.logic.selfPayment" type="select"></salaxy-input-enum>
        <salaxy-input-enum require="true" ng-switch-when="behavior" label="Behavior"  name="Behavior" ng-model="$ctrl.current.value" enum="CalculationFlag" type="select"></salaxy-input-enum>
        <salaxy-input require="true" ng-switch-when="regex" label="Regex"  name="regex" ng-model="$ctrl.current.value"></salaxy-input>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary float-end" ng-disabled="!FlagForm.$valid || ( ($ctrl.current.prefix == 'rowType' || $ctrl.current.prefix == 'type' )  && !$ctrl.current.value)" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/settings/PaymentChannel.html",`<form name="periodForm" class="form-horizontal">
  <div class="modal-header">
    <h2 class="modal-title">{{ $ctrl.logic.channelAvatar.displayName }}, asetukset</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <div class="form-horizontal">
      <p class="lead">
        <strong>{{ $ctrl.logic.channelAvatar.displayName }}</strong>: {{ $ctrl.logic.channelAvatar.description }}
      </p>
      <div ng-switch="$ctrl.current.id">
        <fieldset ng-switch-when="palkkausCfaFinvoice|palkkausEcfaFinvoice"  ng-switch-when-separator="|">
          <legend sxy-text="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaFinvoice.legend"></legend>
          <salaxy-form-group name="eInvoiceReceiver" label="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaFinvoice.eInvoiceAddress">
            <div class="input-group">
              <input class="form-control" type="text" autocomplete="off" id="eInvoiceReceiver" name="eInvoiceReceiver" ng-disabled="true" ng-model="$ctrl.current.invoiceSettings.eInvoiceReceiver">
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="$ctrl.logic.selectEInvoiceAddress($ctrl.current.invoiceSettings)" sxy-text="SALAXY.UI_Terms.choose"></button>
              </span>
            </div>
          </salaxy-form-group>
          <salaxy-input disabled="true" name="intermediator" ng-model="$ctrl.current.invoiceSettings.eInvoiceIntermediator" label="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaFinvoice.intermediator"></salaxy-input>
        </fieldset>
        <fieldset ng-switch-when="palkkausCfaPaytrail|palkkausEcfaPaytrail|palkkausCfaReference|palkkausEcfaReference|palkkausCfaFinvoice|palkkausEcfaFinvoice|palkkausCfaTest" ng-switch-when-separator="|">
          <fieldset>
            <legend sxy-text="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaPaytrail.legend"></legend>
            <p sxy-text="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaPaytrail.infoText"></p>
            <salaxy-input-boolean type="checkbox" name="isTaxAndSocialSecuritySelfHandling" label-type="plain" label-true="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaPaytrail.isTaxAndSocialSecuritySelfHandling" ng-model="$ctrl.current.customerFundsSettings.isTaxAndSocialSecuritySelfHandling"></salaxy-input-boolean>
            <salaxy-input-boolean type="checkbox" name="isWorkerSelfHandling" label-type="plain" label-true="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaPaytrail.isWorkerSelfHandling" ng-model="$ctrl.current.customerFundsSettings.isWorkerSelfHandling"></salaxy-input-boolean>
            <div>&nbsp;</div>
            <div class="alert alert-warning" sxy-html="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaPaytrail.alert.html"></div>
          </fieldset>
        </fieldset>
        <fieldset ng-switch-when="palkkausManual|talenomManual|hausvise|passeliMerit" ng-switch-when-separator="|">
          <legend sxy-text="SALAXY.NG1.PaymentChannelDialogComponent.palkkausManual.legend"></legend>
          <salaxy-input label-cols="col-sm-6" name="ibanNumber" label="SALAXY.NG1.PaymentChannelDialogComponent.palkkausManual.ibanNumber" sxy-iban ng-model="$ctrl.current.invoiceSettings.ibanNumber"></salaxy-input>
          <salaxy-input label-cols="col-sm-6" name="sepaBankPartyId" label="SALAXY.NG1.PaymentChannelDialogComponent.palkkausManual.sepaBankPartyId" ng-model="$ctrl.current.invoiceSettings.sepaBankPartyId"></salaxy-input>
        </fieldset>
        <!--fieldset ng-switch-when="palkkausInvoices">
          <legend sxy-text="SALAXY.NG1.PaymentChannelDialogComponent.palkkausInvoices.legend"></legend>
          <salaxy-input name="creditCard" disabled="true" label="SALAXY.NG1.PaymentChannelDialogComponent.palkkausInvoices.creditCard" ng-model="dummy"></salaxy-input     
        </fieldset-->
        <fieldset ng-switch-default>
          <div class="alert alert-info" sxy-text="SALAXY.NG1.PaymentChannelDialogComponent.default.info"></div>
        </fieldset>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex">
    <button type="button" ng-if="$ctrl.current.settings.isEnabled && $ctrl.current.settings.isAvailable" class="btn btn-danger" ng-disabled="$ctrl.current.isReadOnly" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.unenable"></button>
    <button type="reset" ng-click="$close('cancel')" class="btn btn-default ms-auto" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="button" ng-if="!$ctrl.current.isDefault  && $ctrl.current.settings.isAvailable" class="btn btn-default" ng-disabled="$ctrl.current.isReadOnly && !$ctrl.current.settings.isEnabled" ng-click="$close('set-default')" sxy-text="SALAXY.UI_Terms.setDefault"></button>
    <button type="submit" ng-if="$ctrl.current.settings.isEnabled  && $ctrl.current.settings.isAvailable" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
    <button type="button" ng-if="!$ctrl.current.settings.isEnabled  && $ctrl.current.settings.isAvailable" class="btn btn-primary" ng-disabled="$ctrl.current.isReadOnly" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.enable"></button>
  </div>
</form>`);

 $templateCache.put("salaxy-components/modals/settings/UiTranslator.html",`
<div class="modal-ui-translation">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <salaxy-ui-translator></salaxy-ui-translator>
    <div>
      <button type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
      <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/templates/TemplateSelect.html",`<div class="modal-template-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title | sxyTranslate}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <div class="salaxy-component">
        <salaxy-odata-table ng-ref="$templateList" select-mode="'select'" url="/v03/api/templates"
          options="$ctrl.logic.options"
          selected-items="$ctrl.current"
          template-url="salaxy-components/odata/lists/Templates-select.html"
          on-list-select="$templateList.selectedItems.splice(0, $templateList.selectedItems.length);(value == true ? $templateList.selectedItems.push(item) : null);"
          crud-controller="TemplateCrudController as $crud"></salaxy-odata-table>
      </div>
    </div>
    <div class="text-right">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="{{ $ctrl.logic.cancelButtonText || 'SALAXY.UI_Terms.cancel'}}"></button>
      <button type="submit" ng-disabled="$templateList.selectedItems.length != 1" class="btn btn-primary" ng-click="$close('ok')" sxy-text="{{ $ctrl.logic.okButtonText || 'SALAXY.UI_Terms.save'}}"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/ui/Alert.html",`<div class="modal-header">
  <h3 class="modal-title" id="modal-title">{{$ctrl.data.heading | sxyTranslate}}</h3>
</div>
<div ng-if="$ctrl.data.text" class="modal-body salaxy-component" id="modal-body">
  <p class="pre-wrap">{{$ctrl.data.text | sxyTranslate}}</p>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" type="button" ng-click="$close('ok')">{{$ctrl.data.okText | sxyTranslate}}</button>
</div>`);

 $templateCache.put("salaxy-components/modals/ui/Confirm.html",`<div class="modal-header">
  <h3 class="modal-title" id="modal-title">{{$ctrl.data.heading | sxyTranslate}}</h3>
</div>
<div ng-if="$ctrl.data.text || $ctrl.data.html" class="modal-body" id="modal-body">
  <p ng-if="!$ctrl.data.html" class="pre-wrap">{{$ctrl.data.text | sxyTranslate}}</p>
  <div ng-if="$ctrl.data.html" sxy-html="{{$ctrl.data.html}}"></div>
</div>
<div class="modal-footer">
  <button class="btn btn-default" type="button" ng-click="$close(false)">{{$ctrl.data.cancelText | sxyTranslate}}</button>
  <button class="btn btn-primary" type="button" ng-click="$close(true)">{{$ctrl.data.okText | sxyTranslate}}</button>
</div>`);

 $templateCache.put("salaxy-components/modals/ui/DialogWindow.html",`<div id="salaxyDialog" class="salaxy-component salaxy-dialog modal-dialog {{size ? 'modal-' + size : ''}}" aria-labelledby="salaxyDialogLabel" role="dialog">
        <div class="modal-content" role="document" uib-modal-transclude></div>
</div>`);

 $templateCache.put("salaxy-components/modals/ui/DocumentPreviewWindow.html",`<div class="salaxy-component container-document-print salaxy-rpt" role="dialog">
    <div class="document-preview" id="document-preview">
        <div style="height:auto;min-height:277mm" class="modal-content document a4portrait" role="document" uib-modal-transclude></div>
    </div>
</div>
`);

 $templateCache.put("salaxy-components/modals/ui/Download.html",`<div class="modal-body" id="modal-body">
  <div class="sxy-spinner" ng-if="!$ctrl.data.isReady">
      <svg class="sxy-spinner-bg" viewBox="0 0 64 64"><circle cx="32" cy="32" r="26"></circle></svg>
      <svg class="sxy-spinner-spin" viewBox="0 0 64 64">
          <circle transform="translate(32,32)" r="26"></circle>
      </svg>
  </div>
  
  <div style="text-align: center;">
      <h3 ng-if="!$ctrl.data.isReady" >{{$ctrl.data.waitHeading | sxyTranslate}}</h3>
      <h3 ng-if="$ctrl.data.isReady" >{{$ctrl.data.readyHeading | sxyTranslate}}</h3>
      <p  ng-if="!$ctrl.data.isReady" style="white-space: pre;">{{$ctrl.data.waitText | sxyTranslate}}</p>
      <p ng-if="$ctrl.data.isReady">
        {{$ctrl.data.readyText | sxyTranslate}} 
        <a ng-if="$ctrl.data.target" ng-click="$close('ok')" ng-href="{{$ctrl.data.url}}" target="{{$ctrl.data.target}}" >{{$ctrl.data.openText | sxyTranslate}}</a>
        <a ng-if="!$ctrl.data.target" ng-click="$close('ok')" ng-href="{{$ctrl.data.url}}" >{{$ctrl.data.openText | sxyTranslate}}</a>
      </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/ui/Html.html",`<div class="modal-header">
  <h2 class="modal-title">{{$ctrl.data.title}}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body ">
  <div ng-bind-html="$ctrl.data.html"></div>
</div>`);

 $templateCache.put("salaxy-components/modals/ui/Loading.html",`<div class="modal-body" id="modal-body" style="text-align:center;">
  <div class="sxy-spinner">
    <svg class="sxy-spinner-bg" viewBox="0 0 64 64"><circle cx="32" cy="32" r="26"></circle></svg>
    <svg class="sxy-spinner-spin" viewBox="0 0 64 64">
            <circle transform="translate(32,32)" r="26"></circle>
        </svg>
  </div>
  <div style="text-align: center;">
    <h3 ng-if="$ctrl.data.heading">{{$ctrl.data.heading | sxyTranslate}}</h3>
    <p class="pre-wrap" ng-if="$ctrl.data.text">{{$ctrl.data.text | sxyTranslate}}</p>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/ui/SelectListItem.html",`<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title | sxyTranslate}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <p ng-if="$ctrl.logic.infoHtml" sxy-html="{{$ctrl.logic.infoHtml}}"></p>
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <salaxy-odata-table
        template-url="salaxy-components/odata/lists/SelectListItem.html"
        selected-items="$ctrl.current" on-list-select="$close('ok')"
        crud-controller="DatasetsCrudController as $crud"></salaxy-odata-table>
    </div>
    <div class="text-end">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')">{{$ctrl.logic.okButtonText ? ($ctrl.logic.okButtonText | sxyTranslate) : ('SALAXY.UI_Terms.save' |
        sxyTranslate)}}</button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/worker/taxcard-income-log.html",`<div class="modal-taxcard-new">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addPaidSalaries"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="alert alert-info" ng-if="$ctrl.$incomeLog.hasDiff">
      <button type="button" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addSalaries"></button>
      <span sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addSalariesToTaxCard" params="{validity: ($ctrl.current.card.validity | sxyDateRange)}">
      </span>
    </div>
    <salaxy-taxcard-income-log parent="$ctrl.current" editable="$ctrl.logic.editable" ng-ref="$ctrl.$incomeLog"></salaxy-taxcard-income-log>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addSalaries"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/worker/taxcard-min-percent.html",`<div class="modal-taxcard-min-percent">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardMinPercent.minimumPercent"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body form-horizontal">
    <p class="lead" sxy-html="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardMinPercent.lead.html"></p>
    <p sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardMinPercent.biggerTaxPercentThanInTaxCard"></p>
    <p sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardMinPercent.taxPercentMinimum"></p>
    <salaxy-input-number name="taxPercentMin" ng-model="$ctrl.current.taxPercentMin" label="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardMinPercent.minimumPercent"></salaxy-input-number>
  </div>
  <div class="modal-footer">
    <button class="btn btn-default" type="button" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button class="btn btn-primary" type="button" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>

  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/worker/taxcard-new.html",`<div class="modal-taxcard-new">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardNew.addTaxCard"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div style="min-height: 440px;" class="modal-body">
    <salaxy-taxcard-manual-edit ng-ref="$edit" current="$ctrl.current"></salaxy-taxcard-manual-edit>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" ng-disabled="!$edit.isFormValid" sxy-text="SALAXY.UI_Terms.save"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/modals/workflow/UsecaseInfo.html",`<div class="modal-header">
  <h2 class="modal-title">
    <i ng-if="$ctrl.current.icon[0] == 'f'" class="bi" ng-class="$ctrl.current.icon" aria-hidden="true" style="padding-right: 20px"></i>
    Käyttötapaus: {{ $ctrl.current.label || $ctrl.logic.objUsecase.label || "Ei käyttötapausta" }}
  </h2>
  <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>

</div>
<div class="modal-body">
  <p class="lead">{{ $ctrl.current.description || $ctrl.logic.objUsecase.description }}</p>
  <p><code>{{ $ctrl.logic.objUsecase.uri }}</code></p>
  <div class="alert alert-danger" ng-if="!$ctrl.current">
    <strong>Ei käyttötapausta!</strong>
    Tällä tietuella ei ole määritettyä käyttötapausta.
  </div>
  <div ng-if="$ctrl.current">
    <div class="row">
      <div class="col-sm-6">
        <fieldset>
          <legend>Käyttötapaus</legend>
          <div ng-if="!$ctrl.current.defaultView">Ei räätälöityä näkymää.</div>
          <div ng-if="$ctrl.current.defaultView">
            <p>Näkymät (<a href="{{ $ctrl.current.defaultView }}" target="_blank">linkki oletusnäkymään</a>)</p>
            <ul>
              <li ng-repeat="view in $ctrl.current.views">
                <strong>{{ view.label }}</strong> {{ view.description }}
              </li>
            </ul>
          </div>
          <!-- TODO: Show actions, schemas and workflowData / flow if necessary. -->
        </fieldset>
      </div>
      <div class="col-sm-6">
        <fieldset>
          <legend>Objektiin tallennettu data</legend>
          <salaxy-json-formatter json="$ctrl.logic.objUsecase.data" key="'JSON'"></salaxy-json-formatter>
        </fieldset>
      </div>
    </div>
    <salaxy-json-formatter json="$ctrl.current" key="'JSON'" open="0"></salaxy-json-formatter>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-danger float-start" ng-if="$ctrl.logic.canDelete" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.delete"></button>
  <button class="btn btn-default ms-auto" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/workflow/WorkflowBadgeDetails.html",`<div class="modal-header">
  <h2 class="modal-title" id="salaxyWorkflowBadgeDetailsTitle" sxy-text="{{'SALAXY.ENUM.BootstrapStyle.' + $ctrl.current.event.ui + '.label' }}"></h2>
  <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
</div>
<div class="modal-body">

  <form class="form-horizontal" name="eventAndRecord" ng-readonly="true">
    <salaxy-form-group name="time" label="SALAXY.UI_Terms.updated">
      <span>{{$ctrl.current.event.time | sxyTime }}</span>
    </salaxy-form-group>
    <salaxy-input-enum type="select" enum="BootstrapStyle" label="SALAXY.NG1.WorkFlowEventEditComponent.ui" name="ui" ng-model="$ctrl.current.event.ui"></salaxy-input-enum>
    <salaxy-input label="SALAXY.NG1.WorkFlowEventEditComponent.description" name="message" require="true" ng-model="$ctrl.current.event.message"></salaxy-input>
    <div ng-if="$ctrl.current.record">
      <salaxy-input ng-if="$ctrl.current.record.recordType" ng-model="$ctrl.current.record.recordType" label="SALAXY.NG1.WorkerDetailsComponent.records.recordType" name="recordType"></salaxy-input>
      <salaxy-input ng-if="$ctrl.current.record.title" ng-model="$ctrl.current.record.title" label="SALAXY.NG1.WorkerDetailsComponent.records.title" name="title"></salaxy-input>
      <salaxy-textarea ng-if="$ctrl.current.record.text && !('markdown' | sxyIsInRole)" ng-model="$ctrl.current.record.text" label="SALAXY.NG1.WorkerDetailsComponent.records.text" name="text"></salaxy-textarea>
      <salaxy-input-markdown ng-if="$ctrl.current.record.text && ('markdown' | sxyIsInRole)" ng-model="$ctrl.current.record.text" label="SALAXY.NG1.WorkerDetailsComponent.records.text" name="text" label-type="plain"></salaxy-input-markdown>
      <salaxy-form-group ng-if="$ctrl.current.record.attachments.length > 0" name="attachments" label="SALAXY.NG1.WorkerDetailsComponent.records.attachments">
        <table>
          <tr ng-repeat="attachment in $ctrl.current.record.attachments">
            <td>
              <i class="bi {{ $ctrl.logic.getAttachmentIcon(attachment) }} text-primary float-start me-1"></i>
              <a target="_blank" ng-href="{{$ctrl.logic.getAttachmentDownloadUrl(attachment)}}">{{attachment.fileName}}</a>
            </td>
          </tr>
        </table>
      </salaxy-form-group>
      <salaxy-datepicker-popup ng-if="$ctrl.current.record.startDate" ng-model="$ctrl.current.record.startDate" label="SALAXY.NG1.WorkerDetailsComponent.records.startDate" name="startDate"></salaxy-datepicker-popup>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`);

 $templateCache.put("salaxy-components/modals/workflow/WorkflowEventEdit.html",`<div class="modal-header">
  <h2 class="modal-title" id="salaxyWorkflowEventEditTitle" sxy-text="{{$ctrl.logic.title}}"></h2>
  <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>

</div>
<div class="modal-body">
  <form name="event" class="form-horizontal" ng-readonly="$ctrl.logic.readOnly">
    <salaxy-input label="SALAXY.NG1.WorkFlowEventEditComponent.description" name="message" require="true" ng-model="$ctrl.current.message"></salaxy-input>
    <salaxy-input-enum ng-if="$ctrl.logic.showUi" type="select" enum="BootstrapStyle" label="SALAXY.NG1.WorkFlowEventEditComponent.ui" name="ui" require="true" ng-model="$ctrl.current.ui"></salaxy-input-enum>
  </form>
</div>
<div class="modal-footer">
  <button type="reset" ng-if="!$ctrl.logic.readOnly" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="button" ng-if="$ctrl.logic.readOnly" class="btn btn-primary" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" ng-if="!$ctrl.logic.readOnly" class="btn btn-primary" ng-disabled="!event.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>
`);

 $templateCache.put("salaxy-components/odata/lists/AbsencePeriods.html",`<div ng-class="$ctrl.getCssClass()">
  <!-- TODO: This list is currenlty not in use - may be taken to use (or remove Q1/2020) -->
  <table class="table">
    <thead>
      <tr>
        <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
          <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
        </th>
        <th sxy-orderby="causeCode">{{ "SALAXY.NG1.AbsencePeriodsComponent.headerAbsence" | sxyTranslate }}</th>
        <th sxy-orderby="period/start" class="right" sxy-text="SALAXY.NG1.AbsencePeriodsComponent.wholeAbsence"></th>
        <th sxy-orderby="period/daysCount" class="right" sxy-html="SALAXY.NG1.AbsencePeriodsComponent.periodDaysCount.html"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td class="align-middle td-avatar">
          <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="td-name middle">
          <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong><br /> {{ row.worker.description }}
        </td>
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
          <strong>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</strong><br />
          <div class="float-start" style="padding: 0px;">
            {{ row.isPaid ? ('SALAXY.NG1.AbsencePeriodsComponent.isPaid' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notPaid' | sxyTranslate) }}
            <span ng-if="row.isPaid != row.isHolidayAccrual"> {{ row.isHolidayAccrual ? ('SALAXY.NG1.AbsencePeriodsComponent.isAccrual' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notAccrual' | sxyTranslate) }}</span>
          </div>
          <div class="truncate" style="max-width: 250px; padding: 0px;">
            &nbsp;{{ row.notes }}
          </div>
        </td>
        <td class="right">
          <strong>{{ row.period.daysCount | sxyCount : "day" }}</strong><br /> {{ row.period.start | date : 'dd.MM.' }}-{{ row.period.end | date : 'dd.MM.' }}
        </td>
        <td class="right">
          <strong>{{ (row.isPaid ? 0 : row.period.daysCount) | sxyCount : "day" }}</strong><br />
          <strong>{{ (row.isHolidayAccrual ? 0 : row.period.daysCount) | sxyCount : "day" }}</strong><br />
        </td>
        <td class="hidden-xxs middle">
          <button ng-click="$ctrl.data.$payrollCtrl.showEditWorkerDialog(row.worker.id, 'absences')" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-inline d-sm-none"></i>
            <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.edit"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/Absences.html",`<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
          <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
        </th>
        <th class="right">
          <span sxy-orderby="startAt" sxy-text="SALAXY.NG1.AbsencesComponent.first"></span><br />
          <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.AbsencesComponent.first">Viimeisin</span>
        </th>
        <th class="right" sxy-text="SALAXY.NG1.AbsencesComponent.salaried"></th>
        <th class="right" sxy-text="SALAXY.NG1.AbsencesComponent.unpaid">Palkattomat</th>
        <th>
          <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain"></salaxy-input>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td class="align-middle td-avatar">
          <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="td-name middle">
          <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong><br /> {{ row.data.count }} {{'SALAXY.NG1.AbsencesComponent.absence' | sxyTranslate}}, {{ row.data.days }} {{'SALAXY.NG1.AbsencesComponent.day' | sxyTranslate}}<br />
          <span ng-if="!row.data.employmentId" class="label label-danger" sxy-text="SALAXY.NG1.AbsencesComponent.error"></span>
        </td>
        <td class="right">
          {{ row.startAt | sxyDate }}<br /> {{ row.endAt | sxyDate }}
        </td>
        <td class="right">
          {{ row.data.paidCount }} {{'SALAXY.NG1.AbsencesComponent.pce' | sxyTranslate}}<br /> {{ row.data.paidDays }} {{'SALAXY.NG1.AbsencesComponent.d' | sxyTranslate}}
        </td>
        <td class="right">
          {{ row.data.unpaidCount }} {{'SALAXY.NG1.AbsencesComponent.pce' | sxyTranslate}}<br /> {{ row.data.unpaidDays }} {{'SALAXY.NG1.AbsencesComponent.d' | sxyTranslate}}
        </td>
        <td class="hidden-xxs middle">
          <button ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-sm-none d-inline"></i>
            <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.edit"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/AccountingReports.html",`<div ng-class="$ctrl.getCssClass()">

  <salaxy-accounting-report-tools ng-ref="$reportTools" reader="$crud.selectionDataReader"></salaxy-accounting-report-tools>

  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-datepicker-popup name="year" placeholder="{{'SALAXY.NG1.AccountingReportsComponent.year'}}" ng-change="$crud.logicalDateChanged()" format="year" ng-model="$crud.logicalDate" label-type="plain" require="true"></salaxy-datepicker-popup>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="ownerInfo/avatar/displayName">
            <span>{{ 'SALAXY.NG1_Other.Roles.employer' | sxyTranslate }}</span>
          </th>
          <th>
            <span sxy-orderby="logicalDate">{{ 'SALAXY.NG1.AccountingReportsComponent.period' | sxyTranslate }}</span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary">{{ 'SALAXY.NG1.AccountingReportsComponent.salaries' | sxyTranslate }}</span><br />
            <span sxy-orderby="payment">{{ 'SALAXY.NG1.AccountingReportsComponent.payments' | sxyTranslate }}</span>
          </th>
          <th class="right ">
            <span>{{ 'SALAXY.NG1.AccountingReportsComponent.salariesAlt' | sxyTranslate }}</span><br />
            <span>{{ 'SALAXY.NG1.AccountingReportsComponent.workers' | sxyTranslate }}</span>
          </th>
          <th sxy-text="SALAXY.NG1.AccountingReportsComponent.material"></th>
          <th sxy-text="SALAXY.NG1.AccountingReportsComponent.responsiblePerson"></th>
          <th class="middle hidden-xxs">
            <salaxy-datepicker-popup ng-model="$crud.logicalDate" ng-change="$crud.logicalDateChanged()" name="year" placeholder="{{'SALAXY.NG1.AccountingReportsComponent.year'}}" format="year" label-type="plain" require="true"></salaxy-datepicker-popup>
          </th>
          <th class="middle hidden-xxs">
            <button title="{{'SALAXY.NG1.AccountingReportsComponent.chooseAll' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length == 0" ng-disabled="$ctrl.selectedItems.length == $ctrl.items.length" ng-click="$crud.selectAll()">
              <i class="bi bi-square"></i>
            </button>
            <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length > 0" ng-disabled="$ctrl.selectedItems.length == 0" ng-click="$crud.unselectAll()">
              <i class="bi bi-check-square"></i>
            </button>
          </th>
          <th class="middle hidden-xxs"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name middle">
            <span ng-if="row.ownerInfo.avatar.displayName == ''">{{ 'SALAXY.NG1.AccountingReportsComponent.notSelected' | sxyTranslate }}</span>
            <strong>{{row.ownerInfo.avatar.displayName}}</strong><br /> {{row.data.officialId}}
          </td>
          <td class="middle">
            {{ row.logicalDate | date:'yyyy-MM' }}
          </td>
          <td class="right middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="right middle">
            {{ row.data.calculationCount }} {{'SALAXY.NG1.AccountingReportsComponent.pce' | sxyTranslate}}<br /> {{ row.data.workerCount }} {{'SALAXY.NG1.AccountingReportsComponent.pce' | sxyTranslate}}
          </td>
          <td class="middle">
            <div ng-repeat="message in row.messages" ng-bind-html="message | sxyWorkflowMessage: 'PartnerMessageIssue,PartnerMessageClosed'"></div>
          </td>
          <td class="middle">
            <span ng-if="row.data.partnerMessageAssignedTo" ng-controller="WorkflowController as $workflowCtrl" title="{{ $workflowCtrl.getCredential(row.data.partnerMessageAssignedTo).email || $workflowCtrl.getCredential(row.data.partnerMessageAssignedTo).avatar.displayName }}">
              <salaxy-avatar style="font-size:45px" avatar="$workflowCtrl.getCredential(row.data.partnerMessageAssignedTo).avatar"></salaxy-avatar>
            </span>
          </td>
          <td class="middle hidden-xxs">
            <button class="btn btn-sm btn-block btn-default" ng-disabled="row.isReading" type="button" ng-click="$reportTools.export($crud.getItemDataReader(row),true)">
              <span ng-show="row.isReading"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span ng-show="!row.isReading">{{ 'SALAXY.NG1.AccountingReportsComponent.createMaterial' | sxyTranslate }}</span>
            </button>
          </td>
          <td class="middle hidden-xxs">
            <button title="{{'SALAXY.UI_Terms.select' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="!$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
              <i class="bi bi-square"></i>
            </button>
            <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
              <i class="bi bi-check-square"></i>
            </button>
          </td>
          <td class="middle hidden-xxs">
            <a href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/AccountingReportsPanel.html",`<div class="salaxy-odata-card list-card report-list-card card card-sm card-secondary">
  <div class="card-header d-flex align-items-center">
    {{'SALAXY.NG1.AccountingReportsComponent.accountingReports' | sxyTranslate}}
    <button ng-style="{'visibility': $ctrl.items.length > 0 ? 'visible' : 'hidden'}" class="btn btn-secondary btn-xs ms-auto" ng-click="hideFilter = !hideFilter" title="{{'SALAXY.NG1.AccountingReportsComponent.showFilters' | sxyTranslate}}">
      <i class="bi bi-funnel-fill"></i>
    </button>
  </div>
  <div class="card-body filters text-end" ng-class="{'showfilters' : hideFilter}">
    <div class="filter-buttons">
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="logicalDate">{{'SALAXY.NG1.AccountingReportsComponent.mm' | sxyTranslate}}</button>
    </div>
    <salaxy-input name="search1cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search hidden-xxs" label-type="plain"></salaxy-input>
  </div>
  <div ng-class="$ctrl.getCssClass()">
    <div class="visible-xxs" ng-if="$ctrl.items.length > 0">
      <div class="table-filter-container-mobile">
        <salaxy-input name="search2cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
        </salaxy-input>
      </div>
    </div>
    <div class="card-body text-center card-content lg-height align-middle" ng-show="$ctrl.items.length == 0 && !$ctrl.isLoading">
      <div>
        <h3 sxy-text="SALAXY.NG1.AccountingReportsComponent.noAccountingReports"></h3>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table" ng-if="$ctrl.items.length > 0">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">
            <td class="middle">
              {{ row.logicalDate | date:'yyyy-MM' }}
            </td>
            <td class="middle right">
              {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
            </td>
            <td class="middle right">
              {{row.data.calculationCount}} <i class="bi bi-list-task" title="{{'SALAXY.NG1.AccountingReportsComponent.calcs' | sxyTranslate}}"></i>
              <br/> {{row.data.workerCount}} <i class="bi bi-person-fill" title="{{'SALAXY.NG1.AccountingReportsComponent.workersAlt' | sxyTranslate}}"></i>
            </td>
            <td class="middle right">
              <a href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i
              class="bi bi-info-circle "></i></a>
            </td>

          </tr>
        </tbody>
      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>

  </div>
  <div class="card-footer text-center">
    <a ng-href="#{{$crud.getDefaults().listUrl}}" class="btn btn-primary btn-sm" sxy-text="SALAXY.UI_Terms.showAll"></a>
  </div>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/AccountingTargets.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <div sxy-orderby="shortText" sxy-text="SALAXY.NG1.AccountingTargetsComponent.exportDefinition"></div>
            <div sxy-text="SALAXY.NG1.AccountingTargetsComponent.targetChannel"></div>
          </th>
          <th colspan="2">
            <div sxy-orderby="ownerInfo/avatar/displayName" sxy-text="SALAXY.NG1.AccountingTargetsComponent.owner"></div>
            <div sxy-orderby="status" sxy-text="SALAXY.NG1.AccountingTargetsComponent.status"></div>
          </th>
          <th class="right">
            <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
            <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div title="{{ row.shortText }} ({{ row.id }})">
              <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong>
            </div>
          </td>
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div>{{ row.ownerInfo.avatar.displayName }}</div>
            <div>{{ "AccountingTargetStatus." + row.status | sxyEnum }}</div>
          </td>
          <td class="right">
            <div title="{{ row.createdAt }}">{{ row.createdAt | sxyDate }}</div>
            <div title="{{ row.updatedAt }}">{{ row.updatedAt | sxyDate }}</div>
            <div></div>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="!row.isReadOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
              <i class="bi bi-trash-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>
`);

 $templateCache.put("salaxy-components/odata/lists/AccountingTargetSelect.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <div sxy-orderby="shortText" sxy-text="SALAXY.NG1.AccountingTargetsComponent.exportDefinition"></div>
            <div sxy-text="SALAXY.NG1.AccountingTargetsComponent.targetChannel"></div>
          </th>
          <th sxy-orderby="owner" colspan="2">
            <div sxy-text="SALAXY.NG1.AccountingTargetsComponent.owner"></div>
          </th>
          <th class="right hidden-xxs" colspan="3">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div title="{{ row.shortText }} ({{ row.id }})">
              <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong>
            </div>
          </td>
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div>{{ row.ownerInfo.avatar.displayName }}</div>
          </td>
          <td></td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/ApiCrudObject.html",`<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th sxy-orderby="id">
          <div sxy-text="SALAXY.NG1.ApiCrudObjectComponent.id"></div>
        </th>
        <th sxy-orderby="status"  sxy-text="SALAXY.UI_Terms.status"></th>
        <th class="right">
          <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
          <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
        </th>
        <th sxy-orderby="owner" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.owner"></th>
        <th sxy-orderby="isReadOnly" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.readOnly"></th>
        <th sxy-orderby="partner" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.partner"></th>
        <th colspan="2"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td>
          <div>{{ row.shortText }}</div>
          <div><code><small>{{ row.id }}</small></code></div>
        </td>
        <td>{{ row.status }}</td>
        <td class="right">
          <div>{{ row.createdAt | sxyDate }}</div>
          <div>{{ row.updatedAt | sxyDate }}</div>
        </td>
        <td class="td-avatar">
          <salaxy-avatar avatar="row.ownerInfo.avatar" title="row.owner"></salaxy-avatar>
        </td>
        <td>{{ row.isReadOnly }}</td>
        <td>{{ row.partner }}</td>
        <td>
          <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-sm-none d-inline"></i>
            <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.edit"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-info-circle d-sm-none d-inline"></i>
            <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.show"></span>
          </button>
        </td>
        <td>
          <button ng-if="!row.isReadOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
            <i class="bi bi-trash-fill d-sm-none d-inline"></i>
            <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.delete"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-copy d-sm-none d-inline"></i>
            <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
           </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/BrandList.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="ownerInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1.BrandListComponent.partner"></span>
          </th>
          <th class="right" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <i class="salaxy-avatar" style="font-size: 74px;"><img ng-src="{{ row.data.logo }}" /></i>
          </td>
          <td class="td-name middle">
            <strong>{{row.data.webAppName || row.ownerInfo.avatar.displayName}}</strong>
          </td>
          <td class="right middle">
            <button class="btn" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" type="button" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>

          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/Calculations-select.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
            <span class="label label-primary clickable" ng-if="$ctrl.selectedItems.length" ng-click="$ctrl.selectedItems.splice(0,$ctrl.selectedItems.length)"> {{'SALAXY.UI_Terms.chosen' | sxyTranslate}}: {{ $ctrl.selectedItems.length }} <i class="bi bi-x-circle"></i></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span><br />
            <span sxy-orderby="salaryDate"><span sxy-text="SALAXY.NG1.CalculationsWithSalaryDateSelectComponent.salaryDate"></span></span>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name visible-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
            <br /> {{ row.salaryDate | date }}
          </td>
          <td class="right visible-xxs bottom">
            <a ng-href="#/calc/details/{{row.id}}">
              {{ row.grossSalary | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ row.status ? ("SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate) : "#ERR" }}<br /> {{ row.salaryDate | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}
          </td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsAll.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-header-container-mobile" ng-show="!$ctrl.readOnly">
      <a class="btn btn-sm btn-block btn-primary" href="#/calc/details/new" sxy-text="SALAXY.UI_Terms.createNew"></a>
    </div>
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-orderby="status"><span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span></span><br />
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.CalcListComponent.payment" ></span></span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary"></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.CalcListComponent.payment" ></span></span>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <salaxy-odata-actions show-export="true"></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <a href="">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
              <br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
              <br /> {{row.endAt | date}}
            </a>
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}
              <br />
              {{ row.payment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
            <br /> {{row.endAt | date}}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="hidden-xxs middle">
            <button ng-click="$crud.showDetails(row)" ng-if="row.status == 'draft'" class="btn btn-sm btn-primary btn-block" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-click="$crud.showDetails(row)" ng-if="row.status != 'draft'" class="btn btn-sm btn-default btn-block" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i></a>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show" ng-if="!row.data.payrollId"></span>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.CalcListComponent.calculation" ng-if="row.data.payrollId"></span>
            </button>
          </td>
          <td class="hidden-xxs middle">
            <button ng-if="row.status == 'draft'" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
              <i class="bi bi-trash-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
            </button>
            <button ng-if="!row.data.payrollId && (row.status == 'paymentSucceeded' || row.status == 'paymentStarted')" ng-click="$crud.showCopyAsNew(row)" class="btn btn-sm btn-default btn-block" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}">
              <i class="bi bi-copy d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
            </button>
            <a ng-if="row.data.payrollId" class="btn btn-sm btn-primary btn-block" ng-href="#/payroll/details/{{ row.data.payrollId }}">
              <i class="bi bi-list-task d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.CalcListComponent.payroll"></span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsDrafts.html",`<div ng-class="$ctrl.getCssClass()">


  <div class="visible-xxs">
    <div class="table-header-container-mobile" ng-show="!$ctrl.readOnly">
      <a class="btn btn-sm btn-block btn-primary" href="#/calc/details/new" sxy-text="SALAXY.UI_Terms.createNew"></a>
    </div>
    <div class="table-filter-container-mobile">
      <salaxy-input name="search1x{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-if-role="!worker">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
          </th>
          <th sxy-if-role="worker">
            <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.CalcListComponent.date"></span>
          </th>
          <th class="hidden-xxs" sxy-if-role="!worker">
            <span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span><br />
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.CalcListComponent.date"></span></span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary" ></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.CalcListComponent.payment" ></span></span>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <salaxy-odata-actions show-export="true"></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle" sxy-if-role="!worker">
            <a href="" ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle" sxy-if-role="!worker">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
              <br />{{ row.endAt | date }}
            </a>
          </td>
          <td class="td-name visible-xxs middle" sxy-if-role="worker" ng-click="$crud.showDetails(row)">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.endAt | date }}
            </a>
          </td>
          <td class="right visible-xxs bottom" ng-click="$crud.showDetails(row)">

            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}<br />
              {{ row.payment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle" sxy-if-role="!worker">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle" sxy-if-role="!worker">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}<br /> {{ row.endAt | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="hidden-xxs middle" colspan="{{$ctrl.readOnly ? 2 : 1}}">

            <button ng-if="!row.isReadOnly && !$ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i><span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="!row.isReadOnly && $ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i><span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
          </td>
          <td class="hidden-xxs middle" ng-if="!$ctrl.readOnly">
            <button ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block"><i
                class="bi bi-trash-fill d-inline-block d-sm-none"></i><span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsEmployer.html",`<div ng-class="$ctrl.getCssClass()">


  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>

          <th>
            <span sxy-orderby="status">
              <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.status"></span>
            </span>
            <br />
            <span sxy-orderby="endAt">
              <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.date"></span>
            </span>
          </th>
          <th class="right">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.salary"></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.payment"></span></span>
          </th>
          <th class="right">


          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">

          <td>
            <div ng-switch="row.status">
              <span ng-switch-when="paymentWorkerCopy" class="text-success">
                Maksettu
              </span>
              <span ng-switch-when="workerRequested">
                Lähetetty
              </span>
              <span ng-switch-when="workerRequestAccepted">
                Hyväksytty
              </span>
              <span ng-switch-when="workerRequestDeclined" class="text-warning">
                Hylätty
              </span>

            </div>
            <!--TODO add better status descriptons-->
            <!--br> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}-->
            {{ (row.salaryDate || row.endAt) | date}}
          </td>
          <td class="right">
            {{ row.grossSalary | currency }}
            <br /> {{ row.payment | currency }}
          </td>
          <td class="right middle">
            <button ng-click="$crud.showDetails(row)" class="btn btn-sm btn-default" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              
              <span class="d-sm-inline-block d-none" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>

            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default">
              <i class="bi bi-file-earmark-pdf d-inline-block d-sm-none"></i>
              <span class="d-sm-inline-block d-none" sxy-text="SALAXY.UI_Terms.printable"></span>
            </a>
          </td>

        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsEmployerAll.html",`<div ng-class="$ctrl.getCssClass()">


  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <span sxy-text="SALAXY.NG1_Other.Roles.employer"></span>
          </th>
          <th>
            <span sxy-orderby="status">
              <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.status"></span>
            </span>
            <br />
            <span sxy-orderby="endAt">
              <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.date"></span>
            </span>
          </th>
          <th class="right">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.salary"></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.payment"></span></span>
          </th>
          <th class="right">


          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar  middle">
            <div ng-if="row.status != 'draft'">

              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </div>
            <div ng-if="row.status == 'draft'">
              <i class="bi bi-question-circle-fill" style="font-size: 45px;color: #d0d0d0;"></i>
            </div>
          </td>
          <td class="td-name  middle">
            <div ng-if="row.status == 'draft'">
              <span class="small" sxy-html="Luonnoslaskelma<br>Ei työnantajaa"></span>
            </div>
            <div ng-if="row.status != 'draft'">

              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br>
              <small>{{row.otherPartyInfo.email}}</small>
            </div>
          </td>
          <td>
            <div ng-switch="row.status">
              <span ng-switch-when="draft">
                Luonnos
              </span>
              <span ng-switch-when="paymentWorkerCopy" class="text-success">
                Maksettu
              </span>
              <span ng-switch-when="workerRequested">
                Lähetetty
              </span>
              <span ng-switch-when="workerRequestAccepted" class="text-warning">
                Hyväksytty
              </span>
              <span ng-switch-when="workerRequestDeclined" class="text-danger">
                Hylätty
              </span>

            </div>
            <!--TODO add better status descriptons-->
            <!--br> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}-->
            {{ (row.salaryDate || row.endAt) | date}}
          </td>
          <td class="right">
            {{ row.grossSalary | currency }}
            <br /> {{ row.payment | currency }}
          </td>
          <td class="right middle">
            <button ng-click="$crud.showDetails(row)" class="btn btn-sm btn-default" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              
              <span class="d-sm-inline-block d-none" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>

            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default">
              <i class="bi bi-file-earmark-pdf d-inline-block d-sm-none"></i>
              <span class="d-sm-inline-block d-none" sxy-text="SALAXY.UI_Terms.printable"></span>
            </a>
          </td>

        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsPaid.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-header-container-mobile" ng-show="!$ctrl.readOnly">
      <a class="btn btn-sm btn-block btn-primary" href="#/calc/details/new" sxy-text="SALAXY.UI_Terms.createNew"></a>
    </div>
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-orderby="status"><span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span></span><br />
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.CalcListComponent.payment"></span></span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary"></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.CalcListComponent.payment"></span></span>
          </th>
          <th class="right hidden-xxs" colspan="3">
            <salaxy-odata-actions show-export="true"></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
              <br /> {{ row.endAt | date }}
            </a>
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}<br />
              {{ row.payment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}<br /> {{ row.endAt | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="hidden-xxs middle" colspan="{{$ctrl.readOnly ? 2 : 1 }}">
            <a href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </a>
          </td>
          <td class="hidden-xxs middle" ng-if="!$ctrl.readOnly">
            <button ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-copy d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
            </button>
          </td>
          <td class="hidden-xxs middle">
            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-file-earmark-pdf d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.printable"></span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsPaidIr.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-orderby="salaryDate"><span sxy-text="SALAXY.NG1.PayrollListComponent.salaryDate"></span></span><br />
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary"></span></span><br />
          </th>
          <th class="hidden-xxs">
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.PayrollListComponent.paymentDate"></span></span><br />
          </th>
          <th class="hidden-xxs" colspan="2">
            <span sxy-text="Ilmoitus"></span>
          </th>
          <th class="right hidden-xxs" colspan="4">
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
              <br /> {{ row.salaryDate | date }}
            </a>
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}
              <br /> {{ row.endAt | date }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ row.salaryDate | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}
          </td>
          <td class="hidden-xxs middle">
            {{ row.endAt | date }}
          </td>
          <td class="hidden-xxs middle">
            <div ng-repeat="message in row.messages" ng-bind-html="message | sxyWorkflowMessage: 'SystemMessageReportInvalid,SystemMessageReportScheduled,SystemMessageReportDelivered,SystemMessageReportCanceled,SystemMessageReportError'"></div>
          </td>
          <td class="hidden-xxs middle">
            <span ng-if="row.status == 'paymentSucceeded' && row.data.repairedAt"><i class="bi bi-bandaid"></i></span>
          </td>
          <td class="hidden-xxs middle" ng-show="row.status == 'paymentSucceeded'">
            <a href="" ng-click="$crud.showEpr(row)" title="{{ 'SALAXY.NG1.CalcReportsComponent.irFull' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-lg visible-xs me-1"></i><span class="hidden-xs" sxy-text="Ilmoitus"></span>
            </a>
          </td>
          <td class="hidden-xxs middle" colspan="{{$ctrl.readOnly ? 2 : 1 }}">
            <a href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-lg visible-xs me-1"></i><span class="hidden-xs" sxy-text="SALAXY.UI_Terms.show"></span>
            </a>
          </td>
          <td class="hidden-xxs middle" ng-if="!$ctrl.readOnly">
            <button ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-copy visible-xs me-1"></i><span class="hidden-xs" sxy-text="SALAXY.UI_Terms.copy"></span>
            </button>
          </td>
          <td class="hidden-xxs middle">
            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-file-earmark-pdf visible-xs me-1"></i><span class="hidden-xs" sxy-text="SALAXY.UI_Terms.printable"></span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>
`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsPanel.html",`<div class="salaxy-odata-card card list-card calc-list-card  card-sm card-secondary" ng-init="hideFilter = false">
  

  <div class="card-header">
    {{'SALAXY.NG1.CalcListComponent.panel.' + $ctrl.data.category + '.heading' | sxyTranslate}}
    <div class="float-end" ng-show="$ctrl.data.category != 'sentAndDraft'">
      <button class="btn btn-secondary btn-xs" ng-click="hideFilter = !hideFilter" title="{{'SALAXY.NG1.CalculationsPanelComponent.showFilters' | sxyTranslate}}">
        <i class="bi bi-funnel-fill"></i>
      </button>
    </div>
    <div class="float-end" ng-if="$ctrl.data.category == 'sentAndDraft'">
      <salaxy-action-button action="'newCalc'" button-class="btn-primary btn-labeled-right btn-xs" label="{{'SALAXY.NG1.CalculationsPanelComponent.newCalc' | sxyTranslate}}"></salaxy-action-button>
    </div>
  </div>

  <div class="card-body filters text-end" ng-class="{showfilters: hideFilter}" ng-if="$ctrl.data.category != 'sentAndDraft'">
    <div class="">
      <div class="filter-buttons">
        <button class="btn btn-xs btn-secondary text-end" sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.UI_Terms.abc"></button>
        <button class="btn btn-xs btn-secondary text-end" sxy-orderby="endAt">
          <i class="bi bi-calendar3"></i>
        </button>
        <button ng-if="$ctrl.data.category == 'paid' || $ctrl.data.category == 'sent'" class="btn btn-xs btn-secondary text-end" sxy-orderby="status" sxy-text="SALAXY.NG1.CalculationsPanelComponent.status"></button>
        <button class="btn btn-xs btn-secondary text-end" sxy-orderby="grossSalary">
          €
        </button>
      </div>
      <salaxy-input name="search1cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search d-none d-sm-inline-block" label-type="plain">
      </salaxy-input>
    </div>

  </div>

  <div ng-class="$ctrl.getCssClass()" ng-if="$ctrl.data.category != 'shared' && $ctrl.data.category != 'sentAndDraft' ">
    <div class="d-block d-sm-none">
      <div class="table-filter-container-mobile">
        <salaxy-input name="search2cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
        </salaxy-input>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">
            <td class="td-avatar middle hidden-xxs">
              <salaxy-avatar ng-if="$ctrl.data.category != 'sent'" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
              <salaxy-avatar ng-if="$ctrl.data.category == 'sent'" avatar="row.ownerInfo.avatar"></salaxy-avatar>
            </td>
            <td class="middle">
              <strong ng-if="$ctrl.data.category != 'sent'">{{row.otherPartyInfo.avatar.displayName}}</strong>
              <strong ng-if="$ctrl.data.category == 'sent'">{{row.ownerInfo.avatar.displayName}}</strong>
              <br /> {{ row.endAt | date }}
            </td>
            <td class="middle right">
              {{ row.grossSalary | currency }}
              <br />
              <span ng-if="row.status != 'workerRequestAccepted' && row.status != 'workerRequestDeclined' && row.status != 'workerRequested' && row.status != 'paymentWorkerCopy'" class="row-status" ng-class="{'text-warning' : row.status == 'paymentStarted', 'text-success' : row.status == 'paymentSucceeded'}">{{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}</span>
              <span ng-if="row.status == 'workerRequestAccepted' " class="row-status text-success" sxy-text="SALAXY.NG1.CalculationsPanelComponent.accepted"></span>
              <span ng-if="row.status == 'workerRequestDeclined' " class="row-status text-danger" sxy-text="SALAXY.NG1.CalculationsPanelComponent.declined"></span>
            </td>
            <td class="right middle">
              <button ng-if="$ctrl.data.category == 'draft'" ng-click="$crud.showDetails(row)" title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm" ng-class="$ctrl.readOnly ? 'btn-secondary' : 'btn-primary'">
                <i class="bi" ng-class="$ctrl.readOnly ? 'bi-file-text' : 'bi-pencil-fill'"></i>
              </button>
              <button ng-if="$ctrl.data.category == 'paid' || $ctrl.data.category == 'sent' || $ctrl.data.category == 'received'" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary">
                <i class="bi bi-file-text"></i>
              </button>
              <button ng-if="$ctrl.data.category == 'paid' && !$ctrl.readOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-secondary">
                <i class="bi bi-copy"></i>
              </button>
              <a ng-if="$ctrl.data.category == 'paid' || $ctrl.data.category == 'sent' || $ctrl.data.category == 'received'" ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-secondary">
                <i class="bi bi-file-earmark-pdf"></i>
              </a>
            </td>

          </tr>
        </tbody>

      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>
  </div>
  <!-- IF category is Shared -->
  <div ng-class="$ctrl.getCssClass()" ng-if="$ctrl.data.category == 'shared' ">
    <div class="d-block d-sm-none">
      <div class="table-filter-container-mobile">
        <salaxy-input name="search2cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
        </salaxy-input>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">
            <td class="td-avatar middle hidden-xxs">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="middle">
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
              <br /> {{ row.endAt | date }}
            </td>
            <td class="middle">
              <span class="text-success" ng-if="row.status == 'sharedApproved'" sxy-text="SALAXY.NG1.CalculationsPanelComponent.accepted"></span>
              <span class="text-warning" ng-if="row.status == 'sharedWaiting'" sxy-text="SALAXY.NG1.CalculationsPanelComponent.waiting" ps="..."></span>


            </td>
            <td class="middle right">
              {{ row.grossSalary | currency }}
              <br /> {{ row.payment | currency }}

            </td>
            <td class="right middle">
              <button ng-if="!$ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary">
                <i class="bi bi-pencil-fill"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>
  </div>
  <!-- IF category is Sent or Draft-->
  <div ng-class="$ctrl.getCssClass()" ng-if="$ctrl.data.category == 'sentAndDraft'">


    <div class="table-responsive">
      <table class="table">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">
            <td class="td-avatar middle hidden-xxs">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="middle">
              <strong>{{row.otherPartyInfo.avatar ? row.otherPartyInfo.avatar.displayName : 'SALAXY.UI_Terms.notChosen' | sxyTranslate}}</strong>
              <br /> {{ row.endAt | date }}
            </td>
            <td class="middle">
              <span class="text-warning" ng-if="row.status == 'workerRequested'" sxy-text="SALAXY.NG1.CalculationsPanelComponent.sent"></span>

              <span ng-if="row.status == 'draft'" sxy-text="SALAXY.NG1.CalculationsPanelComponent.draft"></span>

            </td>
            <td class="middle right">
              {{ row.grossSalary | currency }}
              <br /> {{ row.payment | currency }}

            </td>
            <td class="right middle">
              <button ng-if="!$ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary">
                <i class="bi bi-pencil-fill"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>
  </div>



  <!--TODO add binding showAllUrl -->

  <div class="card-footer text-center">
    <a ng-if="$ctrl.data.category != 'received' && $ctrl.data.category != 'sent' && $ctrl.data.category != 'sentAndDraft'" class="btn btn-primary btn-sm" href="#/calc/{{$ctrl.data.category}}" sxy-text="SALAXY.NG1.CalculationsPanelComponent.showWholeList"></a>

    <a ng-if="$ctrl.data.category == 'sent'" class="btn btn-primary btn-sm" href="#/calc/sent" sxy-text="SALAXY.NG1.CalculationsPanelComponent.sentAlt"></a>
    <a ng-if="$ctrl.data.category == 'sent'" class="btn btn-primary btn-sm" href="#/calc/draft" sxy-text="SALAXY.NG1.CalculationsPanelComponent.drafts"></a>
    <a ng-if="$ctrl.data.category == 'received'" class="btn btn-secondary btn-sm" href="#/calc/paid" sxy-text="SALAXY.NG1.CalculationsPanelComponent.allPaid"></a>
    <span class="" ng-if="$ctrl.data.category == 'sentAndDraft'">
      <a class="btn btn-secondary btn-sm" href="#/calc/sent" sxy-text="SALAXY.NG1.CalculationsPanelComponent.allSent"></a>
      <a class="btn btn-secondary btn-sm" href="#/calc/draft" sxy-text="SALAXY.NG1.CalculationsPanelComponent.allDrafts"></a>
    </span>
  </div>

</div>`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsPaymentStartedPanel.html",`<div class="salaxy-odata-card card list-card with-footer calc-list-card card-sm card-secondary">
  <div class="card-header">
    {{'SALAXY.NG1.CalcListComponent.panel.paymentStarted.heading' | sxyTranslate}}
  </div>

  <div ng-class="$ctrl.getCssClass()">
    <div class="table-responsive">
      <table class="table table-striped">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">
            <td class="td-avatar  middle">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="td-name middle">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
              {{ row.salaryDate | date }}
            </td>
            <td class="right">
              {{ row.grossSalary | currency }}<br />
              <span class="text-warning">{{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}</span>              
            </td>
            <td class="middle right">
              <a href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i class="bi bi-info-circle "></i></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer text-center bg-secondary">
      <salaxy-odata-footer></salaxy-odata-footer>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsReceived.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-header-container-mobile" ng-show="!$ctrl.readOnly">
      <a class="btn btn-sm btn-block btn-primary" href="#/calc/details/new" sxy-text="SALAXY.UI_Terms.createNew"></a>
    </div>
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive light-bg">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1_Other.Roles.employer"></span>
          </th>
          <th class="hidden-xxs right">
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.CalcListComponent.date"></span></span>
          </th>
          <th class="right">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary"></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.CalcListComponent.payment"></span></span>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <salaxy-odata-actions show-export="true"></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
              <br /> {{ row.endAt | date }}
            </a>
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}<br />
              {{ row.data.workerPayment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
            <a href="mailto:{{row.otherPartyInfo.email}}">{{row.otherPartyInfo.email}}</a><br /> Puh: {{row.otherPartyInfo.telephone || "-"}}<br />
          </td>
          <td class="hidden-xxs middle right">
            {{ row.endAt | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.data.workerPayment | currency }}
          </td>
          <td class="hidden-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </a>
          </td>
          <td class="hidden-xxs middle">
            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-file-earmark-pdf"></i>
              <span class="d-none d-sm-inline-block" pre=" " sxy-text="SALAXY.UI_Terms.printable"></span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsRepairs.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search1x{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
          </th>
          <th class="hidden-xxs" sxy-if-role="!worker">
            <span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span><br />
            <span sxy-orderby="salaryDate"><span sxy-text="SALAXY.NG1.CalculationsWithSalaryDateSelectComponent.salaryDate"></span></span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary" ></span></span><br />
          </th>
          <th class="right hidden-xxs" colspan="2">
            <salaxy-odata-actions></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
              <br />{{ row.salaryDate | date }}
            </a>
          </td>
          <td class="right visible-xxs bottom" ng-click="$crud.showDetails(row)">

            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}<br /> {{ row.salaryDate | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}
          </td>
          <td class="hidden-xxs middle" colspan="{{$ctrl.readOnly ? 2 : 1}}">
            <button ng-if="!row.isReadOnly && !$ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <span class="hidden-xs" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="!row.isReadOnly && $ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <span class="hidden-xs" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
          </td>
          <td class="hidden-xxs middle" ng-if="!$ctrl.readOnly">
            <button ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
              <span class="hidden-xs" sxy-text="SALAXY.UI_Terms.delete"></span></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsSent.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-header-container-mobile">
      <a class="btn btn-sm btn-block btn-primary" href="#/calc/details/new" sxy-text="SALAXY.UI_Terms.createNew"></a>
    </div>
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive light-bg">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1_Other.Roles.employer"></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-orderby="status"><span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span></span><br />
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.CalcListComponent.payment" ></span></span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary" ></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.CalcListComponent.payment" ></span></span>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">

            <a ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle">
            <a ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="(Ei työnantajaa)"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
              <br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
              <br /> {{row.endAt | date}}
            </a>
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}
              <br />
              {{ row.payment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">

            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalculationsSentComponent.noEmployee"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            <span ng-if="row.status == 'workerRequested'" class="text-warning" sxy-text="SALAXY.NG1.CalculationsSentComponent.waitingForAcception" ps="..."></span>
            <span ng-if="row.status == 'workerRequestDeclined'" class="text-danger" sxy-text="SALAXY.NG1.CalculationsSentComponent.declined"></span>
            <span ng-if="row.status == 'workerRequestAccepted'" class="text-success" sxy-text="SALAXY.NG1.CalculationsSentComponent.accepted"></span>
            <br /> {{row.endAt | date}}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="hidden-xxs middle">
            <button ng-click="$crud.showDetails(row)" ng-if="row.status == 'draft'" class="btn btn-sm btn-primary btn-block" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-click="$crud.showDetails(row)" ng-if="row.status != 'draft'" class="btn btn-sm btn-default btn-block" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i></a>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show" ng-if="!row.data.payrollId"></span>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.CalcListComponent.calculation" ng-if="row.data.payrollId"></span>
            </button>
          </td>
          <td class="hidden-xxs middle">
            <button ng-if="row.status == 'draft'" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
              <i class="bi bi-trash-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span></button>
            <button ng-if="!row.data.payrollId && (row.status == 'paymentSucceeded' || row.status == 'paymentStarted')" ng-click="$crud.showCopyAsNew(row)" class="btn btn-sm btn-default btn-block" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}">
              <i class="bi bi-copy d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
            </button>
            <a ng-if="row.data.payrollId" class="btn btn-sm btn-primary btn-block" ng-href="#/payroll/details/{{ row.data.payrollId }}">
              <i class="bi bi-list-task d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.CalcListComponent.payroll"></span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsShared.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">

    <div class="table-filter-container-mobile">
      <salaxy-input name="search1x{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span><br />
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.CalcListComponent.date"></span></span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary" ></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.CalcListComponent.payment" ></span></span>
          </th>
          <th class="right hidden-xxs">
            <salaxy-odata-actions show-export="true"></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />

              <span ng-switch="row.status">
               
              <span ng-switch-when="sharedApproved" class="status text-success small" sxy-text="SALAXY.NG1.CalculationsSharedComponent.accepted"></span>
              <span ng-switch-when="sharedWaiting" class="status text-warning small" sxy-text="SALAXY.NG1.CalculationsSharedComponent.waitingForHandling"></span>
              <span ng-switch-when="sharedRejected" class="status text-danger small" sxy-text="SALAXY.NG1.CalculationsSharedComponent.declined"></span>
              <br />{{ row.endAt | date }}
            </a>
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}<br />
              {{ row.payment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            <span ng-switch="row.status">
              <span ng-switch-when="sharedWaiting" class="status text-warning small" sxy-text="SALAXY.NG1.CalculationsSharedComponent.waitingForHandling"></span>
            <span ng-switch-when="sharedApproved" class="status text-success small" sxy-text="SALAXY.NG1.CalculationsSharedComponent.accepted"></span>
            
            <span ng-switch-when="sharedRejected" class="status text-danger small" sxy-text="SALAXY.NG1.CalculationsSharedComponent.declined"></span>
            <br /> {{ row.endAt | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="middle right">
            <button ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-secondary">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i><span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
          </td>
          <!-- <td class="hidden-xxs middle">
            <button ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block"><i
                class="bi bi-trash-fill d-inline-block d-sm-none"></i><span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span></button>
          </td>-->
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsWithSalaryDate-select.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
            <span class="label label-primary clickable" ng-if="$ctrl.selectedItems.length" ng-click="$ctrl.selectedItems.splice(0,$ctrl.selectedItems.length)"> {{'SALAXY.UI_Terms.chosen' | sxyTranslate}}: {{ $ctrl.selectedItems.length }} <i class="bi bi-x-circle"></i></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span><br />
            <span sxy-orderby="salaryDate"><span sxy-text="SALAXY.NG1.CalculationsWithSalaryDateSelectComponent.salaryDate"></span></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-text="SALAXY.NG1.CalculationsWithSalaryDateSelectComponent.start"></span><br />
            <span sxy-text="SALAXY.NG1.CalculationsWithSalaryDateSelectComponent.end"></span>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name visible-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
            <br /> {{ row.salaryDate | date }}
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}<br />
              {{ row.payment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ row.status ? ("SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate) : "#ERR" }}<br /> {{ row.salaryDate | date }}
          </td>
          <td class="hidden-xxs middle">
            {{ row.data.workStartDate | date}}<br /> {{ row.data.workEndDate | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/CalculationsWorker.html",`<div ng-class="$ctrl.getCssClass()">

  <div class="visible-xxs">
    <div class="table-header-container-mobile" ng-show="!$ctrl.readOnly">
      <a class="btn btn-sm btn-block btn-primary" href="#/calc/details/new" sxy-text="SALAXY.UI_Terms.createNew"></a>
    </div>
    <div class="table-filter-container-mobile">
      <salaxy-input name="searchMobile{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div id="calculations-worker-table" class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>
            <span sxy-orderby="status">
              <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.status"></span>
            </span>
            <br />
            <span sxy-orderby="endAt">
              <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.date"></span>
            </span>
          </th>
          <th></th>
          <th class="right">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.salary"></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.payment"></span></span>
          </th>
          <th class="right" colspan="{{$ctrl.readOnly ? 2 : 3}}">
            <salaxy-odata-actions show-export="true"></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td>
            {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
            <br /> {{ (row.salaryDate || row.endAt) | date}}
          </td>
          <td>
            <div ng-if="$ctrl.logic.isNotCurrentEmployment(row)">
              Ei tämä työsuhde!<br />
              <a ng-href="#/employments/details/{{ row.data.employmentId }}" class="btn btn-xs btn-default">Näytä työsuhde...</a>
            </div>
          </td>
          <td class="right">
            {{ row.grossSalary | currency }}
            <br /> {{ row.payment | currency }}
          </td>
          <td class="middle">
            <button ng-click="$crud.showDetails(row)" ng-if="row.status == 'draft'" class="btn btn-sm btn-block" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" ng-class="$ctrl.readOnly ? 'btn-default' : 'btn-primary'">
              <i class="bi d-inline-block d-sm-none" ng-class="$ctrl.readOnly ? 'bi-info-lg' : 'bi-pencil-fill'"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit" ng-if="!$ctrl.readOnly"></span>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show" ng-if="$ctrl.readOnly"></span>
            </button>
            <button ng-click="$crud.showDetails(row)" ng-if="row.status != 'draft'" class="btn btn-sm btn-default btn-block" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i></a>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show" ng-if="!row.data.payrollId"></span>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.calculation" ng-if="row.data.payrollId"></span>
            </button>
            
          </td>
          <td class="middle" ng-if="!$ctrl.readOnly">
            <button ng-if="row.status == 'draft' || row.status == 'history'" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
              <i class="bi bi-trash-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
            </button>
            <button ng-if="!row.data.payrollId && (row.status == 'paymentSucceeded' || row.status == 'paymentStarted') && ('employments.calcs.copyAsNew' | sxyShow: 'workers.details')" ng-click="$crud.showCopyAsNew(row)" class="btn btn-sm btn-default btn-block" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}">
              <i class="bi bi-copy d-inline-block d-sm-none"></i><span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
            </button>
            <a ng-if="row.data.payrollId" class="btn btn-sm btn-primary btn-block" ng-href="#/payroll/details/{{ row.data.payrollId }}">
              <i class="bi bi-list-task d-inline-block d-sm-none text-white"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.payroll"></span>
            </a>
          </td>
          <td class="middle">
            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-file-earmark-pdf d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.printable"></span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/calendar/Events.html",`<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.ODataCalendarEventComponent.description"></th>
        <th sxy-text="SALAXY.NG1.ODataCalendarEventComponent.categories"></th>
        <th sxy-orderby="logicalDate" sxy-text="SALAXY.NG1.ODataCalendarEventComponent.period"></th>
        <th sxy-text="SALAXY.NG1.ODataCalendarEventComponent.duration"></th>
        <th>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td>{{ row.shortText }}</td>
        <td><small ng-repeat="cat in row.flags">{{ cat + ($last ? "" : ", ") }}</small></td>
        <td>{{ row.data | sxyDateRange }}</td>
        <td>{{ row.data.duration | sxyDuration }}</td>
        <td>
            <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/CustomerInvoices.html",`<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th sxy-orderby="id" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.id"></th>
        <th sxy-orderby="createdAt"  sxy-text="SALAXY.UI_Terms.created"></th>
        <th sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></th>
        <th sxy-orderby="owner" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.owner"></th>
        <th sxy-orderby="isReadOnly" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.readOnly"></th>
        <th sxy-orderby="partner" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.partner"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td>{{ row.id }}</td>
        <td>{{ row.createdAt | sxyDate }}</td>
        <td>{{ row.updatedAt | sxyDate }}</td>
        <td>{{ row.owner }}</td>
        <td>{{ row.isReadOnly }}</td>
        <td>{{ row.partner }}</td>
        <td class="middle hidden-xxs">
          <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
          </button>
        </td>
        <td class="middle hidden-xxs">
          <button ng-if="!row.isReadOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
            <i class="bi bi-trash-fill d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-copy d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/Datasets.html",`<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th sxy-orderby="shortText" sxy-text="Teksti"></th>
        <th class="right">
          <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
          <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
        </th>
        <th sxy-orderby="isReadOnly" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.readOnly"></th>
        <th class="right hidden-xxs" colspan="2">
          <div class="table-filter-container">
            <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td>{{ row.shortText }}</td>
        <td class="right">
          <div>{{ row.createdAt | sxyDate }}</div>
          <div>{{ row.updatedAt | sxyDate }}</div>
        </td>
        <td>{{ row.isReadOnly }}</td>
        <td class="middle hidden-xxs">
          <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
          </button>
        </td>
        <td class="middle hidden-xxs">
          <button ng-if="!row.isReadOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block"><i
              class="bi bi-trash-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-copy d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/EarningsPayments.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" class="hidden-xxs">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
          </th>
          <th class="visible-xxs">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
          </th>
          <th>
            <span sxy-orderby="status" class="clickable"><span sxy-text="Tila"></span></span>
          </th>
          <th class="right">
            <span sxy-orderby="payment" class="clickable"><span sxy-text="Maksu"></span></span>

          </th>
          <th class="right">
            <span sxy-orderby="startAt" class="clickable"><span sxy-text="Kausi"></span></span>
          </th>
          <th class="right">
            <div class="table-filter-container">
              <salaxy-input name="searchx{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="sort-by-text" label-type="plain">
              </salaxy-input>
            </div>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle hidden-xxs">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''">{{ 'SALAXY.NG1.CalcListComponent.notSelected' | sxyTranslate }}</span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
          </td>
          <td class="middle td-status">
            <span ng-if="row.status == 'new'" class="text-warning small status">
                Käsitelyssä
            </span>
            <span ng-if="row.status == 'succeeded'" class="text-success small status">
                Hyväksytty
            </span>
            <span ng-if="row.status == 'cancelled'" class="text-danger small status">
                Hylätty
            </span>
          </td>
          <td class="middle right">
            {{row.payment | currency}}<br>
            <span class="small">{{ row.endAt | date }}</span>
          </td>
          <td class="right">{{row.startAt | date}} - <br>{{row.endAt | date}}</td>
          <td class="middle right">
            <a ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i
              class="bi bi-info-circle visible-xxs"></i><span class="hidden-xxs">Näytä</span></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/EarningsPaymentsPanel.html",`<div class="card salaxy-odata-card list-card report-list-card  card-sm card-secondary">
  <div class="card-header">
    {{('Tulorekisteri-ilmoitukset' | sxyTranslate) }}
    <div class="float-end" ng-show="$ctrl.items.length > 0">
      <button class="btn btn-secondary btn-xs" ng-click="hideFilter = !hideFilter" title="Näytä suodattimet">
        <i class="bi bi-funnel-fill"></i>
      </button>
    </div>
  </div>
  <div class="card-body filters text-end" ng-class="{'showfilters' : hideFilter}">
    <div class="filter-buttons">
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.UI_Terms.abc"></button>
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="status"> Tila</button>
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="endAt">
        <i class="bi bi-calendar3"></i>
      </button>
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="payment">€</button>
    </div>
    <salaxy-input name="search1cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search hidden-xxs" label-type="plain">
    </salaxy-input>
  </div>
  <div ng-class="$ctrl.getCssClass()">
    <div class="visible-xxs" ng-if="$ctrl.items.length > 0">
      <div class="table-filter-container-mobile">
        <salaxy-input name="search2cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
        </salaxy-input>
      </div>
    </div>
    <div class="card-body text-center card-content lg-height align-middle" ng-show="$ctrl.items.length == 0 && !$ctrl.isLoading">
      <div>
        <h3>Ei Tulorekisteri-ilmoituksia</h3>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table" ng-if="$ctrl.items.length > 0">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">
            <td class="d-none"><pre class="small">{{row | json}}</pre></td>
            <td class="td-avatar middle hidden-xxs">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="td-name middle">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''">{{ 'SALAXY.NG1.CalcListComponent.notSelected' | sxyTranslate }}</span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
            </td>
            <td class="middle td-status">
              <span ng-if="row.status == 'new'" class="text-warning small status">
                Käsitelyssä
              </span>
              <span ng-if="row.status == 'succeeded'" class="text-success small status">
                Hyväksytty
              </span>
              <span ng-if="row.status == 'cancelled'" class="text-danger small status">
                Hylätty
              </span>
            </td>
            <td class="middle right">
              {{row.payment | currency}}<br>
              <span class="small">{{ row.endAt | date }}</span>
            </td>

            <td class="middle right">
              <a ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i
              class="bi bi-info-circle"></i></a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>
  </div>
  <div class="card-footer text-center">
    <a ng-href="#{{$crud.getDefaults().listUrl}}" class="btn btn-primary btn-sm">Näytä kaikki</a> {{$crud.listUrl}}
  </div>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/Employments-select.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="btn-toolbar" role="toolbar">
    <div class="btn-group btn-group-sm dropdown">
      <button id="single-button2" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
       {{'SALAXY.NG1.WorkerListComponent.employments' | sxyTranslate}}:
       {{ ($ctrl.url == '/v03/api/employments' ? 'SALAXY.NG1.WorkerListComponent.all' : 'SALAXY.NG1.WorkerListComponent.active') | sxyTranslate }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button2">
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setUrl('/v03/api/employments')" class="dropdown-item" sxy-text="SALAXY.NG1.WorkerListComponent.all"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setUrl('/v03/api/employments?activeDate=today')" class="dropdown-item" sxy-text="SALAXY.NG1.WorkerListComponent.active"></a>
        </li>
      </ul>
    </div>
    <button ng-if="$ctrl.selectMode === 'multiselect'" ng-click="$ctrl.selectAll()" class="btn btn-default btn-sm" sxy-text="SALAXY.NG1.WorkerListComponent.selectAll"></button>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr class="">
          <th class="d-sm-none">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
            <span class="label label-primary clickable" ng-if="$ctrl.selectedItems.length" ng-click="$ctrl.selectedItems.splice(0,$ctrl.selectedItems.length)"> {{'SALAXY.UI_Terms.chosen' | sxyTranslate}}: {{ $ctrl.selectedItems.length }} <i class="bi bi-x-circle"></i></span>
          </th>
          <th colspan="2" class="d-none d-sm-table-cell">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
            <span class="label label-primary clickable" ng-if="$ctrl.selectedItems.length" ng-click="$ctrl.selectedItems.splice(0,$ctrl.selectedItems.length)"> {{'SALAXY.UI_Terms.chosen' | sxyTranslate}}: {{ $ctrl.selectedItems.length }} <i class="bi bi-x-circle"></i></span>
          </th>
          <th class="right hidden-xxs">
            <span sxy-text="SALAXY.NG1.WorkerListComponent.employment"></span><br/>
            <span sxy-orderby="updatedAt" class="clickable" sxy-text="SALAXY.UI_Terms.updated"></span>
          </th>
          <th class="right">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="sort-by-text" label-type="plain">
              </salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle d-none d-sm-table-cell">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name middle">
            <div>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
            </div>
            <div class="sm-description">
              {{$crud.getEmploymentDescription(row)}}
            </div>
          </td>
          <td class="middle right hidden-xxs">
            <div ng-class="{'text-danger': !row.data.isActive }">{{ row.data | sxyDateRange }}</div>
            <div>{{ row.updatedAt | date}}</div>
          </td>
          <td class="middle right">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ("SALAXY.UI_Terms.unselect" | sxyTranslate) : ("SALAXY.UI_Terms.select" | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/Employments.html",`<div ng-class="$ctrl.getCssClass()">
  <div ng-if="$ctrl.logic.showToolbar" class="btn-toolbar" role="toolbar">
    <salaxy-action-button label="SALAXY.NG1_Pages.Workers.newWorker" action="'newWorker'" button-class="btn-sm btn-primary" ng-if="!$ctrl.readOnly && ('!assureWorkerAccount' | sxyIsInRole)"></salaxy-action-button>
    <div class="btn-group btn-group-sm dropdown">
      <button id="single-button2" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
       {{'SALAXY.NG1.WorkerListComponent.employments' | sxyTranslate}}:
       {{ ($ctrl.url == '/v03/api/employments' ? 'SALAXY.NG1.WorkerListComponent.all' : 'SALAXY.NG1.WorkerListComponent.active') | sxyTranslate }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button2">
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setUrl('/v03/api/employments')" class="dropdown-item" sxy-text="SALAXY.NG1.WorkerListComponent.all"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setUrl('/v03/api/employments?activeDate=today')" class="dropdown-item" sxy-text="SALAXY.NG1.WorkerListComponent.active"></a>
        </li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm ms-1" ng-controller="ExportController as $export" ng-init="$export.api = $crud.getExportable()">
      <button ng-repeat="mapper in $export.listItemMappers" class="btn btn-default " ng-click="$export.quickExport('copyExcel', null, mapper)">{{mapper.title}} {{'SALAXY.NG1.ODataActionsComponent.toExcel' | sxyTranslate}}</button>
      <button class="btn btn-default" ng-click="$export.showExport()" sxy-text="SALAXY.NG1.ODataActionsComponent.export"></button>
    </div>
    <button class="btn btn-default btn-sm ms-1" ng-click="$crud.selectAutoTaxcardForEmployments($ctrl.items)" title="{{'SALAXY.NG1.WorkerListComponent.activeAutoTaxcard' | sxyTranslate}}" sxy-text="SALAXY.NG1.WorkerListComponent.autoTaxcard"></button>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr class="">
          <th colspan="2">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
          </th>
          <th class="hidden-xxs">
            <span><span sxy-text="SALAXY.NG1.WorkerListComponent.employment"></span></span><br />
            <span sxy-orderby="updatedAt" class="clickable"><span sxy-text="SALAXY.UI_Terms.updated"></span></span>
          </th>
          <th ng-if="'workers.employments.records.badge' | sxyShow: 'workers.index'" sxy-text="SALAXY.NG1.WorkerDetailsComponent.records.badge"></th>
          <th ng-if="'workers.employments.taxcard' | sxyShow: 'workers.index'" sxy-text="SALAXY.NG1.WorkerListComponent.taxcard"></th>
          <th class="right hidden-xxs">
            <div>
              <div>
                <div>
                  <span class="salaxy-form-group-plain">
                    <input type="text" ng-model="$ctrl.rawSearchStringOther"  ng-change="$ctrl.searchChanged('other')" class="form-control" autocomplete="off"
                      id="searchx111" name="searchx111" placeholder="{{'SALAXY.UI_Terms.textSearch' | sxyTranslate}}"
                      ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }" maxlength="1024">
                  </span>
                </div>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <a href="#/employments/details/{{row.id}}" class="cell-link" title="{{'SALAXY.NG1.WorkerListComponent.editWorker' | sxyTranslate}}">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name d-none d-sm-table-cell middle">
            <div>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
              <img ng-if="row.otherPartyInfo.avatar.owner == row.otherId" src="https://cdn.salaxy.com/img/elems/logo/square50x50logo.png"
                class="registered-user" style="width: 16px; position: relative; top: -6px;" title="{{'SALAXY.NG1.WorkerListComponent.registeredUser' | sxyTranslate}}">
            </div>
            <div class="sm-description">
              {{$crud.getEmploymentDescription(row)}}
            </div>
          </td>
          <td class="td-name d-table-cell d-sm-none  middle"> 
            <a href="#/employments/details/{{row.id}}" class="cell-link" title="{{'SALAXY.NG1.WorkerListComponent.editWorker' | sxyTranslate}}">
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
              <span class="sm-description" ng-if="row.otherPartyInfo.ibanNumber">{{$crud.getEmploymentDescription(row)}}</span>
              <span class="text-danger missing-info" ng-if="!row.otherPartyInfo.ibanNumber" sxy-text="SALAXY.NG1.WorkerListComponent.addIban"></span>
            </a>
          </td>
          <td class="hidden-xxs middle" colspan="{{$ctrl.readOnly ? 2 : ''}}" title="{{ $crud.getActiveText(row) }}">
          <div style="white-space: nowrap; overflow: hidden;text-overflow: ellipsis;" ng-class="{'text-danger': !row.data.isActive }">{{ row.data | sxyDateRange }}</div>
            <div>{{ row.updatedAt | date}}</div>
          </td>
          <td ng-if="'workers.employments.records.badge' | sxyShow: 'workers.index'" class="middle">
            <salaxy-workflow-badge model="row" api-ctrl="$crud"  wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
          </td>
          <td ng-if="'workers.employments.taxcard' | sxyShow: 'workers.index'" class="middle">
            <span>{{ $crud.getTaxcardBadge(row.data.taxcard) }}</span>
          </td>
          <td class="right middle hidden-xxs" style="white-space: nowrap;">
            <a ng-if="('workers.employments.buttons.newCalc' | sxyShow: 'workers.index') && !$ctrl.readOnly" href="#/calc/details/{{row.id}}/new-for-employment" class="btn btn-default btn-sm" sxy-text="SALAXY.UI_Terms.newCalculation"></a>
            <a href="#/employments/details/{{row.id}}?tab=calculations" class="btn btn-sm btn-default d-none d-sm-inline-block" title="{{'SALAXY.UI_Terms.calculations' | sxyTranslate}}">
              <i class="bi bi-list-task" aria-hidden="true"></i>
            </a>
            <a class="btn btn-sm btn-primary" href="#/employments/details/{{row.id}}" sxy-text="SALAXY.UI_Terms.edit"></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/Holidays.html",`<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
          <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
        </th>
        <th sxy-html="SALAXY.NG1.HolidaysComponent.holidayType.html"></th>
        <th sxy-orderby="endAt" class="right" sxy-text="SALAXY.NG1.HolidaysComponent.year"></th>
        <th class="right" sxy-html="SALAXY.NG1.HolidaysComponent.holidays.html"></th>
        <th>
          <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain"></salaxy-input>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td class="align-middle td-avatar">
          <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="td-workerSnapshot-name">
          <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong><br /> {{ "WageBasis." + row.data.wageBasis | sxyEnum }}<br />
          <span ng-if="!row.data.employmentId" class="label label-danger" sxy-text="SALAXY.NG1.HolidaysComponent.error"></span>
        </td>
        <td>
          {{ "HolidayCode." + row.data.code | sxyEnum }}
          <span ng-if="row.data.code == 'holidayCompensation'">({{ row.data.compensation | sxyCount : 'percent' }})</span>
          <div ng-if="row.data.bonusMethod != 'none'">
            {{ "HolidayBonusPaymentMethod." + row.data.bonusMethod | sxyEnum }}
            <span>({{ row.data.bonus | sxyCount : 'percent' }})</span>
          </div>
        </td>
        <td class="right">{{ row.data.year }}</td>
        <td class="right">
          {{ row.data.plannedDays | sxyCount : 'days' }}<br /> {{ row.data.accrualDays | sxyCount : 'days' }}
        </td>
        <td class="hidden-xxs middle">
          <button ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-inline-block d-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span></button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/HouseholdYears.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th sxy-orderby="logicalDate" class="right" sxy-text="SALAXY.NG1.HouseHoldYearsComponent.year"></th>
          <th sxy-orderby="status" sxy-text="SALAXY.NG1.HouseHoldYearsComponent.answer"></th>
          <th class="right" sxy-orderby="endAt" sxy-text="SALAXY.NG1.HouseHoldYearsComponent.latestSaving"></th>
          <th sxy-orderby="backOfficeStatus" sxy-text="SALAXY.NG1.HouseHoldYearsComponent.backOfficeStatus"></th>
          <th class="right">
            <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
            <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="right">
            {{ row.logicalDate | date:'yyyy' }}
          </td>
          <td>
            {{ 'HouseholdYearStatus.' + row.status | sxyEnum }}
          </td>
          <td class="right">
            {{ row.endAt | sxyDate }}
          </td>
          <td>
            {{ 'HouseholdYearProcessingStatus.' + row.backOfficeStatus | sxyEnum }}
          </td>
          <td class="right">
            <div>{{ row.createdAt | sxyDate }}</div>
            <div>{{ row.updatedAt | sxyDate }}</div>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" class="btn btn-sm btn-primary btn-block" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
            <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" class="btn btn-sm btn-primary btn-block" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/InvoicePaymentList.html",`<div ng-class="$ctrl.getCssClass()"> 
  <salaxy-alert type="warning" ng-if="$crud.paymentChannel === 'palkkausWS' && !$crud.isStronglyAuthorizedPayer()">
    <main>
      <div class="row">
        <div class="col-sm-8 col-lg-9">
          <p class="lead">Vahva tunnistautuminen tarvitaan</p>
          <p>Maksujen maksuun vienti vaatii vahvan tunnistautumisen. Lisäksi sinun tulee olla merkittynä maksajana yritykseesi.</p>
        </div>
        <div class="col-sm-4 col-lg-3">
          
          <button type="button" ng-click="$crud.openStrongAuthDialog()" class="btn btn-warning btn-add btn-add-taxcard btn-block">Käynnistä vahva tunnistautuminen</button>
        </div>
      </div>
    </main>
  </salaxy-alert>
  <div ng-controller="InvoiceToolsController as $invoiceTools">    
    <div class="btn-toolbar mb-3">
      <div class="btn-group dropdown">
        <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          {{ ('SALAXY.MODEL.InvoiceListItem.status.title' | sxyTranslate) }}: {{$crud.statusFilter.text}}
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="btnHide">
          <li role="menuitem" ng-repeat="statusFilter in $crud.statusFilters">
            <a class="dropdown-item" href="" ng-click="$crud.statusFilter = statusFilter">{{statusFilter.text}}</a>
          </li>
        </ul>
      </div>
      <div class="btn-group">
        <salaxy-datepicker-popup style="width: 150px;" name="year" label-type="plain" format="year" ng-model="$crud.queryYear"></salaxy-datepicker-popup>
      </div>
      <button type="button" ng-click="$crud.loadData()" class="btn btn-primary">Hae</button>
      <button type="button" ng-if="$crud.supportItemMultiSelect()" ng-disabled="$crud.selectedInvoices.length === 0" ng-click="$crud.paymentChannelConfig.multiSelectAction().onClick()" class="btn btn-primary">{{$crud.paymentChannelConfig.multiSelectAction().text}}</button>
      <div sxy-if-role="test" class="btn-group dropdown">
        <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          Maksukanava: {{$crud.paymentChannel}}
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="btnHide">
          <li role="menuitem">
            <a class="dropdown-item" href="" ng-click="$crud.paymentChannel = 'palkkausWS'; $crud.loadData()">WS</a>
          </li>
          <li role="menuitem">
            <a class="dropdown-item" href="" ng-click="$crud.paymentChannel = 'palkkausPSD'; $crud.loadData()">PSD</a>
          </li>
        </ul>
      </div>
    </div>
    <fieldset>
      <legend>Maksaja</legend>
      <div class="d-flex">
        <salaxy-avatar avatar="$crud.companyAccount.avatar" class="pull-left" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
        <div class="d-flex flex-column">
          <div><strong>{{ $crud.companyAccount.avatar.displayName }}</strong></div>
          <div>{{ $crud.companyAccount.identity.officialId }}</div>
          <div ng-if="$crud.companyAccount.ibanNumber">{{ $crud.companyAccount.ibanNumber | sxyIban }}</div>
          <div ng-if="!$crud.companyAccount.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </div>
      </div>
    </fieldset>
    <salaxy-tab-buttons
      current-tab="$crud.currentTab"
      options="[
        { value: 'netpaymentsandforeclosure', text: 'Nettopalkat ja ulosotot' },
        { value: 'monthlypayments', text: 'Kuukauden maksut' }
      ]"
      tabs-id="invoicePaymentList"
    ></salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-invoicePaymentList">
      <div class="tab-pane" id="netpaymentsandforeclosure-tab" ng-click="$crud.selectTab('netpaymentsandforeclosure')">
        <div ng-if="$crud.currentTab === 'netpaymentsandforeclosure'">
          <ng-include src="'salaxy-components/odata/lists/InvoicePaymentListTable.html'"></ng-include>
        </div>
      </div>
      <div class="tab-pane" id="monthlypayments-tab" ng-click="$crud.selectTab('monthlypayments')">
        <div ng-if="$crud.currentTab === 'monthlypayments'">
          <ng-include src="'salaxy-components/odata/lists/InvoicePaymentListTable.html'"></ng-include>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/InvoicePaymentListTable.html",`<table class="table" style="min-height: 250px;">
  <thead>
    <tr>
      <th ng-if="$crud.supportItemMultiSelect()">
        <span>Valittu</span>
      </th>
      <th colspan="2">
        <span>Ryhmä</span>
      </th>
      <th colspan="1">
        <span>                
          <input type="text" ng-model="$crud.otherPartyNameFilter" class="form-control" autocomplete="off" id="otherPartyName" name="otherPartyName" placeholder="{{'SALAXY.NG1.InvoicesComponent.receiver' | sxyTranslate}}">
        </span>
      </th>
      <th colspan="1">
        <span>                
          <input type="text" ng-model="$crud.ibanFilter" class="form-control" autocomplete="off" id="iban" name="iban" placeholder="{{'SALAXY.NG1.InvoicesComponent.iban' | sxyTranslate}}">
        </span>
      </th>
      <th>
        <div class="btn-group dropdown">
          <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            {{ ('SALAXY.NG1.InvoicesComponent.invoiceType' | sxyTranslate) }}: {{$crud.invoiceEntityType.label}}
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="btnHide">
            <li role="menuitem" ng-repeat="invoiceEntityType in $crud.invoiceEntityTypes">
              <a class="dropdown-item" href="" ng-click="$crud.invoiceEntityType = invoiceEntityType">{{invoiceEntityType.label}}</a>
            </li>
          </ul>
        </div>
      </th>
      <th>
        <span sxy-text="SALAXY.MODEL.InvoiceListItem.status.title"></span>
      </th>
      <th ng-if="$crud.hasExternalSystemMessagesEnabled()">
        <span sxy-text="Maksun tila"></span>
      </th>
      <th colspan="1">
        <span>                
          <input type="text" ng-model="$crud.referenceFilter" class="form-control" autocomplete="off" id="reference" name="reference" placeholder="{{'SALAXY.MODEL.InvoiceListItem.reference.title' | sxyTranslate}}">
        </span>
      </th>
      <th class="right clickable" ng-click="$crud.changeSortMode()">
        <span sxy-text="SALAXY.MODEL.InvoiceData.dueDate.tableHeading"></span>
        <i class="bi bi-sort-{{$crud.sortMode === 'asc' ? 'up' : 'down'}}"></i>
      </th>
      <th class="right">
        <span sxy-text="SALAXY.MODEL.InvoiceListItem.payment.title"></span>
      </th>
      <th colspan="2">
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat-start="group in $crud.getGroupedItems()" class="active">
      <td ng-if="$crud.supportItemMultiSelect()"></td>
      <td colspan="3">  
        <span>
            <a ng-if="group.groupType === 'payroll'" target="_blank" ng-href="#/payroll/details/{{ group.businessObjectId }}">
              {{group.title}}
            </a>
            <a ng-if="group.groupType === 'calculation'" target="_blank" ng-href="#/calc/details/{{ group.businessObjectId }}">
              {{group.title}}
            </a>
            <span ng-if="group.groupType === 'monthly'">
              {{group.title}}
            </span>
        </span>
      </td>
      <td ng-if="$crud.hasExternalSystemMessagesEnabled()"></td>             
      <td colspan="7"></td>
      <td class="middle">
        <div ng-if="$crud.paymentChannelConfig.rowGroupActions(group).length > 0" class="btn-group btn-group-sm dropup dropdown">
          <button id="actionsButton" type="button" class="btn" ng-disabled="$crud.selectedInvoices.length > 0" style="background-color: transparent; border-color: transparent;" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots-vertical" style="font-size: 20px;"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end" role="menu" aria-labelledby="actionsButton">
            <li role="menuitem" ng-repeat="action in $crud.paymentChannelConfig.rowGroupActions(group)">
              <a class="dropdown-item" href="" ng-click="action.onClick(group)">
                {{action.text}}
              </a>
            </li>
          </ul>
        </div>
      </td>
    </tr>
    <tr ng-repeat-end ng-repeat="invoice in group.invoices | filter: $crud.filterInvoices" >
      <td ng-if="$crud.supportItemMultiSelect()" class="left">
         <button title="{{'SALAXY.UI_Terms.select' | sxyTranslate}}" class="btn btn-transparent pull-right" type="button" ng-if="!$crud.isSelected(invoice) && $crud.isItemSelectable(invoice)" ng-click="$crud.setSelected(invoice, 'toggle')">
            <i class="bi bi-square"></i>
          </button>
          <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-transparent pull-right" type="button" ng-if="$crud.isSelected(invoice)" ng-click="$crud.setSelected(invoice, 'toggle')">
            <i class="bi bi-check-square"></i>
          </button>
      </td>
      <td></td>
      <td class="td-avatar-1line middle">
        <salaxy-avatar avatar="invoice.otherPartyInfo.avatar"></salaxy-avatar>
      </td>
      <td class="td-name middle">
        <div><strong>{{invoice.otherPartyInfo.avatar.displayName}}</strong></div>
        <small ng-switch="invoice.entityType">
        <span ng-switch-when="net|gross|foreclosure" ng-switch-when-separator="|">{{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}} {{ invoice.logicalDate | sxyDate }}</span>
        <span ng-switch-when="unemployment">{{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}}<br/>{{ { start: invoice.data.periodStart, end: invoice.data.periodEnd } | sxyDateRange }}</span>
        <span ng-switch-default>{{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}} {{ { start: invoice.data.periodStart, end: invoice.data.periodEnd } | sxyDateRange }}</span>
      </small>
      </td>
      <td class="middle">
        <span ng-if="invoice.otherPartyInfo.ibanNumber">{{ invoice.otherPartyInfo.ibanNumber }}</span>
        <span ng-if="!invoice.otherPartyInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoicesComponent.noIbanNumber"></span>
      </td>
      <td class="middle">
        {{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}}
      </td>
      <td class="middle">
        <strong ng-class="{ 'bg-danger': invoice.status == 'canceled', 'bg-success': invoice.status == 'paid' }" title="{{ 'InvoiceStatus.' + invoice.status | sxyEnumDescr }}">
          {{ "InvoiceStatus." + invoice.status | sxyEnum }}
        </strong>
      </td>
      <td ng-if="$crud.hasExternalSystemMessagesEnabled()">
        <span ng-class="$crud.getBadgeClass(invoice.data.externalStatus)">{{invoice.data.externalStatus}}</span> <br/>
        <small>{{invoice.data.externalStatusAt | date: "dd.MM.yyyy HH:mm"}}</small>
      </td>
      <td class="middle">
        <span>{{ invoice.entityType !== 'net' && invoice.reference ? invoice.reference : '' }}</span>
      </td>
      <td class="middle right">
        {{ invoice.data.dueDate | sxyDate }}
      </td>
      <td class="middle right">
        {{ invoice.payment | currency }}
      </td>
      <td class="middle">
        <button ng-click="$crud.showInvoiceDialog(invoice)" title="{{ 'SALAXY.NG1.InvoicesComponent.detailsBtn' | sxyTranslate}}" class="btn btn-xs btn-default btn-block" sxy-text="SALAXY.NG1.InvoicesComponent.detailsBtn">
        
      </button>
      </td>
      <td class="middle">
        <div ng-if="$crud.paymentChannelConfig.rowActions(invoice).length > 0" class="btn-group btn-group-sm dropup dropdown">
          <button id="actionsButton" type="button" class="btn" ng-disabled="$crud.selectedInvoices.length > 0" style="color: #000; background-color: transparent; border-color: transparent;" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots-vertical" style="font-size: 20px;"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end" role="menu" aria-labelledby="actionsButton">
            <li role="menuitem" ng-repeat="action in $crud.paymentChannelConfig.rowActions(invoice)">
              <a class="dropdown-item" href="" ng-click="action.onClick(invoice)">
                {{action.text}}
              </a>
            </li>
          </ul>
        </div>
      </td>
    </tr>
  </tbody>
</table>`);

 $templateCache.put("salaxy-components/odata/lists/Invoices.html",`<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th colspan="2"><span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1.InvoicesComponent.receiverAndType"></span></th>
        <th>
          <span sxy-orderby="status" sxy-text="SALAXY.NG1.InvoicesComponent.status"></span><br />
          <small sxy-text="SALAXY.NG1.InvoicesComponent.channel"></small>
        </th>
        <th class="right">
          <span sxy-orderby="startAt" sxy-text="SALAXY.NG1.InvoicesComponent.invoiceDate"></span><br/>
          <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.InvoicesComponent.dueDate"></span>
        </th>
        <th class="right">
          <span sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></span><br />
          <span sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></span>
        </th>
        <th class="right"><span sxy-orderby="payment" sxy-text="SALAXY.NG1.InvoicesComponent.sum"></span></th>        
        <th class="right" colspan="2">
          <div class="table-filter-container hidden-xxs">
            <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items" ng-show="$ctrl.items.length > 0">
        <td class="td-avatar middle">
          <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="middle">
          <div>{{ row.otherPartyInfo.avatar.displayName }}</div>
          <small class="hidden-xxs" ng-switch="row.entityType">
            <span ng-switch-when="net|gross|foreclosure|verification" ng-switch-when-separator="|">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ row.logicalDate | sxyDate }}</span>
            <span ng-switch-when="unemployment">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}}<br/>{{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
            <span ng-switch-default>{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
          </small>
        </td class="middle">
        <td class="middle">
          <span ng-class="{ 'bg-danger': row.status == 'canceled', 'bg-success': row.status == 'paid' }" title="{{ 'InvoiceStatus.' + row.status | sxyEnumDescr }}">
            {{ "InvoiceStatus." + row.status | sxyEnum }}
          </span><br />
          <small>{{ "PaymentChannel." + row.data.channel | sxyEnum }}</small>
        </td>
        <td class="middle right">
          <div>{{ row.startAt | sxyDate }}</div>
          <div ng-switch="$crud.getDueDateType(row)">
            <span ng-switch-when="estimation">{{ row.endAt | date: 'MMMM' }}</span>
            <del ng-switch-when="canceled" class="">{{ row.endAt | sxyDate }}</del>
            <span ng-switch-when="overdue" class="bg-danger">{{ row.endAt | sxyDate }}</span>
            <em ng-switch-when="future" class="disabled">{{ row.endAt | sxyDate }}</em>
            <span ng-switch-when="default">{{ row.endAt | sxyDate }}</span>
            <span ng-switch-when="unknown">{{ row.endAt | sxyDate }}</span>
          </div>
        </td>
        <td class="middle right">
          {{ row.createdAt | sxyDate }}<br /> {{ row.updatedAt | sxyDate }}
        </td>
        <td class="middle right">
          {{ row.payment | currency }}
        </td>       
        <td class="middle right">
          <a href="" ng-click="$crud.showDetails(row)" class="btn btn-primary">
            {{ 'SALAXY.UI_Terms.show' | sxyTranslate}}
          </a>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
  <div class="salaxy-odata-footer">
    <salaxy-spinner></salaxy-spinner>
  </div>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/InvoicesCompany.html",`<div ng-class="$ctrl.getCssClass()">
  <h1 sxy-text="SALAXY.NG1.InvoicesCompany.heading"></h1>
  <style>
    .invoice-label {
      display: inline-block;
      width: 100px;
    }
  </style>
  <div class="btn-toolbar">
    <div class="btn-group dropdown">
      <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        {{ $crud.queryOption.text }}
      </button>
      <ul class="dropdown-menu" aria-labelledby="btnHide">
        <li ng-repeat="queryOption in $crud.queryOptions">
          <a class="dropdown-item" href="" ng-click="$crud.queryOption = queryOption;$crud.doQuery()">{{queryOption.text}}</a>
        </li>
      </ul>
    </div>
    <button type="button" class="btn btn-secondary" ng-click="$crud.showloadPfd($ctrl.items)" sxy-text="SALAXY.UI_Terms.downloadPdf"></button>
    <div ng-if="$crud.queryOption.value != 'unpaid'" class="btn-group dropdown">
      <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        {{ $crud.dateFilterQueryOption.text }}
      </button>
      <ul class="dropdown-menu" aria-labelledby="btnHide">
        <li ng-repeat="queryOption in $crud.queryDateFilterOptions">
          <a class="dropdown-item" href="" ng-click="$crud.setDateFilterQueryOption(queryOption)">{{queryOption.text}}</a>
        </li>
      </ul>
    </div>
    <div ng-if="$crud.queryOption.value == 'unpaid' && $ctrl.items.length > 0" class="btn-group dropdown float-end ms-auto">
      <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        {{'SALAXY.NG1.InvoicesCompany.selectInvoices' | sxyTranslate}}
      </button>
      <ul class="dropdown-menu" aria-labelledby="btnHide">
        <li ng-repeat="option in $crud.getMarkAsPaidOptions($ctrl.items)">
          <a class="dropdown-item" href="" ng-click="$crud.selectInvoicesByType(option.value)">{{option.text}}</a>
        </li>
      </ul>
    </div>
    <button type="button" class="btn btn-primary pull-right" ng-if="$crud.queryOption.value == 'unpaid' && $ctrl.items.length > 0"
      ng-click="$crud.markInvoicesAsPaid()" ng-disabled="!$ctrl.selectedItems || $ctrl.selectedItems.length == 0" sxy-text="SALAXY.NG1.InvoicesCompany.setAsPaid">
    </button>
  </div>
  <table class="table">
    <thead>
      <tr>
        <th colspan="2"><span sxy-text="SALAXY.NG1.InvoicesCompany.receiverAndType"></span></th>
        <th ng-if="$crud.queryOption.value == 'unpaid'" class="right">
          <span sxy-text="SALAXY.NG1.InvoicesCompany.sum"></span>/ <br/>
          <span sxy-text="SALAXY.UI_Terms.chosen"></span>
        </th>
        <th ng-if="$crud.queryOption.value != 'unpaid'" class="right">
          <span sxy-text="SALAXY.NG1.InvoicesCompany.sum"></span>
        </th>          
        <th class="right" colspan="2">
          <div class="table-filter-container hidden-xxs">
            <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search"
             placeholder="SALAXY.UI_Terms.textSearch" label-type="plain">
            </salaxy-input>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat-start="row in $ctrl.items" ng-show="$ctrl.items.length > 0" class="active">
        <td class="middle" colspan="3">
          <div class="d-flex">
            <div class="flex-grow-1">
              <div class="d-flex align-items-center">
                <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
                <span style="font-size: 1.4em; font-weight: bold;">
                  {{ row.otherPartyInfo.avatar.displayName }}:
                  <span ng-switch="row.entityType">
                    <span ng-switch-when="net|gross|foreclosure|verification" ng-switch-when-separator="|">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ row.logicalDate | sxyDate }}</span>
                    <span ng-switch-default>{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
                  </span>
                </span>
              </div>
              <div ng-if="row.entityType == 'net'" class="mt-2" ng-switch="row.status">
                <span ng-switch-when="paid" class="text-success" ng-switch-when-separator="|" sxy-text="SALAXY.NG1.InvoicesCompany.paidNetPaymentInfo"></span>
                <span ng-switch-default  class="text-danger" sxy-text="SALAXY.NG1.InvoicesCompany.unPaidNetPaymentInfo"></span>
              </div>
            </div>
            <div class="row-buttons align-items-end">
              <button title="{{'SALAXY.UI_Terms.select' | sxyTranslate}}" class="btn btn-transparent pull-right" type="button" ng-if="!$ctrl.isSelected(row) && $crud.queryOption.value == 'unpaid' && $crud.showMarkAsPaidButton(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
                <i class="bi bi-square"></i>
              </button>
              <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-transparent pull-right" type="button" ng-if="$ctrl.isSelected(row) && $crud.queryOption.value == 'unpaid' && $crud.showMarkAsPaidButton(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
                <i class="bi bi-check-square"></i>
              </button>
            </div>
          </div>
        </td>
        <td class="right">
          <button ng-if="row.status != 'canceled'" class="btn btn-default" ng-click="$crud.showInvoiceDialog(row)">
            <span class="hidden-xs" sxy-text="SALAXY.NG1.InvoicesCompany.showInvoiceDetails"></span>
          </button>
          <a ng-if="$crud.calculationHref(row)" ng-href="{{$crud.calculationHref(row)}}" class="btn btn-default" sxy-text="SALAXY.NG1.InvoicesCompany.openCalculation"></a>
        </td>
      </tr>
      <tr>
        <td class="td-avatar hidden-xxs" style="width: 160px;padding: 0px;" ng-if="row.status != 'paid' && row.status != 'canceled' && $crud.getQrCode(row) !== 'loading' && $crud.getQrCode(row) !== 'error'">
          <div style="margin: 8px;" height="160px" ng-bind-html="$crud.getQrCode(row)" ></div>
        </td>
        <td class="td-avatar hidden-xxs" style="min-width: 160px;vertical-align: middle; text-align: center; height: 160px;" ng-if="row.status != 'paid' && row.status != 'canceled' && $crud.getQrCode(row) === 'error'">
          <div style="height: 100%; display: flex;align-items: center;justify-content: center; background-color: #e9d310;">
            <div>
              <small sxy-text="SALAXY.NG1.InvoicesCompany.qrCodeNotAvailable"></small>
            </div>
          </div>
        </td>
        <td class="td-avatar hidden-xxs" style="vertical-align: middle; text-align: center; height: 160px; width: 160px;" ng-if="row.status == 'paid'">
          <div class="bg-success" style="height: 100%; display: flex;align-items: center;justify-content: center; font-size: 1.5em;">
            <div>
              <b>
                {{ "SALAXY.ENUM.InvoiceStatus." + row.status + ".label" | sxyTranslate}} <br/>
                {{(row.data.statusAt || row.updatedAt) | date}}
              </b>
            </div>
          </div>
        </td>
        <td class="td-avatar hidden-xxs" style="vertical-align: middle; text-align: center; height: 160px; width: 160px;" ng-if="row.status == 'canceled'">
          <div class="bg-danger" style="height: 100%; display: flex;align-items: center;justify-content: center; font-size: 1.5em;">
            <b>
              {{ "SALAXY.ENUM.InvoiceStatus." + row.status + ".label" | sxyTranslate}} <br/>
              {{(row.data.statusAt || row.updatedAt) | date}}
            </b>
          </div>
        </td>
        <td>
          <div class="row">
            <div class="col-3" sxy-text="SALAXY.NG1.InvoicesCompany.iban" ps=":"></div>
            <div class="col-9">
              {{ row.otherPartyInfo.ibanNumber  }}
            </div>
          </div>
          <div class="row">
            <div class="col-3" sxy-text="SALAXY.NG1.InvoicesCompany.name" ps=":"></div>
            <div class="col-9">
              {{ row.otherPartyInfo.avatar.displayName }}
            </div>
          </div>
          <div class="row">
            <div class="col-3" sxy-text="SALAXY.NG1.InvoicesCompany.dueDate" ps=":"></div>
            <div class="col-9" ng-switch="$crud.getDueDateType(row)">
              <span ng-switch-when="estimation">{{ row.endAt | sxyDate }}</span>
              <del ng-switch-when="canceled" class="">{{ row.endAt | sxyDate }}</del>
              <span ng-switch-when="overdue" class="bg-danger">{{ row.endAt | sxyDate }}</span>
              <em ng-switch-when="future" class="disabled">{{ row.endAt | sxyDate }}</em>
              <span ng-switch-when="default">{{ row.endAt | sxyDate }}</span>
              <span ng-switch-when="unknown">{{ row.endAt | sxyDate }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              {{row.entityType === 'net' || row.entityType === 'gross' ? ('SALAXY.NG1.InvoicesCompany.message' | sxyTranslate) : ('SALAXY.NG1.InvoicesCompany.reference' | sxyTranslate)}}
            </div>
            <div class="col-9">
              <span ng-if="row.entityType === 'net' || row.entityType === 'gross'">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
              <span ng-if="row.entityType !== 'net' && row.entityType !== 'gross'">{{row.reference}}</span>
            </div>
          </div>
          <div class="row" ng-if="row.entityType == 'tax' || row.entityType == 'union'">
            <div class="col-3" sxy-text="SALAXY.NG1.InvoicesCompany.netPaymentCount" ps=":"></div>
            <div class="col-9">
              {{row.businessObjects.length}}
            </div>
          </div>
        </td>
        <td class="right" ng-if="!row.data.totalPaid">
          <h4 style="font-weight: bold;">{{ row.payment | currency }}</h4>
        </td>
        <td class="right" ng-if="row.data.totalPaid && row.data.totalPaid != row.payment">
          <h4 style="text-decoration: line-through;">{{'SALAXY.NG1.InvoicesCompany.sum' | sxyTranslate}} {{ row.payment | currency }}</h4>
          <h4>{{'SALAXY.NG1.InvoicesCompany.alreadyPaid' | sxyTranslate}} {{ row.data.totalPaid | currency }}</h4>
          <h4 class="total" style="font-weight: bold;">{{'SALAXY.NG1.InvoicesCompany.payable' | sxyTranslate}} {{ (row.payment - row.data.totalPaid) | currency }}</h4>
        </td>
        <td class="right" ng-if="row.data.totalPaid && row.payment == row.data.totalPaid">
          <h4 style="font-weight: bold;">{{ row.payment | currency }}</h4>
        </td>
        <td class="right">
          <button ng-if="$crud.showMarkAsPaidButton(row)" class="btn btn-primary" ng-click="$crud.updateInvoiceStatus(row,'paid')">
            <span class="hidden-xs" sxy-text="SALAXY.NG1.InvoicesCompany.setAsPaid"></span>
          </button> 
          <div style="height: 10px;" ng-if="$crud.showMarkAsPaidButton(row) && $crud.showMarkAsCanceledButton(row)"> <br/> </div>         
          <button class="btn btn-danger" ng-if="$crud.showMarkAsCanceledButton(row)" ng-click="$crud.updateInvoiceStatus(row,'canceled')">
            </i><span class="hidden-xs" sxy-text="SALAXY.NG1.InvoicesCompany.cancelPayment"></span>
          </button>
          <div ng-if="$crud.showIrCancelInfoText(row)" class="text-center" style="width: 140px; margin: auto; margin-top: 6px;" sxy-text="SALAXY.NG1.InvoicesCompany.cancelInfoText"></div>
          <div ng-if="row.status == 'preview'" class="text-center" style="width: 140px; margin: auto; margin-top: 6px;">
            {{(row.data.paidBusinessObjectsCount || 0) }} / {{row.businessObjects.length}} {{'SALAXY.NG1.InvoicesCompany.unpaidNetSalaries' | sxyTranslate}}<br/>
            {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}
          </div>
        </td>
      </tr>
      <tr ng-repeat-end ng-if="row.status != 'paid' && row.status != 'canceled'">
        <td colspan="4">
          <button type="button" class="btn btn-default btn-sm" ng-click="$crud.copyBarcode(row)">
            <span><i class="bi bi-clipboard"></i></span>
          </button>
          <span style="font-family: 'Courier New', Courier, monospace; font-size: 1.15em;">{{$crud.getBarcodeValue(row)}}</span>          
        </td>        
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
  <div class="salaxy-odata-footer">
    <salaxy-spinner></salaxy-spinner>
  </div>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/InvoicesPanel.html",`<div class="salaxy-odata-panel list-panel report-list-panel panel panel-sm panel-secondary">
  <div class="card-header">
    {{('SALAXY.NG1.InvoicesComponent.invoices' | sxyTranslate) }}
  </div>
  <div ng-class="$ctrl.getCssClass()">
    <div class="card-body text-center card-content lg-height align-middle" ng-show="$ctrl.items.length == 0 && !$ctrl.isLoading">
      <div>
        <h3 sxy-text="SALAXY.NG1.InvoicesComponent.noInvoices"></h3>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table">
        <tbody>
          <tr ng-repeat="row in $ctrl.items" ng-show="$ctrl.items.length > 0">
            <td class="td-avatar middle hidden-xxs">
              <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="middle">
              {{ row.otherPartyInfo.avatar.displayName }}<br>
              <small class="hidden-xxs">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}}</small>
            </td>
            <td class="middle right">
              {{ row.endAt | date }}
              <span ng-if="row.status=='paid'" class="text-success status small"><br>{{'SALAXY.NG1.InvoicesComponent.paid' | sxyTranslate}}</span>
            </td>
            <td class="middle right">
              {{ row.payment | currency }}
            </td>
            <td class="middle right">
              <a ng-href="{{$crud.getContentUrl(row.id, true)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i
              class="bi bi-file-earmark-pdf"></i></a>
              <button href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i class="bi bi-info-circle"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>
  </div>
  <div class="card-footer text-center footer-empty">
    <a ng-href="#{{$crud.getDefaults().listUrl}}" title="Näytä kaikki" class="btn btn-primary btn-sm" sxy-text="SALAXY.UI_Terms.showAll"></a>
  </div>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/InvoicesPaymentChannel.html",`<div ng-class="$ctrl.getCssClass()" ng-controller="InvoiceToolsController as $invoiceTools" ng-init="$invoiceTools.reader = $crud.selectionDataReader">
  <div ng-show="'test' | sxyIsInRole" class="salaxy-component salaxy-invoice-tools" >
    <div class="btn-toolbar" role="toolbar" aria-label="Invoice options">
      <div class="btn-group">
        <salaxy-input-enum type="dropdown" name="fileType" label-type="plain" ng-model="$invoiceTools.fileTypeId" options="$invoiceTools.fileTypeOptions" remember="invoice"></salaxy-input-enum>
      </div>
      <div class="btn-group">
        <button ng-disabled="$invoiceTools.reader.disabled()" id="reportExport" type="button" class="btn btn-default" ng-click="$invoiceTools.export()">
          {{ $invoiceTools.reader.exportLabel || ('SALAXY.NG1.AccountingReportToolsComponent.createExport' | sxyTranslate) }}
        </button>
      </div>
    </div>
  </div>
  <table class="table">
    <thead>
      <tr>
        <th colspan="2"><span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1.InvoicesComponent.receiverAndType"></span></th>
        <th>
          <span sxy-orderby="status" sxy-text="SALAXY.NG1.InvoicesComponent.status"></span><br />
          <small sxy-text="SALAXY.NG1.InvoicesComponent.channel"></small>
        </th>
        <th class="right">
          <span sxy-orderby="startAt" sxy-text="SALAXY.NG1.InvoicesComponent.invoiceDate"></span><br/>
          <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.InvoicesComponent.dueDate"></span>
        </th>
        <th class="right">
          <span sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></span><br />
          <span sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></span>
        </th>
        <th class="right"><span sxy-orderby="payment" sxy-text="SALAXY.NG1.InvoicesComponent.sum"></span></th>
        <th class="middle" ng-if="'test' | sxyIsInRole">
          <button title="{{'SALAXY.UI_Terms.chooseAll' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length == 0" ng-disabled="$ctrl.selectedItems.length == $ctrl.items.length" ng-click="$crud.selectAll()">
            <i class="bi bi-square"></i>
          </button>
          <button title="{{'SALAXY.UI_Terms.unselectAll' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length > 0" ng-disabled="$ctrl.selectedItems.length == 0" ng-click="$crud.unselectAll()">
            <i class="bi bi-check-square"></i>
          </button>
        </th>
        <th class="right" colspan="2">
          <div class="table-filter-container hidden-xxs">
            <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items" ng-show="$ctrl.items.length > 0">
        <td class="td-avatar middle">
          <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="middle">
          <div>{{ row.otherPartyInfo.avatar.displayName }}</div>
          <small class="hidden-xxs" ng-switch="row.entityType">
            <span ng-switch-when="net|gross|foreclosure|verification" ng-switch-when-separator="|">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ row.logicalDate | sxyDate }}</span>
            <span ng-switch-when="unemployment">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}}<br/>{{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
            <span ng-switch-default>{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
          </small>
        </td class="middle">
        <td class="middle">
          <span ng-class="{ 'bg-danger': row.status == 'canceled', 'bg-success': row.status == 'paid' }" title="{{ 'InvoiceStatus.' + row.status | sxyEnumDescr }}">
            {{ "InvoiceStatus." + row.status | sxyEnum }}
          </span><br />
          <small>{{ "PaymentChannel." + row.data.channel | sxyEnum }}</small>
        </td>
        <td class="middle right">
          <div>{{ row.startAt | sxyDate }}</div>
          <div>{{ row.endAt | sxyDate }}</div>
        </td>
        <td class="middle right">
          {{ row.createdAt | sxyDate }}<br /> {{ row.updatedAt | sxyDate }}
        </td>
        <td class="middle right">
          {{ row.payment | currency }}
        </td>
        <td class="middle" ng-if="'test' | sxyIsInRole">
          <button title="{{'SALAXY.UI_Terms.select' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="!$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
            <i class="bi bi-square"></i>
          </button>
          <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
            <i class="bi bi-check-square"></i>
          </button>
        </td>
        <td class="middle" ng-if="'test' | sxyIsInRole">
          <button class="btn btn-sm btn-block btn-default" ng-disabled="row.isReading" type="button" ng-click="$invoiceTools.export($crud.getItemDataReader(row),true)">
            <span ng-show="row.isReading"><i class="bi bi-arrow-repeat bi-spin"></i></span>
            <span ng-show="!row.isReading">{{ 'SALAXY.NG1.AccountingReportToolsComponent.createExport' | sxyTranslate }}</span>
          </button>
        </td>
        <td class="middle right">
          <a href="" ng-click="$crud.showDetails(row)" class="btn btn-primary">
            {{ 'SALAXY.UI_Terms.show' | sxyTranslate}}
          </a>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
  <div class="salaxy-odata-footer">
    <salaxy-spinner></salaxy-spinner>
  </div>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/InvoicesPerson.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="salaxy-component salaxy-invoice-tools" ng-controller="InvoiceToolsController as $invoiceTools" ng-init="$invoiceTools.reader = $crud.selectionDataReaderPerson">
    <div class="btn-toolbar" role="toolbar" aria-label="Invoice options">
      <div class="btn-group btn-group-sm dropdown">
        <button id="invoiceOptionsFileType" type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown">
          <i class="bi bi-file-earmark-pdf"></i>&nbsp;{{'SALAXY.ENUM.ExportMethod.filePdf.label' | sxyTranslate}}
        </button>
      </div>
      <div class="btn-group btn-group-sm ms-1">
        <button ng-disabled="$crud.selectionDataReaderPerson.disabled()" id="reportExport" type="button" class="btn btn-default" ng-click="$invoiceTools.export()">
          {{'SALAXY.NG1.AccountingReportToolsComponent.createExport' | sxyTranslate}}
        </button>
      </div>
    </div>
  </div>

  <table class="table">
    <thead>
      <tr>
        <th colspan="2"><span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1.InvoicesComponent.receiverAndType"></span></th>
        <th>
          <span sxy-orderby="status" sxy-text="SALAXY.NG1.InvoicesComponent.status"></span><br />
        </th>
        <th class="right">
          <span sxy-orderby="startAt" sxy-text="SALAXY.NG1.InvoicesComponent.invoiceDate"></span><br/>
          <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.InvoicesComponent.dueDate"></span>
        </th>
        <th class="right">
          <span sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></span><br />
          <span sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></span>
        </th>
        <th class="right"><span sxy-orderby="payment" sxy-text="SALAXY.NG1.InvoicesComponent.sum"></span></th>
        <th class="middle">
          <button title="{{'SALAXY.UI_Terms.chooseAll' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length == 0" ng-disabled="$ctrl.selectedItems.length == $ctrl.items.length" ng-click="$crud.selectAll()">
            <i class="bi bi-square"></i>
          </button>
          <button title="{{'SALAXY.UI_Terms.unselectAll' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length > 0" ng-disabled="$ctrl.selectedItems.length == 0" ng-click="$crud.unselectAll()">
            <i class="bi bi-check-square"></i>
          </button>
        </th>
        <th class="right" colspan="2">
          <div class="table-filter-container hidden-xxs">
            <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items" ng-show="$ctrl.items.length > 0">
        <td class="td-avatar middle">
          <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="middle">
          <div>{{ row.otherPartyInfo.avatar.displayName }}</div>
          <small class="hidden-xxs" ng-switch="row.entityType">
            <span ng-switch-when="net|gross|foreclosure" ng-switch-when-separator="|">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ row.logicalDate | sxyDate }}</span>
            <span ng-switch-when="unemployment">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}}<br/>{{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
            <span ng-switch-default>{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
          </small>
        </td class="middle">
        <td class="middle" ng-if="row.entityType !== 'tax' && row.entityType !== 'net'">
          <span title="{{ 'InvoiceStatus.' + row.status | sxyEnumDescr }}">
            {{ "InvoiceStatus.forecast" | sxyEnum }}
          </span><br />
          <small>{{ row.otherPartyInfo.avatar.displayName }} {{'SALAXY.NG1.InvoicesCreateTableComponent.sendsInvoice' | sxyTranslate}}</small>
        </td>
        <td class="middle" ng-if="row.entityType === 'tax' || row.entityType === 'net'">
          <span ng-class="{ 'bg-danger': row.status == 'canceled', 'bg-success': row.status == 'paid' }" title="{{ 'InvoiceStatus.' + row.status | sxyEnumDescr }}">
            {{ "InvoiceStatus." + row.status | sxyEnum }}
          </span><br />
          <small>{{ "PaymentChannel." + row.data.channel | sxyEnum }}</small>
        </td>
        <td class="middle right">
          <div>{{ row.startAt | sxyDate }}</div>
          <div ng-switch="$crud.getDueDateType(row)">
            <span ng-switch-when="estimation">{{ row.endAt | date: 'MMMM' }}</span>
            <del ng-switch-when="canceled" class="">{{ row.endAt | sxyDate }}</del>
            <span ng-switch-when="overdue" class="bg-danger">{{ row.endAt | sxyDate }}</span>
            <em ng-switch-when="future" class="disabled">{{ row.endAt | sxyDate }}</em>
            <span ng-switch-when="default">{{ row.endAt | sxyDate }}</span>
            <span ng-switch-when="unknown">{{ row.endAt | sxyDate }}</span>
          </div>
        </td>
        <td class="middle right">
          {{ row.createdAt | sxyDate }}<br /> {{ row.updatedAt | sxyDate }}
        </td>
        <td class="middle right">
          {{ row.payment | currency }}
        </td>
        <td class="middle" ng-if="row.entityType === 'tax' || row.entityType === 'net'">
          <button title="{{'SALAXY.UI_Terms.select' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="!$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
            <i class="bi bi-square"></i>
          </button>
          <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
            <i class="bi bi-check-square"></i>
          </button>
        </td>
        <td class="middle" ng-if="row.entityType !== 'tax' && row.entityType !== 'net'"></td>
        <td class="middle">
          <button ng-click="$crud.showPaymentDialog(row)" ng-if="row.entityType === 'net' && (row.status === 'paid' || row.status === 'unread')" class="btn btn-sm btn-block btn-default" ng-disabled="row.isReading" type="button">
            <span ng-if="row.status === 'paid'">{{ 'SALAXY.NG1.InvoicesCreateTableComponent.cancelInvoice' | sxyTranslate }}</span>
            <span ng-if="row.status === 'unread'">{{ 'SALAXY.NG1.InvoicesCreateTableComponent.payInvoice' | sxyTranslate }}</span>
          </button>
        </td>
        <td class="middle right">
          <a ng-if="row.entityType === 'tax' || row.entityType === 'net'" ng-href="{{$crud.getContentUrl(row.id, true)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i
            class="bi bi-file-earmark-pdf"></i></a>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
  <div class="salaxy-odata-footer">
    <salaxy-spinner></salaxy-spinner>
  </div>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/InvoicesSepa.html",`<div ng-class="$ctrl.getCssClass()">
  <div ng-controller="InvoiceToolsController as $invoiceTools">
    <div class="btn-toolbar">
      <div class="btn-group">
        <salaxy-input-enum type="dropdown" name="fileType" label-type="plain" ng-model="$invoiceTools.fileTypeId" options="$invoiceTools.fileTypeOptions" remember="invoice"></salaxy-input-enum>
      </div>
      <div class="btn-group dropdown">
        <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
          {{ ('SALAXY.MODEL.InvoiceListItem.status.title' | sxyTranslate) }}: {{$crud.statusFilter.text}}
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="btnHide">
          <li role="menuitem" ng-repeat="statusFilter in $crud.statusFilters">
            <a href="" ng-click="$crud.statusFilter = statusFilter" class="dropdown-item">{{statusFilter.text}}</a>
          </li>
        </ul>
      </div>
      <div class="btn-group ms-1">
        <salaxy-datepicker-popup name="refDateMonth" label-type="plain" format="year" ng-model="$crud.queryYear"></salaxy-datepicker-popup>
      </div>
      <button type="button" ng-click="$crud.loadData()" class="btn btn-primary">Hae</button>
    </div>
    <div class="table-responsive">
      <table class="table" style="min-height: 250px;">
        <thead>
          <tr>
            <th colspan="1">
              <span sxy-text="SALAXY.NG1.InvoicesComponent.payer"></span>
            </th>
            <th colspan="2">
              <span>                
                <input type="text" ng-model="$crud.otherPartyNameFilter" class="form-control" autocomplete="off" id="otherPartyName" name="otherPartyName" placeholder="{{'SALAXY.NG1.InvoicesComponent.receiver' | sxyTranslate}}">
              </span>
            </th>
            <th>
              <span sxy-text="SALAXY.MODEL.InvoiceData.channel.title"></span><br />
              <span sxy-text="SALAXY.NG1.InvoicesComponent.iban"></span>
            </th>
            <th>
              <div class="btn-group dropdown">
                <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
                  {{ ('SALAXY.NG1.InvoicesComponent.invoiceType' | sxyTranslate) }}: {{$crud.invoiceEntityType.label}}
                </button>
                <ul class="dropdown-menu" role="menu" aria-labelledby="btnHide">
                  <li role="menuitem" ng-repeat="invoiceEntityType in $crud.invoiceEntityTypes">
                    <a href="" ng-click="$crud.invoiceEntityType = invoiceEntityType" class="dropdown-item">{{invoiceEntityType.label}}</a>
                  </li>
                </ul>
              </div>
            </th>
            <th>
              <span sxy-orderby="status" sxy-text="SALAXY.MODEL.InvoiceListItem.status.title"></span><br />
              <span sxy-text="SALAXY.MODEL.InvoiceListItem.reference.title"></span>/<span sxy-text="SALAXY.MODEL.InvoiceListItem.messages.title"></span>
            </th>
            <th class="right">
              <span sxy-orderby="endAt" sxy-text="SALAXY.MODEL.InvoiceData.dueDate.tableHeading"></span><br />
              <span sxy-text="SALAXY.MODEL.InvoiceData.date.title"></span>
            </th>
            <th class="right">
              <span sxy-text="SALAXY.MODEL.InvoiceListItem.payment.tableHeading"></span><br />
              <span sxy-text="SALAXY.MODEL.InvoiceListItem.payment.title"></span>
            </th>
            <th colspan="2">
              <span sxy-text="SALAXY.NG1.InvoicesComponent.createInvoices"></span><br />
              <span sxy-text="SALAXY.NG1.InvoicesComponent.markAsPaid"></span>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat-start="group in $crud.getGroupedItems() | filter: $crud.invoiceFilter" class="active">
            <td class="td-avatar middle">
              <salaxy-avatar avatar="group.ownerInfo.avatar"></salaxy-avatar>
            </td>
            <td class="td-name middle" colspan="2">
              <strong>{{group.ownerInfo.avatar.displayName}}</strong><br />
              <span>{{group.ownerInfo.officialId}}</span>
            </td>
            <td class="middle">
              <span>{{ "PaymentChannel." + group.channel | sxyEnum }}</span>
            </td>
            <td>
              <span>{{("SALAXY.ENUM.InvoiceType." + group.invoiceType + ".label") | sxyTranslate}}</span>
            </td>
            <td class="middle" ng-if="!$crud.groupHasDuplicateInvoices(group)">
              <strong ng-class="{ 'bg-danger': group.status == 'canceled', 'bg-success': group.status == 'paid' }" title="{{ 'InvoiceStatus.' + group.status | sxyEnumDescr }}">
              {{ "InvoiceStatus." + group.status | sxyEnum }}
              </strong>
            </td>
            <td class="middle" ng-if="$crud.groupHasDuplicateInvoices(group)">
              <strong class="text-danger">
                {{ 'SALAXY.NG1.InvoicesComponent.duplicateInvoices' | sxyTranslate }}
              </strong>
            </td>
            <td class="middle right">
              <strong>{{ group.dueDate | sxyDate }}</strong>
            </td>
            <td class="middle right">
              <strong>{{ group.payment | currency }}</strong>
            </td>
            <td class="middle">
              <button class="btn btn-default btn-block" ng-if="group.status == 'unread' || group.status == 'read' || group.status== 'waitingConfirmation'" ng-disabled="group.isReadingread || group.isReadingpaid || $crud.groupHasDuplicateInvoices(group)" ng-click="$invoiceTools.export($crud.getGroupDataReader(group,'waitingConfirmation'),true)">
              <span ng-show="group.isReadingwaitingConfirmation"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span ng-show="!group.isReadingwaitingConformation" sxy-text="SALAXY.NG1.InvoicesComponent.createInvoiceBtn"></span>
            </button>
            </td>
            <td class="middle">
              <button class="btn btn-default btn-block" ng-if="group.status == 'unread' || group.status == 'read' || group.status== 'waitingConfirmation'" ng-disabled="group.isReadingread || group.isReadingpaid || $crud.groupHasDuplicateInvoices(group)" ng-click="$invoiceTools.export($crud.getGroupDataReader(group,'paid'),true)">
              <span ng-show="group.isReadingpaid"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span ng-show="!group.isReadingpaid" sxy-text="SALAXY.NG1.InvoicesComponent.markAsPaidBtn"></span>
            </button>
            </td>
            <td class="middle">
              <button class="btn btn-default btn-block" ng-click="$crud.showGroupDialog(group)" sxy-text="SALAXY.NG1.InvoicesComponent.detailsBtn"></button>
            </td>
          </tr>
          <tr ng-repeat-end ng-repeat="invoice in group.invoices | filter: {otherPartyInfo:{avatar:{displayName: $crud.otherPartyNameFilter}}}" >
            <td></td>
            <td class="td-avatar-1line middle">
              <salaxy-avatar avatar="invoice.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="td-name middle">
              <div><strong>{{invoice.otherPartyInfo.avatar.displayName}}</strong></div>
              <small ng-switch="invoice.entityType">
              <span ng-switch-when="net|gross|foreclosure" ng-switch-when-separator="|">{{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}} {{ invoice.logicalDate | sxyDate }}</span>
              <span ng-switch-when="unemployment">{{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}}<br/>{{ { start: invoice.data.periodStart, end: invoice.data.periodEnd } | sxyDateRange }}</span>
              <span ng-switch-default>{{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}} {{ { start: invoice.data.periodStart, end: invoice.data.periodEnd } | sxyDateRange }}</span>
            </small>
            </td>
            <td class="middle">
              <span ng-if="invoice.otherPartyInfo.ibanNumber">{{ invoice.otherPartyInfo.ibanNumber }}</span>
              <span ng-if="!invoice.otherPartyInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoicesComponent.noIbanNumber"></span>
            </td>
            <td class="middle">
              {{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}}
            </td>
            <td class="middle">
              {{ invoice.reference || ("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate }}
            </td>
            <td class="middle right">
              {{ invoice.data.date | sxyDate }}
            </td>
            <td class="middle right">
              {{ invoice.payment | currency }}
            </td>
            <td class="middle">
              <button class="btn btn-default btn-xs btn-block" ng-if="invoice.status == 'unread'  || invoice.status == 'read' || invoice.status== 'waitingConfirmation'" ng-disabled="invoice.isReadingwaitingConfirmation || invoice.isReadingpaid || $crud.groupHasDuplicateInvoices(group)" ng-click="$invoiceTools.export($crud.getGroupItemDataReader(invoice,'waitingConfirmation'),true)">
              <span ng-show="invoice.isReadingwaitingConfirmation"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span ng-show="!invoice.isReadingwaitingConfirmation" sxy-text="SALAXY.NG1.InvoicesComponent.createInvoiceBtn"></span>
            </button>
            </td>
            <td class="middle">
              <button class="btn btn-default btn-xs btn-block" ng-if="invoice.status == 'unread' || invoice.status == 'read' || invoice.status== 'waitingConfirmation'" ng-disabled="invoice.isReadingwaitingConfirmation || invoice.isReadingpaid || $crud.groupHasDuplicateInvoices(group)" ng-click="$invoiceTools.export($crud.getGroupItemDataReader(invoice,'paid'),true)">
              <span ng-show="invoice.isReadingpaid"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span ng-show="!invoice.isReadingpaid" sxy-text="SALAXY.NG1.InvoicesComponent.markAsPaidBtn"></span>
            </button>
            </td>
            <td class="middle">
              <button ng-click="$crud.showInvoiceDialog(invoice)" title="{{ 'SALAXY.NG1.InvoicesComponent.detailsBtn' | sxyTranslate}}" class="btn btn-xs btn-default btn-block" sxy-text="SALAXY.NG1.InvoicesComponent.detailsBtn">
              
            </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/IrEpr.html",`<div ng-class="$ctrl.getCssClass()">  
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <input type="text" ng-model="$ctrl.rawSearchStringOther"  ng-change="$ctrl.searchChanged('both')" class="form-control" autocomplete="off"
            id="searchx111" name="searchx111" placeholder="{{'SALAXY.NG1_Other.Roles.worker' | sxyTranslate}}"
            ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }" maxlength="1024">
          </th>
          <th><salaxy-input-enum ng-model="irEprStatus" ng-change="$ctrl.setFilter('status', irEprStatus, 'eq', $ctrl.originalFilter)" placeholder="SALAXY.MODEL.EarningsPaymentListItem.status.title" name="status" enum="EarningsPaymentReportStatus" options="{ '': 'SALAXY.UI_Terms.showAll','new': 'SALAXY.ENUM_IR.EarningsPaymentReportStatus.new.label', 'succeeded': 'SALAXY.ENUM_IR.EarningsPaymentReportStatus.succeeded.label', 'canceled' : 'SALAXY.ENUM_IR.EarningsPaymentReportStatus.canceled.label' , 'error': 'SALAXY.ENUM_IR.EarningsPaymentReportStatus.error.label', 'invalid': 'SALAXY.ENUM_IR.EarningsPaymentReportStatus.invalid.label', 'scheduled': 'SALAXY.ENUM_IR.EarningsPaymentReportStatus.scheduled.label' }" label-type="plain"></salaxy-input-enum> </th>
          <th class="right"><span sxy-orderby="salaryDate" sxy-text="SALAXY.NG1.IrEprComponent.salaryDate"></span></th>
          <th class="right"><span sxy-orderby="endAt" sxy-text="SALAXY.NG1.IrEprComponent.sendTime"></span></th>
          <th class="right ">
            <span sxy-orderby="payment" sxy-text="SALAXY.NG1.IrEprComponent.payment"></span><br />
            <span sxy-orderby="grossSalary" sxy-text="SALAXY.NG1.IrEprComponent.grossSalary"></span>
          </th>
          <th class="right" colspan="2"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name middle">
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
            <span>{{row.otherPartyInfo.email}}</span>
          </td>
          <td class="middle">
            {{ "SALAXY.ENUM_IR.EarningsPaymentReportStatus." + row.status + ".label" | sxyTranslate }}
            <div ng-if="$crud.isIrModified(row)"><span class="badge bg-danger" title="{{'SALAXY.NG1.IrEprComponent.irModified' | sxyTranslate}}" sxy-text="SALAXY.NG1.IrEprComponent.modified" ps="!"></span></div>
            <div ng-if="$crud.isDelayed(row)"><span class="badge bg-danger" title="Myöhässä" sxy-text="SALAXY.NG1.IrEprComponent.delayed" ps="!"></span></div>
          </td>
          <td class="middle right">
            {{ row.salaryDate | date }}
          </td>
          <td class="middle right">
            <div ng-if="row.data.firstDeliveredAt" title="{{'SALAXY.NG1.IrEprComponent.firstDelivery' | sxyTranslate}}">
              <span>{{ row.data.firstDeliveredAt | date}}</span>
            </div>
            <div ng-if="!row.data.scheduledFor && row.data.lastDeliveredAt && row.data.firstDeliveredAt != row.data.lastDeliveredAt" title="{{'SALAXY.NG1.IrEprComponent.latestDelivery' | sxyTranslate}}">
              <span>{{ row.data.lastDeliveredAt | date}}</span>
            </div>
            <div ng-if="row.data.scheduledFor" title="{{'SALAXY.NG1.IrEprComponent.latestDelivery' | sxyTranslate}}">
              <span class="badge bg-warning">{{ row.data.scheduledFor | date}}</span>
            </div>
          </td>
          <td class="right middle">
            {{ row.payment | currency }}<br /> {{ row.grossSalary | currency }}
          </td>
          <td class="middle">
            <a ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-default"><i
              class="bi bi-info-circle visible-xxs"></i><span class="hidden-xxs" sxy-text="SALAXY.UI_Terms.show"></span></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/IrPsr.html",`<div ng-class="$ctrl.getCssClass()">  
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th sxy-text="SALAXY.NG1.IrPsrComponent.notificationType"></th>
          <th sxy-text="SALAXY.NG1.IrPsrComponent.status"></th>
          <th sxy-text="SALAXY.NG1.IrPsrComponent.month" class="right"><span sxy-orderby="logicalDate"></span></th>
          <th sxy-text="SALAXY.NG1.IrPsrComponent.sendTime" class="right"><span sxy-orderby="endAt"></span></th>
          <th sxy-text="SALAXY.NG1.IrPsrComponent.savaPayment" class="right"><span sxy-orderby="payment"></span></th>
          <th class="right" sxy-text="SALAXY.NG1.IrPsrComponent.expense"></th>
          <th class="right" colspan="2"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="middle">{{ "SALAXY.ENUM_IR.SummaryTransactionCode." + row.entityType + ".label" | sxyTranslate }}</td>
          <td class="middle">
            {{ "SALAXY.ENUM_IR.PayerSummaryReportStatus." + row.status + ".label" | sxyTranslate }}
            <div ng-if="$crud.isIrModified(row)"><span class="badge bg-danger" title="Ilmoitusta on muokattu käsin" sxy-text="SALAXY.NG1.IrPsrComponent.modified" ps="!"></span></div>
            <div ng-if="$crud.isDelayed(row)"><span class="badge bg-danger" title="Myöhässä" sxy-text="SALAXY.NG1.IrPsrComponent.delayed" ps="!"></span></div>
          </td>
          <td class="middle right">
            {{ row.logicalDate | date : 'MM/yyyy' }}
          </td>
          <td class="middle right">
            <div ng-if="row.data.firstDeliveredAt" title="{{'SALAXY.NG1.IrPsrComponent.firstDelivery' | sxyTranslate}}">
              <span>{{ row.data.firstDeliveredAt | date}}</span>
            </div>
            <div ng-if="!row.data.scheduledFor && row.data.lastDeliveredAt && row.data.firstDeliveredAt != row.data.lastDeliveredAt" title="{{'SALAXY.NG1.IrPsrComponent.latestDelivery' | sxyTranslate}}">
              <span>{{ row.data.lastDeliveredAt | date}}</span>
            </div>
            <div ng-if="row.data.scheduledFor" title="{{'SALAXY.NG1.IrPsrComponent.latestDelivery' | sxyTranslate}}">
              <span class="badge bg-warning">{{ row.data.scheduledFor | date}}</span>
            </div>
          </td>
          <td class="right middle">
            {{ row.payment | currency }}
          </td>
          <td class="right middle">{{ row.data.socialSecurityDeduction | currency }}</td>
          <td class="middle">
            <a ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-default"><i class="bi bi-info-circle visible-xxs"></i><span
              class="hidden-xxs" sxy-text="SALAXY.UI_Terms.show"></span></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/MessageThreads.html",`<div ng-class="$ctrl.getCssClass()" class="table-responsive">
  <table class="table">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th>
          <span><span sxy-text="SALAXY.NG1.MessageThreadsComponent.title"></span></span><br/>
          <span sxy-orderby="otherPartyInfo/avatar/displayName"><span sxy-text="SALAXY.NG1.MessageThreadsComponent.sender"></span></span>
        </th>
        <th class="right">
          <span sxy-orderby="salaryDate"><span sxy-text="SALAXY.NG1.MessageThreadComponent.salaryDate"></span></span><br/>
          <span><span sxy-text="SALAXY.NG1_Pages.Service.ApprovePayrollList.period"></span></span><br/>
          <span><span sxy-text="SALAXY.NG1.MessageThreadsComponent.answered"></span></span>
        </th>
        <th class="right ">
          <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1_Pages.Service.ApproveCalculationList.salary" ></span></span><br />
          <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1_Pages.Service.ApproveCalculationList.payment" ></span></span><br/>
          <span><span sxy-text="SALAXY.NG1_Pages.Service.ApprovePayrollList.calculations"></span></span>
        </th>
        <th class="right">
          <span sxy-orderby="status"><span sxy-text="SALAXY.NG1.MessageThreadsComponent.status"></span></span><br />
          <span sxy-orderby="createdAt"><span sxy-text="SALAXY.UI_Terms.created"></span></span><br />
          <span sxy-orderby="updatedAt"><span sxy-text="SALAXY.UI_Terms.updated"></span></span>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td class="td-avatar middle">
          <salaxy-avatar class="float-end" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="middle">
          <span>
            <b>{{row.data.title}}</b>
          </span>
          <span class="label label-primary" ng-if="row.data.otherPartyUnreadCount">
            {{ row.data.otherPartyUnreadCount }}
            <i class="bi bi-chat-fill" aria-hidden="true"></i>
          </span>
          <div>{{row.otherPartyInfo.avatar.displayName}}</div>
          <div class="truncate" style="max-width: 300px; font-size: 0.9em;"><i>{{ row.data.otherPartyLastMessage }}</i></div>
        </td>
        <td class="right">
          {{ row.salaryDate | date }}<br /> {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}<br/> {{ row.data.otherPartyUpdatedAt | sxyTime }}
        </td>
        <td class="right">
          {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}<br/> {{ row.data.calcCount ? (row.data.calcCount + " " + ("SALAXY.NG1.MessageThreadsComponent.pce" | sxyTranslate)) : "-" }}
        </td>
        <td class="middle right">
          <div ng-class="{ 'text-success': row.status == 'approved', 'text-danger': row.status == 'rejected' }">
            <span ng-switch="row.status">
              <span ng-switch-when="draft" sxy-text="SALAXY.NG1.MessageThreadsComponent.message"></span>
            <span ng-switch-when="active" sxy-text="SALAXY.NG1.MessageThreadsComponent.waiting"></span>
            <span ng-switch-default>{{ "MessageThreadStatus." + row.status | sxyEnum }}</span>
            </span>
          </div>
          {{ row.createdAt | sxyTime }}<br /> {{ row.updatedAt | sxyTime }}
        </td>
        <td class="middle">
          <a ng-if="!('aidemo' | sxyIsInRole)" href="#{{$crud.getDefaults().detailsUrl}}{{ row.id }}" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-chat-fill d-inline-block d-sm-none"></i>
            <span sxy-text="SALAXY.UI_Terms.show"></span>
          </a>
          <button ng-if="('aidemo' | sxyIsInRole)" ng-click="$crud.navigateToBusinessObject(row, $crud.getDefaults().detailsUrl)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-chat-fill d-inline-block d-sm-none"></i>
            <span sxy-text="SALAXY.UI_Terms.show"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/MessageThreadsApproval.html",`<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th sxy-orderby="data/title">
          <span sxy-text="SALAXY.NG1.MessageThreadsComponent.title"></span>
          <div>Lähettäjä</div>
        </th>
        <th class="right">Tila</th>
        <th class="right">
          <span sxy-orderby="createdAt"><span sxy-text="SALAXY.UI_Terms.created"></span></span><br />
          <span sxy-orderby="updatedAt"><span sxy-text="SALAXY.UI_Terms.updated"></span></span>
        </th>
        <th class="hidden-xxs"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td class="td-avatar middle">
          <salaxy-avatar class="float-end" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="middle">
          <span ng-switch="row.data.usecaseUri">
            <b ng-switch-when="palkkaus.fi/testing/messages-proto/timer">Kellokortti</b>
            <b ng-switch-when="palkkaus.fi/testing/messages-proto/timeReport">Työaikaraportti</b>
            <b ng-switch-when="palkkaus.fi/testing/messages-proto/hourlyReport">Tuntiraportti</b>
            <b ng-switch-when="palkkaus.fi/testing/messages-proto/calcRow">Palkkarivit</b>
            <b ng-switch-default>{{ row.data.title || row.data.usecaseUri }}</b>
          </span>
          
          <span class="label label-primary" ng-if="row.data.otherPartyUnreadCount">
            {{ row.data.otherPartyUnreadCount }}
            <i class="bi bi-chat-fill" aria-hidden="true"></i>
          </span>

          <div>{{row.otherPartyInfo.avatar.displayName}}</div>
        </td>
        <td class="right">
          <div ng-class="{ 'text-success': row.status == 'approved', 'text-danger': row.status == 'rejected' }">{{ "MessageThreadStatus." + row.status | sxyEnum }}</div>
        </td>
        <td class="middle right">
          {{ row.createdAt | sxyTime }}<br /> {{ row.updatedAt | sxyTime }}
        </td>
        <td class="middle">
          <a href="#{{$crud.getDefaults().approvalUrl}}{{ row.id }}" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-chat-fill d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/PaymentChannelSelect.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <div sxy-orderby="shortText"><span sxy-text="SALAXY.NG1.PaymentChannelSelectComponent.exportDefinition"></span></div>
            <div sxy-text="SALAXY.NG1.PaymentChannelSelectComponent.targetChannel"></div>
          </th>
          <th sxy-orderby="owner" colspan="2">
            <div sxy-text="SALAXY.NG1.ApiCrudObjectComponent.owner"></div>
            <div sxy-text="SALAXY.NG1.ApiCrudObjectComponent.status"></div>
          </th>

          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div title="{{ row.shortText }} ({{ row.id }})">
              <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong>
            </div>
          </td>
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div>{{ row.ownerInfo.avatar.displayName }}</div>
            <div>{{ "AccountingTargetStatus." + row.status | sxyEnum }}</div>
          </td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.NG1.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/Payrolls-select.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <div class="visible-xxs">
      <div class="table-filter-container-mobile">
        <salaxy-input name="search_xxs{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
        </salaxy-input>
      </div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>
            <span sxy-text="SALAXY.NG1.PayrollListComponent.description"></span>
            <span class="label label-primary clickable" ng-if="$ctrl.selectedItems.length" ng-click="$ctrl.selectedItems.splice(0,$ctrl.selectedItems.length)"> {{'SALAXY.UI_Terms.chosen' | sxyTranslate}}: {{ $ctrl.selectedItems.length }} <i class="bi bi-x-circle"></i></span>
            <div>
              <span sxy-text="SALAXY.NG1.PayrollListComponent.salaryDate"></span>
            </div>
          </th>
          <th sxy-orderby="status">
            <span sxy-text="SALAXY.NG1.PayrollListComponent.status"></span>
          </th>
          <th class="right">
            <div sxy-orderby="endAt">
              <span sxy-text="SALAXY.NG1.PayrollListComponent.period"></span>
            </div>
          </th>
          <th class="right">
            <span sxy-text="SALAXY.NG1.PayrollListComponent.paymentDate"></span>
          </th>
          <th class="right">
            <span sxy-text="SALAXY.NG1.PayrollListComponent.calculations"></span>
            <div sxy-orderby="grossSalary">
              <span sxy-text="SALAXY.NG1.PayrollListComponent.grossSalaries"></span>
            </div>
          </th>
          <th class="right" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="">
            <div class="payroll-title"><strong>{{ row.data.title }}</strong></div>
            <div class="payroll-info">{{ row.salaryDate | date }}</div>
          </td>
          <td class="">
            <div>
              {{ 'PayrollStatus.' + row.status | sxyEnum }}
              <span ng-if="row.data.calendarEvent" class="badge bg-primary">
                <i class="bi bi-calendar3" aria-hidden="true"></i>
                <span sxy-text="SALAXY.NG1.PayrollListComponent.calendarEvent"></span>
              </span>
              <i ng-if="row.data.calendarOccurence" class="bi bi-calendar3 text-primary" aria-hidden="true" title="{{ 'SALAXY.NG1.PayrollListComponent.calendarOccurence' | sxyTranslate }}"></i>
              <i ng-if="!row.data.calendarOccurence && row.data.template" class="bi bi-copy text-primary" aria-hidden="true" title="{{ 'SALAXY.NG1.PayrollListComponent.template' | sxyTranslate }}"></i>
            </div>
            <span ng-if="row.status == 'draft'" class="small" ng-class="{'text-danger' : !row.data.isReady }">
              {{ row.data.isReady ? ('SALAXY.NG1.PayrollListComponent.readyForPayment' | sxyTranslate) : ('SALAXY.NG1.PayrollListComponent.notReadyForPayment' | sxyTranslate)  }}
            </span>
          </td>
          <td class="right">
            {{ row.startAt | date }}<br /> {{ row.endAt | date }}
          </td>
          <td class="right">
            {{ row.data.paymentDate || row.data.dueDate | date }}
          </td>
          <td class="right">
            {{ row.data.calcCount ? (row.data.calcCount + " " + ("SALAXY.UI_Terms.pcs" | sxyTranslate)) : "-" }}<br /> {{ row.grossSalary | currency }}
          </td>
          <td class="middle right">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ("SALAXY.UI_Terms.unselect" | sxyTranslate) : ("SALAXY.UI_Terms.select" | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/Payrolls.html",`<div ng-class="$ctrl.getCssClass()" class="table-responsive">

  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search_xxs{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <table class="table">
    <thead>
      <tr>
        <th><span sxy-text="SALAXY.NG1.PayrollListComponent.description"></span></th>
        <th sxy-orderby="status"><span sxy-text="SALAXY.NG1.PayrollListComponent.status"></span></th>
        <th class="right">
          <span sxy-orderby="endAt">
            <span sxy-text="SALAXY.NG1.PayrollListComponent.period"></span>
          </span>
        </th>
        <th sxy-orderby="salaryDate" class="right"><span sxy-text="SALAXY.NG1.PayrollListComponent.salaryDate"></span></th>
        <th class="right"><span sxy-text="SALAXY.NG1.PayrollListComponent.dueDate"></span></th>
        <th class="right"><span sxy-text="SALAXY.NG1.PayrollListComponent.paymentDate"></span></th>
        <th class="right hidden-xxs">
          <span sxy-text="SALAXY.NG1.PayrollListComponent.calculations"></span>

          <div sxy-orderby="grossSalary">
            <span sxy-text="SALAXY.NG1.PayrollListComponent.grossSalaries"></span>
          </div>
        </th>
        <th ng-if="'aidemo' | sxyIsInRole" sxy-text="SALAXY.NG1.CalcListComponent.issues"></th>
        <th class="right hidden-xxs" colspan="2">
          <div class="table-filter-container">
            <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td ng-click="$crud.showDetails(row)" class="d-table-cell d-sm-none clickable" title="Siirry palkkalistaan">
          <span class="payroll-title"><strong>{{ row.data.title }}</strong></span>
        </td>
        <td class="d-none d-sm-table-cell">
          <span class="payroll-title"><strong>{{ row.data.title }}</strong></span>
        </td>
        <td class="">
          <div>
            {{ 'PayrollStatus.' + row.status | sxyEnum }}
            <span ng-if="row.data.calendarEvent" class="badge bg-primary">
              <i class="bi bi-calendar3" aria-hidden="true"></i>
              <span sxy-text="SALAXY.NG1.PayrollListComponent.calendarEvent"></span>
            </span>
            <i ng-if="row.data.calendarOccurence" class="bi bi-calendar3 text-primary" aria-hidden="true" title="{{ 'SALAXY.NG1.PayrollListComponent.calendarOccurence' | sxyTranslate }}"></i>
            <i ng-if="!row.data.calendarOccurence && row.data.template" class="bi bi-copy text-primary" aria-hidden="true" title="{{ 'SALAXY.NG1.PayrollListComponent.template' | sxyTranslate }}"></i>
          </div>
          <span ng-if="row.status == 'draft'" class="small" ng-class="{'text-danger' : !row.data.isReady }">
            {{ row.data.isReady ? ('SALAXY.NG1.PayrollListComponent.readyForPayment' | sxyTranslate) : ('SALAXY.NG1.PayrollListComponent.notReadyForPayment' | sxyTranslate)  }}
          </span>
        </td>
        <td class="right">
          {{ row.startAt | date }}<br /> {{ row.endAt | date }}
        </td>
        <td class="right">
          <span class="payroll-info">{{ row.salaryDate | date }}</span>
        </td>
        <td class="right">
          {{ row.status != 'paymentSucceeded' ? (row.data.dueDate | date) : '' }}
        </td>
        <td class="right">
          {{ ['paymentStarted', 'draft', 'waitingApproval', 'waitingPartnerApproval'].includes(row.status) ? '' : (row.data.paymentDate | date) }}
        </td>
        <td class="right hidden-xxs">
          {{ row.data.calcCount ? (row.data.calcCount + " " +("SALAXY.UI_Terms.pcs" | sxyTranslate)) : "-" }}<br /> {{ row.grossSalary | currency }}
        </td>
        <td ng-if="'aidemo' | sxyIsInRole" class="middle">
            <salaxy-workflow-badge model="row" api-ctrl="$crud"  wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
        </td>
        <td class="middle hidden-xxs">
          <button ng-if="!(row.isReadOnly || row.status == 'paymentStarted') && !$ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
          </button>
          <button ng-if="(row.isReadOnly || row.status == 'paymentStarted') || $ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
          </button>
        </td>
        <td class="middle hidden-xxs">
          <button ng-if="!(row.isReadOnly || row.status == 'paymentStarted') && !$ctrl.readOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
            <i class="bi bi-trash-fill d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
          </button>
          <button ng-if="(row.isReadOnly || row.status == 'paymentStarted') && !$ctrl.readOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-copy d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/ReferenceObjects.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th></th>
          <th sxy-orderby="status">Status</th>
          <th sxy-orderby="shortText">Description</th>
          <th sxy-orderby="logicalDate">Reference date</th>
          <th class="right">
            <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
            <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">{{ row.status  }}</td>
          <td class="middle">{{ row.shortText  }}</td>
          <td class="middle">{{ row.logicalDate | sxyDate }}</td>
          <td class="right">
            <div title="{{ row.createdAt }}">{{ row.createdAt | sxyDate }}</div>
            <div title="{{ row.updatedAt }}">{{ row.updatedAt | sxyDate }}</div>
            <div></div>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/SalaryReports.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <div ng-controller="SalarySlipDownloadController as $downloadCtrl">
      <button type="button" class="btn btn-primary" ng-click="$downloadCtrl.export($ctrl.selectedItems)" ng-disabled="$ctrl.selectedItems.length == 0" sxy-text="SALAXY.UI_Terms.downloadSelected"></button>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" class="hidden-xxs">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
          </th>
          <th class="visible-xxs">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
          </th>
          <th class="right">
            <span sxy-orderby="endAt" class="clickable"><span sxy-text="Pvm"></span></span>
          </th>
          <th class="right">
            <span sxy-orderby="payment" sxy-text="SALAXY.NG1.SalaryReportsComponent.payment"></span><br>
            <span sxy-orderby="grossSalary" sxy-text="SALAXY.NG1.SalaryReportsComponent.grossSalary"></span>
          </th>
          <th class="middle hidden-xxs">
            <button title="{{'SALAXY.NG1.AccountingReportsComponent.chooseAll' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length == 0" ng-disabled="$ctrl.selectedItems.length == $ctrl.items.length" ng-click="$crud.selectAll()">
              <i class="bi bi-square"></i>
            </button>
            <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length > 0" ng-disabled="$ctrl.selectedItems.length == 0" ng-click="$crud.unselectAll()">
              <i class="bi bi-check-square"></i>
            </button>
          </th>
          <th class="right " colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="searchx{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="sort-by-text" label-type="plain">
              </salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle hidden-xxs">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''">{{ 'SALAXY.NG1.SalaryReportsComponent.notSelected' | sxyTranslate }}</span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
          </td>
          <td class="right middle">{{ row.endAt | date }}</td>
          <td class="right">
            {{ row.payment | currency }}<br> {{ row.grossSalary | currency }}
          </td>
          <td class="middle hidden-xxs">
            <button title="{{'SALAXY.UI_Terms.select' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="!$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
              <i class="bi bi-square"></i>
            </button>
            <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
              <i class="bi bi-check-square"></i>
            </button>
          </td>
          <td class="middle ">
            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-block btn-default">
              <i class="bi bi-file-earmark-pdf d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.printable" pre=" "></span>
            </a>
          </td>
          <td class="middle ">
            <button ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-block btn-default">
              <i class="bi bi-info-circle-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show" pre=" "></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/SalaryReportsPanel.html",`<div class="salaxy-odata-card list-card report-list-card card card-sm card-secondary" ng-init="hideFilter = false">
  <div class="card-header d-flex align-items-center">
    {{('SALAXY.NG1.SalaryReportsComponent.calculations' | sxyTranslate) }}
    <button ng-show="$ctrl.items.length > 0" class="btn btn-secondary btn-xs ms-auto" ng-click="hideFilter = !hideFilter" title="Näytä suodattimet">
      <i class="bi bi-funnel-fill"></i>
    </button>
  </div>
  <div class="card-body filters text-end" ng-class="{'showfilters' : hideFilter}">
    <div class="filter-buttons">
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.UI_Terms.abc"></button>
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="endAt">
          <i class="bi bi-calendar3"></i>
      </button>
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="grossSalary">€</button>
    </div>
    <salaxy-input name="search1cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search hidden-xxs" label-type="plain">
    </salaxy-input>
  </div>
  <div ng-class="$ctrl.getCssClass()">
    <div class="visible-xxs" ng-if="$ctrl.items.length > 0">
      <div class="table-filter-container-mobile">
        <salaxy-input name="search2cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
        </salaxy-input>
      </div>
    </div>
    <div class="card-body text-center card-content lg-height align-middle" ng-show="$ctrl.items.length == 0 && !$ctrl.isLoading">
      <div>
        <h3 sxy-text="SALAXY.NG1.SalaryReportsComponent.noCalculations"></h3>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table" ng-if="$ctrl.items.length > 0">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">

            <td class="td-avatar middle  hidden-xxs">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="td-name middle">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''">{{ 'SALAXY.NG1.SalaryReportsComponent.notSelected' | sxyTranslate }}</span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
            </td>
            <td class="right">
              {{ row.grossSalary | currency }}
              <br>
              <small>{{ row.endAt | date }}</small>
            </td>

            <td class="middle right">
              <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i class="bi bi-file-earmark-pdf"></i></a>
              <button href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i class="bi bi-info-circle"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>
  </div>
  <div class="card-footer text-center">
    <a ng-href="#{{$crud.getDefaults().listUrl}}" title="Näytä kaikki" class="btn btn-primary btn-sm" sxy-text="SALAXY.UI_Terms.showAll"></a>
  </div>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/SelectListItem.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="{{'SALAXY.UI_Terms.textSearch' |sxyTranslate}}" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th></th>
          <th>
            <div><span class="label label-primary clickable" ng-if="$ctrl.selectedItems.length" ng-click="$ctrl.selectedItems.splice(0,$ctrl.selectedItems.length)"> {{'SALAXY.UI_Terms.chosen' | sxyTranslate}}: {{ $ctrl.selectedItems.length }} <i class="bi bi-x-circle"></i></span></div>
            <div sxy-orderby="shortText">Teksti</div>
          </th>
          <th class="right">
            <div sxy-orderby="createdAt"  sxy-text="SALAXY.UI_Terms.created"></div>
            <div sxy-orderby="updatedAt"  sxy-text="SALAXY.UI_Terms.updated"></div>
          </th>
          <th>
            <div sxy-orderby="status">Tila</div>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="{{'SALAXY.UI_Terms.textSearch' |sxyTranslate}}" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar ng-if="row.otherPartyInfo.avatar.displayName" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name middle">
            <div><strong>{{row.shortText }}</strong></div>
            <div>{{ row.otherPartyInfo.avatar.displayName }}</div>
          </td>
          <td class="right">
            <div>{{ row.createdAt | sxyDate }}</div>
            <div>{{ row.updatedAt | sxyDate }}</div>
          </td>
          <td class="middle">
            <div>{{ row.status }}</div>
          </td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/ServiceModels.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th></th>
          <th sxy-text="SALAXY.NG1.ServiceModelsComponent.serviceModel"></th>
          <th class="right">
            <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
            <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="middle">
            <img ng-if="row.data.icon || row.ownerInfo.avatar.url" ng-src="{{row.data.icon || row.ownerInfo.avatar.url}}" style="width: 45px; height: 45px;" />
          </td>
          <td class="middle">
            <div ng-if="row.id == row.ownerInfo.avatar.id">
              <strong ng-if="!row.shortText">{{'SALAXY.NG1.ServiceModelsComponent.defaultModel' | sxyTranslate}}  {{ row.ownerInfo.avatar.displayName }}</strong>
              <strong ng-if="row.shortText">{{ row.shortText || ('SALAXY.NG1.ServiceModelsComponent.nameless' | sxyTranslate) }}</strong>
            </div>
            <div ng-if="row.id != row.ownerInfo.avatar.id">
              <strong>{{ row.shortText || ('SALAXY.NG1.ServiceModelsComponent.nameless' | sxyTranslate) }}</strong>
            </div>
          </td>
          <td class="right">
            <div title="{{ row.createdAt }}">{{ row.createdAt | sxyDate }}</div>
            <div title="{{ row.updatedAt }}">{{ row.updatedAt | sxyDate }}</div>
            <div></div>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <i class="bi bi-pencil-fill d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/Taxcards-select.html",`
<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead class="">
        <tr>
          <th colspan="2"><span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1.TaxcardsListComponent.worker"></span></th>
          <th class="right">
            <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.TaxcardsListComponent.year"></span><br />
            </td>
            <th class="right">
              <span sxy-orderby="startAt" sxy-text="SALAXY.NG1.TaxcardsListComponent.valid"></span><br />
              <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.TaxcardsListComponent.validTill"></span><br />
              </td>
              <th class="right">
                <span sxy-text="SALAXY.NG1.TaxcardsListComponent.paid"></span><br>
                <span sxy-text="SALAXY.NG1.TaxcardsListComponent.incomeLimit"></span>
              </th>
              <th>
              </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="align-middle td-avatar">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name">
            <strong ng-if="row.otherPartyInfo.avatar.displayName">{{row.otherPartyInfo.avatar.displayName}}</strong>
            <strong ng-if="!row.otherPartyInfo.avatar.displayName">{{'SALAXY.NG1.TaxcardsListComponent.unknown' | sxyTranslate}}</strong>
            <br /> {{ "SALAXY.ENUM.TaxcardKind." + row.data.kind + ".label" | sxyTranslate}}
            <span ng-if="row.data.kind !== 'noTaxCard' && row.data.kind !== 'noWithholdingHousehold' && row.data.kind !== 'undefined'">{{row.data.taxPercent}} %</span>
            <span ng-if="row.data.taxPercent2">
              <br />{{'SALAXY.NG1.TaxcardsListComponent.taxPercent2' | sxyTranslate}} {{row.data.taxPercent2}} %
            </span>
          </td>
          <td class="right">
            <span>{{row.data.forYear}}</span><br />
          </td>
          <td class="right">
            <span>{{row.data.start | sxyDate}}</span><br />
            <span>{{row.data.end | sxyDate}}</span><br />
          </td>
          <td class="right">
            <span class="small paidsalaries">{{ row.data.totalIncome | currency}}</span>
            <span class="small incomelimit">{{(row.data.incomeLimit | currency) || '-'}}</span>
          </td>
          <td class="middle right">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ("SALAXY.UI_Terms.unselect" | sxyTranslate) : ("SALAXY.UI_Terms.select" | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/Taxcards.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead class="">
        <tr>
          <th colspan="2"><span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1.TaxcardsListComponent.worker"></span></th>
          <th class="right">
            <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.TaxcardsListComponent.year"></span><br />
            </td>
            <th class="right">
              <span sxy-orderby="startAt" sxy-text="SALAXY.NG1.TaxcardsListComponent.valid"></span><br />
              <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.TaxcardsListComponent.validTill"></span><br />
              </td>
              <th class="right">
                <span sxy-text="SALAXY.NG1.TaxcardsListComponent.paid"></span><br>
                <span sxy-text="SALAXY.NG1.TaxcardsListComponent.incomeLimit"></span>
              </th>
              <th>
                <!--div class="table-filter-container text-end">
                  <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" label-type="plain" placeholder="SALAXY.UI_Terms.textSearch"></salaxy-input>
                </div-->
              </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="align-middle td-avatar">
            <a href="#/employments/details/{{row.data.employmentId}}" class="cell-link" title="{{'SALAXY.NG1.WorkerListComponent.editWorker' | sxyTranslate}}">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name">
            <strong ng-if="row.otherPartyInfo.avatar.displayName">{{row.otherPartyInfo.avatar.displayName}}</strong>
            <strong ng-if="!row.otherPartyInfo.avatar.displayName && row.otherPartyInfo.officialId">{{'SALAXY.NG1.TaxcardsListComponent.personalId' | sxyTranslate}} : {{row.otherPartyInfo.officialId}}</strong>
            <strong ng-if="!row.otherPartyInfo.avatar.displayName && !row.otherPartyInfo.officialId">{{'SALAXY.NG1.TaxcardsListComponent.unknown' | sxyTranslate}}</strong>
            <br /> {{ "SALAXY.ENUM.TaxcardKind." + row.data.kind + ".label" | sxyTranslate}}
            <span ng-if="row.data.kind !== 'noTaxCard' && row.data.kind !== 'noWithholdingHousehold' && row.data.kind !== 'undefined'">{{row.data.taxPercent}} %</span>
            <span ng-if="row.data.taxPercent2">
              <br />{{'SALAXY.NG1.TaxcardsListComponent.taxPercent2' | sxyTranslate}} {{row.data.taxPercent2}} %
            </span>
          </td>
          <td class="right">
            <span>{{row.data.forYear}}</span><br />
          </td>
          <td class="right">
            <span>{{row.data.start | sxyDate}}</span><br />
            <span>{{row.data.end | sxyDate}}</span><br />
          </td>
          <td class="right">
            <span class="small paidsalaries">{{ row.data.totalIncome | currency: ' €' : 0 }}</span>
            <span class="small incomelimit">{{(row.data.incomeLimit | currency: ' €' : 0) || '-'}}</span>
            <span class="d-inline d-md-none"></span>
          </td>
          <td class="right">
            <div class="btn-group-sm">
              <button class="btn btn-primary" ng-disabled="$ctrl.loaders['showTaxCardAddDialogForTaxCardsList']" ng-click="$crud.showTaxCardAddDialogForTaxCardsList(row);" ng-if="row.otherId && ('!household' | sxyIsInRole)" sxy-text="SALAXY.UI_Terms.addNew"></button>
              <button title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" ng-click="$crud.showDetails(row)" class="btn btn-default" ng-if="'!household' | sxyIsInRole">
                <i class="bi bi-pencil-fill d-sm-none d-inline-block"></i>
                <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span></button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/Templates-select.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2"></th>
          <th sxy-orderby="shortText">Nimi</th>
          <th>Kuvaus</th>
          <th class="right" sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></th>
          <th class="right" sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div>{{ row.ownerInfo.avatar.displayName }}</div>
          </td>
          <td class="middle">{{ row.shortText  }}</td>
          <td class="middle">{{ row.data.description}}</td>
          <td class="right" title="{{ row.createdAt }}">{{ row.createdAt | sxyDate }}</div>
          <td class="right" title="{{ row.updatedAt }}">{{ row.updatedAt | sxyDate }}</div>
          <td class="middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ("SALAXY.UI_Terms.unselect" | sxyTranslate) : ("SALAXY.UI_Terms.select" | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/Templates.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2"></th>
          <th sxy-orderby="shortText">Nimi</th>
          <th>Kuvaus</th>
          <th class="right" sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></th>
          <th class="right" sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div>{{ row.ownerInfo.avatar.displayName }}</div>
          </td>
          <td class="middle">{{ row.shortText  }}</td>
          <td class="middle">{{ row.data.description}}</td>
          <td class="right" title="{{ row.createdAt }}">{{ row.createdAt | sxyDate }}</div>
          <td class="right" title="{{ row.updatedAt }}">{{ row.updatedAt | sxyDate }}</div>
          <td class="middle">
            <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/Usecases.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th></th>
          <th sxy-orderby="shortText" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.description"></th>
          <th sxy-orderby="entityType" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.entityType"></th>
          <th class="hidden-xxs" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.owner"></th>
          <th class="right">
            <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
            <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td style="width: 86px;">
            <div class="thumbnail" style="margin-bottom: 0;">
              <div class="text-center thumbnail-pic-fixed" style="width: 60px;height: 60px">
                <img ng-if="row.data.icon[0] == 'h'" ng-src="{{row.data.icon}}">
                <div ng-if="row.data.icon[0] != 'h'" class="bg-primary thumbnail-pic-icon" style="font-size: 32px">
                  <i class="fa" ng-class="row.data.icon || 'bi-currency-euro'" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div><strong>{{ row.shortText }}</strong></div>
            <div>{{ row.data.description }}</div>
          </td>
          <td>
            <div>{{ "ApiItemType." + row.entityType | sxyEnum }}</div>
            <div ng-switch="row.status">
              <span class="badge" ng-class="$crud.getStatusBgColor(row.status)">{{ "UsecaseStatus." + row.status | sxyEnum }}</span>
            </div>
          </td>
          <td class="align-middle td-avatar hidden-xxs" title="{{ row.ownerInfo.avatar.displayName }}">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="right">
            <div>{{ row.createdAt | sxyDate }}</div>
            <div>{{ row.updatedAt | sxyDate }}</div>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <i class="bi bi-pencil-fill d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="!row.isReadOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
              <i class="bi bi-trash-fill d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
            </button>
            <button ng-if="row.isReadOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-copy d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/UsecasesAdHocReport.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="row g-4">
    <div class="col" ng-repeat="row in $ctrl.items | orderBy: $crud.getOrder" ng-if="$crud.getActive(row) != 'inactive'">
      <div class="card">
        <div class="text-center card-pic-fixed">
          <img ng-if="row.data.icon[0] == 'h'" ng-src="{{row.data.icon}}">
          <div ng-if="row.data.icon[0] != 'h'" class="bg-primary card-pic-icon">
            <i class="fa" ng-class="row.data.icon || 'bi-currency-euro'" aria-hidden="true"></i>
          </div>
        </div>
        <div class="card-body">
          <h3 class="truncate">{{ row.shortText }}</h3>
          <p style="height: 80px;overflow: hidden">{{ row.data.description }}</p>
          <p ng-switch="row.entityType">
            <a ng-switch-when="dataset" ng-href="#/reports/ad-hoc/new?usecase=%2FUsecaseDefinition%2F{{ row.owner }}%2F{{ row.id }}" class="btn btn-primary" role="button" style="color: white" sxy-text="SALAXY.UI_Terms.select" ps="..."></a>
            <a ng-switch-default class="btn btn-primary" role="button" style="color: white" sxy-text="TODO" ps="..."></a>
          </p>
        </div>
      </div>
    </div>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/UsecasesCalc.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="row g-4">
    <div class="col-sm-6 col-md-4" ng-repeat="row in $ctrl.items" ng-if="$crud.getActive(row) != 'inactive'">
      <div class="card">
        <div class="text-center card-pic-fixed" style="height: 150px;">
          <img ng-if="row.data.icon[0] == 'h'" ng-src="{{row.data.icon}}">
          <div ng-if="row.data.icon[0] != 'h'" class="bg-primary card-pic-icon">
            <i class="fa" ng-class="row.data.icon || 'bi-currency-euro'" aria-hidden="true"></i>
          </div>
          <span class="badge float-end" ng-class="$crud.getStatusBgColor($crud.getActive(row))">{{ "UsecaseStatus." + $crud.getActive(row) | sxyEnum }}</span>
        </div>
        <div class="card-body">
          <h3 class="truncate">{{ row.shortText }}</h3>
          <p style="height: 80px;overflow: hidden">{{ row.data.description }}</p>
          <p ng-switch="row.entityType">
            <a ng-switch-when="calculation" ng-href="#/calc/usecase/new?usecase=%2FUsecaseDefinition%2F{{ row.owner }}%2F{{ row.id }}" class="btn btn-primary" role="button" style="color: white" sxy-text="SALAXY.UI_Terms.createNew" ps="..."></a>
            <a ng-switch-default class="btn btn-primary" role="button" style="color: white" sxy-text="TODO" ps="..."></a>
          </p>
        </div>
      </div>
    </div>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/UsecaseSelect.html",`<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <div sxy-orderby="shortText" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.name"></div>
          </th>
          <th sxy-orderby="owner" colspan="2">
            <div sxy-text="SALAXY.NG1.ApiCrudObjectComponent.owner"></div>
          </th>
          <th class="right hidden-xxs" colspan="3">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <div>
              <strong>{{ row.shortText }}</strong>
            </div>
          </td>
          <td class="middle">
            <div title="{{ row.shortText }} ({{ row.id }})">
              <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong>
            </div>
          </td>
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div>{{ row.ownerInfo.avatar.displayName }}</div>
          </td>
          <td></td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/WorktimeImport.html",`<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th sxy-orderby="id">
          <div>Title</div>
          <div sxy-text="SALAXY.NG1.ApiCrudObjectComponent.id"></div>
        </th>
        <th sxy-orderby="status"  sxy-text="SALAXY.UI_Terms.status"></th>
        <th class="right">
          <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
          <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
        </th>
        <th class="right">Files</th>
        <th class="right">
          <div>Empl.</div>
          <div>Rows</div>
        </th>
        <th class="right">
          Errors
        </th>
        <th class="right">
          <div>Period</div>
          <div>Salary date</div>
        </th>
        <th colspan="2"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td>
          <div>{{ row.shortText || "-" }}</div>
          <div><code><small>{{ row.id }}</small></code></div>
        </td>
        <td>{{ row.status }}</td>
        <td class="right">
          <div>{{ row.createdAt | sxyTime }}</div>
          <div>{{ row.updatedAt | sxyTime }}</div>
        </td>
        <td class="right">{{ row.data.filesCount || "-" }}</td>
        <td class="right">
          <div>{{ row.data.employmentsCount || "-" }}</div>
          <div>{{ row.data.rowsCount || "-" }}</div>
        </td>
        <td class="right">
          <div ng-class="row.data.employmentsErrors ? 'text-danger' : 'text-success'">{{ row.data.employmentsErrors || "OK" }}</div>
          <div ng-class="row.data.employmentsErrors ? 'text-danger' : 'text-success'">{{ row.data.rowsErrors || "OK" }}</div>
        </td>
        <td class="right">
          <div>{{ row | sxyDateRange }}</div>
          <div>{{ row.salaryDate | sxyDate }}</div>
        </td>
        <td>
          <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-s-none d-inline-block"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-info-circle d-sm-none d-inline-block"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
          </button>
        </td>
        <td>
          <button ng-if="!row.isReadOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
            <i class="bi bi-trash-fill d-sm-none d-inline-block"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-copy d-sm-none d-inline-block"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`);

 $templateCache.put("salaxy-components/odata/lists/_default.html",`<ng-include src="$ctrl.$crudController.getDefaults().oDataTemplateUrl || 'salaxy-components/odata/lists/ApiCrudObject.html'"></ng-include>`);

 $templateCache.put("salaxy-components/odata/OdataActions.html",`<div class="salaxy-component salaxy-odata-actions d-flex justify-content-end" ng-init="$ctrl.$crud = $ctrl.$odata.$crudController">
  <div class="me-2">
    <span class="salaxy-form-group-plain">
      <input type="text" ng-model="$ctrl.$odata.options.$search" ng-change="$ctrl.$odata.searchChanged()" class="form-control" autocomplete="off"
        id="searchx111" name="searchx111" placeholder="{{'SALAXY.UI_Terms.textSearch' | sxyTranslate}}"
        ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }" maxlength="1024">
    </span>
  </div>
  <div ng-if="$ctrl.showExport" class="btn-group dropdown">
    <button id="single-button" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
      <i class="bi bi-three-dots" aria-hidden="true"></i>
    </button>
    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="single-button">
      <li>
        <a href="" ng-controller="ExportController as $export" ng-click="$export.showExport($ctrl.getExportable())" sxy-text="SALAXY.NG1.ODataActionsComponent.export" class="dropdown-item"></a>
      </li>
    </ul>
  </div>
</div>`);

 $templateCache.put("salaxy-components/odata/OdataFooter.html",`<div class="salaxy-component salaxy-odata-footer">
  <salaxy-spinner></salaxy-spinner>
  <div ng-if="$ctrl.getNoItemsMessage()" class="salaxy-odata-no-data">
    <div ng-class="$ctrl.getNoItemsCssClass()">{{ $ctrl.getNoItemsMessage() | sxyTranslate }}</div>
  </div>
  <div ng-if="$ctrl.getPagingView() == 'nextPageLink'">
    {{'SALAXY.NG1.ODataFooterComponent.showing' | sxyTranslate}} {{ $ctrl.$odata.count ? ($ctrl.$odata.items.length + "/" + $ctrl.$odata.count) : $ctrl.$odata.items.length }} {{'SALAXY.NG1.ODataFooterComponent.rows' | sxyTranslate}}.
    <a href="" ng-click="$ctrl.$odata.loadNextPage(true)" sxy-text="SALAXY.NG1.ODataFooterComponent.downloadMore" ps="..."></a>
  </div>
  <div ng-if="$ctrl.getPagingView() == 'clientLimit'">
    {{'SALAXY.NG1.ODataFooterComponent.showing' | sxyTranslate}} {{ $ctrl.$odata.count ? ($ctrl.$odata.items.length + "/" + $ctrl.$odata.count) : $ctrl.$odata.items.length }} {{'SALAXY.NG1.ODataFooterComponent.rows' | sxyTranslate}}.
    <a href="" ng-click="$ctrl.$odata.options.$top = null; $ctrl.$odata.reload()" sxy-text="SALAXY.NG1.ODataFooterComponent.downloadMore" ps="..."></a>
  </div>
  <div ng-if="$ctrl.getPagingView() == 'url'">
    {{'SALAXY.NG1.ODataFooterComponent.showing' | sxyTranslate}} {{ $ctrl.$odata.count ? ($ctrl.$odata.items.length + "/" + $ctrl.$odata.count) : $ctrl.$odata.items.length }} {{'SALAXY.NG1.ODataFooterComponent.rows' | sxyTranslate}}.
    <a ng-href="{{$ctrl.nextPageUrl}}" sxy-text="SALAXY.NG1.ODataFooterComponent.showAll" ps="..."></a>
  </div>
  <div ng-if="$ctrl.getPagingView() == 'server'">
    {{'SALAXY.NG1.ODataFooterComponent.showingRows' | sxyTranslate}} rivit {{ ($ctrl.$odata.options.$skip || 0) + 1 }} - {{ ($ctrl.$odata.options.$skip || 0) + $ctrl.$odata.items.length }}
    <span ng-if="$ctrl.count"> {{'SALAXY.NG1.ODataFooterComponent.total' | sxyTranslate}} {{ $ctrl.$odata.count }} {{'SALAXY.NG1.ODataFooterComponent.rows' | sxyTranslate}}</span>
    <a href="" ng-click="$ctrl.loadNextPage(false)" sxy-text="SALAXY.NG1.ODataFooterComponent.nextPage" ps="..."></a>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages/accounting/details.html",`<main class="salaxy-content sxytpl-accounting-report-viewer">
  <section>
    <salaxy-accounting-report-viewer model="'url'"></salaxy-accounting-report-viewer>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/accounting/holiday-pay-debt-query.html",`<main class="salaxy-content sxytpl-accounting-holiday-pay-debt-report-query">
  <section>
    <salaxy-accounting-holiday-pay-debt-report-query></salaxy-accounting-holiday-pay-debt-report-query>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/accounting/index.html",`<main class="salaxy-content sxytpl-accounting-report-list">
  <section class="d-flex flex-column align-items-end">
    <a class="btn btn-default d-block mb-2" href="#/accounting/query" >{{ "SALAXY.NG1_Sitemap.reports.accountingQuery" | sxyTranslate}}...</a>
    <a ng-if="!('hideHolidayDebt' | sxyIsInRole)" class="btn btn-default d-block" href="#/accounting/holiday-pay-debt-query" >{{ "SALAXY.NG1_Sitemap.reports.accountingHolidayPayDebtQuery" | sxyTranslate}}...</a>
  </section>
  <section>
    <salaxy-accounting-report-list></salaxy-accounting-report-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/accounting/query.html",`<main class="salaxy-content sxytpl-accounting-report-query">
  <section>
    <salaxy-accounting-report-query></salaxy-accounting-report-query>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/accounting-targets/details.html",`<main class="salaxy-content sxytpl-accounting-target-details">
  <section class="pt-4">
    <salaxy-accounting-target-details model="'url'"></salaxy-accounting-target-details>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/accounting-targets/index.html",`<main class="salaxy-content sxytpl-accounting-target-list">
  <section>
    <div class="salaxy-component salaxy-accounting-target-list">
      <salaxy-odata-table crud-controller="AccountingTargetCrudController as $crud">
      </salaxy-odata-table>
    </div>
  </section>
</main>
 
 `);

 $templateCache.put("salaxy-components/pages/calc/all.html",`<main class="salaxy-content sxytpl-calculations-all-list">
  <section>
    <salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation"></salaxy-action-button>
    <salaxy-calc-list category="all"></salaxy-calc-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/calc/details.html",`<main class="salaxy-content sxytpl-calc-details">
  <section>
    <salaxy-calc-usecase ng-if="'test' | sxyIsInRole" model="'url'" is-read-only-forced="$ctrl.route.readOnly"></salaxy-calc-usecase>
    <salaxy-calc ng-if="!('test' | sxyIsInRole)" model="'url'" is-read-only-forced="$ctrl.route.readOnly"></salaxy-calc>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/calc/draft.html",`<main class="salaxy-content sxytpl-calculations-draft-list">
  <section>
    <salaxy-action-button ng-if="!$ctrl.route.readOnly" action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation"></salaxy-action-button>
    <salaxy-calc-list category="draft" read-only="$ctrl.route.readOnly"></salaxy-calc-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/calc/editor.html",`<salaxy-calc-editor model="'url'">
</salaxy-calc-editor>`);

 $templateCache.put("salaxy-components/pages/calc/error.html",`<main class="salaxy-content sxytpl-calculations-error-list">
  <section>
    <salaxy-calc-list category="error"></salaxy-calc-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/calc/history.html",`<div ng-controller="Calculator2022Controller as $ctrl" ng-init="$ctrl.updateRows = false;$ctrl.model = 'url';">
  <!-- TODO: Move texts to the model as much as possible. -->
  <h2 sxy-text="SALAXY.NG1_Pages.Calc.History.heading"></h2>
  <p class="lead" sxy-text="SALAXY.NG1_Pages.Calc.History.lead"></p>
  <div ng-if="$ctrl.current">
    <sxy-form open-api="salaxy-secure/schemas/v02.json" type="Calculation" auto-gen="false" debugger="false" model="$ctrl.current">
      <div>
        <fieldset>
          <legend sxy-text="SALAXY.NG1_Pages.Calc.History.workerJobLabel"></legend>
          <salaxy-calc-employment model="$ctrl" update-rows="false"></salaxy-calc-employment>
        </fieldset>
        <fieldset>
          <legend sxy-text="SALAXY.NG1_Pages.Calc.History.payrollInfo"></legend>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.salaryDateLabel" model="form.workflow.salaryDate"></sxy-input>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.workStartDateLabel" model="form.info.workStartDate"></sxy-input>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.workEndDateLabel" model="form.info.workEndDate"></sxy-input>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.statusLabel" model="form.workflow.status" read-only="true"></sxy-input>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.fixedTaxAmountLabel" model="form.worker.tax.fixedTaxAmount" format="euro"></sxy-input>
        </fieldset>
        <fieldset>
          <legend sxy-text="SALAXY.NG1_Pages.Calc.History.rows"></legend>
          <salaxy-calc-rows-2019-editor parent="$ctrl.current" title="{{'SALAXY.NG1_Pages.Calc.History.payrollRows' | sxyTranslate}}" on-commit="$ctrl.historyUsecase.recalculate()" show-edit-buttons="false" show-gross-totals="false"
            is-in-edit="!$ctrl.current.isReadOnly"></salaxy-calc-rows-2019-editor>
        </fieldset>
        <div class="text-end">
          <button ng-if="$ctrl.showAction('recalculate')" type="button" class="btn btn-primary" ng-click="$ctrl.historyUsecase.recalculate()" sxy-text="SALAXY.NG1_Pages.Calc.History.reCalculate"></button>
        </div>
        <fieldset>
          <legend sxy-text="SALAXY.NG1_Pages.Calc.History.cumulativePayrollRows"></legend>
          <p sxy-html="SALAXY.NG1_Pages.Calc.History.cumulativePayrollInfo.html"></p>
          <table class="table">
            <colgroup>
              <col width="35%">
              <col width="15%">
              <col width="35%">
              <col width="15%">
            </colgroup>
            <tbody>
              <tr>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.totalGrossSalary"></th>
                <td class="right">{{ $ctrl.current.result.totals.totalGrossSalary | currency }}</td>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.benefits"></th>
                <td class="right">{{ $ctrl.current.result.workerCalc.benefits | currency }}</td>
              </tr>
              <tr>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.holidayCompensation" ps="*"></th>
                <td class="right">{{ $ctrl.getRowTotal("holidayCompensation") | currency }}</td>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.holidayBonus" ps="*"></th>
                <td class="right">{{ $ctrl.getRowTotal("holidayBonus") | currency }}</td>
              </tr>
              <tr>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.holidaySalary" ps="*"></th>
                <td class="right">{{ $ctrl.getRowTotal("holidaySalary") | currency }}</td>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.totalTaxable" ps="*"></th>
                <td class="right">{{ $ctrl.current.result.totals.totalTaxable | currency }}</td>
              </tr>
              <tr>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.tax" ps="*"></th>
                <td class="right">{{ $ctrl.current.result.workerCalc.tax | currency }}</td>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.pension"></th>
                <td class="right">{{ $ctrl.current.result.workerCalc.pension | currency }}</td>
              </tr>
              <tr>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.unemploymentInsurance"></th>
                <td class="right">{{ $ctrl.current.result.workerCalc.unemploymentInsurance | currency }}</td>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.deductions"></th>
                <td class="right">{{ $ctrl.current.result.workerCalc.deductions | currency }}</td>
              </tr>
              <tr>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.totalExpenses"></th>
                <td class="right">{{ $ctrl.current.result.totals.totalExpenses | currency }}</td>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.salaryPayment"></th>
                <td class="right">{{ $ctrl.current.result.workerCalc.salaryPayment | currency }}</td>
              </tr>
            </tbody>
          </table>
        </fieldset>
        <div class="text-end" ng-if="$ctrl.showAction('save')">
          <button type="button" class="btn btn-primary" ng-click="$ctrl.historyUsecase.save()" sxy-text="SALAXY.UI_Terms.save"></button>
        </div>
      </div>
    </sxy-form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages/calc/import-calcs.html",`<main class="salaxy-content">
  <section>
    <!-- Forcing isFullWidth  -->
    <div style="display: none;" ng-init="$ctrl.current.isFullWidth = true"></div>
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'default', text: 'Palkkalaskelmien tuonti' },
        { value: 'list', text: 'Palkkalistat' },
      ]"
      tabs-id="importCalcs">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-importCalcs">
      <div class="tab-pane" id="default-tab">
        <salaxy-calc-import></salaxy-calc-import>
      </div>
      <div class="tab-pane" id="list-tab">
        <salaxy-payroll-list details-url="/payroll/details/" hide-button="$ctrl.route.readOnly" is-read-only-forced="$ctrl.route.readOnly"></salaxy-payroll-list>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/calc/index.html",`<main class="salaxy-content sxytpl-calculations-dashboard">
  <section>
    <salaxy-calc-dashboard hide-button="$ctrl.route.readOnly" read-only="$ctrl.route.readOnly"></salaxy-calc-dashboard>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/calc/ircalc.html",`<salaxy-ir-calc model="'url'"></salaxy-ir-calc>`);

 $templateCache.put("salaxy-components/pages/calc/paid-ir.html",`<main class="salaxy-content sxytpl-calculations-paid-list">
  <section>
    <salaxy-calc-list category="paidIr" read-only="$ctrl.route.readOnly" ></salaxy-calc-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/calc/paid.html",`<main class="salaxy-content sxytpl-calculations-paid-list">
  <section>
    <salaxy-action-button ng-if="!$ctrl.route.readOnly" class="mb-3 d-block" action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation"></salaxy-action-button>
    <salaxy-calc-list category="paid" read-only="$ctrl.route.readOnly"></salaxy-calc-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/calc/payment.html",`<main class="salaxy-content sxytpl-calc-payment">
  <section>
    <div class="container" ng-controller="CalculationCrudController as $calc" ng-init="$calc.model='url'">
      <salaxy-invoices-create ng-if="$calc.current" model="$calc.current"></salaxy-invoices-create>
    </div>
  </section>
</main>
`);

 $templateCache.put("salaxy-components/pages/calc/repair.html",`<main class="salaxy-content sxytpl-calc-repair">
  <section>
    <salaxy-calc-repair model="'url'" is-read-only-forced="$ctrl.route.readOnly"></salaxy-calc-repair>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/calc/repairs.html",`<main class="salaxy-content sxytpl-calc-repairs">
  <section>
    <salaxy-action-button action="'newRepair'" on-after-action="$list.reload()"></salaxy-action-button>
    <salaxy-odata-table ng-ref="$list" url="/v03/api/calculations/category/all" crud-controller="CalculationCrudController as $crud" options="{$filter: 'status eq \\'repair\\''}" template-url="salaxy-components/odata/lists/CalculationsRepairs.html" read-only="$ctrl.route.readOnly">
    </salaxy-odata-table>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/calc/shared.html",`<main class="salaxy-content sxytpl-calculations-shared-list">
  <section>
    <salaxy-calc-list category="shared" read-only="$ctrl.route.readOnly"></salaxy-calc-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/calc/travel.html",`<div ng-controller="Calculator2022Controller as $ctrl" ng-init="$ctrl.updateRows = false;$ctrl.model = 'url';">
  <!-- TODO: Move texts to the model as much as possible. -->
  <h2>Matkalasku</h2>
  <p class="lead"></p>
  <salaxy-spinner ng-if="!$ctrl.current"></salaxy-spinner>
  <div ng-if="$ctrl.current">
    <sxy-form open-api="salaxy-secure/schemas/v02.json" type="Calculation" auto-gen="false" debugger="false" model="$ctrl.current">
      <div>
        <fieldset>
          <legend sxy-text="SALAXY.NG1_Pages.Calc.History.workerJobLabel"></legend>
          <salaxy-calc-employment model="$ctrl" update-rows="false"></salaxy-calc-employment>
        </fieldset>
        <fieldset>
          <legend sxy-text="SALAXY.NG1_Pages.Calc.History.payrollInfo"></legend>
          <sxy-input label="Matkan alku" model="form.info.workStartDate"></sxy-input>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.workEndDateLabel" model="form.info.workEndDate"></sxy-input>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.statusLabel" model="form.workflow.status" read-only="true"></sxy-input>
        </fieldset>
        <salaxy-calc-rows-editor parent="$ctrl.current" title="Matkalaskun rivit" on-commit="$ctrl.recalculate()"
          show-edit-buttons="false" show-gross-totals="true" ng-ref="$rows"
          is-in-edit="!$ctrl.current.isReadOnly">
          <footer>
            <p>Lisää matkalaskun rivi:</p>
            <button class="btn btn-default" ng-click="$rows.showEdit({ rowType: 'expenses' })">Kulu</button>
            <button class="btn btn-default" ng-click="$rows.showEdit({ rowType: 'milageOwnCar' })">Kilometrikorvaus</button>
            <button class="btn btn-default" ng-click="$rows.showEdit({ rowType: 'dailyAllowance' })">Päiväraha</button>
          </footer>
        </salaxy-calc-rows-editor>
        <div class="text-end">
          <button type="button" class="btn btn-default" ng-click="$ctrl.recalculate()" sxy-text="SALAXY.NG1_Pages.Calc.History.reCalculate"></button>
          <button type="button" class="btn btn-primary" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.send"></button>
        </div>
      </div>
    </sxy-form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages/calendar/details.html",`<main class="salaxy-content sxytpl-calendar-details">
  <section>
    <salaxy-calendar-event-details  model="'url'" is-read-only-forced="$ctrl.route.readOnly"></salaxy-calendar-event-details >
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/calendar/index.html",`<main class="salaxy-content sxytpl-calendar-index">
  <div class="text-end">
    <a class="btn btn-primary" ng-href="#{{$odata.$crudController.getDefaults().detailsUrl}}new" sxy-text="Uusi"></a>
  </div>

  <section>
    <div ng-show="$odata.items.length">
      <salaxy-odata-table ng-ref="$odata" crud-controller="CalendarEventsCrudController as $crud">
      </salaxy-odata-table>
    </div>
  </section>

</main>`);

 $templateCache.put("salaxy-components/pages/customer-invoices/details.html",`<main class="salaxy-content sxytpl-datasets-details">
  <section>
    <h1>TODO: Laskunäkymä</h1>
    <div ng-controller="CustomerInvoiceCrudController as $ctrl" ng-init="$ctrl.model = 'url'">
      <salaxy-spinner ng-if="!$ctrl.current"></salaxy-spinner>
      <div ng-if="$ctrl.current">
        <button type="button" class="btn btn-primary" ng-click="$ctrl.save()">Tallenna</button>
        <sxy-form open-api="salaxy-secure/schemas/v02.json" type="CustomerInvoice" auto-gen="true" debugger="true" model="$ctrl.current">
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/customer-invoices/index.html",`<main class="salaxy-content sxytpl-datasets-list">
  <section>
    <a href="#/customer-invoices/details/new" class="btn btn-primary" sxy-text="Luo uusi"></a>
    <salaxy-odata-table crud-controller="CustomerInvoiceCrudController as $crud"></salaxy-odata-table>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/datasets/details.html",`<main class="salaxy-content sxytpl-datasets-details">
  <section>
    <salaxy-dataset-details mode="full-edit" model="'url'"></salaxy-dataset-details>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/datasets/index.html",`<main class="salaxy-content sxytpl-datasets-list">
  <section>
    <a href="#/datasets/details/new" class="btn btn-primary float-end" sxy-text="Luo uusi"></a>
    <h1>{{'Datasets' | sxyTranslate}}<span class="badge bg-primary">BETA</span></h1>
    <salaxy-odata-table crud-controller="DatasetsCrudController as $crud"></salaxy-odata-table>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/employments/details.html",`<main class="salaxy-content sxytpl-workers-details">
  <section>
    <salaxy-employment-details model="'url'" list-url="/employments/index" is-read-only-forced="$ctrl.route.readOnly" hide-buttons="$ctrl.route.readOnly"></salaxy-employment-details>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/employments/index.html",`<main class="salaxy-content sxytpl-workers-list">
  <section>
    <salaxy-employment-list show-toolbar="true" read-only="$ctrl.route.readOnly"></salaxy-employment-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/employments/taxcards.html",`<main class="salaxy-content sxytpl-workers-taxcardslist">
  <section class="sxytpl-intro">
    <p class="lead" sxy-text="SALAXY.NG1_Pages.Workers.Taxcards.lead"></p>
  </section>
  <section class="sxytpl-list">
    <salaxy-tax-cards-list></salaxy-tax-cards-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/home/error404.html",`<main class="salaxy-content sxytpl-home-error404">
  <section>
    <h1 class="page-header" sxy-text="SALAXY.NG1_Pages.Home.Error.pageNotFound"></h1>
    <p class="lead" sxy-html="SALAXY.NG1_Pages.Home.Error.lead.html"></p>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/home/index.html",`<main class="salaxy-content sxytpl-home-index" salaxy-if-role="auth">
  <salaxy-signing ng-ref="$ctrl.$signing" show-in-popup="true"></salaxy-signing>
  
  <div ng-if="$ctrl.$signing.isSigningOk">
    <section ng-if="$ctrl.showKyc">
      <salaxy-alert type="warning" class="alert-insurance-and-pension" force-more-info="true">
        <main>
          <div class="row">
            <div class="col-sm-11">
              <p class="lead lead-with-text">Asiakkaan tuntemistiedot (KYC)</p>            
            </div>
          </div>
        </main>
        <aside>
          <div class="row">
            <div class="col-sm-11">
              <p>
                <span>
                 Asiakasvaratilin kautta maksaminen (esim. Paytrail, viitemaksu) edellyttää asiakkaan tuntemistietojen (KYC) päivittämisen. Päivityksen voi tehdä nimenkirjoitusoikeudellinen henkilö “Päivitä asiakkaan tuntemistiedot nyt” -linkin kautta. Sivulta “Lue ohjeet” löytyy tarkat ohjeet ja linkki päivityksen tekijälle toimitettavaksi, jos et itse voi tehdä päivitystä.
                </span>
              </p>
              <p>
                <span>
                  KYC-tietojen päivitys on voimassa vuoden kerrallaan ja tiedot voi käydä päivittämässä etukäteen. Näet tilin tiedoista (Asetukset → Tilin tiedot → Palkkaus.fi-tilin tiedot) milloin viimeistään tuntemistiedot (KYC) tulee päivittää.
                </span>
              </p>
            </div>
            <div class="col-sm-11">
              <a href="https://help.palkkaus.fi/hc/fi/articles/19590957330589-Asiakkaan-tuntemistietojen-päivitys-KYC" target="_blank" class="btn btn-primary" role="button">Lue ohjeet </a>
              <a ng-href="{{('test' | sxyIsInRole) ? 'https://rc-iam.palkkaus.fi/wizard/index.html' : 'https://iam.palkkaus.fi/wizard/index.html'}}" target="_blank" class="btn btn-primary" role="button">Päivitä asiakkaan tuntemistiedot nyt</a>
            </div>
          </div>
        </aside>
      </salaxy-alert>
    </section>
    <section ng-if="$ctrl.getRoute('#/').getFlag('features','welcome')" class="sxytpl-welcome">
      <salaxy-welcome settings-by-proxy="false"></salaxy-welcome>
    </section>
    <section ng-if="$ctrl.getRoute('#/').getFlag('features', 'messages')" class="sxytpl-list">
      <div>
        <h3 class="section-title list-title">Toimenpiteitä odottavat...</h3>
        <salaxy-message-thread-list limit-to="10" read-only="$ctrl.route.node.newMessageThreadDisabled"></salaxy-message-thread-list>
      </div>
    </section>
    <section ng-if="$ctrl.getRoute('#/').getFlag('features', 'workerList')" class="sxytpl-list">
      <salaxy-employment-list limit-to="10" read-only="$ctrl.route.node.newCalcDisabled"></salaxy-employment-list>
    </section>
  </div>
  <section ng-if="$ctrl.getRoute('#/').getFlag('features', 'contact')" class="sxytpl-contact-info">
    <p>&nbsp;</p>
    <salaxy-contact-info hide-contact-info="'contactInfoComponent.hideContactInfo' | sxyIsInRole"></salaxy-contact-info>
  </section>
  <p>&nbsp;</p>
  <p>&nbsp;</p>

  <p class="copyright-text"><small sxy-text="SALAXY.NG1_Pages.Home.copyRight"></small> <small class="copyright-year">{{$ctrl.getCurrentYear()}}</small></p>

</main>`);

 $templateCache.put("salaxy-components/pages/household-years/active.html",`
<div ng-controller="HouseholdYearCrudController as $ctrl" ng-init="$ctrl.setActiveYear()">
  <salaxy-household-year-details  model="$ctrl" ></salaxy-household-year-details>
</div>`);

 $templateCache.put("salaxy-components/pages/household-years/details.html",`<salaxy-household-year-details model="'url'" ></salaxy-household-year-details>`);

 $templateCache.put("salaxy-components/pages/household-years/index.html",`<salaxy-household-year-list></salaxy-household-year-list>`);

 $templateCache.put("salaxy-components/pages/info/abc.html",`<div class="row">
  <div class="col-12">
    <h3>Käyttöohjeet</h3>
    <p class="">
      Ohjelman käyttöohjeet löytyvät tukisivustolta osoitteesta <a href="https://help.palkkaus.fi/hc/fi" target="_blank">help.palkkaus.fi</a>.
    </p>
    <p>Pääset ohjeisiin myös oikean alakulman Apua-napin kautta. Kirjoita hakusana hakukenttään niin saat listauksen siihen liittyvistä ohjeista. Voit siirtyä tukisivustolle ohjeen yläkulmassa olevan nuoli-ikonin kautta. Jos et löydä sopivaa ohjetta, voit
      olla yhteydessä asiakaspalveluumme Apua-napin kautta, sähköpostitse tai puhelimitse, niin autamme sinua!
    </p>
  </div>

</div>`);

 $templateCache.put("salaxy-components/pages/info/index.html",`<div class="row mb-4">
  <div class="col-12">
    <h1 sxy-text="SALAXY.NG1_Pages.Info.instructions"></h1>
    <p class="" sxy-html="SALAXY.NG1_Pages.Info.infoText.html"></p>
    <p sxy-text="SALAXY.NG1_Pages.Info.infoText.info"></p>
  </div>

  <div class="col-12" ng-if="!$ctrl.route.node.hideButtons">
    <span sxy-html="SALAXY.NG1_Pages.Info.buttons.web.html"></span>
    <span sxy-html="SALAXY.NG1_Pages.Info.buttons.dataProtection.html"></span>
    <span sxy-html="SALAXY.NG1_Pages.Info.buttons.termsOfService.html"></span>
  </div>
</div>
<div class="row" ng-if="!$ctrl.route.node.hideContactInfo">
  <div class="col-12">
    <h2 sxy-text="SALAXY.NG1_Pages.Info.customerService.title"></h2>
  </div>
  <div class="col-12">

    <salaxy-contact-info hide-contact-info="'contactInfoComponent.hideContactInfo' | sxyIsInRole"></salaxy-contact-info>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages/invoices/company.html",`<main class="salaxy-content sxytpl-company-invoices">
  <section>  
    <salaxy-company-invoices></salaxy-company-invoices>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/invoices/details.html",`<main class="salaxy-content sxytpl-invoice-details">

  <style>
    @media print {
      /*Move to less*/
      .nav-tabs,
      #launcher {
        display: none;
      }
    }
  </style>
  <section ng-controller="InvoiceCrudController as $invoice" ng-init="$invoice.model = 'url'">
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'default', text: 'SALAXY.NG1_Pages.Invoices.preview', hidden: !$ctrl.route.getFlag('features', 'preview') },
        { value: 'calc', text: 'SALAXY.NG1_Pages.Invoices.calcs', hidden: !($invoice.current && $ctrl.route.getFlag('features', 'calc') && ($invoice.current.header.type == 'foreclosure' || $invoice.current.header.type == 'net' || $invoice.current.header.type == 'gross') && $invoice.getReportCalcs().length) },
        { value: 'printandbarcode', text: 'SALAXY.NG1_Pages.Invoices.printAndBarCode', hidden: !$ctrl.route.getFlag('features', 'printAndBarCode') },
        { value: 'actions', text: 'SALAXY.NG1_Pages.Invoices.actions', hidden: !(('test' | sxyIsInRole ) && ( $invoice.current.header.channel == 'palkkausWS' ||  $invoice.current.header.channel == 'palkkausPSD') || $ctrl.route.getFlag('features', 'actions')) },
        { value: 'debug', text: 'Debug', hidden: !('test' | sxyIsInRole) }
      ]"
      tabs-id="invoicesDetails">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-invoicesDetails">
      <div class="tab-pane" id="default-tab">
        <salaxy-invoice-preview model="$invoice" ng-if="$ctrl.route.getFlag('features', 'preview')"></salaxy-invoice-preview>
      </div>
      <div class="tab-pane" id="calc-tab">
        <salaxy-calc-reports calcs="$invoice.getReportCalcs()" report-type="'salarySlip'" ng-if="$invoice.current && $ctrl.route.getFlag('features', 'calc') && ($invoice.current.header.type == 'foreclosure' || $invoice.current.header.type == 'net' || $invoice.current.header.type == 'gross') && $invoice.getReportCalcs().length"></salaxy-calc-reports>
      </div>
      <div class="tab-pane" id="printandbarcode-tab">
        <div ng-if="$ctrl.route.getFlag('features', 'printAndBarCode')">
          <p class="lead">
            <button type="button" class="btn btn-primary float-end" onclick="window.print()" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.printInvoices"></button>
          </p>
          <div class="credit-transfer-container" ng-if="$invoice.current">
            <salaxy-credit-transfer invoice="$invoice.current"></salaxy-credit-transfer>
          </div>
        </div>
      </div>
      <div class='tab-pane' id='actions-tab'>
        <salaxy-invoice-edit model="$invoice" ng-if="('test' | sxyIsInRole ) && ( $invoice.current.header.channel == 'palkkausWS' ||  $invoice.current.header.channel == 'palkkausPSD') || $ctrl.route.getFlag('features', 'actions')"></salaxy-invoice-edit>
      </div>
      <div class="tab-pane" id="debug-tab">
        <p ng-if="'test' | sxyIsInRole">
          <span class="badge bg-primary">test</span> Debug-toiminnot vain testissä.
        </p>
        <salaxy-json-formatter json="$invoice.current" open="1"></salaxy-json-formatter>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/invoices/index.html",`<main class="salaxy-content sxytpl-invoices-list">
  <section>  
    <salaxy-invoice-list ng-if="'!person' | sxyIsInRole"></salaxy-invoice-list>
    <salaxy-invoice-list ng-if="'person' | sxyIsInRole" mode="person"></salaxy-invoice-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/invoices/payment-list.html",`<main class="salaxy-content sxytpl-payment-list">
  <section>  
    <salaxy-invoice-payment-list></salaxy-invoice-payment-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/invoices/sepa.html",`<main class="salaxy-content sxytpl-invoices-list">
  <section>  
    <salaxy-invoice-list mode="sepa"></salaxy-invoice-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/irepr/details.html",`<main class="salaxy-content sxytpl-ir-earnings-payment">
  <section>
    <salaxy-ir-earnings-payment model="'url'"></salaxy-ir-earnings-payment>
  </section>
</main>
`);

 $templateCache.put("salaxy-components/pages/irepr/index.html",`<main class="salaxy-content sxytpl-ir-earnings-payment-list">
  <section>
    <salaxy-ir-earnings-payment-list></salaxy-ir-earnings-payment-list>
  </section>
</main>
 
 `);

 $templateCache.put("salaxy-components/pages/irpsr/details.html",`<main class="salaxy-content sxytpl-ir-payer-summary">
  <section>
    <salaxy-ir-payer-summary model="'url'"></salaxy-ir-payer-summary>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/irpsr/index.html",`<main class="salaxy-content sxytpl-ir-payer-summary-list">
  <section>
    <salaxy-ir-payer-summary-list></salaxy-ir-payer-summary-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/messages/approval-list.html",`<div>
  <div class="btn-toolbar">
    <div class="btn-group">
      <button type="button" class="btn btn-default"
        ng-click="$ctrl.$odata.options.$filter = 'status eq \\'active\\'';$ctrl.$odata.searchChanged()"
        ng-class="{ active: $ctrl.$odata.options.$filter != null }">Aktiiviset</button>
      <button type="button" class="btn btn-default"
        ng-click="$ctrl.$odata.options.$filter = null;$ctrl.$odata.searchChanged()"
        ng-class="{ active: $ctrl.$odata.options.$filter == null }">Kaikki</button>
    </div>
  </div>
  <salaxy-odata-table crud-controller="MessageThreadCrudController as $crud" ng-ref="$ctrl.$odata"
    options="{ $filter: 'status eq \\'active\\'' }"
    template-url="salaxy-components/odata/lists/MessageThreadsApproval.html"></salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/pages/messages/approval.html",`<main class="salaxy-content sxytpl-messages-details">
  <section>
    <h3>Hyväksy / hylkää aineisto</h3>
    <main>
      <div ng-controller="MessageThreadCrudController as $ctrl" ng-init="$ctrl.createCalc=true;$ctrl.model = 'url'">
        <div class="row">
          <div class="col-sm-4">
            <div class="btn-toolbar" role="toolbar" aria-label="Incoming message toolbar">
              <div class="btn-group" role="group" aria-label="Approval toolbar">
                <button type="button" class="btn btn-success" ng-click="$ctrl.current.status = 'approved';$ctrl.save()"
                  ng-disabled="$ctrl.current.status == 'approved'">Hyväksy</button>
                <button type="button" class="btn btn-danger" ng-click="$ctrl.current.status = 'rejected';$ctrl.save()"
                  ng-disabled="$ctrl.current.status == 'rejected'">Hylkää</button>
              </div>
              <div class="btn-group" role="group" aria-label="Update toolbar">
                <button type="button" class="btn btn-primary" ng-click="$ctrl.save()">Tallenna</button>
              </div>
            </div>
            <div ng-switch="$ctrl.current.usecase.data.protoId">
              <div ng-switch-when="timer">
                <salaxy-timer ng-if="$ctrl.current" timer-mode="edit" parent="$ctrl.current" crud-controller="$ctrl"></salaxy-timer>
              </div>
              <div ng-switch-when="hourlyReport">
                <salaxy-hourly-report ng-if="$ctrl.current" parent="$ctrl.current" report-type="$ctrl.current.usecase.data.protoId" crud-controller="$ctrl"></salaxy-hourly-report>
              </div>
              <div ng-switch-when="timeReport">
                <salaxy-hourly-report ng-if="$ctrl.current" parent="$ctrl.current" report-type="$ctrl.current.usecase.data.protoId" crud-controller="$ctrl"></salaxy-hourly-report>
              </div>
              <div ng-switch-when="absence">
                <salaxy-absence-periods ng-if="$ctrl.current" parent="$ctrl.getMessage().contentData" condensed="true"></salaxy-absence-periods>
              </div>
              <div ng-switch-when="annualLeave">
                <salaxy-holiday-year-holidays ng-if="$ctrl.current" parent="$ctrl.getMessage().contentData" condensed="true"></salaxy-holiday-year-holidays>
              </div>
              <div ng-switch-when="calcRow">
                <salaxy-calc-rows-editor ng-if="$ctrl.current" parent="$ctrl.getMessage().contentData">
                </salaxy-calc-rows-editor>
              </div>
              <div ng-switch-when="expense">
                <salaxy-expense-report ng-if="$ctrl.current" parent="$ctrl.current" report-type="$ctrl.current.usecase.data.protoId" crud-controller="$ctrl">
                </salaxy-expense-report>
              </div>
              <div ng-switch-when="travel">
                <salaxy-expense-report ng-if="$ctrl.current" parent="$ctrl.current" report-type="$ctrl.current.usecase.data.protoId" crud-controller="$ctrl">
                </salaxy-expense-report>
              </div>
              <div ng-switch-when="default">
                <div ng-if="$ctrl.isNew()">
                  <h2>Temp UI: This will be replaced!</h2>
                  <salaxy-input name="title" label="SALAXY.NG1.MessageThreadComponent.title" require="true" ng-model="$ctrl.current.title"></salaxy-input>
                  <button type="button" class="btn btn-primary" ng-click="$ctrl.save()">
                    <span sxy-text="SALAXY.UI_Terms.save"></span>
                  </button>
                  <hr />
                </div>
                <div class="messages-container" ng-if="$ctrl.current.messages && !$ctrl.isNew()">
                  <h2>{{ $ctrl.current.title }}</h2>
                  <div ng-repeat="item in $ctrl.current.messages" ng-switch="item.fromParty">
                    <div ng-switch-when="owner,undefined" ng-switch-when-separator=",">
                      <salaxy-avatar avatar="$ctrl.current.ownerInfo" class="float-start"></salaxy-avatar>
                      <div class="message-bubble left" ng-class="{ 'in-edit': $ctrl.isInEdit, 'unread': !$ctrl.getReadTime(item)  }">
                        <ng-include src="'salaxy-components/communications/messages/MessageContent.html'"></ng-include>
                        <span class="updated-at">{{ item.time | sxyTime }}, {{ $ctrl.getReadTime(item) ? (('SALAXY.NG1.MessageThreadComponent.read' |sxyTranslate) + ' ' +
                          ($ctrl.getReadTime(item) | sxyTime)) : ('SALAXY.NG1.MessageThreadComponent.unread' |sxyTranslate) }}</span>
                      </div>
                    </div>
                    <div ng-switch-when="otherParty" class="text-end">
                      <salaxy-avatar avatar="$ctrl.current.otherPartyInfo" class="float-end"></salaxy-avatar>
                      <div class="message-bubble right {{item.type}}" ng-class="{ 'in-edit': $ctrl.isInEdit, 'unread': !$ctrl.getReadTime(item) }">
                        <ng-include src="'salaxy-components/communications/messages/MessageContent.html'"></ng-include>
                        <span class="updated-at" ng-if="item.type != 'email'">{{ item.time | sxyTime }}, {{ $ctrl.getReadTime(item) ? (('SALAXY.NG1.MessageThreadComponent.read'
                          |sxyTranslate) + ' ' + ($ctrl.getReadTime(item) | sxyTime)) : ('SALAXY.NG1.MessageThreadComponent.unread' |sxyTranslate)}}</span>
                        <span class="updated-at" ng-if="item.type == 'email'">{{ item.time | sxyTime }}</span>
                      </div>
                    </div>
                    <div ng-switch-default class="alert alert-danger">
                      <ng-include src="'salaxy-components/communications/MessageThread_MessageContent.html'"></ng-include>
                    </div>
                  </div>
                  <div>
                    <div ng-if="$ctrl.isReadOnly" class="alert alert-info">
                      <p><strong>Työnantaja on merkinnyt viestiketjun käsitellyksi.</strong></p>
                    </div>
                    <div class="row">
                      <div class="col-8 col-sm-9">
                        <textarea placeholder="{{'SALAXY.NG1.MessageThreadComponent.writeOrPaste' |sxyTranslate}}" ng-model="$ctrl.newMessage.content"></textarea>
                      </div>
                      <div class="col-4 col-sm-3">
                        <button type="button" class="btn btn-primary btn-labeled-left" style="width: 100%; text-align: left; margin-bottom: 4px" ng-click="$ctrl.sendMessage()"
                          ng-disabled="!$ctrl.newMessage.content">
                          <i class="bi bi-send-fill"></i>
                          <span sxy-text="SALAXY.UI_Terms.send"></span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div id="messageContainerBottom">&nbsp;</div>
                </div>
              </div>
              <div ng-switch-default>
                TODO: Handle {{ $ctrl.current.usecase.uri }} / {{ $ctrl.current.usecase.data.protoId }}.
              </div>
            </div>
          </div>
          <div class="col-sm-8">
            <div class="btn-toolbar" role="toolbar" aria-label="Calculator toolbar">
              <div class="btn-group" role="group" aria-label="Update">
                <button type="button" class="btn btn-default" ng-click="$ctrl.updateCalc()">Päivitä rivit</button>
                <button type="button" class="btn btn-default" ng-click="$ctrl.recalculate()">Laske uudelleen</button>
              </div>
              <div class="btn-group" role="group" aria-label="Select calc / payroll">
                <button type="button" class="btn btn-default">Valitse palkkalista...</button>
                <button type="button" class="btn btn-default" ng-click="$ctrl.selectCalc()">...laskelma</button>
              </div>
              <div class="btn-group" role="group" aria-label="Process calculation">
                <button type="button" class="btn btn-default" ng-click="$ctrl.saveCalc()">Tallenna</button>
                <a ng-href="#/calc/details/{{ $ctrl.calc.id }}" ng-disabled="!$ctrl.calc.id" class="btn btn-default">Siirry laskelmaan</a>
              </div>
            </div>
            <salaxy-calc-rows-2019-editor parent="$ctrl.calc" mode="edit" title="Laskelman rivit"></salaxy-calc-rows-2019-editor>
            <div ng-if="$ctrl.calc.result.totals">
              <salaxy-calc-reports calcs="[$ctrl.calc]" report-type="'salarySlip'"></salaxy-calc-reports>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/messages/details-partner.html",`<main class="salaxy-content sxytpl-messages-details" ng-init="$ctrl.role = 'otherParty'">
  <section>
    <div class="container" ng-controller="SessionController as $sessionCtrl">
      <div ng-controller="MessageThreadCrudController as $msg" ng-init="$msg.model = 'url'">
        <salaxy-message-thread model="$msg" role="{{ $ctrl.role }}" other-party="$sessionCtrl.session.settings.partner.accountId" other-party-options="{ [$sessionCtrl.session.settings.partner.accountId]: $sessionCtrl.session.settings.partner.info.avatar.displayName }">
          <header-new>
            <h3 sxy-text="SALAXY.PRO_Pages.messages.details.newMessage"></h3>
            {{"SALAXY.PRO_Pages.messages.details.partner" | sxyTranslate}}: {{$sessionCtrl.session.settings.partner.info.avatar.displayName}}<br />
            <salaxy-input name="owner" label="SALAXY.PRO_Pages.messages.details.company" ng-model="$sessionCtrl.session.currentAccount.avatar.displayName" disabled="true"></salaxy-input>
          </header-new>
          <header>
            <h2 class="d-flex justify-content-between">
              <div>{{ $msg.current.ownerWorkflow.salaryDate | sxyDate }}</div>
              <div>{{ $msg.current.title }}</div>
            </h2>
            <div class="row">
              <div class="col-sm-6 d-flex">
                <salaxy-avatar avatar="$sessionCtrl.session.currentAccount.avatar" class=""></salaxy-avatar>
                <div class="ms-3">
                  <h3>{{ $sessionCtrl.session.currentAccount.avatar.displayName }}</h3>
                  <code>{{ $sessionCtrl.session.currentAccount.avatar.id | sxyIban }}</code><br />
                  <a href="mailto:{{ $sessionCtrl.session.currentAccount.contact.email }}">{{ $sessionCtrl.session.currentAccount.contact.email }}</a><br /> {{'SALAXY.PRO_Pages.messages.details.phone' | sxyTranslate}}: {{ $sessionCtrl.session.currentAccount.contact.telephone || "-" }}
                </div>
              </div>
              <div class="col-sm-6">
                <h3>{{ $sessionCtrl.session.currentAccount.identity.contract.authorizedBy.name || ('SALAXY.PRO_Pages.messages.details.noContactPerson' | sxyTranslate) }}</h3>
                <p>
                  <a href="mailto:{{ $sessionCtrl.session.currentAccount.identity.contract.authorizedBy.email }}">{{ $sessionCtrl.session.currentAccount.identity.contract.authorizedBy.email }}</a><br /> {{'SALAXY.PRO_Pages.messages.details.phone' | sxyTranslate}}: {{ $sessionCtrl.session.currentAccount.identity.contract.authorizedBy.telephone
                  || "-" }}<br /> {{ $sessionCtrl.session.currentAccount.identity.contract.isSigned ? ('SALAXY.PRO_Pages.messages.details.signed' | sxyTranslate) + ' ' + ($sessionCtrl.session.currentAccount.identity.contract.signedAt | sxyTime) : ('SALAXY.PRO_Pages.messages.details.notSigned' |
                  sxyTranslate) }}
                </p>
              </div>
            </div>
            <hr />
          </header>
        </salaxy-message-thread>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/messages/details.html",`<main class="salaxy-content sxytpl-messages-details">
  <section>
    <salaxy-assure-partner>
      <main>
        <salaxy-message-thread model="'url'" role="owner" other-party="'partner'" mark-as-read="5">
          <header-new>
            <h2 sxy-text="SALAXY.NG1_Pages.Messages.newMessageDetails.title"></h2>
            <p class="lead" sxy-html="SALAXY.NG1_Pages.Messages.newMessageDetails.description.html"></p>
          </header-new>
        </salaxy-message-thread>
      </main>
    </salaxy-assure-partner>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/messages/index.html",`<main class="salaxy-content sxytpl-message-thread-list">
  <section>
    <salaxy-message-thread-list read-only="$ctrl.route.readOnly"></salaxy-message-thread-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/messages/omapalkka.html",`<div ng-controller="OmapalkkaController as $ctrl">
  <iframe ng-if="$ctrl.url" ng-src="{{$ctrl.url}}" style="width: 100%; height: calc(100vh - 180px); margin-bottom: -100px; border: 0;"></iframe>
</div>`);

 $templateCache.put("salaxy-components/pages/partners/assure-worker-account.html",`<main class="salaxy-content sxytpl-partners-worker-assure">
    <section>
        <salaxy-worker-assure></salaxy-worker-assure>
    </section>
</main>`);

 $templateCache.put("salaxy-components/pages/payment-channel/details.html",`<main class="salaxy-content sxytpl-invoices-list">
  <section ng-controller="PaymentChannelController as $ctrl" ng-init="$ctrl.model = 'url'">
    <div ng-if="$ctrl.channel">
      <salaxy-avatar class="salaxy-calc-row-type-avatar salaxy-input-enum-avatar float-start" avatar="$ctrl.getChannelAvatar()"></salaxy-avatar>
      <div class="salaxy-input-enum-text"><strong>{{"PaymentChannel." + $ctrl.channel | sxyEnum}}</strong></div>
      <div class="salaxy-input-enum-title">{{ "PaymentChannel." + $ctrl.channel | sxyEnumDescr }}</div>
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'default', text: 'Esikatselu' },
          { value: 'status', text: 'Tilan päivitys', hidden: !('test' | sxyIsInRole) },
          { value: 'edit', text: 'Laskun muokkaus', hidden: !('test' | sxyIsInRole) },
          { value: 'debug', text: 'Debug', hidden: !('test' | sxyIsInRole) }
        ]"
        tabs-id="paymentChannelDetails">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-paymentChannelDetails">
        <div class="tab-pane" id="default-tab">
          <salaxy-spinner ng-if="!$ctrl.current && $ctrl.isLoading"></salaxy-spinner>
          <salaxy-payment-channel-invoice-preview ng-if="$ctrl.current" model="$ctrl"></salaxy-payment-channel-invoice-preview>
        </div>
        <div class="tab-pane" id="status-tab" ng-if="'test' | sxyIsInRole">
          <div class="alert alert-danger" ng-if="!$ctrl.isLoading && !$ctrl.current">Laskua ei löydy</div>
            <form ng-if="$ctrl.current" ng-submit="$ctrl.updateStatus()">
              <div class="form-horizontal" ng-init="$ctrl.resetStatusData()">
                <h2>Päivitä tila</h2>
                <p>Testilomake tilan päivitykseen. Alta voit myös poistaa laskun.</p>
                <salaxy-input name="statusId" ng-model="$ctrl.statusData.id" label="Id" disabled="true"></salaxy-input>
                <salaxy-input name="statusExternalId" ng-model="$ctrl.statusData.externalId" label="ID maksukanavassa"></salaxy-input>
                <salaxy-input-enum label="Maksun tila" name="statusStatus" ng-model="$ctrl.statusData.status" enum="InvoiceStatus" required></salaxy-input-enum>
                <salaxy-datepicker-popup name="statusDate" ng-model="$ctrl.statusData.date" label="Maksupäivä"></salaxy-datepicker-popup>
                <salaxy-input-number name="statusAmount" ng-model="$ctrl.statusData.amount" label="Maksettu summa"></salaxy-input-number>
                <salaxy-input name="statusReceiverFullName" ng-model="$ctrl.statusData.receiverFullName" label="Vastaanottajan nimi"></salaxy-input>
                <salaxy-input name="statusReceiverIban" ng-model="$ctrl.statusData.receiverIban" label="Vastaanottajan tilinumero"></salaxy-input>
                <salaxy-input name="statusReferenceNumber" ng-model="$ctrl.statusData.referenceNumber" label="Viitenumero"></salaxy-input>
              </div>
              <div>
                <button type="submit" class="btn btn-primary float-end">Päivitä tila</button>
                <button type="button" ng-click="$ctrl.delete()" class="btn btn-danger">Poista lasku</button>
              </div>
            </form>
        </div>
        <div class="tab-pane" id="edit-tab" ng-if="'test' | sxyIsInRole">
          <div class="alert alert-danger" ng-if="!$ctrl.isLoading && !$ctrl.current">Laskua ei löydy</div>
            <form ng-if="$ctrl.current" ng-submit="$ctrl.save()">
              <div class="form-horizontal">
                <h2>Muokkaa laskua</h2>
                <p>Testilomake laskun muokkaukseen. Alta voit myös poistaa laskun.</p>
                <salaxy-datepicker-popup name="date" ng-model="$ctrl.current.header.date" label="Laskun päivä"></salaxy-datepicker-popup>
                <salaxy-datepicker-popup name="dueDate" ng-model="$ctrl.current.header.dueDate" label="Eräpäivä"></salaxy-datepicker-popup>
                <salaxy-datepicker-popup name="logicalDate" ng-model="$ctrl.current.header.logicalDate" label="Looginen päivä"></salaxy-datepicker-popup>
                <salaxy-input name="message" ng-model="$ctrl.current.header.message" label="Viesti"></salaxy-input>
              </div>
              <div>
                <button type="submit" class="btn btn-primary float-end">Tallenna</button>
                <button type="button" ng-click="$ctrl.delete()" class="btn btn-danger">Poista lasku</button>
              </div>
            </form>
        </div>
        <div class="tab-pane" id="debug-tab" ng-if="'test' | sxyIsInRole">
          <salaxy-json-formatter  ng-if="$ctrl.current" json="$ctrl.current" open="1"></salaxy-json-formatter>
        </div>
      </div>
    </div>
    <div ng-if="!$ctrl.channel && !$ctrl.isLoading">
      <div class="alert alert-danger">Käyttäjätilillä ei ole omaa maksukanavaa</div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/payment-channel/index.html",`<main class="salaxy-content sxytpl-payment-channel">
  <section ng-controller="PaymentChannelController as $ctrl">
    <div ng-if="$ctrl.channel">
      <salaxy-avatar class="salaxy-calc-row-type-avatar salaxy-input-enum-avatar float-start" avatar="$ctrl.getChannelAvatar()"></salaxy-avatar>
      <div class="salaxy-input-enum-text"><strong>{{"PaymentChannel." + $ctrl.channel | sxyEnum}}</strong></div>
      <div class="salaxy-input-enum-title">{{ "PaymentChannel." + $ctrl.channel | sxyEnumDescr }}</div>
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'odata', text: 'All items' },
          { value: 'fulldata', text: 'Unread items' },
        ]"
        tabs-id="paymentChannelIndex">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-paymentChannelIndex">
        <div class="tab-pane" id="odata-tab">
          <salaxy-odata-table crud-controller="PaymentChannelController as $crud" options="{ $orderby: 'endAt desc'}" template-url="salaxy-components/odata/lists/InvoicesPaymentChannel.html"></salaxy-odata-table>
        </div>
        <div class="tab-pane" id="fulldata-tab">
          <div>
            <table class="table">
              <thead>
                <tr>
                  <th colspan="2">Payer</th>
                  <th colspan="2">
                    Receiver<br /> Payment type
                  </th>
                  <th class="right">
                    Date<br /> Due date
                  </th>
                  <th class="right">
                    Created<br /> Updated
                  </th>
                  <th class="right">Payment</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="item in $ctrl.unreadInvoices">
                  <td class="td-avatar middle">
                    <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="item.payer.avatar"></salaxy-avatar>
                  </td>
                  <td class="middle">
                    {{ item.payer.avatar.displayName }}<br>
                    <small class="hidden-xxs">{{ item.payer.officialId }}, {{ item.payer.partnerKey }}</small>
                  </td class="middle">
                  <td class="td-avatar middle">
                    <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="item.recipient.beneficiary.avatar"></salaxy-avatar>
                  </td>
                  <td class="middle">
                    {{ item.recipient.beneficiary.avatar.displayName }}<br>
                    <small class="hidden-xxs">{{ item.header.message }}</small>
                  </td class="middle">
                  <td class="middle right">
                    {{ item.header.date | sxyDate }}<br /> {{ item.header.dueDate | sxyDate }}
                  </td>
                  <td class="right">
                    {{ item.createdAt | sxyDate }}<br /> {{ item.updatedAt | sxyDate }}
                  </td>
                  <td class="middle right">
                    {{ item.header.total | currency }}
                  </td>
                  <td class="middle right">
                    <a ng-href="#{{$ctrl.getDefaults().detailsUrl}}{{ item.id }}" class="btn btn-primary">
                      {{ 'SALAXY.UI_Terms.show' | sxyTranslate}}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div ng-if="!$ctrl.channel">
      <div class="alert alert-danger">Käyttäjätilillä ei ole omaa maksukanavaa</div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/payroll/details.html",`<main class="salaxy-content sxytpl-calculations-payroll-edit">
  <div ng-if="$ctrl.newPayrollVersion.show" class="d-none d-md-block salaxy-payroll-v4 form-horizontal">
    <salaxy-input-boolean name="newPayrollSwitch" type="switch" ng-model="$ctrl.newPayrollVersionUse" label="SALAXY.NG1.PayrollComponent.newVersion" label-cols="col-7" label-true="on" label-false="off"></salaxy-input-boolean>
  </div>
  <section ng-if="$ctrl.newPayrollVersion.use">
    <!-- Switching isFullWidth as long as the two UI are in same URL. -->
    <div style="display: none;" ng-init="$ctrl.current.isFullWidth = true"></div>
    <salaxy-payroll-details model="'url'" is-read-only-forced="$ctrl.route.readOnly" actions="$ctrl.route.getParam('actions')"></salaxy-payroll-details>
  </section>
  <section ng-if="!$ctrl.newPayrollVersion.use">
    <div style="display: none;" ng-init="$ctrl.current.isFullWidth = false"></div>
    <salaxy-payroll-edit model="'url'" is-read-only-forced="$ctrl.route.readOnly"
      actions="$ctrl.route.getParam('actions')"></salaxy-payroll-edit>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/payroll/import.html",`<main class="salaxy-content sxytpl-calculations-payroll-import">
  <section>
    <div ng-controller="SalaryBasesController as $ctrl">
      <div ng-if="!$ctrl.datasets" class="container">
        <salaxy-spinner title="Ladataan määrittelyjä..."></salaxy-spinner>
      </div>
      <div ng-if="$ctrl.datasets && !$ctrl.datasets.length" class="alert alert-danger container">  
        <strong>BETA:</strong>
        Tietojen tuonti (import) on rajoitetussa testauksessa PRO-palvelussa ja tuodaan tuotantoon syksyllä.
        Kysy asiakaspalvelusta lisätietoja ennen kuin käytät tätä toimintoa.
      </div>
      <div ng-if="$ctrl.datasets.length && !$ctrl.dataset" class="container">
        <h3>Valitse Import-tyyppi</h3>
        <div style="max-width: 600px;">
          <label ng-repeat="ds in $ctrl.datasets" class="btn btn-block btn-default" ng-click="$ctrl.loadDataset(ds)">{{ ds.shortText }}</label>
        </div>
      </div>
      <div ng-if="$ctrl.dataset">
        <div class="btn-toolbar">
          <div class="btn-group">
            <button type="button" class="btn btn-default" ng-click="$ctrl.getEmployments()">1. Hae työsuhteet</button>
            <button type="button" class="btn btn-default" ng-controller="ImportController as $import" ng-click="$import.showImport($ctrl.getImportable())">2. Lataa data</button>
            <button type="button" class="btn btn-default" ng-click="$ctrl.processImport()">3. Käsittele data (mapper)</button>
            <button type="button" class="btn btn-default" ng-click="$ctrl.saveToPayroll()">4. Tallenna palkkalistaan</button>
          </div>
        </div>
        <salaxy-tab-buttons
          ng-if="$ctrl.current"
          current-tab="$ctrl.currentTab"
          options="[
            { value: 'payroll', text: 'Palkkalista' },
            { value: 'employments', text: 'Työsuhteet' },
            { value: 'rowtypemapnew', text: 'Säännöt (rivityypit)' },
            { value: 'rows', text: 'Rivit' },
            { value: 'src', text: 'Debug' }
          ]"
          tabs-id="payrollImport">
        </salaxy-tab-buttons>
        <div class="tab-content" id="tab-content-payrollImport">
          <div class="tab-pane" id="payroll-tab">
            <salaxy-payroll-edit model="'url'" ng-ref="$ctrl.payrollController"></salaxy-payroll-edit>
          </div>
          <div class="tab-pane" id="employments-tab">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <div>Työntekijän nimi (Palkkaus.fi)</div>
                    <div><small>Työsuhteen tyyppi</small></div>
                  </th>
                  <th class="right">
                    <div>ID lähteessä</div>
                    <div>Tuntia / kk</div>
                  </th>
                  <th>Rivit</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="emp in $ctrl.employments">
                  <td>
                    <salaxy-avatar style="font-size: 50px;" avatar="emp.personalInfo.avatar"></salaxy-avatar>
                  </td>
                  <td>
                    <div><strong>{{ emp.personalInfo.avatar.displayName }}</strong> ({{ emp.personalInfo.officialId }})</div>
                    <div><small>{{ emp.work.wageBasis }}</small></div>
                    <div><small>{{ emp.updatedAt }}</small></div>
                  </td>
                  <td class="right">
                    <div>{{ emp.info.sourceId || "-" }}</div>
                    <div ng-if="emp.work.monthlyHours"><strong>{{ emp.work.monthlyHours }}</strong></div>
                    <div ng-if="!emp.work.monthlyHours" class="text-muted">160</div>
                  </td>
                  <td>
                    <table class="table table-sm">
                      <tr ng-repeat="row in emp.work.salaryDefaults">
                        <td>{{ "CalculationRowType." + row.rowType | sxyEnum }}</td>
                        <td class="right">{{ row.count | number }} * {{ row.price ? (row.price | currency) : "-" }}</td>
                      </tr>
                    </table>                  
                  </td>
                  <td>
                    <button type="button" class="btn btn-default" ng-click="$ctrl.editEmployment(emp)">Muokkaa</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab-pane" id="rowtypemapnew-tab">
            <div class="btn-toolbar">
              <button type="button" class="btn btn-default" ng-click="$ctrl.save()">Tallenna</button>
            </div>
            <table class="table" ng-controller="CalcRows2019Controller as $rows" ng-init="$rows.rows=$ctrl.getRowTypeMapper()">
              <thead>
                <tr>
                  <th colspan="2">Lähdedata</th>
                  <th></th>
                  <th colspan="2">Kohde</th>
                </tr>
                <tr>
                  <th>Haku</th>
                  <th>RegEx</th>
                  <th>Toiminto</th>
                  <th>
                    <div>Palkkalaji (rowType)</div>
                    <div>Alalaji (kind)</div>
                  </th>
                  <th class="right">
                    <div>Hinta/kerroin</div>
                    <div>Määrä</div>
                  </th>
                  <th>Viesti palkkalaskelmaan</th>
                  <th>Kommentti</th>
                  <th>
                    <button type="button" class="btn btn-default" ng-click="$rows.showRowTypeSelectionDialog()">Luo uusi</button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="match in $rows.list">
                  <td ng-if="!match.$edit">{{ match.search }}</td>
                  <td ng-if="!match.$edit">{{ match.searchType }}</td>
                  <td ng-if="!match.$edit">{{ match.type }}</td>
  
                  <td ng-if="match.$edit"><salaxy-input name="searh{{ $index }}" label-type="plain" ng-model="match.search"></salaxy-input></td>
                  <td ng-if="match.$edit"><input type="checkbox" ng-checked="match.searchType == 'regExp'" ng-click="match.searchType = (match.searchType != 'regExp' ? 'regExp' : 'string')"></td>
                  <td ng-if="match.$edit">
                    <salaxy-input-enum options="$ctrl.matchTypes" name="type{{ $index }}" label-type="plain" ng-model="match.type"></salaxy-input-enum>
                  </td>
                  
                  <td>
                    <div>{{ match.rowType }}</div>
                    <div>{{ match.data.kind }}</div>
                  </td>
                  <td class="right">
                    <div>{{ match.price || "-" }}</div>
                    <div>{{ match.count || "-" }}</div>
                  </td>
                  <td>{{ match.message }}</td>
  
                  <td ng-if="!match.$edit">{{ match.comment }}</td>
                  <td ng-if="match.$edit"><salaxy-input name="comment{{ $index }}" label-type="plain" ng-model="match.comment"></salaxy-input></td>
  
                  <td>
                    <button type="button" class="btn btn-default" ng-disabled="!match.rowType" ng-click="match.rowIndex = $index;$rows.showEdit(match)"><i class="bi bi-list-task" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-primary" ng-click="match.$edit = !match.$edit"><i class="bi bi-pencil-fill" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-danger" ng-click="$rows.delete(match)"><i class="bi bi-trash-fill" aria-hidden="true"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab-pane" id="rows-tab">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th></th>
                  <th colspan="2">Lähde</th>
                  <th colspan="2">Palkkaus.fi</th>
                  <th colspan="3"></th>
                </tr>
                <tr>
                  <th>Päivä</th>
                  <th>Henk. nro</th>
                  <th>Rivikoodi</th>
                  <th>Työntekijä</th>
                  <th>Palkkalaji</th>
                  <th>Alalaji</th>
                  <th class="right">Määrä</th>
                  <th class="right">Hinta</th>
                  <th class="right">Kustannusp.</th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="row in $ctrl.current.rows">
                  <td>{{ row.date | sxyDate }}</td>
                  <td>{{ row.srcEmploymentId }}</td>
                  <td>{{ row.srcRowTypeId }}</td>
                  <td>
                    <div ng-if="row.employment">
                      <salaxy-avatar style="font-size: 18px;" avatar="row.employment.personalInfo.avatar"></salaxy-avatar>
                      {{ row.employment.personalInfo.avatar.displayName }}
                    </div>
                    <div ng-if="!row.employment" class="text-danger">{{ row.employmentId || "Puuttuu!" }}</div>
                  </td>
                  <td>{{ ("CalculationRowType." + (row.rowType || "") | sxyEnum) || "-" }}</td>
                  <td>{{ row.data.kind || row.message }}</td>
                  <td class="right">{{ row.count | sxyCount }}</td>
                  <td class="right">{{ row.price ? (row.price | currency) : "-" }}</td>
                  <td class="right">{{ row.costCenter }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab-pane" id="src-tab">
            <salaxy-json-formatter json="$ctrl.getRowTypeMapper()" key="'Source'"></salaxy-json-formatter>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/payroll/index.html",`<main class="salaxy-content sxytpl-calculations-payroll">
  <div ng-if="$ctrl.newPayrollVersion.show" class="d-none d-md-flex salaxy-payroll-v4 form-horizontal d-flex justify-content-end">
    <salaxy-input-boolean name="newPayrollSwitch" type="switch" ng-model="$ctrl.newPayrollVersionUse" label="SALAXY.NG1.PayrollComponent.newVersion" label-cols="col-7" label-true="on" label-false="off"></salaxy-input-boolean>
  </div>
  <section class="sxytpl-intro d-none d-md-block" ng-if="$ctrl.newPayrollVersion.show">
    <h3 sxy-text="SALAXY.NG1.PayrollComponent.payrollVersions.header"></h3>
    <p sxy-html="SALAXY.NG1.PayrollComponent.payrollVersions.html"></p>
  </section>
  <section class="sxytpl-list" ng-if="$ctrl.newPayrollVersion.use">
    <salaxy-payroll-details-list  details-url="/payroll/details/" hide-button="$ctrl.route.readOnly" is-read-only-forced="$ctrl.route.readOnly"></salaxy-payroll-details-list>
  </section>
  <section class="sxytpl-list" ng-if="!$ctrl.newPayrollVersion.use">
    <salaxy-payroll-list  details-url="/payroll/details/" hide-button="$ctrl.route.readOnly" is-read-only-forced="$ctrl.route.readOnly"></salaxy-payroll-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reference-objects/details.html",`<main class="salaxy-content sxytpl-reference-object-details">
  <section>
    <!-- This should be a component -->
    <!--salaxy-reference-object model="'url'"></salaxy-reference-object -->

    <div class="salaxy-component salaxy-reference-object" ng-controller="ReferenceObjectCrudController as $ctrl" ng-init="$ctrl.model='url'">
      <div ng-if="$ctrl.current">
        <sxy-form open-api="salaxy-secure/schemas/v02.json" type="ReferenceObject" auto-gen="false" debugger="false" model="$ctrl.current">
          <div class="col-12">
            <fieldset>
              <legend>Header</legend>
              <sxy-input  model="form.header.status"></sxy-input>
              <sxy-input model="form.header.referenceDate"></sxy-input>
              <sxy-input model="form.header.description"></sxy-input>
            </fieldset>
            <fieldset>
              <legend>Events</legend>
              <sxy-input model="form.events">
                <form>
                  <fieldset>
                    <legend>Event</legend>
                    <sxy-input model="form.name" ></sxy-input>
                    <sxy-input model="form.date" ></sxy-input>
                    <sxy-input model="form.result" ></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
        </sxy-form>
        <div class="row">
          <div class="col-12 text-end">
            <button class="btn btn-danger" ng-click="$ctrl.delete($ctrl.current)">Poista</button>
            <button class="btn btn-primary" ng-click="$ctrl.save()">Tallenna</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reference-objects/index.html",`<main class="salaxy-content sxytpl-reference-object-list">
  <div class="text-end">
    <a class="btn btn-primary" ng-href="#{{$odata.$crudController.getDefaults().detailsUrl}}new" sxy-text="Uusi"></a>
  </div>
  
  <section>
    <div ng-show="$odata.items.length" >
      <salaxy-odata-table ng-ref="$odata" crud-controller="ReferenceObjectCrudController as $crud">
      </salaxy-odata-table>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reports/absences.html",`<div ng-controller="WorkerAbsencesCrudController as $ctrl" ng-init="$ctrl.testYear=2021;$ctrl.getAbsences()">
  <h1 class="d-print-none" sxy-text="SALAXY.NG1_Pages.Reports.Absences.heading"></h1>
  <h2 class="d-none d-print-block">{{'SALAXY.NG1_Pages.Reports.Absences.heading' | sxyTranslate}} ({{ $ctrl.reportParams | sxyDateRange }})</h2>
  <div class="btn-toolbar d-print-none mb-3 mt-3" role="toolbar" aria-label="Calendar buttons">
    <div class="btn-group" role="group" aria-label="Views">
      <button type="button" class="btn btn-default" ng-class="{ active: !$ctrl.view || $ctrl.reportView == 'calendar' }" ng-click="$ctrl.view = 'calendar'" sxy-text="SALAXY.NG1_Pages.Reports.Absences.calendar"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.view == 'list' }" ng-click="$ctrl.view = 'list'" sxy-text="SALAXY.NG1_Pages.Reports.Absences.list"></button>
    </div>
    <div class="btn-group ms-1" role="group" aria-label="Periods">
      <button type="button" class="btn btn-default" ng-class="{ active: !$ctrl.reportView || $ctrl.reportView == 'thisYear' }" ng-click="$ctrl.reportView = 'thisYear'" sxy-text="SALAXY.NG1_Pages.Reports.Absences.thisYear"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'lastYear' }" ng-click="$ctrl.reportView = 'lastYear'" sxy-text="SALAXY.NG1_Pages.Reports.Absences.lastYear"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'thisMonth' }" ng-click="$ctrl.reportView = 'thisMonth'" sxy-text="SALAXY.NG1_Pages.Reports.Absences.thisMonth"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'lastMonth' }" ng-click="$ctrl.reportView = 'lastMonth'" sxy-text="SALAXY.NG1_Pages.Reports.Absences.lastMonth"></button>
    </div>
    <div class="d-flex ms-1" aria-label="{{'SALAXY.NG1_Pages.Reports.Absences.dates' | sxyTranslate}}">
        <salaxy-datepicker-popup ng-model="$ctrl.reportParams.start" name="start" label="SALAXY.NG1_Pages.Reports.Absences.dates" label-type="inline"></salaxy-datepicker-popup>
        <salaxy-datepicker-popup ng-model="$ctrl.reportParams.end" name="end" label="" label-type="no-label" class="ms-1 "></salaxy-datepicker-popup>
    </div>
    
    <div class="btn-group ms-1" role="group" aria-label="Actions">
      <button ng-click="$ctrl.showAddWorker()" class="btn btn-default" sxy-text="SALAXY.NG1_Pages.Reports.Absences.addWorker"></button>
    </div>
  </div>
  <salaxy-spinner ng-if="!$ctrl.allAbsences"></salaxy-spinner>
  <div ng-if="$ctrl.allAbsences.length === 0" sxy-text="SALAXY.NG1_Pages.Reports.Absences.employeeNoAnsences"></div>
  <div ng-if="$ctrl.allAbsences.length &gt; 0">
    <salaxy-absence-periods style="display: none;" ng-ref="$ctrl.$periodList" on-commit="$ctrl.saveAbsences(parent)"></salaxy-absence-periods>
    <div ng-if="$ctrl.view != 'list'">
      <salaxy-calendar on-list-select="type == 'series' ? $ctrl.showEditDialog(series.data) : null" data="$ctrl.allAbsences" mode="horizontal" mapper="$ctrl.mapToCalendar" list-controller="$ctrl.$periodList" start="$ctrl.reportParams.start" end="$ctrl.reportParams.end"></salaxy-calendar>
    </div>
    <div ng-if="$ctrl.view == 'list'">
      <table class="table">
        <thead>
          <tr>
            <th colspan="2">
              <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
            </th>
            <th class="right">
              <span sxy-text="SALAXY.NG1_Pages.Reports.Absences.first"></span><br />
              <span sxy-text="SALAXY.NG1_Pages.Reports.Absences.latest"></span>
            </th>
            <th class="right">
              <div sxy-text="SALAXY.NG1_Pages.Reports.Absences.absencesPaid"></div>
              <div sxy-text="SALAXY.NG1_Pages.Reports.Absences.absencesUnpaid"></div>
            </th>
            <th class="right">
              <div sxy-text="SALAXY.NG1_Pages.Reports.Absences.absencesHolidayAccrual"></div>
              <div sxy-text="SALAXY.NG1_Pages.Reports.Absences.absencesNoHolidayAccrual"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.allAbsences">
            <td class="align-middle td-avatar clickable"  ng-click="$ctrl.showEditDialog(row)">
              <salaxy-avatar avatar="row.workerSnapshot"></salaxy-avatar>
            </td>
            <td class="td-name middle clickable"  ng-click="$ctrl.showEditDialog(row)">
              <div><strong>{{ row.workerSnapshot.displayName }}</strong></div>
              <div>{{ $ctrl.getPeriodCalculation(row, "length") }} {{'SALAXY.NG1_Pages.Reports.Absences.absence' | sxyTranslate}}, {{ $ctrl.getPeriodCalculation(row, "all") | sxyCount : "day" }}</div>
            </td>
            <td class="right">
              <div>{{ $ctrl.getPeriodCalculation(row, "firstPeriod") | sxyDateRange }}</div>
              <div>{{ $ctrl.getPeriodCalculation(row, "lastPeriod") | sxyDateRange }}</div>
            </td>
            <td class="right">
              <div>{{ $ctrl.getPeriodCalculation(row, "absencesPaid") | sxyCount : "day" }}</div>
              <div>{{ $ctrl.getPeriodCalculation(row, "absencesUnpaid") | sxyCount : "day" }}</div>
            </td>
            <td class="right">
              <div>{{ $ctrl.getPeriodCalculation(row, "absencesHolidayAccrual") | sxyCount : "day" }}</div>
              <div>{{ $ctrl.getPeriodCalculation(row, "absencesNoHolidayAccrual") | sxyCount : "day" }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages/reports/accounting-legacy.html",`<main class="salaxy-content sxytpl-reports-accounting">
  <section class="sxytpl-intro">
    <p class="lead"> {{ 'SALAXY.NG1_Pages.Reports.accountingIntro' | sxyTranslate }}
    </p>
  </section>
  <section class="sxytpl-list">
    <h2>{{ 'SALAXY.NG1_Pages.Reports.accountingMonthly' | sxyTranslate }}</h2>
    <salaxy-report-list report-type="'monthlyDetails'"></salaxy-report-list>
    <salaxy-report-list report-type="'monthlyLiikekirjuri'"></salaxy-report-list>
  </section>
  <section class="sxytpl-list">
    <h2>{{ 'SALAXY.NG1_Pages.Reports.accountingYearly' | sxyTranslate }}</h2>
    <salaxy-report-list report-type="'yearlyDetails'"></salaxy-report-list>
  </section>
  <section class="sxytpl-list">
    <h2>{{ 'SALAXY.NG1_Sitemap.reports.archive' | sxyTranslate }}</h2>
    <a href="#/reports/archive-2018">{{ 'SALAXY.UI_Terms.show' | sxyTranslate }}...</a>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reports/accounting-row-report.html",`<main class="salaxy-content sxytpl-accounting-row-report">
  <section style="height: calc(100vh - 150px)">
    <salaxy-accounting-row-report template-id="'holidays'"></salaxy-accounting-row-report>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reports/ad-hoc-list.html",`<salaxy-odata-table crud-controller="UsecasesCrudController as $crud" options="{ $filter: 'entityType eq \\'dataset\\'' }" template-url="salaxy-components/odata/lists/UsecasesAdHocReport.html"></salaxy-odata-table>`);

 $templateCache.put("salaxy-components/pages/reports/ad-hoc.html",`<main class="salaxy-content sxytpl-reports-ad-hoc">
  <section>
    <div ng-controller="DatasetsCrudController as $ctrl" ng-init="$ctrl.model='url'">
      <salaxy-spinner ng-if="!$ctrl.usecase"></salaxy-spinner>
      <div ng-if="$ctrl.usecase && !$ctrl.usecase.defaultView" class="alert alert-danger">
        ERROR: This usecase {{ $ctrl.usecase.uri }} does not have user interface (view) defined.
      </div>
      <div ng-if="$ctrl.usecase && $ctrl.usecase.defaultView">
        <ng-include src="$ctrl.usecase.defaultView"></ng-include>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reports/archive-2018.html",`<main class="salaxy-content sxytpl-reports-archive-2018">
  <section class="sxytpl-intro">
    <h2 sxy-text="SALAXY.NG1_Pages.Reports.Archive.heading"></h2>
    <p class="lead" sxy-text="SALAXY.NG1_Pages.Reports.Archive.lead"></p>
  </section>
  <h3 sxy-text="SALAXY.NG1_Pages.Reports.Archive.unemploymentInsuranceFund"></h3>
  <section class="sxytpl-list">
    <div ng-controller="ReportsController as $ctrl" ng-init="rptType = 'unemployment'">
      <salaxy-report-list report-type="'unemployment'"></salaxy-report-list>
    </div>
  </section>
  <h3 sxy-text="SALAXY.NG1_Pages.Reports.Archive.taxYearlyNotification"></h3>
  <section class="sxytpl-list">
    <salaxy-report-list report-type="'taxYearly7801'"></salaxy-report-list>
  </section>
  <h3 sxy-text="SALAXY.NG1_Pages.Reports.Archive.taxMonthlyNotification"></h3>
  <section class="sxytpl-list">
    <salaxy-report-list report-type="'taxMonthly4001'"></salaxy-report-list>
  </section>
  <h3 sxy-text="SALAXY.NG1_Pages.Reports.Archive.pension"></h3>
  <section class="sxytpl-list">
    <salaxy-report-list report-type="'insurance'"></salaxy-report-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reports/calculation-report.html",`<main class="salaxy-content sxytpl-calculation-report">
  <section style="height: calc(100vh - 150px)">
    <salaxy-calculation-report template-id="'incomeTypes'"></salaxy-calculation-report>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reports/holiday-pay-report-query.html",`<main class="salaxy-content sxytpl-holiday-pay-report-query">
  <section>
    <salaxy-holiday-pay-report-query></salaxy-holiday-pay-report-query>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reports/holiday-report.html",`<main class="salaxy-content sxytpl-holiday-report">
  <section>
    <salaxy-holiday-report></salaxy-holiday-report>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reports/holidays.html",`<div ng-controller="HolidayYearCrudController as $ctrl" ng-init="$ctrl.getHolidayYears()">
  <h1 class="d-print-none" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.holidayList"></h1>
  <h2 class="d-none d-print-block">{{'SALAXY.NG1_Pages.Reports.Holidays.holidayYear' | sxyTranslate}} {{ $ctrl.reportYear }} ({{ $ctrl.reportParams | sxyDateRange }})</h2>
  <div class="btn-toolbar d-print-none  mb-3 mt-3" role="toolbar" aria-label="Calendar buttons">
    <div class="btn-group" role="group" aria-label="{{'SALAXY.NG1_Pages.Reports.Holidays.holidayYear' | sxyTranslate}}">
      <salaxy-form-group name="year" label="SALAXY.NG1_Pages.Reports.Holidays.holidayYear" class="me-2" label-type="inline">
        <select id="year" name="year" ng-model="$ctrl.reportYear" class="ms-2 form-select" ng-change="$ctrl.getHolidayYears()" ng-options="item as item for item in $ctrl.reportParams.years">
        </select>
      </salaxy-form-group>
    </div>
    <div class="d-flex ms-1" role="group" aria-label="{{'SALAXY.NG1_Pages.Reports.Holidays.show' | sxyTranslate}}">
        <salaxy-datepicker-popup ng-model="$ctrl.reportParams.start" name="start" label="SALAXY.NG1_Pages.Reports.Holidays.show" label-type="inline" min-date="$ctrl.reportParams.yearStart" max-date="$ctrl.reportParams.yearEnd"></salaxy-datepicker-popup>
        <salaxy-datepicker-popup ng-model="$ctrl.reportParams.end" name="end" label="" label-type="no-label" label-cols="none" min-date="$ctrl.reportParams.yearStart" max-date="$ctrl.reportParams.yearEnd" class="ms-1"></salaxy-datepicker-popup>
    </div>
    <div class="btn-group ms-1" role="group" aria-label="Views">
      
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'summerPeriod' }" ng-click="$ctrl.reportView = 'summerPeriod'" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.summerPeriod"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'winterPeriod' }" ng-click="$ctrl.reportView = 'winterPeriod'" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.winterPeriod"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'otherPeriod' }" ng-click="$ctrl.reportView = 'otherPeriod'" sxy-text="Muu"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'list' }" ng-click="$ctrl.reportView = 'list'" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.list"></button>
      
    </div>
    <div class="btn-group ms-1" role="group" aria-label="Actions">
      <button ng-click="$ctrl.showAddWorker()" class="btn btn-default" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.addWorker"></button>
    </div>
  </div>
  <salaxy-spinner ng-if="!$ctrl.allYears"></salaxy-spinner>
  <div ng-if="$ctrl.allYears.length === 0" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.employeeNoHolidays"></div>
  <div ng-if="$ctrl.allYears.length &gt; 0">
    <salaxy-holiday-year-holidays style="display: none;" ng-ref="$ctrl.$holidayList" on-commit="$ctrl.saveYear(parent)"></salaxy-holiday-year-holidays>
    <div ng-if="$ctrl.reportView != 'list'">
      <salaxy-calendar show-export="true" on-list-select="type == 'series' ? $ctrl.showEditDialog(series.data) : null" data="$ctrl.allYears" mode="horizontal" mapper="$ctrl.mapToCalendar" list-controller="$ctrl.$holidayList" start="$ctrl.reportParams.start" end="$ctrl.reportParams.end"></salaxy-calendar>
    </div>
    <div ng-if="$ctrl.reportView == 'list'">
      <table class="table">
        <thead>
          <tr>
            <th colspan="2"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span></th>
            <th sxy-html="SALAXY.NG1_Pages.Reports.Holidays.holidayCompensation.html"></th>
            <th class="right" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.year"></th>
            <th class="right" sxy-html="SALAXY.NG1_Pages.Reports.Holidays.planned.html"></th>
            <th class="right" sxy-html="SALAXY.NG1_Pages.Reports.Holidays.summerWinter.html"></th>
            <th class="right" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.endSaldo"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="year in $ctrl.allYears">
            <td class="align-middle td-avatar clickable" ng-click="$ctrl.showEditDialog(year)">
              <salaxy-avatar avatar="year.workerSnapshot"></salaxy-avatar>
            </td>
            <td class="td-workerSnapshot-name clickable" ng-click="$ctrl.showEditDialog(year)">
              <strong>{{ year.workerSnapshot.displayName }}</strong><br /> {{ "WageBasis." + year.spec.wageBasis | sxyEnum }}<br />
            </td>
            <td>
              {{ "HolidayCode." + year.spec.code | sxyEnum }}
              <span ng-if="year.spec.code == 'holidayCompensation'">({{ year.spec.compensation | sxyCount : 'percent' }})</span>
              <div ng-if="year.spec.bonusMethod != 'none'">
                {{ "HolidayBonusPaymentMethod." + year.spec.bonusMethod | sxyEnum }}
                <span>({{ year.spec.bonus | sxyCount : 'percent' }})</span>
              </div>
            </td>
            <td class="right">{{ year.year }}</td>
            <td class="right">
              {{ $ctrl.getTotalDays("all", year) | sxyCount : 'days' }}<br /> {{ year.leaves.planned.length | sxyCount : 'count' }}
            </td>
            <td class="right">
              {{ $ctrl.getTotalDays("summer", year) | sxyCount : 'days' }}<br /> {{ $ctrl.getTotalDays("winter", year) | sxyCount : 'days' }}
            </td>
            <td class="right">
              {{ year.accrual.endSaldo | sxyCount : 'days' }}
            </td>
          </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages/reports/index.html",`<main class="salaxy-content sxytpl-reports-dashboard">
  <section class="sxytpl-intro">
    <p class="lead">
      {{ 'SALAXY.NG1_Pages.Reports.latestReports' | sxyTranslate }}
    </p>
  </section>
  <section class="sxytpl-report-panels">
    <div class="row">
      <div class="col-12 col-sm-6" ng-if="$ctrl.route.getFlag('features', 'salaryReportList')">
        <salaxy-salary-report-list mode="panel"></salaxy-salary-report-list>
      </div>
      <div class="col-12 col-sm-6" ng-if="$ctrl.route.getFlag('features', 'accountingReportList')">
        <salaxy-accounting-report-list mode="panel"></salaxy-accounting-report-list>
      </div>
      <div class="col-12 col-sm-6" ng-if="$ctrl.route.getFlag('features', 'invoiceList') || ('pro' | sxyIsInRole)">
        <salaxy-invoice-list mode="panel"></salaxy-invoice-list>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reports/pay-certificate.html",`<main class="salaxy-content sxytpl-pay-certificate">
  <section class="sxytpl-intro">
    <p sxy-text="SALAXY.NG1_Pages.Reports.PayCertificate.intro.text"></p>
    <p sxy-text="SALAXY.NG1_Pages.Reports.PayCertificate.intro.payCertificateInfo"></p>
  </section>
  <section>
    <salaxy-pay-certificate></salaxy-pay-certificate>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reports/pay-stats-report-query.html",`<main class="salaxy-content sxytpl-pay-stats-report-query">
  <section>
    <salaxy-pay-stats-report-query></salaxy-pay-stats-report-query>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reports/salary-reports.html",`<main class="salaxy-content sxytpl-salary-reports">
  <section class="sxytpl-list">
    <salaxy-salary-report-list>
    </salaxy-salary-report-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reports/summary-report-query.html",`<main class="salaxy-content sxytpl-summary-report-query">
  <section>
    <salaxy-summary-report-query></salaxy-summary-report-query>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/reports/yearly-summary.html",`<main class="salaxy-content sxytpl-reports-yearly-summary">
  <section class="sxytpl-intro">
    <p class="lead">
      {{ 'SALAXY.NG1_Pages.Reports.yearlySummary' | sxyTranslate }}
    </p>

  </section>
  <section class="sxytpl-list">
    <h2>{{ 'SALAXY.NG1_Pages.Reports.yearlyTitle' | sxyTranslate }}</h2>
    <salaxy-report-list report-type="'yearlyWorkerSummary'"></salaxy-report-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/service-models/current.html",`<main class="salaxy-content sxytpl-service-model-current">
  <section>
    <h1>TODO: Current service model</h1>
    <p class="lead" sxy-text="SALAXY.NG1_Pages.ServiceModels.Current.lead"></p>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/service-models/details.html",`<main class="salaxy-content sxytpl-service-model-details">
  <section>
    <salaxy-service-model-details model="'url'"></salaxy-service-model-details>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/service-models/index.html",`<main class="salaxy-content sxytpl-service-model-list">
  <a class="btn btn-primary float-end" ng-href="#{{$odata.$crudController.getDefaults().detailsUrl}}new" sxy-text="SALAXY.NG1_Pages.ServiceModels.addServiceModel"></a>
  <p class="lead">
    {{'SALAXY.NG1_Pages.ServiceModels.lead' | sxyTranslate}} <a href="">Ota yhteys myyntiimme</a>.
  </p>
  <section>
    <div ng-show="$odata.items.length" class="salaxy-component salaxy-service-model-list">
      <salaxy-odata-table ng-ref="$odata" crud-controller="ServiceModelCrudController as $crud">
      </salaxy-odata-table>
    </div>
    <div ng-if="$odata.status == 'loaded' && !$odata.items.length" class="salaxy-placeholder-empty placeholder-md placeholder-default text-center">
      <a class="btn btn-primary" ng-href="#{{$odata.$crudController.getDefaults().detailsUrl}}new" sxy-text="SALAXY.NG1_Pages.ServiceModels.addServiceModel"></a>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/service-models/read-only.html",`<main class="salaxy-content sxytpl-service-model-details">
  <section>
    <salaxy-service-model-details is-read-only-forced="true" model="'url'"></salaxy-service-model-details>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/account-reset.html",`<main class="salaxy-content sxytpl-settings-account-reset">
  <section class="sxytpl-account-reset">
    <salaxy-account-reset></salaxy-account-reset>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/accountants.html",`<main class="salaxy-content sxytpl-partners-accountants">
  <section>
    <div class="content settings">

      <salaxy-accountant removal-disabled="$ctrl.route.node.accountantRemovalDisabled || 'accountantComponent.removalDisabled' | sxyIsInRole"></salaxy-accountant>

    </div>
  </section>
  <section sxy-if-role="test">
    <div class="row" ng-controller="PartnerController as $partnerCtrl">
      <div class="col-md-6">
        <div class="alert alert-danger">
          <b>Testiympäristö</b>
          <p>Vaihda tyyli tätä sessiota varten!</p>
          <button id="style" type="button" class="btn btn-primary" ng-click="$partnerCtrl.showSwitchCss()">
            Vaihda tyyli (CDN)
          </button>
          <button id="style" type="button" class="btn btn-secondary" ng-click="$partnerCtrl.showSwitchCssDev()">
            Vaihda tyyli <span class="small">(DEV)</span>
          </button>
          <hr />
          <div>Brand ID: {{ $partnerCtrl.brandId || "-" }}</div>
          <div>Skin: {{ $partnerCtrl.skin || "-" }}</div>
          <a ng-href="{{ $partnerCtrl.getLoginUrl() }}" target="_blank" class="btn btn-default">Näytä login</a>
          <a ng-href="{{ $partnerCtrl.getOnboardingUrl() }}" target="_blank" class="btn btn-default">Näytä onboarding</a>
        </div>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/accounting-target-settings.html",`<main class="salaxy-content sxytpl-accounting-targets">
  <section>
    <salaxy-accounting-settings></salaxy-accounting-settings>
  </section>
  <section>
    <div>
      <salaxy-accountant template-url="salaxy-components/settings/AccountantInfo.html"></salaxy-accountant>
    </div>
  </section>
  <section>
    <salaxy-cost-accounting-settings></salaxy-cost-accounting-settings>
  </section>
  <section>
    <salaxy-holiday-settings></salaxy-holiday-settings>
  </section>
  <section ng-if="'bizConfigs' | sxyIsInRole">
    <salaxy-pay-stats-settings></salaxy-pay-stats-settings>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/authorizations.html",`<main class="salaxy-content sxytpl-settings-certificates settings content">
  <section class="sxytpl-credentials mb-4">
    <salaxy-credentials></salaxy-credentials>
  </section>
  <section class="sxytpl-certificates mb-4">
    <salaxy-certificates></salaxy-certificates>
  </section>
  <section class="sxytpl-authorized-accounts mb-4">
    <!-- <p class="lead">{{ 'SALAXY.NG1_Pages.Settings.Authorizations.lead' | sxyTranslate}}</p> -->
    <salaxy-authorized-accounts></salaxy-authorized-accounts>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/index.html",`<main class="salaxy-content sxytpl-settings-dashboard" ng-controller="SessionController as $session">
  <section class="sxytpl-settings-panels">
    <div class="row">

      <div class="col-12 mb-4" ng-if="$ctrl.route.getFlag('features', 'account')">
        <div class="salaxy-odata-card list-card settings-list-card card card-sm card-secondary">
          <div class="card-header" sxy-text="SALAXY.NG1_Pages.Settings.accountTitle">

          </div>
          <div class="card-body card-content">
            <div class="row table-row">

              <div class="col-4">
                <span sxy-text="SALAXY.NG1_Pages.Settings.languageLabel" ps=":"></span>
              </div>

              <div class="col-8 text-end">
                {{("Language." + $session.session.currentAccount.language | sxyEnum) || "-" }}
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="row table-row">
                  <div class="col-12">
                    <strong sxy-text="SALAXY.NG1_Pages.Settings.contactLabel"></strong>
                  </div>
                </div>

                <div class="row table-row">
                  <div class="col-4">
                    <span sxy-text="SALAXY.NG1.AccountInfoComponent.email" ps=":"></span>

                  </div>
                  <div class="col-8 text-end">
                    {{ $session.company.contact.email }}
                  </div>
                </div>
                <div class="row table-row">
                  <div class="col-4">
                    <span sxy-text="SALAXY.NG1.AccountInfoComponent.phone" ps=":"></span>

                  </div>
                  <div class="col-8 text-end">
                    {{ $session.company.contact.telephone }}
                  </div>
                </div>
                <div class="row table-row">
                  <div class="col-4">
                    <span sxy-text="SALAXY.NG1.AccountInfoComponent.address" ps=":"></span>

                  </div>
                  <div class="col-8 text-end">
                    {{ $session.company.contact.street }}<br /> {{ $session.company.contact.postalCode }} {{ $session.company.contact.city }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row table-row">
                  <div class="col-12">
                    <strong sxy-text="SALAXY.NG1_Pages.Settings.userLabel"></strong>
                  </div>
                </div>

                <div class="row table-row" ng-if="$session.session.currentCredential.authenticationMethod != 'salaxy' && $session.session.currentCredential.authenticationMethod != 'x509'">
                  <div class="col-4">
                    <span sxy-text="SALAXY.NG1.UserInfoComponent.email" ps=":"></span>

                  </div>
                  <div class="col-8 text-end">

                    {{ $session.session.currentCredential.email }}
                  </div>
                </div>
                <div class="row table-row">
                  <div class="col-4">
                    <span sxy-text="SALAXY.NG1.UserInfoComponent.name" ps=":"></span>
                  </div>
                  <div class="col-8 text-end">
                    {{ $session.session.currentCredential.avatar.displayName }}
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="card-footer text-center">
            <a href="#/settings/service-settings" title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary" sxy-text="SALAXY.UI_Terms.edit"></a>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12 mb-4" ng-if="$ctrl.route.getFlag('features', 'insurances')" ng-controller="CompanySettingsController as $settings">
        <div class="salaxy-odata-card list-card settings-list-card card card-sm card-secondary">
          <div class="card-header" sxy-text="SALAXY.NG1_Pages.Settings.insurancesTitle">

          </div>
          <div class="card-body card-content lg-height">

            <div class="row table-row">
              <div class="col-6" ng-class="$session.session.settings.pensionContracts == '' ? 'col-6' : 'col-12'">
                <strong sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.titleLong"></strong>
              </div>

              <div class="col-6 text-end" ng-if="$session.session.settings.pensionContracts == ''">
                <a href="#/settings/payment-settings" class="btn btn-danger btn-xs" sxy-text="SALAXY.NG1_Pages.Settings.insuranceMissing"></a>
              </div>
            </div>
            <div class="row-wrapper" ng-repeat="item in $settings.pensionContracts" ng-if="$settings.isVisibleContract(item, $settings.pensionContracts)">
              <div class="row table-row">
                <div class="col-4" ps=":" sxy-text="SALAXY.MODEL.PensionContract.company.title">
  
                </div>
                <div class="col-8 text-end">
                  {{("PensionCompany." + item.company | sxyEnum) || '-'}}
                </div>
              </div>
              
              <div class="row table-row">
                <div class="col-4" sxy-text="SALAXY.MODEL.PensionContract.contractNumber.title" ps=":">
  
                </div>
                <div class="col-8 text-end">
                  {{item.contractNumber || '-'}}
                </div>
              </div>
            </div>
          
            <div class="row-wrapper" ng-repeat="item in $settings.insuranceContracts" ng-if="$settings.isVisibleContract(item, $settings.insuranceContracts)">
              <div class="row table-row">
                <div class="col-6" ng-class="$session.session.settings.insuranceContracts == '' ? 'col-6' : 'col-12'">
                  <strong sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.title"></strong>
                </div>

                <div class="col-6 text-end" ng-if="$session.session.settings.insuranceContracts == ''">
                  <a href="#/settings/payment-settings" class="btn btn-danger btn-xs" sxy-text="SALAXY.NG1_Pages.Settings.insuranceMissing"></a>
                </div>
              </div>
              <div class="row table-row">
                <div class="col-4" sxy-text="SALAXY.MODEL.InsuranceContract.company.title" ps=":">

                </div>
                <div class=" col-8 text-end">
                  {{("InsuranceCompany." + item.company | sxyEnum) || '-'}}
                </div>
              </div>
              <div class="row table-row">
                <div class="col-4" sxy-text="SALAXY.MODEL.InsuranceContract.contractNumber.title" ps=":">

                </div>
                <div class="col-8 text-end">
                  {{item.contractNumber || '-'}}
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer text-center">
            <a href="#/settings/insurances" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary" sxy-text="SALAXY.UI_Terms.edit"></a>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12 mb-4" ng-if="$ctrl.route.getFlag('features', 'accountant')">
        <div class="salaxy-odata-card list-card settings-list-card card card-sm card-secondary">
          <div class="card-header">
            {{'SALAXY.NG1_Pages.Settings.accountantTitle' | sxyTranslate }}
          </div>
          <div class="card-body card-content lg-height text-center align-middle" ng-if="!$session.session.settings.partner">
            <div>
              <h3 sxy-text="SALAXY.NG1_Pages.Settings.noAccountant"></h3>
            </div>
          </div>
          <div class="card-body card-content lg-height" ng-if="$session.session.settings.partner">
            <div class="row table-row">
              <div class="col-4" sxy-text="SALAXY.NG1.AccountantComponent.name" ps=":">
              </div>
              <div class="col-8 d-flex align-items-center justify-content-end">
                <salaxy-avatar style="font-size: 20px; margin-right: 12px;" avatar="$session.session.settings.partner.info.avatar"></salaxy-avatar>
                <span>{{ $session.session.settings.partner.info.avatar.displayName}}</span>
              </div>
            </div>

            <div class="row table-row" ng-if="$session.session.settings.partner.info.officialId">
              <div class="col-4" sxy-text="SALAXY.NG1.AccountantComponent.officialId" ps=":"></div>
              <div class="col-8 text-end">{{ $session.session.settings.partner.info.officialId}}</div>
            </div>
            <div class="row table-row" ng-if="$session.session.settings.partner.info.email">
              <div class="col-4" sxy-text="SALAXY.NG1.AccountantComponent.email" ps=":"></div>
              <div class="col-8 text-end">{{ $session.session.settings.partner.info.email }}</div>
            </div>
            <div class="row table-row" ng-if="$session.session.settings.partner.info.telephone">
              <div class="col-4" sxy-text="SALAXY.NG1.AccountantComponent.phone" ps=":"></div>
              <div class="col-8 text-end">{{ $session.session.settings.partner.info.telephone }}</div>
            </div>
            <div class="row table-row" ng-if="$session.session.settings.partner.type=='primaryPartner' || $session.session.settings.partner.type=='pendingPrimaryPartner' || $session.session.settings.partner.type=='unlinkedPrimaryPartner' || $session.session.settings.partner.type=='unlinkedAccountingOnly'">
              <div class="col-4" sxy-text="SALAXY.NG1.AccountantComponent.accountantType" ps=":">
              </div>
              <div class="col-8 text-end">
                <span ng-if="$session.session.settings.partner.type=='primaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.primaryPartner"></span>
                <span ng-if="$session.session.settings.partner.type=='pendingPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.pendingPrimaryPartner"></span>
                <span ng-if="$session.session.settings.partner.type=='unlinkedPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedPrimaryPartner"></span>
                <span ng-if="$session.session.settings.partner.type=='unlinkedAccountingOnly'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedAccountingOnly"></span>
              </div>
            </div>
          </div>

          <div class="card-footer text-center">
            <a href="#/settings/accountants" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary" sxy-text="SALAXY.UI_Terms.edit"></a>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12 mb-4" ng-if="$session.session.settings.paymentChannels && $ctrl.route.getFlag('features', 'paymentChannels')">
        <div class="salaxy-odata-card list-card settings-list-card card card-sm card-secondary">
          <div class="card-header" sxy-text="SALAXY.NG1_Pages.Settings.paymentChannelsTitle">

          </div>
          <div class="card-body card-content lg-height">
            <div class="row table-row">
              <div class="col-6">
                <strong sxy-text="SALAXY.NG1_Pages.Settings.defaultChannelLabel" ps=":"></strong>
              </div>
              <div class="col-6 text-end">
                {{"PaymentChannel." + $session.session.settings.defaultPaymentChannel | sxyEnum}}
              </div>
            </div>
            <div class="row table-row">
              <div class="col-12">
                <strong sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.title" ps=":"></strong>
              </div>
            </div>
            <div class="row table-row" ng-repeat="channel in $session.session.settings.paymentChannels">

              <div class="col-12">

                {{"PaymentChannel." + channel | sxyEnum}}<br>
              </div>
            </div>
          </div>
          <div class="card-footer text-center">
            <a href="#/settings/payment-channel-settings" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary" sxy-text="SALAXY.UI_Terms.edit"></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/insurances.html",`<main class="salaxy-content sxytpl-insurance-settings">
  <section>
    <salaxy-insurance-settings is-read-only-forced="$ctrl.route.readOnly"></salaxy-insurance-settings>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/integrations.html",`<main class="salaxy-content sxytpl-partners-integrations">
  <section class="sxytpl-intro">
    <p class="lead">
      {{ 'SALAXY.NG1_Pages.Settings.Integrations.lead' | sxyTranslate }}
    </p>
  </section>
  <section class="sxytpl-cards">
    <div ng-controller="AccountAuthorizationController as authCtrl">
      <div class="row align-items-stretch w-100">
        <div class="sxytpl-card col-12 col-sm-4 col-md-4 col-lg-3 m-3" ng-repeat="site in authCtrl.partnerIntegrationSites">
          <salaxy-auth-card class="d-flex h-100" auth-id="site.id"></salaxy-auth-card>
        </div>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/ir-delivery-settings.html",`<main class="salaxy-content sxytpl-ir-delivery-settings">
  <section>
    <salaxy-ir-delivery-settings is-read-only-forced="$ctrl.route.readOnly"></salaxy-ir-delivery-settings>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/open-ai.html",`<div class="content settings"  ng-controller="CompanySettingsController as $ctrl">
  <div class="panel open-ai-settings panel-default" ng-if="$ctrl.current">
    <div>
      <div class="panel-heading icon-panel">
        <h2 sxy-text="OPEN AI"></h2>
      </div>
      <div class="panel-body">
        <div class="row">
          <ng-form name="$openAi" class="form-horizontal">
            <div>
              <fieldset>
                <legend>API Avain</legend>
                <salaxy-input label="Avain" name="key"
                  ng-model="$ctrl.openAiKey"></salaxy-input>
              </fieldset>
            </div>
          </ng-form>
        </div>
      </div>
      <div class="panel-footer">
        <div class="row">
          <div class="col-xs-12 text-right">
            <button type="submit"
              class="btn btn-primary" ng-click="$ctrl.saveOpenAiKey()">
              <span sxy-text="SALAXY.UI_Terms.save"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages/settings/owner-settings.html",`<salaxy-owner-settings is-read-only-forced="$ctrl.route.readOnly"></salaxy-owner-settings>`);

 $templateCache.put("salaxy-components/pages/settings/payment-channel-settings.html",`<main class="salaxy-content sxytpl-payment-channel-settings">
  <section>
    <salaxy-payment-channel-settings></salaxy-payment-channel-settings>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/payment-settings.html",`<main class="salaxy-content sxytpl-payment-settings">

  <section>
    <salaxy-payment-settings is-read-only-forced="$ctrl.route.readOnly"></salaxy-payment-settings>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/pro-settings.html",`<main class="salaxy-content sxytpl-pro-settings">
  <section>
    <salaxy-pro-settings></salaxy-pro-settings>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/records.html",`<main class="salaxy-content sxytpl-settings-records settings content">
  <section class="sxytpl-account-records mb-4">
    <div class="card account-records card-default">
      <!--div class="card-header">
        <h2>{{'SALAXY.NG1.WorkerDetailsComponent.records.label' | sxyTranslate}}</h2>
      </div-->
      <div class="card-body">
        <div ng-if="'person' | sxyIsInRole" ng-controller="PersonAccountController as $person">
          <salaxy-records ng-if="$person.current" read-only="$ctrl.route.readOnly" api-ctrl="$person" entity-type="'account'"></salaxy-records>
        </div>
        <div ng-if="'company' | sxyIsInRole" ng-controller="CompanyAccountController as $company">
          <salaxy-records ng-if="$company.current" read-only="$ctrl.route.readOnly" api-ctrl="$company" entity-type="'account'"></salaxy-records>
        </div>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/row-types-settings.html",`<main class="salaxy-content sxytpl-row-types-settings">
  <section>
    <salaxy-tab-buttons 
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'builtin', text: 'Tuotteen palkkalajit' },
        { value: 'custom', text: 'Yrityskohtaiset palkkalajit' },
        { value: 'prices', text: 'Oletushinnat' },
        { value: 'copy', text: 'Kopioitavat rivit' },
        { value: 'json', text: 'Debug' }
      ]"
      tabs-id="rowTypesSettings">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-rowTypesSettings">
      <div class="tab-pane" id="builtin-tab">
        <p>
          Tuotteen palkkalajit listaa kaikki palkkalajit, jotka on määritetty suoraan tuotteeseen.
          Niitä ei voi muokata. <strong>Klikkaa räätälöi luodaksesi uusi yrityskohtainen palkkalaji.</strong>
        </p>
        <salaxy-row-types-settings mode="builtIn"></salaxy-row-types-settings>
      </div>
      <div class="tab-pane" id="custom-tab">
        <p>
          Voit luoda uuden yrityskohtaisen palkkalajin valitsemalla tuotteen palkkalajin ensimmäiseltä välilehdeltä ja klikkaamalla "räätälöi".
          <br />
          <strong>HUOM: Tässä versiossa yrityskohtaiset palkkalajit toimivat vain tuntitiedon tuonnissa (esim. Nepton, EASoft).</strong>
          Myöhemmissä versioissa ne tulevat mukaan myös laskuriin.
        </p>
        <div>
          <salaxy-row-types-settings mode="custom"></salaxy-row-types-settings>
        </div>
        <!--div ng-if="('bizConfigs' | sxyIsInRole)" ng-controller="TemplateCrudController as $templateCrudCtrl">
          <button type="button" class="btn btn-sm btn-default"
            ng-click="$templateCrudCtrl.selectTemplate()">
            <i class="bi bi-plus"></i> <span sxy-text="Lisää valmiista mallista..."></span>
          </button>
        </div-->
      </div>
      <div class="tab-pane" id="prices-tab">
        <div class="float-end">
          <button class="btn btn-primary" ng-click="$ctrl.$prices.save()"></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
        </div>
        <p style="min-height: 24px;">Hintoja käytetään tällä hetkellä tuntien sisään tuonnissa. Myöhemmissä versioissa oletushintoja käytetään myös laskurissa.</p>
        <salaxy-row-types-settings ng-ref="$ctrl.$prices" mode="prices"></salaxy-row-types-settings>
      </div>
      <div class="tab-pane" id="copy-tab">
        <div class="float-end">
          <button class="btn btn-primary" ng-click="$ctrl.$copyRows.save()"></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
        </div>
        <p style="min-height: 24px;">Rivit päivitetään laskelmalle työsuhteen päivityksen yhteydessä.</p>
        <salaxy-row-types-settings ng-ref="$ctrl.$copyRows" mode="copy" ng-if="$ctrl.currentTab == 'copy'"></salaxy-row-types-settings>
      </div>
      <div class="tab-pane" id="json-tab">
        <salaxy-row-types-settings mode="debugger"></salaxy-row-types-settings>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/service-settings.html",`<main class="salaxy-content sxytpl-settings-service-settings settings content">
  <section class="sxytpl-language-selection mb-4">
    <salaxy-language-selector></salaxy-language-selector>
  </section>
  <section class="sxytpl-account-info mb-4">
    <div class="card account-info card-secondary">
      <div class="card-header">
        <h2>{{'SALAXY.NG1_Pages.Settings.ServiceSettings.heading' | sxyTranslate}}</h2>
      </div>
      <div class="card-body">
        <salaxy-account-info></salaxy-account-info>
      </div>
    </div>
  </section>
  <section class="sxytpl-user-info mb-4" salaxy-if-role="test">
    <div class="card user-info card-default">
      <div class="card-header">
        <h2>{{'SALAXY.NG1.UserInfoComponent.panelTitle' | sxyTranslate}} (TEST ONLY)</h2>
      </div>
      <div class="card-body">
        <salaxy-user-info></salaxy-user-info>
      </div>
    </div>
  </section>
  <section class="sxytpl-account-records mb-4">
    <div class="card account-records card-default">
      <div class="card-header">
        <h2>{{'SALAXY.NG1.WorkerDetailsComponent.records.label' | sxyTranslate}}</h2>
      </div>
      <div class="card-body">
        <div ng-if="'person' | sxyIsInRole" ng-controller="PersonAccountController as $person">
          <salaxy-records ng-if="$person.current" read-only="$ctrl.route.readOnly" api-ctrl="$person" entity-type="'account'"></salaxy-records>
        </div>
        <div ng-if="'company' | sxyIsInRole" ng-controller="CompanyAccountController as $company">
          <salaxy-records ng-if="$company.current" read-only="$ctrl.route.readOnly" api-ctrl="$company" entity-type="'account'"></salaxy-records>
        </div>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/settings/signing-cancel.html",`<div class="text-center" style="height: 100vh; padding-top: 30vh;">
  <div>
    <h1>Allekirjoitus peruttu / Digital signature canceled / 
      Digital signatur avbröts</h1>
    <button type="button" class="btn btn-primary" onclick="closePopup()" sxy-text="SALAXY.UI_Terms.close"></button>
  </div>
</div>
`);

 $templateCache.put("salaxy-components/pages/settings/signing-new.html",`<main class="salaxy-content sxytpl-settings-signing">
  <h1>Signing tester</h1>
  <salaxy-signing ng-ref="$ctrl.$signing" show-in-popup="true" show-always="true"></salaxy-signing>
</div>`);

 $templateCache.put("salaxy-components/pages/settings/signing-success.html",`<div class="text-center" style="height: 100vh; padding-top: 30vh;">
  <div>
    <h1 sxy-text="SALAXY.NG1_Pages.Settings.SigningSuccess.success"></h1>
    <button type="button" class="btn btn-primary" onclick="closePopup()" sxy-text="SALAXY.UI_Terms.close"></button>
  </div>
</div>
`);

 $templateCache.put("salaxy-components/pages/settings/signing.html",`<div ng-cloak ng-controller="NaviController as $ctrl">
  <salaxy-spinner ng-if="$ctrl.showFullPageLoader" full-screen="true" heading="SALAXY.UI_Terms.loading">
  </salaxy-spinner>
  <div class="salaxy-component" ng-if="!$ctrl.showFullPageLoader">
    <div ng-controller="CompanyOnboardingController as $onBoarding">
      <div ng-if="'auth' | sxyIsInRole" ng-init="$onBoarding.launchSigningWizard()"></div>
      <div class="text-center" style="margin-top:100px;">
        <a onClick="window.opener.postMessage({ action: 'refresh' },'*');window.close()" href="#" sxy-text="SALAXY.UI_Terms.close"></a>
      </div>
    </div>
  </div>
</div>

   `);

 $templateCache.put("salaxy-components/pages/settings/translate.html",`<salaxy-ui-translator></salaxy-ui-translator>`);

 $templateCache.put("salaxy-components/pages/taxcards/details.html",`<div class="container">
  <h2>{{'SALAXY.NG1_Pages.Taxcards.Details.heading' | sxyTranslate}}: {{ $ctrl.$taxcardCtrl.current.worker.displayName }}</h2>
  <p class="lead" ng-if="$ctrl.$taxcardCtrl.current">
    <strong>{{ "TaxcardKind." + $ctrl.$taxcardCtrl.current.card.kind | sxyEnum }}, {{ $ctrl.$taxcardCtrl.current.card.validity | sxyDateRange }}</strong>. {{'SALAXY.NG1_Pages.Taxcards.Details.heading' | sxyTranslate}}
  </p>
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'overview', text: 'SALAXY.NG1_Pages.Taxcards.Details.overview' },
      { value: 'pro', text: 'SALAXY.NG1_Pages.Taxcards.Details.editing' },
      { value: 'alltaxcards', text: 'SALAXY.NG1_Pages.Taxcards.Details.allTaxcards' },
      { value: 'debug', text: 'Json / debug' }
    ]"
    tabs-id="taxcardsDetails">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-taxcardsDetails">
    <div class="tab-pane" id="overview-tab">
      <salaxy-spinner heading="SALAXY.UI_Terms.loading" ng-if="$ctrl.$taxcardCtrl.isLoading"></salaxy-spinner>
        <div ng-if="$ctrl.$taxcardCtrl.current && $ctrl.$taxcardCtrl.currentId">
          <salaxy-taxcard-details model="$ctrl.$taxcardCtrl.current" hide-buttons="true"></salaxy-taxcard-details>
          <div class="text-center" ng-if="!$ctrl.$taxcardCtrl.getTaxcardDownloadUrl()" sxy-text="SALAXY.NG1_Pages.Taxcards.Details.noAttachment"></div>
          <a ng-if="$ctrl.$taxcardCtrl.getTaxcardDownloadUrl()" ng-href="{{$ctrl.$taxcardCtrl.getTaxcardDownloadUrl()}}" target="_blank" class="btn btn-xs btn-primary float-end" sxy-text="SALAXY.NG1_Pages.Taxcards.Details.download">Download</a>
          <div ng-if="$ctrl.$taxcardCtrl.getTaxcardPreviewUrl()" class="document-preview text-center">
            <img ng-src="{{ $ctrl.$taxcardCtrl.getTaxcardPreviewUrl() }}" class="img-responsive" style="display: inline;" />
          </div>
        </div>
    </div>
    <div class="tab-pane" id="pro-tab">
      <salaxy-taxcard-details model="'url'" list-url="/taxcards" ng-ref="$ctrl.$taxcardCtrl" mode="pro"></salaxy-taxcard-details>
    </div>
    <div class="tab-pane" id="alltaxcards-tab">
      <div ng-if="$ctrl.currentTab == 'alltaxcards'">
        <salaxy-employment-taxcards employment-id="$ctrl.$taxcardCtrl.current.employmentId" ng-ref="$ctrl.$allTaxcardsCtrl" mode="list"></salaxy-employment-taxcards>
      </div>
    </div>
    <div class="tab-pane" id="debug-tab">
      <p class="clearfix" sxy-if-role="test">
        <button type="button" class="btn btn-danger float-end" ng-click="$ctrl.$taxcardCtrl.delete()" sxy-text="SALAXY.NG1_Pages.Taxcards.Details.deleteButton">Poista (test)</button> {{'SALAXY.NG1_Pages.Taxcards.Details.deleteButtonInfo' | sxyTranslate}}
      </p>
      <salaxy-json-formatter open="1" json="$ctrl.$taxcardCtrl.current"></salaxy-json-formatter>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages/taxcards/index.html",`<div class="container">
  <h2 sxy-text="SALAXY.NG1_Pages.Taxcards.heading"></h2>
  <p class="lead" sxy-if-role="!worker" sxy-html="SALAXY.NG1_Pages.Taxcards.lead.noWorkerHtml"></p>
  <p class="lead" sxy-if-role="worker" sxy-html="SALAXY.NG1_Pages.Taxcards.lead.workerHtml"></p>
  <salaxy-odata-table crud-controller="TaxcardCrudController as $crud" crud-bindings="{ detailsUrl: '/taxcards/details/'}"></salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/pages/templates/details.html",`<main class="salaxy-content sxytpl-template-details">
  <section>
    <div class="salaxy-component salaxy-template-details" ng-controller="TemplateCrudController as $ctrl" ng-init="$ctrl.model='url'">
      <div ng-if="$ctrl.current">
        <sxy-form open-api="salaxy-secure/schemas/v02.json" type="Template" auto-gen="false" debugger="false" model="$ctrl.current">
          <div class="col-12">
            <fieldset>
              <legend>Perustiedot</legend>
              <sxy-input  model="form.name"></sxy-input>
              <sxy-input model="form.description"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
        <div class="row">
          <div class="col-12 text-end">
            <button class="btn btn-danger" ng-click="$ctrl.delete($ctrl.current)">Poista</button>
            <button class="btn btn-primary" ng-click="$ctrl.save()">Tallenna</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/templates/index.html",`<main class="salaxy-content sxytpl-template-list">
  <div class="text-end">
    <a class="btn btn-primary" ng-href="#{{$odata.$crudController.getDefaults().detailsUrl}}new" sxy-text="Uusi"></a>
  </div>
  
  <section>
    <div ng-show="$odata.items.length" class="salaxy-component salaxy-template-list">
      <salaxy-odata-table ng-ref="$odata" crud-controller="TemplateCrudController as $crud">
      </salaxy-odata-table>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/test/account-reset.html",`<main class="salaxy-content sxytpl-settings-account-reset">
  <section class="sxytpl-account-reset">
    <salaxy-account-reset></salaxy-account-reset>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/test/markdown.html",`<main class="salaxy-content sxytpl-test-markdown">
  <section class="sxytpl-test-markdown">
    <div ng-init="test = { 'text': 'tekstiä', 'title': 'Titteli', 'ro': true, 're': false }">
      <salaxy-input-boolean name="ro" label="Read Only" ng-model="test.ro"></salaxy-input-boolean>
      <salaxy-input-boolean name="req" label="Require" ng-model="test.re"></salaxy-input-boolean>
      <salaxy-input name="txt2" label="Text 2" ng-model="test.text"></salaxy-input>
      <form name="markdownTest" ng-readonly="test.ro" class="form-horizontal">
        <salaxy-input name="title" label="Titteli" require="test.re" ng-model="test.title"></salaxy-input>
        <pre>{{ test.text | json}}</pre>
        <salaxy-input-markdown name="text" label="Sisältö" require="test.re" ng-model="test.text"></salaxy-input-markdown>
      </form>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/test/smoke.html",`<main class="salaxy-content sxytpl-test-smoke">
  <section class="sxytpl-test-smoke">
    <h1>Salaxy tester page</h1>
      <p class="lead">
        This page tests whether <code>@salaxy</code> functionality is working.
        <br />
        <a href="/ng1/">Go to AngularJS Components</a>
      </p>
      <fieldset>
        <legend>AngularJS</legend>
        <p>Expressions: 1 + 2 = {{ 1 + 2 }} <i>(result should be "3")</i></p>
        <p>
          Ng-if: <span style="background-color: red; color: white;" ng-if="false">FAILURE</span>
          <i>(should NOT show text "failure" in red background).</i>
        </p>
        <p>
          Directive (ng-style): <span style="background-color: red; color: white;" ng-style="{ 'background-color': 'green' }">This text should be in GREEN backgroung</span>
        </p>
      </fieldset>
      <fieldset>
        <legend>Salaxy styles (LESS)</legend>
        <p>The following buttons should be in Bootstrap colors:</p>
        <div class="btn-toolbar">
          <button type="button" class="btn btn-default">Default</button>
          <button type="button" class="btn btn-primary">Primary</button>
          <a href="" class="btn btn-success">Success a-href</a>
          <button type="button" class="btn btn-info">Info</button>
          <a href="" class="btn btn-warning">Warning a-href</a>
          <button type="button" class="btn btn-danger">Danger</button>
          <button type="button" class="btn btn-link">Link</button>
        </div>
        <p style="margin-top: 10px;">...if this is not the case, rest of the tests may be difficult to read (no red / green etc.)</p>
      </fieldset>
      <p style="background-color: red; color: white; margin-top: 10px;" ng-if="false">
        FAILURE: Angular not available: Rest of tests will not show!
      </p>
      <salaxy-smoke-test mode="core"></salaxy-smoke-test>
      <salaxy-smoke-test mode="reports"></salaxy-smoke-test>
      <salaxy-smoke-test mode="ng1"></salaxy-smoke-test>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/usecases/details.html",`<main class="salaxy-content sxytpl-usecase-details">
  <section>
    <salaxy-usecase-details model="'url'"></salaxy-usecase-details>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/usecases/index.html",`<main class="salaxy-content sxytpl-usecase-list">
  <section>
    <a ng-href="#{{$ctrl.$odata.$crudController.getDefaults().detailsUrl}}new" class="btn btn-primary float-end" sxy-text="SALAXY.NG1_Pages.Usecases.createNewUsecase"></a>
    <h1>{{'SALAXY.NG1_Pages.Usecases.usecase' | sxyTranslate}}<span class="badge bg-primary">BETA</span></h1>
    <p class="lead" sxy-text="SALAXY.NG1_Pages.Usecases.lead"></p>
    <div class="btn-toolbar">
      <button type="button" class="btn btn-default" ng-click="$ctrl.$odata.setFilter(null)">Näytä kaikki</button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.$odata.setFilter('entityType', 'calculation')">Laskelmat</button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.$odata.setFilter('entityType', 'dataset')">Dataset</button>
    </div>
    <salaxy-odata-table crud-controller="UsecasesCrudController as $crud" ng-ref="$ctrl.$odata"></salaxy-odata-table>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/workers/details.html",`<main class="salaxy-content sxytpl-workers-details">
  <section>
    <salaxy-worker-details model="'url'" is-read-only-forced="$ctrl.route.readOnly" hide-buttons="$ctrl.route.readOnly"></salaxy-worker-details>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/workers/import-workers.html",`<main class="salaxy-content">
  <section>
    <!-- Forcing isFullWidth  -->
    <div style="display: none;" ng-init="$ctrl.current.isFullWidth = true"></div>
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'default', text: 'Työntekijöiden tuonti' },
        { value: 'list', text: 'Työntekijät' },
      ]"
      tabs-id="importWorkers">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-importWorkers">
      <div class="tab-pane" id="default-tab">
        <salaxy-worker-import></salaxy-worker-import>
      </div>
      <div class="tab-pane" id="list-tab">
        <salaxy-employment-list show-toolbar="true" read-only="$ctrl.route.readOnly"></salaxy-employment-list>
      </div>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/workers/index.html",`<main class="salaxy-content sxytpl-workers-list">
  <section>
    <salaxy-employment-list show-toolbar="true" read-only="$ctrl.route.readOnly" ng-ref="$odata"></salaxy-employment-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/workers/taxcards.html",`<main class="salaxy-content sxytpl-workers-taxcardslist">
  <section class="sxytpl-intro">
    <p class="lead" sxy-text="SALAXY.NG1_Pages.Workers.Taxcards.lead"></p>
  </section>
  <section class="sxytpl-list">
    <salaxy-tax-cards-list></salaxy-tax-cards-list>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages/worktime-imports/index.html",`<main class="salaxy-content sxytpl-usecase-list">
  <section ng-controller="ImportStagingController as $ctrl">
    <div ng-if="$ctrl.isSupported">
      <salaxy-import-staging></salaxy-import-staging>
    </div>
    <div ng-if="!$ctrl.isSupported" class="container">
      <h1>Työajan tuonti ei käytössä</h1>
      <p class="lead">
        Työajan tuonti ei ole käytössä tälle asiakastilille.
        Ominaisuus on käytössä ensimmäisillä kumppaneilla.
        Kysy asiakaspalvelusta miten voit ottaa tuonnin käyttöön.
      </p>
      <p>
        <strong>HUOM:</strong>
        Jos tiedossasi on jo organisaatiosi Staging-palvelimen osoite
        ,<a href="#/settings/pro-settings">voit määrittää sen asetuksissa</a> => Välilehti   "Muut".
      </p>
    </div>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages-personal/account/authorizations.html",`<main class="salaxy-content sxytpl-settings-certificates settings content">
  <section class="sxytpl-credentials">
    <salaxy-credentials></salaxy-credentials>
  </section>
  <section class="sxytpl-certificates">
    <salaxy-certificates></salaxy-certificates>
  </section>
  <section class="sxytpl-authorized-accounts">
    <salaxy-authorized-accounts></salaxy-authorized-accounts>
  </section>
</main>`);

 $templateCache.put("salaxy-components/pages-personal/account/index.html",`<salaxy-account-details-person></salaxy-account-details-person>`);

 $templateCache.put("salaxy-components/pages-personal/archive/employer-archive.html",`<div>
  <p class="lead" sxy-html="SALAXY.NG1_PagesPersonal.employerArchive.intro.html"></p>
  <ul>
    <li><a href="#/archive/employer-paid" sxy-text="SALAXY.NG1_Sitemap.personalWeb.employerArchive.employerPaid"></a></li>
    <li><a href="#/archive/employer-report" sxy-text="SALAXY.NG1_Sitemap.personalWeb.employerArchive.employerReport"></a></li>
    <li><a href="#/household-years/active" sxy-text="SALAXY.NG1_Sitemap.personalWeb.employerArchive.householdYears.main"></a></li>
  </ul>
</div>`);

 $templateCache.put("salaxy-components/pages-personal/archive/employer-paid.html",`<salaxy-calc-list category="paid" read-only="true"></salaxy-calc-list>`);

 $templateCache.put("salaxy-components/pages-personal/archive/employer-report.html",`<salaxy-employer-report></salaxy-employer-report>`);

 $templateCache.put("salaxy-components/pages-personal/archive/household-deduction-report.html",`<div>
  <salaxy-household-deduction-report></salaxy-household-deduction-report>
</div>
`);

 $templateCache.put("salaxy-components/pages-personal/archive/index.html",`<div class="embed loader" salaxy-if-role="auth">
  <salaxy-spinner full-screen="true" id="iFrameLoader" heading="Ladataan tietoja arkistosta..."></salaxy-spinner>
  <iframe src="/Yearly" onload="document.getElementById('iFrameLoader').style.display = 'none'"></iframe>
</div>`);

 $templateCache.put("salaxy-components/pages-personal/archive/worker-report.html",`<salaxy-worker-report></salaxy-worker-report>`);

 $templateCache.put("salaxy-components/pages-personal/calc/details.html",`<div class="container-fixed">
  <salaxy-calc ng-ref="$calc" model="'url'" ng-hide="$calc.currentCalc.workflow.status == 'paymentStarted' || $calc.currentCalc.workflow.status == 'paymentSucceeded'"></salaxy-calc>
  <div class="light-bg" ng-if="$calc.currentCalc.workflow.status == 'paymentStarted' || $calc.currentCalc.workflow.status == 'paymentSucceeded'">
    <salaxy-calc-reports calcs="[$calc.currentCalc]" report-type="'salarySlip'"></salaxy-calc-reports>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages-personal/calc/draft.html",`<salaxy-action-button sxy-if-role="!household" action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation" button-class="btn-primary mb-2 hidden-xxs"></salaxy-action-button>
<salaxy-calc-list category="draft" class="worker-drafts" read-only="'household' | sxyIsInRole"></salaxy-calc-list>`);

 $templateCache.put("salaxy-components/pages-personal/calc/error.html",`<salaxy-calc-list category="error"></salaxy-calc-list>`);

 $templateCache.put("salaxy-components/pages-personal/calc/index.html",`<div class="row d-sm-none d-block">
  <div class="col-xs-12" ng-if="!$ctrl.hideButton">
    <div style="margin-bottom:15px;">
      <salaxy-action-button action="'newCalc'" label="Luo uusi palkkalaskelma"></salaxy-action-button>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-6 col-xs-12 mb-4 mb-sm-0">
    <salaxy-calc-list category="received" mode="panel" limit-to="5" read-only="'household' | sxyIsInRole"></salaxy-calc-list>
  </div>
  <div class="col-sm-6 col-xs-12">
    <salaxy-odata-table url="/v03/api/calculations/category/all" crud-controller="CalculationCrudController as $crud" options="{$top: 5, $filter: 'status eq \\'workerRequested\\' or status eq \\'workerRequestAccepted\\' or status eq \\'workerRequestDeclined\\' or status eq \\'draft\\'', $orderby:  'createdAt desc'}"
      template-url="salaxy-components/odata/lists/CalculationsPanel.html" data="{ category: 'sentAndDraft' }">
    </salaxy-odata-table>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages-personal/calc/paid-household.html",`<salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation" button-class="btn-primary mb-2 hidden-xxs" sxy-if-role="!household"></salaxy-action-button>
<div>
  <salaxy-calc-list category="paid" read-only="true"></salaxy-calc-list>
</div>`);

 $templateCache.put("salaxy-components/pages-personal/calc/paid-worker.html",`<salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation" button-class="btn-primary mb-2 hidden-xxs" sxy-if-role="!household"></salaxy-action-button>
<div>
  <salaxy-calc-list category="received"></salaxy-calc-list>
</div>`);

 $templateCache.put("salaxy-components/pages-personal/calc/paid.html",`<salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation" button-class="btn-primary mb-2 hidden-xxs"></salaxy-action-button>
<salaxy-calc-list category="received"></salaxy-calc-list>`);

 $templateCache.put("salaxy-components/pages-personal/calc/sent.html",`<p class="lead">
  Olet lähettänyt nämä palkkalaskelmat työnantajalle maksettavaksi.
</p>
<salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation" button-class="btn-primary mb-2 hidden-xxs" sxy-if-role="!household"></salaxy-action-button>
<salaxy-calc-list category="sent"></salaxy-calc-list>`);

 $templateCache.put("salaxy-components/pages-personal/calc/shared.html",`<salaxy-calc-list category="shared" read-only="true"></salaxy-calc-list>`);

 $templateCache.put("salaxy-components/pages-personal/calc/sharing.html",`<salaxy-calc-sharing model="'url'"></salaxy-calc-sharing>`);

 $templateCache.put("salaxy-components/pages-personal/employers/index.html",`<!--
  This is currently in test only and Palkkamylly
  TODO: Move component to Palkkamylly and remove from NG1 (may be recreated in Omapalkka)
-->
<salaxy-employer-list></salaxy-employer-list>`);

 $templateCache.put("salaxy-components/pages-personal/home/error404.html",`<div class="alert alert-danger">
  <span sxy-text="SALAXY.NG1_PagesPersonal.error404"></span><br />
</div>`);

 $templateCache.put("salaxy-components/pages-personal/home/index.html",`<div ng-controller="WelcomeController as $welcomeCtrl">

  <div sxy-if-role="anon" class="alert alert-danger" sxy-html="SALAXY.NG1_PagesPersonal.index.alert.anon.html"></div>
  <div sxy-if-role="company" class="alert alert-danger" sxy-html="SALAXY.NG1_PagesPersonal.index.alert.company.html"></div>
  <div sxy-if-role="person">
    <div class="salaxy-component salaxy-component-welcome">
      <div class="" ng-if="!$welcomeCtrl.workerDataNew.timeline">
        <salaxy-spinner></salaxy-spinner>
      </div>

      <div class="timeline my-5 mx-auto px-2">
        <div ng-if="$welcomeCtrl.hasSystemAlert">
          <div>
            <div class="salaxy-welcome-system-alert alert-has-system-alert" ng-bind-html="$welcomeCtrl.systemAlertHtml"></div>
          </div>
        </div>
        <div ng-if="$welcomeCtrl.workerDataNew.timeline" class="d-sm-none d-block timeline-topbar">
          <div class="row mb-3">
            <div class="col-6">
              <salaxy-action-button action="'newTaxcard'" label="SALAXY.NG1.WelcomeComponent.taxcard" button-class="btn-labeled-right btn-primary btn-block"></salaxy-action-button>
            </div>
            <div class="col-6">
              <salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculationAlt" button-class="btn-labeled-right btn-secondary btn-block"></salaxy-action-button>
            </div>
          </div>
          <div class="list-panel panel panel-sm panel-secondary panel-own-taxcard panel-secondary">
            <div ng-show="$welcomeCtrl.workerUI.taxCardAdded" class="salaxy-component table-responsive panel-content md-height">
              <div class="panel-content md-height">
                <div class="panel-body no-vertical-padding salaxy-tax-card-chart chart-container" style="max-height:216px; padding-top:0; padding-bottom:0; padding-left:5px;padding-right:5px;">               
                  <salaxy-chart ng-if="$welcomeCtrl.taxcardChartData.limits.hasLimit == true" custom-height="210px" config="$welcomeCtrl.taxcardMobileChartData"></salaxy-chart>
                  <salaxy-chart ng-if="$welcomeCtrl.taxcardChartData.limits.hasLimit == false || !$welcomeCtrl.taxcardChartData.limits.hasLimit" custom-height="200px" config="$welcomeCtrl.taxcardChartData.config"></salaxy-chart>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ng-repeat="item in $welcomeCtrl.workerDataNew.timeline" class="mb-3">
          <div class="card personal-timeline-card" ng-class="{'card-paid' : item.type == 'calculationPaid'}">
            <div class="card-header d-flex">
              <div class="icon-container d-flex justify-content-center align-items-center" ng-class="{
                'accepted': (item.status == 'workerRequestAccepted' || item.status == 'sharedApproved'), 
                'requested': (item.status == 'workerRequested'|| item.status == 'shared'), 
                'paid' : item.type == 'calculationPaid', 
                'rejected' : (item.status == 'workerRequestDeclined' || item.status == 'sharedRejected' || item.status == 'sharedRejectedWithoutOpen')
              }">
                <i class="bi" ng-class="{
                  'bi-person-vcard': item.type == 'employment', 
                  'bi-person-fill': item.type == 'personAccount', 
                  'bi-calculator-fill': (item.type == 'calculation' && item.status != 'workerRequestAccepted' && item.status != 'workerRequestDeclined' && item.status != 'workerRequested' ),
                  'bi-reply-fill' : (item.status == 'workerRequestAccepted' || item.status == 'sharedApproved'), 
                  'bi-file-earmark-text': (item.type == 'taxcard' && item.status != 'shared' && item.status != 'sharedApproved' && item.status != 'sharedRejected' && item.status != 'sharedRejectedWithoutOpen'), 
                  'bi-arrow-90deg-right' : (item.status == 'shared' || item.status == 'workerRequested'), 
                  'bi-check-lg' : item.type == 'calculationPaid',
                  'bi-x-lg' : (item.status == 'workerRequestDeclined' || item.status == 'sharedRejected' || item.status == 'sharedRejectedWithoutOpen'),
                }">
                </i>
              </div>
              <!--<div class="float-end actions-container clickable text-center">
              <i class="bi bi-three-dots" style="font-size:1.3em;"></i></div>-->
              <div>
                <h3 class="card-title mb-0">{{ item.shortText }}</h3>
                <div class="date">{{ item.logicalDate | sxyDate }}</div>
              </div>
            </div>
            <div class="card-body" ng-class="{'card-body' : !$welcomeCtrl.getPreviewUrl(item)}">
              <div ng-if="$welcomeCtrl.getPreviewUrl(item)" style="max-height: 200px; overflow: hidden;">
                <img ng-src="{{$welcomeCtrl.getPreviewUrl(item)}}" style="width: 100%;" />
              </div>
              <div ng-if="!$welcomeCtrl.getPreviewUrl(item)" ng-switch="item.type">
                <div ng-switch-when="calculation">
                  <div ng-if="item.status != 'draft'" class="otherparty-container">
                    <salaxy-avatar avatar="item.otherPartyInfo.avatar"></salaxy-avatar>
                    <span>{{item.otherPartyInfo.avatar.displayName}}</span>
                  </div>

                  <div class="card-main text-center" ng-class="{'accepted': item.status == 'workerRequestAccepted', 'requested' : item.status == 'workerRequested', 'rejected' : item.status == 'workerRequestDeclined' }">
                    <span class="">{{item.grossSalary | currency}}</span>
                  </div>
                  <div class="card-details-title" sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.grossSalary"></div>
                  <div class="card-details text-center">
                    <span><span sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.netSalary"></span>: {{ item.data.workerPayment | currency }}</span><br>
                    <span><span sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.taxes"></span>: {{ item.data.taxPayment | currency }}</span>
                  </div>
                </div>
                <div ng-switch-when="calculationPaid">
                  <div class="otherparty-container">
                    <salaxy-avatar avatar="item.otherPartyInfo.avatar"></salaxy-avatar>
                    <span>{{item.otherPartyInfo.avatar.displayName}}</span>
                  </div>

                  <div class="card-main text-center paid-calc">
                    <span class="">{{item.grossSalary | currency}}</span>
                  </div>
                  <div class="card-details-title" sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.grossSalary"></div>
                  <div class="card-details text-center">
                    <span><span sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.netSalary"></span>: {{ item.data.workerPayment | currency }}</span><br>
                    <span><span sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.taxes"></span>: {{ item.data.taxPayment | currency }}</span>
                  </div>
                </div>
                <div ng-switch-when="taxcard">
                  <div ng-if="item.status == 'sharedApproved' || item.status == 'sharedRejected' || item.status == 'sharedRejectedWithoutOpen'" class="otherparty-container">
                    <salaxy-avatar avatar="item.ownerInfo.avatar"></salaxy-avatar>
                    <span>{{item.ownerInfo.avatar.displayName}}</span>
                  </div>
                  <div ng-if="item.data.taxPercent" class="card-main text-center" ng-class="{'accepted' : item.status == 'sharedApproved', 'requested' : item.status == 'shared', 'rejected' : (item.status == 'sharedRejected' || item.status == 'sharedRejectedWithoutOpen') }">
                    <span class="">{{item.data.taxPercent || "-"}} %</span>
                  </div>
                  <div class="card-details-title" ng-if="item.data.taxPercent" sxy-text="SALAXY.NG1_PagesPersonal.index.taxcard.taxPercent"></div>
                  <div ng-if="item.data.taxPercent" class="card-details text-center">
                    <strong> {{ "TaxcardKind." + item.data.kind | sxyEnum }}</strong><br>
                    <span ng-if="item.data.incomeLimit"><span sxy-text="SALAXY.NG1_PagesPersonal.index.taxcard.incomeLimit"></span>: {{ item.data.incomeLimit | currency }}</span><br>
                    <span ng-if="item.data.taxPercent2"><span sxy-text="SALAXY.NG1_PagesPersonal.index.taxcard.taxPercent2"></span>: {{ item.data.taxPercent2 }} %</span>
                  </div>
                </div>
                <div ng-switch-when="personAccount">
                  <div class="text-primary">{{ item.ownerInfo.displayName }}</div>
                  <div><a href="mailto:{{ item.ownerInfo.email }}">{{ item.ownerInfo.email }}</a></div>
                  <div><span sxy-text="SALAXY.NG1_PagesPersonal.index.account.iban"></span>: {{ item.ownerInfo.ibanNumber | sxyIban }}</div>
                  <div><span sxy-text="SALAXY.NG1_PagesPersonal.index.account.phone"></span>: {{ item.ownerInfo.telephone }}</div>
                </div>
                <div ng-switch-when="employment">
                  <div class="row">
                    <div class="col-6 text-center">
                      <div class="otherparty-container">
                        <salaxy-avatar avatar="item.ownerInfo.avatar"></salaxy-avatar>
                      </div>
                      <span> {{ item.ownerInfo.avatar.displayName}}</span>
                    </div>
                    <div class="col-6 text-center">
                      <div class="otherparty-container">
                        <salaxy-avatar avatar="item.otherPartyInfo.avatar"></salaxy-avatar>
                      </div>
                      <span> {{ item.otherPartyInfo.avatar.displayName}}</span>
                    </div>
                  </div>
                </div>
                <div ng-switch-default>
                  <!--TODO: Handle {{ item.type }}-->
                </div>
              </div>
              <div class="collapse small" ng-class="{show: item.showInfo}">
                <pre>{{ item | json }}</pre>
              </div>
            </div>
            <div class="card-footer">
              <span ng-switch="item.type">
                <span ng-switch-when="calculationPaid">
                  <a class="btn btn-sm btn-white" target="_blank" ng-href="{{$welcomeCtrl.getPdfUrl(item, true)}}" sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.buttons.openCalculationBtn"></a>
                  <a ng-href="{{$welcomeCtrl.getPdfUrl(item)}}" class="btn btn-sm btn-white" title="tuloste" sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.buttons.downloadPdfBtn"></a>
                </span>
              <a ng-switch-when="calculation" href="#/calc/details/{{item.id}}" class="btn btn-secondary btn-sm" sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.buttons.showCalculationBtn"></a>
              <a ng-switch-when="taxcard" href="#/taxcards" class="btn btn-secondary btn-sm" sxy-text="SALAXY.NG1_PagesPersonal.index.taxcard.buttons.showTaxcardsBtn"></a>
              <a ng-switch-when="personAccount" href="#/account" class="btn btn-secondary btn-sm" sxy-text="SALAXY.NG1_PagesPersonal.index.account.showAccountInfoBtn"></a>
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages-personal/taxcards/household.html",`<div>
  <salaxy-tax-cards-list></salaxy-tax-cards-list>
</div>`);

 $templateCache.put("salaxy-components/pages-personal/taxcards/index.html",`<div class="salaxy-my-taxcards">
  <div ng-controller="MyTaxcardsController as $ctrl">
    <salaxy-spinner ng-if="!$ctrl.current"></salaxy-spinner>
    <div ng-if="$ctrl.current" class="light-bg mb-2">
      <div ng-if="!$ctrl.current.active">
        <p class="lead">
          <span sxy-html="SALAXY.NG1_PagesPersonal.taxcards.introGetAutoTaxcard.html"></span>
        </p>
        <div class="salaxy-placeholder-empty placeholder-md text-center">
          <button type="button" class="btn btn-primary" ng-click="$ctrl.setSharedAutoForSelf()"
            sxy-text="SALAXY.NG1_PagesPersonal.taxcards.buttons.getTaxPercentsBtn"></button>
        </div>
      </div>
      <div ng-if="$ctrl.current.active">
        <div ng-if="$ctrl.current.active.card.kind != 'auto'">
          <p class="lead">
            <span sxy-html="SALAXY.NG1_PagesPersonal.taxcards.introGetAutoTaxcard.html"></span>
            <a href="" ng-click="$ctrl.showMoreText = true" ng-if="!$ctrl.showMoreText" sxy-text="SALAXY.UI_Terms.readMore"></a>
          </p>
        </div>
        <div ng-if="$ctrl.current.active.card.kind == 'auto'" sxy-html="SALAXY.NG1_PagesPersonal.taxcards.intro.html"></div>
        <button type="button" class="btn btn-default float-end" ng-click="$ctrl.setSharedAutoForSelf()"
          sxy-text="SALAXY.NG1_PagesPersonal.taxcards.buttons.checkTaxPercentsBtn"></button>
        <h3 sxy-text="SALAXY.NG1.WorkerDetailsComponent.currentTaxCard"></h3>
        <ng-include src="'salaxy-components/pages-personal/taxcards/TaxcardDetails_Personal.html'"></ng-include>
      </div>
    </div>
    <div ng-if="$ctrl.current" class="light-bg">
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'calc', text: 'SALAXY.NG1_PagesPersonal.taxcards.calcsPaidForCardTabHeading', hidden: !$ctrl.current.active },
          { value: 'employers', text: 'SALAXY.NG1_PagesPersonal.taxcards.employersTabHeading', hidden: !$ctrl.current.employers },
          { value: 'history', text: 'SALAXY.NG1_PagesPersonal.taxcards.earlierTaxCardsTabHeading', hidden: !$ctrl.current.list.length > 0 },
        ]"
        tabs-id="taxcardsIndex">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-taxcardsIndex">
        <div class="tab-pane" id="calc-tab" ng-if="$ctrl.current.active">
          <salaxy-taxcard-income-log parent="$ctrl.current.active" ng-ref="$ctrl.$incomeLog"></salaxy-taxcard-income-log>
        </div>
        <div class="tab-pane" id="employers-tab" ng-if="$ctrl.current.employers">
          <table class="table table-striped">
            <thead>
              <tr>
                <th class="th-xxs" colspan="2">
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.employerTableHeading"></div>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.typeTableHeading"></div>
                </th>
                <th class="d-none d-md-table-cell " sxy-text="SALAXY.NG1_PagesPersonal.taxcards.yearTableHeading"></th>
                <th class="d-none d-md-table-cell text-end">
                  <div sxy-text="SALAXY.MODEL.TaxcardData.taxPercent.title"></div>
                  <div sxy-text="SALAXY.MODEL.TaxcardData.taxPercent2.title"></div>
                </th>
                <th class="text-end">
                  <div sxy-text="SALAXY.NG1.CurrentTaxCardComponent.salariesPaid"></div>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.incomeLimitTableHeading"></div>
                </th>
                <th class="text-end">
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.validDateTableHeading"></div>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.startDateTableHeading"></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="taxCard in $ctrl.current.employers">
                <td class="align-middle td-avatar">
                  <salaxy-avatar avatar="taxCard.ownerInfo.avatar"></salaxy-avatar>
                </td>
                <td>
                  <div class="d-md-none"><strong>{{taxCard.ownerInfo.avatar.displayName}}</strong></div>
                  <div class="d-md-none">
                    <strong>{{ "TaxcardKind." + taxCard.data.kind | sxyEnum }} {{ taxCard.data.forYear }}</strong>
                    {{taxCard.data.taxPercent}} %
                    <span ng-if="taxCard.data.taxPercent2 != null">({{ taxCard.data.taxPercent2 }} %)</span>
                  </div>
                  <div class="d-none d-md-block"><strong>{{taxCard.ownerInfo.avatar.displayName}}</strong></div>
                  <div class="d-none d-md-block">{{ "TaxcardKind." + taxCard.data.kind | sxyEnum }}</div>
                </td>
                <td class="d-none d-md-table-cell ">{{ taxCard.data.forYear }}</td>
                <td class="d-none d-md-table-cell text-end">
                  <div>{{taxCard.data.taxPercent}} %</div>
                  <div>{{taxCard.data.taxPercent2 != null ? (taxCard.data.taxPercent2 + ' %') : '-'}}</div>
                </td>
                <td class="text-end">
                  <div>{{ taxCard.data.totalIncome | currency: ' €' : 0 }}</div>
                  <div>{{(taxCard.data.incomeLimit | currency: ' €' : 0) || '-'}}</div>
                </td>
                <td class="text-end">
                  <div>{{ taxCard.data | sxyDateRange }}</div>
                  <div>{{ taxCard.createdAt | sxyTime }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-pane" id="history-tab" ng-if="$ctrl.current.list.length > 0">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.validDateTableHeading"></div>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.startDateTableHeading"></div>
                </th>
                <th sxy-text="SALAXY.NG1_PagesPersonal.taxcards.yearTableHeading"></th>
                <th class="d-none d-md-table-cell text-end">
                  <div sxy-text="SALAXY.MODEL.TaxcardData.taxPercent.title"></div>
                  <div sxy-text="SALAXY.MODEL.TaxcardData.taxPercent2.title"></div>
                </th>
                <th class="d-table-cell d-md-none text-end">%</th>
                <th class="d-table-cell d-md-none text-end" colspan="2">
                  <div sxy-text="SALAXY.NG1.CurrentTaxCardComponent.salariesPaid"></div>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.incomeLimitTableHeading"></div>
                </th>
                <th class="d-none d-md-table-cell text-end">
                  <div sxy-text="SALAXY.NG1.CurrentTaxCardComponent.salariesPaid"></div>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.incomeLimitTableHeading"></div>
                </th>
                <th class="d-none d-md-table-cell text-end"></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="taxCard in $ctrl.current.list">
                <td>
                  <div>{{ taxCard.data | sxyDateRange }}</div>
                  <div>{{ taxCard.createdAt | sxyTime }}</div>
                </td>
                <td>{{ taxCard.data.forYear }}</td>
                <td class="text-end">
                  <div>{{taxCard.data.taxPercent}}&nbsp;%</div>
                  <div>{{taxCard.data.taxPercent2 != null ? (taxCard.data.taxPercent2 + '&nbsp;%') : '-'}}</div>
                </td>
                <td class="text-end">
                  <div>{{ taxCard.data.totalIncome | currency: ' €' : 0 }}</div>
                  <div>{{(taxCard.data.incomeLimit | currency: ' €' : 0) || '-'}}</div>
                </td>
                <td class="middle-align text-end" ng-if="!taxCard.isReadOnly">
                  <button class="btn btn-danger btn-sm" ng-click="$ctrl.deleteTaxCard(taxCard.id)">
                    <span title="{{'SALAXY.UI_Terms.delete' | sxyTranslate}}">&times;</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages-personal/taxcards/TaxcardDetails_Personal.html",`<div>
  <div class="row">
    <div class="col-md-7 col-lg-7" ng-switch="$ctrl.chartType">
      <div ng-switch-when="full" class="salaxy-tax-card-chart chart-container">    
          <salaxy-chart custom-height="400px" config="$ctrl.getMainChartConfig($ctrl.current.active)"></salaxy-chart>
      </div>
      <div ng-switch-when="pie" class="salaxy-tax-card-chart chart-container text-center">      
          <salaxy-chart style="height: 400px; position: relative;" config="$ctrl.getPieChartConfig($ctrl.current.active)"></salaxy-chart>
      </div>
    </div>
    <div class="col-md-5 col-lg-5">
      <div class="row current-taxcard-row table-row">
        <div class="col-xs-12">
          <strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCardKind"></strong><br /> {{ 'TaxcardKind.' + $ctrl.current.active.card.kind | sxyEnum }}
          ({{$ctrl.current.active.card.forYear}})
        </div>
      </div>
      <div class="row current-taxcard-row table-row">
        <div class="col-xs-8">
          <strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.validDate"></strong><br /> {{$ctrl.current.active.card.validity.start | date}} - {{$ctrl.current.active.card.validity.end | date}}
        </div>
        <div class="col-xs-4 text-right">
          <strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCardAdded"></strong><br />
          <span title="{{ $ctrl.current.active.createdAt | date : 'short' }}">{{ $ctrl.current.active.createdAt | sxyDate }}</span>
        </div>
      </div>
      <table class="table table-sm" style="margin-bottom: 0; margin-top: 6px">
        <thead>
          <tr>
            <th colspan="2" style="padding-left: 0;"><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.mainTaxPercent2"></span></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td sxy-text="SALAXY.NG1.CurrentTaxCardComponent.basicPercent"></td>
            <td class="right">{{ $ctrl.current.active.card.taxPercent }} %</td>
          </tr>
          <tr ng-if="!$ctrl.current.active.card.incomeLimit">
            <td colspan="2"><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noIncomeLimit"></span></td>
          </tr>
          <tr ng-if="$ctrl.current.active.card.incomeLimit">
            <td><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxPercent2.name"></span> <small>(tulorajan {{ $ctrl.current.active.card.incomeLimit | currency : '€' : 0 }}
                {{'SALAXY.NG1.CurrentTaxCardComponent.after' | sxyTranslate}})</small></td>
            <td class="right">{{ $ctrl.current.active.card.taxPercent2 || "-" }} %</td>
          </tr>
          <tr ng-if="$ctrl.current.active.card.taxPercentMin">
            <!-- Only needed if the view is used for showing Employer taxcards: Worker taxcards no longer can have a minimum. -->
            <td>
              <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxPercentMin.title"></span>
            </td>
            <td class="right">
              <span>{{ $ctrl.current.active.card.taxPercentMin || "-" }} %</span>
            </td>
          </tr>
          <tr ng-if="$ctrl.current.active.card.kind == 'auto'">
            <td colspan="2">
              <span class="text-info" ng-if="$ctrl.current.active.card.lastChecked != '2000-01-01T00:00:00Z'"><small>{{'SALAXY.NG1.CurrentTaxCardComponent.taxCardChecked' | sxyTranslate}}
                  {{$ctrl.current.active.card.lastChecked | date: "dd.MM.yyyy HH:mm"}}</small></span>
              <br />
              <button type="button" ng-click="$ctrl.setSharedAutoForSelf()"
                class="btn btn-info">{{'SALAXY.NG1.CurrentTaxCardComponent.checkAutomaticTaxCard' | sxyTranslate}}</button>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-sm" style="margin-top: 6px" ng-if="$ctrl.current.active.card.incomeLimit">
        <thead>
          <tr>
            <th colspan="2" style="padding-left: 0;"><strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.incomeLimit"></strong></th>
            <th class="right">{{ $ctrl.current.active.card.incomeLimit | currency : '€' : 0 }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width: 20px;" class="text-center">-</td>
            <td><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.salariesPaid"></span></td>
            <td class="right">{{ $ctrl.current.active.result.totalIncome | currency }}</td>
          </tr>
          <tr ng-if="$ctrl.current.active.result.totalIncomeJanuary">
            <td></td>
            <td>...<span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.inJanuary"></span></td>
            <td class="right">{{ $ctrl.current.active.result.totalIncomeJanuary | currency }}</td>
          </tr>
          <tr class="total">
            <td colspan="2"><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.beforeIncomeLimit"></span></td>
            <td class="right">{{ $ctrl.current.active.card.incomeLimit - $ctrl.current.active.result.totalIncome | currency }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages-personal/templates/WorkerLayout.html",`<div ng-cloak class="salaxy-component salaxy-navi-page-container container-personal d-flex" ng-class="($ctrl.isNaviOpen ? 'salaxy-navi-sm-opened ' : '') + $ctrl.current.cssClass" ng-if="!$ctrl.showFullPageLoader">
  <div class="salaxy-navi-sidebar d-print-none" ng-if="!$ctrl.showFullPageLoader">
    <div class="salaxy-logo-container">
      <a href="/#/"><!--<img src="/img/navi-logo.png" />--></a>
    </div>
    <div ng-controller="SessionController as $session">
      <div class="salaxy-login-button text-center" style="padding:7px;" ng-hide="$session.isAuthenticated">
        <button ng-click="$session.signIn()" class="btn btn-default salaxy-login-button-login">
        <i class="bi bi-lock-fill me-2"></i>
        <span class="salaxy-login-button-text">{{ $session.isSessionChecking ?  ('SALAXY.NG1.LoginButtonComponent.searching' | sxyTranslate) : ('SALAXY.UI_Terms.login' | sxyTranslate) }}</span>
      </button>
      </div>
      <div class="salaxy-login-button-personal p-2" ng-controller="PersonalWebLegacyController as $legacy">
        <div ng-show="$session.isAuthenticated" class="salaxy-login-button-logout d-flex" ng-init="isNavCollapsed = true">
          <salaxy-avatar avatar="$session.avatar"></salaxy-avatar>
          <div class="login-text ms-2">
            <div class="salaxy-login-button-text">
            {{ $session.isAuthenticated ? $session.avatar.displayName : ('SALAXY.NG1.LoginButtonComponent.authenticating' | sxyTranslate) }}
            </div>
            <div class="d-flex flex-column align-items-start">
              <button ng-if="$session.isAuthenticated" ng-click="$legacy.signOut()" class="btn btn-transparent btn-xs"><i class="bi bi-box-arrow-right me-1" aria-hidden="true" style="font-size: 150%;"></i> <span class="" sxy-text="SALAXY.UI_Terms.logout"></span></button>
              <div class="btn-group language-selection btn-group-xs dropdown" ng-show="'test' | sxyIsInRole" ng-controller="PersonAccountController as $accountCtrl">
                <button type="button" class="btn btn-transparent dropdown-toggle" data-bs-toggle="dropdown">
                  <i class="bi bi-globe-americas me-1" style="font-size:1.1em;"></i>
                  <span> {{"SALAXY.ENUM.Language." + $accountCtrl.getAccountLanguage() + ".label" | sxyTranslate}}</span> 
                  <i class="bi bi-chevron-down"></i>
                </button>
                <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
                  <li role="menuitem" ng-if="$accountCtrl.getAccountLanguage() != 'fi'"><a ng-click="$accountCtrl.current.language = 'fi'; $accountCtrl.saveCurrent()">Suomi</a></li>
                  <li role="menuitem" ng-if="$accountCtrl.getAccountLanguage() != 'en'"><a ng-click="$accountCtrl.current.language = 'en'; $accountCtrl.saveCurrent()">English</a></li>
                  <li role="menuitem" ng-if="$accountCtrl.getAccountLanguage() != 'sv'"><a ng-click="$accountCtrl.current.language = 'sv';$accountCtrl.saveCurrent()">Svenska</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <salaxy-navi-sitemap template-url="salaxy-components/pages-personal/templates/WorkerSitemap.html" mode="accordion"></salaxy-navi-sitemap>
  </div>
  <header class="salaxy-navi-header-mobile align-items-center">
    <h1 class="d-inline">{{ $ctrl.title | sxyTranslate }}</h1>
    <div class="btn-group btn-group-login-button dropdown ms-auto" ng-controller="SessionController as $session">
      <button ng-hide="$session.isAuthenticated" ng-click="$session.signIn()" class="btn btn-default salaxy-login-button-login">
        <i class="bi bi-lock-fill me-2"></i>
        <span class="salaxy-login-button-text">{{ $ctrl.isSessionChecking ?  ('SALAXY.NG1.LoginButtonComponent.searching' | sxyTranslate) : ('SALAXY.UI_Terms.login' | sxyTranslate) }}</span>
      </button>
      <div class="login-button d-flex align-items-center dropdown-toggle" type="button" data-bs-toggle="dropdown" ng-show="$session.isAuthenticated">
        <salaxy-avatar avatar="$session.avatar" style="font-size: 2em;"></salaxy-avatar>
      </div>
      <ul ng-controller="PersonalWebLegacyController as $legacy" class="dropdown-menu" role="menu">
        <li>
          <a class="dropdown-item" href="#" ng-click="$legacy.signOut()" sxy-text="SALAXY.UI_Terms.logout"></a>
        </li>
      </ul>
    </div>
    <button type="button" class="salaxy-navi-hamburger btn btn-default ms-2" ng-click="$ctrl.toggleNavi()">
      <span class="sr-only" sxy-text="SALAXY.UI_Terms.navigation"></span>
      <i class="bi bi-list m-0" aria-hidden="true"></i>
    </button>
  </header>
  <div class="salaxy-navi-main-container pb-5">
    <content>
      <ng-transclude ng-transclude-slot="header">
      </ng-transclude>
      <div id="salaxy-alert-container"></div>
      <ng-transclude ng-transclude-slot="main">
        <main>
          <div class="d-none d-md-block">
            <div ng-class="$ctrl.current.isFullWidth ? 'container-fluid' : 'container'">

              <div class="row" ng-if="$ctrl.current.id != 'home'">
                <div class="col-xs-12">
                  <h1 class="page-title">
                    {{ $ctrl.title | sxyTranslate }}
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div ng-class="$ctrl.current.isFullWidth ? 'container-fluid' :  'container'" ng-view autoscroll="true"></div>
        </main>
      </ng-transclude>
    </content>
  </div>
  <div ng-if="$ctrl.current.id == 'home'">
    <div ng-controller="WelcomeController as $welcomeCtrl" sxy-if-role="worker">
      <div ng-if="$welcomeCtrl.workerDataNew.timeline" class="timeline-sidebar d-none d-sm-block position-fixed me-3 mt-3">
        <div class="list-card card card-sm card-secondary card-own-taxcard card-secondary mb-4">
          <div class="card-header" sxy-text="SALAXY.NG1.WelcomeComponent.taxcard"></div>
          <div ng-show="$welcomeCtrl.workerUI.taxCardAdded" class="salaxy-component table-responsive card-content md-height">
            <div class="card-content md-height">
              <div class="card-body no-vertical-padding salaxy-tax-card-chart chart-container" style="max-height:230px; padding-top:0; padding-bottom:0; padding-left:5px;padding-right:5px;">              
                <salaxy-chart ng-if="$welcomeCtrl.taxcardChartData.limits.hasLimit == true" custom-height="210px" config="$welcomeCtrl.taxcardChartData.config"></salaxy-chart>             
                <salaxy-chart ng-if="$welcomeCtrl.taxcardChartData.limits.hasLimit == false || !$welcomeCtrl.taxcardChartData.limits.hasLimit" config="$welcomeCtrl.taxcardChartData.config"></salaxy-chart>
              </div>
            </div>
          </div>
          <div ng-show="!$welcomeCtrl.workerUI.taxCardAdded" class="card-body card-content md-height align-middle">
            <div class="text-center">
              <p sxy-text="SALAXY.NG1_PagesPersonal.taxcards.buttons.getTaxPercentsBtn"></p>
            </div>
          </div>
          <div class="card-footer text-center">
            <a class="btn btn-primary btn-sm" href="#/taxcards" sxy-text="SALAXY.NG1.WelcomeComponent.taxcard"></a>

          </div>
        </div>
        <div class="list-card card card-sm card-secondary card-new-calculation">
          <div class="card-header" sxy-text="SALAXY.NG1_PagesPersonal.index.sendCalculation.panelHeading"></div>
          <div class="card-body card-content">
            <div class="text-center">
              <h3 class="text-warning" sxy-text="SALAXY.NG1_PagesPersonal.index.sendCalculation.panelTitle"></h3>
              <p sxy-text="SALAXY.NG1_PagesPersonal.index.sendCalculation.panelText"></p>
            </div>
          </div>
          <div class="card-footer text-center">
            <a class="btn btn-primary btn-sm" href="#/calc/details/new" sxy-text="SALAXY.NG1_PagesPersonal.index.sendCalculation.button"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages-personal/templates/WorkerSitemap.html",`<div class="salaxy-component salaxy-navi-sitemap">
  <ul class="list-group">
    <li ng-repeat="section in $ctrl.sitemap | filter:{ hidden: '!true' }" class="list-group-item">
      <a ng-href="{{section.id != 'abc' ? section.url : 'https://help.palkkaus.fi/hc/fi'}}" ng-attr-target="{{section.id == 'abc' ? '_blank' : undefined}}" ng-click="!section.children || !section.children.length ? $ctrl.toggleNavi() : return" ng-class="{ 'active' : $ctrl.isCurrent(section)}">
        <span ng-if="$ctrl.mode=='accordion' && section.children && section.children.length">
          <i class="bi bi-chevron-down float-end" ng-class="{'upside' : $ctrl.getSectionId() == section.id}" aria-hidden="true"></i>
        </span> {{section.title | sxyTranslate}}
      </a>
      <ul ng-hide="!section.children.length || ($ctrl.mode=='accordion' && $ctrl.getSectionId() != section.id)">
        <li class="d-sm-none d-block">
          <strong ng-show="$ctrl.isCurrent(section)">
            <a ng-href="{{section.url}}" ng-click="$ctrl.toggleNavi()">{{section.title | sxyTranslate}}</a>
          </strong>
          <span ng-hide="$ctrl.isCurrent(section)">
            <a ng-href="{{section.url}}" ng-click="$ctrl.toggleNavi()">{{section.title | sxyTranslate}}</a>
          </span>
        </li>
        <li ng-repeat="subNavi in section.children | filter:{ hidden: '!true' }">
          <strong ng-show="$ctrl.isCurrent(subNavi)">
            <a ng-href="{{subNavi.url}}" ng-click="$ctrl.toggleNavi()">{{subNavi.title | sxyTranslate}}</a>
          </strong>
          <span ng-hide="$ctrl.isCurrent(subNavi)">
            <a ng-href="{{subNavi.url}}" ng-click="$ctrl.toggleNavi()">{{subNavi.title | sxyTranslate}}</a>
          </span>
        </li>
      </ul>
    </li>
  </ul>

  <div class="poweredby">
    <span class="poweredby-image"></span>
  </div>
</div>`);

 $templateCache.put("salaxy-components/pages-personal/workers/details.html",`<salaxy-worker-details model="'url'" is-read-only-forced="$ctrl.route.readOnly" hide-button="$ctrl.route.readOnly"></salaxy-worker-details>`);

 $templateCache.put("salaxy-components/pages-personal/workers/index.html",`<salaxy-employment-list read-only="'household' | sxyIsInRole"></salaxy-employment-list>`);

 $templateCache.put("salaxy-components/personal/AccountAuthorizationPerson.html",`﻿<div class="salaxy-component salaxy-account-authorization-person">
  <form name="accountAuthorization" sxy-if-role="auth">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-12">
        <legend sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.identificationTitle"></legend>
        <div class="row table-row" ng-if="!$ctrl.session.currentAccount.identity.contract.isSigned">
          <div class="col-12 " ng-controller="WorkerOnboardingController as $wizard">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.notIdentified"></strong><br>
            <button class="btn btn-primary" ng-click="$wizard.launch()" sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.identifyBtn"></button>
          </div>
        </div>
        <div class="row table-row" ng-if="$ctrl.session.currentAccount.identity.contract.isSigned">
          <div class="col-12">
            <strong><span sxy-text-="SALAXY.NG1.AccountAuthorizationPersonComponent.haveIdentified"></span> {{$ctrl.session.currentAccount.identity.contract.signedAt | date}}.</strong>
          </div>
        </div>
        <div class="row table-row">
          <div class="col-12 col-sm-4">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.credentialLabel"></strong>
          </div>
          <div class="col-12 col-sm-8">
            {{$ctrl.session.currentCredential.avatar.id}}
          </div>
        </div>
        <div class="row table-row">
          <div class="col-12 col-sm-4">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.authorizationTypeLabel"></strong>
          </div>
          <div class="col-12 col-sm-4">
            {{'SALAXY.ENUM.AuthorizationType.' + $ctrl.session.currentAccount.identity.contract.authorizationType + '.label' |sxyTranslate}}
          </div>
          <div class="col-12 col-sm-4  text-end" ng-if="$ctrl.session.currentAccount.identity.contract.authorizationType == 'employerAuthorization'">
            <a class="" ng-href="{{$ctrl.authorizationPdfUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.seePreview"></a>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-12 mt-4">
        <legend sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.userInfoTitle"></legend>
        <div class="row table-row">
          <div class="col-12 col-sm-4">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.userNameLabel"></strong>
          </div>
          <div class="col-12 col-sm-8">
            {{$ctrl.session.currentCredential.email}}
          </div>
        </div>
        <div class="row table-row">
          <div class="col-12 col-sm-4">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.authMethodLabel"></strong>
          </div>
          <div class="col-12 col-sm-8">
            {{'SALAXY.ENUM.AuthenticationMethod.' + $ctrl.session.currentCredential.authenticationMethod + '.label' |sxyTranslate}}
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-12 mt-4">
        <legend sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.termsAndPrivacyTitle"></legend>
        <div class="row table-row">
          <div class="col-12 col-sm-8">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.termsLabel"></strong>
          </div>
          <div class="col-12 col-sm-4 text-end">
            <span sxy-html="SALAXY.NG1.AccountAuthorizationPersonComponent.termsBtn.html"></span>
          </div>
        </div>
        <div class="row table-row">
          <div class="col-12 col-sm-8">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.privacyLabel"></strong>
          </div>
          <div class="col-12 col-sm-4 text-end">
            <span sxy-html="SALAXY.NG1.AccountAuthorizationPersonComponent.privacyBtn.html"></span>

          </div>
        </div>
        <div class="row table-row">
          <div class="col-12 col-sm-8">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.privacyStatementLabel"></strong>
          </div>
          <div class="col-12 col-sm-4 text-end">

            <span sxy-html="SALAXY.NG1.AccountAuthorizationPersonComponent.privacyStatementBtn.html"></span>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>`);

 $templateCache.put("salaxy-components/personal/AccountAvatarEditPerson.html",`<div class="salaxy-component salaxy-account-avatar-edit-person">
  <form name="workerForm" class="form-horizontal" ng-if="$ctrl.current">
    <div class="form-group row">
      <div class="col-4">
        <label for="avatarPreview" class="control-label" style="text-align:left" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarLabel"></label>
      </div>
      <div class="col-8">
        <div class="worker-avatar-col">
          <salaxy-avatar style="font-size: 130px" avatar="$ctrl.current.avatar"></salaxy-avatar>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-4">
        <label for="avatarPictureType" class="control-label" style="text-align:left" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarTypeLabel"></label>
      </div>
      <div class="col-8">
        <select class="form-select" id="avatarPictureType" ng-model="$ctrl.current.avatar.pictureType" ng-change="$ctrl.typeForAvatarChanged()">
          <option value="" disabled sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionChoose"></option>
          <option value="icon" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionIcon"></option>
          <option value="uploaded" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionUploaded"></option>
          <option value="gravatar" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionGravatar"></option>
        </select>
      </div>
    </div>
    <div ng-if="$ctrl.current.avatar.pictureType == 'gravatar'" class="row">
      <div class="input-info col-sm-8 offset-sm-4">
        <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
        <p class="small input-info-text with-icon " sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.gravatarInfo.html"></p>
      </div>
    </div>
    <div ng-if="$ctrl.current.avatar.pictureType == 'icon'">
      <salaxy-input name="avatarInitials" label="SALAXY.NG1.AccountAvatarEditPersonComponent.initialsLabel" ng-model="$ctrl.current.avatar.initials" max-length="2"></salaxy-input>
      <salaxy-input-enum ng-model="$ctrl.current.avatar.color" name="avatarColor" label="SALAXY.NG1.AccountAvatarEditPersonComponent.colorLabel" options="{ '#7F2C2A': ('SALAXY.NG1.AccountAvatarEditPersonComponent.colorBrown' | sxyTranslate), '#91D214': ('SALAXY.NG1.AccountAvatarEditPersonComponent.colorLime' | sxyTranslate), '#61703B': ('SALAXY.NG1.AccountAvatarEditPersonComponent.colorDarkGreen' | sxyTranslate), '#D10074': ('SALAXY.NG1.AccountAvatarEditPersonComponent.colorPink' | sxyTranslate)}">
      </salaxy-input-enum>
    </div>
    <div class="form-group">
      <div ng-if="$ctrl.current.avatar.pictureType == 'uploaded'" class="row">
        <div class="col-4">
          <label for="avatarImageUpload" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImageLabel"></label>
        </div>
        <div class="col-8">
          <div name="avatarImageUpload" ng-model="avatarImage" ngf-drop="$ctrl.uploadAvatarImage($file)" ngf-select="$ctrl.uploadAvatarImage($file)" class="salaxy-drop-box" ngf-drag-over-class="'salaxy-drag-over'" ngf-multiple="false" ngf-min-size="5KB" ngf-max-size="10MB"
            ngf-pattern="'image/*'" ngf-model-invalid="invalidFile" ng-class="invalidFile.$error != null ? 'error' : ''">
            <span sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImage.html"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-8 offset-sm-4 input-info">
        <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
        <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarDescription.html" style="padding-top:0.4em;"></p>
      </div>
    </div>
    <div class="text-end">
      <button ng-click="$ctrl.saveCurrent()" ng-disabled="workerForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </form>
</div>`);

 $templateCache.put("salaxy-components/personal/AccountContactEditPerson.html",`<div class="salaxy-component salaxy-account-contact-edit-person">
  <form name="workerForm" class="form-horizontal" ng-if="$ctrl.current">
    <div class="row">
      <div class="col-12">
        <salaxy-input name="email" label="SALAXY.MODEL.PersonAccount.contact.email.title" sxy-email ng-model="$ctrl.current.contact.email" ng-change="$ctrl.emailForAvatarChanged()">
        </salaxy-input>
        <salaxy-input name="telephone" label="SALAXY.MODEL.PersonAccount.contact.telephone.title" sxy-mobile-phone ng-model="$ctrl.current.contact.telephone"></salaxy-input>
        <salaxy-input name="street" label="SALAXY.MODEL.PersonAccount.contact.street.title" ng-model="$ctrl.current.contact.street" ng-required="'household' | sxyIsInRole"></salaxy-input>
        <div class="address-info-text row mb-3">
          <div class="col-sm-8 offset-sm-4 input-info d-flex align-items-center">
            <i class="bi bi-info-circle-fill text-default me-2"></i>
            <div class="small input-info-text" sxy-text="SALAXY.NG1.AccountContactEditPersonComponent.addressInfo"></div>
          </div>
        </div>
        <salaxy-input name="postalCode" label="SALAXY.MODEL.PersonAccount.contact.postalCode.title" sxy-postal-code-fi ng-model="$ctrl.current.contact.postalCode" ng-required="'household' | sxyIsInRole"></salaxy-input>
        <salaxy-input name="city" label="SALAXY.MODEL.PersonAccount.contact.city.title" ng-model="$ctrl.current.contact.city" ng-required="'household' | sxyIsInRole"></salaxy-input>
      </div>
    </div>
    <div class="text-end">
      <button ng-click="$ctrl.saveCurrent()" ng-disabled="workerForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </form>
</div>`);

 $templateCache.put("salaxy-components/personal/AccountDetailsEditPerson.html",`<div class="salaxy-component salaxy-account-details-edit-person">
  <form name="workerForm" class="form-horizontal" ng-if="$ctrl.current">
    <div class="row language-selection mb-2" ng-controller="SessionController as $session">
      <div class="col-4 control-label"><strong class="" sxy-text="SALAXY.NG1.LanguageSelectionComponent.languageSelectionLabel"></strong></div>
      <div class="col-8">

        <div class="btn-group btn-group-sm float-end" role="group">

          <button class="btn" ng-class="$ctrl.getAccountLanguage() == 'fi' ? 'active btn-primary disabled' : 'btn-default'" ng-click="$ctrl.current.language='fi'" sxy-text="SALAXY.ENUM.Language.fi.label"></button>
          <button class="btn" ng-class="$ctrl.getAccountLanguage() == 'en' ? 'active btn-primary disabled' : 'btn-default'" ng-click="$ctrl.current.language='en'" sxy-text="SALAXY.ENUM.Language.en.label"></button>
          <button class="btn" ng-class="$ctrl.getAccountLanguage() == 'sv' ? 'active btn-primary disabled' : 'btn-default'" ng-click="$ctrl.current.language='sv'" sxy-text="SALAXY.ENUM.Language.sv.label"></button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">

        <salaxy-input name="firstName" label="SALAXY.MODEL.PersonAccount.identity.firstName.title" readonly="true" ng-model="$ctrl.current.identity.firstName"></salaxy-input>
        <salaxy-input name="lastName" label="SALAXY.MODEL.PersonAccount.identity.lastName.title" readonly="true" ng-model="$ctrl.current.identity.lastName"></salaxy-input>
        <div class="row">
          <div class="col-sm-6 offset-sm-4 input-info">
            <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
            <p class="small input-info-text with-icon " sxy-html="SALAXY.NG1.AccountDetailsEditPersonComponent.nameDecription.html"></p>
          </div>
          <div class="col-sm-2">
            <button class="btn btn-default float-end btn-sm" ng-controller="WorkerOnboardingController as $wizard" ng-click="$wizard.launch()" sxy-text="SALAXY.NG1.AccountDetailsEditPersonComponent.launchWizardBtn"></button>
          </div>
        </div>
        <salaxy-input name="officialPersonId" label="SALAXY.MODEL.PersonAccount.identity.officialId.title" sxy-personal-id-fi readonly="true" ng-model="$ctrl.current.identity.officialId">
        </salaxy-input>
        <div class="row">
          <div class="col-sm-8 offset-sm-4 input-info">
            <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
            <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.AccountDetailsEditPersonComponent.personalIdDescription.html"></p>
          </div>
        </div>
        <salaxy-input name="ibanNumber" label="SALAXY.MODEL.PersonAccount.identity.ibanNumber.title" sxy-iban ng-model="$ctrl.current.identity.ibanNumber"></salaxy-input>
      </div>
      <div class="col-12 text-end">
        <button ng-click="$ctrl.saveCurrent()" ng-disabled="workerForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
      </div>
    </div>
  </form>
</div>`);

 $templateCache.put("salaxy-components/personal/AccountDetailsPerson.html",`<div class="salaxy-component salaxy-account-details-person">
  <div class="row">
    <div class="col-12  col-md-4 account-info-container">
      <div class="light-bg">
        <div class="worker-avatar-wrapper">
          <salaxy-account-info-person></salaxy-account-info-person>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-8" ng-if="$ctrl.current">
      <div>
        <salaxy-tab-buttons
          current-tab="$ctrl.currentTab"
          options="[
            { value: 'default', text: 'SALAXY.NG1.AccountDetailsPersonComponent.personalInfoTabHeading' },
            { value: 'contact', text: 'SALAXY.NG1.AccountDetailsPersonComponent.contactInfoTabHeading' },
            { value: 'avatar', text: 'SALAXY.NG1.AccountDetailsPersonComponent.avatarTabHeading' },
            { value: 'identity', text: 'SALAXY.NG1.AccountDetailsPersonComponent.authorizationTabHeading' },
            { value: 'insurance', text: 'SALAXY.NG1.AccountDetailsPersonComponent.insurancesTabHeading', hidden: !('household' | sxyIsInRole) }
          ]"
          tabs-id="accountDetailsPerson">
        </salaxy-tab-buttons>
        <div class="tab-content" id="tab-content-accountDetailsPerson">
          <div class="tab-pane" id="default-tab">
            <salaxy-account-details-edit-person current="$ctrl.current"></salaxy-account-details-edit-person>
          </div>
          <div class="tab-pane" id="contact-tab">
            <salaxy-account-contact-edit-person current="$ctrl.current"></salaxy-account-contact-edit-person>
          </div>
          <div class="tab-pane" id="avatar-tab">
            <salaxy-account-avatar-edit-person current="$ctrl.current"></salaxy-account-avatar-edit-person>
          </div>
          <div class="tab-pane" id="identity-tab">
            <salaxy-account-authorization-person></salaxy-account-authorization-person>
          </div>
          <div class="tab-pane" id="insurance-tab" ng-if="'household' | sxyIsInRole">
            <salaxy-account-insurance-edit-person></salaxy-account-insurance-edit-person>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" sxy-if-role="test">
      <hr />
      <p>Test only:</p>
      <ul ng-controller="SessionController as $session">
        <li>
          Last login as (session):
          <strong>{{ $session.person.lastLoginAs }}</strong> (isEmployer: {{$session.person.isEmployer}}, isWorker: {{$session.person.isWorker}})
        </li>
        <li>
          Server-side:
          <strong>{{ $ctrl.current.lastLoginAs }}</strong> (isEmployer: {{$ctrl.current.isEmployer}}, isWorker: {{$ctrl.current.isWorker}})
        </li>
        <li>
          Vaihda roolia:
          <a ng-click="$session.switchRole('household')">Kotitalous</a>
          <a ng-click="$session.switchRole('worker')">Työntekijä</a>
        </li>
      </ul>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/personal/AccountInfoPerson.html",`<div class="salaxy-component salaxy-account-info-person d-flex">
  <div class="worker-avatar-wrapper">
    <salaxy-avatar avatar="$ctrl.avatar"></salaxy-avatar>
  </div>
  <div class="info-wrapper w-100 ms-2 ms-sm-0">
    <h2>{{ $ctrl.person.avatar.displayName || ("SALAXY.NG1.AccountInfoPersonComponent.noSelection" | sxyTranslate) }}</h2>
    <div class="account-info-contact-details">
      <span ng-if="$ctrl.person.contact.telephone">{{$ctrl.person.contact.telephone}}</span>
      <br /> {{ $ctrl.person.contact.email }}
      <br />
      <span ng-if="$ctrl.person.identity.ibanNumber">
        {{ $ctrl.person.identity.ibanNumber | sxyIban }}
      </span>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/personal/AccountInsuranceEditPerson.html",`<div class="salaxy-component salaxy-account-insurance-edit-person">
  <form name="insuranceForm" class="form-horizontal">
    <legend>Tapaturmavakuutus</legend>
    <div class="input-info">
      <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
      <p class="small input-info-text with-icon">
        Lakisääteinen tapaturmavakuutus on työnantajalle pakollinen, jos maksat palkkaa kaikille työntekijöillesi yhteensä
        <strong>väh. 1500€</strong> kalenterivuoden aikana. Vakuutus on työnantajan vakuutus, joka kattaa kaikki hänen työntekijänsä.
      </p>
      <p class="small input-info-text with-icon" ng-if="($ctrl.personal.insurance.company || 'none') == 'none'">
        Saat hankittua työnantajan lakisääteisen työtapaturmavakuutuksen omasta vakuutusyhtiöstäsi.
        <strong>HUOM:</strong> Vakuutus pitää olla voimassa ennen töiden aloittamista.
      </p>
    </div>
    <div>
      <p>
        <b>Anna voimassa olevan vakuutuksen tiedot.</b> Valitse "Ei yhtiötä", jos sinulla ei ole vakuutusta.
      </p>
      <salaxy-input-enum ng-model="$ctrl.personal.insurance.company" type="select" enum="InsuranceCompany" filter="none,fennia,if,lähiTapiola,pohjantähti,pohjola,turva,aVakuutus,folksam,alandia,ålands" label="SALAXY.MODEL.InsuranceContract.company.editLabel"
        name="insurance-company" require="true"></salaxy-input-enum>
      <div ng-if="($ctrl.personal.insurance.company || 'none') != 'none'">
        <salaxy-input ng-model="$ctrl.personal.insurance.contractNumber" require="true" name="insuranceContractNumber" label="SALAXY.MODEL.InsuranceContract.contractNumber.title">
        </salaxy-input>
        <salaxy-form-group name="insuranceWarning" label-type="empty-label">
          <small>Tähän syötetyt vakuutustiedot näkyvät myös työntekijän palkkalaskelmassa.</small>
        </salaxy-form-group>
      </div>
    </div>
    <div class="text-end">
      <button ng-disabled="!$ctrl.personal.insurance.company || $ctrl.isSaving('insuranceContracts')" class="btn btn-primary" ng-click="$ctrl.save('insuranceContracts')"><i
          ng-if="$ctrl.isSaving('insuranceContracts')" class="bi bi-arrow-repeat bi-spin"></i>
        <span sxy-text="SALAXY.UI_Terms.save"></span></button>
    </div>
  </form>
  <form name="pensionForm" class="form-horizontal">
    <legend>TYEL-sopimus</legend>
    <div class="input-info">
      <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
      <p class="small input-info-text with-icon">
        Palkkaus.fi-palvelu ilmoittaa TyEL-ilmoitukset tulorekisteriin oletuksena suoraan työeläkeyhtiö Varman kautta ja Varma lähettää näistä laskun jälkikäteen.
        <strong>Tilapäinen työnantaja ei tarvitse siihen sopimusta.</strong>
        <br> Jos sinulla on jatkuva työsopimus tai maksat palkkaa yli {{ $ctrl.sideCosts.tyelContractEmployerLimit | currency}} puolessa vuodessa, suosittelemme tekemään sopimuksen työeläkeyhtiön kanssa.
      </p>
    </div>
    <div>
      <p>
        <b>Anna voimassa olevan sopimuksen tiedot.</b> Valitse "Ei yhtiötä", jos olet tilapäinen työnantaja.
      </p>
      <salaxy-input-enum ng-model="$ctrl.personal.pension.company" type="select" label="SALAXY.MODEL.PensionContract.company.editLabel" name="pensionCompany" enum="PensionCompany" filter="none,varma,elo,ilmarinen,veritas,apteekkien,verso,valio,kevaMunicipal,kevaAland,kevaChurch,kevaKela,kevaState" require="true"></salaxy-input-enum>
      <div salaxy-if-role="test" class="test-number">
        <div class="form-group" ng-if="$ctrl.personal.pension.company && $ctrl.personal.pension.company != 'none'">
          <div class="col-sm-8 offset-sm-4 text-sm-end">
            <span>Test only: <button class="btn btn-secondary btn-xs" ng-click="$ctrl.setPensionNumberForTest($ctrl.personal.pension)"> Generoi numero </button></span>
          </div>
        </div>
      </div>
      <salaxy-input ng-if="$ctrl.personal.pension.company && $ctrl.personal.pension.company != 'none'" require="true" name="pensionContractNumber" label="SALAXY.MODEL.PensionContract.contractNumber.title" ng-model="$ctrl.personal.pension.contractNumber" tooltip-html="{{'SALAXY.NG1.InsuranceSettingsComponent.pension.errors.sxyPensionContractNumber.html' | sxyTranslate}}"
        tooltip-placement="right" sxy-pension-contract-number></salaxy-input>
    </div>
    <div ng-show="pensionForm.pensionContractNumber.$error.sxyTemporaryPensionContractNumber">
      <div class="input-info text-danger">
        <div class="input-info-icon"><i class="bi bi-exclamation-triangle-fill "></i></div>
        <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.InsuranceSettingsComponent.pension.errors.sxyTemporaryPensionContractNumber.html"></p>
      </div>
    </div>
    <div class="text-end">
      <button ng-disabled="!$ctrl.personal.pension.company || pensionForm.$invalid || $ctrl.isSaving('pensionContracts')" class="btn btn-primary" ng-click="$ctrl.save('pensionContracts')"><i ng-if="$ctrl.isSaving('pensionContracts')" class="bi bi-arrow-repeat bi-spin"></i>
        <span sxy-text="SALAXY.UI_Terms.save"></span></button>
    </div>
  </form>
  <div>
    <legend>Työttömyysvakuutus</legend>
    <div class="input-info">
      <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
      <p class="small input-info-text with-icon">
        Työttömyysvakuutusmaksuja ei voi maksaa Palkkaus.fi-palvelun kautta, koska <a href="https://www.tyollisyysrahasto.fi/" target="_blank">Työllisyysrahasto</a> laskuttaa työnantajia suoraan neljännesvuosittain, jos työnantaja maksaa palkkaa vähintään
        1500€ kalenterivuoden aikana.
      </p>
      <p class="small input-info-text with-icon">
        Maksut näkyvät laskelmilla, ne ilmoitetaan tulorekisteriin eikä niiden takia tarvitse tehdä mitään muuta, kuin maksaa Työllisyysrahastolta aikanaan tulevat laskut.
      </p>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/personal/CalcHouseholdUsecase.html",`<div class="salaxy-component salaxy-calc-household-usecase">
  <form ng-submit="$ctrl.submitHouseholdUsecase()" ng-readonly="$ctrl.isReadOnly" name="detailsUsecase" class="form-horizontal">
    <div class="salaxy-calc-dialog-body">
      <div class="salaxy-calc-dialog-container">
        <div class="row">
          <div class="col-md-5 col-12" ng-if="$ctrl.isReadOnly">
            <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.startEdit()" sxy-text="SALAXY.UI_Terms.edit"></button>
          </div>
          <div class="col-md-5 col-12" ng-if="!$ctrl.isReadOnly">
            <h1 ng-if="!$ctrl.isUsecaseSelected" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.ui.selectionTitle" class="choose-usecase"></h1>
            <div ng-if="$ctrl.isUsecaseSelected" class="mb-2 ">
              <div ng-if="$ctrl.showSave" class="mb-2">
                <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.saveEmployment()" sxy-text="SALAXY.UI_Terms.save"></button>
                <button type="button" class="btn btn-secondary btn-sm" ng-click="$ctrl.resetEmployment()" sxy-text="SALAXY.UI_Terms.cancel"></button>
                <button ng-if="$ctrl.isUsecaseSelected" class="btn btn-secondary btn-sm" type="button" ng-click="$ctrl.resetUsecase()"><span
                  HouseholdUsecaseComponent></span></button>
              </div>
              <button ng-if="$ctrl.isUsecaseSelected && !$ctrl.showSave" class="btn btn-secondary btn-sm btn-labeled-left" type="button" ng-click="$ctrl.resetUsecase()"><i
                  class="bi bi-chevron-left"></i><span sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.ui.changeSelection"></span></button>
            </div>
            <div ng-if="$ctrl.isUsecaseSelected && !$ctrl.isEmployment" style="padding-top:15px;">
              <h1 sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.ui.salaryDate"></h1>
              <p sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.ui.salaxyDateInfo.html"></p>
              <div class="form-horizontal">
                <salaxy-datepicker-popup name="requestedSalaryDate" ng-model="$ctrl.requestedSalaryDate" label="SALAXY.NG1.CalcWorktimeComponent.salaryDateLabel" label-cols="col-sm-6" date-disabled="salary" placeholder="SALAXY.NG1.HouseholdUsecaseComponent.datePickerPlaceHolder"
                zero-payment="$ctrl.isCurrentZeroPayment" payment-channel="$ctrl.calc.info.paymentChannel"></salaxy-datepicker-popup>
              </div>
              <h1 sxy-text="SALAXY.NG1.CalcWorktimeComponent.worktime.title"></h1>
              <p ng-if="!$ctrl.dateRange.start || !$ctrl.dateRange.start" sxy-text="SALAXY.NG1.CalcWorktimeComponent.worktime.description"></p>
              <div class="form-horizontal">
                <salaxy-input-enum ng-model="$ctrl.periodShortcut" name="periodShortcut" ng-if="!$ctrl.periodShortcut" label="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.label" label-cols="col-sm-6" type="radio" options="$ctrl.periodShortcuts"></salaxy-input-enum>
                <salaxy-input-enum ng-model="$ctrl.periodShortcut" name="periodShortcut" ng-if="$ctrl.periodShortcut" label="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.label" label-cols="col-sm-6" type="select" options="$ctrl.periodShortcuts"></salaxy-input-enum>
                <salaxy-date-range ng-model="$ctrl.dateRange" class="condensed" name="dateRange" ng-if="$ctrl.periodShortcut == 'other'" on-change="$ctrl.dateRangeChange()" label="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.label" label-days-count="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.labelDaysCount"
                  label-cols="col-sm-6" read-only="$ctrl.isReadOnly"></salaxy-date-range>
                <div ng-if="$ctrl.periodShortcut && $ctrl.periodShortcut != 'other'">
                  <salaxy-form-group name="periodStartDate" label="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.labelStartDate" label-cols="col-sm-6">
                    <input type="text" class="form-control" autocomplete="off" id="periodStartDate" name="periodStartDate" placeholder="{{'SALAXY.UI_Terms.dateFormats.dm' | sxyTranslate}}" ng-model="$ctrl.periodStartDate" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }"
                    />
                    <div ng-if="$ctrl.periodStartDateError" class="form-control-plaintext text-danger">{{ $ctrl.periodStartDateError | sxyTranslate }}</div>
                  </salaxy-form-group>
                  <salaxy-form-group name="formattedRange" label="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.labelStartAndEndDate" label-cols="col-sm-6" class="salaxy-read-only">
                    <div class="form-control-plaintext">{{ $ctrl.dateRange | sxyDateRange }}</div>
                  </salaxy-form-group>
                  <salaxy-input-number name="labelDaysCount" ng-model="$ctrl.dateRange.daysCount" ng-change="$ctrl.dateRangeChange()" label="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.labelWorkDaysCount" label-cols="col-sm-6">
                  </salaxy-input-number>
                </div>
              </div>
            </div>
            <div class="accordion salaxy-accordion" ng-if="!$ctrl.isUsecaseSelected">
              <div class="accordion-item" ng-repeat="group in $ctrl.tree">
                <h2 class="accordion-header">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#group{{ $index }}" aria-expanded="false">
                    {{group.label}} <i class="float-end bi" ng-class="{'bi-chevron-up': status.open, 'bi-chevron-down': !status.open}"></i>
                    <br><small>{{group.descr}}</small>
                  </button>
                </h2>
                <div id="group{{ $index }}" class="accordion-collapse collapse" ng-class="{'show': status.open}">
                  <div class="accordion-body" id="child-list">
                    <div ng-repeat="child in group.children" ng-click="$ctrl.selectUsecase(child)" class="clickable usecase-selection">
                      <div class="icon-wrapper salaxy-household-usecase-avatar">
                        <div class="main-icon-wrapper">
                          <img ng-src="{{child.icon}}">
                        </div>
                        <div ng-if="child.badge" class="badge-image-wrapper">
                          <img ng-src="{{child.badge}}">
                        </div>
                      </div>
                      <strong class="usecase-title">{{child.label}}</strong>
                      <small>{{child.descr |sxyTranslate}}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-7 col-12 panel-detail usecase-details" ng-if="$ctrl.isUsecaseSelected">
            <ng-include src="$ctrl.getTemplate()"></ng-include>
          </div>
        </div>
      </div>
    </div>
    <button ng-if="!$ctrl.isReadOnly && !$ctrl.isEmployment" class="btn btn-warning btn-lg salaxy-calc-btn-recalculate" type="submit" sxy-text="SALAXY.UI_Terms.updateCalculation"></button>
  </form>
</div>`);

 $templateCache.put("salaxy-components/personal/CalcSharing.html",`<div class="salaxy-component salaxy-calc-sharing">
  <button class="btn btn-secondary btn-labeled-left btn-sm mb-2" ng-click="$ctrl.showDetails($ctrl.current)"><i class="bi bi-chevron-left"></i> <span sxy-text="SALAXY.NG1.CalcSharingComponent.backBtn"></span></button>
  <p ng-if="$ctrl.showLinkSharing" class="calc-sharing-instructions" sxy-html="SALAXY.NG1.CalcSharingComponent.intro.html"></p>
  <div class="mb-2" ng-if="$ctrl.showLinkSharing">

    <h3 sxy-text="SALAXY.NG1.CalcSharingComponent.sharing.title"></h3>
    <p class="mb-2" sxy-text="SALAXY.NG1.CalcSharingComponent.sharing.description"></p>
    <button ng-click="$ctrl.share('url')" class="btn btn-primary btn-sm">
      <span ng-show="$ctrl.isSharing('url')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.CalcSharingComponent.sharing.createLinkBtn"></span>
     </button>

  </div>

  <h3 sxy-text="SALAXY.NG1.CalcSharingComponent.select.title"></h3>
  <p sxy-text="SALAXY.NG1.CalcSharingComponent.select.description"></p>

  <div class="table-responsive salaxy-odata-table">
    <table class="table table-striped">
      <thead>
        <tr class="">
          <th colspan="2">
            <span sxy-text="SALAXY.NG1_Other.Roles.employer"></span>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.employingRelations">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <strong>{{row.ownerInfo.avatar.displayName}}</strong><br />

          </td>
          <td class="middle right">
            <button class="btn btn-sm btn-primary" type="button" ng-click="$ctrl.share('employer', row)">
               <span sxy-text="SALAXY.UI_Terms.select"></span>  <span ng-show="$ctrl.isSharing('employer'+row.ownerId)"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>


</div>`);

 $templateCache.put("salaxy-components/personal/CalcSharingInfo.html",`<div class="salaxy-component salaxy-calc-sharing-info">
  <div ng-if="$ctrl.current.workflow.status == 'paymentWorkerCopy'">
    <p class="text-center">
      <span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.paidDate"></span> {{ $ctrl.current.workflow.paidAt | date }}
    </p>
    <p>
      <button type="button" ng-click="$ctrl.showCopyAsNew($ctrl.current)" class="btn btn-primary btn-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
    </p>
  </div>
  <div ng-if="$ctrl.current.sharing.type == 'url'">
    <div ng-if="$ctrl.current.workflow.status == 'workerRequested'">
      <p class="text-center">
        <strong sxy-text="SALAXY.NG1.CalcSharingInfoComponent.sharedViaLink"></strong><br>
        <strong class="small" ng-if="$ctrl.current.sharing.lastSharedTo"><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.sharedViaEmail"></span> {{$ctrl.current.sharing.lastSharedTo}}</strong> <br>
        <span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.shareToEmployer"></span>
      </p>
      <form class="form-inline mb-2">
        <div class="form-group copy-share-url">
          <div class="input-group " ng-class="{'has-success': $ctrl.uriCopied}">
            <div class="input-group-text clickable" title="{{'SALAXY.NG1.CalcSharingInfoComponent.copyToClipBoard' | sxyTranslate}}" type="button" ng-click="$ctrl.copyUri()">
              <i class="bi bi-clipboard"></i>
              <span class="text-success text-center text-indicate" ng-if="$ctrl.uriCopied"><br><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.linkCopied"></span></span>
            </div>
            <textarea class="form-control" rows="1" wrap="off">{{$ctrl.current.sharing.uri}}</textarea>
          </div>
        </div>
      </form>

      <div ng-if="!$ctrl.isMobileSharingEnabled" class="mb-2 text-center">
        <div ng-repeat="target in $ctrl.webSharingTargets" style="display:inline">
          <a ng-if="target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-click="target.action()"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
          </a>
          <a ng-if="!target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-href="{{target.getUrl()}}" target="_blank"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
         </a>
        </div>
      </div>
      <div ng-if="$ctrl.isMobileSharingEnabled" class="mb-2 text-center">
        <div ng-repeat="target in $ctrl.mobileSharingTargets" style="display:inline">
          <a ng-if="target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-click="target.action()"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
          {{target.title}}
          </a>
          <a ng-if="!target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-href="{{target.getUrl()}}" target="_blank"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
          {{target.title}}
         </a>
        </div>
      </div>
      <div class="text-center mb-2">
        <button class="btn btn-secondary btn-sm" ng-click="$ctrl.share('undefined')"><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.deleteLinkBtn"></span><span ng-show="$ctrl.isSharing('undefined')"><i class="bi bi-arrow-repeat bi-spin"></i></span></button>
        <button class="btn btn-primary btn-sm" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
      </div>
    </div>
    <div ng-if="$ctrl.current.workflow.status == 'workerRequestAccepted'">
      <p class="text-center">
        <strong class="text-success" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestAccepted"></strong>
      </p>
      <div ng-if="$ctrl.employer" class="mb-2">
        <salaxy-avatar style="font-size:45px;" avatar="$ctrl.employer.ownerInfo.avatar"></salaxy-avatar>
        <div>
          <strong>&nbsp;{{$ctrl.employer.ownerInfo.avatar.displayName}}</strong>
        </div>
      </div>
      <div class="text-center mb-2">

        <button class="btn btn-primary btn-sm" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
      </div>
    </div>
    <div ng-if="$ctrl.current.workflow.status == 'workerRequestDeclined'">
      <p class="text-center">
        <strong class="text-danger" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestDeclined"></strong>
      </p>
      <form ng-if="!$ctrl.isMobileSharingEnabled" class="form-inline mb-2">
        <div class="form-group copy-share-url">
          <div class="input-group " ng-class="{'has-success': $ctrl.uriCopied}">
            <div class="input-group-text clickable" title="{{'SALAXY.NG1.CalcSharingInfoComponent.copyToClipBoard' | sxyTranslate}}" type="button" ng-click="$ctrl.copyUri()">
              <i class="bi bi-clipboard"></i>
              <span class="text-success text-center text-indicate" ng-if="$ctrl.uriCopied"><br><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.linkCopied"></span></span>
            </div>
            <textarea class="form-control" rows="1" wrap="off">{{$ctrl.current.sharing.uri}}</textarea>
          </div>
        </div>
      </form>

      <div ng-if="!$ctrl.isMobileSharingEnabled" class="mb-2 text-center">
        <div ng-repeat="target in $ctrl.webSharingTargets" style="display:inline">
          <a ng-if="target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-click="target.action()"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
          </a>
          <a ng-if="!target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-href="{{target.getUrl()}}" target="_blank"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
         </a>
        </div>
      </div>
      <div ng-if="$ctrl.isMobileSharingEnabled" class="mb-2 text-center">
        <div ng-repeat="target in $ctrl.mobileSharingTargets" style="display:inline">
          <a ng-if="target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-click="target.action()"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
          {{target.title}}
          </a>
          <a ng-if="!target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-href="{{target.getUrl()}}" target="_blank"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
          {{target.title}} 
         </a>
        </div>
      </div>
      <div class="text-center mb-2">
        <button class="btn btn-secondary btn-sm" ng-click="$ctrl.share('undefined')"><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.deleteLinkBtn"></span><span ng-show="$ctrl.isSharing('undefined')"><i class="bi bi-arrow-repeat bi-spin"></i></span></button>
        <button class="btn btn-primary btn-sm" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
      </div>
    </div>
  </div>

  <div ng-if="$ctrl.current.sharing.type == 'employer'" class="text-center">
    <div ng-if="$ctrl.current.workflow.status == 'workerRequested'">
      <p class="text-center"><strong class="text-warning" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequested"></strong></p>
      <div ng-if="$ctrl.employer" class="mb-2">
        <salaxy-avatar style="font-size:45px;" avatar="$ctrl.employer.ownerInfo.avatar"></salaxy-avatar>
        <div>
          <strong>&nbsp;{{$ctrl.employer.ownerInfo.avatar.displayName}}</strong>
        </div>
      </div>
      <button class="btn btn-secondary btn-sm" ng-click="$ctrl.share('undefined')"><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.cancelDeliveryBtn"></span> <span ng-show="$ctrl.isSharing('undefined')"><i class="bi bi-arrow-repeat bi-spin"></i></span></button>
      <button class="btn btn-primary btn-sm" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>

    </div>
    <div ng-if="$ctrl.current.workflow.status == 'workerRequestAccepted'">
      <p class="text-center"><strong class="text-success" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestAccepted"></strong></p>
      <div ng-if="$ctrl.employer" class="mb-2">
        <salaxy-avatar style="font-size:45px;" avatar="$ctrl.employer.ownerInfo.avatar"></salaxy-avatar>
        <div>
          <strong>&nbsp;{{$ctrl.employer.ownerInfo.avatar.displayName}}</strong>
        </div>
      </div>

      <button class="btn btn-primary btn-sm" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
    </div>
    <div ng-if="$ctrl.current.workflow.status == 'workerRequestDeclined'">
      <p class="text-center"><strong class="text-danger" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestDeclined"></strong></p>
      <div ng-if="$ctrl.employer" class="mb-2">
        <salaxy-avatar style="font-size:45px;" avatar="$ctrl.employer.ownerInfo.avatar"></salaxy-avatar>
        <div>
          <strong>&nbsp;{{$ctrl.employer.ownerInfo.avatar.displayName}}</strong>
        </div>
      </div>
      <button class="btn btn-secondary btn-sm" ng-click="$ctrl.share('undefined')"><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.cancelDeliveryBtn"></span> <span ng-show="$ctrl.isSharing('undefined')"><i class="bi bi-arrow-repeat bi-spin"></i></span></button>
      <button class="btn btn-primary btn-sm" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
    </div>
  </div>
  <div ng-if="$ctrl.current.sharing.type == 'undefined'">
    <p ng-if="$ctrl.current.workflow.status == 'workerRequested'" class="text-center"><strong sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestedAlt"></strong></p>
    <p ng-if="$ctrl.current.workflow.status == 'workerRequestAccepted'" class="text-center"><strong class="text-success" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestAccepted"></strong></p>
    <p ng-if="$ctrl.current.workflow.status == 'workerRequestDeclined'" class="text-center"><strong class="text-danger" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestDeclined"></strong></p>
    <button ng-if="$ctrl.validation.isValid && ( !$ctrl.current.isReadOnly || $ctrl.current.workflow.status == 'workerRequestDeclined')" class="btn btn-primary btn-block" ng-click="$ctrl.showSharing()" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.sendToEmployerBtn"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/personal/EmployerList.html",`<div class="salaxy-component salaxy-employer-list">
  <div class="list-group avatar-list-group">
    <div ng-repeat="row in $ctrl.selectedItems" class="list-group-item">
      <div class="list-group-item-content-wrapper d-flex flex-wrap align-items-center">
        <salaxy-avatar avatar="row.ownerInfo.avatar" class="icon-wrapper"></salaxy-avatar>
        <div class="list-group-item-text-wrapper ms-3 d-flex flex-column">
          <div class="list-group-item-heading">{{row.ownerInfo.avatar.displayName}}</div>
          <div class="list-group-item-text">{{row.ownerInfo.email}}</div>
        </div>
        <button ng-click="$ctrl.setEmployerSelected(row, false);" class="btn btn-sm btn-default ms-auto" sxy-text="SALAXY.UI_Terms.change"></button>
      </div>
    </div>
  </div>
  <div ng-if="!$ctrl.selectedItems.length">

    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr class="">
            <th colspan="2">
              <span class="clickable" sxy-text="SALAXY.NG1_Other.Roles.employer"></span>
            </th>
            <th>
              <span sxy-text="SALAXY.NG1.WorkerListComponent.employment"></span><br />
              <span class="small"><span sxy-text="SALAXY.UI_Terms.updated"></span></span>
            </th>
            <!--th sxy-text="Palkkoja maksettu"></th-->
            <th class="right"> </th>
          </tr>
        </thead>

        <tbody>
          <tr ng-repeat="row in $ctrl.employingRelations">
            <td class="td-avatar middle">
              <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
            </td>
            <td class="td-name middle">
              <strong>{{row.ownerInfo.avatar.displayName}}</strong><br />
              <span class="sm-description">
              {{row.ownerInfo.email}}
            </span>
            </td>
            <td class="middle">
              {{ row.data | sxyDateRange }}<br /> <small>{{ row.updatedAt | date}}</small>
            
            </td>
            <!--td class="middle">
            <span class="">TODO: viimeisin palkka (pvm)</span><br>
            <span class="">TODO: tänä vuonna yht €</span>
          </td-->
            <td class="right middle">
              <button class="btn btn-sm btn-default" sxy-text="SALAXY.UI_Terms.calculations" ng-click="$ctrl.setEmployerSelected(row, true)"></button>
              <!-- TODO button class="btn btn-sm btn-default" sxy-text="SALAXY.UI_Terms.newCalculation"></button-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>



  <salaxy-odata-table ng-if="$ctrl.selectedItems.length" url="/v03/api/calculations/category/all" crud-controller="CalculationCrudController as $crud" options="{ $filter: 'otherId eq \\'' + $ctrl.employerId + '\\' and (status eq \\'paymentWorkerCopy\\' or status eq \\'workerRequested\\' or status eq \\'workerRequestAccepted\\' or status eq \\'workerRequestDeclined\\') ' }"
    template-url="salaxy-components/odata/lists/CalculationsEmployer.html">
  </salaxy-odata-table>

</div>

<div class="salaxy-component salaxy-employer-list d-none">
  <div ng-if="!$ctrl.employingRelations.length" class="">
    <h2>Ei työnantajia</h2>
  </div>
  <div ng-if="$ctrl.employingRelations.length" class="">
    <div class="list-group avatar-list-group">
      <div class="list-group-item list-group-header">


        <div class="list-group-item-content-wrapper one-third">
          <div class="list-group-item-text-wrapper">
            <p class="list-group-item-heading">Työnantaja</p>
          </div>
        </div>
        <div class="list-group-item-content-wrapper one-fifth">
          <div class="list-group-item-text-wrapper">
            <p class="list-group-item-heading">Työsuhde alkanut<br>...päivitetty</p>

          </div>
        </div>
        <div class="list-group-item-content-wrapper one-fifth">
          <div class="list-group-item-text-wrapper">
            <p class="list-group-item-heading">Työsuhde alkanut<br> ...päivitetty
            </p>

          </div>
        </div>
      </div>



      <div ng-repeat="row in $ctrl.employingRelations" class="list-group-item">

        <div class="list-group-item-content-wrapper one-third">
          <salaxy-avatar avatar="row.ownerInfo.avatar" class="float-start icon-wrapper"></salaxy-avatar>
          <div class="list-group-item-text-wrapper">

            <h4 class="list-group-item-heading">{{row.ownerInfo.avatar.displayName}}</h4>
            <p class="list-group-item-text">{{row.ownerInfo.email}}</p>
          </div>
        </div>
        <div class="list-group-item-content-wrapper one-fifth">
          <div class="list-group-item-text-wrapper">
            <h4 class="list-group-item-heading">{{row.createdAt | date}}</h4>
            <p class="list-group-item-text">{{row.updatedAt | date}}</p>
          </div>
        </div>
        <div class="list-group-item-content-wrapper one-fifth">
          <div class="list-group-item-text-wrapper">
            <h4 class="list-group-item-heading">{{row.createdAt | date}}</h4>
            <p class="list-group-item-text">{{row.updatedAt | date}}</p>
          </div>
        </div>
      </div>
      <button ng-click="$ctrl.setEmployerSelected(row, true)" class="btn btn-xs btn-default" sxy-text="SALAXY.UI_Terms.select"></button>
    </div>
  </div>
</div>
</div>`);

 $templateCache.put("salaxy-components/personal/EmployerReport.html",`<div class="salaxy-component salaxy-employer-report mt-3">
  <salaxy-spinner heading="SALAXY.UI_Terms.loading" ng-if="!$ctrl.currentReport"></salaxy-spinner>
  <div class="d-flex align-items-center float-end">
    <label>Valitse vuosi: </label>
    <select class="form-select ms-2" ng-options="option.name for option in $ctrl.yearOptions track by option.value" ng-model="$ctrl.selectedYear" name="years" id="years"></select>
  </div>
  <div ng-if="$ctrl.currentReport.employerReports.length <= 0">
    <p>
      Sinulla ei ole Palkkaus.fi-palvelussa vuonna {{ $ctrl.selectedYear.value }} maksettuja palkkoja.
      Vetovalikosta voit vaihtaa raportointivuotta.
    </p>
    <hr />
    <h2>Ei palkanmaksuja vuonna {{ $ctrl.selectedYear.value }}</h2>
    <p>
      Kun maksat palkkoja kauttamme, edellisten vuosien palkat ja niistä tehdyt raportit jäävät arkistoon tälle sivulle.
      Muut raportit kohdassa voit esikatsella muutaman yleisen raportin
      ja sivun alalaidasta löydät lisätietoja työntekijäkohtaisista raporteista.
    </p>
  </div>
  <div ng-if="$ctrl.currentReport.employerReports.length > 0">
    <p>
      Alla näet kaikki palkanmaksut, jotka olet tehnyt Palkkaus.fi-palvelun kautta vuonna {{ $ctrl.selectedYear.value }}.
    </p>
    <hr />
    <h3>Raportit työntekijöittäin</h3>
    <p>
      Alla on listattu työntekijöittäin ja palkkalaskelmittain tärkeimmät tiedot ja raportit:
      Työntekijän yhteenveto ja Verottajan vuosi-ilmoitus (7801)<span ng-if="$ctrl.selectedYear.value < 2021"> sekä Kotitalousvähennyksen vuosi-ilmoitus (14B)</span>.
      Lisätietoja raporteista löydät sivun alalaidasta.
    </p>
    <table class="table" ng-controller="WorkerSummaryReportDisplayController as $displayCtrl">
      <thead>
        <tr>
          <th colspan="2">Työntekijä</th>
          <th class="right">
            Bruttopalkka<br />
            Verotettava
          </th>
          <th>Yhteenveto</th>
          <th>Vero (7801)</th>
          <th ng-if="$ctrl.selectedYear.value < 2021">KT-väh. (14B)</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat-start="report in $ctrl.currentReport.employerReports">
          <td>
            <div style="font-size: 64px; line-height: 1" ng-init="avatar = $ctrl.avatarFrom(report.worker.avatar.url)">
              <i ng-if="!avatar.url" class="salaxy-avatar bi" ng-class="avatar.baseIcon" ng-style="{color: avatar.color }"><strong>{{ avatar.initials }}</strong></i>
              <i ng-if="avatar.url" class="salaxy-avatar bi"><img ng-src="{{avatar.url}}"></img></i>
            </div>
          </td>
          <td>
            {{ report.worker.fullName}}<br />
            <a ng-href="mailto:{{ $ctrl.workerEmailFrom(report) }}">{{ $ctrl.workerEmailFrom(report) }}</a><br />
            {{ report.worker.identity.socialSecurityNumberValid }}
          </td>
          <td class="right">
            {{ report.grossSalary | currency : "€" : 2}}<br />
            {{ report.totalTaxable | currency : "€" : 2}}
          </td>
          <td>
            <a ng-click="$displayCtrl.display($ctrl.selectedYear.value + '-01-01', report.worker.identity.socialSecurityNumberValid , $ctrl.employerId )"
              >Yhteenveto&nbsp;&raquo;
            </a>
          </td>
          <td>
            <a ng-if="$ctrl.isSelectedYearBeforeIncomesRegistry"
              href="{{ $ctrl.apiServerAddress }}/ReportPdf/TaxYearly7801/{{ report.worker.identity.socialSecurityNumberValid }}?year={{ $ctrl.selectedYear.value }}&access_token={{ $ctrl.token }}"
              target="_blank">Tuloste&nbsp;&raquo;
            </a>
          </td>
          <td ng-if="$ctrl.selectedYear.value < 2021">
            <a ng-if="report.totalTaxableDeductible > 0"
              ng-href="{{ $ctrl.apiServerAddress }}/ReportPdf/TaxHouseholdDeduction14B/{{ report.worker.identity.socialSecurityNumberValid }}?year={{ $ctrl.selectedYear.value }}&access_token={{ $ctrl.token }}"
              target="_blank" class="">Tuloste&nbsp;&raquo;
            </a>
            <p ng-if="report.totalTaxableDeductible <= 0">Ei merkitty koti&shy;talous&shy;vähen&shy;nykseen.</p>
          </td>
        </tr>
        <tr ng-repeat-end="" ng-repeat="calculation in report.underlyingCalculations">
          <td></td>
          <td>
            <b ng-if="!$ctrl.isSelectedYearBeforeIncomesRegistry">
              {{ calculation.salaryDate | date : "dd.MM" }}
            </b>
            <b ng-if="$ctrl.isSelectedYearBeforeIncomesRegistry">
              {{ calculation.paidAt | date : "dd.MM" }}
            </b>
          </td>
          <td class="right">
            {{ calculation.totals.totalGrossSalary | currency : "€" : 2 }}<br />
            {{ calculation.totals.totalTaxable | currency : "€" : 2 }}
          </td>
          <td ng-controller="CalcReportsDisplayController as $displayCtrl">
            <button  ng-click="$displayCtrl.displayForId('salarySlip', calculation.id)"
                    class="btn btn-primary btn-xs">Tuloste&nbsp;&raquo;</button><br />
          <td>
            {{ calculation.workerCalc.tax > 0 ? "Ennakonpidätys: " + (calculation.workerCalc.tax | currency : "€" : 2) : "Ei ennakonpidätystä" }}
          </td>
          <td ng-if="$ctrl.selectedYear.value < 2021">
            {{ calculation.salary.isDeductible ? "Kotitalousvähennys: " + (calculation.employerCalc.householdDeduction | currency : "€" : 2) : "Ei lasketa kotitalousväh." }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <hr />
  <br />
  <h3>Muut raportit</h3>
  <p>Raportit, jotka eivät ole työntekijäkohtaisia.</p>
  <div class="row">
    <div ng-if="$ctrl.isSelectedYearBeforeIncomesRegistry" class="col-sm-4">
      <h4>TVR Palkka&shy;summa&shy;ilmoitus</h4>
      <p>
        Työttömyys&shy;vakuutus&shy;rahastolle (TVR) ilmoitetaan
        yhteystiedot, palkkasumma sekä tilinumero mahdollisia takaisinmaksuja varten.
      </p>
      <p>
        <strong>
          Ilmoitettava palkkasumma on: {{ $ctrl.tvrSalaryAmount | currency : "" : 2 }} euroa.
        </strong>
      </p>
      <p>
        Avaa <a ng-href="{{ $ctrl.apiServerAddress }}/ReportPdf/Unemployment?year={{ $ctrl.selectedYear.value }}&access_token={{ $ctrl.token }}" target="_blank">PDF-dokumentti
          tästä linkistä</a>.
      </p>
    </div>
    <div class="col-sm-4">
      <h4>Vakuutusyhtiön vuosi-ilmoitus</h4>
      <p>
        Vakuutus- tai työeläkeyhtiö saattaa vaatia sinulta selvitystä maksetuista palkoista vuoden ajalta.
        Tämä raportti on tarkoitettu sitä varten.
      </p>
      <p>
        <strong>
          Jos olet ostanut tapaturmavakuutuksen Palkkaus.fi-palvelusta ja
          olet antanut Palkkaus.fi-palvelun hoitaa TyEL-vakuutuksen,
          ei tämä raportti ole tarpeellinen.
        </strong>
      </p>
      <p>
        Avaa <a ng-href="{{ $ctrl.apiServerAddress }}/ReportHtml/Insurance?year={{ $ctrl.selectedYear.value }}&access_token={{ $ctrl.token }}" target="_blank">Raportti tästä</a>.
      </p>
    </div>
    <div class="col-sm-4">
      <h4>Raportti kotitalous&shy;vähennyksistä</h4>
      <p>
        Yksityiskohtainen raportti näyttää yhdessä näkymässä kaikki
        kotitalousvähennysta varten Palkkauksen verottajalle ilmoittamat tiedot.
      </p>
      <p>
        Lisäksi tietoa miten ilmoitat Palkkaus.fi-palvelun ulkopuolella maksetut kotitalousvähennyksen alaiset kustannukset.
      </p>
      <p>
        Avaa <a  ng-href="{{$ctrl.selectedYear.value < 2021 ? '#/archive/household-deduction-report' : '#/household-years/active'}}">Raportti tästä</a>.
      </p>
    </div>
  </div>
  <hr />
  <br />
  <h3 id="more-info">Lisätietoja raporteista</h3>
  <p>
    Lisätietoja yllä listatutuista työntekijäkohtaisista raporteista.
  </p>
  <div class="row">
    <div class="col-sm-4">
      <h4>Työntekijän yhteenveto</h4>
      <p>
        Lain mukaan työnantajan pitää toimittaa työntekijälle yhteenveto kaikista palkoista, joita on maksanut vuoden aikana.
      </p>
      <p>
        <strong>Jos Palkkaus.fi-palvelussa on työntekijän sähköpostiosoite, lähetämme tähän linkin suoraan työntekijälle.</strong>
        Jos sähköpostiosoite ei ole oikein, voit tulostaa tämän yhteenvedon ja lähettää työntekijälle.
      </p>
      <ul ng-controller="WorkerSummaryReportDisplayController as $displayCtrl">
        <li ng-repeat="employerReport in $ctrl.currentReport.employerReports">
          <a ng-click="$displayCtrl.display($ctrl.selectedYear.value + '-01-01', employerReport.worker.identity.socialSecurityNumberValid , $ctrl.employerId )">{{
            employerReport.worker.fullName }}</a>
          {{ $ctrl.workerEmailFrom(employerReport) || 'Ei sähköpostia' }}
        </li>
      </ul>
    </div>
    <div ng-if="$ctrl.isSelectedYearBeforeIncomesRegistry" class="col-sm-4">
      <h4>Vuosi-ilmoitus verottajalle (7801)</h4>
      <p>
        <i>Verottajan lomake 7801: Työnantajan tai suorituksen maksajan vuosi-ilmoitus</i>
        Näitä lomakkeita tuotamme jokaista työntekijääsi kohden yhden.
      </p>
      <p>
        Jokaisen vuoden tammikuussa luomme edellisen vuoden ilmoitukset ja voit vielä tarkistaa lomakkeen tiedot.
        Tämän jälkeen <strong>lähetämme ilmoituksen verottajalle</strong> ja alkuperäinen ilmoitus jää Palkkaus.fi-arkistoon.
      </p>
      <ul>
        <li ng-repeat="employerReport in $ctrl.currentReport.employerReports">
          <a href="{{ $ctrl.apiServerAddress }}/ReportPdf/TaxYearly7801/{{ employerReport.worker.identity.socialSecurityNumberValid }}?year={{ $ctrl.selectedYear.value }}&access_token={{ $ctrl.token }}"
            target="_blank">{{
            employerReport.worker.fullName }}</a>
        </li>
      </ul>
    </div>
    <div class="col-sm-4" >
      <h4>Kotitalous&shy;vähennyksen vuosi-ilmoitus (14B)</h4>
      <p>
        <i>Verottajan lomake 14B / 3026: Kotitalousvähennys työntekijälle maksetusta palkasta</i>
        Yhteen lomakesivuun mahtuu tiedot kahdesta työntekijästä
      </p>
      <p>
        <strong>
          Lähetämme tiedot verottajalle tammikuun loppuun mennessä,
        </strong> kun olet käynyt tarkistamassa tietosi
      </p>
      <p>
        Huomaathan, että verottaja käsittelee kaikki lomakkeet 14B yhdellä kertaa veroilmoitusten kanssa kesäkuussa,
        joten nämä tiedot eivät näy vielä esitäytetyssä veroilmoituksessa.
      </p>

      <ul ng-if="$ctrl.selectedYear.value < 2021">
        <li ng-repeat="employerGroup in $ctrl.employers14BGroups">
          <a href="{{ $ctrl.apiServerAddress }}/ReportPdf/TaxHouseholdDeduction14B/{{ employerGroup.id1 }}?id2={{ employerGroup.id2 }}&year={{ $ctrl.selectedYear.value }}&access_token={{ $ctrl.token }}"
            target="_blank">
            {{ employerGroup.names }}
          </a>
        </li>
      </ul>
      <span ng-if="$ctrl.selectedYear.value >= 2021">Avaa <a href="#/household-years/active">Raportti tästä</a>.</span>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/personal/EmployerSelect.html",`<div class="salaxy-component salaxy-employer-select">
  <div ng-if="!$ctrl.employingRelations.length" class="">
    <h2>Ei työnantajia</h2>
  </div>


  <div class="list-group avatar-list-group">
    <div ng-repeat="row in $ctrl.selectedItems" class="list-group-item">
      <div class="list-group-item-content-wrapper">
        <salaxy-avatar avatar="row.ownerInfo.avatar" class="float-start icon-wrapper"></salaxy-avatar>
        <div class="list-group-item-text-wrapper">
          <h4 class="list-group-item-heading">{{row.ownerInfo.avatar.displayName}}</h4>
          <p class="list-group-item-text">{{row.owner | sxyIban}}</p>
        </div>
      </div>

      <button ng-if="$ctrl.employingRelations.length > 1" ng-click="$ctrl.setEmployerSelected(row, false);" class="btn btn-xs btn-default" sxy-text="SALAXY.UI_Terms.change"></button>

    </div>
  </div>

  <div ng-if="$ctrl.employingRelations.length > 1 && !$ctrl.selectedItems.length">
    <div class="list-group avatar-list-group">
      <div ng-repeat="row in $ctrl.employingRelations" class="list-group-item">
        <div class="list-group-item-content-wrapper">
          <salaxy-avatar avatar="row.ownerInfo.avatar" class="float-start icon-wrapper"></salaxy-avatar>
          <div class="list-group-item-text-wrapper">
            <h4 class="list-group-item-heading">{{row.ownerInfo.avatar.displayName}}</h4>
            <p class="list-group-item-text">{{row.owner | sxyIban}}</p>
          </div>
        </div>
        <button ng-click="$ctrl.setEmployerSelected(row, true)" class="btn btn-xs btn-default" sxy-text="SALAXY.UI_Terms.select"></button>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/personal/HouseholdDeductionReport.html",`<div style="max-width: calc(100% - 45px); margin-left: 15px">
  <salaxy-spinner heading="SALAXY.UI_Terms.loading" ng-if="!$ctrl.currentReport"></salaxy-spinner>
  <div class="row">
    <div class="col-12 mb-2">
      <label>Valitse vuosi: </label>
      <select class="form-select" ng-options="option.name for option in $ctrl.yearOptions track by option.value" ng-model="$ctrl.selectedYear" name="years" id="years"></select>
    </div>
  </div>
  <h2>Palkkaus.fi-palvelussa maksetut palkat</h2>
  <h3 ng-repeat-start="yearlyReport in $ctrl.currentReport" ng-if="$index == 0">Nämä työt voit vähentää omassa verotuksessasi.</h3>
  <p ng-if="$index == 0">Kotitalousvähennys on enintään {{ $ctrl.deductionMaxAmount | currency : "" : 0 }} euroa vuodessa. Vähennyksen omavastuu on 100 euroa.</p>
  <h3 ng-if="$index == 1">Nämä työt voit vähentää mahdollisen puolisosi verotuksessa.</h3>
  <p ng-if="$index == 1">Kotitalousvähennys on henkilökohtainen, joten puolisot voivat saada yhteensä {{ (2 * $ctrl.deductionMaxAmount) | currency : "" : 0 }} euron vähennyksen. Jos {{ $ctrl.deductionMaxAmount | currency : "" : 0 }} euron raja ei ylity, vähennys kannattaa hakea
    vain toiselle puolisolle. Silloin omavastuu vähennetään vain yhden kerran.</p>
  <h3 ng-if="$index == 2">Näitä töitä et voi vähentää verotuksessa</h3>
  <p ng-if="$index == 2">Kotitalousvähennyksen maksimimäärä on {{ $ctrl.deductionMaxAmount | currency : "" : 0 }} yhdessä puolison kanssa.</p>
  <b>Työnantaja {{ yearlyReport.employer.fullName }}</b>
  <table class="table table-sm">
    <thead>
      <tr>
        <th>Työntekijä</th>
        <th>Työ: maksupäivä ja kuvaus</th>
        <th class="right" colspan="2">Luvut 14B-lomakkeessa</th>
        <th class="right">KT-vähennys</th>
      </tr>
    </thead>
    <tbody ng-repeat="employerReport in yearlyReport.employerReports">
      <tr ng-if-start="employerReport.isHouseholdDeductionWork">
        <td rowspan="4">
          {{ employerReport.worker.displayName }}<br /> {{ employerReport.worker.identity.socialSecurityNumberValid }}<br />
        </td>
        <td rowspan="4">
          {{ $ctrl.formatDateRange(employerReport.firstDeductiblePaymentDate, employerReport.lastDeductiblePaymentDate) }} {{ employerReport.deductionWorkDescription }}
          <div class="form-group form-group-display">
            <label class="col-sm-10 control-label">Kotitaloustyö</label>
            <div class="col-sm-2">
              <input ng-checked="employerReport.hasHouseholdWork" class="check-box" disabled="disabled" type="checkbox">
            </div>
          </div>
          <div class="form-group form-group-display">
            <label class="col-sm-10 control-label">Hoiva- ja hoitotyö</label>
            <div class="col-sm-2">
              <input ng-checked="employerReport.hasCareAndNurtureWork" class="check-box" disabled="disabled" type="checkbox">
            </div>
          </div>
          <div class="form-group form-group-display">
            <label class="col-sm-10 control-label">Asunnon kunnossapito- tai perusparannustyö</label>
            <div class="col-sm-2">
              <input ng-checked="employerReport.hasConstructionWork" class="check-box" disabled="disabled" type="checkbox">
            </div>
          </div>
        </td>
        <td>Palkka</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.totalTaxableDeductible) }}</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.totalTaxableDeduction) }}</td>
      </tr>

      <tr>
        <td>Sivukulut (TyEL+Sava+TVR)</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.totalMandatorySideCosts) }}</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.totalMandatorySideCosts) }}</td>
      </tr>
      <tr>
        <td>Vakuutus</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.deductionInsuranceEtc) }}</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.deductionInsuranceEtc) }}</td>
      </tr>
      <tr ng-if-end class="total">
        <td>Yhteensä</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.deduction14BFormTotal) }}</td>
        <td class="right">{{ $ctrl.employerDeductionsTotalAmount(employerReport) }}</td>
      </tr>
      <tr ng-if="!employerReport.isHouseholdDeductionWork">
        <td>
          {{ employerReport.worker.displayName }}<br /> {{ employerReport.worker.identity.socialSecurityNumberValid }}<br />
        </td>
        <td>
          {{ $ctrl.formatDateRange(employerReport.firstPaymentDate, employerReport.lastPaymentDate) }} Ei töitä merkittynä kotitalousvähennykseen.
        </td>
        <td>Palkka</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.totalTaxableDeductible) }}</td>
        <td class="right">-</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="2">&nbsp;</td>
      </tr>
      <tr class="total">
        <th colspan="2">Yhteensä</th>
        <th colspan="2" class="right">{{ $ctrl.yearlyForm14BTotalAmount(yearlyReport) }}</th>
        <th class="right">{{ $ctrl.yearlyDeductionsTotalAmount(yearlyReport) }}</th>
      </tr>
      <tr>
        <td>Omavastuu</td>
        <td>Max. {{ $ctrl.deductionMaxAmount | currency : "" : 0 }} euroa / henkilö (pariskunta {{ (2 * $ctrl.deductionMaxAmount) | currency : "" : 0 }})</td>
        <td colspan="3" class="right">-100,00</td>
      </tr>
      <tr class="total">
        <th colspan="2">Kotitalousvähennys yhteensä</th>
        <th colspan="3" class="right">{{ $ctrl.yearlyDeductionTotal(yearlyReport) }}</th>
      </tr>
    </tfoot>
  </table>
  <p ng-repeat-end="">&nbsp;</p>

  <p>
    Verottaja käsittelee kaikki lomakkeet 14B yhdellä kertaa veroilmoitusten kanssa kesäkuussa, joten nämä tiedot
    <strong>eivät näy vielä esitäytetyssä veroilmoituksessa</strong>. Käymme aktiivista keskustelua verottajan kanssa, jotta ensi vuodeksi saisimme tiedot jo tähän esitäytettyyn veroilmoitukseen. Jos tämä on sinusta tärkeä juttu, lähetä meille palautetta
    osoitteeseen aspa@palkkaus.fi. Viemme mielellämme tätä tietoa eteenpäin verottajalle.
  </p>
  <p>
    Tulet saamaan <strong>elo-syyskuussa Verottajalta korjatun verotuspäätöksen</strong>, jossa kotitalousvähennys on huomioitu kokonaisuudessaan. Jos vielä silloin huomaat joitain puutteita, voit tehdä muutoksen lokakuun aikana. Lopullisesti verotus
    vahvistetaan lokakuun viimeinen päivä.
  </p>
  <hr />
  <h2 id="info14B">Palkkaus.fi-palvelun ulkopuolella maksetut palkat</h2>
  <p>
    Jos olet teettänyt työtä, jonka palkan olet maksanut Palkkaus.fi-palvelun ulkopuolella, muistathan ilmoittaa siitä erikseen verottajalle.
  </p>
  <p>
    Kotitalousvähennyksen alaisen työn voi ilmoittaa kahdella tavalla:
  </p>
  <ol>
    <li>
      Tulosta lomake
      <a href="https://www.vero.fi/fi-FI/Syventavat_veroohjeet/Lomakkeet/Henkiloasiakkaiden_lomakkeet/14B_Kotitalousvahennys_tyontekijalle_mak(12921)" target="_blank">
        14B tästä linkistä
      </a> ja lähetä se verottajalle.
    </li>
    <li>Sähköisellä veroilmoituksella <a href="https://www.vero.fi/veroilmoitus" target="_blank">https://www.vero.fi/veroilmoitus</a></li>
  </ol>
  <hr />
  <h2 id="info14A">Yrityksen laskuttama työ kotitalousvähennykseen</h2>
  <p>
    Jos olet teettänyt yrityksellä työtä, joka kelpaa kotitalousvähennykseen, muistathan ilmoittaa myös sen verottajalle.
  </p>
  <p>
    Laskulla teetetyn työn voi ilmoittaa kahdella tavalla:
  </p>
  <ol>
    <li>
      Tulosta lomake
      <a href="http://www.vero.fi/fi-FI/Syventavat_veroohjeet/Lomakkeet/Henkiloasiakkaiden_lomakkeet/14A_Kotitalousvahennys_yritykselle_makse(12918)" target="_blank">
        14A tästä linkistä
      </a> ja lähetä se verottajalle.
    </li>
    <li>Sähköisellä veroilmoituksella <a href="https://www.vero.fi/veroilmoitus" target="_blank">https://www.vero.fi/veroilmoitus</a></li>
  </ol>
  <p>
    Olemme suunnitelleet tähän myös työkalua Palkkaus.fi-sivustolle. Työkalulla voisi kirjata laskut jo etukäteen ja tallentaa kuitit arkistoon. Palkkaus.fi ilmoittaisi tiedot verottajalle vuoden lopussa. Jos tämä on sinusta tärkeä juttu, lähetä meille palautetta
    osoitteeseen aspa@palkkaus.fi.
  </p>
  <hr />
  <h2 id="info-kuuluuko">Mistä tiedän kuuluuko työ kotitalousvähennykseen?</h2>
  <p>Perusidea on, että työn pitää olla jotain seuraavista:</p>
  <ul>
    <li>kotitaloustyö</li>
    <li>hoiva- tai hoitotyö</li>
    <li>asunnon kunnossapito- tai perusparannustyö</li>
  </ul>
  <p>
    Lisäksi työ pitää tehdä omassa käytössä olevassa asunnossa tai vapaa-ajan asunnnossa. (Erikoistapauksena myös joidenkin lähisukulaisten käytössä olevat asunnot)
  </p>
  <p>
    Jos olet epävarma, niin <a href="http://www.vero.fi/fi-FI/Henkiloasiakkaat/Kotitalousvahennys" target="_blank">tällä verottajan sivulla on kuvattu</a> tarkemmin kotitalousvähennystä. Huomaa alalaidan linkit eri työtyyppeihin.
    <a href="http://www.vero.fi/fi-FI/Henkiloasiakkaat/Kotitalousvahennys/Taulukko_kysytyimmista_kotitalousvahenny(9231)" target="_blank">Tällä toisella sivulla on pitkä lista</a> eri töistä.
  </p>

  <p>Jos et vieläkään ole varma, voit kysyä mielipidettä Suomen Palkanlaskenta Oy:n asiantuntijoilta (yhteystiedot sivun alalaidassa).</p>

  <p>Me autamme mielellämme!</p>
</div>`);

 $templateCache.put("salaxy-components/personal/HouseholdYearDetails.html",`<div class="salaxy-component salaxy-household-year-details">

  <div class="btn-toolbar float-end" role="toolbar" salaxy-if-role="pro">
    <salaxy-workflow-buttons api-ctrl="$ctrl" disabled="!$ctrl.current || $ctrl.isNew() || $ctrl.current.isReadOnly"></salaxy-workflow-buttons>
  </div>

  <div class="table-responsive">
    <p class="lead">
      Palvelu tekee puolestasi kotitalousvähennysilmoitukset maksetuista palkoista, kun laskelmalla on kotitalousvähennysmerkintä. Tarkista valinnat ja täydennä tarvittavat tiedot.
    </p>
    <div ng-if="$ctrl.current && $ctrl.isOpen">
      <p>
        Alla on listattu vuoden {{ $ctrl.current.year || "" }} aikana palvelun kautta maksamasi palkat.
      </p>
      <ol>
        <li>Tarkista palkat</li>
        <li>Lisää tai poista kotitalousvähennys</li>
        <li>Hyväksy tarkistamasi tiedot</li>
      </ol>
      <p>
        <big>Kotitalousvähennys:</big> laita rasti ruutuun niiden palkkalaskelmien kohdalle, joista haluat kotitalousvähennyksen.
      </p>
    </div>
    <div ng-if="$ctrl.current && !$ctrl.isOpen">
      <h3>Tiedot on jo lähetetty</h3>
      <p>
        Olet lähettänyt alla olevat tiedot {{$ctrl.current.userFeedbackTime | date : 'dd.MM.yyyy HH:mm'}}
      </p>
      <p>
        Jos haluat avata tarkistuksen, ole yhteydessä asiakaspalveluun.
      </p>
    </div>
    <hr />
  </div>
  <form name="theForm" ng-if="$ctrl.current">
    <div class="table-responsive" ng-controller="WorkerSummaryReportDisplayController as $displayCtrl">
      <table class="table">
        <thead>
          <tr>
            <th colspan="7">
              <h3>Työntekijöiden palkkalaskelmat</h3>
            </th>
          </tr>
          <tr>
            <th colspan="2">Työntekijä</th>
            <th class="right">Bruttopalkka</th>
            <th class="right">Työnantaja&shy;kulut</th>
            <th colspan="3">Kotitalousvähennys <br>(laita rasti ruutuun)</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat-start="workerSummary in $ctrl.yearlyCalculations.workers">
            <td style="font-size: 64px; line-height: 1">
              <salaxy-avatar avatar="workerSummary.worker.avatar"></salaxy-avatar>
            </td>
            <td>
              {{ workerSummary.worker.avatar.displayName }}<br />
              <a ng-href="mailto:{{ workerSummary.worker.paymentData.email }}"> {{ workerSummary.worker.paymentData.email }}</a><br /> {{ workerSummary.worker.paymentData.socialSecurityNumberValid }}<br />
            </td>
            <td class="right">
              {{ workerSummary.totalTaxable | number : 2 }}€
            </td>
            <td class="right">
              {{ workerSummary.mandatorySideCosts | number : 2 }}€
            </td>
            <td></td>
            <td></td>
            <td>
              Työntekijän raportit (esikatselu):
              <div>
                <a ng-click="$displayCtrl.display($ctrl.current.year + '-01-01', workerSummary.worker.paymentData.socialSecurityNumberValid , null)">Yhteenveto</a>
              </div>
            </td>
          </tr>
          <tr ng-repeat="calc in workerSummary.calculations">
            <td></td>
            <td class="valign-middle" ng-controller="CalcReportsDisplayController as $displayCtrl">
              <a ng-click="$displayCtrl.displayForId('salarySlip', calc.id)">Laskelma {{ calc.workflow.salaryDate | date : 'dd.MM.' }} &raquo;</a>
            </td>
            <td class="right valign-middle">
              {{ calc.result.totals.totalTaxable | number : 2 }}€
            </td>
            <td class="right valign-middle">
              {{ calc.result.employerCalc.mandatorySideCosts | number : 2 }}€
            </td>
            <td class="valign-middle" style="min-width: 40px;">
              <input type="checkbox" ng-disabled="!$ctrl.isOpen" ng-model="calc.usecase.data.isHouseholdDeductible" ng-change="$ctrl.calculationUpdated(calc)" />
            </td>
            <td class="right valign-middle tax-deduction-item" ng-class="{ 'text-disabled': !calc.usecase.data.isHouseholdDeductible }">
              {{ (calc.result.employerCalc.mandatorySideCosts + calc.result.totals.totalTaxable * $ctrl.getHouseholdDeduction(calc)) | number : 2 }}€
            </td>
            <td>
              <span ng-if="!calc.usecase.data.isHouseholdDeductible" class="text-danger">Ei kotitalousvähennystä</span>
              <div ng-if="calc.usecase.data.isHouseholdDeductible">
                <select class="form-select" ng-disabled="!$ctrl.isOpen" ng-model="calc.usecase.data.taxDeductionCategories" ng-change="$ctrl.calculationUpdated(calc)">
                  <option hidden value="">Valitse työn tyyppi...</option>
                  <option value="none">Ei valintaa</option>
                  <option value="householdwork">Kotitaloustyö</option>
                  <option value="carework">Hoiva- ja hoitotyö</option>
                  <option value="homeImprovement">Asunnon/loma-asunnon kunnossapito- tai korjaustyö</option>
                  <option value="oilHeatingReplacementWork">Öljylämmityksestä luopuminen</option>
                </select>
              </div>
              <div ng-if="calc.usecase.data.isHouseholdDeductible">
                <select class="form-select" ng-disabled="!$ctrl.isOpen" ng-model="calc.usecase.data.taxDeductionProperty" ng-change="$ctrl.calculationUpdated(calc)">
                  <option hidden value="">Valitse työn sijainti</option>
                  <option value="none">Ei valintaa</option>
                  <option value="ownProperty">Omassa käytössä oleva asunto tai vapaa-ajan asunto</option>
                  <option value="relativesProperty">Vanhempien, isovanhempien yms. käytössä oleva asunto tai vapaa-ajan asunto.</option>
                </select>
              </div>
            </td>
          </tr>
          <tr ng-repeat-end>
            <td colspan="7" style="border-top-color: rgb(145,210,20); line-height: 0; padding: 0;"></td>
          </tr>
          <tr>
            <th colspan="7">
              <h4>Tapaturmavakuutus kotitalousvähennykseen</h4>
            </th>
          </tr>
          <tr>
            <td></td>
            <td colspan="5">
              <div>
                Tapaturmavakuutus kelpaa kotitalousvähennykseen. Lisää maksamasi vakuutuksen summa tähän.
              </div>
            </td>
            <td>
              <salaxy-input-number name="insuranceAmount" disabled="!$ctrl.isOpen" label-type="plain" unit="euro" ng-model="$ctrl.current.insuranceAmount" />
            </td>
          </tr>
          <tr class="total">
            <th colspan="4">
              <h4>Kotitalousvähennys yhteensä</h4>
            </th>
            <th></th>
            <th class="right valign-middle">{{ $ctrl.getTaxDeductionTotal() + $ctrl.getTaxDeductionTotalExtended() + $ctrl.current.insuranceAmount  | number : 2 }}€</th>
            <th class="valign-middle">
              <small style="font-weight: normal">...josta vähennetään omavastuu.</small>
            </th>
          </tr>
        </tbody>
      </table>
      <p>
        Huomioi: kotitalousvähennyksesi ei näy kevään esitäytetyssä veroilmoituksessasi, koska verottaja käsittelee ilmoitukset niin hitaasti. Lopulliseen verotukseesi ne tulevat kuitenkin oikein.
      </p>
    </div>
    <div ng-show="$ctrl.canSplitWithSpouse()">
      <h3>Jaa kotitalousvähennys puolisosi kanssa</h3>
      <p>
        Kotitalousvähennystä voi saada {{ $ctrl.getGetSplittableMaxAmount() }}€ per henkilö ({{$ctrl.getHouseholdDeductionDeductible()}}€ omavastuun jälkeen).
      </p>
      <p>
        Jos sinulla on puoliso, niin lisää tähän hänen tietonsa. Näin voimme lähettää {{ $ctrl.getGetSplittableMaxAmount() + $ctrl.getHouseholdDeductionDeductible()}}€ ylittävän osan kotitalousvähennyksestä hänen veroilmoitukseensa.
      </p>
      <div class="form-group">
        <label for="spouseName" class="control-label">Puolison nimi:</label>
        <salaxy-input name="spouseName" disabled="!$ctrl.isOpen" placeholder="Koko nimi verottajalle" label-type="plain" ng-model="$ctrl.current.spouseName"></salaxy-input>
      </div>
      <div class="form-group">
        <label for="spousePersonalId" class="control-label">Puolison henkilötunnus:</label>
        <salaxy-input name="spousePersonalId" disabled="!$ctrl.isOpen" placeholder="ddmmyy-123X" label-type="plain" sxy-personal-id-fi ng-model="$ctrl.current.spousePersonalId"></salaxy-input>
      </div>
    </div>
    <div>
      <h3>Tietojen lähettäminen</h3>
      <p>Kun ole tarkistanut tiedot, valitse joku alla olevista vaihtoehdoista.</p>
      <table>
        <tr>
          <td>
            <label for="statusOk">
            <input id="statusOk" type="radio" ng-disabled="!$ctrl.isOpen" ng-model="$ctrl.current.status" value="ok">
            <span class="text-success">Kyllä, tiedot tarkistettu / korjattu</span>
            </label>
          </td>
          <td>
            <p>Palvelu lähettää kotitalousvähennysilmoituksen 14B-lomakkeen verottajalle</p>
          </td>
        </tr>
        <tr>
          <td>
            <label for="statusOkWithModifications">
            <input id="statusOkWithModifications" type="radio" ng-disabled="!$ctrl.isOpen" ng-model="$ctrl.current.status" value="okWithModifications">
            <span class="text-danger">Tiedoissa on puutteita / virheitä<span>
            </label>
          </td>
          <td>
            <p>Jos tiedoissa on puutteita, joita et voinut korjata tällä sivulla itse, listaa puutteet tähän. Palvelu on sinuun tarvittaessa yhteydessä.</p>
            <div ng-if="$ctrl.current.status == 'okWithModifications'">
              <textarea class="form-control" ng-disabled="!$ctrl.isOpen" ng-model="$ctrl.current.userFeedbackText" rows="2"></textarea>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <label for="statusWillHandleMyself">
            <input id="statusWillHandleMyself" type="radio" ng-disabled="!$ctrl.isOpen" ng-model="$ctrl.current.status" value="willHandleMyself">
            <span class="text-default">Teen kotitalous&shy;vähennysilmoituksen itse</span>
            </label>
          </td>
          <td>
            <p>
              Palvelu ei lähetä kotitalousvähennysilmoitusta (14B-lomake) verottajalle. Valitse tämä vaihtoehto, jos olet jo itse tehnyt kotitalousvähennysilmoitukset OmaVerossa tai et halua hakea kotitalousvähennystä.
            </p>
          </td>
        </tr>
      </table>
    </div>

    <div class="text-end">
      <button type="button" class="btn btn-default" ng-disabled="!$ctrl.current || !$ctrl.current.id" ng-click="$ctrl.export()">Lataa pdf(t)</button>
      <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.current || !theForm.$valid || $ctrl.current.isReadOnly || !$ctrl.isOpen" ng-click="$ctrl.save()">Tallenna</button>
    </div>
  </form>
</div>`);

 $templateCache.put("salaxy-components/personal/HouseholdYearList.html",`<div class="salaxy-component household-year-list">
  <salaxy-odata-table ng-ref="$odata" crud-controller="HouseholdYearCrudController as $crud">
  </salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/personal/WorkerReport.html",`<div class="salaxy-component salaxy-worker-report">
  <salaxy-spinner heading="SALAXY.UI_Terms.loading" ng-if="!$ctrl.currentReport"></salaxy-spinner>
  <div class="d-flex align-items-center mb-3 d-flex">
    <label class="text-nowrap" sxy-text="SALAXY.NG1.WorkerReportComponent.selectYearLabel"></label>
    <select class="form-select ms-2 w-auto" ng-options="option.name for option in $ctrl.yearOptions track by option.value" ng-model="$ctrl.selectedYear" name="years" id="years"></select>
  </div>
  <div>
    <h2 ng-if-start="$ctrl.currentReport.length <= 0" sxy-text="SALAXY.NG1.WorkerReportComponent.noPaidSalaries.title" params="{year: $ctrl.selectedYear.value}"></h2>
    <p sxy-text="SALAXY.NG1.WorkerReportComponent.noPaidSalaries.description" params="{year: $ctrl.selectedYear.value}"></p>
    <p ng-if-end sxy-text="SALAXY.NG1.WorkerReportComponent.contactCustomerService" params="{year: $ctrl.selectedYear.value}"></p>
    <p ng-if-start="$ctrl.currentReport.length > 0" class="" sxy-text="SALAXY.NG1.WorkerReportComponent.paidSalariesText" params="{year: $ctrl.selectedYear.value}"></p>
    <div ng-if-end class="table-responsive light-bg">
      <table class="table table-striped table-sm">
        <thead>
          <tr>
            <th colspan="2" sxy-text="SALAXY.NG1.WorkerReportComponent.table.employer"></th>
            <th class="right">
              <span sxy-text="SALAXY.NG1.WorkerReportComponent.table.grossSalary"></span><br /><span sxy-text="SALAXY.NG1.WorkerReportComponent.table.totalTaxable"></span>
            </th>
            <th class="right" sxy-text="SALAXY.NG1.WorkerReportComponent.table.compensation"></th>
            <th sxy-text="SALAXY.NG1.WorkerReportComponent.table.summary"></th>
            <th class="right" sxy-text="SALAXY.NG1.WorkerReportComponent.table.taxPercent"></th>
            <th class="right" sxy-text="SALAXY.NG1.WorkerReportComponent.table.householdDeduction"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat-start="report in $ctrl.currentReport" ng-controller="WorkerSummaryReportDisplayController as $displayCtrl">
            <td>
              <div style="font-size: 64px; line-height: 1" ng-init="avatar = $ctrl.avatarFrom(report.employer.avatar.url)">
                <i ng-if="!avatar.url" class="salaxy-avatar bi" ng-class="avatar.baseIcon" ng-style="{color: avatar.color}"><strong>{{ avatar.initials }}</strong></i>
                <i ng-if="avatar.url" class="salaxy-avatar bi"><img ng-src="{{ avatar.url }}"></img></i>
              </div>
            </td>
            <td>
              {{ report.employer.fullName}}<br />
              <a ng-href="mailto:{{ $ctrl.workerEmailFrom(report) }}">{{ $ctrl.employerEmailFrom(report) }}</a><br /> {{ report.employer.identity.socialSecurityNumberValid }}
            </td>
            <td class="right">
              {{ report.grossSalary | currency : "€" : 2}}<br /> {{ report.totalTaxable | currency : "€" : 2}}
            </td>
            <td class="right">
              {{ report.totalExpenses | currency : "€" : 2}}
            </td>
            <td>
              <a ng-click="$displayCtrl.display($ctrl.selectedYear.value, 'self', report.employer.id)"
                class="btn btn-primary btn-xs"
                sxy-text="SALAXY.NG1.WorkerReportComponent.table.yearlyReport" post="&nbsp;&raquo;"
                ></a>
            </td>
            <td colspan="2">
              <p class="small">
                <strong sxy-text="SALAXY.NG1.WorkerReportComponent.table.workerYearlySummaryTitle"></strong><br />
                <a ng-click="$displayCtrl.display($ctrl.selectedYear.value, 'self', report.employer.id)">
                  <span sxy-text="SALAXY.NG1.WorkerReportComponent.table.workerYearlySummaryLink"></span></a> <span
                  sxy-text="SALAXY.NG1.WorkerReportComponent.table.workerYearlySummaryText"></span>
              </p>
            </td>
          </tr>
          <tr ng-repeat-end="" ng-repeat="calculation in report.underlyingCalculations">
            <td></td>
            <td>
              <b ng-if="!$ctrl.isSelectedYearBeforeIncomesRegistry">
                {{ calculation.salaryDate | date : "dd.MM" }}
              </b>
              <b ng-if="$ctrl.isSelectedYearBeforeIncomesRegistry">
                {{ calculation.paidAt | date : "dd.MM" }}
              </b>
            </td>
            <td class="right">
              {{ calculation.totals.totalGrossSalary | currency : "€" : 2 }}<br /> {{ calculation.totals.totalTaxable | currency : "€" : 2 }}
            </td>
            <td class="right">
              {{ calculation.totals.totalExpenses | currency : "€" : 2 }}
            </td>
            <td ng-controller="CalcReportsDisplayController as $displayCtrl">
              <a ng-href="#/calc/details/{{ calculation.id }}" class="btn btn-secondary btn-xs"><span
                  sxy-text="SALAXY.NG1.WorkerReportComponent.table.calculationBtn"></span>&nbsp;&raquo;</a><br />
              <button ng-click="$displayCtrl.displayForId('salarySlip', calculation.id)" class="btn btn-primary btn-xs"><span
                  sxy-text="SALAXY.NG1.WorkerReportComponent.table.printBtn"></span>&nbsp;&raquo;</button><br />
            </td>
            <td class="right">
              {{ calculation.workerCalc.tax > 0 ? (calculation.workerCalc.tax | currency : "€" : 2) : "-" }}
            </td>
            <td class="right">
              {{ calculation.salary.isDeductible ? (calculation.employerCalc.householdDeduction | currency : "€" : 2) : "-" }}
            </td>
          </tr>
        </tbody>
      </table>
      <br />
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/records/Records.html",`<div class="salaxy-component salaxy-records">
  <table class="table">
    <thead>
      <tr>
        <th>{{"SALAXY.NG1.WorkerDetailsComponent.records.recordType" | sxyTranslate}}</th>
        <th>{{"SALAXY.NG1.WorkerDetailsComponent.records.title" | sxyTranslate}}</th>
        <th>{{"SALAXY.NG1.WorkerDetailsComponent.records.text" | sxyTranslate}}</th>
        <th>{{"SALAXY.NG1.WorkerDetailsComponent.records.startDate" | sxyTranslate}}</th>
        <th>{{"SALAXY.NG1.WorkerDetailsComponent.records.badge" | sxyTranslate}}</th> 
        <th class="text-end">
          <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.readOnly" ng-click="$ctrl.showEditRecord({attachments: []})" sxy-text="SALAXY.UI_Terms.add"></button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="item in $ctrl.records">
        <td>{{item.recordType}}</td>
        <td>{{item.title}}</td>
        <td>
          <span ng-if="!('markdown' | sxyIsInRole)">{{item.text}}</span>
          <p  ng-if="'markdown' | sxyIsInRole"  style="
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Number of lines you want to display */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word; /* For older browsers */
  overflow-wrap: break-word; ">
            <salaxy-input-markdown read-only="true" ng-model="item.text" name="{{ 'md-viewer' + $index }}" label-type="plain"></salaxy-input-markdown>
          </p>
          <div ng-repeat="attachment in item.attachments">
            <a target="_blank" ng-href="{{$ctrl.getAttachmentDownloadUrl(attachment)}}">
              <i class="bi {{ $ctrl.getAttachmentIcon(attachment) }} text-primary me-1"></i>{{attachment.fileName}}
            </a>
          </div>
        </td>
        <td>{{ item.startDate | date }}</td>
        <td>
          <div ng-repeat="wfEvent in $ctrl.getEvents(item)">
            <salaxy-workflow-badge ng-if="wfEvent.message" model="{ workflowData:  { events: [wfEvent]}}"  wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
          </div>
        </td>
        <td class="text-end" ng-if="!$ctrl.readOnly">
          <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.showEditRecord(item, $index)">
            <i class="bi bi-pencil-fill" title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}"></i>
          </button>
          <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.deleteRecord(item, $index)">
            <i class="bi bi-trash" title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}"></i>
          </button>
        </td>
        <td class="text-end" ng-if="$ctrl.readOnly">
          <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.showEditRecord(item, $index)">
            <i class="bi bi-info-circle" title="{{'SALAXY.UI_Terms.show' | sxyTranslate}}"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>`);

 $templateCache.put("salaxy-components/report/AccountingHolidayPayDebtReportQuery.html",`<div class="salaxy-component salaxy-accounting-report-query">
  <form name="queryForm" class="form-horizontal">
    <div ng-show="false" ng-init="$ctrl.queryForm = queryForm"></div>
    <fieldset>
      <div class="col col-md-6">
        <salaxy-datepicker-popup name="refDate" ng-model="$ctrl.refDate" label="Velan päivämäärä" require="true" ng-change="$ctrl.query()"></salaxy-datepicker-popup>
      </div>
    </fieldset>
  </form>
  <div class="col col-md-12 text-right">
    <button class="btn btn-primary" ng-disabled="!$ctrl.queryForm.$valid" ng-click="$ctrl.queryData($reportTools.targetId)" sxy-text="SALAXY.NG1.AccountingReportQueryComponent.queryRows"></button>
  </div>

  <salaxy-accounting-report-tools ng-ref="$reportTools" any-expanded="$reportRows.anyExpanded" on-expand-change="$reportRows.expand(close)" on-target-change="$ctrl.queryData(targetId)" reader="$ctrl.dataReader" view="$ctrl.view"></salaxy-accounting-report-tools>
  <salaxy-accounting-report-rows lang="$ctrl.lang" ng-ref="$reportRows" data="$ctrl.data" view="$ctrl.view"></salaxy-accounting-report-rows>
</div>`);

 $templateCache.put("salaxy-components/report/AccountingReportList.html",`<div class="salaxy-component salaxy-accounting-report-list">
  <salaxy-odata-table ng-if="$ctrl.mode != 'panel'" crud-controller="AccountingReportCrudController as $crud" template-url="salaxy-components/odata/lists/AccountingReports.html" options="{ $filter: $ctrl.getODataFilter(), $orderby: 'logicalDate desc' }">
  </salaxy-odata-table>
  <salaxy-odata-table ng-if="$ctrl.mode == 'panel'" crud-controller="AccountingReportCrudController as $crud" template-url="salaxy-components/odata/lists/AccountingReportsPanel.html" options="$ctrl.panelQueryOptions">
  </salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/report/AccountingReportQuery.html",`<div class="salaxy-component salaxy-accounting-report-query">
  <form name="queryForm" ng-if="!$ctrl.calcs" class="form-horizontal">
    <div ng-show="false" ng-init="$ctrl.queryForm = queryForm"></div>
    <fieldset>
      <div class="row">
        <div class="col col-6">
          <salaxy-input-enum name="queryType" label="SALAXY.NG1.AccountingReportQueryComponent.reportCalcsLabel" options="{periodQuery: ('SALAXY.NG1.AccountingReportQueryComponent.periodQueryEnum' | sxyTranslate), selectionQuery: ('SALAXY.NG1.AccountingReportQueryComponent.selectionQueryEnum' | sxyTranslate) }"
          ng-model="$ctrl.queryType" type="radio" required></salaxy-input-enum>
        </div>
        <div class="col col-6" ng-if="$ctrl.queryType == 'selectionQuery'">
          <p>
            <span class="label label-primary" ng-if="$ctrl.calculations.length"> <span sxy-text="SALAXY.UI_Terms.chosen" ps=":"></span>{{ $ctrl.calculations.length }}</span>
          </p>
          <div class="btn-toolbar" role="toolbar">
            <button class="btn btn-default" ng-click="$ctrl.addCalcs('paid')" sxy-text="SALAXY.NG1.AccountingReportQueryComponent.addPaidCalcs"></button>
            <button class="btn btn-default" ng-click="$ctrl.addCalcs('draft')" sxy-text="SALAXY.NG1.AccountingReportQueryComponent.addDraftCalcs"></button>
          </div>
        </div>
        <div class="col col-6" ng-if="$ctrl.queryType == 'periodQuery'">
          <salaxy-input-enum name="periodDateKind" label="SALAXY.NG1.AccountingReportQueryComponent.periodDateKindLabel" enum="PeriodDateKind"
          ng-model="$ctrl.periodDateKind" type="radio" required></salaxy-input-enum>
        </div>
      </div>
      <div class="row">
        <div class="col col-6" ng-if="$ctrl.queryType == 'periodQuery'">
          <salaxy-input-enum name="period" label="SALAXY.NG1.AccountingReportQueryComponent.period" options="{month: ('SALAXY.NG1.AccountingReportQueryComponent.monthEnum' | sxyTranslate), custom: ('SALAXY.NG1.AccountingReportQueryComponent.customEnum' | sxyTranslate) }"
          ng-model="$ctrl.periodType" type="radio" required></salaxy-input-enum>
        </div>
        <div class="col col-6" ng-if="$ctrl.queryType == 'periodQuery'">
          <salaxy-datepicker-popup name="refDateMonth" placeholder="SALAXY.NG1.AccountingReportQueryComponent.monthPlaceHolder" ng-if="$ctrl.periodType == 'month'" format="month" ng-model="$ctrl.refDate"
            label="SALAXY.NG1.AccountingReportQueryComponent.refDateMonthLabel" require="true"></salaxy-datepicker-popup>
          <salaxy-datepicker-popup name="refDateQuarter" placeholder="SALAXY.NG1.AccountingReportQueryComponent.monthPlaceHolder" ng-if="$ctrl.periodType == 'quarter'" format="month" ng-model="$ctrl.refDate"
            label="SALAXY.NG1.AccountingReportQueryComponent.refDateQuarterLabel" require="true"></salaxy-datepicker-popup>
          <salaxy-datepicker-popup name="refDateYear" placeholder="SALAXY.NG1.AccountingReportQueryComponent.yearPlaceholder" ng-if="$ctrl.periodType == 'year'" format="year" ng-model="$ctrl.refDate"
            label="SALAXY.NG1.AccountingReportQueryComponent.refDateYearLabel" require="true"></salaxy-datepicker-popup>
          <salaxy-datepicker-popup name="refDateCustom" ng-if="$ctrl.periodType == 'custom'" ng-model="$ctrl.refDate" label="SALAXY.NG1.AccountingReportQueryComponent.refDateCustomLabel" require="true"></salaxy-datepicker-popup>
          <salaxy-datepicker-popup name="endDateCustom" ng-if="$ctrl.periodType == 'custom'" ng-model="$ctrl.endDate" label="SALAXY.NG1.AccountingReportQueryComponent.endDateCustomLabel"></salaxy-datepicker-popup>
        </div>
      </div>
    </fieldset>
    <div ng-if="$ctrl.queryType == 'selectionQuery'" class="col col-md-12">
      <div ng-if="$ctrl.calculations.length" class="table-responsive salaxy-odata-table">
        <table class="table table-striped">
          <thead>
            <tr>
              <th colspan="2">
                <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
              </th>
              <th class="hidden-xxs">
                <span sxy-text="SALAXY.NG1.AccountingReportQueryComponent.status"></span><br />
                <span><span sxy-text="SALAXY.NG1.AccountingReportQueryComponent.date"></span></span>
              </th>
              <th class="right hidden-xxs">
                <span sxy-text="SALAXY.NG1.AccountingReportQueryComponent.salary"></span><br />
                <span><span sxy-text="SALAXY.NG1.AccountingReportQueryComponent.payment"></span></span>
              </th>
              <th class="hidden-xxs"></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="row in $ctrl.calculations">
              <td class="td-avatar visible-xxs middle">
                <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
              </td>
              <td class="td-name visible-xxs middle">
                <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.AccountingReportQueryComponent.notSelected"></span>
                <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
                <br /> {{ row.endAt | date }}
              </td>
              <td class="right visible-xxs bottom">
                <div>
                  {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
                </div>
              </td>
              <td class="td-avatar hidden-xxs middle">
                <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
              </td>
              <td class="td-name hidden-xxs middle">
                <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.AccountingReportQueryComponent.notSelected"></span>
                <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
              </td>
              <td class="hidden-xxs middle">
                {{ row.status ? ("SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate) : "#ERR" }}<br /> {{ row.endAt | date }}
              </td>
              <td class="right hidden-xxs middle">
                {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
              </td>
              <td class="right middle">
                <button class="btn btn-sm  btn-danger" type="button" ng-click="$ctrl.removeCalc(row)">
                      {{ 'SALAXY.UI_Terms.unselect' | sxyTranslate }}
                    </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
  <div ng-if="!$ctrl.calcs" class="col col-md-12 text-end">
    <button class="btn btn-primary" ng-disabled="!$ctrl.queryForm.$valid" ng-click="$ctrl.queryData($reportTools.targetId)" sxy-text="SALAXY.NG1.AccountingReportQueryComponent.queryRows"></button>
  </div>

  <salaxy-accounting-report-tools ng-ref="$reportTools" any-expanded="$reportRows.anyExpanded" on-expand-change="$reportRows.expand(close)" on-target-change="$ctrl.queryData(targetId)" reader="$ctrl.dataReader" view="$ctrl.view"></salaxy-accounting-report-tools>
  <salaxy-accounting-report-rows lang="$ctrl.lang" ng-ref="$reportRows" data="$ctrl.data" view="$ctrl.view"></salaxy-accounting-report-rows>
</div>`);

 $templateCache.put("salaxy-components/report/AccountingReportRows.html",`<div class="salaxy-component salaxy-accounting-report-rows">
  <table ng-if="$ctrl.view != 'full'" class="table table-sm">
    <thead style="display: table-header-group;">
      <tr>
        <th class="col-md-3" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.accountNumber"></th>
        <th class="col-md-6" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.accountName"></th>
        <th class="col-md-3 right" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.saldo"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat-start="ledgerAccount in ($ctrl.data || {}).ledgerAccounts">
        <td>{{ledgerAccount.accountNumber }}</td>
        <td>{{ledgerAccount.accountName}}</td>
        <td class="right"><a ng-click="ledgerAccount.rowToggle = !ledgerAccount.rowToggle">{{ledgerAccount.saldo | currency}}</a></td>
      </tr>
      <tr ng-if="ledgerAccount.rowToggle" ng-repeat-end>
        <td colspan="3">
          <table class="table table-sm">
            <thead>
              <tr class="toggled-rows">
                <th class="col-md-3" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.calculation"></th>
                <th class="col-md-6" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.description"></th>
                <th class="col-md-1 right" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.vatPercent"></th>
                <th class="col-md-2 right" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.sum"></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="entry in ledgerAccount.entries" class="toggled-rows">
                <td>
                  <a ng-if="entry.dimension.calculationId" ng-href="#/calc/details/{{entry.dimension.calculationId}}">{{entry.dimension.calculationTitle}}</a>
                  <a ng-if="!entry.dimension.calculationId && entry.dimension.employmentId" ng-href="#/employments/details/{{entry.dimension.employmentId}}">{{entry.dimension.workerName}}</a>
                </td>
                <td>{{entry.description}}
                  <div ng-if="entry.dimension.projectNumber">{{'SALAXY.NG1.AccountingReportRowsComponent.projectNumber' | sxyTranslate}}: {{entry.dimension.projectNumber}}</div>
                  <div ng-if="entry.dimension.costCenter">{{'SALAXY.NG1.AccountingReportRowsComponent.costCenter' | sxyTranslate}}: {{entry.dimension.costCenter}}</div>
                  <div ng-if="entry.dimension.dimensions" ng-repeat="(k,v) in entry.dimension.dimensions">
                    {{k}}: {{v}}
                  </div>
                </td>
                <td class="right"><span ng-if="entry.vatPercent >= 0">{{ entry.vatPercent | sxyCount : 'percent'}}</span></td>
                <td class="right">{{!entry.isDebit ? -1 * entry.amount : entry.amount | currency}}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
  <div ng-if="$ctrl.view == 'full'">
    <div ng-bind-html="$ctrl.html" class="report-binder table-responsive"></div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/report/AccountingReportTools.html",`<div class="salaxy-component salaxy-accounting-report-tools">
  <div class="btn-toolbar" role="toolbar" aria-label="Report options">
    <div class="btn-group btn-group-sm dropdown">
      <button id="reportOptionsTarget" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        {{'SALAXY.NG1.AccountingReportToolsComponent.target' | sxyTranslate}}: <img style="height: 15px;" ng-if="$ctrl.getTarget($ctrl.targetId).avatar.url" ng-src="{{$ctrl.getTarget($ctrl.targetId).avatar.url}}">&nbsp;{{$ctrl.getTarget($ctrl.targetId).avatar.displayName}}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="reportOptionsTarget">
        <li ng-repeat="target in $ctrl.targets" role="menuitem">
          <a href="" ng-click="$ctrl.changeTarget(target.id)" class="dropdown-item"><img style="height: 20px;" ng-if="$ctrl.getTarget(target.id).avatar.url" ng-src="{{$ctrl.getTarget(target.id).avatar.url}}">&nbsp;{{$ctrl.getTarget(target.id).avatar.displayName}}</a>
        </li>
        <li role="menuitem"><button class="btn btn-link dropdown-item" ng-click="$ctrl.navigate('/settings/accounting-target-settings')" sxy-text="SALAXY.NG1.AccountingReportToolsComponent.settingsAddMoreTargets" ps="..."></button></li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm dropdown ms-1" ng-if="$ctrl.getTarget($ctrl.targetId).schemes.length">
      <button id="reportOptionsScheme" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        {{$ctrl.getScheme($ctrl.schemeId).label}}
      </button>
      <ul class="dropdown-menu"  role="menu" aria-labelledby="reportOptionsScheme">
        <li ng-repeat="scheme in $ctrl.getTarget($ctrl.targetId).schemes" role="menuitem">
          <a href="" ng-click="$ctrl.schemeId = scheme.id" class="dropdown-item">{{$ctrl.getScheme(scheme.id).label}}</a>
        </li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm dropdown ms-1">
      <button id="reportOptionsExportMethod" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        {{$ctrl.getExportMethod($ctrl.exportMethod).label}}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="reportOptionsExportMethod">
        <li role="menuitem" ng-repeat="exportMethod in $ctrl.exportMethods">
          <a href="" ng-click="$ctrl.exportMethod = exportMethod.id" class="dropdown-item">{{$ctrl.getExportMethod(exportMethod.id).label}}</a>
        </li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm dropdown ms-1">
      <button id="reportOptionsCulture" type="button" class="btn btn-default dropdown-toggle" ng-disabled="!$ctrl.getExportMethod($ctrl.exportMethod).hasLocales" data-bs-toggle="dropdown">
        {{$ctrl.getLocale($ctrl.localeId).label}}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="reportOptionsCulture">
        <li role="menuitem">
          <a href="" ng-click="$ctrl.localeId = 'fi'" class="dropdown-item">{{$ctrl.getLocale('fi').description}}</a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.localeId = 'en'" class="dropdown-item">{{$ctrl.getLocale('en').description}}</a>
        </li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm ms-1">
      <button ng-disabled="$ctrl.reader.disabled()" id="reportExport" type="button" class="btn btn-primary" ng-click="$ctrl.export()">
        {{ $ctrl.reader.exportLabel || ('SALAXY.NG1.AccountingReportToolsComponent.createExport' | sxyTranslate) }}  
      </button>
    </div>
    <div class="ms-auto" ng-if="$ctrl.reader.showExpand && $ctrl.view == 'partial'">
      <button ng-if="!$ctrl.anyExpanded" ng-disabled="$ctrl.reader.hasRows()" class="btn btn-block btn-transparent p-0" title="{{'SALAXY.NG1.AccountingReportToolsComponent.showRowsAndExports' | sxyTranslate}}" ng-click="$ctrl.expand()">
        <i class="bi bi-arrows-angle-expand"></i>
      </button>
      <button ng-if="$ctrl.anyExpanded" ng-disabled="$ctrl.reader.hasRows()" class="btn btn-block btn-transparent p-0" title="{{'SALAXY.NG1.AccountingReportToolsComponent.showOnlyRows' | sxyTranslate}}" ng-click="$ctrl.expand(true)">
        <i class="bi bi-arrows-angle-contract"></i>
      </button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/report/AccountingReportViewer.html",`<div class="btn-toolbar" role="toolbar" salaxy-if-role="test,pro">
  <salaxy-accounting-report-tools any-expanded="$reportRows.anyExpanded" on-expand-change="$reportRows.expand(close)" on-target-change="$ctrl.loadCurrentData(targetId)" reader="$ctrl.currentDataReader"></salaxy-accounting-report-tools>
  <salaxy-workflow-buttons class="ms-auto" disabled="!($ctrl.currentData && $ctrl.currentData.ledgerAccounts.length > 0)" api-ctrl="$ctrl"></salaxy-workflow-buttons>
</div>
<salaxy-accounting-report-rows ng-ref="$reportRows" data="$ctrl.currentData"></salaxy-accounting-report-rows>`);

 $templateCache.put("salaxy-components/report/AccountingRowReport.html",`<div class="salaxy-component salaxy-accounting-row-report" style="width:100%;height:100%;display:flex;flex-flow:column">
  <div class="btn-toolbar" role="toolbar">
    <div class="btn-group" role="group" aria-label="{{'SALAXY.NG1.CumulativeReportComponent.chooseData' | sxyTranslate}}">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.showPeriodSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectPeriod" ps="..."></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showCalcsSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectCalcs" ps="..."></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showPayrollSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectPayrolls" ps="..."></button>
    </div>
    <div class="btn-group ms-1" role="group" aria-label="{{'SALAXY.NG1.CumulativeReportComponent.reportTemplates' | sxyTranslate}}">
      <div class="btn-group btn-group dropdown">
        <button id="templateId" type="button" class="btn btn-default dropdown-toggle" ng-disabled="!$ctrl.data" data-bs-toggle="dropdown">
          <span ng-if="$ctrl.data">
            <salaxy-avatar style="font-size: 1.8em; margin: -2px 4px -2px -2px;" avatar="$ctrl.getTemplate($ctrl.templateId).avatar"></salaxy-avatar> {{$ctrl.getTemplate($ctrl.templateId).label}}
          </span>
          <span ng-if="!$ctrl.data" sxy-text="SALAXY.NG1.CumulativeReportComponent.reportTemplates"></span>
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="templateId">
          <li role="menuitem" ng-repeat="template in $ctrl.templates">
            <a href="" ng-click="$ctrl.selectTemplate(template.id)" class="dropdown-item">
               <salaxy-avatar style="font-size: 1.8em; margin: -2px 4px -2px -2px;" avatar="$ctrl.getTemplate(template.id).avatar"></salaxy-avatar> {{$ctrl.getTemplate(template.id).label}}
            </a>
          </li>
        </ul>
      </div>
      <button type="button" class="btn btn-default ms-1"  ng-disabled="!$ctrl.data" ng-click="$ctrl.showSaveTemplate()">{{'SALAXY.UI_Terms.edit' | sxyTranslate}}...</button>
    </div>
  </div>
  <div style="height:100%;flex-grow:1">
    <div id="dataGrid" class="ag-theme-balham" style="height:100%;overflow: hidden;"></div>
  </div>
</div>
`);

 $templateCache.put("salaxy-components/report/CalculationReport.html",`<div class="salaxy-component salaxy-calculation-report" style="width:100%;height:100%;display:flex;flex-flow:column">
  <div class="btn-toolbar" role="toolbar">
    <div class="btn-group" role="group" aria-label="{{'SALAXY.NG1.CumulativeReportComponent.chooseData' | sxyTranslate}}">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.showPeriodSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectPeriod" ps="..."></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showCalcsSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectCalcs" ps="..."></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showPayrollSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectPayrolls" ps="..."></button>
    </div>
    <div class="btn-group" role="group" aria-label="{{'SALAXY.NG1.CumulativeReportComponent.reportTemplates' | sxyTranslate}}">
      <div class="btn-group btn-group dropdown">
        <button id="templateId" type="button" class="btn btn-default dropdown-toggle" ng-disabled="!$ctrl.data" data-bs-toggle="dropdown">
          <span ng-if="$ctrl.data">
            <salaxy-avatar style="font-size: 1.8em; margin: -2px 4px -2px -2px;" avatar="$ctrl.getTemplate($ctrl.templateId).avatar"></salaxy-avatar> {{$ctrl.getTemplate($ctrl.templateId).label}}
          </span>
          <span ng-if="!$ctrl.data" sxy-text="SALAXY.NG1.CumulativeReportComponent.reportTemplates"></span>
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="templateId">
          <li role="menuitem" ng-repeat="template in $ctrl.templates">
            <a href="" ng-click="$ctrl.selectTemplate(template.id)" class="dropdown-item">
               <salaxy-avatar style="font-size: 1.8em; margin: -2px 4px -2px -2px;" avatar="$ctrl.getTemplate(template.id).avatar"></salaxy-avatar> {{$ctrl.getTemplate(template.id).label}}
            </a>
           </li>
        </ul>
      </div>
      <button type="button" class="btn btn-default ms-1"  ng-disabled="!$ctrl.data" ng-click="$ctrl.showSaveTemplate()">{{'SALAXY.UI_Terms.edit' | sxyTranslate}}...</button>
    </div>
  </div>
  <div style="height:100%;flex-grow:1">
    <div id="dataGrid" class="ag-theme-balham" style="height:100%;overflow: hidden;"></div>
  </div>
</div>
`);

 $templateCache.put("salaxy-components/report/HolidayPayReportQuery.html",`<div class="salaxy-component salaxy-holiday-pay-report-query">
  <div ng-if="$ctrl.data.holidayYear.employmentId" class="salaxy-calc-worker-info" ng-controller="EmploymentCrudController as $employmentCtrl" ng-init="$employmentCtrl.model=$ctrl.data.holidayYear.employmentId">
    <div class="row spacer-bottom" ng-if="$employmentCtrl.current">
      <div class="col-xs-3 col-sm-2 col-xxs-3">
        <salaxy-avatar avatar="$employmentCtrl.current.personalInfo.avatar"></salaxy-avatar>
      </div>
      <div class="col-xs-9 col-sm-10 col-xxs-9 worker-info-col">
        <h2>{{ $employmentCtrl.current.personalInfo.avatar.displayName || ("SALAXY.NG1.WorkerInfo.noSelection" | sxyTranslate) }}</h2>
        <div class="row" ng-if="$employmentCtrl.current">
          <div class="col-xs-12 col-sm-6 ">
            <div ng-class="$employmentCtrl.current.personalInfo.officialId ? '' : 'text-danger'">
              {{ $employmentCtrl.current.personalInfo.officialId || ( "SALAXY.NG1.PaymentDialogComponent.noSSNumber" | sxyTranslate ) }}
              &nbsp;
              <div class="btn-group" ng-if="$employmentCtrl.otherEmployments.length > 0">
                <button id="single-button" type="button" class="btn btn-default btn-xs dropdown-toggle" 
                  data-bs-toggle="dropdown" aria-expanded="false">
                  {{ $employmentCtrl.otherEmployments.length }} muuta työsuhdetta
                </button>
                <ul class="dropdown-menu" aria-labelledby="single-button">
                  <li ng-repeat="item in $employmentCtrl.otherEmployments">
                    <a class="dropdown-item" ng-href="{{$employmentCtrl.isModal ? '' : ('#/employments/details/' + item.id)}}">
                      {{ $employmentCtrl.getEmploymentDescription(item) }} 
                      ({{ $employmentCtrl.getActiveText(item) }})
                    </a>
                  </li>
                </ul>
              </div>
              <span ng-if="!$employmentCtrl.otherEmployments">Tarkistetaan muita työsuhteita...</span>
            </div>
            <div>{{ $employmentCtrl.getEmploymentDescription($employmentCtrl.current) }}</div>
            <div>{{ $employmentCtrl.getActiveText($employmentCtrl.current) }}</div>
            <div><small>{{ $employmentCtrl.current.id }}</small></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <form class="form-horizontal">
            <salaxy-input-enum  name="year"  ng-model="$ctrl.year"   label="SALAXY.NG1.HolidayReportComponent.holidayYear" options="$ctrl.years" ng-change="$ctrl.query()"></salaxy-input-enum>
            <salaxy-input-enum ng-if="$ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script'" name="holidayPayCalculation" ng-model="$ctrl.data.holidayYear.spec.holidayPayCalculation" disabled="true" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayCalculation.title" enum="HolidayPayCalculation"></salaxy-input-enum>
            <salaxy-input-enum name="holidayCode" ng-model="$ctrl.data.holidayYear.spec.code" disabled="true" label="SALAXY.MODEL.HolidaySpecificationForYear.code.title" enum="HolidayCode"></salaxy-input-enum>
            <salaxy-input-enum name="wageBasis" ng-model="$ctrl.data.holidayYear.spec.wageBasis" disabled="true" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.wageBasis" enum="WageBasis"></salaxy-input-enum>   
        </form>
      </div>
      <div class="col-sm-6">
        <form class="form-horizontal" ng-if="$ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script'">

            <salaxy-input-number ng-model="$ctrl.data.holidayYear.accrual.total" name="accrualTotal"   disabled="true" label="Lomavuoden kertymä" ></salaxy-input-number>

            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.otherPay" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'otherPay'" name="otherPay"   disabled="true"  label="SALAXY.MODEL.HolidayPay.otherPay.title" ></salaxy-input-number>

            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.scriptPay" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'scriptPay'" name="scriptPay"   disabled="true"  label="SALAXY.MODEL.HolidayPay.scriptPay.title" ></salaxy-input-number>

            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.normalMonthlyPayDailySalary" name="normalMonthlyPayDailySalary" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && $ctrl.data.holidayYear.spec.wageBasis =='monthly' && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'normalMonthlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.normalMonthlyPayDailySalary.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.normalMonthlyPayManual" name="normalMonthlyPayManual" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && $ctrl.data.holidayYear.spec.wageBasis =='monthly' && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'normalMonthlyPay'"  disabled="true" label="SALAXY.MODEL.HolidayPay.normalMonthlyPayManual.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.normalMonthlyPay" name="normalMonthlyPay" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && $ctrl.data.holidayYear.spec.wageBasis =='monthly' && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'normalMonthlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.normalMonthlyPay.title" ></salaxy-input-number>

            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageDailyPayDailySalary" name="averageDailyPayDailySalary" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayDailySalary.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageDailyPayManual" name="averageDailyPayManual" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'"  disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayManual.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageDailyPay" name="averageDailyPay" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPay.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageDailyPayBase" name="averageDailyPayBase" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true"  label="SALAXY.MODEL.HolidayPay.averageDailyPayBase.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageDailyPayDays" name="averageDailyPayDays" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayDays.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageDailyPayMultiplier" name="averageDailyPayMultiplier" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayMultiplier.title" ></salaxy-input-number>
  
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageHourlyPayDailySalary" name="averageHourlyPayDailySalary" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayDailySalary.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageHourlyPayManual" name="averageHourlyPayManual" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'"  disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayManual.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageHourlyPay" name="averageHourlyPay" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPay.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageHourlyPayBase" name="averageHourlyPayBase" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true"  label="SALAXY.MODEL.HolidayPay.averageHourlyPayBase.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageHourlyPayHours" name="averageHourlyPayHours" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayHours.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageHourlyPayMultiplier" name="averageHourlyPayMultiplier" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayMultiplier.title" ></salaxy-input-number>
      
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.percentageBasedPayDailySalary" name="percentageBasedPayDailySalary" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'percentageBasedPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPayDailySalary.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.percentageBasedPayManual" name="percentageBasedPayManual" ng-if="$($ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'percentageBasedPay'"  disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPayManual.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.percentageBasedPay" name="percentageBasedPay" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'percentageBasedPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPay.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.percentageBasedPayBase" name="percentageBasedPayBase" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'percentageBasedPay'"  disabled="true" disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPayBase.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.spec.holidayPayPercent" name="holidayPayPercent" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'percentageBasedPay'" required unit="percent"  disabled="true" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayPercent.title" ></salaxy-input-number>

            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.compensationPayDailySalary" name="compensationPayDailySalary" ng-if="($ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'holidayCompensation'"  disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPayDailySalary.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.compensationPayManual" name="compensationPayManual" ng-if="($ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'holidayCompensation'"  disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPayManual.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.compensationPay" name="compensationPay" ng-if="($ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'holidayCompensation'" disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPay.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.compensationPayBase" name="compensationPayBase" ng-if="($ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'holidayCompensation'" disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPayBase.title" ></salaxy-input-number>        
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.spec.compensation" name="compensation" ng-if="($ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other' || $ctrl.data.holidayYear.spec.code == 'script') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'holidayCompensation'" unit="percent" required  disabled="true" label="SALAXY.MODEL.HolidaySpecificationForYear.compensation.title" ></salaxy-input-number>
 
        </form>
      </div>
    </div>
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { 'value': 'calcs', 'text': 'SALAXY.NG1.HolidayPayReportQueryComponent.calculationsTab' },
        { 'value': 'parameters', 'text': 'SALAXY.NG1.HolidayPayReportQueryComponent.parametersTab' }
      ]"
      tabs-id="holidayPayReportQuery">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-holidayPayReportQuery" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'percentageBasedPay' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'holidayCompensation' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'normalMonthlyPay' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'scriptPay'">
      <div class="tab-pane" id="calcs-tab">
        <table ng-if="$ctrl.currentTab == 'calcs'" class="table table-striped">
          <thead>
            <tr>
              <th sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.calculation"></th>
              <th sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.description"></th>
              <th class="right" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.count"></th>
              <th class="right" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.price"></th>
              <th class="right" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.toHolidayPay"></th>
              <th class="right" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.toWorkingHours"></th>
              <th class="right" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.toOvertimeHours"></th>
              <th class="right" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.workingDays"></th>
              <th class="right" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.absenceDays"></th>
              <th sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.holidayPaySelection"></th>
              <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.workingHoursSelection"></th>
              <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.overtimeHoursSelection"></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat-start="calc in $ctrl.data.calculations">
              <td><a ng-href="#/calc/details/{{calc.calculationId}}">{{calc.calculationTitle}} {{calc.salaryDate | date}}</a></td>
              <td>{{calc.workStartDate | date }} - {{calc.workEndDate | date}}</td>
              <td class="right"></td>
              <td class="right"></td>
              <td class="right"></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" class="right"></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right"></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right">{{calc.workingDays}}</td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right">{{calc.absenceDays}}</td>
              <td></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'"></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'"></td>
            </tr>
            <tr ng-repeat-end ng-repeat="row in calc.rows">
              <td></td>
              <td>{{$ctrl.getLabel(row.irRow)}}</td>
              <td class="right">{{row.irRow.count}}</td>
              <td class="right">{{row.irRow.price | currency}}</td>
              <td class="right">{{row.total | currency}}</td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" class="right">{{row.hours}}</td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right">{{row.overtimeHours}}</td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right"></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right"></td>
              <td><salaxy-input-pay-stats-row-type name="salaryType" label-type="no-label" ng-model="row.salaryType" read-only="true"></salaxy-input-pay-stats-row-type></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'"><salaxy-input-pay-stats-row-type name="workingTimeType" label-type="no-label" ng-model="row.workingTimeType" read-only="true"></salaxy-input-pay-stats-row-type></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'"><salaxy-input-pay-stats-row-type name="overtimeType" label-type="no-label" ng-model="row.overtimeType" read-only="true"></salaxy-input-pay-stats-row-type></td>
            </tr>
          </tbody>
          <tfoot>
            <th sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.total"></th>
            <th></th>
            <th class="right"></th>
            <th class="right"></th>
            <th class="right">{{$ctrl.totals.total | currency}}</th>
            <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" class="right">{{$ctrl.totals.hours}}</th>
            <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right">{{$ctrl.totals.overtimeHours}}</th>
            <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right">{{$ctrl.totals.workingDays}}</th>
            <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right">{{$ctrl.totals.absenceDays}}</th>
            <th></th>
            <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'"></th>
            <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'"></th>
          </tfoot>
        </table>
      </div>
      <div class="tab-pane" id="parameters-tab">
        <div ng-if="$ctrl.currentTab == 'parameters'">
          <div class="row">
            <div class="col-sm-6">
              <form class="form-horizontal">
                <salaxy-form-group ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'percentageBasedPay' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'holidayCompensation' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'normalMonthlyPay'" name="salaryTypes" label="SALAXY.NG1.HolidayPayReportQueryComponent.holidayPayRowTypes">
                  <salaxy-input-pay-stats-row-type ng-repeat="rowType in $ctrl.data.holidayPaySettings.salaryTypes" name="salaryType" label-type="no-label" ng-model="rowType" read-only="true"></salaxy-input-pay-stats-row-type>
                </salaxy-form-group>
              </form>
            </div>
            <div class="col-sm-6">
              <form class="form-horizontal">
                <salaxy-form-group  ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" name="workingTimeTypes" label="SALAXY.NG1.HolidayPayReportQueryComponent.workingHoursRowTypes">
                  <salaxy-input-pay-stats-row-type ng-repeat="rowType in $ctrl.data.holidayPaySettings.workingTimeTypes" name="workingTimeType" label-type="no-label" ng-model="rowType" read-only="true"></salaxy-input-pay-stats-row-type>
                </salaxy-form-group>
                <salaxy-form-group  ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" name="overtimeTypes" label="SALAXY.NG1.HolidayPayReportQueryComponent.overtimeHoursRowTypes">
                  <salaxy-input-pay-stats-row-type ng-repeat="rowType in $ctrl.data.holidayPaySettings.overtimeTypes" name="overtimeType" label-type="no-label" ng-model="rowType" read-only="true"></salaxy-input-pay-stats-row-type>
                </salaxy-form-group>
                <salaxy-form-group  ng-if="$ctrl.data.holidayYear.spec.code == 'permanent35Hours'"  name="accrualWorkingTimeTypes" label="SALAXY.NG1.HolidayPayReportQueryComponent.accrualWorkingTimeRowTypes">
                  <salaxy-input-pay-stats-row-type ng-repeat="rowType in $ctrl.data.holidayAccrualSettings.workingTimeTypes" name="accrualWorkingTimeType" label-type="no-label" ng-model="rowType" read-only="true"></salaxy-input-pay-stats-row-type>
                </salaxy-form-group>
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <form class="form-horizontal">
                <salaxy-input-holiday-multipliers ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" name="multipliers" label="SALAXY.MODEL.HolidayPaySettings.multipliers.title" ng-model="$ctrl.data.holidayPaySettings.multipliers" read-only="true"></salaxy-input-holiday-multipliers>
              </form>
            <div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`);

 $templateCache.put("salaxy-components/report/HolidayReport.html",`<div class="salaxy-component salaxy-holiday-report">
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'years', text: 'SALAXY.NG1.HolidayReportComponent.holidayYears' },
      { value: 'debt', text: 'SALAXY.NG1.HolidayReportComponent.holidayPayDebt', hidden: ('hideHolidayDebt' | sxyIsInRole) }
    ]"
    tabs-id="holidayReport">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-holidayReport">
    <div class="tab-pane" id="years-tab">
      <div class="row">
        <div class="form-horizontal col-sm-3">
          <salaxy-input-enum  name="year"  ng-model="$ctrl.year"   label="SALAXY.NG1.HolidayReportComponent.holidayYear" options="$ctrl.years"></salaxy-input-enum>
        </div>
        <div class="col-sm-3">
          <button type="button" class="btn btn-secondary" ng-click="$ctrl.exportToExcel()">
            <span class="hidden-sm hidden-xs" sxy-text="SALAXY.NG1.HolidayReportComponent.exportToExcel"></span>
            <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th colspan="2"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.startDate"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.endDate"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.employment"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.table.salary"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.holidayCode"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.table.periodDefaultAccrual"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.holidayPayCalculation"></th>        
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.startSaldo"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.total"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.paid"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.available"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidaySalary"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayCompensation"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.paidBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.availableBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayPayDailySalary"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.resultRows | filter: { data : { holidayYear : { year: $ctrl.year } } } track by $index">
            <td class="align-middle td-avatar">
              <salaxy-avatar class="clickable" ng-click="$ctrl.showEditEmploymentDialog(row)" avatar="row.holidayYearReportRow.workerAvatar"></salaxy-avatar>
            </td>
            <td>{{row.holidayYearReportRow.workerAvatar.displayName}}</td>
            <td>{{row.holidayYearReportRow.startDate | sxyDate}}</td>
            <td>{{row.holidayYearReportRow.endDate | sxyDate}}</td>
            <td>{{row.holidayYearReportRow.employmentType}}</td>
            <td class="right">{{(row.holidayYearReportRow.grossSalary| currency) || "&nbsp;"}}</td>
            <td>{{row.holidayYearReportRow.holidayCode}}</td>
            <td class="right">{{(row.holidayYearReportRow.periodDefaultAccrual | sxyCount : 'day') || "&nbsp;"}}</td>
            <td>{{row.holidayYearReportRow.holidayPayCalculation}}</td>      
            <td class="right">{{(row.holidayYearReportRow.startSaldo | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.total| sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.paid | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.available | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.holidaySalary | currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.holidayCompensation| currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.paidBonus | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.availableBonus | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.holidayBonus| currency) || "&nbsp;"}}</td>
            <td class="right"><a ng-href="#/reports/holiday-pay-report-query/{{row.data.holidayYear.year}}/{{row.employment.id}}">{{(row.holidayYearReportRow.holidayPayDailySalary | currency) || "&nbsp;"}}</a></td>      
          </tr>
        </tbody>
      </table>
    </div>
    <div class="tab-pane" id="debt-tab">
      <div class="row">
        <div class="form-horizontal col-sm-3">
          <salaxy-input-enum  name="year"  ng-model="$ctrl.year"   label="SALAXY.NG1.HolidayReportComponent.holidayYear" options="$ctrl.years"></salaxy-input-enum>
        </div>
        <div class="col-sm-3">
          <button type="button" class="btn btn-secondary" ng-click="$ctrl.exportToExcel()">
            <span class="hidden-sm hidden-xs" sxy-text="SALAXY.NG1.HolidayReportComponent.exportToExcel"></span>
            <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
          </button>
        </div>
        <div class="form-horizontal  col-sm-3">
          <salaxy-datepicker-popup name="refDate" placeholder=""  ng-model="$ctrl.refDate"
          label="SALAXY.NG1.HolidayReportComponent.holidayPayDebtDate" require="true" ng-change="$ctrl.query(true)"></salaxy-datepicker-popup>
        </div>
        <div class="col-sm-3">
          <button type="button" class="btn btn-primary" ng-click="$ctrl.query(true)" sxy-text="SALAXY.NG1.HolidayReportComponent.calculateHolidayPayDebt"></button>
        </div>
      </div>
      <table class="table table-striped" ng-if="$ctrl.hasQueryedDebt">
        <thead>
          <tr>
            <th colspan="2"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.startDate"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.endDate"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.employment"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.table.salary"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.holidayCode"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.table.periodDefaultAccrual"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.holidayPayCalculation"></th>         
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.startSaldo"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.total"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.paid"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.available"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidaySalary"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayCompensation"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.paidBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.availableBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayPayDailySalary"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayPay"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidaySocialSecurity"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayPension"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayUnemployment"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayAccidentInsurance"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayGroupLifeInsurance"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayTotal"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.resultRows | filter: { data : { holidayYear : { year: $ctrl.year } } } track by $index">
            <td class="align-middle td-avatar">
              <salaxy-avatar class="clickable" ng-click="$ctrl.showEditEmploymentDialog(row)" avatar="row.holidayYearReportRow.workerAvatar"></salaxy-avatar>
            </td>
            <td>{{row.holidayYearReportRow.workerAvatar.displayName}}</td>
            <td>{{row.holidayYearReportRow.startDate | sxyDate}}</td>
            <td>{{row.holidayYearReportRow.endDate | sxyDate}}</td>
            <td>{{row.holidayYearReportRow.employmentType}}</td>
            <td class="right">{{(row.holidayYearReportRow.grossSalary| currency) || "&nbsp;"}}</td>
            <td>{{row.holidayYearReportRow.holidayCode}}</td>
            <td class="right">{{(row.holidayYearReportRow.periodDefaultAccrual | sxyCount : 'day') || "&nbsp;"}}</td>
            <td>{{row.holidayYearReportRow.holidayPayCalculation}}</td>       
            <td class="right">{{(row.holidayYearReportRow.startSaldo | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.total| sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.paid | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.available | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.holidaySalary | currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.holidayCompensation| currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.paidBonus | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.availableBonus | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.holidayBonus| currency) || "&nbsp;"}}</td>
            <td class="right"><a ng-href="#/reports/holiday-pay-report-query/{{row.data.holidayYear.year}}/{{row.employment.id}}">{{(row.holidayYearReportRow.holidayPayDailySalary | currency) || "&nbsp;"}}</a></td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayPay| currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayBonus| currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidaySocialSecurity | currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayPension | currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayUnemployment | currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayAccidentInsurance| currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayGroupLifeInsurance| currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayTotal| currency) || "&nbsp;"}}</td>       
          </tr>
        </tbody>
        <tfoot>
          <tr>&nbsp;</tr>
          <tr>
            <th colspan="19">{{ "SALAXY.NG1.HolidayReportComponent.yearAccruedDebt" | sxyTranslate }} {{$ctrl.year}} </th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidayPay| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidayBonus| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidaySocialSecurity | currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidayPension | currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidayUnemployment | currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidayAccidentInsurance| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidayGroupLifeInsurance| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalcTotal[$ctrl.year] | currency) || "&nbsp;"}}</td>       
          </tr>
          <tr>
            <th colspan="19">{{ "SALAXY.NG1.HolidayReportComponent.allAccruedDebt" | sxyTranslate }}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidayPay| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidayBonus| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidaySocialSecurity | currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidayPension | currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidayUnemployment | currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidayAccidentInsurance| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidayGroupLifeInsurance| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalcTotal['total'] | currency) || "&nbsp;"}}</td>       
          </tr>
        </tfoot>
      </table>
    </div>
  </div> 
</div>
`);

 $templateCache.put("salaxy-components/report/IrEarningsPayment.html",`<div class="salaxy-component salaxy salaxy-ir-earnings-payment">
  <salaxy-spinner ng-if="$ctrl.isLoading" full-screen="true" heading="SALAXY.UI_Terms.loading" text="SALAXY.UI_Terms.pleaseWait"></salaxy-spinner>
  <div ng-if="'test' | sxyIsInRole">
    <div ng-if="$ctrl.current.isReadOnly" class="alert alert-info" pre="VAIN TEST: " sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.readOnlyInfo"></div>
    <div class="btn-toolbar" role="toolbar" ng-if="$ctrl.current && $ctrl.isReadOnly && !$ctrl.current.isReadOnly">
      <div class="btn-group" role="group" aria-label="Muokkaa">
        <button ng-click="$ctrl.tempShowEditInNonAdminMode = true" type="button" role="group" class="btn btn-primary">VAIN TEST: Muokkaa</button>
      </div>
    </div>
  </div>
  <div class="btn-toolbar" role="toolbar" ng-if="!$ctrl.isReadOnly">
    <div class="btn-group" role="group" aria-label="Tallenna">
      <button ng-click="$ctrl.saveChanges()" type="button" role="group" class="btn btn-primary" ng-disabled="!($ctrl.hasChanges || ( $ctrl.calcController && $ctrl.calcController.hasChanges)) || $ctrl.isReadOnly" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
    <div class="btn-group" role="group" aria-label="Lähetä/mitätöi">
      <button ng-click="$ctrl.sendToIncomesRegister()" type="button" role="group" class="btn btn-default" ng-disabled="$ctrl.isReadOnly" sxy-text="SALAXY.UI_Terms.send"></button>
      <button ng-click="$ctrl.openSetScheduleDialog()" type="button" role="group" class="btn btn-default" ng-disabled="$ctrl.isReadOnly" sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.addScheduling"></button>
      <button ng-click="$ctrl.removeIrQueueItem()" type="button" role="group" class="btn btn-danger" ng-disabled="!$ctrl.current.scheduledFor || $ctrl.isReadOnly" sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.removeScheduling"></button>
      <button ng-click="$ctrl.cancelToIncomesRegister()" type="button" role="group" class="btn btn-danger" ng-disabled="!$ctrl.isCancellable || $ctrl.isReadOnly" sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.cancel"></button>
    </div>
  </div>
  <div ng-if="!$ctrl.isLoading && !$ctrl.current">
    <h3>Ei Palkkatietoilmoitusta</h3>
    <p>Palkkatietoilmoitus luodaan vasta, kun laskelma on merkitty maksetuksi.</p>
  </div>
  <div class="form-horizontal form-condensed" ng-if="$ctrl.current">
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'default', text: 'SALAXY.NG1.EarningsPaymentComponent.common.basicInfo' },
        { value: 'payer', text: 'SALAXY.MODEL.Payer.title' },
        { value: 'incomeearner', text: 'SALAXY.MODEL.IncomeEarner.title' },
        { value: 'insurances', text: 'SALAXY.NG1.EarningsPaymentComponent.common.insurances' },
        { value: 'absenses', text: 'SALAXY.NG1.EarningsPaymentComponent.common.absences' },
        { value: 'calcrows', text: 'SALAXY.NG1.EarningsPaymentComponent.common.rows' },
        { value: 'history', text: 'SALAXY.NG1.EarningsPaymentComponent.common.history' },
      ]"
      tabs-id="irEarningsPayment">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-irEarningsPayment"">
      <div class="tab-pane" id="default-tab">
        <div>
          <div class="label label-success float-end" style="font-size: 1.5em" ng-if="$ctrl.current.validation.isValid">{{'SALAXY.NG1.EarningsPaymentComponent.common.noErrors' | sxyTranslate}}</div>
          <!-- TODO: Check texts and add to language versioning. Consider could this be done with SXY-IPT infra. -->
          <h3 ng-switch="$ctrl.current.status">
            <span ng-switch-when="new">{{'SALAXY.NG1.EarningsPaymentComponent.statuses.new.text' | sxyTranslate}} <small sxy-text="SALAXY.NG1.EarningsPaymentComponent.statuses.new.smallText"></small></span>
            <span ng-switch-when="succeeded">{{'SALAXY.NG1.EarningsPaymentComponent.statuses.succeeded.text' | sxyTranslate}} <small>{{ $ctrl.current.lastDeliveredAt | sxyDate }} {{'SALAXY.NG1.EarningsPaymentComponent.common.time' | sxyTranslate}} {{ $ctrl.current.lastDeliveredAt | date : "hh:mm" }}</small></span>
            <span ng-switch-when="canceled">{{'SALAXY.NG1.EarningsPaymentComponent.statuses.canceled.text' | sxyTranslate}} <small sxy-text="SALAXY.NG1.EarningsPaymentComponent.statuses.canceled.smallText"></small> </span>
            <span ng-switch-when="error">{{'SALAXY.NG1.EarningsPaymentComponent.statuses.error.text' | sxyTranslate}} <small>{{'SALAXY.NG1.EarningsPaymentComponent.statuses.error.sending' | sxyTranslate}} {{ $ctrl.current.lastDeliveredAt | sxyDate }} {{'SALAXY.NG1.EarningsPaymentComponent.common.time' | sxyTranslate}} {{ $ctrl.current.lastDeliveredAt | date : "hh:mm" }} {{'SALAXY.NG1.EarningsPaymentComponent.statuses.error.gaveError' | sxyTranslate}}</small></span>
            <span ng-switch-when="invalid">{{'SALAXY.NG1.EarningsPaymentComponent.statuses.invalid.text' | sxyTranslate}} <small sxy-text="SALAXY.NG1.EarningsPaymentComponent.statuses.invalid.smallText"></small></span>
            <span ng-switch-when="scheduled">{{'SALAXY.NG1.EarningsPaymentComponent.statuses.scheduled.text' | sxyTranslate}} <small>{{ $ctrl.current.scheduledFor | sxyDate }} {{'SALAXY.NG1.EarningsPaymentComponent.common.time' | sxyTranslate}} {{ $ctrl.current.scheduledFor | date : "hh:mm" }}</small></span>
            <span ng-switch-default>{{'SALAXY.MODEL.EarningsPayment.status.title' | sxyTranslate}}: {{ "EarningsPaymentReportStatus." + $ctrl.current.status | sxyEnum }}</span>
          </h3>
          <salaxy-validation-summary api-validation="$ctrl.current.validation" ng-if="!$ctrl.current.validation.isValid">
          </salaxy-validation-summary>
          <salaxy-validation-summary api-validation="$ctrl.current.irErrors" ng-if="!$ctrl.current.irErrors.isValid">
          </salaxy-validation-summary>
        </div>
        <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current" type="EarningsPayment" debugger="false" auto-gen="false">
          <div>
            <div class="row">
              <div class="col-md-6">
                <fieldset>
                  <legend sxy-text="SALAXY.MODEL.PaymentPeriod.title"></legend>
                  <sxy-input model="form.deliveryData.paymentPeriod.startDate" format="date"></sxy-input>
                  <sxy-input model="form.deliveryData.paymentPeriod.endDate" format="date"></sxy-input>
                  <sxy-input model="form.deliveryData.paymentPeriod.paymentDate" format="date"></sxy-input>
                </fieldset>
              </div>
              <div class="col-md-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.worker"></legend>
                  <salaxy-avatar class="float-start" style="margin-right: 20px;font-size: 102px;" avatar="$ctrl.current.info.worker"></salaxy-avatar>
                  <div>{{ $ctrl.current.info.worker.sortableName }}</div>
                  <div>{{ $ctrl.current.deliveryData.reports[0].incomeEarner.incomeEarnerIds[0].code || "Ei henkilötunnusta" }}</div>
                </fieldset>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.basicInfo"></legend>
                  <sxy-form open-api="salaxy-secure/schemas/irepr.json" model="$ctrl.current.deliveryData.reports[0].reportData" type="ReportData" debugger="false" auto-gen="false">
                    <div>
                      <sxy-input model="form.reportId" read-only="true"></sxy-input>
                      <!--sxy-input model="form.irReportId" read-only="true"></sxy-input-->
                    </div>
                  </sxy-form>
                  <sxy-input model="form.createdAt"></sxy-input>
                  <sxy-input model="form.updatedAt"></sxy-input>
                  <sxy-input model="form.irStatus" read-only="true"></sxy-input>
                  <sxy-input model="form.isModified" read-only="true"></sxy-input>
                  <sxy-input model="form.scheduledFor" read-only="true"></sxy-input>
                </fieldset>
              </div>
              <div class="col-md-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.deliveryData.title"></legend>
                  <sxy-input model="form.deliveryData.deliveryDataType" read-only="true"></sxy-input>
                  <sxy-input model="form.deliveryData.timestamp" read-only="true"></sxy-input>
                  <sxy-input model="form.deliveryData.deliveryDataCreator.code" label="SALAXY.NG1.EarningsPaymentComponent.deliveryData.deliveryDataCreator" read-only="true">
                  </sxy-input>
                  </sxy-input>
                  <sxy-input model="form.deliveryData.deliveryDataSender.code" label="SALAXY.NG1.EarningsPaymentComponent.deliveryData.deliveryDataSender" read-only="true">
                  </sxy-input>
                </fieldset>
              </div>
            </div>
            <sxy-input model="form.deliveryData.contactPersons" include="name,responsibilityCode"></sxy-input>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.deliveryData.deliveryDataOwner"></legend>
              <sxy-input model="form.deliveryData.deliveryDataOwner.code"></sxy-input>
              <sxy-input model="form.deliveryData.deliveryDataOwner.type"></sxy-input>
              <sxy-input model="form.deliveryData.deliveryDataOwner.countryCode"></sxy-input>
              <sxy-input model="form.deliveryData.deliveryDataOwner.countryName"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="payer-tab">
        <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current.deliveryData.payer" type="Payer" debugger="false" auto-gen="false">
          <div>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.payer.title"></legend>
              <sxy-input model="form.payerBasic.companyName"></sxy-input>
              <sxy-input model="form.payerBasic.missingId" format="checkbox"></sxy-input>
              <sxy-input model="form.payerIds"></sxy-input>
              <sxy-input model="form.payerOther.payerTypes"></sxy-input>
              <sxy-input model="form.subOrgs"></sxy-input>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.address.title"></legend>
              <sxy-input model="form.address.co"></sxy-input>
              <sxy-input model="form.address.street"></sxy-input>
              <sxy-input model="form.address.poBox"></sxy-input>
              <sxy-input model="form.address.postalCode"></sxy-input>
              <sxy-input model="form.address.postOffice"></sxy-input>
              <sxy-input model="form.address.countryCode"></sxy-input>
              <sxy-input model="form.address.countryName"></sxy-input>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.MODEL.SubstitutePayer.title"></legend>
              <sxy-input model="form.substitutePayer.acts"></sxy-input>
              <sxy-input model="form.substitutePayer.employerName"></sxy-input>
              <sxy-input model="form.substitutePayer.employerId.type" label="SALAXY.NG1.EarningsPaymentComponent.substitutePayer.employerIdType.title"></sxy-input>
              <sxy-input model="form.substitutePayer.employerId.code" label="SALAXY.NG1.EarningsPaymentComponent.substitutePayer.employerIdCode.title"></sxy-input>
              <sxy-input model="form.substitutePayer.employerId.countryCode" label="SALAXY.NG1.EarningsPaymentComponent.substitutePayer.employerIdCountryCode.title"></sxy-input>
              <sxy-input model="form.substitutePayer.employerId.countryName" label="SALAXY.NG1.EarningsPaymentComponent.substitutePayer.employerIdCountryName.title"></sxy-input>
              <sxy-input model="form.substitutePayer.wageSec"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="incomeearner-tab">
        <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current.deliveryData.reports[0].incomeEarner" type="IncomeEarner" debugger="false" auto-gen="false">
          <div>
            <fieldset>
              <sxy-input model="form.incomeEarnerIds" include="code,type,countryCode"></sxy-input>
              <sxy-input model="form.incomeEarnerBasic.missingId" format="checkbox"></sxy-input>
              <sxy-input model="form.incomeEarnerBasic.companyName"></sxy-input>
              <sxy-input model="form.incomeEarnerBasic.firstName"></sxy-input>
              <sxy-input model="form.incomeEarnerBasic.lastName"></sxy-input>
              <sxy-input model="form.incomeEarnerBasic.birthDate" format="date"></sxy-input>
              <sxy-input model="form.incomeEarnerBasic.gender"></sxy-input>
              <sxy-input model="form.addresses" include="street,postalCode,postOffice,countryCode"></sxy-input>
              <salaxy-custom-code>
                <sxy-input model="form.professions" template-url="epr-professions.html"></sxy-input>
              </salaxy-custom-code>
              <sxy-input model="form.employmentRegs"></sxy-input>
              <sxy-input ng-if="$ctrl.current.deliveryData.reports[0].incomeEarner.incomeEarnerOther != null && $ctrl.current.deliveryData.reports[0].incomeEarner.incomeEarnerOther.incomeEarnerTypes != null" model="form.incomeEarnerOther.incomeEarnerTypes"></sxy-input>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.MODEL.Employment.title"></legend>
              <sxy-input model="form.employment.employed"></sxy-input>
              <sxy-input model="form.employment.employmentCode"></sxy-input>
              <sxy-input model="form.employment.termCode"></sxy-input>
              <sxy-input model="form.employment.partTime"></sxy-input>
              <sxy-input model="form.employment.hoursPerWeek"></sxy-input>
              <sxy-input model="form.employment.paymentTypes"></sxy-input>
              <sxy-input model="form.employment.employmentPeriods" include="startDate,endDate">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL_IR.Period.title"></legend>
                    
                    <sxy-input model="form.startDate" format="date"></sxy-input>
                    <sxy-input model="form.endDate" format="date"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
              <sxy-input model="form.employment.employmentEndings"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="insurances-tab">
        <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current.deliveryData.reports[0].incomeEarner" type="IncomeEarner" debugger="false" auto-gen="false">
          <div>
            <fieldset>
              <legend sxy-text="SALAXY.MODEL.PensionInsurance.title"></legend>
              <sxy-input model="form.pensionInsurance.pensionActCode"></sxy-input>
              <sxy-input model="form.pensionInsurance.pensionProvIdCode"></sxy-input>
              <sxy-input model="form.pensionInsurance.pensionPolicyNo"></sxy-input>
              <sxy-input ng-if="$ctrl.current.deliveryData.reports[0].incomeEarner.incomeEarnerOther != null && $ctrl.current.deliveryData.reports[0].incomeEarner.incomeEarnerOther.payments != null" model="form.incomeEarnerOther.payments" include="paymentRef,paymentSpecifier"></sxy-input>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.MODEL.AccidentInsurance.title"></legend>
              <sxy-input model="form.accidentInsurance.accInsPolicyNo"></sxy-input>
              <sxy-input model="form.accidentInsurance.accInsProvId.type"></sxy-input>
              <sxy-input model="form.accidentInsurance.accInsProvId.code"></sxy-input>
              <sxy-input model="form.accidentInsurance.accInsProvId.countryCode"></sxy-input>
              <sxy-input model="form.accidentInsurance.accInsProvId.countryName"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="absenses-tab">
        <salaxy-custom-code>
          <div class="text-end">
            <button type="button" class="btn btn-xs btn-primary" ng-if="!$ctrl.isReadOnly" ng-click="$ctrl.importAbsences()" sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.selectAbsences"></button>
          </div>
        </salaxy-custom-code>
        <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current.deliveryData.reports[0].absence" type="Absence" debugger="false" auto-gen="false">
          <div>
            <sxy-input model="form.absenceRepStartDate" format="date"></sxy-input>
            <sxy-input model="form.absenceRepEndDate" format="date"></sxy-input>
            <sxy-input model="form.unpaidAbsence.unpaidAbsencePeriods" include="startDate,endDate,causeCode">
              <form>
                <fieldset>
                  <legend sxy-text="SALAXY.MODEL.UnpaidAbsencePeriod.title"></legend>
                  <sxy-input model="form.startDate" format="date"></sxy-input>
                  <sxy-input model="form.endDate" format="date"></sxy-input>
                  <sxy-input model="form.causeCode"></sxy-input>
                  <sxy-input model="form.absenceDays"></sxy-input>
                </fieldset>
              </form>
            </sxy-input>
            <sxy-input model="form.paidAbsence.paidAbsencePeriods" include="startDate,endDate,causeCode">
              <form>
                <fieldset>
                  <legend sxy-text="SALAXY.MODEL.PaidAbsencePeriod.title"></legend>
                  <sxy-input model="form.startDate" format="date"></sxy-input>
                  <sxy-input model="form.endDate" format="date"></sxy-input>
                  <sxy-input model="form.causeCode"></sxy-input>
                  <sxy-input model="form.absenceDays"></sxy-input>
                  <sxy-input model="form.absenceUntil" format="date"></sxy-input>
                  <sxy-input model="form.amount"></sxy-input>
                  <sxy-input model="form.paidAbsencePeriodInfo"></sxy-input>
                  <sxy-input model="form.reimbApp"></sxy-input>
                </fieldset>
              </form>
            </sxy-input>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="calcrows-tab">
        <div ng-if="$ctrl.current.deliveryData.reports.length == 1">

          <fieldset>
            <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.calcRows"></legend>
            <salaxy-calc-ir-rows model="$ctrl.calculation" is-read-only-forced="true" ng-ref="$ctrl.calcController"></salaxy-calc-ir-rows>
          </fieldset>
          <hr/>

          <fieldset>
            <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.allRows"></legend>
            <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current.deliveryData.reports[0]" type="Report" debugger="false" auto-gen="false">
              <div>
                <fieldset>
                  <sxy-input model="form.transactions" read-only="true" template-url="epr-transactions.html"></sxy-input>
                </fieldset>
              </div>
            </sxy-form>
          </fieldset>
        </div>
      </div>
      <div class="tab-pane" id="history-tab">
        <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current" type="EarningsPayment" debugger="false" auto-gen="false">
          <div>
            <fieldset>
              <sxy-input model="form.reportLog" read-only="true" include="irTimestamp,eventType,reportId,irReportId,irVersion">
              </sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
    </div>
  </div>
</div>
<script type="text/ng-template" id="epr-professions.html">
  <table class="table">
    <caption sxy-text="SALAXY.NG1.EarningsPaymentComponent.professions.caption"></caption>
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.EarningsPaymentComponent.professions.type"></th>
        <th sxy-text="SALAXY.NG1.EarningsPaymentComponent.professions.code"></th>
        <th sxy-text="SALAXY.NG1.EarningsPaymentComponent.professions.title"></th>
        <th class="text-end">
          <button type="button" class="btn btn-xs btn-primary" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.value.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </th>
      </tr>
    </thead>
    <tbody class="form-horizontal">
      <tr ng-repeat="item in $ctrl.value">
        <td>
          <salaxy-input-enum name="professionType" label-type="plain" type="select" read-only="$ctrl.getReadOnly()" enum="SALAXY.ENUM_IR.ProfessionType" require="true" ng-model="item.type"></salaxy-input-enum>
        </td>
        <td>
          <div ng-if="$ctrl.getReadOnly() && item.type == 'statisticsFinland'">
            <salaxy-input-occupation-type style="display: inline-block" require="true" name="statCode" ng-model="item.code" label-type="plain" read-only="$ctrl.getReadOnly()"></salaxy-input-occupation-type>
            <span style="display: inline-block" ng-if="$ctrl.getReadOnly()">{{item.code}}</span>
          </div>
          <salaxy-input-occupation-type ng-if="!$ctrl.getReadOnly() && item.type == 'statisticsFinland'" require="true" name="statCode" ng-model="item.code" label-type="plain" read-only="$ctrl.getReadOnly()"></salaxy-input-occupation-type>
          <salaxy-input ng-if="item.type != 'statisticsFinland'" require="true" name="code" ng-model="item.code" label-type="plain" read-only="$ctrl.getReadOnly()"></salaxy-input>
        </td>
        <td>
          <salaxy-input name="title" ng-model="item.title" label-type="plain" read-only="$ctrl.getReadOnly()"></salaxy-input>
        </td>
        <td class="text-end">
          <button type="button" class="btn btn-xs btn-danger" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.delete(item, $index)">
            <i class="bi bi-trash" title="Delete row"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</script>
<script type="text/ng-template" id="epr-transactions.html">
  <table class="table">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.EarningsPaymentComponent.transactions.code"></th>
        <th class="text-end" sxy-text="SALAXY.NG1.EarningsPaymentComponent.transactions.count"></th>
        <!--th class="text-end">Ansaintakauden<br> alku ja loppu</th -->
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="item in $ctrl.value">
        <td>
          <salaxy-input-income-type name="code" label-type="plain" ng-model="item.transactionBasic.transactionCode" read-only="true"></salaxy-input-income-type>
        </td>
        <td class="text-end">
          <salaxy-input-number name="amount" label-type="plain" ng-model="item.transactionBasic.amount" read-only="true">
        </td>
        <!--td class="text-end">
          <span ng-repeat="earningPeriod in item.earningPeriods">
            {{earningPeriod.startDate | sxyDate}} - {{earningPeriod.endDate | sxyDate}}
          </span>


        </td-->
      </tr>
    </tbody>
  </table>
</script>`);

 $templateCache.put("salaxy-components/report/IrEarningsPaymentList.html",`<div class="salaxy-component salaxy-ir-earnings-payment-list">
  <salaxy-odata-table crud-controller="IrEarningsPaymentCrudController as $crud" template-url="salaxy-components/odata/lists/IrEpr.html" options="$ctrl.queryOptions">
  </salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/report/IrPayerSummary.html",`<div class="salaxy-component salaxy salaxy-ir-payer-summary">
  <salaxy-spinner ng-if="$ctrl.isLoading" full-screen="true" heading="SALAXY.UI_Terms.loading" text="SALAXY.UI_Terms.pleaseWait"></salaxy-spinner>
  <div ng-if="'test' | sxyIsInRole">
    <div class="btn-toolbar" role="toolbar" ng-if="$ctrl.isReadOnly">
      <div class="btn-group" role="group" aria-label="Muokkaa">
        <button ng-click="$ctrl.tempShowEditInNonAdminMode = true" type="button" role="group" class="btn btn-primary">VAIN TEST: Muokkaa</button>
      </div>
    </div>
  </div>
  <div class="btn-toolbar" role="toolbar" ng-if="!$ctrl.isReadOnly">
    <div class="btn-group" role="group" aria-label="Tallenna">
      <button ng-click="$ctrl.save()" type="button" role="group" class="btn btn-primary" ng-disabled="!$ctrl.hasChanges" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
    <div class="btn-group" role="group" aria-label="Lähetä/mitätöi">
      <button ng-click="$ctrl.sendToIncomesRegister()" type="button" role="group" class="btn btn-default" sxy-text="SALAXY.UI_Terms.send"></button>
      <button ng-click="$ctrl.openSetScheduleDialog()" type="button" role="group" class="btn btn-default" sxy-text="SALAXY.NG1.PayerSummaryComponent.common.addScheduling"></button>
      <button ng-click="$ctrl.removeIrQueueItem()" type="button" role="group" class="btn btn-danger" ng-disabled="!$ctrl.current.scheduledFor" sxy-text="SALAXY.NG1.PayerSummaryComponent.common.removeScheduling"></button>
      <button ng-click="$ctrl.cancelToIncomesRegister()" type="button" role="group" class="btn btn-danger" ng-disabled="!$ctrl.isCancellable" sxy-text="SALAXY.NG1.PayerSummaryComponent.common.cancel"></button>
    </div>
  </div>
  <div class="form-horizontal">
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'default', text: 'SALAXY.NG1.PayerSummaryComponent.common.basicInfo' },
        { value: 'payer', text: 'SALAXY.NG1.PayerSummaryComponent.common.payer' },
        { value: 'paymentmonth', text: 'SALAXY.NG1.PayerSummaryComponent.common.payerInfo' },
        { value: 'history', text: 'SALAXY.NG1.PayerSummaryComponent.common.historyTitle' },
        { value: 'calculations', text: 'SALAXY.NG1.PayerSummaryComponent.common.calculationsTitle', hidden: !$ctrl.current.info.calculationIds.length }
      ]"
      tabs-id="irPayerSummary">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-irPayerSummary">
      <div class="tab-pane" id="default-tab">
        <div>
          <h3>
            {{'SALAXY.MODEL.PayerSummary.status.title' | sxyTranslate}}: {{ "SALAXY.ENUM_IR.PayerSummaryReportStatus." + $ctrl.current.status + ".label" | sxyTranslate }}
            <div class="label label-success float-end" ng-if="$ctrl.current.validation.isValid">{{SALAXY.NG1.PayerSummaryComponent.common.noErrors | sxyTranslate}}</div>
          </h3>
          <salaxy-validation-summary api-validation="$ctrl.current.validation" ng-if="!$ctrl.current.validation.isValid">
          </salaxy-validation-summary>
          <salaxy-validation-summary api-validation="$ctrl.current.irErrors" ng-if="!$ctrl.current.irErrors.isValid">
          </salaxy-validation-summary>
        </div>
        <sxy-form open-api="salaxy-secure/schemas/irpsr.json" model="$ctrl.current" type="PayerSummary" debugger="false" auto-gen="false" read-only="{{ $ctrl.isReadOnly }}">
          <div>
            <div class="row">
              <div class="col-md-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.PayerSummaryComponent.common.basicInfo"></legend>
                  <sxy-form open-api="salaxy-secure/schemas/irpsr.json" model="$ctrl.current.deliveryData.reports[0].reportData" type="ReportData" debugger="false" auto-gen="false" read-only="{{ $ctrl.isReadOnly }}">
                    <div>
                      <sxy-input model="form.reportId" read-only="true"></sxy-input>
                      <!--sxy-input model="form.irReportId" read-only="true"></sxy-input-->
                    </div>
                  </sxy-form>
                  <sxy-input model="form.createdAt"></sxy-input>
                  <sxy-input model="form.updatedAt"></sxy-input>
                  <sxy-input model="form.irStatus" read-only="true"></sxy-input>
                  <sxy-input model="form.isModified" read-only="true"></sxy-input>
                  <sxy-input model="form.scheduledFor" read-only="true"></sxy-input>
                </fieldset>
              </div>
              <div class="col-md-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.PayerSummaryComponent.common.deliveryDataTitle"></legend>
                  <sxy-input model="form.deliveryData.deliveryDataType" read-only="true"></sxy-input>
                  <sxy-input model="form.deliveryData.timestamp" read-only="true"></sxy-input>
                  <sxy-input model="form.deliveryData.reportDate" format="date" read-only="true"></sxy-input>
                  <sxy-input model="form.deliveryData.deliveryDataCreator.code" label="SALAXY.NG1.PayerSummaryComponent.common.deliveryDataCreator" read-only="true"></sxy-input>
                  <sxy-input model="form.deliveryData.deliveryDataSender.code" label="SALAXY.NG1.PayerSummaryComponent.common.deliveryDataSender" read-only="true"></sxy-input>
                </fieldset>
              </div>
            </div>
            <sxy-input model="form.deliveryData.contactPersons" include="name,responsibilityCode"></sxy-input>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.PayerSummaryComponent.common.deliveryDataOwner"></legend>
              <sxy-input model="form.deliveryData.deliveryDataOwner.code"></sxy-input>
              <sxy-input model="form.deliveryData.deliveryDataOwner.type"></sxy-input>
              <sxy-input model="form.deliveryData.deliveryDataOwner.countryCode"></sxy-input>
              <sxy-input model="form.deliveryData.deliveryDataOwner.countryName"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="payer-tab">
        <sxy-form open-api="salaxy-secure/schemas/irpsr.json" model="$ctrl.current.deliveryData.payer" type="Payer" debugger="false" auto-gen="false" read-only="{{ $ctrl.isReadOnly }}">
          <div>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.PayerSummaryComponent.common.payerTitle"></legend>
              <sxy-input model="form.payerBasic.companyName"></sxy-input>
              <sxy-input model="form.payerBasic.missingId"></sxy-input>
              <sxy-input model="form.payerIds"></sxy-input>
              <sxy-input model="form.payerOther.payerTypes"></sxy-input>
              <sxy-input model="form.subOrgs"></sxy-input>
              <sxy-input model="form.pensionInsurances"></sxy-input>
              <sxy-input model="form.accidentInsurances" include="accInsPolicyNo">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.AccidentInsurance.title"></legend>
                    <sxy-input model="form.accInsPolicyNo"></sxy-input>
                    <sxy-input model="form.accInsProvId.code"></sxy-input>
                    <sxy-input model="form.accInsProvId.type"></sxy-input>
                    <sxy-input model="form.accInsProvId.countryCode"></sxy-input>
                    <sxy-input model="form.accInsProvId.countryName"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.PayerSummaryComponent.common.payerAddressTitle"></legend>
              <sxy-input model="form.address.co"></sxy-input>
              <sxy-input model="form.address.street"></sxy-input>
              <sxy-input model="form.address.poBox"></sxy-input>
              <sxy-input model="form.address.postalCode"></sxy-input>
              <sxy-input model="form.address.postOffice"></sxy-input>
              <sxy-input model="form.address.countryCode"></sxy-input>
              <sxy-input model="form.address.countryName"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="paymentmonth-tab">
        <sxy-form open-api="salaxy-secure/schemas/irpsr.json" model="$ctrl.current.deliveryData.reports[0]" type="Report" debugger="false" auto-gen="false" read-only="{{ $ctrl.isReadOnly }}">
          <div>
            <fieldset>
              <sxy-input model="form.paymentMonth.year" read-only="true"></sxy-input>
              <sxy-input model="form.paymentMonth.month" read-only="true"></sxy-input>
            </fieldset>
            <fieldset>
              <salaxy-custom-code>
                <sxy-input model="form.transactions" template-url="psr-transactions.html"></sxy-input>
              </salaxy-custom-code>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="history-tab">
        <sxy-form open-api="salaxy-secure/schemas/irpsr.json" model="$ctrl.current" type="PayerSummary" debugger="false" auto-gen="false" read-only="{{ $ctrl.isReadOnly }}">
          <div>
            <fieldset>
              <sxy-input model="form.reportLog" read-only="true" include="irTimestamp,eventType,reportId,irReportId,irVersion"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="calculations-tab">
        <sxy-form ng-if="$ctrl.calculationsOpened || $ctrl.currentTab == 'calculations'" ng-init="$ctrl.calculationsOpened=true" open-api="salaxy-secure/schemas/irpsr.json" model="$ctrl.current" type="PayerSummary" debugger="false" auto-gen="false" read-only="{{ $ctrl.isReadOnly }}">
          <div>
            <fieldset>
              <salaxy-custom-code>
                <sxy-input model="form.info.calculationIds" template-url="psr-calculations.html"></sxy-input>
              </salaxy-custom-code>
            </fieldset>
          </div>
        </sxy-form>
      </div>
  </div>
</div>
<script type="text/ng-template" id="psr-transactions.html">
  <table class="table">
    <caption sxy-text="SALAXY.NG1.PayerSummaryComponent.transactions.incomeTypes"></caption>
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.PayerSummaryComponent.transactions.incomeType"></th>
        <th sxy-text="SALAXY.NG1.PayerSummaryComponent.transactions.count"></th>
        <th class="text-end">
          <button type="button" class="btn btn-xs btn-primary" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.value.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </th>
      </tr>
    </thead>
    <tbody class="form-horizontal">
      <tr ng-repeat="item in $ctrl.value">
        <td>
          <salaxy-input-enum name="transactionCode" label-type="plain" type="select" read-only="$ctrl.getReadOnly()" enum="SALAXY.ENUM_IR.SummaryTransactionCode" require="true" ng-model="item.transactionBasic.summaryTransactionCode"></salaxy-input-enum>
        </td>
        <td>
          <salaxy-input-number ng-if="item.transactionBasic.summaryTransactionCode != 'noWagesPayable'" require="true" name="transactionAmount" label-type="plain" read-only="$ctrl.getReadOnly()" ng-model="item.transactionBasic.amount"></salaxy-input-number>
          <div ng-if="item.transactionBasic.summaryTransactionCode == 'noWagesPayable'" class="form-control-plaintext" ng-init="item.transactionBasic.amount = null">-</div>
        </td>
        <td class="text-end">
          <button type="button" class="btn btn-xs btn-danger" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.delete(item, $index)">
            <i class="bi bi-trash" title="Delete row"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</script>
<script type="text/ng-template" id="psr-calculations.html">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th colspan="2">
              <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
            </th>
            <th>
              <span><span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span></span><br />
              <span><span sxy-text="SALAXY.NG1.CalcListComponent.payment"></span></span>
            </th>
            <th class="right">
              <span><span sxy-text="SALAXY.NG1.CalcListComponent.salary"></span></span><br />
              <span><span sxy-text="SALAXY.NG1.CalcListComponent.payment"></span></span>
            </th>
            <th class="right" colspan="2">
            </th>
          </tr>
        </thead>
        <tbody ng-controller="CalculationCrudController as $crud">
          <tr ng-repeat="id in $ctrl.value" ng-controller="ODataQueryController as $odata" ng-init="$odata.url='/v03/api/calculations/category/all?$filter=id eq \\'' + id + '\\'';$odata.reload()">
            <td ng-if="!$odata.items[0]" colspan="6"><span><i class="bi bi-arrow-repeat bi-spin"></i></span></td>
            <td ng-if="$odata.items[0]" class="td-avatar middle">
              <salaxy-avatar avatar="$odata.items[0].otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td ng-if="$odata.items[0]"class="td-name middle">
              <span ng-if="$odata.items[0].otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{$odata.items[0].otherPartyInfo.avatar.displayName}}</strong><br />
            </td>
            <td ng-if="$odata.items[0]" class="middle">
              {{ "SALAXY.ENUM.CalculationStatus." + $odata.items[0].status + ".label" | sxyTranslate }}<br /> {{ $odata.items[0].endAt | date }}
            </td>
            <td ng-if="$odata.items[0]" class="right middle">
              {{ $odata.items[0].grossSalary | currency }}<br /> {{ $odata.items[0].payment | currency }}
            </td>
            <td ng-if="$odata.items[0]" class="middle">
              <a href="" ng-click="$crud.showDetails($odata.items[0])" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block"><span sxy-text="SALAXY.UI_Terms.show"></span>
                </a>
            </td>    
            <td ng-if="$odata.items[0]" class="middle">
              <a ng-href="{{$crud.getPdfUrl($odata.items[0])}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default btn-block"><span sxy-text="SALAXY.UI_Terms.printable"></span></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</script>
`);

 $templateCache.put("salaxy-components/report/IrPayerSummaryList.html",`<div class="salaxy-component salaxy-ir-payer-summary-list">
  <salaxy-odata-table crud-controller="IrPayerSummaryCrudController as $crud" template-url="salaxy-components/odata/lists/IrPsr.html" options="$ctrl.queryOptions">
  </salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/report/modals/AccountNumbers.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AccountNumbersComponent.title"></h2>
  <button type="button" class="ms-auto btn-close" ng-click="$close(null)" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <div class="table-responsive" style="max-height: 40vh;">
    <table class="table table-sm">
      <thead>
        <tr>
          <th sxy-text="SALAXY.NG1.AccountNumbersComponent.accountNumber"></th>
          <th sxy-text="SALAXY.NG1.AccountNumbersComponent.description"></th>
          <th>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="account in $ctrl.data.accounts">
          <td>
            {{account.account}}
          </td>
          <td>
            {{account.text}}
          </td>
          <td class="right">
            <button ng-disabled="account.isSelected" title="Valitse" class="btn btn-success" type="button" ng-click="$close(account)" sxy-text="SALAXY.NG1.AccountNumbersComponent.choose"></button>
          </td>
        </tr>
      </tbody>
      <tfoot>
      </tfoot>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default float-end" ng-click="$close(null)" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`);

 $templateCache.put("salaxy-components/report/modals/CalculationReportPeriodSelection.html",`<form name="periodForm" class="form-horizontal">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.CumulativeReportPeriodSelection.title"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-input-enum name="period" label="SALAXY.NG1.CumulativeReportPeriodSelection.periodLabel" options="{year: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionYear' | sxyTranslate), month: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionMonth' | sxyTranslate), all: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionAll' | sxyTranslate), custom: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionCustom' | sxyTranslate)}"
      ng-model="$ctrl.current.periodType" type="radio" required>
    </salaxy-input-enum>
    <salaxy-input-enum name="periodDateKind" label="SALAXY.NG1.CumulativeReportPeriodSelection.periodDateKindLabel" enum="PeriodDateKind"
      ng-model="$ctrl.current.periodDateKind" type="radio" required>
    </salaxy-input-enum>
    <salaxy-datepicker-popup name="refDateMonth" placeholder="SALAXY.NG1.CumulativeReportPeriodSelection.month" ng-if="$ctrl.current.periodType == 'month'" format="month" ng-model="$ctrl.current.refDate"
      label="SALAXY.NG1.CumulativeReportPeriodSelection.chooseMonthLabel" require="true"></salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="refDateYear" placeholder="SALAXY.NG1.CumulativeReportPeriodSelection.year" ng-if="$ctrl.current.periodType == 'year'" format="year" ng-model="$ctrl.current.refDate"
      label="SALAXY.NG1.CumulativeReportPeriodSelection.chooseYearLabel" require="true"></salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="refDateCustom" ng-if="$ctrl.current.periodType == 'custom'" ng-model="$ctrl.current.refDate" label="SALAXY.NG1.CumulativeReportPeriodSelection.refDateCustomLabel" require="true">
    </salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="endDateCustom" ng-if="$ctrl.current.periodType == 'custom'" ng-model="$ctrl.current.endDate" label="SALAXY.NG1.CumulativeReportPeriodSelection.endDateCustomLabel">
    </salaxy-datepicker-popup>
    <salaxy-form-group name="Workers" label="SALAXY.NG1.CumulativeReportPeriodSelection.workersLabel">
      <span ng-if="$ctrl.current.selectedWorkers.length"> {{'SALAXY.NG1.CumulativeReportPeriodSelection.chosen' | sxyTranslate}}: {{ $ctrl.current.selectedWorkers.length }} </span>
      <span ng-if="!$ctrl.current.selectedWorkers.length"> {{'SALAXY.NG1.CumulativeReportPeriodSelection.all' | sxyTranslate}} </span>
      <button type="button" class="btn btn-xs btn-default" ng-click="$ctrl.logic.showWorkerSelection($ctrl.current)" sxy-text="SALAXY.NG1.CumulativeReportPeriodSelection.more" ps="..."></button>
    </salaxy-form-group>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="submit" class="btn btn-primary" ng-disabled="!periodForm.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
  </div>
</form>`);

 $templateCache.put("salaxy-components/report/modals/CalculationReportSaveTemplate.html",`<form name="templateForm" class="form-horizontal">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.CumulativeReportSaveTemplate.title"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-input-boolean disabled="!$ctrl.current.isEditable" name="isNew" label="SALAXY.NG1.CumulativeReportSaveTemplate.isNewLabel" ng-model="$ctrl.current.isNew" type="radio" label-true="SALAXY.NG1.CumulativeReportSaveTemplate.isNewLabelTrue" label-false="SALAXY.NG1.CumulativeReportSaveTemplate.isNewLabelFalse" required>
    </salaxy-input-boolean>
    <salaxy-input name="label" label="SALAXY.NG1.CumulativeReportSaveTemplate.currentLabel" ng-model="$ctrl.current.label" required></salaxy-input>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="button" ng-if="!$ctrl.current.isNew" class="btn btn-danger" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.delete"></button>
    <button type="submit" class="btn btn-primary" ng-disabled="!templateForm.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
  </div>
</form>`);

 $templateCache.put("salaxy-components/report/modals/FivaldiPreview.html",`<div class="table-responsive">
  <table class="table table-sm table-striped text-small">
    <tbody>
      <tr>
        <th>voucherTypeId</th>
        <td>{{item.preview.voucherTypeId}}</td>
        <td colspan="7"></td>
      </tr>
      <tr>
        <th>originalVoucherNumber</th>
        <td>{{item.preview.originalVoucherNumber}}</td>
        <td colspan="7"></td>
      </tr>
      <tr>
        <th>voucherDate</th>
        <td>{{item.preview.voucherDate}}</td>
        <td colspan="7"></td>
      </tr>
      <tr>
        <th>bookkeepingMonth</th>
        <td>{{item.preview.bookkeepingMonth}}</td>
        <td colspan="7"></td>
      </tr>
      <tr>
        <th>validateEntrySum</th>
        <td>{{item.preview.validateEntrySum}}</td>
        <td colspan="7"></td>
      </tr>
      <tr>
        <th>vatType</th>
        <td>{{item.preview.vatType}}</td>
        <td colspan="7"></td>
      </tr>
      <tr>
        <th>amount</th>
        <th>accountNumber</th>
        <th>balanceCode</th>
        <th>dimensionValue1</th>
        <th>description</th>
        <th>vat.vatCode</th>
        <th>vat.vatAmount</th>
        <th>vat.account</th>
        <th>vat.account2</th>
      </tr>
      <tr ng-repeat="entry in item.preview.voucherEntries">
        <td class="right">{{ entry.amount }}</td>
        <td class="right">{{ entry.accountNumber}}</td>
        <td class="right">{{ entry.balanceCode }}</td>
        <td>{{ entry.dimensionValue1 }}</td>
        <td>{{ entry.description }}</td>      
        <td>{{entry.vat.vatCode}}</td>
        <td class="right">{{entry.vat.vatAmount}}</td>
        <td>{{entry.vat.account}}</td>
        <td>{{entry.vat.account2}}</td>
      </tr>
    </tbody>
  </table>
</div>`);

 $templateCache.put("salaxy-components/report/modals/IncomeTypeCodeEditor.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.title"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <div class="row">
    <div class="col-6 form-horizontal">
      <salaxy-input-income-type name="Tulolaji"  ng-model="$ctrl.data.row.transactionBasic.transactionCode" ></salaxy-input-income-type>
      <salaxy-input-number name="Summa" ng-model="$ctrl.data.row.transactionBasic.amount"></salaxy-input-number>

      <salaxy-form-group name="carBenefit" label="SALAXY.NG1.IncomeTypeCodeEditorComponent.carBenefitTypeLabel" label-type="horizontal">
        <select class="form-select" ng-model="$ctrl.data.carBenefit" ng-model-options="{ getterSetter: true }">
          <option value="" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.noSelection"></option>
          <option value="limitedCarBenefit" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.carBenefitLimited"></option>
          <option value="fullCarBenefit" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.carBenefitFull"></option>
        </select>
      </salaxy-form-group>

      <salaxy-input-enum ng-if="$ctrl.data.row.carBenefit" label="SALAXY.NG1.IncomeTypeCodeEditorComponent.carBenefitAgeGroupCodeLabel" name="ageGroupCode" ng-model="$ctrl.data.row.carBenefit.ageGroupCode" options="{ '': ('SALAXY.NG1.IncomeTypeCodeEditorComponent.noSelection' | sxyTranslate), 'a': 'A', 'b': 'B', 'c': 'C', 'u': 'U' }" type="select"></salaxy-input-enum>

      <salaxy-input-number ng-if="$ctrl.data.row.carBenefit" label="SALAXY.NG1.IncomeTypeCodeEditorComponent.carBenefitEmissionsValueLabel" name="emissionsValue" ng-model="$ctrl.data.row.carBenefit.emissionsValue" minimum="0" maximum="100" ></salaxy-input-number>

      <salaxy-form-group name="kilometers" label="SALAXY.NG1.IncomeTypeCodeEditorComponent.carBenefitKilometersLabel" label-type="horizontal">
        <label>
          {{ $ctrl.data.row.carBenefit.kilometers == null ? "-" : $ctrl.data.row.carBenefit.kilometers }}
        </label>
      </salaxy-form-group>

      <salaxy-form-group name="mealBenefit" label="SALAXY.NG1.IncomeTypeCodeEditorComponent.mealBenefitLabel" label-type="horizontal">
        <select class="form-select" ng-model="$ctrl.data.mealBenefit" ng-model-options="{ getterSetter: true }">
          <option value="" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.noSelection">Ei valintaa</option>
          <option ng-value="true" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.mealBenefitTrue">Kyllä</option>
          <option ng-value="false" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.mealBenefitFalse">Ei</option>
        </select>
      </salaxy-form-group>

      <div class="form-group" ng-if="!$ctrl.data.row.dailyAllowance || $ctrl.data.row.dailyAllowance.length != 1">
        <label for="addDailyAllowance" class="col-sm-4 control-label">
              <span sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.dailyAllowanceTypeLabel"></span>
          </label>
        <div class="col-sm-8">
          <button type="button" class="btn btn-block btn-success" ng-click="$ctrl.data.row.dailyAllowance = ['fullDailyAllowance']"><i class="bi bi-plus-lg"></i> {{'SALAXY.NG1.IncomeTypeCodeEditorComponent.add' | sxyTranslate}}</button>
        </div>
      </div>

      <div ng-if="$ctrl.data.row.dailyAllowance && $ctrl.data.row.dailyAllowance.length == 1">
        <salaxy-input-enum label="SALAXY.NG1.IncomeTypeCodeEditorComponent.dailyAllowanceTypeLabel" name="dailyAllowance" ng-model="$ctrl.data.row.dailyAllowance[0]" options="{ '': ('SALAXY.NG1.IncomeTypeCodeEditorComponent.noSelection' | sxyTranslate), 'partialDailyAllowance': ('SALAXY.NG1.IncomeTypeCodeEditorComponent.partialDailyAllowanceEnum' | sxyTranslate), 'fullDailyAllowance': ('SALAXY.NG1.IncomeTypeCodeEditorComponent.fullDailyAllowanceEnum' | sxyTranslate), 'internationalDailyAllowance': ('SALAXY.NG1.IncomeTypeCodeEditorComponent.internationalDailyAllowanceEnum' | sxyTranslate) }"
          type="select"></salaxy-input-enum>
        <div class="row">
          <div class="col-sm-4"></div>
          <div class="col-sm-8">
            <button type="button" class="btn btn-block btn-danger" ng-click="$ctrl.data.row.dailyAllowance = null"><i class="bi bi-trash-fill"></i> {{'SALAXY.UI_Terms.delete' | sxyTranslate}}</button>
          </div>
        </div>
      </div>

    </div>
    <div class="col-6">
      <div style="width: 100%; overflow: auto">
        <pre>{{ $ctrl.data.row | json }}</pre>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`);

 $templateCache.put("salaxy-components/report/modals/IrImportAbsencesDialog.html",`<div class="card panel-primary">
  <div class="card-header ">
    <h2 sxy-text="SALAXY.NG1.IrImportAbsencesDialogComponent.heading"></h2>
    <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
  </div>
  <div class="card-body">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>{{ "SALAXY.NG1.IrImportAbsencesDialogComponent.absences" | sxyTranslate }}</th>
            <th class="right" sxy-text="SALAXY.NG1.IrImportAbsencesDialogComponent.wholeAbsence"></th>
            <th class="right" sxy-html="SALAXY.NG1.IrImportAbsencesDialogComponent.isHolidayAccrual.html"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.current.periods">
            <td>
              <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }">
              </salaxy-avatar>
              <strong>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</strong><br />
              <div class="float-start" style="padding: 0px;">
                {{ row.isPaid ? ('SALAXY.NG1.IrImportAbsencesDialogComponent.isPaid' | sxyTranslate) : ('SALAXY.NG1.IrImportAbsencesDialogComponent.notPaid' | sxyTranslate) }}
                <span ng-if="row.isPaid != row.isHolidayAccrual"> {{ row.isHolidayAccrual ? ('SALAXY.NG1.IrImportAbsencesDialogComponent.isAccrual' | sxyTranslate) :
                  ('SALAXY.NG1.IrImportAbsencesDialogComponent.notAccrual' | sxyTranslate) }}</span>
              </div>
              <div class="truncate" style="max-width: 250px; padding: 0px;">
                &nbsp;{{ row.notes }}
              </div>
            </td>
            <td class="right">
              <strong>{{ row.period.daysCount | sxyCount : "day" }}</strong><br /> {{ row.period.start | date : 'dd.MM.' }}-{{ row.period.end | date : 'dd.MM.' }}
            </td>
            <td class="right">
              <strong>{{ (row.isPaid ? 0 : row.period.daysCount) | sxyCount : "day" }}</strong><br />
              <strong>{{ (row.isHolidayAccrual ? 0 : row.period.daysCount) | sxyCount : "day" }}</strong><br />
            </td>
            <td class="middle right">
              <button class="btn btn-xs" type="button" ng-class="row.selected ? 'btn-danger' : 'btn-info'" ng-click="row.selected = !row.selected">
                {{ row.selected ? ("SALAXY.UI_Terms.unselect" | sxyTranslate) : ("SALAXY.UI_Terms.select" | sxyTranslate) }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <button type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
      <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/report/modals/IrRowsEditorDialog.html",`<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="card-body">
    <salaxy-calc-ir-rows model="$ctrl.current"></salaxy-calc-ir-rows>
    <div>
      <button type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
      <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/report/modals/IrScheduleSendDialog.html",`  <div class="modal-header ">
    <h2 sxy-text="SALAXY.NG1.IrScheduleSendDialogComponent.heading"></h2>
    <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <form class="form-horizontal" name="schedulingDialog">
      <div class="col-12">
        <div class="salaxy-component salaxy-datepicker">
          <salaxy-datepicker ng-model="$ctrl.current.startAt" label="SALAXY.NG1.IrScheduleSendDialogComponent.dateLabel" name="date" timepicker="true"></salaxy-datepicker>
        </div>
      </div>
      <div class="col-12">
        <salaxy-form-group label="SALAXY.NG1.IrScheduleSendDialogComponent.dateTimeLabel" name="dateTime">
          <pre class="alert alert-danger d-inline-block">{{$ctrl.current.startAt | sxyTime }}</pre>
        </salaxy-form-group>
      </div>
      <div>
        <button type="submit" class="btn btn-primary float-end" ng-disabled="schedulingDialog.$invalid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.send"></button>
        <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      </div>
    </form>
  </div>
  <div class="modal-footer"></div>`);

 $templateCache.put("salaxy-components/report/modals/PostAccountingData.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.UI_Terms.send"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body"  style="max-height: calc(100vh - 300px); overflow-y: auto;">
  <div class="table-responsive">
    <table class="table table-sm">
      <thead>
        <tr>
          <th><span sxy-text="SALAXY.NG1.AccountingReportToolsComponent.accountingData"></span></th>
          <th><span sxy-text="SALAXY.NG1.AccountingReportToolsComponent.status"></span></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat-start="item in $ctrl.current">
          <td><a ng-click="item.rowToggle = !item.rowToggle">{{item.accountingData.employer.displayName}}/{{item.accountingData.period.start}}</a></td>
          <td>
            <span ng-if="item.error" class="text-danger">{{item.error}}</span>
            <span ng-if="item.result" class="text-success">{{item.result}}</span>
          </td>
          <td class="right">
            <button  class="btn btn-default" ng-click="$ctrl.logic.postData(item)" ng-disabled="item.isPosting" type="button">
              <span ng-show="!item.isPosting"><i class="bi bi-upload"></i></span>
              <span ng-show="item.isPosting"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.send"></span>
            </button>
          </td>
        </tr>
        <tr ng-if="item.rowToggle" ng-repeat-end>
          <td colspan="3">
            <ng-include src="$ctrl.logic.previewTemplateUrl" ></ng-include>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`);

 $templateCache.put("salaxy-components/report/modals/SummaryReportPeriodSelection.html",`<form name="periodForm" class="form-horizontal">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.CumulativeReportPeriodSelection.title"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-input-enum name="period" label="SALAXY.NG1.CumulativeReportPeriodSelection.periodLabel" options="{year: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionYear' | sxyTranslate), month: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionMonth' | sxyTranslate), all: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionAll' | sxyTranslate), custom: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionCustom' | sxyTranslate)}"
      ng-model="$ctrl.current.periodType" type="radio" required>
    </salaxy-input-enum>
    <salaxy-input-enum name="periodDateKind" label="SALAXY.NG1.CumulativeReportPeriodSelection.periodDateKindLabel" enum="PeriodDateKind"
      ng-model="$ctrl.current.periodDateKind" type="radio" required>
    </salaxy-input-enum>
    <salaxy-datepicker-popup name="refDateMonth" placeholder="SALAXY.NG1.CumulativeReportPeriodSelection.month" ng-if="$ctrl.current.periodType == 'month'" format="month" ng-model="$ctrl.current.refDate"
      label="SALAXY.NG1.CumulativeReportPeriodSelection.chooseMonthLabel" require="true"></salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="refDateYear" placeholder="SALAXY.NG1.CumulativeReportPeriodSelection.year" ng-if="$ctrl.current.periodType == 'year'" format="year" ng-model="$ctrl.current.refDate"
      label="SALAXY.NG1.CumulativeReportPeriodSelection.chooseYearLabel" require="true"></salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="refDateCustom" ng-if="$ctrl.current.periodType == 'custom'" ng-model="$ctrl.current.refDate" label="SALAXY.NG1.CumulativeReportPeriodSelection.refDateCustomLabel" require="true">
    </salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="endDateCustom" ng-if="$ctrl.current.periodType == 'custom'" ng-model="$ctrl.current.endDate" label="SALAXY.NG1.CumulativeReportPeriodSelection.endDateCustomLabel">
    </salaxy-datepicker-popup>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="submit" class="btn btn-primary" ng-disabled="!periodForm.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.select"></button>
  </div>
</form>`);

 $templateCache.put("salaxy-components/report/PayCertificate.html",`<div class="salaxy-component salaxy-pay-certificate">
  <div class="d-block d-md-none">
    <h4><span sxy-text="SALAXY.NG1.PayCertificateComponent.step"></span> {{$ctrl.currentStep.number}}/{{$ctrl.steps.length}}</h4>
  </div>
  <div class="salaxy-wizard">
    <div class="wizard-steps">
      <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
        <span class="salaxy-avatar">
          <div class="wizard-icons-wrapper">
            <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
            <i class="bi bi-circle-fill"></i>
          </div>
          <strong class="number">{{ step.number }}</strong>
        </span>
        <span class="step-text">{{ step.title | sxyTranslate }}</span>
      </div>
    </div>
    <div class="wizard-strikethrough"></div>
  </div>
  <div class="wizard-content" style="height: 600px; overflow-y: auto;">
    <ng-include src="$ctrl.currentStep.view"></ng-include>
  </div>
  <div class="modal-footer">
    <button ng-if="$ctrl.step >= 2" ng-click="$ctrl.goPrevious()" ng-disabled="!$ctrl.canGoPrevious" class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
    <button ng-if="($ctrl.step < $ctrl.steps.length)" ng-click="$ctrl.goNext()" ng-disabled="!$ctrl.canGoNext" class="btn btn-primary ms-auto" sxy-text="SALAXY.UI_Terms.next"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/report/PayCertificateStep1.html",`<div>
  <salaxy-employment-list mode="select" selected-items="$ctrl.selectedWorkers" on-list-select="$ctrl.selectWorker(item, value)"></salaxy-employment-list>
</div>`);

 $templateCache.put("salaxy-components/report/PayCertificateStep2.html",`<div>
  <div class="btn-toolbar mb-2" role="toolbar">
    <div class="btn-group" role="group">
      <button type="button" class="btn btn-sm btn-primary" ng-click="$ctrl.selectCalculations($odata.items, 26)" sxy-text="SALAXY.NG1.PayCertificateComponent.choose26Weeks"></button>
      <button type="button" class="btn btn-sm btn-primary" ng-click="$ctrl.selectCalculations($odata.items, 34)" sxy-text="SALAXY.NG1.PayCertificateComponent.choose34Weeks"></button>
      <button type="button" class="btn btn-sm btn-default" ng-click="$ctrl.unselectCalculations()" sxy-text="SALAXY.NG1.PayCertificateComponent.clear"></button>
    </div>
  </div>
  <salaxy-odata-table ng-ref="$odata" selected-items="$ctrl.periodCalculations" url="/v03/api/calculations/category/readonly"
    template-url="salaxy-components/odata/lists/CalculationsWithSalaryDate-select.html" crud-controller="CalculationCrudController as $crud"
    options="{$orderby: 'salaryDate desc', $filter: 'otherId eq \\'' + $ctrl.worker.otherId + '\\' and ( status eq \\'paymentSucceeded\\' )' }">
  </salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/report/PayCertificateStep3.html",`
<salaxy-spinner ng-show="!$ctrl.validation" heading="SALAXY.NG1.PayCertificateComponent.creatingPayCertificate"></salaxy-spinner>
<salaxy-validation-summary api-validation="$ctrl.validation" template-url="pay-certificate-validation.html">
  <p class="text-center">
    <b sxy-text="SALAXY.NG1.PayCertificateComponent.payCertificateReadyForDownload"></b>
  </p>
</salaxy-validation-summary>

<p>&nbsp;</p>
<p class="text-center" ng-show="$ctrl.validation && $ctrl.worker && $ctrl.periodCalculations.length > 0">{{'SALAXY.NG1.PayCertificateComponent.open' | sxyTranslate}} <a ng-href="{{$ctrl.getDownloadPdfUrl(true)}}" target="_blank>">{{'SALAXY.NG1.PayCertificateComponent.payCertificate' | sxyTranslate}}</a>. </p>


<button class="btn btn-default float-end" ng-click="$ctrl.startNew()" sxy-text="SALAXY.NG1.PayCertificateComponent.createNewPayCertificate"></button>



<script type="text/ng-template" id="pay-certificate-validation.html">
<div ng-if="!$ctrl.hasValidation" ng-bind-html="$ctrl.loadingHtml"></div>
<div ng-if="$ctrl.hasValidation">
  <ng-transclude ng-if="$ctrl.isValid"></ng-transclude>
  <div ng-if="!$ctrl.isValid" class="alert alert-danger">
      <h4 sxy-text="SALAXY.NG1.PayCertificateComponent.alertHeading" ps=":"></h4>
      <p style="display: block; font-family: monospace; white-space: pre;" ng-repeat="error in $ctrl.getErrors()">{{ error.msg }}</p>
  </div>
</div>
</script>`);

 $templateCache.put("salaxy-components/report/PayStatsReportQuery.html",`<style>
  .tabulator-row {
    border-bottom: 1px solid #ddd;
  }
  .tabulator-row.nested-odd {
    background-color: #fff !important;
  }
  .tabulator-row.nested-even {
    background-color: #efefef !important;
  }
  .tabulator-row.tabulator-tree-level-1 {
    font-weight: bold;
  }
</style>
<div class="salaxy-component salaxy-pay-stats-report-query">
  <div class="row">
    <div class="col-sm-6">
      <div ng-if="$ctrl.employmentId" class="salaxy-calc-worker-info" ng-controller="EmploymentCrudController as $employmentCtrl"
        ng-init="$employmentCtrl.model=$ctrl.employmentId">
        <div class="row spacer-bottom" ng-if="$employmentCtrl.current">
          <div class="col-xs-3 col-sm-2 col-xxs-3">
            <salaxy-avatar avatar="$employmentCtrl.current.personalInfo.avatar"></salaxy-avatar>
          </div>
          <div class="col-xs-9 col-sm-10 col-xxs-9 worker-info-col">
            <h2>{{ $employmentCtrl.current.personalInfo.avatar.displayName || ("SALAXY.NG1.WorkerInfo.noSelection" | sxyTranslate) }}</h2>
            <div class="row" ng-if="$employmentCtrl.current">
              <div class="col-xs-12 col-sm-6 ">
                <div ng-class="$employmentCtrl.current.personalInfo.officialId ? '' : 'text-danger'">
                  {{ $employmentCtrl.current.personalInfo.officialId || ( "SALAXY.NG1.PaymentDialogComponent.noSSNumber" | sxyTranslate ) }}
                  &nbsp;
                  <div class="btn-group" ng-if="$employmentCtrl.otherEmployments.length > 0">
                    <button id="single-button" type="button" class="btn btn-default btn-xs dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      {{ $employmentCtrl.otherEmployments.length }} muuta työsuhdetta
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="single-button">
                      <li ng-repeat="item in $employmentCtrl.otherEmployments">
                        <a class="dropdown-item" ng-href="{{$employmentCtrl.isModal ? '' : ('#/employments/details/' + item.id)}}">
                          {{ $employmentCtrl.getEmploymentDescription(item) }}
                          ({{ $employmentCtrl.getActiveText(item) }})
                        </a>
                      </li>
                    </ul>
                  </div>
                  <span ng-if="!$employmentCtrl.otherEmployments">Tarkistetaan muita työsuhteita...</span>
                </div>
                <div>{{ $employmentCtrl.getEmploymentDescription($employmentCtrl.current) }}</div>
                <div>{{ $employmentCtrl.getActiveText($employmentCtrl.current) }}</div>
                <div><small>{{ $employmentCtrl.current.id }}</small></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.query()" ng-disabled="$ctrl.isQuerying">
      <span ng-if="$ctrl.isQuerying"><i class="bi bi-arrow-repeat bi-spin me-1"></i></span>
      <span sxy-text="Laske ansiot"></span>
    </button>
    </div>
  </div>
  <sxy-table class="report" ng-if="$ctrl.reportData" ng-ref="$ctrl.$sxyTable" options="$ctrl.reportOptions" include="$ctrl.reportInclude" data="$ctrl.reportData"></sxy-table>
</div>`);

 $templateCache.put("salaxy-components/report/ReportList.html",`<div class="salaxy-component salaxy-report-list">
  <div ng-hide="$ctrl.getReports($ctrl.reportType).length > 0">
    <p sxy-text="SALAXY.NG1.ReportListComponent.noReportsToShow" ps="."></p>
  </div>
  <div class="table-responsive" ng-show="$ctrl.getReports($ctrl.reportType).length > 0">
    <table class="table">
      <thead>
        <tr>
          <th style="width: 100px"></th>
          <th sxy-text="SALAXY.NG1.ReportListComponent.report"></th>
          <th sxy-text="SALAXY.NG1.ReportListComponent.links"></th>
          <th sxy-text="SALAXY.NG1.ReportListComponent.reportDate"></th>
          <th sxy-text="SALAXY.NG1.ReportListComponent.updated"></th>
          <th sxy-text="SALAXY.NG1.ReportListComponent.note" ps="."></th>
        </tr>
      </thead>
      <tbody ng-if="$ctrl.reportType !== 'monthlyDetails' && $ctrl.reportType !== 'yearlyDetails' && $ctrl.reportType !== 'monthlyLiikekirjuri'" ng-controller="WorkerSummaryReportDisplayController as $displayCtrl">
        <tr ng-repeat="report in $ctrl.getReports($ctrl.reportType)">
          <td>
            <a ng-if="!report.isPreview" href="{{ report.pdfUrl || report.htmlUrl || report.jsonUrl }}" target="_blank">
              <img ng-src="{{ report.thumbnail }}" class="img-responsive img-thumbnail" />
            </a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate, $displayCtrl.parseWorkerID(report.htmlUrl), null)">
              <img ng-src="{{ report.thumbnail }}" class="img-responsive img-thumbnail" />
            </a>
          </td>
          <td>
            <a ng-if="!report.isPreview" href="{{ report.pdfUrl || report.htmlUrl || report.jsonUrl }}" target="_blank">{{ report.title }}</a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate, $displayCtrl.parseWorkerID(report.htmlUrl), null)">{{ report.title }} </a>
          </td>
          <td>
            <a ng-if="!report.isPreview && report.pdfUrl" href="{{ report.pdfUrl }}" target="_blank">PDF</a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate, $displayCtrl.parseWorkerID(report.htmlUrl), null)">HTML</a>
            <a ng-if="!report.isPreview && report.jsonUrl" href="{{ report.jsonUrl }}" target="_blank">JSON</a>
          </td>
          <td>{{ report.reportDate | date }}</td>
          <td>{{ report.updatedAt | date }}</td>
          <td>
            <span class="label label-info" ng-if="report.isPreview" sxy-text="SALAXY.NG1.ReportListComponent.preview"></span>
            <span class="label label-danger" ng-if="report.isDemoData">DEMO: demodataa</span>
          </td>
        </tr>
      </tbody>
      <tbody ng-if="$ctrl.reportType === 'monthlyDetails' || $ctrl.reportType === 'yearlyDetails'" ng-controller="SummaryReportDisplayController as $displayCtrl">
        <tr ng-repeat="report in $ctrl.getReports($ctrl.reportType)">
          <td>
            <a ng-if="!report.isPreview" href="{{ report.pdfUrl || report.htmlUrl || report.jsonUrl }}" target="_blank">
              <img ng-src="{{ report.thumbnail }}" class="img-responsive img-thumbnail" />
            </a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate,report.type)">
              <img ng-src="{{ report.thumbnail }}" class="img-responsive img-thumbnail" />
            </a>
          </td>
          <td>
            <a ng-if="!report.isPreview" href="{{ report.pdfUrl || report.htmlUrl || report.jsonUrl }}" target="_blank">{{ report.title }}</a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate,report.type)">{{ report.title }} </a>
          </td>
          <td>
            <a ng-if="!report.isPreview && report.pdfUrl" href="{{ report.pdfUrl }}" target="_blank">PDF</a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate,report.type)">HTML</a>
            <a ng-if="!report.isPreview && report.jsonUrl" href="{{ report.jsonUrl }}" target="_blank">JSON</a>
          </td>
          <td>{{ report.reportDate | date }}</td>
          <td>{{ report.updatedAt | date }}</td>
          <td>
            <span class="label label-info" ng-if="report.isPreview" sxy-text="SALAXY.NG1.ReportListComponent.preview"></span>
            <span class="label label-danger" ng-if="report.isDemoData">DEMO: demodataa</span>
          </td>
        </tr>
      
      </tbody>
      <tbody ng-if="$ctrl.reportType === 'monthlyLiikekirjuri'" ng-controller="AccountingReportDisplayController as $displayCtrl">
        <tr ng-repeat="report in $ctrl.getReports($ctrl.reportType)">
          <td>
            <a ng-if="!report.isPreview" href="{{ report.pdfUrl || report.htmlUrl || report.jsonUrl }}" target="_blank">
              <img ng-src="{{ report.thumbnail }}" class="img-responsive img-thumbnail" />
            </a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate,report.type, report)">
              <img ng-src="{{ report.thumbnail }}" class="img-responsive img-thumbnail" />
            </a>
          </td>
          <td>
            <a ng-if="!report.isPreview" href="{{ report.pdfUrl || report.htmlUrl || report.jsonUrl }}" target="_blank">{{ report.title }}</a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate,report.type)">{{ report.title }} </a>
          </td>
          <td>
            <a ng-if="!report.isPreview && report.pdfUrl" href="{{ report.pdfUrl }}" target="_blank">PDF</a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate)">HTML</a>
            <a ng-if="!report.isPreview && report.jsonUrl" href="{{ report.jsonUrl }}" target="_blank">JSON</a>
          </td>
          <td>{{ report.reportDate | date }}</td>
          <td>{{ report.updatedAt | date }}</td>
          <td>
            <span class="label label-info" ng-if="report.isPreview" sxy-text="SALAXY.NG1.ReportListComponent.preview"></span>
            <span class="label label-danger" ng-if="report.isDemoData">DEMO: demodataa</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>`);

 $templateCache.put("salaxy-components/report/SalaryReportList.html",`<div class="salaxy-component salaxy-salary-report-list">
  <salaxy-odata-table ng-if="$ctrl.mode != 'panel'" crud-controller="SalaryReportCrudController as $crud" template-url="salaxy-components/odata/lists/SalaryReports.html" options="$ctrl.queryOptions">
  </salaxy-odata-table>
  <salaxy-odata-table ng-if="$ctrl.mode == 'panel'" crud-controller="SalaryReportCrudController as $crud" template-url="salaxy-components/odata/lists/SalaryReportsPanel.html" options="$ctrl.panelQueryOptions">
  </salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/report/SummaryReport.html",`<div class="salaxy-component salaxy-summary-report">
  <div class="btn-toolbar" role="toolbar" aria-label="Report options">

    <div class="btn-group btn-group-sm dropdown">
      <button id="single-button2" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
        <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguage" ps=":"></span> {{$ctrl.languageText | sxyTranslate}}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button2">
        <li ng-if="$ctrl.reportType === 'salarySlip'" role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'default'" class="dropdown-item" sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguageWorker"></a>
        </li>
        <li ng-if="$ctrl.reportType !== 'salarySlip'" role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'default'" class="dropdown-item" sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguageCompany"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'fi'" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.fi.label"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'en'" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.en.label"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'sv'" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.sv.label"></a>
        </li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm ms-sm-auto" role="group" aria-label="Pdf">
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.showDownloadDialog(true)">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.print"></span>
        <i class="bi bi-printer" aria-hidden="true"></i>
      </button>
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.showDownloadDialog(false)">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.downloadPdf"></span>
        <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <div class="" ng-class="{'report-table-html': $ctrl.applySiteStyles}">
    <div ng-bind-html="$ctrl.html" class="report-binder table-responsive"></div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/report/SummaryReportQuery.html",`<div class="salaxy-component salaxy-summary-report-query">
  <div class="btn-toolbar" role="toolbar">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.showPeriodSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectPeriod" ps="..."></button>
      <button type="button" class="btn btn-secondary" ng-click="$ctrl.exportToExcel()">
        <span class="hidden-sm hidden-xs" sxy-text="SALAXY.NG1.HolidayReportComponent.exportToExcel"></span>
        <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
      </button>
  </div>
  <p> {{ $ctrl.getQueryInfoText()}}</p>
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'incomereport', text: 'SALAXY.NG1.HolidayReportComponent.irIncomeTypeReport' },
      { value: 'salarypaymentreport', text: 'SALAXY.NG1.HolidayReportComponent.salaryPaymentReport' },
      { value: 'totalsreport', text: 'SALAXY.ENUM.ReportType.totalsReport.label', hidden: !('test' | sxyIsInRole) },
      { value: 'irrowsreport', text: 'SALAXY.NG1.CalcReportsComponent.irRows', hidden: !('test' | sxyIsInRole) },
      { value: 'rowsreport', text: 'SALAXY.NG1.CalcReportsComponent.rowsReport', hidden: !('test' | sxyIsInRole) },
      { value: 'unionpaymentreport', text: 'SALAXY.NG1.CalcReportsComponent.unionPaymentReport' },
      { value: 'costcenterreport', text: 'SALAXY.NG1.CalcReportsComponent.costCenterReport', hidden: !('test' | sxyIsInRole) }
    ]"
    tabs-id="summaryReportQuery">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-summaryReportQuery">
    <div class="tab-pane" id="incomereport-tab">
      <div ng-if="$ctrl.currentTab == 'incomereport' && $ctrl.irReportRows.length > 0 && $ctrl.irReportRows[0].rows.length > 0">
        <table class="table table-striped">
          <thead>
            <tr>
              <th colspan="2"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span></th>
              <th ng-repeat="row in $ctrl.irReportRows[0].rows" class="right">{{row.label}}</th>             
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="row in $ctrl.irReportRows">
              <td class="align-middle td-avatar">
                <salaxy-avatar class="clickable" ng-click="$ctrl.showEditEmploymentDialog(row)" avatar="row.workerAvatar"></salaxy-avatar>
              </td>
              <td>{{row.workerAvatar.displayName}}</td>
              <td ng-repeat="r in row.rows" class="right">{{ r.isCount ?  r.total  : (r.total| currency) || "&nbsp;"}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="tab-pane" id="salarypaymentreport-tab">
      <div ng-if="$ctrl.currentTab == 'salarypaymentreport' && $ctrl.resultRows.length > 0 && ($ctrl.entrepreneurSummaryReportResults.length > 0 || $ctrl.workerSummaryReportResults.length > 0)">
        <table class="table table-striped">
          <thead>
            <tr>
              <th></th>             
              <th></th>             
              <th class="right">{{ "SALAXY.REPORTS.summary.table.totalGrossSalary" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.totalRowCategory" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.benefits" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.irCode" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.totalTaxable" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.tax" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.pension" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.unemploymentInsurance" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.unionPayment" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.foreclosure" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.otherDeductions" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.totalExpenses" | sxyTranslate}}</th>
              <th class="right" style="border-right: 1px solid #000">{{ "SALAXY.REPORTS.summary.table.totalWorkerPayment" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.totalPayment" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.palkkaus" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.service" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.socialSecurity" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.totalPensions" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.employerPension" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.unemployment" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.employerUnemployment" | sxyTranslate}}</th>
            </tr>
          </thead>
          <tbody ng-if="$ctrl.entrepreneurSummaryReportResults.length > 0">
            <tr >
              <td colspan="15" style="border-right: 1px solid #000"><strong>{{"SALAXY.REPORTS.summary.table.entrepreneurSalary" | sxyTranslate}}</strong></td>
              <td colspan="8"></td>
            </tr>
            <tr ng-repeat="row in $ctrl.entrepreneurSummaryReportResults">
              <td class="align-middle td-avatar">
                <salaxy-avatar class="clickable" ng-click="$ctrl.showEditEmploymentDialog(row)" avatar="row.avatar"></salaxy-avatar>
              </td>     
              <td>{{row.avatar.displayName}}</td>
              <td class="right">{{(row.totalGrossSalary | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalRowCategory | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.benefits | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.irCode | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalTaxable | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.tax | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.pension | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unemploymentInsurance | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unionPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.foreclosure | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.otherDeductions | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalExpenses | currency) || "&nbsp;"}}</td>
              <td class="right" style="border-right: 1px solid #000">{{(row.totalWorkerPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.palkkaus | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.service | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.socialSecurity | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalPensions | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.employerPension | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unemployment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.employerUnemployment | currency) || "&nbsp;"}}</td>
            </tr>
          </tbody>
          <tbody ng-if="$ctrl.workerSummaryReportResults.length > 0">
            <tr>
              <td colspan="15" style="border-right: 1px solid #000"><strong>{{"SALAXY.REPORTS.summary.table.workerSalary" | sxyTranslate}}</strong></td>
              <td colspan="8"></td>
            </tr>
            <tr ng-repeat="row in $ctrl.workerSummaryReportResults">
              <td class="align-middle td-avatar">
                <salaxy-avatar class="clickable" ng-click="$ctrl.showEditEmploymentDialog(row)" avatar="row.avatar"></salaxy-avatar>
              </td>     
              <td>{{row.avatar.displayName}}</td>
              <td class="right">{{(row.totalGrossSalary | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalRowCategory | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.benefits | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.irCode | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalTaxable | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.tax | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.pension | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unemploymentInsurance | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unionPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.foreclosure | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.otherDeductions | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalExpenses | currency) || "&nbsp;"}}</td>
              <td class="right" style="border-right: 1px solid #000">{{(row.totalWorkerPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.palkkaus | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.service | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.socialSecurity | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalPensions | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.employerPension | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unemployment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.employerUnemployment | currency) || "&nbsp;"}}</td>
            </tr>
          </tbody>
          <tbody ng-if="$ctrl.totalSummaryReportResults.length > 0">           
            <tr ng-repeat="row in $ctrl.totalSummaryReportResults">
              <td class="right"><strong>{{"SALAXY.REPORTS.summary.table.total" | sxyTranslate }}:</strong></td>
              <td></td>
              <td class="right">{{(row.totalGrossSalary | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalRowCategory | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.benefits | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.irCode | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalTaxable | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.tax | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.pension | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unemploymentInsurance | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unionPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.foreclosure | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.otherDeductions | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalExpenses | currency) || "&nbsp;"}}</td>
              <td class="right" style="border-right: 1px solid #000">{{(row.totalWorkerPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.palkkaus | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.service | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.socialSecurity | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalPensions | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.employerPension | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unemployment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.employerUnemployment | currency) || "&nbsp;"}}</td>
            </tr>
          </tbody>
        </table>
        <small>
          <small>
            <div>
              <span>{{"SALAXY.REPORTS.summary.infoText.tt" | sxyTranslate}}</span><br />
              <span>{{"SALAXY.REPORTS.summary.infoText.ta" | sxyTranslate}}</span><br />
              <span>{{"SALAXY.REPORTS.summary.infoText.lo" | sxyTranslate}}</span><br />
            </div>
          </small>
        </small>
      </div>
    </div>
    <div class="tab-pane" id="totalsreport-tab" ng-if="'test' | sxyIsInRole">
      <div class="report">
        <salaxy-calc-report ng-ref="$ctrl.$calcReports" lang="$ctrl.reportLang" calc="$ctrl.summaryReportData.calculations"
          apply-site-styles="$ctrl.view == 'partial'" report-type="'totalsReport'" preview="false" template-name="'totalsTables'">
        </salaxy-calc-report>
      </div>
    </div>
    <div class="tab-pane" id="irrowsreport-tab" ng-if="'test' | sxyIsInRole">
      <div class="report" ng-if="$ctrl.currentTab == 'irrowsreport' && $ctrl.resultRows.length > 0">
        <salaxy-calcs-ir-rows ng-ref="$ctrl.$calcsIrRows" calcs="$ctrl.summaryReportData.calculations" lang="$ctrl.reportLang"></salaxy-calcs-ir-rows>
      </div>
    </div>
    <div class="tab-pane" id="rowsreport-tab" ng-if="'test' | sxyIsInRole">
      <div class="report" ng-init="$reportsCtrl.calcs = $ctrl.summaryReportData.calculations; $reportsCtrl.reportType = 'rowsReport';" ng-controller="CalcReportsController as $reportsCtrl" ng-if="$ctrl.currentTab == 'rowsreport' && $ctrl.resultRows.length > 0">
        <sxy-table ng-ref="$reportsCtrl.$sxyTable" options="$reportsCtrl.reportTableConfig.options" include="$reportsCtrl.reportTableConfig.include" data="$reportsCtrl.reportTableConfig.data"></sxy-table>
      </div>
    </div>
    <div class="tab-pane" id="unionpaymentreport-tab">
      <sxy-table class="report" ng-if="$ctrl.currentTab == 'unionpaymentreport' && $ctrl.reportConfig.unionPaymentTableConfig.data" ng-ref="$ctrl.$sxyTable" options="$ctrl.reportConfig.unionPaymentTableConfig.options" include="$ctrl.reportConfig.unionPaymentTableConfig.include" data="$ctrl.reportConfig.unionPaymentTableConfig.data"></sxy-table>
    </div>
    <div class="tab-pane" id="costcenterreport-tab" ng-if="'test' | sxyIsInRole">
      <sxy-table class="report" ng-if="$ctrl.currentTab == 'costcenterreport' && $ctrl.reportConfig.costCenterReportTableConfig.data" ng-ref="$ctrl.$sxyTable" options="$ctrl.reportConfig.costCenterReportTableConfig.options" include="$ctrl.reportConfig.costCenterReportTableConfig.include" data="$ctrl.reportConfig.costCenterReportTableConfig.data"></sxy-table>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/report/WorkerSummaryReport.html",`<div class="salaxy-component salaxy-summary-report">
  <div class="btn-toolbar" role="toolbar" aria-label="Report options">

    <div class="btn-group btn-group-sm dropdown">
      <button id="single-button2" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
        <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguage" ps=":"></span> {{$ctrl.languageText | sxyTranslate}}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button2">
        <li ng-if="$ctrl.reportType === 'salarySlip'" role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'default'" class="dropdown-item" sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguageWorker"></a>
        </li>
        <li ng-if="$ctrl.reportType !== 'salarySlip'" role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'default'" class="dropdown-item" sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguageCompany"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'fi'" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.fi.label"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'en'" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.en.label"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'sv'" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.sv.label"></a>
        </li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm ms-sm-auto" role="group" aria-label="Pdf">
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.showDownloadDialog(true)">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.print"></span>
        <i class="bi bi-printer" aria-hidden="true"></i>
      </button>
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.showDownloadDialog(false)">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.downloadPdf"></span>
        <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <div class="" ng-class="{'report-table-html': $ctrl.applySiteStyles}">
    <div ng-bind-html="$ctrl.html" class="report-binder table-responsive"></div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/Accountant.html",`<div class="content settings">
  <div class="card card-secondary accountant" ng-if="$ctrl.accountant">
    <div class="card-header d-flex">
      <div class="flex-grow-1">
        <h2><span sxy-text="SALAXY.NG1.AccountantComponent.title"></span>
        </h2>
        <p>
          <small sxy-text="SALAXY.NG1.AccountantComponent.intro2"></small>
        </p>
      </div>
      <i class="bi bi-check-circle-fill text-success status-icon fs-1 d-block"></i>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <fieldset>
            <div class="salaxy-component salaxy-accountant-info">
              <div>
                <table>
                  <tr ng-if="$ctrl.accountant.info.avatar.displayName">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.name" ps=":"></td>
                    <td>
                      <div class="d-flex align-items-center">
                        <salaxy-avatar class="me-2" style="font-size: 25px;" avatar="$ctrl.accountant.info.avatar"></salaxy-avatar>
                        <strong>{{ $ctrl.accountant.info.avatar.displayName}}<strong>
                      </div>
                    </td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.officialId">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.officialId" ps=":"></td>
                    <td>{{ $ctrl.accountant.info.officialId}}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.email">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.email" ps=":"></td>
                    <td>{{ $ctrl.accountant.info.email }}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.telephone">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.phone" ps=":"></td>
                    <td>{{ $ctrl.accountant.info.telephone }}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner' || $ctrl.accountant.type == 'unlinkedPrimaryPartner' || $ctrl.accountant.type == 'unlinkedAccountingOnly'">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.accountantType" ps=":"></td>
                    <td>
                      <span ng-if="$ctrl.accountant.type == 'primaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.primaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'pendingPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.pendingPrimaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'unlinkedPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedPrimaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'unlinkedAccountingOnly'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedAccountingOnly"></span>
                    </td>
                  </tr>
                  <tr ng-if="$ctrl.accountantMainType == 'none' && !($ctrl.accountant.info.avatar.firstName || $ctrl.accountant.info.avatar.lastName || $ctrl.accountant.info.email || $ctrl.accountant.info.telephone)">
                    <td colspan="2">
                      <span sxy-text="SALAXY.NG1.AccountantSelectionComponent.noAccountantEnum"></span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-12">
          <button class="btn btn-primary float-end" ng-click="$ctrl.showEdit($ctrl.removalDisabled)" sxy-text="SALAXY.UI_Terms.edit"></button>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/AccountantEmails.html",`<div class="content settings">
  <div class="card card-secondary accountant" ng-if="$ctrl.accountant">
    <div class="card-header">
      <h2><span sxy-text="SALAXY.NG1.AccountantComponent.title"></span>
      </h2>
    </div>
    <div class="card-body">
      <div class="row">
        <form name="companyAccountantForm" class="form-horizontal">
          <div class="col">
            <fieldset ng-if="$ctrl.accountantMainType != 'none'">
              <div  class="container-fixed salaxy-component salaxy-accountant-info">
                <div class="table-responsive">
                  <table class="table">
                    <tr>
                      <th sxy-text="SALAXY.NG1.AccountantComponent.name" ps=":"></th>
                      <td>
                        <salaxy-avatar style="font-size: 20px; margin-right: 12px;" avatar="$ctrl.accountant.info.avatar"></salaxy-avatar><strong>{{ $ctrl.accountant.info.avatar.displayName}}<strong></td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.officialId">
                    <th sxy-text="SALAXY.NG1.AccountantComponent.officialId" ps=":"></th>
                    <td>{{ $ctrl.accountant.info.officialId}}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner'">
                    <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.accountingDataEmail" ps=":"></th>
                    <td>
                      <salaxy-input-boolean ng-model="$ctrl.accountant.info.accountantEmailsOrdered" type="checkbox" name="order" label="" label-type="plain">
                        </salaxy-input-boolean>
                    </td>
                  </tr>
      
                  <tr ng-if="$ctrl.accountant.type == 'unlinkedAccountingOnly' || !$ctrl.accountant.info.avatar.id || $ctrl.accountant.type == 'pendingPrimaryPartner' || $ctrl.accountant.type == 'primaryPartner'">
                    <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.email" ps=":"></th>
                    <td>
                      <salaxy-input name="email" label="" read-only="($ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner') && !$ctrl.accountant.info.accountantEmailsOrdered" require="!(($ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner') && !$ctrl.accountant.info.accountantEmailsOrdered)"
                        label-type="plain" sxy-email ng-model="$ctrl.accountant.info.email"></salaxy-input>
                    </td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.type == 'unlinkedAccountingOnly' || !$ctrl.accountant.info.avatar.id || $ctrl.accountant.type == 'pendingPrimaryPartner' || $ctrl.accountant.type == 'primaryPartner'">
                    <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.telephone" ps=":"></th>
                    <td>
                      <salaxy-input name="telephone" label="" read-only="($ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner') && !$ctrl.accountant.info.accountantEmailsOrdered" require="!(($ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner') && !$ctrl.accountant.info.accountantEmailsOrdered)"
                        label-type="plain" sxy-mobile-phone ng-model="$ctrl.accountant.info.telephone"></salaxy-input>
                    </td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner' || $ctrl.accountant.type == 'unlinkedPrimaryPartner' || $ctrl.accountant.type == 'unlinkedAccountingOnly'">
                    <th sxy-text="SALAXY.NG1.AccountantComponent.accountantType" ps=":"></th>
                    <td>
                      <span ng-if="$ctrl.accountant.type == 'primaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.primaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'pendingPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.pendingPrimaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'unlinkedPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedPrimaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'unlinkedAccountingOnly'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedAccountingOnly"></span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </fieldset>
          <fieldset ng-if="$ctrl.accountantMainType == 'none'">
            <salaxy-input name="firstName" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.firstName" ng-model="$ctrl.accountant.info.avatar.firstName"></salaxy-input>
            <salaxy-input name="lastName" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.lastName"  ng-model="$ctrl.accountant.info.avatar.lastName"></salaxy-input>
            <salaxy-input name="email" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.email"  sxy-email ng-model="$ctrl.accountant.info.email"></salaxy-input>
            <salaxy-input name="telephone" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.telephone"  sxy-mobile-phone ng-model="$ctrl.accountant.info.telephone"></salaxy-input>
          </fieldset>
        </div>
      </form>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col">
          <div class="text-end">
            <a ng-if="$ctrl.accountantMainType == 'none'" class="btn btn-default" href="#/settings/accountants" sxy-text="SALAXY.NG1.AccountantComponent.addPrimaryPartner"></a>
            <button ng-disabled="!companyAccountantForm.$valid" class="btn btn-primary" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.save"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/AccountantInfo.html",`<div class="content settings">
  <div class="card mb-4 card-secondary accountant" ng-if="$ctrl.accountant">
    <div class="card-header">
      <h2><span sxy-text="SALAXY.NG1.AccountantComponent.title"></span>
      </h2>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <fieldset>
            <div class="salaxy-component salaxy-accountant-info">
              <div >
                <table>
                  <tr ng-if="$ctrl.accountant.info.avatar.displayName">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.name" ps=":"></td>
                    <td>
                      <div class="d-flex align-items-center">
                        <salaxy-avatar class="me-2" style="font-size: 25px;" avatar="$ctrl.accountant.info.avatar"></salaxy-avatar>
                        <strong>{{ $ctrl.accountant.info.avatar.displayName}}<strong>
                      </div>
                    </td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.officialId">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.officialId" ps=":"></td>
                    <td>{{ $ctrl.accountant.info.officialId}}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.email">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.email" ps=":"></td>
                    <td>{{ $ctrl.accountant.info.email }}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.telephone">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.phone" ps=":"></td>
                    <td>{{ $ctrl.accountant.info.telephone }}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner' || $ctrl.accountant.type == 'unlinkedPrimaryPartner' || $ctrl.accountant.type == 'unlinkedAccountingOnly'">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.accountantType" ps=":"></td>
                    <td>
                      <span ng-if="$ctrl.accountant.type == 'primaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.primaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'pendingPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.pendingPrimaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'unlinkedPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedPrimaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'unlinkedAccountingOnly'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedAccountingOnly"></span>
                    </td>
                  </tr>
                  <tr ng-if="$ctrl.accountantMainType == 'none' && !($ctrl.accountant.info.avatar.firstName || $ctrl.accountant.info.avatar.lastName || $ctrl.accountant.info.email || $ctrl.accountant.info.telephone)">
                    <td colspan="2">
                      <span sxy-text="SALAXY.NG1.AccountantSelectionComponent.noAccountantEnum"></span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer" ng-if="$ctrl.accountantMainType == 'none'">
      <div class="row">
        <div class="col-12">
          <div class="text-end">
            <a class="btn btn-default" href="#/settings/accountants" sxy-text="SALAXY.NG1.AccountantComponent.addPrimaryPartner"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/AccountingSettings.html",`<div class="content settings" ng-if="$ctrl.current">
  <div class="card mb-4 accounting card-secondary">
    <div>
      <div class="card-header">
        <h2 sxy-text="SALAXY.MODEL.AccountingSettings.title"></h2>
        <p><small sxy-text="SALAXY.MODEL.AccountingSettings.descr"></small></p>
      </div>
      <div class="card-body">
        <div class="row">

          <sxy-form ng-ref="$frm" open-api="salaxy-secure/schemas/v02.json" type="CompanyAccountSettings" auto-gen="false" debugger="false" model="$ctrl.current" read-only="{{!$ctrl.current.accounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.accounting}}">
            <div class="col-12 form-horizontal">
              <fieldset>
                <salaxy-input-typeahead
                  label="SALAXY.MODEL.AccountingSettings.defaultTargetId.title"
                  ng-model="$ctrl.current.accounting.defaultTargetId"
                  name="options_type"
                  disable-cache="true"
                  options="$ctrl.getSelectableAccountingTargets()">
                </salaxy-input-typeahead>
                <salaxy-form-group name="targets" label="SALAXY.MODEL.AccountingSettings.targets.title">
                  <div>
                    <span>
                        <i ng-click="$ctrl.showTargets = !$ctrl.showTargets" class="clickable bi" ng-class="$frm.readOnly == 'true' ? 'bi-info-circle-fill' : 'bi-pencil-fill'"></i>
                    </span>
                  </div>
                </salaxy-form-group>

                  <sxy-input ng-if="$ctrl.showTargets" template-url="salaxy-components/sxy-form/custom-templates/array-accounting-targets.html" model="form.accounting.targets">
                    <form>
                      <fieldset ng-show="!$ctrl.logic.showDelete" ng-controller="CompanySettingsController as $companySettingsCtrl" ng-init="$ctrl.logic.isReadOnly = true">
                        <salaxy-odata-table crud-controller="AccountingTargetCrudController as $crud" template-url="salaxy-components/odata/lists/AccountingTargetSelect.html" selected-items="$ctrl.selectedItems" on-list-select="$companySettingsCtrl.onAccountingTargetSelect($ctrl.current, $ctrl.logic, value, item, allItems)">
                        </salaxy-odata-table>
                      </fieldset>
                      <fieldset ng-show="$ctrl.logic.showDelete" ng-init="$ctrl.logic.isReadOnly = false">
                        <salaxy-input-enum disabled="false" name="format" label="SALAXY.NG1.AccountingTargetDetailsComponent.excelCsvFormat" ng-model="$ctrl.current.format"
                          options="{
                            '36dff2e2-e181-4f0d-9004-0e4aa92f5e17': 'Palkkaus.fi',
                            '0db4e85f-93a8-46f1-b6d2-f7523d289d88': 'Fennoa',
                            '8613f133-3fce-4611-b372-51f6a2e007dd': 'Procountor',
                            'e62c10b0-222a-4170-b8b4-b1e02d9a7644': 'Passeli Merit',
                            '53fd3863-b8f9-4909-86c9-cb4597595181': 'Heeros',
                            '2fc7899c-7a3d-4d56-ad2f-05d52782bbbc': 'Asteri',
                            '0a2bd312-06da-4862-aef5-75166e0bf461': 'Maestro',
                            'c04e0757-63f3-420d-a183-3427710fc954': 'Visma Fivaldi',
                            'ba271dac-dd63-4036-9d70-053a09ca4d9e' :'Visma Netvisor',
                            '27e271d5-41f5-4319-ab29-4d5d9eb945c6': 'Lemonsoft',
                            'd311f9d3-8c3a-4fd8-a665-8e3698e41e87': 'Tampuuri',
                            'd58e95b7-d0b5-40ac-992b-6d3b29efc45e': 'Domus',
                            '54e93c5f-bd74-4157-8a74-3515be7f585d': 'Oscar Software',
                            '0e4f0a71-dcb9-43ba-9028-0239e674711f': 'Digia Enterprise',
                            '2ccefa46-7992-46c5-9d87-b88336935916': 'Digia Enterprise - VILPE',
                            'c36c24b9-5e2c-4f44-b67a-90d81aeea257': 'iScala'
                          }">
                        </salaxy-input-enum>
                        <sxy-input model="form.method" read-only="false"></sxy-input>
                        <salaxy-input-enum disabled="false" enum="ExportMethod" label="SALAXY.MODEL.AccountingTargetSettings.availableMethods.title" name="availableMethods" type="multi-select" ng-model="$ctrl.current.availableMethods"></salaxy-input-enum>
                      </fieldset>
                    </form>
                  </sxy-input>

                <sxy-input model="form.accounting.defaultPeriodDateKind"></sxy-input>
                <salaxy-input-enum ng-if="$ctrl.defaultAccountingTarget"
                  read-only="$frm.readOnly == 'true'" type="select" name="method"
                  ng-model="$ctrl.defaultAccountingTarget.method" enum="ExportMethod" label="SALAXY.MODEL.AccountingTargetSettings.method.title"></salaxy-input-enum>
              </fieldset>
              <fieldset>
                <legend sxy-text="SALAXY.MODEL.AccountingSettings.reportDelivery.title"></legend>
                <sxy-input read-only="false" format="checkbox" model="form.accounting.reportDelivery.isEnabled"></sxy-input>
                <sxy-input read-only="false"  format="email" model="form.accounting.reportDelivery.address" ng-if="$ctrl.current.accounting.reportDelivery.isEnabled"></sxy-input>
              </fieldset>
              <fieldset>
                <legend sxy-text="SALAXY.MODEL.AccountingSettings.accountantReportDelivery.title"></legend>
                <sxy-input read-only="false" format="checkbox" model="form.accounting.accountantReportDelivery.isEnabled"></sxy-input>
                <sxy-input read-only="false"  format="email" model="form.accounting.accountantReportDelivery.address" ng-if="$ctrl.current.accounting.accountantReportDelivery.isEnabled"></sxy-input>
           
              </fieldset>
            </div>
          </sxy-form>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-12">
            <button type="submit" ng-disabled="!$frm.ngForm.$valid || $ctrl.isSaving('all')" class="btn btn-primary float-end" ng-click="$ctrl.save('all')">
              <span ng-if="$ctrl.isSaving('all')"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span sxy-text="SALAXY.UI_Terms.save"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/AccountingTargetDetails.html",`<div class="salaxy-component salaxy-accounting-target-editor">
  <div ng-if="!$ctrl.current">
    <salaxy-spinner heading="SALAXY.UI_Terms.loading"></salaxy-spinner>
  </div>
  <div class="row" ng-if="$ctrl.current">
    <div class="col-12 accounting-target-info-col">
      <div class="row mb-2">
        <div class="col-12">
          <div class="btn-toolbar float-end" role="toolbar" aria-label="Tilit">
            <div class="btn-group" role="group" aria-label="Save and load">
              <button class="btn btn-danger" ng-disabled="$ctrl.isReadOnly" ng-click="$ctrl.delete()" sxy-text="SALAXY.UI_Terms.delete"></button>
              <button class="btn btn-default" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
              <button class="btn btn-primary" ng-disabled="!$ctrl.hasChanges && !$ctrl.isNew()" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.save"></button>
            </div>
          </div>
          <salaxy-avatar class="float-start" style="font-size: 58px; margin-right: 15px; margin-top: -15px;" avatar="$ctrl.current.info.target.avatar"></salaxy-avatar>
          <h2>{{ $ctrl.current.info.target.avatar.displayName}}</h2>

          <fieldset class="form-horizontal">
            <legend sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.accountingTargetLegend"></legend>
            <div ng-if="$ctrl.template">
              <div class="row">
                <div class="col-sm-4">
                  <salaxy-input read-only="true" name="template_name" label="SALAXY.NG1.AccountingTargetDetailsComponent.name"
                    ng-model="$ctrl.template.info.target.avatar.displayName"></salaxy-input>
                  <salaxy-input read-only="true" name="template_id" label="SALAXY.NG1.AccountingTargetDetailsComponent.id" ng-model="$ctrl.template.id"></salaxy-input>
                </div>
                <div class="col-sm-4">
                  <salaxy-input-enum read-only="true" name="format" label="SALAXY.NG1.AccountingTargetDetailsComponent.excelCsv" ng-model="$ctrl.template.info.format" options="{
                    '36dff2e2-e181-4f0d-9004-0e4aa92f5e17': 'Palkkaus.fi',
                    '0db4e85f-93a8-46f1-b6d2-f7523d289d88': 'Fennoa',
                    '8613f133-3fce-4611-b372-51f6a2e007dd': 'Procountor',
                    'e62c10b0-222a-4170-b8b4-b1e02d9a7644': 'Passeli Merit',
                    '53fd3863-b8f9-4909-86c9-cb4597595181': 'Heeros',
                    '2fc7899c-7a3d-4d56-ad2f-05d52782bbbc': 'Asteri',
                    '0a2bd312-06da-4862-aef5-75166e0bf461': 'Maestro',
                    'c04e0757-63f3-420d-a183-3427710fc954': 'Visma Fivaldi',
                    'ba271dac-dd63-4036-9d70-053a09ca4d9e': 'Visma Netvisor',
                    '27e271d5-41f5-4319-ab29-4d5d9eb945c6': 'Lemonsoft',
                    'd311f9d3-8c3a-4fd8-a665-8e3698e41e87': 'Tampuuri',
                    'd58e95b7-d0b5-40ac-992b-6d3b29efc45e': 'Domus',
                    '54e93c5f-bd74-4157-8a74-3515be7f585d': 'Oscar Software',
                    '0e4f0a71-dcb9-43ba-9028-0239e674711f': 'Digia Enterprise',
                    '2ccefa46-7992-46c5-9d87-b88336935916': 'Digia Enterprise - VILPE',
                    'c36c24b9-5e2c-4f44-b67a-90d81aeea257': 'iScala'
                  }"></salaxy-input-enum>
                </div>
                <div class="col-sm-4">
                  <salaxy-datepicker read-only="true" name="createdAt" ng-model="$ctrl.template.createdAt" label="SALAXY.UI_Terms.created"></salaxy-datepicker>
                  <salaxy-datepicker read-only="true" name="updatedAt" ng-model="$ctrl.template.updatedAt" label="SALAXY.UI_Terms.updated"></salaxy-datepicker>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
  <div ng-if="$ctrl.current">
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'overview', text: 'SALAXY.NG1.AccountingTargetDetailsComponent.tabs.overview' },
        { value: 'coa', text: 'SALAXY.NG1.AccountingTargetDetailsComponent.tabs.chartOfAccounts' },
        { value: 'accounts', text: 'SALAXY.NG1.AccountingTargetDetailsComponent.tabs.usedAccounts', onClick: $ctrl.sortRulesetAccounts },
        { value: 'guidelines', text: 'SALAXY.NG1.AccountingTargetDetailsComponent.tabs.guidelines' },
        { value: 'rules', text: 'SALAXY.NG1.AccountingTargetDetailsComponent.tabs.rules' },
        { value: 'accountingquery', text: 'SALAXY.NG1.AccountingTargetDetailsComponent.tabs.accountingQuery' },
        { value: 'debugger', text: 'Debugger', hidden: !('test' | sxyIsInRole) }
      ]"
      tabs-id="accountingTargetDetails">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-accountingTargetDetails">
      <div class="tab-pane" id="overview-tab">
        <form name="ruleSetForm" class="form-horizontal">
          <div class="row">
            <div class="col-6">
              <fieldset>
                <div ng-if="$ctrl.isReadOnly" class="alert alert-danger">
                  <span class="text-danger" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.readOnly"></span>
                </div>
                <salaxy-input disabled="$ctrl.isReadOnly" name="ruleSetName" label="SALAXY.NG1.AccountingTargetDetailsComponent.name"
                  ng-model="$ctrl.current.info.target.avatar.displayName"></salaxy-input>
                  <salaxy-input disabled="$ctrl.isReadOnly" name="logoUrl" label="SALAXY.NG1.AccountingTargetDetailsComponent.logoUrl"
                  ng-model="$ctrl.current.info.target.avatar.url"></salaxy-input>
                <salaxy-input-enum disabled="$ctrl.isReadOnly" name="channel" label="SALAXY.NG1.AccountingTargetDetailsComponent.channel" ng-model="$ctrl.current.info.channel" enum="AccountingChannel">
                </salaxy-input-enum>
                <salaxy-input-enum disabled="$ctrl.isReadOnly" name="format" label="SALAXY.NG1.AccountingTargetDetailsComponent.excelCsvFormat" ng-model="$ctrl.current.info.format"
                  options="{
                    '36dff2e2-e181-4f0d-9004-0e4aa92f5e17': 'Palkkaus.fi',
                    '0db4e85f-93a8-46f1-b6d2-f7523d289d88': 'Fennoa',
                    '8613f133-3fce-4611-b372-51f6a2e007dd': 'Procountor',
                    'e62c10b0-222a-4170-b8b4-b1e02d9a7644': 'Passeli Merit',
                    '53fd3863-b8f9-4909-86c9-cb4597595181': 'Heeros',
                    '2fc7899c-7a3d-4d56-ad2f-05d52782bbbc': 'Asteri',
                    '0a2bd312-06da-4862-aef5-75166e0bf461': 'Maestro',
                    'c04e0757-63f3-420d-a183-3427710fc954': 'Visma Fivaldi',
                    'ba271dac-dd63-4036-9d70-053a09ca4d9e' :'Visma Netvisor',
                    '27e271d5-41f5-4319-ab29-4d5d9eb945c6': 'Lemonsoft',
                    'd311f9d3-8c3a-4fd8-a665-8e3698e41e87': 'Tampuuri',
                    'd58e95b7-d0b5-40ac-992b-6d3b29efc45e': 'Domus',
                    '54e93c5f-bd74-4157-8a74-3515be7f585d': 'Oscar Software',
                    '0e4f0a71-dcb9-43ba-9028-0239e674711f': 'Digia Enterprise',
                    '2ccefa46-7992-46c5-9d87-b88336935916': 'Digia Enterprise - VILPE',
                    'c36c24b9-5e2c-4f44-b67a-90d81aeea257': 'iScala'
                  }">
                </salaxy-input-enum>
                <salaxy-form-group name="method" label="SALAXY.NG1.AccountingTargetDetailsComponent.exportMethod" label-type="horizontal">
                  <select class="form-select" ng-model="$ctrl.current.info.method">
                    <option ng-repeat="method in $ctrl.current.info.availableMethods"ng-value="method">{{'SALAXY.ENUM.ExportMethod.' + method + ".label" | sxyTranslate}}</option>
                  </select>
                </salaxy-form-group>
                <salaxy-input-enum label="SALAXY.NG1.AccountingTargetDetailsComponent.exportMethods" disabled="false" enum="ExportMethod"
                  name="availableMethods" type="multi-select" ng-model="$ctrl.current.info.availableMethods"></salaxy-input-enum>
              </fieldset>
            </div>
          </div>
        </form>
      </div>
      <div class="tab-pane" id="coa-tab">
        <div class="btn-toolbar" role="toolbar" aria-label="Data options">
          <div class="btn-group" role="group">
            <button ng-disabled="$ctrl.isReadOnly" type="button" class="btn btn-default" ng-click="$ctrl.pasteFromClipboard()">
              <span><span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.pasteFromClipboard"></span> <i class="bi bi-clipboard"></i></span></button>
            <button ng-disabled="$ctrl.isReadOnly" type="button" class="btn btn-default" ngf-select="$ctrl.readFile($file)" ngf-multiple="false" ngf-max-size="10MB">
              <span><span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.readFile" ps="..."></span><i class="bi bi-file-earmark-text"></i></span>
            </button>
          </div>
        </div>
        <div class="table-responsive" ng-if="$ctrl.hasTargetCoA">
          <table class="table table-sm">
            <thead>
              <tr>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.accountNumber"></th>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.name"></th>
                <th class="right">
                  <button title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addTargetCoaAccount(false)"
                    sxy-text="SALAXY.UI_Terms.addRow"></button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="account in $ctrl.current.ruleSet.targetCoA">
                <td>
                  <salaxy-input read-only="$ctrl.isReadOnly" name="{{'accountAccount'+$index}}" ng-change="$ctrl.updateRuleSetAccount(account)" ng-model="account.account" label-type="plain"></salaxy-input>
                </td>
                <td>
                  <salaxy-input read-only="$ctrl.isReadOnly" name="{{'accountText'+$index}}" ng-change="$ctrl.updateRuleSetAccount(account)" ng-model="account.text"
                    label-type="plain"></salaxy-input>
                </td>
                <td class="right">
                  <button title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}" class="btn btn-transparent" type="button" ng-if="!account.isReadOnly"
                    ng-click="$ctrl.removeAccount(account, true)">
                    <i class="bi bi-trash-fill"></i>
                  </button>
                </td>
              </tr>
              <tr ng-if="$ctrl.hasTargetCoA">
                <td></td>
                <td></td>
                <td class="right">
                  <button title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addTargetCoaAccount(true)"
                    sxy-text="SALAXY.UI_Terms.addRow"></button>
                </td>
              </tr>
            </tbody>
            <tfoot>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="tab-pane" id="accounts-tab">
        <div class="btn-group btn-group-sm dropdown">
          <button id="single-button2" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
            <span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.filters.rowsToShow" ps=":"></span> {{$ctrl.accountFilterText | sxyTranslate}}
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="single-button2">
            <li role="menuitem">
              <a href="" ng-click="$ctrl.accountFilter = 'all'" class="dropdown-item" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.filters.all"></a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.accountFilter = 'includedAndEnabled'" class="dropdown-item" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.filters.includedAndEnabled"></a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.accountFilter = 'error'" class="dropdown-item" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.filters.error"></a>
            </li>
          </ul>
        </div>
        <button class="btn btn-default btn-sm ms-1" ng-click="$ctrl.showDistinct = !$ctrl.showDistinct">{{$ctrl.showDistinct ?
          ('SALAXY.NG1.AccountingTargetDetailsComponent.filters.showNormal' | sxyTranslate) : "SALAXY.NG1.AccountingTargetDetailsComponent.filters.showDistinct" |
          sxyTranslate}}</button>
        <div ng-if="$ctrl.showDistinct && !$ctrl.distinctAccounts.length || !$ctrl.showDistinct && !$ctrl.filteredAccounts.length">
            <p sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.filters.noRows"></p>
        </div>
        <div class="table-responsive" ng-if="!$ctrl.showDistinct && $ctrl.filteredAccounts.length">
          <table class="table table-sm">
            <thead>
              <tr>
                <th></th>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.accountNumber"></th>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.name"></th>
                <th class="right">
                  <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button"
                    ng-click="$ctrl.addAccount(false)" sxy-text="SALAXY.UI_Terms.addRow"></button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="account in $ctrl.filteredAccounts">
                <td class="middle">
                  <div class="text-center" ng-if="!$ctrl.isValidAccount(account)" data-toggle="tooltip" data-placement="top" data-bs-title="'SALAXY.NG1.AccountingTargetDetailsComponent.noAccountNumberFound' | sxyTranslate" sxy-bs5-tooltip>
                    <i class="bi bi-exclamation-circle-fill text-danger"></i>
                  </div>
                </td>
                <td>
                  <salaxy-input read-only="$ctrl.isReadOnly" name="{{'accountAccount'+$index}}" ng-change="$ctrl.updateAccountToMatchTargetCoa(account)" ng-model="account.account" label-type="plain"></salaxy-input>
                </td>
                <td>
                  <salaxy-input read-only="true" name="{{'accountText'+$index}}" ng-model="account.text" label-type="plain"></salaxy-input>
                </td>
                <td class="right">
                  <button title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}" class="btn btn-transparent" type="button" ng-if="!account.isReadOnly"
                    ng-click="$ctrl.removeAccount(account)">
                    <i class="bi bi-trash-fill"></i>
                  </button>
                  <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.changeAccount' | sxyTranslate}}" class="btn btn-transparent"
                    type="button" ng-click="$ctrl.selectTargetAccount(account)" ng-if="$ctrl.hasTargetCoA">
                    <i class="bi bi-pencil-fill"></i>
                  </button>
                </td>
              </tr>
              <tr ng-if="$ctrl.current.ruleSet.accounts.length">
                <td></td>
                <td></td>
                <td></td>
                <td class="right">
                  <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button"
                    ng-click="$ctrl.addAccount(true)" sxy-text="SALAXY.UI_Terms.addRow"></button>
                </td>
              </tr>
            </tbody>
            <tfoot>
            </tfoot>
          </table>
        </div>
        <div class="table-responsive" ng-if="$ctrl.showDistinct && $ctrl.distinctAccounts.length">
          <table class="table table-sm">
            <thead>
              <tr>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.accountNumber"></th>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.name"></th>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.ruleCount"></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="account in $ctrl.distinctAccounts">
                <td>
                  <salaxy-input read-only="true" name="{{'accountAccount'+$index}}" ng-model="account.account" label-type="plain"></salaxy-input>
                </td>
                <td>
                  <salaxy-input read-only="true" name="{{'accountText'+$index}}" ng-model="account.text" label-type="plain">
                  </salaxy-input>
                </td>
                <td>{{$ctrl.getRulesCount(account.account)}}</td>
              </tr>
            </tbody>
            <tfoot>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="tab-pane" id="guidelines-tab">
        <div sxy-html="SALAXY.NG1.AccountingTargetDetailsComponent.guidelinesInfo.html"></div>
      </div>
      <div class="tab-pane" id="rules-tab">
        <div class="btn-toolbar" role="toolbar" aria-label="{{'SALAXY.NG1.AccountingTargetDetailsComponent.accounts' | sxyTranslate}}">
          <div class="btn-group" role="group" aria-label="{{'SALAXY.NG1.AccountingTargetDetailsComponent.sorting' | sxyTranslate}}" ng-init="$ctrl.ruleViewSorting = 'default'">
            <salaxy-toggle-buttons ng-model="$ctrl.ruleViewSorting" options="[
              { value: 'default', label: 'SALAXY.NG1.AccountingTargetDetailsComponent.sortDefault' },
              { value: 'byAccountPairs', label: 'SALAXY.NG1.AccountingTargetDetailsComponent.sortByAccountPairs' },
              { value: 'byAccount', label: 'SALAXY.NG1.AccountingTargetDetailsComponent.sortByAccount' }
              ]" type="inline"></salaxy-toggle-buttons>
          </div>
        </div>
        <div ng-if="$ctrl.currentTab == 'rules'">
          <ng-include
            src="'salaxy-components/settings/AccountingTargetEditorRulesTable' + ($ctrl.ruleViewSorting == 'byAccountPairs' ? 2 : $ctrl.ruleViewSorting == 'byAccount' ? 3 : 1) + '.html'">
          </ng-include>
        </div>
      </div>
      <div class="tab-pane" id="accountingquery-tab">
        <ng-include src="'salaxy-components/settings/AccountingTargetEditorQuery.html'"></ng-include>
      </div>
      <div class="tab-pane" id="debugger-tab" ng-if="'test' | sxyIsInRole">
        <salaxy-json-formatter json="$ctrl.current"></salaxy-json-formatter>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/AccountingTargetEditorQuery.html",`<div class="salaxy-component salaxy-accounting-report-query" ng-controller="AccountingReportQueryController as $ctrlQuery" ng-init="$ctrlQuery.queryType = 'selectionQuery'">
  <form name="queryForm" class="form-horizontal">
    <fieldset>
      <div class="col col-md-6">
        <p>
          <span class="label label-primary" ng-if="$ctrlQuery.calculations.length">
            <span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.selectedAmount" ps=":"></span>{{ $ctrlQuery.calculations.length }}
          </span>
        </p>
        <div class="btn-toolbar" role="toolbar">
          <button class="btn btn-default" ng-click="$ctrlQuery.addCalcs('draft')" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.addDraftBtn"></button>
        </div>
      </div>
    </fieldset>
    <div class="col col-md-12">
      <div ng-if="$ctrlQuery.calculations.length" class="table-responsive salaxy-odata-table">
        <table class="table table-striped">
          <thead>
            <tr>
              <th colspan="2">
                <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
              </th>
              <th class="hidden-xxs">
                <span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.status"></span><br />
                <span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.date"></span>
              </th>
              <th class="right hidden-xxs">
                <span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.salary"></span><br />
                <span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.payment"></span>
              </th>
              <th class="hidden-xxs"></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="row in $ctrlQuery.calculations">
              <td class="td-avatar visible-xxs middle">
                <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
              </td>
              <td class="td-name visible-xxs middle">
                <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.notSelected"></span>
                <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
                <br /> {{ row.endAt | date }}
              </td>
              <td class="right visible-xxs bottom">
                <div>
                  {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
                </div>
              </td>
              <td class="td-avatar hidden-xxs middle">
                <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
              </td>
              <td class="td-name hidden-xxs middle">
                <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.notSelected"></span>
                <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
              </td>
              <td class="hidden-xxs middle">
                {{ row.status ? ("SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate) : "#ERR" }}<br /> {{ row.endAt | date }}
              </td>
              <td class="right hidden-xxs middle">
                {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
              </td>
              <td class="right middle">
                <button class="btn btn-sm  btn-danger" type="button" ng-click="$ctrlQuery.removeCalc(row)">
                        {{ 'SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.unselect' | sxyTranslate }}
                      </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
  <div class="col col-md-12 text-end">
    <button class="btn btn-primary" ng-disabled="!queryForm.$valid || !$ctrlQuery.calculations.length" ng-click="$ctrlQuery.queryData($ctrl.current.id)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.fetchRowsBtn"></button>
  </div>
  <salaxy-accounting-report-rows data="$ctrlQuery.data"></salaxy-accounting-report-rows>
</div>`);

 $templateCache.put("salaxy-components/settings/AccountingTargetEditorRulesTable1.html",`<div class="table-responsive">
  <table class="table table-sm">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.incomeTypeHead"></th>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.additionalSelectionsHead"></th>
        <th>
          <div sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.includeHead"></div>
          <div sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabledHead"></div>
        </th>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.debetHead"></th>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.creditHead"></th>
        <th class="right">
          <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.UI_Terms.addRow'| sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addRow(null, true)" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat-start="ruleSetRow in $ctrl.current.ruleSet.rows">
        <td>{{$ctrl.getEntryDescription(ruleSetRow)}}</td>
        <td>
          <div ng-repeat="flag in ruleSetRow.flags">
            <span class="badge" ng-class="$ctrl.getFlagText(flag).found ? 'bg-success' : 'bg-warning'">{{$ctrl.getFlagText(flag).text}}</span>
          </div>
        </td>
        <td>
          <div ng-class="{ 'text-danger': !ruleSetRow.isIncluded }">{{ ruleSetRow.isIncluded ? ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.included'| sxyTranslate) : ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.excluded'| sxyTranslate) }}</div>
          <div ng-class="{ 'text-danger': !ruleSetRow.enabled }">{{ ruleSetRow.enabled ? ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabled'| sxyTranslate) : ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.disabled'| sxyTranslate) }}</div>
        </td>
        <td ng-if="ruleSetRow.isIncluded">
          <div>
            {{ $ctrl.getAccount(ruleSetRow.debitId).account || ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.debitUndefined'| sxyTranslate) }}
            <span ng-if="ruleSetRow.debitGrouping">
              <span>{{ ruleSetRow.debitGrouping }}</span>
            <small style="text-decoration: line-through">{{ $ctrl.getAccount(ruleSetRow.debitId).text }}</small>
            </span>
            <span ng-if="!ruleSetRow.debitGrouping">
              <span>{{ $ctrl.getAccount(ruleSetRow.debitId).text }}</span>
            </span>
          </div>
        </td>
        <td ng-if="ruleSetRow.isIncluded">
          <div>
            {{ $ctrl.getAccount(ruleSetRow.creditId).account || ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.creditUndefined'| sxyTranslate) }}
            <span ng-if="ruleSetRow.creditGrouping">
              <span>{{ ruleSetRow.creditGrouping }}</span>
            <small style="text-decoration: line-through">{{ $ctrl.getAccount(ruleSetRow.creditId).text }}</small>
            </span>
            <span ng-if="!ruleSetRow.creditGrouping">
              <span>{{ $ctrl.getAccount(ruleSetRow.creditId).text }}</span>
            </span>
          </div>
        </td>
        <td colspan="2" ng-if="!ruleSetRow.isIncluded" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></td>
        <td class="right">
          <div class="btn-group">
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editRule' | sxyTranslate}}" class="btn btn-sm" ng-class="{ 'btn-primary': !ruleSetRow.isInEdit, 'btn-default': ruleSetRow.isInEdit }" type="button"
              ng-click="ruleSetRow.isInEdit=!ruleSetRow.isInEdit">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.copyAsNewRule' | sxyTranslate}}" class="btn btn-default btn-sm" type="button" ng-click="$ctrl.addRow(ruleSetRow)">
              <i class="bi bi-copy"></i>
            </button>
          </div>
        </td>
      </tr>
      <tr ng-repeat-end ng-if="ruleSetRow.isInEdit">
        <td>
          <button title="{{'SALAXY.UI_Terms.change' | sxyTranslate}}" class="btn btn-sm btn-default" type="button" ng-click="$ctrl.selectEntry(ruleSetRow)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeIncomeTypeBtn"></button>
        </td>
        <td>
          <button title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-default" type="button" ng-click="$ctrl.selectFlags(ruleSetRow)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editAdditionalsBtn"></button>
        </td>
        <td>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetIsIncluded'+$index}}" ng-model="ruleSetRow.isIncluded" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.includeHead">
          </salaxy-input-boolean>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetEnabled'+$index}}" ng-model="ruleSetRow.enabled" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabledHead"></salaxy-input-boolean>
        </td>
        <td>
          <div ng-if="ruleSetRow.isIncluded">
            <button title="{{'SALAXY.UI_Terms.change' | sxyTranslate}}" ng-disabled="!ruleSetRow.isIncluded" class="btn btn-default btn-sm btn-block" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, false)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
            <salaxy-input name="{{'debitGrouping'+$index}}" placeholder="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.grouping" label-type="plain" ng-model="ruleSetRow.debitGrouping"></salaxy-input>
          </div>
        </td>
        <td>
          <div ng-if="ruleSetRow.isIncluded">
            <button title="{{'SALAXY.UI_Terms.change' | sxyTranslate}}" ng-disabled="!ruleSetRow.isIncluded" class="btn btn-default btn-sm btn-block" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, true)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
            <salaxy-input name="{{'creditGrouping'+$index}}" placeholder="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.grouping" label-type="plain" ng-model="ruleSetRow.creditGrouping"></salaxy-input>
          </div>
        </td>
        <td class="right">
          <button title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}" class="btn btn-danger btn-sm" type="button" ng-disabled="ruleSetRow.isReadOnly" ng-click="$ctrl.removeRow(ruleSetRow)" sxy-text="SALAXY.UI_Terms.deleteRow"></button>
        </td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="right">
          <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addRow(null)" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </td>
      </tr>
    </tbody>
  </table>
</div>`);

 $templateCache.put("salaxy-components/settings/AccountingTargetEditorRulesTable2.html",`<div class="table-responsive">
  <table class="table table-sm">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.debetHead"></th>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.creditHead"></th>
        <th></th>
        <th></th>
        <th class="right">
          <button ng-disabled="true" title="{{'SALAXY.UI_Terms.addRow'| sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addRow(null, true)" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat-start="(key, ruleSetGroup) in $ctrl.groupedRows" class="primary">
        <td ng-if="ruleSetGroup[0].isIncluded">
          <div>
            {{ $ctrl.getAccount(ruleSetGroup[0].debitId).account || ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.debitUndefined'| sxyTranslate) }}
            <span ng-if="ruleSetGroup[0].debitGrouping">
              <span>{{ ruleSetGroup[0].debitGrouping }}</span>
            <small style="text-decoration: line-through">{{ $ctrl.getAccount(ruleSetGroup[0].debitId).text }}</small>
            </span>
            <span ng-if="!ruleSetGroup[0].debitGrouping">
              <span>{{ $ctrl.getAccount(ruleSetGroup[0].debitId).text }}</span>
            </span>
          </div>
        </td>
        <td ng-if="ruleSetGroup[0].isIncluded">
          <div>
            {{ $ctrl.getAccount(ruleSetGroup[0].creditId).account || ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.creditUndefined'| sxyTranslate) }}
            <span ng-if="ruleSetGroup[0].creditGrouping">
              <span>{{ ruleSetGroup[0].creditGrouping }}</span>
            <small style="text-decoration: line-through">{{ $ctrl.getAccount(ruleSetGroup[0].creditId).text }}</small>
            </span>
            <span ng-if="!ruleSetGroup[0].creditGrouping">
              <span>{{ $ctrl.getAccount(ruleSetGroup[0].creditId).text }}</span>
            </span>
          </div>
        </td>
        <td colspan="2" ng-if="!ruleSetGroup[0].isIncluded" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></td>
        <td colspan="4"></td>
      </tr>
      <tr ng-repeat-start="ruleSetRow in ruleSetGroup">
        <td colspan="2">{{$ctrl.getEntryDescription(ruleSetRow)}}</td>
        <td>
          <div ng-repeat="flag in ruleSetRow.flags">
            <span class="badge" ng-class="$ctrl.getFlagText(flag).found ? 'bg-success' : 'bg-warning'">{{$ctrl.getFlagText(flag).text}}</span>
          </div>
        </td>
        <td>
          <div ng-class="{ 'text-danger': !ruleSetRow.enabled }">{{ ruleSetRow.enabled ? ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabled'| sxyTranslate) : ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.disabled'| sxyTranslate) }}</div>
        </td>
        <td class="right">
          <div class="btn-group">
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editRule' | sxyTranslate}}" class="btn btn-sm" ng-class="{ 'btn-primary': !ruleSetRow.isInEdit, 'btn-default': ruleSetRow.isInEdit }" type="button"
              ng-click="ruleSetRow.isInEdit=!ruleSetRow.isInEdit">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.copyAsNewRule' | sxyTranslate}}" class="btn btn-default btn-sm" type="button" ng-click="$ctrl.addRow(ruleSetRow)">
              <i class="bi bi-copy"></i>
            </button>
          </div>
        </td>
      </tr>
      <tr ng-repeat-end ng-if="ruleSetRow.isInEdit" class="no-border">
        <td>
          <div ng-if="!ruleSetRow.isIncluded">
            <small sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></small>
          </div>
          <div ng-if="ruleSetRow.isIncluded">
            <div class="input-group">
              <input type="text" class="form-control" ng-value="$ctrl.getAccount(ruleSetRow.debitId).account + ' ' + $ctrl.getAccount(ruleSetRow.debitId).text" disabled="true">
              <span class="input-group-btn">
                <button class="btn btn-default fixed-width-addon" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, false)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
              </span>
            </div>
            <div class="input-group">
              <input type="text" class="form-control" ng-init="ruleSetRow.debitGroupingTemp = ruleSetRow.debitGrouping" ng-model="ruleSetRow.debitGroupingTemp" placeholder="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.addGrouping' | sxyTranslate}}">
              <span class="input-group-btn">
                <button class="btn btn-default fixed-width-addon" type="button" ng-click="ruleSetRow.debitGrouping = ruleSetRow.debitGroupingTemp" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeGroupingBtn"></button>
              </span>
            </div>
          </div>
        </td>
        <td>
          <div ng-if="!ruleSetRow.isIncluded">
            <small sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></small>
          </div>
          <div ng-if="ruleSetRow.isIncluded">
            <div class="input-group">
              <input type="text" class="form-control" ng-value="$ctrl.getAccount(ruleSetRow.creditId).account + ' ' + $ctrl.getAccount(ruleSetRow.creditId).text" disabled="true">
              <span class="input-group-btn">
                <button class="btn btn-default fixed-width-addon" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, true)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
              </span>
            </div>
            <div class="input-group">
              <input type="text" class="form-control" ng-init="ruleSetRow.creditGroupingTemp = ruleSetRow.creditGrouping" ng-model="ruleSetRow.creditGroupingTemp" placeholder="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.addGrouping' | sxyTranslate}}">
              <span class="input-group-btn">
                <button class="btn btn-default fixed-width-addon" type="button" ng-click="ruleSetRow.creditGrouping = ruleSetRow.creditGroupingTemp" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeGroupingBtn"></button>
              </span>
            </div>
          </div>
        </td>
        <td>
          <button title="{{'SALAXY.UI_Terms.change' | sxyTranslate}}" class="btn btn-default fixed-width-button" type="button" ng-click="$ctrl.selectEntry(ruleSetRow)">
            <span sxy-text="SALAXY.UI_Terms.change"></span> {{ ruleSetRow.entryCodeGroup == 'incomeType' ? ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.incomeTypeBtnPS' | sxyTranslate) : ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.calcRowBtnPS' | sxyTranslate) }}
          </button>
          <button title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-default fixed-width-button" type="button" ng-click="$ctrl.selectFlags(ruleSetRow)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editAdditionalsBtn"></button>
        </td>
        <td>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetIsIncluded'+$index}}" ng-model="ruleSetRow.isIncluded" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.includeHead">
          </salaxy-input-boolean>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetEnabled'+$index}}" ng-model="ruleSetRow.enabled" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabledHead"></salaxy-input-boolean>
        </td>
        <td class="right">
          <button title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}" class="btn btn-danger btn-sm" ng-disabled="ruleSetRow.isReadOnly" type="button" ng-disabled="ruleSetRow.isReadOnly" ng-click="$ctrl.removeRow(ruleSetRow)" sxy-text="SALAXY.UI_Terms.deleteRow"></button>
        </td>
      </tr>
      <tr ng-repeat-end></tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="right">
          <button ng-disabled="true" title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addRow(null)" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </td>
      </tr>
    </tbody>
  </table>
</div>`);

 $templateCache.put("salaxy-components/settings/AccountingTargetEditorRulesTable3.html",`<div class="table-responsive">
  <table class="table table-sm">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.accountsHead"></th>
        <th></th>
        <th></th>
      </tr>
      <tr>
        <th></th>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.debetHead"></th>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.creditHead"></th>
        <th></th>
        <th class="right">
          <button ng-disabled="true" title="{{'SALAXY.UI_Terms.addRow'| sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addRow(null, true)" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat-start="account in $ctrl.current.ruleSet.accounts" class="primary">
        <td>
          {{account.account}} {{account.text}}
        </td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr ng-repeat-start="ruleSetRow in $ctrl.getRulesetByAccount(account, true)">
        <td></td>
        <td>
          {{$ctrl.getEntryDescription(ruleSetRow)}}
        </td>
        <td></td>
        <td></td>
        <td class="right">
          <div class="btn-group">
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editRule' | sxyTranslate}}" class="btn btn-sm" ng-class="{ 'btn-primary': !ruleSetRow.isInEdit, 'btn-default': ruleSetRow.isInEdit }" type="button"
              ng-click="ruleSetRow.isInEdit=!ruleSetRow.isInEdit">
                <i class="bi bi-pencil-square"></i>
              </button>
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.copyAsNewRule' | sxyTranslate}}" class="btn btn-default btn-sm" type="button" ng-click="$ctrl.addRow(ruleSetRow)">
                <i class="bi bi-copy"></i>
              </button>
          </div>
        </td>
      </tr>
      <tr ng-if="ruleSetRow.isInEdit">
        <td>
          <div ng-if="!ruleSetRow.isIncluded">
            <small sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></small>
          </div>
          <div ng-if="ruleSetRow.isIncluded">
            <div class="input-group">
              <input type="text" class="form-control" ng-value="$ctrl.getAccount(ruleSetRow.debitId).account + ' ' + $ctrl.getAccount(ruleSetRow.debitId).text" disabled="true">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, false)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
                </span>
            </div>
            <div class="input-group">
              <input type="text" class="form-control" ng-init="ruleSetRow.debitGroupingTemp = ruleSetRow.debitGrouping" ng-model="ruleSetRow.debitGroupingTemp" placeholder="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.addGrouping' | sxyTranslate}}">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="ruleSetRow.debitGrouping = ruleSetRow.debitGroupingTemp" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeGroupingBtn"></button>
                </span>
            </div>
          </div>
        </td>
        <td>
          <div ng-if="!ruleSetRow.isIncluded">
            <small sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></small>
          </div>
          <div ng-if="ruleSetRow.isIncluded">
            <div class="input-group">
              <input type="text" class="form-control" ng-value="$ctrl.getAccount(ruleSetRow.creditId).account + ' ' + $ctrl.getAccount(ruleSetRow.creditId).text" disabled="true">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, true)"  sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
                </span>
            </div>
            <div class="input-group">
              <input type="text" class="form-control" ng-init="ruleSetRow.creditGroupingTemp = ruleSetRow.creditGrouping" ng-model="ruleSetRow.creditGroupingTemp" placeholder="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.addGrouping' | sxyTranslate}}">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="ruleSetRow.creditGrouping = ruleSetRow.creditGroupingTemp" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeGroupingBtn"></button>
                </span>
            </div>
          </div>
        </td>
        <td></td>
        <td>
          <button title="{{'SALAXY.UI_Terms.change' | sxyTranslate}}" class="btn btn-default fixed-width-button" type="button" ng-click="$ctrl.selectEntry(ruleSetRow)">
            <span sxy-text="SALAXY.UI_Terms.change"></span> {{ ruleSetRow.entryCodeGroup == 'incomeType' ? ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.incomeTypeBtnPS' | sxyTranslate) : ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.calcRowBtnPS' | sxyTranslate) }}
            </button>
          <button title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-default fixed-width-button" type="button" ng-click="$ctrl.selectFlags(ruleSetRow)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editAdditionalsBtn"></button>
        </td>
        <td>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetIsIncluded'+$index}}" ng-model="ruleSetRow.isIncluded" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.includeHead">
          </salaxy-input-boolean>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetEnabled'+$index}}" ng-model="ruleSetRow.enabled" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabledHead"></salaxy-input-boolean>
          <button title="Poista rivi" ng-disabled="ruleSetRow.isReadOnly" class="btn btn-danger btn-sm" type="button" ng-click="$ctrl.removeRow(ruleSetRow)" sxy-text="SALAXY.UI_Terms.deleteRow"></button>
        </td>
      </tr>
      <tr ng-repeat-end></tr>
      <tr ng-repeat-start="ruleSetRow in $ctrl.getRulesetByAccount(account, false)">
        <td></td>
        <td></td>
        <td>
          {{$ctrl.getEntryDescription(ruleSetRow)}}
        </td>
        <td></td>
        <td class="right">
          <div class="btn-group">
            <button ng-disabled="$ctrl.isReadOnly" ttitle="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editRule' | sxyTranslate}}" class="btn btn-sm" ng-class="{ 'btn-primary': !ruleSetRow.isInEdit, 'btn-default': ruleSetRow.isInEdit }" type="button"
              ng-click="ruleSetRow.isInEdit=!ruleSetRow.isInEdit">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.copyAsNewRule' | sxyTranslate}}" class="btn btn-default btn-sm" type="button" ng-click="$ctrl.addRow(ruleSetRow)">
              <i class="bi bi-copy"></i>
            </button>
          </div>
        </td>
      </tr>
      <tr ng-if="ruleSetRow.isInEdit">
        <td>
          <div ng-if="!ruleSetRow.isIncluded">
            <small sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></small>
          </div>
          <div ng-if="ruleSetRow.isIncluded">
            <div class="input-group">
              <input type="text" class="form-control" ng-value="$ctrl.getAccount(ruleSetRow.debitId).account + ' ' + $ctrl.getAccount(ruleSetRow.debitId).text" disabled="true">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, false)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
                </span>
            </div>
            <div class="input-group">
              <input type="text" class="form-control" ng-init="ruleSetRow.debitGroupingTemp = ruleSetRow.debitGrouping" ng-model="ruleSetRow.debitGroupingTemp" placeholder="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.addGrouping' | sxyTranslate}}">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="ruleSetRow.debitGrouping = ruleSetRow.debitGroupingTemp" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeGroupingBtn"></button>
                </span>
            </div>
          </div>
        </td>
        <td>
          <div ng-if="!ruleSetRow.isIncluded">
            <small sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></small>
          </div>
          <div ng-if="ruleSetRow.isIncluded">
            <div class="input-group">
              <input type="text" class="form-control" ng-value="$ctrl.getAccount(ruleSetRow.creditId).account + ' ' + $ctrl.getAccount(ruleSetRow.creditId).text" disabled="true">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, true)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
                </span>
            </div>
            <div class="input-group">
              <input type="text" class="form-control" ng-init="ruleSetRow.creditGroupingTemp = ruleSetRow.creditGrouping" ng-model="ruleSetRow.creditGroupingTemp" placeholder="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.addGrouping' | sxyTranslate}}">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="ruleSetRow.creditGrouping = ruleSetRow.creditGroupingTemp" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeGroupingBtn"></button>
                </span>
            </div>
          </div>
        </td>
        <td>
          <button title="{{'SALAXY.UI_Terms.change' | sxyTranslate}}" class="btn btn-default fixed-width-button" type="button" ng-click="$ctrl.selectEntry(ruleSetRow)">
            <span sxy-text="SALAXY.UI_Terms.change"></span> {{ ruleSetRow.entryCodeGroup == 'incomeType' ? ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.incomeTypeBtnPS' | sxyTranslate) : ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.calcRowBtnPS' | sxyTranslate) }}
            </button>
          <button title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-default fixed-width-button" type="button" ng-click="$ctrl.selectFlags(ruleSetRow)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editAdditionalsBtn"></button>
        </td>
        <td>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetIsIncluded'+$index}}" ng-model="ruleSetRow.isIncluded" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.includeHead">
          </salaxy-input-boolean>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetEnabled'+$index}}" ng-model="ruleSetRow.enabled" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabledHead"></salaxy-input-boolean>
          <button title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}" ng-disabled="ruleSetRow.isReadOnly" class="btn btn-danger btn-sm" type="button" ng-click="$ctrl.removeRow(ruleSetRow)">
              Poista rivi
            </button>
        </td>
      </tr>
      <tr ng-repeat-end>

      </tr>
      <tr ng-repeat-end></tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="right">
          <button ng-disabled="true" title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addRow(null)" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </td>
      </tr>
    </tbody>
  </table>
</div>`);

 $templateCache.put("salaxy-components/settings/AccountingTargetSettings.html",`<div class="content settings" ng-if="$ctrl.current">
  <div class="card accounting-target-settings card-default">
    <sxy-form open-api="salaxy-secure/schemas/v02.json" type="CompanyAccountSettings" auto-gen="false" debugger="false" model="$ctrl.current">
      <div class="card-header icon-card">
        <h2 sxy-text="SALAXY.NG1.AccountingTargetSettings.title"></h2>
        <p ng-if="!(!$ctrl.current.accounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.accounting)"><small sxy-text="SALAXY.NG1.AccountingTargetSettings.intro"></small></p>
      </div>
      <div class="card-body">
        <fieldset>
          <legend><span sxy-text="SALAXY.NG1.AccountingTargetSettings.accountingLegend"></span></legend>
          <salaxy-input-typeahead name="options_type" ng-model="$ctrl.current.accounting.defaultTargetId" options="$ctrl.getSelectableAccountingTargets()"
            disable-cache="true" label="SALAXY.NG1.AccountingTargetSettings.defaultTarget"></salaxy-input-typeahead>
          <sxy-input template-url="salaxy-components/sxy-form/custom-templates/array-accounting-targets.html" model="form.accounting.targets" read-only="{{!$ctrl.current.accounting.denyServiceModel && $ctrl.current.partner.serviceModel.features.accounting}}">
            <form>
              <fieldset ng-show="!$ctrl.logic.showDelete" ng-controller="CompanySettingsController as $companySettingsCtrl" ng-init="$ctrl.logic.isReadOnly = true">
                <salaxy-odata-table  crud-controller="AccountingTargetCrudController as $crud" template-url="salaxy-components/odata/lists/AccountingTargetSelect.html" selected-items="$ctrl.selectedItems" on-list-select="$companySettingsCtrl.onAccountingTargetSelect($ctrl.current, $ctrl.logic, value, item, allItems)">
                </salaxy-odata-table>
              </fieldset>
              <fieldset ng-show="$ctrl.logic.showDelete" ng-init="$ctrl.logic.isReadOnly = false">
                <salaxy-input-enum disabled="false" name="format" label="SALAXY.NG1.AccountingTargetDetailsComponent.excelCsvFormat" ng-model="$ctrl.current.format"
                options="{
                  '36dff2e2-e181-4f0d-9004-0e4aa92f5e17': 'Palkkaus.fi',
                  '0db4e85f-93a8-46f1-b6d2-f7523d289d88': 'Fennoa',
                  '8613f133-3fce-4611-b372-51f6a2e007dd': 'Procountor',
                  'e62c10b0-222a-4170-b8b4-b1e02d9a7644': 'Passeli Merit',
                  '53fd3863-b8f9-4909-86c9-cb4597595181': 'Heeros',
                  '2fc7899c-7a3d-4d56-ad2f-05d52782bbbc': 'Asteri',
                  '0a2bd312-06da-4862-aef5-75166e0bf461': 'Maestro',
                  'c04e0757-63f3-420d-a183-3427710fc954': 'Visma Fivaldi',
                  'ba271dac-dd63-4036-9d70-053a09ca4d9e' :'Visma Netvisor',
                  '27e271d5-41f5-4319-ab29-4d5d9eb945c6': 'Lemonsoft',
                  'd311f9d3-8c3a-4fd8-a665-8e3698e41e87': 'Tampuuri',
                  'd58e95b7-d0b5-40ac-992b-6d3b29efc45e': 'Domus',
                  '54e93c5f-bd74-4157-8a74-3515be7f585d': 'Oscar Software',
                  '0e4f0a71-dcb9-43ba-9028-0239e674711f': 'Digia Enterprise',
                  '2ccefa46-7992-46c5-9d87-b88336935916': 'Digia Enterprise - VILPE',
                  'c36c24b9-5e2c-4f44-b67a-90d81aeea257': 'iScala'
                }">
                </salaxy-input-enum>
                <sxy-input model="form.method" read-only="false"></sxy-input>
                <salaxy-input-enum disabled="false" enum="ExportMethod" label="SALAXY.MODEL.AccountingTargetSettings.availableMethods.title" name="availableMethods" type="multi-select" ng-model="$ctrl.current.availableMethods"></salaxy-input-enum>
              </fieldset>
            </form>
          </sxy-input>
          <sxy-input model="form.accounting.defaultPeriodDateKind" read-only="{{!$ctrl.current.accounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.accounting}}"></sxy-input>
        </fieldset>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-12 text-end">
            <button class="btn btn-primary" ng-click="$ctrl.save('all')" ng-disabled="$ctrl.isSaving('all')"><span ng-if="$ctrl.isSaving('all')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
          </div>
        </div>
      </div>
    </sxy-form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/CostAccountingSettings.html",`<div class="content settings" ng-if="$ctrl.current">
  <div class="card mb-4 costAccounting card-secondary">
    <div>
      <div class="card-header">
        <h2 sxy-text="SALAXY.MODEL.CostAccountingSettings.title"></h2>
        <p><small sxy-text="SALAXY.MODEL.CostAccountingSettings.descr"></small></p>
      </div>
      <div class="card-body">
        <div class="row">

          <sxy-form open-api="salaxy-secure/schemas/v02.json" type="CompanyAccountSettings" auto-gen="false" debugger="false" model="$ctrl.current"
            read-only="{{(!$ctrl.current.costAccounting.denyServiceModel && $ctrl.current.partner.serviceModel.features.costAccounting) || $ctrl.isReadOnlyForced}}">
            
            <div class="col form-horizontal">
              
              <sxy-input model="form.costAccounting.dimensions" include="id,label,scope">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.CostAccountingDimensionDefinition.title"></legend>
                    <sxy-input model="form.id" read-only="{{$ctrl.logic.showDelete}}"></sxy-input>
                    <sxy-input model="form.label"></sxy-input>
                    <sxy-input model="form.allowCostSharing"></sxy-input>
                    <sxy-input model="form.scope"></sxy-input>
                    <sxy-input model="form.options" template-url="salaxy-components/sxy-form/custom-templates/cost-accounting-options.html"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input> 
              
            </div>
          </sxy-form>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col">
            <button type="submit" ng-disabled="(!$ctrl.current.costAccounting.denyServiceModel && $ctrl.current.partner.serviceModel.features.costAccounting) ||$ctrl.isSaving('all')" class="btn btn-primary float-end" ng-click="$ctrl.save('all')"><span ng-if="$ctrl.isSaving('all')"><i
                  class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/HolidaySettings.html",`<div class="content settings" ng-if="$ctrl.current">
  <div class="card mb-4 accounting card-secondary">
    <div>
      <div class="card-header icon-card">
        <h2 sxy-text="SALAXY.MODEL.HolidaySettings.title"></h2>
      </div>
      <div class="card-body">
        <div class="row">
          <sxy-form ng-ref="$frm" open-api="salaxy-secure/schemas/v02.json" type="CompanyAccountSettings" auto-gen="false" debugger="false" model="$ctrl.current" read-only="{{!$ctrl.current.holiday.denyServiceModel  && $ctrl.current.partner.serviceModel.features.holiday}}">
            <div>
              <sxy-input model="form.partner.serviceModel.features.holiday" label="SALAXY.NG1.ProSettingsComponent.customHoliday" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc6" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.holiday" ng-model="$ctrl.current.holiday.denyServiceModel"></salaxy-input-boolean>
              <sxy-input model="form.holiday.holidayPaySettings"
                read-only="{{!$ctrl.current.holiday.denyServiceModel  && $ctrl.current.partner.serviceModel.features.holiday }}" include="holidayPayCalculation">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.HolidayPaySettings.title"></legend>
                    <salaxy-input-enum ng-show="!('bizConfigs' | sxyIsInRole)" enum="HolidayPayCalculation" label="SALAXY.MODEL.HolidayPaySettings.holidayPayCalculation.title" name="holidayPayCalculation" filter="averageDailyPay,averageHourlyPay,percentageBasedPay,holidayCompensation" require="true" ng-model="$ctrl.current.holidayPayCalculation" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                    <salaxy-input-enum ng-show="'bizConfigs' | sxyIsInRole" enum="HolidayPayCalculation" label="SALAXY.MODEL.HolidayPaySettings.holidayPayCalculation.title" name="holidayPayCalculation" filter="averageDailyPay,averageHourlyPay,percentageBasedPay,holidayCompensation,scriptPay" require="true" ng-model="$ctrl.current.holidayPayCalculation" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                    <salaxy-input-collective-bargain-agreement ng-show="'bizConfigs' | sxyIsInRole" name="cbaCode" ng-model="$ctrl.current.cbaCode" label="SALAXY.MODEL.HolidayPaySettings.cbaCode.title"></salaxy-input-collective-bargain-agreement>
                    <salaxy-input-employee-group ng-show="'bizConfigs' | sxyIsInRole" name="employeeGroup" ng-model="$ctrl.current.employeeGroup" label="SALAXY.MODEL.HolidayPaySettings.employeeGroup.title"></salaxy-input-employee-group>
                    <sxy-input model="form.disabled"></sxy-input>
                    <sxy-input model="form.startYear" label="SALAXY.MODEL.HolidayPaySettings.startYear.title"></sxy-input>  
                    <sxy-input model="form.endYear" label="SALAXY.MODEL.HolidayPaySettings.endYear.title"></sxy-input>                   
                    <legend ng-show="$ctrl.current.holidayPayCalculation && $ctrl.current.holidayPayCalculation != 'scriptPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.salaryTypes.title"></legend>
                    <sxy-input  ng-show="$ctrl.current.holidayPayCalculation && $ctrl.current.holidayPayCalculation != 'scriptPay'" model="form.salaryTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.workingTimeTypes.title"></legend>
                    <sxy-input ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay'" model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.overtimeTypes.title"></legend>
                    <sxy-input  ng-show="$ctrl.current.holidayPayCalculation == 'averageDailyPay'" model="form.overtimeTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay' || $ctrl.current.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.multipliers.title"></legend>
                    <salaxy-input-holiday-multipliers ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay' || $ctrl.current.holidayPayCalculation == 'averageDailyPay'" name="multipliers" label="SALAXY.MODEL.HolidayPaySettings.multipliers.title" ng-model="$ctrl.current.multipliers" read-only="$ctrl.logic.isReadOnly"></salaxy-input-holiday-multipliers>
                    <sxy-code-editor ng-show="$ctrl.current.holidayPayCalculation == 'scriptPay'" ng-model="$ctrl.current.script"></sxy-code-editor>
                  </fieldset>
                </form>
              </sxy-input>
              <sxy-input model="form.holiday.holidayAccrualSettings"
                read-only="{{!$ctrl.current.holiday.denyServiceModel  && $ctrl.current.partner.serviceModel.features.holiday }}" include="code">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.HolidayAccrualSettings.title"></legend>
                    <salaxy-input-enum ng-show="!('bizConfigs' | sxyIsInRole)" enum="HolidayCode" label="SALAXY.MODEL.HolidayAccrualSettings.code.title" name="code" filter="permanent35Hours" require="true" ng-model="$ctrl.current.code" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                    <salaxy-input-enum  ng-show="'bizConfigs' | sxyIsInRole" enum="HolidayCode" label="SALAXY.MODEL.HolidayAccrualSettings.code.title" name="code" filter="permanent35Hours,script" require="true" ng-model="$ctrl.current.code" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                    <salaxy-input-collective-bargain-agreement ng-show="'bizConfigs' | sxyIsInRole" name="cbaCode" ng-model="$ctrl.current.cbaCode" label="SALAXY.MODEL.HolidayAccrualSettings.cbaCode.title"></salaxy-input-collective-bargain-agreement>
                    <salaxy-input-employee-group ng-show="'bizConfigs' | sxyIsInRole" name="employeeGroup" ng-model="$ctrl.current.employeeGroup" label="SALAXY.MODEL.HolidayAccrualSettings.employeeGroup.title"></salaxy-input-employee-group>
                    <sxy-input model="form.disabled"></sxy-input>
                    <sxy-input model="form.startYear" label="SALAXY.MODEL.HolidayAccrualSettings.startYear.title"></sxy-input>  
                    <sxy-input model="form.endYear" label="SALAXY.MODEL.HolidayAccrualSettings.endYear.title"></sxy-input>  
                    <legend ng-show="$ctrl.current.code == 'permanent35Hours'" sxy-text="SALAXY.MODEL.HolidayAccrualSettings.workingTimeTypes.title"></legend>
                    <sxy-input ng-show="$ctrl.current.code == 'permanent35Hours'" model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                    <sxy-code-editor  ng-show="$ctrl.current.code == 'script'" ng-model="$ctrl.current.script"></sxy-code-editor>
                  </fieldset>
                </form>
              </sxy-input>
            </div>
           
          </sxy-form>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-xs-12">
            <button type="submit" ng-disabled="(!$ctrl.current.holiday.denyServiceModel && $ctrl.current.partner.serviceModel.features.holiday) || !$frm.ngForm.$valid || $ctrl.isSaving('all')" class="btn btn-primary pull-right" ng-click="$ctrl.save('all')">
              <span ng-if="$ctrl.isSaving('all')"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span sxy-text="SALAXY.UI_Terms.save"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/Insurances.html",`<div class="content settings" ng-if="$ctrl.current" ng-controller="VarmaBannerController as $varma">
  <div class="card pension card-secondary my-4" ng-repeat="item in $ctrl.pensionContracts" ng-if="$ctrl.sections.indexOf('pensionContracts') >= 0 && $ctrl.isVisibleContract(item, $ctrl.pensionContracts)">
    <form name="pensionForm" class="pension-form" ng-readonly="$ctrl.isReadOnlyForced">
      <div class="card-header d-flex">
        <div class="flex-grow-1 pe-5">
          <h2 sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.title"></h2>
          <p><small sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.description"></small></p>
        </div>
        <i class="bi bi-check-circle-fill text-success status-icon fs-1 d-block"></i>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6 col-12">
            <div class="form-horizontal">
              <fieldset>
                <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.currentContractLegend"></legend>
                <salaxy-input-enum ng-model="item.company" type="select" label="SALAXY.MODEL.PensionContract.company.editLabel" name="pensionCompany" enum="PensionCompany" filter="none,varma,elo,ilmarinen,veritas,apteekkien,verso,valio,kevaMunicipal,kevaAland,kevaChurch,kevaKela,kevaState" require="true" ng-change="item.contractNumber = null"></salaxy-input-enum>
                <main salaxy-if-role="test" class="test-number">
                  <div class="form-group" ng-if="item.company && item.company != 'none'">
                    <div class="col-sm-8 offset-sm-4 text-sm-end">
                      <span>Test only: <button class="btn btn-secondary btn-xs" ng-click="$ctrl.setPensionNumberForTest(item)"> Generoi numero </button></span>
                    </div>
                  </div>
                </main>
                <salaxy-input ng-if="item.company && item.company != 'none'" require="true" name="pensionContractNumber" label="SALAXY.MODEL.PensionContract.contractNumber.title" ng-model="item.contractNumber" tooltip-html="{{'SALAXY.NG1.InsuranceSettingsComponent.pension.errors.sxyPensionContractNumber.html' | sxyTranslate}}"
                  tooltip-placement="right" sxy-pension-contract-number="item.company"></salaxy-input>
                <div class="row" ng-show="pensionForm.pensionContractNumber.$error.sxyTemporaryPensionContractNumber">
                  <div class="col-12 offset-sm-4 input-info text-danger">
                    <div class="input-info-icon"><i class="bi bi-exclamation-triangle-fill"></i></div>
                    <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.InsuranceSettingsComponent.pension.errors.sxyTemporaryPensionContractNumber.html"></p>
                  </div>
                </div>
                <salaxy-input-number disabled="true" ng-if="(item.company && item.company != 'none')" unit="percent" ng-model="item.pensionDefaultPercent" name="pensionDefaultPercent" label="SALAXY.MODEL.PensionContract.pensionDefaultPercent.title"></salaxy-input-number>
                <salaxy-input-number disabled="!('admin,pro' | sxyIsInRole)" ng-if="(item.company && item.company != 'none') && (('admin,pro' | sxyIsInRole) || item.pensionPercent)" unit="percent" ng-model="item.pensionPercent" name="pensionPercent" label="SALAXY.MODEL.PensionContract.pensionPercent.title"></salaxy-input-number>
              </fieldset>
            </div>
          </div>
          <div class="col-sm-6 col-12" ng-show="item.company && item.company != 'none' && item.company != 'varma'">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.moveContractLegend"></legend>
              <p sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.moveContractDescription"></p>
              <div>
                <a ng-href="{{$varma.getVarmaShopLink()}}" target="_blank" class="btn btn-primary" sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.moveContractCta"></a>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-12" ng-show="!item.company || item.company == 'none'">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.varmaLegend"></legend>
              <p sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.varmaDescription"></p>
              <div>
                <a ng-href="{{$varma.getVarmaShopLink()}}" target="_blank" class="btn btn-primary" sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.varmaCta"></a>
              </div>
            </fieldset>
          </div>
          <div class="col-sm-6 col-12" ng-show="!item.company || item.company == 'none'">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.temporaryLegend"></legend>
              <p sxy-html="SALAXY.NG1.InsuranceSettingsComponent.pension.temporaryDescription.html"></p>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-12">
            <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="!item.company || pensionForm.$invalid || $ctrl.isSaving('pensionContracts')" class="btn btn-primary float-end" ng-click="$ctrl.save('pensionContracts')"><span ng-if="$ctrl.isSaving('pensionContracts')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="card pension yel-pension card-secondary mb-4" ng-if="$ctrl.sections.indexOf('yelPensionContracts') >= 0">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.InsuranceSettingsComponent.yelPension.title"></h2>
    </div>
    <div class="card-body">
      <p sxy-text="SALAXY.NG1.InsuranceSettingsComponent.yelPension.description"></p>
    </div>
    <div class="card-footer text-end">
      <a class="btn btn-primary" ng-href="{{$varma.getVarmaShopLink()}}" target="_blank" sxy-text="SALAXY.NG1.InsuranceSettingsComponent.yelPension.takeInsuranceBtn"></a>
    </div>
  </div>
  <div class="card insurance card-secondary mb-4" ng-repeat="item in $ctrl.insuranceContracts" ng-if="$ctrl.sections.indexOf('insuranceContracts') >= 0 && $ctrl.isVisibleContract(item, $ctrl.insuranceContracts)">
    <form ng-if="item.status != 'pending'" name="insuranceForm" class="insurance-form" ng-readonly="$ctrl.isReadOnlyForced">
      <div class="card-header d-flex">
        <div class="flex-grow-1 pe-5">
          <h2 sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.title"></h2>
          <p><small sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.description"></small></p>
        </div>
        <i class="bi bi-check-circle-fill text-success status-icon fs-1 d-block"></i>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6 col-12">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.currentContractLegend"></legend>
              <div class="form-horizontal">
                <salaxy-input-enum ng-model="item.company" type="select" enum="InsuranceCompany" filter="none,fennia,if,lähiTapiola,pohjantähti,pohjola,turva,aVakuutus,folksam,alandia,ålands,protector" label="SALAXY.MODEL.InsuranceContract.company.editLabel" name="insurance-company"
                  require="true"></salaxy-input-enum>
              </div>
              <div class="form-horizontal" ng-if="item.company && item.company != 'none'">
                <salaxy-input ng-model="item.contractNumber" require="true" name="insuranceContractNumber" label="SALAXY.MODEL.InsuranceContract.contractNumber.title"></salaxy-input>
              </div>
              <div class="form-horizontal" ng-if="item.company">
                <salaxy-input-number unit="percent" tooltip-html="{{'SALAXY.MODEL.InsuranceContract.insurancePercent.descr' | sxyTranslate}}" ng-model="item.insurancePercent" name="insurancePercent" label="SALAXY.MODEL.InsuranceContract.insurancePercent.title"></salaxy-input-number>
              </div>
              <div class="form-horizontal" ng-if="item.company">
                <salaxy-input-number unit="percent" tooltip-html="{{'SALAXY.MODEL.InsuranceContract.groupLifeInsurancePercent.descr' | sxyTranslate}}" ng-model="item.groupLifeInsurancePercent" name="groupLifeInsurancePercent" label="SALAXY.MODEL.InsuranceContract.groupLifeInsurancePercent.title"></salaxy-input-number>
              </div>
            </fieldset>
          </div>
          <div class="col-sm-6 col-12" ng-if="!$ctrl.isReadOnlyForced">
            <fieldset ng-show="item.company && item.company != 'lähiTapiola' && item.company != 'none' ">
              <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.moveToLocalTapiolaLegend"></legend>
              <div ng-controller="InsuranceWizardController as insuranceCtrl">
                <button class="btn btn-primary" ng-click="insuranceCtrl.openModal();" sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.moveToLocalTapiolaBtn"></button>
              </div>
            </fieldset>
            <fieldset ng-if="item.company == 'none' || !item.company">
              <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.takeFromLocalTapiolaLegend"></legend>
              <div ng-controller="InsuranceWizardController as insuranceCtrl">
                <button class="btn btn-primary" ng-click="insuranceCtrl.openModal();" sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.takeFromLocalTapiolaBtn"></button>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="row" style="margin-top:10px;">
          <div class="col-12 settings-alert">
            <div ng-if="item.company && item.company != 'none'">
              <div class="float-start">
                <i class="bi bi-info-circle-fill alert-icon text-info icon-info"></i>
              </div>
              <div class="alert-text">
                <p class="text-info " sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.insuranceComment"></p>
              </div>
            </div>
            <div ng-if="item.company == 'none'">
              <div class="float-start">
                <i class="bi bi-exclamation-lg alert-icon d-flex align-items-center justify-content-center text-danger icon-danger"></i>
              </div>
              <div class="alert-text">
                <p class="text-danger" sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.warning"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-12">
            <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="!item.company || $ctrl.isSaving('insuranceContracts')" class="btn btn-primary float-end" ng-click="$ctrl.save('insuranceContracts')"><span ng-if="$ctrl.isSaving('insuranceContracts')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/IrDeliverySettings.html",`<div class="content settings" ng-if="$ctrl.current">
  <div class="card ir-delivery card-secondary mb-4">
    <div class="card-header icon-card">
      <h2 sxy-text="Tulorekisteriraportoinnissa käytettävä varmenne"></h2>
    </div>
    <div class="card-body">
      <div class="row">
        <ng-form name="$frmDelivery" class="form-horizontal">
          <div>
            <fieldset>
              <legend>Tulorekisterivarmenteen omistaja</legend>
              <p
                sxy-text="Jos haluat käyttää tilitoimistovarmennetta Palkkaus.fi:n varmenteen sijasta, anna käytettävän varmenteen Y-tunnus.">
              </p>
              <salaxy-input label="Tulorekisterivarmenteen omistajan Y-tunnus" name="senderOfficialId"
                ng-model="$ctrl.current.calc.incomesRegister.irDelivery.senderOfficialId"></salaxy-input>
            </fieldset>
            <fieldset>
              <legend>Tulorekisteriraportin yhteyshenkilöt</legend>
              <table class="table">
                <thead>
                  <tr>
                    <th>{{('Nimi') | sxyTranslate}}</th>
                    <th>{{('Puhelin') | sxyTranslate}}</th>
                    <th>{{('Sähköposti') | sxyTranslate}}</th>
                    <th>{{('Vastuualue') | sxyTranslate}}</th>
                    <th class="right">
                      <button type="button" class="btn btn-primary btn-xs"
                        ng-click="$ctrl.current.calc.incomesRegister.irDelivery.contactPersons.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr ng-repeat="item in $ctrl.current.calc.incomesRegister.irDelivery.contactPersons">
                    <td>
                      <salaxy-input require="true" ng-model="item.name" name="{{ 'name' + $index }}" label-type="plain"></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input require="true" ng-model="item.telephone" name="{{ 'telephone' + $index }}" label-type="plain" sxy-mobile-phone></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input require="true" ng-model="item.email" name="{{ 'email' + $index }}" label-type="plain" sxy-email></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input-enum require="true" ng-model="item.responsibilityCode" name="{{ 'responsibilityCode' + $index }}" label-type="plain" type="select"
                        options="{ contentIssues: 'Raporttien sisältö', technicalIssues: 'Tekniset asiat' }"></salaxy-input-enum>
                    </td>
                    <td class="text-right">
                      <button type="button" class="btn btn-danger" ng-click="$ctrl.current.calc.incomesRegister.irDelivery.contactPersons.splice($index, 1)">
                        <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
          </div>
        </ng-form>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-xs-12 text-right">
          <button type="submit" ng-disabled="!$frmDelivery.$valid || ($ctrl.current.calc.incomesRegister.irDelivery.senderOfficialId && !$ctrl.current.calc.incomesRegister.irDelivery.contactPersons[0].responsibilityCode ) || $ctrl.isSaving('all')"
            class="btn btn-primary" ng-click="$ctrl.save('all')">
            <span ng-if="$ctrl.isSaving('all')"><i class="bi bi-arrow-repeat bi-spin"></i></span>
            <span sxy-text="SALAXY.UI_Terms.save"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card ir-certificate-actions card-secondary" ng-if="$ctrl.hasOwnIrCertificate()">
    <div class="card-header icon-card">
      <h2 sxy-text="Tulorekisterivarmenteen luonti/uusinta"></h2>
    </div>
    <div class="card-body">
      <div class="row">
        <ng-form name="$frmCert" class="form-horizontal">
          <div>
              <legend>Yrityksesi tulorekisterivarmenteen tila</legend>
              <table class="table">
                <tr>
                  <th>Luotu</th>
                  <th>Voimassaolo päättyy</th>
                </tr>
                <tr ng-if="!$ctrl.irCertificate.id">
                  <td colspan="2">Ei voimassa olevaa varmennetta</td>
                </tr>
                <tr ng-if="$ctrl.irCertificate.id">
                  <td>{{$ctrl.irCertificate.updatedAt | date}}</td>
                  <td>{{$ctrl.irCertificate.expiresAt | date}}</td>
                </tr>
              </table>
            </fieldset>
            <fieldset>
              <legend>Varmenteen luonti/uusinta</legend>
              <salaxy-input-enum ng-if="$ctrl.irCertificate.id" ng-init="$ctrl.irCertificateAction = 'renew'" label="Toimenpide" ng-model="$ctrl.irCertificateAction" name="certAction" type="radio"
                options="{ create: 'Luo uusi varmenne', renew: 'Uusi nykyinen varmenne' }"></salaxy-input-enum>
              <salaxy-input-enum ng-if="!$ctrl.irCertificate.id" ng-init="$ctrl.irCertificateAction = 'create'" label="Toimenpide" ng-model="$ctrl.irCertificateAction" name="certAction" type="radio"
                options="{ create: 'Luo uusi varmenne'}"></salaxy-input-enum>
              <salaxy-input ng-if="$ctrl.irCertificateAction == 'create'" require="true" label="Siirtotunnus" ng-model="$ctrl.irCertificateTransferId"
                name="transferId"></salaxy-input>
              <salaxy-input ng-if="$ctrl.irCertificateAction == 'create'" require="true" label="Kertakäyttösalasana" ng-model="$ctrl.irCertificateTransferPassword"
                name="transferPassword" type="password"></salaxy-input>
            </fieldset>
          </div>
        </ng-form>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-xs-12 text-right">
          <button type="button" ng-if="$ctrl.irCertificateAction == 'create'" class="btn btn-primary" ng-disabled="$ctrl.isSaving('irCertificate') || !$frmCert.$valid"
            ng-click="$ctrl.createIrCertificate($ctrl.irCertificateTransferId, $ctrl.irCertificateTransferPassword)"><span ng-if="$ctrl.isSaving('irCertificate')"><i
                class="bi bi-arrow-repeat bi-spin"></i></span><span sxy-text="Luo uusi varmenne"></span></button>
          <button type="button" ng-if="$ctrl.irCertificateAction == 'renew'" class="btn btn-primary" ng-disabled="$ctrl.isSaving('irCertificate')  || !$frmCert.$valid"
            ng-click="$ctrl.renewIrCertificate()"><span ng-if="$ctrl.isSaving('irCertificate')"><i class="bi bi-arrow-repeat bi-spin"></i></span><span
              sxy-text="Uusi nykyinen varmenne"></span></button>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/OwnerSettings.html",`<div class="salaxy-component salaxy-owner-settings">

  <style>
    @media print {
      salaxy-tab {
        display: none !important;
      }
    }
  </style>
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'default', text: 'SALAXY.NG1.OwnerSettingsComponent.tabs.editing' },
      { value: 'beneficiaries', text: 'SALAXY.NG1.OwnerSettingsComponent.tabs.beneficiaries' },
      { value: 'printable', text: 'SALAXY.NG1.OwnerSettingsComponent.tabs.printable' }
    ]"
    tabs-id="ownerSettings">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-ownerSettings">
    <div class="tab-pane" id="default-tab">
      <form class="form-horizontal" ng-if="$ctrl.current" ng-readonly="$ctrl.isReadOnlyForced">
        <div class="row">
          <div class="col-12">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.OwnerSettingsComponent.shareAmountTitle"></legend>
              <div class="row">
                <div class="col-md-6">
                  <salaxy-input-enum type="radio" options="{ byPercent: ('SALAXY.NG1.OwnerSettingsComponent.byPercent' | sxyTranslate), byAmount: ('SALAXY.NG1.OwnerSettingsComponent.byAmount' | sxyTranslate)}" ng-model="$ctrl.mode" name="editMode" label="SALAXY.NG1.OwnerSettingsComponent.sharesBy"
                    label-cols="col-md-6"></salaxy-input-enum>
                </div>
                <div class="col-md-6">
                  <salaxy-input-number ng-model="$ctrl.current.ownedCompanyDetails.totalNumberOfShares" name="numberOfShares" label="SALAXY.NG1.OwnerSettingsComponent.shareAmount" label-cols="col-md-6" ng-change="$ctrl.recalculateShares()"></salaxy-input-number>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <fieldset>
          <legend sxy-text="SALAXY.NG1.OwnerSettingsComponent.ownerInfoTitle"></legend>
          <div ng-if="!$ctrl.current.owners.length" class="salaxy-placeholder-empty placeholder-md placeholder-default text-center">
            <h4 sxy-text="SALAXY.NG1.OwnerSettingsComponent.noOwnersTitle"></h4>
            <p></p>
            <button class="btn btn-primary" ng-click="$ctrl.current.owners.push({numberOfShares:0,percentOfShares:0, avatar:{}});" ng-disabled="!$ctrl.mode" sxy-text="SALAXY.NG1.OwnerSettingsComponent.addOwnerBtn"></button>
          </div>
          <div class="row" ng-repeat="owner in $ctrl.current.owners">
            <div class="col-md-6">
              <salaxy-input ng-model="owner.avatar.displayName" name="ownerName{{$index}}" label="SALAXY.NG1.OwnerSettingsComponent.ownerName" label-type="basic"></salaxy-input>
            </div>
            <div class="col-md-3">
              <salaxy-input ng-model="owner.officialId" name="officialId{{$index}}" label="SALAXY.NG1.OwnerSettingsComponent.ownerOfficialId" label-type="basic"></salaxy-input>
            </div>
            <div class="col-md-3">
              <salaxy-input ng-model="owner.email" name="email{{$index}}" label="SALAXY.NG1.OwnerSettingsComponent.ownerEmail" label-type="basic" sxy-email></salaxy-input>
            </div>
            <div class="col-md-6">
              <salaxy-input ng-model="owner.address" name="address{{$index}}" label="SALAXY.NG1.OwnerSettingsComponent.ownerAddress" label-type="basic"></salaxy-input>
            </div>
            <div class="col-md-3 col-5">
              <salaxy-input-number ng-model="owner.numberOfShares" name="ownerShare{{$index}}" label="SALAXY.NG1.OwnerSettingsComponent.ownerShareAmount" label-type="basic" read-only="$ctrl.mode == 'byPercent' || $ctrl.isReadOnlyForced" ng-change="$ctrl.recalculateShares()"></salaxy-input-number>
            </div>
            <div class="col-md-2 col-5">
              <salaxy-input-number ng-model="owner.percentOfShares" name="ownerpercentOfShares{{$index}}" label="SALAXY.NG1.OwnerSettingsComponent.ownerSharePercent" label-type="basic" read-only="$ctrl.mode == 'byAmount' || $ctrl.isReadOnlyForced" ng-change="$ctrl.recalculateShares()"></salaxy-input-number>
            </div>
            <div class="col-md-1 col-2 text-end" style="padding-top:39px">
              <button ng-if="!$ctrl.isReadOnlyForced" class="btn btn-danger btn-sm" ng-click="$ctrl.current.owners.splice($index,1)" title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}"><i class="bi bi-trash-fill"></i></button>
            </div>
            <div class="col-12">
              <hr>
            </div>
          </div>
          <div class="row total-row" ng-if="$ctrl.current.owners.length">
            <div class="col-6">
              <strong sxy-text="SALAXY.NG1.OwnerSettingsComponent.totalShares"></strong>
            </div>
            <div class="col-6 text-end" ng-if="$ctrl.mode == 'byAmount'" ng-class="{'text-danger' : $ctrl.getTotalAmount() > $ctrl.current.ownedCompanyDetails.totalNumberOfShares, 'text-warning' : $ctrl.getTotalAmount() < $ctrl.current.ownedCompanyDetails.totalNumberOfShares && $ctrl.getTotalAmount() > 0, 'text-success' : $ctrl.getTotalAmount() == $ctrl.current.ownedCompanyDetails.totalNumberOfShares}">
              <strong>{{$ctrl.getTotalAmount()}} / {{$ctrl.current.ownedCompanyDetails.totalNumberOfShares}} <span sxy-text="SALAXY.UI_Terms.units.pce"></span></strong>
            </div>
            <div class="col-6 text-end" ng-if="$ctrl.mode != 'byAmount'" ng-class="{'text-danger' : $ctrl.getTotalPercent() > 100, 'text-warning' : $ctrl.getTotalPercent() < 100 && $ctrl.getTotalPercent() > 0, 'text-success' : $ctrl.getTotalPercent() == 100}">
              <strong>{{$ctrl.getTotalPercent()}} / 100 %</strong>
            </div>
            <div class="col-12">
              <hr>
            </div>
          </div>
          <div class="row" ng-if="$ctrl.current.owners.length && !$ctrl.isReadOnlyForced">
            <div class="col-6">
              <button class="btn btn-secondary btn-sm" ng-click="$ctrl.current.owners.push({numberOfShares:0,percentOfShares:0, avatar: {}})"><i class="bi bi-plus-lg" style="margin-right:5px"></i><span sxy-text="SALAXY.NG1.OwnerSettingsComponent.addOwnerBtn"></span></button>
            </div>
            <div class="col-6 text-end">
              <button class="btn btn-primary btn-sm" ng-click="$ctrl.save('owners')" ng-disabled="$ctrl.isSaving('owners')"><span ng-if="$ctrl.isSaving('owners')"><i
                class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
            </div>
          </div>
        </fieldset>
      </form>
    </div> 
    <div class="tab-pane" id="beneficiaries-tab">
      <form class="form-horizontal" ng-if="$ctrl.current" ng-readonly="$ctrl.isReadOnlyForced">
        <fieldset>
          <legend sxy-text="SALAXY.NG1.OwnerSettingsComponent.beneficiariesInfoTitle"></legend>
          <div ng-if="!$ctrl.current.beneficiaries.length" class="salaxy-placeholder-empty placeholder-md placeholder-default text-center">
            <h4 sxy-title="SALAXY.NG1.OwnerSettingsComponent.noBeneficiariesTitle">Edunsaajat</h4>
            <p></p>
            <button class="btn btn-primary" ng-click="$ctrl.current.beneficiaries.push({ avatar:{}});" sxy-text="SALAXY.NG1.OwnerSettingsComponent.addBeneficiaryBtn"></button>
          </div>
          <div class="row" ng-repeat="beneficiary in $ctrl.current.beneficiaries">
            <div class="col-md-5">
              <salaxy-input ng-model="beneficiary.avatar.displayName" name="beneficiaryName" label="SALAXY.NG1.OwnerSettingsComponent.beneficiaryName" label-type="basic"></salaxy-input>
            </div>
            <div class="col-md-3">
              <salaxy-input ng-model="beneficiary.officialId" name="beneficiaryOfficialId" label="SALAXY.NG1.OwnerSettingsComponent.beneficiaryOfficialId" label-type="basic"></salaxy-input>
            </div>
            <div class="col-md-3 col-10">
              <salaxy-input ng-model="beneficiary.nationality" name="beneficiaryNationality" label="SALAXY.NG1.OwnerSettingsComponent.beneficiaryNationality" label-type="basic"></salaxy-input>
            </div>
            <div class="col-md-1 col-2 text-end" style="padding-top:39px">
              <button ng-if="!$ctrl.isReadOnlyForced" class="btn btn-danger btn-sm" ng-click="$ctrl.current.beneficiaries.splice($index,1)" title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}"><i class="bi bi-trash-fill"></i></button>
            </div>
            <div class="col-12">
              <hr>
            </div>
          </div>
          <div class="row" ng-if="$ctrl.current.beneficiaries.length && !$ctrl.isReadOnlyForced">
            <div class="col-6">
              <button class="btn btn-secondary btn-sm" ng-click="$ctrl.current.beneficiaries.push({avatar:{}})"><i class="bi bi-plus-lg" style="margin-right:5px"></i> <span sxy-text="SALAXY.NG1.OwnerSettingsComponent.addBeneficiaryBtn"></span></button>
            </div>
            <div class="col-6 text-end">
              <button class="btn btn-primary btn-sm" ng-click="$ctrl.save('beneficiaries')" ng-disabled="$ctrl.isSaving('beneficiaries')"><span ng-if="$ctrl.isSaving('beneficiaries')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
            </div>
          </div>
        </fieldset>
      </form>
    </div> 
    <div class="tab-pane" id="printable-tab">
      <div class="report-table-html" ng-if="$ctrl.current">
        <div class="table-responsive">

          <h1 sxy-text="SALAXY.NG1.OwnerSettingsComponent.shareHoldersTitle"></h1>
          <table class="report-table columns-tree">
            <thead>
              <tr style="border-bottom:1px solid black;">
                <th sxy-text="SALAXY.NG1.OwnerSettingsComponent.shareHolder"></th>
                <th class="right" sxy-text="SALAXY.NG1.OwnerSettingsComponent.shares"></th>
                <th class="right" sxy-text="SALAXY.NG1.OwnerSettingsComponent.sharesPercent"></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="owner in $ctrl.current.owners">
                <td>
                  {{owner.avatar.displayName}}
                </td>
                <td class="right">
                  {{owner.numberOfShares}}
                </td>
                <td class="right">
                  {{owner.percentOfShares}}
                </td>
              </tr>
              <tfoot class="">
                <tr class="total">
                  <td><strong sxy-text="SALAXY.NG1.OwnerSettingsComponent.totalShares"></strong></td>
                  <td class="right">{{$ctrl.getTotalAmount()}}</td>
                  <td class="right">{{$ctrl.getTotalPercent()}}</td>
                </tr>
              </tfoot>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/PaymentChannelSettings.html",`<div class="salaxy-component salaxy-payment-channel-settings">
  <div class="row">
    <div class="col-sm-6 max-h-600px mb-4">
      <h4 sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.title"></h4>
      <table class="table">
        <tbody>
          <tr ng-repeat="channel in $ctrl.getPaymentChannels('enabled')">
            <td>
              <salaxy-avatar avatar="$ctrl.getAvatar(channel.channel)" class="" style="font-size: 64px; border-bottom: 32px;"></salaxy-avatar>
            </td>
            <td>
              <div>
                <button class="btn btn-default float-end" ng-click="$ctrl.openChannelSetupDialog(channel.channel)" sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.settingsBtn" ps="..."></button>
                <strong>{{$ctrl.getAvatar(channel.channel).displayName}}</strong>
                <strong ng-if="channel.channel == $ctrl.defaultChannel" class="text-primary" sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.defaultChannel"></strong>
              </div>
              <div>{{$ctrl.getAvatar(channel.channel).description}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-sm-6 max-h-600px mb-4">
      <h4 sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.addNewTitle" ps=":"></h4>
      <table class="table">
        <tbody>
          <tr ng-repeat="channel in $ctrl.getPaymentChannels('available')">
            <td>
              <salaxy-avatar avatar="$ctrl.getAvatar(channel.channel)" class="" style="font-size: 64px; border-bottom: 32px;"></salaxy-avatar>
            </td>
            <td>
              <button class="btn btn-default float-end" ng-click="$ctrl.openChannelSetupDialog(channel.channel)" sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.addBtn" ps="..."></button>
              <div><strong>{{$ctrl.getAvatar(channel.channel).displayName}}</strong></div>
              <div>{{$ctrl.getAvatar(channel.channel).description}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row" ng-if="'test' | sxyIsInRole">
    <div class="col-sm-12">
      <h4><span sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.notAvailableTitle"></span> <span class="badge bg-primary"><span class="small text-white" sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.test"></span></span>
      </h4>
      <p sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.notAvailableText"></p>
      <div class="table-wrapper">
        <table class="table table-sm">
          <tbody>
            <tr ng-repeat="channel in $ctrl.getPaymentChannels('unavailable') | filter: { id: '!undefined' }">
              <td>
                <salaxy-avatar avatar="$ctrl.getAvatar(channel.channel)" class="" style="font-size: 32px; border-bottom: 32px;"></salaxy-avatar>
              </td>
              <td>
                <div>
                  <strong>{{$ctrl.getAvatar(channel.channel).displayName}}</strong>:
                  <small>{{$ctrl.getAvatar(channel.channel).description}}</small>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/PaymentSettings.html",`<div class="content settings" ng-if="$ctrl.current">
  <div class="card tax card-secondary mb-4" ng-if="$ctrl.sections.indexOf('incomesRegister') >= 0">
    <div class="card-header icon-card d-flex">
      <div>
        <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.tax.title"></h2>
        <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.tax.intro"></small></p>
      </div>
      <i class="bi bi-check-circle-fill text-success status-icon fs-1 d-block"></i>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <fieldset>
            <salaxy-input-enum read-only="$ctrl.isReadOnlyForced" type="radio" ng-model="$ctrl.current.calc.incomesRegister.irReporting" name="irReporting" label="SALAXY.MODEL.IncomesRegisterSettings.irReporting.editLabel" options="{ 
                                default: ('SALAXY.ENUM.TaxReportHandling.default.label' | sxyTranslate),
                                noMonthlyReport: ('SALAXY.ENUM.TaxReportHandling.noMonthlyReport.label' | sxyTranslate),
                                always: ('SALAXY.ENUM.TaxReportHandling.always.label' | sxyTranslate)
                              }">
            </salaxy-input-enum>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-12">
          <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="$ctrl.isSaving('incomesRegister')" class="btn btn-primary float-end" ng-click="$ctrl.save('incomesRegister')"><span ng-if="$ctrl.isSaving('incomesRegister')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
        </div>
      </div>
    </div>
  </div>
  <div class="card einvoice card-secondary mb-4" ng-if="$ctrl.sections.indexOf('eInvoice') >= 0">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.einvoice.title"></h2>
      <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.einvoice.description"></small></p>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <form name="eInvoiceForm" class="einvoice-form" ng-readonly="$ctrl.isReadOnlyForced">
            <fieldset>
              <salaxy-form-group name="eInvoiceReceiver" label="SALAXY.NG1.PaymentSettingsComponent.einvoice.invoiceAddress">
                <div class="input-group">
                  <input class="form-control" type="text" autocomplete="off" id="eInvoiceReceiver" name="eInvoiceReceiver" ng-disabled="true" ng-model="$ctrl.current.payments.invoice.eInvoiceReceiver">
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-default" ng-if="!$ctrl.isReadOnlyForced" ng-click="$ctrl.selectEInvoiceAddress()" sxy-text="SALAXY.UI_Terms.choose"></button>
                  </span>
                </div>
              </salaxy-form-group>
              <salaxy-input disabled="true" name="intermediator" ng-model="$ctrl.current.payments.invoice.eInvoiceIntermediator" label="SALAXY.NG1.NewPaymentComponent.einvoice.intermediatorLabel"></salaxy-input>

            </fieldset>
          </form>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-12">
          <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="$ctrl.isSaving('eInvoice')" class="btn btn-primary float-end" ng-click="$ctrl.save('eInvoice')"><span ng-if="$ctrl.isSaving('eInvoice')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
        </div>
      </div>
    </div>
  </div>
  <div class="card sepa card-secondary mb-4" ng-if="$ctrl.sections.indexOf('sepa') >= 0">
    <form name="sepaForm" ng-readonly="$ctrl.isReadOnlyForced">
      <div class="card-header">
        <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.sepa.title"></h2>
        <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.sepa.title"></small></p>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 form-horizontal">
            <fieldset>
              <salaxy-input name="ibanNumber" label="SALAXY.NG1.PaymentSettingsComponent.sepa.iban" ng-model="$ctrl.current.payments.invoice.ibanNumber" sxy-iban></salaxy-input>
              <salaxy-input name="sepaBankPartyId" label="SALAXY.NG1.PaymentSettingsComponent.sepa.sepaId" ng-model="$ctrl.current.payments.invoice.sepaBankPartyId"></salaxy-input>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-12">
            <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="sepaForm.$invalid || $ctrl.isSaving('sepa')" class="btn btn-primary float-end" ng-click="$ctrl.save('sepa')"><span ng-if="$ctrl.isSaving('sepa')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="card taxAndSocialSecuritySelfHandling card-secondary mb-4" ng-if="$ctrl.sections.indexOf('taxAndSocialSecuritySelfHandling') >= 0">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.taxSelfHandling.title"></h2>
      <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.taxSelfHandling.intro"></small></p>
      <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.taxSelfHandling.intro2"></small></p>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <fieldset>
            <salaxy-input-boolean read-only="$ctrl.isReadOnlyForced" type="checkbox" name="isTaxAndSocialSecuritySelfHandling" label-type="plain" label-true="SALAXY.NG1.PaymentSettingsComponent.taxSelfHandling.taxSelfHandlingTrue" ng-model="$ctrl.current.payments.customerFunds.isTaxAndSocialSecuritySelfHandling"></salaxy-input-boolean>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-12">
          <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="$ctrl.isSaving('taxAndSocialSecuritySelfHandling')" class="btn btn-primary float-end" ng-click="$ctrl.save('taxAndSocialSecuritySelfHandling')"><span ng-if="$ctrl.isSaving('taxAndSocialSecuritySelfHandling')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
        </div>
      </div>
    </div>
  </div>
  <div class="card workerSelfHandling card-secondary mb-4" ng-if="$ctrl.sections.indexOf('workerSelfHandling') >= 0">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.workerSelfHandling.title"></h2>
      <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.workerSelfHandling.intro"></small></p>
      <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.workerSelfHandling.intro2"></small></p>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <fieldset>
            <salaxy-input-boolean read-only="$ctrl.isReadOnlyForced" type="checkbox" name="isWorkerSelfHandling" label-type="plain" label-true="SALAXY.NG1.PaymentSettingsComponent.workerSelfHandling.workerSelfHandlingTrue" ng-model="$ctrl.current.payments.customerFunds.isWorkerSelfHandling"></salaxy-input-boolean>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-12">
          <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="$ctrl.isSaving('workerSelfHandling')" class="btn btn-primary float-end" ng-click="$ctrl.save('workerSelfHandling')"><span ng-if="$ctrl.isSaving('workerSelfHandling')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
        </div>
      </div>
    </div>
  </div>
  <div class="card unemployment card-secondary mb-4" ng-if="$ctrl.sections.indexOf('unemploymentSelfHandling') >= 0">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.unemployment.title"></h2>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <fieldset>
            <p sxy-text="SALAXY.NG1.PaymentSettingsComponent.unemployment.intro"></p>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
  <div class="card salarySlipDeliveryMethods card-secondary mb-4" ng-if="$ctrl.sections.indexOf('payslip') >= 0  && ('payslip' | sxyIsInRole)">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.salarySlipDeliveryMethods.payslip.title"></h2>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <form name="salarySlipDeliveryMethodsForm" class="salarySlipDeliveryMethods-form">
            <fieldset>
              <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.salarySlipDeliveryMethods.payslip.description"></small></p>
              <salaxy-input-boolean label="SALAXY.ENUM.WorkerSalarySlipDeliveryMethod.payslip.label" name="payslip" type="checkbox" ng-model="$ctrl.payslip" disabled="$ctrl.disableSwitchInput()"></salaxy-input-boolean>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="card omapalkka card-secondary mb-4" ng-if="$ctrl.sections.indexOf('omapalkka') >= 0 && ('test,admin' | sxyIsInRole)">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.salarySlipDeliveryMethods.omapalkka.title">
      </h2>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <form name="omapalkkaForm" class="omapalkka-form">
            <fieldset>
              <salaxy-input-boolean label="SALAXY.ENUM.WorkerSalarySlipDeliveryMethod.omapalkka.label" name="omapalkka" type="checkbox" ng-model="$ctrl.omapalkka" disabled="$ctrl.disableSwitchInput()"></salaxy-input-boolean>
            </fieldset>
          </form>
          <salaxy-form-group name="paidCalculationsToOmapalkka" label="SALAXY.NG1.PaymentSettingsComponent.salarySlipDeliveryMethods.omapalkka.label">
            <div class="input-group">
              <button type="button" class="btn btn-default float-end" ng-click="$ctrl.sendPaidCalculationsToOmapalkka()" sxy-text="SALAXY.NG1.PaymentSettingsComponent.salarySlipDeliveryMethods.omapalkka.sendToOmapalkkaButtonText"></button>
            </div>
          </salaxy-form-group>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/PayStatsSettings.html",`<div class="content settings" ng-if="$ctrl.current">
  <div class="card mb-4 accounting card-secondary">
    <div>
      <div class="card-header icon-card">
        <h2 sxy-text="SALAXY.MODEL.PayStatsSettings.title"></h2>
      </div>
      <div class="card-body">
        <div class="row">
          <sxy-form ng-ref="$frm" open-api="salaxy-secure/schemas/v02.json" type="CompanyAccountSettings" auto-gen="false" debugger="false" model="$ctrl.current" read-only="{{!$ctrl.current.payStats.denyServiceModel  && $ctrl.current.partner.serviceModel.features.payStats}}">
            <div>
              <sxy-input model="form.partner.serviceModel.features.payStats" label="SALAXY.NG1.ProSettingsComponent.customPayStats" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="serviceModelPayStats" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.payStats" ng-model="$ctrl.current.payStats.denyServiceModel"></salaxy-input-boolean>
              <sxy-input model="form.payStats.types"
                read-only="{{!$ctrl.current.payStats.denyServiceModel  && $ctrl.current.partner.serviceModel.features.payStats }}" include="id,kind,periodLength,employeeGroup,cbaCode">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.PayStatsTypeDefinition.title"></legend>
                    <sxy-input model="form.id" require="true" read-only="{{$ctrl.logic.isReadOnly}}"></sxy-input>
                    <sxy-input model="form.description"></sxy-input>
                    <salaxy-input-enum enum="PayStatsKind" label="SALAXY.MODEL.PayStatsTypeDefinition.kind.title" name="kind" require="true" ng-model="$ctrl.current.kind" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                    <salaxy-input-enum enum="PayStatsPeriodLength" label="SALAXY.MODEL.PayStatsTypeDefinition.periodLength.title" name="periodLength" require="true" ng-model="$ctrl.current.periodLength" filter="quarter,month,year" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                    <salaxy-input-enum enum="PeriodDateKind" label="SALAXY.MODEL.PayStatsTypeDefinition.periodDateKind.title" name="periodDateKind" require="true" ng-model="$ctrl.current.periodDateKind" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>                   
                    <salaxy-input-collective-bargain-agreement name="cbaCode" ng-model="$ctrl.current.cbaCode" label="SALAXY.MODEL.PayStatsTypeDefinition.cbaCode.title"></salaxy-input-collective-bargain-agreement>
                    <salaxy-input-employee-group name="employeeGroup" ng-model="$ctrl.current.employeeGroup" label="SALAXY.MODEL.PayStatsTypeDefinition.employeeGroup.title"></salaxy-input-employee-group>
                    <sxy-input model="form.disabled"></sxy-input>
                    <sxy-input model="form.startDate"></sxy-input>
                    <sxy-input model="form.endDate"></sxy-input>
                    <legend ng-show="$ctrl.current.kind == 'averageHourlyPay'" sxy-text="SALAXY.MODEL.PayStatsTypeDefinition.salaryTypes.title"></legend>
                    <sxy-input ng-show="$ctrl.current.kind == 'averageHourlyPay'" model="form.salaryTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.kind == 'averageHourlyPay'" sxy-text="SALAXY.MODEL.PayStatsTypeDefinition.workingTimeTypes.title"></legend>
                    <sxy-input ng-show="$ctrl.current.kind == 'averageHourlyPay'" format="undefined" model="form.minWorkingTime"></sxy-input>
                    <sxy-input ng-show="$ctrl.current.kind == 'averageHourlyPay'" model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                    <sxy-code-editor ng-show="$ctrl.current.kind == 'script'" ng-model="$ctrl.current.script"></sxy-code-editor>
                  </fieldset>
                </form>
              </sxy-input>
            </div>         
          </sxy-form>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-xs-12">
            <button type="submit" ng-disabled="(!$ctrl.current.payStats.denyServiceModel && $ctrl.current.partner.serviceModel.features.payStats) || !$frm.ngForm.$valid || $ctrl.isSaving('all')" class="btn btn-primary pull-right" ng-click="$ctrl.save('all')">
              <span ng-if="$ctrl.isSaving('all')"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span sxy-text="SALAXY.UI_Terms.save"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/ProSettings.html",`<div class="salaxy-component salaxy-pro-settings">
  <div class="btn-toolbar d-flex justify-content-end">
    <button class="btn btn-primary" ng-click="$ctrl.save('all')" ng-disabled="$ctrl.isSaving('all')"><span ng-if="$ctrl.isSaving('all')"><i
      class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
  </div>
  <div ng-if="$ctrl.current">
    <sxy-form open-api="salaxy-secure/schemas/v02.json" type="CompanyAccountSettings" auto-gen="false" debugger="false" model="$ctrl.current">
      <div>
        <salaxy-tab-buttons
          current-tab="$ctrl.currentTab"
          options="[
            { value: 'insurances', text: 'SALAXY.NG1.ProSettingsComponent.insurances' },
            { value: 'rows', text: 'SALAXY.NG1.ProSettingsComponent.tabs.defaultRows' },
            { value: 'coms', text: 'SALAXY.NG1.ProSettingsComponent.tabs.messagingAndLayout' },
            { value: 'paymentchannels', text: 'SALAXY.NG1.ProSettingsComponent.tabs.paymentChannels' },
            { value: 'dimensions', text: 'SALAXY.NG1.ProSettingsComponent.tabs.dimensions' },
            { value: 'accounting', text: 'SALAXY.NG1.ProSettingsComponent.tabs.accounting' },
            { value: 'holidays', text: 'SALAXY.NG1.ProSettingsComponent.tabs.holidays' },
            { value: 'other', text: 'SALAXY.NG1.ProSettingsComponent.tabs.other' },
            { value: 'irdelivery', text: 'SALAXY.NG1.ProSettingsComponent.tabs.irdelivery' },
            { value: 'paystats', text: 'SALAXY.NG1.ProSettingsComponent.tabs.paystats', hidden: !('bizConfigs' | sxyIsInRole) },
            { value: 'employeeGroups', text: 'SALAXY.MODEL.CalculationSettings.employeeGroups.title', hidden: !('bizConfigs' | sxyIsInRole) },
            { value: 'configs', text: 'SALAXY.MODEL.CompanyAccountSettings.configs.title', hidden: !('bizConfigs' | sxyIsInRole) },
            { value: 'readonly', text: 'SALAXY.NG1.ProSettingsComponent.tabs.read-only' }
          ]"
          tabs-id="proSettings">
        </salaxy-tab-buttons>
        <div class="tab-content" id="tab-content-proSettings">
          <div class="tab-pane" id="insurances-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.insurances"></span> </legend>
              <sxy-input model="form.calc.pensionContracts" template-url="salaxy-components/sxy-form/custom-templates/array-pension.html">
                <form>
                  <fieldset>
                    <sxy-input model="form.company"></sxy-input>
                    <sxy-input model="form.contractNumber" format="pension-contract-number"></sxy-input>
                    <sxy-input model="form.startDate" format="date"></sxy-input>
                    <sxy-input model="form.endDate" format="date"></sxy-input>
                    <sxy-input model="form.pensionDefaultPercent"></sxy-input>
                    <sxy-input model="form.pensionPercent"></sxy-input>
                    <sxy-input ng-show="['kevaMunicipal','kevaAland','kevaChurch','kevaKela','kevaState'].indexOf($ctrl.current.company) >= 0" model="form.subOrgCode"></sxy-input>
                    <sxy-input ng-show="'admin' | sxyIsInRole" model="form.pensionDiscountPercent"></sxy-input>
                    <sxy-input ng-show="'admin' | sxyIsInRole" model="form.status" read-only="false"></sxy-input>
                    <sxy-input ng-show="'!admin' | sxyIsInRole" model="form.status" read-only="true"></sxy-input>
                    <!--sxy-input model="form.id" read-only="true"></sxy-input-->
                  </fieldset>
                </form>
              </sxy-input>
              <sxy-input model="form.calc.insuranceContracts" template-url="salaxy-components/sxy-form/custom-templates/array-insurance.html">
                <form>
                  <fieldset>
                    <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.insurance"></span> </legend>
                    <sxy-input model="form.company"></sxy-input>
                    <sxy-input model="form.contractNumber"></sxy-input>
                    <sxy-input model="form.startDate" format="date"></sxy-input>
                    <sxy-input model="form.endDate" format="date"></sxy-input>
                    <sxy-input model="form.insurancePercent"></sxy-input>
                    <sxy-input model="form.groupLifeInsurancePercent"></sxy-input>
                    <sxy-input model="form.isPartnerInsurance"></sxy-input>
                    <sxy-input ng-show="'admin' | sxyIsInRole" model="form.status" read-only="false"></sxy-input>
                    <sxy-input ng-show="'!admin' | sxyIsInRole" model="form.status" read-only="true"></sxy-input>
                    <!--sxy-input model="form.id" read-only="true"></sxy-input-->
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.unemploymentInsurance"></span> </legend>
              <sxy-input model="form.calc.unemploymentInsurance.payrollLimitStatus"></sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="rows-tab">
            <salaxy-calc-rows-editor ng-if="!$ctrl.isLoading" rows="$ctrl.current.calc.salaryDefaults"
              title="{{ 'SALAXY.NG1.WorkerDetailsComponent.defaultCalcRows' | sxyTranslate }}" type="salary-defaults"></salaxy-calc-rows-editor>
          </div>
          <div class="tab-pane" id="coms-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.messaging"></span> <span
                  ng-if="!$ctrl.current.messaging.denyServiceModel && $ctrl.current.partner.serviceModel.features.messaging" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.messaging" label="SALAXY.NG1.ProSettingsComponent.customMessages" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="messagingDeny" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.messaging" ng-model="$ctrl.current.messaging.denyServiceModel"></salaxy-input-boolean>
              <salaxy-input-boolean ng-if="$ctrl.current.partner.serviceModel.features.messaging" read-only="!$ctrl.current.messaging.denyServiceModel"
                ng-model="$ctrl.current.messaging.partnerMessages" name="partnerMessages" label="SALAXY.NG1.ProSettingsComponent.messagesAccountant"></salaxy-input-boolean>
              <salaxy-input-enum read-only="!$ctrl.current.messaging.denyServiceModel && $ctrl.current.partner.serviceModel.features.messaging" type="multi-select"
                enum="WorkerSalaryNotification" ng-model="$ctrl.current.messaging.workerSalaryNotifications" name="workerSalaryNotifications"
                label="SALAXY.NG1.ProSettingsComponent.messagesPayment"></salaxy-input-enum>
              <salaxy-input-enum read-only="!$ctrl.current.messaging.denyServiceModel && $ctrl.current.partner.serviceModel.features.messaging" type="multi-select"
                enum="WorkerSalarySlipDeliveryMethod" ng-model="$ctrl.current.messaging.workerSalarySlipDeliveryMethods" name="workerSalarySlipDeliveryMethods"
                label="SALAXY.NG1.ProSettingsComponent.workerSalarySlipDeliveryMethods"></salaxy-input-enum>
            </fieldset>
            <fieldset ng-init="$ctrl.isReportLogoManuallyUploaded = false">
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.reporting"></span> <span
                  ng-if="!$ctrl.current.reporting.denyServiceModel && $ctrl.current.partner.serviceModel.features.reporting" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.reporting" label="SALAXY.NG1.ProSettingsComponent.customReporting" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc4" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.reporting" ng-model="$ctrl.current.reporting.denyServiceModel"></salaxy-input-boolean>
              <salaxy-input-enum read-only="!$ctrl.current.reporting.denyServiceModel && $ctrl.current.partner.serviceModel.features.reporting"
                ng-model="$ctrl.current.reporting.layoutTemplateId" name="layputTemplateId" label="SALAXY.NG1.ProSettingsComponent.layoutTemplateId" options="{'palkkaus-report-options@FI53POYS0025543933': ('SALAXY.NG1.ProSettingsComponent.templateIdPalkkaus' | sxyTranslate),
                'no-logo-report-options@FI53POYS0025543933': ('SALAXY.NG1.ProSettingsComponent.templateIdNoLogo' | sxyTranslate),
                'logo-report-options@FI53POYS0025543933': ('SALAXY.NG1.ProSettingsComponent.templateIdLogo' | sxyTranslate)
               }"></salaxy-input-enum>
               <salaxy-input-boolean ng-if="$ctrl.current.reporting.layoutTemplateId == 'logo-report-options@FI53POYS0025543933'" type="radio" name="reportLogoUploadType" label="SALAXY.NG1.ProSettingsComponent.fileUpload.uploadMethod" ng-model="$ctrl.isReportLogoManuallyUploaded" label-true="SALAXY.NG1.ProSettingsComponent.fileUpload.manualUpload" label-false="SALAXY.NG1.ProSettingsComponent.fileUpload.uploadFromDevice"></salaxy-input-boolean>
               <div class="form-group row" ng-if="!$ctrl.isReportLogoManuallyUploaded && $ctrl.current.reporting.layoutTemplateId == 'logo-report-options@FI53POYS0025543933'">
                  <div class="col-xs-12 col-sm-4">
                    <label for="avatarImageUpload" sxy-text="SALAXY.NG1.ProSettingsComponent.fileUpload.previewLabel"></label>
                  </div>
                  <div class="col-xs-12 col-sm-8">
                    <div name="avatarImageUpload" ng-model="avatarImage" ngf-drop="$ctrl.createReportLogoDatauri($file)" ngf-select="$ctrl.createReportLogoDatauri($file)" class="salaxy-drop-box" ngf-drag-over-class="'salaxy-drag-over'" ngf-multiple="false" ngf-min-size="1KB" ngf-max-size="10MB"
                       ngf-model-invalid="invalidFile" ng-class="invalidFile.$error != null ? 'error' : ''">
                      <span sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImage.html"></span>
                      <p sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.preferredImageSize"></p>
                    </div>
                  </div>
                  
              </div>
              <salaxy-textarea maxlength="" read-only="!$ctrl.current.reporting.denyServiceModel && $ctrl.current.partner.serviceModel.features.reporting"
                label="SALAXY.NG1.ProSettingsComponent.customReportLogo" name="logo" ng-model="$ctrl.current.reporting.logo" rows="3"
                ng-if="$ctrl.current.reporting.layoutTemplateId == 'logo-report-options@FI53POYS0025543933' && $ctrl.isReportLogoManuallyUploaded">
              </salaxy-textarea>
              <div class="form-group row" ng-if="$ctrl.current.reporting.logo && $ctrl.current.reporting.layoutTemplateId == 'logo-report-options@FI53POYS0025543933'">
                <div class="col-xs-12 col-sm-4">
                  <label for="avatarImageUpload" sxy-text="Logo"></label>
                </div>
                <div class="col-xs-12 col-sm-8">
                  <div class="salaxy-report-logo-preview">
                    <div ng-bind-html="$ctrl.getReportLogo()" ></div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="tab-pane" id="paymentchannels-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.selfHandling"></span> </legend>
              <sxy-input model="form.payments.customerFunds.isWorkerSelfHandling"></sxy-input>
              <sxy-input model="form.payments.customerFunds.isPensionSelfHandling"></sxy-input>
              <sxy-input model="form.payments.customerFunds.isTaxAndSocialSecuritySelfHandling"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.invoices"></span> </legend>
              <sxy-input model="form.payments.invoice.eInvoiceReceiver"></sxy-input>
              <sxy-input model="form.payments.invoice.eInvoiceIntermediator"></sxy-input>
              <sxy-input model="form.payments.invoice.sepaBankPartyId"></sxy-input>
              <sxy-input model="form.payments.invoice.ibanNumber"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.paymentChannels"></span> <span
                  ng-if="!$ctrl.current.payments.denyServiceModel && $ctrl.current.partner.serviceModel.features.payments" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.payments" label="SALAXY.NG1.ProSettingsComponent.customPaymentChannels" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc1" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.payments" ng-model="$ctrl.current.payments.denyServiceModel"></salaxy-input-boolean>
  
              <salaxy-input-typeahead class="default-channel-input-enum" disabled="!$ctrl.current.payments.denyServiceModel && $ctrl.current.partner.serviceModel.features.payments"
                name="options_type" ng-model="$ctrl.current.payments.defaultChannel" options="$ctrl.getSelectablePaymenMethods()" disable-cache="true"
                label="SALAXY.NG1.ProSettingsComponent.defaultChannel"></salaxy-input-typeahead>
  
              <sxy-input class="payment-channels" template-url="salaxy-components/sxy-form/custom-templates/array-payment-channels.html" model="form.payments.channels"
                read-only="{{!$ctrl.current.payments.denyServiceModel && $ctrl.current.partner.serviceModel.features.payments}}">
                <form>
                  <fieldset ng-init="$ctrl.logic.showDelete = false">
                    <sxy-input model="form.channel" read-only="true"></sxy-input>
                    <sxy-input model="form.isAvailable" read-only="true"></sxy-input>
                    <sxy-input model="form.isEnabled" read-only="{{!$ctrl.current.isAvailable}}"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="dimensions-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.MODEL.CostAccountingSettings.title"></span> <span
                  ng-if="!$ctrl.current.costAccounting.denyServiceModel && $ctrl.current.partner.serviceModel.features.costAccounting" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.costAccounting" label="SALAXY.NG1.ProSettingsComponent.customCostAccounting" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc5" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.costAccounting" ng-model="$ctrl.current.costAccounting.denyServiceModel"></salaxy-input-boolean>
              <sxy-input model="form.costAccounting.dimensions"
                read-only="{{!$ctrl.current.costAccounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.costAccounting }}" include="id,label,scope">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.CostAccountingDimensionDefinition.title"></legend>
                    <sxy-input model="form.id" read-only="{{$ctrl.logic.showDelete}}"></sxy-input>
                    <sxy-input model="form.label"></sxy-input>
                    <sxy-input model="form.allowCostSharing"></sxy-input>
                    <sxy-input model="form.scope"></sxy-input>
                    <sxy-input model="form.options" template-url="salaxy-components/sxy-form/custom-templates/cost-accounting-options.html"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="accounting-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.accounting"></span> <span
                  ng-if="!$ctrl.current.accounting.denyServiceModel && $ctrl.current.partner.serviceModel.features.accounting" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.accounting" label="SALAXY.NG1.ProSettingsComponent.customAccounting" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc2" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.accounting" ng-model="$ctrl.current.accounting.denyServiceModel"></salaxy-input-boolean>
              <salaxy-input-typeahead 
                name="options_type" ng-model="$ctrl.current.accounting.defaultTargetId" options="$ctrl.getSelectableAccountingTargets()" disable-cache="true"
                label="SALAXY.NG1.ProSettingsComponent.defaultTarget"></salaxy-input-typeahead>
              <sxy-input template-url="salaxy-components/sxy-form/custom-templates/array-accounting-targets.html" model="form.accounting.targets"
                read-only="{{!$ctrl.current.accounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.accounting}}">
                <form>
                  <fieldset ng-show="!$ctrl.logic.showDelete" ng-controller="CompanySettingsController as $companySettingsCtrl" ng-init="$ctrl.logic.isReadOnly = true">
                    <salaxy-odata-table url="/v03/api/accounting-target" template-url="salaxy-components/odata/lists/AccountingTargetSelect.html"
                      selected-items="$ctrl.selectedItems" on-list-select="$companySettingsCtrl.onAccountingTargetSelect($ctrl.current, $ctrl.logic, value, item, allItems)">
                    </salaxy-odata-table>
                  </fieldset>
                  <fieldset ng-show="$ctrl.logic.showDelete" ng-controller="AccountingChannelSettingsController as $settings" ng-init="$ctrl.logic.isReadOnly = false">
                    <salaxy-input-enum disabled="false" name="format" label="SALAXY.NG1.AccountingTargetDetailsComponent.excelCsvFormat" ng-model="$ctrl.current.format"
                      options="{
                        '36dff2e2-e181-4f0d-9004-0e4aa92f5e17': 'Palkkaus.fi',
                        '0db4e85f-93a8-46f1-b6d2-f7523d289d88': 'Fennoa',
                        '8613f133-3fce-4611-b372-51f6a2e007dd': 'Procountor',
                        'e62c10b0-222a-4170-b8b4-b1e02d9a7644': 'Passeli Merit',
                        '53fd3863-b8f9-4909-86c9-cb4597595181': 'Heeros',
                        '2fc7899c-7a3d-4d56-ad2f-05d52782bbbc': 'Asteri',
                        '0a2bd312-06da-4862-aef5-75166e0bf461': 'Maestro',
                        'c04e0757-63f3-420d-a183-3427710fc954': 'Visma Fivaldi',
                        'ba271dac-dd63-4036-9d70-053a09ca4d9e' :'Visma Netvisor',
                        '27e271d5-41f5-4319-ab29-4d5d9eb945c6': 'Lemonsoft',
                        'd311f9d3-8c3a-4fd8-a665-8e3698e41e87': 'Tampuuri',
                        'd58e95b7-d0b5-40ac-992b-6d3b29efc45e': 'Domus',
                        '54e93c5f-bd74-4157-8a74-3515be7f585d': 'Oscar Software',
                        '0e4f0a71-dcb9-43ba-9028-0239e674711f': 'Digia Enterprise',
                        '2ccefa46-7992-46c5-9d87-b88336935916': 'Digia Enterprise - VILPE',
                        'c36c24b9-5e2c-4f44-b67a-90d81aeea257': 'iScala'
                      }">
                    </salaxy-input-enum>
                    <sxy-input model="form.method" read-only="false"></sxy-input>
                    <salaxy-input-enum disabled="false" enum="ExportMethod" label="SALAXY.MODEL.AccountingTargetSettings.availableMethods.title" name="availableMethods"
                      type="multi-select" ng-model="$ctrl.current.availableMethods"></salaxy-input-enum>
                    <button ng-show="$settings.isApiIntegration($ctrl.current)" type="button" class="btn btn-sm btn-default"
                      ng-click="$settings.openChannelSetupDialog($ctrl.current, $close)">
                      Siirry APIn konfigurointiin <i class="bi bi-box-arrow-up-right"></i>
                    </button>
                    <button ng-show="$settings.isApiIntegration($ctrl.current)" type="button" class="btn btn-sm btn-default"
                      ng-click="$settings.configureCoa($ctrl.current, $close)">
                      Siirry tilikartan konfigurointiin <i class="bi bi-chevron-right"></i>
                    </button>
                  </fieldset>
                </form>
              </sxy-input>
              <sxy-input model="form.accounting.defaultPeriodDateKind"
                read-only="{{!$ctrl.current.accounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.accounting}}"></sxy-input>
              <salaxy-input-enum ng-if="$ctrl.defaultAccountingTarget"
                read-only="!$ctrl.current.accounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.accounting" type="select" name="method"
                ng-model="$ctrl.defaultAccountingTarget.method" enum="ExportMethod" label="SALAXY.MODEL.AccountingTargetSettings.method.title"></salaxy-input-enum>
              <legend sxy-text="SALAXY.MODEL.AccountingSettings.reportDelivery.title"></legend>
              <sxy-input model="form.accounting.reportDelivery.isEnabled"></sxy-input>
              <sxy-input model="form.accounting.reportDelivery.address"></sxy-input>
              <legend sxy-text="SALAXY.MODEL.AccountingSettings.accountantReportDelivery.title"></legend>
              <sxy-input model="form.accounting.accountantReportDelivery.isEnabled"></sxy-input>
              <sxy-input model="form.accounting.accountantReportDelivery.address"></sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="holidays-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.MODEL.HolidaySettings.title"></span> <span
                  ng-if="!$ctrl.current.holiday.denyServiceModel && $ctrl.current.partner.serviceModel.features.holiday" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.holiday" label="SALAXY.NG1.ProSettingsComponent.customHoliday" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc6" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.holiday" ng-model="$ctrl.current.holiday.denyServiceModel"></salaxy-input-boolean>
              <!--div ng-if="('bizConfigs' | sxyIsInRole) && ($ctrl.current.holiday.denyServiceModel || !$ctrl.current.partner.serviceModel.features.holiday)" ng-controller="TemplateCrudController as $templateCrudCtrl">
                <button type="button" class="btn btn-sm btn-default"
                  ng-click="$templateCrudCtrl.selectTemplate()">
                  <i class="bi bi-plus"></i> <span sxy-text="Lisää valmiista mallista..."></span>
                </button>
              </div-->
              <sxy-input model="form.holiday.holidayPaySettings"
                read-only="{{!$ctrl.current.holiday.denyServiceModel  && $ctrl.current.partner.serviceModel.features.holiday }}" include="holidayPayCalculation">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.HolidayPaySettings.title"></legend>
                    <salaxy-input-enum ng-show="!('bizConfigs' | sxyIsInRole)" enum="HolidayPayCalculation" label="SALAXY.MODEL.HolidayPaySettings.holidayPayCalculation.title" name="holidayPayCalculation" filter="averageDailyPay,averageHourlyPay,percentageBasedPay,holidayCompensation" require="true" ng-model="$ctrl.current.holidayPayCalculation" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                    <salaxy-input-enum ng-show="'bizConfigs' | sxyIsInRole" enum="HolidayPayCalculation" label="SALAXY.MODEL.HolidayPaySettings.holidayPayCalculation.title" name="holidayPayCalculation" filter="averageDailyPay,averageHourlyPay,percentageBasedPay,holidayCompensation,scriptPay" require="true" ng-model="$ctrl.current.holidayPayCalculation" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                    <salaxy-input-collective-bargain-agreement ng-show="'bizConfigs' | sxyIsInRole" name="cbaCode" ng-model="$ctrl.current.cbaCode" label="SALAXY.MODEL.HolidayPaySettings.cbaCode.title"></salaxy-input-collective-bargain-agreement>
                    <salaxy-input-employee-group ng-show="'bizConfigs' | sxyIsInRole" name="employeeGroup" ng-model="$ctrl.current.employeeGroup" label="SALAXY.MODEL.HolidayPaySettings.employeeGroup.title"></salaxy-input-employee-group>
                    <sxy-input model="form.disabled"></sxy-input>
                    <sxy-input model="form.startYear" label="SALAXY.MODEL.HolidayPaySettings.startYear.title"></sxy-input>  
                    <sxy-input model="form.endYear" label="SALAXY.MODEL.HolidayPaySettings.endYear.title"></sxy-input> 
                    <legend  ng-show="$ctrl.current.holidayPayCalculation && $ctrl.current.holidayPayCalculation != 'scriptPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.salaryTypes.title"></legend>
                    <sxy-input  ng-show="$ctrl.current.holidayPayCalculation && $ctrl.current.holidayPayCalculation != 'scriptPay'" model="form.salaryTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.workingTimeTypes.title"></legend>
                    <sxy-input ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay'" model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.overtimeTypes.title"></legend>
                    <sxy-input  ng-show="$ctrl.current.holidayPayCalculation == 'averageDailyPay'" model="form.overtimeTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay' || $ctrl.current.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.multipliers.title"></legend>
                    <salaxy-input-holiday-multipliers ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay' || $ctrl.current.holidayPayCalculation == 'averageDailyPay'" name="multipliers" label="SALAXY.MODEL.HolidayPaySettings.multipliers.title" ng-model="$ctrl.current.multipliers" read-only="$ctrl.logic.isReadOnly"></salaxy-input-holiday-multipliers>
                    <sxy-code-editor ng-show="$ctrl.current.holidayPayCalculation == 'scriptPay'" ng-model="$ctrl.current.script"></sxy-code-editor>
                  </fieldset>
                </form>
              </sxy-input>
              <!--div ng-if="('bizConfigs' | sxyIsInRole) && ($ctrl.current.holiday.denyServiceModel || !$ctrl.current.partner.serviceModel.features.holiday)" ng-controller="TemplateCrudController as $templateCrudCtrl">
                <button type="button" class="btn btn-sm btn-default"
                  ng-click="$templateCrudCtrl.selectTemplate()">
                  <i class="bi bi-plus"></i> <span sxy-text="Lisää valmiista mallista..."></span>
                </button>
              </div-->
              <sxy-input model="form.holiday.holidayAccrualSettings"
                read-only="{{!$ctrl.current.holiday.denyServiceModel  && $ctrl.current.partner.serviceModel.features.holiday }}" include="code">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.HolidayAccrualSettings.title"></legend>
                    <salaxy-input-enum ng-show="!('bizConfigs' | sxyIsInRole)" enum="HolidayCode" label="SALAXY.MODEL.HolidayAccrualSettings.code.title" name="code" filter="permanent35Hours" require="true" ng-model="$ctrl.current.code" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                    <salaxy-input-enum ng-show="'bizConfigs' | sxyIsInRole" enum="HolidayCode" label="SALAXY.MODEL.HolidayAccrualSettings.code.title" name="code" filter="permanent35Hours,script" require="true" ng-model="$ctrl.current.code" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                    <salaxy-input-collective-bargain-agreement ng-show="'bizConfigs' | sxyIsInRole" name="cbaCode" ng-model="$ctrl.current.cbaCode" label="SALAXY.MODEL.HolidayAccrualSettings.cbaCode.title"></salaxy-input-collective-bargain-agreement>
                    <salaxy-input-employee-group ng-show="'bizConfigs' | sxyIsInRole" name="employeeGroup" ng-model="$ctrl.current.employeeGroup" label="SALAXY.MODEL.HolidayAccrualSettings.employeeGroup.title"></salaxy-input-employee-group>
                    <sxy-input model="form.disabled"></sxy-input>
                    <sxy-input model="form.startYear" label="SALAXY.MODEL.HolidayAccrualSettings.startYear.title"></sxy-input>  
                    <sxy-input model="form.endYear" label="SALAXY.MODEL.HolidayAccrualSettings.endYear.title"></sxy-input> 
                    <legend ng-show="$ctrl.current.code == 'permanent35Hours'" sxy-text="SALAXY.MODEL.HolidayAccrualSettings.workingTimeTypes.title"></legend>
                    <sxy-input  ng-show="$ctrl.current.code == 'permanent35Hours'" model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                    <sxy-code-editor ng-show="$ctrl.current.code == 'script'" ng-model="$ctrl.current.script"></sxy-code-editor>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="other-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.incomesRegister"></span> </legend>
              <sxy-input model="form.calc.incomesRegister.irReporting"></sxy-input>
              <sxy-input model="form.calc.incomesRegister.taxReferenceNumber"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.usecases"></span> <span
                  ng-if="!$ctrl.current.usecase.denyServiceModel && $ctrl.current.partner.serviceModel.features.usecase" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.usecase.serverUrl" label="Integration server (staging)"></sxy-input>
              <sxy-input model="form.partner.serviceModel.features.usecase" label="SALAXY.NG1.ProSettingsComponent.customUsecases" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc3" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.usecase" ng-model="$ctrl.current.usecase.denyServiceModel"></salaxy-input-boolean>
              <sxy-input template-url="salaxy-components/sxy-form/custom-templates/array-usecase.html" model="form.usecase.usecases"
                read-only="{{!$ctrl.current.usecase.denyServiceModel  && $ctrl.current.partner.serviceModel.features.usecase}}">
                <form>
                  <fieldset ng-show="!$ctrl.logic.showDelete" ng-controller="CompanySettingsController as $companySettingsCtrl">
                    <salaxy-odata-table url="/v03/api/usecases" template-url="salaxy-components/odata/lists/UsecaseSelect.html" selected-items="$ctrl.selectedItems"
                      on-list-select="$companySettingsCtrl.onUsecaseSelect($ctrl.current, $ctrl.logic, value, item, allItems)">
                    </salaxy-odata-table>
                  </fieldset>
                  <fieldset ng-show="$ctrl.logic.showDelete">
                    <sxy-input model="form.uri" read-only="true"></sxy-input>
                    <sxy-input model="form.label" read-only="true"></sxy-input>
                    <sxy-input model="form.itemType" read-only="true"></sxy-input>
                    <sxy-input model="form.status"></sxy-input>
                    <sxy-input model="form.order"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="irdelivery-tab">
            <fieldset>
              <legend>Tulorekisterivarmenteen omistaja</legend>
              <p
                sxy-text="Jos haluat käyttää tilitoimistovarmennetta Palkkaus.fi:n varmenteen sijasta, anna käytettävän varmenteen Y-tunnus.">
              </p>
              <salaxy-input label="Tulorekisterivarmenteen omistajan Y-tunnus" name="senderOfficialId"
                ng-model="$ctrl.current.calc.incomesRegister.irDelivery.senderOfficialId"></salaxy-input>
            </fieldset>
            <fieldset>
              <legend>Tulorekisteriraportin yhteyshenkilöt</legend>
              <table class="table">
                <thead>
                  <tr>
                    <th>{{('Nimi') | sxyTranslate}}</th>
                    <th>{{('Puhelin') | sxyTranslate}}</th>
                    <th>{{('Sähköposti') | sxyTranslate}}</th>
                    <th>{{('Vastuualue') | sxyTranslate}}</th>
                    <th class="right">
                      <button type="button" class="btn btn-primary btn-xs"
                        ng-click="$ctrl.current.calc.incomesRegister.irDelivery.contactPersons.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr ng-repeat="item in $ctrl.current.calc.incomesRegister.irDelivery.contactPersons">
                    <td>
                      <salaxy-input require="true" ng-model="item.name" name="{{ 'name' + $index }}" label-type="plain"></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input require="true" ng-model="item.telephone" name="{{ 'telephone' + $index }}" label-type="plain" sxy-mobile-phone></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input require="true" ng-model="item.email" name="{{ 'email' + $index }}" label-type="plain" sxy-email></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input-enum require="true" ng-model="item.responsibilityCode" name="{{ 'responsibilityCode' + $index }}" label-type="plain" type="select"
                        options="{ contentIssues: 'Raporttien sisältö', technicalIssues: 'Tekniset asiat' }"></salaxy-input-enum>
                    </td>
                    <td class="text-right">
                      <button type="button" class="btn btn-danger" ng-click="$ctrl.current.calc.incomesRegister.irDelivery.contactPersons.splice($index, 1)">
                        <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
            <legend>Yrityksesi tulorekisterivarmenteen tila</legend>
                <table class="table">
                  <tr>
                    <th>Luotu</th>
                    <th>Voimassaolo päättyy</th>
                  </tr>
                  <tr ng-if="!$ctrl.irCertificate.id">
                    <td colspan="2">Ei voimassa olevaa varmennetta</td>
                  </tr>
                  <tr ng-if="$ctrl.irCertificate.id">
                    <td>{{$ctrl.irCertificate.updatedAt | date}}</td>
                    <td>{{$ctrl.irCertificate.expiresAt | date}}</td>
                  </tr>
                </table>
              </fieldset>
              <fieldset>
                <legend>Varmenteen luonti/uusinta</legend>
                <salaxy-input-enum ng-if="$ctrl.irCertificate.id" ng-init="$ctrl.irCertificateAction = 'renew'" label="Toimenpide" ng-model="$ctrl.irCertificateAction" name="certAction" type="radio"
                  options="{ create: 'Luo uusi varmenne', renew: 'Uusi nykyinen varmenne' }"></salaxy-input-enum>
                <salaxy-input-enum ng-if="!$ctrl.irCertificate.id" ng-init="$ctrl.irCertificateAction = 'create'" label="Toimenpide" ng-model="$ctrl.irCertificateAction" name="certAction" type="radio"
                  options="{ create: 'Luo uusi varmenne'}"></salaxy-input-enum>
                <salaxy-input ng-if="$ctrl.irCertificateAction == 'create'" require="true" label="Siirtotunnus" ng-model="$ctrl.irCertificateTransferId"
                  name="transferId"></salaxy-input>
                <salaxy-input ng-if="$ctrl.irCertificateAction == 'create'" require="true" label="Kertakäyttösalasana" ng-model="$ctrl.irCertificateTransferPassword"
                  name="transferPassword" type="password"></salaxy-input>

                  <div class="row">
                    <div class="col-xs-12 text-right">
                      <button type="button" ng-if="$ctrl.irCertificateAction == 'create'" class="btn btn-primary" ng-disabled="$ctrl.isSaving('irCertificate')"
                        ng-click="$ctrl.createIrCertificate($ctrl.irCertificateTransferId, $ctrl.irCertificateTransferPassword)"><span ng-if="$ctrl.isSaving('irCertificate')"><i
                            class="bi bi-arrow-repeat bi-spin"></i></span><span sxy-text="Luo uusi varmenne"></span></button>
                      <button type="button" ng-if="$ctrl.irCertificateAction == 'renew'" class="btn btn-primary" ng-disabled="$ctrl.isSaving('irCertificate')"
                        ng-click="$ctrl.renewIrCertificate()"><span ng-if="$ctrl.isSaving('irCertificate')"><i class="bi bi-arrow-repeat bi-spin"></i></span><span
                          sxy-text="Uusi nykyinen varmenne"></span></button>
                    </div>
                  </div>
              </fieldset>
          </div>
          <div class="tab-pane" id="paystats-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.MODEL.PayStatsSettings.title"></span> <span
                  ng-if="!$ctrl.current.payStats.denyServiceModel && $ctrl.current.partner.serviceModel.features.payStats" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.payStats" label="SALAXY.NG1.ProSettingsComponent.customPayStats" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="serviceModelPayStats" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.payStats" ng-model="$ctrl.current.payStats.denyServiceModel"></salaxy-input-boolean>
              <!--div ng-if="('bizConfigs' | sxyIsInRole) && ($ctrl.current.payStats.denyServiceModel || !$ctrl.current.partner.serviceModel.features.payStats)" ng-controller="TemplateCrudController as $templateCrudCtrl">
                <button type="button" class="btn btn-sm btn-default"
                  ng-click="$templateCrudCtrl.selectTemplate()">
                  <i class="bi bi-plus"></i> <span sxy-text="Lisää valmiista mallista..."></span>
                </button>
              </div-->
              <sxy-input model="form.payStats.types"
                read-only="{{!$ctrl.current.payStats.denyServiceModel  && $ctrl.current.partner.serviceModel.features.payStats }}" include="id,kind,periodLength,cbaCode,employeeGroup">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.PayStatsTypeDefinition.title"></legend>
                    <sxy-input model="form.id" require="true" read-only="{{$ctrl.logic.isReadOnly}}"></sxy-input>
                    <sxy-input model="form.description"></sxy-input>
                    <salaxy-input-enum enum="PayStatsKind" label="SALAXY.MODEL.PayStatsTypeDefinition.kind.title" name="kind" require="true" ng-model="$ctrl.current.kind" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                    <salaxy-input-enum enum="PayStatsPeriodLength" label="SALAXY.MODEL.PayStatsTypeDefinition.periodLength.title" name="periodLength" require="true" ng-model="$ctrl.current.periodLength" filter="quarter,month,year" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                    <salaxy-input-enum enum="PeriodDateKind" label="SALAXY.MODEL.PayStatsTypeDefinition.periodDateKind.title" name="periodDateKind" require="true" ng-model="$ctrl.current.periodDateKind" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>                   
                    <salaxy-input-collective-bargain-agreement name="cbaCode" ng-model="$ctrl.current.cbaCode" label="SALAXY.MODEL.PayStatsTypeDefinition.cbaCode.title"></salaxy-input-collective-bargain-agreement>
                    <salaxy-input-employee-group name="employeeGroup" ng-model="$ctrl.current.employeeGroup" label="SALAXY.MODEL.PayStatsTypeDefinition.employeeGroup.title"></salaxy-input-employee-group>
                    <sxy-input model="form.disabled"></sxy-input>
                    <sxy-input model="form.startDate"></sxy-input>
                    <sxy-input model="form.endDate"></sxy-input>
                    <legend ng-show="$ctrl.current.kind == 'averageHourlyPay'" sxy-text="SALAXY.MODEL.PayStatsTypeDefinition.salaryTypes.title"></legend>
                    <sxy-input ng-show="$ctrl.current.kind == 'averageHourlyPay'" model="form.salaryTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.kind == 'averageHourlyPay'" sxy-text="SALAXY.MODEL.PayStatsTypeDefinition.workingTimeTypes.title"></legend>
                    <sxy-input ng-show="$ctrl.current.kind == 'averageHourlyPay'" format="undefined" model="form.minWorkingTime"></sxy-input>
                    <sxy-input ng-show="$ctrl.current.kind == 'averageHourlyPay'" model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                    <sxy-code-editor ng-show="$ctrl.current.kind == 'script'" ng-model="$ctrl.current.script"></sxy-code-editor>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="employeeGroups-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.MODEL.CalculationSettings.employeeGroups.title"></span></legend>
              <sxy-input model="form.calc.employeeGroups">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.EmployeeGroupDefinition.title"></legend>
                    <sxy-input model="form.id" require="true" read-only="{{$ctrl.logic.isReadOnly}}"></sxy-input>
                    <sxy-input model="form.name"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="configs-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.MODEL.CompanyAccountSettings.configs.title"></span></legend>
              <sxy-input model="form.configs" include="name,data">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.BizConfig.title"></legend>
                    <sxy-input require="true" model="form.name"></sxy-input>
                    <salaxy-input-collective-bargain-agreement name="cbaCode" ng-model="$ctrl.current.cbaCode" label="SALAXY.MODEL.BizConfig.cbaCode.title"></salaxy-input-collective-bargain-agreement>
                    <salaxy-input-employee-group name="employeeGroup" ng-model="$ctrl.current.employeeGroup" label="SALAXY.MODEL.BizConfig.employeeGroup.title"></salaxy-input-employee-group>
                    <sxy-input model="form.disabled"></sxy-input>
                    <sxy-input model="form.startDate"></sxy-input>
                    <sxy-input model="form.endDate"></sxy-input>
                    <salaxy-input-enum ng-model="$ctrl.current.dataType" name="dataType" label="SALAXY.MODEL.BizConfig.dataType.title" options="{
                      'string': 'Teksti',
                      'number': 'Luku',
                      'boolean': 'Kyllä/Ei'
                     }"></salaxy-input-enum>
                     <salaxy-input ng-show="!$ctrl.current.dataType || $ctrl.current.dataType === 'string'" ng-model="$ctrl.current.data" name="dataString" label="SALAXY.MODEL.BizConfig.data.title"></salaxy-input>
                     <salaxy-input-number ng-show="$ctrl.current.dataType == 'number'" ng-model="$ctrl.current.data"  name="dataNumber" label="SALAXY.MODEL.BizConfig.data.title"></salaxy-input-number>
                     <salaxy-input-boolean ng-show="$ctrl.current.dataType == 'boolean'" ng-model="$ctrl.current.data" name="dataBoolean" label="SALAXY.MODEL.BizConfig.data.title"></salaxy-input-boolean>
                    <sxy-input model="form.updatedAt" read-only="true"></sxy-input>
                    <sxy-input model="form.updatedBy" read-only="true"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="readonly-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.pricing"></span> <span ng-if="$ctrl.current.partner.accountId" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.pricing.pricingModel" read-only="true"></sxy-input>
              <sxy-input model="form.partner.serviceModel.pricing.fixedFee" read-only="true"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.webApp"></span> <span class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.site.webApp" read-only="true"></sxy-input>
              <sxy-input model="form.partner.serviceModel.site.webAppUrl" read-only="true"></sxy-input>
              <sxy-input model="form.partner.serviceModel.site.webAppName" read-only="true"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.branding"></span> <span class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.branding.logo" read-only="true"></sxy-input>
              <sxy-input model="form.partner.serviceModel.branding.skin" read-only="true"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.MODEL.FormsSettings.title"></span> <span
                  ng-if="!$ctrl.current.forms.denyServiceModel && $ctrl.current.partner.serviceModel.features.forms" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.forms" label="SALAXY.NG1.ProSettingsComponent.customForms" read-only="true"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="Tulorekisterin varmenne"></span> <span
                  ng-if="$ctrl.current.partner.serviceModel.features.irDelivery" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.irDelivery" label="Tilitoimiston asettama varmenne käytössä" read-only="true"></sxy-input>
            </fieldset>
          </div>
        </div>
      </div>
    </sxy-form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/RowTypesSettings.html",`<div class="salaxy-component salaxy-pro-settings" ng-class="'salaxy-pro-settings-' + $ctrl.mode"
  ng-if="$ctrl.current" ng-switch="$ctrl.mode">
  <div ng-switch-when="custom">
    <div class="d-flex mb-3 align-items-center">
      <div class="btn-group">
        <button id="categories" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" ng-disabled="disabled">
          Kategoriat
        </button>
        <ul class="dropdown-menu" aria-labelledby="categories">
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = null">All categories (no filter)</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['salary', 'salaryCalc', 'holidays', 'salaryAdditions']">Salaries and additions</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['benefits']">Benefits</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['expenses']">Expenses</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['deductions']">Deductions</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['other']">Other</a></li>
        </ul>
      </div>
      <div class="form-horizontal ms-2 flex-grow-1">
        <salaxy-input name="calcRowTypeSearch" ng-model="$ctrl.searchText" label="Search name and description"></salaxy-input>
      </div>
    </div>
    <ng-include src="'salaxy-components/settings/RowTypesSettings_table.html'"></ng-include>
  </div>
  <div ng-switch-when="prices">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th colspan="2">Palkkalajien hinnat</th>
          <th class="right" sxy-text="SALAXY.NG1.DateRange.labelStartAndEndDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.price"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.pricesList">
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td style="width: 40%;">
            <div>{{$ctrl.getMessagePlaceholderText(row)}}</div>
            <div><small><code>{{ row.type }}{{ row.data.kind ? "/" + row.data.kind : "" }}</code></small>  &nbsp;</div>
          </td>
          <td class="right middle">
            <div>{{ row.period | sxyDateRange }}&nbsp;&nbsp;</div>
          </td>
          <td class="right">
            <salaxy-input-number name="{{ 'iptPrice' + row.rowIndex }}" ng-model="row.price" label-type="plain"  disabled="$ctrl.isDisabled(row, 'price')" require="true"></salaxy-input-number>
          </td>
          <td class="right" style="width: 120px;">
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}"><i class="bi bi-pencil-fill"></i></button>
            <button type="button" class="btn btn-danger" ng-click="$ctrl.delete(row)"><i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td class="middle">
            Lisää hinta:
          </td>
          <td>
            <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder"
              on-row-changed="$ctrl.commitNewRow('price', false)" categories="$ctrl.categories" clear-on-select="true"></salaxy-calc-row-type>
          </td>
          <td>
            <button type="button" class="btn btn-default" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-circle-fill text-primary me-2"></i> <span
                sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <div ng-switch-when="copy">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th colspan="2">Laskelmalle kopioitavat rivit</th>
          <th class="right" sxy-text="SALAXY.NG1.DateRange.labelStartAndEndDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.price"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.copyRowsList">
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td style="width: 40%;">
            <div>{{$ctrl.getMessagePlaceholderText(row)}}</div>
            <div><small><code>{{ row.type }}{{ row.data.kind ? "/" + row.data.kind : "" }}</code></small>  &nbsp;</div>
          </td>
          <td class="right middle">
            <div>{{ row.period | sxyDateRange }}&nbsp;&nbsp;</div>
          </td>
          <td class="right">
            <salaxy-input-number name="{{ 'iptPrice' + row.rowIndex }}" ng-model="row.price" label-type="plain"  disabled="$ctrl.isDisabled(row, 'price')" require="true"></salaxy-input-number>
          </td>
          <td class="right">
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}"><i class="bi bi-pencil-square"></i></button>
            <button type="button" class="btn btn-danger" ng-click="$ctrl.delete(row)"><i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td class="middle">
            Lisää kopioitava rivi:
          </td>
          <td>
            <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder"
              on-row-changed="$ctrl.commitNewRow('copy', false)" categories="$ctrl.categories"></salaxy-calc-row-type>
          </td>
          <td>
            <button type="button" class="btn btn-default" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-lg text-primary"></i> <span
                sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <div ng-switch-when="defaults">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th colspan="2">Oletusrivit</th>
          <th class="right" sxy-text="SALAXY.NG1.DateRange.labelStartAndEndDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.defaultsList">
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td style="width: 40%;">
            <div>{{row.message || ( "CalculationRowType." + row.rowType | sxyEnum) }}</div>
            <div>{{row.data.kind }}&nbsp;</div>
          </td>
          <td class="right middle">
            <div>{{ row.period | sxyDateRange }}&nbsp;&nbsp;</div>
          </td>
          <td class="right">
            <salaxy-input-number name="{{ 'iptPrice' + row.rowIndex }}" ng-model="row.price" label-type="plain"  disabled="$ctrl.isDisabled(row, 'price')" require="true"></salaxy-input-number>
          </td>
          <td class="right">
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}">
              <i class="bi bi-info-circle-fill" ng-class="$ctrl.current == row ? 'bi-arrow-right-circle-fill' : 'bi-info-circle'"></i></button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td class="middle">
            Lisää oletusrivi:
          </td>
          <td>
            <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder"
              on-row-changed="$ctrl.commitNewRow('manualRow', true)" categories="$ctrl.categories"></salaxy-calc-row-type>
          </td>
          <td>
            <button type="button" class="btn btn-default" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-circle-fill text-primary me-2"></i> <span
                sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <div ng-switch-when="debugger">
    <salaxy-json-formatter key="'Rivit'" json="$ctrl.list" open="1"></salaxy-json-formatter>
    <hr />
    <salaxy-calc-rows-editor ng-if="!$ctrl.isLoading" rows="$ctrl.list"
      title="{{ 'SALAXY.NG1.WorkerDetailsComponent.defaultCalcRows' | sxyTranslate }}" type="salary-defaults"></salaxy-calc-rows-editor>
  </div>
  <div ng-switch-default>
    <div class="d-flex mb-3 align-items-center">
      <div class="btn-group">
        <button id="categories" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" ng-disabled="disabled">
          Kategoriat
        </button>
        <ul class="dropdown-menu" aria-labelledby="categories">
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = null">All categories (no filter)</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['salary', 'salaryCalc', 'holidays', 'salaryAdditions']">Salaries and additions</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['benefits']">Benefits</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['expenses']">Expenses</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['deductions']">Deductions</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['other']">Other</a></li>
        </ul>
      </div>
      <div class="form-horizontal ms-2 flex-grow-1">
        <salaxy-input name="calcRowTypeSearch" ng-model="$ctrl.searchText" label="Search name and description"></salaxy-input>
      </div>
    </div>
    <ng-include src="'salaxy-components/settings/RowTypesSettings_table.html'"></ng-include>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/RowTypesSettings_table.html",`<div class="salaxy-calc-row-type-table">
  <div>
    <div class="d-flex my-1 py-1 border-bottom ps-2" style="background-color: #f5f5f5;">
      <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="{ color: 'rgb(79, 205, 196)', initials: 'type', entityType: 'company' }"></salaxy-avatar>
      <div class="description w-100">
        <div class="flex-grow-1 row">
          <strong class="col-6" sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowType" ps=" (type)"></strong>
          <strong class="col-6" sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowTypeEn"></strong>
        </div>
        <div sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowDescription" class="border-bottom py-1 mb-1"></div>
        <div class="flex-grow-1 row">
          <div class="col-6" sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowKind" ps=" (kind)"></div>
          <div class="col-6" sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowKindEn"></div>
        </div>
      </div>
      <div style="width: 140px;"></div>
  </div>
  <div>
    <div class="d-flex my-1 py-1 border-bottom ps-2" ng-repeat="item in $ctrl.getCachedSearch($ctrl.searchText, true)">
      <salaxy-avatar ng-if="item.ui.iconText" class="salaxy-calc-row-type-avatar me-2" avatar="{ color: item.ui.color, initials: item.ui.iconText, entityType: 'company' }"></salaxy-avatar>
      <div class="description w-100">
        <div ng-if="item.ui.iconText" class="row">
          <strong class="col-6 salaxy-highlight" ng-bind-html="item.text | uibTypeaheadHighlight:$ctrl.searchText"></strong>
          <strong class="col-6 salaxy-highlight" ng-bind-html="item.value | uibTypeaheadHighlight:$ctrl.searchText"></strong>
        </div>
        <div ng-if="!item.ui.iconText">
          <div class="salaxy-highlight" ng-bind-html="item.text | uibTypeaheadHighlight:$ctrl.searchText"></div>
          <div class="salaxy-highlight" ng-bind-html="item.value.split('.')[1] | uibTypeaheadHighlight:$ctrl.searchText"></div>
        </div>
        <div class="salaxy-highlight" ng-bind-html="item.title | uibTypeaheadHighlight:$ctrl.searchText"></div>
      </div>
      <div class="actions" style="width: 140px;">
        <div class="btn-group" ng-if="item.ui.group == 'builtIn'">
          <button type="button" class="btn btn-primary" ng-click="$ctrl.showRowTypeDetails(item)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate }}">
            <i class="bi bi-info-circle-fill" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-info" ng-click="$ctrl.createCustomRowType(item)" title="Räätälöi">
            <i class="bi bi-plus-square-fill" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-default" ng-click="$ctrl.copyToClipboard(item.ui.type)" title="Kopioi ID leikepöydälle">
            <i class="bi bi-clipboard" aria-hidden="true"></i>
          </button>
        </div>
        <div class="btn-group" ng-if="item.ui.group != 'builtIn'">
          <button type="button" class="btn btn-primary" ng-click="$ctrl.showRowTypeDetails(item)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate }}">
            <i class="bi bi-pencil-fill" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-danger" ng-click="$ctrl.deleteCustomRowType(item)" title="Poista">
            <i class="bi bi-trash-fill" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-default" ng-click="$ctrl.copyToClipboard(item.ui.type)" title="Kopioi ID leikepöydälle">
            <i class="bi bi-clipboard" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/settings/ServiceModelDetails.html",`<style>
  /* TODO: Move to less */
  
  .salaxy-workspace {
    display: flex;
  }
  
  .salaxy-workspace-navi {
    flex: 0 0 200px;
  }
  
  .salaxy-workspace-content {
    flex: 1 1 100%;
    margin-left: -1px;
    height: calc(100vh - 200px);
    overflow-y: auto;
    border: solid 1px #009fd8;
    padding: 10px;
  }
  
  .salaxy-workspace-content .container {
    margin-left: 0px;
  }
</style>
<!--

TODO-lista:

Työnkulut:

- Itsepalvelu (Asiakas yksin)
- Tilitoimisto tekee laskelman => Hyväksyntä => Tilitoimisto maksaa
- Tilitoimisto tekee laskelman => Hyväksyntä => Asiakas maksaa
- Asiakas tekee laskelman => PRO Tarkistaa => Asiakas maksaa
- Asiakas tekee laskelman => PRO Tarkistaa => Tilitoimisto maksaa

Flagit:

- Aineiston lähetys: Näkyvissä / ei
- Yritys: Maksaako vai hyväksyykö?

Mietittävä:

- Entäs useita?
- Saako muokata (osana hyväksyntää)?
- Palkkalaskelman (Salary Slip) lähetys
  - Notifikaatiot

-->
<div class="salaxy-component salaxy-service-model-details">

  <div class="btn-toolbar" style="margin-left: 195px; margin-bottom: 2px;">
    <div class="btn-group">
      <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly || $ctrl.isReadOnly" ng-click="$ctrl.saveServiceModel()" sxy-text="SALAXY.UI_Terms.save"></button>
      </button>
      <button type="button" class="btn btn-default" ng-disabled="$ctrl.isReadOnlyForced" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"> </button>
      <button class="btn btn-default" ng-click="$ctrl.reload()" title="{{ 'SALAXY.UI_Terms.refresh' | sxyTranslate}}"><i class="bi bi-arrow-repeat" aria-hidden="true"></i></button>
    </div>
    
    <div class="btn-group ms-1">
        <div class="d-flex" style="line-height: 34px;">
          <strong><span sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.name" ps=":"></span></strong> {{$ctrl.current.name}}
        </div>
    </div>
    <div class="btn-group ms-auto">
      <button type="button" class="btn btn-danger" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly || $ctrl.isReadOnly" ng-click="$ctrl.delete($ctrl.current)" sxy-text="Poista (test)" ng-if="'test' | sxyIsInRole" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></button>
    </div>
  </div>
  <div ng-if="$ctrl.current">
    <sxy-form open-api="salaxy-secure/schemas/v02.json" type="ServiceModel" auto-gen="false" debugger="false" model="$ctrl.current" read-only="{{$ctrl.isReadOnly}}">
      <div ng-init="$ctrl.currentSection = 'basicInfo'" class="salaxy-workspace">
        <div class="salaxy-workspace-navi">
          <salaxy-toggle-buttons ng-model="$ctrl.currentSection" 
            options="[
              { value: 'basicInfo', label: 'SALAXY.NG1.ServiceModelDetailsComponent.basicInfo' },
              { value: 'exports', label: 'SALAXY.NG1.ServiceModelDetailsComponent.exports' },
              { value: 'branding', label: 'SALAXY.NG1.ServiceModelDetailsComponent.branding' },
              { value: 'sitemap', label: 'SALAXY.NG1.ServiceModelDetailsComponent.sitemap' },
              { value: 'messaging', label: 'SALAXY.NG1.ServiceModelDetailsComponent.messaging' },
              { value: 'i18n', label: 'SALAXY.NG1.ServiceModelDetailsComponent.i18n' },
              { value: 'workflow', label: 'SALAXY.NG1.ServiceModelDetailsComponent.workflow' },
              { value: 'usecases', label: 'SALAXY.NG1.ServiceModelDetailsComponent.usecases' },
              { value: 'irdelivery', label: 'SALAXY.NG1.ServiceModelDetailsComponent.irdelivery' },
              { value: 'advanced', label: 'Tech' }
            ]"
            type="block">
          </salaxy-toggle-buttons>
        </div>
        <div class="salaxy-workspace-content">
          <div ng-if="$ctrl.currentSection == 'basicInfo'" class="form-horizontal container">
            <div class="row">
              <div class="col-sm-8">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.serviceModelTitle"></legend>
                  <p><strong sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.serviceModelId" ps=":"></strong> {{ $ctrl.current.id + "@" + $ctrl.current.owner }}</p>
                  <sxy-input model="form.name"></sxy-input>
                  <sxy-input model="form.icon" label="SALAXY.NG1.ServiceModelDetailsComponent.serviceModelIcon"></sxy-input>
                </fieldset>
              </div>
              <div class="col-sm-4 text-center">
                <img ng-if="$ctrl.current.icon" ng-src="{{ $ctrl.current.icon }}" style="width: 100px; margin-top: 60px;" />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.endUserPricing"></legend>
                  <sxy-input model="form.pricing.pricingModel"></sxy-input>
                  <sxy-input model="form.pricing.fixedFee" ng-if="$ctrl.current.pricing.pricingModel == 'fixedFee'"></sxy-input>
                </fieldset>
              </div>
              <div class="col-sm-4"></div>
            </div>
          </div>
          <div ng-if="$ctrl.currentSection == 'exports'" class="form-horizontal container">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.paymentChannelsTitle"></legend>
              <sxy-input model="form.features.payments" format="switch" label="SALAXY.NG1.ServiceModelDetailsComponent.customPaymentChannels"></sxy-input>
              <div ng-if="$ctrl.current.features.payments">
                <sxy-input template-url="salaxy-components/sxy-form/custom-templates/array-service-model-payment-channels.html" model="form.payments.channels">
                  <form>
                    <fieldset>
                      <sxy-input model="form.channel"></sxy-input>
                      <sxy-input model="form.isAvailable"></sxy-input>
                      <sxy-input model="form.isEnabled"></sxy-input>
                    </fieldset>
                  </form>
                </sxy-input>
                <salaxy-input-typeahead read-only="$ctrl.isReadOnly" class="default-channel-input-enum" name="options_type" ng-model="$ctrl.current.payments.defaultChannel" options="$ctrl.getSelectablePaymentChannels()" ng-if="$ctrl.getSelectablePaymentChannels().length &gt; 1"
                  disable-cache="true" label="SALAXY.NG1.ServiceModelDetailsComponent.defaultChannel"></salaxy-input-typeahead>
              </div>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.accountingTitle"></legend>
              <sxy-input model="form.features.accounting" format="switch" label="SALAXY.NG1.ServiceModelDetailsComponent.customAccounting"></sxy-input>
              <div ng-if="$ctrl.current.features.accounting">
                <sxy-input model="form.accounting.defaultPeriodDateKind"></sxy-input>
                <sxy-input template-url="salaxy-components/sxy-form/custom-templates/array-accounting-targets.html" model="form.accounting.targets">
                  <form>
                    <fieldset ng-show="!$ctrl.logic.showDelete" ng-controller="ServiceModelCrudController as $serviceModelController" ng-init="$ctrl.logic.isReadOnly = true">
                      <salaxy-odata-table crud-controller="AccountingTargetCrudController as $crud" template-url="salaxy-components/odata/lists/AccountingTargetSelect.html" selected-items="$ctrl.selectedItems" on-list-select="$serviceModelController.onAccountingTargetSelect($ctrl.current, $ctrl.logic, value, item, allItems)">
                      </salaxy-odata-table>
                    </fieldset>
                    <fieldset ng-show="$ctrl.logic.showDelete" ng-init="$ctrl.logic.isReadOnly = false">
                      <salaxy-input-enum disabled="false" name="format" label="SALAXY.NG1.AccountingTargetDetailsComponent.excelCsvFormat" ng-model="$ctrl.current.format"
                        options="{
                          '36dff2e2-e181-4f0d-9004-0e4aa92f5e17': 'Palkkaus.fi',
                          '0db4e85f-93a8-46f1-b6d2-f7523d289d88': 'Fennoa',
                          '8613f133-3fce-4611-b372-51f6a2e007dd': 'Procountor',
                          'e62c10b0-222a-4170-b8b4-b1e02d9a7644': 'Passeli Merit',
                          '53fd3863-b8f9-4909-86c9-cb4597595181': 'Heeros',
                          '2fc7899c-7a3d-4d56-ad2f-05d52782bbbc': 'Asteri',
                          '0a2bd312-06da-4862-aef5-75166e0bf461': 'Maestro',
                          'c04e0757-63f3-420d-a183-3427710fc954': 'Visma Fivaldi',
                          'ba271dac-dd63-4036-9d70-053a09ca4d9e' :'Visma Netvisor',
                          '27e271d5-41f5-4319-ab29-4d5d9eb945c6': 'Lemonsoft',
                          'd311f9d3-8c3a-4fd8-a665-8e3698e41e87': 'Tampuuri',
                          'd58e95b7-d0b5-40ac-992b-6d3b29efc45e': 'Domus',
                          '54e93c5f-bd74-4157-8a74-3515be7f585d': 'Oscar Software',
                          '0e4f0a71-dcb9-43ba-9028-0239e674711f': 'Digia Enterprise',
                          '2ccefa46-7992-46c5-9d87-b88336935916': 'Digia Enterprise - VILPE',
                          'c36c24b9-5e2c-4f44-b67a-90d81aeea257': 'iScala'
                        }">
                      </salaxy-input-enum>
                      <sxy-input model="form.method" read-only="false"></sxy-input>
                      <salaxy-input-enum disabled="false" enum="ExportMethod" label="SALAXY.MODEL.AccountingTargetSettings.availableMethods.title" name="availableMethods" type="multi-select" ng-model="$ctrl.current.availableMethods"></salaxy-input-enum>
                    </fieldset>
                  </form>
                </sxy-input>
                <salaxy-input-typeahead name="options_type" ng-model="$ctrl.current.accounting.defaultTargetId" options="$ctrl.getSelectableAccountingTargets()" disable-cache="true" ng-if="$ctrl.getSelectableAccountingTargets().length &gt; 1" label="SALAXY.NG1.ServiceModelDetailsComponent.defaultTarget"></salaxy-input-typeahead>
              </div>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.MODEL.ServiceModelCostAccounting.title"></legend>
              <sxy-input model="form.features.costAccounting" format="switch" label="SALAXY.NG1.ServiceModelDetailsComponent.customCostAccounting"></sxy-input>
              <div ng-if="$ctrl.current.features.costAccounting">
                <sxy-input model="form.costAccounting.dimensions" include="id,label,scope">
                  <form>
                    <fieldset>
                      <legend sxy-text="SALAXY.MODEL.CostAccountingDimensionDefinition.title"></legend>
                      <sxy-input model="form.id" read-only="{{$ctrl.logic.showDelete}}"></sxy-input>
                      <sxy-input model="form.label"></sxy-input>
                      <sxy-input model="form.allowCostSharing"></sxy-input>
                      <sxy-input model="form.scope"></sxy-input>
                      <sxy-input model="form.options" template-url="salaxy-components/sxy-form/custom-templates/cost-accounting-options.html"></sxy-input>
                    </fieldset>
                  </form>
                </sxy-input>
              </div>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.MODEL.ServiceModelHoliday.title"></legend>
              <sxy-input model="form.features.holiday" format="switch" label="SALAXY.NG1.ServiceModelDetailsComponent.customHoliday"></sxy-input>
              <div ng-if="$ctrl.current.features.holiday">
                <sxy-input model="form.holiday.holidayPaySettings" include="holidayPayCalculation">
                  <form>
                    <fieldset>
                      <legend sxy-text="SALAXY.MODEL.HolidayPaySettings.title"></legend>
                      <salaxy-input-enum ng-show="!('bizConfigs' | sxyIsInRole)" enum="HolidayPayCalculation" label="SALAXY.MODEL.HolidayPaySettings.holidayPayCalculation.title" name="holidayPayCalculation" filter="averageDailyPay,averageHourlyPay,percentageBasedPay,holidayCompensation" require="true" ng-model="$ctrl.current.holidayPayCalculation" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                      <salaxy-input-enum ng-show="'bizConfigs' | sxyIsInRole" enum="HolidayPayCalculation" label="SALAXY.MODEL.HolidayPaySettings.holidayPayCalculation.title" name="holidayPayCalculation" filter="averageDailyPay,averageHourlyPay,percentageBasedPay,holidayCompensation,scriptPay" require="true" ng-model="$ctrl.current.holidayPayCalculation" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>                     
                      <salaxy-input-collective-bargain-agreement ng-show="'bizConfigs' | sxyIsInRole" name="cbaCode" ng-model="$ctrl.current.cbaCode" label="SALAXY.MODEL.HolidayPaySettings.cbaCode.title"></salaxy-input-collective-bargain-agreement>
                      <salaxy-input-employee-group ng-show="'bizConfigs' | sxyIsInRole" name="employeeGroup" ng-model="$ctrl.current.employeeGroup" label="SALAXY.MODEL.HolidayPaySettings.employeeGroup.title"></salaxy-input-employee-group>
                      <sxy-input model="form.disabled"></sxy-input>
                      <sxy-input model="form.startYear" label="SALAXY.MODEL.HolidayPaySettings.startYear.title"></sxy-input>  
                      <sxy-input model="form.endYear" label="SALAXY.MODEL.HolidayPaySettings.endYear.title"></sxy-input> 
                      <legend  ng-show="$ctrl.current.holidayPayCalculation && $ctrl.current.holidayPayCalculation != 'scriptPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.salaryTypes.title"></legend>
                      <sxy-input  ng-show="$ctrl.current.holidayPayCalculation && $ctrl.current.holidayPayCalculation != 'scriptPay'" model="form.salaryTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                      <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.workingTimeTypes.title"></legend>
                      <sxy-input ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay'" model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                      <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.overtimeTypes.title"></legend>
                      <sxy-input  ng-show="$ctrl.current.holidayPayCalculation == 'averageDailyPay'" model="form.overtimeTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                      <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay' || $ctrl.current.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.multipliers.title"></legend>
                      <salaxy-input-holiday-multipliers ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay' || $ctrl.current.holidayPayCalculation == 'averageDailyPay'" name="multipliers" label="SALAXY.MODEL.HolidayPaySettings.multipliers.title" ng-model="$ctrl.current.multipliers" read-only="$ctrl.logic.isReadOnly"></salaxy-input-holiday-multipliers>
                      <sxy-code-editor ng-show="$ctrl.current.holidayPayCalculation == 'scriptPay'" ng-model="$ctrl.current.script"></sxy-code-editor>
                    </fieldset>
                  </form>
                </sxy-input>
               <sxy-input model="form.holiday.holidayAccrualSettings" include="code">
                  <form>
                    <fieldset>
                      <legend sxy-text="SALAXY.MODEL.HolidayAccrualSettings.title"></legend>
                      <salaxy-input-enum  ng-show="!('bizConfigs' | sxyIsInRole)" enum="HolidayCode" label="SALAXY.MODEL.HolidayAccrualSettings.code.title" name="code" filter="permanent35Hours" require="true" ng-model="$ctrl.current.code" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                      <salaxy-input-enum  ng-show="'bizConfigs' | sxyIsInRole" enum="HolidayCode" label="SALAXY.MODEL.HolidayAccrualSettings.code.title" name="code" filter="permanent35Hours,script" require="true" ng-model="$ctrl.current.code" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                      <salaxy-input-collective-bargain-agreement  ng-show="'bizConfigs' | sxyIsInRole" name="cbaCode" ng-model="$ctrl.current.cbaCode" label="SALAXY.MODEL.HolidayAccrualSettings.cbaCode.title"></salaxy-input-collective-bargain-agreement>
                      <salaxy-input-employee-group  ng-show="'bizConfigs' | sxyIsInRole" name="employeeGroup" ng-model="$ctrl.current.employeeGroup" label="SALAXY.MODEL.HolidayAccrualSettings.employeeGroup.title"></salaxy-input-employee-group>
                      <sxy-input model="form.disabled"></sxy-input>
                      <sxy-input model="form.startYear" label="SALAXY.MODEL.HolidayAccrualSettings.startYear.title"></sxy-input>  
                      <sxy-input model="form.endYear" label="SALAXY.MODEL.HolidayAccrualSettings.endYear.title"></sxy-input> 
                      <legend ng-show="$ctrl.current.code == 'permanent35Hours'" sxy-text="SALAXY.MODEL.HolidayAccrualSettings.workingTimeTypes.title"></legend>
                      <sxy-input  ng-show="$ctrl.current.code == 'permanent35Hours'" model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                      <sxy-code-editor ng-show="$ctrl.current.code == 'script'" ng-model="$ctrl.current.script"></sxy-code-editor>
                    </fieldset>
                  </form>
                </sxy-input>
              </div>
            </fieldset>
            <fieldset  ng-if="'bizConfigs' | sxyIsInRole">
              <legend sxy-text="SALAXY.MODEL.ServiceModelPayStats.title"></legend>
              <sxy-input model="form.features.payStats" format="switch" label="SALAXY.NG1.ServiceModelDetailsComponent.customPayStats"></sxy-input>
              <div ng-if="$ctrl.current.features.payStats">
                <sxy-input model="form.payStats.types" include="id,kind,periodLength,cbaCode,employeeGroup">
                  <form>
                    <fieldset>
                      <legend sxy-text="SALAXY.MODEL.PayStatsTypeDefinition.title"></legend>
                      <sxy-input model="form.id" require="true" read-only="{{$ctrl.logic.isReadOnly}}"></sxy-input>
                      <sxy-input model="form.description"></sxy-input>
                      <salaxy-input-enum enum="PayStatsKind" label="SALAXY.MODEL.PayStatsTypeDefinition.kind.title" name="kind" require="true" ng-model="$ctrl.current.kind" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                      <salaxy-input-enum enum="PayStatsPeriodLength" label="SALAXY.MODEL.PayStatsTypeDefinition.periodLength.title" name="periodLength" require="true" ng-model="$ctrl.current.periodLength" filter="quarter,month,year" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>
                      <salaxy-input-enum enum="PeriodDateKind" label="SALAXY.MODEL.PayStatsTypeDefinition.periodDateKind.title" name="periodDateKind" require="true" ng-model="$ctrl.current.periodDateKind" read-only="$ctrl.logic.isReadOnly"></salaxy-input-enum>                   
                      <salaxy-input-collective-bargain-agreement name="cbaCode" ng-model="$ctrl.current.cbaCode" label="SALAXY.MODEL.PayStatsTypeDefinition.cbaCode.title"></salaxy-input-collective-bargain-agreement>
                      <salaxy-input-employee-group name="employeeGroup" ng-model="$ctrl.current.employeeGroup" label="SALAXY.MODEL.PayStatsTypeDefinition.employeeGroup.title"></salaxy-input-employee-group>
                      <sxy-input model="form.disabled"></sxy-input>
                      <sxy-input model="form.startDate"></sxy-input>
                      <sxy-input model="form.endDate"></sxy-input>
                      <legend ng-show="$ctrl.current.kind == 'averageHourlyPay'" label="SALAXY.MODEL.PayStatsTypeDefinition.salaryTypes.title"></legend>
                      <sxy-input ng-show="$ctrl.current.kind == 'averageHourlyPay'" model="form.salaryTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                      <legend ng-show="$ctrl.current.kind == 'averageHourlyPay'" sxy-text="SALAXY.MODEL.PayStatsTypeDefinition.workingTimeTypes.title"></legend>
                      <sxy-input ng-show="$ctrl.current.kind == 'averageHourlyPay'" format="undefined" model="form.minWorkingTime"></sxy-input>
                      <sxy-input ng-show="$ctrl.current.kind == 'averageHourlyPay'" model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html"></sxy-input>
                      <sxy-code-editor ng-show="$ctrl.current.kind == 'script'" ng-model="$ctrl.current.script"></sxy-code-editor>
                    </fieldset>
                  </form>
                </sxy-input>
              </div>
            </fieldset>
          </div>
          <div ng-if="$ctrl.currentSection == 'branding'" class="form-horizontal container">
            <div class="row">
              <div class="col-sm-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.webAppTitle"></legend>
                  <sxy-input model="form.site.webApp"></sxy-input>
                  <sxy-input model="form.site.webAppUrl"></sxy-input>
                  <sxy-input model="form.site.webAppName"></sxy-input>
                </fieldset>
              </div>
              <div class="col-sm-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.reportingTitle"></legend>
                  <sxy-input model="form.features.reporting" label="SALAXY.NG1.ServiceModelDetailsComponent.customReporting"></sxy-input>
                  <salaxy-input-enum ng-model="$ctrl.current.reporting.layoutTemplateId" name="layputTemplateId" label="SALAXY.NG1.ServiceModelDetailsComponent.layoutTemplateId" options="{'palkkaus-report-options@FI53POYS0025543933': ('SALAXY.NG1.ServiceModelDetailsComponent.templateIdPalkkaus' | sxyTranslate),
                      'no-logo-report-options@FI53POYS0025543933': ('SALAXY.NG1.ServiceModelDetailsComponent.templateIdNoLogo' | sxyTranslate),
                      'logo-report-options@FI53POYS0025543933': ('SALAXY.NG1.ServiceModelDetailsComponent.templateIdLogo' | sxyTranslate),
                      'kevytyrittaja-report-options@FI06POYT0009439335': ('SALAXY.NG1.ServiceModelDetailsComponent.templateIdTalenom' | sxyTranslate),
                      'tilijaska-report-options@FI39POYT0025590211': ('SALAXY.NG1.ServiceModelDetailsComponent.templateIdTilijaska' | sxyTranslate),
                      'treamer-report-options@FI86POYI0028244891': ('SALAXY.NG1.ServiceModelDetailsComponent.templateIdTreamer' | sxyTranslate)}" read-only="$ctrl.isReadOnly"></salaxy-input-enum>
                  <salaxy-textarea maxlength="" label="SALAXY.NG1.ServiceModelDetailsComponent.customReportLogo" name="logo" ng-model="$ctrl.current.reporting.logo" rows="3" ng-if="$ctrl.current.reporting.layoutTemplateId == 'logo-report-options@FI53POYS0025543933'">
                  </salaxy-textarea>
                </fieldset>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.brandingTitle"></legend>
                  <sxy-input model="form.branding.logo"></sxy-input>
                  <sxy-input model="form.branding.skin"></sxy-input>
                </fieldset>
              </div>
              <div class="col-sm-4 text-center">
                <img ng-if="$ctrl.current.branding.logo" ng-src="{{ $ctrl.current.branding.logo }}" style="width: 100px; margin-top: 35px;" />
              </div>
            </div>
          </div>
          <div ng-if="$ctrl.currentSection == 'sitemap'" class="form-horizontal height100">
            <div class="row height100" style="width: 95%;">
              <div class="col-6 height100" style="width: 45%; overflow-y: auto">
                <div class="btn-toolbar">
                  <div class="btn-group">
                    <button type="button" class="btn btn-default" ng-click="$ctrl.showHideAll(true)">Avaa kaikki</button>
                    <button type="button" class="btn btn-default" ng-click="$ctrl.showHideAll(false)">Sulje kaikki</button>
                  </div>
                  <button type="button" ng-disabled="$ctrl.isReadOnly" class="btn btn-danger" ng-click="$ctrl.resetSitemapChanges()">Palauta kaikki</button>
                </div>
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th colspan="3">Title</th>
                      <th class="right">Flags</th>
                      <th class="right">Roles</th>
                      <th class="right">Changes</th>
                      <th colspan="2"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr ng-repeat-start="level1 in $ctrl.sitemap" class="clickable" ng-class="{ 'active': $ctrl.currentSitemapNode == level1 }">
                      <td colspan="3" ng-click="$ctrl.currentSitemapNode = level1">{{ $ctrl.translate(level1.title) }}</td>
                      <td class="right" ng-click="$ctrl.currentSitemapNode = level1">
                        <i ng-class="'bi ' + icon" ng-repeat="icon in level1.$edit.$faIcons" aria-hidden="true"></i>
                      </td>
                      <td class="right" ng-click="$ctrl.currentSitemapNode = level1">
                        <span ng-if="$ctrl.getIsTest(level1)" class="badge bg-primary"><span class="small">test</span></span>
                        <span>{{ $ctrl.getRoles(level1) }}</span>
                      </td>
                      <td class="right" ng-click="$ctrl.currentSitemapNode = level1">
                        <i class="bi bi-translate text-primary" ng-if="level1.$edit.$hasTextChanges" aria-hidden="true"></i>
                        <i class="bi bi-pencil-square text-primary" ng-if="level1.$edit.$hasChanges" aria-hidden="true"></i>
                        <i class="bi bi-pencil-square" ng-if="level1.$edit.$hasChildrenChanges" aria-hidden="true"></i>
                      </td>
                      <td colspan="2" class="right" ng-if="level1.children.length" ng-click="level1.$edit.$isOpen = !level1.$edit.$isOpen">
                        <i class="bi" ng-class="level1.$edit.$isOpen ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
                      </td>
                      <td colspan="2" ng-if="!level1.children.length"></td>
                    </tr>
                    <tr ng-if="level1.$edit.$isOpen" ng-repeat-start="level2 in level1.children" class="clickable" ng-class="{ 'active': $ctrl.currentSitemapNode == level2 }">
                      <td style="width: 10px;">-</td>
                      <td colspan="2" ng-click="$ctrl.currentSitemapNode = level2">{{ $ctrl.translate(level2.title) }}</td>
                      <td class="right" ng-click="$ctrl.currentSitemapNode = level2">
                        <i ng-class="'bi ' + icon" ng-repeat="icon in level2.$edit.$faIcons" aria-hidden="true"></i>
                      </td>
                      <td class="right" ng-click="$ctrl.currentSitemapNode = level2">
                        <span ng-if="$ctrl.getIsTest(level2)" class="badge bg-primary"><span class="small">test</span></span>
                        <span>{{ $ctrl.getRoles(level2) }}</span>
                      </td>
                      <td class="right" ng-click="$ctrl.currentSitemapNode = level2">
                        <i class="bi bi-translate text-primary" ng-if="level2.$edit.$hasTextChanges" aria-hidden="true"></i>
                        <i class="bi bi-pencil-square text-primary" ng-if="level2.$edit.$hasChanges" aria-hidden="true"></i>
                        <i class="bi bi-pencil-square" ng-if="level2.$edit.$hasChildrenChanges" aria-hidden="true"></i>
                      </td>
                      <td ng-if="level2.children.length" ng-click="level2.$edit.$isOpen = !level2.$edit.$isOpen">
                        <i class="bi" ng-class="level2.$edit.$isOpen ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
                      </td>
                      <td ng-if="!level2.children.length"></td>
                      <td></td>
                    </tr>
                    <tr ng-if="level1.$edit.$isOpen && level2.$edit.$isOpen" ng-repeat-end ng-repeat="level3 in level2.children" class="clickable" ng-click="$ctrl.currentSitemapNode = level3" ng-class="{ 'active': $ctrl.currentSitemapNode == level3 }">
                      <td style="width: 10px;">&nbsp;</td>
                      <td style="width: 10px;">-</td>
                      <td>{{ $ctrl.translate(level3.title) }}</td>
                      <td class="right">
                        <i ng-class="'bi ' + icon" ng-repeat="icon in level3.$edit.$faIcons" aria-hidden="true"></i>
                      </td>
                      <td class="right">
                        <span ng-if="$ctrl.getIsTest(level3)" class="badge bg-primary"><span class="small">test</span></span>
                        <span>{{ $ctrl.getRoles(level3) }}</span>
                      </td>
                      <td class="right">
                        <i class="bi bi-translate text-primary" ng-if="level3.$edit.$hasTextChanges" aria-hidden="true"></i>
                        <i class="bi bi-pencil-square text-primary" ng-if="level3.$edit.$hasChanges" aria-hidden="true"></i>
                        <i class="bi bi-pencil-square" ng-if="level3.$edit.$hasChildrenChanges" aria-hidden="true"></i>
                      </td>
                      <td colspan="2"></td>
                    </tr>
                    <tr ng-repeat-end ng-if=0></tr>
                  </tbody>
                </table>
              </div>
              <div class="col-6">
                <div class="btn-toolbar">
                  <button type="button" ng-disabled="$ctrl.isReadOnly" class="btn btn-danger" ng-click="$ctrl.resetSitemapNode(true)">Palauta muutokset</button>
                  <div class="btn-group ms-auto">
                    <button type="button" ng-disabled="$ctrl.isReadOnly" class="btn btn-default" ng-click="$ctrl.resetSitemapNode()">Peruuta</button>
                    <button type="button" ng-disabled="$ctrl.isReadOnly" class="btn btn-primary" ng-click="$ctrl.commitSitemapNode()">OK</button>
                  </div>
                </div>

                <h3>{{ $ctrl.translate($ctrl.currentSitemapNode.title) }} <small>({{ $ctrl.currentSitemapNode.$edit.$id }})</small></h3>
                <salaxy-tab-buttons
                  current-tab="$ctrl.SitemapActive"
                  options="[
                    { value: 'general', text: 'Perustiedot' },
                    { value: 'params', text: 'Parametrit' },
                    { value: 'i18n', text: 'Tekstit' },
                    { value: 'debug', text: 'Debug' }
                  ]"
                  tabs-id="serviceModelDetails">
                </salaxy-tab-buttons>
                <div class="tab-content" id="tab-content-serviceModelDetails">
                  <div class="tab-pane" id="general-tab">
                    <div class="form-horizontal">
                      <salaxy-input name="id" read-only="true" ng-model="$ctrl.currentSitemapNode.$edit.$id" label="Id"></salaxy-input>
                      <salaxy-input name="url" read-only="true" ng-model="$ctrl.currentSitemapNode.url" label="SALAXY.NG1.ServiceModelDetailsComponent.url"></salaxy-input>
                      <salaxy-input-enum name="visibility" enum="SitemapVisibility" label="Näkyvyys ({{ 'SitemapVisibility.' + ($ctrl.currentSitemapNode.visibility || 'visible') | sxyEnum }})" ng-model="$ctrl.currentSitemapNode.$edit.visibility" read-only="$ctrl.isReadOnly"></salaxy-input-enum>
                      <salaxy-input name="roles" ng-model="$ctrl.currentSitemapNode.$edit.roles" label="Roolit ({{ $ctrl.currentSitemapNode.roles || '-' }})" read-only="$ctrl.isReadOnly"></salaxy-input>
                      <salaxy-input-boolean name="isFullWidth" type="select" label="Leveä näyttö ({{ $ctrl.currentSitemapNode.isFullWidth ? 'Kyllä' : 'Ei' }})" ng-model="$ctrl.currentSitemapNode.$edit.isFullWidth" read-only="$ctrl.isReadOnly"></salaxy-input-boolean>
                      <div class="row">
                        <div ng-if="$ctrl.currentSitemapNode.$edit.isFullWidth != null" class="col-sm-6 offset-sm-4">
                          <button type="button" class="btn btn-default btn-xs" ng-click="$ctrl.currentSitemapNode.$edit.isFullWidth = null">Palauta oletus</button>
                        </div>
                      </div>
                      <fieldset>
                        <legend>Sivun otsikko</legend>
                        <small><p>Klikkaa muokataksesi kieliversioita. HUOM: Muutokset menevät suoraan kieliversiointiin, "Peruuta"/"OK"-nappuloila yllä ei ole vaikutusta. Käytä delete-nappia alla erikseen poistaaksesi muutokset.</p></small>
                        <div style="padding-left: 10px;">
                          <salaxy-ui-translator mode="fieldset" texts="$ctrl.current.site.texts" filter="$ctrl.currentSitemapNode.$edit.$i18nKey"></salaxy-ui-translator>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div class="tab-pane" id="params-tab">
                    <sxy-form open-api="SitemapParams" open-api-doc="$ctrl.getSitemapParamsSchema()" type="{{$ctrl.currentSitemapNode.$edit.$id}}" auto-gen="true" model="$ctrl.currentSitemapNode.$edit" read-only="{{$ctrl.isReadOnly}}"></sxy-form>
                  </div>
                  <div class="tab-pane" id="i18n-tab">
                    <div class="alert alert-info"><strong>HUOM!</strong> Suurin osa teksteistä on komponenttien tekstejä. Niiden muokkaaminen vaikuttaa kaikkiin sivuihin, joissa komponentti on käytössä: Ei pelkästään tähän sivuun.</div>
                      <div ng-if="!$ctrl.currentSitemapNode.i18n.length">Käännöstekstejä ei ole määritetty tälle sivulle.</div>
                      <salaxy-ui-translator ng-if="$ctrl.currentSitemapNode.i18n.length" texts="$ctrl.current.site.texts" filter="$ctrl.currentSitemapNode.i18n"></salaxy-ui-translator>
                  </div>
                  <div class="tab-pane" id="debug-tab">
                    <salaxy-json-formatter json="$ctrl.currentSitemapNode" key="'Node'"></salaxy-json-formatter>
                    <salaxy-json-formatter json="$ctrl.currentSitemapNode.$edit" key="'$edit'"></salaxy-json-formatter>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div ng-if="$ctrl.currentSection == 'messaging'" class="form-horizontal container">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.messagingTitle"></legend>
              <sxy-input model="form.features.messaging" label="SALAXY.NG1.ServiceModelDetailsComponent.messagingActive"></sxy-input>
              <sxy-input model="form.messaging.partnerMessages"></sxy-input>
              <sxy-input model="form.messaging.workerSalaryNotifications"></sxy-input>
              <sxy-input model="form.messaging.workerSalarySlipDeliveryMethods"></sxy-input>
            </fieldset>
          </div>
          <div ng-if="$ctrl.currentSection == 'i18n'" class="form-horizontal" ng-init="$ctrl.current.site.texts = $ctrl.current.site.texts ? $ctrl.current.site.texts : {}">
            <salaxy-ui-translator texts="$ctrl.current.site.texts"></salaxy-ui-translator>
          </div>
          <div ng-if="$ctrl.currentSection == 'workflow'" class="form-horizontal">
            <div class="container">
              <sxy-input model="form.features.forms" legend="Aineiston lähetys käytössä"></sxy-input>
            </div>
          </div>
          <div ng-if="$ctrl.currentSection == 'usecases'" class="form-horizontal container">
            <fieldset>
              <sxy-input model="form.features.usecase" label="SALAXY.NG1.ServiceModelDetailsComponent.customUsecases"></sxy-input>
              <sxy-input template-url="salaxy-components/sxy-form/custom-templates/array-usecase.html" model="form.usecase.usecases">
                <form>
                  <fieldset ng-show="!$ctrl.logic.showDelete" ng-controller="ServiceModelCrudController as $serviceModelController">
                    <salaxy-odata-table url="/v03/api/usecases" template-url="salaxy-components/odata/lists/UsecaseSelect.html" selected-items="$ctrl.selectedItems" on-list-select="$serviceModelController.onUsecaseSelect($ctrl.current, $ctrl.logic, value, item, allItems)">
                    </salaxy-odata-table>
                  </fieldset>
                  <fieldset ng-show="$ctrl.logic.showDelete">
                    <sxy-input model="form.uri" read-only="true"></sxy-input>
                    <sxy-input model="form.label"></sxy-input>
                    <sxy-input model="form.itemType"></sxy-input>
                    <sxy-input model="form.status"></sxy-input>
                    <sxy-input model="form.order"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
          <div ng-if="$ctrl.currentSection == 'irdelivery'" class="form-horizontal container">
            <fieldset>
              <legend>Tulorekisterin varmenne</legend>
              <salaxy-input-boolean type="select" name="irDelivery" ng-model="$ctrl.current.features.irDelivery" label="Käytä tätä varmennetta asiakkaille"></salaxy-input-boolean>
              
              <salaxy-input label="Tulorekisterivarmenteen omistajan Y-tunnus" name="senderOfficialId"
                        ng-model="$ctrl.current.calc.irDelivery.senderOfficialId"></salaxy-input>
              <legend>Tulorekisteriraportin yhteyshenkilöt</legend>
              <table class="table">
                <thead>
                  <tr>
                    <th>{{('Nimi') | sxyTranslate}}</th>
                    <th>{{('Puhelin') | sxyTranslate}}</th>
                    <th>{{('Sähköposti') | sxyTranslate}}</th>
                    <th>{{('Vastuualue') | sxyTranslate}}</th>
                    <th class="right">
                      <button type="button" class="btn btn-primary btn-xs"
                        ng-click="$ctrl.current.calc.irDelivery.contactPersons.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr ng-repeat="item in $ctrl.current.calc.irDelivery.contactPersons">
                    <td>
                      <salaxy-input require="true" ng-model="item.name" name="{{ 'name' + $index }}" label-type="plain"></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input require="true" ng-model="item.telephone" name="{{ 'telephone' + $index }}" label-type="plain" sxy-mobile-phone></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input require="true" ng-model="item.email" name="{{ 'email' + $index }}" label-type="plain" sxy-email></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input-enum require="true" ng-model="item.responsibilityCode" name="{{ 'responsibilityCode' + $index }}" label-type="plain" type="select"
                        options="{ contentIssues: 'Raporttien sisältö', technicalIssues: 'Tekniset asiat' }"></salaxy-input-enum>
                    </td>
                    <td class="text-right">
                      <button type="button" class="btn btn-danger" ng-click="$ctrl.current.calc.irDelivery.contactPersons.splice($index, 1)">
                        <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
          </div>
          <div ng-if="$ctrl.currentSection == 'advanced'">
            <div class="container" ng-init="$ctrl.exportJson()">
              <h3>Tuonti ja vienti</h3>
              <div class="btn-toolbar">
                <div class="btn-group">
                  <button type="button" class="btn btn-default" ng-click="$ctrl.importJson()">Import JSON to this service model</button>
                </div>
              </div>
              <sxy-code-editor read-only="$ctrl.current.isReadOnly" lang="json" ng-model="$ctrl.json"></sxy-code-editor>
            </div>
          </div>
        </div>
      </div>
    </sxy-form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/sxy-form/array/default.html",`<div ng-switch="$ctrl.schemaModel.items.type">
  <div ng-switch-when="object">
    <table class="table">
      <caption>{{ $ctrl.getLabel() }}</caption>
      <thead>
        <tr>
          <th ng-repeat="itemInput in $ctrl.getChildInputs(3)">{{ $ctrl.getLabel(itemInput.name) }}</th>
          <th class="text-end">
            <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew()" sxy-text="SALAXY.UI_Terms.addRow"></button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in $ctrl.value">
          <td ng-repeat="itemInput in $ctrl.getChildInputs(3)">{{ $ctrl.formatValue(itemInput.name, $parent.$index) }}</td>
          <td class="text-end" ng-if="!$ctrl.getReadOnly()">
            <div class="btn-group" role="group" ng-if="$ctrl.value.length > 1">
              <button ng-if="$index < $ctrl.value.length - 1 && $index > 0" id="move" type="button" class="btn btn-secondary dropdown-toggle btn-xs" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-arrow-down-up" title="Move row"></i>
              </button>
              <ul ng-if="$index < $ctrl.value.length - 1 && $index > 0" class="dropdown-menu" aria-labelledby="move">
                <li>
                  <button class="btn btn-secondary dropdown-item btn-xs" ng-click="$ctrl.moveUp($index)"><i class="bi bi-arrow-up" title="Move row up"></i></button>
                </li>
                <li>
                  <button class="btn btn-secondary dropdown-item btn-xs" ng-click="$ctrl.moveDown($index)"><i class="bi bi-arrow-down" title="Move row down"></i></button>
                </li>
              </ul>
            </div>
            <button ng-if="$ctrl.value.length > 1 && $index == 0" class="btn btn-secondary btn-xs" ng-click="$ctrl.moveDown($index)"><i class="bi bi-arrow-down" title="Move row down"></i></button>
            <button ng-if="$ctrl.value.length > 1 && $index == $ctrl.value.length - 1" class="btn btn-secondary btn-xs" ng-click="$ctrl.moveUp($index)"><i class="bi bi-arrow-up" title="Move row up"></i></button>
            <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
              <i class="bi bi-pencil-fill" title="Edit row"></i>
            </button>
            <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.delete(item, $index)">
              <i class="bi bi-trash" title="Delete row"></i>
            </button>
          </td>
          <td class="text-end" ng-if="$ctrl.getReadOnly()">
            <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
              <i class="bi bi-info-circle" title="Show row"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-switch-when="string">
    <salaxy-input-enum ng-if="$ctrl.schemaModel.items.enum.length" ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()"
      type="multi-select" options="$ctrl.getEnumOptions()"></salaxy-input-enum>
    <salaxy-form-group ng-if="!$ctrl.schemaModel.items.enum.length" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()">
      <div class="input-group" ng-repeat="item in $ctrl.value track by $index">
        <input type="text" class="form-control" ng-model="$ctrl.value[$index]" name="{{ $ctrl.id + '_' + $index }}" id="{{ $ctrl.id + '_' + $index }}" ng-readonly="$ctrl.getReadOnly()" ng-disabled="$ctrl.getDisable()">
        <div class="input-group-btn">
          <button type="button" class="btn btn-danger" ng-click="$ctrl.delete(item, $index)">
            <i class="bi bi-trash" title="Delete row"></i>
          </button>
        </div>
      </div>
      <div class="text-end">
        <button type="button" class="btn btn-primary" ng-click="$ctrl.value.push('')">Add new</button>
      </div>
    </salaxy-form-group>
  </div>
  <div ng-switch-default>
    <salaxy-form-group name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()">
      <p>Unhandled array type: {{ $ctrl.schemaModel.items.type }}</p>
    </salaxy-form-group>
  </div>
</div>`);

 $templateCache.put("salaxy-components/sxy-form/array/PercentDimension.html",`<table class="table">
  <caption>{{ $ctrl.getLabel() }}</caption>
  <thead>
    <tr>
      <th>{{"SALAXY.MODEL.PercentDimension.id.title" | sxyTranslate}}</th>
      <th class="right">{{"SALAXY.MODEL.PercentDimension.percent.title" | sxyTranslate}}</th>
      <th class="right">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value">
      <td>
        <salaxy-input ng-model="item.id" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()"></salaxy-input>
      </td>
      <td>
        <salaxy-input-number ng-model="item.percent" name="{{ 'percent' + $index }}" label-type="plain" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" unit="percent"></salaxy-input-number>
      </td>
      <td class="text-end">
        <button  ng-if="!$ctrl.getReadOnly()" type="button" class="btn btn-danger" ng-click="$ctrl.delete(item, $index)">
          <i class="bi bi-trash" title="Delete row"></i>
        </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr class="total">
      <td>{{"SALAXY.UI_Terms.total" | sxyTranslate}}</td>
      <td class="right">{{ ($ctrl.getTotal('percent') || ($ctrl.value.length == 1 ? 1 : "-")) | sxyCount : 'percent' }}</td>
      <td></td>
    </tr>
  </tfoot>
</table>`);

 $templateCache.put("salaxy-components/sxy-form/boolean/checkbox.html",`<salaxy-input-boolean ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" ng-require="$ctrl.getRequire()" type="checkbox">

</salaxy-input-boolean>`);

 $templateCache.put("salaxy-components/sxy-form/boolean/default.html",`<salaxy-input-boolean ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="select"></salaxy-input-boolean>`);

 $templateCache.put("salaxy-components/sxy-form/boolean/radio.html",`<salaxy-input-boolean ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="radio"></salaxy-input-boolean>`);

 $templateCache.put("salaxy-components/sxy-form/boolean/switch.html",`<salaxy-input-boolean ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="switch"></salaxy-input-boolean>`);

 $templateCache.put("salaxy-components/sxy-form/custom-templates/array-accounting-targets.html",`
<table class="table">
  <thead>
    <tr>
      <th sxy-text="SALAXY.MODEL.AccountingSettings.targets.title" colspan="2"></th>
      <th></th>
      <th class="text-end">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew()" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value">
      <td>
        <salaxy-avatar avatar="item.avatar"></salaxy-avatar>
      </td>
      <td>{{item.avatar.displayName}}</td>
      <td></td>
      <td class="text-end" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
          <i class="bi bi-pencil-fill" title="Edit row"></i>
        </button>
        <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.delete(item, $index)">
            <i class="bi bi-trash" title="Delete row"></i>
          </button>
      </td>

    </tr>
  </tbody>
</table>`);

 $templateCache.put("salaxy-components/sxy-form/custom-templates/array-insurance.html",`<p sxy-text="SALAXY.MODEL.CalculationSettings.insuranceContracts.title" class="table-title"></p>
<table class="table">

  <thead>
    <tr>
      <th sxy-text="SALAXY.MODEL.InsuranceContract.company.title"></th>
      <th sxy-text="SALAXY.MODEL.InsuranceContract.contractNumber.title"></th>
      <th sxy-text="SALAXY.MODEL.InsuranceContract.status.title"></th>
      <th class="right" sxy-text="SALAXY.MODEL.InsuranceContract.startDate.title"></th>
      <th class="text-end">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew()" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value">
      <td>{{'SALAXY.ENUM.InsuranceCompany.' + item.company + '.label' | sxyTranslate}}</td>
      <td>{{item.contractNumber}}</td>
      <td>{{'SALAXY.ENUM.SettingsStatus.' + item.status + '.label' | sxyTranslate}}</td>
      <td class="right">{{item.startDate | date}}
        <span class="" ng-if="item.endDate">
          <br><small>(päättyy {{item.endDate | date}})</small>
        </span>
      </td>

      <td class="text-end" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
            <i class="bi bi-pencil-fill" title="Edit row"></i>
          </button>
        <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.delete(item, $index)">
            <i class="bi bi-trash" title="Delete row"></i>
          </button>
      </td>
      <td class="text-end" ng-if="$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
            <i class="bi bi-info-circle" title="Show row"></i>
          </button>
      </td>
    </tr>
  </tbody>
</table>`);

 $templateCache.put("salaxy-components/sxy-form/custom-templates/array-payment-channels.html",`<table class="table">
  <thead>
    <tr>
      <th sxy-text="SALAXY.MODEL.PaymentSettings.channels.title" colspan="2"></th>
      <th>Käytössä</th>
      <th>Valittavissa</th>
      <th class="text-end"></th>

    </tr>
  </thead>
  <tbody ng-controller="CompanySettingsController as $settingsCtrl">
    <tr ng-repeat="item in $ctrl.value">
      <td>
        <salaxy-avatar avatar="$settingsCtrl.getPaymentChannelAvatar(item)"></salaxy-avatar>
      </td>
      <td>
        {{$settingsCtrl.getPaymentChannelAvatar(item).displayName}}
      </td>
      <td>
        <span ng-if="item.isAvailable">{{'SALAXY.UI_Terms.yes' | sxyTranslate}} </span>
        <span ng-if="!item.isAvailable">{{'SALAXY.UI_Terms.no' | sxyTranslate}} </span>
      </td>
      <td>
        <span ng-if="item.isEnabled">{{'SALAXY.UI_Terms.yes' | sxyTranslate}} </span>
        <span ng-if="!item.isEnabled">{{'SALAXY.UI_Terms.no' | sxyTranslate}} </span>
      </td>
      <td class="text-end" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
            <i class="bi bi-pencil-fill" title="Edit row"></i>
          </button>
      </td>
    </tr>
  </tbody>
</table>`);

 $templateCache.put("salaxy-components/sxy-form/custom-templates/array-pension.html",`<p sxy-text="SALAXY.MODEL.CalculationSettings.pensionContracts.title" class="table-title"></p>
<table class="table">

  <thead>
    <tr>
      <th sxy-text="SALAXY.MODEL.PensionContract.company.title"></th>
      <th sxy-text="SALAXY.MODEL.PensionContract.contractNumber.title"></th>
      <th sxy-text="SALAXY.MODEL.PensionContract.status.title"></th>
      <th class="right" sxy-text="SALAXY.MODEL.PensionContract.startDate.title"></th>
      <th class="text-end">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew()" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value">
      <td>{{'SALAXY.ENUM.PensionCompany.' + item.company + '.label' | sxyTranslate}}</td>
      <td>{{ item.contractNumber}}</td>
      <td>{{'SALAXY.ENUM.SettingsStatus.' + item.status + '.label' | sxyTranslate}}</td>
      <td class="right">{{item.startDate | date}}
        <span class="" ng-if="item.endDate">
          <br><small>(päättyy {{item.endDate | date}})</small>
        </span>
      </td>

      <td class="text-end" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
            <i class="bi bi-pencil-fill" title="Edit row"></i>
          </button>
        <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.delete(item, $index)">
            <i class="bi bi-trash" title="Delete row"></i>
          </button>
      </td>
      <td class="text-end" ng-if="$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
            <i class="bi bi-info-circle" title="Show row"></i>
          </button>
      </td>
    </tr>
  </tbody>
</table>`);

 $templateCache.put("salaxy-components/sxy-form/custom-templates/array-service-model-payment-channels.html",`<table class="table">
  <thead>
    <tr>
      <th sxy-text="SALAXY.MODEL.PaymentSettings.channels.title" colspan="2"></th>
      <th>Käytössä</th>
      <th>Valittavissa</th>
      <th class="text-end">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew()" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>

    </tr>
  </thead>
  <tbody ng-controller="CompanySettingsController as $settingsCtrl">
    <tr ng-repeat="item in $ctrl.value">
      <td>
        <salaxy-avatar avatar="$settingsCtrl.getPaymentChannelAvatar(item)"></salaxy-avatar>
      </td>
      <td>
        {{$settingsCtrl.getPaymentChannelAvatar(item).displayName}}
      </td>
      <td>
        <span ng-if="item.isAvailable">{{'SALAXY.UI_Terms.yes' | sxyTranslate}} </span>
        <span ng-if="!item.isAvailable">{{'SALAXY.UI_Terms.no' | sxyTranslate}} </span>
      </td>
      <td>
        <span ng-if="item.isEnabled">{{'SALAXY.UI_Terms.yes' | sxyTranslate}} </span>
        <span ng-if="!item.isEnabled">{{'SALAXY.UI_Terms.no' | sxyTranslate}} </span>
      </td>
      <td class="text-end" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
            <i class="bi bi-pencil-fill" title="Edit row"></i>
          </button>
      </td>
    </tr>
  </tbody>
</table>`);

 $templateCache.put("salaxy-components/sxy-form/custom-templates/array-usecase.html",`<table class="table">
  <thead>
    <tr>
      <th sxy-text="SALAXY.NG1.ArrayUsecase.table.usecaseLabel" colspan="2"></th>
      <th></th>

      <th class="text-end">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew()" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value">
      <td>
        {{item.label}}
      </td>
      <td>{{'SALAXY.NG1.CalcListComponent.' + item.itemType | sxyTranslate}}</td>
      <td></td>
      <td class="text-end" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
          <i class="bi bi-pencil-fill" title="Edit row"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>`);

 $templateCache.put("salaxy-components/sxy-form/custom-templates/cost-accounting-options.html",`<table class="table" ng-if="$ctrl.form">
  <thead>
    <tr>
      <th sxy-text="SALAXY.MODEL.CostAccountingDimensionOption.value.title"></th>
      <th sxy-text="SALAXY.MODEL.CostAccountingDimensionOption.text.title"></th>
      <th sxy-text="SALAXY.MODEL.CostAccountingDimensionOption.scope.title"></th>
      <th colspan="2">
        <div class="btn-group btn-xs float-end dropdown">
          <button id="single-button" type="button" class="btn btn-default btn-xs dropdown-toggle" data-bs-toggle="dropdown">
            <i class="bi bi-three-dots" aria-hidden="true"></i>
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
            <li role="menuitem">
              <a href="" ng-controller="ExportController as $export" ng-click="$export.showExport($ctrl.getExportable())" class="dropdown-item" sxy-text="SALAXY.NG1.ODataActionsComponent.export"></a>
            </li>
            <!--
              <li role="menuitem">
                <a href="" ng-controller="ImportController as $import" ng-click="$import.showImport($ctrl.getImportable())" class="dropdown-item" sxy-text="SALAXY.NG1.ODataActionsComponent.import"></a>
              </li> --> 
          </ul>
        </div>
        <button type="button" class="btn btn-default btn-xs float-end" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value">
      <td>
        <salaxy-input ng-model="item.value" name="{{ 'value' + $index }}" label-type="plain" read-only="$ctrl.getReadOnly()" ></salaxy-input>
      </td>
      <td>
        <salaxy-input ng-model="item.text" name="{{ 'text' + $index }}" label-type="plain" read-only="$ctrl.getReadOnly()" ></salaxy-input>
      </td>
      <td>
        <salaxy-input-enum enum="CostAccountingDimensionScope" ng-model="item.scope" name="{{ 'scope' + $index }}" label-type="plain" read-only="$ctrl.getReadOnly()" ></salaxy-input-enum>
      </td>
      <td colspan="2" class="text-end">
        <button ng-if="!$ctrl.getReadOnly()" type="button" class="btn btn-danger" ng-click="$ctrl.delete(item, $index)">
          <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>`);

 $templateCache.put("salaxy-components/sxy-form/custom-templates/pay-stats-row-types.html",`<table class="table" ng-if="$ctrl.form">
  <thead>
    <tr>
      <th sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.type"></th>
      <th class="text-right">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.value=($ctrl.value || []);$ctrl.value.push('')" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value track by $index">
      <td>
        <salaxy-input-pay-stats-row-type ng-ref="$row" ng-model="$ctrl.value[$index]" name="{{ 'rowType' + $index }}" label-type="plain" read-only="$ctrl.getReadOnly()" ></salaxy-input-pay-stats-row-type>
      </td>
      <td class="text-right" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$row.edit()">
          <i class="bi bi-pencil-fill" title="Edit row"></i>
        </button>
        <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.delete(item, $index)">
          <i class="bi bi-trash" title="Delete row"></i>
        </button>
      </td>
      <td class="text-right" ng-if="$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$row.edit()">
          <i class="bi bi-info-circle" title="Show row"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>`);

 $templateCache.put("salaxy-components/sxy-form/custom-templates/select-accounting-target-item.html",`<a class="clickable salaxy-component salaxy-avatar-item">
  <salaxy-avatar style="font-size: 30px; vertical-align: middle;"
  avatar="match.model.otherPartyInfo.avatar"></salaxy-avatar>
  <b class="salaxy-highlight" ng-bind-html="match.label | uibTypeaheadHighlight:query"></b>
</a>
`);

 $templateCache.put("salaxy-components/sxy-form/error/default.html",`<salaxy-form-group name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()"
  require="$ctrl.getRequire()">
  <sxy-alert type="error">
    <div ng-if="$ctrl.input.content">{{ $ctrl.input.content }}</div>
    <div ng-if="!$ctrl.input.content">No UI for model "{{ $ctrl.model }}",  type "{{ $ctrl.type }}", format "{{ $ctrl.format }}".</div>
    <div>
      <salaxy-json-formatter key="'See input json'" json="$ctrl.input" type="dialog"></salaxy-json-formatter>
      <salaxy-json-formatter key="'See schema'" json="$ctrl.schemaModel" type="dialog"></salaxy-json-formatter>
    </div>
  </sxy-alert>
</salaxy-form-group>`);

 $templateCache.put("salaxy-components/sxy-form/integer/default.html",`<salaxy-input-number ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" sxy-integer>
</salaxy-input-number>`);

 $templateCache.put("salaxy-components/sxy-form/number/default.html",`<salaxy-input-number ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" unit="{{ $ctrl.input.format }}"
  minimum="{{$ctrl.getMinimum()}}" maximum="{{$ctrl.getMaximum()}}" multiple-of="{{$ctrl.getMultipleOf()}}">
</salaxy-input-number>`);

 $templateCache.put("salaxy-components/sxy-form/object/Avatar.html",`<salaxy-form-group name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()">
  <table>
    <tr>
      <td class="td-avatar middle">
        <salaxy-avatar avatar="$ctrl.value"></salaxy-avatar>
      </td>
      <td class="td-name middle">
        <strong>{{$ctrl.value.displayName}}</strong><br />
        <span class="">{{ $ctrl.value.id | sxyIban }}</span>
      </td>
    </tr>
  </table>
</salaxy-form-group>`);

 $templateCache.put("salaxy-components/sxy-form/object/DateRange.html",`<salaxy-date-range ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()">
</salaxy-date-range>`);

 $templateCache.put("salaxy-components/sxy-form/object/default.html",`<salaxy-form-group name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()"
  require="$ctrl.getRequire()">
  <div>
    <button type="button" class="btn btn-default" ng-click="$ctrl.isInEdit[$ctrl.id] = !$ctrl.isInEdit[$ctrl.id]">{{ $ctrl.isInEdit[$ctrl.id] ? "Hide" : "Edit" }}</button>
  </div>
</salaxy-form-group>
<div ng-if="$ctrl.isInEdit[$ctrl.id]" class="row">
  <div class="col-md-offset-1 col-11">
    <sxy-fieldset model="{{ $ctrl.model }}"></sxy-fieldset>
  </div>
</div>`);

 $templateCache.put("salaxy-components/sxy-form/string/date-time.html",`<salaxy-form-group name="{{$ctrl.id}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.getLabel()}}">
  <div class="form-control-plaintext">{{ $ctrl.value | date : "dd.MM.yyyy HH:mm" }}</div>
</salaxy-form-group>
`);

 $templateCache.put("salaxy-components/sxy-form/string/date.html",`<salaxy-datepicker-popup ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()"></salaxy-datepicker-popup>`);

 $templateCache.put("salaxy-components/sxy-form/string/default.html",`<salaxy-input ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" minlength="{{$ctrl.getMinLength()}}"
  maxlength="{{$ctrl.getMaxLength()}}" pattern="{{$ctrl.getPattern()}}">
</salaxy-input>`);

 $templateCache.put("salaxy-components/sxy-form/string/email.html",`<salaxy-input ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" sxy-email>
</salaxy-input>`);

 $templateCache.put("salaxy-components/sxy-form/string/enum.html",`<salaxy-input-enum ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="{{ $ctrl.getFormat() }}" options="$ctrl.getEnumOptions()"></salaxy-input-enum>`);

 $templateCache.put("salaxy-components/sxy-form/string/multiline.html",`<salaxy-textarea ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" maxlength="10000">
</salaxy-textarea>`);

 $templateCache.put("salaxy-components/sxy-form/string/password.html",`<salaxy-input ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="password"></salaxy-input>`);

 $templateCache.put("salaxy-components/sxy-form/string/pension-contract-number.html",`<salaxy-input  ng-if="'!admin' | sxyIsInRole" ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="pension-contract-number" sxy-pension-contract-number>
</salaxy-input>
<salaxy-input  ng-if="'admin' | sxyIsInRole" ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="pension-contract-number">
</salaxy-input>`);

 $templateCache.put("salaxy-components/sxy-form/string/telephone.html",`<salaxy-input ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" sxy-mobile-phone></salaxy-input>`);

 $templateCache.put("salaxy-components/sxy-form/SxyAlert.html",`<div class="salaxy-component salaxy-alert">
  <!-- TODO: Switch styling to "sxy-component sxy-alert" -->
  <div ng-class="$ctrl.getAlertClasses()">
    <div>
      <table style="width: 100%; border-collapse:separate;">
        <!-- TODO: Switch this to position:absolute & margins or flex-grid -->
        <tr>
          <td class="icon-container hidden-xxs" ng-if="$ctrl.getAlertIcon()">
            <span class="icon"><i class="bi {{ $ctrl.getAlertIcon() }}"></i></span>
          </td>
          <td>
            <div class="main">
              <ng-transclude>
                <div sxy-html="{{$ctrl.msg}}"></div>
              </ng-transclude>
            </div>
          </td>
          <td ng-if="$ctrl.aside" class="text-end">
            <button class="btn btn-info btn-main" ng-click="$ctrl.showMoreInfo = !$ctrl.showMoreInfo" sxy-text="SALAXY.UI_Terms.learnMore"></button>
          </td>
        </tr>
      </table>
      <div class="collapse" ng-if="$ctrl.aside" ng-class="{ show: $ctrl.showMoreInfo }">
        <div sxy-html="$ctrl.aside"></div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/sxy-form/SxyCodeEditor.html",`<div class="salaxy-component sxy-code-editor">
  <div ng-if="$ctrl.mode == 'basic'">
    <pre ng-if="$ctrl.readOnly" style="padding: 10px; background-color: #1e1e1e; color: #d4d4d4">{{ $ctrl.code }}</pre>
    <textarea ng-if="!$ctrl.readOnly"
      style="font-family: 'Courier New', Courier, monospace; background-color: #1e1e1e; color: #d4d4d4; padding: 10px; width: 100%;"
      ng-model="$ctrl.value" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }" ng-change="$ctrl.onChange()"
      name="actionContent" rows="10"></textarea>
  </div>
  <div ng-if="$ctrl.mode != 'basic'">
    <iframe ng-src="{{ $ctrl.codeEditorUrl }}" style="width: 100%;" ng-style="{ height: $ctrl.height || '400px' }"></iframe>
  </div>
</div>


`);

 $templateCache.put("salaxy-components/sxy-form/SxyFieldset.html",`<div ng-switch="$ctrl.format" ng-if="$ctrl.form">
  <fieldset ng-switch-when="source">
    <legend>Form inputs source code (auto-gen)</legend>
    <pre>&lt;fieldset&gt;
  &lt;legend&gt;{{ $ctrl.label }}&lt;/legend&gt;
<span ng-repeat="input in $ctrl.getChildInputs()">  &lt;sxy-input model="{{ input.path }}"&gt;&lt;/sxy-input&gt;<br /></span>&lt;/fieldset&gt;
</pre>
  </fieldset>
  <fieldset ng-switch-default>
    <legend>{{ $ctrl.getLabel() }}</legend>
    <p>{{ $ctrl.getDescr() }}</p>
    <sxy-input model="{{ input.path }}" ng-repeat="input in $ctrl.getChildInputs()"></sxy-input>
  </fieldset>
</div>`);

 $templateCache.put("salaxy-components/sxy-form/SxyForm.html",`<div class="salaxy-component sxy-form form-horizontal">
  <h2 ng-if="$ctrl.legend">{{ $ctrl.legend }}</h2>
  <ng-form name="$ctrl.ngForm">
    <div ng-if="!$ctrl.isReady">
      <p>Ladataan...</p>
    </div>
    <div ng-if="$ctrl.isReady">
      <div ng-if="!$ctrl.autoGen" ng-transclude="div">
        <div class="alert alert-info">
          Either set <code>auto-gen</code> attribute to true or add a
          <code>DIV</code> element with your form sxy-input definitions.
        </div>
      </div>
      <div ng-if="$ctrl.autoGen">
        <sxy-fieldset model="form" label="{{ $ctrl.label }}"></sxy-fieldset>
      </div>
      <div ng-if="$ctrl.debugger">
        <salaxy-tab-buttons
          current-tab="$ctrl.currentTab"
          options="[
            { value: 'data', text: 'Data' },
            { value: 'schema', text: 'Auto-gen' },
            { value: 'codegen', text: 'Code-gen' },
            { value: 'registrations', text: 'Components' },
            { value: 'validation', text: 'Validation' }
          ]"
          tabs-id="sxyForm">
        </salaxy-tab-buttons>
        <div class="tab-content" id="tab-content-sxyForm">
          <div class="tab-pane" id="data-tab">
            <salaxy-json-formatter key="'data'" json="$ctrl.model" open="2"></salaxy-json-formatter>
          </div>
          <div class="tab-pane" id="schema-tab">
            <salaxy-json-formatter key="$ctrl.type" json="$ctrl.schemaModel" open="2"></salaxy-json-formatter>
          </div>
          <div class="tab-pane" id="codegen-tab">
            <sxy-fieldset model="form" format="source" label="{{ $ctrl.label }}"></sxy-fieldset>
          </div>
          <div class="tab-pane" id="registrations-tab">
            <p>
              This is a list of component registrations. Note that debugger "Code-gen" tab currently makes one registration for the form (with name "[Parent][n1]_form[n2]"). This might be removed later.
            </p>
            <ul>
              <li ng-repeat="(key, value) in $ctrl.registeredInputs">{{ key }}</li>
            </ul>
          </div>
          <div class="tab-pane" id="validation-tab">
            <salaxy-validation-summary api-validation="$ctrl.getValidation()"></salaxy-validation-summary>
          </div>
        </div>
      </div>
    </div>
  </ng-form>
</div>`);

 $templateCache.put("salaxy-components/sxy-form/SxyGrid.html",`<div class="salaxy-component sxy-grid height100">
  <div class="btn-toolbar">
    <div class="btn-group">
      <button type="button" class="btn btn-default" ng-click="$ctrl.addRow()">Add row</button>
      <button type="button" class="btn btn-danger" ng-disabled="!$ctrl.selection.length" ng-click="$ctrl.deleteSelectedRows()">Delete rows ({{ $ctrl.selection.length }})</button>
    </div>
    <div class="btn-group" ng-if="$ctrl">
      <button type="button" class="btn btn-default" ng-controller="ExportController as $export" ng-click="$export.showExport($ctrl.getExportable())">Export</button>
    </div>
  </div>
  <div id="dataGrid" class="ag-theme-balham height100" style="height: calc(100% - 34px);overflow: hidden;"></div>
</div>`);

 $templateCache.put("salaxy-components/sxy-form/SxyInput-dialog-edit.html",`<div class="modal-header">
  <h2 class="modal-title">{{ $ctrl.logic.title }}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <sxy-form open-api="{{ $ctrl.logic.openApi }}" type="{{ $ctrl.logic.type }}" auto-gen="true" debugger="$ctrl.logic.debugger" model="$ctrl.current" read-only="{{$ctrl.logic.isReadOnly ? 'true' : ''}}"></sxy-form>
</div>
<div class="modal-footer">
  <button type="button" ng-if="$ctrl.logic.showDelete" class="btn btn-danger float-start" ng-click="$close('delete-no-save')" sxy-text="SALAXY.UI_Terms.delete"></button>
  <button type="reset" ng-if="!$ctrl.logic.isReadOnly" class="btn btn-default ms-auto" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="button" ng-if="!$ctrl.logic.isReadOnly" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
  <button type="button" ng-if="$ctrl.logic.isReadOnly" class="btn btn-primary" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`);

 $templateCache.put("salaxy-components/sxy-form/SxyInput.html",`<ng-include src="$ctrl.templateUrl" ng-if="$ctrl.form"></ng-include>`);

 $templateCache.put("salaxy-components/sxy-form/SxySchemaEditor.html",`<div class="row">
  <div class="col-md-6" ng-repeat="(key, value) in $ctrl.model">
    <fieldset>
      <legend>
        <button type="button" class="btn btn-danger btn-xs float-end" ng-click="$ctrl.deleteProperty(key)">Poista</button>
        {{ $index + 1 }}. {{ key }}
      </legend>
      <salaxy-input label="Teksti" name="title" ng-model="value.title"></salaxy-input>
      <salaxy-input label="Kuvaus" name="description" ng-model="value.description"></salaxy-input>
      <salaxy-input-enum label="Tietotyyppi" name="type" ng-model="value.type"
        options="$ctrl.types"></salaxy-input-enum>
      <salaxy-input-enum ng-if="value.type" label="Käyttöliittymä" name="type" ng-model="value.format"
        disable-cache="true" options="$ctrl.getFormats(value.type)"></salaxy-input-enum>
<!--
- Lisää esikatselu
- Lisää Array: Prosenttipohjainen jako, ehkä myös string ja number
-->
    </fieldset>
  </div>
  <div class="col-md-6">
    <button type="button" class="btn btn-primary btn-block" ng-click="$ctrl.addProperty()">Lisää uusi</button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/sxy-table/SxyTable.html",`<div style="margin-top: 10px; margin-bottom: 10px;"></div>`);

 $templateCache.put("salaxy-components/test/AccountReset.html",`<div class="salaxy-component salaxy-account-reset">
  <hr />
  <h2>Vain testiympäristö</h2>
  <p class="lead">
    Nämä toiminnallisuudet ovat näkyvissä vain testiympäristössä. Voit käyttää näitä toimintoja testataksesi työnantajan tiliä eri tiloissa.
  </p>
  <div class="table-responsive">
    <table class="table">
      <tr>
        <td>Poista kaikki laskelmat.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteCalculations()">Poista laskelmat</button></td>
      </tr>
      <tr>
        <td>Poista kaikki työntekijät. Tämä poistaa myös laskelmat, jos niitä on.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteWorkers()">Poista työntekijät</button></td>
      </tr>
      <tr>
        <td>Poista loma- ja poissaolokirjanpito kaikilta työntekijöiltä.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteHolidays()">Poista lomat ja poissaolot</button></td>
      </tr>
      <tr>
        <td>Poista kaikki data: Laskelmien ja työntekijöiden lisäksi myös mahd. työsopimukset, raportit jne. Asetukset ja allekirjoitus pysyvät ennallaan.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteData()">Poista kaikki data</button></td>
      </tr>
      <tr>
        <td>Poista TyEL ja Tapavak: Käyttäjällä on puutteita palkanmaksun asetuksissa.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deletePensionAndInsurance()">Poista TyEL ja Tapavak</button></td>
      </tr>
      <tr>
        <td>Poista Allekirjoitus: Käyttäjä keskeyttänyt Onboarding-wizardin ennen digitaalista allekirjoitusta.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteSignature()">Poista Allekirjoitus</button></td>
      </tr>
      <tr>
        <td>Poista luodut tilit. Tämän tilin luomat uudet tilit, joilla ei ole maksettuja laskelmia tai allekirjoituksia, poistetaan.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteAuthorizingAccounts()">Poista luodut tilit</button></td>
      </tr>
      <tr>
        <td>Tuhoa tili: Tuhoa koko tili. Voit aloittaa Onboarding-prosessin alusta.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteCurrent()">Tuhoa tili</button></td>
      </tr>
      <tr>
        <td>{{$ctrl.isKycMissing() ? 'Aktivoi tilin KYC' : 'Poista tilin KYC'}}</td>
        <td>
          <button ng-class="$ctrl.isKycMissing() ? 'btn-info' : 'btn-danger'" class="btn btn-block" ng-click="$ctrl.handleKyc()">{{$ctrl.isKycMissing() ? 'Aktivoi KYC' : 'Poista KYC'}}</button>
        </td>
      </tr>
    </table>
  </div>
</div>`);

 $templateCache.put("salaxy-components/test/SmokeTest.html",`<div ng-switch="$ctrl.mode">
  <fieldset ng-switch-when="reports">
    <legend><code>@salaxy/reports</code> functionality</legend>
    <p>
      Library loaded:
      <span class="label" ng-class="$ctrl.reportsTests.loaded ? 'label-success' : 'label-danger'">{{ $ctrl.reportsTests.loaded ? "OK" : "ERROR" }}</span>
    </p>
    <p>
      Basic functionality:
      <span class="label" ng-class="$ctrl.reportsTests.mapper ? 'label-success' : 'label-danger'">{{ $ctrl.reportsTests.mapper ? "OK" : "ERROR" }}</span>
    </p>
    <p>
      Report templates <small>(Handlebars)</small>:
      <span class="label" ng-class="$ctrl.reportsTests.handlebars ? 'label-success' : 'label-danger'">{{ $ctrl.reportsTests.handlebars ? "OK" : "ERROR" }}</span>
    </p>
  </fieldset>
  <fieldset ng-switch-default>
    <legend><code>@salaxy/core</code> functionality</legend>
    <p>
      Basic functionality:
      <span class="label" ng-class="$ctrl.getNumber() ? 'label-success' : 'label-danger'">{{ $ctrl.getNumber() ? "OK" : "ERROR" }}</span>
    </p>
    <p>
      Dates <small>(MomentJS loaded)</small>:
      <span class="label" ng-class="$ctrl.getADate() == '20.02.2020' ? 'label-success' : 'label-danger'">
        {{ $ctrl.getADate() == '20.02.2020' ? "OK" : "ERROR" }}</span>
    </p>
    <p>
      Token <small>(Base64)</small>:
      <span class="label" ng-class="$ctrl.readToken() ? 'label-success' : 'label-danger'">{{ $ctrl.readToken() ? "OK" : "ERROR" }}</span>
    </p>
    <p>
      Text from json: {{ $ctrl.getJson() }}
      <span class="label" ng-class="$ctrl.getJson() == 'This text is in json' ? 'label-success' : 'label-danger'">{{ $ctrl.getJson() == 'This text is in json' ? "OK" : "ERROR" }}</span>
    </p>
  </fieldset>
  <fieldset ng-switch-when="ng1">
    <legend><code>@salaxy/ng1</code> functionality</legend>
    <p>
      Library loaded:
      <span class="label" ng-class="$ctrl.sessionSrv ? 'label-success' : 'label-danger'">{{ $ctrl.sessionSrv ? "OK" : "ERROR" }}</span>
    </p>
    <p>
      Basic functionality:
      <span class="label" ng-class="$ctrl.sessionSrv.isInSomeRole('auth,anon,init') ? 'label-success' : 'label-danger'">{{ $ctrl.sessionSrv.isInSomeRole('auth,anon,init') ? "OK" : "ERROR" }}</span>
    </p>
    <div>
      <p>Component with template: You should see a drop-down menu with insurance companies below.</p>
      <salaxy-input-enum enum="InsuranceCompany" name="InsuranceCompany" label="SALAXY.NG1.ProductDialogsComponent.company" ng-model="$ctrl.temp.insuranceCompany"></salaxy-input-enum>
    </div>
  </fieldset>
  <fieldset ng-switch-when="ng1">
    <legend><code>@salaxy/ng1</code> AngularJS Modules</legend>
    <div>
      <b>angular-i18n (angular-locale_fi):</b><br /> The following sums should have the same euro currency format: {{ 1234 | currency }} == 1 234,00€<br /> Date should be in Finnish format: 20.12.2021 == {{ "2021-12-20" | date }}
    </div>
    <div>
      <b>angular-route:</b>
      <span class="label label-warning">TODO</span>
    </div>
    <div>
      <b>angular-sanitize:</b>
      <div sxy-html="&lt;span class='label label-success'&gt;This text should be in GREEN background&lt;/span&gt;"></div>
    </div>
    <div>
      <b>angular-translate:</b><br />
      <p>This text should be "Kyllä" / "Yes": <strong sxy-text="SALAXY.UI_Terms.yes">ERROR</strong> <small>(ng1)</small></p>
      <p>This text should be "OK": <strong sxy-text="SALAXY.UI_Terms.ok">ERROR</strong> <small>(core)</small></p>
    </div>
    <div>
      <b>angular-ui-bootstrap:</b> You should see a progress bar below:<br />
      <div class="progress">
        <div class="progress-bar-striped bg-danger" role="progressbar" style="width: 83%">83 %</div>
      </div>
    </div>
    <!-- <div>
      <b>Chart <small>Chart.js, angular-chart.js and chartjs-plugin-annotation</small>:</b> You should see a chart below with annotation.
      <div class="salaxy-tax-card-chart chart-container">
        <canvas id="line" class="chart chart-line" chart-data="$ctrl.chartData.data" chart-dataset-override="$ctrl.chartData.datasets" chart-labels="$ctrl.chartData.labels" chart-fill="$ctrl.chartData.fill" chart-colors="$ctrl.chartData.colors" chart-options="$ctrl.chartData.options"></canvas>
      </div>
    </div> -->
    <div>
      <b>ng-file-upload:</b><br />
      <button type="button" class="btn btn-default" ngf-select="upload($file)">Click me to show Upload dialog</button> (Open/Cancel does nothing)
    </div>
    <hr />
    <legend><code>@salaxy/ng1</code> Imported Modules</legend>
    <div>
      <b>file-saver:</b>
      <button type="button" class="btn btn-default" ng-click="$ctrl.saveAs()">Click me to download a text file.</button>
    </div>
    <div>
      <b>jszip:</b>
      <span class="label label-warning">TODO</span>
    </div>
    <div>
      <b>marked: The following text should be formatted:</b>
      <div ng-bind-html="'_italic_, **bold**, 'monospace', ~~strikethrough~~, [link](http://example.com)' | sxyMarkdown"></div>
    </div>
    <div>
      <b>rrule:</b>
      <span class="label label-warning">TODO</span>
    </div>
    <hr />
    <legend>Removed</legend>
    <p>The following dependencies have been dropped from this version:</p>
    <ul>
      <li>Babel (was in core): Babel was obsolete and we can target 2015. If necesssary, consider https://github.com/ryanelian/ts-polyfill or https://polyfill.io/v3/url-builder/ instead of js-core 3 (it has advertising issues).</li>
      <li>js-base64: Moved from NG1 to Core (so not really removed)</li>
      <li>angular-i18n: Not currently in use. Contains angular locales, e.g. </li>
      <li>angular-animate: Removed as not used. Search for "ngAnimate" in projects.</li>
      <li>angular-touch: Removed. Project marked as obsolete ages ago.</li>
    </ul>
  </fieldset>
</div>`);

 $templateCache.put("salaxy-components/worker/AbsencePeriods.html",`<div class="salaxy-component salaxy-holiday-year-absences">
  <div ng-if="!$ctrl.list" class="alert alert-info">
    <p sxy-text="SALAXY.NG1.AbsencePeriodsComponent.selectWorker"></p>
  </div>
  <div ng-if="$ctrl.list && $ctrl.mode == 'calendar'">
    <salaxy-calendar data="$ctrl.parent" on-list-select="$ctrl.calendarClick(type, date, calEvent)"
      start="$ctrl.filterStart" end="$ctrl.filterEnd" mapper="$ctrl.mapToCalendar"></salaxy-calendar>
    <div class="text-end">
      &nbsp;<br/>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showEditDialog('new')" sxy-text="SALAXY.NG1.AbsencePeriodsComponent.addAbsenceButtonText"></button>
    </div>
  </div>
  <div ng-if="$ctrl.list && $ctrl.mode != 'calendar'">
    <table class="table table-striped {{ $ctrl.condensed ? 'table-sm' : '' }}">
      <thead>
        <tr>
          <th sxy-text="SALAXY.NG1.AbsencePeriodsComponent.headerAbsence"></th>
          <th class="right" sxy-text="SALAXY.NG1.AbsencePeriodsComponent.headerDays"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.list | filter: $ctrl.filter" ng-click="$ctrl.showEditDialog(row)" class="clickable">
          <td>
            <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
            <strong>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</strong><br />
            <div class="float-start" style="padding: 0px;">
              {{ row.isPaid ? ('SALAXY.NG1.AbsencePeriodsComponent.isPaid' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notPaid' |sxyTranslate) }}
              <span ng-if="row.isPaid != row.isHolidayAccrual"> {{ row.isHolidayAccrual ? ('SALAXY.NG1.AbsencePeriodsComponent.isAccrual' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notAccrual' | sxyTranslate) }}</span>
            </div>
            <div class="truncate" style="max-width: 250px; padding: 0px;">
              &nbsp;{{ row.notes }}
            </div>
          </td>
          <td class="right">
            <strong>{{ row.period.daysCount | sxyCount : "day" }}</strong><br /> {{ row.period | sxyDateRange }}
          </td>
        </tr>
        <tr ng-if="$ctrl.filteredList.length == 0">
          <td colspan="2">
            <h3 sxy-text="SALAXY.NG1.AbsencePeriodsComponent.noAbsences"></h3>
            <p sxy-text="SALAXY.NG1.AbsencePeriodsComponent.noAbsencesDescription"></p>
            <p sxy-text="SALAXY.NG1.AbsencePeriodsComponent.noAbsencesDescription2"></p>
          </td>
        </tr>
        <tr class="total">
          <td>
            <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" style="margin-bottom: 20px" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
            <strong>
             <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalUnpaid"></span><br />
                         <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalNoHolidayAccrual"></span><br />
                           <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalAll"></span><br />
            </strong>
          </td>
          <td class="right">
            <strong>
              {{ $ctrl.getTotalDays("absencesUnpaid") | sxyCount : "day" }}<br />
              {{ $ctrl.getTotalDays("absencesNoHolidayAccrual") | sxyCount : "day" }}<br />
              {{ $ctrl.getTotalDays("all") | sxyCount : "day" }}<br />
            </strong>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="text-end">
      <button type="button" class="btn btn-default" ng-click="$ctrl.showEditDialog('new')" sxy-text="SALAXY.NG1.AbsencePeriodsComponent.addAbsenceButtonText"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/AbsencePeriodsEditDialog.html",`  <div class="modal-header">
    <h1 class="modal-title" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.panelHeading"></h1>
    <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <form class="form-horizontal" name="absencePeriodsForm">
      <salaxy-input-typeahead name="causeCode" ng-model="$ctrl.current.causeCode" enum="AbsenceCauseCode" label="SALAXY.MODEL.WorkerAbsencePeriod.absencesId.title" ng-change="$ctrl.logic.updateIsPaid($ctrl.current)" require="true" options="$ctrl.getCauseCodes()"></salaxy-input-typeahead>
      <salaxy-datepicker-popup name="start" ng-model="$ctrl.current.period.start" ng-change="$ctrl.logic.updatePeriodDays($ctrl.current)" label="SALAXY.MODEL.DateRange.start.title"></salaxy-datepicker-popup>
      <salaxy-datepicker-popup name="end" ng-model="$ctrl.current.period.end" ng-change="$ctrl.logic.updatePeriodDays($ctrl.current)" label="SALAXY.MODEL.DateRange.end.title"></salaxy-datepicker-popup>
      <salaxy-form-group name="daysCount" label="SALAXY.MODEL.DateRange.daysCount.title" ng-if="$ctrl.current.period.days == null">
        <div class="input-group">
          <input class="form-control" type="text" autocomplete="off" id="daysCount" name="daysCount" ng-model="$ctrl.current.period.daysCount" disabled>
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="$ctrl.logic.setDaysSelection($ctrl.current);" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.editDatesButtonText"></button>
          </span>
        </div>
      </salaxy-form-group>
      <salaxy-datepicker ng-if="$ctrl.current.period.days != null" name="days" is-multiple="true" ng-model="$ctrl.current.period" label="SALAXY.MODEL.WorkerAbsencePeriod.period.title" min-date="$ctrl.current.period.start" max-date="$ctrl.current.period.end"></salaxy-datepicker>
      <salaxy-input-boolean type="checkbox" name="isPaid" label="SALAXY.MODEL.WorkerAbsencePeriod.isPaid.title" label-true="SALAXY.NG1.AbsencePeriodsEditDialog.label.isPaidLabelTrue" disabled="!$ctrl.logic.canSelectIsPaid($ctrl.current)" ng-model="$ctrl.current.isPaid"
        ng-change="$ctrl.logic.updateIsHolidayAccrual($ctrl.current)"></salaxy-input-boolean>
      <salaxy-input-boolean type="checkbox" name="isHolidayAccrual" label="SALAXY.MODEL.WorkerAbsencePeriod.isHolidayAccrual.title" label-true="SALAXY.NG1.AbsencePeriodsEditDialog.label.isAccrualLabelTrue" ng-model="$ctrl.current.isHolidayAccrual"></salaxy-input-boolean>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" ng-click="$close('delete')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.deleteButtonText"></button>
    <button type="reset" class="btn btn-default ms-auto" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
    <button type="submit" ng-disabled="absencePeriodsForm.$invalid" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
  </div>`);

 $templateCache.put("salaxy-components/worker/employment/Details.html",`<ng-include src="'salaxy-components/worker/employment/Details_Header.html'"></ng-include>
<div ng-if="$ctrl.status == 'initialLoading'">
  <p sxy-text="SALAXY.UI_Terms.loading"></p>
</div>
<div>
  <salaxy-tab-buttons
    ng-if="$ctrl.current"
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'default', text: 'SALAXY.NG1.WorkerDetailsComponent.workerInfo', isDefault: true },
      { value: 'employment', text: 'SALAXY.NG1.WorkerDetailsComponent.employment' },
      { value: 'calcrows', text: 'SALAXY.NG1.WorkerDetailsComponent.defaultCalcRows' },
      { value: 'calculations', text: 'SALAXY.NG1.WorkerDetailsComponent.calculations' },
      { value: 'taxcards', text: 'SALAXY.NG1.WorkerDetailsComponent.taxcards' },
      { value: 'holidays', text: 'SALAXY.NG1.WorkerDetailsComponent.holidays', hidden: ('disableHolidays' | sxyIsInRole) },
      { value: 'absences', text: 'SALAXY.NG1.WorkerDetailsComponent.absences', hidden: ('disableHolidays' | sxyIsInRole) },
      { value: 'records', text: 'SALAXY.NG1.WorkerDetailsComponent.records.label', hidden: $ctrl.isModal && isHousehold },
      { value: 'debugger', text: 'DEBUG', hidden: !('disabled-test' | sxyIsInRole) }
    ]"
    tabs-id="employmentDetails">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-employmentDetails">
    <div class="tab-pane" id="default-tab">
      <ng-include src="'salaxy-components/worker/employment/Details_Basic.html'" ng-if="$ctrl.currentTab == 'default'"></ng-include>
    </div>
    <div class="tab-pane" id="employment-tab">
      <ng-include src="'salaxy-components/worker/employment/Details_EmploymentRelation.html'" ng-if="$ctrl.currentTab == 'employment'"></ng-include>
    </div>
    <div class="tab-pane" id="calcrows-tab">
      <ng-include src="'salaxy-components/worker/employment/Details_Calc.html'" ng-if="$ctrl.currentTab == 'calcrows'"></ng-include>
    </div>
    <div class="tab-pane" id="calculations-tab">
      <salaxy-odata-table ng-if="$ctrl.current.personalInfo" read-only="$ctrl.isReadOnlyForced" crud-controller="CalculationCrudController as $crud"
        options="{ $filter: 'otherPartyInfo/officialId eq \\'' + $ctrl.current.personalInfo.officialId + '\\' and ( status ne \\'proDraft\\' and status ne \\'payrollDraft\\')' }"
        template-url="salaxy-components/odata/lists/CalculationsWorker.html" logic="$ctrl.calcListLogic" ng-if="$ctrl.currentTab == 'calculations'">
      </salaxy-odata-table>
    </div>
    <div class="tab-pane" id="taxcards-tab">
      <ng-include src="'salaxy-components/worker/employment/Details_Tax.html'" ng-if="$ctrl.currentTab == 'taxcards'"></ng-include>
    </div>
    <div class="tab-pane" id="holidays-tab">
      <salaxy-worker-holidays employment-id="$ctrl.current.id" ng-if="$ctrl.currentTab == 'holidays'"></salaxy-worker-holidays>
    </div>
    <div class="tab-pane" id="absences-tab">
      <salaxy-worker-absences employment-id="$ctrl.current.id" ng-if="$ctrl.currentTab == 'absences'"></salaxy-worker-absences>
    </div>
    <div class="tab-pane" id="records-tab">
      <salaxy-records read-only="$ctrl.isReadOnlyForced" api-ctrl="$ctrl" entity-type="'employment'" ng-if="$ctrl.current && (!$ctrl.isModal || !isHousehold) && $ctrl.currentTab == 'records'"></salaxy-records>
    </div>
    <div class="tab-pane" id="debugger-tab">
      <div ng-if="('disabled-test' | sxyIsInRole) && $ctrl.currentTab == 'debugger'">
        <p><a ng-href="{{'#/workers/details/' + $ctrl.current.info.workerAccountId}}">Old version (Worker ID {{ $ctrl.current.info.workerAccountId }})</a></p>
        <salaxy-json-formatter json="$ctrl.current" open="1" key="'Employment'"></salaxy-json-formatter>
      </div>
    </div>
  </div>
</div>
`);

 $templateCache.put("salaxy-components/worker/employment/Details_Accruals.html",`<div ng-if="$ctrl.current">
  <sxy-form open-api="salaxy-secure/schemas/v02.json" type="Employment" auto-gen="false" debugger="false" model="$ctrl.current">
    <div>
      <fieldset>
        <legend><span sxy-text="SALAXY.MODEL.Employment.accruals.title"></span></legend>
        <sxy-input model="form.accruals" include="type,startDate,endDate,amount,unit">
          <form>
             <fieldset>
                <legend sxy-text="SALAXY.MODEL.EmploymentAccrual.title"></legend>
                <sxy-input require="true" model="form.type"></sxy-input>
                <sxy-input model="form.startDate"></sxy-input>
                <sxy-input model="form.endDate"></sxy-input>
                <sxy-input format="undefined" model="form.amount"></sxy-input>
                <sxy-input model="form.unit"></sxy-input>
            </fieldset>
          </form>
        </sxy-input>
      </fieldset>
    </div>
  </sxy-form>
</div>`);

 $templateCache.put("salaxy-components/worker/employment/Details_Basic.html",`<div class="salaxy-component salaxy-worker-employment">
  <form name="basicForm" class="form-horizontal" ng-readonly="$ctrl.isReadOnlyForced">
    <div class="row">
      <div class="col-md-6">
        <fieldset ng-if="$ctrl.isNew()">
          <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.details"></legend>
          <salaxy-input name="firstName" label="SALAXY.NG1.WorkerDetailsComponent.firstName" ng-required="true" ng-model="$ctrl.current.identity.firstName"></salaxy-input>
          <salaxy-input name="lastName" label="SALAXY.NG1.WorkerDetailsComponent.lastName" ng-required="true" ng-model="$ctrl.current.identity.lastName"></salaxy-input>
          <salaxy-input name="officialPersonId" label="SALAXY.NG1.WorkerDetailsComponent.ssNumber" sxy-personal-id-fi ng-required="true" ng-model="$ctrl.current.identity.personalId"></salaxy-input>
          <salaxy-input-enum enum="Language" ng-model="$ctrl.current.identity.language" name="workerLanguage" label="SALAXY.NG1.WorkerDetailsComponent.language"></salaxy-input-enum>
        </fieldset>
        <fieldset ng-if="!$ctrl.isNew()">
          <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.details"></legend>
          <salaxy-input read-only="$ctrl.current.isRegistered ? true : undefined" name="firstName" label="SALAXY.NG1.WorkerDetailsComponent.firstName" ng-required="true" ng-model="$ctrl.current.identity.firstName"></salaxy-input>
          <salaxy-input read-only="$ctrl.current.isRegistered ? true : undefined" name="lastName" label="SALAXY.NG1.WorkerDetailsComponent.lastName" ng-required="true" ng-model="$ctrl.current.identity.lastName"></salaxy-input>
          <salaxy-input name="officialPersonId" label="SALAXY.NG1.WorkerDetailsComponent.ssNumber" sxy-personal-id-fi read-only="true" ng-required="true" ng-model="$ctrl.current.identity.personalId"></salaxy-input>
          <salaxy-form-group ng-if="'workers.employments.employmentId' | sxyShow: 'workers.index'" label="SALAXY.NG1.WorkerDetailsComponent.workerId" name="workerId">
            <div class="salaxy-read-only-value">
              <small ng-if="!$ctrl.current.isRegistered">{{ $ctrl.current.info.workerAccountId | sxyIban }}</small>
              <code ng-if="$ctrl.current.isRegistered">{{ $ctrl.current.info.workerAccountId | sxyIban }}</code><br/>
              <small>({{ $ctrl.current.isRegistered ? "Rekisteröitynyt, pysyvä ID" : "Ei rekisteröitynyt, tilapäinen ID" }})</small>
            </div>
          </salaxy-form-group>
          <salaxy-input-enum enum="Language" ng-model="$ctrl.current.identity.language" read-only="$ctrl.current.isRegistered" name="workerLanguage" label="SALAXY.NG1.WorkerDetailsComponent.language"></salaxy-input-enum>
        </fieldset>
        <fieldset>
          <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.paymentDetails"></legend>
          <salaxy-input-enum ng-if="!('hideSalaryPaymentMethod' | sxyIsInRole)" label="SALAXY.NG1.WorkerDetailsComponent.salaryPaymentMethod" name="employmentRelationSalaryPaymentMethod" ng-model="$ctrl.current.info.salaryPaymentMethod" enum="EmploymentRelationSalaryPaymentMethod" required placeholder="SALAXY.UI_Terms.selectAlt"></salaxy-input-enum>
          <salaxy-input ng-if="$ctrl.current.info.salaryPaymentMethod === 'bankAccount'" name="ibanNumber" label="SALAXY.NG1.WorkerDetailsComponent.ibanNumber" sxy-iban
            require="$ctrl.isRequired('ibanNumber')" ng-model="$ctrl.current.info.ibanNumber" tooltip-html="{{ $ctrl.getInputTooltip('ibanNumber') }}"></salaxy-input>
        </fieldset>
      </div>
      <div class="col-md-6">
        <fieldset>
          <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.contactInfo"></legend>
          <salaxy-input name="email" label="SALAXY.NG1.WorkerDetailsComponent.email" sxy-email ng-model="$ctrl.getContact().email" tooltip-html="{{ $ctrl.getInputTooltip('email') }}"></salaxy-input>
          <salaxy-input name="telephone" label="SALAXY.NG1.WorkerDetailsComponent.tel" sxy-mobile-phone ng-model="$ctrl.getContact().telephone" tooltip-html="{{ $ctrl.getInputTooltip('telephone') }}"></salaxy-input>
        </fieldset>
        <fieldset>
          <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.address"></legend>
          <p ng-if="!$ctrl.isOtherIdentifier" sxy-text="SALAXY.NG1.WorkerDetailsComponent.addressInfo"></p>
          <p ng-if="$ctrl.isOtherIdentifier" sxy-text="SALAXY.NG1.WorkerDetailsComponent.addressInfoOtherIdentifier"></p>
          <salaxy-input name="street" label="SALAXY.NG1.WorkerDetailsComponent.street" require="$ctrl.isRequired('street')" ng-model="$ctrl.getContact().street" tooltip-html="{{ $ctrl.getInputTooltip('street') }}">
          </salaxy-input>
          <salaxy-input name="postalCode" label="SALAXY.NG1.WorkerDetailsComponent.postalCode" require="$ctrl.isRequired('postalCode')" ng-model="$ctrl.getContact().postalCode" tooltip-html="{{ $ctrl.getInputTooltip('postalCode') }}">
          </salaxy-input>
          <salaxy-input name="city" label="SALAXY.NG1.WorkerDetailsComponent.city" require="$ctrl.isRequired('city')" ng-model="$ctrl.getContact().city" tooltip-html="{{ $ctrl.getInputTooltip('city') }}">
          </salaxy-input>
        </fieldset>
      </div>
    </div>
    <div ng-if="!$ctrl.isModal">
      <button ng-click="$ctrl.deleteEmployment()" type="button" class="btn btn-danger" sxy-text="SALAXY.UI_Terms.delete"></button>
      <button ng-click="$ctrl.save()" ng-disabled="basicForm.$invalid" class="btn btn-primary float-end" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </form>
</div>`);

 $templateCache.put("salaxy-components/worker/employment/Details_Calc.html",`<div>
  <div class="float-end" ng-if="!$ctrl.isModal">
    <salaxy-json-formatter key="'Debug'" sxy-if-role="test" json="$ctrl.current.work.salaryDefaults" open="1" type="dialog"></salaxy-json-formatter>
    <button ng-click="$ctrl.save()" ng-disabled="workerForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
  </div>
  <p>Oletuspalkkarivit kopioidaan uudelle laskelmalle sellaisenaan. Päivämäärärajaukset huomioidaan vain tuntien sisääntuonnissa.</p>  
  <salaxy-calc-rows-editor rows="$ctrl.current.work.salaryDefaults" row-sources="thisproperty will be removed, just a marker until refactoring"
    title="{{ 'SALAXY.NG1.WorkerDetailsComponent.defaultCalcRows' | sxyTranslate }}" type="salary-defaults-temp2" mode="{{ $ctrl.isReadOnlyForced ? 'read-only' : 'edit'}}"></salaxy-calc-rows-editor>
  <hr>
  <p>
    Hintoja käytetään tällä hetkellä tuntien sisään tuonnissa. Myöhemmissä versioissa oletushintoja käytetään myös laskurissa.<br>
    <span ng-if="'bizConfigs' | sxyIsInRole">Jos hintoihin lasketaan keskituntiansioita, voit käyttää erillistä <a ng-href="#/reports/pay-stats-report-query/{{$ctrl.current.id}}">ansioiden laskentaraporttia</a> tulosten tarkasteluun.</span>
    <span ng-if="'bizConfigs' | sxyIsInRole"><br>Jos haluat laskea uudelleen ja päivittää tälle työsuhteelle keskituntiansiot, voit käynnistää laskennan oheisesta painikkeesta. <button class="btn btn-xs btn-default" ng-click="$ctrl.recalculatePayStats()">Laske keskituntiansiot tälle työsuhteelle</button></span>
    <span ng-if="'bizConfigs' | sxyIsInRole"><br>Jos haluat laskea uudelleen ja päivittää kaikille työsuhteille keskituntiansiot, voit käynnistää laskennan oheisesta painikkeesta. <button class="btn btn-xs btn-danger" ng-click="$ctrl.recalculateAllPayStats()">Laske keskituntiansiot kaikille työsuhteille</button></span>
  </p>
  <salaxy-row-types-settings ng-ref="$ctrl.$prices" mode="prices" model="$ctrl.current"></salaxy-row-types-settings>
</div>

<p>&nbsp;</p>

<div class="row form-horizontal" ng-if="!$ctrl.isHousehold && ('employments.defaultCalcRows.features' | sxyShow: 'workers.details')">
  <div class="col-sm-6">
    <fieldset>
      <legend sxy-text="SALAXY.NG1.WorkerDetailsCalc.payrollDetails"></legend>
      <salaxy-input-enum label="SALAXY.NG1.WorkerDetailsCalc.wageBasis" name="wageBases" ng-model="$ctrl.current.work.wageBasis" enum="WageBasis" type="select" read-only="$ctrl.isReadOnlyForced"></salaxy-input-enum>
      <salaxy-input-number label="SALAXY.NG1.WorkerDetailsCalc.monthlyHours" name="monthlyHours" unit="hour" ng-model="$ctrl.current.work.monthlyHours" read-only="$ctrl.isReadOnlyForced"></salaxy-input-number>
      <salaxy-input-enum label="SALAXY.NG1.WorkerDetailsCalc.irIncomeEarnerTypes" label-type="basic" name="wageBases" ng-model="$ctrl.current.info.irIncomeEarnerTypes" enum="IncomeEarnerType" type="multi-select" read-only="$ctrl.isReadOnlyForced"></salaxy-input-enum>
    </fieldset>
  </div>
  <div class="col-sm-6">
    <fieldset>
      <legend sxy-text="SALAXY.NG1.WorkerDetailsCalc.integrations"></legend>
      <salaxy-input label="SALAXY.NG1.WorkerDetailsCalc.ssNumber" name="sourceId" ng-model="$ctrl.current.info.sourceId" read-only="$ctrl.isReadOnlyForced"></salaxy-input>
    </fieldset>
    <salaxy-cost-accounting read-only="$ctrl.isReadOnlyForced" ng-init="$ctrl.current.work.accounting = $ctrl.current.work.accounting ? $ctrl.current.work.accounting : { dimensions: []}" current="$ctrl.current.work.accounting.dimensions"
      scope="calculation"></salaxy-cost-accounting>
  </div>
  <div class="col-sm-6" ng-if="'bizConfigs' | sxyIsInRole">
    <ng-include src="'salaxy-components/worker/employment/Details_Configs.html'"></ng-include>
  </div>
  <div class="col-sm-6" ng-if="'bizConfigs' | sxyIsInRole">
    <ng-include src="'salaxy-components/worker/employment/Details_Accruals.html'"></ng-include>
  </div>
</div>
<div class="text-end" ng-if="!$ctrl.isModal">
  <button ng-click="$ctrl.save()" ng-disabled="workerForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`);

 $templateCache.put("salaxy-components/worker/employment/Details_Configs.html",`<div ng-if="$ctrl.current">
  <sxy-form open-api="salaxy-secure/schemas/v02.json" type="Employment" auto-gen="false" debugger="false" model="$ctrl.current">
    <div>
      <fieldset>
        <legend><span sxy-text="SALAXY.MODEL.Employment.configs.title"></span></legend>
        <sxy-input model="form.configs" include="name,data,priority">
          <form>
             <fieldset>
                <legend sxy-text="SALAXY.MODEL.BizConfig.title"></legend>
                <sxy-input require="true" model="form.name"></sxy-input>
                <salaxy-input-collective-bargain-agreement name="cbaCode" ng-model="$ctrl.current.cbaCode" label="SALAXY.MODEL.BizConfig.cbaCode.title"></salaxy-input-collective-bargain-agreement>
                <salaxy-input-employee-group name="employeeGroup" ng-model="$ctrl.current.employeeGroup" label="SALAXY.MODEL.BizConfig.employeeGroup.title"></salaxy-input-employee-group>
                <sxy-input model="form.disabled"></sxy-input>
                <sxy-input model="form.startDate"></sxy-input>
                <sxy-input model="form.endDate"></sxy-input>
                <salaxy-input-enum ng-model="$ctrl.current.dataType" name="dataType" label="SALAXY.MODEL.BizConfig.dataType.title" options="{
                      'string': 'Teksti',
                      'number': 'Luku',
                      'boolean': 'Kyllä/Ei'
                     }"></salaxy-input-enum>
                <salaxy-input ng-show="!$ctrl.current.dataType || $ctrl.current.dataType === 'string'" ng-model="$ctrl.current.data" name="dataString" label="SALAXY.MODEL.BizConfig.data.title"></salaxy-input>
                <salaxy-input-number ng-show="$ctrl.current.dataType == 'number'" ng-model="$ctrl.current.data"  name="dataNumber" label="SALAXY.MODEL.BizConfig.data.title"></salaxy-input-number>
                <salaxy-input-boolean ng-show="$ctrl.current.dataType == 'boolean'" ng-model="$ctrl.current.data" name="dataBoolean" label="SALAXY.MODEL.BizConfig.data.title"></salaxy-input-boolean>       
                <sxy-input model="form.updatedAt" read-only="true"></sxy-input>
                <sxy-input model="form.updatedBy" read-only="true"></sxy-input>
            </fieldset>
          </form>
        </sxy-input>
      </fieldset>
    </div>
  </sxy-form>
</div>`);

 $templateCache.put("salaxy-components/worker/employment/Details_EmploymentRelation.html",`﻿<div class="salaxy-component salaxy-worker-employment">
  <ng-form name="$ctrl.employmentForm" class="form-horizontal" ng-readonly="$ctrl.isReadOnlyForced">
    <ng-include src="'salaxy-components/worker/employment/shared-EmploymentRelation.html'"></ng-include>
    <div class="text-end" ng-if="!$ctrl.isModal">
      <button ng-click="$ctrl.save()" class="btn btn-primary" ng-disabled="$ctrl.employmentForm.$invalid" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </ng-form>
</div>`);

 $templateCache.put("salaxy-components/worker/employment/Details_Header.html",`<div class="salaxy-calc-worker-info">
  <div ng-if="$ctrl.status == 'initialLoading'">
    <div class="col-3 col-sm-2">
      <salaxy-spinner></salaxy-spinner>
    </div>
    <div class="col-9 col-sm-10 worker-info-col">
      <h2 sxy-text="SALAXY.UI_Terms.loading"></h2>
      <div class="row">
        <div class="col-12 col-sm-6">
          &nbsp;<br /> &nbsp;
          <br /> &nbsp;
        </div>
        <div class="col-12 col-sm-6">
          &nbsp;<br />
          <div>&nbsp;</div>
          <div>&nbsp;</div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" ng-if="$ctrl.status !== 'initialLoading'">
    <div class="col-3 col-md-2 align-items-center justify-content-center d-flex">
      <salaxy-avatar avatar="$ctrl.current.personalInfo.avatar"></salaxy-avatar>
    </div>
    <div class="col-9 col-md-10 worker-info-col">
      <div class="d-flex justify-content-between">
        <h2>{{ $ctrl.current.personalInfo.avatar.displayName || ("SALAXY.NG1.WorkerInfo.noSelection" | sxyTranslate) }}</h2>
        <salaxy-action-button label="SALAXY.NG1.WorkerDetailsComponent.newCalculation" action="'newCalcForEmployment'" ng-if="!$ctrl.isModal" options="{'id': $ctrl.currentId }" button-class="btn-default float-start float-sm-end"></salaxy-action-button>
      </div>
      <div class="row" ng-if="$ctrl.current">
        <div class="col-12 col-md-6">
          <div ng-class="$ctrl.current.personalInfo.officialId ? '' : 'text-danger'">
            {{ $ctrl.current.personalInfo.officialId || ( "SALAXY.NG1.PaymentDialogComponent.noSSNumber" | sxyTranslate ) }}
            &nbsp;
            <div class="btn-group dropdown" ng-if="$ctrl.otherEmployments.length > 0">
              <button id="single-button" type="button" class="btn btn-default btn-xs dropdown-toggle" data-bs-toggle="dropdown">
                {{ $ctrl.otherEmployments.length }} muuta työsuhdetta
              </button>
              <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
                <li role="menuitem" ng-repeat="item in $ctrl.otherEmployments">
                  <a ng-href="{{$ctrl.isModal ? '' : ('#/employments/details/' + item.id)}}" class="dropdown-item">
                    {{ $ctrl.getEmploymentDescription(item) }}
                    ({{ $ctrl.getActiveText(item) }})
                  </a>
                </li>
              </ul>
            </div>
            <span ng-if="!$ctrl.otherEmployments">Tarkistetaan muita työsuhteita...</span>
          </div>
          <div>{{ $ctrl.getEmploymentDescription($ctrl.current) }}</div>
          <div>{{ $ctrl.getActiveText($ctrl.current) }}</div>
          <div><small>{{ $ctrl.current.id }}</small></div>
        </div>
        <div class="col-12 col-md-6 ">
          
          <div ng-if="$ctrl.readOnlyDefaultContact.email">
            <a href="{{ 'mailto:' + $ctrl.readOnlyDefaultContact.email }}">{{ $ctrl.readOnlyDefaultContact.email }}</a>
          </div>
          <div ng-if="!$ctrl.readOnlyDefaultContact.email">
            <span sxy-text="SALAXY.NG1.PaymentDialogComponent.noEmail"></span>
            <span class="text-warning" sxy-text="SALAXY.NG1.PaymentDialogComponent.noEmailInfo"></span>
          </div>
          <div ng-if="!$ctrl.current.info.ibanNumber" class="text-danger" sxy-text="SALAXY.NG1.WorkerInfo.noIbanNumber"></div>
          <div ng-if="$ctrl.current.info.ibanNumber">IBAN: {{ $ctrl.current.info.ibanNumber | sxyIban }}</div>
          <div ng-class="{ 'text-danger': $ctrl.getTaxCardInfo().isMissing }">
            {{ $ctrl.getTaxCardInfo().text }}</div>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/employment/Details_Tax.html",`<form name="employmentTaxcardForm" class="form-horizontal" ng-readonly="$ctrl.isReadOnlyForced">
  <salaxy-input-enum label="SALAXY.NG1.WorkerDetailsComponent.employmentTaxcard" name="employmentTaxcard" ng-model="$ctrl.taxcardType"
    enum="EmploymentRelationTaxcard" label-cols="col-sm-5"></salaxy-input-enum>
</form>
<div ng-switch="$ctrl.current.info.taxcard">
  <div ng-switch-when="taxAtSource">
    <fieldset>
      <legend>{{'SALAXY.NG1.EmploymentDetails.taxAtSource.title' | sxyTranslate}}</legend>
      <div class="alert alert-danger" ng-if="!$ctrl.socSec.isInternational" sxy-html="SALAXY.NG1.EmploymentDetails.taxAtSource.info.html"></div>
      <salaxy-input-number name="percent" unit="percent" minimum="0" maximum="100" label="SALAXY.NG1.EmploymentDetails.percent" label-cols="col-sm-8" ng-model="$ctrl.current.international.taxAtSource.percent" require="true"></salaxy-input-number>
      <salaxy-input-number name="deductionMonthly" unit="eur" label="SALAXY.NG1.EmploymentDetails.monthlyDeduction" label-cols="col-sm-8" ng-model="$ctrl.current.international.taxAtSource.deductionMonthly"></salaxy-input-number>
      <salaxy-input-number name="deductionDaily" unit="eur" label="SALAXY.NG1.EmploymentDetails.deductionDaily" label-cols="col-sm-8" ng-model="$ctrl.current.international.taxAtSource.deductionDaily"></salaxy-input-number>
    </fieldset>
    <div class="text-right">
      <button ng-click="$ctrl.save()" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </div>
  <div ng-switch-when="noTaxCard">
    <fieldset>
      <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.taxCard.noTaxCard"></legend>
      <p sxy-text="SALAXY.NG1.WorkerDetailsComponent.taxCard.noTaxCardText"></p>
    </fieldset>
  </div>
  <div ng-switch-default>
    <salaxy-employment-taxcards employment-id="$ctrl.current.id" on-save="$ctrl.reload()" is-read-only-forced="$ctrl.isReadOnlyForced" hide-buttons="$ctrl.isReadOnlyForced"
      ng-ref="$ctrl.taxcardsController"></salaxy-employment-taxcards>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/employment/shared-EmploymentRelation.html",`<div class="row">
  <div class="col-md-6" ng-if="!$ctrl.isHousehold">
    <salaxy-input-enum ng-required="true" hidden-options="undefined" name="type" ng-model="$ctrl.current.info.type" ng-change="$ctrl.employmentTypeChange()"
      enum="EmploymentRelationType" type="{{ $ctrl.socSec.isInternational ? 'select' : 'radio'}}" label="Työsuhteen tyyppi"
      label-type="{{ $ctrl.current.info.type == 'foreignWorker' ? 'basic' : 'plain'}}"
      filter="entrepreneur,farmer,monthlySalary,hourlySalary,salary,employedByStateEmploymentFund,compensation,boardMember,athlete,performingArtist,foreignWorker"></salaxy-input-enum>
    <p>&nbsp;</p>
    <div ng-if="( $ctrl.current.info.type == 'entrepreneur' ||  $ctrl.current.employment.type == 'farmer')">
      <div class="alert alert-danger" ng-if="$ctrl.session.currentAccount.companyType =='fiTm'" sxy-text="SALAXY.NG1.WorkerWizardComponent.workerType.entrepreneurTmiWarning"></div>
      <div class="alert alert-danger" ng-if="$ctrl.session.currentAccount.companyType =='fiRy'" sxy-text="SALAXY.NG1.WorkerWizardComponent.workerType.entrepreneurRyWarning"></div>
      <div class="alert alert-danger" ng-if="$ctrl.session.currentAccount.entityType !='company'" sxy-text="SALAXY.NG1.WorkerWizardComponent.workerType.entrepreneurPrivateWarning"></div>
    </div>
    <fieldset ng-if="$ctrl.current.info.type == 'compensation'">
      <legend sxy-text="SALAXY.ENUM.EmploymentRelationType.compensation.label"></legend>
      <p>
        <span sxy-text="SALAXY.NG1.WorkerWizardComponent.workerType.compensationDescription"></span><br>
        <a href="{{'SALAXY.NG1.WorkerWizardComponent.workerType.compensationLink' | sxyTranslate}}" target="_blank" sxy-text="SALAXY.NG1.WorkerWizardComponent.workerType.compensationCta"></a>
      </p>
    </fieldset>
    <fieldset ng-if="$ctrl.socSec.isInternational">
      <legend>{{'SALAXY.NG1.EmploymentRelation.isInternational.title' | sxyTranslate}}</legend>
      <p sxy-html="SALAXY.NG1.EmploymentRelation.isInternational.info.html"></p>
      <salaxy-input-enum type="select" ng-model="$ctrl.country" label="SALAXY.MODEL.EmploymentRelationInternational.country.title" name="country" require="true" enum="Country"
        hidden-options="fi"></salaxy-input-enum>
      <salaxy-input-enum type="select" ng-model="$ctrl.current.international.idType" label="SALAXY.MODEL.EmploymentRelationInternational.idType.title" name="idType" require="true"
        enum="InternationalIdentifier"></salaxy-input-enum>
      <salaxy-input ng-model="$ctrl.current.international.foreignId" label="SALAXY.MODEL.EmploymentRelationInternational.foreignId.title" name="foreignId"
        require="true"></salaxy-input>
      <salaxy-input name="street" label="SALAXY.NG1.WorkerDetailsComponent.street" ng-model="$ctrl.getContact('foreign').street" require="true"></salaxy-input>
      <salaxy-input name="postalCode" label="SALAXY.NG1.WorkerDetailsComponent.postalCode" ng-model="$ctrl.getContact('foreign').postalCode" require="true"></salaxy-input>
      <salaxy-input name="city" label="SALAXY.NG1.WorkerDetailsComponent.city" ng-model="$ctrl.getContact('foreign').city" require="true"></salaxy-input>
      <salaxy-input-enum type="select" ng-model="$ctrl.getContact('foreign').country" label="SALAXY.MODEL.EmploymentRelationInternational.contactCountry.title"
        name="contactCountry" read-only="true" enum="Country"></salaxy-input-enum>
      <salaxy-input ng-if="$ctrl.getContact('foreign').country == 'other'" ng-model="$ctrl.getContact('foreign').countryOtherName"
        label="SALAXY.MODEL.EmploymentRelationInternational.country.title" name="countryOtherName" require="true"></salaxy-input>
      <salaxy-input-enum type="select" name="taxation"
        options="{ taxAtSource: ('SALAXY.NG1.EmploymentRelation.taxation.taxAtSource' | sxyTranslate), auto: ('SALAXY.NG1.EmploymentRelation.taxation.auto' | sxyTranslate), manual: ('SALAXY.NG1.EmploymentRelation.taxation.manual' | sxyTranslate) }"
        label="SALAXY.NG1.EmploymentRelation.taxation.label" ng-model="$ctrl.current.info.taxcard"></salaxy-input-enum>
    </fieldset>
    <fieldset ng-if="false && $ctrl.current.info.taxcard == 'taxAtSource'">
      <legend>{{'SALAXY.NG1.EmploymentRelation.taxAtSourceInfo' | sxyTranslate}}</legend>
      <salaxy-input-number name="percent" unit="percent" minimum="0" maximum="100" label="SALAXY.NG1.EmploymentRelation.percent" label-cols="col-sm-8"
        ng-model="$ctrl.current.international.taxAtSource.percent" require="true"></salaxy-input-number>
      <salaxy-input-number name="deductionMonthly" unit="eur" label="SALAXY.NG1.EmploymentRelation.monthlyDeduction" label-cols="col-sm-8"
        ng-model="$ctrl.current.international.taxAtSource.deductionMonthly"></salaxy-input-number>
      <salaxy-input-number name="deductionDaily" unit="eur" label="SALAXY.NG1.EmploymentRelation.deductionDaily" label-cols="col-sm-8"
        ng-model="$ctrl.current.international.taxAtSource.deductionDaily"></salaxy-input-number>
    </fieldset>
  </div>
  <div class="col-md-6">
    <fieldset ng-if="!$ctrl.isHousehold">
      <legend>{{'SALAXY.NG1.EmploymentRelation.socSec'|sxyTranslate}}</legend>
      <salaxy-input-enum type="select" name="socialSecurity" ng-if="$ctrl.socSec.isInternational" enum="InternationalSocialSecurityType"
        label="SALAXY.MODEL.EmploymentRelationInternational.socialSecurity.title" ng-model="$ctrl.current.international.socialSecurity"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.current.international.socialSecurity == 'mixed'" type="multi-select" name="irIncomeEarnerTypes" disable-cache="true"
        enum="InternationalSocialSecurityException" label="SALAXY.MODEL.EmploymentRelationInternational.socialSecurityExceptions.title"
        ng-model="$ctrl.current.international.socialSecurityExceptions" label-type="basic" hidden-options="voluntaryEarningsRelatedPensionInsurance"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.socSec.pensionCalculationOptions" type="select" name="pensionCalculation" disable-cache="true"
        options="$ctrl.socSec.pensionCalculationOptions" label="SALAXY.NG1.WorkerWizardComponent.employment.pension.title" ng-model="$ctrl.current.info.pensionCalculation"
        ng-change="$ctrl.pensionCalculationChange()"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.socSec.showPensionCompanySelection" type="select" name="pensionCompany" placeholder="SALAXY.UI_Terms.notChosen" disable-cache="true"
        options="$ctrl.socSec.pensionCompanies" label="SALAXY.MODEL.PensionContract.title" ng-model="$ctrl.current.info.pensionCompany"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.socSec.pensionContractNumbers" type="select" name="pensionContractNumber" placeholder="SALAXY.UI_Terms.notChosen" disable-cache="true"
        options="$ctrl.socSec.pensionContractNumbers" label="SALAXY.MODEL.PensionContract.contractNumber.title"
        ng-model="$ctrl.current.info.pensionContractNumber"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.socSec.showPension && ('test,admin,pro' | sxyIsInRole)" type="select" name="pensionRule" enum="PensionRule"
        label="SALAXY.NG1.WorkerWizardComponent.employment.pensionRule" ng-model="$ctrl.current.info.pensionRule"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.socSec.showInsuranceCompanySelection" type="select" name="insuranceCompany" placeholder="SALAXY.UI_Terms.notChosen" disable-cache="true"
        options="$ctrl.socSec.insuranceCompanies" label="SALAXY.NG1.InsuranceSettingsComponent.insurance.title" ng-model="$ctrl.current.info.insuranceCompany"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.socSec.insuranceContractNumbers" type="select" name="insuranceContractNumber" placeholder="SALAXY.UI_Terms.notChosen" disable-cache="true"
        options="$ctrl.socSec.insuranceContractNumbers" label="SALAXY.MODEL.InsuranceContract.contractNumber.title"
        ng-model="$ctrl.current.info.insuranceContractNumber"></salaxy-input-enum>
    </fieldset>
    <fieldset>
      <legend ng-if="!$ctrl.isHousehold">{{'SALAXY.NG1.EmploymentRelation.employmentRelation'|sxyTranslate}}</legend>
      <salaxy-input ng-model="$ctrl.current.work.description" label="SALAXY.NG1.WorkerWizardComponent.employment.work.description" name="description"></salaxy-input>
      <salaxy-input-occupation-type  name="occupationType" ng-model="$ctrl.current.work.occupationCode"
        label="SALAXY.NG1.WorkerWizardComponent.employment.work.occupationCode"></salaxy-input-occupation-type>
      <salaxy-input-collective-bargain-agreement name="collectiveBargainAgreement" ng-model="$ctrl.current.info.cbaCode" label="SALAXY.NG1.WorkerWizardComponent.employment.info.cbaCode"></salaxy-input-collective-bargain-agreement>
      <salaxy-input-employee-group ng-if="'bizConfigs' | sxyIsInRole" name="employeeGroup" ng-model="$ctrl.current.info.employeeGroup" label="SALAXY.MODEL.EmploymentRelationInfo.employeeGroup.title"></salaxy-input-employee-group>
      <salaxy-input tooltip-html="&lt;a target=&#39;_blank&#39; href=&#39;https://www.keva.fi/tyonantajalle/elakemaksut/ammattinimikkeiden-haku/&#39;&gt;Info&lt;/a&gt;" ng-if="$ctrl.current.info.pensionCalculation == 'publicSector'" name="occupationCode2" ng-model="$ctrl.current.work.occupationCode2"
        label="SALAXY.NG1.WorkerWizardComponent.employment.work.occupationCode2"></salaxy-input>
      <salaxy-form-group label="SALAXY.NG1.WorkerWizardComponent.employment.group.title" name="contract">
        <salaxy-datepicker-popup name="startDate" label="SALAXY.NG1.WorkerWizardComponent.employment.group.startDate"
          ng-model="$ctrl.current.info.startDate"></salaxy-datepicker-popup>
        <salaxy-datepicker-popup name="endDate" label="SALAXY.NG1.WorkerWizardComponent.employment.group.endDate"
          disabled="!$ctrl.current.info.isFixedTerm && !$ctrl.current.info.isTerminated" ng-model="$ctrl.current.info.endDate"></salaxy-datepicker-popup>
        <salaxy-input-boolean type="checkbox" ng-model="$ctrl.current.info.isFixedTerm" name="isFixedTerm" id="isFixedTerm" label-type="no-label" label-true="SALAXY.NG1.WorkerWizardComponent.employment.isFixedTerm"></salaxy-input-boolean>
        <salaxy-input-boolean type="checkbox" ng-model="$ctrl.current.info.isTerminated" name="isTerminated" id="isTerminated" label-type="no-label" label-true="SALAXY.NG1.WorkerWizardComponent.employment.isTerminated"></salaxy-input-boolean>

      </salaxy-form-group>
      <salaxy-input-enum ng-if="$ctrl.current.info.pensionCalculation == 'publicSector'" type="select" name="employmentRegCodes" disable-cache="true"
      options="$ctrl.socSec.employmentRegCodes" label="SALAXY.NG1.WorkerWizardComponent.employment.employmentRegCode" ng-model="$ctrl.current.info.employmentRegCode"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.current.isReadOnly" label="SALAXY.NG1.WorkerDetailsComponent.salaryPaymentMethod" name="employmentRelationSalaryPaymentMethod"
        ng-model="$ctrl.current.info.salaryPaymentMethod" enum="EmploymentRelationSalaryPaymentMethod" required placeholder="SALAXY.UI_Terms.selectAlt"></salaxy-input-enum>
    </fieldset>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/EmploymentEditModal.html",`﻿<div class="modal-worker-edit">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-employment-details model="$ctrl.current" current-tab="{{$ctrl.logic.initialTab}}" is-read-only-forced="$ctrl.route.readOnly" is-modal="true" ng-ref="$ctrl.employmentDetails"></salaxy-employment-details>
  </div>
  <div class="modal-footer text-end">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" ng-if="$ctrl.logic.buttonTypes != 'updateCalc'" ng-disabled="$ctrl.employmentDetails.employmentForm.$invalid" sxy-text="SALAXY.UI_Terms.save"></button>
    <button type="submit" class="btn btn-default" ng-click="$close('ok-no-rows')" ng-if="$ctrl.logic.buttonTypes == 'updateCalc'" ng-disabled="$ctrl.employmentDetails.employmentForm.$invalid" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.workerEdit.updateWorkerInfo"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" ng-if="$ctrl.logic.buttonTypes == 'updateCalc'" ng-disabled="$ctrl.employmentDetails.employmentForm.$invalid" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.workerEdit.updateWorkerInfoAndSalaryRows"></button>
  </div>
</div>
`);

 $templateCache.put("salaxy-components/worker/EmploymentList.html",`<div class="salaxy-component salaxy-worker-list">
  <salaxy-odata-table logic="{showToolbar: $ctrl.showToolbar}" url="/v03/api/employments?activeDate=today"
    options="{$top: $ctrl.limitTo}"
    ng-if="($ctrl.mode || 'default') == 'default'"
    read-only="$ctrl.readOnly" crud-controller="EmploymentCrudController as $crud"
    template-url="salaxy-components/odata/lists/Employments.html"></salaxy-odata-table>
  <salaxy-odata-table select-mode="$ctrl.mode" url="/v03/api/employments?activeDate=today"
    options="{$top: $ctrl.limitTo }"
    ng-if="$ctrl.mode == 'select' || $ctrl.mode == 'multiselect'"
     template-url="salaxy-components/odata/lists/Employments-select.html"
    items="$ctrl.items" selected-items="$ctrl.selectedItems"
    on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });"
    crud-controller="EmploymentCrudController as $crud"></salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/worker/EmploymentWizard/identity.html",`<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid  }}</span>
  <div class="row">
    <div class="col-12 col-sm-6 margin-top-sm margin-xs">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.details"></legend>
        <salaxy-input name="officialPersonId" label="SALAXY.NG1.WorkerDetailsComponent.ssNumber" sxy-personal-id-fi ng-required="true" ng-model="$ctrl.current.identity.personalId">
        </salaxy-input>
        <salaxy-input name="firstName" label="SALAXY.NG1.WorkerDetailsComponent.firstName" ng-required="true" ng-model="$ctrl.current.identity.firstName"></salaxy-input>
        <salaxy-input name="lastName" label="SALAXY.NG1.WorkerDetailsComponent.lastName" ng-required="true" ng-model="$ctrl.current.identity.lastName"></salaxy-input>
      </fieldset>
    </div>
    <div class="col-12 col-sm-6 margin-top-sm margin-xs">
      <fieldset ng-if="$ctrl.otherEmployments.length > 0">
        <legend>Henkilötunnuksella on jo {{ $ctrl.otherEmployments.length }} työsuhdetta</legend>
        <div class="list-group">
          <a ng-href="#/employments/details/{{ item.id }}" ng-click="$close()" class="list-group-item" ng-repeat="item in $ctrl.otherEmployments">
            <strong>{{ $ctrl.getEmploymentDescription(item) }}</strong><br>
            {{ $ctrl.getActiveText(item) }}
          </a>
        </div>
      </fieldset>
      <fieldset salaxy-if-role="test">
        <legend>Vain TESTI</legend>
        <p>
          <strong>Vain testiympäristö:</strong> Täytä loput tiedot nimen perusteella (syötä ensin etu- ja sukunimi).
        </p>
        <div class="text-end">
          <button ng-disabled="!$ctrl.current.identity.firstName || !$ctrl.current.identity.lastName" ng-click="$ctrl.populateWithTestData(true)" class="btn btn-danger">
            Täytä tiedot</button>
          <button ng-disabled="!$ctrl.current.identity.firstName || !$ctrl.current.identity.lastName" ng-click="$ctrl.populateWithTestData(false)" class="btn btn-default">...keinohetu</button>
        </div>
      </fieldset>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/worker/EmploymentWizard/index.html",`<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.WorkerWizardComponent.wizard.title"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="d-block d-md-none">
    <h4><span sxy-text="SALAXY.NG1.WorkerWizardComponent.wizard.step"></span> {{$ctrl.currentStep.number}}/{{$ctrl.steps.length}}</h4>
  </div>
  <div class="salaxy-wizard">
    <div class="wizard-steps">
      <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
        <span class="salaxy-avatar">
          <div class="wizard-icons-wrapper">
            <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
            <i class="bi bi-circle-fill"></i>
          </div>
          <strong class="number">{{ step.number }}</strong>
        </span>
        <span class="step-text">{{ step.title | sxyTranslate }}</span>
      </div>
    </div>
    <div class="wizard-strikethrough"></div>
  </div>
  <div class="worker-wizard-content">
    <ng-include src="$ctrl.currentStep.view"></ng-include>
  </div>
</div>
<div class="modal-footer">
  <div>
    <button ng-if="$ctrl.step &lt; 2" ng-click="$close('cancel')" class="btn btn-default" sxy-text="SALAXY.UI_Terms.close"></button>
    <button ng-if="$ctrl.step >= 2" ng-click="$ctrl.goPrevious()" ng-disabled="!$ctrl.canGoPrevious" class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
  </div>
  <div class="ms-auto">
    <button ng-if="$ctrl.step &lt; $ctrl.steps.length" ng-click="$ctrl.goNext()" ng-disabled="!$ctrl.canGoNext" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>
    <button ng-if="$ctrl.step == $ctrl.steps.length" ng-click="$ctrl.saveAndClose($close)" class="btn btn-primary" ng-disabled="!$ctrl.formDataValidity" sxy-text="SALAXY.UI_Terms.done"></button>
  </div>
  
</div>`);

 $templateCache.put("salaxy-components/worker/EmploymentWizard/person.html",`<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid  }}</span>
    <div class="row">
    <div class="col-12 col-sm-6 margin-top-sm margin-xs">
      <fieldset>
        <legend>Yhteystiedot</legend>
        <salaxy-input name="email" label="SALAXY.NG1.WorkerDetailsComponent.email" sxy-email ng-model="$ctrl.getContact().email"></salaxy-input>
        <salaxy-input name="telephone" label="SALAXY.NG1.WorkerDetailsComponent.tel" sxy-mobile-phone ng-model="$ctrl.getContact().telephone"></salaxy-input>
      </fieldset>
      <fieldset ng-if="$ctrl.isOtherIdentifier">
        <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.address"></legend>
        <p class="small" sxy-text="SALAXY.NG1.WorkerDetailsComponent.unRealPersonalIndenficationNumer"></p>
        <salaxy-input name="street" label="SALAXY.NG1.WorkerDetailsComponent.street" ng-required="true" ng-model="$ctrl.getContact().street">
        </salaxy-input>
        <salaxy-input name="postalCode" label="SALAXY.NG1.WorkerDetailsComponent.postalCode" ng-required="true" ng-model="$ctrl.getContact().postalCode">
        </salaxy-input>
        <salaxy-input name="city" label="SALAXY.NG1.WorkerDetailsComponent.city" ng-required="true" ng-model="$ctrl.getContact().city">
        </salaxy-input>
      </fieldset>
    </div>
    <div class="col-12 col-sm-6 margin-top-sm margin-xs">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.paymentDetails"></legend>
        <salaxy-input-enum label="SALAXY.NG1.WorkerDetailsComponent.salaryPaymentMethod" name="employmentRelationSalaryPaymentMethod" ng-model="$ctrl.current.info.salaryPaymentMethod" enum="EmploymentRelationSalaryPaymentMethod" required placeholder="SALAXY.UI_Terms.selectAlt"></salaxy-input-enum>
        <salaxy-input ng-if="$ctrl.current.info.salaryPaymentMethod === 'bankAccount'" name="ibanNumber" label="SALAXY.NG1.WorkerDetailsComponent.ibanNumber" sxy-iban ng-required="true" ng-model="$ctrl.current.info.ibanNumber"></salaxy-input>
      </fieldset>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/worker/EmploymentWizard/tax.html",`<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>
  <div class="row">
    <div class="col-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.employmentTaxcard"></legend>
        <salaxy-input-enum label="" name="employmentTaxcard" ng-model="$ctrl.current.info.taxcard" enum="EmploymentRelationTaxcard"
          label-cols="col-sm-5" label-type="plain" type="radio"></salaxy-input-enum>
      </fieldset>
    </div>
    <div ng-switch="$ctrl.current.info.taxcard" class="col-6">
      <fieldset ng-switch-when="taxAtSource">
        <legend>{{'SALAXY.NG1.EmploymentDetails.taxAtSource.title' | sxyTranslate}}</legend>
        <div class="alert alert-danger" ng-if="!$ctrl.socSec.isInternational" sxy-html="SALAXY.NG1.EmploymentDetails.taxAtSource.info.html"></div>
        <salaxy-input-number name="percent" unit="percent" minimum="0" maximum="100" label="SALAXY.NG1.EmploymentDetails.percent" label-cols="col-sm-8"
          ng-model="$ctrl.current.international.taxAtSource.percent" require="true"></salaxy-input-number>
        <salaxy-input-number name="deductionMonthly" unit="eur" label="SALAXY.NG1.EmploymentDetails.monthlyDeduction" label-cols="col-sm-8"
          ng-model="$ctrl.current.international.taxAtSource.deductionMonthly"></salaxy-input-number>
        <salaxy-input-number name="deductionDaily" unit="eur" label="SALAXY.NG1.EmploymentDetails.deductionDaily" label-cols="col-sm-8"
          ng-model="$ctrl.current.international.taxAtSource.deductionDaily"></salaxy-input-number>
      </fieldset>
      <fieldset ng-switch-when="noTaxCard">
        <legend>Ei verokorttia (60%)</legend>
        <p class="lead">Ennakonpidätys tehdään 60%:n mukaan.</p>
      </fieldset>
      <fieldset ng-switch-when="auto">
        <legend sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCards.taxCardDetails.automaticTaxcard.legend"></legend>
        <!--
        TODO: Consider implementing this
        <button class="btn btn-default float-end" ng-click="$ctrl.getTaxCard()">Hae verokortti</button>
        -->
        <p sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCards.taxCardDetails.automaticTaxcard.mainTaxPercentApi"></p>
        <span sxy-html="SALAXY.NG1.CurrentTaxCardComponent.taxCards.taxCardDetails.automaticTaxcard.taxPercentInfoText.html"></span>
      </fieldset>
      <div ng-switch-default>
        <span class="d-none">{{ $ctrl.formDataValidity = $edit.isFormValid  }}</span>
        <salaxy-taxcard-manual-edit ng-ref="$edit" current="$ctrl.taxcard"></salaxy-taxcard-manual-edit>
      </div>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/worker/EmploymentWizard/type.html",`<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>
  <ng-include src="'salaxy-components/worker/employment/shared-EmploymentRelation.html'"></ng-include>
</form>`);

 $templateCache.put("salaxy-components/worker/EmploymentWizard/work.html",`<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid  }}</span>
  <div class="row">
    <div class="col-12 margin-top-sm margin-xs">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.WorkerWizardComponent.employment.work.salaryDefaults.title"></legend>
        <div sxy-html="SALAXY.NG1.WorkerWizardComponent.employment.work.salaryDefaults.info.md"></div>
        <div class="table-responsive">
          <salaxy-calc-rows-2019-editor rows="$ctrl.current.work.salaryDefaults" title="{{ 'SALAXY.NG1.WorkerDetailsComponent.defaultCalcRows' | sxyTranslate }}" condensed="true" mode="edit"></salaxy-calc-rows-2019-editor>
        </div>
      </fieldset>
    </div>
  </div>
</form>`);

 $templateCache.put("salaxy-components/worker/holidays/HolidayParametersForm.html",`<form class="form-horizontal" name="holidayForm">
  <div class="row form-horizontal">
    <div class="col-sm-4">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.legendSelectHolidayType"></legend>
        <div class="radio mb-1">
          <label class="d-flex align-items-start">
            <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="permanent14Days" value="permanent14Days" class="mt-1 me-2"> 
            <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.permanent14Days.html"></span>
          </label>
        </div>
        <div class="radio mb-1">
          <label class="d-flex align-items-start">
            <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="permanent35Hours" value="permanent35Hours" class="mt-1 me-2">
            <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.permanent35Hours.html"></span>
          </label>
        </div>
        <div class="radio mb-1">
          <label class="d-flex align-items-start">
            <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="holidayCompensation" value="holidayCompensation" class="mt-1 me-2">
            <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.holidayCompensation.html"></span>
          </label>
        </div>
        <div class="radio mb-1">
          <label class="d-flex align-items-start">
            <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="temporaryTimeOff" value="temporaryTimeOff" class="mt-1 me-2">
            <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.temporaryTimeOff.html"></span>
          </label>
        </div>
        <div class="radio mb-1">
          <label class="d-flex align-items-start">
            <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="other" value="other" class="mt-1 me-2">
            <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.other.html"></span>
          </label>
        </div>
        <div class="radio mb-1" ng-if="'bizConfigs' | sxyIsInRole">
          <label class="d-flex align-items-start">
            <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="script" value="script" class="mt-1 me-2">
            <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.script.html"></span>
          </label>
        </div>
        <div class="radio mb-1">
          <label class="d-flex align-items-start">
            <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="noHolidays" value="noHolidays" class="mt-1 me-2">
            <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.noHolidays.html"></span>
          </label>
        </div>
      </fieldset>
    </div>
    <div class="col-sm-8">
      <fieldset >
        <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.legendDetails"></legend>
        <div ng-if="$ctrl.getHolidayLogic($ctrl.current.spec).getVisibility($ctrl.current.spec, 'accrualFixed')" ng-init="$holidayLogic = $ctrl.getHolidayLogic($ctrl.current.spec)">
          <salaxy-input-boolean type="checkbox" name="accrualByLaw" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.accrualByLaw" label-true="{{ 'SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.accrualByLawLabelTrue' + ($ctrl.current.spec.code == 'temporaryTimeOff' ? '2' : '') }}"
            ng-change="$holidayLogic.accrualByLawChanged($ctrl.current.spec)" ng-model="$holidayLogic.accrualByLaw"></salaxy-input-boolean>
          <salaxy-input-number ng-model="$ctrl.current.spec.accrualFixed" name="accrualFixed" ng-if="$ctrl.current.spec.accrualFixed" ng-change="$holidayLogic.accrualFixedChanged($ctrl.current.spec)" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.accrualFixed" unit="days">
          </salaxy-input-number>
        </div>
        <salaxy-input-number ng-model="$ctrl.current.spec.compensation" name="compensation" ng-if="$ctrl.getHolidayLogic($ctrl.current.spec).getVisibility($ctrl.current.spec, 'compensation')" required label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.compensation" unit="percent"></salaxy-input-number>
        <salaxy-input-enum name="bonusMethod" ng-model="$ctrl.current.spec.bonusMethod" ng-if="$ctrl.getHolidayLogic($ctrl.current.spec).getVisibility($ctrl.current.spec, 'bonusMethod')" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethod" filter="none,payForHolidaySalary,paySelectedDays" enum="HolidayBonusPaymentMethod"></salaxy-input-enum>
        <salaxy-input-enum name="bonusMethod" ng-model="$ctrl.current.spec.bonusMethod" ng-if="$ctrl.getHolidayLogic($ctrl.current.spec).getVisibility($ctrl.current.spec, 'compensation')" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethod" options="{ 'none': ('SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethodNone' | sxyTranslate), 'payForHolidaySalary': ('SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethodPayForHolidaySalary' | sxyTranslate)  }">
        </salaxy-input-enum>
        <salaxy-input-number ng-model="$ctrl.current.spec.bonus" name="bonus" ng-if="$ctrl.getHolidayLogic($ctrl.current.spec).getVisibility($ctrl.current.spec, 'bonusPercent')" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusPercent" unit="percent"></salaxy-input-number>
        <div ng-if="$ctrl.getHolidayLogic($ctrl.current.spec).getVisibility($ctrl.current.spec, 'accruesHolidays')">
          <salaxy-input-enum  required name="wageBasis" ng-model="$ctrl.current.spec.wageBasis" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.wageBasis" enum="WageBasis" hidden-options="undefined,other"></salaxy-input-enum>
          <salaxy-input-enum name="holidayPayCalculation" ng-model="$ctrl.current.spec.holidayPayCalculation" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayCalculation.title" options="$ctrl.getHolidayLogic($ctrl.current.spec).getholidayPayCalculationOptions($ctrl.current.spec)" required disable-cache="true"></salaxy-input-enum>
          <salaxy-form-group name="holidayPayReport" ng-if="$ctrl.current.spec.holidayPayCalculation && $ctrl.current.spec.holidayPayCalculation != 'undefined' && $ctrl.current.spec.holidayPayCalculation != 'otherPay'" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.holidayPayCalculationReport">
            <a ng-href="#/reports/holiday-pay-report-query/{{$ctrl.current.year}}/{{$ctrl.current.employmentId}}" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.calculationReport"></a>
          </salaxy-form-group>
          <salaxy-form-group name="holidayPayEmploymentRecalculate" ng-if="('bizConfigs' | sxyIsInRole) && $ctrl.current.spec.holidayPayCalculation && $ctrl.current.spec.holidayPayCalculation != 'undefined' && $ctrl.current.spec.holidayPayCalculation != 'otherPay'" label="Vuosilomapalkan laskenta">
            <button class="btn btn-xs btn-default" ng-click="$ctrl.recalculateHolidayPay()">Laske vuosilomapalkka tälle työsuhteelle</button></span>
          </salaxy-form-group>
          <salaxy-form-group name="holidayPayRecalculate" ng-if="('bizConfigs' | sxyIsInRole) && $ctrl.current.spec.holidayPayCalculation && $ctrl.current.spec.holidayPayCalculation != 'undefined' && $ctrl.current.spec.holidayPayCalculation != 'otherPay'" label="Vuosilomapalkan laskenta">
            <button class="btn btn-xs btn-danger" ng-click="$ctrl.recalculateAllHolidayPay()">Laske vuosilomapalkka kaikille työsuhteille</button></span>
          </salaxy-form-group>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.otherPay" ng-if="$ctrl.current.spec.holidayPayCalculation == 'otherPay'" name="otherPay"  label="SALAXY.MODEL.HolidayPay.otherPay.title" ></salaxy-input-number>
  
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.normalMonthlyPayDailySalary" name="normalMonthlyPayDailySalary" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.wageBasis =='monthly' && $ctrl.current.spec.holidayPayCalculation == 'normalMonthlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.normalMonthlyPayDailySalary.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.normalMonthlyPayManual" name="normalMonthlyPayManual" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.wageBasis =='monthly' && $ctrl.current.spec.holidayPayCalculation == 'normalMonthlyPay'" label="SALAXY.MODEL.HolidayPay.normalMonthlyPayManual.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.normalMonthlyPay" name="normalMonthlyPay" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.wageBasis =='monthly' && $ctrl.current.spec.holidayPayCalculation == 'normalMonthlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.normalMonthlyPay.title" ></salaxy-input-number>

          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageDailyPayDailySalary" name="averageDailyPayDailySalary" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayDailySalary.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageDailyPayManual" name="averageDailyPayManual" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'" label="SALAXY.MODEL.HolidayPay.averageDailyPayManual.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageDailyPay" name="averageDailyPay" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPay.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageDailyPayBase" name="averageDailyPayBase" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayBase.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageDailyPayDays" name="averageDailyPayDays" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayDays.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageDailyPayMultiplier" name="averageDailyPayMultiplier" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayMultiplier.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.accrual" name="averageDailyPayAccrual" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'"disabled="true" label="SALAXY.MODEL.HolidayPay.accrual.title" ></salaxy-input-number>

          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageHourlyPayDailySalary" name="averageHourlyPayDailySalary" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayDailySalary.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageHourlyPayManual" name="averageHourlyPayManual" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" label="SALAXY.MODEL.HolidayPay.averageHourlyPayManual.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageHourlyPay" name="averageHourlyPay" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPay.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageHourlyPayBase" name="averageHourlyPayBase" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true"  label="SALAXY.MODEL.HolidayPay.averageHourlyPayBase.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageHourlyPayHours" name="averageHourlyPayHours" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayHours.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageHourlyPayMultiplier" name="averageHourlyPayMultiplier" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayMultiplier.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.accrual" name="averageHourlyPayAccrual" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.accrual.title"></salaxy-input-number>

          <salaxy-input-number ng-model="$ctrl.current.holidayPay.percentageBasedPayDailySalary" name="percentageBasedPayDailySalary" ng-if="($ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.holidayPayCalculation == 'percentageBasedPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPayDailySalary.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.percentageBasedPayManual" name="percentageBasedPayManual" ng-if="($ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.holidayPayCalculation == 'percentageBasedPay'" label="SALAXY.MODEL.HolidayPay.percentageBasedPayManual.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.percentageBasedPay" name="percentageBasedPay" ng-if="($ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.holidayPayCalculation == 'percentageBasedPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPay.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.percentageBasedPayBase" name="percentageBasedPayBase" ng-if="($ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.holidayPayCalculation == 'percentageBasedPay'"  disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPayBase.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.spec.holidayPayPercent" name="holidayPayPercent" ng-if="($ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.holidayPayCalculation == 'percentageBasedPay'" required unit="percent" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayPercent.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.accrual" name="percentageBasedPayAccrual" ng-if="($ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.holidayPayCalculation == 'percentageBasedPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.accrual.title"></salaxy-input-number>

          <salaxy-input-number ng-model="$ctrl.current.holidayPay.compensationPayDailySalary" name="compensationPayDailySalary" ng-if="($ctrl.current.spec.code == 'temporaryTimeOff'|| $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.holidayPayCalculation == 'holidayCompensation'" disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPayDailySalary.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.compensationPayManual" name="compensationPayManual" ng-if="($ctrl.current.spec.code == 'temporaryTimeOff'|| $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.holidayPayCalculation == 'holidayCompensation'" label="SALAXY.MODEL.HolidayPay.compensationPayManual.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.compensationPay" name="compensationPay" ng-if="$($ctrl.current.spec.code == 'temporaryTimeOff'|| $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.holidayPayCalculation == 'holidayCompensation'" disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPay.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.compensationPayBase" name="compensationPayBase" ng-if="($ctrl.current.spec.code == 'temporaryTimeOff'|| $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.holidayPayCalculation == 'holidayCompensation'" disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPayBase.title" ></salaxy-input-number>          
          <salaxy-input-number ng-model="$ctrl.current.spec.compensation" name="compensation" ng-if="($ctrl.current.spec.code == 'temporaryTimeOff'|| $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.holidayPayCalculation == 'holidayCompensation'" unit="percent" required label="SALAXY.MODEL.HolidaySpecificationForYear.compensation.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.accrual" name="compensationPayAccrual" ng-if="($ctrl.current.spec.code == 'temporaryTimeOff'|| $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script') && $ctrl.current.spec.holidayPayCalculation == 'holidayCompensation'" disabled="true" label="SALAXY.MODEL.HolidayPay.accrual.title"></salaxy-input-number>          

          <salaxy-input-number ng-model="$ctrl.current.holidayPay.scriptPay" ng-if="$ctrl.current.spec.holidayPayCalculation == 'scriptPay'" name="scriptPay"  label="SALAXY.MODEL.HolidayPay.scriptPay.title" ></salaxy-input-number>
 
          <salaxy-form-group label="SALAXY.MODEL.HolidaySpecificationForYear.employmentPeriod.title" name="contract">
            <salaxy-datepicker-popup require="true" name="startDate" label="SALAXY.NG1.WorkerWizardComponent.employment.group.startDate" ng-model="$ctrl.current.spec.employmentPeriod.start"></salaxy-datepicker-popup>
            <salaxy-datepicker-popup name="endDate" label="SALAXY.NG1.WorkerWizardComponent.employment.group.endDate" ng-model="$ctrl.current.spec.employmentPeriod.end"></salaxy-datepicker-popup>
          </salaxy-form-group>
        </div>
      </fieldset>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <button class="btn btn-primary float-end" ng-disabled="holidayForm.$invalid" ng-click="$ctrl.saveYear($ctrl.current)" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
</form>`);

 $templateCache.put("salaxy-components/worker/holidays/HolidayYearAccrual.html",`<salaxy-chart config="$ctrl.getChartConfig($ctrl.list)"></salaxy-chart>
<table class="table table-striped table-sm">
  <thead>
    <tr>
      <th sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableHead.month"></th>
      <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableHead.daysCount"></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: $ctrl.getRowColor('start'), initials: 'saldo', entityType: 'company' }"></salaxy-avatar>
        <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.startSaldo"></strong>
        <br />
        <small>
          <div class="truncate" style="max-width: 300px;" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.startSaldoMore"></div>
        </small>
      </td>
      <td class="right" style="width: 100px">
        <salaxy-input-number name="startSaldo" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.startSaldo" label-type="plain" unit="days" ng-model="$ctrl.parent.accrual.startSaldo"></salaxy-input-number>
      </td>
    </tr>
    <tr ng-repeat="row in $ctrl.list">
      <td>
        <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: $ctrl.getRowColor(row), initials: (row.month | date : 'MM'), entityType: 'company' }"></salaxy-avatar>
        <strong>{{ "SALAXY.ENUM.CalendarMonth.month" + (row.month | date : 'M') + ".label" | sxyTranslate }}</strong>
        <br />
        <small>
          <div class="truncate" style="max-width: 300px;">{{ $ctrl.getAccrualNotes(row) }}</div>
        </small>
      </td>
      <td class="right" style="width: 100px">
        <salaxy-input-number name="{{ 'daysAccrued' + $index }}" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.daysAccruedLabel" label-type="plain" unit="days" ng-model="row.daysAccrued" ng-change="row.daysAccrued == null ? row.source='initial': row.source = 'manual'"></salaxy-input-number>
      </td>
    </tr>
    <tr class="total">
      <td>
        <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: $ctrl.getRowColor('total'), initials: 'Yht.', entityType: 'company' }"></salaxy-avatar>
        <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.daysAccrued"></strong><br />
        <strong ng-if="$ctrl.getAccrualCalculations().totalToday != $ctrl.getAccrualCalculations().accrualToday" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.total"></strong>
        <div ng-if="$ctrl.getAccrualCalculations().total != $ctrl.getAccrualCalculations().totalToday" class="truncate" style="max-width: 300px;" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.estimatedHolidaysNexYear"></div>
      </td>
      <td class="right" style="width: 100px">
        <strong>{{ $ctrl.getAccrualCalculations().accrualToday | sxyCount : 'day' }}</strong><br />
        <strong ng-if="$ctrl.getAccrualCalculations().totalToday != $ctrl.getAccrualCalculations().accrualToday">{{ $ctrl.getAccrualCalculations().totalToday | sxyCount : 'day' }}</strong>
        <div ng-if="$ctrl.getAccrualCalculations().total != $ctrl.getAccrualCalculations().totalToday">{{ $ctrl.getAccrualCalculations().total | sxyCount : 'day' }}</div>
      </td>
    </tr>
  </tbody>
</table>
<div class="text-end">
  <button type="button" class="btn btn-primary" ng-click="$ctrl.saveParent()" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`);

 $templateCache.put("salaxy-components/worker/holidays/HolidayYearHolidays.html",`<div class="salaxy-component salaxy-holiday-year-holidays">
  <table class="table table-striped {{ $ctrl.condensed ? 'table-sm' : ''}}">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.period"></th>
        <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.daysCount"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-if="!$ctrl.condensed">
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: 'saldo', entityType: 'company' }"></salaxy-avatar>
          <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.availableHolidays"></strong>
          <br />
          <small>
            <div class="truncate" style="max-width: 250px;" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.availableHolidaysMore"></div>
          </small>
        </td>
        <td class="right">
          <strong>{{ $ctrl.getTotalDays("holidaysSaldoStart") | sxyCount : "day" }}</strong>
        </td>
      </tr>
      <tr ng-repeat="row in $ctrl.list | filter : $ctrl.filter" ng-click="$ctrl.showEditDialog(row)" class="clickable">
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
          <strong>{{ row.period | sxyDateRange }}</strong>
          <br />
          <small>
            <div class="truncate" style="max-width: 250px;">{{ $ctrl.getDescription(row) }}</div>
          </small>
        </td>
        <td class="right">
          <strong>{{ row.period.daysCount | sxyCount : "day"  }}</strong>
        </td>
      </tr>
      <tr class="total" ng-if="$ctrl.condensed">
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
          <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.total"></strong>
        </td>
        <td class="right">
          <strong>{{ $ctrl.getTotalDays("filtered") | sxyCount : "day" }}</strong>
        </td>
      </tr>
      <tr ng-if="$ctrl.list.length == 0 && !$ctrl.condensed">
        <td colspan="2" style="padding-left: 48px">
          <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.noHolidaysTitle"></h3>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.noHolidaysDescription"></p>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.noHolidaysDescription2"></p>
          <button type="button" class="btn btn-primary btn-block" ng-click="$ctrl.showEditDialog('new')" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.addFirstHolidayButtonText"></button>
        </td>
      </tr>
      <tr class="total" ng-if="!$ctrl.condensed">
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
          <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.total2"></strong>
          <br />
          <small>
            <div class="truncate" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.total2More"></div>
          </small>
        </td>
        <td class="right">
          <strong>{{ $ctrl.getTotalDays("all") | sxyCount : "day" }}</strong>
        </td>
      </tr>
      <tr ng-if="!$ctrl.condensed">
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: 'saldo', entityType: 'company' }"></salaxy-avatar>
          <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.unusedHolidays"></strong>
          <br />
          <small>
            <div class="truncate" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.unusedHolidaysMore"></div>
          </small>
        </td>
        <td class="right">
          <strong>{{ $ctrl.getTotalDays("holidaysSaldoEnd") | sxyCount : "day" }}</strong>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="text-end">
    <button type="button" class="btn btn-primary" ng-click="$ctrl.showEditDialog('new')" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.addHolidayButtonText"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/holidays/HolidayYearHolidaysEditDialog.html",`<div class="modal-header d-flex">
  <h1 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.panelHeading"></h1>
  <button type="button" class="btn-close btn-close ms-auto" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <form class="form-horizontal">
    <salaxy-datepicker-popup name="start" min-date="$ctrl.logic.minDate" max-date="$ctrl.logic.maxDate" ng-model="$ctrl.current.period.start" ng-change="$ctrl.logic.updatePeriodDays($ctrl.current)" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelStartDate"></salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="end" min-date="$ctrl.logic.minDate" max-date="$ctrl.logic.maxDate" ng-model="$ctrl.current.period.end" ng-change="$ctrl.logic.updatePeriodDays($ctrl.current)" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelEndDate"></salaxy-datepicker-popup>
    <salaxy-form-group name="daysCount" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelHolidaysCount" ng-if="!$ctrl.current.period.days || $ctrl.current.period.days.length == 0">
      <div class="input-group">
        <input class="form-control" type="text" autocomplete="off" id="daysCount" name="daysCount" ng-model="$ctrl.current.period.daysCount" disabled>
        <span class="input-group-btn">
          <button type="button" class="btn btn-default" ng-click="$ctrl.logic.setDaysSelection($ctrl.current)" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.editDatesButtonText"></button>
        </span>
      </div>
    </salaxy-form-group>
    <salaxy-datepicker ng-model="$ctrl.current.period" name="days" is-multiple="true" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelHolidaysCount" min-date="$ctrl.current.period.start" max-date="$ctrl.current.period.end" ng-if="$ctrl.current.period.days.length > 0"></salaxy-datepicker>
    <salaxy-input name="notes" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelDescription" ng-model="$ctrl.current.notes"></salaxy-input>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.delete"></button>
  <button type="reset" class="btn btn-default ms-auto" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
</div>`);

 $templateCache.put("salaxy-components/worker/holidays/HolidayYearPaid.html",`<div class="salaxy-component salaxy-holiday-year-paid">
  <div ng-if="!$ctrl.list">
    <salaxy-spinner></salaxy-spinner>
  </div>
  <div ng-if="$ctrl.list">
    <table class="table table-sm">
      <thead>
        <tr>
          <th colspan="2">
            &nbsp; <br />
            <span class="uppercase" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.paidHolidays"></span>
          </th>
          <th class="right">
            <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.holidaysCount"></span>
            <br />
            <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.holidaySalary"></span>
          </th>
          <th class="right">
            <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.compensation"></span>
            <br />
            <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.bonus"></span>
          </th>
        </tr>
      </thead>
      <tbody>

        <tr ng-repeat="row in $ctrl.list" class="clickable" ng-click="$ctrl.showEditDialog(row)" ng-style="row.isDisabled ? {opacity: 0.5, 'text-decoration': 'line-through'}: ''">
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ row.avatar.displayName }}</strong>
            <span ng-if="row.kind =='manualSalary' || row.kind =='manualCompensation' || row.kind =='manualBonus'" class="badge bg-primary" sxy-text="Manual"></span>
            <div>{{ row.avatar.description }}</div>
          </td>
         
          <td class="right">
            <div>{{ (row.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ (row.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ (row.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ (row.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
        
        <tr>
          <th colspan="4">
            &nbsp; <br />
            <span class="uppercase"> <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.holidaySalary"></span>, <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.compensation"></span></span>
          </th>
        </tr>
        <tr>
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="$ctrl.totals.startSaldo.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ $ctrl.totals.startSaldo.avatar.displayName }}</strong>
            <div>{{ $ctrl.totals.startSaldo.avatar.description }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.totals.startSaldo.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ ($ctrl.totals.startSaldo.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.totals.startSaldo.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ ($ctrl.totals.startSaldo.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
        <tr class="total">
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="$ctrl.totals.total.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ $ctrl.totals.total.avatar.displayName }}</strong>
            <div>{{ $ctrl.totals.total.avatar.description }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.totals.total.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ ($ctrl.totals.total.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.totals.total.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ ($ctrl.totals.total.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
        <tr>
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="$ctrl.totals.endSaldo.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ $ctrl.totals.endSaldo.avatar.displayName }}</strong>
            <div>{{ $ctrl.totals.endSaldo.avatar.description }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.totals.endSaldo.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ ($ctrl.totals.endSaldo.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.totals.endSaldo.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ ($ctrl.totals.endSaldo.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
        <tr>
          <th colspan="4">
            &nbsp; <br />
            <span class="uppercase"> <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.bonus"></span></span>
          </th>
        </tr>
        <tr ng-if="$ctrl.shoudPayBonus">
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="$ctrl.bonusTotals.startSaldo.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ $ctrl.bonusTotals.startSaldo.avatar.displayName }}</strong>
            <div>{{ $ctrl.bonusTotals.startSaldo.avatar.description }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.bonusTotals.startSaldo.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ ($ctrl.bonusTotals.startSaldo.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.bonusTotals.startSaldo.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ ($ctrl.bonusTotals.startSaldo.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
        <tr class="total">
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="$ctrl.bonusTotals.total.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ $ctrl.bonusTotals.total.avatar.displayName }}</strong>
            <div>{{ $ctrl.bonusTotals.total.avatar.description }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.bonusTotals.total.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ ($ctrl.bonusTotals.total.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.bonusTotals.total.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ ($ctrl.bonusTotals.total.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
        <tr ng-if="$ctrl.shoudPayBonus">
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="$ctrl.bonusTotals.endSaldo.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ $ctrl.bonusTotals.endSaldo.avatar.displayName }}</strong>
            <div>{{ $ctrl.bonusTotals.endSaldo.avatar.description }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.bonusTotals.endSaldo.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ ($ctrl.bonusTotals.endSaldo.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.bonusTotals.endSaldo.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ ($ctrl.bonusTotals.endSaldo.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
      </tbody>
    </table>
    <button type="button" class="btn btn-primary pull-right" ng-click="$ctrl.showEditDialog('new', true)" sxy-text="SALAXY.UI_Terms.add"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/holidays/HolidayYearPaidEditDialog.html",`<div class="card card-primary">
  <div class="card-header ">
    <h2 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.panelHeading"></h2>
    <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
  </div>
  <div class="card-body">
    <form class="form-horizontal">      
      <div ng-switch="$ctrl.current.kind">
        <div ng-switch-when="manualSalary">
          <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.title"></h3>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.description"></p>
        </div>
        <div ng-switch-when="manualCompensation">
          <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualCompensation.title"></h3>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualCompensation.description"></p>
        </div>
        <div ng-switch-when="manualBonus">
          <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualBonus.title"></h3>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualBonus.description"></p>
        </div>
        <div ng-switch-when="paidCalc">
          <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.paidCalc.title"></h3>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.paidCalc.description"></p>
        </div>
      </div>
      <div ng-if="$ctrl.current.kind == 'undefined'">
        <p class="lead" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.undefined.labelAnnualLeavePaymentKind"></p>
        <salaxy-input-enum ng-model="$ctrl.current.kind" name="typeRadio" enum="AnnualLeavePaymentKind" type="radio" filter="manualSalary,manualCompensation,manualBonus" label-type="plain"></salaxy-input-enum>
        <p>&nbsp;</p>
      </div>
      <div ng-if="$ctrl.current.kind != 'undefined'">
        <salaxy-input-enum  disabled="true" ng-if="$ctrl.current.kind == 'paidCalc'" ng-model="$ctrl.current.kind" enum="AnnualLeavePaymentKind" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.kind" filter="paidCalc" name="typeSelect" type="select"></salaxy-input-enum>
        <salaxy-input-enum  ng-if="$ctrl.current.kind != 'paidCalc'" ng-model="$ctrl.current.kind" enum="AnnualLeavePaymentKind" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.kind" filter="manualSalary,manualCompensation,manualBonus" name="typeSelect" type="select"></salaxy-input-enum>
 
        <salaxy-datepicker-popup disabled="$ctrl.current.kind =='paidCalc'" name="date" ng-model="$ctrl.current.date" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelPaidAt" ></salaxy-datepicker-popup>
        <salaxy-datepicker-popup disabled="$ctrl.current.kind =='paidCalc'" name="myDatepickerPopup" ng-model="$ctrl.current.period.start" ng-change="$ctrl.logic.updatePeriodDays($ctrl.current)" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelStartDate" >
        </salaxy-datepicker-popup>
        <salaxy-datepicker-popup disabled="$ctrl.current.kind =='paidCalc'" name="myDatepickerPopup" ng-model="$ctrl.current.period.end" ng-change="$ctrl.logic.updatePeriodDays($ctrl.current)" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelEndDate">
        </salaxy-datepicker-popup>
        <salaxy-input-number disabled="true" name="days" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelDaysCount" ng-model="$ctrl.current.period.daysCount" ></salaxy-input-number>
        <salaxy-input-number disabled="$ctrl.current.kind =='paidCalc'" name="holidayDays" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelUsedHolidays" ng-model="$ctrl.current.holidayDays" ng-change="$ctrl.logic.updateDaysCount($ctrl.current)"></salaxy-input-number>
        <salaxy-input-number disabled="$ctrl.current.kind =='paidCalc'" ng-if="$ctrl.current.kind =='paidCalc' || $ctrl.current.kind =='manualSalary'" name="holidaySalary" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelHolidaySalary" ng-model="$ctrl.current.holidaySalary" ></salaxy-input-number>
        <salaxy-input-number disabled="$ctrl.current.kind =='paidCalc'" ng-if="$ctrl.current.kind =='paidCalc' || $ctrl.current.kind =='manualCompensation'" name="holidayCompensation" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualCompensation.labelCompensation" ng-model="$ctrl.current.holidayCompensation"></salaxy-input-number>
        <salaxy-input-number disabled="$ctrl.current.kind =='paidCalc'" ng-if="$ctrl.current.kind =='paidCalc' || $ctrl.current.kind =='manualBonus'" name="holidayBonus" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelBonus" ng-model="$ctrl.current.holidayBonus"></salaxy-input-number>
        <salaxy-input-boolean ng-if="$ctrl.current.kind =='paidCalc'" type="switch" name="isDisabled" ng-model="$ctrl.current.isDisabled" label="Poista käytöstä" label-true="on"
          label-false="off"></salaxy-input-boolean>
        <salaxy-form-group name="calc" label="SALAXY.ENUM.AnnualLeavePaymentKind.paidCalc.label" ng-if="$ctrl.current.calcId">
            <a ng-href="{{$ctrl.logic.getPdfUrl($ctrl.current.calcId)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i class="bi bi-file-earmark-pdf"></i></a>
        </salaxy-form-group>
        <salaxy-input disabled="$ctrl.current.kind =='paidCalc'" name="notes" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelDescription" ng-model="$ctrl.current.notes"></salaxy-input>
      </div>
      <div>
        <button ng-disabled="$ctrl.current.kind == 'undefined'" type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
        <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
        <button ng-disabled="$ctrl.current.kind == 'paidCalc' || $ctrl.current.kind == 'undefined'" type="button" class="btn btn-danger" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.delete"></button>
      </div>
    </form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/holidays/WorkerHolidays-accrual.html",`<div class="row">
  <div class="col-sm-9">
    <fieldset ng-if="$ctrl.viewType == 'overview'">
      <legend><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.overview.legend"></span> {{ $ctrl.current.year }}</legend>
      <table class="salaxy-holidays-overview-table">
        <thead>
          <tr>
            <th class="year bg-{{year.style}}" ng-repeat="year in $ctrl.getYearVisualisation().years" colspan="{{ year.months }}">{{ year.text }}</th>
          </tr>
          <tr>
            <th ng-class="{ 'month': true, 'bg-primary': month%2, 'bg-danger': $index == $ctrl.getYearVisualisation().currentMonthIx }" ng-repeat="month in $ctrl.getYearVisualisation().months track by $index" class="text-end">{{ month }}</th>
          </tr>
        </thead>
        <tr ng-repeat="item in $ctrl.getYearVisualisation().items">
          <td class="month-empty" ng-repeat="x in [].constructor(item.start) track by $index"></td>
          <td colspan="{{ item.months }}">
            <button class="btn btn-{{ item.style }} btn-block btn-sm" ng-click="$ctrl.viewType = item.view">{{ item.text }}</button>
          </td>
          <td class="month-empty" ng-repeat="x in [].constructor(25 - item.start - item.months) track by $index"></td>
        </tr>
      </table>
      <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.overview.introTitle"></h3>
      <ol class="lead">
        <li sxy-html="SALAXY.NG1.WorkerHolidaysComponent.accrual.overview.introList.html"></li>
        <li sxy-html="SALAXY.NG1.WorkerHolidaysComponent.accrual.overview.introList2.html"></li>
        <li ng-if="$ctrl.getVisibility('hourly')" sxy-html="SALAXY.NG1.WorkerHolidaysComponent.accrual.overview.introList3.html"></li>
        <li sxy-html="SALAXY.NG1.WorkerHolidaysComponent.accrual.overview.introList4.html"></li>
      </ol>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'parameters'">
      <ng-include src="'salaxy-components/worker/holidays/HolidayParametersForm.html'"></ng-include>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'holidays'">
      <legend>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays-summer'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonSummer"></button>
        <span class="float-end">&nbsp;</span>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays-winter'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonWinter"></button>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.calendarTitle"></span> {{ $ctrl.current.year}}
      </legend>
      <salaxy-holiday-year-holidays on-commit="$ctrl.save()" parent="$ctrl.current"></salaxy-holiday-year-holidays>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'holidays-summer'">
      <legend>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonAll"></button>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.summerHolidaysTitle"></span> {{ $ctrl.current.year}}
      </legend>
      <salaxy-calendar data="[$ctrl.current]" mapper="$ctrl.mapToCalendar" on-list-select="$ctrl.calendarClick(type, date, calEvent)" start="$ctrl.current.year + '-05-01'" end="$ctrl.current.year + '-09-01'"></salaxy-calendar>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'holidays-winter'">
      <legend>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonAll"></button>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.winterHolidaysTitle"></span> {{ $ctrl.current.year}}
      </legend>
      <salaxy-calendar data="[$ctrl.current]" mapper="$ctrl.mapToCalendar" on-list-select="$ctrl.calendarClick(type, date, calEvent)" start="$ctrl.current.year + '-10-01'" end="(1 * $ctrl.current.year + 1) + '-04-01'"></salaxy-calendar>
    </fieldset>

    <fieldset ng-if="$ctrl.viewType == 'paidHolidays'">
      <legend>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.paidSalaries.legend"></span> {{ $ctrl.current.period | sxyDateRange }}
      </legend>
      <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.paidSalaries.description"></p>

      <ul sxy-html="SALAXY.NG1.WorkerHolidaysComponent.accrual.paidSalaries.descriptionList.html"></ul>
      <salaxy-holiday-year-paid parent="$ctrl.current" on-commit="$ctrl.save()"></salaxy-holiday-year-paid>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'accrual'">
      <legend>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.accrualHolidays.legend"></span> {{ $ctrl.current.accrual.period | sxyDateRange }}
      </legend>
      <p>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.accrualHolidays.description"></span> {{ $ctrl.current.year - 1 }}.
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.accrualHolidays.description2"></span> {{ $ctrl.current.year }}.
      </p>
      <salaxy-holiday-year-accrual parent="$ctrl.current"></salaxy-holiday-year-accrual>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'hourlySalaries'">
      <legend>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.hourlySalaries.legend"></span> {{ $ctrl.current.period | sxyDateRange }}
      </legend>
      <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.hourlySalaries.description"></p>
      <ul sxy-html="SALAXY.NG1.WorkerHolidaysComponent.accrual.hourlySalaries.descriptionList.html"></ul>
      <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.hourlySalaries.description2"></p>
    </fieldset>
  </div>
  <div class="col-sm-3">
    <div class="btn-group btn-block dropdown mb-4">
      <button id="year-selection" type="button" class="btn btn-primary btn-block dropdown-toggle" data-bs-toggle="dropdown">
        {{ $ctrl.current ? ('SALAXY.NG1.WorkerHolidaysComponent.UI.dropdown.selectedYear' | sxyTranslate) + " " + $ctrl.current.year : ('SALAXY.NG1.WorkerHolidaysComponent.UI.dropdown.selectYear' | sxyTranslate)  }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
        <li role="menuitem" ng-repeat="year in $ctrl.employmentHolidayYears">
          <a href="" ng-click="$ctrl.model = year" class="dropdown-item" >{{ year.year }}</a>
        </li>
        <li role="menuitem">
          <a ng-href="#{{ $ctrl.getDefaults().listUrl }}" class="dropdown-item" ng-if="!($ctrl.employmentHolidayYears.length > 0)" sxy-text="SALAXY.UI_Terms.back"></a>
        </li>
        <li class="divider"></li>
        <li role="menuitem" ng-if="$ctrl.missingHolidayYear">
          <a href="" ng-click="$ctrl.showInitHolidays()" class="dropdown-item">{{"SALAXY.UI_Terms.add" | sxyTranslate}} {{"SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.legendYear" | sxyTranslate}} {{$ctrl.missingHolidayYear}}</a>
        </li>
      </ul>
    </div>
    <salaxy-toggle-buttons ng-model="$ctrl.viewType" 
      options="[
        { value: 'overview', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonOverview' },
        { value: 'parameters', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonSettings' },
        { value: 'accrual', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonAccrual' },
        { value: 'holidays', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonHolidays' },
        { value: 'paidHolidays', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonPaidHolidays' }
        ]" 
      type="block">
    </salaxy-toggle-buttons>
    <p>&nbsp;</p>
    <fieldset ng-if="$ctrl.current">
      <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.info"></legend>
      <div>{{ "WageBasis." + $ctrl.current.spec.wageBasis | sxyEnum }}</div>
      <div>{{ "HolidayCode." + $ctrl.current.spec.code | sxyEnum }}</div>
      <div ng-if="$ctrl.getVisibility('accrual')">
        {{'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.periodAccrual' | sxyTranslate}}<br />{{ $ctrl.current.accrual.period | sxyDateRange }}</div>
      <div><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.periodSelectedYear"></span>
        <br />{{ $ctrl.current.period | sxyDateRange }}
      </div>
      <div ng-if="$ctrl.getVisibility('accrual')">
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.periodDefaultAccrual"></span> {{ $ctrl.current.accrual.defaultAccrual | sxyCount : 'day' }}
      </div>
      <div ng-if="$ctrl.getVisibility('compensation')">
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.compensation"></span> {{ $ctrl.current.spec.compensation | sxyCount : 'percent' }}
      </div>
      <div ng-if="$ctrl.current.spec.bonusMethod != 'none'">
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.bonus"></span> {{ $ctrl.current.spec.bonus | sxyCount : 'percent' }}
      </div>
      <div ng-if="$ctrl.current.spec.bonusMethod == 'none'">{{ "HolidayBonusPaymentMethod." + $ctrl.current.spec.bonusMethod | sxyEnum }} </div>
    </fieldset>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/holidays/WorkerHolidays-holidayCompensation.html",`<div class="row">
  <div class="col-sm-9">
    <fieldset ng-if="$ctrl.viewType == 'overview'">
      <legend>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.legend"></span> (
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.legendYear"></span> {{$ctrl.current.year}})
      </legend>
      <p class="lead" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.intro"></p>
      <ul class="lead">
        <li>
          <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.intro2"></strong>
          <ul>
            <li> <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.introCompensation"></span>{{ $ctrl.current.spec.compensation | sxyCount : 'percent' }}</li>
            <li ng-if="$ctrl.current.spec.bonusMethod != 'none'"><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.introBonus"></span> {{ $ctrl.current.spec.bonus | sxyCount : 'percent' }}</li>
            <li ng-if="$ctrl.current.spec.bonusMethod == 'none'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.introNoBonus"></li>
          </ul>
        </li>
      </ul>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'parameters'">
      <ng-include src="'salaxy-components/worker/holidays/HolidayParametersForm.html'"></ng-include>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'holidays'">
      <legend>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays-summer'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonSummer"></button>
        <span class="float-end">&nbsp;</span>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays-winter'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonWinter"></button>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.calendarTitle"></span> {{ $ctrl.current.year}}
      </legend>
      <salaxy-holiday-year-holidays on-commit="$ctrl.save()" parent="$ctrl.current"></salaxy-holiday-year-holidays>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'holidays-summer'">
      <legend>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonAll"></button>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.summerHolidaysTitle"></span> {{ $ctrl.current.year}}
      </legend>
      <salaxy-calendar data="[$ctrl.current]" mapper="$ctrl.mapToCalendar" on-list-select="$ctrl.calendarClick(type, date, calEvent)" start="$ctrl.current + '-05-01'" end="$ctrl.current + '-09-01'"></salaxy-calendar>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'holidays-winter'">
      <legend>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonAll"></button>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.winterHolidaysTitle"></span> {{ $ctrl.current.year}}
      </legend>
      <salaxy-calendar data="[$ctrl.current]" mapper="$ctrl.mapToCalendar" on-list-select="$ctrl.calendarClick(type, date, calEvent)" start="$ctrl.current + '-10-01'" end="(1 * $ctrl.current + 1) + '-04-01'"></salaxy-calendar>
    </fieldset>
  </div>
  <div class="col-sm-3">
    <div class="btn-group btn-block dropdown">
      <button id="year-selection" type="button" class="btn btn-primary btn-block dropdown-toggle" data-bs-toggle="dropdown">
        {{ $ctrl.current ? ('SALAXY.NG1.WorkerHolidaysComponent.UI.dropdown.selectedYear' | sxyTranslate) + " " +  $ctrl.current.year : ('SALAXY.NG1.WorkerHolidaysComponent.UI.dropdown.selectYear' | sxyTranslate) }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
        <li role="menuitem"  ng-repeat="year in $ctrl.employmentHolidayYears" >
          <a href="" ng-click="$ctrl.model = year" class="dropdown-item">{{ year.year }}</a></li>
        <li role="menuitem">
          <a ng-href="#{{ $ctrl.getDefaults().listUrl }}" ng-if="!($ctrl.employmentHolidayYears.length > 0)" class="dropdown-item" sxy-text="SALAXY.UI_Terms.back"></a></li>
        <li class="divider"></li>
        <li role="menuitem" ng-if="$ctrl.missingHolidayYear">
          <a href="" ng-click="$ctrl.showInitHolidays()" class="dropdown-item">{{"SALAXY.UI_Terms.add" | sxyTranslate}} {{"SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.legendYear" | sxyTranslate}} {{$ctrl.missingHolidayYear}}</a>
        </li>
      </ul>
    </div>
    <p>&nbsp;</p>
    <salaxy-toggle-buttons ng-model="$ctrl.viewType" options="[
      { value: 'overview', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonOverview' },
      { value: 'parameters', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonSettings' },
      ]" type="block"></salaxy-toggle-buttons>
    <p>&nbsp;</p>
    <fieldset ng-if="$ctrl.current">
      <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.info"></legend>
      <div>{{ "HolidayCode." + $ctrl.current.spec.code | sxyEnum }}</div>
      <div><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.periodSelectedYear"></span><br />{{ $ctrl.current.period | sxyDateRange }}</div>
      <div><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.compensation"></span> {{ $ctrl.current.spec.compensation | sxyCount : 'percent' }}</div>
      <div ng-if="$ctrl.current.spec.bonusMethod != 'none'">
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.bonus"></span> {{ $ctrl.current.spec.bonus | sxyCount : 'percent' }}
      </div>
      <div ng-if="$ctrl.current.spec.bonusMethod == 'none'">{{ "HolidayBonusPaymentMethod." + $ctrl.current.spec.bonusMethod | sxyEnum }} </div>
    </fieldset>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/holidays/WorkerHolidays-noHolidays.html",`<div class="row">
  <div class="col-sm-9">
    <fieldset ng-if="$ctrl.viewType == 'overview'">
      <legend><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.noHolidays.legend"></span>{{ $ctrl.current.year }}</legend>
      <p class="lead" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.noHolidays.intro"></p>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'parameters'">
      <ng-include src="'salaxy-components/worker/holidays/HolidayParametersForm.html'"></ng-include>
    </fieldset>
  </div>
  <div class="col-sm-3">
    <div class="btn-group btn-block dropdown">
      <button id="year-selection" type="button" class="btn btn-primary btn-block dropdown-toggle" data-bs-toggle="dropdown">
        {{ $ctrl.current ? ('SALAXY.NG1.WorkerHolidaysComponent.UI.dropdown.selectedYear' | sxyTranslate) + " " + $ctrl.current.year : ('SALAXY.NG1.WorkerHolidaysComponent.UI.dropdown.selectYear' | sxyTranslate) }}
      </button>
      <ul class="dropdown-menu"  role="menu" aria-labelledby="single-button">
        <li role="menuitem" ng-repeat="year in $ctrl.employmentHolidayYears">
          <a href="" ng-click="$ctrl.model = year" class="dropdown-item">{{ year.year }}</a>
        </li>
        <li role="menuitem">
          <a ng-href="#{{ $ctrl.getDefaults().listUrl }}" ng-if="!($ctrl.employmentHolidayYears.length > 0)" class="dropdown-item" sxy-text="SALAXY.UI_Terms.back"></a>
        </li>
        <li class="divider"></li>
        <li role="menuitem" ng-if="$ctrl.missingHolidayYear">
          <a href="" ng-click="$ctrl.showInitHolidays()" class="dropdown-item">{{"SALAXY.UI_Terms.add" | sxyTranslate}} {{"SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.legendYear" | sxyTranslate}} {{$ctrl.missingHolidayYear}}</a>
        </li>
      </ul>
    </div>
    <p>&nbsp;</p>
    <salaxy-toggle-buttons ng-model="$ctrl.viewType" options="[{ value: 'parameters', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonSettings' }]" type="block"></salaxy-toggle-buttons>
    <fieldset ng-if="$ctrl.current">
      <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.info"></legend>
      <div>{{ "HolidayCode." + $ctrl.current.spec.code | sxyEnum }}</div>
      <div><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.periodSelectedYear"></span><br />{{ $ctrl.current.period | sxyDateRange }}</div>
    </fieldset>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/holidays/WorkerHolidays-undefined.html",`<div class="salaxy-placeholder-empty placeholder-md">
  <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.undefined.title"></h3>
  <button class="btn btn-primary" ng-click="$ctrl.showInitHolidays()" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.undefined.showInitHolidaysButtonText"></button>
</div>`);

 $templateCache.put("salaxy-components/worker/holidays/WorkerHolidays.html",`<div class="salaxy-component salaxy-worker-holidays">
  <ng-include ng-if="!$ctrl.current" src="'salaxy-components/worker/holidays/WorkerHolidays-undefined.html'"></ng-include>
  <ng-include ng-if="$ctrl.current.spec.code == 'holidayCompensation'" src="'salaxy-components/worker/holidays/WorkerHolidays-holidayCompensation.html'"></ng-include>
  <ng-include ng-if="($ctrl.current && !$ctrl.current.spec.code) || $ctrl.current.spec.code == 'undefined' || $ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'temporaryTimeOff' || $ctrl.current.spec.code == 'other' || $ctrl.current.spec.code == 'script'" src="'salaxy-components/worker/holidays/WorkerHolidays-accrual.html'"></ng-include>
  <ng-include ng-if="$ctrl.current.spec.code == 'noHolidays'" src="'salaxy-components/worker/holidays/WorkerHolidays-noHolidays.html'"></ng-include>
</div>`);

 $templateCache.put("salaxy-components/worker/holidays/WorkerHolidaysInitDialog.html",`<div class="salaxy-component salaxy-holidays-init-dialog" ng-init="$ctrl.current.code = 'permanent14Days'">
  <form class="form-horizontal" name="holidayForm">
    <div class="modal-content card-primary">
      <div class="modal-header d-flex">
        <div>
          <h2 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.panelHeading"></h2>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.intro"></p>
        </div>
        <button type="button" class="btn-close ms-auto align-self-start" data-dismiss="alert" ng-click="$close('cancel')" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row form-horizontal">
          <div class="col-sm-6">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.legendSelectHolidayType"></legend>
              <div class="radio mb-1">
                <label class="d-flex align-items-start">
                  <input type="radio"  ng-model="$ctrl.current.code" name="code" id="permanent14Days" value="permanent14Days" class="mt-1 me-2"> 
                  <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.permanent14Days.html"></span>
                </label>
              </div>
              <div class="radio mb-1">
                <label class="d-flex align-items-start">
                  <input type="radio" ng-model="$ctrl.current.code" name="code" id="permanent35Hours" value="permanent35Hours" class="mt-1 me-2">
                  <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.permanent35Hours.html"></span>
                </label>
              </div>
              <div class="radio mb-1">
                <label class="d-flex align-items-start">
                  <input type="radio" ng-model="$ctrl.current.code" name="code" id="holidayCompensation" value="holidayCompensation" class="mt-1 me-2">
                  <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.holidayCompensation.html"></span>
                </label>
              </div>
              <div class="radio mb-1">
                <label class="d-flex align-items-start">
                  <input type="radio" ng-model="$ctrl.current.code" name="code" id="temporaryTimeOff" value="temporaryTimeOff" class="mt-1 me-2">
                  <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.temporaryTimeOff.html"></span>
                </label>
              </div>
              <div class="radio mb-1">
                <label class="d-flex align-items-start">
                  <input type="radio" ng-model="$ctrl.current.code" name="code" id="other" value="other" class="mt-1 me-2">
                  <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.other.html"></span>
                </label>
              </div>
              <div class="radio mb-1" ng-if="'bizConfigs' | sxyIsInRole">
                <label class="d-flex align-items-start">
                  <input type="radio" ng-model="$ctrl.current.code" name="code" id="script" value="script" class="mt-1 me-2">
                  <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.script.html"></span>
                </label>
              </div>
              <div class="radio mb-1">
                <label class="d-flex align-items-start">
                  <input type="radio" ng-model="$ctrl.current.code" name="code" id="noHolidays" value="noHolidays" class="mt-1 me-2">
                  <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.noHolidays.html"></span>
                </label>
              </div>
            </fieldset>
          </div>
          <div class="col-sm-6">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.legendDetails"></legend>
              <div ng-if="$ctrl.logic.getVisibility($ctrl.current, 'accrualFixed')">
                <salaxy-input-boolean type="checkbox" name="accrualByLaw" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.accrualByLaw" label-true="{{ 'SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.accrualByLawLabelTrue' + ($ctrl.current.code == 'temporaryTimeOff' ? '2' : '') }}"
                  ng-change="$ctrl.logic.accrualByLawChanged($ctrl.current)" ng-model="$ctrl.logic.accrualByLaw"></salaxy-input-boolean>
                <salaxy-input-number ng-model="$ctrl.current.accrualFixed" name="accrualFixed" ng-if="$ctrl.current.accrualFixed" ng-change="$ctrl.logic.accrualFixedChanged($ctrl.current)" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.accrualFixed" unit="days">
                </salaxy-input-number>
              </div>
              <salaxy-input-number ng-model="$ctrl.current.compensation" name="compensation" ng-if="$ctrl.logic.getVisibility($ctrl.current, 'compensation')" required label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.compensation" unit="percent"></salaxy-input-number>
              <salaxy-input-enum name="bonusMethod" ng-model="$ctrl.current.bonusMethod" ng-if="$ctrl.logic.getVisibility($ctrl.current, 'bonusMethod')" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethod" filter="none,payForHolidaySalary,paySelectedDays" enum="HolidayBonusPaymentMethod"></salaxy-input-enum>
              <salaxy-input-enum name="bonusMethod" ng-model="$ctrl.current.bonusMethod" ng-if="$ctrl.logic.getVisibility($ctrl.current, 'compensation')" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethod" options="{ 'none': ('SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethodNone' | sxyTranslate), 'payForHolidaySalary': ('SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethodPayForHolidaySalary' | sxyTranslate)  }">
              </salaxy-input-enum>
              <salaxy-input-number ng-model="$ctrl.current.bonus" name="bonus" ng-if="$ctrl.logic.getVisibility($ctrl.current, 'bonusPercent')" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusPercent" unit="percent"></salaxy-input-number>
              <div ng-if="$ctrl.logic.getVisibility($ctrl.current, 'accruesHolidays')">
                <salaxy-input-enum required name="wageBasis" ng-model="$ctrl.current.wageBasis" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.wageBasis" enum="WageBasis" hidden-options="undefined,other,script"></salaxy-input-enum>
                <salaxy-input-enum name="holidayPayCalculation" ng-model="$ctrl.current.holidayPayCalculation" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayCalculation.title" options="$ctrl.logic.getholidayPayCalculationOptions($ctrl.current)" required disable-cache="true"></salaxy-input-enum>

                <salaxy-input-number ng-model="$ctrl.current.compensation" name="compensation" ng-if="($ctrl.current.code == 'temporaryTimeOff' || $ctrl.current.code == 'other' || $ctrl.current.code == 'script')  && $ctrl.current.holidayPayCalculation == 'holidayCompensation'" unit="percent" required label="SALAXY.MODEL.HolidaySpecificationForYear.compensation.title" ></salaxy-input-number>
                <salaxy-input-number ng-model="$ctrl.current.holidayPayPercent" name="holidayPayPercent" ng-if="($ctrl.current.code == 'permanent35Hours' || $ctrl.current.code == 'other' || $ctrl.current.code == 'script') && $ctrl.current.holidayPayCalculation == 'percentageBasedPay'" required unit="percent" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayPercent.title" ></salaxy-input-number>
              
                <salaxy-form-group label="SALAXY.MODEL.HolidaySpecificationForYear.employmentPeriod.title" name="contract">
                  <salaxy-datepicker-popup require="true" name="startDate" label="SALAXY.NG1.WorkerWizardComponent.employment.group.startDate" ng-model="$ctrl.current.employmentPeriod.start"></salaxy-datepicker-popup>
                  <salaxy-datepicker-popup name="endDate" label="SALAXY.NG1.WorkerWizardComponent.employment.group.endDate" ng-model="$ctrl.current.employmentPeriod.end"></salaxy-datepicker-popup>
                </salaxy-form-group>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary float-end" ng-disabled="holidayForm.$invalid" ng-click="$close('ok')" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.submitButtonText"></button>
        <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      </div>
    </div>
  </form>
</div>`);

 $templateCache.put("salaxy-components/worker/HourlyReportEditDialog.html",`<div class="salaxy-component salaxy-timer-dialog">
  <div>
    <div class="modal-header">
      <h2 sxy-text="Muokkaa tuntikirjausta"></h2>
      <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form class="form-horizontal">
        <div class="row">
          <div class="col-sm-6 col-12">
            <salaxy-input-typeahead ng-if="$ctrl.logic.costAccountingSettings" label-format="text-value" name="options_project" ng-model="$ctrl.current.contentData.project" options="$ctrl.logic.costAccountingSettings.options" label="{{($ctrl.logic.costAccountingSettings.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" required="true"></salaxy-input-typeahead>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input name="message" ng-model="$ctrl.current.contentData.projectText" label="Kommentti"></salaxy-input>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input-time name="startTime" label="Työaika" type="minutes" ng-model="$ctrl.current.contentData.totalTime"></salaxy-input-time>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input-number label="Työaika" type="slider" name="slider" minimum="10" maximum="720" slider-step="5" ng-model="$ctrl.current.contentData.totalTime"></salaxy-input-number>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>

      <button type="button" class="btn btn-danger float-start" ng-click="$close('delete')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.deleteButtonText"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/taxcard/EmploymentTaxcards.html",`﻿<div class="salaxy-component salaxy-employment-taxcards">
  <div ng-if="!$ctrl.current">
    <div class="alert alert-warning" ng-if="!$ctrl.employmentId">
      <p sxy-text="SALAXY.NG1.WorkerTaxCardsComponent.instruction"></p>
    </div>
    <salaxy-spinner ng-if="$ctrl.employmentId"></salaxy-spinner>
  </div>
  <div ng-if="$ctrl.current">
    <div class="alert alert-warning" ng-if="!$ctrl.current.personalId">
      <p sxy-text="SALAXY.NG1.WorkerTaxCardsComponent.error"></p>
    </div>
    <div ng-if="$ctrl.mode != 'list'">
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'taxcarddetails', text: 'SALAXY.NG1.WorkerDetailsComponent.currentTaxCard' },
          { value: 'taxcardcalcs', text: 'SALAXY.NG1_PagesPersonal.taxcards.calcsPaidForCardTabHeading', hidden: !$ctrl.current.active },
        ]"
        tabs-id="employmentTaxcards">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-employmentTaxcards">
        <div class="tab-pane" id="taxcarddetails-tab">
          <salaxy-taxcard-details model="$ctrl.current.active" ng-ref="$ctrl.$active" personal-id="$ctrl.current.personalId" on-save="$ctrl.reload();$ctrl.onSave()" hide-buttons="$ctrl.hideButtons" employment-relation-taxcard-type="$ctrl.current.employmentTaxcard"></salaxy-taxcard-details>
        </div>
        <div class="tab-pane" id="taxcardcalcs-tab" ng-if="$ctrl.current.active">
          <div class="alert alert-info" ng-if="$ctrl.$incomeLog.hasDiff">
            <button type="button" class="btn btn-primary float-end" ng-click="$ctrl.$active.commitDiff()" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addSalaries"></button>
            <span sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addSalariesToTaxCard" params="{validity: ($ctrl.current.active.card.validity | sxyDateRange)}">
            </span>
          </div>
          <salaxy-taxcard-income-log parent="$ctrl.current.active" editable="false" ng-ref="$ctrl.$incomeLog"></salaxy-taxcard-income-log>
          <div class="text-end">
            <button type="button" class="btn btn-default btn-xs" ng-click="$ctrl.editIncomeLog()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.edit"></button>
          </div>
        </div>
      </div>
    </div>
    <div class="row form-horizontal" sxy-if-role="test">
      <div class="col-8">
        <salaxy-datepicker-popup name="today" ng-model="$ctrl.today" label="Maksupäivän testaus" ng-change=""></salaxy-datepicker-popup>
      </div>
      <div class="col-4">
        <button type="button" class="btn btn-primary" ng-click="$ctrl.reload()">Vaihda (TEST)</button>
      </div>
    </div>
    <div ng-if="$ctrl.mode != 'active' && $ctrl.list.length > 0">
      <h3 ng-if="$ctrl.mode != 'list'" sxy-text="SALAXY.NG1.WorkerDetailsComponent.historyTaxCard"></h3>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="th-xxs">
                <span sxy-text="SALAXY.NG1.WorkerTaxCardsComponent.type"></span>
                <span class="d-inline d-md-none" sxy-text="SALAXY.NG1.WorkerDetailsComponent.taxPercent"></span>
                <span class="d-inline d-md-none" sxy-text="SALAXY.NG1.WorkerTaxCardsComponent.percentAfterIncomeLimit"></span>
              </th>
              <th class="d-none d-md-table-cell" sxy-text="SALAXY.NG1.WorkerDetailsComponent.year"></th>
              <th class="d-none d-md-table-cell tax-percentage right" sxy-text="SALAXY.NG1.WorkerDetailsComponent.taxPercent"></th>
              <th class="th-xxs salaries-paid right">
                <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.salariesPaid"></span>
                <span class="d-inline d-md-none" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.incomeLimit"></span>
              </th>
              <th class="d-none d-md-table-cell income-limit right">
                <span sxy-text="SALAXY.NG1.WorkerTaxCardsComponent.incomeLimit"></span><br /><span sxy-text="SALAXY.NG1.WorkerTaxCardsComponent.incomeLimitSpan"></span>

              </th>
              <th class="th-xxs right" sxy-html="SALAXY.NG1.WorkerDetailsComponent.validHtml"></th>
              <th></th>
              <th sxy-if-role="test,admin"></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="taxCard in $ctrl.list">
              <td>
                <span class="d-inline d-md-none">
                  <i>{{ "TaxcardKind." + taxCard.data.kind | sxyEnum }} {{ taxCard.data.forYear }}</i>
                  {{taxCard.data.taxPercent}} %
                  <span ng-if="taxCard.data.taxPercent2 != null">({{ taxCard.data.taxPercent2 }} %)</span>
                </span>
                <span class="d-none d-md-table-cell">
                  <b>{{ "TaxcardKind." + taxCard.data.kind | sxyEnum }}</b>
                </span>
              </td>
              <td class="d-none d-md-table-cell">{{ taxCard.data.forYear }}</td>
              <td class="d-none d-md-table-cell tax-percentage right">{{taxCard.data.taxPercent}} %</td>
              <td class="salaries-paid right">
                {{ taxCard.data.totalIncome | currency: ' €' : 0 }}
                <span class="d-inline d-md-none">{{(taxCard.data.incomeLimit | currency: ' €' : 0) || '-'}}</span>
              </td>
              <td class="d-none d-md-table-cell income-limit right">
                {{(taxCard.data.incomeLimit | currency: '€' : 0) || '-'}}<br />
                <span>{{taxCard.data.taxPercent2 != null ? (taxCard.data.taxPercent2 + ' %') : '-'}}</span>
              </td>
              <td class="right">
                {{ taxCard.data | sxyDateRange }}<br /> {{ taxCard.createdAt | sxyDate }}
              </td>
              <td class="middle text-center">
                <span ng-if="!taxCard.isReadOnly && !$ctrl.hideButtons">
                  <button class="btn btn-danger btn-sm" ng-click="$ctrl.deleteTaxCard(taxCard.id)">
                    <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.delete"></span>
                    <span class="d-inline d-sm-none">&times;</span>
                  </button>
                </span>
              </td>
              <td class="middle text-center" sxy-if-role="test,admin,pro">
                <a type="button" class="edit btn btn-sm btn-default" href="#/taxcards/details/{{taxCard.id}}"><i class="bi bi-pencil-square"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/taxcard/TaxcardDetails.html",`<div class="salaxy-component salaxy-taxcard-details">

  <form name="editForm">
    <div ng-show="false" ng-init="$ctrl.editForm = editForm"></div>
    <!-- TODO: See if this is in use in pro. It is probably in use in Admin. -->
    <div ng-if="$ctrl.getMode() == 'pro'" ng-include="'salaxy-components/worker/taxcard/TaxcardDetails_Pro.html'"></div>
    <div ng-if="$ctrl.getMode() == 'new'" class="alert alert-danger">
      <h3>Error: Disabled</h3>
      <p>Adding a new taxcard in details view is diabled.</p>
    </div>
    <div ng-if="$ctrl.getMode() == 'default'" ng-include="'salaxy-components/worker/taxcard/TaxcardDetails_Info.html'"></div>
    <div ng-if="$ctrl.getMode() == 'null'" class="salaxy-placeholder-empty placeholder-md text-center">
      <div ng-if="$ctrl.employmentRelationTaxcardType != 'auto'">
        <h4 sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noTaxCardAddedWorker" ng-if="$ctrl.employmentId == 'self'"></h4>
        <h4 sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noTaxCardAdded" ng-if="$ctrl.employmentId != 'self'"></h4>
        <button class="btn btn-primary" ng-if="!$ctrl.hideButtons" ng-disabled="$ctrl.loaders['showAddNew']" ng-click="$ctrl.showAddNew()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.addTaxCard"></button>
      </div>
      <div ng-if="$ctrl.employmentRelationTaxcardType == 'auto'">
        <button class="btn btn-primary" ng-if="!$ctrl.hideButtons" ng-disabled="$ctrl.loaders['showSetAuto']" ng-click="$ctrl.setAuto()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.searchTaxCard"></button>  
      </div>
    </div>
    <div ng-if="$ctrl.getMode() == 'no-personal-id'" class="alert alert-danger" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noPersonalIdError"></div>
  </form>
</div>`);

 $templateCache.put("salaxy-components/worker/taxcard/TaxcardDetails_Info.html",`<div>
  <div ng-if="$ctrl.isTaxCardExpired($ctrl.current)" class="salaxy-placeholder-empty placeholder-md placeholder-danger text-center">
    <h4 sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCardExpired"></h4>
    <button class="btn btn-primary" ng-if="!$ctrl.hideButtons" ng-disabled="$ctrl.loaders['showAddNew']" ng-click="$ctrl.showAddNew()"
      sxy-text="SALAXY.NG1.CurrentTaxCardComponent.newTaxCard"></button>
  </div>
  <div class="row">

    <div class="col-md-7 col-lg-7" ng-switch="$ctrl.chartType">
      <div ng-switch-when="full" class="salaxy-tax-card-chart chart-container">    
          <salaxy-chart custom-height="400px" config="$ctrl.getMainChartConfig($ctrl.current)"></salaxy-chart>
      </div>

      <div ng-switch-when="pie" class="salaxy-tax-card-chart chart-container text-center">      
          <salaxy-chart style="height: 400px; position: relative;" config="$ctrl.getPieChartConfig($ctrl.current)"></salaxy-chart>
      </div>
    </div>
    <div class="col-md-5 col-lg-5">
      <div class="row current-taxcard-row table-row">
        <div class="col-12">
          <div class="btn-group float-end">
            <a ng-if="$ctrl.getTaxcardPreviewUrl($ctrl.current)" ng-href="{{$ctrl.getTaxcardPreviewUrl($ctrl.current)}}" target="_blank" class="btn btn-xs btn-default"
              sxy-text="SALAXY.UI_Terms.open"></a>
            <a ng-if="$ctrl.getTaxcardDownloadUrl($ctrl.current)" ng-href="{{$ctrl.getTaxcardDownloadUrl($ctrl.current)}}" target="_blank" class="btn btn-xs btn-default"
              sxy-text="SALAXY.UI_Terms.download"></a>
          </div>
          <strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCardKind"></strong><br /> {{ 'TaxcardKind.' + $ctrl.current.card.kind | sxyEnum }}
          ({{$ctrl.current.card.forYear}})
        </div>
      </div>
      <div class="row current-taxcard-row table-row">
        <div class="col-8">
          <strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.validDate"></strong><br /> {{$ctrl.current.card.validity.start | date}} - {{$ctrl.current.card.validity.end | date}}
        </div>
        <div class="col-4 text-end">
          <strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCardAdded"></strong><br />
          <span title="{{ $ctrl.current.createdAt | date : 'short' }}">{{ $ctrl.current.createdAt | sxyDate }}</span>
        </div>
      </div>
      <table class="table table-sm" style="margin-bottom: 0; margin-top: 6px">
        <thead>
          <tr>
            <th colspan="2" style="padding-left: 0;"><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.mainTaxPercent2"></span></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td sxy-text="SALAXY.NG1.CurrentTaxCardComponent.basicPercent"></td>
            <td class="right">{{ $ctrl.current.card.taxPercent }} %</td>
          </tr>
          <tr ng-if="!$ctrl.current.card.incomeLimit">
            <td colspan="2"><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noIncomeLimit"></span></td>
          </tr>
          <tr ng-if="$ctrl.current.card.incomeLimit">
            <td><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxPercent2.name"></span> <small>(tulorajan {{ $ctrl.current.card.incomeLimit | currency : '€' : 0 }}
                {{'SALAXY.NG1.CurrentTaxCardComponent.after' | sxyTranslate}})</small></td>
            <td class="right">{{ $ctrl.current.card.taxPercent2 || "-" }} %</td>
          </tr>
          <tr>
            <td>
              <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxPercentMin.title"></span>
              <button
                ng-if="$ctrl.current.card.kind == 'auto' && ( $ctrl.current.card.state == 'shared' || $ctrl.current.card.state == 'employerAdded' || $ctrl.current.card.state == 'verifiedVero' || $ctrl.current.card.state == 'sharedApproved')"
                type="button" class="btn btn-default btn-xs" ng-click="$ctrl.editTaxPercentMin()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.edit"></button>
            </td>
            <td class="right">
              <span>{{ $ctrl.current.card.taxPercentMin || "-" }} %</span>
            </td>
          </tr>
          <tr ng-if="$ctrl.current.card.kind == 'auto'">
            <td colspan="2">
              <span class="text-info" ng-if="$ctrl.current.card.lastChecked != '2000-01-01T00:00:00Z'"><small>{{'SALAXY.NG1.CurrentTaxCardComponent.taxCardChecked' | sxyTranslate}}
                  {{$ctrl.current.card.lastChecked | date: "dd.MM.yyyy HH:mm"}}</small></span>
              <br />
              <button type="button" ng-disabled="$ctrl.loaders['showRefreshAutoTaxcardDialog']" ng-click="$ctrl.showRefreshAutoTaxcardDialog()"
                class="btn btn-info">{{'SALAXY.NG1.CurrentTaxCardComponent.checkAutomaticTaxCard' | sxyTranslate}}</button>
            </td>
          </tr>
          <tr ng-if="$ctrl.current.card.kind != 'auto'">
            <td colspan="2">
              <button class="btn btn-primary" ng-if="!$ctrl.isTaxCardExpired($ctrl.current) && !$ctrl.hideButtons" ng-disabled="$ctrl.loaders['showAddNew']"
                ng-click="$ctrl.showAddNew()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.newTaxCard"></button>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-sm" style="margin-top: 6px" ng-if="$ctrl.current.card.incomeLimit">
        <thead>
          <tr>
            <th colspan="2" style="padding-left: 0;"><strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.incomeLimit"></strong></th>
            <th class="right">{{ $ctrl.current.card.incomeLimit | currency : '€' : 0 }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width: 20px;" class="text-center">-</td>
            <td>
              <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.salariesPaid"></span>
              <button type="button" class="btn btn-default btn-xs" ng-click="$ctrl.editIncomeLog()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.edit"></button>
            </td>
            <td class="right">{{ $ctrl.current.result.totalIncome | currency }}</td>
          </tr>
          <tr ng-if="$ctrl.current.result.totalIncomeJanuary">
            <td></td>
            <td>...<span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.inJanuary"></span></td>
            <td class="right">{{ $ctrl.current.result.totalIncomeJanuary | currency }}</td>
          </tr>
          <tr>
            <td></td>
            <td><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.inPalkkaus"></span></td>
            <td class="right">{{ $ctrl.current.result.payment | currency }}</td>
          </tr>
          <tr ng-if="$ctrl.current.result.paymentJanuary">
            <td></td>
            <td>...<span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.inJanuary"></span></td>
            <td class="right">{{ $ctrl.current.result.paymentJanuary | currency }}</td>
          </tr>
          <tr class="total">
            <td colspan="2"><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.beforeIncomeLimit"></span></td>
            <td class="right">{{ $ctrl.current.card.incomeLimit - $ctrl.current.result.totalIncome | currency }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/taxcard/TaxcardDetails_Pro.html",`<div class="salaxy-calc-worker-info row" ng-if="$ctrl.status !== 'initialLoading'">
  <div class="col-3 col-sm-2 col-xxs-3 ">
    <salaxy-avatar avatar="$ctrl.current.worker"></salaxy-avatar>
  </div>
  <div class="col-9 col-sm-10 col-xxs-9 worker-info-col">
    <button class="btn btn-primary float-end" ng-click="$ctrl.save()" ng-disabled="!$ctrl.hasChanges" sxy-text="SALAXY.UI_Terms.save"></button>
    <button class="btn btn-default float-end" ng-disabled="$ctrl.loaders['showAddNew']" ng-click="$ctrl.showAddNew()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.newTaxCard"></button>
    <h2>{{ $ctrl.current.worker.displayName || ('SALAXY.NG1.WorkerInfo.noSelection'| sxyTranslate) }}</h2>
    <div class="row">
      <div class="col-12 col-sm-6 ">
        <span ng-if="!$ctrl.current.card.personalId" sxy-text="SALAXY.NG1.PaymentDialogComponent.noSSNumber" class="text-danger"></span>
        <span ng-if="$ctrl.current.card.personalId">{{ $ctrl.current.card.personalId }}</span>
      </div>
    </div>
  </div>
</div>
<hr />
<div ng-if="$ctrl.current">
  <div class="row">
    <div class="col-sm-6">
      <div class="form-horizontal">
        <salaxy-input-enum disabled="true" label="SALAXY.NG1.WorkerDetailsComponent.taxCard.cardType" ng-required="true" name="kind" enum="TaxcardKind" ng-model="$ctrl.current.card.kind">
        </salaxy-input-enum>
        <salaxy-input-number disabled="$ctrl.current.card.kind == 'auto'" label="SALAXY.NG1.CurrentTaxCardComponent.taxCards.year" name="year" ng-model="$ctrl.current.card.forYear" require="true"></salaxy-input-number>
        <salaxy-datepicker-popup disabled="$ctrl.current.card.kind == 'auto'" name="validityStart" ng-model="$ctrl.current.card.validity.start" require="true" label="SALAXY.NG1.CurrentTaxCardComponent.validFromDate2">
        </salaxy-datepicker-popup>
        <salaxy-datepicker-popup disabled="$ctrl.current.card.kind == 'auto'" name="validityEnd" ng-model="$ctrl.current.card.validity.end" require="true" label="SALAXY.NG1.CurrentTaxCardComponent.validTillDate"></salaxy-datepicker-popup>
        <salaxy-input-number disabled="$ctrl.current.card.kind == 'auto'" label="SALAXY.NG1.CurrentTaxCardComponent.mainTaxPercent" name="taxPercent" ng-model="$ctrl.current.card.taxPercent" require="true" sxy-tax-percent></salaxy-input-number>
        <salaxy-input-number disabled="$ctrl.current.card.kind == 'auto'" name="incomeLimit" label="SALAXY.NG1.CurrentTaxCardComponent.incomeLimit2" ng-model="$ctrl.current.card.incomeLimit" sxy-currency></salaxy-input-number>
        <salaxy-input-number disabled="$ctrl.current.card.kind == 'auto'" name="taxPercent2" label="SALAXY.NG1.CurrentTaxCardComponent.taxPercent2.name" ng-model="$ctrl.current.card.taxPercent2" sxy-tax-percent></salaxy-input-number>
        <div class="row" ng-if="$ctrl.current.card.kind != 'auto'">
          <div class="col-12">
            <div class="float-end">
              <a ng-href="{{ $ctrl.getTaxcardDownloadUrl($ctrl.current) }}" ng-if="$ctrl.getTaxcardDownloadUrl($ctrl.current)" target="_blank" sxy-text="SALAXY.UI_Terms.download"></a>
            </div>
            <legend style="text-align:left" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCardAsFile"></legend>
            <div ng-include="'salaxy-components/worker/taxcard/TaxcardDetails_Upload.html'"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="alert alert-info" ng-if="$ctrl.$incomeLog.hasDiff">
        <button type="button" class="btn btn-primary float-end" ng-click="$ctrl.commitDiff()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.commitDiffBtn"></button>
        <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.commitDiffNote"></span>
      </div>
      <salaxy-taxcard-income-log parent="$ctrl.current" editable="false" ng-ref="$ctrl.$incomeLog"></salaxy-taxcard-income-log>
      <div class="text-end">
        <button type="button" class="btn btn-default btn-xs" ng-click="$ctrl.editIncomeLog()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.edit"></button>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/taxcard/TaxcardDetails_Upload.html",`<div name="taxCardFile" ng-model="taxCardFile" ngf-drop="$ctrl.uploadTaxCard($file)" 
  ngf-select="$ctrl.uploadTaxCard($file)" class="salaxy-drop-box" ngf-drag-over-class="'salaxy-drag-over'" 
  ngf-multiple="false" ngf-min-size="5KB" ngf-max-size="10MB"
  ngf-pattern="'image/*,application/pdf'" ngf-model-invalid="invalidFile" ng-class="invalidFile.$error != null ? 'error' : ''"
  ng-required="$ctrl.addNewUi.upload == 'required'">
  <span ng-if="$ctrl.uploadProgress && $ctrl.uploadProgress != 100">
    <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.loading"></span> {{ $ctrl.uploadProgress }}% {{'SALAXY.NG1.CurrentTaxCardComponent.taxCards.taxCardDetails.downloaded' | sxyTranslate}}
  </span>
  <span ng-if="$ctrl.uploadProgress == 100" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.progressPreview"></span>
  <span class="text-danger" ng-if="$ctrl.getInvalidFileDescription(invalidFile)">{{$ctrl.getInvalidFileDescription(invalidFile)}}</span>
  <span ng-if="!$ctrl.uploadProgress && !$ctrl.current.card.fileUri" sxy-html="SALAXY.NG1.CurrentTaxCardComponent.uploadTaxCard.html"></span>
  <span ng-if="!$ctrl.uploadProgress && $ctrl.current.card.fileUri">
    <img class="img-responsive" ng-src="{{$ctrl.getUploadPreviewUrl($ctrl.current)}}" />
  </span>
</div>`);

 $templateCache.put("salaxy-components/worker/taxcard/TaxcardIncomeLog.html",`<div class="salaxy-component salaxy-taxcard-income-log">
  <table class="table table-sm">
    <thead>
      <tr>
        <th>
          <strong sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.addedForTaxCard"></strong><br />
          <span sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.salaryPeriod"></span>
        </th>
        <th class="right">
          <strong sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.mainTaxPercent"></strong><br />
          <span sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.salaryAmount"></span>
        </th>
        <th ng-if="$ctrl.editable" style="width: 20px;"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.list" class="" ng-style="row.diff == 'removed' ? 'text-decoration: line-through' : ''" ng-class="{ 'success': row.diff == 'new', 'text-primary': row.diff == 'changed', 'text-danger': row.diff == 'removed' }">
        <td>
          <strong>
            <span ng-if="row.id && row.diff != 'removed'" sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.calculation"></span>
            <span ng-if="row.id && row.diff == 'removed'" sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.removedCalc"></span>
            <span ng-if="!row.id">{{ "TaxCardIncomeType." + row.type | sxyEnum }}</span ng-if="row.id">
            {{ row.paidAt | sxyDate }}
            <button ng-if="row.diff == 'new'"
              type="button" 
              class="btn btn-xs btn-success" 
              data-bs-toggle="popover" 
              data-bs-html="true" 
              data-bs-title="Info" 
              data-bs-content="'SALAXY.NG1.TaxCardIncomeLogComponent.newCalcPopover'| sxyTranslate" 
              data-bs-trigger="hover"
              sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.newCalcBtn" 
              sxy-bs5-popover></button>

            <button ng-if="row.diff == 'changed' && row.type != 'diff'" 
              type="button" 
              class="btn btn-xs btn-primary"
              data-bs-toggle="popover" 
              data-bs-html="true" 
              data-bs-title="Info"
              data-bs-content="'SALAXY.NG1.TaxCardIncomeLogComponent.taxCardChangedPopover'| sxyTranslate" 
              data-bs-trigger="hover" 
              sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.taxCardChangedBtn" 
              sxy-bs5-popover></button>

            <button ng-if="row.diff == 'changed' && row.type == 'diff'" 
              type="button" 
              class="btn btn-xs btn-primary"
              data-bs-toggle="popover" 
              data-bs-html="true" 
              data-bs-title="'Info'"  
              data-bs-content="'SALAXY.NG1.TaxCardIncomeLogComponent.calcChangedPopover'| sxyTranslate"
              data-bs-trigger="hover" 
              sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.calcChangedBtn"
              sxy-bs5-popover></button>

            <button ng-if="row.diff == 'removed'" 
              type="button" 
              class="btn btn-xs btn-danger" 
              data-bs-toggle="popover" 
              data-bs-html="true" 
              data-bs-title="'Info'" 
              data-bs-content="'SALAXY.NG1.TaxCardIncomeLogComponent.calcRemovedPopover'| sxyTranslate" 
              data-bs-trigger="hover" 
              sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.calcRemovedBtn"
              sxy-bs5-popover></button>
          </strong><br />
          <div class="float-start" style="padding: 0px;">
            {{ { start: row.startDate, end: row.endDate } | sxyDateRange }}
          </div>
          <div class="truncate" style="max-width: 250px; padding: 0px;">
            &nbsp;{{ row.description }}
          </div>
        </td>
        <td class="right">
          <strong>{{ row.tax ? (row.tax | currency) : "-" }}</strong><br /> {{ row.income | currency }}
        </td>
        <td ng-if="$ctrl.editable" style="width: 20px;">
          <button type="button" class="btn btn-default" ng-if="!$ctrl.isReadOnly(row)" ng-click="$ctrl.showEditDialog(row)"><i class="bi bi-pencil-square"></i></button>
        </td>
      </tr>
      <tr ng-if="!($ctrl.list.length > 0)">
        <td colspan="2">
          <h3 sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.noCalcsTitle"></h3>
          <p sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.noCalcsDescription"></p>
        </td>
      </tr>
      <tr class="total">
        <td>
          <strong>
         <span sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.totalTaxes"></span> <br />
            <span sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.totalIncome"></span>
          </strong>
        </td>
        <td class="right">
          <strong>
            {{ $ctrl.getSum("tax") | currency }}<br />
            {{ $ctrl.getSum("income") | currency }}
          </strong>
        </td>
        <td ng-if="$ctrl.editable" style="width: 20px;"></td>
      </tr>
    </tbody>
  </table>
  <div class="text-end" ng-if="$ctrl.editable">
    <button type="button" class="btn btn-default" ng-click="$ctrl.showEditDialog('new')" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addElseWherePaidSalary"></button>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/taxcard/TaxcardIncomeLogEditDialog.html",`<div class="card card-primary">
  <div class="card-header ">
    <h2 sxy-text="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.title"></h2>
    <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
  </div>
  <div class="card-body">
    <form class="form-horizontal">
      <fieldset>
        <legend>Tulorajaan vaikuttavat tiedot</legend>
        <salaxy-input-enum name="causeCode" ng-model="$ctrl.current.type" read-only="true" enum="TaxCardIncomeType" filter="externalSalaries" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.incomeType" type="select"></salaxy-input-enum>
        <salaxy-datepicker-popup name="paidAt" ng-model="$ctrl.current.paidAt" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.paymentDate"></salaxy-datepicker-popup>
        <salaxy-input-number name="income" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.taxableIncome" ng-model="$ctrl.current.income"></salaxy-input-number>
      </fieldset>
      <fieldset>
        <legend>Lisätiedot</legend>
        <salaxy-datepicker-popup name="startDate" ng-model="$ctrl.current.startDate" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.periodStart"></salaxy-datepicker-popup>
        <salaxy-datepicker-popup name="endDate" ng-model="$ctrl.current.endDate" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.periodEnd"></salaxy-datepicker-popup>
        <salaxy-input-number name="tax" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.tax" ng-model="$ctrl.current.tax"></salaxy-input-number>
        <salaxy-input name="description" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.notes" ng-model="$ctrl.current.description"></salaxy-input>
        <salaxy-input name="id" read-only="true" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.calcId" ng-model="$ctrl.current.id"></salaxy-input>
      </fieldset>
      <div>
        <button type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
        <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
        <button type="button" class="btn btn-danger" ng-click="$close('delete')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.deleteButtonText"></button>
      </div>
    </form>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/taxcard/TaxcardList.html",`<div class="salaxy-component salaxy-taxcard-list">
  <salaxy-odata-table select-mode="$ctrl.mode" url="/v03/api/taxcards"
    options="$ctrl.options"
    ng-if="$ctrl.mode == 'select' || $ctrl.mode == 'multiselect'"
    template-url="salaxy-components/odata/lists/Taxcards-select.html"
    items="$ctrl.items" selected-items="$ctrl.selectedItems"
    on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });"
    crud-controller="TaxcardCrudController as $crud"></salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/worker/taxcard/TaxcardManualEdit.html",`<div class="salaxy-component salaxy-manual-edit">
  <form name="editForm">
    <div ng-show="false" ng-init="$ctrl.editForm = editForm"></div>
    <div class="form-horizontal">
      <legend>
        <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.newTaxCardTitle"></span>
        <button class="btn btn-primary btn-xs float-end" sxy-if-role="test" ng-click="$ctrl.showToday=!$ctrl.showToday">test</button>
      </legend>
      <salaxy-datepicker-popup ng-if="$ctrl.showToday" name="todayTest" ng-model="$ctrl.today" ng-change="$ctrl.current.card.forYear = null;$ctrl.resetAsNew()" label-cols="col-sm-7"
        label="SALAXY.NG1.CurrentTaxCardComponent.taxCards.taxCardDetails.changeThisDate"></salaxy-datepicker-popup>
      <salaxy-input-enum label="SALAXY.NG1.CurrentTaxCardComponent.taxCardKind" label-cols="col-sm-7" require="true" name="verokortinTyyppi" enum="TaxcardKind"
        type="{{ (!$ctrl.current.card.kind || $ctrl.current.card.kind == 'undefined' || $ctrl.current.card.kind == 'auto') ? 'radio' : 'select' }}"
        ng-model="$ctrl.current.card.kind" ng-change="$ctrl.resetAsNew($ctrl.current.card.kind)" options="$ctrl.taxcardKindOptions"
        placeholder="SALAXY.NG1.CurrentTaxCardComponent.selectCardKind">
      </salaxy-input-enum>
      <p ng-if="$ctrl.current.card.kind == 'noTaxCard'" class="text-danger" style="margin-top:5px; margin-bottom:0;"
        sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noTaxCard.description"></p>
      <p ng-if="$ctrl.current.card.kind == 'noWithholdingHousehold'" class="text-danger" style="margin-top:5px; margin-bottom:0;"
        sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noWithholdingHousehold.description"></p>
      <salaxy-form-group label="SALAXY.NG1.CurrentTaxCardComponent.year" require="true" name="year" label-cols="col-sm-7" ng-if="$ctrl.addNewUi.yearsAllowed">
        <select class="form-select" ng-model="$ctrl.current.card.forYear" ng-options="i for i in $ctrl.addNewUi.yearsAllowed" ng-change="$ctrl.yearChanged()"></select>
      </salaxy-form-group>
      <salaxy-input label="SALAXY.NG1.CurrentTaxCardComponent.mainTaxPercent3" name="veroprosentti" label-cols="col-sm-7" ng-model="$ctrl.current.card.taxPercent"
        disabled="$ctrl.addNewUi.readonly" require="true" sxy-tax-percent ng-if="$ctrl.addNewUi.showTaxPercent"></salaxy-input>
      <salaxy-input name="tuloraja" label="SALAXY.NG1.CurrentTaxCardComponent.incomeLimit2" ng-model="$ctrl.current.card.incomeLimit" maxlength="10"
        ng-if="$ctrl.addNewUi.showIncomeLimit" label-cols="col-sm-7" require="$ctrl.addNewUi.requireIncomeLimit || $ctrl.current.card.taxPercent2" sxy-currency></salaxy-input>
      <salaxy-input name="lisaveroprosentti" label="SALAXY.NG1.CurrentTaxCardComponent.taxPercent2.name" label-cols="col-sm-7" ng-model="$ctrl.current.card.taxPercent2"
        ng-if="$ctrl.addNewUi.showIncomeLimit" require="$ctrl.addNewUi.requireIncomeLimit || $ctrl.current.card.incomeLimit" sxy-tax-percent></salaxy-input>
      <salaxy-form-group label-cols="col-sm-5" label="SALAXY.NG1.CurrentTaxCardComponent.validDate" name="validityStart" class="salaxy-read-only"
        ng-if="$ctrl.current.card.kind =='defaultYearly' || $ctrl.current.card.kind == 'replacement'">
        <div class="form-control-plaintext text-end">{{ $ctrl.current.card.validity.start | date : "dd.MM.yyyy" }} – {{ $ctrl.current.card.validity.end | date :
          "dd.MM.yyyy" }}</div>
      </salaxy-form-group>
      <salaxy-datepicker-popup name="voimaantuloPvm" ng-model="$ctrl.current.card.validity.start" ng-if="$ctrl.addNewUi.startDateOptions"
        min-date="$ctrl.addNewUi.startDateOptions.minDate" max-date="$ctrl.addNewUi.startDateOptions.maxDate" label-cols="col-sm-7" require="true"
        label="SALAXY.NG1.CurrentTaxCardComponent.validFromDate2"></salaxy-datepicker-popup>
      <salaxy-input name="previousSalariesRow" label="SALAXY.NG1.CurrentTaxCardComponent.previousSalariesForTaxCard.label" ng-model="$ctrl.previousSalariesRow.income"
        ng-if="$ctrl.addNewUi.showPreviousSalariesPaid" tooltip-html="{{'SALAXY.NG1.CurrentTaxCardComponent.previousSalariesForTaxCard.tooltip' | sxyTranslate}}"
        tooltip-placement="right" label-cols="col-sm-7" sxy-currency></salaxy-input>
    </div>
  </form>
</div>`);

 $templateCache.put("salaxy-components/worker/taxcard/TaxCardsList.html",`<div class="salaxy-component salaxy-tax-cards-list">
  <div class="row form-horizontal" sxy-if-role="test" ng-init="$ctrl.today = 'today'">
    <div class="col-6">
      <salaxy-datepicker-popup name="today" ng-model="$ctrl.today" label="SALAXY.NG1.CurrentTaxCardComponent.salaryDate"
        ng-change=""></salaxy-datepicker-popup>
    </div>
    <div class="col-6">
      <button type="button" class="btn btn-primary" 
        ng-click="$ctrl.$odata.setUrl('/v03/api/taxcards/current/' + $ctrl.today || 'null')" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.changePaymentDate"></button>
    </div>
  </div>
  <salaxy-odata-table url="/v03/api/taxcards/current/null" crud-controller="TaxcardCrudController as $crud"
    ng-ref="$ctrl.$odata"
    template-url="salaxy-components/odata/lists/Taxcards.html"></salaxy-odata-table>
</div>`);

 $templateCache.put("salaxy-components/worker/TimerEditDialog.html",`<div class="salaxy-component salaxy-timer-dialog">
  <div>
    <div class="modal-header">
      <h2 sxy-text="Muokkaa kellokorttimerkintää"></h2>
      <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form class="form-horizontal">
        <div class="row">
          <div class="col-sm-6 col-12">
            <salaxy-datepicker-popup name="start" ng-model="$ctrl.current.contentData.period.start" label="Aloituspäivä"></salaxy-datepicker-popup>
          </div>
          <div class="col-sm-6  col-12">
            <salaxy-input-time name="startTime" label="Alkoi" type="time" ng-model="$ctrl.current.contentData.startTime"></salaxy-input-time>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6  col-12">
            <salaxy-datepicker-popup name="start" ng-model="$ctrl.current.contentData.period.end" label="Lopetuspäivä"></salaxy-datepicker-popup>
          </div>
          <div class="col-sm-6  col-12">
            <salaxy-input-time name="endTime" label="Loppui" type="time" ng-model="$ctrl.current.contentData.endTime"></salaxy-input-time>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-12">
            <salaxy-input-typeahead ng-if="$ctrl.logic.costAccountingSettings" label-format="text-value"
              name="options_project" ng-model="$ctrl.current.contentData.project" options="$ctrl.logic.costAccountingSettings.options"
              label="{{($ctrl.logic.costAccountingSettings.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" required="true"></salaxy-input-typeahead>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input label="Kommentti" placeholder="Kommentti"  name="comment" ng-model="$ctrl.current.contentData.projectText">
            </salaxy-input>
          </div>
        </div>
    </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>

    <button type="button" class="btn btn-danger float-start" ng-click="$close('delete')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.deleteButtonText"></button>
  </div>
</div>
</div>`);

 $templateCache.put("salaxy-components/worker/TimeReportEditDialog.html",`<div class="salaxy-component salaxy-timer-dialog">
  <div>
    <div class="modal-header">
      <h2 sxy-text="Muokkaa aikakirjausta"></h2>
      <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form class="form-horizontal">
        <div class="row">
          <div class="col-sm-6 col-12">
            <salaxy-input-typeahead ng-if="$ctrl.logic.costAccountingSettings" label-format="text-value" name="options_project" ng-model="$ctrl.current.contentData.project" options="$ctrl.logic.costAccountingSettings.options" label="{{($ctrl.logic.costAccountingSettings.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" required="true"></salaxy-input-typeahead>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input name="message" ng-model="$ctrl.current.contentData.projectText" label="Kommentti"></salaxy-input>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input-time name="startTime" label="Aloitusaika" type="time" ng-model="$ctrl.current.contentData.startTime"></salaxy-input-time>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input-time name="endTime" label="Lopetusaika" type="time" ng-model="$ctrl.current.contentData.endTime"></salaxy-input-time>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>

      <button type="button" class="btn btn-danger float-start" ng-click="$close('delete')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.deleteButtonText"></button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/WorkerAbsences.html",`<div class="salaxy-component salaxy-worker-absences">
  <salaxy-spinner ng-if="$ctrl.isLoading"></salaxy-spinner>
  <div class="row">
    <div class="col-sm-8">
      <fieldset ng-if="$ctrl.viewType == 'overview'">
        <salaxy-absence-periods on-commit="$ctrl.save()" parent="$ctrl.current" mode="calendar"
          filter-start="$ctrl.currentYear + '-01-01'" filter-end="$ctrl.currentYear + '-12-31'"
          ></salaxy-absence-periods>
      </fieldset>
      <fieldset ng-if="$ctrl.viewType == 'list'">
        <salaxy-absence-periods on-commit="$ctrl.save()" parent="$ctrl.current"></salaxy-absence-periods>
      </fieldset>
    </div>
    <div class="col-sm-4">
      <div class="btn-group btn-block dropdown mb-4">
        <button id="year-selection" type="button" class="btn btn-primary btn-block dropdown-toggle" data-bs-toggle="dropdown">
          {{ $ctrl.currentYear  }}
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
          <li role="menuitem"  ng-repeat="year in $ctrl.years">
            <a href="" ng-click="$ctrl.currentYear = year" class="dropdown-item">{{ year }}</a>
          </li>
        </ul>
      </div>
      <salaxy-toggle-buttons ng-model="$ctrl.viewType" options="[
        { value: 'overview', label: 'SALAXY.NG1.WorkerAbsencesComponent.calendarButtonText' },
        { value: 'list', label: 'SALAXY.NG1.WorkerAbsencesComponent.listButtonText' }
      ]" type="block"></salaxy-toggle-buttons>
      <p>&nbsp;</p>
      <fieldset>
        <legend sxy-text="SALAXY.NG1.WorkerAbsencesComponent.legendInstructions"></legend>
        <div sxy-html="SALAXY.NG1.WorkerAbsencesComponent.instructions.html"></div>
      </fieldset>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/WorkerAssure.html",`<div class="salaxy-component salaxy-worker-assure">
  <div class="col">
    <form name="assureWorkerForm" class="form-horizontal">
      <h3>Luo uusi työntekijä (Partner, BETA)</h3>
      <salaxy-input sxy-personal-id-fi ng-model="$ctrl.assureWorkerAccountReq.officialId" label="Henkilötunnus" name="officialId" require="true"></salaxy-input>
      <salaxy-input ng-model="$ctrl.assureWorkerAccountReq.firstName" label="Etunimi" name="firstName" require="true"></salaxy-input>
      <salaxy-input ng-model="$ctrl.assureWorkerAccountReq.lastName" label="Sukunimi" name="lastName" require="true"></salaxy-input>
      <salaxy-input sxy-email ng-model="$ctrl.assureWorkerAccountReq.email" label="Sähköposti" name="email" require="true"></salaxy-input>
      <salaxy-input sxy-mobile-phone ng-model="$ctrl.assureWorkerAccountReq.telephone" label="Puhelin" name="telephone" require="true"></salaxy-input>
      <salaxy-input sxy-iban ng-model="$ctrl.assureWorkerAccountReq.bankAccountIban" label="Pankkitili" name="bankAccountIban" require="true"></salaxy-input>
      <salaxy-datepicker-popup name="startDate" label="Työsuhteen alkamispäivä" ng-model="$ctrl.assureWorkerAccountReq.startDate"></salaxy-datepicker-popup>
      <salaxy-datepicker-popup name="endDate" label="Työsuhteen päättymispäivä" ng-model="$ctrl.assureWorkerAccountReq.endDate"></salaxy-datepicker-popup>

      <div class="text-end">
        <button type="reset" ng-click="assureWorkerForm.$setPristine(); $ctrl.resetAssureWorkerAccount()" class="btn btn-default">Tyhjennä</button>
        <button ng-click="assureWorkerForm.$setPristine(); $ctrl.submitAssureWorkerAccount($employmentDetails, $employmentsList);" ng-disabled="assureWorkerForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
      </div>
    </form>
  </div>

  <div class="col col-md-5 col-lg-5">
    <hr />
    <salaxy-employment-list limit-to="10" ng-ref="$employmentsList" mode="select" on-list-select="$employmentDetails.model = (value == true ? item.id : null); $employmentsList.selectedItems = []"></salaxy-employment-list>
  </div>
  <div class="col-md-7 col-lg-7">
    <hr />
    <salaxy-employment-details ng-ref="$employmentDetails"></salaxy-employment-details>
  </div>
</div>`);

 $templateCache.put("salaxy-components/worker/WorkerDetails.html",`<div ng-if="$ctrl.status == 'initialLoading'">
  <p sxy-text="SALAXY.UI_Terms.loading"></p>
</div>
<div ng-if="$ctrl.current">
  <div class="alert alert-warning">
    <div><strong>WARNING: This page is depricated!</strong></div>
    <div>Tämä on vanha sivu, joka ei pitäisi enää olle näkyvissä. 
      <strong>Ilmoita asiakaspalvelulle</strong>, jos tämä sivu on vielä näkyvissä sivustollasi.</div>
  </div>
  <salaxy-employment-details model="$ctrl.current.employmentId"></salaxy-employment-details>
</div>`);

 $templateCache.put("salaxy-components/workflow/CalendarEventDetails.html",`<div class="salaxy-component salaxy-calendar-event-details">
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="$ctrl.tabOptions"
    tabs-id="calendarEventDetails">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-calendarEventDetails" style="min-height: 360px">
    <div class="tab-pane" id="basic-tab">
      <div class="row">
        <div class="col-sm-6 form-horizontal">
          <fieldset>
            <legend>Tapahtuma-aika</legend>
            <salaxy-datepicker-popup ng-model="$ctrl.current.event.start" name="start" label="Alku" require="true" ng-change="$ctrl.current.event.end = $ctrl.current.event.start">
            </salaxy-datepicker-popup>
            <salaxy-datepicker-popup ng-model="$ctrl.current.event.end" name="end" label="Loppu" ng-change="$ctrl.current.event.duration = null" min-date="$ctrl.current.event.start"></salaxy-datepicker-popup>
            <salaxy-form-group name="duration" class="salaxy-component salaxy-read-only" label="Kesto">
              <div class="form-control-plaintext">{{ $ctrl.getEventDuration() }}</div>
            </salaxy-form-group>
            <div class="alert alert-warning" ng-if="!$ctrl.current.event.isAllDay">
              Kalenteritapahtuma määrittää kellonaikoja. Tämä käyttöliittymä on suunniteltu vain koko päivän kestäviin tapahtumiin ja muokkaukset saattavat johtaa virheellisiin tuloksiin.
            </div>
          </fieldset>
          <fieldset>
            <legend>Lisätietoja</legend>
            <salaxy-input-enum name="status" enum="CalendarEventStatus" ng-model="$ctrl.current.event.status" label="Status" read-only="true"></salaxy-input-enum>
            <salaxy-form-group name="categories" class="salaxy-component salaxy-read-only" label="Kategoriat">
              <div class="form-control-plaintext">
                <div ng-repeat="cat in $ctrl.current.event.categories"><span>{{ cat + ($last ? "" : ", ") }}</span></div>
                <div ng-if="!$ctrl.current.event.categories.length">-</div>
              </div>
            </salaxy-form-group>
            <salaxy-input-number name="priority" ng-model="$ctrl.current.event.priority" label="Prioriteetti" read-only="true"></salaxy-input-number>
          </fieldset>
        </div>
        <div class="col-sm-6">
          <fieldset class="form-horizontal">
            <legend>Kuvaus</legend>
            <salaxy-input ng-model="$ctrl.current.event.summary" name="summary" required="true" label="Lyhyt kuvaus"></salaxy-input>
            <salaxy-textarea ng-model="$ctrl.current.event.description" name="description" label="Kuvaus" rows="5" label-type="basic"></salaxy-textarea>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="tab-pane" id="recurrence-tab">
      <p class="lead">
        <button type="button" class="btn btn-primary float-end" ng-click="$ctrl.addRecurrenceRule()">Lisää sääntö</button> Voit määrittää tapahtumalle toistuvuussääntöjä: Esim. kuukausittain, viikottain jne. Toistuvuus perustuu alkupäivämäärään <strong>{{ $ctrl.current.event.start | sxyDate }}</strong>        aivan kuten Outlookissa tai Google kalenterissa.
      </p>
      <fieldset ng-repeat="rule in $ctrl.current.event.recurrenceRules track by $index">
        <legend>
          <button ng-click="$ctrl.deleteRecurrence($index)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-danger btn-sm float-end">
            <i class="bi bi-trash-fill"></i>
          </button> Toistuvuus {{ $index + 1 }}
        </legend>
        <salaxy-input ng-model="$ctrl.current.event.recurrenceRules[$index]" name="rule{{$index}}" required="true" label="iCalendar sääntö (rrule)"></salaxy-input>
      </fieldset>
    </div>
    <div class="tab-pane" id="actions-tab">
      <p class="lead">
        <button type="button" class="btn btn-primary float-end" ng-click="$ctrl.addAction()">Lisää tehtävä</button> Säännöt määritetään päivinä ennen tai jälkeen alkupäivän <strong>{{ $ctrl.current.event.start | sxyDate }}</strong> (+ mahd. toistuvuus).
      </p>
      <fieldset ng-repeat="action in $ctrl.current.event.actions | orderBy: 'triggerDuration'" class="form-horizontal" ng-switch="action.type">
        <legend>
          <button ng-click="$ctrl.deleteAction($index)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-danger btn-sm float-end">
            <i class="bi bi-trash-fill"></i>
          </button> Skripti {{ $index + 1 }}
        </legend>
        <div class="alert alert-danger">
          <strong>HUOM: </strong> Skriptit ovat rajatussa testikäytössä. Ota yhteyttä asiakaspalveluun, jos tarvitse skriptejä.
        </div>
      </fieldset>
    </div>
    <div class="tab-pane" id="debug-tab">
      <salaxy-json-formatter key="'Event'" json="$ctrl.current" open="1"></salaxy-json-formatter>
    </div>
  </div>

  <div class="row">
    <div class="col-12 text-end">
      <button class="btn btn-danger" ng-click="$ctrl.delete($ctrl.current)">Poista</button>
      <button class="btn btn-primary" ng-click="$ctrl.save()">Tallenna</button>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/workflow/dataset/DatasetDetails.html",`<div class="salaxy-component salaxy-dataset-details" ng-switch="$ctrl.getMode()">
  <salaxy-spinner ng-switch-when="loading"></salaxy-spinner>
  <div ng-switch-when="usecase">
    <div ng-if="$ctrl.usecase && !$ctrl.usecase.defaultView" class="alert alert-danger">
      ERROR: This usecase {{ $ctrl.usecase.uri }} does not have user interface (view) defined.
    </div>
    <div ng-if="$ctrl.usecase.defaultView">
      <ng-include src="$ctrl.usecase.defaultView"></ng-include>
    </div>
  </div>
  <div ng-switch-when="data-edit">
    <ng-include src="'salaxy-components/workflow/dataset/DatasetDetails_data.html'"></ng-include>
  </div>
  <div ng-switch-when="full-edit">
    <ng-include src="'salaxy-components/workflow/dataset/DatasetDetails_full.html'"></ng-include>
  </div>
  <div ng-switch-default class="alert alert-danger">ERROR: Unable to load Dataset</div>
</div>`);

 $templateCache.put("salaxy-components/workflow/dataset/DatasetDetails_data.html",`<div>
  <div class="btn-toolbar">
    <div class="btn-group">
      <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.save"></button>
      </button>
    </div>
    <div class="btn-group">
      
        <div class="form-group" style="line-height: 34px;">
          <strong> &nbsp; Nimi:</strong> {{$ctrl.current.info.label}}
        </div>
     
    </div>
    <div class="btn-group ms-1">
      <button type="button" class="btn" ng-class="'btn-' + (action.uiColor || 'default')" ng-repeat="action in $ctrl.usecase.actions" ng-click="$ctrl.executeAction(action)">{{
        action.uiText }}</button>
    </div>
  </div>
  <div style="height: calc(100vh - 200px);" class="form-horizontal">
    <style>
      /* TODO: Move to less */
      .salaxy-tab-height100 {
        height: 100%;
      }

      .salaxy-tab-height100 .tab-content {
        height: calc(100% - 43px);
      }

      .salaxy-tab-height100 .height100 {
        height: 100%;
      }
    </style>
    <salaxy-tab-buttons
      currentTab="$ctrl.currentTab"
      options="$ctrl.generateTabOptions()"
      tabs-id="datasetDetailsData">
    </salaxy-tab-buttons>

    <div class="tab-content" id="tab-content-datasetDetailsData">
      <div class="tab-pane" ng-repeat="table in $ctrl.current.data" id="{{ $ctrl.generateTabOptions()[$index].value }}">
        <div class="height100">
          <sxy-grid
            ng-if="$ctrl.getSchamaDef($index)"
            data="table.content"
            schema-def="$ctrl.getSchamaDef($index)"
            schema="table.schema"
            ng-ref="grid">
          </sxy-grid>
        </div>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/workflow/dataset/DatasetDetails_full.html",`<div>
  <div class="btn-toolbar" style="margin-left: 195px; margin-bottom: 2px;">
    <div class="btn-group">
      <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.save"></button>
      </button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
      <button class="btn btn-default" ng-click="$ctrl.reload()"><i class="bi bi-arrow-repeat" aria-hidden="true"></i></button>
    </div>
    <div class="btn-group ms-1">
      <button type="button" class="btn btn-default" ng-click="$ctrl.addDataObject()" sxy-text="Lisää dataobjekti"></button>
    </div>
    <div class="btn-group ms-1">
      
        <div class="form-group" style="line-height: 34px;">
          <strong> &nbsp; Nimi:</strong> {{$ctrl.current.info.label}}
        </div>
      
    </div>
    <div class="btn-group ms-1">
      <button type="button" class="btn" ng-class="'btn-' + (action.uiColor || 'default')" ng-repeat="action in $ctrl.usecase.actions" ng-click="$ctrl.executeAction(action)">{{ action.uiText }}</button>
    </div>
    <div class="btn-group ms-auto">
      <button type="button" class="btn btn-danger" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly" ng-click="$ctrl.delete($ctrl.current)"
        sxy-text="SALAXY.UI_Terms.delete" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}">
    </div>
  </div>
  <div ng-init="$ctrl.currentSection = 'basicInfo'" style="display: flex">
    <div style="flex: 0 0 200px;">
      <salaxy-toggle-buttons ng-model="$ctrl.currentSection" options="[{ value: 'basicInfo', label: 'Perustiedot' }]" type="block"></salaxy-toggle-buttons>
      <div style="margin-top: 8px;">Dataobjektit:</div>
      <salaxy-toggle-buttons ng-repeat="table in $ctrl.current.data" ng-model="$ctrl.currentSection" options="[{ value: 'table' + $index, label: table.label }]" type="block"></salaxy-toggle-buttons>
      <div>&nbsp;</div>
      <salaxy-toggle-buttons ng-model="$ctrl.currentSection" options="[{ value: 'debugger', label: 'Debugger' }]" type="block"></salaxy-toggle-buttons>
    </div>
    <div ng-if="$ctrl.current" style="flex: 1 1 100%;margin-left: -1px; height: calc(100vh - 200px); overflow-y: auto; border: solid 1px #009fd8; padding: 10px;">
      <div ng-if="$ctrl.currentSection == 'basicInfo'" class="form-horizontal">
        <sxy-form open-api="salaxy-secure/schemas/v02.json" type="Dataset" auto-gen="false" debugger="false" model="$ctrl.current">
          <div class="row">
            <div class="col-sm-6">
              <fieldset>
                <legend>Perustiedot</legend>
                <sxy-input label="Id" model="form.id"></sxy-input>
                <sxy-input label="Nimi" model="form.info.label"></sxy-input>
                <sxy-input label="Status" model="form.info.status"></sxy-input>
                <sxy-input label="Tyyppi" model="form.info.type"></sxy-input>
              </fieldset>
            </div>
            <div class="col-sm-6">
              <fieldset>
                <legend>Räätälöinti</legend>
                <div ng-if="$ctrl.usecase == 'none'">
                  <salaxy-input-enum label="Valitse räätälöinti" ng-if="$ctrl.usecases" name="uri" ng-model="$ctrl.current.usecase.uri" options="$ctrl.usecases"></salaxy-input-enum>
                  <div ng-if="!$ctrl.current.usecase.uri" class="alert alert-danger">
                    Tälle datasetille ei ole määritetty räätälöintiä (datamalli ja toiminnallisuudet).
                  </div>
                  <div ng-if="$ctrl.current.usecase.uri" class="alert alert-info">
                    <p>
                      Räätälöintiä ei löytynyt tai ei vielä ladattu (tallenna ladataksesi): {{ $ctrl.current.usecase.uri }}
                    </p>
                  </div>
                </div>
                <div ng-if="$ctrl.usecase != 'none'">
                  <p><strong>URI:</strong> <code>{{ $ctrl.current.usecase.uri }}</code></p>
                  <sxy-input label="Nimi" model="form.usecase.label" read-only="true"></sxy-input>
                  <sxy-input label="Kuvaus" model="form.usecase.description" read-only="true"></sxy-input>
                  <salaxy-form-group name="btnEdit" label="Muokkaa">
                    <a ng-href="#/usecases/details/{{ $ctrl.usecase.id }}@{{ $ctrl.usecase.owner }}" target="_blank" ng-disabled="!$ctrl.usecase || $ctrl.usecase.isReadOnly"
                      class="btn btn-default btn-sm">Muokkaa (uuteen ikkunaan)...</a>
                  </salaxy-form-group>
                  <salaxy-json-formatter json="$ctrl.usecase" key="'Yksityiskohdat...'" open="0"></salaxy-json-formatter>
                </div>
              </fieldset>
            </div>
          </div>
        </sxy-form>
      </div>
      <div ng-repeat="dataObj in $ctrl.current.data" ng-if="$ctrl.currentSection == ('table' + $index)" class="height100 form-horizontal">
        <style>
          /* TODO: Move to less */
          .salaxy-tab-height100 {
            height: 100%;
          }

          .salaxy-tab-height100 .tab-content {
            height: calc(100% - 43px);
          }

          .salaxy-tab-height100 .tab-pane {
            height: 100%;
          }
        </style>
        <salaxy-tab-buttons
          current-tab="$ctrl.currentTab"
          options="[
            { value: 'grid', text: 'Grid' },
            { value: 'properties', text: 'Ominaisuudet' },
            { value: 'validation', text: 'Validation' }
          ]"
          tabs-id="datasetDetailsFull">
        </salaxy-tab-buttons>
        <div class="tab-content" id="tab-content-datasetDetailsFull">
          <div class="tab-pane" id="grid-tab">
            <div style="height: 100%">
              <sxy-grid data="dataObj.content" schema-def="$ctrl.getSchamaDef($index)"
                schema="{{$ctrl.current.data[$index].schema}}"
                include="dataObj.views[0].include"
                exclude="dataObj.views[0].exclude"></sxy-grid>
            </div>
          </div>
          <div class="tab-pane" id="properties-tab">
            <div class="row">
              <div class="col-sm-6">
                <salaxy-input label="Label" name="label" ng-model="dataObj.label"></salaxy-input>
                <salaxy-input label="Technical name" name="name" ng-model="dataObj.name"></salaxy-input>
                <salaxy-form-group name="btnDeleteIndex" label="Remove">
                  <button type="button" ng-click="$ctrl.deleteObject($index)" class="btn btn-danger btn-sm" ng-disabled="$ctrl.usecase.isReadOnly">Remove object</button>
                </salaxy-form-group>
              </div>
              <div class="col-sm-6">
                <salaxy-input-enum label="Schema document" name="schemaDoc" ng-model="dataObj.schemaDoc" disable-cache="true"
                  options="$ctrl.getSchemaDocs()"></salaxy-input-enum>
                <salaxy-input-typeahead label="Schema" name="schema" ng-model="dataObj.schema" disable-cache="true"
                  options="$ctrl.getSchemas(dataObj.schemaDoc)" disabled="(dataObj.schemaDoc || 'any') == 'any'"></salaxy-input-typeahead>
                <!-- TODO: isArray -->
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <fieldset>
                  <legend>Include fields (default view)</legend>
                  <ul class="list-group">
                    <li class="list-group-item" ng-repeat="incl in dataObj.views[0].include track by $index">
                      {{ incl }}
                      <div class="float-end">
                        <button class="btn btn-primary btn-xs" title="Move up" ng-click="$ctrl.arraymove($ctrl.current.data[$parent.$index].views[0].include, $index, -1)">&#9650;</button>
                        <button class="btn btn-primary btn-xs" title="Move down" ng-click="$ctrl.arraymove($ctrl.current.data[$parent.$index].views[0].include, $index, +1)">&#9660;</button>
                        <button class="btn btn-default btn-xs" title="Delete" ng-click="$ctrl.current.data[$parent.$index].views[0].include.splice($index, 1)">&#10060;</button>
                      </div>
                    </li>
                    <li class="list-group-item" ng-if="!dataObj.views[0].include.length">No rows selected: All columns</li>
                  </ul>
                  <div style="display: inline-block;">
                    <salaxy-input-typeahead label="Add new property" name="addProp" label-type="plain"
                      ng-model="$ctrl.tempNewProperty" disable-cache="true"
                      ng-change="$ctrl.addViewItem($index, 'include', $ctrl.tempNewProperty);$ctrl.tempNewProperty=null"
                      options="$ctrl.getAllPropertiesOfSchema($index)"></salaxy-input-typeahead>
                  </div>
                  <button type="button" class="btn btn-default btn-sm" ng-click="$ctrl.addViewItem($index, 'include', $ctrl.tempNewProperty);$ctrl.tempNewProperty=null">Add</button>
                </fieldset>
              </div>
              <div class="col-sm-6">
                <fieldset>
                  <legend>Exclude fields (default view)</legend>
                  <ul class="list-group">
                    <li class="list-group-item" ng-repeat="incl in dataObj.views[0].exclude track by $index">
                      {{ incl }}
                      <div class="float-end">
                        <button class="btn btn-primary btn-xs" title="Move up" ng-click="$ctrl.arraymove($ctrl.current.data[$parent.$index].views[0].exclude, $index, -1)">&#9650;</button>
                        <button class="btn btn-primary btn-xs" title="Move down" ng-click="$ctrl.arraymove($ctrl.current.data[$parent.$index].views[0].exclude, $index, +1)">&#9660;</button>
                        <button class="btn btn-default btn-xs" title="Delete" ng-click="$ctrl.current.data[$parent.$index].views[0].exclude.splice($index, 1)">&#10060;</button>
                      </div>
                    </li>
                    <li class="list-group-item" ng-if="!dataObj.views[0].exclude.length">No rows selected: All columns</li>
                  </ul>
                  <div style="display: inline-block;">
                    <salaxy-input-typeahead label="Add new property" name="addProp" label-type="plain"
                      ng-model="$ctrl.tempNewProperty" disable-cache="true"
                      ng-change="$ctrl.addViewItem($index, 'exclude', $ctrl.tempNewProperty);$ctrl.tempNewProperty=null"
                      options="$ctrl.getAllPropertiesOfSchema($index)"></salaxy-input-typeahead>
                  </div>
                  <button type="button" class="btn btn-default btn-sm" ng-click="$ctrl.addViewItem($index, 'exclude', $ctrl.tempNewProperty);$ctrl.tempNewProperty=null">Add</button>
                </fieldset>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="validation-tab">
            <p>TODO: Validation</p>
          </div>
        </div>
      </div>
      <div ng-if="$ctrl.currentSection == 'debugger'">
        <salaxy-json-formatter json="$ctrl.current" key="'Data'" open="1"></salaxy-json-formatter>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/workflow/usecases/UsecaseDetails.html",`<main class="salaxy-content sxytpl-usecases-details">
  <div class="btn-toolbar" style="margin-left: 195px; margin-bottom: 2px;">
    <div class="btn-group">
      <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.save"></button>
      </button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
      <button class="btn btn-default" ng-click="$ctrl.reload()"><i class="bi bi-arrow-repeat" aria-hidden="true"></i></button>
    </div>
   
    <div class="btn-group ms-1">
      <div class="form-group" style="line-height: 34px;">
        <strong> &nbsp; Nimi:</strong> {{$ctrl.current.label}}
      </div>
    </div>
    <div class="btn-group ms-auto">
      <button type="button" class="btn btn-danger" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly" ng-click="$ctrl.delete($ctrl.current)" sxy-text="SALAXY.UI_Terms.delete" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></button>
    </div>
  </div>
  <div ng-init="$ctrl.currentSection = 'basicInfo'" style="display: flex">
    <div style="flex: 0 0 200px;">
      <salaxy-toggle-buttons ng-model="$ctrl.currentSection" 
        options="[
            { value: 'basicInfo', label: 'Perustiedot' },
            { value: 'schemas', label: 'Datamalli' },
            { value: 'scripts', label: 'Skriptit' },
            { value: 'schema', label: 'Schema' },
            { value: 'views', label: 'Käyttöliittymä' },
            { value: 'tester', label: 'Testaa' },
            { value: 'debugger', label: 'Debugger' }
        ]" 
        type="block">
      </salaxy-toggle-buttons>
    </div>
    <div ng-if="$ctrl.current" style="flex: 1 1 100%;margin-left: -1px; height: calc(100vh - 200px); overflow-y: auto; border: solid 1px #009fd8; padding: 10px;">
      <div ng-if="$ctrl.currentSection == 'basicInfo'" class="form-horizontal">
        <div class="row">
          <div class="col-sm-6">
            <sxy-form open-api="salaxy-secure/schemas/v02.json" type="Usecase" auto-gen="false" debugger="false" model="$ctrl.current">
              <div>
                <fieldset>
                  <legend>Perustiedot</legend>
                  <p ng-if="$ctrl.current.id"><strong>URI:</strong> <code>{{ $ctrl.current.uri }}</code></p>
                  <sxy-input label="Id" model="form.id"></sxy-input>
                  <sxy-input label="Nimi" model="form.label"></sxy-input>
                  <sxy-input label="Kuvaus" model="form.description"></sxy-input>
                  <sxy-input label="Ikoni / kuva" model="form.icon"></sxy-input>
                  <sxy-input label="Objektin tyyppi" model="form.itemType"></sxy-input>
                  <sxy-input label="Tila" model="form.status"></sxy-input>
                  <sxy-input label="Järjestysnumero" model="form.order"></sxy-input>
                </fieldset>
              </div>
            </sxy-form>
          </div>
          <div class="col-sm-6 col-md-4">
            <fieldset>
              <legend>Perustietojen esikatselu</legend>
              <div class="card">
                <div class="text-center card-pic-fixed" style="height: 150px;">
                  <img ng-if="$ctrl.current.icon[0] == 'h'" ng-src="{{$ctrl.current.icon}}">
                  <div ng-if="$ctrl.current.icon[0] != 'h'" class="bg-primary card-pic-icon">
                    <i class="bi" ng-class="($ctrl.current.icon || 'bi') == 'bi' ? 'bi-currency-euro' : $ctrl.current.icon" aria-hidden="true"></i>
                  </div>
                  <span class="badge float-end" ng-class="$ctrl.getStatusBgColor($ctrl.current.status)">{{ "UsecaseStatus." + $ctrl.current.status | sxyEnum }}</span>
                </div>
                <div class="card-body">
                  <h3 class="truncate">{{ $ctrl.current.label }}</h3>
                  <p style="height: 80px;overflow: hidden">{{ $ctrl.current.description }}</p>
                  <p>
                    <a ng-href="#/calc/usecase/new?usecase=%2FUsecaseDefinition%2F{{ $ctrl.current.owner }}%2F{{ $ctrl.current.id }}" class="btn btn-primary" role="button" style="color: white" sxy-text="SALAXY.UI_Terms.createNew" ps="..."></a>
                  </p>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <ng-include src="'salaxy-components/workflow/usecases/UsecaseDetails_schemas.html'"></ng-include>
      <ng-include src="'salaxy-components/workflow/usecases/UsecaseDetails_scripts.html'"></ng-include>
      <ng-include src="'salaxy-components/workflow/usecases/UsecaseDetails_views.html'"></ng-include>
      <div ng-if="$ctrl.currentSection == 'schema'" class="height100">
        <sxy-code-editor read-only="$ctrl.current.isReadOnly" lang="json" ng-model="$ctrl.editableSchema"></sxy-code-editor>
      </div>
      <ng-include src="'salaxy-components/workflow/usecases/UsecaseDetails_tester.html'"></ng-include>
      <div ng-if="$ctrl.currentSection == 'debugger'">
        <div class="row">
          <div class="col-sm-6">
            <salaxy-json-formatter json="$ctrl.current" key="'Usecase'" open="1"></salaxy-json-formatter>
          </div>
          <div class="col-sm-6">
            <salaxy-json-formatter json="$ctrl.currentItem" key="'Current item'" open="1"></salaxy-json-formatter>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>`);

 $templateCache.put("salaxy-components/workflow/usecases/UsecaseDetails_schemas.html",`<div ng-if="$ctrl.currentSection == 'schemas'">
  <div class="btn-toolbar" role="toolbar">
    <button type="button" ng-click="$ctrl.createSchema()" class="btn btn-primary">Lisää uusi</button>
    <div class="btn-group dropdown">
      <button id="selectAction" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        <span ng-if="!$ctrl.currentSchema">Valitse datamalli...</span>
        <span ng-if="$ctrl.currentSchema">{{ $ctrl.currentSchema.title || ("Ei nimeä " + ($index + 1)) }}</span>
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="selectAction">
        <li ng-repeat="(key, schema) in $ctrl.current.schema.components.schemas" ng-click="$ctrl.setCurrentSchema(key)" role="menuitem">
          <a href="" class="dropdown-item">{{ schema.title || ("Ei nimeä " + ($index + 1)) }} ({{ key }})</a>
        </li>
      </ul>
    </div>
    <button type="button" ng-click="$ctrl.deleteSchema($ctrl.currentSchemaKey)" ng-disabled="!$ctrl.currentSchema" class="btn btn-danger">Poista</button>
  </div>
  <hr />
  <div ng-if="!$ctrl.currentSchema" class="alert alert-info">
    Lisää uusi datamalli tai valitse yksi muokattavista.
  </div>
  <div class="row form-horizontal" ng-if="$ctrl.currentSchema">
    <div class="col-sm-6">
      <salaxy-input label="Nimi" name="{{ 'schemaTitle' + $index }}" ng-model="$ctrl.currentSchema.title"></salaxy-input>
    </div>
    <div class="col-sm-6">
      <salaxy-input label="Tekninen nimi" name="{{ 'schemaKey' + $index }}" ng-model="$ctrl.currentSchemaKey" readonly="true"></salaxy-input>
    </div>
    <div class="col-12">
      <h4>Datamallin muokkaus</h4>
      <sxy-schema-editor model="$ctrl.currentSchema.properties"></sxy-schema-editor>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/workflow/usecases/UsecaseDetails_scripts.html",`<div ng-if="$ctrl.currentSection == 'scripts'">
  <div class="btn-toolbar" role="toolbar">
    <button type="button" ng-click="$ctrl.createAction()" class="btn btn-primary">Lisää uusi</button>
    <div class="btn-group dropdown">
      <button id="selectAction" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="$ctrl.current.actions.length == 0">
        <span ng-if="!$ctrl.currentAction">Valitse skripti...</span>
        <span ng-if="$ctrl.currentAction">{{ $ctrl.currentAction.label || ("Ei nimeä " + ($index + 1)) }}</span>
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="selectAction">
        <li ng-repeat="action in $ctrl.current.actions" ng-click="$ctrl.currentAction = action" role="menuitem">
          <a href="" class="dropdown-item">{{ action.label || ("Ei nimeä " + ($index + 1)) }}</a>
        </li>
      </ul>
    </div>
    <button type="button" ng-click="$ctrl.deleteAction($ctrl.currentAction)" ng-disabled="!$ctrl.currentAction" class="btn btn-danger">Poista</button>
    <button type="button" ng-click="$ctrl.executeAction()" class="btn float-end" ng-class="'btn-' + ($ctrl.currentAction.uiColor || 'default')"
      ng-disabled="!$ctrl.currentAction.content">
      {{ $ctrl.currentAction.uiText || "Käynnistä" }}
    </button>
  </div>
  <hr />
  <div ng-if="!$ctrl.currentAction" class="alert alert-info">
    Lisää uusi skripti tai valitse yksi muokattavista.
  </div>
  <div class="row" ng-if="$ctrl.currentAction">
    <div class="col-sm-6">
      <salaxy-input label="Nimi" name="actionTitle" ng-model="$ctrl.currentAction.label"></salaxy-input>
      <salaxy-input label="Kuvaus" name="actionDescription" ng-model="$ctrl.currentAction.description"></salaxy-input>
      <salaxy-input-enum label="Tyyppi" name="actionType" ng-model="$ctrl.currentAction.actionType" enum="UsecaseActionType"></salaxy-input-enum>
    </div>
    <div class="col-sm-6">
      <salaxy-input label="Napin teksti" name="actionUiText" ng-model="$ctrl.currentAction.uiText"></salaxy-input>
      <salaxy-input-enum label="Napin väri" name="actionUiColor" ng-model="$ctrl.currentAction.uiColor" enum="WorkflowEventUi"></salaxy-input-enum>
    </div>
    <div class="col-12">
      <div><small>Globals in this script:
          <code>item: <span>{{ $ctrl.itemType || 'any / unknown' }}</span></code>,
          <code>session: UserSession</code>, <code>core: @salaxy/core</code>
          <span ng-if="$ctrl.currentExecutor.isAsync">, <code>ajax: Ajax</code></span>
        </small></div>
      <sxy-code-editor read-only="$ctrl.current.isReadOnly" item-type="$ctrl.itemType || 'any'" ng-model="$ctrl.currentAction.content"></sxy-code-editor>
      <pre class="alert" ng-class="'alert-' + ($ctrl.currentExecutor.status || 'default')">{{ $ctrl.currentExecutor.result | json }}</pre>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/workflow/usecases/UsecaseDetails_tester.html",`<div ng-if="$ctrl.currentSection == 'tester'" ng-init="$ctrl.refreshCurrentInCache();$ctrl.currentView=$ctrl.currentView">
  <div>
    <div class="btn-toolbar">
      <div class="btn-group">
        <button type="button" class="btn btn-primary" ng-click="$ctrl.selectItem('new')">Luo uusi</button>
        <button type="button" class="btn btn-default" ng-click="$ctrl.selectItem('select')">Valitse testitietue..</button>
        <button type="button" class="btn btn-default float-end" ng-click="$ctrl.selectItem(null)">Tyhjennä</button>
      </div>
      <div class="btn-group dropdown">
        <button id="selectView" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="$ctrl.current.views.length == 0">
          <span ng-if="!$ctrl.currentView">Oletusnäkymä</span>
          <span ng-if="$ctrl.currentView">{{ $ctrl.currentView.label || ("Ei nimeä " + ($index + 1)) }}</span>
        </button>
        <ul class="dropdown-menu"  role="menu" aria-labelledby="selectView">
          <li ng-click="$ctrl.currentView = null" role="menuitem">
            <a href=""  class="dropdown-item">Oletusnäkymä</a>
          </li>
          <li ng-repeat="view in $ctrl.current.views" ng-click="$ctrl.currentView = view" role="menuitem">
            <a href="" class="dropdown-item">{{ view.label || ("Ei nimeä " + ($index + 1)) }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div ng-if="!$ctrl.currentItem" class="container alert alert-info">
      <p>Valitse testitietue ja näkymä, jota haluat testata.</p>
    </div>
    <div class="container" ng-if="$ctrl.currentItem" ng-switch="$ctrl.current.itemType" ng-init="temp = $ctrl.currentItem">
      <div ng-switch-when="calculation">
        <div ng-if="$ctrl.currentView">
          <div ng-controller="Calculator2022Controller as $ctrl" ng-init="$ctrl.model = temp">
            <ng-include src="'salaxy-dynamic-templates/usecase-custom-view.html'"></ng-include>
          </div>
        </div>
        <div ng-if="!$ctrl.currentView">
          <salaxy-calc model="$ctrl.currentItem"></salaxy-calc>
        </div>
      </div>
      <div ng-switch-when="dataset">
        <div ng-if="$ctrl.currentView">
          <div ng-controller="DatasetsCrudController as $ctrl" ng-init="$ctrl.model = temp">
            <ng-include src="'salaxy-dynamic-templates/usecase-custom-view.html'"></ng-include>
          </div>
        </div>
        <div ng-if="!$ctrl.currentView">
          <salaxy-dataset-details mode="data-edit" model="$ctrl.currentItem"></salaxy-dataset-details>
        </div>
      </div>
      <div ng-switch-default>
        <p>
          TODO: Testinäkymää ei ole toteutettu datatyypille
          <strong>{{$ctrl.current.itemType}}</strong>.
        </p>
      </div>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/workflow/usecases/UsecaseDetails_views.html",`<div ng-if="$ctrl.currentSection == 'views'">
  <div class="btn-toolbar" role="toolbar">
    <button type="button" ng-click="$ctrl.createView()" class="btn btn-primary">Lisää uusi</button>
    <div class="btn-group dropdown">
      <button id="selectView" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="$ctrl.current.views.length == 0">
        <span ng-if="!$ctrl.currentView">Valitse käyttöliittymä...</span>
        <span ng-if="$ctrl.currentView">{{ $ctrl.currentView.label || ("Ei nimeä " + ($index + 1)) }}</span>
      </button>
      <ul class="dropdown-menu"role="menu" aria-labelledby="selectView">
        <li ng-repeat="view in $ctrl.current.views" ng-click="$ctrl.currentView = view" role="menuitem">
          <a href="" class="dropdown-item">{{ view.label || ("Ei nimeä " + ($index + 1)) }}</a>
        </li>
      </ul>
    </div>
    <button type="button" ng-click="$ctrl.deleteView($ctrl.currentView)" ng-disabled="!$ctrl.currentView" class="btn btn-danger">Poista</button>
  </div>
  <hr />
  <div ng-if="!$ctrl.currentView" class="alert alert-info">
    Lisää uusi näkymä tai valitse yksi muokattavista.
  </div>
  <div class="row" ng-if="$ctrl.currentView">
    <div class="col-sm-6">
      <salaxy-input label="Nimi" name="viewTitle" ng-model="$ctrl.currentView.label"></salaxy-input>
      <salaxy-input label="Kuvaus" name="viewDescription" ng-model="$ctrl.currentView.description"></salaxy-input>
    </div>
    <div class="col-sm-6"></div>
    <div class="col-12">
      <sxy-code-editor read-only="$ctrl.current.isReadOnly" lang="html" ng-model="$ctrl.currentView.content"></sxy-code-editor>
    </div>
  </div>
</div>`);

 $templateCache.put("salaxy-components/workflow/WorkflowBadge.html",`<div ng-if="$ctrl.mode != 'horizontal'" class="salaxy-component salaxy-workflow-badge">
  <div ng-repeat="event in $ctrl.events">
    <span ng-click="$ctrl.showEventDetails(event)" class="clickable" ng-class="'badge bg-' + event.ui" title="{{ event.message + ' (' + (event.time | sxyTime)  + ')' }}">
      {{event.message}}
    </span>
  </div>
</div>
<span ng-if="$ctrl.mode == 'horizontal' && $ctrl.events.length" class="salaxy-component salaxy-workflow-badge">
  <span ng-repeat="event in $ctrl.events" ng-click="$ctrl.showEventDetails(event)" class="clickable" ng-class="'badge bg-' + event.ui"
    title="{{ event.message + ' (' + (event.time | sxyTime)  + ')' }}" style="margin-right: 4px;">{{event.message}}</span>
</span>`);

 $templateCache.put("salaxy-components/workflow/WorkflowButtons.html",`<div class="btn-group salaxy-workflow-buttons">
  <button class="btn btn-icon btn-transparent" ng-class="$ctrl.hasWorkflowEvent('PartnerMessageClosed') ? 'text-success' : 'text-muted'" ng-disabled="$ctrl.disabled"
    ng-click="$ctrl.buttonClick('close')" title="{{ $ctrl.getWorkflowEvent('PartnerMessageClosed').message || ('SALAXY.UI_Terms.markChecked' | sxyTranslate)}}">
    <span ng-if="$ctrl.getWorkflowEvent('PartnerMessageClosed').message" class="badge bg-success">{{$ctrl.getWorkflowEvent('PartnerMessageClosed').message}}</span>
    <i ng-if="!$ctrl.getWorkflowEvent('PartnerMessageClosed').message" class="bi bi-check-circle-fill bi-2x" ng-class="{ 'text-muted': $ctrl.isUpdating }"></i>
  </button>
  <button ng-disabled="$ctrl.disabled"
    title="{{ $ctrl.getWorkflowEvent('PartnerMessageIssue').message || ('SALAXY.NG1.WorkFlowIssueComponent.buttons.showEditor' | sxyTranslate) }}"
    ng-click="$ctrl.buttonClick('issue')" class="btn btn-icon btn-transparent" ng-class="$ctrl.hasWorkflowEvent('PartnerMessageIssue') ? 'text-danger' : 'text-muted'">
    <span ng-if="$ctrl.getWorkflowEvent('PartnerMessageIssue').message" class="badge bg-danger">{{$ctrl.getWorkflowEvent('PartnerMessageIssue').message}}</span>
    <i ng-if="!$ctrl.getWorkflowEvent('PartnerMessageIssue').message" class="bi bi-exclamation-circle-fill bi-2x" ng-class="{ 'text-muted': $ctrl.isUpdating }"></i>
  </button>
  <div ng-if="$ctrl.showWorkflowAssign" class="btn-group workflow-assign dropdown d-flex align-items-center">
    <button id="workflowAssign" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="$ctrl.disabled">
      <salaxy-avatar ng-if="$ctrl.getAssignedTo().id" avatar="$ctrl.getAssignedTo().avatar"></salaxy-avatar>
      <span class="workflow-assign-title">{{ $ctrl.getAssignedTo().email ||
        $ctrl.getAssignedTo().avatar.displayName || ('SALAXY.UI_Terms.assignToPerson' | sxyTranslate) }}</span>
    </button>
    <ul class="dropdown-menu"  role="menu" aria-labelledby="workflowAssign">
      <li role="menuitem" ng-if="$ctrl.getAssignedTo().id">
        <a href=""ng-click="$ctrl.buttonClick('assign', undefined)" class="dropdown-item">Poista valinta</a>
      </li>
      <li role="menuitem" ng-repeat="credential in $ctrl.credentials" ng-class="{ active: credential == $ctrl.getAssignedTo() }">
        <a href="" ng-click="$ctrl.buttonClick('assign', credential)" class="dropdown-item d-flex align-items-center">
          <salaxy-avatar avatar="credential.avatar"></salaxy-avatar>
          <span>&nbsp; {{ credential.email || credential.avatar.displayName }}</span>
        </a>
      </li>
    </ul>
  </div>
</div>`);

 $templateCache.put("salaxy-components/workflow/WorkflowReopen.html",`<button class="btn btn-sm btn-secondary" ng-disabled="$ctrl.disabled" ng-class="{muted : $ctrl.isUpdating}" ng-if="$ctrl.hasWorkflowEvent('PartnerMessageClosed') && $ctrl.apiCtrl.role === 'owner'" ng-click="$ctrl.deleteWorkflowEvent('PartnerMessageClosed')">
  Avaa keskustelu
</button>`);

      }
    }]);
    